webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {

    SQUARE_UP_APPLICATION_ID: 'sandbox-sq0idp-6o35glEKAVY0GtW8MmMvhg',

    SHOPIFY_RETAILER_TYPE: 'Shopify',
    AMAZON_RETAILER_TYPE: 'Amazon',

    BroadcastMessages: {
        TOGGLE_POPUP_BAG: 'togglePopupBag',
        CART_PAGE_REQUESTED: 'cartPageRequested',
        SESSION_CHANGED: 'sessionChanged',
        DISPLAY_POPUP_BAG: 'displayPopupBag',
        HIDE_POPUP_BAG: 'hidePopupBag',
        POPUP_BAG_CHANGED: 'popupBagChanged',
        CREATE_GROUP_ORDER: 'createGroupOrder'
    },

    UserTypes: {
        NormalUser: null,
        StoreAdmin: 1
    },

    RootEvents: {
        CART_CHANGED: 'cartChanged',
        PAYMENT_STATUS_CHANGED: 'paymentStatusChanged',
        USER_PROFILE_UPDATED: 'userProfileUpdated',
        DELETE_CONTACT_CONFIRM_FROM_ADDMORE_PEOPLE: 'DELETE_CONTACT_CONFIRM_FROM_ADDMORE_PEOPLE'
    },

    WindowMode: {
        minimized: 'MINIMIZED',
        maximized: 'MAXIMIZED'
    },
    Notifications: {
        chatNotification: 'resources/media/chat_notif.wav',
        newCartItemNotification: 'resources/media/chat_notif.wav'
    },
    Events: {
        WINDOW_WIDTH_CHANGED: 'windowWidthChanged',
        WINDOW_STATE_CHANGED: 'windowStateChanged',
        WINDOW_SCROLL: 'windowScroll',
        GROUP_ORDER_STATUS_CHANGED: 'groupOrderStatusChanged',
        ORDER_CREATED: 'setupOrderFinished',
        ORDER_CANCELLED: 'orderStatusCancelled',
        ORDER_CLEAR_ITEMS: 'clearCartItems',
        ORDER_CHANGED: 'orderChanged',
        ORDER_CANCELLED_BY_OWNER: 'orderCancelledByOwner',
        ORDER_CLEARED_BY_OWNER: 'orderClearedByOwner',
        USER_REMOVED_BY_OWNER: 'userRemovedByOwner',
        USER_JOINED_OTHER_CART: 'userJoinedOtherCart',
        ORDER_CHECKED_OUT: 'orderCheckedOut',
        LEFT_ORDER: 'participantLeftOrder',
        USER_LOGGED_OUT: 'userLoggedOut',
        USER_LOGGED_IN: 'userLoggedIn',
        INVITATION_ACCEPTED: 'invitationAccepted',
        INVITATION_FAILED_DUE_TO_CART_CLOSED: 'invitationFailedDueToCartClosed',
        CHAT_MESSAGE_RECEIVED: 'chatMessageReceived',
        CART_ITEMS_CHANGED: 'cartItemsUpdated',
        CART_OWNERSHIP_TRANSFERRED: 'CartOwnershipTransferred',
        REALTIME_CHAT_RECEIVED: 'RealtimeChatMessageReceived',
        EXTERNAL_PRODUCT_DETAIL_REQUESTED: 'externalProductDetailRequested',
        ADD_PEOPLE_ADVANCE_TO_NEXT_PAGE: 'AddPeopleAdvanceToNextPage',
        ORDER_CREATION_CANCEL_REQUESTED: 'OrderCreationCancelRequest',
        VERSION_PAGE_REQUESTED: "VersionPageRequested",
        LOGIN_PAGE_CANCEL_REQUESTED: 'LogInPageCancelRequest',
        ON_WINDOW_UNLOADING: 'WINDOW_UNLOADING',
        SIGNALR_CONNECTED: 'SignalrConnected',
        CANCEL_INVITATION: 'CANCEL_INVITATION',
        WINDOW_RECEIVED_MESSAGE: 'WINDOW_MESSAGE_RECEIVED',
        OPEN_SPLASH_SCREEN: 'OPEN_SPLASH_SCREEN',
        DELETE_CONTACT_COMPLETE: 'DELETE_CONTACT_COMPLETE',
        DIALOG_OPENED: 'DIALOG_OPENED',
        DIALOG_CLOSED: 'DIALOG_CLOSED',
        BACK_BUTTON_CLICKED: "BACK_BUTTON_CLICKED",
        ACCEPT_INVITES: "ACCEPT_INVITES"
    },

    SignalRHubStates: {
        CONNECTING: 0,
        CONNECTED: 1,
        RECONNECTING: 2,
        DISCONNECTED: 4
    },

    ElementAnchors: {
        TOP_NAVIGATION_BAR: 'top-navbar',
        TOP_NAVIGATION_BAR_PLACEHOLDER: 'top-navbar-placeholder',
        TOP_MOBILE_TOOLBAR: 'top-mobile-toolbar'
    },

    Timeouts: {
        POOLING_INTERVAL: 6000
    },

    SessionStorage: {
        AUTH_TOKEN: 'authToken',
        USER_EMAIL: 'userEmail',
        USER_NAME: 'userName',
        USER_FIRST_NAME: 'userFirstName',
        USER_LAST_NAME: 'userLastName',
        USER_DATA: 'userData',
        CART: 'cart',
        DELIVERY_PHONE: 'deliveryPhone',
        DELIVERY_ADDRESS: 'deliveryAddress',
        IS_INVITE: 'isInvite',
        NEW_ORDER_CONFIGURATION: 'newOrderConfiguration',
        ANTI_FORGERY_TOKEN: 'requestVerificationToken',
        AwaitingInvitation: 'awaiting_invitation',
        UnreadChatMessages: 'unread_chat_messages',
        CARTONOMY_BUILD_TIME: 'CARTONOMY_BUILD_TIME',
        CARTONOMY_BUILD_VERSION: 'CARTONOMY_BUILD_VERSION',
        LAST_STATE_NAME: 'LAST_STATE_BEFORE_UNLOAD',
        LAST_WINDOW_STATE: 'LAST_WINDOW_STATE',
        InvitationUserInvalid: 'InvitationUserInvalid',
        CREATE_ORDER_CONFIGURATION: 'CREATING_ORDER_CONFIGURATION',
        CREATE_ORDER_CURRENT_TAB: 'CREATING_ORDER_CURRENT_TAB',
        LINKING_SOCIAL_ACCOUNT: 'LINKING_SOCIAL_ACCOUNT',
        SAFARI_WARNING_SHOWED: 'SAFARI_WARNING_SHOWED',
        RETAILER_DATA: 'RETAILER_DATA_CHECK'
    },

    RoutingStates: {
        ABOUT: 'about',
        CATALOG: 'catalog',
        USER_PROFILE: 'profile',
        STORE_ADMIN: 'storeAdmin',
        START_CHECKOUT: 'start_checkout',
        CHECKOUT: 'checkout',
        CHECKOUT_FULL_MIXED: 'fullmixed',
        CART: 'cart',
        INVITED_PEOPLE: 'invited_people',
        CHAT: 'chat',
        INVITE: 'invite',
        CONFIRM_TICKET: 'confirm_ticket',
        PAY: 'pay',
        CONFIRM_ORDER: 'confirm_order',
        LOGIN_TICKET: 'login_ticket',
        PAYPAL_REDIRECT: 'paypal',
        ORDER_SUMMARY_PAGE: 'orderSummaryPage',
        OPEN_CARTS: 'openCarts'
    },

    Pagination: {
        PAGE_LIMIT: 10
    },

    CartDetails: {

        DEADLINE_HOURS: 1,

        DeliveryMethods: {
            DELIVERY: "DELIVERY",
            PICKUP: "PICKUP",
            SHIPPING: "SHIPPING",
            DEFAULT: "DELIVERY"
        },

        PaymentMethods: {
            SINGLE: "single",
            MULTIPLE: "multiple",
            DEFAULT: "multiple",
            MIXED: 'mixed',
            FULL_MIXED: 'fullmixed',
            USER_SELECT: 'user-select',
            SELF: 'self'
        },

        BudgetTypes: {
            PER_CART: 'per-cart',
            PER_USER: 'per-user',
            USER_SELECT: 'user-select'
        },

        ShippingMethods: {
            DEFAULT: "default"
        },

        Participant: {
            Status: {
                OWNER: 'OWNER',
                INVITE_SENT: 'INVITESENT',
                INVITED: 'INVITED',
                JOINED: 'JOINED',
                DECLINED: 'DECLINED',
                REMOVED: 'REMOVED',
                LEFT: 'LEFT'
            }
        }
    },

    AddressType: {
        BILLING: "billing",
        SHIPPING: "shipping"
    },

    OrderSetupTabs: {
        WELCOME: 'welcome',
        DELIVERY_MODE: 'deliveryMode',
        DELIVERY_ADDRESS: 'deliveryAddress',
        PAY_MODE: 'payMode',
        DEADLINE: 'deadline',
        BUDGET: 'budget',
        ADD_PEOPLE: 'addPeople',
        PREVIEW: 'preview',
        FINISH: 'finish',
        CANCEL: 'cancel',
        CANCELEDITING: 'cancelEditing',
        PAYMENT_DETAILS: 'paymentDetails',
        ORDER_CREATE_CONFIRM: 'orderCreateConfirm',
        CONFIRM_DELETE_CONTACT: 'confirmDeleteContact',
        INVITE_WELCOME: 'inviteWelcome'
    },

    InvitationTypes: {
        normal: 1,
        share: 2
    },

    CartonomyMode: {
        default: 0,
        marketing: 1
    },

    PAYPAL_CHECKOUT_URL: 'https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=',

    EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    DEFAULT_AVATAR_URL: 'resources/images/in_page_img/def_avatar.png',
    DEFAULT_PRODUCT_IMAGE: '/resources/images/in_page_img/coming_soon_image_1.jpg',
    EMPTY_SESSION_ID: '00000000-0000-0000-0000-000000000000',
    CHAT_MESSAGES_LIMIT: 5,
    MAXIMUM_CHAT_TEXT_LENGTH: 256,
    CHAT_TIME_LABEL: '[timeUtc]',
    INVITE_LINK: '?t=1/#/invite/',

    GENERAL_MILLS_POC: ['pillsbury.com', 'bettycrocker.com', 'tablespoon.com'],
    CART_NAME_DEFAULT_VALUE: 'client.external.custom_cart_name'
};

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(22);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('Cartonomy.Shared', ['ngResource']);

_module.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
}]);

exports.default = _module;

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Utilities
//


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _class(obj) {
  return Object.prototype.toString.call(obj);
}

function isString(obj) {
  return _class(obj) === '[object String]';
}

var _hasOwnProperty = Object.prototype.hasOwnProperty;

function has(object, key) {
  return _hasOwnProperty.call(object, key);
}

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) {
      return;
    }

    if ((typeof source === 'undefined' ? 'undefined' : _typeof(source)) !== 'object') {
      throw new TypeError(source + 'must be object');
    }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function arrayReplaceAt(src, pos, newElements) {
  return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}

////////////////////////////////////////////////////////////////////////////////

function isValidEntityCode(c) {
  /*eslint no-bitwise:0*/
  // broken sequence
  if (c >= 0xD800 && c <= 0xDFFF) {
    return false;
  }
  // never used
  if (c >= 0xFDD0 && c <= 0xFDEF) {
    return false;
  }
  if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) {
    return false;
  }
  // control codes
  if (c >= 0x00 && c <= 0x08) {
    return false;
  }
  if (c === 0x0B) {
    return false;
  }
  if (c >= 0x0E && c <= 0x1F) {
    return false;
  }
  if (c >= 0x7F && c <= 0x9F) {
    return false;
  }
  // out of range
  if (c > 0x10FFFF) {
    return false;
  }
  return true;
}

function fromCodePoint(c) {
  /*eslint no-bitwise:0*/
  if (c > 0xffff) {
    c -= 0x10000;
    var surrogate1 = 0xd800 + (c >> 10),
        surrogate2 = 0xdc00 + (c & 0x3ff);

    return String.fromCharCode(surrogate1, surrogate2);
  }
  return String.fromCharCode(c);
}

var UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var UNESCAPE_ALL_RE = new RegExp(UNESCAPE_MD_RE.source + '|' + ENTITY_RE.source, 'gi');

var DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;

var entities = __webpack_require__(420);

function replaceEntityPattern(match, name) {
  var code = 0;

  if (has(entities, name)) {
    return entities[name];
  }

  if (name.charCodeAt(0) === 0x23 /* # */ && DIGITAL_ENTITY_TEST_RE.test(name)) {
    code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
    if (isValidEntityCode(code)) {
      return fromCodePoint(code);
    }
  }

  return match;
}

/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/

function unescapeMd(str) {
  if (str.indexOf('\\') < 0) {
    return str;
  }
  return str.replace(UNESCAPE_MD_RE, '$1');
}

function unescapeAll(str) {
  if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) {
    return str;
  }

  return str.replace(UNESCAPE_ALL_RE, function (match, escaped, entity) {
    if (escaped) {
      return escaped;
    }
    return replaceEntityPattern(match, entity);
  });
}

////////////////////////////////////////////////////////////////////////////////

var HTML_ESCAPE_TEST_RE = /[&<>"]/;
var HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var HTML_REPLACEMENTS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
};

function replaceUnsafeChar(ch) {
  return HTML_REPLACEMENTS[ch];
}

function escapeHtml(str) {
  if (HTML_ESCAPE_TEST_RE.test(str)) {
    return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
  }
  return str;
}

////////////////////////////////////////////////////////////////////////////////

var REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;

function escapeRE(str) {
  return str.replace(REGEXP_ESCAPE_RE, '\\$&');
}

////////////////////////////////////////////////////////////////////////////////

function isSpace(code) {
  switch (code) {
    case 0x09:
    case 0x20:
      return true;
  }
  return false;
}

// Zs (unicode class) || [\t\f\v\r\n]
function isWhiteSpace(code) {
  if (code >= 0x2000 && code <= 0x200A) {
    return true;
  }
  switch (code) {
    case 0x09: // \t
    case 0x0A: // \n
    case 0x0B: // \v
    case 0x0C: // \f
    case 0x0D: // \r
    case 0x20:
    case 0xA0:
    case 0x1680:
    case 0x202F:
    case 0x205F:
    case 0x3000:
      return true;
  }
  return false;
}

////////////////////////////////////////////////////////////////////////////////

/*eslint-disable max-len*/
var UNICODE_PUNCT_RE = __webpack_require__(113);

// Currently without astral characters support.
function isPunctChar(ch) {
  return UNICODE_PUNCT_RE.test(ch);
}

// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function isMdAsciiPunct(ch) {
  switch (ch) {
    case 0x21 /* ! */:
    case 0x22 /* " */:
    case 0x23 /* # */:
    case 0x24 /* $ */:
    case 0x25 /* % */:
    case 0x26 /* & */:
    case 0x27 /* ' */:
    case 0x28 /* ( */:
    case 0x29 /* ) */:
    case 0x2A /* * */:
    case 0x2B /* + */:
    case 0x2C /* , */:
    case 0x2D /* - */:
    case 0x2E /* . */:
    case 0x2F /* / */:
    case 0x3A /* : */:
    case 0x3B /* ; */:
    case 0x3C /* < */:
    case 0x3D /* = */:
    case 0x3E /* > */:
    case 0x3F /* ? */:
    case 0x40 /* @ */:
    case 0x5B /* [ */:
    case 0x5C /* \ */:
    case 0x5D /* ] */:
    case 0x5E /* ^ */:
    case 0x5F /* _ */:
    case 0x60 /* ` */:
    case 0x7B /* { */:
    case 0x7C /* | */:
    case 0x7D /* } */:
    case 0x7E /* ~ */:
      return true;
    default:
      return false;
  }
}

// Hepler to unify [reference labels].
//
function normalizeReference(str) {
  // use .toUpperCase() instead of .toLowerCase()
  // here to avoid a conflict with Object.prototype
  // members (most notably, `__proto__`)
  return str.trim().replace(/\s+/g, ' ').toUpperCase();
}

////////////////////////////////////////////////////////////////////////////////

// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
exports.lib = {};
exports.lib.mdurl = __webpack_require__(421);
exports.lib.ucmicro = __webpack_require__(710);

exports.assign = assign;
exports.isString = isString;
exports.has = has;
exports.unescapeMd = unescapeMd;
exports.unescapeAll = unescapeAll;
exports.isValidEntityCode = isValidEntityCode;
exports.fromCodePoint = fromCodePoint;
// exports.replaceEntities     = replaceEntities;
exports.escapeHtml = escapeHtml;
exports.arrayReplaceAt = arrayReplaceAt;
exports.isSpace = isSpace;
exports.isWhiteSpace = isWhiteSpace;
exports.isMdAsciiPunct = isMdAsciiPunct;
exports.isPunctChar = isPunctChar;
exports.escapeRE = escapeRE;
exports.normalizeReference = normalizeReference;

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var scopeUtils = {
    apply: function apply($scope, fn) {
        if (!$scope || !$scope.$root) return;

        var phase = $scope.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            if (fn && typeof fn === 'function') {
                fn();
            }
        } else {
            $scope.$apply(fn);
        }
    }
};

exports.default = scopeUtils;

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(22);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('Cartonomy.Order', []);

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var commandKeys = exports.commandKeys = {
    checkOutCart: "CHECK_OUT_CART",
    userLoggedIn: "USER_LOGGED_IN",
    checkCartItems: "CHECK_CART_ITEMS",
    clearCartItems: "CLEAR_CART_ITEMS",
    addProductToCart: "ADD_PRODUCT_TO_CART",
    removeAddToCartButton: "REMOVE_ADD_TO_CART_BUTTON",
    enableAddToCartButton: "ENABLE_ADD_TO_CART_BUTTON",
    windowStateChange: "WIDGET_WINDOW_STATE_CHANGE",
    checkoutCart: "CHECKOUT_CART_ITEMS",
    addToCartButtonDetected: "ADD_TO_CART_BUTTON_DETECTED",
    widgetInitialized: "WIDGET_INITIALIZATION_FINISHED",
    removeHashKey: "REMOVE_HASH_KEY",
    updateMyCartButtonText: "UPDATE_MY_CART_BUTTON_TEXT",
    createNewGroupOrder: "CREATE_NEW_GROUP_ORDER",
    invitationAccepted: "INVITATION_ACCEPTED",
    checkProductCartCapability: "CHECK_PRODUCT_CART_CAPABILITY",
    moneyFormatChange: "MONEY_FORMAT_CHANGE",
    getLocation: "GET_LOCATION",
    getTranslations: "GET_TRANSLATION"
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommunicationService = exports.CommunicationService = function () {
  function CommunicationService() {
    _classCallCheck(this, CommunicationService);
  }

  _createClass(CommunicationService, [{
    key: 'setWidgetTarget',
    value: function setWidgetTarget(widgetTarget) {
      this.widgetTarget = widgetTarget;
      this._tryAttemps = 0;
    }
  }, {
    key: 'requestToParent',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(command, data) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', new Promise(function (resolve, reject) {
                  var responseMessageId = 'ResponseToCommand_' + command + '_' + new Date().getTime();
                  var onResponseReceive = function onResponseReceive(event) {
                    if (event.data.action === responseMessageId) {
                      delete event.data.action;
                      resolve(event.data);
                      window.removeEventListener('message', onResponseReceive);
                    }
                  };

                  window.addEventListener('message', onResponseReceive);

                  window.parent.postMessage({
                    action: command,
                    responseCommand: responseMessageId,
                    data: data
                  }, '*');
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function requestToParent(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return requestToParent;
    }()
  }, {
    key: 'requestToWidget',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(command, data) {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.widgetTarget) {
                  _context2.next = 8;
                  break;
                }

                if (!(this._tryAttemps >= 3)) {
                  _context2.next = 6;
                  break;
                }

                this._tryAttemps = 0;
                return _context2.abrupt('return');

              case 6:
                this._tryAttemps++;
                setTimeout(function () {
                  return _this.requestToWidget(command, data);
                }, 500);

              case 8:
                return _context2.abrupt('return', new Promise(function (resolve, reject) {
                  var responseMessageId = 'ResponseToCommand_' + command + '_' + new Date().getTime();
                  var onResponseReceive = function onResponseReceive(event) {
                    if (event.data.action === responseMessageId) {
                      delete event.data.action;
                      resolve(event.data);
                      window.removeEventListener('message', onResponseReceive);
                    }
                  };

                  window.addEventListener('message', onResponseReceive);

                  _this.widgetTarget.contentWindow.postMessage({
                    action: command,
                    responseCommand: responseMessageId,
                    data: data
                  }, '*');
                }));

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function requestToWidget(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return requestToWidget;
    }()
  }], [{
    key: 'getInstance',
    value: function getInstance() {
      return CommunicationService._instance || (CommunicationService._instance = new CommunicationService());
    }
  }]);

  return CommunicationService;
}();

CommunicationService._instance = null;
var communicationService = exports.communicationService = CommunicationService.getInstance();

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utils = undefined;

var _translateJs = __webpack_require__(655);

var _translateJs2 = _interopRequireDefault(_translateJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var localStorageCartonomyHashKey = 'cartonomy_shopify_url_hash';

var utils = exports.utils = {
    $: null,
    localStorageCartonomyHashKey: localStorageCartonomyHashKey,
    isIOS: /ios|iphone|android/gi.test(navigator.userAgent),
    isIOSMobile: /ios|iphone/gi.test(navigator.userAgent),
    bodyDOM: null,
    headDOM: null,
    cartonomyBaseUrl: '//apppartner1.cartonomy.com',
    cartonomyApiUrl: 'https://apipartner1.cartonomy.com/api/',
    retailerShop: '',
    hash: decodeURIComponent(window.location.hash) || window.localStorage.getItem(localStorageCartonomyHashKey) || '',
    cartonomyOpenIndicatorName: 'cartonomy-opened',
    addToGroupCartButtonId: 'AddToGroupCart',
    possibleProductVariantSelector: [],
    possibleProductQuantitySelector: [],
    ignoreTriggerCloseSelector: [],
    localStorageAddCartBtnTextKey: 'cartonomy_group_shopping_button_text',
    myGroupOrdertButtonText: 'client.button.my_group_order',
    addToCartButtonText: 'client.button.add_to_new_order',
    addToMyCartButtonText: 'client.button.add_to_my_cart',
    addToMyGroupButtonText: 'client.button.add_to_my_group',
    customCartnameValue: 'client.external.custom_cart_name',
    externalStoreWindowTitle: 'client.external.external_store_title',
    originalWidget: {
        width: null,
        height: null
    },
    customAvatarText: '',
    moneyFormat: '',
    isInvitingMode: function isInvitingMode() {
        return this.hash.toLowerCase().indexOf('invite/') > -1;
    },
    isOauthCallbackMode: function isOauthCallbackMode() {
        return this.hash.toLowerCase().indexOf('auth_token') > -1;
    },
    isShowedCartonomyOnPages: function isShowedCartonomyOnPages() {
        //Apply for Shopify
        return window.location.href.indexOf('/collections/') > -1 || window.location.href.indexOf('/products/') > -1;
    },
    isAlwaysShowCartonomy: function isAlwaysShowCartonomy() {
        return window.location.hash.indexOf('/invite/') > -1 || window.location.pathname === '/';
    },
    toPossessiveString: function toPossessiveString(name) {
        return (0, _translateJs2.default)('client.possessive_name', { name: name });
    },
    compileMyCartButtonText: function compileMyCartButtonText(value) {
        var shouldTranslate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        if (!value) return shouldTranslate ? (0, _translateJs2.default)(this.addToMyCartButtonText) : this.addToMyCartButtonText;

        return shouldTranslate ? (0, _translateJs2.default)('client.button.add_to', { user: (0, _translateJs2.default)(value) }) : 'client.button.add_to';
    },
    findClosest: function findClosest(selector, fromChild) {
        var parent = fromChild.parent();
        while (parent) {
            if (parent.is('body')) return null;

            if (parent.is(selector)) return parent;

            parent = parent.parent();
        }

        return null;
    },
    checkIfIE: function checkIfIE() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("Trident");

        return msie > 0;
    }
};

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Merge two attribute objects giving precedence
 * to values in object `b`. Classes are special-cased
 * allowing for arrays and merging/joining appropriately
 * resulting in a string.
 *
 * @param {Object} a
 * @param {Object} b
 * @return {Object} a
 * @api private
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.merge = function merge(a, b) {
  if (arguments.length === 1) {
    var attrs = a[0];
    for (var i = 1; i < a.length; i++) {
      attrs = merge(attrs, a[i]);
    }
    return attrs;
  }
  var ac = a['class'];
  var bc = b['class'];

  if (ac || bc) {
    ac = ac || [];
    bc = bc || [];
    if (!Array.isArray(ac)) ac = [ac];
    if (!Array.isArray(bc)) bc = [bc];
    a['class'] = ac.concat(bc).filter(nulls);
  }

  for (var key in b) {
    if (key != 'class') {
      a[key] = b[key];
    }
  }

  return a;
};

/**
 * Filter null `val`s.
 *
 * @param {*} val
 * @return {Boolean}
 * @api private
 */

function nulls(val) {
  return val != null && val !== '';
}

/**
 * join array as classes.
 *
 * @param {*} val
 * @return {String}
 */
exports.joinClasses = joinClasses;
function joinClasses(val) {
  return (Array.isArray(val) ? val.map(joinClasses) : val && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' ? Object.keys(val).filter(function (key) {
    return val[key];
  }) : [val]).filter(nulls).join(' ');
}

/**
 * Render the given classes.
 *
 * @param {Array} classes
 * @param {Array.<Boolean>} escaped
 * @return {String}
 */
exports.cls = function cls(classes, escaped) {
  var buf = [];
  for (var i = 0; i < classes.length; i++) {
    if (escaped && escaped[i]) {
      buf.push(exports.escape(joinClasses([classes[i]])));
    } else {
      buf.push(joinClasses(classes[i]));
    }
  }
  var text = joinClasses(buf);
  if (text.length) {
    return ' class="' + text + '"';
  } else {
    return '';
  }
};

exports.style = function (val) {
  if (val && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
    return Object.keys(val).map(function (style) {
      return style + ':' + val[style];
    }).join(';');
  } else {
    return val;
  }
};
/**
 * Render the given attribute.
 *
 * @param {String} key
 * @param {String} val
 * @param {Boolean} escaped
 * @param {Boolean} terse
 * @return {String}
 */
exports.attr = function attr(key, val, escaped, terse) {
  if (key === 'style') {
    val = exports.style(val);
  }
  if ('boolean' == typeof val || null == val) {
    if (val) {
      return ' ' + (terse ? key : key + '="' + key + '"');
    } else {
      return '';
    }
  } else if (0 == key.indexOf('data') && 'string' != typeof val) {
    if (JSON.stringify(val).indexOf('&') !== -1) {
      console.warn('Since Jade 2.0.0, ampersands (`&`) in data attributes ' + 'will be escaped to `&amp;`');
    };
    if (val && typeof val.toISOString === 'function') {
      console.warn('Jade will eliminate the double quotes around dates in ' + 'ISO form after 2.0.0');
    }
    return ' ' + key + "='" + JSON.stringify(val).replace(/'/g, '&apos;') + "'";
  } else if (escaped) {
    if (val && typeof val.toISOString === 'function') {
      console.warn('Jade will stringify dates in ISO form after 2.0.0');
    }
    return ' ' + key + '="' + exports.escape(val) + '"';
  } else {
    if (val && typeof val.toISOString === 'function') {
      console.warn('Jade will stringify dates in ISO form after 2.0.0');
    }
    return ' ' + key + '="' + val + '"';
  }
};

/**
 * Render the given attributes object.
 *
 * @param {Object} obj
 * @param {Object} escaped
 * @return {String}
 */
exports.attrs = function attrs(obj, terse) {
  var buf = [];

  var keys = Object.keys(obj);

  if (keys.length) {
    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i],
          val = obj[key];

      if ('class' == key) {
        if (val = joinClasses(val)) {
          buf.push(' ' + key + '="' + val + '"');
        }
      } else {
        buf.push(exports.attr(key, val, false, terse));
      }
    }
  }

  return buf.join('');
};

/**
 * Escape the given string of `html`.
 *
 * @param {String} html
 * @return {String}
 * @api private
 */

var jade_encode_html_rules = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
};
var jade_match_html = /[&<>"]/g;

function jade_encode_char(c) {
  return jade_encode_html_rules[c] || c;
}

exports.escape = jade_escape;
function jade_escape(html) {
  var result = String(html).replace(jade_match_html, jade_encode_char);
  if (result === '' + html) return html;else return result;
};

/**
 * Re-throw the given `err` in context to the
 * the jade in `filename` at the given `lineno`.
 *
 * @param {Error} err
 * @param {String} filename
 * @param {String} lineno
 * @api private
 */

exports.rethrow = function rethrow(err, filename, lineno, str) {
  if (!(err instanceof Error)) throw err;
  if ((typeof window != 'undefined' || !filename) && !str) {
    err.message += ' on line ' + lineno;
    throw err;
  }
  try {
    str = str || __webpack_require__(651).readFileSync(filename, 'utf8');
  } catch (ex) {
    rethrow(err, null, lineno);
  }
  var context = 3,
      lines = str.split('\n'),
      start = Math.max(lineno - context, 0),
      end = Math.min(lines.length, lineno + context);

  // Error context
  var context = lines.slice(start, end).map(function (line, i) {
    var curr = i + start + 1;
    return (curr == lineno ? '  > ' : '    ') + curr + '| ' + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'Jade') + ':' + lineno + '\n' + context + '\n\n' + err.message;
  throw err;
};

exports.DebugItem = function DebugItem(lineno, filename) {
  this.lineno = lineno;
  this.filename = filename;
};

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(22);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('Cartonomy.Profile', []);

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(22);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('Cartonomy.Cart', []);

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/


/**
 * new Ruler()
 **/

function Ruler() {
  // List of added rules. Each element is:
  //
  // {
  //   name: XXX,
  //   enabled: Boolean,
  //   fn: Function(),
  //   alt: [ name2, name3 ]
  // }
  //
  this.__rules__ = [];

  // Cached rule chains.
  //
  // First level - chain name, '' for default.
  // Second level - diginal anchor for fast filtering by charcodes.
  //
  this.__cache__ = null;
}

////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly


// Find rule index by name
//
Ruler.prototype.__find__ = function (name) {
  for (var i = 0; i < this.__rules__.length; i++) {
    if (this.__rules__[i].name === name) {
      return i;
    }
  }
  return -1;
};

// Build rules lookup cache
//
Ruler.prototype.__compile__ = function () {
  var self = this;
  var chains = [''];

  // collect unique names
  self.__rules__.forEach(function (rule) {
    if (!rule.enabled) {
      return;
    }

    rule.alt.forEach(function (altName) {
      if (chains.indexOf(altName) < 0) {
        chains.push(altName);
      }
    });
  });

  self.__cache__ = {};

  chains.forEach(function (chain) {
    self.__cache__[chain] = [];
    self.__rules__.forEach(function (rule) {
      if (!rule.enabled) {
        return;
      }

      if (chain && rule.alt.indexOf(chain) < 0) {
        return;
      }

      self.__cache__[chain].push(rule.fn);
    });
  });
};

/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.at = function (name, fn, options) {
  var index = this.__find__(name);
  var opt = options || {};

  if (index === -1) {
    throw new Error('Parser rule not found: ' + name);
  }

  this.__rules__[index].fn = fn;
  this.__rules__[index].alt = opt.alt || [];
  this.__cache__ = null;
};

/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.before = function (beforeName, ruleName, fn, options) {
  var index = this.__find__(beforeName);
  var opt = options || {};

  if (index === -1) {
    throw new Error('Parser rule not found: ' + beforeName);
  }

  this.__rules__.splice(index, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.after = function (afterName, ruleName, fn, options) {
  var index = this.__find__(afterName);
  var opt = options || {};

  if (index === -1) {
    throw new Error('Parser rule not found: ' + afterName);
  }

  this.__rules__.splice(index + 1, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.push = function (ruleName, fn, options) {
  var opt = options || {};

  this.__rules__.push({
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/
Ruler.prototype.enable = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) {
    list = [list];
  }

  var result = [];

  // Search by name and enable
  list.forEach(function (name) {
    var idx = this.__find__(name);

    if (idx < 0) {
      if (ignoreInvalid) {
        return;
      }
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = true;
    result.push(name);
  }, this);

  this.__cache__ = null;
  return result;
};

/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/
Ruler.prototype.enableOnly = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) {
    list = [list];
  }

  this.__rules__.forEach(function (rule) {
    rule.enabled = false;
  });

  this.enable(list, ignoreInvalid);
};

/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/
Ruler.prototype.disable = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) {
    list = [list];
  }

  var result = [];

  // Search by name and disable
  list.forEach(function (name) {
    var idx = this.__find__(name);

    if (idx < 0) {
      if (ignoreInvalid) {
        return;
      }
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = false;
    result.push(name);
  }, this);

  this.__cache__ = null;
  return result;
};

/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/
Ruler.prototype.getRules = function (chainName) {
  if (this.__cache__ === null) {
    this.__compile__();
  }

  // Chain can be empty, if rules disabled. But we still have to return Array.
  return this.__cache__[chainName] || [];
};

module.exports = Ruler;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Token class



/**
 * class Token
 **/

/**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/

function Token(type, tag, nesting) {
  /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/
  this.type = type;

  /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/
  this.tag = tag;

  /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/
  this.attrs = null;

  /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/
  this.map = null;

  /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/
  this.nesting = nesting;

  /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/
  this.level = 0;

  /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/
  this.children = null;

  /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/
  this.content = '';

  /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/
  this.markup = '';

  /**
   * Token#info -> String
   *
   * fence infostring
   **/
  this.info = '';

  /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/
  this.meta = null;

  /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/
  this.block = false;

  /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/
  this.hidden = false;
}

/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/
Token.prototype.attrIndex = function attrIndex(name) {
  var attrs, i, len;

  if (!this.attrs) {
    return -1;
  }

  attrs = this.attrs;

  for (i = 0, len = attrs.length; i < len; i++) {
    if (attrs[i][0] === name) {
      return i;
    }
  }
  return -1;
};

/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/
Token.prototype.attrPush = function attrPush(attrData) {
  if (this.attrs) {
    this.attrs.push(attrData);
  } else {
    this.attrs = [attrData];
  }
};

/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/
Token.prototype.attrSet = function attrSet(name, value) {
  var idx = this.attrIndex(name),
      attrData = [name, value];

  if (idx < 0) {
    this.attrPush(attrData);
  } else {
    this.attrs[idx] = attrData;
  }
};

/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/
Token.prototype.attrGet = function attrGet(name) {
  var idx = this.attrIndex(name),
      value = null;
  if (idx >= 0) {
    value = this.attrs[idx][1];
  }
  return value;
};

/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/
Token.prototype.attrJoin = function attrJoin(name, value) {
  var idx = this.attrIndex(name);

  if (idx < 0) {
    this.attrPush([name, value]);
  } else {
    this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
  }
};

module.exports = Token;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(22);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('Cartonomy.Catalog', []);

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cartonomy_config = __webpack_require__(413);

var _cartonomy_config2 = _interopRequireDefault(_cartonomy_config);

var _index = __webpack_require__(646);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(652);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(770);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(788);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(814);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(824);

var _index12 = _interopRequireDefault(_index11);

var _angular = __webpack_require__(22);

var _angular2 = _interopRequireDefault(_angular);

var _angularAnimate = __webpack_require__(85);

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _angularCookies = __webpack_require__(118);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularMaterial = __webpack_require__(119);

var _angularMaterial2 = _interopRequireDefault(_angularMaterial);

var _angularMessages = __webpack_require__(120);

var _angularMessages2 = _interopRequireDefault(_angularMessages);

var _angularMoment = __webpack_require__(121);

var _angularMoment2 = _interopRequireDefault(_angularMoment);

var _angularResource = __webpack_require__(237);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _angularSanitize = __webpack_require__(836);

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _angularUiRouter = __webpack_require__(238);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _angularUiMask = __webpack_require__(239);

var _angularUiMask2 = _interopRequireDefault(_angularUiMask);

var _angularMarked = __webpack_require__(838);

var _angularMarked2 = _interopRequireDefault(_angularMarked);

var _angularSmartTable = __webpack_require__(841);

var _angularSmartTable2 = _interopRequireDefault(_angularSmartTable);

var _ngMaterialDatetimepicker = __webpack_require__(240);

var _ngMaterialDatetimepicker2 = _interopRequireDefault(_ngMaterialDatetimepicker);

var _angularTranslate = __webpack_require__(843);

var _angularTranslate2 = _interopRequireDefault(_angularTranslate);

var _angularTranslateLoaderUrl = __webpack_require__(844);

var _angularTranslateLoaderUrl2 = _interopRequireDefault(_angularTranslateLoaderUrl);

var _angularSignalrHub = __webpack_require__(845);

var _angularSignalrHub2 = _interopRequireDefault(_angularSignalrHub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dependencies = [_angularResource2.default, _angularCookies2.default, _angularMaterial2.default, _angularSmartTable2.default, _angularMessages2.default, _angularMoment2.default, _angularAnimate2.default, _angularSanitize2.default, _angularUiRouter2.default, _angularUiMask2.default, _angularMarked2.default, _angularSignalrHub2.default.name, _ngMaterialDatetimepicker2.default, _angularTranslate2.default, _angularTranslateLoaderUrl2.default,

// application modules
_index2.default, _index4.default, _index6.default, _index12.default, _index8.default, _index10.default];

var _module = _angular2.default.module('Cartonomy', dependencies);
_module.config(['$mdThemingProvider', 'uiMask.ConfigProvider', '$qProvider', '$translateProvider', function (themingProvider, uiMaskConfigProvider, $qProvider, $translateProvider) {
    themingProvider.theme('default').primaryPalette('blue').accentPalette('grey');
    uiMaskConfigProvider.maskDefinitions({ '9': /\d/, 'A': /[a-zA-Z]/, '*': /[a-zA-Z0-9]/, '2': /[2-9]/ });
    uiMaskConfigProvider.clearOnBlur(false);
    uiMaskConfigProvider.eventsToHandle(['input', 'keyup', 'click']);

    $qProvider.errorOnUnhandledRejections(false);

    $translateProvider.useUrlLoader(_cartonomy_config2.default.backendEndPoint + '/api/locales');
    $translateProvider.preferredLanguage('default');
}]);

_module.constant('cartonomyConfig', _cartonomy_config2.default);

exports.default = _module;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getPageParam(name) {
    if (name = new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)').exec(location.search)) return decodeURIComponent(name[1]);
}

var shopName = getPageParam("shop");

// TODO: this line should be removed in production
var url = window.CARTONOMY_API_URL || 'https://apipartner1.cartonomy.com/api/';

var backendEndPoint = url.substr(0, url.lastIndexOf('/api'));

var cartonomyConfig = {
    backendEndPoint: backendEndPoint,
    ApiV1: url + 'v1/',
    ApiV2: url + 'v2/',
    version: '4.4.21',
    buildTime: '2023-10-25T09:24:53.841Z',
    externalStoreMode: window.EXTERNAL_STORE_MODE || false,
    externalStoreUrl: shopName,
    getPageParam: getPageParam
};

exports.default = cartonomyConfig;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalStoreHandler = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _IdleDetectingService = __webpack_require__(415);

var _commandKeys = __webpack_require__(27);

var _commandHandlerService = __webpack_require__(416);

var _communicationService = __webpack_require__(28);

var _utils = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExternalStoreHandler = exports.ExternalStoreHandler = function () {
  function ExternalStoreHandler(scope, rootScope, timeoutService, authenticationService, sessionService, cartService, groupOrderService, orderSetupService, stateService, messageService, localForageService, heapService, $translate) {
    var _this = this;

    _classCallCheck(this, ExternalStoreHandler);

    this._scope = scope;
    this._rootScope = rootScope;
    this._cartService = cartService;
    this._groupOrderService = groupOrderService;
    this._stateService = stateService;
    this._sessionService = sessionService;
    //this._sessionStorageService = sessionStorageService;
    this._localForageService = localForageService;
    this._messageService = messageService;
    this._orderSetupService = orderSetupService;
    this._scope.needAddItem = false;
    this._authenticationService = authenticationService;
    this._heapService = heapService;
    this.timeoutService = timeoutService;
    this.$translate = $translate;

    this._scope.variantId = null;
    this._scope.quantity = null;
    this.isMobile = /iphone|android/gi.test(navigator.userAgent);

    this.idleTimeBeforeRefreshing = this.isMobile ? 5 : 15; // minutes

    this._scope.$on(_CommonConstants2.default.Events.ORDER_CREATED, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', _this._onOrderSetupFinished());

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    })));
    this._scope.$on(_CommonConstants2.default.Events.ORDER_CANCELLED, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', _this._onOrderCancelled());

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    })));
    this._scope.$on(_CommonConstants2.default.Events.LEFT_ORDER, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', _this._onParticipantLeftOrder());

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    })));

    this._scope.$on(_CommonConstants2.default.Events.USER_LOGGED_IN, function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(scope, registration) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', _this._onUserLoggedIn(registration));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this);
      }));

      return function (_x, _x2) {
        return _ref4.apply(this, arguments);
      };
    }());
    this._scope.$on(_CommonConstants2.default.Events.USER_LOGGED_OUT, function () {
      return _this._onUserLoggedOut();
    });
    this._scope.$on(_CommonConstants2.default.Events.INVITATION_ACCEPTED, function () {
      return _this._onInvitationAccepted();
    });
    this._scope.$on(_CommonConstants2.default.Events.CART_ITEMS_CHANGED, function () {
      return _this._onProductItemsChanged();
    });
    this._scope.$on(_CommonConstants2.default.RootEvents.USER_PROFILE_UPDATED, function () {
      return _this._onUserProfileChanged();
    });
    this._scope.$on(_CommonConstants2.default.Events.EXTERNAL_PRODUCT_DETAIL_REQUESTED, function (scope, shopifyProductUrl) {
      return _this._onProductDetailRequested(shopifyProductUrl);
    });
    this._scope.$on(_CommonConstants2.default.Events.ORDER_CANCELLED_BY_OWNER, _.debounce(function () {
      return _this._onOrderCancelledByOwner();
    }, 300));
    this._scope.$on(_CommonConstants2.default.Events.ORDER_CLEARED_BY_OWNER, _.debounce(function () {
      return _this._onOrderClearedByOwner();
    }, 300));
    this._scope.$on(_CommonConstants2.default.Events.USER_REMOVED_BY_OWNER, _.debounce(function () {
      return _this._onUserRemovedByOwner();
    }, 300));
    this._scope.$on(_CommonConstants2.default.Events.ORDER_CHECKED_OUT, _.debounce(function () {
      return _this._onOrderCheckedOut();
    }, 300));
    this._scope.$on(_CommonConstants2.default.Events.CART_OWNERSHIP_TRANSFERRED, _.debounce(function (scope, obj) {
      return _this._onOwnershipTransferred(obj);
    }, 300));
    this._scope.$on(_CommonConstants2.default.Events.USER_JOINED_OTHER_CART, _.debounce(function (scope, obj) {
      return _this._onUserJoinedOtherCart(obj);
    }, 300));

    this._scope.$on(_CommonConstants2.default.RootEvents.CART_CHANGED, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this._onCartChanged();

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    })));

    this._rootScope.toggleWindowState = function (e) {
      return _this._toggleWindowState("", e);
    };
    this._rootScope.enlargeWidget = function (e) {
      return _this._enlargeWidget();
    };
    this._rootScope.collapsed = !stateService.is(_CommonConstants2.default.RoutingStates.CONFIRM_TICKET) && !stateService.is(_CommonConstants2.default.RoutingStates.INVITE) && !stateService.is(_CommonConstants2.default.RoutingStates.LOGIN_TICKET) && !rootScope.safariWarningIsShowing;

    this._scope.externalStoreWindowTitle = '';
    this.canAddCurrentProduct = false;

    this._scope._createGroupOrder = function () {
      return _this._createGroupOrder();
    };
    this._scope.createGroupOrderIfNeeded = function (e) {
      return _this._createGroupOrderIfNeeded(e);
    };
    this._scope.toggleChat = function () {
      return _this._toggleChatPage();
    };
    this._scope.toggleOrderPage = function () {
      return _this._toggleOrderPage();
    };
    this._scope.toggleProfilePage = function () {
      return _this._toggleProfilePage();
    };
    this._scope.toggleInvitedPeoplePage = function () {
      return _this._toggleInvitedPeoplePage();
    };
    this._scope.showVersionPage = function () {
      return _this._showVersionPage();
    };
    this._scope.isOrderFreezed = false;

    this._rootScope.canAddCurrentProduct = function () {
      return _this.canAddCurrentProduct;
    };
    this._rootScope.addCurrentProduct = function () {
      return _this.addCurrentProduct();
    };

    this.addProductToCartHandler = {
      command: _commandKeys.commandKeys.addProductToCart,

      handle: function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(request, sender, sendResponse) {
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return _this.onProductAddRequested(request, sendResponse);

                case 2:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, _this);
        }));

        return function handle(_x3, _x4, _x5) {
          return _ref6.apply(this, arguments);
        };
      }()
    };

    this.windowStateChangeCommandHandler = {
      command: _commandKeys.commandKeys.windowStateChange,

      handle: function handle(request, sender, sendResponse) {
        _this.onWindowStateChanged(request, sendResponse);
      }
    };

    this.canAddCurrentProductHandler = {
      command: _commandKeys.commandKeys.addToCartButtonDetected,

      handle: function handle(request, sender, sendResponse) {
        _this.canAddCurrentProduct = true;
      }
    };

    this.checkProductCartCapabilityHandler = {
      command: _commandKeys.commandKeys.checkProductCartCapability,

      handle: function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(request, sender, sendResponse) {
          var cart;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return _this._cartService.getCart(undefined, request.data && request.data.fromCache);

                case 2:
                  cart = _context7.sent;

                  console.log(cart);

                case 4:
                case 'end':
                  return _context7.stop();
              }
            }
          }, _callee7, _this);
        }));

        return function handle(_x6, _x7, _x8) {
          return _ref7.apply(this, arguments);
        };
      }()
    };

    this.moneyFormatChangeHandler = {
      command: _commandKeys.commandKeys.moneyFormatChange,

      handle: function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(request, sender, sendResponse) {
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  console.log(request.data.moneyFormat);
                  _this._rootScope.moneyFormat = request.data.moneyFormat;

                case 2:
                case 'end':
                  return _context8.stop();
              }
            }
          }, _callee8, _this);
        }));

        return function handle(_x9, _x10, _x11) {
          return _ref8.apply(this, arguments);
        };
      }()
    };

    this.translationsHanler = {
      command: _commandKeys.commandKeys.getTranslations,

      handle: function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(request, sender, sendResponse) {
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  sendResponse(_this.$translate.getTranslationTable());

                case 1:
                case 'end':
                  return _context9.stop();
              }
            }
          }, _callee9, _this);
        }));

        return function handle(_x12, _x13, _x14) {
          return _ref9.apply(this, arguments);
        };
      }()
    };

    _commandHandlerService.commandHandlerService.registerHandler(this.addProductToCartHandler);
    _commandHandlerService.commandHandlerService.registerHandler(this.windowStateChangeCommandHandler);
    _commandHandlerService.commandHandlerService.registerHandler(this.canAddCurrentProductHandler);
    _commandHandlerService.commandHandlerService.registerHandler(this.checkProductCartCapabilityHandler);
    _commandHandlerService.commandHandlerService.registerHandler(this.moneyFormatChangeHandler);
    _commandHandlerService.commandHandlerService.registerHandler(this.translationsHanler);

    this._lastSessionState = null;
  }

  _createClass(ExternalStoreHandler, [{
    key: 'initialize',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _this2 = this;

        var self;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                new _IdleDetectingService.IdleDetectingService(function (idleTime) {
                  return _this2._onUserActiveAfterIdle(idleTime);
                });
                window.parent.postMessage({
                  checkWindowState: true,
                  cartonomyInitialized: true,
                  retailer: this._scope.retailer
                }, '*');

                _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.widgetInitialized, {});

                if (!this._stateService.is(_CommonConstants2.default.RoutingStates.CONFIRM_TICKET)) {
                  _context10.next = 7;
                  break;
                }

                _context10.next = 6;
                return this._stateService.go(_CommonConstants2.default.RoutingStates.CONFIRM_TICKET);

              case 6:
                return _context10.abrupt('return');

              case 7:
                _context10.next = 9;
                return this._localForageService.retrieve(_CommonConstants2.default.SessionStorage.LAST_STATE_NAME);

              case 9:
                this._lastSessionState = _context10.sent;

                if (!(this._lastSessionState && this._lastSessionState !== "invite")) {
                  _context10.next = 13;
                  break;
                }

                _context10.next = 13;
                return this._stateService.go(this._lastSessionState);

              case 13:
                self = this;

                this._rootScope.$on('$stateChangeStart', function (event, toState) {
                  if (toState.name !== _CommonConstants2.default.RoutingStates.CHECKOUT_FULL_MIXED) {
                    self._localForageService.store(_CommonConstants2.default.SessionStorage.LAST_STATE_NAME, toState.name).then(function () {});
                  }
                });

                _context10.next = 17;
                return this._sessionService.loggedIn();

              case 17:
                if (_context10.sent) {
                  _context10.next = 25;
                  break;
                }

                _context10.next = 20;
                return this._sendUserCartInfoToParent();

              case 20:
                window.parent.postMessage({
                  orderExists: false,
                  retailer: this._scope.retailer
                }, '*');

                if (this._stateService.is(_CommonConstants2.default.RoutingStates.LOGIN_TICKET)) {
                  _context10.next = 24;
                  break;
                }

                _context10.next = 24;
                return this._goToCart();

              case 24:
                return _context10.abrupt('return');

              case 25:
                if (!this._stateService.is(_CommonConstants2.default.RoutingStates.INVITE)) {
                  _context10.next = 28;
                  break;
                }

                this._scope.$on(_CommonConstants2.default.Events.INVITATION_ACCEPTED, function () {
                  return _this2._onUserLoggedIn(true);
                });
                return _context10.abrupt('return');

              case 28:
                if (this._stateService.is(_CommonConstants2.default.RoutingStates.LOGIN_TICKET)) {
                  _context10.next = 31;
                  break;
                }

                _context10.next = 31;
                return this._onUserLoggedIn();

              case 31:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function initialize() {
        return _ref10.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: 'addCurrentProduct',
    value: function addCurrentProduct() {
      _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.addProductToCart, {});
    }
  }, {
    key: 'onProductAddRequested',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(request, sendResponse) {
        var isStealthMode, qty, cart;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!this._addingProduct) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt('return');

              case 2:

                //Check Stealth mode
                isStealthMode = this._sessionService.getStealthUserMode();

                if (!isStealthMode) {
                  _context11.next = 8;
                  break;
                }

                _context11.next = 6;
                return this._messageService.showErrorPopup(this.$translate.instant('client.user.cart_restrict'));

              case 6:
                window.parent.postMessage({
                  addProductDone: true
                }, '*');
                return _context11.abrupt('return');

              case 8:
                qty = request.data.quantity || 1;
                _context11.next = 11;
                return this._cartService.getCart(undefined);

              case 11:
                cart = _context11.sent;

                if (!(cart.retailerStoreId && request.data.storeId !== cart.retailerStoreId)) {
                  _context11.next = 16;
                  break;
                }

                this._messageService.showErrorPopup(this.$translate.instant('client.user.product_restrict'));
                window.parent.postMessage({
                  addProductDone: true
                }, '*');
                return _context11.abrupt('return');

              case 16:
                _context11.next = 18;
                return this._onProductVariantReceived(request.data.productVariantId, qty, request.data.productName, request.data.productImage, request.data.productPrice, request.data.productOptions, request.data.productUrl);

              case 18:

                _scope2.default.apply(this._scope);

              case 19:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function onProductAddRequested(_x15, _x16) {
        return _ref11.apply(this, arguments);
      }

      return onProductAddRequested;
    }()
  }, {
    key: 'onWindowStateChanged',
    value: function onWindowStateChanged(event, sendResponse) {
      this._rootScope.collapsed = event.data.windowState === _CommonConstants2.default.WindowMode.minimized;

      this._rootScope.currentWindowState = event.data.windowState;
      this._rootScope.$broadcast(_CommonConstants2.default.Events.WINDOW_STATE_CHANGED, event.data.windowState);

      if (!this._rootScope.collapsed) {
        if (this._rootScope.orderCreationCancelRequested) {
          this._rootScope.orderCreationCancelRequested = false;
          this._goToCart();
        } else if (!this._scope.isProfile() && !this._scope.isChat() && !this._stateService.is(_CommonConstants2.default.RoutingStates.INVITE) && !this._stateService.is(_CommonConstants2.default.RoutingStates.INVITED_PEOPLE) && !this._stateService.is(_CommonConstants2.default.RoutingStates.STORE_ADMIN) && !this._stateService.is(_CommonConstants2.default.RoutingStates.OPEN_CARTS) && !this._stateService.is(_CommonConstants2.default.RoutingStates.LOGIN_TICKET) && !this._stateService.is(_CommonConstants2.default.RoutingStates.CONFIRM_TICKET)) {
          this._goToCart();
        }
      }

      _scope2.default.apply(this._scope);
      sendResponse({
        status: "onWindowStateChanged: event handled"
      });
    }
  }, {
    key: '_onProductVariantReceived',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(productVariantId, quantity, productName, productImage, productPrice, productOptions, productUrl) {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this._scope.variantId = productVariantId;
                this._scope.quantity = quantity;
                this._scope.productName = productName;
                this._scope.productImage = productImage;
                this._scope.productPrice = productPrice;
                this._scope.productOptions = productOptions;
                this._scope.productUrl = productUrl;

                _context12.next = 9;
                return this._checkGroupOrder();

              case 9:
                _context12.next = 11;
                return this._sessionService.loggedIn();

              case 11:
                _context12.t0 = _context12.sent;

                if (!_context12.t0) {
                  _context12.next = 14;
                  break;
                }

                _context12.t0 = this.orderExists;

              case 14:
                if (!_context12.t0) {
                  _context12.next = 20;
                  break;
                }

                _context12.next = 17;
                return this.addItemToCart();

              case 17:
                return _context12.abrupt('return');

              case 20:
                this._scope.needAddItem = true;

                if (!this._orderBeingCreated) {
                  _context12.next = 23;
                  break;
                }

                return _context12.abrupt('return');

              case 23:

                this._toggleWindowState("addProductTrigger");
                window.parent.postMessage({
                  addProductDone: true
                }, '*');

                _context12.next = 27;
                return this._setupNewOrder(this._scope.needAddItem);

              case 27:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function _onProductVariantReceived(_x17, _x18, _x19, _x20, _x21, _x22, _x23) {
        return _ref12.apply(this, arguments);
      }

      return _onProductVariantReceived;
    }()
  }, {
    key: '_onUserJoinedOtherCart',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(obj) {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (this._rootScope.forceInvite) {
                  _context13.next = 3;
                  break;
                }

                _context13.next = 3;
                return this._messageService.showMessagePopup(this.$translate.instant('client.order.joined_diff_group'));

              case 3:
                this._rootScope.forceInvite = false;
                this._sessionService.setCartReference(null);

              case 5:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function _onUserJoinedOtherCart(_x24) {
        return _ref13.apply(this, arguments);
      }

      return _onUserJoinedOtherCart;
    }()
  }, {
    key: '_onOrderSetupFinished',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!this._scope.needAddItem) {
                  _context14.next = 15;
                  break;
                }

                if (this.orderExists) {
                  _context14.next = 10;
                  break;
                }

                _context14.prev = 2;
                _context14.next = 5;
                return this._stateService.go(_CommonConstants2.default.RoutingStates.USER_PROFILE);

              case 5:
                _context14.next = 10;
                break;

              case 7:
                _context14.prev = 7;
                _context14.t0 = _context14['catch'](2);

                console.log(_context14.t0);

              case 10:
                // this._sessionStorageService.set(Constants.LAST_STATE_NAME, Constants.SessionStorage.CART);
                setTimeout(function () {
                  return _this3._goToCart();
                }, 10);
                _context14.next = 13;
                return this.addItemToCart();

              case 13:
                _context14.next = 16;
                break;

              case 15:
                this._goToChatPage();

              case 16:
                _context14.next = 18;
                return this._checkGroupOrder();

              case 18:
                _context14.next = 20;
                return this._sendUserCartInfoToParent();

              case 20:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this, [[2, 7]]);
      }));

      function _onOrderSetupFinished() {
        return _ref14.apply(this, arguments);
      }

      return _onOrderSetupFinished;
    }()
  }, {
    key: '_goToChatPage',
    value: function _goToChatPage() {
      this._stateService.go(_CommonConstants2.default.RoutingStates.CHAT);
    }
  }, {
    key: '_onUserLoggedOut',
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                window.parent.postMessage({
                  userDetails: {
                    userFirstName: null,
                    hasCart: null
                  },
                  orderExists: false,
                  retailer: this._scope.retailer
                }, '*');
                this._scope.externalStoreWindowTitle = this.$translate.instant('client.auth.signin');
                _context15.next = 4;
                return this._checkGroupOrder();

              case 4:
                _context15.next = 6;
                return this._sendUserCartInfoToParent();

              case 6:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function _onUserLoggedOut() {
        return _ref15.apply(this, arguments);
      }

      return _onUserLoggedOut;
    }()
  }, {
    key: '_toggleWindowState',
    value: function _toggleWindowState(trigger, e) {
      if (trigger === "") trigger = "titleBar";
      window.parent.postMessage({
        toggleWindowState: true,
        toggleWindowTrigger: trigger
      }, '*');
    }
  }, {
    key: '_enlargeWidget',
    value: function _enlargeWidget(e) {
      this._rootScope.enlarged = !this._rootScope.enlarged;
      window.parent.postMessage({
        enlargeWidgetState: true,
        enlargeTrigger: this._rootScope.enlarged ? 'enlarge' : 'decrease'
      }, '*');
    }
  }, {
    key: '_toggleChatPage',
    value: function _toggleChatPage() {
      this._scope.showChat();

      if (this._rootScope.collapsed) {
        this._toggleWindowState("chat");
      }

      this._cancelOrderCreationDialogIfNeeded();
    }
  }, {
    key: '_createGroupOrder',
    value: function _createGroupOrder() {
      this._goToCart();

      if (this._rootScope.collapsed) this._toggleWindowState("createOrder");
    }
  }, {
    key: '_createGroupOrderIfNeeded',
    value: function _createGroupOrderIfNeeded(e) {
      if (this._rootScope.collapsed) this._toggleWindowState("");
      // if(this._scope.groupOrderCreated) {
      //   return;
      // }
      // let trigger = "createOrder";
      // if (e != undefined && e.srcElement != undefined && e.srcElement.outerText == "My Group Order")
      //   trigger = "titleBar";
      // if (this.orderExists) {
      //   return;
      // }else{
      //   this._cartService.resetCartInvitationType();
      //   this._rootScope.$broadcast(Constants.Events.OPEN_SPLASH_SCREEN);
      // }
      //
      // this._goToCart();
    }
  }, {
    key: '_toggleOrderPage',
    value: function _toggleOrderPage() {
      if (this._scope.isOrderFreezed) {
        return;
      }
      if (!this.orderExists) {
        this._cartService.resetCartInvitationType();
        this._rootScope.$broadcast(_CommonConstants2.default.Events.OPEN_SPLASH_SCREEN);
      }

      this._scope.onCartBagClicked();

      if (this._rootScope.collapsed) this._toggleWindowState("cartBag");

      //this._cancelOrderCreationDialogIfNeeded();
    }
  }, {
    key: '_toggleProfilePage',
    value: function _toggleProfilePage() {
      this._scope.showAccount();

      this._cancelOrderCreationDialogIfNeeded();

      if (this._rootScope.collapsed) {
        this._toggleWindowState("profile");
      }
    }
  }, {
    key: '_showVersionPage',
    value: function _showVersionPage() {
      this._stateService.go(_CommonConstants2.default.RoutingStates.ABOUT);

      this._cancelOrderCreationDialogIfNeeded();

      this._rootScope.$broadcast(_CommonConstants2.default.Events.VERSION_PAGE_REQUESTED);

      if (this._rootScope.collapsed) {
        this._toggleWindowState("version");
      }
    }
  }, {
    key: '_toggleInvitedPeoplePage',
    value: function _toggleInvitedPeoplePage() {
      this._scope.showInvitedPeople();

      if (this._rootScope.collapsed) {
        this._toggleWindowState("invitedPeople");
      }

      this._cancelOrderCreationDialogIfNeeded();
    }
  }, {
    key: '_cancelOrderCreationDialogIfNeeded',
    value: function _cancelOrderCreationDialogIfNeeded() {
      if (this._orderSetupService.orderSetupDialogShowing) {
        this._rootScope.orderCreationCancelRequested = true;
        this._rootScope.$broadcast(_CommonConstants2.default.Events.ORDER_CREATION_CANCEL_REQUESTED);
      }
    }
  }, {
    key: '_onOrderCancelled',
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this._scope.showAccount();

              case 2:
                this._sessionService.setCartReference(null);
                _context16.next = 5;
                return this._onUserLoggedIn();

              case 5:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function _onOrderCancelled() {
        return _ref16.apply(this, arguments);
      }

      return _onOrderCancelled;
    }()
  }, {
    key: '_onOrderCancelledByOwner',
    value: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this._scope.isOrderFreezed = true;
                _context17.next = 3;
                return this._scope.showAccount();

              case 3:
                this._messageService.showMessagePopup(this.$translate.instant('client.order.owner_cancelled'));
                this._sessionService.setCartReference(null);
                _context17.next = 7;
                return this._goToCart();

              case 7:
                this._scope.isOrderFreezed = false;

              case 8:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function _onOrderCancelledByOwner() {
        return _ref17.apply(this, arguments);
      }

      return _onOrderCancelledByOwner;
    }()
  }, {
    key: '_onOrderClearedByOwner',
    value: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                this._scope.isOrderFreezed = true;
                _context18.next = 3;
                return this._scope.showAccount();

              case 3:
                this._messageService.showMessagePopup(this.$translate.instant('client.order.owner_cleared'));
                this._sessionService.setCartReference(null);
                _context18.next = 7;
                return this._onUserLoggedIn(false, true);

              case 7:
                this._scope.isOrderFreezed = false;

              case 8:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function _onOrderClearedByOwner() {
        return _ref18.apply(this, arguments);
      }

      return _onOrderClearedByOwner;
    }()
  }, {
    key: '_onUserRemovedByOwner',
    value: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                this._scope.isOrderFreezed = true;
                _context19.next = 3;
                return this._scope.showAccount();

              case 3:
                this._messageService.showMessagePopup(this.$translate.instant('client.order.owner_removed'));
                this._sessionService.setCartReference(null);
                _context19.next = 7;
                return this._goToCart(false, true);

              case 7:
                this._scope.isOrderFreezed = false;

              case 8:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function _onUserRemovedByOwner() {
        return _ref19.apply(this, arguments);
      }

      return _onUserRemovedByOwner;
    }()
  }, {
    key: '_onOrderCheckedOut',
    value: function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var messageText;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this._scope.isOrderFreezed = true;
                _context20.next = 3;
                return this._scope.showAccount();

              case 3:
                messageText = this.$translate.instant('client.order.owner_closed');


                if (this.isOwner) {
                  messageText = this.$translate.instant('client.order.owner_fulfilled');
                }
                _context20.next = 7;
                return this._messageService.showMessagePopup(messageText);

              case 7:
                this._sessionService.setCartReference(null);
                _context20.next = 10;
                return this._onUserLoggedIn(false, true);

              case 10:
                this._scope.isOrderFreezed = false;

              case 11:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function _onOrderCheckedOut() {
        return _ref20.apply(this, arguments);
      }

      return _onOrderCheckedOut;
    }()
  }, {
    key: '_onParticipantLeftOrder',
    value: function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this._onUserLoggedIn();

              case 2:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function _onParticipantLeftOrder() {
        return _ref21.apply(this, arguments);
      }

      return _onParticipantLeftOrder;
    }()
  }, {
    key: '_onUserLoggedIn',
    value: function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(fromInvitation, forceGoTCart) {
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this._checkGroupOrder();

              case 2:
                _context22.next = 4;
                return this._sendUserCartInfoToParent();

              case 4:
                if (!(forceGoTCart || !fromInvitation && !this._lastSessionState)) {
                  _context22.next = 7;
                  break;
                }

                _context22.next = 7;
                return this._goToCart();

              case 7:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function _onUserLoggedIn(_x25, _x26) {
        return _ref22.apply(this, arguments);
      }

      return _onUserLoggedIn;
    }()
  }, {
    key: '_onUserProfileChanged',
    value: function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this._checkGroupOrder(false);

              case 2:
                _context23.next = 4;
                return this._sendUserCartInfoToParent();

              case 4:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function _onUserProfileChanged() {
        return _ref23.apply(this, arguments);
      }

      return _onUserProfileChanged;
    }()
  }, {
    key: '_goToCart',
    value: function () {
      var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this._stateService.go(_CommonConstants2.default.RoutingStates.CART);

              case 2:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function _goToCart() {
        return _ref24.apply(this, arguments);
      }

      return _goToCart;
    }()
  }, {
    key: '_sendUserCartInfoToParent',
    value: function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var _this4 = this;

        var cartOwner, currentEmail, isOwner;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                cartOwner = this.orderExists ? _.find(this.cart.participants, function (participant) {
                  return participant.status === 'OWNER';
                }) : null;
                _context26.next = 3;
                return this._sessionService.getUserEmail();

              case 3:
                currentEmail = _context26.sent;
                isOwner = cartOwner && cartOwner.email === currentEmail;

                this.isOwner = isOwner;

                this.timeoutService(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
                  var cartName, getFirstName, name;
                  return regeneratorRuntime.wrap(function _callee25$(_context25) {
                    while (1) {
                      switch (_context25.prev = _context25.next) {
                        case 0:
                          if (!(cartOwner && cartOwner.name)) {
                            _context25.next = 19;
                            break;
                          }

                          cartName = 'My Group Order';

                          if (_this4._scope.retailer.customCartNames === '1' && _this4.cart.cartName && _this4.cart.cartName !== _CommonConstants2.default.CART_NAME_DEFAULT_VALUE) {
                            cartName = _this4.cart.cartName;
                          }

                          if (!_this4.isMobile) {
                            _context25.next = 7;
                            break;
                          }

                          _this4._scope.externalStoreWindowTitle = _this4.$translate.instant('client.group_order');
                          _context25.next = 17;
                          break;

                        case 7:
                          if (isOwner) {
                            _context25.next = 16;
                            break;
                          }

                          _context25.next = 10;
                          return _this4._sessionService.getUserFirstName();

                        case 10:
                          getFirstName = _context25.sent;
                          name = cartOwner && cartOwner.name || getFirstName;

                          if (_this4._scope.retailer.customCartNames === '1' && _this4.cart.cartName && _this4.cart.cartName !== _CommonConstants2.default.CART_NAME_DEFAULT_VALUE) {
                            name = _this4.cart.cartName;
                          } else {
                            name = _this4.$translate.instant('client.user.in_order', { name: ExternalStoreHandler.toPossessiveString(name) });
                          }
                          _this4._scope.externalStoreWindowTitle = '' + name;
                          _context25.next = 17;
                          break;

                        case 16:
                          _this4._scope.externalStoreWindowTitle = '' + cartName;

                        case 17:
                          _context25.next = 26;
                          break;

                        case 19:
                          _context25.next = 21;
                          return _this4._sessionService.loggedIn();

                        case 21:
                          if (!_context25.sent) {
                            _context25.next = 25;
                            break;
                          }

                          _this4._scope.externalStoreWindowTitle = _this4.$translate.instant(_utils.utils.externalStoreWindowTitle);
                          _context25.next = 26;
                          break;

                        case 25:
                          _this4._scope.externalStoreWindowTitle = _this4.$translate.instant('client.auth.signin');

                        case 26:
                        case 'end':
                          return _context25.stop();
                      }
                    }
                  }, _callee25, _this4);
                })), 300);

                _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.userLoggedIn, {
                  cartOwnerName: cartOwner && cartOwner.name,
                  isOwner: isOwner,
                  hasCart: this.orderExists
                });

                _context26.t0 = window.parent;
                _context26.next = 11;
                return this._sessionService.getUserFirstName();

              case 11:
                _context26.t1 = _context26.sent;
                _context26.t2 = cartOwner && cartOwner.name;
                _context26.t3 = isOwner;
                _context26.t4 = this.orderExists;
                _context26.t5 = this._scope.retailer.customCartNames;
                _context26.t6 = this.cart ? this.cart.cartName : "";
                _context26.t7 = {
                  userFirstName: _context26.t1,
                  cartOwnerName: _context26.t2,
                  isOwner: _context26.t3,
                  hasCart: _context26.t4,
                  customCartNames: _context26.t5,
                  cartName: _context26.t6
                };
                _context26.t8 = {
                  userDetails: _context26.t7
                };

                _context26.t0.postMessage.call(_context26.t0, _context26.t8, '*');

              case 20:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function _sendUserCartInfoToParent() {
        return _ref25.apply(this, arguments);
      }

      return _sendUserCartInfoToParent;
    }()
  }, {
    key: '_onProductDetailRequested',
    value: function _onProductDetailRequested(shopifyProductUrl) {
      window.parent.postMessage({
        requestDetailPage: {
          shopifyProductUrl: shopifyProductUrl
        }
      }, '*');
    }
  }, {
    key: 'addItemToCart',
    value: function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this._checkGroupOrder();

              case 2:
                if (!(this._addingProduct || !this.orderExists)) {
                  _context27.next = 4;
                  break;
                }

                return _context27.abrupt('return');

              case 4:

                this._addingProduct = true;
                _context27.prev = 5;

                this._rootScope.addingProduct = {
                  variantId: this._scope.variantId,
                  quantity: this._scope.quantity
                };

                if (!(!this._scope.productName && !this._scope.productImage)) {
                  _context27.next = 12;
                  break;
                }

                _context27.next = 10;
                return this._cartService.addProductFromShopify(this._scope.variantId, this._scope.quantity, this._scope.productOptions);

              case 10:
                _context27.next = 14;
                break;

              case 12:
                _context27.next = 14;
                return this._cartService.addProductFromCustomSite(this._scope.variantId, this._scope.quantity, this._scope.productName, this._scope.productImage, this._scope.productPrice, this._scope.productOptions, this._scope.productUrl);

              case 14:

                _scope2.default.apply(this._scope);

                this._goToCart();
                _context27.next = 22;
                break;

              case 18:
                _context27.prev = 18;
                _context27.t0 = _context27['catch'](5);

                this._messageService.showErrorPopupForResponse(_context27.t0);

                window.parent.postMessage({
                  closeWindow: true
                }, '*');

              case 22:
                _context27.prev = 22;

                window.parent.postMessage({
                  addProductDone: true
                }, '*');
                this._addingProduct = false;
                this._scope.needAddItem = false;
                return _context27.finish(22);

              case 27:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, this, [[5, 18, 22, 27]]);
      }));

      function addItemToCart() {
        return _ref27.apply(this, arguments);
      }

      return addItemToCart;
    }()
  }, {
    key: '_checkGroupOrder',
    value: function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        var fromCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this._cartService.getCart(undefined, fromCache);

              case 2:
                this.cart = _context28.sent;
                _context28.next = 5;
                return this._cartService.isGroupOrder();

              case 5:
                this.orderExists = _context28.sent;

                this._rootScope.orderExists = this.orderExists;

                window.parent.postMessage({
                  orderExists: this.orderExists,
                  retailer: this._scope.retailer
                }, '*');

              case 8:
              case 'end':
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function _checkGroupOrder() {
        return _ref28.apply(this, arguments);
      }

      return _checkGroupOrder;
    }()
  }, {
    key: '_setupNewOrder',
    value: function () {
      var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(needAddItem) {
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                this._orderBeingCreated = true;
                _context29.next = 3;
                return this._orderSetupService.createOrder(needAddItem);

              case 3:
                this._orderBeingCreated = false;

              case 4:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function _setupNewOrder(_x28) {
        return _ref29.apply(this, arguments);
      }

      return _setupNewOrder;
    }()
  }, {
    key: '_onInvitationAccepted',
    value: function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this._checkGroupOrder(false);

              case 2:
                _context30.next = 4;
                return this._sendUserCartInfoToParent();

              case 4:
              case 'end':
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function _onInvitationAccepted() {
        return _ref30.apply(this, arguments);
      }

      return _onInvitationAccepted;
    }()
  }, {
    key: '_onProductItemsChanged',
    value: function _onProductItemsChanged() {
      if (this._scope.isCart()) {
        this._rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.CART_PAGE_REQUESTED);
      }
    }
  }, {
    key: '_onCartChanged',
    value: function () {
      var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this._checkGroupOrder();

              case 2:
                _context31.next = 4;
                return this._sendUserCartInfoToParent();

              case 4:
              case 'end':
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function _onCartChanged() {
        return _ref31.apply(this, arguments);
      }

      return _onCartChanged;
    }()
  }, {
    key: '_onOwnershipTransferred',
    value: function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32(obj) {
        var message;
        return regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                message = this.$translate.instant('client.order.owner_shared');
                _context32.next = 3;
                return this._messageService.showMessagePopup('' + message);

              case 3:
              case 'end':
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function _onOwnershipTransferred(_x29) {
        return _ref32.apply(this, arguments);
      }

      return _onOwnershipTransferred;
    }()
  }, {
    key: '_onUserActiveAfterIdle',
    value: function _onUserActiveAfterIdle(idleTimeInSecond) {

      if (idleTimeInSecond >= this.idleTimeBeforeRefreshing * 60) {
        window.location.reload(true);
      }
    }
  }], [{
    key: 'toPossessiveString',
    value: function toPossessiveString(name) {
      if (name[name.length - 1] === 's') {
        return name + '\'';
      }

      return name + '\'s';
    }
  }]);

  return ExternalStoreHandler;
}();

exports.default = ExternalStoreHandler;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IdleDetectingService = undefined;

var _away = __webpack_require__(653);

var _away2 = _interopRequireDefault(_away);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IdleDetectingService = exports.IdleDetectingService = function IdleDetectingService(onUserBackActive) {
    var _this = this;

    _classCallCheck(this, IdleDetectingService);

    this.idleStart = null;

    var timer = (0, _away2.default)(10000);

    timer.on('idle', function () {
        _this.idleStart = (0, _moment2.default)();
    });
    timer.on('active', function () {
        onUserBackActive((0, _moment2.default)().diff(_this.idleStart, 'second'));
    });
};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommandHandlerService = exports.CommandHandlerService = function () {
  _createClass(CommandHandlerService, null, [{
    key: "getInstance",
    value: function getInstance() {
      return CommandHandlerService.__instance || (CommandHandlerService.__instance = new CommandHandlerService());
    }
  }]);

  function CommandHandlerService() {
    _classCallCheck(this, CommandHandlerService);

    this.handlers = [];
  }

  _createClass(CommandHandlerService, [{
    key: "registerHandler",
    value: function registerHandler(handler) {
      this.handlers.push(handler);
    }
  }, {
    key: "hasHandler",
    value: function hasHandler(command) {
      return this.handlers.some(function (h) {
        return h.command === command;
      });
    }
  }, {
    key: "handleCommand",
    value: function handleCommand(command, request, sender, sendResponse) {
      var handlers = this.handlers.filter(function (h) {
        return h.command === command;
      });

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var handler = _step.value;

          handler.handle(request, sender, sendResponse);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }]);

  return CommandHandlerService;
}();

CommandHandlerService.__instance = null;
var commandHandlerService = exports.commandHandlerService = CommandHandlerService.getInstance();

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\"\r\n\t xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t viewBox=\"20 20 200 200\" style=\"enable-background:new 20 20 200 200;\"\r\n\t xml:space=\"preserve\">\r\n<g id=\"logos\">\r\n\t<g id=\"gem\" transform=\"translate(2.000000, 0.000000)\">\r\n\t\t<path id=\"Fill-1\" class=\"circle-path\" d=\"M116.1,33.8c46.9,0,85,38.1,85,85c0,46.9-38.1,85-85,85c-46.9,0-85-38.1-85-85\r\n\t\t\tC31.1,71.9,69.2,33.8,116.1,33.8\"/>\r\n\t\t<g id=\"cart\" transform=\"translate(0.851630, 10.000000)\">\r\n\t\t\t<path id=\"Fill-3\" class=\"cart-fire-path\" d=\"M215.2,174.4c-7.3-0.1-13.3-6.6-16.8-12.1c3.3-0.3,9.7,0.5,11.6,3.5c2.1-3.2-1.5-10.7-3.7-13\r\n\t\t\t\tc-3-3.1-8.5-5.3-12.9-4.2c1.3-1.1,2.7-2.4,4.4-2.9c2.2-0.7,4.6-0.5,6.8-0.7c-7.8-24.6-24.6-11.3-38.8-15.5\r\n\t\t\t\tc4.4,3.7,15.5,10.8,17.6,26c-15.9,4.7-24.6-2-32-4.9c6.9,38.2,25.3,21.9,33.2,32.6c2.5-3.5,3.2-9,0.9-12\r\n\t\t\t\tc0.3,0.3,0.5,0.6,0.8,0.8C187.7,173.2,203.8,181.9,215.2,174.4\"/>\r\n\t\t\t<g id=\"Combined-Shape-Copy\">\r\n\t\t\t\t<g>\r\n\t\t\t\t\t<path id=\"path-1\" class=\"cart-bg-path\" d=\"M158.2,113.4l6.9,4.4l-24.8,35.9l-6.9-4.4l5.1-7.5l-5.5-3.5l-4.1,5.9\r\n\t\t\t\t\t\tc-0.9,1.3-2.8,1.6-4.1,0.7l-9.7-6.2l-8.2,7.6c0.7,2,1,4.3,0.9,6.8c-0.3,6-2.9,14.4-9.8,20.3l-13.6-4.8l-0.5,5.4\r\n\t\t\t\t\t\tc2.3,1.1,3.8,3.5,3.6,6.2c-0.3,3.5-3.5,6.1-7.1,5.8c-3.6-0.3-6.3-3.3-6-6.8c0.2-2.7,2.1-4.8,4.7-5.5l0.6-6.7l-43.2-15.5\r\n\t\t\t\t\t\tl-1.1,5.8c2.2,1.4,3.5,3.9,2.9,6.5c-0.7,3.4-4.1,5.7-7.7,5c-3.6-0.6-5.9-3.9-5.2-7.4c0.5-2.6,2.6-4.5,5.2-5l1.3-6.6l-8.8-3.2\r\n\t\t\t\t\t\tc-2.3-0.9-3.4-3.3-2.6-5.6c0.9-2.2,3.4-3.3,5.9-2.5l68.9,24.7c3.8-5.7,4-12.4,3-14.4l-71.3-39.9c-1.9-1.1-2.8-3.3-1.9-5.3\r\n\t\t\t\t\t\tl27.4-67.7c0.5-1.2,1.6-2.2,2.9-2.6c1.3-0.4,2.8-0.2,3.9,0.5l91.7,59.3l18.3-17c3.9-3.7,9.1-5.7,14.6-5.7\r\n\t\t\t\t\t\tc5.5,0,10.8,2.1,14.7,5.8c8.1,7.8,8.1,20.4,0,28.1c-1.8,1.6-4.5,1.7-6.3,0.1c-1.8-1.7-1.8-4.5-0.1-6.2\r\n\t\t\t\t\t\tc4.5-4.4,4.5-11.5,0-15.8c-2.2-2.1-5.1-3.3-8.3-3.3c-3.1,0-6.1,1.2-8.3,3.2l-19.8,18.5c-0.2,0.4-0.5,0.8-0.9,1.1l-5.8,5.4\r\n\t\t\t\t\t\tl1.3,0.8c1.3,1,1.7,2.9,0.8,4.2l-3.5,5l5.5,3.5L158.2,113.4z M35.1,102.7l65.1,37l44.1-40l-85.1-55L35.1,102.7z\"/>\r\n\t\t\t\t</g>\r\n\t\t\t\t<path class=\"cart-outline-path\" d=\"M152.6,118.8l-3-1.9l2.6-3.7c1.3-1.9,0.9-4.6-0.9-6.1l4.4-4.1c0.4-0.4,0.8-0.8,1-1.3l19.6-18.3\r\n\t\t\t\t\tc2-1.8,4.6-2.8,7.3-2.8c2.7,0,5.3,1,7.2,2.9c3.9,3.8,3.9,9.9,0,13.6c-2.4,2.4-2.3,6.1,0.1,8.4c2.3,2.2,6,2.1,8.4-0.1\r\n\t\t\t\t\tc8.7-8.3,8.8-21.9,0-30.3c-4.2-4-9.8-6.2-15.7-6.2c-5.9,0-11.4,2.2-15.6,6.1l-17.4,16.2L59.9,32.5c-1.5-1-3.4-1.2-5.1-0.7\r\n\t\t\t\t\tc-1.8,0.5-3.2,1.8-3.8,3.5L23.5,103c-1.1,2.7,0,5.8,2.6,7.2L97,149.9c0.8,2.2-0.1,7.4-2.5,11.5l-67.8-24.3\r\n\t\t\t\t\tc-3.2-1.1-6.6,0.4-7.8,3.4c-1.2,3,0.4,6.3,3.4,7.5l7.6,2.7l-0.9,4.4c-2.7,0.9-4.8,3.1-5.4,6c-0.9,4.3,2.1,8.4,6.5,9.1\r\n\t\t\t\t\tc4.4,0.8,8.6-2,9.4-6.2c0.6-2.8-0.5-5.7-2.8-7.5l0.6-3.1L78,168l-0.4,4.6c-2.6,1.1-4.5,3.6-4.7,6.5c-0.4,4.3,3,8.1,7.4,8.5\r\n\t\t\t\t\tc4.4,0.3,8.4-2.8,8.7-7.1c0.2-2.9-1.2-5.6-3.5-7.1l0.2-2.5l11.7,4.2l0.8,0.3l0.7-0.6c6.4-5.5,10-13.7,10.4-21.4\r\n\t\t\t\t\tc0.1-2.3-0.1-4.5-0.7-6.5l6.6-6.2l8.8,5.6c2,1.4,4.8,0.9,6.2-1.1l3.3-4.8l3,1.9l-4.3,6.2l-0.9,1.3l1.3,0.8l6.9,4.4l1.2,0.8\r\n\t\t\t\t\tl0.8-1.2l24.8-35.9l0.9-1.3l-1.3-0.8l-6.9-4.4l-1.2-0.8l-0.8,1.2L152.6,118.8z M37,102.1L59.9,47l82,53l-41.8,38L37,102.1z\"/>\r\n\t\t\t</g>\r\n\t\t</g>\r\n\t</g>\r\n</g>\r\n</svg>\r\n"

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChangePasswordController = undefined;

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChangePasswordController = exports.ChangePasswordController = function ChangePasswordController($scope, $mdDialog, authenticationService, messageService) {
    var _this = this;

    _classCallCheck(this, ChangePasswordController);

    $scope.inProgress = false;
    $scope.errorMessage = '';

    $scope.data = {
        password: '',
        oldPassword: ''
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    $scope.changePassword = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            $scope.errorMessage = '';

                            if (!form.$invalid) {
                                _context.next = 4;
                                break;
                            }

                            form.highlightAllErrors();
                            return _context.abrupt('return');

                        case 4:

                            $scope.inProgress = true;

                            return _context.abrupt('return', authenticationService.changePassword($scope.data.oldPassword, $scope.data.password).then(function () {
                                return $mdDialog.hide();
                            }, function (error) {
                                $scope.errorMessage = messageService.getMessageFromErrorResponse(error);
                            }).finally(function () {
                                $scope.inProgress = false;
                            }));

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
};

ChangePasswordController.$inject = ['$scope', '$mdDialog', 'AuthenticationService', 'Message'];
ChangePasswordController.controllerName = 'ChangePasswordController';


_module3.default.controller(ChangePasswordController.controllerName, ChangePasswordController);

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _utils = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSetupDialogController = function () {
    function OrderSetupDialogController(scope, windowService, cartonomyConfig, rootScope, dialogService, messageService, tabToShow, initialConfiguration, userProfileService, groupOrderService, paymentOptions, editMode, sessionService, localForageService, cartService, stateService, HeapService, initialCart, $translate) {
        var _this = this;

        _classCallCheck(this, OrderSetupDialogController);

        this._onDialogDeleteContact = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(contact) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this._scope.contactDelete = contact;
                                _context.next = 3;
                                return _this._resetConfiguration();

                            case 3:
                                _this._setCurrentTabById(_CommonConstants2.default.OrderSetupTabs.CONFIRM_DELETE_CONTACT);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        this._scope = scope;
        this._cartonomyConfig = cartonomyConfig;
        this._rootScope = rootScope;
        this._initialConfiguration = initialConfiguration;
        this._dialogService = dialogService;
        this._tabToShow = tabToShow;
        this._tabBeforeCancel = null;
        this._groupOrderService = groupOrderService;
        this._userProfileService = userProfileService;
        this._scope.groupPay = groupOrderService.getGroupPay();
        this._paymentOptions = paymentOptions;
        this._scope._editMode = editMode;
        this._windowService = windowService;
        this._messageService = messageService;
        //this._sessionStorageService = SessionStorage;
        this._localForageService = localForageService;
        this._cartService = cartService;
        this._sessionService = sessionService;
        this._stateService = stateService;
        this._heapService = HeapService;
        this._initialCart = initialCart;
        this.$translate = $translate;

        scope.hasMandatoryDeadline = !!rootScope.retailer.mandatoryDeadline;

        // onboarding
        scope.onboarding = {
            steps: 5,
            currentStep: 0
        };

        scope.onboardingNextStep = function () {
            console.log(scope.onboarding.currentStep);
            scope.onboarding.currentStep++;
        };

        scope.onboardingPreviousStep = function () {
            scope.onboarding.currentStep--;
        };

        scope.returnToPreview = false;
        scope.resetConfiguration = function () {
            return _this._resetConfiguration();
        };
        scope.setCurrentTabById = function (id) {
            return _this._setCurrentTabById(id);
        };
        scope.showCancelTab = function () {
            return _this._showCancelTab();
        };
        scope.closeDialog = function () {
            return _this._closeOrderDialog(true);
        };
        scope.cancelOrder = function () {
            return _this._closeOrderDialog();
        };
        scope.restoreOrder = function () {
            return _this._restoreOrder();
        };
        scope.backEnabled = function () {
            return _this._backEnabled();
        };
        scope.back = function () {
            return _this._back();
        };
        scope.onDialogDeleteContact = function (contact) {
            return _this._onDialogDeleteContact(contact);
        };
        scope.cancelPreview = function () {
            return _this._cancelPreview();
        };
        scope.next = function () {
            return _this._next();
        };
        scope.finishOrderSetup = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            return _context2.abrupt('return', _this._finishOrderSetup());

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));
        scope.previewTab = function (tabId) {
            return _this._previewTab(tabId);
        };
        scope.enableTab = function (tabId, enable) {
            return _this._enableTab(tabId, enable);
        };
        scope.isExternalRetailer = function () {
            return cartonomyConfig.externalStoreMode;
        };
        scope.$on(_CommonConstants2.default.Events.ORDER_CREATION_CANCEL_REQUESTED, function () {
            return _this._closeOrderDialog();
        });
        scope.$on(_CommonConstants2.default.Events.OPEN_SPLASH_SCREEN, function () {
            return _this._openSplashScreen();
        });
        rootScope.$on(_CommonConstants2.default.Events.BACK_BUTTON_CLICKED, function () {
            return _this._closeOrderDialog();
        });
        scope.formattedUserFirstName = "";

        scope.getStarted = function () {
            return _this._getStarted();
        };
        scope.singleInviteLink = function () {
            return _this._singleInviteLink();
        };
        scope.acceptDeleteContact = function () {
            return _this._acceptDeleteContact();
        };
        scope.backToCreateOrder = function () {
            return _this._backToCreateOrder();
        };
        scope.contactDelete = null;

        this.startTabIndex = null;
        this._initialize();
    }

    _createClass(OrderSetupDialogController, [{
        key: '_initialize',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var _this2 = this;

                var storedCurrentTab, tab, cancelTab;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this._scope.noBudgetMode = this._rootScope.retailer && this._rootScope.retailer.noBudgetMode;
                                if (this._scope._editMode) {
                                    this._rootScope.storeWindowTitle = 'client.order.group_setting';
                                } else if (!this._initialCart.$id) {
                                    this._rootScope.storeWindowTitle = 'client.order.group_creating';
                                } else {
                                    this._rootScope.storeWindowTitle = 'client.order.group_join';
                                }
                                if (this._initialCart) {
                                    this._scope.deadline = this._initialCart.closeOn && (0, _moment2.default)(this._initialCart.closeOn).format('L LT') || 'client.unlimited';
                                    this._scope.budget = this._initialCart.orderLimit && this._rootScope.formatAmount(this._initialCart.orderLimit) || 'client.unlimited';
                                    this._scope.orderTitle = this._initialCart.cartName || this._initialCart.title;
                                    this._scope.payerTitle = this._initialCart.fulfillment && (this._initialCart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.SELF || this._initialCart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.MIXED) ? 'client.order.group_member_pay' : 'client.order.group_owner_pay';
                                }

                                _scope2.default.apply(this._scope);
                                _context3.t0 = this;
                                _context3.next = 7;
                                return this._sessionService.getUserFirstName();

                            case 7:
                                _context3.t1 = _context3.sent;
                                this._scope.formattedUserFirstName = _context3.t0.toPossessiveString.call(_context3.t0, _context3.t1);

                                this._createTabs();
                                _context3.next = 12;
                                return this._resetConfiguration();

                            case 12:
                                _context3.t2 = this;
                                _context3.next = 15;
                                return this._userProfileService.getUserAddresses();

                            case 15:
                                _context3.t3 = _context3.sent;

                                _context3.t2._onUserAddressesReceived.call(_context3.t2, _context3.t3);

                                _context3.next = 19;
                                return this._localForageService.retrieve(_CommonConstants2.default.SessionStorage.CREATE_ORDER_CURRENT_TAB);

                            case 19:
                                storedCurrentTab = _context3.sent;


                                this.startTabIndex = 0;

                                if (this._tabToShow) {
                                    tab = _.find(this._scope.tabs, { id: this._tabToShow });

                                    tab.save = true;
                                    tab.disabled = false;
                                    cancelTab = this._scope.tabs.find(function (tab) {
                                        return tab.id === _CommonConstants2.default.OrderSetupTabs.CANCELEDITING;
                                    });

                                    this._scope.tabs = [tab, cancelTab];
                                    this.startTabIndex = _.findIndex(this._scope.tabs, function (t) {
                                        return t.id === _this2._tabToShow;
                                    });
                                }

                                this._scope.tabs.forEach(function (tab) {
                                    tab.templateUrl = 'modules/order/views/orderSetupTabs/' + tab.templateUrl;
                                });

                                if (!this._paymentOptions) {
                                    _context3.next = 27;
                                    break;
                                }

                                this._groupOrderService.loadFromSessionStorage();
                                this._setCurrentTabById(_CommonConstants2.default.OrderSetupTabs.ADD_PEOPLE);
                                return _context3.abrupt('return', null);

                            case 27:
                                if (!(storedCurrentTab && !this._tabToShow)) {
                                    _context3.next = 30;
                                    break;
                                }

                                this._setCurrentTabById(storedCurrentTab);
                                return _context3.abrupt('return');

                            case 30:

                                this._setCurrentTab(this.startTabIndex);

                            case 31:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function _initialize() {
                return _ref3.apply(this, arguments);
            }

            return _initialize;
        }()
    }, {
        key: 'toPossessiveString',
        value: function toPossessiveString(name) {
            if (name[name.length - 1] === 's') {
                return name + '\'';
            }

            return name + '\'s';
        }
    }, {
        key: '_getStarted',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this._singleInviteLink();

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function _getStarted() {
                return _ref4.apply(this, arguments);
            }

            return _getStarted;
        }()
    }, {
        key: '_singleInviteLink',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                this._scope.invitationCode = this._cartService.getInviteCode();

                                if (this._scope.invitationCode) {
                                    _context5.next = 7;
                                    break;
                                }

                                _context5.next = 4;
                                return this._cartService.getInvitationCode();

                            case 4:
                                this._scope.invitationCode = _context5.sent;

                                this._cartService.setInviteCode(this._scope.invitationCode);
                                this._cartService.setInvitationType(_CommonConstants2.default.InvitationTypes.share);

                            case 7:

                                this._scope.returnToPreview = false;
                                this._setCurrentTabById(_CommonConstants2.default.OrderSetupTabs.PREVIEW);

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function _singleInviteLink() {
                return _ref5.apply(this, arguments);
            }

            return _singleInviteLink;
        }()
    }, {
        key: '_resetConfiguration',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var storedConfiguration;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this._localForageService.retrieve(_CommonConstants2.default.SessionStorage.CREATE_ORDER_CONFIGURATION);

                            case 2:
                                storedConfiguration = _context6.sent;

                                if (!storedConfiguration) {
                                    _context6.next = 8;
                                    break;
                                }

                                _context6.next = 6;
                                return this._groupOrderService.loadConfiguration(JSON.parse(storedConfiguration));

                            case 6:
                                _context6.next = 15;
                                break;

                            case 8:
                                if (!this._initialConfiguration) {
                                    _context6.next = 13;
                                    break;
                                }

                                _context6.next = 11;
                                return this._groupOrderService.loadConfiguration(this._initialConfiguration);

                            case 11:
                                _context6.next = 15;
                                break;

                            case 13:
                                _context6.next = 15;
                                return this._groupOrderService.initConfiguration();

                            case 15:

                                // external store: always pay for everyone - set this up before showing set up wizard
                                if (this._cartonomyConfig.externalStoreMode) {
                                    this._groupOrderService.setGroupPay(this._groupOrderService.PayForEveryone);
                                    this._groupOrderService.setSinglePayOrder(this._groupOrderService.getSinglePayOrder() || {
                                        enterPaymentInformation: 'no'
                                    });
                                }

                            case 16:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function _resetConfiguration() {
                return _ref6.apply(this, arguments);
            }

            return _resetConfiguration;
        }()
    }, {
        key: '_onUserAddressesReceived',
        value: function _onUserAddressesReceived(addresses) {
            if (!addresses) {
                return;
            }

            this._scope.deliveryAddresses = addresses.filter(function (address) {
                return address.addressType === _CommonConstants2.default.AddressType.SHIPPING;
            }).map(function (address) {
                return {
                    label: address.address + (address.address2 ? ', ' + address.address2 : '') + ', ' + address.city + ', ' + address.state + ' ' + address.zip,
                    id: address.id,
                    source: address
                };
            });

            this._scope.deliveryAddresses.push({
                label: this.$translate.instant('client.user.address_enter'),
                id: 0
            });
        }
    }, {
        key: '_setCurrentTab',
        value: function _setCurrentTab(index) {
            this._scope.groupPay = this._groupOrderService.getGroupPay();
            this._scope.selectedIndex = index;
            var tab = this._scope.tabs[this._scope.selectedIndex];

            if (tab && tab.customAction) {
                tab.customAction();
                return;
            }

            this._scope.selectedTab = tab;

            _scope2.default.apply(this._scope);
        }
    }, {
        key: '_setCurrentTabById',
        value: function _setCurrentTabById(id) {
            var tab = _.find(this._scope.tabs, { id: id });
            this._setCurrentTab(_.indexOf(this._scope.tabs, tab));
        }
    }, {
        key: '_showCancelTab',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                return _context7.abrupt('return');

                            case 4:
                                return _context7.abrupt('return');

                            case 5:
                                //
                                // if (this._scope.selectedTab.id === Constants.OrderSetupTabs.CANCEL) {
                                //     this._scope.restoreOrder();
                                //     return;
                                // }
                                //
                                // if (this._tabToShow && (this._scope._editMode || !this._cartonomyConfig.externalStoreMode)) {
                                //     this._scope.cancelOrder();
                                //     return;
                                // }
                                //
                                this._tabBeforeCancel = this._scope.selectedTab.id;
                                this._setCurrentTabById(_CommonConstants2.default.OrderSetupTabs.CANCELEDITING);

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function _showCancelTab() {
                return _ref7.apply(this, arguments);
            }

            return _showCancelTab;
        }()
    }, {
        key: '_openSplashScreen',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this._resetConfiguration();

                            case 2:
                                this._setCurrentTabById(_CommonConstants2.default.OrderSetupTabs.PREVIEW);

                            case 3:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function _openSplashScreen() {
                return _ref8.apply(this, arguments);
            }

            return _openSplashScreen;
        }()
    }, {
        key: '_closeOrderDialog',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(forceClose) {
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!(this._scope._editMode || !this._cartonomyConfig.externalStoreMode || forceClose)) {
                                    _context9.next = 4;
                                    break;
                                }

                                this._dialogService.cancel();
                                this._rootScope.$broadcast(_CommonConstants2.default.Events.DIALOG_CLOSED);
                                return _context9.abrupt('return');

                            case 4:
                                _context9.next = 6;
                                return this._localForageService.store(_CommonConstants2.default.SessionStorage.CREATE_ORDER_CURRENT_TAB, this._scope.selectedTab.id);

                            case 6:
                                _context9.next = 8;
                                return this._localForageService.store(_CommonConstants2.default.SessionStorage.CREATE_ORDER_CONFIGURATION, JSON.stringify(this._groupOrderService._configuration));

                            case 8:

                                if (!this._rootScope.collapsed) {
                                    if (!this._rootScope.orderCreationCancelRequested) {
                                        this._rootScope.toggleWindowState();
                                    }
                                    this._dialogService.cancel();
                                }

                            case 9:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function _closeOrderDialog(_x2) {
                return _ref9.apply(this, arguments);
            }

            return _closeOrderDialog;
        }()
    }, {
        key: '_restoreOrder',
        value: function _restoreOrder() {
            this._setCurrentTabById(this._tabBeforeCancel);
        }
    }, {
        key: '_backEnabled',
        value: function _backEnabled() {
            return (this._cartonomyConfig.externalStoreMode || !this._tabToShow) && this._scope.selectedIndex > this.startTabIndex && this._scope.selectedIndex <= this._scope.tabs.length - 1 && !this._scope.returnToPreview && this._scope.tabs[this._scope.selectedIndex].id !== _CommonConstants2.default.OrderSetupTabs.FINISH && !this._scope.tabs[this._scope.selectedIndex].disableBackButton;
        }
    }, {
        key: '_back',
        value: function _back() {
            if (this._scope.__editMode) {}
            var newIndex = this._scope.selectedIndex - 1;
            for (; newIndex > 0; newIndex--) {
                if (!this._scope.tabs[newIndex].disabled) {
                    break;
                }
            }
            this._setCurrentTab(newIndex);
        }
    }, {
        key: '_cancelPreview',
        value: function _cancelPreview() {
            this._scope.returnToPreview = false;
        }
    }, {
        key: '_next',
        value: function _next() {
            if ((this._scope._editMode || !this._cartonomyConfig.externalStoreMode) && this._tabToShow) {
                this._dialogService.hide();
                return;
            }

            if (this._scope.returnToPreview) {
                this._scope.returnToPreview = false;
                this._setCurrentTabById(_CommonConstants2.default.OrderSetupTabs.PREVIEW);
                return;
            }

            var newIndex = this._scope.selectedIndex + 1;
            for (; newIndex < this._scope.tabs.length; newIndex++) {
                if (!this._scope.tabs[newIndex].disabled) {
                    break;
                }
            }
            this._setCurrentTab(newIndex);
        }
    }, {
        key: '_showFinishDialog',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this._finishOrderSetup();

                            case 2:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function _showFinishDialog() {
                return _ref10.apply(this, arguments);
            }

            return _showFinishDialog;
        }()
    }, {
        key: '_finishOrderSetup',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this._stateService.go(_CommonConstants2.default.RoutingStates.CART);

                            case 2:
                                this._rootScope.$broadcast(_CommonConstants2.default.Events.ORDER_CREATED);
                                this._dialogService.hide();
                                _context11.next = 6;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.CREATE_ORDER_CONFIGURATION);

                            case 6:
                                _context11.next = 8;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.CREATE_ORDER_CURRENT_TAB);

                            case 8:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function _finishOrderSetup() {
                return _ref11.apply(this, arguments);
            }

            return _finishOrderSetup;
        }()
    }, {
        key: '_previewTab',
        value: function _previewTab(tabId) {
            this._scope.returnToPreview = true;
            this._scope.setCurrentTabById(tabId);
        }
    }, {
        key: '_enableTab',
        value: function _enableTab(tabId, enable) {
            var tab = _.find(this._scope.tabs, { id: tabId });
            tab.disabled = !enable;
        }
    }, {
        key: '_acceptDeleteContact',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this._groupOrderService.deleteContact(this._scope.contactDelete.contactUserId);

                            case 2:

                                // 2. back to Add people tab
                                this._setCurrentTabById(_CommonConstants2.default.OrderSetupTabs.ADD_PEOPLE);

                            case 3:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function _acceptDeleteContact() {
                return _ref12.apply(this, arguments);
            }

            return _acceptDeleteContact;
        }()
    }, {
        key: '_backToCreateOrder',
        value: function _backToCreateOrder() {
            this._setCurrentTabById(_CommonConstants2.default.OrderSetupTabs.ADD_PEOPLE);
        }
    }, {
        key: '_createTabs',
        value: function _createTabs() {
            var _this3 = this;

            this._scope.tabs = [
            // {
            //     id: Constants.OrderSetupTabs.WELCOME,
            //     title: '',
            //     templateUrl: 'welcome.html',
            //     template: require('../views/orderSetupTabs/welcome.jade')()
            // },
            {
                id: _CommonConstants2.default.OrderSetupTabs.PREVIEW,
                title: 'client.order.tab.finalize_details',
                templateUrl: 'preview.html',
                custom: true
            }, {
                id: _CommonConstants2.default.OrderSetupTabs.ADD_PEOPLE,
                title: 'client.order.tab.add_people',
                templateUrl: 'addPeople.html',
                custom: true,
                disableBackButton: true
            }, {
                id: _CommonConstants2.default.OrderSetupTabs.DELIVERY_MODE,
                title: 'client.order.tab.choose_delivery',
                templateUrl: 'deliveryMode.html',
                disabled: !!this._cartonomyConfig.externalStoreMode
            }, {
                id: _CommonConstants2.default.OrderSetupTabs.DELIVERY_ADDRESS,
                title: '',
                templateUrl: 'deliveryAddress.html',
                disabled: !!this._cartonomyConfig.externalStoreMode
            }, {
                id: _CommonConstants2.default.OrderSetupTabs.PAY_MODE,
                title: 'client.order.tab.who_pay',
                templateUrl: 'payMode.html',
                disabled: !!this._cartonomyConfig.externalStoreMode
            }, {
                id: _CommonConstants2.default.OrderSetupTabs.DEADLINE,
                title: '',
                templateUrl: 'deadline.html',
                disabled: !!this._cartonomyConfig.externalStoreMode
            }, {
                id: _CommonConstants2.default.OrderSetupTabs.BUDGET,
                title: '',
                templateUrl: 'budget.html',
                disabled: !!this._cartonomyConfig.externalStoreMode
            }, {
                id: _CommonConstants2.default.OrderSetupTabs.PAYMENT_DETAILS,
                title: 'client.order.tab.payment_info',
                templateUrl: 'paymentDetails.html',
                disabled: true
            }, {
                id: _CommonConstants2.default.OrderSetupTabs.FINISH,
                title: 'client.order.tab.all_set',
                templateUrl: 'finish.html',
                custom: true,
                customAction: function () {
                    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                        return regeneratorRuntime.wrap(function _callee13$(_context13) {
                            while (1) {
                                switch (_context13.prev = _context13.next) {
                                    case 0:
                                        _context13.next = 2;
                                        return _this3._showFinishDialog();

                                    case 2:
                                        return _context13.abrupt('return', _context13.sent);

                                    case 3:
                                    case 'end':
                                        return _context13.stop();
                                }
                            }
                        }, _callee13, _this3);
                    }));

                    return function customAction() {
                        return _ref13.apply(this, arguments);
                    };
                }()
            }, {
                id: _CommonConstants2.default.OrderSetupTabs.CANCEL,
                title: 'client.order.tab.cancel_order',
                templateUrl: 'cancel.html',
                disabled: true,
                custom: true
            }, {
                id: _CommonConstants2.default.OrderSetupTabs.CANCELEDITING,
                title: 'client.order.tab.cancel_editing',
                templateUrl: 'cancelEditing.html',
                disabled: true,
                custom: true
            }, {
                id: _CommonConstants2.default.OrderSetupTabs.CONFIRM_DELETE_CONTACT,
                title: '',
                templateUrl: 'confirmDeleteContact.html',
                template: __webpack_require__(691)()
            }, {
                id: _CommonConstants2.default.OrderSetupTabs.INVITE_WELCOME,
                title: '',
                templateUrl: 'inviteWelcome.html',
                template: __webpack_require__(692)(),
                custom: true
            }];
        }
    }]);

    return OrderSetupDialogController;
}();

OrderSetupDialogController.$inject = ['$scope', '$window', 'cartonomyConfig', '$rootScope', '$mdDialog', 'Message', 'tabToShow', 'initialConfiguration', 'UserProfile', 'GroupOrder', 'paymentOptions', 'editMode', 'Session', 'LocalForageService', 'CartService', '$state', 'HeapService', 'initialCart', '$translate'];
exports.default = OrderSetupDialogController;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// HTML5 entities map: { name -> utf16string }
//


/*eslint quotes:0*/

module.exports = __webpack_require__(705);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.encode = __webpack_require__(706);
module.exports.decode = __webpack_require__(707);
module.exports.format = __webpack_require__(708);
module.exports.parse = __webpack_require__(709);

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = /[\0-\x1F\x7F-\x9F]/;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Regexps to match html elements



var attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';

var unquoted = '[^"\'=<>`\\x00-\\x20]+';
var single_quoted = "'[^']*'";
var double_quoted = '"[^"]*"';

var attr_value = '(?:' + unquoted + '|' + single_quoted + '|' + double_quoted + ')';

var attribute = '(?:\\s+' + attr_name + '(?:\\s*=\\s*' + attr_value + ')?)';

var open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';

var close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var processing = '<[?].*?[?]>';
var declaration = '<![A-Z]+\\s+[^>]*>';
var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';

var HTML_TAG_RE = new RegExp('^(?:' + open_tag + '|' + close_tag + '|' + comment + '|' + processing + '|' + declaration + '|' + cdata + ')');
var HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + open_tag + '|' + close_tag + ')');

module.exports.HTML_TAG_RE = HTML_TAG_RE;
module.exports.HTML_OPEN_CLOSE_TAG_RE = HTML_OPEN_CLOSE_TAG_RE;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ~~strike through~~
//


// Insert each marker as a separate text token, and add it to delimiter list
//

module.exports.tokenize = function strikethrough(state, silent) {
  var i,
      scanned,
      token,
      len,
      ch,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (silent) {
    return false;
  }

  if (marker !== 0x7E /* ~ */) {
      return false;
    }

  scanned = state.scanDelims(state.pos, true);
  len = scanned.length;
  ch = String.fromCharCode(marker);

  if (len < 2) {
    return false;
  }

  if (len % 2) {
    token = state.push('text', '', 0);
    token.content = ch;
    len--;
  }

  for (i = 0; i < len; i += 2) {
    token = state.push('text', '', 0);
    token.content = ch + ch;

    state.delimiters.push({
      marker: marker,
      jump: i,
      token: state.tokens.length - 1,
      level: state.level,
      end: -1,
      open: scanned.can_open,
      close: scanned.can_close
    });
  }

  state.pos += scanned.length;

  return true;
};

// Walk through delimiter list and replace text tokens with tags
//
module.exports.postProcess = function strikethrough(state) {
  var i,
      j,
      startDelim,
      endDelim,
      token,
      loneMarkers = [],
      delimiters = state.delimiters,
      max = state.delimiters.length;

  for (i = 0; i < max; i++) {
    startDelim = delimiters[i];

    if (startDelim.marker !== 0x7E /* ~ */) {
        continue;
      }

    if (startDelim.end === -1) {
      continue;
    }

    endDelim = delimiters[startDelim.end];

    token = state.tokens[startDelim.token];
    token.type = 's_open';
    token.tag = 's';
    token.nesting = 1;
    token.markup = '~~';
    token.content = '';

    token = state.tokens[endDelim.token];
    token.type = 's_close';
    token.tag = 's';
    token.nesting = -1;
    token.markup = '~~';
    token.content = '';

    if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') {

      loneMarkers.push(endDelim.token - 1);
    }
  }

  // If a marker sequence has an odd number of characters, it's splitted
  // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
  // start of the sequence.
  //
  // So, we have to move all those markers after subsequent s_close tags.
  //
  while (loneMarkers.length) {
    i = loneMarkers.pop();
    j = i + 1;

    while (j < state.tokens.length && state.tokens[j].type === 's_close') {
      j++;
    }

    j--;

    if (i !== j) {
      token = state.tokens[j];
      state.tokens[j] = state.tokens[i];
      state.tokens[i] = token;
    }
  }
};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process *this* and _that_
//


// Insert each marker as a separate text token, and add it to delimiter list
//

module.exports.tokenize = function emphasis(state, silent) {
  var i,
      scanned,
      token,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (silent) {
    return false;
  }

  if (marker !== 0x5F /* _ */ && marker !== 0x2A /* * */) {
      return false;
    }

  scanned = state.scanDelims(state.pos, marker === 0x2A);

  for (i = 0; i < scanned.length; i++) {
    token = state.push('text', '', 0);
    token.content = String.fromCharCode(marker);

    state.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: marker,

      // Total length of these series of delimiters.
      //
      length: scanned.length,

      // An amount of characters before this one that's equivalent to
      // current one. In plain English: if this delimiter does not open
      // an emphasis, neither do previous `jump` characters.
      //
      // Used to skip sequences like "*****" in one step, for 1st asterisk
      // value will be 0, for 2nd it's 1 and so on.
      //
      jump: i,

      // A position of the token this delimiter corresponds to.
      //
      token: state.tokens.length - 1,

      // Token level.
      //
      level: state.level,

      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,

      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: scanned.can_open,
      close: scanned.can_close
    });
  }

  state.pos += scanned.length;

  return true;
};

// Walk through delimiter list and replace text tokens with tags
//
module.exports.postProcess = function emphasis(state) {
  var i,
      startDelim,
      endDelim,
      token,
      ch,
      isStrong,
      delimiters = state.delimiters,
      max = state.delimiters.length;

  for (i = max - 1; i >= 0; i--) {
    startDelim = delimiters[i];

    if (startDelim.marker !== 0x5F /* _ */ && startDelim.marker !== 0x2A /* * */) {
        continue;
      }

    // Process only opening markers
    if (startDelim.end === -1) {
      continue;
    }

    endDelim = delimiters[startDelim.end];

    // If the previous delimiter has the same marker and is adjacent to this one,
    // merge those into one strong delimiter.
    //
    // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
    //
    isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && delimiters[i - 1].token === startDelim.token - 1 && delimiters[startDelim.end + 1].token === endDelim.token + 1 && delimiters[i - 1].marker === startDelim.marker;

    ch = String.fromCharCode(startDelim.marker);

    token = state.tokens[startDelim.token];
    token.type = isStrong ? 'strong_open' : 'em_open';
    token.tag = isStrong ? 'strong' : 'em';
    token.nesting = 1;
    token.markup = isStrong ? ch + ch : ch;
    token.content = '';

    token = state.tokens[endDelim.token];
    token.type = isStrong ? 'strong_close' : 'em_close';
    token.tag = isStrong ? 'strong' : 'em';
    token.nesting = -1;
    token.markup = isStrong ? ch + ch : ch;
    token.content = '';

    if (isStrong) {
      state.tokens[delimiters[i - 1].token].content = '';
      state.tokens[delimiters[startDelim.end + 1].token].content = '';
      i--;
    }
  }
};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StoreAdminCartController = function () {
    function StoreAdminCartController(scope, CartService, $state, $rootScope, sessionService) {
        var _this = this;

        _classCallCheck(this, StoreAdminCartController);

        this._scope = scope;
        this._sessionService = sessionService;
        this._cartService = CartService;
        this._stateService = $state;
        this._rootScope = $rootScope;
        this.carts = [];

        scope.overlayOpened = false;
        scope.model = this;

        scope.backToProfile = function () {
            if (_this._sessionService.getStealthUserMode()) {
                _this._sessionService.setStealthUserMode(null);
                _this._cartService.resetCart();
                _this._rootScope.$broadcast(_CommonConstants2.default.Events.ORDER_CANCELLED);
            }

            _this._stateService.go(_CommonConstants2.default.RoutingStates.USER_PROFILE);
        };
        scope.goToCart = function (cartId) {
            return _this.goToCart(cartId);
        };
        scope.joinToCart = function (cartId, cartToken) {
            return _this.joinToCart(cartId, cartToken);
        };
    }

    _createClass(StoreAdminCartController, [{
        key: "$onInit",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _this2 = this;

                var carts;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                carts = {};

                                if (!(this._stateService.current.name === _CommonConstants2.default.RoutingStates.OPEN_CARTS)) {
                                    _context.next = 8;
                                    break;
                                }

                                this._rootScope.storeWindowTitle = 'client.carts';
                                _context.next = 5;
                                return this._cartService.getCartReport("OPEN");

                            case 5:
                                carts = _context.sent;
                                _context.next = 12;
                                break;

                            case 8:
                                this._rootScope.storeWindowTitle = 'client.order.group_report';
                                _context.next = 11;
                                return this._cartService.getCartReport();

                            case 11:
                                carts = _context.sent;

                            case 12:

                                _scope2.default.apply(this._scope, function () {
                                    _this2.carts = carts;
                                });

                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function $onInit() {
                return _ref.apply(this, arguments);
            }

            return $onInit;
        }()
    }, {
        key: "goToCart",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(cartId) {
                var currentUserEmail, _cart, isOwnerOrParticipant, statuses;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this._cartService.resetCartInvitationType();
                                _context2.next = 3;
                                return this._sessionService.getUserEmail();

                            case 3:
                                currentUserEmail = _context2.sent;

                                this._sessionService.setCartReference(null, false);
                                _context2.next = 7;
                                return this._cartService.getCartById(cartId);

                            case 7:
                                _cart = _context2.sent;
                                isOwnerOrParticipant = false;
                                statuses = ['OWNER', 'JOINED'];

                                if (_cart.participants && _cart.participants.length > 0) {
                                    isOwnerOrParticipant = _cart.participants.some(function (c) {
                                        return c.email === currentUserEmail && statuses.indexOf(c.status) > -1;
                                    });
                                }

                                if (isOwnerOrParticipant) {
                                    _context2.next = 15;
                                    break;
                                }

                                this._sessionService.setStealthUserMode(true);
                                _context2.next = 19;
                                break;

                            case 15:
                                this._sessionService.setStealthUserMode(null);
                                // make sure cart is loaded before going to chat;
                                this._sessionService.setCartReference(null, false);
                                _context2.next = 19;
                                return this._cartService.getCart(cartId);

                            case 19:

                                this._stateService.go(_CommonConstants2.default.RoutingStates.CART);

                            case 20:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function goToCart(_x) {
                return _ref2.apply(this, arguments);
            }

            return goToCart;
        }()

        // accept cart [CW-2538]

    }, {
        key: "joinToCart",
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(cartId, cartToken) {
                var response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this._cartService.shareTokenPromise = null;

                                _context3.next = 3;
                                return this._cartService.acceptInvite(cartToken, true);

                            case 3:
                                response = _context3.sent;


                                this._sessionService.setStealthUserMode(null);

                                _context3.next = 7;
                                return this._cartService.getCart(cartId, false);

                            case 7:

                                this._stateService.go(_CommonConstants2.default.RoutingStates.CART);

                            case 8:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function joinToCart(_x2, _x3) {
                return _ref3.apply(this, arguments);
            }

            return joinToCart;
        }()
    }]);

    return StoreAdminCartController;
}();

StoreAdminCartController.$controllerName = 'Cartonomy.Cart.StoreAdminCartController';
StoreAdminCartController.$inject = ['$scope', 'CartService', '$state', '$rootScope', 'Session'];
exports.default = StoreAdminCartController;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InviteController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _InviteDialogController = __webpack_require__(789);

var _InviteDialogController2 = _interopRequireDefault(_InviteDialogController);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _communicationService = __webpack_require__(28);

var _commandKeys = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InviteController = exports.InviteController = function () {
    function InviteController($scope, $rootScope, stateParams, cartService, dialogService, stateService, authenticationService, sessionService, localForageService, messageService, cartonomyConfig, HeapService, OrderSetupService, $translate) {
        var _this = this;

        _classCallCheck(this, InviteController);

        this._stateParams = stateParams;
        this._cartService = cartService;
        this._dialogService = dialogService;
        this._stateService = stateService;
        this._authenticationService = authenticationService;
        this._sessionService = sessionService;
        this._messageService = messageService;
        this._cartonomyConfig = cartonomyConfig;
        //this._sessionStorageService = sessionStorage;
        this._localForageService = localForageService;
        this._rootScope = $rootScope;
        this._heapService = HeapService;
        this._orderSetupService = OrderSetupService;
        this.invitationToken = this._stateService.params;
        this._scope = $scope;
        this.$translate = $translate;

        this._rootScope.$on(_CommonConstants2.default.Events.CANCEL_INVITATION, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.invitationToken = null;
                            _context.next = 3;
                            return _this._localForageService.remove(_CommonConstants2.default.SessionStorage.AwaitingInvitation);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        })));

        this._rootScope.$on(_CommonConstants2.default.Events.USER_LOGGED_IN, function () {});

        this._scope.$on("$destroy", _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var stateToGo;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _this._sessionService.setCartReference(null);
                            _context2.next = 3;
                            return _this._cartService.getCart();

                        case 3:
                            stateToGo = _this._cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CHAT : _CommonConstants2.default.RoutingStates.CATALOG;
                            _context2.next = 6;
                            return _this._stateService.go(stateToGo);

                        case 6:
                            _scope2.default.apply(_this._scope);

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        })));
    }

    _createClass(InviteController, [{
        key: '$onInit',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var cart;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;

                                this.invitationToken = this._stateService.params;
                                _context3.next = 4;
                                return this._authenticationService.waitForLogin(true);

                            case 4:
                                _context3.next = 6;
                                return this._cartService.getCart();

                            case 6:
                                cart = _context3.sent;

                                this._orderSetupService.invitationPromise = this._safeAccept(cart);

                                _context3.next = 13;
                                break;

                            case 10:
                                _context3.prev = 10;
                                _context3.t0 = _context3['catch'](0);

                                this._showInviteError();
                                //await this._handleAcceptError(error);

                            case 13:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 10]]);
            }));

            function $onInit() {
                return _ref3.apply(this, arguments);
            }

            return $onInit;
        }()
    }, {
        key: '_acceptInvite',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(forceInvite, resolve) {
                var response, cart, resp;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;
                                _context4.next = 3;
                                return this._localForageService.store(_CommonConstants2.default.SessionStorage.AwaitingInvitation, JSON.stringify(this.invitationToken));

                            case 3:
                                _context4.next = 5;
                                return this._cartService.acceptInvite(this._stateParams.participantToken, forceInvite || false);

                            case 5:
                                response = _context4.sent;
                                _context4.next = 8;
                                return this._heapService.track('Invite-Accepted', { token: this._stateParams.participantToken });

                            case 8:
                                _context4.next = 10;
                                return this._sessionService.setCartReference(null, false);

                            case 10:
                                _context4.next = 12;
                                return this._rootScope.$broadcast(_CommonConstants2.default.Events.INVITATION_ACCEPTED);

                            case 12:
                                _context4.next = 14;
                                return this._cartService.getCart(response.cartId, false);

                            case 14:
                                cart = _context4.sent;
                                _context4.next = 17;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.AwaitingInvitation);

                            case 17:
                                _context4.next = 19;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.InvitationUserInvalid);

                            case 19:
                                if (this._sessionService.isTryingToLogIn) {
                                    _context4.next = 22;
                                    break;
                                }

                                _context4.next = 22;
                                return this._orderSetupService.showInvitePreview();

                            case 22:
                                _context4.next = 24;
                                return this._stateService.go(_CommonConstants2.default.RoutingStates.CHAT);

                            case 24:
                                _context4.next = 26;
                                return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.invitationAccepted, { cart: cart });

                            case 26:
                                resp = _context4.sent;

                                if (!resp.success) {
                                    this._messageService.showErrorPopup(this.$translate.instant('client.order.group_restrict_add'));
                                }
                                _context4.next = 34;
                                break;

                            case 30:
                                _context4.prev = 30;
                                _context4.t0 = _context4['catch'](0);
                                _context4.next = 34;
                                return this._handleAcceptError(_context4.t0, forceInvite);

                            case 34:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[0, 30]]);
            }));

            function _acceptInvite(_x, _x2) {
                return _ref4.apply(this, arguments);
            }

            return _acceptInvite;
        }()
    }, {
        key: '_handleLoginRequest',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(response) {
                var invitedCart, stateToGo;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.prev = 0;

                                if (!this._sessionService.isTryingToLogIn) {
                                    _context5.next = 3;
                                    break;
                                }

                                return _context5.abrupt('return');

                            case 3:
                                _context5.next = 5;
                                return this._sessionService.loggedIn();

                            case 5:
                                if (_context5.sent) {
                                    _context5.next = 12;
                                    break;
                                }

                                this._sessionService.isTryingToLogIn = true;
                                _context5.next = 9;
                                return this._cartService.getCartByInvitationCode(this._stateParams.participantToken);

                            case 9:
                                invitedCart = _context5.sent;
                                _context5.next = 12;
                                return this._authenticationService.showLoginDialog(response.data && response.data.parameters && response.data.parameters.prefillEmail, response.data && response.data.parameters && response.data.parameters.needSignUp ? 'signup' : null, false, invitedCart);

                            case 12:
                                _context5.next = 14;
                                return this._sessionService.loggedIn();

                            case 14:
                                if (!_context5.sent) {
                                    _context5.next = 19;
                                    break;
                                }

                                _context5.next = 17;
                                return this._acceptInvite(null);

                            case 17:
                                this._sessionService.isTryingToLogIn = false;
                                return _context5.abrupt('return', false);

                            case 19:
                                _context5.next = 27;
                                break;

                            case 21:
                                _context5.prev = 21;
                                _context5.t0 = _context5['catch'](0);

                                if (!(_context5.t0 && _context5.t0.cancel)) {
                                    _context5.next = 27;
                                    break;
                                }

                                stateToGo = this._cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CHAT : _CommonConstants2.default.RoutingStates.CATALOG;

                                this._stateService.go(stateToGo);
                                return _context5.abrupt('return', false);

                            case 27:
                                return _context5.abrupt('return', true);

                            case 28:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[0, 21]]);
            }));

            function _handleLoginRequest(_x3) {
                return _ref5.apply(this, arguments);
            }

            return _handleLoginRequest;
        }()
    }, {
        key: '_handleAcceptError',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(response, forceInvite) {
                var isInvitationNotForCurrentUser, stateToGo, _stateToGo, isGroupOrder, message, _stateToGo2, _isGroupOrder, _message, _stateToGo3, _stateToGo4;

                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.t0 = response.status === 401;

                                if (!_context6.t0) {
                                    _context6.next = 5;
                                    break;
                                }

                                _context6.next = 4;
                                return this._sessionService.loggedIn();

                            case 4:
                                _context6.t0 = !_context6.sent;

                            case 5:
                                if (!_context6.t0) {
                                    _context6.next = 14;
                                    break;
                                }

                                _context6.prev = 6;
                                _context6.next = 9;
                                return this._handleLoginRequest(response);

                            case 9:
                                _context6.next = 13;
                                break;

                            case 11:
                                _context6.prev = 11;
                                _context6.t1 = _context6['catch'](6);

                            case 13:
                                return _context6.abrupt('return', null);

                            case 14:
                                _context6.next = 16;
                                return this._localForageService.retrieve(_CommonConstants2.default.SessionStorage.InvitationUserInvalid);

                            case 16:
                                isInvitationNotForCurrentUser = _context6.sent;

                                if (!(response.status === 403 && response.data.exceptionType === 'UnauthorizedGroupOrderInvitationException')) {
                                    _context6.next = 31;
                                    break;
                                }

                                if (!isInvitationNotForCurrentUser) {
                                    _context6.next = 21;
                                    break;
                                }

                                _context6.next = 21;
                                return this._messageService.showMessagePopup(this.$translate.instant('client.user.email_different', { email: response.data.parameters.prefillEmail }), this.$translate.instant('client.order.joining'));

                            case 21:
                                _context6.next = 23;
                                return this._authenticationService.logout();

                            case 23:
                                _context6.next = 25;
                                return this._localForageService.exists(_CommonConstants2.default.SessionStorage.InvitationUserInvalid);

                            case 25:
                                if (!_context6.sent) {
                                    _context6.next = 28;
                                    break;
                                }

                                _context6.next = 28;
                                return this._localForageService.store(_CommonConstants2.default.SessionStorage.InvitationUserInvalid, true);

                            case 28:
                                _context6.next = 30;
                                return this._acceptInvite();

                            case 30:
                                return _context6.abrupt('return', null);

                            case 31:
                                if (!(response.status === 403 && response.data.exceptionType === 'JoiningCartHasBeenClosedException')) {
                                    _context6.next = 51;
                                    break;
                                }

                                _context6.next = 34;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.AwaitingInvitation);

                            case 34:
                                _context6.next = 36;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.InvitationUserInvalid);

                            case 36:

                                this._sessionService.setCartReference(null, false);
                                _context6.next = 39;
                                return this._cartService.getCart();

                            case 39:
                                this._rootScope.$broadcast(_CommonConstants2.default.Events.INVITATION_FAILED_DUE_TO_CART_CLOSED);

                                _context6.next = 42;
                                return this._messageService.showMessagePopup(response.data.message);

                            case 42:
                                _context6.next = 44;
                                return this._sessionService.loggedIn();

                            case 44:
                                if (_context6.sent) {
                                    _context6.next = 47;
                                    break;
                                }

                                _context6.next = 47;
                                return this._authenticationService.showLoginDialog('', 'facade', true);

                            case 47:
                                stateToGo = this._cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CHAT : _CommonConstants2.default.RoutingStates.CATALOG;
                                _context6.next = 50;
                                return this._stateService.go(stateToGo);

                            case 50:
                                return _context6.abrupt('return', null);

                            case 51:
                                if (!(response.status === 403 && response.data.exceptionType === 'JoiningOwnCartException')) {
                                    _context6.next = 57;
                                    break;
                                }

                                _context6.next = 54;
                                return this._messageService.showErrorPopupForResponse(response);

                            case 54:
                                _stateToGo = this._cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CHAT : _CommonConstants2.default.RoutingStates.CATALOG;

                                this._stateService.go(_stateToGo);
                                return _context6.abrupt('return', null);

                            case 57:
                                if (!(response.status === 409 && response.data.exceptionType === 'CartPaidMergeException' && !forceInvite)) {
                                    _context6.next = 78;
                                    break;
                                }

                                _context6.prev = 58;
                                _context6.next = 61;
                                return this._showInviteConfirmLeavePaidCart();

                            case 61:
                                this._rootScope.forceInvite = true;
                                _context6.next = 64;
                                return this._acceptInvite(true);

                            case 64:
                                _context6.next = 77;
                                break;

                            case 66:
                                _context6.prev = 66;
                                _context6.t2 = _context6['catch'](58);

                                this._sessionService.setCartReference(null, false);
                                _context6.next = 71;
                                return this._cartService.isGroupOrder();

                            case 71:
                                isGroupOrder = _context6.sent;
                                message = this.$translate.instant('client.order.group_order_declined') + ' ' + (isGroupOrder ? this.$translate.instant('client.order.group_order_taken') : this.$translate.instant('client.order.group_order_prompted'));
                                _context6.next = 75;
                                return this._messageService.showMessagePopup(message);

                            case 75:
                                _stateToGo2 = this._cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CHAT : _CommonConstants2.default.RoutingStates.CATALOG;

                                this._stateService.go(_stateToGo2);

                            case 77:
                                return _context6.abrupt('return', null);

                            case 78:
                                if (!(response.status === 409 && !forceInvite)) {
                                    _context6.next = 99;
                                    break;
                                }

                                _context6.prev = 79;
                                _context6.next = 82;
                                return this._showInviteConfirm();

                            case 82:
                                this._rootScope.forceInvite = true;
                                _context6.next = 85;
                                return this._acceptInvite(true);

                            case 85:
                                _context6.next = 98;
                                break;

                            case 87:
                                _context6.prev = 87;
                                _context6.t3 = _context6['catch'](79);

                                this._sessionService.setCartReference(null, false);
                                _context6.next = 92;
                                return this._cartService.isGroupOrder();

                            case 92:
                                _isGroupOrder = _context6.sent;
                                _message = this.$translate.instant('client.order.group_order_declined') + ' ' + (_isGroupOrder ? this.$translate.instant('client.order.group_order_taken') : this.$translate.instant('client.order.group_order_prompted'));
                                _context6.next = 96;
                                return this._messageService.showMessagePopup(_message);

                            case 96:
                                _stateToGo3 = this._cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CHAT : _CommonConstants2.default.RoutingStates.CATALOG;

                                this._stateService.go(_stateToGo3);

                            case 98:
                                return _context6.abrupt('return', null);

                            case 99:
                                if (!this._messageService.isErrorResponse(response)) {
                                    _context6.next = 105;
                                    break;
                                }

                                _context6.next = 102;
                                return this._messageService.showErrorPopupForResponse(response);

                            case 102:
                                _stateToGo4 = this._cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CHAT : _CommonConstants2.default.RoutingStates.CATALOG;

                                this._stateService.go(_stateToGo4);
                                return _context6.abrupt('return', null);

                            case 105:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this, [[6, 11], [58, 66], [79, 87]]);
            }));

            function _handleAcceptError(_x4, _x5) {
                return _ref6.apply(this, arguments);
            }

            return _handleAcceptError;
        }()
    }, {
        key: '_safeAccept',
        value: function _safeAccept(cart) {
            var _this2 = this;

            return new Promise(function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(resolve) {
                    var confirmed, _confirmed;

                    return regeneratorRuntime.wrap(function _callee7$(_context7) {
                        while (1) {
                            switch (_context7.prev = _context7.next) {
                                case 0:
                                    _context7.next = 2;
                                    return _this2._sessionService.loggedIn();

                                case 2:
                                    if (!_context7.sent) {
                                        _context7.next = 7;
                                        break;
                                    }

                                    _context7.next = 5;
                                    return _this2._acceptInvite(false);

                                case 5:
                                    _context7.next = 33;
                                    break;

                                case 7:
                                    _context7.next = 9;
                                    return _this2._cartService.isGroupOrder(cart);

                                case 9:
                                    if (!_context7.sent) {
                                        _context7.next = 18;
                                        break;
                                    }

                                    _context7.next = 12;
                                    return _this2._messageService.showQuestionPopup(_this2.$translate.instant('client.order.user_removed'), _this2.$translate.instant('client.order.joining'), _this2.$translate.instant(client.yes), _this2.$translate.instant(client.no), 'md-warn');

                                case 12:
                                    confirmed = _context7.sent;

                                    if (!confirmed) {
                                        _context7.next = 16;
                                        break;
                                    }

                                    _context7.next = 16;
                                    return _this2._acceptInvite(false);

                                case 16:
                                    _context7.next = 33;
                                    break;

                                case 18:
                                    if (cart.items.length) {
                                        _context7.next = 25;
                                        break;
                                    }

                                    _context7.next = 21;
                                    return _this2._cartService.deleteCart();

                                case 21:
                                    _context7.next = 23;
                                    return _this2._acceptInvite(false);

                                case 23:
                                    _context7.next = 33;
                                    break;

                                case 25:
                                    _context7.next = 27;
                                    return _this2._messageService.showQuestionPopup(_this2.$translate.instant('client.order.item_removed'), _this2.$translate.instant('client.order.joining'), _this2.$translate.instant(client.yes), _this2.$translate.instant(client.no), 'md-warn');

                                case 27:
                                    _confirmed = _context7.sent;

                                    if (!_confirmed) {
                                        _context7.next = 33;
                                        break;
                                    }

                                    _context7.next = 31;
                                    return _this2._cartService.deleteCart();

                                case 31:
                                    _context7.next = 33;
                                    return _this2._acceptInvite(false);

                                case 33:
                                    resolve();

                                case 34:
                                case 'end':
                                    return _context7.stop();
                            }
                        }
                    }, _callee7, _this2);
                }));

                return function (_x6) {
                    return _ref7.apply(this, arguments);
                };
            }());
        }
    }, {
        key: '_showInviteWelcome',
        value: function _showInviteWelcome(response) {

            // if (response.alreadyJoined) {
            //     this._authenticationService.loginWithInviteToken(response);
            //     this._stateService.go(Constants.RoutingStates.CATALOG);
            // }


            return this._dialogService.show({
                controller: (0, _InviteDialogController2.default)(response),
                templateUrl: "modules/order/views/inviteWelcome.html",
                clickOutsideToClose: false
            });
        }
    }, {
        key: '_showInviteConfirm',
        value: function _showInviteConfirm() {
            var _this3 = this;

            // [CW-2417]
            this._rootScope.storeWindowTitle = "client.order.joining_group";
            return this._dialogService.show({
                controller: ['$scope', '$mdDialog', function (scope, dialogService) {
                    scope.accept = function () {
                        dialogService.hide();
                        _this3._rootScope.storeWindowTitle = null;
                    };
                    scope.cancel = function () {
                        dialogService.cancel();
                        _this3._rootScope.storeWindowTitle = null;
                    };
                }],
                templateUrl: "modules/order/views/inviteConfirm.html",
                clickOutsideToClose: false
            });
        }
    }, {
        key: '_showInviteConfirmLeavePaidCart',
        value: function _showInviteConfirmLeavePaidCart() {
            return this._dialogService.show({
                controller: ['$scope', '$mdDialog', function (scope, dialogService) {
                    scope.accept = function () {
                        dialogService.hide();
                    };
                    scope.cancel = function () {
                        dialogService.cancel();
                    };
                }],
                template: __webpack_require__(790),
                clickOutsideToClose: false
            });
        }
    }, {
        key: '_showInviteError',
        value: function _showInviteError() {
            var _this4 = this;

            return this._dialogService.show({
                controller: ['$scope', '$mdDialog', function (scope, dialogService) {

                    scope.ok = function () {
                        dialogService.hide();
                        var stateToGo = _this4._cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CART : _CommonConstants2.default.RoutingStates.CATALOG;
                        _this4._stateService.go(stateToGo);
                    };
                }],
                templateUrl: "modules/order/views/inviteFailed.html",
                clickOutsideToClose: false
            });
        }
    }]);

    return InviteController;
}();

InviteController.$inject = ['$scope', '$rootScope', '$stateParams', 'CartService', '$mdDialog', '$state', 'AuthenticationService', 'Session', 'LocalForageService', 'Message', 'cartonomyConfig', 'HeapService', 'OrderSetupService', '$translate'];

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = ['$scope', '$mdDialog', 'product', function (scope, dialogService, product) {

    var shortDescriptionLimit = 160;

    _.assign(scope, product);

    scope.showFullDescription = false;
    scope.showMoreLess = product.description.length > shortDescriptionLimit;
    scope.descriptionTruncated = product.description.substring(0, shortDescriptionLimit);

    scope.ok = function () {
        return dialogService.hide();
    };
}];

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var Config = {};
Config.Emoji = {
    "00a9": ["\xA9", ["copyright"]],
    "00ae": ["\xAE", ["registered"]],
    "203c": ["\u203C", ["bangbang"]],
    "2049": ["\u2049", ["interrobang"]],
    "2122": ["\u2122", ["tm"]],
    "2139": ["\u2139", ["information_source"]],
    "2194": ["\u2194", ["left_right_arrow"]],
    "2195": ["\u2195", ["arrow_up_down"]],
    "2196": ["\u2196", ["arrow_upper_left"]],
    "2197": ["\u2197", ["arrow_upper_right"]],
    "2198": ["\u2198", ["arrow_lower_right"]],
    "2199": ["\u2199", ["arrow_lower_left"]],
    "21a9": ["\u21A9", ["leftwards_arrow_with_hook"]],
    "21aa": ["\u21AA", ["arrow_right_hook"]],
    "231a": ["\u231A", ["watch"]],
    "231b": ["\u231B", ["hourglass"]],
    "23e9": ["\u23E9", ["fast_forward"]],
    "23ea": ["\u23EA", ["rewind"]],
    "23eb": ["\u23EB", ["arrow_double_up"]],
    "23ec": ["\u23EC", ["arrow_double_down"]],
    "23f0": ["\u23F0", ["alarm_clock"]],
    "23f3": ["\u23F3", ["hourglass_flowing_sand"]],
    "24c2": ["\u24C2", ["m"]],
    "25aa": ["\u25AA", ["black_small_square"]],
    "25ab": ["\u25AB", ["white_small_square"]],
    "25b6": ["\u25B6", ["arrow_forward"]],
    "25c0": ["\u25C0", ["arrow_backward"]],
    "25fb": ["\u25FB", ["white_medium_square"]],
    "25fc": ["\u25FC", ["black_medium_square"]],
    "25fd": ["\u25FD", ["white_medium_small_square"]],
    "25fe": ["\u25FE", ["black_medium_small_square"]],
    "2600": ["\u2600", ["sunny"]],
    "2601": ["\u2601", ["cloud"]],
    "260e": ["\u260E", ["phone", "telephone"]],
    "2611": ["\u2611", ["ballot_box_with_check"]],
    "2614": ["\u2614", ["umbrella"]],
    "2615": ["\u2615", ["coffee"]],
    "261d": ["\u261D", ["point_up"]],
    "263a": ["\u263A", ["relaxed"]],
    "2648": ["\u2648", ["aries"]],
    "2649": ["\u2649", ["taurus"]],
    "264a": ["\u264A", ["gemini"]],
    "264b": ["\u264B", ["cancer"]],
    "264c": ["\u264C", ["leo"]],
    "264d": ["\u264D", ["virgo"]],
    "264e": ["\u264E", ["libra"]],
    "264f": ["\u264F", ["scorpius"]],
    "2650": ["\u2650", ["sagittarius"]],
    "2651": ["\u2651", ["capricorn"]],
    "2652": ["\u2652", ["aquarius"]],
    "2653": ["\u2653", ["pisces"]],
    "2660": ["\u2660", ["spades"]],
    "2663": ["\u2663", ["clubs"]],
    "2665": ["\u2665", ["hearts"]],
    "2666": ["\u2666", ["diamonds"]],
    "2668": ["\u2668", ["hotsprings"]],
    "267b": ["\u267B", ["recycle"]],
    "267f": ["\u267F", ["wheelchair"]],
    "2693": ["\u2693", ["anchor"]],
    "26a0": ["\u26A0", ["warning"]],
    "26a1": ["\u26A1", ["zap"]],
    "26aa": ["\u26AA", ["white_circle"]],
    "26ab": ["\u26AB", ["black_circle"]],
    "26bd": ["\u26BD", ["soccer"]],
    "26be": ["\u26BE", ["baseball"]],
    "26c4": ["\u26C4", ["snowman"]],
    "26c5": ["\u26C5", ["partly_sunny"]],
    "26ce": ["\u26CE", ["ophiuchus"]],
    "26d4": ["\u26D4", ["no_entry"]],
    "26ea": ["\u26EA", ["church"]],
    "26f2": ["\u26F2", ["fountain"]],
    "26f3": ["\u26F3", ["golf"]],
    "26f5": ["\u26F5", ["boat", "sailboat"]],
    "26fa": ["\u26FA", ["tent"]],
    "26fd": ["\u26FD", ["fuelpump"]],
    "2702": ["\u2702", ["scissors"]],
    "2705": ["\u2705", ["white_check_mark"]],
    "2708": ["\u2708", ["airplane"]],
    "2709": ["\u2709", ["email", "envelope"]],
    "270a": ["\u270A", ["fist"]],
    "270b": ["\u270B", ["hand", "raised_hand"]],
    "270c": ["\u270C", ["v"]],
    "270f": ["\u270F", ["pencil2"]],
    "2712": ["\u2712", ["black_nib"]],
    "2714": ["\u2714", ["heavy_check_mark"]],
    "2716": ["\u2716", ["heavy_multiplication_x"]],
    "2728": ["\u2728", ["sparkles"]],
    "2733": ["\u2733", ["eight_spoked_asterisk"]],
    "2734": ["\u2734", ["eight_pointed_black_star"]],
    "2744": ["\u2744", ["snowflake"]],
    "2747": ["\u2747", ["sparkle"]],
    "274c": ["\u274C", ["x"]],
    "274e": ["\u274E", ["negative_squared_cross_mark"]],
    "2753": ["\u2753", ["question"]],
    "2754": ["\u2754", ["grey_question"]],
    "2755": ["\u2755", ["grey_exclamation"]],
    "2757": ["\u2757", ["exclamation", "heavy_exclamation_mark"]],
    "2764": ["\u2764", ["heart"], "<3"],
    "2795": ["\u2795", ["heavy_plus_sign"]],
    "2796": ["\u2796", ["heavy_minus_sign"]],
    "2797": ["\u2797", ["heavy_division_sign"]],
    "27a1": ["\u27A1", ["arrow_right"]],
    "27b0": ["\u27B0", ["curly_loop"]],
    "27bf": ["\u27BF", ["loop"]],
    "2934": ["\u2934", ["arrow_heading_up"]],
    "2935": ["\u2935", ["arrow_heading_down"]],
    "2b05": ["\u2B05", ["arrow_left"]],
    "2b06": ["\u2B06", ["arrow_up"]],
    "2b07": ["\u2B07", ["arrow_down"]],
    "2b1b": ["\u2B1B", ["black_large_square"]],
    "2b1c": ["\u2B1C", ["white_large_square"]],
    "2b50": ["\u2B50", ["star"]],
    "2b55": ["\u2B55", ["o"]],
    "3030": ["\u3030", ["wavy_dash"]],
    "303d": ["\u303D", ["part_alternation_mark"]],
    "3297": ["\u3297", ["congratulations"]],
    "3299": ["\u3299", ["secret"]],
    "1f004": ["\uD83C\uDC04", ["mahjong"]],
    "1f0cf": ["\uD83C\uDCCF", ["black_joker"]],
    "1f170": ["\uD83C\uDD70", ["a"]],
    "1f171": ["\uD83C\uDD71", ["b"]],
    "1f17e": ["\uD83C\uDD7E", ["o2"]],
    "1f17f": ["\uD83C\uDD7F", ["parking"]],
    "1f18e": ["\uD83C\uDD8E", ["ab"]],
    "1f191": ["\uD83C\uDD91", ["cl"]],
    "1f192": ["\uD83C\uDD92", ["cool"]],
    "1f193": ["\uD83C\uDD93", ["free"]],
    "1f194": ["\uD83C\uDD94", ["id"]],
    "1f195": ["\uD83C\uDD95", ["new"]],
    "1f196": ["\uD83C\uDD96", ["ng"]],
    "1f197": ["\uD83C\uDD97", ["ok"]],
    "1f198": ["\uD83C\uDD98", ["sos"]],
    "1f199": ["\uD83C\uDD99", ["up"]],
    "1f19a": ["\uD83C\uDD9A", ["vs"]],
    "1f201": ["\uD83C\uDE01", ["koko"]],
    "1f202": ["\uD83C\uDE02", ["sa"]],
    "1f21a": ["\uD83C\uDE1A", ["u7121"]],
    "1f22f": ["\uD83C\uDE2F", ["u6307"]],
    "1f232": ["\uD83C\uDE32", ["u7981"]],
    "1f233": ["\uD83C\uDE33", ["u7a7a"]],
    "1f234": ["\uD83C\uDE34", ["u5408"]],
    "1f235": ["\uD83C\uDE35", ["u6e80"]],
    "1f236": ["\uD83C\uDE36", ["u6709"]],
    "1f237": ["\uD83C\uDE37", ["u6708"]],
    "1f238": ["\uD83C\uDE38", ["u7533"]],
    "1f239": ["\uD83C\uDE39", ["u5272"]],
    "1f23a": ["\uD83C\uDE3A", ["u55b6"]],
    "1f250": ["\uD83C\uDE50", ["ideograph_advantage"]],
    "1f251": ["\uD83C\uDE51", ["accept"]],
    "1f300": ["\uD83C\uDF00", ["cyclone"]],
    "1f301": ["\uD83C\uDF01", ["foggy"]],
    "1f302": ["\uD83C\uDF02", ["closed_umbrella"]],
    "1f303": ["\uD83C\uDF03", ["night_with_stars"]],
    "1f304": ["\uD83C\uDF04", ["sunrise_over_mountains"]],
    "1f305": ["\uD83C\uDF05", ["sunrise"]],
    "1f306": ["\uD83C\uDF06", ["city_sunset"]],
    "1f307": ["\uD83C\uDF07", ["city_sunrise"]],
    "1f308": ["\uD83C\uDF08", ["rainbow"]],
    "1f309": ["\uD83C\uDF09", ["bridge_at_night"]],
    "1f30a": ["\uD83C\uDF0A", ["ocean"]],
    "1f30b": ["\uD83C\uDF0B", ["volcano"]],
    "1f30c": ["\uD83C\uDF0C", ["milky_way"]],
    "1f30d": ["\uD83C\uDF0D", ["earth_africa"]],
    "1f30e": ["\uD83C\uDF0E", ["earth_americas"]],
    "1f30f": ["\uD83C\uDF0F", ["earth_asia"]],
    "1f310": ["\uD83C\uDF10", ["globe_with_meridians"]],
    "1f311": ["\uD83C\uDF11", ["new_moon"]],
    "1f312": ["\uD83C\uDF12", ["waxing_crescent_moon"]],
    "1f313": ["\uD83C\uDF13", ["first_quarter_moon"]],
    "1f314": ["\uD83C\uDF14", ["moon", "waxing_gibbous_moon"]],
    "1f315": ["\uD83C\uDF15", ["full_moon"]],
    "1f316": ["\uD83C\uDF16", ["waning_gibbous_moon"]],
    "1f317": ["\uD83C\uDF17", ["last_quarter_moon"]],
    "1f318": ["\uD83C\uDF18", ["waning_crescent_moon"]],
    "1f319": ["\uD83C\uDF19", ["crescent_moon"]],
    "1f320": ["\uD83C\uDF20", ["stars"]],
    "1f31a": ["\uD83C\uDF1A", ["new_moon_with_face"]],
    "1f31b": ["\uD83C\uDF1B", ["first_quarter_moon_with_face"]],
    "1f31c": ["\uD83C\uDF1C", ["last_quarter_moon_with_face"]],
    "1f31d": ["\uD83C\uDF1D", ["full_moon_with_face"]],
    "1f31e": ["\uD83C\uDF1E", ["sun_with_face"]],
    "1f31f": ["\uD83C\uDF1F", ["star2"]],
    "1f330": ["\uD83C\uDF30", ["chestnut"]],
    "1f331": ["\uD83C\uDF31", ["seedling"]],
    "1f332": ["\uD83C\uDF32", ["evergreen_tree"]],
    "1f333": ["\uD83C\uDF33", ["deciduous_tree"]],
    "1f334": ["\uD83C\uDF34", ["palm_tree"]],
    "1f335": ["\uD83C\uDF35", ["cactus"]],
    "1f337": ["\uD83C\uDF37", ["tulip"]],
    "1f338": ["\uD83C\uDF38", ["cherry_blossom"]],
    "1f339": ["\uD83C\uDF39", ["rose"]],
    "1f33a": ["\uD83C\uDF3A", ["hibiscus"]],
    "1f33b": ["\uD83C\uDF3B", ["sunflower"]],
    "1f33c": ["\uD83C\uDF3C", ["blossom"]],
    "1f33d": ["\uD83C\uDF3D", ["corn"]],
    "1f33e": ["\uD83C\uDF3E", ["ear_of_rice"]],
    "1f33f": ["\uD83C\uDF3F", ["herb"]],
    "1f340": ["\uD83C\uDF40", ["four_leaf_clover"]],
    "1f341": ["\uD83C\uDF41", ["maple_leaf"]],
    "1f342": ["\uD83C\uDF42", ["fallen_leaf"]],
    "1f343": ["\uD83C\uDF43", ["leaves"]],
    "1f344": ["\uD83C\uDF44", ["mushroom"]],
    "1f345": ["\uD83C\uDF45", ["tomato"]],
    "1f346": ["\uD83C\uDF46", ["eggplant"]],
    "1f347": ["\uD83C\uDF47", ["grapes"]],
    "1f348": ["\uD83C\uDF48", ["melon"]],
    "1f349": ["\uD83C\uDF49", ["watermelon"]],
    "1f34a": ["\uD83C\uDF4A", ["tangerine"]],
    "1f34b": ["\uD83C\uDF4B", ["lemon"]],
    "1f34c": ["\uD83C\uDF4C", ["banana"]],
    "1f34d": ["\uD83C\uDF4D", ["pineapple"]],
    "1f34e": ["\uD83C\uDF4E", ["apple"]],
    "1f34f": ["\uD83C\uDF4F", ["green_apple"]],
    "1f350": ["\uD83C\uDF50", ["pear"]],
    "1f351": ["\uD83C\uDF51", ["peach"]],
    "1f352": ["\uD83C\uDF52", ["cherries"]],
    "1f353": ["\uD83C\uDF53", ["strawberry"]],
    "1f354": ["\uD83C\uDF54", ["hamburger"]],
    "1f355": ["\uD83C\uDF55", ["pizza"]],
    "1f356": ["\uD83C\uDF56", ["meat_on_bone"]],
    "1f357": ["\uD83C\uDF57", ["poultry_leg"]],
    "1f358": ["\uD83C\uDF58", ["rice_cracker"]],
    "1f359": ["\uD83C\uDF59", ["rice_ball"]],
    "1f35a": ["\uD83C\uDF5A", ["rice"]],
    "1f35b": ["\uD83C\uDF5B", ["curry"]],
    "1f35c": ["\uD83C\uDF5C", ["ramen"]],
    "1f35d": ["\uD83C\uDF5D", ["spaghetti"]],
    "1f35e": ["\uD83C\uDF5E", ["bread"]],
    "1f35f": ["\uD83C\uDF5F", ["fries"]],
    "1f360": ["\uD83C\uDF60", ["sweet_potato"]],
    "1f361": ["\uD83C\uDF61", ["dango"]],
    "1f362": ["\uD83C\uDF62", ["oden"]],
    "1f363": ["\uD83C\uDF63", ["sushi"]],
    "1f364": ["\uD83C\uDF64", ["fried_shrimp"]],
    "1f365": ["\uD83C\uDF65", ["fish_cake"]],
    "1f366": ["\uD83C\uDF66", ["icecream"]],
    "1f367": ["\uD83C\uDF67", ["shaved_ice"]],
    "1f368": ["\uD83C\uDF68", ["ice_cream"]],
    "1f369": ["\uD83C\uDF69", ["doughnut"]],
    "1f36a": ["\uD83C\uDF6A", ["cookie"]],
    "1f36b": ["\uD83C\uDF6B", ["chocolate_bar"]],
    "1f36c": ["\uD83C\uDF6C", ["candy"]],
    "1f36d": ["\uD83C\uDF6D", ["lollipop"]],
    "1f36e": ["\uD83C\uDF6E", ["custard"]],
    "1f36f": ["\uD83C\uDF6F", ["honey_pot"]],
    "1f370": ["\uD83C\uDF70", ["cake"]],
    "1f371": ["\uD83C\uDF71", ["bento"]],
    "1f372": ["\uD83C\uDF72", ["stew"]],
    "1f373": ["\uD83C\uDF73", ["egg"]],
    "1f374": ["\uD83C\uDF74", ["fork_and_knife"]],
    "1f375": ["\uD83C\uDF75", ["tea"]],
    "1f376": ["\uD83C\uDF76", ["sake"]],
    "1f377": ["\uD83C\uDF77", ["wine_glass"]],
    "1f378": ["\uD83C\uDF78", ["cocktail"]],
    "1f379": ["\uD83C\uDF79", ["tropical_drink"]],
    "1f37a": ["\uD83C\uDF7A", ["beer"]],
    "1f37b": ["\uD83C\uDF7B", ["beers"]],
    "1f37c": ["\uD83C\uDF7C", ["baby_bottle"]],
    "1f380": ["\uD83C\uDF80", ["ribbon"]],
    "1f381": ["\uD83C\uDF81", ["gift"]],
    "1f382": ["\uD83C\uDF82", ["birthday"]],
    "1f383": ["\uD83C\uDF83", ["jack_o_lantern"]],
    "1f384": ["\uD83C\uDF84", ["christmas_tree"]],
    "1f385": ["\uD83C\uDF85", ["santa"]],
    "1f386": ["\uD83C\uDF86", ["fireworks"]],
    "1f387": ["\uD83C\uDF87", ["sparkler"]],
    "1f388": ["\uD83C\uDF88", ["balloon"]],
    "1f389": ["\uD83C\uDF89", ["tada"]],
    "1f38a": ["\uD83C\uDF8A", ["confetti_ball"]],
    "1f38b": ["\uD83C\uDF8B", ["tanabata_tree"]],
    "1f38c": ["\uD83C\uDF8C", ["crossed_flags"]],
    "1f38d": ["\uD83C\uDF8D", ["bamboo"]],
    "1f38e": ["\uD83C\uDF8E", ["dolls"]],
    "1f38f": ["\uD83C\uDF8F", ["flags"]],
    "1f390": ["\uD83C\uDF90", ["wind_chime"]],
    "1f391": ["\uD83C\uDF91", ["rice_scene"]],
    "1f392": ["\uD83C\uDF92", ["school_satchel"]],
    "1f393": ["\uD83C\uDF93", ["mortar_board"]],
    "1f3a0": ["\uD83C\uDFA0", ["carousel_horse"]],
    "1f3a1": ["\uD83C\uDFA1", ["ferris_wheel"]],
    "1f3a2": ["\uD83C\uDFA2", ["roller_coaster"]],
    "1f3a3": ["\uD83C\uDFA3", ["fishing_pole_and_fish"]],
    "1f3a4": ["\uD83C\uDFA4", ["microphone"]],
    "1f3a5": ["\uD83C\uDFA5", ["movie_camera"]],
    "1f3a6": ["\uD83C\uDFA6", ["cinema"]],
    "1f3a7": ["\uD83C\uDFA7", ["headphones"]],
    "1f3a8": ["\uD83C\uDFA8", ["art"]],
    "1f3a9": ["\uD83C\uDFA9", ["tophat"]],
    "1f3aa": ["\uD83C\uDFAA", ["circus_tent"]],
    "1f3ab": ["\uD83C\uDFAB", ["ticket"]],
    "1f3ac": ["\uD83C\uDFAC", ["clapper"]],
    "1f3ad": ["\uD83C\uDFAD", ["performing_arts"]],
    "1f3ae": ["\uD83C\uDFAE", ["video_game"]],
    "1f3af": ["\uD83C\uDFAF", ["dart"]],
    "1f3b0": ["\uD83C\uDFB0", ["slot_machine"]],
    "1f3b1": ["\uD83C\uDFB1", ["8ball"]],
    "1f3b2": ["\uD83C\uDFB2", ["game_die"]],
    "1f3b3": ["\uD83C\uDFB3", ["bowling"]],
    "1f3b4": ["\uD83C\uDFB4", ["flower_playing_cards"]],
    "1f3b5": ["\uD83C\uDFB5", ["musical_note"]],
    "1f3b6": ["\uD83C\uDFB6", ["notes"]],
    "1f3b7": ["\uD83C\uDFB7", ["saxophone"]],
    "1f3b8": ["\uD83C\uDFB8", ["guitar"]],
    "1f3b9": ["\uD83C\uDFB9", ["musical_keyboard"]],
    "1f3ba": ["\uD83C\uDFBA", ["trumpet"]],
    "1f3bb": ["\uD83C\uDFBB", ["violin"]],
    "1f3bc": ["\uD83C\uDFBC", ["musical_score"]],
    "1f3bd": ["\uD83C\uDFBD", ["running_shirt_with_sash"]],
    "1f3be": ["\uD83C\uDFBE", ["tennis"]],
    "1f3bf": ["\uD83C\uDFBF", ["ski"]],
    "1f3c0": ["\uD83C\uDFC0", ["basketball"]],
    "1f3c1": ["\uD83C\uDFC1", ["checkered_flag"]],
    "1f3c2": ["\uD83C\uDFC2", ["snowboarder"]],
    "1f3c3": ["\uD83C\uDFC3", ["runner", "running"]],
    "1f3c4": ["\uD83C\uDFC4", ["surfer"]],
    "1f3c6": ["\uD83C\uDFC6", ["trophy"]],
    "1f3c7": ["\uD83C\uDFC7", ["horse_racing"]],
    "1f3c8": ["\uD83C\uDFC8", ["football"]],
    "1f3c9": ["\uD83C\uDFC9", ["rugby_football"]],
    "1f3ca": ["\uD83C\uDFCA", ["swimmer"]],
    "1f3e0": ["\uD83C\uDFE0", ["house"]],
    "1f3e1": ["\uD83C\uDFE1", ["house_with_garden"]],
    "1f3e2": ["\uD83C\uDFE2", ["office"]],
    "1f3e3": ["\uD83C\uDFE3", ["post_office"]],
    "1f3e4": ["\uD83C\uDFE4", ["european_post_office"]],
    "1f3e5": ["\uD83C\uDFE5", ["hospital"]],
    "1f3e6": ["\uD83C\uDFE6", ["bank"]],
    "1f3e7": ["\uD83C\uDFE7", ["atm"]],
    "1f3e8": ["\uD83C\uDFE8", ["hotel"]],
    "1f3e9": ["\uD83C\uDFE9", ["love_hotel"]],
    "1f3ea": ["\uD83C\uDFEA", ["convenience_store"]],
    "1f3eb": ["\uD83C\uDFEB", ["school"]],
    "1f3ec": ["\uD83C\uDFEC", ["department_store"]],
    "1f3ed": ["\uD83C\uDFED", ["factory"]],
    "1f3ee": ["\uD83C\uDFEE", ["izakaya_lantern", "lantern"]],
    "1f3ef": ["\uD83C\uDFEF", ["japanese_castle"]],
    "1f3f0": ["\uD83C\uDFF0", ["european_castle"]],
    "1f400": ["\uD83D\uDC00", ["rat"]],
    "1f401": ["\uD83D\uDC01", ["mouse2"]],
    "1f402": ["\uD83D\uDC02", ["ox"]],
    "1f403": ["\uD83D\uDC03", ["water_buffalo"]],
    "1f404": ["\uD83D\uDC04", ["cow2"]],
    "1f405": ["\uD83D\uDC05", ["tiger2"]],
    "1f406": ["\uD83D\uDC06", ["leopard"]],
    "1f407": ["\uD83D\uDC07", ["rabbit2"]],
    "1f408": ["\uD83D\uDC08", ["cat2"]],
    "1f409": ["\uD83D\uDC09", ["dragon"]],
    "1f40a": ["\uD83D\uDC0A", ["crocodile"]],
    "1f40b": ["\uD83D\uDC0B", ["whale2"]],
    "1f40c": ["\uD83D\uDC0C", ["snail"]],
    "1f40d": ["\uD83D\uDC0D", ["snake"]],
    "1f40e": ["\uD83D\uDC0E", ["racehorse"]],
    "1f40f": ["\uD83D\uDC0F", ["ram"]],
    "1f410": ["\uD83D\uDC10", ["goat"]],
    "1f411": ["\uD83D\uDC11", ["sheep"]],
    "1f412": ["\uD83D\uDC12", ["monkey"]],
    "1f413": ["\uD83D\uDC13", ["rooster"]],
    "1f414": ["\uD83D\uDC14", ["chicken"]],
    "1f415": ["\uD83D\uDC15", ["dog2"]],
    "1f416": ["\uD83D\uDC16", ["pig2"]],
    "1f417": ["\uD83D\uDC17", ["boar"]],
    "1f418": ["\uD83D\uDC18", ["elephant"]],
    "1f419": ["\uD83D\uDC19", ["octopus"]],
    "1f41a": ["\uD83D\uDC1A", ["shell"]],
    "1f41b": ["\uD83D\uDC1B", ["bug"]],
    "1f41c": ["\uD83D\uDC1C", ["ant"]],
    "1f41d": ["\uD83D\uDC1D", ["bee", "honeybee"]],
    "1f41e": ["\uD83D\uDC1E", ["beetle"]],
    "1f41f": ["\uD83D\uDC1F", ["fish"]],
    "1f420": ["\uD83D\uDC20", ["tropical_fish"]],
    "1f421": ["\uD83D\uDC21", ["blowfish"]],
    "1f422": ["\uD83D\uDC22", ["turtle"]],
    "1f423": ["\uD83D\uDC23", ["hatching_chick"]],
    "1f424": ["\uD83D\uDC24", ["baby_chick"]],
    "1f425": ["\uD83D\uDC25", ["hatched_chick"]],
    "1f426": ["\uD83D\uDC26", ["bird"]],
    "1f427": ["\uD83D\uDC27", ["penguin"]],
    "1f428": ["\uD83D\uDC28", ["koala"]],
    "1f429": ["\uD83D\uDC29", ["poodle"]],
    "1f42a": ["\uD83D\uDC2A", ["dromedary_camel"]],
    "1f42b": ["\uD83D\uDC2B", ["camel"]],
    "1f42c": ["\uD83D\uDC2C", ["dolphin", "flipper"]],
    "1f42d": ["\uD83D\uDC2D", ["mouse"]],
    "1f42e": ["\uD83D\uDC2E", ["cow"]],
    "1f42f": ["\uD83D\uDC2F", ["tiger"]],
    "1f430": ["\uD83D\uDC30", ["rabbit"]],
    "1f431": ["\uD83D\uDC31", ["cat"]],
    "1f432": ["\uD83D\uDC32", ["dragon_face"]],
    "1f433": ["\uD83D\uDC33", ["whale"]],
    "1f434": ["\uD83D\uDC34", ["horse"]],
    "1f435": ["\uD83D\uDC35", ["monkey_face"]],
    "1f436": ["\uD83D\uDC36", ["dog"]],
    "1f437": ["\uD83D\uDC37", ["pig"]],
    "1f438": ["\uD83D\uDC38", ["frog"]],
    "1f439": ["\uD83D\uDC39", ["hamster"]],
    "1f43a": ["\uD83D\uDC3A", ["wolf"]],
    "1f43b": ["\uD83D\uDC3B", ["bear"]],
    "1f43c": ["\uD83D\uDC3C", ["panda_face"]],
    "1f43d": ["\uD83D\uDC3D", ["pig_nose"]],
    "1f43e": ["\uD83D\uDC3E", ["feet", "paw_prints"]],
    "1f440": ["\uD83D\uDC40", ["eyes"]],
    "1f442": ["\uD83D\uDC42", ["ear"]],
    "1f443": ["\uD83D\uDC43", ["nose"]],
    "1f444": ["\uD83D\uDC44", ["lips"]],
    "1f445": ["\uD83D\uDC45", ["tongue"]],
    "1f446": ["\uD83D\uDC46", ["point_up_2"]],
    "1f447": ["\uD83D\uDC47", ["point_down"]],
    "1f448": ["\uD83D\uDC48", ["point_left"]],
    "1f449": ["\uD83D\uDC49", ["point_right"]],
    "1f44a": ["\uD83D\uDC4A", ["facepunch", "punch"]],
    "1f44b": ["\uD83D\uDC4B", ["wave"]],
    "1f44c": ["\uD83D\uDC4C", ["ok_hand"]],
    "1f44d": ["\uD83D\uDC4D", ["+1", "thumbsup"]],
    "1f44e": ["\uD83D\uDC4E", ["-1", "thumbsdown"]],
    "1f44f": ["\uD83D\uDC4F", ["clap"]],
    "1f450": ["\uD83D\uDC50", ["open_hands"]],
    "1f451": ["\uD83D\uDC51", ["crown"]],
    "1f452": ["\uD83D\uDC52", ["womans_hat"]],
    "1f453": ["\uD83D\uDC53", ["eyeglasses"]],
    "1f454": ["\uD83D\uDC54", ["necktie"]],
    "1f455": ["\uD83D\uDC55", ["shirt", "tshirt"]],
    "1f456": ["\uD83D\uDC56", ["jeans"]],
    "1f457": ["\uD83D\uDC57", ["dress"]],
    "1f458": ["\uD83D\uDC58", ["kimono"]],
    "1f459": ["\uD83D\uDC59", ["bikini"]],
    "1f45a": ["\uD83D\uDC5A", ["womans_clothes"]],
    "1f45b": ["\uD83D\uDC5B", ["purse"]],
    "1f45c": ["\uD83D\uDC5C", ["handbag"]],
    "1f45d": ["\uD83D\uDC5D", ["pouch"]],
    "1f45e": ["\uD83D\uDC5E", ["mans_shoe", "shoe"]],
    "1f45f": ["\uD83D\uDC5F", ["athletic_shoe"]],
    "1f460": ["\uD83D\uDC60", ["high_heel"]],
    "1f461": ["\uD83D\uDC61", ["sandal"]],
    "1f462": ["\uD83D\uDC62", ["boot"]],
    "1f463": ["\uD83D\uDC63", ["footprints"]],
    "1f464": ["\uD83D\uDC64", ["bust_in_silhouette"]],
    "1f465": ["\uD83D\uDC65", ["busts_in_silhouette"]],
    "1f466": ["\uD83D\uDC66", ["boy"]],
    "1f467": ["\uD83D\uDC67", ["girl"]],
    "1f468": ["\uD83D\uDC68", ["man"]],
    "1f469": ["\uD83D\uDC69", ["woman"]],
    "1f46a": ["\uD83D\uDC6A", ["family"]],
    "1f46b": ["\uD83D\uDC6B", ["couple"]],
    "1f46c": ["\uD83D\uDC6C", ["two_men_holding_hands"]],
    "1f46d": ["\uD83D\uDC6D", ["two_women_holding_hands"]],
    "1f46e": ["\uD83D\uDC6E", ["cop"]],
    "1f46f": ["\uD83D\uDC6F", ["dancers"]],
    "1f470": ["\uD83D\uDC70", ["bride_with_veil"]],
    "1f471": ["\uD83D\uDC71", ["person_with_blond_hair"]],
    "1f472": ["\uD83D\uDC72", ["man_with_gua_pi_mao"]],
    "1f473": ["\uD83D\uDC73", ["man_with_turban"]],
    "1f474": ["\uD83D\uDC74", ["older_man"]],
    "1f475": ["\uD83D\uDC75", ["older_woman"]],
    "1f476": ["\uD83D\uDC76", ["baby"]],
    "1f477": ["\uD83D\uDC77", ["construction_worker"]],
    "1f478": ["\uD83D\uDC78", ["princess"]],
    "1f479": ["\uD83D\uDC79", ["japanese_ogre"]],
    "1f47a": ["\uD83D\uDC7A", ["japanese_goblin"]],
    "1f47b": ["\uD83D\uDC7B", ["ghost"]],
    "1f47c": ["\uD83D\uDC7C", ["angel"]],
    "1f47d": ["\uD83D\uDC7D", ["alien"]],
    "1f47e": ["\uD83D\uDC7E", ["space_invader"]],
    "1f47f": ["\uD83D\uDC7F", ["imp"]],
    "1f480": ["\uD83D\uDC80", ["skull"]],
    "1f481": ["\uD83D\uDC81", ["information_desk_person"]],
    "1f482": ["\uD83D\uDC82", ["guardsman"]],
    "1f483": ["\uD83D\uDC83", ["dancer"]],
    "1f484": ["\uD83D\uDC84", ["lipstick"]],
    "1f485": ["\uD83D\uDC85", ["nail_care"]],
    "1f486": ["\uD83D\uDC86", ["massage"]],
    "1f487": ["\uD83D\uDC87", ["haircut"]],
    "1f488": ["\uD83D\uDC88", ["barber"]],
    "1f489": ["\uD83D\uDC89", ["syringe"]],
    "1f48a": ["\uD83D\uDC8A", ["pill"]],
    "1f48b": ["\uD83D\uDC8B", ["kiss"]],
    "1f48c": ["\uD83D\uDC8C", ["love_letter"]],
    "1f48d": ["\uD83D\uDC8D", ["ring"]],
    "1f48e": ["\uD83D\uDC8E", ["gem"]],
    "1f48f": ["\uD83D\uDC8F", ["couplekiss"]],
    "1f490": ["\uD83D\uDC90", ["bouquet"]],
    "1f491": ["\uD83D\uDC91", ["couple_with_heart"]],
    "1f492": ["\uD83D\uDC92", ["wedding"]],
    "1f493": ["\uD83D\uDC93", ["heartbeat"]],
    "1f494": ["\uD83D\uDC94", ["broken_heart"], "<\/3"],
    "1f495": ["\uD83D\uDC95", ["two_hearts"]],
    "1f496": ["\uD83D\uDC96", ["sparkling_heart"]],
    "1f497": ["\uD83D\uDC97", ["heartpulse"]],
    "1f498": ["\uD83D\uDC98", ["cupid"]],
    "1f499": ["\uD83D\uDC99", ["blue_heart"], "<3"],
    "1f49a": ["\uD83D\uDC9A", ["green_heart"], "<3"],
    "1f49b": ["\uD83D\uDC9B", ["yellow_heart"], "<3"],
    "1f49c": ["\uD83D\uDC9C", ["purple_heart"], "<3"],
    "1f49d": ["\uD83D\uDC9D", ["gift_heart"]],
    "1f49e": ["\uD83D\uDC9E", ["revolving_hearts"]],
    "1f49f": ["\uD83D\uDC9F", ["heart_decoration"]],
    "1f4a0": ["\uD83D\uDCA0", ["diamond_shape_with_a_dot_inside"]],
    "1f4a1": ["\uD83D\uDCA1", ["bulb"]],
    "1f4a2": ["\uD83D\uDCA2", ["anger"]],
    "1f4a3": ["\uD83D\uDCA3", ["bomb"]],
    "1f4a4": ["\uD83D\uDCA4", ["zzz"]],
    "1f4a5": ["\uD83D\uDCA5", ["boom", "collision"]],
    "1f4a6": ["\uD83D\uDCA6", ["sweat_drops"]],
    "1f4a7": ["\uD83D\uDCA7", ["droplet"]],
    "1f4a8": ["\uD83D\uDCA8", ["dash"]],
    "1f4a9": ["\uD83D\uDCA9", ["hankey", "poop", "shit"]],
    "1f4aa": ["\uD83D\uDCAA", ["muscle"]],
    "1f4ab": ["\uD83D\uDCAB", ["dizzy"]],
    "1f4ac": ["\uD83D\uDCAC", ["speech_balloon"]],
    "1f4ad": ["\uD83D\uDCAD", ["thought_balloon"]],
    "1f4ae": ["\uD83D\uDCAE", ["white_flower"]],
    "1f4af": ["\uD83D\uDCAF", ["100"]],
    "1f4b0": ["\uD83D\uDCB0", ["moneybag"]],
    "1f4b1": ["\uD83D\uDCB1", ["currency_exchange"]],
    "1f4b2": ["\uD83D\uDCB2", ["heavy_dollar_sign"]],
    "1f4b3": ["\uD83D\uDCB3", ["credit_card"]],
    "1f4b4": ["\uD83D\uDCB4", ["yen"]],
    "1f4b5": ["\uD83D\uDCB5", ["dollar"]],
    "1f4b6": ["\uD83D\uDCB6", ["euro"]],
    "1f4b7": ["\uD83D\uDCB7", ["pound"]],
    "1f4b8": ["\uD83D\uDCB8", ["money_with_wings"]],
    "1f4b9": ["\uD83D\uDCB9", ["chart"]],
    "1f4ba": ["\uD83D\uDCBA", ["seat"]],
    "1f4bb": ["\uD83D\uDCBB", ["computer"]],
    "1f4bc": ["\uD83D\uDCBC", ["briefcase"]],
    "1f4bd": ["\uD83D\uDCBD", ["minidisc"]],
    "1f4be": ["\uD83D\uDCBE", ["floppy_disk"]],
    "1f4bf": ["\uD83D\uDCBF", ["cd"]],
    "1f4c0": ["\uD83D\uDCC0", ["dvd"]],
    "1f4c1": ["\uD83D\uDCC1", ["file_folder"]],
    "1f4c2": ["\uD83D\uDCC2", ["open_file_folder"]],
    "1f4c3": ["\uD83D\uDCC3", ["page_with_curl"]],
    "1f4c4": ["\uD83D\uDCC4", ["page_facing_up"]],
    "1f4c5": ["\uD83D\uDCC5", ["date"]],
    "1f4c6": ["\uD83D\uDCC6", ["calendar"]],
    "1f4c7": ["\uD83D\uDCC7", ["card_index"]],
    "1f4c8": ["\uD83D\uDCC8", ["chart_with_upwards_trend"]],
    "1f4c9": ["\uD83D\uDCC9", ["chart_with_downwards_trend"]],
    "1f4ca": ["\uD83D\uDCCA", ["bar_chart"]],
    "1f4cb": ["\uD83D\uDCCB", ["clipboard"]],
    "1f4cc": ["\uD83D\uDCCC", ["pushpin"]],
    "1f4cd": ["\uD83D\uDCCD", ["round_pushpin"]],
    "1f4ce": ["\uD83D\uDCCE", ["paperclip"]],
    "1f4cf": ["\uD83D\uDCCF", ["straight_ruler"]],
    "1f4d0": ["\uD83D\uDCD0", ["triangular_ruler"]],
    "1f4d1": ["\uD83D\uDCD1", ["bookmark_tabs"]],
    "1f4d2": ["\uD83D\uDCD2", ["ledger"]],
    "1f4d3": ["\uD83D\uDCD3", ["notebook"]],
    "1f4d4": ["\uD83D\uDCD4", ["notebook_with_decorative_cover"]],
    "1f4d5": ["\uD83D\uDCD5", ["closed_book"]],
    "1f4d6": ["\uD83D\uDCD6", ["book", "open_book"]],
    "1f4d7": ["\uD83D\uDCD7", ["green_book"]],
    "1f4d8": ["\uD83D\uDCD8", ["blue_book"]],
    "1f4d9": ["\uD83D\uDCD9", ["orange_book"]],
    "1f4da": ["\uD83D\uDCDA", ["books"]],
    "1f4db": ["\uD83D\uDCDB", ["name_badge"]],
    "1f4dc": ["\uD83D\uDCDC", ["scroll"]],
    "1f4dd": ["\uD83D\uDCDD", ["memo", "pencil"]],
    "1f4de": ["\uD83D\uDCDE", ["telephone_receiver"]],
    "1f4df": ["\uD83D\uDCDF", ["pager"]],
    "1f4e0": ["\uD83D\uDCE0", ["fax"]],
    "1f4e1": ["\uD83D\uDCE1", ["satellite"]],
    "1f4e2": ["\uD83D\uDCE2", ["loudspeaker"]],
    "1f4e3": ["\uD83D\uDCE3", ["mega"]],
    "1f4e4": ["\uD83D\uDCE4", ["outbox_tray"]],
    "1f4e5": ["\uD83D\uDCE5", ["inbox_tray"]],
    "1f4e6": ["\uD83D\uDCE6", ["package"]],
    "1f4e7": ["\uD83D\uDCE7", ["e-mail"]],
    "1f4e8": ["\uD83D\uDCE8", ["incoming_envelope"]],
    "1f4e9": ["\uD83D\uDCE9", ["envelope_with_arrow"]],
    "1f4ea": ["\uD83D\uDCEA", ["mailbox_closed"]],
    "1f4eb": ["\uD83D\uDCEB", ["mailbox"]],
    "1f4ec": ["\uD83D\uDCEC", ["mailbox_with_mail"]],
    "1f4ed": ["\uD83D\uDCED", ["mailbox_with_no_mail"]],
    "1f4ee": ["\uD83D\uDCEE", ["postbox"]],
    "1f4ef": ["\uD83D\uDCEF", ["postal_horn"]],
    "1f4f0": ["\uD83D\uDCF0", ["newspaper"]],
    "1f4f1": ["\uD83D\uDCF1", ["iphone"]],
    "1f4f2": ["\uD83D\uDCF2", ["calling"]],
    "1f4f3": ["\uD83D\uDCF3", ["vibration_mode"]],
    "1f4f4": ["\uD83D\uDCF4", ["mobile_phone_off"]],
    "1f4f5": ["\uD83D\uDCF5", ["no_mobile_phones"]],
    "1f4f6": ["\uD83D\uDCF6", ["signal_strength"]],
    "1f4f7": ["\uD83D\uDCF7", ["camera"]],
    "1f4f9": ["\uD83D\uDCF9", ["video_camera"]],
    "1f4fa": ["\uD83D\uDCFA", ["tv"]],
    "1f4fb": ["\uD83D\uDCFB", ["radio"]],
    "1f4fc": ["\uD83D\uDCFC", ["vhs"]],
    "1f500": ["\uD83D\uDD00", ["twisted_rightwards_arrows"]],
    "1f501": ["\uD83D\uDD01", ["repeat"]],
    "1f502": ["\uD83D\uDD02", ["repeat_one"]],
    "1f503": ["\uD83D\uDD03", ["arrows_clockwise"]],
    "1f504": ["\uD83D\uDD04", ["arrows_counterclockwise"]],
    "1f505": ["\uD83D\uDD05", ["low_brightness"]],
    "1f506": ["\uD83D\uDD06", ["high_brightness"]],
    "1f507": ["\uD83D\uDD07", ["mute"]],
    "1f508": ["\uD83D\uDD09", ["speaker"]],
    "1f509": ["\uD83D\uDD09", ["sound"]],
    "1f50a": ["\uD83D\uDD0A", ["loud_sound"]],
    "1f50b": ["\uD83D\uDD0B", ["battery"]],
    "1f50c": ["\uD83D\uDD0C", ["electric_plug"]],
    "1f50d": ["\uD83D\uDD0D", ["mag"]],
    "1f50e": ["\uD83D\uDD0E", ["mag_right"]],
    "1f50f": ["\uD83D\uDD0F", ["lock_with_ink_pen"]],
    "1f510": ["\uD83D\uDD10", ["closed_lock_with_key"]],
    "1f511": ["\uD83D\uDD11", ["key"]],
    "1f512": ["\uD83D\uDD12", ["lock"]],
    "1f513": ["\uD83D\uDD13", ["unlock"]],
    "1f514": ["\uD83D\uDD14", ["bell"]],
    "1f515": ["\uD83D\uDD15", ["no_bell"]],
    "1f516": ["\uD83D\uDD16", ["bookmark"]],
    "1f517": ["\uD83D\uDD17", ["link"]],
    "1f518": ["\uD83D\uDD18", ["radio_button"]],
    "1f519": ["\uD83D\uDD19", ["back"]],
    "1f51a": ["\uD83D\uDD1A", ["end"]],
    "1f51b": ["\uD83D\uDD1B", ["on"]],
    "1f51c": ["\uD83D\uDD1C", ["soon"]],
    "1f51d": ["\uD83D\uDD1D", ["top"]],
    "1f51e": ["\uD83D\uDD1E", ["underage"]],
    "1f51f": ["\uD83D\uDD1F", ["keycap_ten"]],
    "1f520": ["\uD83D\uDD20", ["capital_abcd"]],
    "1f521": ["\uD83D\uDD21", ["abcd"]],
    "1f522": ["\uD83D\uDD22", ["1234"]],
    "1f523": ["\uD83D\uDD23", ["symbols"]],
    "1f524": ["\uD83D\uDD24", ["abc"]],
    "1f525": ["\uD83D\uDD25", ["fire"]],
    "1f526": ["\uD83D\uDD26", ["flashlight"]],
    "1f527": ["\uD83D\uDD27", ["wrench"]],
    "1f528": ["\uD83D\uDD28", ["hammer"]],
    "1f529": ["\uD83D\uDD29", ["nut_and_bolt"]],
    "1f52a": ["\uD83D\uDD2A", ["hocho"]],
    "1f52b": ["\uD83D\uDD2B", ["gun"]],
    "1f52c": ["\uD83D\uDD2C", ["microscope"]],
    "1f52d": ["\uD83D\uDD2D", ["telescope"]],
    "1f52e": ["\uD83D\uDD2E", ["crystal_ball"]],
    "1f52f": ["\uD83D\uDD2F", ["six_pointed_star"]],
    "1f530": ["\uD83D\uDD30", ["beginner"]],
    "1f531": ["\uD83D\uDD31", ["trident"]],
    "1f532": ["\uD83D\uDD32", ["black_square_button"]],
    "1f533": ["\uD83D\uDD33", ["white_square_button"]],
    "1f534": ["\uD83D\uDD34", ["red_circle"]],
    "1f535": ["\uD83D\uDD35", ["large_blue_circle"]],
    "1f536": ["\uD83D\uDD36", ["large_orange_diamond"]],
    "1f537": ["\uD83D\uDD37", ["large_blue_diamond"]],
    "1f538": ["\uD83D\uDD38", ["small_orange_diamond"]],
    "1f539": ["\uD83D\uDD39", ["small_blue_diamond"]],
    "1f53a": ["\uD83D\uDD3A", ["small_red_triangle"]],
    "1f53b": ["\uD83D\uDD3B", ["small_red_triangle_down"]],
    "1f53c": ["\uD83D\uDD3C", ["arrow_up_small"]],
    "1f53d": ["\uD83D\uDD3D", ["arrow_down_small"]],
    "1f550": ["\uD83D\uDD50", ["clock1"]],
    "1f551": ["\uD83D\uDD51", ["clock2"]],
    "1f552": ["\uD83D\uDD52", ["clock3"]],
    "1f553": ["\uD83D\uDD53", ["clock4"]],
    "1f554": ["\uD83D\uDD54", ["clock5"]],
    "1f555": ["\uD83D\uDD55", ["clock6"]],
    "1f556": ["\uD83D\uDD56", ["clock7"]],
    "1f557": ["\uD83D\uDD57", ["clock8"]],
    "1f558": ["\uD83D\uDD58", ["clock9"]],
    "1f559": ["\uD83D\uDD59", ["clock10"]],
    "1f55a": ["\uD83D\uDD5A", ["clock11"]],
    "1f55b": ["\uD83D\uDD5B", ["clock12"]],
    "1f55c": ["\uD83D\uDD5C", ["clock130"]],
    "1f55d": ["\uD83D\uDD5D", ["clock230"]],
    "1f55e": ["\uD83D\uDD5E", ["clock330"]],
    "1f55f": ["\uD83D\uDD5F", ["clock430"]],
    "1f560": ["\uD83D\uDD60", ["clock530"]],
    "1f561": ["\uD83D\uDD61", ["clock630"]],
    "1f562": ["\uD83D\uDD62", ["clock730"]],
    "1f563": ["\uD83D\uDD63", ["clock830"]],
    "1f564": ["\uD83D\uDD64", ["clock930"]],
    "1f565": ["\uD83D\uDD65", ["clock1030"]],
    "1f566": ["\uD83D\uDD66", ["clock1130"]],
    "1f567": ["\uD83D\uDD67", ["clock1230"]],
    "1f5fb": ["\uD83D\uDDFB", ["mount_fuji"]],
    "1f5fc": ["\uD83D\uDDFC", ["tokyo_tower"]],
    "1f5fd": ["\uD83D\uDDFD", ["statue_of_liberty"]],
    "1f5fe": ["\uD83D\uDDFE", ["japan"]],
    "1f5ff": ["\uD83D\uDDFF", ["moyai"]],
    "1f600": ["\uD83D\uDE00", ["grinning"]],
    "1f601": ["\uD83D\uDE01", ["grin"]],
    "1f602": ["\uD83D\uDE02", ["joy"]],
    "1f603": ["\uD83D\uDE03", ["smiley"], ":)"],
    "1f604": ["\uD83D\uDE04", ["smile"], ":)"],
    "1f605": ["\uD83D\uDE05", ["sweat_smile"]],
    "1f606": ["\uD83D\uDE06", ["satisfied"]],
    "1f607": ["\uD83D\uDE07", ["innocent"]],
    "1f608": ["\uD83D\uDE08", ["smiling_imp"]],
    "1f609": ["\uD83D\uDE09", ["wink"], ";)"],
    "1f60a": ["\uD83D\uDE0A", ["blush"]],
    "1f60b": ["\uD83D\uDE0B", ["yum"]],
    "1f60c": ["\uD83D\uDE0C", ["relieved"]],
    "1f60d": ["\uD83D\uDE0D", ["heart_eyes"]],
    "1f60e": ["\uD83D\uDE0E", ["sunglasses"]],
    "1f60f": ["\uD83D\uDE0F", ["smirk"]],
    "1f610": ["\uD83D\uDE10", ["neutral_face"]],
    "1f611": ["\uD83D\uDE11", ["expressionless"]],
    "1f612": ["\uD83D\uDE12", ["unamused"]],
    "1f613": ["\uD83D\uDE13", ["sweat"]],
    "1f614": ["\uD83D\uDE14", ["pensive"]],
    "1f615": ["\uD83D\uDE15", ["confused"]],
    "1f616": ["\uD83D\uDE16", ["confounded"]],
    "1f617": ["\uD83D\uDE17", ["kissing"]],
    "1f618": ["\uD83D\uDE18", ["kissing_heart"]],
    "1f619": ["\uD83D\uDE19", ["kissing_smiling_eyes"]],
    "1f61a": ["\uD83D\uDE1A", ["kissing_closed_eyes"]],
    "1f61b": ["\uD83D\uDE1B", ["stuck_out_tongue"]],
    "1f61c": ["\uD83D\uDE1C", ["stuck_out_tongue_winking_eye"], ";p"],
    "1f61d": ["\uD83D\uDE1D", ["stuck_out_tongue_closed_eyes"]],
    "1f61e": ["\uD83D\uDE1E", ["disappointed"], ":("],
    "1f61f": ["\uD83D\uDE1F", ["worried"]],
    "1f620": ["\uD83D\uDE20", ["angry"]],
    "1f621": ["\uD83D\uDE21", ["rage"]],
    "1f622": ["\uD83D\uDE22", ["cry"], ":'("],
    "1f623": ["\uD83D\uDE23", ["persevere"]],
    "1f624": ["\uD83D\uDE24", ["triumph"]],
    "1f625": ["\uD83D\uDE25", ["disappointed_relieved"]],
    "1f626": ["\uD83D\uDE26", ["frowning"]],
    "1f627": ["\uD83D\uDE27", ["anguished"]],
    "1f628": ["\uD83D\uDE28", ["fearful"]],
    "1f629": ["\uD83D\uDE29", ["weary"]],
    "1f62a": ["\uD83D\uDE2A", ["sleepy"]],
    "1f62b": ["\uD83D\uDE2B", ["tired_face"]],
    "1f62c": ["\uD83D\uDE2C", ["grimacing"]],
    "1f62d": ["\uD83D\uDE2D", ["sob"], ":'("],
    "1f62e": ["\uD83D\uDE2E", ["open_mouth"]],
    "1f62f": ["\uD83D\uDE2F", ["hushed"]],
    "1f630": ["\uD83D\uDE30", ["cold_sweat"]],
    "1f631": ["\uD83D\uDE31", ["scream"]],
    "1f632": ["\uD83D\uDE32", ["astonished"]],
    "1f633": ["\uD83D\uDE33", ["flushed"]],
    "1f634": ["\uD83D\uDE34", ["sleeping"]],
    "1f635": ["\uD83D\uDE35", ["dizzy_face"]],
    "1f636": ["\uD83D\uDE36", ["no_mouth"]],
    "1f637": ["\uD83D\uDE37", ["mask"]],
    "1f638": ["\uD83D\uDE38", ["smile_cat"]],
    "1f639": ["\uD83D\uDE39", ["joy_cat"]],
    "1f63a": ["\uD83D\uDE3A", ["smiley_cat"]],
    "1f63b": ["\uD83D\uDE3B", ["heart_eyes_cat"]],
    "1f63c": ["\uD83D\uDE3C", ["smirk_cat"]],
    "1f63d": ["\uD83D\uDE3D", ["kissing_cat"]],
    "1f63e": ["\uD83D\uDE3E", ["pouting_cat"]],
    "1f63f": ["\uD83D\uDE3F", ["crying_cat_face"]],
    "1f640": ["\uD83D\uDE40", ["scream_cat"]],
    "1f645": ["\uD83D\uDE45", ["no_good"]],
    "1f646": ["\uD83D\uDE46", ["ok_woman"]],
    "1f647": ["\uD83D\uDE47", ["bow"]],
    "1f648": ["\uD83D\uDE48", ["see_no_evil"]],
    "1f649": ["\uD83D\uDE49", ["hear_no_evil"]],
    "1f64a": ["\uD83D\uDE4A", ["speak_no_evil"]],
    "1f64b": ["\uD83D\uDE4B", ["raising_hand"]],
    "1f64c": ["\uD83D\uDE4C", ["raised_hands"]],
    "1f64d": ["\uD83D\uDE4D", ["person_frowning"]],
    "1f64e": ["\uD83D\uDE4E", ["person_with_pouting_face"]],
    "1f64f": ["\uD83D\uDE4F", ["pray"]],
    "1f680": ["\uD83D\uDE80", ["rocket"]],
    "1f681": ["\uD83D\uDE81", ["helicopter"]],
    "1f682": ["\uD83D\uDE82", ["steam_locomotive"]],
    "1f683": ["\uD83D\uDE83", ["railway_car"]],
    "1f68b": ["\uD83D\uDE8B", ["train"]],
    "1f684": ["\uD83D\uDE84", ["bullettrain_side"]],
    "1f685": ["\uD83D\uDE85", ["bullettrain_front"]],
    "1f686": ["\uD83D\uDE86", ["train2"]],
    "1f687": ["\uD83D\uDE87", ["metro"]],
    "1f688": ["\uD83D\uDE88", ["light_rail"]],
    "1f689": ["\uD83D\uDE89", ["station"]],
    "1f68a": ["\uD83D\uDE8A", ["tram"]],
    "1f68c": ["\uD83D\uDE8C", ["bus"]],
    "1f68d": ["\uD83D\uDE8D", ["oncoming_bus"]],
    "1f68e": ["\uD83D\uDE8E", ["trolleybus"]],
    "1f68f": ["\uD83D\uDE8F", ["busstop"]],
    "1f690": ["\uD83D\uDE90", ["minibus"]],
    "1f691": ["\uD83D\uDE91", ["ambulance"]],
    "1f692": ["\uD83D\uDE92", ["fire_engine"]],
    "1f693": ["\uD83D\uDE93", ["police_car"]],
    "1f694": ["\uD83D\uDE94", ["oncoming_police_car"]],
    "1f695": ["\uD83D\uDE95", ["taxi"]],
    "1f696": ["\uD83D\uDE96", ["oncoming_taxi"]],
    "1f697": ["\uD83D\uDE97", ["car", "red_car"]],
    "1f698": ["\uD83D\uDE98", ["oncoming_automobile"]],
    "1f699": ["\uD83D\uDE99", ["blue_car"]],
    "1f69a": ["\uD83D\uDE9A", ["truck"]],
    "1f69b": ["\uD83D\uDE9B", ["articulated_lorry"]],
    "1f69c": ["\uD83D\uDE9C", ["tractor"]],
    "1f69d": ["\uD83D\uDE9D", ["monorail"]],
    "1f69e": ["\uD83D\uDE9E", ["mountain_railway"]],
    "1f69f": ["\uD83D\uDE9F", ["suspension_railway"]],
    "1f6a0": ["\uD83D\uDEA0", ["mountain_cableway"]],
    "1f6a1": ["\uD83D\uDEA1", ["aerial_tramway"]],
    "1f6a2": ["\uD83D\uDEA2", ["ship"]],
    "1f6a3": ["\uD83D\uDEA3", ["rowboat"]],
    "1f6a4": ["\uD83D\uDEA4", ["speedboat"]],
    "1f6a5": ["\uD83D\uDEA5", ["traffic_light"]],
    "1f6a6": ["\uD83D\uDEA6", ["vertical_traffic_light"]],
    "1f6a7": ["\uD83D\uDEA7", ["construction"]],
    "1f6a8": ["\uD83D\uDEA8", ["rotating_light"]],
    "1f6a9": ["\uD83D\uDEA9", ["triangular_flag_on_post"]],
    "1f6aa": ["\uD83D\uDEAA", ["door"]],
    "1f6ab": ["\uD83D\uDEAB", ["no_entry_sign"]],
    "1f6ac": ["\uD83D\uDEAC", ["smoking"]],
    "1f6ad": ["\uD83D\uDEAD", ["no_smoking"]],
    "1f6ae": ["\uD83D\uDEAE", ["put_litter_in_its_place"]],
    "1f6af": ["\uD83D\uDEAF", ["do_not_litter"]],
    "1f6b0": ["\uD83D\uDEB0", ["potable_water"]],
    "1f6b1": ["\uD83D\uDEB1", ["non-potable_water"]],
    "1f6b2": ["\uD83D\uDEB2", ["bike"]],
    "1f6b3": ["\uD83D\uDEB3", ["no_bicycles"]],
    "1f6b4": ["\uD83D\uDEB4", ["bicyclist"]],
    "1f6b5": ["\uD83D\uDEB5", ["mountain_bicyclist"]],
    "1f6b6": ["\uD83D\uDEB6", ["walking"]],
    "1f6b7": ["\uD83D\uDEB7", ["no_pedestrians"]],
    "1f6b8": ["\uD83D\uDEB8", ["children_crossing"]],
    "1f6b9": ["\uD83D\uDEB9", ["mens"]],
    "1f6ba": ["\uD83D\uDEBA", ["womens"]],
    "1f6bb": ["\uD83D\uDEBB", ["restroom"]],
    "1f6bc": ["\uD83D\uDEBC", ["baby_symbol"]],
    "1f6bd": ["\uD83D\uDEBD", ["toilet"]],
    "1f6be": ["\uD83D\uDEBE", ["wc"]],
    "1f6bf": ["\uD83D\uDEBF", ["shower"]],
    "1f6c0": ["\uD83D\uDEC0", ["bath"]],
    "1f6c1": ["\uD83D\uDEC1", ["bathtub"]],
    "1f6c2": ["\uD83D\uDEC2", ["passport_control"]],
    "1f6c3": ["\uD83D\uDEC3", ["customs"]],
    "1f6c4": ["\uD83D\uDEC4", ["baggage_claim"]],
    "1f6c5": ["\uD83D\uDEC5", ["left_luggage"]],
    "0023": ["#\u20E3", ["hash"]],
    "0030": ["0\u20E3", ["zero"]],
    "0031": ["1\u20E3", ["one"]],
    "0032": ["2\u20E3", ["two"]],
    "0033": ["3\u20E3", ["three"]],
    "0034": ["4\u20E3", ["four"]],
    "0035": ["5\u20E3", ["five"]],
    "0036": ["6\u20E3", ["six"]],
    "0037": ["7\u20E3", ["seven"]],
    "0038": ["8\u20E3", ["eight"]],
    "0039": ["9\u20E3", ["nine"]],
    "1f1e8-1f1f3": ["\uD83C\uDDE8\uD83C\uDDF3", ["cn"]],
    "1f1e9-1f1ea": ["\uD83C\uDDE9\uD83C\uDDEA", ["de"]],
    "1f1ea-1f1f8": ["\uD83C\uDDEA\uD83C\uDDF8", ["es"]],
    "1f1eb-1f1f7": ["\uD83C\uDDEB\uD83C\uDDF7", ["fr"]],
    "1f1ec-1f1e7": ["\uD83C\uDDEC\uD83C\uDDE7", ["gb", "uk"]],
    "1f1ee-1f1f9": ["\uD83C\uDDEE\uD83C\uDDF9", ["it"]],
    "1f1ef-1f1f5": ["\uD83C\uDDEF\uD83C\uDDF5", ["jp"]],
    "1f1f0-1f1f7": ["\uD83C\uDDF0\uD83C\uDDF7", ["kr"]],
    "1f1f7-1f1fa": ["\uD83C\uDDF7\uD83C\uDDFA", ["ru"]],
    "1f1fa-1f1f8": ["\uD83C\uDDFA\uD83C\uDDF8", ["us"]]
};

Config.EmojiCategories = [["1f604", "1f603", "1f600", "1f60a", "263a", "1f609", "1f60d", "1f618", "1f61a", "1f617", "1f619", "1f61c", "1f61d", "1f61b", "1f633", "1f601", "1f614", "1f60c", "1f612", "1f61e", "1f623", "1f622", "1f602", "1f62d", "1f62a", "1f625", "1f630", "1f605", "1f613", "1f629", "1f62b", "1f628", "1f631", "1f620", "1f621", "1f624", "1f616", "1f606", "1f60b", "1f637", "1f60e", "1f634", "1f635", "1f632", "1f61f", "1f626", "1f627", "1f608", "1f47f", "1f62e", "1f62c", "1f610", "1f615", "1f62f", "1f636", "1f607", "1f60f", "1f611", "1f472", "1f473", "1f46e", "1f477", "1f482", "1f476", "1f466", "1f467", "1f468", "1f469", "1f474", "1f475", "1f471", "1f47c", "1f478", "1f63a", "1f638", "1f63b", "1f63d", "1f63c", "1f640", "1f63f", "1f639", "1f63e", "1f479", "1f47a", "1f648", "1f649", "1f64a", "1f480", "1f47d", "1f4a9", "1f525", "2728", "1f31f", "1f4ab", "1f4a5", "1f4a2", "1f4a6", "1f4a7", "1f4a4", "1f4a8", "1f442", "1f440", "1f443", "1f445", "1f444", "1f44d", "1f44e", "1f44c", "1f44a", "270a", "270c", "1f44b", "270b", "1f450", "1f446", "1f447", "1f449", "1f448", "1f64c", "1f64f", "261d", "1f44f", "1f4aa", "1f6b6", "1f3c3", "1f483", "1f46b", "1f46a", "1f46c", "1f46d", "1f48f", "1f491", "1f46f", "1f646", "1f645", "1f481", "1f64b", "1f486", "1f487", "1f485", "1f470", "1f64e", "1f64d", "1f647", "1f3a9", "1f451", "1f452", "1f45f", "1f45e", "1f461", "1f460", "1f462", "1f455", "1f454", "1f45a", "1f457", "1f3bd", "1f456", "1f458", "1f459", "1f4bc", "1f45c", "1f45d", "1f45b", "1f453", "1f380", "1f302", "1f484", "1f49b", "1f499", "1f49c", "1f49a", "2764", "1f494", "1f497", "1f493", "1f495", "1f496", "1f49e", "1f498", "1f48c", "1f48b", "1f48d", "1f48e", "1f464", "1f465", "1f4ac", "1f463", "1f4ad"], ["1f436", "1f43a", "1f431", "1f42d", "1f439", "1f430", "1f438", "1f42f", "1f428", "1f43b", "1f437", "1f43d", "1f42e", "1f417", "1f435", "1f412", "1f434", "1f411", "1f418", "1f43c", "1f427", "1f426", "1f424", "1f425", "1f423", "1f414", "1f40d", "1f422", "1f41b", "1f41d", "1f41c", "1f41e", "1f40c", "1f419", "1f41a", "1f420", "1f41f", "1f42c", "1f433", "1f40b", "1f404", "1f40f", "1f400", "1f403", "1f405", "1f407", "1f409", "1f40e", "1f410", "1f413", "1f415", "1f416", "1f401", "1f402", "1f432", "1f421", "1f40a", "1f42b", "1f42a", "1f406", "1f408", "1f429", "1f43e", "1f490", "1f338", "1f337", "1f340", "1f339", "1f33b", "1f33a", "1f341", "1f343", "1f342", "1f33f", "1f33e", "1f344", "1f335", "1f334", "1f332", "1f333", "1f330", "1f331", "1f33c", "1f310", "1f31e", "1f31d", "1f31a", "1f311", "1f312", "1f313", "1f314", "1f315", "1f316", "1f317", "1f318", "1f31c", "1f31b", "1f319", "1f30d", "1f30e", "1f30f", "1f30b", "1f30c", "1f320", "2b50", "2600", "26c5", "2601", "26a1", "2614", "2744", "26c4", "1f300", "1f301", "1f308", "1f30a"], ["1f38d", "1f49d", "1f38e", "1f392", "1f393", "1f38f", "1f386", "1f387", "1f390", "1f391", "1f383", "1f47b", "1f385", "1f384", "1f381", "1f38b", "1f389", "1f38a", "1f388", "1f38c", "1f52e", "1f3a5", "1f4f7", "1f4f9", "1f4fc", "1f4bf", "1f4c0", "1f4bd", "1f4be", "1f4bb", "1f4f1", "260e", "1f4de", "1f4df", "1f4e0", "1f4e1", "1f4fa", "1f4fb", "1f50a", "1f509", "1f508", "1f507", "1f514", "1f515", "1f4e3", "1f4e2", "23f3", "231b", "23f0", "231a", "1f513", "1f512", "1f50f", "1f510", "1f511", "1f50e", "1f4a1", "1f526", "1f506", "1f505", "1f50c", "1f50b", "1f50d", "1f6c0", "1f6c1", "1f6bf", "1f6bd", "1f527", "1f529", "1f528", "1f6aa", "1f6ac", "1f4a3", "1f52b", "1f52a", "1f48a", "1f489", "1f4b0", "1f4b4", "1f4b5", "1f4b7", "1f4b6", "1f4b3", "1f4b8", "1f4f2", "1f4e7", "1f4e5", "1f4e4", "2709", "1f4e9", "1f4e8", "1f4ef", "1f4eb", "1f4ea", "1f4ec", "1f4ed", "1f4ee", "1f4e6", "1f4dd", "1f4c4", "1f4c3", "1f4d1", "1f4ca", "1f4c8", "1f4c9", "1f4dc", "1f4cb", "1f4c5", "1f4c6", "1f4c7", "1f4c1", "1f4c2", "2702", "1f4cc", "1f4ce", "2712", "270f", "1f4cf", "1f4d0", "1f4d5", "1f4d7", "1f4d8", "1f4d9", "1f4d3", "1f4d4", "1f4d2", "1f4da", "1f4d6", "1f516", "1f4db", "1f52c", "1f52d", "1f4f0", "1f3a8", "1f3ac", "1f3a4", "1f3a7", "1f3bc", "1f3b5", "1f3b6", "1f3b9", "1f3bb", "1f3ba", "1f3b7", "1f3b8", "1f47e", "1f3ae", "1f0cf", "1f3b4", "1f004", "1f3b2", "1f3af", "1f3c8", "1f3c0", "26bd", "26be", "1f3be", "1f3b1", "1f3c9", "1f3b3", "26f3", "1f6b5", "1f6b4", "1f3c1", "1f3c7", "1f3c6", "1f3bf", "1f3c2", "1f3ca", "1f3c4", "1f3a3", "2615", "1f375", "1f376", "1f37c", "1f37a", "1f37b", "1f378", "1f379", "1f377", "1f374", "1f355", "1f354", "1f35f", "1f357", "1f356", "1f35d", "1f35b", "1f364", "1f371", "1f363", "1f365", "1f359", "1f358", "1f35a", "1f35c", "1f372", "1f362", "1f361", "1f373", "1f35e", "1f369", "1f36e", "1f366", "1f368", "1f367", "1f382", "1f370", "1f36a", "1f36b", "1f36c", "1f36d", "1f36f", "1f34e", "1f34f", "1f34a", "1f34b", "1f352", "1f347", "1f349", "1f353", "1f351", "1f348", "1f34c", "1f350", "1f34d", "1f360", "1f346", "1f345", "1f33d"], ["1f3e0", "1f3e1", "1f3eb", "1f3e2", "1f3e3", "1f3e5", "1f3e6", "1f3ea", "1f3e9", "1f3e8", "1f492", "26ea", "1f3ec", "1f3e4", "1f307", "1f306", "1f3ef", "1f3f0", "26fa", "1f3ed", "1f5fc", "1f5fe", "1f5fb", "1f304", "1f305", "1f303", "1f5fd", "1f309", "1f3a0", "1f3a1", "26f2", "1f3a2", "1f6a2", "26f5", "1f6a4", "1f6a3", "2693", "1f680", "2708", "1f4ba", "1f681", "1f682", "1f68a", "1f689", "1f69e", "1f686", "1f684", "1f685", "1f688", "1f687", "1f69d", "1f683", "1f68b", "1f68e", "1f68c", "1f68d", "1f699", "1f698", "1f697", "1f695", "1f696", "1f69b", "1f69a", "1f6a8", "1f693", "1f694", "1f692", "1f691", "1f690", "1f6b2", "1f6a1", "1f69f", "1f6a0", "1f69c", "1f488", "1f68f", "1f3ab", "1f6a6", "1f6a5", "26a0", "1f6a7", "1f530", "26fd", "1f3ee", "1f3b0", "2668", "1f5ff", "1f3aa", "1f3ad", "1f4cd", "1f6a9", "1f1ef-1f1f5", "1f1f0-1f1f7", "1f1e9-1f1ea", "1f1e8-1f1f3", "1f1fa-1f1f8", "1f1eb-1f1f7", "1f1ea-1f1f8", "1f1ee-1f1f9", "1f1f7-1f1fa", "1f1ec-1f1e7"], ["0031", "0032", "0033", "0034", "0035", "0036", "0037", "0038", "0039", "0030", "1f51f", "1f522", "0023", "1f523", "2b06", "2b07", "2b05", "27a1", "1f520", "1f521", "1f524", "2197", "2196", "2198", "2199", "2194", "2195", "1f504", "25c0", "25b6", "1f53c", "1f53d", "21a9", "21aa", "2139", "23ea", "23e9", "23eb", "23ec", "2935", "2934", "1f197", "1f500", "1f501", "1f502", "1f195", "1f199", "1f192", "1f193", "1f196", "1f4f6", "1f3a6", "1f201", "1f22f", "1f233", "1f235", "1f234", "1f232", "1f250", "1f239", "1f23a", "1f236", "1f21a", "1f6bb", "1f6b9", "1f6ba", "1f6bc", "1f6be", "1f6b0", "1f6ae", "1f17f", "267f", "1f6ad", "1f237", "1f238", "1f202", "24c2", "1f6c2", "1f6c4", "1f6c5", "1f6c3", "1f251", "3299", "3297", "1f191", "1f198", "1f194", "1f6ab", "1f51e", "1f4f5", "1f6af", "1f6b1", "1f6b3", "1f6b7", "1f6b8", "26d4", "2733", "2747", "274e", "2705", "2734", "1f49f", "1f19a", "1f4f3", "1f4f4", "1f170", "1f171", "1f18e", "1f17e", "1f4a0", "27bf", "267b", "2648", "2649", "264a", "264b", "264c", "264d", "264e", "264f", "2650", "2651", "2652", "2653", "26ce", "1f52f", "1f3e7", "1f4b9", "1f4b2", "1f4b1", "00a9", "00ae", "2122", "274c", "203c", "2049", "2757", "2753", "2755", "2754", "2b55", "1f51d", "1f51a", "1f519", "1f51b", "1f51c", "1f503", "1f55b", "1f567", "1f550", "1f55c", "1f551", "1f55d", "1f552", "1f55e", "1f553", "1f55f", "1f554", "1f560", "1f555", "1f556", "1f557", "1f558", "1f559", "1f55a", "1f561", "1f562", "1f563", "1f564", "1f565", "1f566", "2716", "2795", "2796", "2797", "2660", "2665", "2663", "2666", "1f4ae", "1f4af", "2714", "2611", "1f518", "1f517", "27b0", "3030", "303d", "1f531", "25fc", "25fb", "25fe", "25fd", "25aa", "25ab", "1f53a", "1f532", "1f533", "26ab", "26aa", "1f534", "1f535", "1f53b", "2b1c", "2b1b", "1f536", "1f537", "1f538", "1f539"]];

Config.EmojiCategorySpritesheetDimens = [[7, 27], [4, 29], [7, 33], [3, 34], [7, 34]];

Config.emoji_data = {
    "00a9": [["\xA9"], "\uE24E", "\uDBBA\uDF29", ["copyright"], 0, 0],
    "00ae": [["\xAE"], "\uE24F", "\uDBBA\uDF2D", ["registered"], 0, 1],
    "203c": [["\u203C\uFE0F", "\u203C"], "", "\uDBBA\uDF06", ["bangbang"], 0, 2],
    "2049": [["\u2049\uFE0F", "\u2049"], "", "\uDBBA\uDF05", ["interrobang"], 0, 3],
    "2122": [["\u2122"], "\uE537", "\uDBBA\uDF2A", ["tm"], 0, 4],
    "2139": [["\u2139\uFE0F", "\u2139"], "", "\uDBBA\uDF47", ["information_source"], 0, 5],
    "2194": [["\u2194\uFE0F", "\u2194"], "", "\uDBBA\uDEF6", ["left_right_arrow"], 0, 6],
    "2195": [["\u2195\uFE0F", "\u2195"], "", "\uDBBA\uDEF7", ["arrow_up_down"], 0, 7],
    "2196": [["\u2196\uFE0F", "\u2196"], "\uE237", "\uDBBA\uDEF2", ["arrow_upper_left"], 0, 8],
    "2197": [["\u2197\uFE0F", "\u2197"], "\uE236", "\uDBBA\uDEF0", ["arrow_upper_right"], 0, 9],
    "2198": [["\u2198\uFE0F", "\u2198"], "\uE238", "\uDBBA\uDEF1", ["arrow_lower_right"], 0, 10],
    "2199": [["\u2199\uFE0F", "\u2199"], "\uE239", "\uDBBA\uDEF3", ["arrow_lower_left"], 0, 11],
    "21a9": [["\u21A9\uFE0F", "\u21A9"], "", "\uDBBA\uDF83", ["leftwards_arrow_with_hook"], 0, 12],
    "21aa": [["\u21AA\uFE0F", "\u21AA"], "", "\uDBBA\uDF88", ["arrow_right_hook"], 0, 13],
    "231a": [["\u231A\uFE0F", "\u231A"], "", "\uDBB8\uDC1D", ["watch"], 0, 14],
    "231b": [["\u231B\uFE0F", "\u231B"], "", "\uDBB8\uDC1C", ["hourglass"], 0, 15],
    "23e9": [["\u23E9"], "\uE23C", "\uDBBA\uDEFE", ["fast_forward"], 0, 16],
    "23ea": [["\u23EA"], "\uE23D", "\uDBBA\uDEFF", ["rewind"], 0, 17],
    "23eb": [["\u23EB"], "", "\uDBBA\uDF03", ["arrow_double_up"], 0, 18],
    "23ec": [["\u23EC"], "", "\uDBBA\uDF02", ["arrow_double_down"], 0, 19],
    "23f0": [["\u23F0"], "\uE02D", "\uDBB8\uDC2A", ["alarm_clock"], 0, 20],
    "23f3": [["\u23F3"], "", "\uDBB8\uDC1B", ["hourglass_flowing_sand"], 0, 21],
    "24c2": [["\u24C2\uFE0F", "\u24C2"], "\uE434", "\uDBB9\uDFE1", ["m"], 0, 22],
    "25aa": [["\u25AA\uFE0F", "\u25AA"], "\uE21A", "\uDBBA\uDF6E", ["black_small_square"], 0, 23],
    "25ab": [["\u25AB\uFE0F", "\u25AB"], "\uE21B", "\uDBBA\uDF6D", ["white_small_square"], 0, 24],
    "25b6": [["\u25B6\uFE0F", "\u25B6"], "\uE23A", "\uDBBA\uDEFC", ["arrow_forward"], 0, 25],
    "25c0": [["\u25C0\uFE0F", "\u25C0"], "\uE23B", "\uDBBA\uDEFD", ["arrow_backward"], 0, 26],
    "25fb": [["\u25FB\uFE0F", "\u25FB"], "\uE21B", "\uDBBA\uDF71", ["white_medium_square"], 0, 27],
    "25fc": [["\u25FC\uFE0F", "\u25FC"], "\uE21A", "\uDBBA\uDF72", ["black_medium_square"], 0, 28],
    "25fd": [["\u25FD\uFE0F", "\u25FD"], "\uE21B", "\uDBBA\uDF6F", ["white_medium_small_square"], 0, 29],
    "25fe": [["\u25FE\uFE0F", "\u25FE"], "\uE21A", "\uDBBA\uDF70", ["black_medium_small_square"], 1, 0],
    "2600": [["\u2600\uFE0F", "\u2600"], "\uE04A", "\uDBB8\uDC00", ["sunny"], 1, 1],
    "2601": [["\u2601\uFE0F", "\u2601"], "\uE049", "\uDBB8\uDC01", ["cloud"], 1, 2],
    "260e": [["\u260E\uFE0F", "\u260E"], "\uE009", "\uDBB9\uDD23", ["phone", "telephone"], 1, 3],
    "2611": [["\u2611\uFE0F", "\u2611"], "", "\uDBBA\uDF8B", ["ballot_box_with_check"], 1, 4],
    "2614": [["\u2614\uFE0F", "\u2614"], "\uE04B", "\uDBB8\uDC02", ["umbrella"], 1, 5],
    "2615": [["\u2615\uFE0F", "\u2615"], "\uE045", "\uDBBA\uDD81", ["coffee"], 1, 6],
    "261d": [["\u261D\uFE0F", "\u261D"], "\uE00F", "\uDBBA\uDF98", ["point_up"], 1, 7],
    "263a": [["\u263A\uFE0F", "\u263A"], "\uE414", "\uDBB8\uDF36", ["relaxed"], 1, 8],
    "2648": [["\u2648\uFE0F", "\u2648"], "\uE23F", "\uDBB8\uDC2B", ["aries"], 1, 9],
    "2649": [["\u2649\uFE0F", "\u2649"], "\uE240", "\uDBB8\uDC2C", ["taurus"], 1, 10],
    "264a": [["\u264A\uFE0F", "\u264A"], "\uE241", "\uDBB8\uDC2D", ["gemini"], 1, 11],
    "264b": [["\u264B\uFE0F", "\u264B"], "\uE242", "\uDBB8\uDC2E", ["cancer"], 1, 12],
    "264c": [["\u264C\uFE0F", "\u264C"], "\uE243", "\uDBB8\uDC2F", ["leo"], 1, 13],
    "264d": [["\u264D\uFE0F", "\u264D"], "\uE244", "\uDBB8\uDC30", ["virgo"], 1, 14],
    "264e": [["\u264E\uFE0F", "\u264E"], "\uE245", "\uDBB8\uDC31", ["libra"], 1, 15],
    "264f": [["\u264F\uFE0F", "\u264F"], "\uE246", "\uDBB8\uDC32", ["scorpius"], 1, 16],
    "2650": [["\u2650\uFE0F", "\u2650"], "\uE247", "\uDBB8\uDC33", ["sagittarius"], 1, 17],
    "2651": [["\u2651\uFE0F", "\u2651"], "\uE248", "\uDBB8\uDC34", ["capricorn"], 1, 18],
    "2652": [["\u2652\uFE0F", "\u2652"], "\uE249", "\uDBB8\uDC35", ["aquarius"], 1, 19],
    "2653": [["\u2653\uFE0F", "\u2653"], "\uE24A", "\uDBB8\uDC36", ["pisces"], 1, 20],
    "2660": [["\u2660\uFE0F", "\u2660"], "\uE20E", "\uDBBA\uDF1B", ["spades"], 1, 21],
    "2663": [["\u2663\uFE0F", "\u2663"], "\uE20F", "\uDBBA\uDF1D", ["clubs"], 1, 22],
    "2665": [["\u2665\uFE0F", "\u2665"], "\uE20C", "\uDBBA\uDF1A", ["hearts"], 1, 23],
    "2666": [["\u2666\uFE0F", "\u2666"], "\uE20D", "\uDBBA\uDF1C", ["diamonds"], 1, 24],
    "2668": [["\u2668\uFE0F", "\u2668"], "\uE123", "\uDBB9\uDFFA", ["hotsprings"], 1, 25],
    "267b": [["\u267B\uFE0F", "\u267B"], "", "\uDBBA\uDF2C", ["recycle"], 1, 26],
    "267f": [["\u267F\uFE0F", "\u267F"], "\uE20A", "\uDBBA\uDF20", ["wheelchair"], 1, 27],
    "2693": [["\u2693\uFE0F", "\u2693"], "\uE202", "\uDBB9\uDCC1", ["anchor"], 1, 28],
    "26a0": [["\u26A0\uFE0F", "\u26A0"], "\uE252", "\uDBBA\uDF23", ["warning"], 1, 29],
    "26a1": [["\u26A1\uFE0F", "\u26A1"], "\uE13D", "\uDBB8\uDC04", ["zap"], 2, 0],
    "26aa": [["\u26AA\uFE0F", "\u26AA"], "\uE219", "\uDBBA\uDF65", ["white_circle"], 2, 1],
    "26ab": [["\u26AB\uFE0F", "\u26AB"], "\uE219", "\uDBBA\uDF66", ["black_circle"], 2, 2],
    "26bd": [["\u26BD\uFE0F", "\u26BD"], "\uE018", "\uDBB9\uDFD4", ["soccer"], 2, 3],
    "26be": [["\u26BE\uFE0F", "\u26BE"], "\uE016", "\uDBB9\uDFD1", ["baseball"], 2, 4],
    "26c4": [["\u26C4\uFE0F", "\u26C4"], "\uE048", "\uDBB8\uDC03", ["snowman"], 2, 5],
    "26c5": [["\u26C5\uFE0F", "\u26C5"], "\uE04A\uE049", "\uDBB8\uDC0F", ["partly_sunny"], 2, 6],
    "26ce": [["\u26CE"], "\uE24B", "\uDBB8\uDC37", ["ophiuchus"], 2, 7],
    "26d4": [["\u26D4\uFE0F", "\u26D4"], "\uE137", "\uDBBA\uDF26", ["no_entry"], 2, 8],
    "26ea": [["\u26EA\uFE0F", "\u26EA"], "\uE037", "\uDBB9\uDCBB", ["church"], 2, 9],
    "26f2": [["\u26F2\uFE0F", "\u26F2"], "\uE121", "\uDBB9\uDCBC", ["fountain"], 2, 10],
    "26f3": [["\u26F3\uFE0F", "\u26F3"], "\uE014", "\uDBB9\uDFD2", ["golf"], 2, 11],
    "26f5": [["\u26F5\uFE0F", "\u26F5"], "\uE01C", "\uDBB9\uDFEA", ["boat", "sailboat"], 2, 12],
    "26fa": [["\u26FA\uFE0F", "\u26FA"], "\uE122", "\uDBB9\uDFFB", ["tent"], 2, 13],
    "26fd": [["\u26FD\uFE0F", "\u26FD"], "\uE03A", "\uDBB9\uDFF5", ["fuelpump"], 2, 14],
    "2702": [["\u2702\uFE0F", "\u2702"], "\uE313", "\uDBB9\uDD3E", ["scissors"], 2, 15],
    "2705": [["\u2705"], "", "\uDBBA\uDF4A", ["white_check_mark"], 2, 16],
    "2708": [["\u2708\uFE0F", "\u2708"], "\uE01D", "\uDBB9\uDFE9", ["airplane"], 2, 17],
    "2709": [["\u2709\uFE0F", "\u2709"], "\uE103", "\uDBB9\uDD29", ["email", "envelope"], 2, 18],
    "270a": [["\u270A"], "\uE010", "\uDBBA\uDF93", ["fist"], 2, 19],
    "270b": [["\u270B"], "\uE012", "\uDBBA\uDF95", ["hand", "raised_hand"], 2, 20],
    "270c": [["\u270C\uFE0F", "\u270C"], "\uE011", "\uDBBA\uDF94", ["v"], 2, 21],
    "270f": [["\u270F\uFE0F", "\u270F"], "\uE301", "\uDBB9\uDD39", ["pencil2"], 2, 22],
    "2712": [["\u2712\uFE0F", "\u2712"], "", "\uDBB9\uDD36", ["black_nib"], 2, 23],
    "2714": [["\u2714\uFE0F", "\u2714"], "", "\uDBBA\uDF49", ["heavy_check_mark"], 2, 24],
    "2716": [["\u2716\uFE0F", "\u2716"], "\uE333", "\uDBBA\uDF53", ["heavy_multiplication_x"], 2, 25],
    "2728": [["\u2728"], "\uE32E", "\uDBBA\uDF60", ["sparkles"], 2, 26],
    "2733": [["\u2733\uFE0F", "\u2733"], "\uE206", "\uDBBA\uDF62", ["eight_spoked_asterisk"], 2, 27],
    "2734": [["\u2734\uFE0F", "\u2734"], "\uE205", "\uDBBA\uDF61", ["eight_pointed_black_star"], 2, 28],
    "2744": [["\u2744\uFE0F", "\u2744"], "", "\uDBB8\uDC0E", ["snowflake"], 2, 29],
    "2747": [["\u2747\uFE0F", "\u2747"], "\uE32E", "\uDBBA\uDF77", ["sparkle"], 3, 0],
    "274c": [["\u274C"], "\uE333", "\uDBBA\uDF45", ["x"], 3, 1],
    "274e": [["\u274E"], "\uE333", "\uDBBA\uDF46", ["negative_squared_cross_mark"], 3, 2],
    "2753": [["\u2753"], "\uE020", "\uDBBA\uDF09", ["question"], 3, 3],
    "2754": [["\u2754"], "\uE336", "\uDBBA\uDF0A", ["grey_question"], 3, 4],
    "2755": [["\u2755"], "\uE337", "\uDBBA\uDF0B", ["grey_exclamation"], 3, 5],
    "2757": [["\u2757\uFE0F", "\u2757"], "\uE021", "\uDBBA\uDF04", ["exclamation", "heavy_exclamation_mark"], 3, 6],
    "2764": [["\u2764\uFE0F", "\u2764"], "\uE022", "\uDBBA\uDF0C", ["heart"], 3, 7, "<3"],
    "2795": [["\u2795"], "", "\uDBBA\uDF51", ["heavy_plus_sign"], 3, 8],
    "2796": [["\u2796"], "", "\uDBBA\uDF52", ["heavy_minus_sign"], 3, 9],
    "2797": [["\u2797"], "", "\uDBBA\uDF54", ["heavy_division_sign"], 3, 10],
    "27a1": [["\u27A1\uFE0F", "\u27A1"], "\uE234", "\uDBBA\uDEFA", ["arrow_right"], 3, 11],
    "27b0": [["\u27B0"], "", "\uDBBA\uDF08", ["curly_loop"], 3, 12],
    "27bf": [["\u27BF"], "\uE211", "\uDBBA\uDC2B", ["loop"], 3, 13],
    "2934": [["\u2934\uFE0F", "\u2934"], "\uE236", "\uDBBA\uDEF4", ["arrow_heading_up"], 3, 14],
    "2935": [["\u2935\uFE0F", "\u2935"], "\uE238", "\uDBBA\uDEF5", ["arrow_heading_down"], 3, 15],
    "2b05": [["\u2B05\uFE0F", "\u2B05"], "\uE235", "\uDBBA\uDEFB", ["arrow_left"], 3, 16],
    "2b06": [["\u2B06\uFE0F", "\u2B06"], "\uE232", "\uDBBA\uDEF8", ["arrow_up"], 3, 17],
    "2b07": [["\u2B07\uFE0F", "\u2B07"], "\uE233", "\uDBBA\uDEF9", ["arrow_down"], 3, 18],
    "2b1b": [["\u2B1B\uFE0F", "\u2B1B"], "\uE21A", "\uDBBA\uDF6C", ["black_large_square"], 3, 19],
    "2b1c": [["\u2B1C\uFE0F", "\u2B1C"], "\uE21B", "\uDBBA\uDF6B", ["white_large_square"], 3, 20],
    "2b50": [["\u2B50\uFE0F", "\u2B50"], "\uE32F", "\uDBBA\uDF68", ["star"], 3, 21],
    "2b55": [["\u2B55\uFE0F", "\u2B55"], "\uE332", "\uDBBA\uDF44", ["o"], 3, 22],
    "3030": [["\u3030"], "", "\uDBBA\uDF07", ["wavy_dash"], 3, 23],
    "303d": [["\u303D\uFE0F", "\u303D"], "\uE12C", "\uDBBA\uDC1B", ["part_alternation_mark"], 3, 24],
    "3297": [["\u3297\uFE0F", "\u3297"], "\uE30D", "\uDBBA\uDF43", ["congratulations"], 3, 25],
    "3299": [["\u3299\uFE0F", "\u3299"], "\uE315", "\uDBBA\uDF2B", ["secret"], 3, 26],
    "1f004": [["\uD83C\uDC04\uFE0F", "\uD83C\uDC04"], "\uE12D", "\uDBBA\uDC0B", ["mahjong"], 3, 27],
    "1f0cf": [["\uD83C\uDCCF"], "", "\uDBBA\uDC12", ["black_joker"], 3, 28],
    "1f170": [["\uD83C\uDD70"], "\uE532", "\uDBB9\uDD0B", ["a"], 3, 29],
    "1f171": [["\uD83C\uDD71"], "\uE533", "\uDBB9\uDD0C", ["b"], 4, 0],
    "1f17e": [["\uD83C\uDD7E"], "\uE535", "\uDBB9\uDD0E", ["o2"], 4, 1],
    "1f17f": [["\uD83C\uDD7F\uFE0F", "\uD83C\uDD7F"], "\uE14F", "\uDBB9\uDFF6", ["parking"], 4, 2],
    "1f18e": [["\uD83C\uDD8E"], "\uE534", "\uDBB9\uDD0D", ["ab"], 4, 3],
    "1f191": [["\uD83C\uDD91"], "", "\uDBBA\uDF84", ["cl"], 4, 4],
    "1f192": [["\uD83C\uDD92"], "\uE214", "\uDBBA\uDF38", ["cool"], 4, 5],
    "1f193": [["\uD83C\uDD93"], "", "\uDBBA\uDF21", ["free"], 4, 6],
    "1f194": [["\uD83C\uDD94"], "\uE229", "\uDBBA\uDF81", ["id"], 4, 7],
    "1f195": [["\uD83C\uDD95"], "\uE212", "\uDBBA\uDF36", ["new"], 4, 8],
    "1f196": [["\uD83C\uDD96"], "", "\uDBBA\uDF28", ["ng"], 4, 9],
    "1f197": [["\uD83C\uDD97"], "\uE24D", "\uDBBA\uDF27", ["ok"], 4, 10],
    "1f198": [["\uD83C\uDD98"], "", "\uDBBA\uDF4F", ["sos"], 4, 11],
    "1f199": [["\uD83C\uDD99"], "\uE213", "\uDBBA\uDF37", ["up"], 4, 12],
    "1f19a": [["\uD83C\uDD9A"], "\uE12E", "\uDBBA\uDF32", ["vs"], 4, 13],
    "1f201": [["\uD83C\uDE01"], "\uE203", "\uDBBA\uDF24", ["koko"], 4, 14],
    "1f202": [["\uD83C\uDE02"], "\uE228", "\uDBBA\uDF3F", ["sa"], 4, 15],
    "1f21a": [["\uD83C\uDE1A\uFE0F", "\uD83C\uDE1A"], "\uE216", "\uDBBA\uDF3A", ["u7121"], 4, 16],
    "1f22f": [["\uD83C\uDE2F\uFE0F", "\uD83C\uDE2F"], "\uE22C", "\uDBBA\uDF40", ["u6307"], 4, 17],
    "1f232": [["\uD83C\uDE32"], "", "\uDBBA\uDF2E", ["u7981"], 4, 18],
    "1f233": [["\uD83C\uDE33"], "\uE22B", "\uDBBA\uDF2F", ["u7a7a"], 4, 19],
    "1f234": [["\uD83C\uDE34"], "", "\uDBBA\uDF30", ["u5408"], 4, 20],
    "1f235": [["\uD83C\uDE35"], "\uE22A", "\uDBBA\uDF31", ["u6e80"], 4, 21],
    "1f236": [["\uD83C\uDE36"], "\uE215", "\uDBBA\uDF39", ["u6709"], 4, 22],
    "1f237": [["\uD83C\uDE37"], "\uE217", "\uDBBA\uDF3B", ["u6708"], 4, 23],
    "1f238": [["\uD83C\uDE38"], "\uE218", "\uDBBA\uDF3C", ["u7533"], 4, 24],
    "1f239": [["\uD83C\uDE39"], "\uE227", "\uDBBA\uDF3E", ["u5272"], 4, 25],
    "1f23a": [["\uD83C\uDE3A"], "\uE22D", "\uDBBA\uDF41", ["u55b6"], 4, 26],
    "1f250": [["\uD83C\uDE50"], "\uE226", "\uDBBA\uDF3D", ["ideograph_advantage"], 4, 27],
    "1f251": [["\uD83C\uDE51"], "", "\uDBBA\uDF50", ["accept"], 4, 28],
    "1f300": [["\uD83C\uDF00"], "\uE443", "\uDBB8\uDC05", ["cyclone"], 4, 29],
    "1f301": [["\uD83C\uDF01"], "", "\uDBB8\uDC06", ["foggy"], 5, 0],
    "1f302": [["\uD83C\uDF02"], "\uE43C", "\uDBB8\uDC07", ["closed_umbrella"], 5, 1],
    "1f303": [["\uD83C\uDF03"], "\uE44B", "\uDBB8\uDC08", ["night_with_stars"], 5, 2],
    "1f304": [["\uD83C\uDF04"], "\uE04D", "\uDBB8\uDC09", ["sunrise_over_mountains"], 5, 3],
    "1f305": [["\uD83C\uDF05"], "\uE449", "\uDBB8\uDC0A", ["sunrise"], 5, 4],
    "1f306": [["\uD83C\uDF06"], "\uE146", "\uDBB8\uDC0B", ["city_sunset"], 5, 5],
    "1f307": [["\uD83C\uDF07"], "\uE44A", "\uDBB8\uDC0C", ["city_sunrise"], 5, 6],
    "1f308": [["\uD83C\uDF08"], "\uE44C", "\uDBB8\uDC0D", ["rainbow"], 5, 7],
    "1f309": [["\uD83C\uDF09"], "\uE44B", "\uDBB8\uDC10", ["bridge_at_night"], 5, 8],
    "1f30a": [["\uD83C\uDF0A"], "\uE43E", "\uDBB8\uDC38", ["ocean"], 5, 9],
    "1f30b": [["\uD83C\uDF0B"], "", "\uDBB8\uDC3A", ["volcano"], 5, 10],
    "1f30c": [["\uD83C\uDF0C"], "\uE44B", "\uDBB8\uDC3B", ["milky_way"], 5, 11],
    "1f30d": [["\uD83C\uDF0D"], "", "", ["earth_africa"], 5, 12],
    "1f30e": [["\uD83C\uDF0E"], "", "", ["earth_americas"], 5, 13],
    "1f30f": [["\uD83C\uDF0F"], "", "\uDBB8\uDC39", ["earth_asia"], 5, 14],
    "1f310": [["\uD83C\uDF10"], "", "", ["globe_with_meridians"], 5, 15],
    "1f311": [["\uD83C\uDF11"], "", "\uDBB8\uDC11", ["new_moon"], 5, 16],
    "1f312": [["\uD83C\uDF12"], "", "", ["waxing_crescent_moon"], 5, 17],
    "1f313": [["\uD83C\uDF13"], "\uE04C", "\uDBB8\uDC13", ["first_quarter_moon"], 5, 18],
    "1f314": [["\uD83C\uDF14"], "\uE04C", "\uDBB8\uDC12", ["moon", "waxing_gibbous_moon"], 5, 19],
    "1f315": [["\uD83C\uDF15"], "", "\uDBB8\uDC15", ["full_moon"], 5, 20],
    "1f316": [["\uD83C\uDF16"], "", "", ["waning_gibbous_moon"], 5, 21],
    "1f317": [["\uD83C\uDF17"], "", "", ["last_quarter_moon"], 5, 22],
    "1f318": [["\uD83C\uDF18"], "", "", ["waning_crescent_moon"], 5, 23],
    "1f319": [["\uD83C\uDF19"], "\uE04C", "\uDBB8\uDC14", ["crescent_moon"], 5, 24],
    "1f31a": [["\uD83C\uDF1A"], "", "", ["new_moon_with_face"], 5, 25],
    "1f31b": [["\uD83C\uDF1B"], "\uE04C", "\uDBB8\uDC16", ["first_quarter_moon_with_face"], 5, 26],
    "1f31c": [["\uD83C\uDF1C"], "", "", ["last_quarter_moon_with_face"], 5, 27],
    "1f31d": [["\uD83C\uDF1D"], "", "", ["full_moon_with_face"], 5, 28],
    "1f31e": [["\uD83C\uDF1E"], "", "", ["sun_with_face"], 5, 29],
    "1f31f": [["\uD83C\uDF1F"], "\uE335", "\uDBBA\uDF69", ["star2"], 6, 0],
    "1f320": [["\uD83C\uDF20"], "", "\uDBBA\uDF6A", ["stars"], 6, 1],
    "1f330": [["\uD83C\uDF30"], "", "\uDBB8\uDC4C", ["chestnut"], 6, 2],
    "1f331": [["\uD83C\uDF31"], "\uE110", "\uDBB8\uDC3E", ["seedling"], 6, 3],
    "1f332": [["\uD83C\uDF32"], "", "", ["evergreen_tree"], 6, 4],
    "1f333": [["\uD83C\uDF33"], "", "", ["deciduous_tree"], 6, 5],
    "1f334": [["\uD83C\uDF34"], "\uE307", "\uDBB8\uDC47", ["palm_tree"], 6, 6],
    "1f335": [["\uD83C\uDF35"], "\uE308", "\uDBB8\uDC48", ["cactus"], 6, 7],
    "1f337": [["\uD83C\uDF37"], "\uE304", "\uDBB8\uDC3D", ["tulip"], 6, 8],
    "1f338": [["\uD83C\uDF38"], "\uE030", "\uDBB8\uDC40", ["cherry_blossom"], 6, 9],
    "1f339": [["\uD83C\uDF39"], "\uE032", "\uDBB8\uDC41", ["rose"], 6, 10],
    "1f33a": [["\uD83C\uDF3A"], "\uE303", "\uDBB8\uDC45", ["hibiscus"], 6, 11],
    "1f33b": [["\uD83C\uDF3B"], "\uE305", "\uDBB8\uDC46", ["sunflower"], 6, 12],
    "1f33c": [["\uD83C\uDF3C"], "\uE305", "\uDBB8\uDC4D", ["blossom"], 6, 13],
    "1f33d": [["\uD83C\uDF3D"], "", "\uDBB8\uDC4A", ["corn"], 6, 14],
    "1f33e": [["\uD83C\uDF3E"], "\uE444", "\uDBB8\uDC49", ["ear_of_rice"], 6, 15],
    "1f33f": [["\uD83C\uDF3F"], "\uE110", "\uDBB8\uDC4E", ["herb"], 6, 16],
    "1f340": [["\uD83C\uDF40"], "\uE110", "\uDBB8\uDC3C", ["four_leaf_clover"], 6, 17],
    "1f341": [["\uD83C\uDF41"], "\uE118", "\uDBB8\uDC3F", ["maple_leaf"], 6, 18],
    "1f342": [["\uD83C\uDF42"], "\uE119", "\uDBB8\uDC42", ["fallen_leaf"], 6, 19],
    "1f343": [["\uD83C\uDF43"], "\uE447", "\uDBB8\uDC43", ["leaves"], 6, 20],
    "1f344": [["\uD83C\uDF44"], "", "\uDBB8\uDC4B", ["mushroom"], 6, 21],
    "1f345": [["\uD83C\uDF45"], "\uE349", "\uDBB8\uDC55", ["tomato"], 6, 22],
    "1f346": [["\uD83C\uDF46"], "\uE34A", "\uDBB8\uDC56", ["eggplant"], 6, 23],
    "1f347": [["\uD83C\uDF47"], "", "\uDBB8\uDC59", ["grapes"], 6, 24],
    "1f348": [["\uD83C\uDF48"], "", "\uDBB8\uDC57", ["melon"], 6, 25],
    "1f349": [["\uD83C\uDF49"], "\uE348", "\uDBB8\uDC54", ["watermelon"], 6, 26],
    "1f34a": [["\uD83C\uDF4A"], "\uE346", "\uDBB8\uDC52", ["tangerine"], 6, 27],
    "1f34b": [["\uD83C\uDF4B"], "", "", ["lemon"], 6, 28],
    "1f34c": [["\uD83C\uDF4C"], "", "\uDBB8\uDC50", ["banana"], 6, 29],
    "1f34d": [["\uD83C\uDF4D"], "", "\uDBB8\uDC58", ["pineapple"], 7, 0],
    "1f34e": [["\uD83C\uDF4E"], "\uE345", "\uDBB8\uDC51", ["apple"], 7, 1],
    "1f34f": [["\uD83C\uDF4F"], "\uE345", "\uDBB8\uDC5B", ["green_apple"], 7, 2],
    "1f350": [["\uD83C\uDF50"], "", "", ["pear"], 7, 3],
    "1f351": [["\uD83C\uDF51"], "", "\uDBB8\uDC5A", ["peach"], 7, 4],
    "1f352": [["\uD83C\uDF52"], "", "\uDBB8\uDC4F", ["cherries"], 7, 5],
    "1f353": [["\uD83C\uDF53"], "\uE347", "\uDBB8\uDC53", ["strawberry"], 7, 6],
    "1f354": [["\uD83C\uDF54"], "\uE120", "\uDBBA\uDD60", ["hamburger"], 7, 7],
    "1f355": [["\uD83C\uDF55"], "", "\uDBBA\uDD75", ["pizza"], 7, 8],
    "1f356": [["\uD83C\uDF56"], "", "\uDBBA\uDD72", ["meat_on_bone"], 7, 9],
    "1f357": [["\uD83C\uDF57"], "", "\uDBBA\uDD76", ["poultry_leg"], 7, 10],
    "1f358": [["\uD83C\uDF58"], "\uE33D", "\uDBBA\uDD69", ["rice_cracker"], 7, 11],
    "1f359": [["\uD83C\uDF59"], "\uE342", "\uDBBA\uDD61", ["rice_ball"], 7, 12],
    "1f35a": [["\uD83C\uDF5A"], "\uE33E", "\uDBBA\uDD6A", ["rice"], 7, 13],
    "1f35b": [["\uD83C\uDF5B"], "\uE341", "\uDBBA\uDD6C", ["curry"], 7, 14],
    "1f35c": [["\uD83C\uDF5C"], "\uE340", "\uDBBA\uDD63", ["ramen"], 7, 15],
    "1f35d": [["\uD83C\uDF5D"], "\uE33F", "\uDBBA\uDD6B", ["spaghetti"], 7, 16],
    "1f35e": [["\uD83C\uDF5E"], "\uE339", "\uDBBA\uDD64", ["bread"], 7, 17],
    "1f35f": [["\uD83C\uDF5F"], "\uE33B", "\uDBBA\uDD67", ["fries"], 7, 18],
    "1f360": [["\uD83C\uDF60"], "", "\uDBBA\uDD74", ["sweet_potato"], 7, 19],
    "1f361": [["\uD83C\uDF61"], "\uE33C", "\uDBBA\uDD68", ["dango"], 7, 20],
    "1f362": [["\uD83C\uDF62"], "\uE343", "\uDBBA\uDD6D", ["oden"], 7, 21],
    "1f363": [["\uD83C\uDF63"], "\uE344", "\uDBBA\uDD6E", ["sushi"], 7, 22],
    "1f364": [["\uD83C\uDF64"], "", "\uDBBA\uDD7F", ["fried_shrimp"], 7, 23],
    "1f365": [["\uD83C\uDF65"], "", "\uDBBA\uDD73", ["fish_cake"], 7, 24],
    "1f366": [["\uD83C\uDF66"], "\uE33A", "\uDBBA\uDD66", ["icecream"], 7, 25],
    "1f367": [["\uD83C\uDF67"], "\uE43F", "\uDBBA\uDD71", ["shaved_ice"], 7, 26],
    "1f368": [["\uD83C\uDF68"], "", "\uDBBA\uDD77", ["ice_cream"], 7, 27],
    "1f369": [["\uD83C\uDF69"], "", "\uDBBA\uDD78", ["doughnut"], 7, 28],
    "1f36a": [["\uD83C\uDF6A"], "", "\uDBBA\uDD79", ["cookie"], 7, 29],
    "1f36b": [["\uD83C\uDF6B"], "", "\uDBBA\uDD7A", ["chocolate_bar"], 8, 0],
    "1f36c": [["\uD83C\uDF6C"], "", "\uDBBA\uDD7B", ["candy"], 8, 1],
    "1f36d": [["\uD83C\uDF6D"], "", "\uDBBA\uDD7C", ["lollipop"], 8, 2],
    "1f36e": [["\uD83C\uDF6E"], "", "\uDBBA\uDD7D", ["custard"], 8, 3],
    "1f36f": [["\uD83C\uDF6F"], "", "\uDBBA\uDD7E", ["honey_pot"], 8, 4],
    "1f370": [["\uD83C\uDF70"], "\uE046", "\uDBBA\uDD62", ["cake"], 8, 5],
    "1f371": [["\uD83C\uDF71"], "\uE34C", "\uDBBA\uDD6F", ["bento"], 8, 6],
    "1f372": [["\uD83C\uDF72"], "\uE34D", "\uDBBA\uDD70", ["stew"], 8, 7],
    "1f373": [["\uD83C\uDF73"], "\uE147", "\uDBBA\uDD65", ["egg"], 8, 8],
    "1f374": [["\uD83C\uDF74"], "\uE043", "\uDBBA\uDD80", ["fork_and_knife"], 8, 9],
    "1f375": [["\uD83C\uDF75"], "\uE338", "\uDBBA\uDD84", ["tea"], 8, 10],
    "1f376": [["\uD83C\uDF76"], "\uE30B", "\uDBBA\uDD85", ["sake"], 8, 11],
    "1f377": [["\uD83C\uDF77"], "\uE044", "\uDBBA\uDD86", ["wine_glass"], 8, 12],
    "1f378": [["\uD83C\uDF78"], "\uE044", "\uDBBA\uDD82", ["cocktail"], 8, 13],
    "1f379": [["\uD83C\uDF79"], "\uE044", "\uDBBA\uDD88", ["tropical_drink"], 8, 14],
    "1f37a": [["\uD83C\uDF7A"], "\uE047", "\uDBBA\uDD83", ["beer"], 8, 15],
    "1f37b": [["\uD83C\uDF7B"], "\uE30C", "\uDBBA\uDD87", ["beers"], 8, 16],
    "1f37c": [["\uD83C\uDF7C"], "", "", ["baby_bottle"], 8, 17],
    "1f380": [["\uD83C\uDF80"], "\uE314", "\uDBB9\uDD0F", ["ribbon"], 8, 18],
    "1f381": [["\uD83C\uDF81"], "\uE112", "\uDBB9\uDD10", ["gift"], 8, 19],
    "1f382": [["\uD83C\uDF82"], "\uE34B", "\uDBB9\uDD11", ["birthday"], 8, 20],
    "1f383": [["\uD83C\uDF83"], "\uE445", "\uDBB9\uDD1F", ["jack_o_lantern"], 8, 21],
    "1f384": [["\uD83C\uDF84"], "\uE033", "\uDBB9\uDD12", ["christmas_tree"], 8, 22],
    "1f385": [["\uD83C\uDF85"], "\uE448", "\uDBB9\uDD13", ["santa"], 8, 23],
    "1f386": [["\uD83C\uDF86"], "\uE117", "\uDBB9\uDD15", ["fireworks"], 8, 24],
    "1f387": [["\uD83C\uDF87"], "\uE440", "\uDBB9\uDD1D", ["sparkler"], 8, 25],
    "1f388": [["\uD83C\uDF88"], "\uE310", "\uDBB9\uDD16", ["balloon"], 8, 26],
    "1f389": [["\uD83C\uDF89"], "\uE312", "\uDBB9\uDD17", ["tada"], 8, 27],
    "1f38a": [["\uD83C\uDF8A"], "", "\uDBB9\uDD20", ["confetti_ball"], 8, 28],
    "1f38b": [["\uD83C\uDF8B"], "", "\uDBB9\uDD21", ["tanabata_tree"], 8, 29],
    "1f38c": [["\uD83C\uDF8C"], "\uE143", "\uDBB9\uDD14", ["crossed_flags"], 9, 0],
    "1f38d": [["\uD83C\uDF8D"], "\uE436", "\uDBB9\uDD18", ["bamboo"], 9, 1],
    "1f38e": [["\uD83C\uDF8E"], "\uE438", "\uDBB9\uDD19", ["dolls"], 9, 2],
    "1f38f": [["\uD83C\uDF8F"], "\uE43B", "\uDBB9\uDD1C", ["flags"], 9, 3],
    "1f390": [["\uD83C\uDF90"], "\uE442", "\uDBB9\uDD1E", ["wind_chime"], 9, 4],
    "1f391": [["\uD83C\uDF91"], "\uE446", "\uDBB8\uDC17", ["rice_scene"], 9, 5],
    "1f392": [["\uD83C\uDF92"], "\uE43A", "\uDBB9\uDD1B", ["school_satchel"], 9, 6],
    "1f393": [["\uD83C\uDF93"], "\uE439", "\uDBB9\uDD1A", ["mortar_board"], 9, 7],
    "1f3a0": [["\uD83C\uDFA0"], "", "\uDBB9\uDFFC", ["carousel_horse"], 9, 8],
    "1f3a1": [["\uD83C\uDFA1"], "\uE124", "\uDBB9\uDFFD", ["ferris_wheel"], 9, 9],
    "1f3a2": [["\uD83C\uDFA2"], "\uE433", "\uDBB9\uDFFE", ["roller_coaster"], 9, 10],
    "1f3a3": [["\uD83C\uDFA3"], "\uE019", "\uDBB9\uDFFF", ["fishing_pole_and_fish"], 9, 11],
    "1f3a4": [["\uD83C\uDFA4"], "\uE03C", "\uDBBA\uDC00", ["microphone"], 9, 12],
    "1f3a5": [["\uD83C\uDFA5"], "\uE03D", "\uDBBA\uDC01", ["movie_camera"], 9, 13],
    "1f3a6": [["\uD83C\uDFA6"], "\uE507", "\uDBBA\uDC02", ["cinema"], 9, 14],
    "1f3a7": [["\uD83C\uDFA7"], "\uE30A", "\uDBBA\uDC03", ["headphones"], 9, 15],
    "1f3a8": [["\uD83C\uDFA8"], "\uE502", "\uDBBA\uDC04", ["art"], 9, 16],
    "1f3a9": [["\uD83C\uDFA9"], "\uE503", "\uDBBA\uDC05", ["tophat"], 9, 17],
    "1f3aa": [["\uD83C\uDFAA"], "", "\uDBBA\uDC06", ["circus_tent"], 9, 18],
    "1f3ab": [["\uD83C\uDFAB"], "\uE125", "\uDBBA\uDC07", ["ticket"], 9, 19],
    "1f3ac": [["\uD83C\uDFAC"], "\uE324", "\uDBBA\uDC08", ["clapper"], 9, 20],
    "1f3ad": [["\uD83C\uDFAD"], "\uE503", "\uDBBA\uDC09", ["performing_arts"], 9, 21],
    "1f3ae": [["\uD83C\uDFAE"], "", "\uDBBA\uDC0A", ["video_game"], 9, 22],
    "1f3af": [["\uD83C\uDFAF"], "\uE130", "\uDBBA\uDC0C", ["dart"], 9, 23],
    "1f3b0": [["\uD83C\uDFB0"], "\uE133", "\uDBBA\uDC0D", ["slot_machine"], 9, 24],
    "1f3b1": [["\uD83C\uDFB1"], "\uE42C", "\uDBBA\uDC0E", ["8ball"], 9, 25],
    "1f3b2": [["\uD83C\uDFB2"], "", "\uDBBA\uDC0F", ["game_die"], 9, 26],
    "1f3b3": [["\uD83C\uDFB3"], "", "\uDBBA\uDC10", ["bowling"], 9, 27],
    "1f3b4": [["\uD83C\uDFB4"], "", "\uDBBA\uDC11", ["flower_playing_cards"], 9, 28],
    "1f3b5": [["\uD83C\uDFB5"], "\uE03E", "\uDBBA\uDC13", ["musical_note"], 9, 29],
    "1f3b6": [["\uD83C\uDFB6"], "\uE326", "\uDBBA\uDC14", ["notes"], 10, 0],
    "1f3b7": [["\uD83C\uDFB7"], "\uE040", "\uDBBA\uDC15", ["saxophone"], 10, 1],
    "1f3b8": [["\uD83C\uDFB8"], "\uE041", "\uDBBA\uDC16", ["guitar"], 10, 2],
    "1f3b9": [["\uD83C\uDFB9"], "", "\uDBBA\uDC17", ["musical_keyboard"], 10, 3],
    "1f3ba": [["\uD83C\uDFBA"], "\uE042", "\uDBBA\uDC18", ["trumpet"], 10, 4],
    "1f3bb": [["\uD83C\uDFBB"], "", "\uDBBA\uDC19", ["violin"], 10, 5],
    "1f3bc": [["\uD83C\uDFBC"], "\uE326", "\uDBBA\uDC1A", ["musical_score"], 10, 6],
    "1f3bd": [["\uD83C\uDFBD"], "", "\uDBB9\uDFD0", ["running_shirt_with_sash"], 10, 7],
    "1f3be": [["\uD83C\uDFBE"], "\uE015", "\uDBB9\uDFD3", ["tennis"], 10, 8],
    "1f3bf": [["\uD83C\uDFBF"], "\uE013", "\uDBB9\uDFD5", ["ski"], 10, 9],
    "1f3c0": [["\uD83C\uDFC0"], "\uE42A", "\uDBB9\uDFD6", ["basketball"], 10, 10],
    "1f3c1": [["\uD83C\uDFC1"], "\uE132", "\uDBB9\uDFD7", ["checkered_flag"], 10, 11],
    "1f3c2": [["\uD83C\uDFC2"], "", "\uDBB9\uDFD8", ["snowboarder"], 10, 12],
    "1f3c3": [["\uD83C\uDFC3"], "\uE115", "\uDBB9\uDFD9", ["runner", "running"], 10, 13],
    "1f3c4": [["\uD83C\uDFC4"], "\uE017", "\uDBB9\uDFDA", ["surfer"], 10, 14],
    "1f3c6": [["\uD83C\uDFC6"], "\uE131", "\uDBB9\uDFDB", ["trophy"], 10, 15],
    "1f3c7": [["\uD83C\uDFC7"], "", "", ["horse_racing"], 10, 16],
    "1f3c8": [["\uD83C\uDFC8"], "\uE42B", "\uDBB9\uDFDD", ["football"], 10, 17],
    "1f3c9": [["\uD83C\uDFC9"], "", "", ["rugby_football"], 10, 18],
    "1f3ca": [["\uD83C\uDFCA"], "\uE42D", "\uDBB9\uDFDE", ["swimmer"], 10, 19],
    "1f3e0": [["\uD83C\uDFE0"], "\uE036", "\uDBB9\uDCB0", ["house"], 10, 20],
    "1f3e1": [["\uD83C\uDFE1"], "\uE036", "\uDBB9\uDCB1", ["house_with_garden"], 10, 21],
    "1f3e2": [["\uD83C\uDFE2"], "\uE038", "\uDBB9\uDCB2", ["office"], 10, 22],
    "1f3e3": [["\uD83C\uDFE3"], "\uE153", "\uDBB9\uDCB3", ["post_office"], 10, 23],
    "1f3e4": [["\uD83C\uDFE4"], "", "", ["european_post_office"], 10, 24],
    "1f3e5": [["\uD83C\uDFE5"], "\uE155", "\uDBB9\uDCB4", ["hospital"], 10, 25],
    "1f3e6": [["\uD83C\uDFE6"], "\uE14D", "\uDBB9\uDCB5", ["bank"], 10, 26],
    "1f3e7": [["\uD83C\uDFE7"], "\uE154", "\uDBB9\uDCB6", ["atm"], 10, 27],
    "1f3e8": [["\uD83C\uDFE8"], "\uE158", "\uDBB9\uDCB7", ["hotel"], 10, 28],
    "1f3e9": [["\uD83C\uDFE9"], "\uE501", "\uDBB9\uDCB8", ["love_hotel"], 10, 29],
    "1f3ea": [["\uD83C\uDFEA"], "\uE156", "\uDBB9\uDCB9", ["convenience_store"], 11, 0],
    "1f3eb": [["\uD83C\uDFEB"], "\uE157", "\uDBB9\uDCBA", ["school"], 11, 1],
    "1f3ec": [["\uD83C\uDFEC"], "\uE504", "\uDBB9\uDCBD", ["department_store"], 11, 2],
    "1f3ed": [["\uD83C\uDFED"], "\uE508", "\uDBB9\uDCC0", ["factory"], 11, 3],
    "1f3ee": [["\uD83C\uDFEE"], "\uE30B", "\uDBB9\uDCC2", ["izakaya_lantern", "lantern"], 11, 4],
    "1f3ef": [["\uD83C\uDFEF"], "\uE505", "\uDBB9\uDCBE", ["japanese_castle"], 11, 5],
    "1f3f0": [["\uD83C\uDFF0"], "\uE506", "\uDBB9\uDCBF", ["european_castle"], 11, 6],
    "1f400": [["\uD83D\uDC00"], "", "", ["rat"], 11, 7],
    "1f401": [["\uD83D\uDC01"], "", "", ["mouse2"], 11, 8],
    "1f402": [["\uD83D\uDC02"], "", "", ["ox"], 11, 9],
    "1f403": [["\uD83D\uDC03"], "", "", ["water_buffalo"], 11, 10],
    "1f404": [["\uD83D\uDC04"], "", "", ["cow2"], 11, 11],
    "1f405": [["\uD83D\uDC05"], "", "", ["tiger2"], 11, 12],
    "1f406": [["\uD83D\uDC06"], "", "", ["leopard"], 11, 13],
    "1f407": [["\uD83D\uDC07"], "", "", ["rabbit2"], 11, 14],
    "1f408": [["\uD83D\uDC08"], "", "", ["cat2"], 11, 15],
    "1f409": [["\uD83D\uDC09"], "", "", ["dragon"], 11, 16],
    "1f40a": [["\uD83D\uDC0A"], "", "", ["crocodile"], 11, 17],
    "1f40b": [["\uD83D\uDC0B"], "", "", ["whale2"], 11, 18],
    "1f40c": [["\uD83D\uDC0C"], "", "\uDBB8\uDDB9", ["snail"], 11, 19],
    "1f40d": [["\uD83D\uDC0D"], "\uE52D", "\uDBB8\uDDD3", ["snake"], 11, 20],
    "1f40e": [["\uD83D\uDC0E"], "\uE134", "\uDBB9\uDFDC", ["racehorse"], 11, 21],
    "1f40f": [["\uD83D\uDC0F"], "", "", ["ram"], 11, 22],
    "1f410": [["\uD83D\uDC10"], "", "", ["goat"], 11, 23],
    "1f411": [["\uD83D\uDC11"], "\uE529", "\uDBB8\uDDCF", ["sheep"], 11, 24],
    "1f412": [["\uD83D\uDC12"], "\uE528", "\uDBB8\uDDCE", ["monkey"], 11, 25],
    "1f413": [["\uD83D\uDC13"], "", "", ["rooster"], 11, 26],
    "1f414": [["\uD83D\uDC14"], "\uE52E", "\uDBB8\uDDD4", ["chicken"], 11, 27],
    "1f415": [["\uD83D\uDC15"], "", "", ["dog2"], 11, 28],
    "1f416": [["\uD83D\uDC16"], "", "", ["pig2"], 11, 29],
    "1f417": [["\uD83D\uDC17"], "\uE52F", "\uDBB8\uDDD5", ["boar"], 12, 0],
    "1f418": [["\uD83D\uDC18"], "\uE526", "\uDBB8\uDDCC", ["elephant"], 12, 1],
    "1f419": [["\uD83D\uDC19"], "\uE10A", "\uDBB8\uDDC5", ["octopus"], 12, 2],
    "1f41a": [["\uD83D\uDC1A"], "\uE441", "\uDBB8\uDDC6", ["shell"], 12, 3],
    "1f41b": [["\uD83D\uDC1B"], "\uE525", "\uDBB8\uDDCB", ["bug"], 12, 4],
    "1f41c": [["\uD83D\uDC1C"], "", "\uDBB8\uDDDA", ["ant"], 12, 5],
    "1f41d": [["\uD83D\uDC1D"], "", "\uDBB8\uDDE1", ["bee", "honeybee"], 12, 6],
    "1f41e": [["\uD83D\uDC1E"], "", "\uDBB8\uDDE2", ["beetle"], 12, 7],
    "1f41f": [["\uD83D\uDC1F"], "\uE019", "\uDBB8\uDDBD", ["fish"], 12, 8],
    "1f420": [["\uD83D\uDC20"], "\uE522", "\uDBB8\uDDC9", ["tropical_fish"], 12, 9],
    "1f421": [["\uD83D\uDC21"], "\uE019", "\uDBB8\uDDD9", ["blowfish"], 12, 10],
    "1f422": [["\uD83D\uDC22"], "", "\uDBB8\uDDDC", ["turtle"], 12, 11],
    "1f423": [["\uD83D\uDC23"], "\uE523", "\uDBB8\uDDDD", ["hatching_chick"], 12, 12],
    "1f424": [["\uD83D\uDC24"], "\uE523", "\uDBB8\uDDBA", ["baby_chick"], 12, 13],
    "1f425": [["\uD83D\uDC25"], "\uE523", "\uDBB8\uDDBB", ["hatched_chick"], 12, 14],
    "1f426": [["\uD83D\uDC26"], "\uE521", "\uDBB8\uDDC8", ["bird"], 12, 15],
    "1f427": [["\uD83D\uDC27"], "\uE055", "\uDBB8\uDDBC", ["penguin"], 12, 16],
    "1f428": [["\uD83D\uDC28"], "\uE527", "\uDBB8\uDDCD", ["koala"], 12, 17],
    "1f429": [["\uD83D\uDC29"], "\uE052", "\uDBB8\uDDD8", ["poodle"], 12, 18],
    "1f42a": [["\uD83D\uDC2A"], "", "", ["dromedary_camel"], 12, 19],
    "1f42b": [["\uD83D\uDC2B"], "\uE530", "\uDBB8\uDDD6", ["camel"], 12, 20],
    "1f42c": [["\uD83D\uDC2C"], "\uE520", "\uDBB8\uDDC7", ["dolphin", "flipper"], 12, 21],
    "1f42d": [["\uD83D\uDC2D"], "\uE053", "\uDBB8\uDDC2", ["mouse"], 12, 22],
    "1f42e": [["\uD83D\uDC2E"], "\uE52B", "\uDBB8\uDDD1", ["cow"], 12, 23],
    "1f42f": [["\uD83D\uDC2F"], "\uE050", "\uDBB8\uDDC0", ["tiger"], 12, 24],
    "1f430": [["\uD83D\uDC30"], "\uE52C", "\uDBB8\uDDD2", ["rabbit"], 12, 25],
    "1f431": [["\uD83D\uDC31"], "\uE04F", "\uDBB8\uDDB8", ["cat"], 12, 26],
    "1f432": [["\uD83D\uDC32"], "", "\uDBB8\uDDDE", ["dragon_face"], 12, 27],
    "1f433": [["\uD83D\uDC33"], "\uE054", "\uDBB8\uDDC3", ["whale"], 12, 28],
    "1f434": [["\uD83D\uDC34"], "\uE01A", "\uDBB8\uDDBE", ["horse"], 12, 29],
    "1f435": [["\uD83D\uDC35"], "\uE109", "\uDBB8\uDDC4", ["monkey_face"], 13, 0],
    "1f436": [["\uD83D\uDC36"], "\uE052", "\uDBB8\uDDB7", ["dog"], 13, 1],
    "1f437": [["\uD83D\uDC37"], "\uE10B", "\uDBB8\uDDBF", ["pig"], 13, 2],
    "1f438": [["\uD83D\uDC38"], "\uE531", "\uDBB8\uDDD7", ["frog"], 13, 3],
    "1f439": [["\uD83D\uDC39"], "\uE524", "\uDBB8\uDDCA", ["hamster"], 13, 4],
    "1f43a": [["\uD83D\uDC3A"], "\uE52A", "\uDBB8\uDDD0", ["wolf"], 13, 5],
    "1f43b": [["\uD83D\uDC3B"], "\uE051", "\uDBB8\uDDC1", ["bear"], 13, 6],
    "1f43c": [["\uD83D\uDC3C"], "", "\uDBB8\uDDDF", ["panda_face"], 13, 7],
    "1f43d": [["\uD83D\uDC3D"], "\uE10B", "\uDBB8\uDDE0", ["pig_nose"], 13, 8],
    "1f43e": [["\uD83D\uDC3E"], "\uE536", "\uDBB8\uDDDB", ["feet", "paw_prints"], 13, 9],
    "1f440": [["\uD83D\uDC40"], "\uE419", "\uDBB8\uDD90", ["eyes"], 13, 10],
    "1f442": [["\uD83D\uDC42"], "\uE41B", "\uDBB8\uDD91", ["ear"], 13, 11],
    "1f443": [["\uD83D\uDC43"], "\uE41A", "\uDBB8\uDD92", ["nose"], 13, 12],
    "1f444": [["\uD83D\uDC44"], "\uE41C", "\uDBB8\uDD93", ["lips"], 13, 13],
    "1f445": [["\uD83D\uDC45"], "\uE409", "\uDBB8\uDD94", ["tongue"], 13, 14],
    "1f446": [["\uD83D\uDC46"], "\uE22E", "\uDBBA\uDF99", ["point_up_2"], 13, 15],
    "1f447": [["\uD83D\uDC47"], "\uE22F", "\uDBBA\uDF9A", ["point_down"], 13, 16],
    "1f448": [["\uD83D\uDC48"], "\uE230", "\uDBBA\uDF9B", ["point_left"], 13, 17],
    "1f449": [["\uD83D\uDC49"], "\uE231", "\uDBBA\uDF9C", ["point_right"], 13, 18],
    "1f44a": [["\uD83D\uDC4A"], "\uE00D", "\uDBBA\uDF96", ["facepunch", "punch"], 13, 19],
    "1f44b": [["\uD83D\uDC4B"], "\uE41E", "\uDBBA\uDF9D", ["wave"], 13, 20],
    "1f44c": [["\uD83D\uDC4C"], "\uE420", "\uDBBA\uDF9F", ["ok_hand"], 13, 21],
    "1f44d": [["\uD83D\uDC4D"], "\uE00E", "\uDBBA\uDF97", ["+1", "thumbsup"], 13, 22],
    "1f44e": [["\uD83D\uDC4E"], "\uE421", "\uDBBA\uDFA0", ["-1", "thumbsdown"], 13, 23],
    "1f44f": [["\uD83D\uDC4F"], "\uE41F", "\uDBBA\uDF9E", ["clap"], 13, 24],
    "1f450": [["\uD83D\uDC50"], "\uE422", "\uDBBA\uDFA1", ["open_hands"], 13, 25],
    "1f451": [["\uD83D\uDC51"], "\uE10E", "\uDBB9\uDCD1", ["crown"], 13, 26],
    "1f452": [["\uD83D\uDC52"], "\uE318", "\uDBB9\uDCD4", ["womans_hat"], 13, 27],
    "1f453": [["\uD83D\uDC53"], "", "\uDBB9\uDCCE", ["eyeglasses"], 13, 28],
    "1f454": [["\uD83D\uDC54"], "\uE302", "\uDBB9\uDCD3", ["necktie"], 13, 29],
    "1f455": [["\uD83D\uDC55"], "\uE006", "\uDBB9\uDCCF", ["shirt", "tshirt"], 14, 0],
    "1f456": [["\uD83D\uDC56"], "", "\uDBB9\uDCD0", ["jeans"], 14, 1],
    "1f457": [["\uD83D\uDC57"], "\uE319", "\uDBB9\uDCD5", ["dress"], 14, 2],
    "1f458": [["\uD83D\uDC58"], "\uE321", "\uDBB9\uDCD9", ["kimono"], 14, 3],
    "1f459": [["\uD83D\uDC59"], "\uE322", "\uDBB9\uDCDA", ["bikini"], 14, 4],
    "1f45a": [["\uD83D\uDC5A"], "\uE006", "\uDBB9\uDCDB", ["womans_clothes"], 14, 5],
    "1f45b": [["\uD83D\uDC5B"], "", "\uDBB9\uDCDC", ["purse"], 14, 6],
    "1f45c": [["\uD83D\uDC5C"], "\uE323", "\uDBB9\uDCF0", ["handbag"], 14, 7],
    "1f45d": [["\uD83D\uDC5D"], "", "\uDBB9\uDCF1", ["pouch"], 14, 8],
    "1f45e": [["\uD83D\uDC5E"], "\uE007", "\uDBB9\uDCCC", ["mans_shoe", "shoe"], 14, 9],
    "1f45f": [["\uD83D\uDC5F"], "\uE007", "\uDBB9\uDCCD", ["athletic_shoe"], 14, 10],
    "1f460": [["\uD83D\uDC60"], "\uE13E", "\uDBB9\uDCD6", ["high_heel"], 14, 11],
    "1f461": [["\uD83D\uDC61"], "\uE31A", "\uDBB9\uDCD7", ["sandal"], 14, 12],
    "1f462": [["\uD83D\uDC62"], "\uE31B", "\uDBB9\uDCD8", ["boot"], 14, 13],
    "1f463": [["\uD83D\uDC63"], "\uE536", "\uDBB9\uDD53", ["footprints"], 14, 14],
    "1f464": [["\uD83D\uDC64"], "", "\uDBB8\uDD9A", ["bust_in_silhouette"], 14, 15],
    "1f465": [["\uD83D\uDC65"], "", "", ["busts_in_silhouette"], 14, 16],
    "1f466": [["\uD83D\uDC66"], "\uE001", "\uDBB8\uDD9B", ["boy"], 14, 17],
    "1f467": [["\uD83D\uDC67"], "\uE002", "\uDBB8\uDD9C", ["girl"], 14, 18],
    "1f468": [["\uD83D\uDC68"], "\uE004", "\uDBB8\uDD9D", ["man"], 14, 19],
    "1f469": [["\uD83D\uDC69"], "\uE005", "\uDBB8\uDD9E", ["woman"], 14, 20],
    "1f46a": [["\uD83D\uDC6A"], "", "\uDBB8\uDD9F", ["family"], 14, 21],
    "1f46b": [["\uD83D\uDC6B"], "\uE428", "\uDBB8\uDDA0", ["couple"], 14, 22],
    "1f46c": [["\uD83D\uDC6C"], "", "", ["two_men_holding_hands"], 14, 23],
    "1f46d": [["\uD83D\uDC6D"], "", "", ["two_women_holding_hands"], 14, 24],
    "1f46e": [["\uD83D\uDC6E"], "\uE152", "\uDBB8\uDDA1", ["cop"], 14, 25],
    "1f46f": [["\uD83D\uDC6F"], "\uE429", "\uDBB8\uDDA2", ["dancers"], 14, 26],
    "1f470": [["\uD83D\uDC70"], "", "\uDBB8\uDDA3", ["bride_with_veil"], 14, 27],
    "1f471": [["\uD83D\uDC71"], "\uE515", "\uDBB8\uDDA4", ["person_with_blond_hair"], 14, 28],
    "1f472": [["\uD83D\uDC72"], "\uE516", "\uDBB8\uDDA5", ["man_with_gua_pi_mao"], 14, 29],
    "1f473": [["\uD83D\uDC73"], "\uE517", "\uDBB8\uDDA6", ["man_with_turban"], 15, 0],
    "1f474": [["\uD83D\uDC74"], "\uE518", "\uDBB8\uDDA7", ["older_man"], 15, 1],
    "1f475": [["\uD83D\uDC75"], "\uE519", "\uDBB8\uDDA8", ["older_woman"], 15, 2],
    "1f476": [["\uD83D\uDC76"], "\uE51A", "\uDBB8\uDDA9", ["baby"], 15, 3],
    "1f477": [["\uD83D\uDC77"], "\uE51B", "\uDBB8\uDDAA", ["construction_worker"], 15, 4],
    "1f478": [["\uD83D\uDC78"], "\uE51C", "\uDBB8\uDDAB", ["princess"], 15, 5],
    "1f479": [["\uD83D\uDC79"], "", "\uDBB8\uDDAC", ["japanese_ogre"], 15, 6],
    "1f47a": [["\uD83D\uDC7A"], "", "\uDBB8\uDDAD", ["japanese_goblin"], 15, 7],
    "1f47b": [["\uD83D\uDC7B"], "\uE11B", "\uDBB8\uDDAE", ["ghost"], 15, 8],
    "1f47c": [["\uD83D\uDC7C"], "\uE04E", "\uDBB8\uDDAF", ["angel"], 15, 9],
    "1f47d": [["\uD83D\uDC7D"], "\uE10C", "\uDBB8\uDDB0", ["alien"], 15, 10],
    "1f47e": [["\uD83D\uDC7E"], "\uE12B", "\uDBB8\uDDB1", ["space_invader"], 15, 11],
    "1f47f": [["\uD83D\uDC7F"], "\uE11A", "\uDBB8\uDDB2", ["imp"], 15, 12],
    "1f480": [["\uD83D\uDC80"], "\uE11C", "\uDBB8\uDDB3", ["skull"], 15, 13],
    "1f481": [["\uD83D\uDC81"], "\uE253", "\uDBB8\uDDB4", ["information_desk_person"], 15, 14],
    "1f482": [["\uD83D\uDC82"], "\uE51E", "\uDBB8\uDDB5", ["guardsman"], 15, 15],
    "1f483": [["\uD83D\uDC83"], "\uE51F", "\uDBB8\uDDB6", ["dancer"], 15, 16],
    "1f484": [["\uD83D\uDC84"], "\uE31C", "\uDBB8\uDD95", ["lipstick"], 15, 17],
    "1f485": [["\uD83D\uDC85"], "\uE31D", "\uDBB8\uDD96", ["nail_care"], 15, 18],
    "1f486": [["\uD83D\uDC86"], "\uE31E", "\uDBB8\uDD97", ["massage"], 15, 19],
    "1f487": [["\uD83D\uDC87"], "\uE31F", "\uDBB8\uDD98", ["haircut"], 15, 20],
    "1f488": [["\uD83D\uDC88"], "\uE320", "\uDBB8\uDD99", ["barber"], 15, 21],
    "1f489": [["\uD83D\uDC89"], "\uE13B", "\uDBB9\uDD09", ["syringe"], 15, 22],
    "1f48a": [["\uD83D\uDC8A"], "\uE30F", "\uDBB9\uDD0A", ["pill"], 15, 23],
    "1f48b": [["\uD83D\uDC8B"], "\uE003", "\uDBBA\uDC23", ["kiss"], 15, 24],
    "1f48c": [["\uD83D\uDC8C"], "\uE103\uE328", "\uDBBA\uDC24", ["love_letter"], 15, 25],
    "1f48d": [["\uD83D\uDC8D"], "\uE034", "\uDBBA\uDC25", ["ring"], 15, 26],
    "1f48e": [["\uD83D\uDC8E"], "\uE035", "\uDBBA\uDC26", ["gem"], 15, 27],
    "1f48f": [["\uD83D\uDC8F"], "\uE111", "\uDBBA\uDC27", ["couplekiss"], 15, 28],
    "1f490": [["\uD83D\uDC90"], "\uE306", "\uDBBA\uDC28", ["bouquet"], 15, 29],
    "1f491": [["\uD83D\uDC91"], "\uE425", "\uDBBA\uDC29", ["couple_with_heart"], 16, 0],
    "1f492": [["\uD83D\uDC92"], "\uE43D", "\uDBBA\uDC2A", ["wedding"], 16, 1],
    "1f493": [["\uD83D\uDC93"], "\uE327", "\uDBBA\uDF0D", ["heartbeat"], 16, 2],
    "1f494": [["\uD83D\uDC94"], "\uE023", "\uDBBA\uDF0E", ["broken_heart"], 16, 3, "<\/3"],
    "1f495": [["\uD83D\uDC95"], "\uE327", "\uDBBA\uDF0F", ["two_hearts"], 16, 4],
    "1f496": [["\uD83D\uDC96"], "\uE327", "\uDBBA\uDF10", ["sparkling_heart"], 16, 5],
    "1f497": [["\uD83D\uDC97"], "\uE328", "\uDBBA\uDF11", ["heartpulse"], 16, 6],
    "1f498": [["\uD83D\uDC98"], "\uE329", "\uDBBA\uDF12", ["cupid"], 16, 7],
    "1f499": [["\uD83D\uDC99"], "\uE32A", "\uDBBA\uDF13", ["blue_heart"], 16, 8, "<3"],
    "1f49a": [["\uD83D\uDC9A"], "\uE32B", "\uDBBA\uDF14", ["green_heart"], 16, 9, "<3"],
    "1f49b": [["\uD83D\uDC9B"], "\uE32C", "\uDBBA\uDF15", ["yellow_heart"], 16, 10, "<3"],
    "1f49c": [["\uD83D\uDC9C"], "\uE32D", "\uDBBA\uDF16", ["purple_heart"], 16, 11, "<3"],
    "1f49d": [["\uD83D\uDC9D"], "\uE437", "\uDBBA\uDF17", ["gift_heart"], 16, 12],
    "1f49e": [["\uD83D\uDC9E"], "\uE327", "\uDBBA\uDF18", ["revolving_hearts"], 16, 13],
    "1f49f": [["\uD83D\uDC9F"], "\uE204", "\uDBBA\uDF19", ["heart_decoration"], 16, 14],
    "1f4a0": [["\uD83D\uDCA0"], "", "\uDBBA\uDF55", ["diamond_shape_with_a_dot_inside"], 16, 15],
    "1f4a1": [["\uD83D\uDCA1"], "\uE10F", "\uDBBA\uDF56", ["bulb"], 16, 16],
    "1f4a2": [["\uD83D\uDCA2"], "\uE334", "\uDBBA\uDF57", ["anger"], 16, 17],
    "1f4a3": [["\uD83D\uDCA3"], "\uE311", "\uDBBA\uDF58", ["bomb"], 16, 18],
    "1f4a4": [["\uD83D\uDCA4"], "\uE13C", "\uDBBA\uDF59", ["zzz"], 16, 19],
    "1f4a5": [["\uD83D\uDCA5"], "", "\uDBBA\uDF5A", ["boom", "collision"], 16, 20],
    "1f4a6": [["\uD83D\uDCA6"], "\uE331", "\uDBBA\uDF5B", ["sweat_drops"], 16, 21],
    "1f4a7": [["\uD83D\uDCA7"], "\uE331", "\uDBBA\uDF5C", ["droplet"], 16, 22],
    "1f4a8": [["\uD83D\uDCA8"], "\uE330", "\uDBBA\uDF5D", ["dash"], 16, 23],
    "1f4a9": [["\uD83D\uDCA9"], "\uE05A", "\uDBB9\uDCF4", ["hankey", "poop", "shit"], 16, 24],
    "1f4aa": [["\uD83D\uDCAA"], "\uE14C", "\uDBBA\uDF5E", ["muscle"], 16, 25],
    "1f4ab": [["\uD83D\uDCAB"], "\uE407", "\uDBBA\uDF5F", ["dizzy"], 16, 26],
    "1f4ac": [["\uD83D\uDCAC"], "", "\uDBB9\uDD32", ["speech_balloon"], 16, 27],
    "1f4ad": [["\uD83D\uDCAD"], "", "", ["thought_balloon"], 16, 28],
    "1f4ae": [["\uD83D\uDCAE"], "", "\uDBBA\uDF7A", ["white_flower"], 16, 29],
    "1f4af": [["\uD83D\uDCAF"], "", "\uDBBA\uDF7B", ["100"], 17, 0],
    "1f4b0": [["\uD83D\uDCB0"], "\uE12F", "\uDBB9\uDCDD", ["moneybag"], 17, 1],
    "1f4b1": [["\uD83D\uDCB1"], "\uE149", "\uDBB9\uDCDE", ["currency_exchange"], 17, 2],
    "1f4b2": [["\uD83D\uDCB2"], "\uE12F", "\uDBB9\uDCE0", ["heavy_dollar_sign"], 17, 3],
    "1f4b3": [["\uD83D\uDCB3"], "", "\uDBB9\uDCE1", ["credit_card"], 17, 4],
    "1f4b4": [["\uD83D\uDCB4"], "", "\uDBB9\uDCE2", ["yen"], 17, 5],
    "1f4b5": [["\uD83D\uDCB5"], "\uE12F", "\uDBB9\uDCE3", ["dollar"], 17, 6],
    "1f4b6": [["\uD83D\uDCB6"], "", "", ["euro"], 17, 7],
    "1f4b7": [["\uD83D\uDCB7"], "", "", ["pound"], 17, 8],
    "1f4b8": [["\uD83D\uDCB8"], "", "\uDBB9\uDCE4", ["money_with_wings"], 17, 9],
    "1f4b9": [["\uD83D\uDCB9"], "\uE14A", "\uDBB9\uDCDF", ["chart"], 17, 10],
    "1f4ba": [["\uD83D\uDCBA"], "\uE11F", "\uDBB9\uDD37", ["seat"], 17, 11],
    "1f4bb": [["\uD83D\uDCBB"], "\uE00C", "\uDBB9\uDD38", ["computer"], 17, 12],
    "1f4bc": [["\uD83D\uDCBC"], "\uE11E", "\uDBB9\uDD3B", ["briefcase"], 17, 13],
    "1f4bd": [["\uD83D\uDCBD"], "\uE316", "\uDBB9\uDD3C", ["minidisc"], 17, 14],
    "1f4be": [["\uD83D\uDCBE"], "\uE316", "\uDBB9\uDD3D", ["floppy_disk"], 17, 15],
    "1f4bf": [["\uD83D\uDCBF"], "\uE126", "\uDBBA\uDC1D", ["cd"], 17, 16],
    "1f4c0": [["\uD83D\uDCC0"], "\uE127", "\uDBBA\uDC1E", ["dvd"], 17, 17],
    "1f4c1": [["\uD83D\uDCC1"], "", "\uDBB9\uDD43", ["file_folder"], 17, 18],
    "1f4c2": [["\uD83D\uDCC2"], "", "\uDBB9\uDD44", ["open_file_folder"], 17, 19],
    "1f4c3": [["\uD83D\uDCC3"], "\uE301", "\uDBB9\uDD40", ["page_with_curl"], 17, 20],
    "1f4c4": [["\uD83D\uDCC4"], "\uE301", "\uDBB9\uDD41", ["page_facing_up"], 17, 21],
    "1f4c5": [["\uD83D\uDCC5"], "", "\uDBB9\uDD42", ["date"], 17, 22],
    "1f4c6": [["\uD83D\uDCC6"], "", "\uDBB9\uDD49", ["calendar"], 17, 23],
    "1f4c7": [["\uD83D\uDCC7"], "\uE148", "\uDBB9\uDD4D", ["card_index"], 17, 24],
    "1f4c8": [["\uD83D\uDCC8"], "\uE14A", "\uDBB9\uDD4B", ["chart_with_upwards_trend"], 17, 25],
    "1f4c9": [["\uD83D\uDCC9"], "", "\uDBB9\uDD4C", ["chart_with_downwards_trend"], 17, 26],
    "1f4ca": [["\uD83D\uDCCA"], "\uE14A", "\uDBB9\uDD4A", ["bar_chart"], 17, 27],
    "1f4cb": [["\uD83D\uDCCB"], "\uE301", "\uDBB9\uDD48", ["clipboard"], 17, 28],
    "1f4cc": [["\uD83D\uDCCC"], "", "\uDBB9\uDD4E", ["pushpin"], 17, 29],
    "1f4cd": [["\uD83D\uDCCD"], "", "\uDBB9\uDD3F", ["round_pushpin"], 18, 0],
    "1f4ce": [["\uD83D\uDCCE"], "", "\uDBB9\uDD3A", ["paperclip"], 18, 1],
    "1f4cf": [["\uD83D\uDCCF"], "", "\uDBB9\uDD50", ["straight_ruler"], 18, 2],
    "1f4d0": [["\uD83D\uDCD0"], "", "\uDBB9\uDD51", ["triangular_ruler"], 18, 3],
    "1f4d1": [["\uD83D\uDCD1"], "\uE301", "\uDBB9\uDD52", ["bookmark_tabs"], 18, 4],
    "1f4d2": [["\uD83D\uDCD2"], "\uE148", "\uDBB9\uDD4F", ["ledger"], 18, 5],
    "1f4d3": [["\uD83D\uDCD3"], "\uE148", "\uDBB9\uDD45", ["notebook"], 18, 6],
    "1f4d4": [["\uD83D\uDCD4"], "\uE148", "\uDBB9\uDD47", ["notebook_with_decorative_cover"], 18, 7],
    "1f4d5": [["\uD83D\uDCD5"], "\uE148", "\uDBB9\uDD02", ["closed_book"], 18, 8],
    "1f4d6": [["\uD83D\uDCD6"], "\uE148", "\uDBB9\uDD46", ["book", "open_book"], 18, 9],
    "1f4d7": [["\uD83D\uDCD7"], "\uE148", "\uDBB9\uDCFF", ["green_book"], 18, 10],
    "1f4d8": [["\uD83D\uDCD8"], "\uE148", "\uDBB9\uDD00", ["blue_book"], 18, 11],
    "1f4d9": [["\uD83D\uDCD9"], "\uE148", "\uDBB9\uDD01", ["orange_book"], 18, 12],
    "1f4da": [["\uD83D\uDCDA"], "\uE148", "\uDBB9\uDD03", ["books"], 18, 13],
    "1f4db": [["\uD83D\uDCDB"], "", "\uDBB9\uDD04", ["name_badge"], 18, 14],
    "1f4dc": [["\uD83D\uDCDC"], "", "\uDBB9\uDCFD", ["scroll"], 18, 15],
    "1f4dd": [["\uD83D\uDCDD"], "\uE301", "\uDBB9\uDD27", ["memo", "pencil"], 18, 16],
    "1f4de": [["\uD83D\uDCDE"], "\uE009", "\uDBB9\uDD24", ["telephone_receiver"], 18, 17],
    "1f4df": [["\uD83D\uDCDF"], "", "\uDBB9\uDD22", ["pager"], 18, 18],
    "1f4e0": [["\uD83D\uDCE0"], "\uE00B", "\uDBB9\uDD28", ["fax"], 18, 19],
    "1f4e1": [["\uD83D\uDCE1"], "\uE14B", "\uDBB9\uDD31", ["satellite"], 18, 20],
    "1f4e2": [["\uD83D\uDCE2"], "\uE142", "\uDBB9\uDD2F", ["loudspeaker"], 18, 21],
    "1f4e3": [["\uD83D\uDCE3"], "\uE317", "\uDBB9\uDD30", ["mega"], 18, 22],
    "1f4e4": [["\uD83D\uDCE4"], "", "\uDBB9\uDD33", ["outbox_tray"], 18, 23],
    "1f4e5": [["\uD83D\uDCE5"], "", "\uDBB9\uDD34", ["inbox_tray"], 18, 24],
    "1f4e6": [["\uD83D\uDCE6"], "\uE112", "\uDBB9\uDD35", ["package"], 18, 25],
    "1f4e7": [["\uD83D\uDCE7"], "\uE103", "\uDBBA\uDF92", ["e-mail"], 18, 26],
    "1f4e8": [["\uD83D\uDCE8"], "\uE103", "\uDBB9\uDD2A", ["incoming_envelope"], 18, 27],
    "1f4e9": [["\uD83D\uDCE9"], "\uE103", "\uDBB9\uDD2B", ["envelope_with_arrow"], 18, 28],
    "1f4ea": [["\uD83D\uDCEA"], "\uE101", "\uDBB9\uDD2C", ["mailbox_closed"], 18, 29],
    "1f4eb": [["\uD83D\uDCEB"], "\uE101", "\uDBB9\uDD2D", ["mailbox"], 19, 0],
    "1f4ec": [["\uD83D\uDCEC"], "", "", ["mailbox_with_mail"], 19, 1],
    "1f4ed": [["\uD83D\uDCED"], "", "", ["mailbox_with_no_mail"], 19, 2],
    "1f4ee": [["\uD83D\uDCEE"], "\uE102", "\uDBB9\uDD2E", ["postbox"], 19, 3],
    "1f4ef": [["\uD83D\uDCEF"], "", "", ["postal_horn"], 19, 4],
    "1f4f0": [["\uD83D\uDCF0"], "", "\uDBBA\uDC22", ["newspaper"], 19, 5],
    "1f4f1": [["\uD83D\uDCF1"], "\uE00A", "\uDBB9\uDD25", ["iphone"], 19, 6],
    "1f4f2": [["\uD83D\uDCF2"], "\uE104", "\uDBB9\uDD26", ["calling"], 19, 7],
    "1f4f3": [["\uD83D\uDCF3"], "\uE250", "\uDBBA\uDC39", ["vibration_mode"], 19, 8],
    "1f4f4": [["\uD83D\uDCF4"], "\uE251", "\uDBBA\uDC3A", ["mobile_phone_off"], 19, 9],
    "1f4f5": [["\uD83D\uDCF5"], "", "", ["no_mobile_phones"], 19, 10],
    "1f4f6": [["\uD83D\uDCF6"], "\uE20B", "\uDBBA\uDC38", ["signal_strength"], 19, 11],
    "1f4f7": [["\uD83D\uDCF7"], "\uE008", "\uDBB9\uDCEF", ["camera"], 19, 12],
    "1f4f9": [["\uD83D\uDCF9"], "\uE03D", "\uDBB9\uDCF9", ["video_camera"], 19, 13],
    "1f4fa": [["\uD83D\uDCFA"], "\uE12A", "\uDBBA\uDC1C", ["tv"], 19, 14],
    "1f4fb": [["\uD83D\uDCFB"], "\uE128", "\uDBBA\uDC1F", ["radio"], 19, 15],
    "1f4fc": [["\uD83D\uDCFC"], "\uE129", "\uDBBA\uDC20", ["vhs"], 19, 16],
    "1f500": [["\uD83D\uDD00"], "", "", ["twisted_rightwards_arrows"], 19, 17],
    "1f501": [["\uD83D\uDD01"], "", "", ["repeat"], 19, 18],
    "1f502": [["\uD83D\uDD02"], "", "", ["repeat_one"], 19, 19],
    "1f503": [["\uD83D\uDD03"], "", "\uDBBA\uDF91", ["arrows_clockwise"], 19, 20],
    "1f504": [["\uD83D\uDD04"], "", "", ["arrows_counterclockwise"], 19, 21],
    "1f505": [["\uD83D\uDD05"], "", "", ["low_brightness"], 19, 22],
    "1f506": [["\uD83D\uDD06"], "", "", ["high_brightness"], 19, 23],
    "1f507": [["\uD83D\uDD07"], "", "", ["mute"], 19, 24],
    "1f508": [["\uD83D\uDD08"], "", "", ["speaker"], 19, 25],
    "1f509": [["\uD83D\uDD09"], "", "", ["sound"], 19, 26],
    "1f50a": [["\uD83D\uDD0A"], "\uE141", "\uDBBA\uDC21", ["loud_sound"], 19, 27],
    "1f50b": [["\uD83D\uDD0B"], "", "\uDBB9\uDCFC", ["battery"], 19, 28],
    "1f50c": [["\uD83D\uDD0C"], "", "\uDBB9\uDCFE", ["electric_plug"], 19, 29],
    "1f50d": [["\uD83D\uDD0D"], "\uE114", "\uDBBA\uDF85", ["mag"], 20, 0],
    "1f50e": [["\uD83D\uDD0E"], "\uE114", "\uDBBA\uDF8D", ["mag_right"], 20, 1],
    "1f50f": [["\uD83D\uDD0F"], "\uE144", "\uDBBA\uDF90", ["lock_with_ink_pen"], 20, 2],
    "1f510": [["\uD83D\uDD10"], "\uE144", "\uDBBA\uDF8A", ["closed_lock_with_key"], 20, 3],
    "1f511": [["\uD83D\uDD11"], "\uE03F", "\uDBBA\uDF82", ["key"], 20, 4],
    "1f512": [["\uD83D\uDD12"], "\uE144", "\uDBBA\uDF86", ["lock"], 20, 5],
    "1f513": [["\uD83D\uDD13"], "\uE145", "\uDBBA\uDF87", ["unlock"], 20, 6],
    "1f514": [["\uD83D\uDD14"], "\uE325", "\uDBB9\uDCF2", ["bell"], 20, 7],
    "1f515": [["\uD83D\uDD15"], "", "", ["no_bell"], 20, 8],
    "1f516": [["\uD83D\uDD16"], "", "\uDBBA\uDF8F", ["bookmark"], 20, 9],
    "1f517": [["\uD83D\uDD17"], "", "\uDBBA\uDF4B", ["link"], 20, 10],
    "1f518": [["\uD83D\uDD18"], "", "\uDBBA\uDF8C", ["radio_button"], 20, 11],
    "1f519": [["\uD83D\uDD19"], "\uE235", "\uDBBA\uDF8E", ["back"], 20, 12],
    "1f51a": [["\uD83D\uDD1A"], "", "\uDBB8\uDC1A", ["end"], 20, 13],
    "1f51b": [["\uD83D\uDD1B"], "", "\uDBB8\uDC19", ["on"], 20, 14],
    "1f51c": [["\uD83D\uDD1C"], "", "\uDBB8\uDC18", ["soon"], 20, 15],
    "1f51d": [["\uD83D\uDD1D"], "\uE24C", "\uDBBA\uDF42", ["top"], 20, 16],
    "1f51e": [["\uD83D\uDD1E"], "\uE207", "\uDBBA\uDF25", ["underage"], 20, 17],
    "1f51f": [["\uD83D\uDD1F"], "", "\uDBBA\uDC3B", ["keycap_ten"], 20, 18],
    "1f520": [["\uD83D\uDD20"], "", "\uDBBA\uDF7C", ["capital_abcd"], 20, 19],
    "1f521": [["\uD83D\uDD21"], "", "\uDBBA\uDF7D", ["abcd"], 20, 20],
    "1f522": [["\uD83D\uDD22"], "", "\uDBBA\uDF7E", ["1234"], 20, 21],
    "1f523": [["\uD83D\uDD23"], "", "\uDBBA\uDF7F", ["symbols"], 20, 22],
    "1f524": [["\uD83D\uDD24"], "", "\uDBBA\uDF80", ["abc"], 20, 23],
    "1f525": [["\uD83D\uDD25"], "\uE11D", "\uDBB9\uDCF6", ["fire"], 20, 24],
    "1f526": [["\uD83D\uDD26"], "", "\uDBB9\uDCFB", ["flashlight"], 20, 25],
    "1f527": [["\uD83D\uDD27"], "", "\uDBB9\uDCC9", ["wrench"], 20, 26],
    "1f528": [["\uD83D\uDD28"], "\uE116", "\uDBB9\uDCCA", ["hammer"], 20, 27],
    "1f529": [["\uD83D\uDD29"], "", "\uDBB9\uDCCB", ["nut_and_bolt"], 20, 28],
    "1f52a": [["\uD83D\uDD2A"], "", "\uDBB9\uDCFA", ["hocho", "knife"], 20, 29],
    "1f52b": [["\uD83D\uDD2B"], "\uE113", "\uDBB9\uDCF5", ["gun"], 21, 0],
    "1f52c": [["\uD83D\uDD2C"], "", "", ["microscope"], 21, 1],
    "1f52d": [["\uD83D\uDD2D"], "", "", ["telescope"], 21, 2],
    "1f52e": [["\uD83D\uDD2E"], "\uE23E", "\uDBB9\uDCF7", ["crystal_ball"], 21, 3],
    "1f52f": [["\uD83D\uDD2F"], "\uE23E", "\uDBB9\uDCF8", ["six_pointed_star"], 21, 4],
    "1f530": [["\uD83D\uDD30"], "\uE209", "\uDBB8\uDC44", ["beginner"], 21, 5],
    "1f531": [["\uD83D\uDD31"], "\uE031", "\uDBB9\uDCD2", ["trident"], 21, 6],
    "1f532": [["\uD83D\uDD32"], "\uE21A", "\uDBBA\uDF64", ["black_square_button"], 21, 7],
    "1f533": [["\uD83D\uDD33"], "\uE21B", "\uDBBA\uDF67", ["white_square_button"], 21, 8],
    "1f534": [["\uD83D\uDD34"], "\uE219", "\uDBBA\uDF63", ["red_circle"], 21, 9],
    "1f535": [["\uD83D\uDD35"], "\uE21A", "\uDBBA\uDF64", ["large_blue_circle"], 21, 10],
    "1f536": [["\uD83D\uDD36"], "\uE21B", "\uDBBA\uDF73", ["large_orange_diamond"], 21, 11],
    "1f537": [["\uD83D\uDD37"], "\uE21B", "\uDBBA\uDF74", ["large_blue_diamond"], 21, 12],
    "1f538": [["\uD83D\uDD38"], "\uE21B", "\uDBBA\uDF75", ["small_orange_diamond"], 21, 13],
    "1f539": [["\uD83D\uDD39"], "\uE21B", "\uDBBA\uDF76", ["small_blue_diamond"], 21, 14],
    "1f53a": [["\uD83D\uDD3A"], "", "\uDBBA\uDF78", ["small_red_triangle"], 21, 15],
    "1f53b": [["\uD83D\uDD3B"], "", "\uDBBA\uDF79", ["small_red_triangle_down"], 21, 16],
    "1f53c": [["\uD83D\uDD3C"], "", "\uDBBA\uDF01", ["arrow_up_small"], 21, 17],
    "1f53d": [["\uD83D\uDD3D"], "", "\uDBBA\uDF00", ["arrow_down_small"], 21, 18],
    "1f550": [["\uD83D\uDD50"], "\uE024", "\uDBB8\uDC1E", ["clock1"], 21, 19],
    "1f551": [["\uD83D\uDD51"], "\uE025", "\uDBB8\uDC1F", ["clock2"], 21, 20],
    "1f552": [["\uD83D\uDD52"], "\uE026", "\uDBB8\uDC20", ["clock3"], 21, 21],
    "1f553": [["\uD83D\uDD53"], "\uE027", "\uDBB8\uDC21", ["clock4"], 21, 22],
    "1f554": [["\uD83D\uDD54"], "\uE028", "\uDBB8\uDC22", ["clock5"], 21, 23],
    "1f555": [["\uD83D\uDD55"], "\uE029", "\uDBB8\uDC23", ["clock6"], 21, 24],
    "1f556": [["\uD83D\uDD56"], "\uE02A", "\uDBB8\uDC24", ["clock7"], 21, 25],
    "1f557": [["\uD83D\uDD57"], "\uE02B", "\uDBB8\uDC25", ["clock8"], 21, 26],
    "1f558": [["\uD83D\uDD58"], "\uE02C", "\uDBB8\uDC26", ["clock9"], 21, 27],
    "1f559": [["\uD83D\uDD59"], "\uE02D", "\uDBB8\uDC27", ["clock10"], 21, 28],
    "1f55a": [["\uD83D\uDD5A"], "\uE02E", "\uDBB8\uDC28", ["clock11"], 21, 29],
    "1f55b": [["\uD83D\uDD5B"], "\uE02F", "\uDBB8\uDC29", ["clock12"], 22, 0],
    "1f55c": [["\uD83D\uDD5C"], "", "", ["clock130"], 22, 1],
    "1f55d": [["\uD83D\uDD5D"], "", "", ["clock230"], 22, 2],
    "1f55e": [["\uD83D\uDD5E"], "", "", ["clock330"], 22, 3],
    "1f55f": [["\uD83D\uDD5F"], "", "", ["clock430"], 22, 4],
    "1f560": [["\uD83D\uDD60"], "", "", ["clock530"], 22, 5],
    "1f561": [["\uD83D\uDD61"], "", "", ["clock630"], 22, 6],
    "1f562": [["\uD83D\uDD62"], "", "", ["clock730"], 22, 7],
    "1f563": [["\uD83D\uDD63"], "", "", ["clock830"], 22, 8],
    "1f564": [["\uD83D\uDD64"], "", "", ["clock930"], 22, 9],
    "1f565": [["\uD83D\uDD65"], "", "", ["clock1030"], 22, 10],
    "1f566": [["\uD83D\uDD66"], "", "", ["clock1130"], 22, 11],
    "1f567": [["\uD83D\uDD67"], "", "", ["clock1230"], 22, 12],
    "1f5fb": [["\uD83D\uDDFB"], "\uE03B", "\uDBB9\uDCC3", ["mount_fuji"], 22, 13],
    "1f5fc": [["\uD83D\uDDFC"], "\uE509", "\uDBB9\uDCC4", ["tokyo_tower"], 22, 14],
    "1f5fd": [["\uD83D\uDDFD"], "\uE51D", "\uDBB9\uDCC6", ["statue_of_liberty"], 22, 15],
    "1f5fe": [["\uD83D\uDDFE"], "", "\uDBB9\uDCC7", ["japan"], 22, 16],
    "1f5ff": [["\uD83D\uDDFF"], "", "\uDBB9\uDCC8", ["moyai"], 22, 17],
    "1f600": [["\uD83D\uDE00"], "", "", ["grinning"], 22, 18, ":D"],
    "1f601": [["\uD83D\uDE01"], "\uE404", "\uDBB8\uDF33", ["grin"], 22, 19],
    "1f602": [["\uD83D\uDE02"], "\uE412", "\uDBB8\uDF34", ["joy"], 22, 20],
    "1f603": [["\uD83D\uDE03"], "\uE057", "\uDBB8\uDF30", ["smiley"], 22, 21, ":)"],
    "1f604": [["\uD83D\uDE04"], "\uE415", "\uDBB8\uDF38", ["smile"], 22, 22, ":)"],
    "1f605": [["\uD83D\uDE05"], "\uE415\uE331", "\uDBB8\uDF31", ["sweat_smile"], 22, 23],
    "1f606": [["\uD83D\uDE06"], "\uE40A", "\uDBB8\uDF32", ["satisfied"], 22, 24],
    "1f607": [["\uD83D\uDE07"], "", "", ["innocent"], 22, 25],
    "1f608": [["\uD83D\uDE08"], "", "", ["smiling_imp"], 22, 26],
    "1f609": [["\uD83D\uDE09"], "\uE405", "\uDBB8\uDF47", ["wink"], 22, 27, ";)"],
    "1f60a": [["\uD83D\uDE0A"], "\uE056", "\uDBB8\uDF35", ["blush"], 22, 28],
    "1f60b": [["\uD83D\uDE0B"], "\uE056", "\uDBB8\uDF2B", ["yum"], 22, 29],
    "1f60c": [["\uD83D\uDE0C"], "\uE40A", "\uDBB8\uDF3E", ["relieved"], 23, 0],
    "1f60d": [["\uD83D\uDE0D"], "\uE106", "\uDBB8\uDF27", ["heart_eyes"], 23, 1],
    "1f60e": [["\uD83D\uDE0E"], "", "", ["sunglasses"], 23, 2],
    "1f60f": [["\uD83D\uDE0F"], "\uE402", "\uDBB8\uDF43", ["smirk"], 23, 3],
    "1f610": [["\uD83D\uDE10"], "", "", ["neutral_face"], 23, 4],
    "1f611": [["\uD83D\uDE11"], "", "", ["expressionless"], 23, 5],
    "1f612": [["\uD83D\uDE12"], "\uE40E", "\uDBB8\uDF26", ["unamused"], 23, 6],
    "1f613": [["\uD83D\uDE13"], "\uE108", "\uDBB8\uDF44", ["sweat"], 23, 7],
    "1f614": [["\uD83D\uDE14"], "\uE403", "\uDBB8\uDF40", ["pensive"], 23, 8],
    "1f615": [["\uD83D\uDE15"], "", "", ["confused"], 23, 9],
    "1f616": [["\uD83D\uDE16"], "\uE407", "\uDBB8\uDF3F", ["confounded"], 23, 10],
    "1f617": [["\uD83D\uDE17"], "", "", ["kissing"], 23, 11],
    "1f618": [["\uD83D\uDE18"], "\uE418", "\uDBB8\uDF2C", ["kissing_heart"], 23, 12],
    "1f619": [["\uD83D\uDE19"], "", "", ["kissing_smiling_eyes"], 23, 13],
    "1f61a": [["\uD83D\uDE1A"], "\uE417", "\uDBB8\uDF2D", ["kissing_closed_eyes"], 23, 14],
    "1f61b": [["\uD83D\uDE1B"], "", "", ["stuck_out_tongue"], 23, 15, ":p"],
    "1f61c": [["\uD83D\uDE1C"], "\uE105", "\uDBB8\uDF29", ["stuck_out_tongue_winking_eye"], 23, 16, ";p"],
    "1f61d": [["\uD83D\uDE1D"], "\uE409", "\uDBB8\uDF2A", ["stuck_out_tongue_closed_eyes"], 23, 17],
    "1f61e": [["\uD83D\uDE1E"], "\uE058", "\uDBB8\uDF23", ["disappointed"], 23, 18, ":("],
    "1f61f": [["\uD83D\uDE1F"], "", "", ["worried"], 23, 19],
    "1f620": [["\uD83D\uDE20"], "\uE059", "\uDBB8\uDF20", ["angry"], 23, 20],
    "1f621": [["\uD83D\uDE21"], "\uE416", "\uDBB8\uDF3D", ["rage"], 23, 21],
    "1f622": [["\uD83D\uDE22"], "\uE413", "\uDBB8\uDF39", ["cry"], 23, 22, ":'("],
    "1f623": [["\uD83D\uDE23"], "\uE406", "\uDBB8\uDF3C", ["persevere"], 23, 23],
    "1f624": [["\uD83D\uDE24"], "\uE404", "\uDBB8\uDF28", ["triumph"], 23, 24],
    "1f625": [["\uD83D\uDE25"], "\uE401", "\uDBB8\uDF45", ["disappointed_relieved"], 23, 25],
    "1f626": [["\uD83D\uDE26"], "", "", ["frowning"], 23, 26],
    "1f627": [["\uD83D\uDE27"], "", "", ["anguished"], 23, 27],
    "1f628": [["\uD83D\uDE28"], "\uE40B", "\uDBB8\uDF3B", ["fearful"], 23, 28],
    "1f629": [["\uD83D\uDE29"], "\uE403", "\uDBB8\uDF21", ["weary"], 23, 29],
    "1f62a": [["\uD83D\uDE2A"], "\uE408", "\uDBB8\uDF42", ["sleepy"], 24, 0],
    "1f62b": [["\uD83D\uDE2B"], "\uE406", "\uDBB8\uDF46", ["tired_face"], 24, 1],
    "1f62c": [["\uD83D\uDE2C"], "", "", ["grimacing"], 24, 2],
    "1f62d": [["\uD83D\uDE2D"], "\uE411", "\uDBB8\uDF3A", ["sob"], 24, 3, ":'("],
    "1f62e": [["\uD83D\uDE2E"], "", "", ["open_mouth"], 24, 4],
    "1f62f": [["\uD83D\uDE2F"], "", "", ["hushed"], 24, 5],
    "1f630": [["\uD83D\uDE30"], "\uE40F", "\uDBB8\uDF25", ["cold_sweat"], 24, 6],
    "1f631": [["\uD83D\uDE31"], "\uE107", "\uDBB8\uDF41", ["scream"], 24, 7],
    "1f632": [["\uD83D\uDE32"], "\uE410", "\uDBB8\uDF22", ["astonished"], 24, 8],
    "1f633": [["\uD83D\uDE33"], "\uE40D", "\uDBB8\uDF2F", ["flushed"], 24, 9],
    "1f634": [["\uD83D\uDE34"], "", "", ["sleeping"], 24, 10],
    "1f635": [["\uD83D\uDE35"], "\uE406", "\uDBB8\uDF24", ["dizzy_face"], 24, 11],
    "1f636": [["\uD83D\uDE36"], "", "", ["no_mouth"], 24, 12],
    "1f637": [["\uD83D\uDE37"], "\uE40C", "\uDBB8\uDF2E", ["mask"], 24, 13],
    "1f638": [["\uD83D\uDE38"], "\uE404", "\uDBB8\uDF49", ["smile_cat"], 24, 14],
    "1f639": [["\uD83D\uDE39"], "\uE412", "\uDBB8\uDF4A", ["joy_cat"], 24, 15],
    "1f63a": [["\uD83D\uDE3A"], "\uE057", "\uDBB8\uDF48", ["smiley_cat"], 24, 16],
    "1f63b": [["\uD83D\uDE3B"], "\uE106", "\uDBB8\uDF4C", ["heart_eyes_cat"], 24, 17],
    "1f63c": [["\uD83D\uDE3C"], "\uE404", "\uDBB8\uDF4F", ["smirk_cat"], 24, 18],
    "1f63d": [["\uD83D\uDE3D"], "\uE418", "\uDBB8\uDF4B", ["kissing_cat"], 24, 19],
    "1f63e": [["\uD83D\uDE3E"], "\uE416", "\uDBB8\uDF4E", ["pouting_cat"], 24, 20],
    "1f63f": [["\uD83D\uDE3F"], "\uE413", "\uDBB8\uDF4D", ["crying_cat_face"], 24, 21],
    "1f640": [["\uD83D\uDE40"], "\uE403", "\uDBB8\uDF50", ["scream_cat"], 24, 22],
    "1f645": [["\uD83D\uDE45"], "\uE423", "\uDBB8\uDF51", ["no_good"], 24, 23],
    "1f646": [["\uD83D\uDE46"], "\uE424", "\uDBB8\uDF52", ["ok_woman"], 24, 24],
    "1f647": [["\uD83D\uDE47"], "\uE426", "\uDBB8\uDF53", ["bow"], 24, 25],
    "1f648": [["\uD83D\uDE48"], "", "\uDBB8\uDF54", ["see_no_evil"], 24, 26],
    "1f649": [["\uD83D\uDE49"], "", "\uDBB8\uDF56", ["hear_no_evil"], 24, 27],
    "1f64a": [["\uD83D\uDE4A"], "", "\uDBB8\uDF55", ["speak_no_evil"], 24, 28],
    "1f64b": [["\uD83D\uDE4B"], "\uE012", "\uDBB8\uDF57", ["raising_hand"], 24, 29],
    "1f64c": [["\uD83D\uDE4C"], "\uE427", "\uDBB8\uDF58", ["raised_hands"], 25, 0],
    "1f64d": [["\uD83D\uDE4D"], "\uE403", "\uDBB8\uDF59", ["person_frowning"], 25, 1],
    "1f64e": [["\uD83D\uDE4E"], "\uE416", "\uDBB8\uDF5A", ["person_with_pouting_face"], 25, 2],
    "1f64f": [["\uD83D\uDE4F"], "\uE41D", "\uDBB8\uDF5B", ["pray"], 25, 3],
    "1f680": [["\uD83D\uDE80"], "\uE10D", "\uDBB9\uDFED", ["rocket"], 25, 4],
    "1f681": [["\uD83D\uDE81"], "", "", ["helicopter"], 25, 5],
    "1f682": [["\uD83D\uDE82"], "", "", ["steam_locomotive"], 25, 6],
    "1f683": [["\uD83D\uDE83"], "\uE01E", "\uDBB9\uDFDF", ["railway_car"], 25, 7],
    "1f684": [["\uD83D\uDE84"], "\uE435", "\uDBB9\uDFE2", ["bullettrain_side"], 25, 8],
    "1f685": [["\uD83D\uDE85"], "\uE01F", "\uDBB9\uDFE3", ["bullettrain_front"], 25, 9],
    "1f686": [["\uD83D\uDE86"], "", "", ["train2"], 25, 10],
    "1f687": [["\uD83D\uDE87"], "\uE434", "\uDBB9\uDFE0", ["metro"], 25, 11],
    "1f688": [["\uD83D\uDE88"], "", "", ["light_rail"], 25, 12],
    "1f689": [["\uD83D\uDE89"], "\uE039", "\uDBB9\uDFEC", ["station"], 25, 13],
    "1f68a": [["\uD83D\uDE8A"], "", "", ["tram"], 25, 14],
    "1f68b": [["\uD83D\uDE8B"], "", "", ["train"], 25, 15],
    "1f68c": [["\uD83D\uDE8C"], "\uE159", "\uDBB9\uDFE6", ["bus"], 25, 16],
    "1f68d": [["\uD83D\uDE8D"], "", "", ["oncoming_bus"], 25, 17],
    "1f68e": [["\uD83D\uDE8E"], "", "", ["trolleybus"], 25, 18],
    "1f68f": [["\uD83D\uDE8F"], "\uE150", "\uDBB9\uDFE7", ["busstop"], 25, 19],
    "1f690": [["\uD83D\uDE90"], "", "", ["minibus"], 25, 20],
    "1f691": [["\uD83D\uDE91"], "\uE431", "\uDBB9\uDFF3", ["ambulance"], 25, 21],
    "1f692": [["\uD83D\uDE92"], "\uE430", "\uDBB9\uDFF2", ["fire_engine"], 25, 22],
    "1f693": [["\uD83D\uDE93"], "\uE432", "\uDBB9\uDFF4", ["police_car"], 25, 23],
    "1f694": [["\uD83D\uDE94"], "", "", ["oncoming_police_car"], 25, 24],
    "1f695": [["\uD83D\uDE95"], "\uE15A", "\uDBB9\uDFEF", ["taxi"], 25, 25],
    "1f696": [["\uD83D\uDE96"], "", "", ["oncoming_taxi"], 25, 26],
    "1f697": [["\uD83D\uDE97"], "\uE01B", "\uDBB9\uDFE4", ["car", "red_car"], 25, 27],
    "1f698": [["\uD83D\uDE98"], "", "", ["oncoming_automobile"], 25, 28],
    "1f699": [["\uD83D\uDE99"], "\uE42E", "\uDBB9\uDFE5", ["blue_car"], 25, 29],
    "1f69a": [["\uD83D\uDE9A"], "\uE42F", "\uDBB9\uDFF1", ["truck"], 26, 0],
    "1f69b": [["\uD83D\uDE9B"], "", "", ["articulated_lorry"], 26, 1],
    "1f69c": [["\uD83D\uDE9C"], "", "", ["tractor"], 26, 2],
    "1f69d": [["\uD83D\uDE9D"], "", "", ["monorail"], 26, 3],
    "1f69e": [["\uD83D\uDE9E"], "", "", ["mountain_railway"], 26, 4],
    "1f69f": [["\uD83D\uDE9F"], "", "", ["suspension_railway"], 26, 5],
    "1f6a0": [["\uD83D\uDEA0"], "", "", ["mountain_cableway"], 26, 6],
    "1f6a1": [["\uD83D\uDEA1"], "", "", ["aerial_tramway"], 26, 7],
    "1f6a2": [["\uD83D\uDEA2"], "\uE202", "\uDBB9\uDFE8", ["ship"], 26, 8],
    "1f6a3": [["\uD83D\uDEA3"], "", "", ["rowboat"], 26, 9],
    "1f6a4": [["\uD83D\uDEA4"], "\uE135", "\uDBB9\uDFEE", ["speedboat"], 26, 10],
    "1f6a5": [["\uD83D\uDEA5"], "\uE14E", "\uDBB9\uDFF7", ["traffic_light"], 26, 11],
    "1f6a6": [["\uD83D\uDEA6"], "", "", ["vertical_traffic_light"], 26, 12],
    "1f6a7": [["\uD83D\uDEA7"], "\uE137", "\uDBB9\uDFF8", ["construction"], 26, 13],
    "1f6a8": [["\uD83D\uDEA8"], "\uE432", "\uDBB9\uDFF9", ["rotating_light"], 26, 14],
    "1f6a9": [["\uD83D\uDEA9"], "", "\uDBBA\uDF22", ["triangular_flag_on_post"], 26, 15],
    "1f6aa": [["\uD83D\uDEAA"], "", "\uDBB9\uDCF3", ["door"], 26, 16],
    "1f6ab": [["\uD83D\uDEAB"], "", "\uDBBA\uDF48", ["no_entry_sign"], 26, 17],
    "1f6ac": [["\uD83D\uDEAC"], "\uE30E", "\uDBBA\uDF1E", ["smoking"], 26, 18],
    "1f6ad": [["\uD83D\uDEAD"], "\uE208", "\uDBBA\uDF1F", ["no_smoking"], 26, 19],
    "1f6ae": [["\uD83D\uDEAE"], "", "", ["put_litter_in_its_place"], 26, 20],
    "1f6af": [["\uD83D\uDEAF"], "", "", ["do_not_litter"], 26, 21],
    "1f6b0": [["\uD83D\uDEB0"], "", "", ["potable_water"], 26, 22],
    "1f6b1": [["\uD83D\uDEB1"], "", "", ["non-potable_water"], 26, 23],
    "1f6b2": [["\uD83D\uDEB2"], "\uE136", "\uDBB9\uDFEB", ["bike"], 26, 24],
    "1f6b3": [["\uD83D\uDEB3"], "", "", ["no_bicycles"], 26, 25],
    "1f6b4": [["\uD83D\uDEB4"], "", "", ["bicyclist"], 26, 26],
    "1f6b5": [["\uD83D\uDEB5"], "", "", ["mountain_bicyclist"], 26, 27],
    "1f6b6": [["\uD83D\uDEB6"], "\uE201", "\uDBB9\uDFF0", ["walking"], 26, 28],
    "1f6b7": [["\uD83D\uDEB7"], "", "", ["no_pedestrians"], 26, 29],
    "1f6b8": [["\uD83D\uDEB8"], "", "", ["children_crossing"], 27, 0],
    "1f6b9": [["\uD83D\uDEB9"], "\uE138", "\uDBBA\uDF33", ["mens"], 27, 1],
    "1f6ba": [["\uD83D\uDEBA"], "\uE139", "\uDBBA\uDF34", ["womens"], 27, 2],
    "1f6bb": [["\uD83D\uDEBB"], "\uE151", "\uDBB9\uDD06", ["restroom"], 27, 3],
    "1f6bc": [["\uD83D\uDEBC"], "\uE13A", "\uDBBA\uDF35", ["baby_symbol"], 27, 4],
    "1f6bd": [["\uD83D\uDEBD"], "\uE140", "\uDBB9\uDD07", ["toilet"], 27, 5],
    "1f6be": [["\uD83D\uDEBE"], "\uE309", "\uDBB9\uDD08", ["wc"], 27, 6],
    "1f6bf": [["\uD83D\uDEBF"], "", "", ["shower"], 27, 7],
    "1f6c0": [["\uD83D\uDEC0"], "\uE13F", "\uDBB9\uDD05", ["bath"], 27, 8],
    "1f6c1": [["\uD83D\uDEC1"], "", "", ["bathtub"], 27, 9],
    "1f6c2": [["\uD83D\uDEC2"], "", "", ["passport_control"], 27, 10],
    "1f6c3": [["\uD83D\uDEC3"], "", "", ["customs"], 27, 11],
    "1f6c4": [["\uD83D\uDEC4"], "", "", ["baggage_claim"], 27, 12],
    "1f6c5": [["\uD83D\uDEC5"], "", "", ["left_luggage"], 27, 13],
    "0023-20e3": [["#\uFE0F\u20E3", "#\u20E3"], "\uE210", "\uDBBA\uDC2C", ["hash"], 27, 14],
    "0030-20e3": [["0\uFE0F\u20E3", "0\u20E3"], "\uE225", "\uDBBA\uDC37", ["zero"], 27, 15],
    "0031-20e3": [["1\uFE0F\u20E3", "1\u20E3"], "\uE21C", "\uDBBA\uDC2E", ["one"], 27, 16],
    "0032-20e3": [["2\uFE0F\u20E3", "2\u20E3"], "\uE21D", "\uDBBA\uDC2F", ["two"], 27, 17],
    "0033-20e3": [["3\uFE0F\u20E3", "3\u20E3"], "\uE21E", "\uDBBA\uDC30", ["three"], 27, 18],
    "0034-20e3": [["4\uFE0F\u20E3", "4\u20E3"], "\uE21F", "\uDBBA\uDC31", ["four"], 27, 19],
    "0035-20e3": [["5\uFE0F\u20E3", "5\u20E3"], "\uE220", "\uDBBA\uDC32", ["five"], 27, 20],
    "0036-20e3": [["6\uFE0F\u20E3", "6\u20E3"], "\uE221", "\uDBBA\uDC33", ["six"], 27, 21],
    "0037-20e3": [["7\uFE0F\u20E3", "7\u20E3"], "\uE222", "\uDBBA\uDC34", ["seven"], 27, 22],
    "0038-20e3": [["8\uFE0F\u20E3", "8\u20E3"], "\uE223", "\uDBBA\uDC35", ["eight"], 27, 23],
    "0039-20e3": [["9\uFE0F\u20E3", "9\u20E3"], "\uE224", "\uDBBA\uDC36", ["nine"], 27, 24],
    "1f1e8-1f1f3": [["\uD83C\uDDE8\uD83C\uDDF3"], "\uE513", "\uDBB9\uDCED", ["cn"], 27, 25],
    "1f1e9-1f1ea": [["\uD83C\uDDE9\uD83C\uDDEA"], "\uE50E", "\uDBB9\uDCE8", ["de"], 27, 26],
    "1f1ea-1f1f8": [["\uD83C\uDDEA\uD83C\uDDF8"], "\uE511", "\uDBB9\uDCEB", ["es"], 27, 27],
    "1f1eb-1f1f7": [["\uD83C\uDDEB\uD83C\uDDF7"], "\uE50D", "\uDBB9\uDCE7", ["fr"], 27, 28],
    "1f1ec-1f1e7": [["\uD83C\uDDEC\uD83C\uDDE7"], "\uE510", "\uDBB9\uDCEA", ["gb", "uk"], 27, 29],
    "1f1ee-1f1f9": [["\uD83C\uDDEE\uD83C\uDDF9"], "\uE50F", "\uDBB9\uDCE9", ["it"], 28, 0],
    "1f1ef-1f1f5": [["\uD83C\uDDEF\uD83C\uDDF5"], "\uE50B", "\uDBB9\uDCE5", ["jp"], 28, 1],
    "1f1f0-1f1f7": [["\uD83C\uDDF0\uD83C\uDDF7"], "\uE514", "\uDBB9\uDCEE", ["kr"], 28, 2],
    "1f1f7-1f1fa": [["\uD83C\uDDF7\uD83C\uDDFA"], "\uE512", "\uDBB9\uDCEC", ["ru"], 28, 3],
    "1f1fa-1f1f8": [["\uD83C\uDDFA\uD83C\uDDF8"], "\uE50C", "\uDBB9\uDCE6", ["us"], 28, 4]
};

Config.smileys = {
    "<3": "heart",
    "<\/3": "broken_heart",
    ":)": "blush",
    "(:": "blush",
    ":-)": "blush",
    "C:": "smile",
    "c:": "smile",
    ":D": "smile",
    ":-D": "smile",
    ";)": "wink",
    ";-)": "wink",
    "):": "disappointed",
    ":(": "disappointed",
    ":-(": "disappointed",
    ":'(": "cry",
    "=)": "smiley",
    "=-)": "smiley",
    ":*": "kiss",
    ":-*": "kiss",
    ":>": "laughing",
    ":->": "laughing",
    "8)": "sunglasses",
    ":\\\\": "confused",
    ":-\\\\": "confused",
    ":\/": "confused",
    ":-\/": "confused",
    ":|": "neutral_face",
    ":-|": "neutral_face",
    ":o": "open_mouth",
    ":-o": "open_mouth",
    ">:(": "angry",
    ">:-(": "angry",
    ":p": "stuck_out_tongue",
    ":-p": "stuck_out_tongue",
    ":P": "stuck_out_tongue",
    ":-P": "stuck_out_tongue",
    ":b": "stuck_out_tongue",
    ":-b": "stuck_out_tongue",
    ";p": "stuck_out_tongue_winking_eye",
    ";-p": "stuck_out_tongue_winking_eye",
    ";b": "stuck_out_tongue_winking_eye",
    ";-b": "stuck_out_tongue_winking_eye",
    ";P": "stuck_out_tongue_winking_eye",
    ";-P": "stuck_out_tongue_winking_eye",
    ":o)": "monkey_face",
    "D:": "anguished"
};

Config.inits = {};
Config.map = {};

Config.mapcolon = {};
var a = [];
Config.reversemap = {};

Config.init_emoticons = function () {
    if (Config.inits.emoticons) return;
    Config.init_colons(); // we require this for the emoticons map
    Config.inits.emoticons = 1;

    var a = [];
    Config.map.emoticons = {};
    for (var i in Config.emoticons_data) {
        // because we never see some characters in our text except as
        // entities, we must do some replacing
        var emoticon = i.replace(/\&/g, '&amp;').replace(/\</g, '&lt;').replace(/\>/g, '&gt;');

        if (!Config.map.colons[emoji.emoticons_data[i]]) continue;

        Config.map.emoticons[emoticon] = Config.map.colons[Config.emoticons_data[i]];
        a.push(Config.escape_rx(emoticon));
    }
    Config.rx_emoticons = new RegExp('(^|\\s)(' + a.join('|') + ')(?=$|[\\s|\\?\\.,!])', 'g');
};
Config.init_colons = function () {
    if (Config.inits.colons) return;
    Config.inits.colons = 1;
    Config.rx_colons = new RegExp('\:[^\\s:]+\:', 'g');
    Config.map.colons = {};
    for (var i in Config.data) {
        for (var j = 0; j < Config.data[i][3].length; j++) {
            Config.map.colons[emoji.data[i][3][j]] = i;
        }
    }
};
Config.init_unified = function () {
    if (Config.inits.unified) return;
    Config.inits.unified = 1;

    buildMap();
};

Config.escape_rx = function (text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};

function buildMap() {

    var colons = [],
        codes = [];
    for (var i in Config.emoji_data) {
        for (var j = 0; j < Config.emoji_data[i][0].length; j++) {
            colons.push(Config.escape_rx(":" + Config.emoji_data[i][3][0]) + ":");
            codes.push(Config.emoji_data[i][0][0]);

            // it is a map of {"colon smiley":"unicode char"}
            Config.map[Config.emoji_data[i][3][0]] = Config.emoji_data[i][0][0];
            Config.mapcolon[":" + Config.emoji_data[i][3][0] + ":"] = Config.emoji_data[i][0][0];
            // it is a map of {"unicode char": "colon smiley"}
            Config.reversemap[Config.emoji_data[i][0][0]] = Config.emoji_data[i][3][0];
        }

        Config.rx_colons = new RegExp('(' + colons.join('|') + ')', "g");
        Config.rx_codes = new RegExp('(' + codes.join('|') + ')', "g");
    }
}

exports.default = Config;

/***/ }),
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(412);

var _app2 = _interopRequireDefault(_app);

var _fetch = __webpack_require__(847);

var _fetch2 = _interopRequireDefault(_fetch);

var _routes = __webpack_require__(852);

var _routes2 = _interopRequireDefault(_routes);

var _eventHandlerService = __webpack_require__(855);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!window.fetch) {
    (0, _fetch2.default)(window);
}

if (/Gecko\//g.test(navigator.userAgent)) {
    document.querySelector('body').classList.add('cartonomy-firefox');
}

if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    document.querySelector('body').classList.add('cartonomy-safari');
}

(0, _eventHandlerService.initializeEventHandlerService)();

angular.bootstrap(document, [_app2.default.name]);

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AboutController = __webpack_require__(647);

var _AboutController2 = _interopRequireDefault(_AboutController);

var _module2 = __webpack_require__(648);

var _module3 = _interopRequireDefault(_module2);

var _routeConfig = __webpack_require__(649);

var _routeConfig2 = _interopRequireDefault(_routeConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.controller('Cartonomy.About.AboutController', _AboutController2.default);

_module3.default.config(['$stateProvider', function ($stateProvider) {
    _routeConfig2.default.forEach(function (route) {
        $stateProvider.state(route);
    });
}]);

exports.default = _module3.default.name;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AboutController = function () {
    function AboutController(scope, stateService, cartonomyConfig) {
        _classCallCheck(this, AboutController);

        this._scope = scope;
        this._stateService = stateService;
        this._scope.versionNumber = cartonomyConfig.version;
        this._scope.buildTime = (0, _moment2.default)(cartonomyConfig.buildTime).utc().format('MM/DD/YYYY HH:mm:ss');
        this.cartonomyConfig = cartonomyConfig;
    }

    _createClass(AboutController, [{
        key: '$onInit',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return fetch(this.cartonomyConfig.ApiV2 + '/version');

                            case 2:
                                response = _context.sent;
                                _context.next = 5;
                                return response.json();

                            case 5:
                                this._scope.serverVersion = _context.sent;

                                _scope2.default.apply(this._scope);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function $onInit() {
                return _ref.apply(this, arguments);
            }

            return $onInit;
        }()
    }]);

    return AboutController;
}();

AboutController.$inject = ['$scope', '$state', 'cartonomyConfig'];
exports.default = AboutController;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(22);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('Cartonomy.About', []);

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    name: _CommonConstants2.default.RoutingStates.ABOUT,
    url: '/about',
    views: {
        contents: {
            template: __webpack_require__(650),
            controller: 'Cartonomy.About.AboutController'
        }
    }
}];

exports.default = routes;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__(41);

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout-gt-sm=\"row\" layout=\"column\" layout-margin class=\"about-page content\"><div layout=\"column\" flex-gt-sm=\"60\" class=\"order\"><h1 text-center>{{'client.about.cartonomy' | translate}}</h1><div layout=\"column\" layout-wrap items=\"groups\" text-center><p class=\"small\">{{'client.about.version' | translate}}: {{ versionNumber }}</p><p class=\"small\">{{'client.about.build_date' | translate}}: {{ buildTime }}</p><p class=\"small\">{{'client.about.api_version' | translate}}: {{ serverVersion.version }}</p><p class=\"small\">{{'client.about.api_build_date' | translate}}: {{ serverVersion.buildTime }}</p></div></div></div>");;return buf.join("");
}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _ExternalStoreHandler = __webpack_require__(414);

var _ExternalStoreHandler2 = _interopRequireDefault(_ExternalStoreHandler);

var _ApplicationController = __webpack_require__(656);

var _ApplicationController2 = _interopRequireDefault(_ApplicationController);

var _ConfirmTicketController = __webpack_require__(657);

var _ConfirmTicketController2 = _interopRequireDefault(_ConfirmTicketController);

var _ChangePasswordController = __webpack_require__(418);

var _ChangePasswordController2 = _interopRequireDefault(_ChangePasswordController);

var _LoginController = __webpack_require__(658);

var _LoginController2 = _interopRequireDefault(_LoginController);

var _LoginTicketController = __webpack_require__(659);

var _LoginTicketController2 = _interopRequireDefault(_LoginTicketController);

var _CategoryHeaderDirective = __webpack_require__(660);

var _CategoryHeaderDirective2 = _interopRequireDefault(_CategoryHeaderDirective);

var _FocusMeDirective = __webpack_require__(661);

var _FocusMeDirective2 = _interopRequireDefault(_FocusMeDirective);

var _FooterDirective = __webpack_require__(662);

var _FooterDirective2 = _interopRequireDefault(_FooterDirective);

var _HeaderDirective = __webpack_require__(664);

var _HeaderDirective2 = _interopRequireDefault(_HeaderDirective);

var _LoadingIndicatorDirective = __webpack_require__(666);

var _LoadingIndicatorDirective2 = _interopRequireDefault(_LoadingIndicatorDirective);

var _InputCompareToDirective = __webpack_require__(667);

var _InputCompareToDirective2 = _interopRequireDefault(_InputCompareToDirective);

var _InputElementErrorDirective = __webpack_require__(668);

var _InputElementErrorDirective2 = _interopRequireDefault(_InputElementErrorDirective);

var _InputFocusDirective = __webpack_require__(669);

var _InputFocusDirective2 = _interopRequireDefault(_InputFocusDirective);

var _PayPalPaymentForm = __webpack_require__(670);

var _PayPalPaymentForm2 = _interopRequireDefault(_PayPalPaymentForm);

var _SquareUpPaymentForm = __webpack_require__(671);

var _SquareUpPaymentForm2 = _interopRequireDefault(_SquareUpPaymentForm);

var _StickyPanelDirective = __webpack_require__(672);

var _StickyPanelDirective2 = _interopRequireDefault(_StickyPanelDirective);

var _WidthChangedHandlerDirective = __webpack_require__(673);

var _WidthChangedHandlerDirective2 = _interopRequireDefault(_WidthChangedHandlerDirective);

var _InviteLinkDirective = __webpack_require__(674);

var _InviteLinkDirective2 = _interopRequireDefault(_InviteLinkDirective);

var _AuthenticationService = __webpack_require__(677);

var _AuthenticationService2 = _interopRequireDefault(_AuthenticationService);

var _AuthInterceptorService = __webpack_require__(679);

var _AuthInterceptorService2 = _interopRequireDefault(_AuthInterceptorService);

var _CartService = __webpack_require__(680);

var _CartService2 = _interopRequireDefault(_CartService);

var _CheckoutService = __webpack_require__(681);

var _CheckoutService2 = _interopRequireDefault(_CheckoutService);

var _ConfigurationService = __webpack_require__(684);

var _ConfigurationService2 = _interopRequireDefault(_ConfigurationService);

var _ContactsService = __webpack_require__(685);

var _ContactsService2 = _interopRequireDefault(_ContactsService);

var _GroupOrderService = __webpack_require__(686);

var _GroupOrderService2 = _interopRequireDefault(_GroupOrderService);

var _MessageService = __webpack_require__(687);

var _MessageService2 = _interopRequireDefault(_MessageService);

var _OrderSetupService = __webpack_require__(690);

var _OrderSetupService2 = _interopRequireDefault(_OrderSetupService);

var _RealTimeUpdateService = __webpack_require__(694);

var _RealTimeUpdateService2 = _interopRequireDefault(_RealTimeUpdateService);

var _SessionService = __webpack_require__(695);

var _SessionService2 = _interopRequireDefault(_SessionService);

var _SessionStorageService = __webpack_require__(696);

var _SessionStorageService2 = _interopRequireDefault(_SessionStorageService);

var _storageService = __webpack_require__(698);

var _storageService2 = _interopRequireDefault(_storageService);

var _UserProfileService = __webpack_require__(699);

var _UserProfileService2 = _interopRequireDefault(_UserProfileService);

var _HeapService = __webpack_require__(700);

var _HeapService2 = _interopRequireDefault(_HeapService);

var _MoneyDirective = __webpack_require__(701);

var _MoneyDirective2 = _interopRequireDefault(_MoneyDirective);

var _markdownTranspileDirective = __webpack_require__(702);

var _markdownTranspileDirective2 = _interopRequireDefault(_markdownTranspileDirective);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _TextOnHoverDirective = __webpack_require__(768);

var _CartonomyLogoDirective = __webpack_require__(769);

var _CartonomyLogoDirective2 = _interopRequireDefault(_CartonomyLogoDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.controller('ApplicationController', _ApplicationController2.default);

_module3.default.directive(_markdownTranspileDirective2.default.directiveName, _markdownTranspileDirective2.default);

_module3.default.run(['$window', '$state', 'LocalForageService', '$rootScope', 'CartService', function (windowService, $state, localForageService, $rootScope, CartService) {
    windowService.onbeforeunload = function ($event) {

        var context = {
            preventReloadMessage: null,
            preventReload: false
        };

        $rootScope.$broadcast(_CommonConstants2.default.Events.ON_WINDOW_UNLOADING, context);

        if (context.preventReload) return context.preventReloadMessage;

        return;
    };
}]);

_module3.default.directive('textOnHover', _TextOnHoverDirective.textOnHover);

_module3.default.filter('ellipsisText', [function () {
    return function (input, trimLength, trimHtml) {
        if (!trimLength) {
            trimLength = 20;
        }

        if (!input) return '';

        if (trimHtml) {
            input = input.replace(/<(?:.|\n)*?>/gm, '');
        }

        var output = input.substr(0, trimLength);
        var s = output + (input.length > trimLength - 3 ? '...' : '');

        return s;
    };
}]);

exports.default = _module3.default.name;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(654);

module.exports = function (timeout) {
    return new Idle({ timeout: timeout });
};

// default settings
var defaults = {
    //start as soon as timer is set up
    start: true,
    // timer is enabled
    enabled: true,
    // amount of time before timer fires
    timeout: 30000,
    // what element to attach to
    element: document,
    // activity is one of these events
    events: 'mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove'
};

var Idle = function Idle(opt) {
    var self = this;

    self.opt = xtend(defaults, opt);
    self.element = self.opt.element;

    self.state = {
        idle: self.opt.idle,
        timeout: self.opt.timeout,
        enabled: self.opt.enabled,
        idle_fn: [],
        active_fn: []
    };

    // wrapper to pass state to toggleState
    self.state.state_fn = function () {
        toggleState(self.state);
    };

    if (self.opt.start) {
        self.start();
    }
};

var proto = Idle.prototype;

proto.start = function () {
    var self = this;
    var state = self.state;
    var element = self.element;

    function handler(ev) {
        // clear any current timouet
        clearTimeout(state.timer_id);

        if (!state.enabled) {
            return;
        }

        if (state.idle) {
            toggleState(state);
        }

        state.timer_id = setTimeout(state.state_fn, state.timeout);
    }

    // to remove later
    state.handler = handler;

    var events = this.opt.events.split(' ');
    for (var i = 0; i < events.length; ++i) {
        var event = events[i];
        attach(element, event, handler);
    }

    state.timer_id = setTimeout(self.state.state_fn, state.timeout);
};

// 'idle' | 'active'
proto.on = function (what, fn) {

    var self = this;
    var state = self.state;

    if (what === 'idle') {
        state.idle_fn.push(fn);
    } else {
        state.active_fn.push(fn);
    }
};

proto.getElapsed = function () {
    return +new Date() - this.state.olddate;
};

// Stops the idle timer. This removes appropriate event handlers
// and cancels any pending timeouts.
proto.stop = function () {
    var self = this;
    var state = this.state;
    var element = self.element;

    state.enabled = false;

    //clear any pending timeouts
    clearTimeout(state.timer_id);

    // detach handlers
    var events = this.opt.events.split(' ');
    for (var i = 0; i < events.length; ++i) {
        var event = events[i];
        detach(element, event, state.handler);
    }
};

/// private api

// Toggles the idle state and fires an appropriate event.
// borrowed from jquery-idletimer (see readme for link)
function toggleState(state) {
    // toggle the state
    state.idle = !state.idle;

    // reset timeout
    var elapsed = +new Date() - state.olddate;
    state.olddate = +new Date();

    // handle Chrome always triggering idle after js alert or comfirm popup
    if (state.idle && elapsed < state.timeout) {
        state.idle = false;
        clearTimeout(state.timer_id);
        if (state.enabled) {
            state.timer_id = setTimeout(state.state_fn, state.timeout);
        }
        return;
    }

    // fire event
    var event = state.idle ? 'idle' : 'active';

    var fns = event === 'idle' ? state.idle_fn : state.active_fn;
    for (var i = 0; i < fns.length; ++i) {
        fns[i]();
    }
}

// TODO (shtylman) detect at startup to avoid if during runtime?
var attach = function attach(element, event, fn) {
    if (element.addEventListener) {
        element.addEventListener(event, fn, false);
    } else if (element.attachEvent) {
        element.attachEvent('on' + event, fn);
    }
};

var detach = function detach(element, event, fn) {
    if (element.removeEventListener) {
        element.removeEventListener(event, fn, false);
    } else if (element.detachEvent) {
        element.detachEvent('on' + event, fn);
    }
};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Keys = Object.keys || objectKeys;

module.exports = extend;

function extend() {
    var target = {};

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i];

        if (!isObject(source)) {
            continue;
        }

        var keys = Keys(source);

        for (var j = 0; j < keys.length; j++) {
            var name = keys[j];
            target[name] = source[name];
        }
    }

    return target;
}

function objectKeys(obj) {
    var keys = [];
    for (var k in obj) {
        keys.push(k);
    }
    return keys;
}

function isObject(obj) {
    return obj !== null && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object";
}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (root, factory) {

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
        module.exports = factory();
    } else {
        root.translate = factory();
    }
})(undefined, function () {

    function each(storage, callback) {
        for (var key in storage) {
            storage.hasOwnProperty(key) && callback(key, storage[key]);
        }
    }

    function createRegistry() {

        var registry = {};
        var currentLocale = 'en';
        var interpolateRE = /{{\s*(\w+)\s*}}/g;
        var pluralizationRules = {
            en: {
                pluralizeTo: 'count',
                getVariationIndex: function getVariationIndex(count) {
                    return 1 === count ? 0 : 1;
                }
            }
        };

        function translate(key, templateData, options) {

            options = options || {};

            var locale = options.locale || currentLocale;
            var store = options.registry || registry;
            var translation = store[locale] && store[locale][key];

            if (typeof translation === 'undefined') {
                return translate.whenUndefined(key, locale);
            } else if (Array.isArray(translation)) {
                return translatePlural(key, translation, templateData, locale, options.pluralizeTo);
            } else {
                return interpolate(translation, templateData);
            }
        }

        function translatePlural(key, variations, data, locale, pluralizeTo) {

            var rule = pluralizationRules[locale];
            var dataKeys = Object.keys(data);
            var pluralizeKey = dataKeys.length === 1 ? dataKeys[0] : pluralizeTo || rule.pluralizeTo;
            var count = parseFloat(data[pluralizeKey]);

            if (isNaN(count)) {
                throw new Error('Tranlation pluralization missing parameters on key "' + key + '"');
            } else {
                return interpolate(variations[rule.getVariationIndex(count)], data);
            }
        }

        function interpolate(translationString, data) {

            return data ? translationString.replace(interpolateRE, function (match, param) {
                return data.hasOwnProperty(param) ? data[param] : match;
            }) : translationString;
        }

        translate.add = function (items, locale, prefix) {

            locale = locale || currentLocale;
            registry[locale] = registry[locale] || {};

            each(items, function (key, value) {

                var registryKey = prefix ? prefix + '.' + key : key;
                var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);

                if (Array.isArray(value) || valueType === 'string' || valueType === 'number') {
                    registry[locale][registryKey] = value;
                } else {
                    translate.add(value, locale, registryKey);
                }
            });

            return this;
        };

        translate.setLocale = function (locale) {

            currentLocale = locale;
            return this;
        };

        translate.getLocale = function () {

            return currentLocale;
        };

        translate.interpolateWith = function (userRE) {

            interpolateRE = userRE;
            return this;
        };

        translate.setPluralizationRule = function (locale, rule, options) {

            pluralizationRules[locale] = {
                pluralizeTo: options && options.pluralizeTo || 'count',
                getVariationIndex: rule
            };
            return this;
        };

        translate.whenUndefined = function (key, locale) {

            return key;
        };

        translate.clear = function () {

            registry = {};
            return this;
        };

        translate.createRegistry = function () {

            return createRegistry();
        };

        return translate;
    }

    return createRegistry();
});

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ApplicationController;

var _ExternalStoreHandler = __webpack_require__(414);

var _ExternalStoreHandler2 = _interopRequireDefault(_ExternalStoreHandler);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _communicationService = __webpack_require__(28);

var _commandKeys = __webpack_require__(27);

var _utils = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var cartonomyLogo = __webpack_require__(417);

ApplicationController.$inject = ['$scope', '$rootScope', '$timeout', 'cartonomyConfig', '$state', 'AuthenticationService', 'Session', 'ConfigurationService', 'CartService', 'UserProfile', 'OrderSetupService', 'Message', 'GroupOrder', 'RealTimeUpdateService', 'HeapService', 'LocalForageService', '$translate'];

function ApplicationController($scope, rootScope, timeout, cartonomyConfig, $state, authenticationService, sessionService, configurationService, cartService, userProfileService, orderSetupService, messageService, groupOrderService, RealTimeUpdateService, HeapService, localForageService, $translate) {
    var _this = this;

    var updateProperties = function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
            var getUserFromCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var setDefaultProfile, user;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            setDefaultProfile = function setDefaultProfile() {

                                $scope.profile = {
                                    name: '',
                                    welcome: 'Login',
                                    email: '',
                                    emails: '',
                                    addresses: '',
                                    avatar: ''
                                };
                            };

                            _context6.next = 3;
                            return sessionService.loggedIn();

                        case 3:
                            $scope.isGuest = !_context6.sent;
                            _context6.next = 6;
                            return sessionService.loggedIn();

                        case 6:
                            if (_context6.sent) {
                                _context6.next = 9;
                                break;
                            }

                            setDefaultProfile();
                            return _context6.abrupt('return');

                        case 9:
                            _context6.prev = 9;
                            _context6.next = 12;
                            return userProfileService.getUser(getUserFromCache);

                        case 12:
                            user = _context6.sent;
                            _context6.t0 = user.fullName;
                            _context6.t1 = user.firstName;
                            _context6.t2 = user.lastName;
                            _context6.t3 = $translate.instant('client.user.welcome', { firstName: user.firstName });
                            _context6.next = 19;
                            return sessionService.isInvite();

                        case 19:
                            _context6.t4 = _context6.sent;
                            _context6.t5 = user.email;
                            _context6.t6 = _.sortBy(user.userEmails, ['main', 'email']);
                            _context6.t7 = user.addresses;
                            _context6.t8 = user.avatarSrc || _CommonConstants2.default.DEFAULT_AVATAR_URL;
                            _context6.t9 = user.avatarCropped;
                            _context6.t10 = user.linkOAuthOnly;
                            _context6.t11 = user.linkedOAuth;
                            $scope.profile = {
                                name: _context6.t0,
                                firstName: _context6.t1,
                                lastName: _context6.t2,
                                welcome: _context6.t3,
                                isInvite: _context6.t4,
                                email: _context6.t5,
                                emails: _context6.t6,
                                addresses: _context6.t7,
                                avatar: _context6.t8,
                                avatarCropped: _context6.t9,
                                linkOAuthOnly: _context6.t10,
                                linkedOAuth: _context6.t11
                            };

                            if ($scope.profile.isInvite) {
                                $scope.profile.welcome += '. ' + $translate.instant('client.user.signup_here') + '.';
                            }

                            if (!$scope.$root.$$phase) {
                                $scope.$apply();
                            }
                            _context6.next = 35;
                            break;

                        case 32:
                            _context6.prev = 32;
                            _context6.t12 = _context6['catch'](9);

                            setDefaultProfile();

                        case 35:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this, [[9, 32]]);
        }));

        return function updateProperties() {
            return _ref6.apply(this, arguments);
        };
    }();

    var setOrderProperties = function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
            var properties;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.next = 2;
                            return cartService.getCartProperties();

                        case 2:
                            properties = _context7.sent;

                            $scope.groupOrderCreated = properties.isGroupOrder;
                            $scope.groupOrderTitle = properties.title;
                            $scope.singlePayGroupOrder = properties.singlePay;
                            $scope.groupOrderOwner = properties.isOwner;
                            _scope2.default.apply($scope);

                        case 8:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        return function setOrderProperties() {
            return _ref7.apply(this, arguments);
        };
    }();

    var setCartProperties = function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
            var getUserFromCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var cart, lastLeftCart, lastCartStatusResult;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            updateProperties(getUserFromCache);
                            setOrderProperties();

                            if (oldCart) {
                                _context8.next = 7;
                                break;
                            }

                            _context8.next = 5;
                            return cartService.getCart();

                        case 5:
                            oldCart = _context8.sent;
                            return _context8.abrupt('return');

                        case 7:
                            _context8.next = 9;
                            return cartService.getCart();

                        case 9:
                            cart = _context8.sent;
                            lastLeftCart = cartService.getLastLeftCart();
                            _context8.next = 13;
                            return cartService.getUserLastCart();

                        case 13:
                            lastCartStatusResult = _context8.sent;

                            if (!_.isEqual(_lastCartResult, lastCartStatusResult)) {
                                _context8.next = 16;
                                break;
                            }

                            return _context8.abrupt('return');

                        case 16:
                            if (!(lastCartStatusResult.status === 'CANCELLED' || lastCartStatusResult.status === 'ORDER_PLACED' && isExternalRetailer())) {
                                _context8.next = 18;
                                break;
                            }

                            return _context8.abrupt('return');

                        case 18:
                            if (!(lastCartStatusResult && lastCartStatusResult.message)) {
                                _context8.next = 22;
                                break;
                            }

                            _lastCartResult = lastCartStatusResult;
                            _context8.next = 22;
                            return messageService.showMessagePopup(lastCartStatusResult.message);

                        case 22:

                            oldCart = cart;

                        case 23:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        return function setCartProperties() {
            return _ref8.apply(this, arguments);
        };
    }();

    var userLoggedOut = function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            $scope.hideMessage();
                            setCartProperties(false);
                            rootScope.isLoggedin = false;

                        case 3:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));

        return function userLoggedOut() {
            return _ref9.apply(this, arguments);
        };
    }();

    var connectRealtimeUpdate = function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            $scope.hideMessage();
                            RealTimeUpdateService.ensureConnected();

                        case 2:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, this);
        }));

        return function connectRealtimeUpdate() {
            return _ref10.apply(this, arguments);
        };
    }();

    var checkAndConnectRealtimeUpdateIfNeeded = function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
            var isGroupOrder;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            _context11.next = 2;
                            return checkAndShowSafariWarning();

                        case 2:
                            _context11.next = 4;
                            return cartService.isGroupOrder();

                        case 4:
                            isGroupOrder = _context11.sent;

                            if (isGroupOrder) {
                                RealTimeUpdateService.ensureConnected();
                            }
                            rootScope.isLoggedin = true;

                        case 7:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, this);
        }));

        return function checkAndConnectRealtimeUpdateIfNeeded() {
            return _ref11.apply(this, arguments);
        };
    }();

    var checkAndShowSafariWarning = function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
            var user;
            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            _context12.next = 2;
                            return userProfileService.getUser();

                        case 2:
                            user = _context12.sent;


                            rootScope.isStoreAdmin = user.userType === _CommonConstants2.default.UserTypes.StoreAdmin || user.isUserAdmin;

                            if (!(!rootScope.isSafari() || rootScope.safariWarningShowed)) {
                                _context12.next = 6;
                                break;
                            }

                            return _context12.abrupt('return');

                        case 6:

                            if (user.showMacSafariMessage) {
                                rootScope.displaySafariWarning();
                            }

                        case 7:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, this);
        }));

        return function checkAndShowSafariWarning() {
            return _ref12.apply(this, arguments);
        };
    }();

    rootScope.cartonomyLogoSvg = cartonomyLogo;

    // Load retailer styles
    var defaultStylesLink = document.createElement("link");
    defaultStylesLink.type = "text/css";
    defaultStylesLink.rel = "stylesheet";
    defaultStylesLink.href = cartonomyConfig.backendEndPoint + '/api/styles/defaultStyle' + window.location.search;
    document.head.appendChild(defaultStylesLink);

    var retailerStylesLink = document.createElement("link");
    retailerStylesLink.type = "text/css";
    retailerStylesLink.rel = "stylesheet";
    retailerStylesLink.href = cartonomyConfig.backendEndPoint + '/api/styles/shopify' + window.location.search;
    document.head.appendChild(retailerStylesLink);

    // check if window is inside frame
    var isInIframe = window.self !== window.top;

    if (!isInIframe) {
        $scope.noError = true;
        if (!cartonomyConfig.externalStoreMode) {
            messageService.showErrorPopup('There has been an application error. Please return to your Shopify store.');
            return;
        }
        var url = window.location.protocol + '//' + cartonomyConfig.externalStoreUrl + '/' + window.location.hash;
        window.location.href = url;
        return;
    }

    $scope.siteName = '';
    $scope.logoImage = '';
    $scope.retailer = null;
    var _lastCartResult = null;
    var oldCart = void 0;

    $scope.isExternalRetailer = function () {
        return isExternalRetailer();
    };

    rootScope.isExternalRetailer = function () {
        return isExternalRetailer();
    };

    localForageService.retrieve(_CommonConstants2.default.SessionStorage.SAFARI_WARNING_SHOWED).then(function (safariWarning) {
        rootScope.safariWarningShowed = safariWarning || false;
    });

    rootScope.isMobile = function () {
        return (/ios|iphone|android/gi.test(navigator.userAgent)
        );
    };
    rootScope.isSafari = function () {
        return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
        );
    };

    rootScope.displaySafariWarning = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        rootScope.safariWarningIsShowing = true;
                        _context.next = 3;
                        return messageService.showMessagePopup($translate.instant('client.safari_warning'));

                    case 3:
                        rootScope.safariWarningIsShowing = false;
                        rootScope.safariWarningShowed = true;
                        _context.next = 7;
                        return localForageService.store(_CommonConstants2.default.SessionStorage.SAFARI_WARNING_SHOWED, true);

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    $scope.isCartOwner = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return cartService.isCartOwner();

                    case 2:
                        return _context2.abrupt('return', _context2.sent);

                    case 3:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this);
    }));
    sessionService.loggedIn().then(function (loggedIn) {
        rootScope.isLoggedin = loggedIn;
    });

    $scope.currentState = function () {
        return $state.current.name.replace(/\./g, '-');
    };

    $scope.onCartBagClicked = function () {
        if (isExternalRetailer()) {
            if ($scope.isCart()) {
                rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.CART_PAGE_REQUESTED);
            } else {
                $scope.showPopupBag();
                $state.go(_CommonConstants2.default.RoutingStates.CART);
            }
        } else {
            $scope.showPopupBag();
        }
    };

    $scope.showPopupBag = function () {
        $scope.$broadcast(_CommonConstants2.default.BroadcastMessages.TOGGLE_POPUP_BAG);
    };

    $scope.showCatalog = function () {
        $scope.$broadcast(_CommonConstants2.default.BroadcastMessages.HIDE_POPUP_BAG);
        $state.go(_CommonConstants2.default.RoutingStates.CATALOG);
    };

    $scope.showSplashScreen = function () {
        $scope.$broadcast(_CommonConstants2.default.BroadcastMessages.HIDE_POPUP_BAG);
        $scope.$broadcast(_CommonConstants2.default.Events.OPEN_SPLASH_SCREEN);
    };

    $scope.showChat = function () {
        $scope.$broadcast(_CommonConstants2.default.BroadcastMessages.HIDE_POPUP_BAG);
        $state.go(_CommonConstants2.default.RoutingStates.CHAT);
    };

    $scope.showVersionPage = function () {
        $scope.$broadcast(_CommonConstants2.default.BroadcastMessages.HIDE_POPUP_BAG);
        $state.go(_CommonConstants2.default.RoutingStates.ABOUT);
    };

    $scope.showAccount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        $scope.$broadcast(_CommonConstants2.default.BroadcastMessages.HIDE_POPUP_BAG);

                        _context3.next = 3;
                        return sessionService.isInvite();

                    case 3:
                        if (!_context3.sent) {
                            _context3.next = 10;
                            break;
                        }

                        _context3.t0 = authenticationService;
                        _context3.next = 7;
                        return sessionService.getUserEmail();

                    case 7:
                        _context3.t1 = _context3.sent;

                        _context3.t0.showSignupDialog.call(_context3.t0, _context3.t1);

                        return _context3.abrupt('return');

                    case 10:
                        _context3.next = 12;
                        return sessionService.loggedIn();

                    case 12:
                        _context3.t2 = !_context3.sent;

                        if (_context3.t2) {
                            _context3.next = 17;
                            break;
                        }

                        _context3.next = 16;
                        return sessionService.isInvite();

                    case 16:
                        _context3.t2 = _context3.sent;

                    case 17:
                        if (!_context3.t2) {
                            _context3.next = 21;
                            break;
                        }

                        _context3.next = 20;
                        return authenticationService.showLoginDialog();

                    case 20:
                        return _context3.abrupt('return');

                    case 21:
                        _context3.next = 23;
                        return authenticationService.ensureLoggedIn();

                    case 23:
                        $state.go(_CommonConstants2.default.RoutingStates.USER_PROFILE);

                    case 24:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this);
    }));

    $scope.showInvitedPeople = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        $scope.$broadcast(_CommonConstants2.default.BroadcastMessages.HIDE_POPUP_BAG);

                        _context4.next = 3;
                        return sessionService.isInvite();

                    case 3:
                        if (!_context4.sent) {
                            _context4.next = 10;
                            break;
                        }

                        _context4.t0 = authenticationService;
                        _context4.next = 7;
                        return sessionService.getUserEmail();

                    case 7:
                        _context4.t1 = _context4.sent;

                        _context4.t0.showSignupDialog.call(_context4.t0, _context4.t1);

                        return _context4.abrupt('return');

                    case 10:
                        _context4.next = 12;
                        return sessionService.loggedIn();

                    case 12:
                        _context4.t2 = !_context4.sent;

                        if (_context4.t2) {
                            _context4.next = 17;
                            break;
                        }

                        _context4.next = 16;
                        return sessionService.isInvite();

                    case 16:
                        _context4.t2 = _context4.sent;

                    case 17:
                        if (!_context4.t2) {
                            _context4.next = 21;
                            break;
                        }

                        _context4.next = 20;
                        return authenticationService.showLoginDialog();

                    case 20:
                        return _context4.abrupt('return');

                    case 21:
                        _context4.next = 23;
                        return authenticationService.ensureLoggedIn();

                    case 23:
                        $state.go(_CommonConstants2.default.RoutingStates.INVITED_PEOPLE);

                    case 24:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this);
    }));

    $scope.isCatalog = function () {
        return $state.is(_CommonConstants2.default.RoutingStates.CATALOG);
    };

    $scope.isCart = function () {
        return $state.is(_CommonConstants2.default.RoutingStates.CART) || !($scope.groupOrderCreated || $scope.isProfile());
    };

    $scope.isInvitePeople = function () {
        return $state.is(_CommonConstants2.default.RoutingStates.INVITED_PEOPLE);
    };

    $scope.isProfile = function () {
        return $state.is(_CommonConstants2.default.RoutingStates.USER_PROFILE);
    };

    $scope.isChat = function () {
        return $state.is(_CommonConstants2.default.RoutingStates.CHAT);
    };

    $scope.isCheckout = function () {
        return $state.is(_CommonConstants2.default.RoutingStates.CHECKOUT);
    };

    $scope.isShowTabButton = function () {
        return $scope.groupOrderCreated && !$scope.isCheckout() && !$scope.isDialogOpened && !$scope.isOrderFreezed;
    };

    $scope.isCatalogVisible = function () {
        return !isExternalRetailer() && !$scope.isCheckout();
    };

    $scope.isInvitedPeopleAvailable = function () {
        return $scope.groupOrderCreated && !$scope.isCheckout();
    };

    $scope.isProfileVisible = function () {
        return rootScope.isLoggedin && !$scope.isCheckout() && !$scope.isShowBackButton;
    };

    $scope.isCartVisible = function () {
        return rootScope.isLoggedin && !($scope.isDialogOpened && $scope.groupOrderCreated);
    };

    $scope.isChatVisible = function () {
        return $scope.groupOrderCreated && !$scope.isCheckout();
    };

    $scope.isCreateOrderVisible = function () {
        return !$scope.groupOrderCreated && !$scope.isCheckout();
    };

    $scope.isEditOrderVisible = function () {
        return $scope.groupOrderCreated && $scope.groupOrderOwner && !$scope.isCheckout();
    };

    $scope.createGroupOrder = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var result;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return orderSetupService.createOrder();

                    case 2:
                        result = _context5.sent;

                        if (!result || !result.stateToGo) $state.go(cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CHAT : _CommonConstants2.default.RoutingStates.CATALOG);else $state.go(result.stateToGo);

                    case 4:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this);
    }));

    $scope.editGroupOrder = function () {
        orderSetupService.editOrder(_CommonConstants2.default.OrderSetupTabs.DELIVERY_ADDRESS);
    };

    $scope.back = function () {
        rootScope.$broadcast(_CommonConstants2.default.Events.BACK_BUTTON_CLICKED);
    };

    $scope.hideMessage = function () {
        if (rootScope.headerMessage) {
            rootScope.headerMessage.resolve(true);
            rootScope.headerMessage = null;
        }
    };
    //CW-2252: improve load experience
    $scope.loading = null;

    $scope.isShowBackButton = false;
    $scope.isDialogOpened = false;


    function isExternalRetailer() {
        return cartonomyConfig.externalStoreMode;
    }

    function dialogOpened($event, showBackButton) {
        $scope.isShowBackButton = showBackButton;
        $scope.isDialogOpened = true;
    }

    function dialogClosed() {
        $scope.isShowBackButton = false;
        $scope.isDialogOpened = false;
        rootScope.storeWindowTitle = $state.current.windowTitle || '';
    }

    rootScope.$on(_CommonConstants2.default.RootEvents.CART_CHANGED, function () {
        return setCartProperties();
    });
    rootScope.$on(_CommonConstants2.default.RootEvents.USER_PROFILE_UPDATED, function () {
        return setCartProperties(false);
    });
    rootScope.$on(_CommonConstants2.default.Events.USER_LOGGED_OUT, function () {
        return userLoggedOut();
    });

    rootScope.$on(_CommonConstants2.default.Events.ORDER_CANCELLED, function () {
        return cancelRealtimeUpdate();
    });
    rootScope.$on(_CommonConstants2.default.Events.ORDER_CANCELLED_BY_OWNER, function () {
        return cancelRealtimeUpdate();
    });
    rootScope.$on(_CommonConstants2.default.Events.ORDER_CHECKED_OUT, function () {
        return cancelRealtimeUpdate();
    });
    rootScope.$on(_CommonConstants2.default.Events.LEFT_ORDER, function () {
        return cancelRealtimeUpdate();
    });

    rootScope.$on(_CommonConstants2.default.Events.ORDER_CREATED, function () {
        return connectRealtimeUpdate();
    });
    rootScope.$on(_CommonConstants2.default.Events.INVITATION_ACCEPTED, function () {
        return connectRealtimeUpdate();
    });
    rootScope.$on(_CommonConstants2.default.Events.DIALOG_OPENED, function ($event, showBackButton) {
        return dialogOpened($event, showBackButton);
    });
    rootScope.$on(_CommonConstants2.default.Events.DIALOG_CLOSED, function () {
        return dialogClosed();
    });
    rootScope.$on('$stateChangeStart', function (event, toState) {
        rootScope.storeWindowTitle = toState.windowTitle || '';
    });

    function cancelRealtimeUpdate() {
        $scope.hideMessage();
        RealTimeUpdateService.disconnect(true);
        RealTimeUpdateService.reset();
    }

    this.$onInit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var retailer, isGroupOrder, result;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        _context13.next = 2;
                        return messageService.showLoadingWhiteBackground();

                    case 2:
                        $scope.loading = _context13.sent;


                        HeapService.identify(sessionService.getAuthToken());

                        _context13.next = 6;
                        return configurationService.getItem('retailer');

                    case 6:
                        retailer = _context13.sent;

                        if (!(retailer.status !== 'Available')) {
                            _context13.next = 11;
                            break;
                        }

                        HeapService.track('CartonomyNotAvailable', { retailer: retailer });
                        window.parent.postMessage({
                            disableCartonomy: true
                        }, '*');
                        return _context13.abrupt('return');

                    case 11:
                        $scope.siteName = retailer.name;
                        $scope.logoImage = retailer.retailerImg;
                        $scope.retailer = retailer;
                        rootScope.retailer = retailer;

                        if (!cartonomyConfig.externalStoreMode) {
                            _context13.next = 19;
                            break;
                        }

                        $scope.externalStoreHandler = new _ExternalStoreHandler2.default($scope, rootScope, timeout, authenticationService, sessionService, cartService, groupOrderService, orderSetupService, $state, messageService, localForageService, HeapService, $translate);

                        _context13.next = 19;
                        return $scope.externalStoreHandler.initialize();

                    case 19:
                        _context13.next = 21;
                        return updateProperties(true);

                    case 21:
                        _context13.next = 23;
                        return setCartProperties();

                    case 23:
                        _context13.next = 25;
                        return cartService.isGroupOrder();

                    case 25:
                        isGroupOrder = _context13.sent;
                        _context13.next = 28;
                        return sessionService.loggedIn();

                    case 28:
                        if (!_context13.sent) {
                            _context13.next = 34;
                            break;
                        }

                        _context13.next = 31;
                        return checkAndShowSafariWarning();

                    case 31:
                        if (!isGroupOrder) {
                            _context13.next = 34;
                            break;
                        }

                        _context13.next = 34;
                        return connectRealtimeUpdate();

                    case 34:

                        rootScope.$on(_CommonConstants2.default.Events.USER_LOGGED_IN, function (scope) {
                            return checkAndConnectRealtimeUpdateIfNeeded();
                        });
                        if ($scope.loading) {
                            //CW-2252: improve load experience
                            $scope.loading.close();
                            $scope.loading = null;
                        }

                        _context13.next = 38;
                        return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.moneyFormatChange);

                    case 38:
                        result = _context13.sent;

                        rootScope.moneyFormat = result.moneyFormat;
                        _utils.utils.moneyFormat = result.moneyFormat;
                        rootScope.formatAmount = function (amount) {
                            if (!amount) {
                                return '';
                            }
                            return rootScope.moneyFormat.replace('{{amount}}', amount.toFixed(2));
                        };

                    case 42:
                    case 'end':
                        return _context13.stop();
                }
            }
        }, _callee13, _this);
    }));
}

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _communicationService = __webpack_require__(28);

var _commandKeys = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConfirmTicketController = function () {
    function ConfirmTicketController($scope, $stateParams, authenticationService, $state, messageService, sessionStorageService, $rootScope) {
        var _this = this;

        _classCallCheck(this, ConfirmTicketController);

        this._messageService = messageService;
        $scope.validated = false;
        $scope.success = true;
        $scope.inProgress = false;
        $scope.password = '';
        $scope.confirmPassword = '';
        $scope.errorMessage = '';
        this._rootScope = $rootScope;
        this._scope = $scope;
        this._sessionStorageService = sessionStorageService;
        $scope.continue = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this._sessionStorageService.clear(_CommonConstants2.default.SessionStorage.LAST_STATE_NAME);
                            $state.go(_CommonConstants2.default.RoutingStates.CART);

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        $scope.sendRequest = function (form) {
            if (!form.$valid) {
                form.highlightAllErrors();
                return;
            }

            $scope.inProgress = true;
            $scope.errorMessage = '';

            authenticationService.validatePasswordTicket($stateParams.ticket, $scope.password).then(function (response) {
                $scope.inProgress = false;
                $scope.success = response.success;
                $scope.validated = $scope.success;
                $scope.errorMessage = response.errorMessage;
                _this._scope.$apply();
            }).then(function () {
                return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.removeHashKey, {});
            }).catch(function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(error) {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    $scope.inProgress = false;
                                    $scope.validated = false;
                                    $scope.success = false;
                                    _this._messageService.showErrorPopupForResponse(error);
                                    _this._scope.$apply();
                                    _this._sessionStorageService.clear(_CommonConstants2.default.SessionStorage.LAST_STATE_NAME);
                                    _context2.next = 8;
                                    return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.removeHashKey, {});

                                case 8:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this);
                }));

                return function (_x) {
                    return _ref2.apply(this, arguments);
                };
            }());
        };
    }

    _createClass(ConfirmTicketController, [{
        key: '$onInit',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this._rootScope.storeWindowTitle = 'client.user.reset_password';
                                try {
                                    window.parent.postMessage({
                                        toggleWindowState: true,
                                        toggleWindowTrigger: 'titleBar'
                                    }, '*');
                                } catch (error) {
                                    console.log(error);
                                }

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function $onInit() {
                return _ref3.apply(this, arguments);
            }

            return $onInit;
        }()
    }]);

    return ConfirmTicketController;
}();

ConfirmTicketController.$inject = ['$scope', '$stateParams', 'AuthenticationService', '$state', 'Message', 'SessionStorage', '$rootScope'];


_module3.default.controller('Cartonomy.Shared.ConfirmTicketController', ConfirmTicketController);

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoginController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _utils = __webpack_require__(29);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pages = [{
    id: 'login',
    fileName: 'loginPage',
    isShowBackButton: false,
    title: 'Sign In'
}, {
    id: 'presignup',
    fileName: 'preSignupPage',
    isShowBackButton: false,
    title: 'Sign Up'
}, {
    id: 'signup',
    fileName: 'signupPage',
    isShowBackButton: true,
    prevPage: 'presignup',
    title: 'Sign Up with Email'
}, {
    id: 'forgot',
    fileName: 'forgotPasswordPage',
    isShowBackButton: false,
    title: 'Forgot Password'
}, {
    id: 'message',
    fileName: 'messagePage',
    isShowBackButton: false,
    title: 'Message'
}, {
    id: 'facade',
    fileName: 'loginFacadePage',
    isShowBackButton: false,
    title: 'Group Order'
}, {
    id: 'inviteFacade',
    fileName: 'inviteFacadePage',
    isShowBackButton: false,
    title: 'Join Group Order'
}];

var LoginController = exports.LoginController = function () {
    function LoginController(scope, rootScope, stateService, cartonomyConfig, localForageService, dialogService, authenticationService, email, cartService, currentPage, createOrderFlow, $http, MessageService, SessionService, UserProfileService, invitedCart, $translate) {
        var _this = this;

        _classCallCheck(this, LoginController);

        this._scope = scope;
        this._cartService = cartService;
        this._dialogService = dialogService;
        this._authenticationService = authenticationService;
        this._scope.emailPattern = _CommonConstants2.default.EMAIL_REGEX;
        this._rootScope = rootScope;
        this.dialogMode = !!dialogService;
        this._cartonomyConfig = cartonomyConfig;
        this._currentPage = currentPage;
        this._stateService = stateService;
        //this._sessionStorageService = SessionStorage;
        this._localForageService = localForageService;
        this._messageService = MessageService;
        this._sessionService = SessionService;
        this._userProfileService = UserProfileService;
        this._invitedCart = invitedCart;
        this.$translate = $translate;

        scope.isExternalStore = function () {
            return _this._cartonomyConfig.externalStoreMode;
        };
        scope.openIds = this._authenticationService.getOpenIdProviders();

        scope.$on(_CommonConstants2.default.Events.VERSION_PAGE_REQUESTED, function () {
            dialogService.cancel();
        });

        if (rootScope.retailer) {
            scope.customLoginText = rootScope.retailer.customLoginText;
        }

        this._pages = pages.map(function (page) {
            page.template = 'modules/shared/views/' + page.fileName + '.html';
            $http.get(page.template);
            return page;
        });

        // onboarding
        scope.onboarding = {
            steps: 5,
            currentStep: 0
        };

        scope.onboardingNextStep = function () {
            scope.onboarding.currentStep++;
        };

        scope.onboardingPreviousStep = function () {
            scope.onboarding.currentStep--;
        };

        scope.goToOnboardingStep = function (step) {
            scope.onboarding.currentStep = step;
        };

        scope.pageVersion = 0;
        scope.inProgress = false;
        scope.requestSent = false;
        scope.createOrderFlow = createOrderFlow;

        scope.credentials = {
            email: email,
            password: ''
        };

        scope.presignup = {
            email: email
        };

        scope.signup = {
            email: email,
            password: '',
            firstName: '',
            lastName: '',
            fullName: '',
            confirmPassword: ''
        };

        scope.message = '';
        scope.resetLocalCart = false;
        scope.loggingInWithOpenId = false;

        // scope.setCurrentPage = _.debounce(id => this._setCurrentPage(id), 300);
        scope.setCurrentPage = function (id) {
            return _this._setCurrentPage(id);
        };

        scope.cancel = function () {
            if (scope.isExternalStore()) {
                _this._rootScope.toggleWindowState();
            } else {
                dialogService.cancel({
                    cancel: true
                });
            }
        };

        scope.loginOpenId = function (provider) {
            scope.loggingInWithOpenId = true;
            var externalLogin = authenticationService.externalLogin(provider);
            window.open('' + externalLogin, 'social_login_facebook');
        };

        scope.setForgotPage = function () {
            _this._setCurrentPage('forgot');
            scope.requestSent = false;
            scope.inProgress = false;
        };

        this._continueState = '';

        scope.messageContinue = function () {
            if (_this._continueState === 'signup') {
                dialogService.close();
            } else if (_this._continueState === 'forget') {
                _this._setCurrentPage('login');
            }
        };

        scope.login = function (form) {
            return _this._login(form);
        };

        scope.inputFieldKeyPressed = function (event, form) {
            if (event.which !== 13) {
                return;
            }

            scope.login(form);
        };

        scope.sendForgotRequest = function (form) {
            return _this._sendForgotRequest(form);
        };

        scope.preRegisterUser = function (form) {
            return _this._preRegisterUser(form);
        };
        scope.registerUser = function (form) {
            return _this._registerUser(form);
        };
        scope.cancelInvitation = function () {
            return _this.cancelInvitation();
        };
        scope.isBeingInvited = function () {
            return _this.isBeingInvited();
        };
        scope.vm = this;

        this.onOAuthResponseCallback = function (event) {
            return _this.onOAuthResponse(event);
        };
        window.addEventListener('message', this.onOAuthResponseCallback);

        rootScope.$on(_CommonConstants2.default.Events.BACK_BUTTON_CLICKED, function () {
            return _this._back();
        });

        scope.$on("$destroy", function () {
            window.removeEventListener('message', scope.vm.onOAuthResponseCallback);
        });
    }

    _createClass(LoginController, [{
        key: '$onInit',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this._rootScope.$broadcast(_CommonConstants2.default.Events.DIALOG_OPENED, this._currentPage && this._currentPage.isShowBackButton || false);
                                if (this._invitedCart) {
                                    this._scope.noBudgetMode = this._rootScope.retailer && this._rootScope.retailer.noBudgetMode;
                                    this._scope.deadline = this._invitedCart.closeOn && (0, _moment2.default)(this._invitedCart.closeOn).format('L LT') || 'client.unlimited';
                                    this._scope.budget = this._invitedCart.orderLimit && this._rootScope.formatAmount(this._invitedCart.orderLimit) || 'client.unlimited';
                                    this._scope.orderTitle = this._invitedCart.cartName || this._invitedCart.title;
                                    console.log(this._invitedCart);
                                    this._scope.payerTitle = this._invitedCart.fulfillment && this._invitedCart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.SELF || this._invitedCart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.MIXED ? 'client.order.group_member_pay' : 'client.order.group_owner_pay';
                                    this._setCurrentPage('inviteFacade');
                                } else {
                                    this._rootScope.isLoggedin = false;
                                    this._setCurrentPage(this._currentPage || 'login');
                                }

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function $onInit() {
                return _ref.apply(this, arguments);
            }

            return $onInit;
        }()
    }, {
        key: 'onOAuthResponse',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(response) {
                var responseData, authToken, user, linkingSocialAccount;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(response.data.eventType !== 'OAuthResult')) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _context2.next = 4;
                                return this._sessionService.loggedIn();

                            case 4:
                                if (!_context2.sent) {
                                    _context2.next = 6;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 6:
                                responseData = response.data;
                                authToken = responseData.token;

                                if (!(!authToken && responseData.errorMessage)) {
                                    _context2.next = 12;
                                    break;
                                }

                                this._messageService.showErrorPopup(responseData.errorMessage);
                                this._setCurrentPage(this._currentPage || 'login');
                                return _context2.abrupt('return');

                            case 12:

                                window.removeEventListener('message', this.onOAuthResponseCallback);
                                _context2.prev = 13;
                                _context2.next = 16;
                                return this._authenticationService.externalLoginFinalize(authToken);

                            case 16:
                                _context2.next = 24;
                                break;

                            case 18:
                                _context2.prev = 18;
                                _context2.t0 = _context2['catch'](13);

                                this._messageService.showErrorPopupForResponse(_context2.t0);
                                if (this.dialogMode) {
                                    this._dialogService.hide();
                                }
                                this._stateService.go(_CommonConstants2.default.RoutingStates.CART);
                                return _context2.abrupt('return');

                            case 24:
                                _context2.next = 26;
                                return this._sessionService.clearSessionDetails();

                            case 26:
                                _context2.t1 = this._sessionService;
                                _context2.t2 = authToken;
                                _context2.next = 30;
                                return this._sessionService.getUserEmail();

                            case 30:
                                _context2.t3 = _context2.sent;
                                _context2.next = 33;
                                return this._sessionService.getUserName();

                            case 33:
                                _context2.t4 = _context2.sent;
                                _context2.t5 = {
                                    authToken: _context2.t2,
                                    userEmail: _context2.t3,
                                    userName: _context2.t4
                                };
                                _context2.next = 37;
                                return _context2.t1.setSessionDetails.call(_context2.t1, _context2.t5);

                            case 37:
                                this._userProfileService.resetUser();
                                _context2.next = 40;
                                return this._userProfileService.getUser();

                            case 40:
                                user = _context2.sent;
                                _context2.next = 43;
                                return this._sessionService.setSessionDetails({
                                    authToken: authToken,
                                    userEmail: user.email,
                                    userName: user.fullName,
                                    firstName: user.firstName,
                                    lastName: user.lastName
                                });

                            case 43:
                                _context2.next = 45;
                                return this._cartService.clearLocalCart();

                            case 45:
                                _context2.next = 47;
                                return this._cartService.resetCart();

                            case 47:

                                this._rootScope.$broadcast(_CommonConstants2.default.Events.USER_LOGGED_IN);
                                this._rootScope.storeWindowTitle = null;
                                if (this.dialogMode) {
                                    this._dialogService.hide(true);
                                }

                                // let awaitingInvitation = null;
                                // if(utils.hash.indexOf('#/invite/') > -1){
                                //     awaitingInvitation = JSON.stringify({participantToken : utils.hash.replace('#/invite/','') });
                                // }
                                // if (awaitingInvitation) {
                                //     this._stateService.go(Constants.RoutingStates.INVITE, JSON.parse(awaitingInvitation));
                                //     return;
                                // }

                                _context2.next = 52;
                                return this._localForageService.retrieve(_CommonConstants2.default.SessionStorage.LINKING_SOCIAL_ACCOUNT);

                            case 52:
                                linkingSocialAccount = _context2.sent;

                                if (!linkingSocialAccount) {
                                    _context2.next = 58;
                                    break;
                                }

                                _context2.next = 56;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.LINKING_SOCIAL_ACCOUNT);

                            case 56:
                                this._stateService.go(_CommonConstants2.default.RoutingStates.USER_PROFILE);
                                return _context2.abrupt('return');

                            case 58:

                                this._sessionService.setCartReference(null);
                                this._stateService.go(_CommonConstants2.default.RoutingStates.CART);

                            case 60:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[13, 18]]);
            }));

            function onOAuthResponse(_x) {
                return _ref2.apply(this, arguments);
            }

            return onOAuthResponse;
        }()
    }, {
        key: 'isBeingInvited',
        value: function isBeingInvited() {
            this._localForageService.exists(_CommonConstants2.default.SessionStorage.AwaitingInvitation).then(function (exist) {
                return exist;
            });
        }
    }, {
        key: 'cancelInvitation',
        value: function cancelInvitation() {
            this._rootScope.$broadcast(_CommonConstants2.default.Events.CANCEL_INVITATION);
        }
    }, {
        key: '_setCurrentPage',
        value: function _setCurrentPage(id) {
            this._scope.errorMessage = '';
            this._scope.page = this._pages.find(function (page) {
                return page.id === id;
            });
            this._rootScope.storeWindowTitle = this._scope.page.title;
            console.log('Set to ' + this._scope.page.title);
            this._scope.resetLocalCart = false;
            this._rootScope.$broadcast(_CommonConstants2.default.Events.DIALOG_OPENED, this._scope.page.isShowBackButton);
            _scope2.default.apply(this._scope);
        }
    }, {
        key: '_back',
        value: function _back() {
            if (this._scope.page.id === 'signup') {
                this._scope.presignup.email = this._scope.signup.email;
            }
            this._setCurrentPage(this._scope.page.prevPage || this._scope.page.id);
        }
    }, {
        key: '_showErrorMessage',
        value: function _showErrorMessage(text) {
            this._scope.errorMessage = text || this.$translate.instant('client.error.server_connect');
            _scope2.default.apply(this._scope);
        }
    }, {
        key: '_handleLoggedIn',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(executor, isRegistration) {
                var message;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return executor();

                            case 3:
                                this._scope.inProgress = false;
                                _context3.next = 6;
                                return this._cartService.getCart();

                            case 6:
                                this._rootScope.$broadcast(_CommonConstants2.default.Events.USER_LOGGED_IN, isRegistration);

                                if (this.dialogMode) {
                                    this._dialogService.hide();
                                    this._rootScope.storeWindowTitle = null;
                                }

                                // CW-2616: join order with link has bugs
                                // let awaitingInvitation = null;
                                // if(utils.hash.indexOf('#/invite/') > -1){
                                //     awaitingInvitation = JSON.stringify({participantToken : utils.hash.replace('#/invite/','') });
                                // }
                                // if (awaitingInvitation) {
                                //     this._stateService.go(Constants.RoutingStates.INVITE, JSON.parse(awaitingInvitation));
                                //     return;
                                // }
                                _context3.next = 20;
                                break;

                            case 10:
                                _context3.prev = 10;
                                _context3.t0 = _context3['catch'](0);

                                if (!(_context3.t0.status === 409)) {
                                    _context3.next = 17;
                                    break;
                                }

                                // cart merge conflict
                                this._scope.resetLocalCart = true;
                                this._scope.inProgress = false;
                                this._showErrorMessage(this.$translate.instant('client.order.pageid', { pageId: this._scope.page.id }));
                                return _context3.abrupt('return', null);

                            case 17:

                                this._scope.inProgress = false;
                                message = _context3.t0 && _context3.t0.status === 404 ? this.$translate.instant('client.error.invali_cred') : _context3.t0.data && _context3.t0.data.message;


                                this._showErrorMessage(message);

                            case 20:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 10]]);
            }));

            function _handleLoggedIn(_x2, _x3) {
                return _ref3.apply(this, arguments);
            }

            return _handleLoggedIn;
        }()
    }, {
        key: '_login',
        value: function _login(form) {
            var _this2 = this;

            if (form.$invalid) {
                form.highlightAllErrors();
                return;
            }

            this._scope.inProgress = true;
            this._scope.errorMessage = '';

            var credentials = {
                username: this._scope.credentials.email,
                password: this._scope.credentials.password
            };

            return this._handleLoggedIn(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _this2._authenticationService.loginRequest(credentials, _this2._scope.resetLocalCart);

                            case 2:
                                return _context4.abrupt('return', _context4.sent);

                            case 3:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this2);
            })));
        }
    }, {
        key: '_sendForgotRequest',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(form) {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!this._scope.inProgress) {
                                    _context5.next = 2;
                                    break;
                                }

                                return _context5.abrupt('return', null);

                            case 2:
                                if (!form.$invalid) {
                                    _context5.next = 5;
                                    break;
                                }

                                form.highlightAllErrors();
                                return _context5.abrupt('return', null);

                            case 5:

                                this._scope.inProgress = true;
                                this._scope.errorMessage = '';

                                _context5.prev = 7;
                                _context5.next = 10;
                                return this._authenticationService.sendValidateRequest(this._scope.credentials.email);

                            case 10:
                                _context5.next = 12;
                                return this._messageService.showAlertPopup(this.$translate.instant('client.forgot_password.success'), this.$translate.instant('client.ok'));

                            case 12:

                                this._setCurrentPage('login');

                                this._scope.inProgress = false;
                                this._scope.requestSent = true;
                                _scope2.default.apply(this._scope);
                                _context5.next = 24;
                                break;

                            case 18:
                                _context5.prev = 18;
                                _context5.t0 = _context5['catch'](7);

                                this._scope.errorMessage = this.$translate.instant('client.error.reset_password');
                                this._scope.inProgress = false;
                                this._scope.requestSent = false;
                                _scope2.default.apply(this._scope);

                            case 24:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[7, 18]]);
            }));

            function _sendForgotRequest(_x4) {
                return _ref5.apply(this, arguments);
            }

            return _sendForgotRequest;
        }()
    }, {
        key: '_preRegisterUser',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(form) {
                var response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!this._scope.inProgress) {
                                    _context6.next = 2;
                                    break;
                                }

                                return _context6.abrupt('return');

                            case 2:
                                if (!form.$invalid) {
                                    _context6.next = 5;
                                    break;
                                }

                                form.highlightAllErrors();
                                return _context6.abrupt('return');

                            case 5:

                                this._scope.inProgress = true;
                                this._scope.errorMessage = '';

                                _context6.next = 9;
                                return this._authenticationService.checkIfEmailCanRegister(this._scope.presignup.email);

                            case 9:
                                response = _context6.sent;

                                this._scope.inProgress = false;

                                if (response.data.canRegister) {
                                    this._scope.signup.email = response.data.email;
                                    this._setCurrentPage('signup');
                                } else {
                                    if (response.data.errorCode === 1) {
                                        // invalid email address
                                        this._showErrorMessage(response.data.errorMessage);
                                    } else if (response.data.errorCode === 2) {
                                        // Oauth user existing
                                        this._scope.credentials.email = response.data.email;
                                        this._setCurrentPage('login');
                                        this._showErrorMessage(response.data.errorMessage);
                                    } else if (response.data.errorCode === 3) {
                                        // user existing
                                        this._scope.credentials.email = response.data.email;
                                        this._setCurrentPage('login');
                                        this._showErrorMessage(response.data.errorMessage);
                                    } else {
                                        // should not go to this case
                                        this._showErrorMessage(response.data.errorMessage);
                                    }
                                }

                                this._scope.presignup.email = '';

                            case 13:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function _preRegisterUser(_x5) {
                return _ref6.apply(this, arguments);
            }

            return _preRegisterUser;
        }()
    }, {
        key: '_registerUser',
        value: function _registerUser(form) {
            var _this3 = this;

            if (this._scope.inProgress) {
                return;
            }

            if (form.$invalid) {
                form.highlightAllErrors();
                return;
            }

            this._scope.inProgress = true;
            this._scope.errorMessage = '';

            return this._handleLoggedIn(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return _this3._authenticationService.register(_this3._scope.signup, _this3._scope.resetLocalCart);

                            case 2:
                                return _context7.abrupt('return', _context7.sent);

                            case 3:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this3);
            })), true);
        }
    }]);

    return LoginController;
}();

LoginController.$inject = ['$scope', '$rootScope', '$state', 'cartonomyConfig', 'LocalForageService', '$mdDialog', 'AuthenticationService', 'email', 'CartService', 'currentPage', 'createOrderFlow', '$http', 'Message', 'Session', 'UserProfile', 'invitedCart', '$translate'];


_module3.default.controller('Cartonomy.Shared.LoginController', LoginController);

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoginTicketController = undefined;

var LoginTicketController = exports.LoginTicketController = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(sessionService, localForageService, cartService, $state, $stateParams, authenticationService, messageService, userProfileService, cartonomyConfig, $rootScope) {
        var checkCartAndGo = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var cartExists, stateToGo;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return cartService.isGroupOrder();

                            case 2:
                                cartExists = _context.sent;
                                stateToGo = cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CHAT : _CommonConstants2.default.RoutingStates.CATALOG;

                                if (!cartExists && cartonomyConfig.externalStoreMode) {
                                    stateToGo = _CommonConstants2.default.RoutingStates.CART;
                                }
                                $rootScope.$broadcast(_CommonConstants2.default.Events.USER_LOGGED_IN);
                                $state.go(stateToGo);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            return function checkCartAndGo() {
                return _ref2.apply(this, arguments);
            };
        }();

        var isInIframe, authToken, user, awaitingInvitation, linkingSocialAccount;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        if (!cartonomyConfig.externalStoreMode) {
                            _context2.next = 4;
                            break;
                        }

                        isInIframe = window.self !== window.top;

                        if (isInIframe) {
                            _context2.next = 4;
                            break;
                        }

                        return _context2.abrupt('return');

                    case 4:
                        authToken = $stateParams.authToken;

                        if (!(!authToken && $stateParams.errorMessage)) {
                            _context2.next = 16;
                            break;
                        }

                        _context2.next = 8;
                        return messageService.showErrorPopup($stateParams.errorMessage);

                    case 8:
                        _context2.next = 10;
                        return sessionService.loggedIn();

                    case 10:
                        if (_context2.sent) {
                            _context2.next = 13;
                            break;
                        }

                        _context2.next = 13;
                        return authenticationService.showLoginDialog();

                    case 13:
                        _context2.next = 15;
                        return checkCartAndGo();

                    case 15:
                        return _context2.abrupt('return');

                    case 16:
                        _context2.next = 18;
                        return authenticationService.waitForLogin();

                    case 18:
                        _context2.prev = 18;
                        _context2.next = 21;
                        return authenticationService.externalLoginFinalize(authToken);

                    case 21:
                        _context2.next = 29;
                        break;

                    case 23:
                        _context2.prev = 23;
                        _context2.t0 = _context2['catch'](18);
                        _context2.next = 27;
                        return messageService.showErrorPopupForResponse(_context2.t0);

                    case 27:
                        $state.go(_CommonConstants2.default.RoutingStates.CATALOG);
                        return _context2.abrupt('return');

                    case 29:
                        _context2.next = 31;
                        return cartService.clearLocalCart();

                    case 31:
                        _context2.next = 33;
                        return sessionService.clearSessionDetails();

                    case 33:
                        _context2.t1 = sessionService;
                        _context2.t2 = authToken;
                        _context2.next = 37;
                        return sessionService.getUserEmail();

                    case 37:
                        _context2.t3 = _context2.sent;
                        _context2.next = 40;
                        return sessionService.getUserName();

                    case 40:
                        _context2.t4 = _context2.sent;
                        _context2.t5 = {
                            authToken: _context2.t2,
                            userEmail: _context2.t3,
                            userName: _context2.t4
                        };
                        _context2.next = 44;
                        return _context2.t1.setSessionDetails.call(_context2.t1, _context2.t5);

                    case 44:

                        userProfileService.resetUser();
                        _context2.next = 47;
                        return userProfileService.getUser();

                    case 47:
                        user = _context2.sent;
                        _context2.next = 50;
                        return sessionService.setSessionDetails({
                            authToken: authToken,
                            userEmail: user.email,
                            userName: user.fullName,
                            firstName: user.firstName,
                            lastName: user.lastName
                        });

                    case 50:
                        _context2.next = 52;
                        return localForageService.retrieve(_CommonConstants2.default.SessionStorage.AwaitingInvitation);

                    case 52:
                        awaitingInvitation = _context2.sent;

                        if (!awaitingInvitation) {
                            _context2.next = 56;
                            break;
                        }

                        $state.go(_CommonConstants2.default.RoutingStates.INVITE, JSON.parse(awaitingInvitation));
                        return _context2.abrupt('return');

                    case 56:
                        _context2.next = 58;
                        return localForageService.retrieve(_CommonConstants2.default.SessionStorage.LINKING_SOCIAL_ACCOUNT);

                    case 58:
                        linkingSocialAccount = _context2.sent;

                        if (!linkingSocialAccount) {
                            _context2.next = 64;
                            break;
                        }

                        _context2.next = 62;
                        return localForageService.remove(_CommonConstants2.default.SessionStorage.LINKING_SOCIAL_ACCOUNT);

                    case 62:
                        $state.go(_CommonConstants2.default.RoutingStates.USER_PROFILE);
                        return _context2.abrupt('return');

                    case 64:

                        sessionService.setCartReference(null);
                        _context2.next = 67;
                        return checkCartAndGo();

                    case 67:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this, [[18, 23]]);
    }));

    return function LoginTicketController(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x10) {
        return _ref.apply(this, arguments);
    };
}();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

LoginTicketController.$inject = ['Session', 'LocalForageService', 'CartService', '$state', '$stateParams', 'AuthenticationService', 'Message', 'UserProfile', 'cartonomyConfig', '$rootScope'];

_module3.default.controller('Cartonomy.Shared.LoginTicketController', LoginTicketController);

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CategoryHeaderDirectiveController = function () {
    function CategoryHeaderDirectiveController(scope, catalogService, messageService, rootScope) {
        var _this = this;

        _classCallCheck(this, CategoryHeaderDirectiveController);

        this._scope = scope;
        this._rootScope = rootScope;
        this._catalogService = catalogService;
        this._messageService = messageService;

        scope.searchInProgress = false;
        scope.categoryName = "";
        scope.categoryId = 0;
        rootScope.categoryId = 0;
        scope.categories = [];
        rootScope.searchString = "";

        scope.clearSearch = function () {
            return _this._clearSearch();
        };

        scope.$watch('categoryId', function (categoryId) {
            rootScope.categoryId = categoryId;
            var category = _.find(scope.categories, { id: parseInt(categoryId) });
            scope.categoryName = category ? category.name : '';
        });
    }

    _createClass(CategoryHeaderDirectiveController, [{
        key: '$onInit',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._loadCategories();

                            case 2:
                                _scope2.default.apply(this._scope);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function $onInit() {
                return _ref.apply(this, arguments);
            }

            return $onInit;
        }()
    }, {
        key: '_clearSearch',
        value: function _clearSearch() {
            this._scope.searchInProgress = false;
            this._scope.searchString = '';
        }
    }, {
        key: '_loadCategories',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var category;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return this._catalogService.getAllCategories();

                            case 3:
                                this._scope.categories = _context2.sent;
                                _context2.next = 6;
                                return this._catalogService.getDefaultCategory();

                            case 6:
                                this._scope.categoryName = _context2.sent;
                                category = _.find(this._scope.categories, { name: this._scope.categoryName });

                                this._scope.categoryId = category ? category.id : this._scope.categories[0].id;
                                _context2.next = 14;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2['catch'](0);

                                this._messageService.showErrorPopupForResponse(_context2.t0);

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 11]]);
            }));

            function _loadCategories() {
                return _ref2.apply(this, arguments);
            }

            return _loadCategories;
        }()
    }]);

    return CategoryHeaderDirectiveController;
}();

CategoryHeaderDirectiveController.$inject = ['$scope', 'CatalogService', 'Message', '$rootScope'];


_module3.default.directive('categoryHeader', function () {
    return {
        scope: true,
        templateUrl: 'modules/shared/views/categoryHeader.html',
        controller: CategoryHeaderDirectiveController
    };
});

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('focusMe', ['$timeout', function ($timeout) {
    return {
        scope: {
            focusMe: '='
        },
        link: function link($scope, element) {
            $scope.$watch('focusMe', function (newValue) {
                if (newValue === 0) {
                    return;
                }
                $timeout(function () {
                    element[0].focus();
                }, 800);
            });
        }
    };
}]);

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FooterDirectiveController = undefined;

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FooterDirectiveController = exports.FooterDirectiveController = function FooterDirectiveController($scope, configurationService, cartonomyConfig) {
    _classCallCheck(this, FooterDirectiveController);

    $scope.addresses = [];
    $scope.hours = [];
    $scope.externalStoreMode = cartonomyConfig.externalStoreMode;
    $scope.currentYear = new Date().getFullYear();

    configurationService.getItem('addresses').then(function (addresses) {
        $scope.addresses = addresses;
    });

    configurationService.getItem('storeHours').then(function (hours) {

        _.each(hours, function (hour) {
            hour.open = hour.open ? (0, _moment2.default)(hour.open).format('LT') : '';
            hour.close = hour.close ? (0, _moment2.default)(hour.close).format('LT') : '';
        });

        $scope.hours = hours;
    });
};

FooterDirectiveController.$inject = ['$scope', 'ConfigurationService', 'cartonomyConfig'];


_module3.default.directive('cartonomyFooter', function () {
    return {
        template: __webpack_require__(663),
        controller: FooterDirectiveController
    };
});

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "<div class=\"footer flex-row\"><div class=\"footer-link\"><a class=\"clickable\" href=\"faq.html\" target=\"_blank\">{{'client.faq' | translate}}</a></div><div class=\"flex-row centered-items\"><div class=\"footer-link\"><a ng-click=\"showVersionPage()\">&copy;{{currentYear}} &nbsp;</a></div><div class=\"footer-link clickable\"><a class=\"clickable\" href=\"https://cartonomy.com/privacy-policy\" target=\"_blank\">{{'client.about.privacy_policy' | translate}}</a></div><div class=\"footer-link\"><a>&nbsp; | &nbsp;</a></div><div class=\"footer-link\"><a>{{'client.about.right_reserved' | translate}}</a></div></div></div>"

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HeaderDirectiveController($scope, $window, $document, $rootScope) {

    $scope.onScroll = false;

    $scope.scrollToTop = function () {
        $window.scrollTo(0, 0);
    };

    function getElementsByClassName(className) {
        return $document[0].getElementsByClassName(className);
    }

    function handleWindowResize() {

        var document = $document[0];
        var header = document.getElementById('header');
        var footer = document.getElementById('footer');
        var body = $document.find('body')[0];
        var contents = document.getElementById('contents');

        $rootScope.contentsMinHeight = body.offsetHeight - header.offsetHeight - footer.offsetHeight;
    }

    $rootScope.$on(_CommonConstants2.default.Events.WINDOW_WIDTH_CHANGED, handleWindowResize);
    // $rootScope.$on(Constants.Events.GROUP_ORDER_STATUS_CHANGED, () => {
    //     calculateNavbarHeight();
    //     $timeout(() => calculateNavbarHeight(), 200);
    //     $timeout(() => calculateNavbarHeight(), 400);
    // });

    $rootScope.$on(_CommonConstants2.default.Events.WINDOW_SCROLL, function ($event, scrollTop) {
        $scope.onScroll = scrollTop > 0;
    });

    $scope.$on('groupOrderCreated', function () {
        handleWindowResize();
    });
}

_module3.default.directive('cartonomyHeader', function () {
    return {
        // templateUrl: 'modules/shared/views/header.html',
        template: __webpack_require__(665)(),
        controller: ['$scope', '$window', '$document', '$rootScope', HeaderDirectiveController]
    };
});

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__(41);

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"header flex-column\"><div class=\"flex-row center-items header-items-block\"><button ng-if=\"isShowBackButton\" ng-click=\"back()\" class=\"icon-btn\"><svg width=\"12\" height=\"19\" viewBox=\"0 0 12 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.7807 0.284433C11.0983 0.637255 11.0698 1.18081 10.717 1.49849L2.16708 9.19689L10.717 16.8953C11.0698 17.213 11.0983 17.7565 10.7807 18.1093C10.463 18.4622 9.91942 18.4907 9.5666 18.173L0.473084 9.98513C0.380389 9.93848 0.29464 9.87413 0.22102 9.79237C0.068132 9.62257 -0.00457898 9.4086 0.000453547 9.19688C-0.00457519 8.98518 0.0681358 8.77121 0.22102 8.60141C0.29464 8.51965 0.380389 8.4553 0.473083 8.40865L9.5666 0.220808C9.91942 -0.0968742 10.463 -0.068388 10.7807 0.284433Z\" fill=\"#54636C\"/>\n</svg>\n</button><button ng-click=\"toggleProfilePage()\" ng-if=\"isProfileVisible()\" class=\"icon-btn\"><img ng-if=\"profile.avatarCropped\" ng-src=\"{{ profile.avatarCropped }}\" ng-class=\"isProfile() ? 'active' : ''\" class=\"header-avatar-img header-avatar\"><div ng-if=\"!profile.avatarCropped\" ng-class=\"isProfile() ? 'active' : ''\" class=\"header-avatar avatar-label\">{{profile.firstName[0]}}</div></button><label ng-click=\"createGroupOrderIfNeeded($event)\" ng-class=\"{'center-text': !isShowTabButton()}\" class=\"window-title\">{{(storeWindowTitle || '') | translate}}</label><div class=\"header-btn-block flex-row\"><div ng-if=\"isShowTabButton()\" class=\"chat-counter-placeholder\"><chat-counter></chat-counter></div><button ng-click=\"toggleChat()\" ng-class=\"isChat() ? 'active' : ''\" ng-if=\"isShowTabButton()\" class=\"tab-btn icon-btn\"><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M15.3 0H1.7C0.765 0 0 0.765 0 1.7V17L3.4 13.6H15.3C16.235 13.6 17 12.835 17 11.9V1.7C17 0.765 16.235 0 15.3 0Z\" fill=\"#C9CFD2\"/>\n</svg>\n</button><button ng-click=\"toggleInvitedPeoplePage()\" ng-class=\"isInvitePeople() ? 'active' : ''\" ng-show=\"isShowTabButton()\" class=\"tab-btn icon-btn\"><?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n<svg width=\"23px\" height=\"20px\" viewBox=\"0 0 23 20\" fill=\"none\" \n    xmlns=\"http://www.w3.org/2000/svg\" \n    xmlns:xlink=\"http://www.w3.org/1999/xlink\" \n    xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n    <path d=\"M16.4971 0C16.4879 0 16.4786 4.1176e-05 16.4694 8.23974e-05C15.5259 0.00746102 14.6447 0.383853 13.988 1.06001C13.3429 1.72421 12.9921 2.60045 13.0001 3.52727C13.0083 4.45409 13.3743 5.32472 14.0309 5.97882C14.6928 6.63799 15.5694 7 16.5024 7C16.5118 7 16.5212 6.99996 16.5306 6.99992C17.4741 6.99254 18.3553 6.61611 19.012 5.93999C19.6571 5.27579 20.0079 4.39955 19.9999 3.47269C19.9831 1.55202 18.4145 0 16.4971 0Z\" fill=\"#C9CFD2\"/>\n    <path d=\"M16.7518 8.06152H16.4061C14.7962 8.06152 13.327 8.70269 12.2178 9.75357C12.4953 9.97663 12.7595 10.2197 13.0098 10.482C13.7484 11.2557 14.3284 12.1572 14.7338 13.1615C15.0991 14.0658 15.3076 15.0187 15.3561 16.0001H23V14.6062C23 10.9976 20.1971 8.06152 16.7518 8.06152Z\" fill=\"#C9CFD2\"/>\n    <path d=\"M6.99998 0C4.79437 0 3 1.7944 3 4C3 6.2056 4.79437 8 6.99998 8C9.20559 8 11 6.2056 11 4C11 1.7944 9.20563 0 6.99998 0Z\" fill=\"#C9CFD2\"/>\n    <path d=\"M13.9865 15.7004C13.8589 13.5364 12.8174 11.633 11.2631 10.4131C10.1324 9.52545 8.72989 9 7.21069 9H6.78976C3.03976 9.00005 0 12.2016 0 16.1513V17H14V16.1513C14 15.9999 13.9955 15.8494 13.9865 15.7004Z\" fill=\"#C9CFD2\"/>\n</svg>\n</button><div ng-show=\"isShowTabButton()\" class=\"popup-bag-holder\"><popup-bag id=\"popup-bag\" has-group-order=\"groupOrderCreated\"></popup-bag></div><button ng-click=\"toggleOrderPage()\" ng-class=\"isCart() ? 'active' : ''\" ng-if=\"isCartVisible()\" class=\"tab-btn icon-btn\"><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M14.8624 6.59686L10.8257 0.376963C10.6422 0.188482 10.367 0 10.0917 0C9.81651 0 9.54128 0.0942409 9.3578 0.376963L5.3211 6.59686H0.917431C0.366972 6.59686 0 6.97382 0 7.53927C0 7.63351 0 7.72775 0 7.82199L2.29358 16.5864C2.47706 17.3403 3.21101 18 4.0367 18H15.9633C16.789 18 17.5229 17.4346 17.7064 16.5864L20 7.82199C20 7.72775 20 7.63351 20 7.53927C20 6.97382 19.633 6.59686 19.0826 6.59686H14.8624ZM7.33945 6.59686L10.0917 2.45026L12.844 6.59686H7.33945ZM10.0917 14.1361C9.08257 14.1361 8.25688 13.288 8.25688 12.2513C8.25688 11.2147 9.08257 10.3665 10.0917 10.3665C11.1009 10.3665 11.9266 11.2147 11.9266 12.2513C11.9266 13.288 11.1009 14.1361 10.0917 14.1361Z\" fill=\"#C9CFD2\"/>\n</svg>\n</button><button ng-click=\"toggleWindowState($event)\" ng-class=\"$root.collapsed ? '': 'un-collapsed'\" class=\"toggle-btn icon-btn\"><?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"1792\" height=\"1792\" viewBox=\"0 0 1792 1792\">\n    <path d=\"M1408 1216q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z\"/>\n</svg>\n</button></div></div><div ng-if=\"!$root.collapsed &amp;&amp; headerMessage &amp;&amp; !isDialogOpened\" class=\"notification-box flex-row center-items {{headerMessage.class}}\"><label>{{headerMessage.content}}</label><button ng-click=\"hideMessage()\" class=\"icon-btn\"><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.0012 4.23577L11.2953 3.52981L7.7655 7.05958L4.23573 3.52981L3.52977 4.23577L7.05954 7.76554L3.52971 11.2954L4.23567 12.0013L7.7655 8.4715L11.2953 12.0013L12.0013 11.2954L8.47146 7.76554L12.0012 4.23577Z\" fill=\"#54636C\"/>\n</svg>\n</button></div></div>");;return buf.join("");
}

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('loadingIndicator', ['$', function ($) {
    return {
        replace: false,
        scope: {
            isLoading: "=loadingIndicator"
        },
        link: function link($scope, element) {
            $(element).prepend('<div class="loader"><div class="spinner"></div></div>');

            $scope.$watch('isLoading', function () {
                if ($scope.isLoading) {
                    $(element).addClass('panel-loading');
                } else {
                    $(element).removeClass('panel-loading');
                }
            }, true);
        }
    };
}]);

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InputCompareToLink($scope, element, attributes, $ngModel) {

    $ngModel.$validators.compareTo = function (modelValue) {
        return modelValue === $scope.compareTo;
    };

    $scope.$watch('compareTo', function () {
        $ngModel.$validate();
    });
}

_module3.default.directive('compareTo', function () {
    return {
        require: 'ngModel',
        scope: {
            compareTo: '=compareTo'
        },
        link: InputCompareToLink
    };
});

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InputElementErrorDirectiveLink($scope, element, attributes, $ngForm) {
    $ngForm.highlightAllErrors = $ngForm.highlightAllErrors || function () {
        _.each(this, function (field, name) {
            if (name && name[0] != '$' && field && field.$setTouched) {
                field.$setTouched();
            }
        });
    };
    $ngForm.hideAllErrors = $ngForm.hideAllErrors || function () {
        _.each(this, function (field, name) {
            if (name && name[0] != '$' && field && field.$setUntouched) {
                field.$setUntouched();
            }
        });
    };
}

_module3.default.directive('inputError', function () {
    return {
        template: "<div class='errors' ng-messages='messages.$error' ng-show='messages.$touched && messages.$invalid' ng-transclude='' layout='column'></div>",
        transclude: true,
        replace: false,
        scope: {
            messages: '='
        },
        require: '^form',
        link: InputElementErrorDirectiveLink
    };
});

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('inputFocus', ['$timeout', function ($timeout) {
    return {
        replace: false,
        scope: {
            inputFocus: '='
        },
        link: function link($scope, element) {
            $scope.inputFocus = function (options) {

                $timeout(function () {
                    element[0].focus();

                    if (options && options.selectAll) {
                        element[0].setSelectionRange(0, 9999);
                    }
                });
            };
        }
    };
}]);

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PayPalPaymentFormDirectiveController = function PayPalPaymentFormDirectiveController(scope, messageService) {
    _classCallCheck(this, PayPalPaymentFormDirectiveController);

    this._scope = scope;
    this._messageService = messageService;
};

PayPalPaymentFormDirectiveController.$inject = ['$scope', 'Message'];


_module3.default.directive('payPalPaymentForm', function () {
    return {
        scope: {},
        templateUrl: 'modules/shared/views/payPalPaymentForm.html',
        controller: PayPalPaymentFormDirectiveController
    };
});

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SquareUpPaymentFormDirectiveController = function () {
    function SquareUpPaymentFormDirectiveController(scope) {
        var _this = this;

        _classCallCheck(this, SquareUpPaymentFormDirectiveController);

        this._scope = scope;

        scope.$watch('visible', function (visible) {
            if (visible) {
                _this._paymentForm = new SqPaymentForm({
                    applicationId: _CommonConstants2.default.SQUARE_UP_APPLICATION_ID,
                    inputClass: 'sq-input',
                    inputStyles: [{
                        fontSize: '14px'
                    }],
                    cardNumber: {
                        elementId: 'sq-card-number'
                    },
                    cvv: {
                        elementId: 'sq-card-cvv'
                    },
                    expirationDate: {
                        elementId: 'sq-card-date'
                    },
                    postalCode: {
                        elementId: 'sq-card-postal-code'
                    },
                    callbacks: {
                        cardNonceResponseReceived: _this._onCardNonceResponseReceived.bind(_this)
                    }
                });
                _this._paymentForm.build();
            }
        });

        scope.$on('$destroy', function () {
            if (_this._paymentForm) {
                _this._paymentForm.destroy();
            }
        });

        scope.nonce = function () {
            return new Promise(function (resolve, reject) {
                _this._nonceCallback = function (errors, nonce, cardData) {
                    _this._nonceCallback = null;
                    if (errors) {
                        reject(errors);
                        return;
                    }

                    resolve({
                        nonce: nonce,
                        cardData: cardData
                    });
                };
                _this._paymentForm.requestCardNonce();
            });
        };
    }

    _createClass(SquareUpPaymentFormDirectiveController, [{
        key: '_onCardNonceResponseReceived',
        value: function _onCardNonceResponseReceived(errors, nonce, cardData) {
            this._nonceCallback(errors, nonce, cardData);
        }
    }]);

    return SquareUpPaymentFormDirectiveController;
}();

_module3.default.directive('squareUpPaymentForm', function () {
    return {
        scope: {
            nonce: '=',
            visible: '='
        },
        templateUrl: 'modules/shared/views/squareUpPaymentForm.html',
        link: function link($scope, element) {
            new SquareUpPaymentFormDirectiveController($scope, element);
        }
    };
});

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StickyPanelDirectiveController = function () {
    function StickyPanelDirectiveController(scope, element, rootScope) {
        var _this = this;

        _classCallCheck(this, StickyPanelDirectiveController);

        this._rootScope = rootScope;
        this._scope = scope;
        this._element = element[0];
        this._stickyMode = false;

        rootScope.$on(_CommonConstants2.default.Events.WINDOW_SCROLL, function ($event, scrollTop) {
            return _this._onScroll(scrollTop);
        });
        rootScope.$on(_CommonConstants2.default.Events.WINDOW_WIDTH_CHANGED, function () {
            return _this._onWidthChanged();
        });

        this._paddingElement = document.createElement("div");
        this._paddingElement.style.display = 'none';
        this._element.parentElement.insertBefore(this._paddingElement, this._element);

        this._element.className += ' sticky-panel';
    }

    _createClass(StickyPanelDirectiveController, [{
        key: '_onScroll',
        value: function _onScroll(scrollTop) {
            var element = this._stickyMode ? this._paddingElement : this._element;
            var top = 0;
            while (element) {
                top += element.offsetTop;
                element = element.offsetParent;
            }
            var stickyMode = top < scrollTop;
            if (stickyMode !== this._stickyMode) {
                this._stickyMode = stickyMode;
                var stickyPanelClass = ' sticky-panel-docked';
                if (stickyMode) {
                    this._element.className += stickyPanelClass;
                    this._paddingElement.style.display = 'block';
                } else {
                    var pos = this._element.className.indexOf(stickyPanelClass);
                    this._element.className = this._element.className.substring(0, pos) + this._element.className.substring(pos + stickyPanelClass.length);
                    this._paddingElement.style.display = 'none';
                }
            }
        }
    }, {
        key: '_onWidthChanged',
        value: function _onWidthChanged() {
            this._paddingElement.style.height = this._element.clientHeight + 'px';
        }
    }]);

    return StickyPanelDirectiveController;
}();

_module3.default.directive('stickyPanel', ['$rootScope', function ($rootScope) {
    return {
        replace: false,
        scope: {
            inputFocus: '='
        },
        link: function link($scope, element) {
            new StickyPanelDirectiveController($scope, element, $rootScope);
        }
    };
}]);

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WidthChangedHandlerLink($rootScope, $timeout, $window, $document, element) {

    var promise = null;

    function applySizes() {
        var width = element[0].offsetWidth;
        $rootScope.sizeXs = width < 600;
        $rootScope.sizeSm = !$rootScope.sizeXs && width < 960;
        $rootScope.sizeMd = !$rootScope.sizeSm && width < 1280;
        $rootScope.sizeLg = !$rootScope.sizeMd && width < 1920;
        $rootScope.sizeXsSm = $rootScope.sizeXs || $rootScope.sizeSm;
    }

    function invokeEvent() {
        promise = null;
        applySizes();
        $rootScope.$emit(_CommonConstants2.default.Events.WINDOW_WIDTH_CHANGED, element[0].offsetWidth);
    }

    function handleWindowResize() {

        if (promise) {
            $timeout.cancel(promise);
        }

        promise = $timeout(function () {
            $rootScope.$apply(invokeEvent);
        }, 100);
    }

    element[0].contentWindow.addEventListener('resize', handleWindowResize);

    handleWindowResize();
    applySizes();

    $window.addEventListener('scroll', function () {
        var scrollTop = ($window.pageYOffset || $document[0].documentElement.scrollTop) - ($document[0].documentElement.clientTop || 0);
        $rootScope.$apply(function () {
            $rootScope.$emit(_CommonConstants2.default.Events.WINDOW_SCROLL, scrollTop);
        });
    });
}

_module3.default.directive('widthChangedHandler', ['$rootScope', '$timeout', '$window', '$document', function ($rootScope, $timeout, $window, $document) {

    return {
        link: function link($scope, element) {
            WidthChangedHandlerLink($rootScope, $timeout, $window, $document, element);
        },
        template: "<iframe style='width:100%;height:0;border:0;padding:0;margin:0;background-color:transparent;position:absolute'></iframe>",
        replace: true
    };
}]);

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _communicationService = __webpack_require__(28);

var _commandKeys = __webpack_require__(27);

var _InviteUserController = __webpack_require__(675);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InviteLinkDirectiveController = function () {
    function InviteLinkDirectiveController(scope, cartService, configurationService, rootScope, $translate, dialogService) {
        var _this = this;

        _classCallCheck(this, InviteLinkDirectiveController);

        this._scope = scope;
        this._rootScope = rootScope;
        this._cartService = cartService;
        this._configurationService = configurationService;
        this.$translate = $translate;
        this._dialogService = dialogService;

        scope.invitationLink = this._cartService.getInviteSingleLink();
        scope.invitationType = this._cartService.getInvitationType();
        scope.invitationCode = this._cartService.getInviteCode();
        scope.minimumOrderMessage = null;
        scope.ownerDiscountMessage = null;

        scope.copyToClipboard = function () {
            return _this._copyClipboard();
        };
        scope.isShowInviteLink = function () {
            return _this._isShowInviteLink();
        };
        scope.isMarketingShow = function () {
            return _this._isMarketingShow();
        };
        scope.inviteUser = function () {
            return _this._inviteUser();
        };
        rootScope.$on(_CommonConstants2.default.Events.ORDER_CREATED, function () {
            return _this._initInvitationCode();
        });
        rootScope.$on(_CommonConstants2.default.RootEvents.CART_CHANGED, function () {
            return _this._cartChanged();
        });
    }

    _createClass(InviteLinkDirectiveController, [{
        key: '$onInit',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._initInvitationCode();

                            case 2:
                                _context.next = 4;
                                return this._updateMinimumOrderMessage();

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function $onInit() {
                return _ref.apply(this, arguments);
            }

            return $onInit;
        }()
    }, {
        key: '_inviteUser',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var self;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                self = this;

                                this._dialogOptions = {
                                    controller: _InviteUserController.InviteUserController,
                                    template: __webpack_require__(676)(),
                                    escapeToClose: true,
                                    locals: {},
                                    onRemoving: function onRemoving(event, removePromise) {
                                        self._rootScope.$broadcast(_CommonConstants2.default.Events.DIALOG_CLOSED);
                                    }
                                };

                                _context2.next = 4;
                                return this._dialogService.show(this._dialogOptions);

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _inviteUser() {
                return _ref2.apply(this, arguments);
            }

            return _inviteUser;
        }()
    }, {
        key: '_cartChanged',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this._initInvitationCode();

                            case 2:
                                _context3.next = 4;
                                return this._updateMinimumOrderMessage();

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function _cartChanged() {
                return _ref3.apply(this, arguments);
            }

            return _cartChanged;
        }()
    }, {
        key: '_isShowInviteLink',
        value: function _isShowInviteLink() {
            return this._scope.cart && !(this._scope.cart.cartStatus === 'OWNER_CHECKING_OUT' || this._scope.cart.cartStatus === 'CHECKING_OUT');
        }
    }, {
        key: '_isMarketingShow',
        value: function _isMarketingShow() {
            return this.retailer && this._scope.cart && (this.retailer.cartonomyMode !== _CommonConstants2.default.CartonomyMode.marketing || this._scope.cart.items.length > 0);
        }
    }, {
        key: '_initInvitationCode',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var siteLocation, _retailer, siteUrl, retailerSiteUrl;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.getLocation, {});

                            case 2:
                                siteLocation = _context4.sent;
                                _retailer = this._configurationService.getRetailer().retailer;

                                this.retailer = _retailer;
                                _context4.next = 7;
                                return this._cartService.getCart();

                            case 7:
                                this._scope.cart = _context4.sent;

                                this._scope.invitationCode = this._cartService.getInviteCode();

                                if (!(this._scope.cart && this._scope.cart.id)) {
                                    _context4.next = 15;
                                    break;
                                }

                                _context4.next = 12;
                                return this._cartService.getShareTokenByCartId(this._scope.cart.id);

                            case 12:
                                this._scope.invitationCode = _context4.sent;

                                this._cartService.setInviteCode(this._scope.invitationCode);
                                this._cartService.setInvitationType(_CommonConstants2.default.InvitationTypes.share);

                            case 15:
                                siteUrl = void 0;
                                retailerSiteUrl = _retailer.website.startsWith('https://') ? _retailer.website : 'https://' + _retailer.website;

                                if (_retailer.cartonomyMode === _CommonConstants2.default.CartonomyMode.marketing && this._scope.cart && this._scope.cart.items[0]) {
                                    siteUrl = this._scope.cart.items[0].productUrl;
                                } else {
                                    siteUrl = retailerSiteUrl;
                                }

                                if (siteLocation && siteLocation.origin) {
                                    siteUrl = siteUrl.replace(retailerSiteUrl, siteLocation.origin);
                                } else if (_retailer.retailerType === 'Shopify') {
                                    siteUrl = 'https://' + siteUrl;
                                }
                                this._scope.invitationLink = siteUrl + _CommonConstants2.default.INVITE_LINK + this._scope.invitationCode;

                                this._cartService.setInviteSingleLink(this._scope.invitationLink);

                                _scope2.default.apply(this._scope);

                            case 22:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function _initInvitationCode() {
                return _ref4.apply(this, arguments);
            }

            return _initInvitationCode;
        }()
    }, {
        key: '_updateMinimumOrderMessage',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var retailer;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                retailer = this._configurationService.getRetailer().retailer;

                                if (!this._scope.cart) {
                                    _context5.next = 18;
                                    break;
                                }

                                if (retailer.minimumOrderAmount > 0) {
                                    if (this._scope.cart.cartItemTotal >= retailer.minimumOrderAmount) {
                                        this._scope.minimumOrderMessage = this.$translate.instant('client.group.free_shipping');
                                    } else {
                                        this._scope.minimumOrderMessage = this.$translate.instant('client.group.amount_for_free_shipping', { amount: (retailer.minimumOrderAmount - this._scope.cart.cartItemTotal).toFixed(2) });
                                    }
                                }
                                _context5.t1 = this._scope.cart.cartDiscount && this._scope.cart.cartDiscount > 0;

                                if (!_context5.t1) {
                                    _context5.next = 8;
                                    break;
                                }

                                _context5.next = 7;
                                return this._cartService.isOwner(this._scope.cart);

                            case 7:
                                _context5.t1 = _context5.sent;

                            case 8:
                                _context5.t0 = _context5.t1;

                                if (_context5.t0) {
                                    _context5.next = 11;
                                    break;
                                }

                                _context5.t0 = retailer.cartonomyMode === _CommonConstants2.default.CartonomyMode.marketing;

                            case 11:
                                if (!_context5.t0) {
                                    _context5.next = 15;
                                    break;
                                }

                                if (retailer.cartonomyMode === _CommonConstants2.default.CartonomyMode.marketing) {
                                    this._scope.ownerDiscountMessage = this.$translate.instant('client.group.invite_discount', { cartDiscount: this._scope.cart.cartDiscount.toFixed(2), availableDiscount: this._scope.cart.availableDiscount.toFixed(2) });
                                } else {
                                    this._scope.ownerDiscountMessage = this.$translate.instant('client.group.discount', { cartDiscount: this._scope.cart.cartDiscount.toFixed(2) });
                                }
                                _context5.next = 16;
                                break;

                            case 15:
                                this._scope.ownerDiscountMessage = null;

                            case 16:
                                _context5.next = 20;
                                break;

                            case 18:
                                this._scope.minimumOrderMessage = null;
                                this._scope.ownerDiscountMessage = null;

                            case 20:
                                _scope2.default.apply(this._scope);

                            case 21:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function _updateMinimumOrderMessage() {
                return _ref5.apply(this, arguments);
            }

            return _updateMinimumOrderMessage;
        }()
    }, {
        key: '_copyClipboard',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                this._cartService.copyClipboard(this._scope.invitationLink);

                            case 1:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function _copyClipboard() {
                return _ref6.apply(this, arguments);
            }

            return _copyClipboard;
        }()
    }]);

    return InviteLinkDirectiveController;
}();

InviteLinkDirectiveController.$inject = ['$scope', 'CartService', 'ConfigurationService', '$rootScope', '$translate', '$mdDialog'];


_module3.default.directive('inviteLink', function () {
    return {
        scope: true,
        templateUrl: 'modules/shared/views/inviteLink.html',
        controller: InviteLinkDirectiveController
    };
});

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InviteUserController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InviteUserController = exports.InviteUserController = function () {
  function InviteUserController(scope, cartService, rootScope, dialogService, messageService, translate) {
    var _this = this;

    _classCallCheck(this, InviteUserController);

    this._scope = scope;

    this._rootScope = rootScope;
    this._cartService = cartService;
    this._messageService = messageService;
    this._dialogService = dialogService;
    this.translate = translate;

    scope.inviteEmails = '';
    scope.sendInvitation = function () {
      return _this._sendInvitation();
    };
    scope.cancel = function () {
      return _this._cancel();
    };

    rootScope.$on(_CommonConstants2.default.Events.BACK_BUTTON_CLICKED, function () {
      return dialogService.hide();
    });

    this.initialize();
  }

  _createClass(InviteUserController, [{
    key: "initialize",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._rootScope.storeWindowTitle = 'client.order.invite_user';
                this._rootScope.$broadcast(_CommonConstants2.default.Events.DIALOG_OPENED, true);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initialize() {
        return _ref.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "_cancel",
    value: function _cancel() {
      this._dialogService.hide();
    }
  }, {
    key: "_sendInvitation",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var emails;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                emails = this._scope.inviteEmails.split(/[\n\r,;]+/).map(function (e) {
                  return e.trim();
                }).filter(function (e, index, arr) {
                  return !!e && arr.indexOf(e) === index;
                });

                if (!(emails.length === 0)) {
                  _context2.next = 4;
                  break;
                }

                this._scope.errorMessage = 'client.invite_user.email_error';
                return _context2.abrupt("return");

              case 4:
                this._scope.inProgress = true;
                _context2.prev = 5;
                _context2.next = 8;
                return this._cartService.sendInvites(emails);

              case 8:
                this._messageService.showMessagePopup(this.translate.instant('client.invite_user.success'));
                this._dialogService.hide();
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](5);

                this._scope.errorMessage = _context2.t0.data && _context2.t0.data.message || 'client.invite_user.api_error';

              case 15:
                _context2.prev = 15;

                this._scope.inProgress = false;
                return _context2.finish(15);

              case 18:

                _scope2.default.apply(this._scope);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 12, 15, 18]]);
      }));

      function _sendInvitation() {
        return _ref2.apply(this, arguments);
      }

      return _sendInvitation;
    }()
  }]);

  return InviteUserController;
}();

InviteUserController.$inject = ['$scope', 'CartService', '$rootScope', '$mdDialog', 'Message', '$translate'];


_module3.default.controller('InviteUser', InviteUserController);

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__(41);

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<md-dialog aria-label=\"Invite User\" flex=\"80\" flex-sm=\"100\" flex-xs=\"100\" layout=\"column\"><md-dialog-content ng-class=\"{ 'dialog-content-custom': selectedTab.custom, 'external-store': isExternalRetailer() }\" flex=\"noshrink\" layout=\"column\"><md-content layout=\"column\" ng-class=\"'tab-' + selectedTab.id\" flex=\"noshrink\" ng-form=\"form\"><div class=\"invite-user-dialog flex-column\"><div class=\"input-group\"><label for=\"email\">{{ 'client.emails' | translate }}</label><textarea id=\"email\" ng-model=\"inviteEmails\" ng-disabled=\"inProgress\" name=\"email\"></textarea></div><div ng-show=\"errorMessage\" class=\"error\">{{errorMessage | translate}}</div><button ng-click=\"sendInvitation()\" ng-disabled=\"inProgress\" class=\"continue-btn primary btn-lg\">{{ 'client.invite_user.submit' | translate }}</button><button ng-click=\"cancel()\" ng-disabled=\"inProgress\" class=\"cancel-btn secondary btn-lg\">{{ 'client.cancel' | translate }}</button></div></md-content></md-dialog-content></md-dialog>");;return buf.join("");
}

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthenticationService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _ChangePasswordController = __webpack_require__(418);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _utils = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthenticationService = exports.AuthenticationService = function () {
  function AuthenticationService(httpService, timeoutService, sessionService, localForageService, cartonomyConfig, dialogService, qService, cartService, messageService, windowService, stateService, rootScope) {
    _classCallCheck(this, AuthenticationService);

    this._urlBase = cartonomyConfig.ApiV2 + 'authentication/';
    this._urlUserBase = cartonomyConfig.ApiV2 + 'user/';
    this._sessionService = sessionService;
    this._httpService = httpService;
    this._dialogService = dialogService;
    this._qService = qService;
    this._cartService = cartService;
    this._messageService = messageService;
    this._windowService = windowService;
    this._stateService = stateService;
    this._loginPromise = null;
    this._cartonomyConfig = cartonomyConfig;
    //this._sessionStorageService = sessionStorageService;
    this._localForageService = localForageService;
    this._timeout = timeoutService;
    this._rootScope = rootScope;
    this.checkLoginToken();
  }

  _createClass(AuthenticationService, [{
    key: "checkLoginToken",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var bearer;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._sessionService.loggedIn();

              case 2:
                if (!_context.sent) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return this._sessionService.getAuthToken();

              case 5:
                bearer = _context.sent;

                this.authToken = bearer;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkLoginToken() {
        return _ref.apply(this, arguments);
      }

      return checkLoginToken;
    }()
  }, {
    key: "_updateSession",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        var payload;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                payload = {
                  authToken: data.authToken,
                  userEmail: data.user.userName,
                  userName: data.user.fullName,
                  firstName: data.user.firstName,
                  lastName: data.user.lastName,
                  email: data.user.email
                };
                _context2.next = 3;
                return this._sessionService.setSessionDetails(payload);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _updateSession(_x) {
        return _ref2.apply(this, arguments);
      }

      return _updateSession;
    }()
  }, {
    key: "waitForLogin",
    value: function waitForLogin(onlySuccessful) {
      var _this = this;

      return new Promise(function (resolve) {
        if (!_this._loginPromise) {
          resolve();
        } else {
          if (onlySuccessful) {
            _this._loginPromise.then(function () {
              return resolve();
            });
          } else {
            _this._loginPromise.finally(function () {
              return resolve();
            });
          }
        }
      });
    }
  }, {
    key: "showLoginDialog",
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(email, currentPage, createOrderFlow, invitedCart) {
        var self;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.isLoggingIn) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", this.isLoggingIn);

              case 2:
                this._rootScope.$broadcast(_CommonConstants2.default.Events.DIALOG_OPENED, false);
                self = this;
                _context3.next = 6;
                return this._dialogService.show({
                  controller: 'Cartonomy.Shared.LoginController',
                  templateUrl: 'modules/shared/views/loginDialog.html',
                  clickOutsideToClose: false,
                  escapeToClose: false,
                  focusOnOpen: false,
                  locals: {
                    email: email,
                    currentPage: currentPage,
                    createOrderFlow: createOrderFlow,
                    invitedCart: invitedCart
                  },
                  onRemoving: function onRemoving(event, removePromise) {
                    self._rootScope.$broadcast(_CommonConstants2.default.Events.DIALOG_CLOSED);
                  }
                });

              case 6:
                this.isLoggingIn = _context3.sent;


                this.isLoggingIn = null;

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function showLoginDialog(_x2, _x3, _x4, _x5) {
        return _ref3.apply(this, arguments);
      }

      return showLoginDialog;
    }()
  }, {
    key: "showSignupDialog",
    value: function showSignupDialog(email) {
      return this.showLoginDialog(email, 'signup');
    }
  }, {
    key: "showChangePasswordDialog",
    value: function showChangePasswordDialog() {
      return this._dialogService.show({
        controller: _ChangePasswordController.ChangePasswordController,
        template: __webpack_require__(678),
        clickOutsideToClose: true
      });
    }
  }, {
    key: "_prepareNewCart",
    value: function _prepareNewCart(cart) {

      if (!cart.items || cart.items.length === 0) {
        return null;
      }

      return {
        items: cart.items.map(function (item) {
          return {
            catalogProductId: item.catalogProductId,
            quantity: item.quantity,
            comment: item.comment
          };
        })
      };
    }
  }, {
    key: "externalLoginFinalize",
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(authToken) {
        var cart, newCart;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._cartService.getCart();

              case 2:
                cart = _context4.sent;
                newCart = this._prepareNewCart(cart);
                _context4.prev = 4;
                _context4.next = 7;
                return this._httpService.post(this._urlBase + 'externalLoginFinalize', {
                  cart: newCart,
                  authToken: authToken
                });

              case 7:
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](4);

                console.log(_context4.t0);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 9]]);
      }));

      function externalLoginFinalize(_x6) {
        return _ref4.apply(this, arguments);
      }

      return externalLoginFinalize;
    }()
  }, {
    key: "loginRequest",
    value: function loginRequest(credentials, ignoreLocalCart) {
      var _this2 = this;

      if (this._loginPromise) {
        return this.waitForLogin().then(function () {
          return _this2.loginRequest(credentials);
        });
      }

      this._loginPromise = this._doLogin(credentials, ignoreLocalCart).then(undefined, function (error) {
        _this2._loginPromise = null;
        return new Promise(function (resolve, reject) {
          return reject(error);
        });
      });

      return this._loginPromise;
    }
  }, {
    key: "_doLogin",
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(credentials, ignoreLocalCart) {
        var leaveInvite, cart, newCart, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                leaveInvite = false;
                _context5.next = 3;
                return this._sessionService.isInvite();

              case 3:
                if (!_context5.sent) {
                  _context5.next = 6;
                  break;
                }

                leaveInvite = ignoreLocalCart;
                ignoreLocalCart = true;

              case 6:
                _context5.next = 8;
                return this._cartService.getCart();

              case 8:
                cart = _context5.sent;
                newCart = ignoreLocalCart ? null : this._prepareNewCart(cart);

                if (!leaveInvite) {
                  _context5.next = 13;
                  break;
                }

                _context5.next = 13;
                return this._sessionService.clearSessionDetails();

              case 13:
                _context5.next = 15;
                return this._httpService.post(this._urlBase + 'login', {
                  username: credentials.username,
                  password: credentials.password,
                  cart: newCart
                });

              case 15:
                res = _context5.sent;
                _context5.next = 18;
                return this._cartService.clearLocalCart();

              case 18:
                this._sessionService.setCachedUser(null);
                _context5.next = 21;
                return this._updateSession(res.data);

              case 21:
                _context5.next = 23;
                return this._cartService.resetCart();

              case 23:
                this._loginPromise = null;
                return _context5.abrupt("return", res.data.user);

              case 25:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _doLogin(_x7, _x8) {
        return _ref5.apply(this, arguments);
      }

      return _doLogin;
    }()
  }, {
    key: "ensureLoggedIn",
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._sessionService.loggedIn();

              case 2:
                if (_context6.sent) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt("return", this.showLoginDialog());

              case 4:
                return _context6.abrupt("return", this._qService.resolve());

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function ensureLoggedIn() {
        return _ref6.apply(this, arguments);
      }

      return ensureLoggedIn;
    }()
  }, {
    key: "logout",
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!this._loginPromise) {
                  _context7.next = 5;
                  break;
                }

                _context7.next = 3;
                return this.waitForLogin();

              case 3:
                this.logout();
                return _context7.abrupt("return");

              case 5:
                _context7.next = 7;
                return this._sessionService.loggedIn();

              case 7:
                if (_context7.sent) {
                  _context7.next = 9;
                  break;
                }

                return _context7.abrupt("return");

              case 9:
                _context7.next = 11;
                return this._httpService.post(this._urlBase + 'logout');

              case 11:

                this._sessionService.setCachedUser(null);
                this._sessionService.setStealthUserMode(null);
                this._cartService.resetCart();

                _context7.next = 16;
                return this._localForageService.clear();

              case 16:

                this.authToken = null;
                this._loginPromise = null;

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function logout() {
        return _ref7.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "register",
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(registration, ignoreLocalCart) {
        var cart, res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._sessionService.isInvite();

              case 2:
                if (!_context8.sent) {
                  _context8.next = 4;
                  break;
                }

                ignoreLocalCart = true;

              case 4:
                _context8.next = 6;
                return this._cartService.getCart();

              case 6:
                cart = _context8.sent;
                _context8.next = 9;
                return this._httpService.post(this._urlBase + 'register', {
                  email: registration.email,
                  password: registration.password,
                  firstName: registration.firstName,
                  lastName: registration.lastName,
                  fullName: registration.fullName,
                  confirmPassword: registration.password,
                  cart: ignoreLocalCart ? null : this._prepareNewCart(cart)
                });

              case 9:
                res = _context8.sent;
                _context8.next = 12;
                return this._cartService.clearLocalCart();

              case 12:
                this._sessionService.setCachedUser(null);
                _context8.next = 15;
                return this._updateSession(res.data);

              case 15:
                this._cartService.resetCart();
                this._loginPromise = null;
                return _context8.abrupt("return", res.data.user);

              case 18:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function register(_x9, _x10) {
        return _ref8.apply(this, arguments);
      }

      return register;
    }()
  }, {
    key: "checkIfEmailCanRegister",
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(email) {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._httpService.post(this._urlBase + 'canEmailRegister', {
                  email: email
                });

              case 2:
                return _context9.abrupt("return", _context9.sent);

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function checkIfEmailCanRegister(_x11) {
        return _ref9.apply(this, arguments);
      }

      return checkIfEmailCanRegister;
    }()
  }, {
    key: "loginWithInviteToken",
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(inviteDetails) {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                inviteDetails.isInvite = true;
                _context10.next = 3;
                return this._sessionService.clearSessionDetails();

              case 3:
                _context10.next = 5;
                return this._sessionService.setSessionDetails(inviteDetails);

              case 5:
                this._sessionService.setCachedUser(null);
                this._sessionService.setCartReference(null);

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function loginWithInviteToken(_x12) {
        return _ref10.apply(this, arguments);
      }

      return loginWithInviteToken;
    }()
  }, {
    key: "onInviteAccepted",
    value: function onInviteAccepted() {
      this._sessionService.setCachedUser(null);
      this._sessionService.setCartReference(null);
    }
  }, {
    key: "externalLogin",
    value: function externalLogin(provider) {
      var location = this._windowService.location;
      var redirectUri = location.origin + location.pathname;

      if (location.pathname === '/') {
        redirectUri += 'index.html';
      }

      var href = this._cartonomyConfig.ApiV2 + "oauth/" + provider + "?";

      if (this.authToken) {
        href += "&authenticationToken=" + this.authToken;
      }

      if (!href.startsWith('https') || !href.startsWith('http')) {
        href = location.origin + href;
      }

      href += "&redirectUrl=" + encodeURI(redirectUri);
      return href;
    }
  }, {
    key: "validatePasswordTicket",
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(ticket, password) {
        var response;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this._httpService.post(this._urlUserBase + 'password/reset', {
                  resetToken: ticket,
                  password: password,
                  confirmPassword: password
                });

              case 2:
                response = _context11.sent;

                if (!(response.data.result !== 'failure')) {
                  _context11.next = 5;
                  break;
                }

                return _context11.abrupt("return", {
                  success: true
                });

              case 5:
                if (!(response.data.errors && response.data.errors.length)) {
                  _context11.next = 7;
                  break;
                }

                return _context11.abrupt("return", {
                  success: false,
                  errorMessage: response.data.errors[0].errorMessage
                });

              case 7:
                return _context11.abrupt("return", {
                  success: false
                });

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function validatePasswordTicket(_x13, _x14) {
        return _ref11.apply(this, arguments);
      }

      return validatePasswordTicket;
    }()
  }, {
    key: "sendValidateRequest",
    value: function sendValidateRequest(email) {
      return this._httpService.post(this._urlUserBase + 'password/recover', {
        username: email
      });
    }
  }, {
    key: "changePassword",
    value: function changePassword(oldPassword, newPassword) {
      return this._httpService.post(this._urlUserBase + 'changepassword', {
        password: newPassword,
        confirmPassword: newPassword
      });
    }
  }, {
    key: "getOpenIdProviders",
    value: function getOpenIdProviders() {
      return [{
        id: 'facebook',
        title: 'Facebook',
        color: '#4267B2',
        provider: 'Facebook',
        icon: 'fa-facebook',
        svgIcon: 'resources/icons/social/facebook-logo.svg'
      }, {
        id: 'google+',
        title: 'Google+',
        color: '#da4a27',
        icon: 'fa-google-plus',
        provider: 'Google'
      }];
    }
  }]);

  return AuthenticationService;
}();

AuthenticationService.$inject = ['$http', '$timeout', 'Session', 'LocalForageService', 'cartonomyConfig', '$mdDialog', '$q', 'CartService', 'Message', '$window', '$state', '$rootScope'];


_module3.default.service('AuthenticationService', AuthenticationService);

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = "<md-dialog aria-label=\"Change Password\" flex=\"80\" flex-sm=\"100\" flex-xs=\"100\"><md-dialog-content><md-content layout=\"column\" layout-padding=\"layout-padding\"><div class=\"change-password-dialog\" ng-form=\"form\"><div class=\"input-group\"><label for=\"password\">{{ 'client.user.new_password' | translate }}</label><input ng-model=\"data.password\" type=\"password\" ng-disabled=\"inProgress\" required=\"required\" name=\"password\" id=\"password\"/><input-error messages=\"form.password\"><ng-message when=\"required\">{{'client.user.password_required' | translate}}</ng-message></input-error></div><div class=\"input-group\"><label for=\"confirmPassword\">{{ 'client.user.new_password_confirm' | translate }}</label><input ng-model=\"data.confirmPassword\" type=\"password\" ng-disabled=\"inProgress\" required=\"required\" name=\"confirmPassword\" id=\"confirmPassword\" compare-to=\"data.password\"/><input-error messages=\"form.confirmPassword\"><ng-message when=\"required\">{{'client.user.password_required' | translate}}</ng-message><ng-message when=\"compareTo\">{{'client.user.password_equal' | translate}}</ng-message></input-error></div><div class=\"error\" ng-show=\"errorMessage\">{{errorMessage}}</div><button class=\"continue-btn primary btn-lg\" ng-click=\"changePassword(form)\" ng-disabled=\"inProgress\">{{ 'client.user.change_password' | translate }}</button><button class=\"back-btn secondary btn-lg\" ng-click=\"cancel()\" ng-disabled=\"inProgress\">{{ 'client.back' | translate }}</button></div></md-content></md-dialog-content></md-dialog>"

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _utils = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthInterceptorService = function () {
    function AuthInterceptorService(session, rootScope, qService, cartonomyConfig) {
        var _this = this;

        _classCallCheck(this, AuthInterceptorService);

        this._session = session;
        this._rootScope = rootScope;
        this._qService = qService;
        this._cartonomyConfig = cartonomyConfig;

        // these calls are required as these methods will be used directly
        this.request = function (config) {
            return _this._request(config);
        };
        this.responseError = function (response) {
            return _this._responseError(response);
        };
    }

    _createClass(AuthInterceptorService, [{
        key: '_request',
        value: function _request(config) {
            config.headers = config.headers || {};

            if (config.method === "GET" && /\.(html|svg|png|gif|jpg|css|js)$/.test(config.url)) {
                // these file types should be downloaded as static files, no authorization or other adjustments
                return config;
            }

            if (this._cartonomyConfig.externalStoreMode && this._cartonomyConfig.externalStoreUrl) {
                config.headers.X_EXTERNAL_STORE = this._cartonomyConfig.externalStoreUrl;
            }

            return this._session.getAuthToken().then(function (authToken) {
                if (!authToken) {
                    return config;
                }

                config.headers.Authorization = 'Bearer ' + authToken;
                return config;
            });
        }
    }, {
        key: '_responseError',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(response.status === 401)) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return this._session.clearSessionDetails();

                            case 3:
                                this._session.setCachedUser(null);
                                this._session.setCartReference(null, false);

                            case 5:
                                return _context.abrupt('return', this._qService.reject(response));

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _responseError(_x) {
                return _ref.apply(this, arguments);
            }

            return _responseError;
        }()
    }]);

    return AuthInterceptorService;
}();

AuthInterceptorService.$inject = ['Session', '$rootScope', '$q', 'cartonomyConfig'];


_module3.default.service('AuthInterceptor', AuthInterceptorService).config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');
}]);

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(29);

var _communicationService = __webpack_require__(28);

var _commandKeys = __webpack_require__(27);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartService = function () {
    function CartService(httpService, sessionService, cartonomyConfig, rootScope, localForageService, timeoutService, messageService, HeapService, RealTimeUpdateService, $translate) {
        _classCallCheck(this, CartService);

        this._httpService = httpService;
        this._sessionService = sessionService;
        this._rootScope = rootScope;
        this._urlBase = cartonomyConfig.ApiV2 + 'cart';
        this._urlBaseShopify = cartonomyConfig.ApiV2 + 'shopify';
        //this._sessionStorage = sessionStorage;
        this._localForageService = localForageService;
        this._isGroupOrder = false;
        this._timeoutService = timeoutService;
        this._messageService = messageService;
        this._heapService = HeapService;
        this._lastLeftCart = null;
        this.$translate = $translate;

        this.lastCartRequest = null;
        this._invitationType = _CommonConstants2.default.InvitationTypes.normal;
        this._inviteCode = null;
        this._inviteSingleLink = null;
        this._inviteMorePeopleMode = false;
        this.shareTokenPromise = null;
    }

    _createClass(CartService, [{
        key: 'clearCart',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this = this;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context2.sent) {
                                    _context2.next = 6;
                                    break;
                                }

                                _context2.next = 5;
                                return this.resetCart();

                            case 5:
                                return _context2.abrupt('return', new Promise(function (resolve) {
                                    return resolve();
                                }));

                            case 6:
                                return _context2.abrupt('return', this._httpService.delete(this._urlBase + '/clearCart').then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                                    return regeneratorRuntime.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    _context.next = 2;
                                                    return _this.resetCart();

                                                case 2:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, _this);
                                }))));

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function clearCart() {
                return _ref.apply(this, arguments);
            }

            return clearCart;
        }()
    }, {
        key: 'deleteCart',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var _this2 = this;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context4.sent) {
                                    _context4.next = 6;
                                    break;
                                }

                                _context4.next = 5;
                                return this.resetCart();

                            case 5:
                                return _context4.abrupt('return', new Promise(function (resolve) {
                                    return resolve();
                                }));

                            case 6:
                                return _context4.abrupt('return', this.getCart().then(function (cart) {
                                    cart.createdOn = undefined; // in order to block main controller notification about removed carts
                                    return _this2._httpService.delete(_this2._urlBase).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                                        return regeneratorRuntime.wrap(function _callee3$(_context3) {
                                            while (1) {
                                                switch (_context3.prev = _context3.next) {
                                                    case 0:
                                                        _context3.next = 2;
                                                        return _this2.resetCart();

                                                    case 2:
                                                    case 'end':
                                                        return _context3.stop();
                                                }
                                            }
                                        }, _callee3, _this2);
                                    })));
                                }));

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function deleteCart() {
                return _ref3.apply(this, arguments);
            }

            return deleteCart;
        }()
    }, {
        key: 'getLastLeftCart',
        value: function getLastLeftCart() {
            return this._lastLeftCart;
        }
    }, {
        key: 'getUserLastCart',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var _this3 = this;

                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context5.sent) {
                                    _context5.next = 4;
                                    break;
                                }

                                return _context5.abrupt('return', "");

                            case 4:
                                if (!this.lastCartRequest) {
                                    _context5.next = 6;
                                    break;
                                }

                                return _context5.abrupt('return', this.lastCartRequest);

                            case 6:

                                this.lastCartRequest = this._httpService.get(this._urlBase + '/laststatus').then(function (response) {
                                    return response.data;
                                }).finally(function () {
                                    _this3.lastCartRequest = null;
                                });

                                return _context5.abrupt('return', this.lastCartRequest);

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function getUserLastCart() {
                return _ref5.apply(this, arguments);
            }

            return getUserLastCart;
        }()
    }, {
        key: 'isCartOwner',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var cart, cartOwner, getEmail, isCartOwner;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.getCart();

                            case 2:
                                cart = _context6.sent;
                                cartOwner = _.find(cart.participants, function (participant) {
                                    return participant.status === 'OWNER';
                                });
                                _context6.next = 6;
                                return this._sessionService.getUserEmail();

                            case 6:
                                getEmail = _context6.sent;
                                isCartOwner = getEmail === (cartOwner && cartOwner.email);
                                return _context6.abrupt('return', isCartOwner);

                            case 9:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function isCartOwner() {
                return _ref6.apply(this, arguments);
            }

            return isCartOwner;
        }()
    }, {
        key: 'isLastLeftCartDeadlineExpired',
        value: function isLastLeftCartDeadlineExpired() {
            if (!this._lastLeftCart || !this._lastLeftCart.closeOn) {
                return false;
            }
            var deadlineTime = (0, _moment2.default)(this._lastLeftCart.closeOn).subtract(15, 'minutes');
            return (0, _moment2.default)().isAfter(deadlineTime);
        }
    }, {
        key: 'leaveCart',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context7.sent) {
                                    _context7.next = 6;
                                    break;
                                }

                                _context7.next = 5;
                                return this.resetCart();

                            case 5:
                                return _context7.abrupt('return');

                            case 6:
                                _context7.next = 8;
                                return this.getCart();

                            case 8:
                                this._lastLeftCart = _context7.sent;
                                _context7.next = 11;
                                return this._httpService.post(this._urlBase + '/leave');

                            case 11:
                                _context7.next = 13;
                                return this._sessionService.isInvite();

                            case 13:
                                if (!_context7.sent) {
                                    _context7.next = 16;
                                    break;
                                }

                                _context7.next = 16;
                                return this._sessionService.clearSessionDetails();

                            case 16:
                                _context7.next = 18;
                                return this.resetCart();

                            case 18:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function leaveCart() {
                return _ref7.apply(this, arguments);
            }

            return leaveCart;
        }()
    }, {
        key: 'checkOutCart',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                return _context8.abrupt('return', this._httpService.get(this._urlBase + '/checkout'));

                            case 1:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function checkOutCart() {
                return _ref8.apply(this, arguments);
            }

            return checkOutCart;
        }()
    }, {
        key: 'clearLocalCart',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.CART);

                            case 2:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function clearLocalCart() {
                return _ref9.apply(this, arguments);
            }

            return clearLocalCart;
        }()
    }, {
        key: 'getLocalCart',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var cart;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this._localForageService.retrieve(_CommonConstants2.default.SessionStorage.CART);

                            case 2:
                                cart = _context10.sent;

                                if (!cart) {
                                    _context10.next = 5;
                                    break;
                                }

                                return _context10.abrupt('return', JSON.parse(cart));

                            case 5:
                                return _context10.abrupt('return', null);

                            case 6:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function getLocalCart() {
                return _ref10.apply(this, arguments);
            }

            return getLocalCart;
        }()
    }, {
        key: 'getCartReport',
        value: function getCartReport(status) {
            var pageIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;

            return this._httpService.get(this._urlBase + '/cartsReport', {
                params: {
                    pageIndex: pageIndex,
                    pageSize: pageSize,
                    status: status
                }
            }).then(function (response) {
                return response.data;
            }).catch(function (error) {
                throw error;
            });
        }
    }, {
        key: 'getCart',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(cartId) {
                var _this4 = this;

                var fromCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var promise, isLoggedIn, url, cart, response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this._sessionService.getCartReference();

                            case 2:
                                promise = _context11.sent;

                                if (!(fromCache && promise)) {
                                    _context11.next = 6;
                                    break;
                                }

                                this.setAddCartButtonState(promise);
                                return _context11.abrupt('return', promise);

                            case 6:
                                _context11.next = 8;
                                return this._sessionService.loggedIn();

                            case 8:
                                isLoggedIn = _context11.sent;

                                if (!isLoggedIn) {
                                    _context11.next = 15;
                                    break;
                                }

                                url = this._urlBase;

                                if (cartId) {
                                    url = this._urlBase + '/' + cartId;
                                }

                                return _context11.abrupt('return', this._httpService.get(url).then(function (response) {
                                    var cart = response.data;
                                    _this4.updateGroupOrderStatus(cart);
                                    _this4._sessionService.setCartReference(cart);
                                    if (_this4._rootScope.retailer && _this4._rootScope.retailer.customCartNames === '1') {
                                        _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.updateMyCartButtonText, { cartNameValue: cart.cartName });
                                    }

                                    _this4.setAddCartButtonState(cart);
                                    return cart;
                                }));

                            case 15:
                                _context11.next = 17;
                                return this.getLocalCart();

                            case 17:
                                cart = _context11.sent;
                                response = cart || {
                                    items: [],
                                    participants: [],
                                    fulfillment: {}
                                };

                                this.setAddCartButtonState(cart);
                                this._sessionService.setCartReference(response);
                                return _context11.abrupt('return', response);

                            case 22:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function getCart(_x3) {
                return _ref11.apply(this, arguments);
            }

            return getCart;
        }()
    }, {
        key: 'setAddCartButtonState',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(cart) {
                var cartOwner, getEmail, isOwner;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                if (!cart) {
                                    _context12.next = 7;
                                    break;
                                }

                                cartOwner = _.find(cart.participants, function (participant) {
                                    return participant.status === 'OWNER';
                                });
                                _context12.next = 4;
                                return this._sessionService.getUserEmail();

                            case 4:
                                getEmail = _context12.sent;
                                isOwner = getEmail === (cartOwner && cartOwner.email);

                                if (this._rootScope.retailer) {
                                    if (this._rootScope.retailer.cartonomyMode !== _CommonConstants2.default.CartonomyMode.marketing || (isOwner || cart.participants.length == 0) && cart.participants.filter(function (p) {
                                        return p.status === 'JOINED';
                                    }).length === 0) {
                                        _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.enableAddToCartButton, {});
                                    } else {
                                        _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.removeAddToCartButton, {});
                                    }
                                }

                            case 7:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function setAddCartButtonState(_x5) {
                return _ref12.apply(this, arguments);
            }

            return setAddCartButtonState;
        }()
    }, {
        key: 'getCartById',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(cartId) {
                var promise;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                //let response = await this._httpService.get(this._urlBase + '/' + cartId);

                                promise = this._httpService.get(this._urlBase + '/' + cartId).then(function (response) {
                                    var cart = response.data;
                                    //this.updateGroupOrderStatus(cart);
                                    return cart;
                                });


                                this._sessionService.setCartReference(promise);

                                return _context13.abrupt('return', promise);

                            case 3:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function getCartById(_x6) {
                return _ref13.apply(this, arguments);
            }

            return getCartById;
        }()
    }, {
        key: 'getCartByInvitationCode',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(invitationCode) {
                var promise;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                promise = this._httpService.get(this._urlBase + '/invitation/' + invitationCode).then(function (response) {
                                    var cart = response.data;
                                    //this.updateGroupOrderStatus(cart);
                                    return cart;
                                });
                                return _context14.abrupt('return', promise);

                            case 2:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function getCartByInvitationCode(_x7) {
                return _ref14.apply(this, arguments);
            }

            return getCartByInvitationCode;
        }()
    }, {
        key: 'updateGroupOrderStatus',
        value: function updateGroupOrderStatus(cart) {
            var isGroupOrder = cart ? CartService.isGroupOrder(cart) : false;
            if (isGroupOrder != this._isGroupOrder) {
                this._isGroupOrder = isGroupOrder;
                this.onGroupOrderStatusChanged();
            }
        }
    }, {
        key: 'onGroupOrderStatusChanged',
        value: function onGroupOrderStatusChanged() {
            this._rootScope.$emit(_CommonConstants2.default.Events.GROUP_ORDER_STATUS_CHANGED);
        }
    }, {
        key: 'isGroupOrder',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(cart) {
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context15.sent) {
                                    _context15.next = 4;
                                    break;
                                }

                                return _context15.abrupt('return', false);

                            case 4:
                                if (!cart) {
                                    _context15.next = 6;
                                    break;
                                }

                                return _context15.abrupt('return', CartService.isGroupOrder(cart));

                            case 6:
                                _context15.t0 = CartService;
                                _context15.next = 9;
                                return this.getCart();

                            case 9:
                                _context15.t1 = _context15.sent;
                                return _context15.abrupt('return', _context15.t0.isGroupOrder.call(_context15.t0, _context15.t1));

                            case 11:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function isGroupOrder(_x8) {
                return _ref15.apply(this, arguments);
            }

            return isGroupOrder;
        }()
    }, {
        key: 'getCartAmount',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
                var cart, items, amount;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this.getCart();

                            case 2:
                                cart = _context16.sent;
                                items = _.cloneDeep(cart.items);
                                amount = _.sumBy(items, function (item) {
                                    return item.price * item.quantity;
                                });
                                return _context16.abrupt('return', amount);

                            case 6:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function getCartAmount() {
                return _ref16.apply(this, arguments);
            }

            return getCartAmount;
        }()
    }, {
        key: '_updateLocalCart',
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(cart) {
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                _context17.next = 2;
                                return this._localForageService.store(_CommonConstants2.default.SessionStorage.CART, JSON.stringify(cart));

                            case 2:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function _updateLocalCart(_x9) {
                return _ref17.apply(this, arguments);
            }

            return _updateLocalCart;
        }()
    }, {
        key: 'addProductFromShopify',
        value: function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(productVariantId, quantity, productOptions) {
                var params, response, cart;
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                params = {
                                    externalProductId: productVariantId,
                                    quantity: quantity,
                                    itemComment: "",
                                    itemOption: productOptions,
                                    itemName: ""
                                };
                                _context18.prev = 1;
                                _context18.next = 4;
                                return this._httpService.post(this._urlBase + '/item', params);

                            case 4:
                                response = _context18.sent;
                                cart = response.data;


                                this._heapService.track('AddItem', { itemId: productVariantId, quantity: quantity });

                                this._sessionService.setCartReference(new Promise(function (resolve) {
                                    return resolve(cart);
                                }));
                                this.updateGroupOrderStatus(cart);
                                _context18.next = 14;
                                break;

                            case 11:
                                _context18.prev = 11;
                                _context18.t0 = _context18['catch'](1);
                                throw _context18.t0;

                            case 14:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this, [[1, 11]]);
            }));

            function addProductFromShopify(_x10, _x11, _x12) {
                return _ref18.apply(this, arguments);
            }

            return addProductFromShopify;
        }()
    }, {
        key: 'addProductFromCustomSite',
        value: function () {
            var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(productVariantId, quantity, name, image, price, productOptions, productUrl) {
                var params, response, cart;
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                params = {
                                    externalProductId: productVariantId,
                                    quantity: quantity,
                                    itemComment: "",
                                    itemOption: productOptions,
                                    itemName: name,
                                    image: image,
                                    price: price,
                                    productUrl: productUrl
                                };
                                _context19.prev = 1;
                                _context19.next = 4;
                                return this._httpService.post(this._urlBase + '/item', params);

                            case 4:
                                response = _context19.sent;
                                cart = response.data;


                                this._heapService.track('AddItem', { itemId: productVariantId, quantity: quantity });

                                this._sessionService.setCartReference(new Promise(function (resolve) {
                                    return resolve(cart);
                                }));
                                this.updateGroupOrderStatus(cart);
                                _context19.next = 14;
                                break;

                            case 11:
                                _context19.prev = 11;
                                _context19.t0 = _context19['catch'](1);
                                throw _context19.t0;

                            case 14:
                            case 'end':
                                return _context19.stop();
                        }
                    }
                }, _callee19, this, [[1, 11]]);
            }));

            function addProductFromCustomSite(_x13, _x14, _x15, _x16, _x17, _x18, _x19) {
                return _ref19.apply(this, arguments);
            }

            return addProductFromCustomSite;
        }()
    }, {
        key: 'addProduct',
        value: function () {
            var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(product) {
                var _this5 = this;

                var cart, existingItem, _email, onCartReceived, _ret, params, response, email, item;

                return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:
                                _context20.next = 2;
                                return this.getCart();

                            case 2:
                                cart = _context20.sent;
                                existingItem = void 0;
                                _context20.next = 6;
                                return this._sessionService.loggedIn();

                            case 6:
                                if (!_context20.sent) {
                                    _context20.next = 13;
                                    break;
                                }

                                _context20.next = 9;
                                return this._sessionService.getUserEmail();

                            case 9:
                                _email = _context20.sent;

                                existingItem = cart.items && cart.items.find(function (item) {
                                    return item.catalogProductId === product.id && item.participantEmail === _email;
                                });
                                _context20.next = 14;
                                break;

                            case 13:
                                existingItem = cart.items && cart.items.find(function (item) {
                                    return item.catalogProductId === product.id;
                                });

                            case 14:
                                if (!existingItem) {
                                    _context20.next = 17;
                                    break;
                                }

                                existingItem.quantity += product.quantity;
                                return _context20.abrupt('return', this.updateItem(existingItem, true));

                            case 17:
                                onCartReceived = function onCartReceived(cart, item) {
                                    _this5._sessionService.setCartReference(new Promise(function (resolve) {
                                        return resolve(cart);
                                    }));
                                    _this5._rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.DISPLAY_POPUP_BAG, item ? item.id : null);

                                    _this5.updateGroupOrderStatus(cart);
                                };

                                _context20.next = 20;
                                return this._sessionService.loggedIn();

                            case 20:
                                if (_context20.sent) {
                                    _context20.next = 24;
                                    break;
                                }

                                _ret = function () {

                                    var itemId = _this5._itemId || 1;

                                    var item = {
                                        catalogProductId: product.id,
                                        catalogProductImage: product.image,
                                        quantity: product.quantity || 1,
                                        comment: product.comment,
                                        itemName: product.name,
                                        itemOption: "",
                                        price: product.price
                                    };

                                    if (!cart.items) {
                                        cart.items = [];
                                    }

                                    //noinspection JSReferencingMutableVariableFromClosure
                                    while (cart.items.find(function (item) {
                                        return item.id === itemId;
                                    })) {
                                        itemId++;
                                    }

                                    item.id = itemId;

                                    _this5._itemId = itemId + 1;

                                    item.total = item.price * item.quantity;

                                    cart.items.push(item);

                                    _this5._updateLocalCart(cart);
                                    onCartReceived(cart, item);
                                    return {
                                        v: void 0
                                    };
                                }();

                                if (!((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object")) {
                                    _context20.next = 24;
                                    break;
                                }

                                return _context20.abrupt('return', _ret.v);

                            case 24:
                                params = {
                                    catalogItemId: product.id,
                                    quantity: product.quantity || 1,
                                    itemComment: product.comment,
                                    itemOption: "",
                                    itemName: ""
                                };
                                _context20.next = 27;
                                return this._httpService.post(this._urlBase + '/item', params);

                            case 27:
                                response = _context20.sent;


                                cart = response.data;
                                _context20.next = 31;
                                return this._sessionService.getUserEmail();

                            case 31:
                                email = _context20.sent;
                                item = cart.items && cart.items.find(function (item) {
                                    return item.catalogProductId === product.id && item.participantEmail === email;
                                });


                                onCartReceived(cart, item);

                            case 34:
                            case 'end':
                                return _context20.stop();
                        }
                    }
                }, _callee20, this);
            }));

            function addProduct(_x20) {
                return _ref20.apply(this, arguments);
            }

            return addProduct;
        }()
    }, {
        key: 'updateItem',
        value: function () {
            var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(item, displayPopupBag) {
                var _cart, existingItem, params, response, cartItem, cart, i;

                return regeneratorRuntime.wrap(function _callee21$(_context21) {
                    while (1) {
                        switch (_context21.prev = _context21.next) {
                            case 0:
                                _context21.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context21.sent) {
                                    _context21.next = 16;
                                    break;
                                }

                                _context21.next = 5;
                                return this.getCart();

                            case 5:
                                _cart = _context21.sent;
                                existingItem = _cart.items && _cart.items.find(function (i) {
                                    return i.id === item.id;
                                });

                                if (existingItem) {
                                    _context21.next = 9;
                                    break;
                                }

                                return _context21.abrupt('return');

                            case 9:
                                existingItem.quantity = item.quantity;
                                existingItem.comment = item.comment;
                                _context21.next = 13;
                                return this._updateLocalCart(_cart);

                            case 13:
                                this._sessionService.setCartReference(new Promise(function (resolve) {
                                    return resolve(_cart);
                                }));
                                if (displayPopupBag) {
                                    this._rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.DISPLAY_POPUP_BAG, item.id);
                                } else {
                                    this._rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.POPUP_BAG_CHANGED);
                                }
                                return _context21.abrupt('return');

                            case 16:
                                params = {
                                    id: item.id,
                                    catalogProductId: item.catalogProductId,
                                    quantity: item.quantity,
                                    itemComment: item.comment,
                                    itemOption: item.itemOption,
                                    isShared: item.isShared
                                };
                                _context21.next = 19;
                                return this._httpService.put(this._urlBase + '/item', params);

                            case 19:
                                response = _context21.sent;
                                cartItem = response.data;
                                _context21.next = 23;
                                return this._sessionService.getCartReference();

                            case 23:
                                cart = _context21.sent;

                                if (cart) {
                                    _context21.next = 27;
                                    break;
                                }

                                this._rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.POPUP_BAG_CHANGED);
                                return _context21.abrupt('return');

                            case 27:
                                if (!cart.items) {
                                    _context21.next = 37;
                                    break;
                                }

                                i = 0;

                            case 29:
                                if (!(i < cart.items.length)) {
                                    _context21.next = 37;
                                    break;
                                }

                                if (!(cart.items[i].id === cartItem.id)) {
                                    _context21.next = 34;
                                    break;
                                }

                                cartItem.product = cartItem.product || cart.items[i].product;
                                cart.items[i] = cartItem;
                                return _context21.abrupt('break', 37);

                            case 34:
                                i++;
                                _context21.next = 29;
                                break;

                            case 37:

                                this._sessionService.setCartReference(cart);

                                if (displayPopupBag) {
                                    this._rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.DISPLAY_POPUP_BAG, item.id);
                                } else {
                                    this._rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.POPUP_BAG_CHANGED);
                                }

                            case 39:
                            case 'end':
                                return _context21.stop();
                        }
                    }
                }, _callee21, this);
            }));

            function updateItem(_x21, _x22) {
                return _ref21.apply(this, arguments);
            }

            return updateItem;
        }()
    }, {
        key: 'deleteItem',
        value: function () {
            var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(id) {
                var cart, index, res;
                return regeneratorRuntime.wrap(function _callee22$(_context22) {
                    while (1) {
                        switch (_context22.prev = _context22.next) {
                            case 0:
                                _context22.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context22.sent) {
                                    _context22.next = 14;
                                    break;
                                }

                                _context22.next = 5;
                                return this.getCart();

                            case 5:
                                cart = _context22.sent;
                                index = cart.items && cart.items.findIndex(function (item) {
                                    return item.id === id;
                                });

                                if (!(index < 0)) {
                                    _context22.next = 9;
                                    break;
                                }

                                return _context22.abrupt('return', false);

                            case 9:
                                cart.items.splice(index, 1);
                                this._updateLocalCart(cart);
                                this._sessionService.setCartReference(null);
                                this._rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.POPUP_BAG_CHANGED);
                                return _context22.abrupt('return', true);

                            case 14:
                                _context22.next = 16;
                                return this._httpService.delete(this._urlBase + '/item/' + id);

                            case 16:
                                res = _context22.sent;


                                this._sessionService.setCartReference(null);
                                this._rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.POPUP_BAG_CHANGED);
                                return _context22.abrupt('return', res);

                            case 20:
                            case 'end':
                                return _context22.stop();
                        }
                    }
                }, _callee22, this);
            }));

            function deleteItem(_x23) {
                return _ref22.apply(this, arguments);
            }

            return deleteItem;
        }()
    }, {
        key: 'sendInvites',
        value: function sendInvites(emails) {
            return this._httpService.post(this._urlBase + '/participants', _.map(emails, function (email) {
                return {
                    email: email
                };
            }));
        }
    }, {
        key: 'removeParticipant',
        value: function removeParticipant(participantEmail) {
            return this._httpService.delete(this._urlBase + '/participant?participantEmail=' + encodeURIComponent(participantEmail));
        }
    }, {
        key: 'getParticipants',
        value: function getParticipants() {
            return this._httpService.get(this._urlBase + '/participants').then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'transferOwner',
        value: function transferOwner(newOwnerParticipantId) {
            return this._httpService.post(this._urlBase + '/transferOwner/' + newOwnerParticipantId).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'isOwner',
        value: function () {
            var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(cart) {
                var userEmail, participant;
                return regeneratorRuntime.wrap(function _callee23$(_context23) {
                    while (1) {
                        switch (_context23.prev = _context23.next) {
                            case 0:
                                if (!(!cart || !cart.participants)) {
                                    _context23.next = 2;
                                    break;
                                }

                                return _context23.abrupt('return', false);

                            case 2:
                                _context23.next = 4;
                                return this._sessionService.getUserEmail();

                            case 4:
                                userEmail = _context23.sent;
                                participant = _.find(cart.participants, function (participant) {
                                    return participant.email === userEmail;
                                });
                                return _context23.abrupt('return', participant && participant.status === _CommonConstants2.default.CartDetails.Participant.Status.OWNER);

                            case 7:
                            case 'end':
                                return _context23.stop();
                        }
                    }
                }, _callee23, this);
            }));

            function isOwner(_x24) {
                return _ref23.apply(this, arguments);
            }

            return isOwner;
        }()
    }, {
        key: 'isParticipantOwner',
        value: function () {
            var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(participant) {
                return regeneratorRuntime.wrap(function _callee24$(_context24) {
                    while (1) {
                        switch (_context24.prev = _context24.next) {
                            case 0:
                                if (participant) {
                                    _context24.next = 2;
                                    break;
                                }

                                return _context24.abrupt('return', false);

                            case 2:
                                return _context24.abrupt('return', participant.status === _CommonConstants2.default.CartDetails.Participant.Status.OWNER);

                            case 3:
                            case 'end':
                                return _context24.stop();
                        }
                    }
                }, _callee24, this);
            }));

            function isParticipantOwner(_x25) {
                return _ref24.apply(this, arguments);
            }

            return isParticipantOwner;
        }()
    }, {
        key: 'resetCart',
        value: function () {
            var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
                return regeneratorRuntime.wrap(function _callee25$(_context25) {
                    while (1) {
                        switch (_context25.prev = _context25.next) {
                            case 0:
                                _context25.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context25.sent) {
                                    _context25.next = 5;
                                    break;
                                }

                                _context25.next = 5;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.CART);

                            case 5:

                                this._sessionService.setCartReference(null, false);
                                this._rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.POPUP_BAG_CHANGED);

                            case 7:
                            case 'end':
                                return _context25.stop();
                        }
                    }
                }, _callee25, this);
            }));

            function resetCart() {
                return _ref25.apply(this, arguments);
            }

            return resetCart;
        }()
    }, {
        key: 'getCartProperties',
        value: function () {
            var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
                var cart;
                return regeneratorRuntime.wrap(function _callee26$(_context26) {
                    while (1) {
                        switch (_context26.prev = _context26.next) {
                            case 0:
                                _context26.next = 2;
                                return this.getCart();

                            case 2:
                                cart = _context26.sent;
                                _context26.next = 5;
                                return this.isGroupOrder(cart);

                            case 5:
                                _context26.t0 = _context26.sent;
                                _context26.t1 = this.isOwner(cart);
                                _context26.t2 = cart.title;
                                _context26.t3 = cart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.SINGLE;
                                return _context26.abrupt('return', {
                                    isGroupOrder: _context26.t0,
                                    isOwner: _context26.t1,
                                    title: _context26.t2,
                                    singlePay: _context26.t3
                                });

                            case 10:
                            case 'end':
                                return _context26.stop();
                        }
                    }
                }, _callee26, this);
            }));

            function getCartProperties() {
                return _ref26.apply(this, arguments);
            }

            return getCartProperties;
        }()
    }, {
        key: 'getCartDetails',
        value: function () {
            var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
                var fulfillment;
                return regeneratorRuntime.wrap(function _callee27$(_context27) {
                    while (1) {
                        switch (_context27.prev = _context27.next) {
                            case 0:
                                _context27.next = 2;
                                return this.getCart();

                            case 2:
                                fulfillment = _context27.sent.fulfillment;
                                return _context27.abrupt('return', {
                                    deliveryMethod: fulfillment.deliveryMethod || _CommonConstants2.default.CartDetails.DeliveryMethods.DEFAULT,
                                    paymentMethod: fulfillment.paymentMethod || _CommonConstants2.default.CartDetails.PaymentMethods.DEFAULT,
                                    shippingMethod: fulfillment.shippingMethod || _CommonConstants2.default.CartDetails.ShippingMethods.DEFAULT,
                                    deliveryDate: fulfillment.expectedOn,
                                    deliveryTime: fulfillment.expectedOn,
                                    deliveryPhone: fulfillment.shippingPhone,
                                    deliveryAddress: {
                                        city: fulfillment.shippingCity,
                                        street: fulfillment.shippingAddress,
                                        zip: fulfillment.shippingZip,
                                        aptSuite: fulfillment.shippingAddress2,
                                        state: fulfillment.shippingState
                                    }
                                });

                            case 4:
                            case 'end':
                                return _context27.stop();
                        }
                    }
                }, _callee27, this);
            }));

            function getCartDetails() {
                return _ref27.apply(this, arguments);
            }

            return getCartDetails;
        }()
    }, {
        key: 'setCartConfiguration',
        value: function () {
            var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28(configuration) {
                var cart;
                return regeneratorRuntime.wrap(function _callee28$(_context28) {
                    while (1) {
                        switch (_context28.prev = _context28.next) {
                            case 0:
                                _context28.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context28.sent) {
                                    _context28.next = 12;
                                    break;
                                }

                                _context28.next = 5;
                                return this.getCart();

                            case 5:
                                cart = _context28.sent;

                                cart.title = configuration.title;
                                cart.comment = configuration.comment;
                                _context28.next = 10;
                                return this._updateLocalCart(cart);

                            case 10:
                                this._sessionService.setCartReference(null);
                                return _context28.abrupt('return');

                            case 12:
                                _context28.next = 14;
                                return this._httpService.put(this._urlBase, {
                                    title: configuration.title,
                                    comment: configuration.comment,
                                    automaticExpire: configuration.automaticExpire,
                                    automaticProcess: configuration.automaticProcess,
                                    sendCloseNotification: configuration.sendCloseNotification,
                                    orderLimit: configuration.orderLimit,
                                    orderLimitType: configuration.orderLimitType,
                                    closeOn: configuration.closeOn, // Must be retailer timezone
                                    shippingTotal: configuration.shippingTotal,
                                    taxTotal: configuration.taxTotal,
                                    cartName: configuration.cartName,
                                    retailerStoreId: configuration.retailerStoreId
                                });

                            case 14:
                            case 'end':
                                return _context28.stop();
                        }
                    }
                }, _callee28, this);
            }));

            function setCartConfiguration(_x26) {
                return _ref28.apply(this, arguments);
            }

            return setCartConfiguration;
        }()
    }, {
        key: 'setCartDetails',
        value: function () {
            var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(details) {
                var fulfillment, url, response, cart;
                return regeneratorRuntime.wrap(function _callee29$(_context29) {
                    while (1) {
                        switch (_context29.prev = _context29.next) {
                            case 0:
                                _context29.next = 2;
                                return this.getCart();

                            case 2:
                                fulfillment = _context29.sent.fulfillment;

                                console.log('setCartDetails');
                                _.assign(fulfillment, {
                                    deliveryMethod: details.deliveryMethod || fulfillment.deliveryMethod,
                                    paymentMethod: details.paymentMethod || fulfillment.paymentMethod,
                                    expectedOn: details.deliveryDate ? _moment2.default.utc(details.deliveryDate).format() : fulfillment.expectedOn,
                                    shippingPhone: details.deliveryPhone || fulfillment.shippingPhone,
                                    cartInvitationType: this._invitationType,
                                    shareToken: this._invitationType == _CommonConstants2.default.InvitationTypes.share ? this._inviteCode : null,
                                    cartName: details.cartName
                                });

                                if (details.deliveryAddress && (details.deliveryAddress.city || details.deliveryAddress.street || details.deliveryAddress.zip)) {
                                    fulfillment.shippingCity = details.deliveryAddress.city;
                                    fulfillment.shippingAddress = details.deliveryAddress.street;
                                    fulfillment.shippingZip = details.deliveryAddress.zip;
                                    fulfillment.shippingAddress2 = details.deliveryAddress.aptSuite;
                                    fulfillment.shippingState = details.deliveryAddress.state;
                                }

                                url = this._urlBase + "/fulfillment";
                                _context29.next = 9;
                                return this._httpService.put(url, fulfillment);

                            case 9:
                                response = _context29.sent;


                                this.resetCartInvitationType();

                                _context29.next = 13;
                                return this.getCart();

                            case 13:
                                cart = _context29.sent;


                                cart.fulfillment = response.data;

                                return _context29.abrupt('return', response.data);

                            case 16:
                            case 'end':
                                return _context29.stop();
                        }
                    }
                }, _callee29, this);
            }));

            function setCartDetails(_x27) {
                return _ref29.apply(this, arguments);
            }

            return setCartDetails;
        }()
    }, {
        key: 'acceptInvite',
        value: function () {
            var _ref30 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30(token, forceInvite) {
                var invitationType, response;
                return regeneratorRuntime.wrap(function _callee30$(_context30) {
                    while (1) {
                        switch (_context30.prev = _context30.next) {
                            case 0:
                                invitationType = this._invitationType;
                                _context30.next = 3;
                                return this._httpService.post(this._urlBase + '/invite/accept', {
                                    token: token,
                                    forceInvite: forceInvite
                                });

                            case 3:
                                response = _context30.sent;
                                return _context30.abrupt('return', {
                                    alreadyJoined: response.data.alreadyJoined,
                                    authToken: response.data.authToken,
                                    userEmail: response.data.user.userName,
                                    userName: response.data.user.fullName,
                                    participantToken: response.data.participantToken,
                                    cartId: response.data.cartId
                                });

                            case 5:
                            case 'end':
                                return _context30.stop();
                        }
                    }
                }, _callee30, this);
            }));

            function acceptInvite(_x28, _x29) {
                return _ref30.apply(this, arguments);
            }

            return acceptInvite;
        }()
    }, {
        key: 'updateCartName',
        value: function () {
            var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31(cartName) {
                return regeneratorRuntime.wrap(function _callee31$(_context31) {
                    while (1) {
                        switch (_context31.prev = _context31.next) {
                            case 0:
                                if (this._sessionService.loggedIn()) {
                                    _context31.next = 2;
                                    break;
                                }

                                return _context31.abrupt('return');

                            case 2:
                                _context31.next = 4;
                                return this._httpService.put(this._urlBase + '/updateCartName', {
                                    cartName: cartName
                                });

                            case 4:
                            case 'end':
                                return _context31.stop();
                        }
                    }
                }, _callee31, this);
            }));

            function updateCartName(_x30) {
                return _ref31.apply(this, arguments);
            }

            return updateCartName;
        }()
    }, {
        key: 'refreshItems',
        value: function refreshItems() {
            this._sessionService.setCartReference(null);
        }
    }, {
        key: 'getInvitationCode',
        value: function () {
            var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
                return regeneratorRuntime.wrap(function _callee32$(_context32) {
                    while (1) {
                        switch (_context32.prev = _context32.next) {
                            case 0:
                                return _context32.abrupt('return', this._httpService.get(this._urlBase + '/getInvitationCode').then(function (response) {
                                    return response.data;
                                }));

                            case 1:
                            case 'end':
                                return _context32.stop();
                        }
                    }
                }, _callee32, this);
            }));

            function getInvitationCode() {
                return _ref32.apply(this, arguments);
            }

            return getInvitationCode;
        }()
    }, {
        key: 'getShareTokenByCartId',
        value: function () {
            var _ref33 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee33(cartId) {
                var _this6 = this;

                return regeneratorRuntime.wrap(function _callee33$(_context33) {
                    while (1) {
                        switch (_context33.prev = _context33.next) {
                            case 0:
                                if (!this.shareTokenPromise) {
                                    this.shareTokenPromise = new Promise(function (resolve) {
                                        _this6._httpService.get(_this6._urlBase + '/getShareTokenByCartId/' + cartId).then(function (response) {
                                            resolve(response.data);
                                        });
                                    });
                                }
                                return _context33.abrupt('return', this.shareTokenPromise);

                            case 2:
                            case 'end':
                                return _context33.stop();
                        }
                    }
                }, _callee33, this);
            }));

            function getShareTokenByCartId(_x31) {
                return _ref33.apply(this, arguments);
            }

            return getShareTokenByCartId;
        }()
    }, {
        key: 'getParticipantamounts',
        value: function () {
            var _ref34 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee34(cartId) {
                return regeneratorRuntime.wrap(function _callee34$(_context34) {
                    while (1) {
                        switch (_context34.prev = _context34.next) {
                            case 0:
                                return _context34.abrupt('return', this._httpService.get(this._urlBase + '/getParticipantamounts/' + cartId).then(function (response) {
                                    return response.data;
                                }));

                            case 1:
                            case 'end':
                                return _context34.stop();
                        }
                    }
                }, _callee34, this);
            }));

            function getParticipantamounts(_x32) {
                return _ref34.apply(this, arguments);
            }

            return getParticipantamounts;
        }()
    }, {
        key: 'updateAmountTopay',
        value: function () {
            var _ref35 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee35(params) {
                return regeneratorRuntime.wrap(function _callee35$(_context35) {
                    while (1) {
                        switch (_context35.prev = _context35.next) {
                            case 0:
                                _context35.next = 2;
                                return this._httpService.put(this._urlBase + '/updateParticipantamount', params);

                            case 2:
                                return _context35.abrupt('return', _context35.sent);

                            case 3:
                            case 'end':
                                return _context35.stop();
                        }
                    }
                }, _callee35, this);
            }));

            function updateAmountTopay(_x33) {
                return _ref35.apply(this, arguments);
            }

            return updateAmountTopay;
        }()
    }, {
        key: 'setInvitationType',
        value: function setInvitationType(value) {
            this._invitationType = value;
        }
    }, {
        key: 'getInvitationType',
        value: function getInvitationType() {
            return this._invitationType;
        }
    }, {
        key: 'setInviteCode',
        value: function setInviteCode(value) {
            this._inviteCode = value;
        }
    }, {
        key: 'getInviteCode',
        value: function getInviteCode() {
            return this._inviteCode;
        }
    }, {
        key: 'setInviteSingleLink',
        value: function setInviteSingleLink(value) {
            this._inviteSingleLink = value;
        }
    }, {
        key: 'getInviteSingleLink',
        value: function getInviteSingleLink(value) {
            return this._inviteSingleLink;
        }
    }, {
        key: 'setInviteMorePeopleMode',
        value: function setInviteMorePeopleMode(value) {
            this._inviteMorePeopleMode = value;
        }
    }, {
        key: 'getInviteMorePeopleMode',
        value: function getInviteMorePeopleMode() {
            return this._inviteMorePeopleMode;
        }
    }, {
        key: 'resetCartInvitationType',
        value: function resetCartInvitationType() {
            this._inviteMorePeopleMode = false;
            this._inviteCode = null;
            this.shareTokenPromise = null;
            this._invitationType = _CommonConstants2.default.InvitationTypes.normal;
            this._inviteSingleLink = null;
        }
    }, {
        key: 'copyClipboard',
        value: function copyClipboard(invitationLink) {
            var copyElement = document.createElement("textarea");
            copyElement.style.position = 'fixed';
            copyElement.style.opacity = '0';
            copyElement.textContent = invitationLink;
            copyElement.contentEditable = true;
            copyElement.readOnly = true;
            var body = document.getElementsByTagName('body')[0];
            body.appendChild(copyElement);
            if (_utils.utils.isIOSMobile) {

                var range = document.createRange();
                range.selectNodeContents(copyElement);
                var s = window.getSelection();
                s.removeAllRanges();
                s.addRange(range);
                copyElement.setSelectionRange(0, 999999);
            } else {
                copyElement.select();
            }
            document.execCommand('copy');
            body.removeChild(copyElement);
        }
    }, {
        key: 'confirmContinueCheckoutWhenMatchCartItems',
        value: function () {
            var _ref36 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee36() {
                var continueCheckout;
                return regeneratorRuntime.wrap(function _callee36$(_context36) {
                    while (1) {
                        switch (_context36.prev = _context36.next) {
                            case 0:
                                _context36.next = 2;
                                return this._messageService.showQuestionPopup(this.$translate.instant('client.confirm_checkout.match_items'), '', this.$translate.instant('client.ok'), this.$translate.instant('client.cancel'));

                            case 2:
                                continueCheckout = _context36.sent;
                                return _context36.abrupt('return', continueCheckout);

                            case 4:
                            case 'end':
                                return _context36.stop();
                        }
                    }
                }, _callee36, this);
            }));

            function confirmContinueCheckoutWhenMatchCartItems() {
                return _ref36.apply(this, arguments);
            }

            return confirmContinueCheckoutWhenMatchCartItems;
        }()
    }, {
        key: 'confirmContinueCheckout',
        value: function () {
            var _ref37 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee37() {
                var retailerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Shopify';
                var continueCheckout;
                return regeneratorRuntime.wrap(function _callee37$(_context37) {
                    while (1) {
                        switch (_context37.prev = _context37.next) {
                            case 0:
                                _context37.next = 2;
                                return this._messageService.showQuestionPopup(this.$translate.instant('client.confirm_checkout'), '', this.$translate.instant('client.ok'), this.$translate.instant('client.cancel'));

                            case 2:
                                continueCheckout = _context37.sent;
                                return _context37.abrupt('return', continueCheckout);

                            case 4:
                            case 'end':
                                return _context37.stop();
                        }
                    }
                }, _callee37, this);
            }));

            function confirmContinueCheckout() {
                return _ref37.apply(this, arguments);
            }

            return confirmContinueCheckout;
        }()
    }, {
        key: 'startProcessCheckout',
        value: function () {
            var _ref38 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee38() {
                var confirmed;
                return regeneratorRuntime.wrap(function _callee38$(_context38) {
                    while (1) {
                        switch (_context38.prev = _context38.next) {
                            case 0:
                                _context38.next = 2;
                                return this._messageService.showQuestionPopup(this.$translate.instant('client.start_checkout'), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

                            case 2:
                                confirmed = _context38.sent;
                                return _context38.abrupt('return', confirmed);

                            case 4:
                            case 'end':
                                return _context38.stop();
                        }
                    }
                }, _callee38, this);
            }));

            function startProcessCheckout() {
                return _ref38.apply(this, arguments);
            }

            return startProcessCheckout;
        }()
    }], [{
        key: 'isGroupOrder',
        value: function isGroupOrder(cart) {
            if (!cart) {
                return false;
            }

            return cart.cartType === 'GROUP' || cart.participants && cart.participants.length > 1;
        }
    }]);

    return CartService;
}();

CartService.$inject = ['$http', 'Session', 'cartonomyConfig', '$rootScope', 'LocalForageService', '$timeout', 'Message', 'HeapService', 'RealTimeUpdateService', '$translate'];


_module3.default.service('CartService', CartService);

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _retailerService = __webpack_require__(682);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckoutService = exports.CheckoutService = function () {
  function CheckoutService(httpService, cartonomyConfig, configurationService, rootScope, sessionService) {
    _classCallCheck(this, CheckoutService);

    this._urlBase = cartonomyConfig.ApiV2 + 'checkout';
    this._httpService = httpService;
    this._configurationService = configurationService;
    this._rootScope = rootScope;
    this._sessionService = sessionService;
    this.cartonomyConfig = cartonomyConfig;
  }

  _createClass(CheckoutService, [{
    key: '_getDefaultRetailerId',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var retailer;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._configurationService.getItem('retailer');

              case 2:
                retailer = _context.sent;
                return _context.abrupt('return', retailer.id);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _getDefaultRetailerId() {
        return _ref.apply(this, arguments);
      }

      return _getDefaultRetailerId;
    }()
  }, {
    key: 'getVendorList',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var retailerId, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this._vendorList) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', this._vendorList);

              case 2:
                _context2.next = 4;
                return this._getDefaultRetailerId();

              case 4:
                retailerId = _context2.sent;
                _context2.next = 7;
                return this._httpService.get(this._urlBase + '/options/' + retailerId);

              case 7:
                response = _context2.sent;

                this._vendorList = response.data;
                return _context2.abrupt('return', this._vendorList);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getVendorList() {
        return _ref2.apply(this, arguments);
      }

      return getVendorList;
    }()
  }, {
    key: 'getVendorMap',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var vendorList, ret;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getVendorList();

              case 2:
                vendorList = _context3.sent;
                ret = {};

                vendorList.forEach(function (vendor) {
                  ret[vendor.vendorName] = vendor.vendorId;
                });
                return _context3.abrupt('return', ret);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getVendorMap() {
        return _ref3.apply(this, arguments);
      }

      return getVendorMap;
    }()
  }, {
    key: 'beginCheckout',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(vendorName) {
        var vendorMap, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getVendorMap();

              case 2:
                vendorMap = _context4.sent;
                _context4.next = 5;
                return this._httpService.post(this._urlBase + '/begin', {
                  vendorId: vendorMap[vendorName]
                });

              case 5:
                response = _context4.sent;
                return _context4.abrupt('return', response.data);

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function beginCheckout(_x) {
        return _ref4.apply(this, arguments);
      }

      return beginCheckout;
    }()
  }, {
    key: 'submitOrder',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(vendorName, configuration) {
        var vendorMap, url, params, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getVendorMap();

              case 2:
                vendorMap = _context5.sent;
                url = this._urlBase + '/submit';
                params = {
                  vendorId: vendorMap[vendorName],
                  billing: {},
                  amount: configuration.orderTotal,
                  isAuthorization: configuration.isAuthorization
                };

                if (vendorName === 'Square') {
                  params.nonce = configuration.nonce;
                  params.billing.zip = configuration.cardData.billing_postal_code;
                } else {
                  params.externalPayerId = configuration.externalPayerId;
                }
                _context5.next = 8;
                return this._httpService.post(url, params);

              case 8:
                response = _context5.sent;

                this._rootScope.$emit(_CommonConstants2.default.RootEvents.PAYMENT_STATUS_CHANGED);
                return _context5.abrupt('return', response.data);

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function submitOrder(_x2, _x3) {
        return _ref5.apply(this, arguments);
      }

      return submitOrder;
    }()
  }, {
    key: 'paymentAuthorizedOrCaptured',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._sessionService.loggedIn();

              case 2:
                if (_context6.sent) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt('return', false);

              case 4:
                if (!this._paymentStatusPromise) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt('return', this._paymentStatusPromise);

              case 6:

                this._paymentStatusPromise = this._httpService.get(this._urlBase + '/paymentStatus').then(function (response) {
                  setTimeout(function () {
                    _this._paymentStatusPromise = null;
                  }, 500);
                  return response.data == 1 || response.data === 2;
                });

                return _context6.abrupt('return', this._paymentStatusPromise);

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function paymentAuthorizedOrCaptured() {
        return _ref6.apply(this, arguments);
      }

      return paymentAuthorizedOrCaptured;
    }()
  }, {
    key: 'getShopifyCheckoutInfo',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(userId) {
        var shopifyCheckoutUrl, response, data, errors, retailer, url, cartItemUrlPortions, cartInfoObj, i, shopifyCheckoutInfo, errorsList;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                shopifyCheckoutUrl = this.cartonomyConfig.ApiV2 + 'shopify/checkout';


                if (userId) {
                  shopifyCheckoutUrl += '?asUserId=' + userId;
                }

                _context7.next = 4;
                return this._httpService.get(shopifyCheckoutUrl);

              case 4:
                response = _context7.sent;
                data = response.data;
                errors = data.items.some(function (item) {
                  return item.errors.length > 0;
                });
                _context7.next = 9;
                return this._configurationService.getItem('retailer');

              case 9:
                retailer = _context7.sent;
                url = '//' + retailer.externalAPIURL + '/cart/';
                cartItemUrlPortions = [];
                _context7.t0 = [];
                _context7.next = 15;
                return this._sessionService.getAuthToken();

              case 15:
                _context7.t1 = _context7.sent;
                _context7.next = 18;
                return _retailerService.retailerService.checkRetailer();

              case 18:
                _context7.t2 = _context7.sent.retailer.id;
                _context7.t3 = {
                  'cartonomy-bearer': _context7.t1,
                  'cartonomy-retailer': _context7.t2
                };
                cartInfoObj = {
                  cartItems: _context7.t0,
                  customAttributes: _context7.t3,
                  discount: null
                };


                if (userId) {
                  cartInfoObj.customAttributes['cartonomy-participant-user-id'] = userId;
                }

                if (data.ownerOrderNumber) {
                  cartInfoObj.customAttributes['GroupOrderNumber'] = data.ownerOrderNumber;
                }

                if (data.deliveryDate) {
                  cartInfoObj.customAttributes['DeliveryDate'] = _moment2.default.utc(data.deliveryDate).local().format('LLL');
                }

                for (i = 0; i < data.items.length; i++) {
                  cartInfoObj.cartItems.push({
                    id: data.items[i].variantID,
                    quantity: data.items[i].quantity,
                    itemOptions: data.items[i].itemOptions
                  });
                  cartItemUrlPortions.push(data.items[i].variantID + ':' + data.items[i].quantity);
                }

                _context7.t4 = cartItemUrlPortions.join(',') + "?attributes[cartonomy-bearer]=";
                _context7.next = 28;
                return this._sessionService.getAuthToken();

              case 28:
                _context7.t5 = _context7.sent;
                url += _context7.t4 + _context7.t5;


                if (data.discountCode !== undefined && data.discountCode != null && data.discountCode != "") {
                  cartInfoObj.discount = data.discountCode;
                  url += "&discount=" + encodeURIComponent(cartInfoObj.discount);
                }

                shopifyCheckoutInfo = {
                  url: url,
                  cartInfo: cartInfoObj,
                  warningInfo: null,
                  ownerPaid: data.ownerPaid
                };

                //check if hulkapps extension installed, it changes price

                if (errors && !window.hulkapps) {
                  errorsList = [];

                  data.items.forEach(function (item) {
                    errorsList = errorsList.concat(item.errors);
                  });

                  shopifyCheckoutInfo.warningInfo = "Prices in your cart have changed.<p></p><p></p>" + errorsList.join('.<br />. Do you want to continue checking out, or to review your cart again?');
                }

                return _context7.abrupt('return', shopifyCheckoutInfo);

              case 34:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getShopifyCheckoutInfo(_x4) {
        return _ref7.apply(this, arguments);
      }

      return getShopifyCheckoutInfo;
    }()
  }, {
    key: 'getAmazonCheckoutInfo',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var amazonCheckoutUrl, response, amazonCheckoutInfo;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                amazonCheckoutUrl = this.cartonomyConfig.ApiV2 + 'amazon/checkout';
                _context8.next = 3;
                return this._httpService.get(amazonCheckoutUrl);

              case 3:
                response = _context8.sent;
                amazonCheckoutInfo = {
                  url: response.data,
                  cartInfo: null,
                  warningInfo: null
                };
                return _context8.abrupt('return', amazonCheckoutInfo);

              case 6:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getAmazonCheckoutInfo() {
        return _ref8.apply(this, arguments);
      }

      return getAmazonCheckoutInfo;
    }()
  }, {
    key: 'getWalmartCheckoutInfo',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var walmartCheckoutUrl, response, walmartCheckoutInfo;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                walmartCheckoutUrl = this.cartonomyConfig.ApiV2 + 'walmart/checkout';
                _context9.next = 3;
                return this._httpService.get(walmartCheckoutUrl);

              case 3:
                response = _context9.sent;
                walmartCheckoutInfo = {
                  url: null,
                  cartInfo: response.data,
                  warningInfo: null
                };
                return _context9.abrupt('return', walmartCheckoutInfo);

              case 6:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getWalmartCheckoutInfo() {
        return _ref9.apply(this, arguments);
      }

      return getWalmartCheckoutInfo;
    }()
  }, {
    key: 'getFreshopCheckoutInfo',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var freshopCheckoutUrl, response, freshopCheckoutInfo;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                freshopCheckoutUrl = this.cartonomyConfig.ApiV2 + 'freshop/checkout';
                _context10.next = 3;
                return this._httpService.get(freshopCheckoutUrl);

              case 3:
                response = _context10.sent;
                freshopCheckoutInfo = {
                  url: null,
                  cartInfo: response.data,
                  warningInfo: null
                };
                return _context10.abrupt('return', freshopCheckoutInfo);

              case 6:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getFreshopCheckoutInfo() {
        return _ref10.apply(this, arguments);
      }

      return getFreshopCheckoutInfo;
    }()
  }]);

  return CheckoutService;
}();

CheckoutService.$inject = ['$http', 'cartonomyConfig', 'ConfigurationService', '$rootScope', 'Session'];


_module3.default.service('CheckoutService', CheckoutService);

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.retailerService = undefined;

var _RestClientService = __webpack_require__(683);

var _RestClientService2 = _interopRequireDefault(_RestClientService);

var _utils = __webpack_require__(29);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _cartonomy_config = __webpack_require__(413);

var _cartonomy_config2 = _interopRequireDefault(_cartonomy_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var retailerService = exports.retailerService = {
    getRetailer: function getRetailer() {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var localRetailer, _retailer;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            localRetailer = window.localStorage.getItem(_CommonConstants2.default.SessionStorage.RETAILER_DATA);

                            if (localRetailer) {
                                _context.next = 7;
                                break;
                            }

                            _context.next = 4;
                            return _this.checkRetailer();

                        case 4:
                            _retailer = _context.sent;

                            window.localStorage.setItem(_CommonConstants2.default.SessionStorage.RETAILER_DATA, _retailer ? JSON.stringify(_retailer) : _retailer);
                            return _context.abrupt("return", _retailer);

                        case 7:
                            _context.next = 9;
                            return JSON.parse(localRetailer);

                        case 9:
                            return _context.abrupt("return", _context.sent);

                        case 10:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    getTranslations: function getTranslations() {
        var _this2 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _RestClientService2.default.get(_cartonomy_config2.default.backendEndPoint + "/api/locales?shop=" + _utils.utils.retailerShop);

                        case 2:
                            return _context2.abrupt("return", _context2.sent);

                        case 3:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    getLogo: function getLogo() {
        var _this3 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return _RestClientService2.default.get(_cartonomy_config2.default.backendEndPoint + "/api/styles/logo?shop=" + _utils.utils.retailerShop);

                        case 2:
                            return _context3.abrupt("return", _context3.sent);

                        case 3:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    updateRetailer: function updateRetailer() {
        var _this4 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            var _retailer;

            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return _RestClientService2.default.get(_utils.utils.cartonomyApiUrl + "v2/retailer/default?shop=" + _utils.utils.retailerShop);

                        case 2:
                            _retailer = _context4.sent;

                            window.localStorage.setItem(_CommonConstants2.default.SessionStorage.RETAILER_DATA, _retailer ? JSON.stringify(_retailer) : _retailer);

                        case 4:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    checkRetailer: function checkRetailer() {
        return _RestClientService2.default.get(_utils.utils.cartonomyApiUrl + "v2/retailer/default?shop=" + _utils.utils.retailerShop);
    },
    setRetailerCurrencyFormat: function setRetailerCurrencyFormat(retailerId, moneyFormat) {
        var _this5 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            return _context5.abrupt("return", _RestClientService2.default.post(_utils.utils.cartonomyApiUrl + "v2/retailer/" + retailerId + "/setting/currency", {
                                MoneyFormat: moneyFormat
                            }));

                        case 1:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    }
};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RestClientService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RequestMethod = {
    HEAD: 'HEAD',
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE'
};

/**
 * Represent Centralize Ajax Service
 */

var applicationJsonType = 'application/json';

var RestClientService = exports.RestClientService = function () {
    function RestClientService() {
        _classCallCheck(this, RestClientService);

        this.getUrls = [];
        this.credentialOptions = null;
        this.keepCredential = false;
    }

    _createClass(RestClientService, [{
        key: 'useCredentials',
        value: function useCredentials() {
            this.credentialOptions = 'include';
            this.keepCredential = false;
        }
    }, {
        key: 'keepCredentials',
        value: function keepCredentials() {
            this.credentialOptions = 'include';
            this.keepCredential = true;
        }
    }, {
        key: 'request',
        value: function request(url, type, data, customHeaders) {
            var headers = {
                'Content-Type': applicationJsonType,
                'Accept': applicationJsonType
            };

            if (customHeaders) {
                headers = _.merge(headers, customHeaders);
            }

            var options = {
                method: type,
                headers: headers
            };

            if (data && headers['Content-Type'] === applicationJsonType) {
                options.body = JSON.stringify(data);
            }

            if (this.credentialOptions) {
                options.credentials = this.credentialOptions;
                if (!this.keepCredential) {
                    this.credentialOptions = null;
                }
            }

            return fetch(url, options).then(function (response) {
                if (response.ok) {
                    return response.text();
                }

                return response.json().then(function (actualResponse) {
                    throw actualResponse;
                });
            }).then(function (response) {
                try {
                    var resultObject = JSON.parse(response);

                    return resultObject || JSON.parse(response);
                } catch (e) {
                    return response;
                }
            });
        }
    }, {
        key: 'head',
        value: function head(url) {
            return this.request(url, RequestMethod.HEAD);
        }
    }, {
        key: 'get',
        value: function get(url, customHeaders) {
            return this.request(url, RequestMethod.GET, null, customHeaders);
        }
    }, {
        key: 'singleGet',
        value: function singleGet(url, customHeaders) {
            var _this = this;

            var existingRequest = this.getUrls.find(function (getRequest) {
                return getRequest.url === url;
            });
            if (existingRequest) {
                return existingRequest.request;
            }

            var promise = this.request(url, RequestMethod.GET, null, customHeaders).then(function (response) {
                setTimeout(function () {
                    _this.getUrls = _.filter(_this.getUrls, function (getRequest) {
                        return getRequest.url !== url;
                    });
                }, 700);

                return response;
            });

            this.getUrls.push({
                url: url,
                request: promise
            });

            return promise;
        }
    }, {
        key: 'post',
        value: function post(url, data, customHeaders) {
            return this.request(url, RequestMethod.POST, data, customHeaders);
        }
    }, {
        key: 'put',
        value: function put(url, data, customHeaders) {
            return this.request(url, RequestMethod.PUT, data, customHeaders);
        }
    }, {
        key: 'delete',
        value: function _delete(url, customHeaders) {
            return this.request(url, RequestMethod.DELETE, null, customHeaders);
        }
    }], [{
        key: '_singleInstance',
        value: function _singleInstance() {
            return RestClientService.singleInstance || (RestClientService.singleInstance = new RestClientService());
        }
    }]);

    return RestClientService;
}();

RestClientService.singleInstance = null;


var restClientService = RestClientService._singleInstance();

exports.default = restClientService;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _IdleDetectingService = __webpack_require__(415);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ConfigurationService($http, $q, cartonomyConfig) {

    var urlBase = cartonomyConfig.ApiV2 + 'retailer/default' + window.location.search;

    var configurationService = {};

    var promise = $http.get(urlBase).then(function (response) {
        configurationService.retailer = response.data;
        return configurationService.retailer;
    });

    configurationService.getRetailer = function () {
        return _.cloneDeep(configurationService.retailer);
    };

    configurationService.getRetailerSettings = function () {
        return $http.get(cartonomyConfig.ApiV2 + 'retailer/settings').then(function (settingsResponse) {
            return settingsResponse.data;
        });
    };

    configurationService.getItem = function (key) {

        // todo: temporary solution to not to store hardcoded and potentially configurable values
        switch (key) {
            case 'deliveryDaysRange':
                return $q.resolve(5);
        }

        return promise.then(function (data) {
            return _.cloneDeep(data[key]);
        });
    };

    return configurationService;
}

_module3.default.factory('ConfigurationService', ['$http', '$q', 'cartonomyConfig', ConfigurationService]);

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function ContactsService($http, cartonomyConfig) {
    var _this = this;

    var urlBase = cartonomyConfig.ApiV2 + 'group';

    return {
        getContacts: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return $http.get(urlBase + '/contact/all');

                            case 2:
                                response = _context.sent;
                                return _context.abrupt('return', response.data);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function getContacts() {
                return _ref.apply(this, arguments);
            };
        }(),

        getGroups: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var response;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return $http.get(urlBase);

                            case 2:
                                response = _context2.sent;
                                return _context2.abrupt('return', response.data);

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }));

            return function getGroups() {
                return _ref2.apply(this, arguments);
            };
        }(),

        createGroup: function createGroup(name, emails) {
            return $http.post(urlBase, {
                name: name,
                groupMembers: _.map(emails, function (email) {
                    return { memberEmail: email };
                })
            });
        },

        updateGroup: function updateGroup(name, emails) {
            return $http.post(urlBase, {
                name: name,
                groupMembers: _.map(emails, function (email) {
                    return { memberEmail: email };
                })
            });
        },

        getGroup: function getGroup(id) {
            return $http.get(urlBase + '/' + id).then(function (response) {
                return response.data;
            });
        }
    };
}

_module3.default.factory('ContactsService', ['$http', 'cartonomyConfig', ContactsService]);

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupOrderService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _communicationService = __webpack_require__(28);

var _commandKeys = __webpack_require__(27);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GroupOrderService = exports.GroupOrderService = function () {
  function GroupOrderService(httpService, cartonomyConfig, checkoutService, cartService, $window) {
    _classCallCheck(this, GroupOrderService);

    this.PayForEveryone = false;
    this.EverySelfPays = true;

    this._httpService = httpService;
    this._checkoutService = checkoutService;
    this._cartService = cartService;
    this._urlBase = cartonomyConfig.ApiV2 + 'order';
    this._urlGroupBase = cartonomyConfig.ApiV2 + 'group';
    this._windowService = $window;
    //noinspection JSIgnoredPromiseFromCall
    this.initConfiguration();

    this._customCartNameSetting = {
      customCartNames: '0',
      cartName: ''
    };
  }

  _createClass(GroupOrderService, [{
    key: 'save',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var cartName, configuration, cart;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cartName = this._customCartNameSetting.customCartNames === '1' ? this._customCartNameSetting.cartName : '';
                configuration = this.serialize();
                _context.next = 4;
                return this._cartService.getCart();

              case 4:
                cart = _context.sent;

                configuration.cartName = cartName;
                _context.next = 8;
                return this._cartService.setCartDetails(configuration);

              case 8:
                cart.orderLimit = configuration.price;
                cart.orderLimitType = configuration.budgetType;
                cart.closeOn = configuration.deadlineTime;
                cart.comment = '';
                cart.cartName = cartName;

                if (data && data.storeId) {
                  cart.retailerStoreId = data.storeId;
                }

                _context.next = 16;
                return this._cartService.setCartConfiguration(cart);

              case 16:

                if (this._customCartNameSetting.customCartNames === '1' && this._customCartNameSetting.cartName !== '') {
                  _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.updateMyCartButtonText, { cartNameValue: this._customCartNameSetting.cartName });
                }

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save(_x) {
        return _ref.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: 'sendInvites',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var emails;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this._configuration.contactDetails && this._configuration.contactDetails.selectedEmails)) {
                  _context2.next = 4;
                  break;
                }

                emails = this._configuration.contactDetails.selectedEmails;
                _context2.next = 4;
                return this._cartService.sendInvites(emails);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendInvites() {
        return _ref2.apply(this, arguments);
      }

      return sendInvites;
    }()
  }, {
    key: 'saveToSessionStorage',
    value: function saveToSessionStorage() {
      this._windowService.sessionStorage.setItem(_CommonConstants2.default.SessionStorage.NEW_ORDER_CONFIGURATION, JSON.stringify(this._configuration));
    }
  }, {
    key: 'hasSavedSession',
    value: function hasSavedSession() {
      var configuration = this._windowService.sessionStorage.getItem(_CommonConstants2.default.SessionStorage.NEW_ORDER_CONFIGURATION);
      return !!configuration;
    }
  }, {
    key: 'loadFromSessionStorage',
    value: function loadFromSessionStorage() {
      var configuration = this._windowService.sessionStorage.getItem(_CommonConstants2.default.SessionStorage.NEW_ORDER_CONFIGURATION);
      this._configuration = JSON.parse(configuration);
    }
  }, {
    key: 'serialize',
    value: function serialize() {
      var configuration = _.cloneDeep(this._configuration);

      return {
        deliveryMethod: configuration.delivery ? _CommonConstants2.default.CartDetails.DeliveryMethods.DELIVERY : _CommonConstants2.default.CartDetails.DeliveryMethods.PICKUP,
        paymentMethod: configuration.paymentMethod,
        price: configuration.groupPay ? 0 : configuration.singlePayOrder.budget,
        budgetType: configuration.singlePayOrder.budgetType,
        deliveryPhone: configuration.deliveryDetails.phone,
        deadlineTime: configuration.deliveryDetails.deadlineTime,
        deliveryDate: configuration.deliveryDetails.deliveryTime,
        deliveryTime: configuration.deliveryDetails.deliveryTime,
        customCartNameSetting: this._customCartNameSetting
      };
    }
  }, {
    key: 'getPaymentSystems',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._checkoutService.getVendorMap();

              case 2:
                return _context3.abrupt('return', _context3.sent);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getPaymentSystems() {
        return _ref3.apply(this, arguments);
      }

      return getPaymentSystems;
    }()
  }, {
    key: 'getPaymentSystem',
    value: function getPaymentSystem() {
      return this._configuration.paymentSystem;
    }
  }, {
    key: 'setPaymentSystem',
    value: function setPaymentSystem(system) {
      this._configuration.paymentSystem = system;
    }
  }, {
    key: 'setAmountToPay',
    value: function setAmountToPay(amount) {
      this._configuration.amountToPay = amount;
    }
  }, {
    key: 'getAmountToPay',
    value: function getAmountToPay() {
      return this._configuration.amountToPay;
    }
  }, {
    key: 'setDeliveryMode',
    value: function setDeliveryMode(mode) {
      this._configuration.delivery = mode;
    }
  }, {
    key: 'getDeliveryMode',
    value: function getDeliveryMode() {
      return this._configuration.delivery;
    }
  }, {
    key: 'getDeliveryDetails',
    value: function getDeliveryDetails() {
      return this._configuration.deliveryDetails;
    }
  }, {
    key: 'setDeliveryDetails',
    value: function setDeliveryDetails(details) {
      this._configuration.deliveryDetails = details;
    }
  }, {
    key: 'getDeliveryAddress',
    value: function getDeliveryAddress() {
      return this._configuration.deliveryAddress;
    }
  }, {
    key: 'setDeliveryAddress',
    value: function setDeliveryAddress(address) {
      this._configuration.deliveryAddress = address;
    }
  }, {
    key: 'setPaymentMethod',
    value: function setPaymentMethod(method) {
      this._configuration.paymentMethod = method;
    }
  }, {
    key: 'getSelectedDeliveryAddress',
    value: function getSelectedDeliveryAddress() {
      return this._configuration.selectedDeliveryAddress;
    }
  }, {
    key: 'setSelectedDeliveryAddress',
    value: function setSelectedDeliveryAddress(selectedAddress) {
      this._configuration.selectedDeliveryAddress = selectedAddress;
    }
  }, {
    key: 'getGroupPay',
    value: function getGroupPay() {
      return this._configuration.groupPay;
    }
  }, {
    key: 'setGroupPay',
    value: function setGroupPay(groupPay) {
      this._configuration.groupPay = groupPay;
    }
  }, {
    key: 'getSinglePayOrder',
    value: function getSinglePayOrder() {
      return this._configuration.singlePayOrder;
    }
  }, {
    key: 'setSinglePayOrder',
    value: function setSinglePayOrder(singlePay) {
      this._configuration.singlePayOrder = singlePay;
    }
  }, {
    key: 'getContactDetails',
    value: function getContactDetails() {
      return this._configuration.contactDetails;
    }
  }, {
    key: 'setContactDetails',
    value: function setContactDetails(details) {
      this._configuration.contactDetails = details;
    }
  }, {
    key: 'getVendorDetails',
    value: function getVendorDetails() {
      return this._configuration.vendorDetails;
    }
  }, {
    key: 'setVendorDetails',
    value: function setVendorDetails(details) {
      this._configuration.vendorDetails = details;
    }
  }, {
    key: 'initConfiguration',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this._configuration = {
                  groupPay: true,
                  amountToPay: 0
                };

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function initConfiguration() {
        return _ref4.apply(this, arguments);
      }

      return initConfiguration;
    }()
  }, {
    key: 'loadConfiguration',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(configuration) {
        var cart;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._cartService.getCart();

              case 2:
                cart = _context5.sent;


                this._configuration = {
                  delivery: configuration.deliveryMethod === _CommonConstants2.default.CartDetails.DeliveryMethods.DELIVERY,
                  groupPay: configuration.paymentMethod !== _CommonConstants2.default.CartDetails.PaymentMethods.SINGLE,
                  deliveryDetails: {
                    deliveryTime: configuration.deliveryTime,
                    deliveryDate: configuration.deliveryTime,
                    phone: configuration.deliveryPhone,
                    entered: !!configuration.deliveryPhone,
                    accepted: !!configuration.deliveryPhone
                  }
                };

                if (configuration.deliveryDetails) {
                  //configuration.deliveryDetails.deadlineTime = cart.closeOn;
                  this.setDeliveryDetails(configuration.deliveryDetails);
                } else {
                  this._configuration.deliveryDetails.deadlineTime = cart.closeOn ? _.isDate(cart.closeOn) ? cart.closeOn : _moment2.default.utc(cart.closeOn).toDate() : undefined;

                  this._configuration.deliveryDetails.defineDeadline = !!this._configuration.deliveryDetails.deadlineTime;

                  this._configuration.deliveryDetails.placeEntered = true;
                }

                if (configuration.deliveryAddress) {
                  this._configuration.deliveryAddress = {
                    city: configuration.deliveryAddress.city,
                    state: configuration.deliveryAddress.state,
                    street: configuration.deliveryAddress.street,
                    zip: configuration.deliveryAddress.zip,
                    aptSuite: configuration.deliveryAddress.aptSuite,
                    entered: !!configuration.deliveryAddress.street
                  };
                }

                if (configuration.singlePayOrder) {
                  configuration.singlePayOrder.budget = cart.orderLimit;
                  this.setSinglePayOrder(configuration.singlePayOrder);
                } else {
                  if (!this._configuration.groupPay) {
                    this._configuration.singlePayOrder = {
                      budget: cart.orderLimit
                    };
                  }
                }

                if (configuration.contactDetails) {
                  this.setContactDetails(configuration.contactDetails);
                }

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadConfiguration(_x2) {
        return _ref5.apply(this, arguments);
      }

      return loadConfiguration;
    }()
  }, {
    key: 'payNow',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(details) {
        var response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._httpService.post(this._urlBase + "payNow", details);

              case 2:
                response = _context6.sent;
                return _context6.abrupt('return', response.data);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function payNow(_x3) {
        return _ref6.apply(this, arguments);
      }

      return payNow;
    }()
  }, {
    key: 'setCustomCartName',
    value: function setCustomCartName(customCartNames, cartName) {
      this._customCartNameSetting.customCartNames = customCartNames;
      this._customCartNameSetting.cartName = cartName;
    }
  }, {
    key: 'deleteContact',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(contactUserId) {
        var response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._httpService.delete(this._urlGroupBase + '/contact/delete/' + contactUserId);

              case 2:
                response = _context7.sent;
                return _context7.abrupt('return', response.data);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteContact(_x4) {
        return _ref7.apply(this, arguments);
      }

      return deleteContact;
    }()
  }]);

  return GroupOrderService;
}();

GroupOrderService.$inject = ['$http', 'cartonomyConfig', 'CheckoutService', 'CartService', '$window'];


_module3.default.service('GroupOrder', GroupOrderService);

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MessageService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageService = exports.MessageService = function () {
    function MessageService(toastService, dialogService, rootScope) {
        _classCallCheck(this, MessageService);

        this._toastService = toastService;
        this._dialogService = dialogService;
        this._rootScope = rootScope;
    }

    _createClass(MessageService, [{
        key: '_showMessagePopup',
        value: function _showMessagePopup(messageText, isError, title) {
            var buttonText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Close';

            var self = this;
            return new Promise(function (resolve) {
                self._rootScope.headerMessage = {
                    resolve: resolve,
                    content: messageText,
                    class: isError ? 'danger' : 'success'
                };
                _scope2.default.apply(self._rootScope);
            });
            // return this._dialogService.show({
            //     controller: [ '$scope', '$mdDialog', ($scope, $mdDialog) => {
            //         $scope.close = () => $mdDialog.hide();
            //         $scope.title = title;
            //         $scope.message = messageText;
            //         $scope.isError = isError;
            //         $scope.buttonText = buttonText;
            //     } ],
            //     templateUrl: 'modules/shared/views/messageDialog.html',
            //     escapeToClose: true,
            //     clickOutsideToClose: true
            // });
        }
    }, {
        key: 'showLoading',
        value: function showLoading() {
            var _this = this;

            return new Promise(function (resolve, reject) {
                _this._dialogService.show({
                    controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
                        $scope.close = function () {
                            return $mdDialog.hide();
                        };
                        resolve($scope);
                    }],
                    template: __webpack_require__(688),
                    escapeToClose: true,
                    clickOutsideToClose: false
                });
            });
        }
    }, {
        key: 'showLoadingWhiteBackground',
        value: function showLoadingWhiteBackground() {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                _this2._dialogService.show({
                    controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
                        $scope.close = function () {
                            return $mdDialog.hide();
                        };
                        resolve($scope);
                    }],
                    template: __webpack_require__(689),
                    escapeToClose: true,
                    clickOutsideToClose: false
                });
            });
        }
    }, {
        key: 'showErrorPopup',
        value: function showErrorPopup(messageText) {
            return this._showMessagePopup(messageText, true);
        }
    }, {
        key: 'showMessagePopup',
        value: function showMessagePopup(messageText, buttonText) {
            return this._showMessagePopup(messageText, false, '', buttonText);
        }
    }, {
        key: 'showAlertPopup',
        value: function showAlertPopup(messageText, buttonText) {
            return this._dialogService.show({
                controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
                    $scope.close = function () {
                        return $mdDialog.hide();
                    };
                    $scope.title = '';
                    $scope.message = messageText;
                    $scope.buttonText = buttonText;
                }],
                templateUrl: 'modules/shared/views/messageDialog.html',
                escapeToClose: true,
                clickOutsideToClose: true,
                multiple: true,
                hasBackdrop: true
            });
        }
    }, {
        key: 'showQuestionPopup',
        value: function showQuestionPopup(messageText) {
            var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var yesBtnText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Yes';
            var noBtnText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'No';
            var yesBtnClass = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'primary';
            var noBtnClass = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'secondary';

            return this._dialogService.show({
                controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
                    $scope.close = function (response) {
                        $mdDialog.hide(response);
                    };

                    $scope.cancel = function () {
                        $mdDialog.hide(false);
                    };

                    $scope.title = title;
                    $scope.message = messageText;
                    $scope.yesBtnText = yesBtnText;
                    $scope.yesBtnClass = yesBtnClass;
                    $scope.noBtnText = noBtnText;
                    $scope.noBtnClass = noBtnClass;
                }],
                templateUrl: 'modules/shared/views/questionDialog.html',
                escapeToClose: true,
                clickOutsideToClose: false
            });
        }
    }, {
        key: 'getMessageFromErrorResponse',
        value: function getMessageFromErrorResponse(response) {
            return response && response.data && response.data.message;
        }
    }, {
        key: 'isErrorResponse',
        value: function isErrorResponse(response) {
            return response && response.status >= 400;
        }
    }, {
        key: 'showErrorPopupForResponse',
        value: function showErrorPopupForResponse(errorResponse) {
            var message = this.getMessageFromErrorResponse(errorResponse);
            return this.showErrorPopup(message || errorResponse && errorResponse.statusText || "Unknown error occurred: " + JSON.stringify(errorResponse));
        }
    }]);

    return MessageService;
}();

MessageService.$inject = ['$mdToast', '$mdDialog', "$rootScope"];


_module3.default.service('Message', MessageService);

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports = "<md-dialog class=\"loading-dialog\"><div class=\"loader-indicator\"></div></md-dialog>"

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = "<md-dialog class=\"loading-dialog dialog-background-white\"><div class=\"loader-indicator\"></div></md-dialog>"

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderSetupService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _OrderSetupDialogController = __webpack_require__(419);

var _OrderSetupDialogController2 = _interopRequireDefault(_OrderSetupDialogController);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _communicationService = __webpack_require__(28);

var _commandKeys = __webpack_require__(27);

var _utils = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSetupService = exports.OrderSetupService = function () {
    function OrderSetupService(cartonomyConfig, windowService, dialogService, sessionService, authenticationService, cartService, messageService, groupOrderService, localForageService, stateService, rootScope) {
        _classCallCheck(this, OrderSetupService);

        this._rootScope = rootScope;
        this._stateService = stateService;
        this._cartonomyConfig = cartonomyConfig;
        this._dialogService = dialogService;
        this._sessionService = sessionService;
        this._authenticationService = authenticationService;
        this._groupOrderService = groupOrderService;
        this._cartService = cartService;
        this._messageService = messageService;
        this._windowService = windowService;
        this.isOrderCreating = false;
        this.orderSetupDialogShowing = false;
        //this._sessionStorageService = sessionStorageService;
        this._localForageService = localForageService;

        this._dialogOptions = null;
        this._inviteMoreOption = null;

        this.invitationPromise = null;
    }

    _createClass(OrderSetupService, [{
        key: '_showOrderSetupDialog',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
                var _this = this;

                var cart, self;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._cartService.getCart();

                            case 2:
                                cart = _context.sent;

                                this.orderSetupDialogShowing = true;
                                _context.t0 = !(options && options.tabToShow);

                                if (!_context.t0) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 8;
                                return this._cartService.isGroupOrder(cart);

                            case 8:
                                _context.t0 = _context.sent;

                            case 9:
                                if (!_context.t0) {
                                    _context.next = 20;
                                    break;
                                }

                                if (!options.needAddItem) {
                                    _context.next = 16;
                                    break;
                                }

                                _context.next = 13;
                                return this._stateService.go(_CommonConstants2.default.RoutingStates.USER_PROFILE);

                            case 13:
                                this._rootScope.$broadcast(_CommonConstants2.default.Events.ORDER_CREATED);
                                setTimeout(function () {
                                    _this._stateService.go(_CommonConstants2.default.RoutingStates.CART);
                                }, 0);
                                return _context.abrupt('return');

                            case 16:
                                _context.next = 18;
                                return this._rootScope.$broadcast(_CommonConstants2.default.Events.INVITATION_ACCEPTED);

                            case 18:
                                _context.next = 20;
                                return this._sessionService.setCartReference(null, false);

                            case 20:
                                _context.prev = 20;

                                if (this._cartService.getInvitationType() !== 2) this._cartService.setInvitationType(_CommonConstants2.default.InvitationTypes.normal);
                                this._rootScope.$broadcast(_CommonConstants2.default.Events.DIALOG_OPENED, options && options.__editMode);
                                self = this;

                                this._dialogOptions = {
                                    controller: _OrderSetupDialogController2.default,
                                    template: __webpack_require__(693)(),
                                    // templateUrl: 'modules/order/views/orderSetupDialog.html',
                                    clickOutsideToClose: false,
                                    escapeToClose: false,
                                    locals: {
                                        tabToShow: options && options.tabToShow || null,
                                        initialConfiguration: options && options.initialConfiguration || {},
                                        initialCart: options && options.initialCart || {},
                                        paymentOptions: options && options.paymentOptions,
                                        editMode: options && options.__editMode
                                    },
                                    onRemoving: function onRemoving(event, removePromise) {
                                        self._rootScope.$broadcast(_CommonConstants2.default.Events.DIALOG_CLOSED);
                                    }
                                };
                                _context.next = 27;
                                return this._dialogService.show(this._dialogOptions);

                            case 27:
                                return _context.abrupt('return', this._groupOrderService.serialize());

                            case 30:
                                _context.prev = 30;
                                _context.t1 = _context['catch'](20);

                            case 32:
                                _context.prev = 32;

                                this.orderSetupDialogShowing = false;
                                return _context.finish(32);

                            case 35:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[20, 30, 32, 35]]);
            }));

            function _showOrderSetupDialog(_x) {
                return _ref.apply(this, arguments);
            }

            return _showOrderSetupDialog;
        }()
    }, {
        key: 'reShowDialog',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this._dialogOptions) {
                                    _context2.next = 11;
                                    break;
                                }

                                _context2.next = 3;
                                return this._localForageService.store(_CommonConstants2.default.SessionStorage.CREATE_ORDER_CURRENT_TAB, _CommonConstants2.default.OrderSetupTabs.ADD_PEOPLE);

                            case 3:
                                _context2.next = 5;
                                return this._dialogService.show(this._dialogOptions);

                            case 5:
                                _context2.next = 7;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.CREATE_ORDER_CONFIGURATION);

                            case 7:
                                _context2.next = 9;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.CREATE_ORDER_CURRENT_TAB);

                            case 9:
                                _context2.next = 12;
                                break;

                            case 11:
                                if (this._inviteMoreOption) this._dialogService.show(this._inviteMoreOption);else console.log('_dialogOptions and _inviteMoreOption are null');

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function reShowDialog() {
                return _ref2.apply(this, arguments);
            }

            return reShowDialog;
        }()
    }, {
        key: 'hideDialog',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (this._dialogOptions) {
                                    this._dialogService.hide();
                                }

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function hideDialog() {
                return _ref3.apply(this, arguments);
            }

            return hideDialog;
        }()
    }, {
        key: 'showInviteMorePeople',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(emails) {
                var _this2 = this;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this._dialogOptions = null;
                                this._inviteMoreOption = {
                                    templateUrl: 'modules/cart/views/addMorePeopleDialog.html',
                                    clickOutsideToClose: true,
                                    escapeToClose: true,
                                    controller: ['$scope', '$mdDialog', 'CartService', function (scope, dialogService, CartService) {

                                        scope.readOnly = false;
                                        scope.canAddEmail = false;

                                        scope.cancel = function () {
                                            dialogService.hide();
                                        };

                                        scope.$on('order:add:people.canAddPeople', function (s, value) {
                                            scope.canAddEmail = value;
                                        });

                                        scope.configuration = {
                                            exclude: emails
                                        };

                                        scope.onEmailChanges = function (emails) {
                                            scope.configuration.emails = emails;
                                        };

                                        scope.sendInvitation = function () {
                                            CartService.sendInvites(scope.configuration.emails).then(function () {
                                                dialogService.hide();
                                                CartService.resetCart();
                                                //return this._fetchParticipants();
                                            }).catch(function (error) {
                                                return _this2._messageService.showErrorPopupForResponse(error);
                                            });
                                        };

                                        scope.prepareSendingInvitations = function (emails) {
                                            scope.$broadcast(_CommonConstants2.default.Events.ADD_PEOPLE_ADVANCE_TO_NEXT_PAGE);
                                            scope.readOnly = true;
                                            _scope2.default.apply(scope);
                                        };

                                        scope.onDeleteContact = function (contact) {
                                            _this2._rootScope.$broadcast(_CommonConstants2.default.RootEvents.DELETE_CONTACT_CONFIRM_FROM_ADDMORE_PEOPLE, contact);
                                        };
                                    }]
                                };

                                this._dialogService.show(this._inviteMoreOption);
                                _context4.next = 5;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.CREATE_ORDER_CURRENT_TAB);

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function showInviteMorePeople(_x2) {
                return _ref4.apply(this, arguments);
            }

            return showInviteMorePeople;
        }()
    }, {
        key: 'onWindowUnloading',
        value: function onWindowUnloading(context) {
            if (!this.orderSetupDialogShowing) {
                return;
            }
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(needAddItem) {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context5.sent) {
                                    _context5.next = 5;
                                    break;
                                }

                                _context5.next = 5;
                                return this._authenticationService.showLoginDialog('', 'facade', true);

                            case 5:
                                if (!this.isOrderCreating) {
                                    _context5.next = 7;
                                    break;
                                }

                                return _context5.abrupt('return', false);

                            case 7:

                                this.isOrderCreating = true;

                                _context5.next = 10;
                                return this._showOrderSetupDialog({
                                    needAddItem: needAddItem
                                });

                            case 10:

                                this.isOrderCreating = false;

                                return _context5.abrupt('return', true);

                            case 12:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x3) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'editOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(tabId) {
                var cart, configuration;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                console.log('editOrder');
                                _context6.next = 3;
                                return this._cartService.getCart();

                            case 3:
                                cart = _context6.sent;
                                _context6.next = 6;
                                return this._cartService.getCartDetails(cart);

                            case 6:
                                configuration = _context6.sent;

                                console.log(configuration);
                                _context6.next = 10;
                                return this._showOrderSetupDialog({
                                    tabToShow: tabId,
                                    initialConfiguration: configuration,
                                    initialCart: cart,
                                    __editMode: true
                                });

                            case 10:
                                configuration = _context6.sent;

                                if (configuration) {
                                    _context6.next = 13;
                                    break;
                                }

                                return _context6.abrupt('return', null);

                            case 13:
                                _context6.next = 15;
                                return this._cartService.setCartDetails(configuration);

                            case 15:
                                cart.cartName = configuration.customCartNameSetting.customCartNames === '1' ? configuration.customCartNameSetting.cartName : '';
                                if (configuration.customCartNameSetting.customCartNames === '1' && configuration.customCartNameSetting.cartName !== '') {
                                    _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.updateMyCartButtonText, { cartNameValue: configuration.customCartNameSetting.cartName });
                                }
                                cart.orderLimit = isNaN(configuration.price) ? null : Number(configuration.price);
                                cart.closeOn = configuration.deadlineTime;
                                _context6.next = 21;
                                return this._cartService.setCartConfiguration(cart);

                            case 21:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function editOrder(_x4) {
                return _ref6.apply(this, arguments);
            }

            return editOrder;
        }()
    }, {
        key: 'continueOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(paymentOptions) {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context7.sent) {
                                    _context7.next = 5;
                                    break;
                                }

                                _context7.next = 5;
                                return this._authenticationService.showLoginDialog('', 'facade', true);

                            case 5:
                                _context7.next = 7;
                                return this._showOrderSetupDialog({
                                    paymentOptions: paymentOptions
                                });

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function continueOrder(_x5) {
                return _ref7.apply(this, arguments);
            }

            return continueOrder;
        }()
    }, {
        key: 'showInvitePreview',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var cart, configuration;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this._cartService.getCart();

                            case 2:
                                cart = _context8.sent;
                                _context8.next = 5;
                                return this._cartService.getCartDetails(cart);

                            case 5:
                                configuration = _context8.sent;
                                _context8.next = 8;
                                return this._showOrderSetupDialog({
                                    tabToShow: _CommonConstants2.default.OrderSetupTabs.INVITE_WELCOME,
                                    initialConfiguration: configuration,
                                    initialCart: cart
                                });

                            case 8:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function showInvitePreview() {
                return _ref8.apply(this, arguments);
            }

            return showInvitePreview;
        }()
    }]);

    return OrderSetupService;
}();

OrderSetupService.$inject = ['cartonomyConfig', '$window', '$mdDialog', 'Session', 'AuthenticationService', 'CartService', 'Message', 'GroupOrder', 'LocalForageService', '$state', '$rootScope'];


_module3.default.service('OrderSetupService', OrderSetupService);

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__(41);

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<md-content layout=\"column\" layout-padding class=\"confirm-delete-contact\"><h2 class=\"title\">{{'client.user.remove_contact' | translate}}</h2><div text-center ng-bind-html=\"message\"></div><div layout=\"row\" layout-align=\"center\" class=\"buttons\"><div flex=\"50\" class=\"full-width\"><md-button ng-click=\"acceptDeleteContact()\" aria-label=\"{{'client.yes' | translate}}\" class=\"md-raised md-warn\">{{'client.yes' | translate}}</md-button><md-button ng-click=\"backToCreateOrder()\" aria-label=\"{{'client.no' | translate}}\" class=\"md-raised\">{{'client.no' | translate}}</md-button></div></div></md-content>");;return buf.join("");
}

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__(41);

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"invite-welcome layout-column flex h-100\"><div class=\"text-area flex-column\"><p class=\"primary-text\">{{'client.order.welcome_to' | translate}} {{orderTitle}}</p><p class=\"outline-text\">{{payerTitle | translate}}</p><svg width=\"130\" height=\"130\" viewBox=\"0 0 130 130\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<circle cx=\"65\" cy=\"65\" r=\"65\" fill=\"#EFF4F7\"/>\n<circle cx=\"65\" cy=\"65\" r=\"65\" fill=\"#EFF4F7\"/>\n<path d=\"M65.5 64.6622C66.3085 64.6622 66.9648 64.0059 66.9648 63.1973C66.9648 62.3888 66.3085 61.7325 65.5 61.7325C64.6915 61.7325 64.0352 62.3888 64.0352 63.1973C64.0352 64.0059 64.6915 64.6622 65.5 64.6622Z\" fill=\"#689DBC\"/>\n<path d=\"M97.1406 52.9434H88.478L75.1525 34.6106C73.9555 32.5592 71.3187 31.8291 69.2245 32.9889C67.1016 34.1683 66.3383 36.8422 67.5182 38.9656C67.5519 39.0257 67.5891 39.0835 67.6309 39.1384L78.0828 52.9434H52.9172L63.3691 39.1384C63.4103 39.0835 63.4481 39.0257 63.4818 38.9656C64.6589 36.8473 63.9041 34.1711 61.7738 32.9878C59.6841 31.8302 57.0474 32.5598 55.8481 34.6094L42.522 52.9434H33.8594C30.6287 52.9434 28 55.5721 28 58.8028C28 61.3508 29.6537 63.5693 31.9831 64.3543C32.2315 64.5466 32.5416 64.6622 32.8792 64.6622C32.9467 64.6622 33.0102 64.6662 33.0766 64.6753C33.7072 64.76 34.2067 65.2384 34.3211 65.8644L39.3045 93.281C39.685 95.3713 41.5035 96.8887 43.6286 96.8887H87.3714C89.4965 96.8887 91.315 95.3713 91.6955 93.2804L96.6789 65.865C96.7933 65.2384 97.2934 64.76 97.9263 64.6753C97.9903 64.6662 98.0539 64.6622 98.1208 64.6622C98.4607 64.6622 98.7731 64.5454 99.0215 64.3509C101.353 63.5607 103 61.3463 103 58.8028C103 55.5721 100.371 52.9434 97.1406 52.9434ZM70.0393 37.4659C69.7046 36.7729 69.9643 35.9289 70.6453 35.5513C71.3542 35.1582 72.248 35.4117 72.6388 36.116C72.6674 36.1687 72.7001 36.219 72.735 36.2671L84.856 52.9434H81.7569L70.0393 37.4659ZM58.265 36.2677C58.2999 36.2196 58.3314 36.1698 58.3606 36.1183C58.7526 35.4134 59.6469 35.1593 60.353 35.5501C61.0351 35.9289 61.296 36.7718 60.9607 37.4659L49.2431 52.9434H46.144L58.265 36.2677ZM97.1406 61.7325H71.3594C70.5503 61.7325 69.8945 62.3882 69.8945 63.1973C69.8945 64.0064 70.5503 64.6473 71.3594 64.6473H93.9763C93.8997 64.8659 93.839 65.0925 93.7967 65.3259L88.8128 92.7563C88.6863 93.4532 88.0798 93.9591 87.3714 93.9591H43.6286C42.9197 93.9591 42.3137 93.4532 42.1867 92.7569L37.2033 65.3402C37.161 65.1068 37.1003 64.8802 37.0237 64.6622H59.6406C60.4497 64.6622 61.1055 64.0064 61.1055 63.1973C61.1055 62.3882 60.4497 61.7325 59.6406 61.7325H33.8594C32.2303 61.7325 30.9297 60.405 30.9297 58.8028C30.9297 57.1875 32.244 55.8731 33.8594 55.8731H97.1406C98.756 55.8731 100.07 57.1875 100.07 58.8028C100.07 60.4296 98.7394 61.7325 97.1406 61.7325Z\" fill=\"#689DBC\"/>\n<path d=\"M65.5 69.0567C63.0767 69.0567 61.1055 71.0279 61.1055 73.4512V85.17C61.1055 87.5933 63.0767 89.5645 65.5 89.5645C67.9233 89.5645 69.8945 87.5933 69.8945 85.17V73.4512C69.8945 71.0234 67.9279 69.0567 65.5 69.0567ZM66.9648 85.17C66.9648 85.9779 66.308 86.6348 65.5 86.6348C64.692 86.6348 64.0352 85.9779 64.0352 85.17V73.4512C64.0352 72.6433 64.692 71.9864 65.5 71.9864C66.3085 71.9864 66.9648 72.6427 66.9648 73.4512V85.17Z\" fill=\"#689DBC\"/>\n<path d=\"M80.1484 89.5645C82.5717 89.5645 84.543 87.5933 84.543 85.17V73.4512C84.543 71.0234 82.5763 69.0567 80.1484 69.0567C77.7252 69.0567 75.7539 71.0279 75.7539 73.4512V85.17C75.7539 87.5933 77.7252 89.5645 80.1484 89.5645ZM78.6836 73.4512C78.6836 72.6433 79.3405 71.9864 80.1484 71.9864C80.957 71.9864 81.6133 72.6427 81.6133 73.4512V85.17C81.6133 85.9779 80.9564 86.6348 80.1484 86.6348C79.3405 86.6348 78.6836 85.9779 78.6836 85.17V73.4512Z\" fill=\"#689DBC\"/>\n<path d=\"M50.8516 69.0567C48.4283 69.0567 46.457 71.0279 46.457 73.4512V85.17C46.457 87.5933 48.4283 89.5645 50.8516 89.5645C53.2748 89.5645 55.2461 87.5933 55.2461 85.17V73.4512C55.2461 71.0234 53.2794 69.0567 50.8516 69.0567ZM52.3164 85.17C52.3164 85.9779 51.6595 86.6348 50.8516 86.6348C50.0436 86.6348 49.3867 85.9779 49.3867 85.17V73.4512C49.3867 72.6433 50.0436 71.9864 50.8516 71.9864C51.6601 71.9864 52.3164 72.6421 52.3164 73.4512V85.17Z\" fill=\"#689DBC\"/>\n</svg>\n<div class=\"flex-column info-group\"><label>{{'client.order.deadline_label' | translate}}</label><div class=\"info-block\">{{deadline | translate}}</div></div><div ng-if=\"!noBudgetMode\" class=\"flex-column info-group\"><label>{{'client.order.budget_label' | translate}}</label><div class=\"info-block\">{{budget | translate}}</div></div></div><button ng-click=\"closeDialog()\" class=\"btn-lg primary\">{{'client.order.enter' | translate}}</button></div>");;return buf.join("");
}

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__(41);

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<!-- ng-class=\"groupPay ? 'group-pay' : 'single-pay'\"--><md-dialog aria-label=\"Order Setup\" flex=\"80\" flex-sm=\"100\" flex-xs=\"100\" layout=\"column\" class=\"order-setup-dialog single-pay\"><md-dialog-content ng-class=\"{ 'dialog-content-custom': selectedTab.custom, 'external-store': isExternalRetailer() }\" flex=\"noshrink\" layout=\"column\"><md-content layout=\"column\" ng-class=\"'tab-' + selectedTab.id\" flex=\"noshrink\"><div ng-if=\"selectedTab.custom\" ng-include=\"selectedTab.templateUrl\" flex=\"noshrink\" layout=\"column\"></div><div ng-if=\"!selectedTab.custom\" flex=\"noshrink\" layout=\"column\" class=\"order-tab-contents\"><h2 ng-if=\"selectedTab.title\">{{selectedTab.title | translate}}</h2><div ng-include=\"selectedTab.templateUrl\" flex=\"noshrink\" class=\"ds-table\"></div></div></md-content></md-dialog-content></md-dialog>");;return buf.join("");
}

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RealTimeUpdateService = exports.connectionState = exports.connectionStateString = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _utils = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var connectionStateString = exports.connectionStateString = ['connecting', 'connected', 'reconnecting', '', 'disconnected'];

var connectionState = exports.connectionState = {
    connecting: 0,
    connected: 1,
    reconnecting: 2,
    disconnected: 4
};

var RealTimeUpdateService = exports.RealTimeUpdateService = function () {
    function RealTimeUpdateService(cartonomyConfig, sessionService, rootScope, Hub) {
        var _this = this;

        _classCallCheck(this, RealTimeUpdateService);

        this._hubService = Hub;
        this._sessionService = sessionService;
        this._rootScope = rootScope;
        this._cartonomyConfig = cartonomyConfig;
        this.hubOptions = null;
        this.retriesResetConnection = 0;
        this.intentionallyDisconnected = false;

        var signalrServerRoot = this._cartonomyConfig.backendEndPoint.trim('/') + '/signalr';

        this.hubConfiguration = {
            listeners: {
                onCartUpdated: function onCartUpdated() {
                    return _this._onCartUpdated();
                },
                onCartCheckedOut: function onCartCheckedOut() {
                    return _this._onCartCheckedOut();
                },
                onCartItemsUpdated: function onCartItemsUpdated(cartUpdate) {
                    return _this._onCartItemsUpdated(cartUpdate);
                },
                onChatMessageReceived: function onChatMessageReceived(messageObj) {
                    return _this._onChatMessageReceived(messageObj);
                },
                onCartCancelledByOwner: function onCartCancelledByOwner(messageObj) {
                    return _this._onCartCancelledByOwner();
                },
                onCartClearedByOwner: function onCartClearedByOwner(messageObj) {
                    return _this._onCartClearedByOwner();
                },
                onRemovedByOwner: function onRemovedByOwner(messageObj) {
                    return _this._onRemovedByOwner();
                },
                onCartOwnershipTransfererred: function onCartOwnershipTransfererred(messageObj) {
                    return _this._onCartOwnershipTransferred(messageObj);
                },
                onSwitchedCart: function onSwitchedCart(messageObj) {
                    return _this._onSwitchedCart(messageObj);
                }
            },
            serverMethods: ['createMessage'],
            rootPath: signalrServerRoot,
            onError: function onError(error) {
                return _this._onHubError(error);
            },

            errorHandler: function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(error) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _this.resetConnection();

                                case 1:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }));

                return function errorHandler(_x) {
                    return _ref.apply(this, arguments);
                };
            }(),

            stateChanged: function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(state) {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    if (state.newState === connectionState.disconnected && !_this.intentionallyDisconnected) {
                                        setTimeout(function () {
                                            _this.retriesResetConnection++;
                                            if (_this.retriesResetConnection === 50 && navigator.onLine) {
                                                //ping to check internet
                                                fetch(_utils.utils.cartonomyApiUrl + 'v2/version/ping').then(function (response) {
                                                    if (response.status === 200) {
                                                        window.location.reload();
                                                    }
                                                }).catch(function (error) {
                                                    console.log(error);
                                                });
                                            } else if (_this.retriesResetConnection > 50) {
                                                _this.retriesResetConnection = 0;
                                            }
                                            _this.resetConnection();
                                        }, 2000);
                                    }

                                    if (state.newState === connectionState.connected) {
                                        _this._rootScope.$broadcast(_CommonConstants2.default.Events.SIGNALR_CONNECTED);
                                        setTimeout(function () {
                                            _this.retriesResetConnection = 0;
                                        }, 5000);
                                    }

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this);
                }));

                return function stateChanged(_x2) {
                    return _ref2.apply(this, arguments);
                };
            }()
        };

        rootScope.$on(_CommonConstants2.default.Events.USER_LOGGED_OUT, function (scope) {
            _this.disconnect(true);
            _this.reset();
        });
    }

    _createClass(RealTimeUpdateService, [{
        key: '_onHubError',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(error) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                console.error(error);
                                this.resetConnection();

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function _onHubError(_x3) {
                return _ref3.apply(this, arguments);
            }

            return _onHubError;
        }()
    }, {
        key: 'disconnect',
        value: function disconnect(intentionally) {
            this.intentionallyDisconnected = !!intentionally;
            try {
                this.instance && this.instance.disconnect();
            } catch (e) {} finally {
                this.instance = null;
            }
        }
    }, {
        key: 'resetConnection',
        value: function resetConnection() {
            this.disconnect();
            this._createHub(this.hubOptions);
        }
    }, {
        key: 'ensureConnected',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!this.instance) {
                                    _context4.next = 2;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 2:
                                _context4.next = 4;
                                return this._connect();

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function ensureConnected() {
                return _ref4.apply(this, arguments);
            }

            return ensureConnected;
        }()
    }, {
        key: '_connect',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                this.hubOptions = _.cloneDeep(this.hubConfiguration);

                                _context5.next = 3;
                                return this._sessionService.getAuthToken();

                            case 3:
                                _context5.t0 = _context5.sent;
                                _context5.t1 = 'Bearer ' + _context5.t0;
                                _context5.t2 = this._cartonomyConfig.externalStoreUrl;
                                this.hubOptions.queryParams = {
                                    Authorization: _context5.t1,
                                    X_EXTERNAL_STORE: _context5.t2
                                };


                                this.intentionallyDisconnected = false;
                                this._createHub();

                                _context5.next = 11;
                                return this.instance.connect().done();

                            case 11:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function _connect() {
                return _ref5.apply(this, arguments);
            }

            return _connect;
        }()
    }, {
        key: '_createHub',
        value: function _createHub() {
            this.instance = new this._hubService('clientGroupCartHub', this.hubOptions);
        }
    }, {
        key: 'reset',
        value: function reset() {
            this._postList = [];
        }
    }, {
        key: '_onCartUpdated',
        value: function _onCartUpdated() {
            this._sessionService.setCartReference(null);
        }
    }, {
        key: '_onSwitchedCart',
        value: function _onSwitchedCart(cartInfo) {
            this._rootScope.$broadcast(_CommonConstants2.default.Events.USER_JOINED_OTHER_CART, cartInfo);
        }
    }, {
        key: '_onCartClearedByOwner',
        value: function _onCartClearedByOwner() {
            this._rootScope.$broadcast(_CommonConstants2.default.Events.ORDER_CLEARED_BY_OWNER);
        }
    }, {
        key: '_onCartCancelledByOwner',
        value: function _onCartCancelledByOwner() {
            this._rootScope.$broadcast(_CommonConstants2.default.Events.ORDER_CANCELLED_BY_OWNER);
        }
    }, {
        key: '_onRemovedByOwner',
        value: function _onRemovedByOwner() {
            this._rootScope.$broadcast(_CommonConstants2.default.Events.USER_REMOVED_BY_OWNER);
        }
    }, {
        key: '_onCartCheckedOut',
        value: function _onCartCheckedOut() {
            this._rootScope.$broadcast(_CommonConstants2.default.Events.ORDER_CHECKED_OUT);
        }
    }, {
        key: '_onChatMessageReceived',
        value: function _onChatMessageReceived(messageObj) {
            this._rootScope.$broadcast(_CommonConstants2.default.Events.REALTIME_CHAT_RECEIVED, messageObj);
        }
    }, {
        key: '_onCartOwnershipTransferred',
        value: function _onCartOwnershipTransferred(messageObj) {
            new Audio(_CommonConstants2.default.Notifications.newCartItemNotification).play();
            this._rootScope.$broadcast(_CommonConstants2.default.Events.CART_OWNERSHIP_TRANSFERRED, messageObj);
        }
    }, {
        key: '_onCartItemsUpdated',
        value: function _onCartItemsUpdated(cartUpdate) {
            if (!cartUpdate.isOwner) {
                new Audio(_CommonConstants2.default.Notifications.newCartItemNotification).play();
            }

            this._rootScope.$broadcast(_CommonConstants2.default.Events.CART_ITEMS_CHANGED, cartUpdate);
            this._sessionService.setCartReference(null);
            this._rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.POPUP_BAG_CHANGED);
        }
    }]);

    return RealTimeUpdateService;
}();

RealTimeUpdateService.$inject = ['cartonomyConfig', 'Session', '$rootScope', 'Hub'];


_module3.default.service('RealTimeUpdateService', RealTimeUpdateService);

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function SessionService(localForageService, timeoutService, rootScope) {

    var cartReference = undefined;
    var cartEmitTimeout = null;
    var stealthUserMode = null;

    return {

        getCartReference: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                return _context.abrupt('return', cartReference);

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getCartReference() {
                return _ref.apply(this, arguments);
            }

            return getCartReference;
        }(),

        setCartReference: function setCartReference(reference) {
            var notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            cartReference = reference;
            if (!notify) {
                return;
            }

            if (cartEmitTimeout) {
                timeoutService.cancel(cartEmitTimeout);
            }

            cartEmitTimeout = timeoutService(function () {
                rootScope.$broadcast(_CommonConstants2.default.RootEvents.CART_CHANGED);
                cartEmitTimeout = null;
            }, 200);
        },

        setSessionDetails: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(details) {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return localForageService.store(_CommonConstants2.default.SessionStorage.USER_EMAIL, details.userEmail);

                            case 2:
                                _context2.next = 4;
                                return localForageService.store(_CommonConstants2.default.SessionStorage.USER_NAME, details.userName);

                            case 4:
                                _context2.next = 6;
                                return localForageService.store(_CommonConstants2.default.SessionStorage.USER_FIRST_NAME, details.firstName);

                            case 6:
                                _context2.next = 8;
                                return localForageService.store(_CommonConstants2.default.SessionStorage.USER_LAST_NAME, details.lastName);

                            case 8:
                                _context2.next = 10;
                                return localForageService.store(_CommonConstants2.default.SessionStorage.AUTH_TOKEN, details.authToken);

                            case 10:
                                _context2.next = 12;
                                return localForageService.store(_CommonConstants2.default.SessionStorage.IS_INVITE, details.isInvite || false);

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function setSessionDetails(_x2) {
                return _ref2.apply(this, arguments);
            }

            return setSessionDetails;
        }(),

        clearSessionDetails: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return localForageService.remove(_CommonConstants2.default.SessionStorage.USER_EMAIL);

                            case 2:
                                _context3.next = 4;
                                return localForageService.remove(_CommonConstants2.default.SessionStorage.USER_NAME);

                            case 4:
                                _context3.next = 6;
                                return localForageService.remove(_CommonConstants2.default.SessionStorage.USER_FIRST_NAME);

                            case 6:
                                _context3.next = 8;
                                return localForageService.remove(_CommonConstants2.default.SessionStorage.USER_LAST_NAME);

                            case 8:
                                _context3.next = 10;
                                return localForageService.remove(_CommonConstants2.default.SessionStorage.AUTH_TOKEN);

                            case 10:
                                _context3.next = 12;
                                return localForageService.remove(_CommonConstants2.default.SessionStorage.IS_INVITE);

                            case 12:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function clearSessionDetails() {
                return _ref3.apply(this, arguments);
            }

            return clearSessionDetails;
        }(),

        hasAuthToken: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return localForageService.exists(_CommonConstants2.default.SessionStorage.AUTH_TOKEN);

                            case 2:
                                return _context4.abrupt('return', _context4.sent);

                            case 3:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function hasAuthToken() {
                return _ref4.apply(this, arguments);
            }

            return hasAuthToken;
        }(),

        getAuthToken: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return localForageService.retrieve(_CommonConstants2.default.SessionStorage.AUTH_TOKEN);

                            case 2:
                                return _context5.abrupt('return', _context5.sent);

                            case 3:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function getAuthToken() {
                return _ref5.apply(this, arguments);
            }

            return getAuthToken;
        }(),

        clearAuthToken: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return localForageService.remove(_CommonConstants2.default.SessionStorage.AUTH_TOKEN);

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function clearAuthToken() {
                return _ref6.apply(this, arguments);
            }

            return clearAuthToken;
        }(),

        loggedIn: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var email;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.getUserEmail();

                            case 2:
                                email = _context7.sent;
                                return _context7.abrupt('return', !!email);

                            case 4:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function loggedIn() {
                return _ref7.apply(this, arguments);
            }

            return loggedIn;
        }(),

        isInvite: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return localForageService.retrieve(_CommonConstants2.default.SessionStorage.IS_INVITE);

                            case 2:
                                _context8.t0 = _context8.sent;
                                return _context8.abrupt('return', _context8.t0 == 'true');

                            case 4:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function isInvite() {
                return _ref8.apply(this, arguments);
            }

            return isInvite;
        }(),

        getUserEmail: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return localForageService.retrieve(_CommonConstants2.default.SessionStorage.USER_EMAIL);

                            case 2:
                                return _context9.abrupt('return', _context9.sent);

                            case 3:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function getUserEmail() {
                return _ref9.apply(this, arguments);
            }

            return getUserEmail;
        }(),

        getUserName: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return localForageService.retrieve(_CommonConstants2.default.SessionStorage.USER_NAME);

                            case 2:
                                return _context10.abrupt('return', _context10.sent);

                            case 3:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function getUserName() {
                return _ref10.apply(this, arguments);
            }

            return getUserName;
        }(),

        getUserFirstName: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return localForageService.retrieve(_CommonConstants2.default.SessionStorage.USER_FIRST_NAME);

                            case 2:
                                return _context11.abrupt('return', _context11.sent);

                            case 3:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function getUserFirstName() {
                return _ref11.apply(this, arguments);
            }

            return getUserFirstName;
        }(),

        getCachedUser: function getCachedUser() {
            return this._cachedUser;
        },

        setCachedUser: function setCachedUser(user) {
            this._cachedUser = user;
        },

        getStealthUserMode: function getStealthUserMode() {
            return stealthUserMode;
        },

        setStealthUserMode: function setStealthUserMode(value) {
            stealthUserMode = value;
        }
    };
}

_module3.default.service('Session', ['LocalForageService', '$timeout', '$rootScope', SessionService]);

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SessionStorageService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _DbStorageService = __webpack_require__(697);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SessionStorageService = exports.SessionStorageService = function () {
    function SessionStorageService(cookies, cartonomyConfig) {
        _classCallCheck(this, SessionStorageService);

        this.cookiesService = cookies;
        this.cartonomyConfig = cartonomyConfig;
        this.storageCopy = {};

        this.checkLocalStorage();
        if (window.localStorage.getItem(_CommonConstants2.default.SessionStorage.CARTONOMY_BUILD_TIME) !== this.cartonomyConfig.buildTime || window.localStorage.getItem(_CommonConstants2.default.SessionStorage.CARTONOMY_BUILD_VERSION) !== this.cartonomyConfig.version) {
            this.resetVersionStorage();
        }
    }

    _createClass(SessionStorageService, [{
        key: 'checkLocalStorage',
        value: function checkLocalStorage() {
            var _this = this;

            if (window.localStorage.length) {
                for (var i in window.localStorage) {
                    this.storageCopy[i] = window.localStorage[i];
                }
            } else {
                for (var _i in this.storageCopy) {
                    window.localStorage.setItem(_i, this.storageCopy[_i]);
                }
            }

            setTimeout(function () {
                return _this.checkLocalStorage();
            }, 60 * 1000);
        }
    }, {
        key: 'resetVersionStorage',
        value: function resetVersionStorage() {
            window.localStorage.setItem(_CommonConstants2.default.SessionStorage.CARTONOMY_BUILD_TIME, this.cartonomyConfig.buildTime);
            window.localStorage.setItem(_CommonConstants2.default.SessionStorage.CARTONOMY_BUILD_VERSION, this.cartonomyConfig.version);
        }
    }, {
        key: 'getStorageKey',
        value: function getStorageKey(key) {
            if (this.cartonomyConfig.externalStoreMode) {
                return this.cartonomyConfig.externalStoreUrl + '__' + key;
            }

            return key;
        }
    }, {
        key: 'get',
        value: function get(key) {
            if (window.localStorage) {
                return window.localStorage.getItem(this.getStorageKey(key));
            } else {
                return this.cookiesService.get(this.getStorageKey(key));
            }
        }
    }, {
        key: 'set',
        value: function set(key, value) {
            if (window.localStorage) {
                window.localStorage.setItem(this.getStorageKey(key), value);
            } else {
                this.cookiesService.put(this.getStorageKey(key), value);
            }
            return value;
        }
    }, {
        key: 'clear',
        value: function clear(key) {
            if (window.localStorage) {
                window.localStorage.removeItem(this.getStorageKey(key));
            } else {
                this.cookiesService.remove(this.getStorageKey(key));
            }
        }
    }, {
        key: 'clearAll',
        value: function clearAll() {
            window.localStorage.clear();
            window.sessionStorage.clear();
            this.resetVersionStorage();
        }
    }, {
        key: 'exists',
        value: function exists(key) {
            return !_.isUndefined(this.get(key)) && !_.isNull(this.get(key));
        }
    }]);

    return SessionStorageService;
}();

SessionStorageService.$inject = ['$cookies', 'cartonomyConfig'];


_module3.default.service('SessionStorage', SessionStorageService);

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartonomyDbName = 'CartonomyDatabase';

var DbStorageService = exports.DbStorageService = function DbStorageService(cartonomyConfig) {
    _classCallCheck(this, DbStorageService);

    this.cartonomyConfig = cartonomyConfig;

    var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

    // Open (or create) the database
    var open = indexedDB.open(this.cartonomyConfig.externalStoreUrl + '_' + CartonomyDbName, 1);

    // Create the schema
    open.onupgradeneeded = function () {
        var db = open.result;
        var userauthenticationStore = db.createObjectStore("AuthenticationStore", { keyPath: "token" });
        userauthenticationStore.createIndex("AuthenticationStoreIndex", ['token']);

        var store = db.createObjectStore("WindowState", { keyPath: "id" });
        var index = store.createIndex("NameIndex", ["name.last", "name.first"]);
    };

    open.onsuccess = function () {
        var db = open.result;

        /*
        let tx = db.transaction("MyObjectStore", "readwrite");
        let store = tx.objectStore("MyObjectStore");
        let index = store.index("NameIndex");
          // Add some data
        store.put({id: 12345, name: {first: "John", last: "Doe"}, age: 42});
        store.put({id: 67890, name: {first: "Bob", last: "Smith"}, age: 35});
          // Query the data
        let getJohn = store.get(12345);
        let getBob = index.get(["Smith", "Bob"]);
          getJohn.onsuccess = function () {
            console.log(getJohn.result.name.first);  // => "John"
        };
          getBob.onsuccess = function () {
            console.log(getBob.result.name.first);   // => "Bob"
        };
          // Close the db when the transaction is done
        tx.oncomplete = function () {
            db.close();
        };
          */
    };

    this.database = open;
};

DbStorageService.$inject = ['cartonomyConfig'];

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalForageServiceAdapter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LocalForageServiceAdapter = exports.LocalForageServiceAdapter = function () {
  function LocalForageServiceAdapter() {
    _classCallCheck(this, LocalForageServiceAdapter);

    if (!window.localStorage) {
      throw new Error('Current browser does not support Local Storage');
    }
    this.localStorage = localStorage;
  }

  _createClass(LocalForageServiceAdapter, [{
    key: 'reinitialize',
    value: function reinitialize() {}
  }, {
    key: 'exists',
    value: function exists(key) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        resolve(!!_this.localStorage.getItem(key));
      });
    }
  }, {
    key: 'retrieve',
    value: function retrieve(key) {
      var result = this.localStorage.getItem(key);
      if (result === undefined || result == null) {
        return Promise.resolve(null);
      }

      try {
        var output = JSON.parse(result);
        return Promise.resolve(output);
      } catch (e) {
        return Promise.resolve(result);
      }
    }
  }, {
    key: 'store',
    value: function store(key, value) {
      this.localStorage.setItem(key, JSON.stringify(value));
      return Promise.resolve();
    }
  }, {
    key: 'remove',
    value: function remove(key) {
      this.localStorage.removeItem(key);
      return Promise.resolve();
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.localStorage.clear();
      return Promise.resolve();
    }
  }]);

  return LocalForageServiceAdapter;
}();

_module3.default.service('LocalForageService', LocalForageServiceAdapter);

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UserProfileService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProfileService = exports.UserProfileService = function () {
    function UserProfileService(httpService, rootScopeService, cartonomyConfig, sessionService, localForageService) {
        var _this = this;

        _classCallCheck(this, UserProfileService);

        this.baseUrl = cartonomyConfig.ApiV2 + 'user';
        this.emailUrl = this.baseUrl + '/email';
        this.addressUrl = this.baseUrl + '/address';
        this._httpService = httpService;
        this.cartonomyConfig = cartonomyConfig;
        this._sessionService = sessionService;
        //this._sessionStorageService = SessionStorage;
        this._localForageService = localForageService;
        this._addresses = null;

        rootScopeService.$on(_CommonConstants2.default.RootEvents.CART_CHANGED, function () {
            _this.resetUser();
        });
    }

    _createClass(UserProfileService, [{
        key: 'saveProfile',
        value: function saveProfile(profile) {
            var _this2 = this;

            return this._httpService.post(this.cartonomyConfig.ApiV2 + 'user/profile', profile).then(function (response) {
                _this2._sessionService.setCachedUser(null);
                _this2._addresses = null;
                _this2.getUser(false);
                return response.data;
            });
        }
    }, {
        key: 'resetUser',
        value: function resetUser() {
            this._addresses = null;
            this._sessionService.setCachedUser(null);
        }
    }, {
        key: 'getUser',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this3 = this;

                var getFromCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var cachedUser;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                cachedUser = this._sessionService.getCachedUser();

                                if (!(getFromCache && cachedUser)) {
                                    _context2.next = 3;
                                    break;
                                }

                                return _context2.abrupt('return', cachedUser);

                            case 3:
                                _context2.next = 5;
                                return this._httpService.get(this.baseUrl).then(function () {
                                    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                                        return regeneratorRuntime.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        _context.next = 2;
                                                        return _this3._localForageService.store(_CommonConstants2.default.SessionStorage.USER_DATA, JSON.stringify(response.data));

                                                    case 2:
                                                        return _context.abrupt('return', response.data);

                                                    case 3:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this3);
                                    }));

                                    return function (_x2) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }());

                            case 5:
                                cachedUser = _context2.sent;


                                this._sessionService.setCachedUser(cachedUser);
                                this._addresses = null;

                                return _context2.abrupt('return', cachedUser);

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getUser() {
                return _ref.apply(this, arguments);
            }

            return getUser;
        }()
    }, {
        key: 'getUserEmails',
        value: function getUserEmails() {
            return this.getUser().then(function (user) {
                return user.userEmails;
            });
        }
    }, {
        key: 'deleteEmail',
        value: function deleteEmail(email) {
            var _this4 = this;

            return this._httpService.delete(this.emailUrl + "/" + email.id).then(function () {
                _this4._sessionService.setCachedUser(null);
            });
        }
    }, {
        key: 'updateEmail',
        value: function updateEmail(email) {
            var _this5 = this;

            return this._httpService.patch(this.emailUrl, email).then(function (response) {
                _this5._sessionService.setCachedUser(null);
                return response.data;
            });
        }
    }, {
        key: 'createEmail',
        value: function createEmail(email) {
            var _this6 = this;

            return this._httpService.post(this.emailUrl, email).then(function (response) {
                _this6._sessionService.setCachedUser(null);
                return response.data;
            });
        }
    }, {
        key: 'getUserAddresses',
        value: function getUserAddresses() {
            if (this._addresses) {
                return this._addresses;
            }
            this._addresses = this._httpService.get(this.addressUrl).then(function (response) {
                return response.data;
            });
            return this._addresses;
        }
    }, {
        key: 'updateAddress',
        value: function updateAddress(address) {
            var _this7 = this;

            return this._httpService.patch(this.addressUrl, address).then(function (response) {
                _this7._addresses = null;
                _this7._sessionService.setCachedUser(null);
                return response.data;
            });
        }
    }, {
        key: 'createAddress',
        value: function createAddress(address) {
            var _this8 = this;

            return this._httpService.post(this.addressUrl, address).then(function (response) {
                _this8._addresses = null;
                _this8._sessionService.setCachedUser(null);
                return response.data;
            });
        }
    }, {
        key: 'deleteAddress',
        value: function deleteAddress(id) {
            var _this9 = this;

            return this._httpService.delete(this.addressUrl + '/' + id).then(function () {
                _this9._addresses = null;
                _this9._sessionService.setCachedUser(null);
            });
        }
    }, {
        key: 'updateOpenIdAvatar',
        value: function updateOpenIdAvatar(providerId) {
            return this._httpService.get(this.baseUrl + '/avatar/oauth/' + providerId);
        }
    }, {
        key: 'getUserAvatar',
        value: function getUserAvatar(userEmail) {
            return this._httpService.get(this.baseUrl + '/avatar/byemail?email=' + userEmail);
        }
    }, {
        key: 'uploadAvatar',
        value: function uploadAvatar(file) {
            var config = {
                headers: {
                    'Content-Type': undefined
                }
            };
            var formData = new window.FormData();
            formData.append('file', file);
            return this._httpService.post(this.cartonomyConfig.ApiV1 + 'avatar/upload/jpg', formData, config);
        }
    }]);

    return UserProfileService;
}();

UserProfileService.$inject = ['$http', '$rootScope', 'cartonomyConfig', 'Session', 'LocalForageService'];


_module3.default.service('UserProfile', UserProfileService);

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HeapService() {
    return {
        identify: function identify() {
            try {
                window.heap.identify.apply(null, arguments);
            } catch (e) {}
        },
        track: function track(name, obj) {
            try {
                window.heap.track.apply(null, arguments);
            } catch (e) {}
        }
    };
}

_module3.default.factory('HeapService', HeapService);

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('money', ['$locale', '$filter', function ($locale, $filter) {

    // For input validation
    var isValid = function isValid(val) {
        return angular.isNumber(val) && !isNaN(val);
    };

    // Saved to your $scope/model
    var toModel = function toModel(val) {
        return parseInt(val.replace(/[^0-9]+/g, "")) || 0;
    };

    // Link to DOM
    var link = function link($scope, $element, $attrs, $ngModel) {
        function toView(val) {
            var converted = val ? $filter('currency')(val, '', 0) : "";
            if (converted !== val) {
                var caretPosition = $element[0].selectionStart;
                $ngModel.$setViewValue(converted);
                $ngModel.$render();
                //$element[0].selectionStart = $element[0].selectionEnd = caretPosition + caretPosition / 4;
            }
            return converted;
        }
        $ngModel.$formatters.push(toView);
        $ngModel.$parsers.push(toModel);
        $ngModel.$validators.currency = isValid;

        $element.on('keyup', function ($event) {
            $ngModel.$viewValue = toView($ngModel.$modelValue);
        });
    };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: link
    };
}]);

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = markdownTranspileDirective;

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _markdownIt = __webpack_require__(703);

var _markdownIt2 = _interopRequireDefault(_markdownIt);

var _markdownItEmoji = __webpack_require__(758);

var _markdownItEmoji2 = _interopRequireDefault(_markdownItEmoji);

var _emojiMaker = __webpack_require__(764);

var _emojiMaker2 = _interopRequireDefault(_emojiMaker);

var _markdownItBlockImage = __webpack_require__(765);

var _markdownItBlockImage2 = _interopRequireDefault(_markdownItBlockImage);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var marked = new _markdownIt2.default();
marked.use(_markdownItEmoji2.default);
marked.use(_markdownItBlockImage2.default, {
    outputContainer: true,
    containerClassName: "image-container"
});

function unindent(text) {
    if (!text) {
        return text;
    }

    var lines = text.replace(/\t/g, '  ').split(/\r?\n/);

    var min = null;
    var len = lines.length;
    var i = void 0;

    for (i = 0; i < len; i++) {
        var line = lines[i];
        var l = line.match(/^(\s*)/)[0].length;
        if (l === line.length) {
            continue;
        }
        min = l < min || min === null ? l : min;
    }

    if (min !== null && min > 0) {
        for (i = 0; i < len; i++) {
            lines[i] = lines[i].substr(min);
        }
    }
    return lines.join('\n');
}

markdownTranspileDirective.$inject = ['$', '$timeout'];
markdownTranspileDirective.directiveName = "markdownTranspile";
markdownTranspileDirective.emojiConvertor = new _emojiMaker2.default();
markdownTranspileDirective.emojiConvertor.use_sheet = true;

function getParents(elem, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) {}
            return i > -1;
        };
    }

    // Setup parents array
    var parents = [];

    // Get matching parent elements
    for (; elem && elem !== document; elem = elem.parentNode) {

        // Add matching parents to array
        if (selector) {
            if (elem.matches(selector)) {
                parents.push(elem);
            }
        } else {
            parents.push(elem);
        }
    }

    return parents;
}

function isElement(obj) {
    return obj instanceof HTMLElement;
}

function showEmoji(node) {
    if (node.textContent.trim().length < 1) return true;

    var nodeParents = getParents(node);

    // check if inside contenteditable div
    for (var p = 0; p < nodeParents.length; p++) {
        if (isElement(nodeParents[p]) && nodeParents[p].getAttribute('contenteditable') == 'true') return true;
    }

    var textToCheck = node.textContent.replace(/&amp;/g, '&').replace(/&/g, '&amp;');
    var modifiedText = textToCheck;
    var emojiExist = false;

    if (modifiedText.length > 0) {
        modifiedText = markdownTranspileDirective.emojiConvertor.replace_unified(modifiedText);
        if (modifiedText !== textToCheck) emojiExist = true;
    }

    if (emojiExist === true) {

        var element = node.parentElement;

        for (var _p = 1; _p < nodeParents.length; _p++) {
            if (element === undefined || !isElement(element)) element = nodeParents[_p];
        }

        if (element) {
            var html = element.innerHTML;
            if (html.toLowerCase().indexOf('document.write') === -1) {
                html = html.replace(/”/g, '&rdquo;');
                var replace = html.replace(textToCheck.replace(/\xa0/g, '&nbsp;').replace(/”/g, '&rdquo;'), modifiedText);
                element.innerHTML = replace;
            }
        }
    }
}

function markdownTranspileDirective($, timeout) {
    return {
        restrict: 'AE',
        scope: {
            markdownTranspile: '='
        },
        link: function link(scope, element, attrs) {
            // scope.$watch('marked', set);

            timeout(function () {
                if (scope.markdownTranspile) {
                    set(scope.markdownTranspile);
                } else {
                    set(element.text());
                }
            });

            function processImageTag(text) {
                var startingPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

                var chatImageStartingIndex = text.indexOf('![chatImage](', startingPos);

                if (chatImageStartingIndex == -1) return text;

                var chatImageStringEndindex = text.indexOf(')', chatImageStartingIndex);

                var chatImageStr = text.substring(chatImageStartingIndex, chatImageStringEndindex + 1);

                var proceededText = _.trim(chatImageStr.split(' ')[0], ')') + ')';

                text = text.replace(chatImageStr, proceededText);
                return processImageTag(text, chatImageStringEndindex);
            }

            function set(text) {
                text = unindent(text || '');

                // fix image messages
                text = processImageTag(text);

                var transpiledText = marked.render(text);

                transpiledText = transpiledText.replace(/&lt;/g, '<').replace(/&quot;/g, '"').replace(/&gt;/g, '>');

                var transpiledDOM = $(transpiledText);

                $('a', transpiledDOM).each(function () {
                    var target = $(this).attr('target');
                    if (!target || target != "_parent") {
                        $(this).attr('target', '_blank');
                    }
                });

                _scope2.default.apply(scope, function () {
                    $(element).append(transpiledDOM);
                    showEmoji($(element)[0]);
                });
            }
        }
    };
}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(704);

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Main parser class



var utils = __webpack_require__(9);
var helpers = __webpack_require__(712);
var Renderer = __webpack_require__(716);
var ParserCore = __webpack_require__(717);
var ParserBlock = __webpack_require__(725);
var ParserInline = __webpack_require__(739);
var LinkifyIt = __webpack_require__(752);
var mdurl = __webpack_require__(421);
var punycode = __webpack_require__(754);

var config = {
  'default': __webpack_require__(755),
  zero: __webpack_require__(756),
  commonmark: __webpack_require__(757)
};

////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//

var BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;

function validateLink(url) {
  // url should be normalized at this point, and existing entities are decoded
  var str = url.trim().toLowerCase();

  return BAD_PROTO_RE.test(str) ? GOOD_DATA_RE.test(str) ? true : false : true;
}

////////////////////////////////////////////////////////////////////////////////


var RECODE_HOSTNAME_FOR = ['http:', 'https:', 'mailto:'];

function normalizeLink(url) {
  var parsed = mdurl.parse(url, true);

  if (parsed.hostname) {
    // Encode hostnames in urls like:
    // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
    //
    // We don't encode unknown schemas, because it's likely that we encode
    // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
    //
    if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
      try {
        parsed.hostname = punycode.toASCII(parsed.hostname);
      } catch (er) {/**/}
    }
  }

  return mdurl.encode(mdurl.format(parsed));
}

function normalizeLinkText(url) {
  var parsed = mdurl.parse(url, true);

  if (parsed.hostname) {
    // Encode hostnames in urls like:
    // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
    //
    // We don't encode unknown schemas, because it's likely that we encode
    // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
    //
    if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
      try {
        parsed.hostname = punycode.toUnicode(parsed.hostname);
      } catch (er) {/**/}
    }
  }

  return mdurl.decode(mdurl.format(parsed));
}

/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/

/**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(lang, str, true).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(lang, str, true).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/
function MarkdownIt(presetName, options) {
  if (!(this instanceof MarkdownIt)) {
    return new MarkdownIt(presetName, options);
  }

  if (!options) {
    if (!utils.isString(presetName)) {
      options = presetName || {};
      presetName = 'default';
    }
  }

  /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.inline = new ParserInline();

  /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.block = new ParserBlock();

  /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.core = new ParserCore();

  /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/
  this.renderer = new Renderer();

  /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/
  this.linkify = new LinkifyIt();

  /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/
  this.validateLink = validateLink;

  /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/
  this.normalizeLink = normalizeLink;

  /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/
  this.normalizeLinkText = normalizeLinkText;

  // Expose utils & helpers for easy acces from plugins

  /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/
  this.utils = utils;

  /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/
  this.helpers = utils.assign({}, helpers);

  this.options = {};
  this.configure(presetName);

  if (options) {
    this.set(options);
  }
}

/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/
MarkdownIt.prototype.set = function (options) {
  utils.assign(this.options, options);
  return this;
};

/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you with - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/
MarkdownIt.prototype.configure = function (presets) {
  var self = this,
      presetName;

  if (utils.isString(presets)) {
    presetName = presets;
    presets = config[presetName];
    if (!presets) {
      throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
  }

  if (!presets) {
    throw new Error('Wrong `markdown-it` preset, can\'t be empty');
  }

  if (presets.options) {
    self.set(presets.options);
  }

  if (presets.components) {
    Object.keys(presets.components).forEach(function (name) {
      if (presets.components[name].rules) {
        self[name].ruler.enableOnly(presets.components[name].rules);
      }
      if (presets.components[name].rules2) {
        self[name].ruler2.enableOnly(presets.components[name].rules2);
      }
    });
  }
  return this;
};

/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/
MarkdownIt.prototype.enable = function (list, ignoreInvalid) {
  var result = [];

  if (!Array.isArray(list)) {
    list = [list];
  }

  ['core', 'block', 'inline'].forEach(function (chain) {
    result = result.concat(this[chain].ruler.enable(list, true));
  }, this);

  result = result.concat(this.inline.ruler2.enable(list, true));

  var missed = list.filter(function (name) {
    return result.indexOf(name) < 0;
  });

  if (missed.length && !ignoreInvalid) {
    throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
  }

  return this;
};

/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/
MarkdownIt.prototype.disable = function (list, ignoreInvalid) {
  var result = [];

  if (!Array.isArray(list)) {
    list = [list];
  }

  ['core', 'block', 'inline'].forEach(function (chain) {
    result = result.concat(this[chain].ruler.disable(list, true));
  }, this);

  result = result.concat(this.inline.ruler2.disable(list, true));

  var missed = list.filter(function (name) {
    return result.indexOf(name) < 0;
  });

  if (missed.length && !ignoreInvalid) {
    throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
  }
  return this;
};

/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/
MarkdownIt.prototype.use = function (plugin /*, params, ... */) {
  var args = [this].concat(Array.prototype.slice.call(arguments, 1));
  plugin.apply(plugin, args);
  return this;
};

/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and returns list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/
MarkdownIt.prototype.parse = function (src, env) {
  if (typeof src !== 'string') {
    throw new Error('Input data should be a String');
  }

  var state = new this.core.State(src, this, env);

  this.core.process(state);

  return state.tokens;
};

/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/
MarkdownIt.prototype.render = function (src, env) {
  env = env || {};

  return this.renderer.render(this.parse(src, env), this.options, env);
};

/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/
MarkdownIt.prototype.parseInline = function (src, env) {
  var state = new this.core.State(src, this, env);

  state.inlineMode = true;
  this.core.process(state);

  return state.tokens;
};

/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/
MarkdownIt.prototype.renderInline = function (src, env) {
  env = env || {};

  return this.renderer.render(this.parseInline(src, env), this.options, env);
};

module.exports = MarkdownIt;

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var encodeCache = {};

// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function getEncodeCache(exclude) {
  var i,
      ch,
      cache = encodeCache[exclude];
  if (cache) {
    return cache;
  }

  cache = encodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);

    if (/^[0-9a-z]$/i.test(ch)) {
      // always allow unencoded alphanumeric characters
      cache.push(ch);
    } else {
      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
  }

  for (i = 0; i < exclude.length; i++) {
    cache[exclude.charCodeAt(i)] = exclude[i];
  }

  return cache;
}

// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function encode(string, exclude, keepEscaped) {
  var i,
      l,
      code,
      nextCode,
      cache,
      result = '';

  if (typeof exclude !== 'string') {
    // encode(string, keepEscaped)
    keepEscaped = exclude;
    exclude = encode.defaultChars;
  }

  if (typeof keepEscaped === 'undefined') {
    keepEscaped = true;
  }

  cache = getEncodeCache(exclude);

  for (i = 0, l = string.length; i < l; i++) {
    code = string.charCodeAt(i);

    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
        result += string.slice(i, i + 3);
        i += 2;
        continue;
      }
    }

    if (code < 128) {
      result += cache[code];
      continue;
    }

    if (code >= 0xD800 && code <= 0xDFFF) {
      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
        nextCode = string.charCodeAt(i + 1);
        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
          result += encodeURIComponent(string[i] + string[i + 1]);
          i++;
          continue;
        }
      }
      result += '%EF%BF%BD';
      continue;
    }

    result += encodeURIComponent(string[i]);
  }

  return result;
}

encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
encode.componentChars = "-_.!~*'()";

module.exports = encode;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



/* eslint-disable no-bitwise */

var decodeCache = {};

function getDecodeCache(exclude) {
  var i,
      ch,
      cache = decodeCache[exclude];
  if (cache) {
    return cache;
  }

  cache = decodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);
    cache.push(ch);
  }

  for (i = 0; i < exclude.length; i++) {
    ch = exclude.charCodeAt(i);
    cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
  }

  return cache;
}

// Decode percent-encoded string.
//
function decode(string, exclude) {
  var cache;

  if (typeof exclude !== 'string') {
    exclude = decode.defaultChars;
  }

  cache = getDecodeCache(exclude);

  return string.replace(/(%[a-f0-9]{2})+/gi, function (seq) {
    var i,
        l,
        b1,
        b2,
        b3,
        b4,
        chr,
        result = '';

    for (i = 0, l = seq.length; i < l; i += 3) {
      b1 = parseInt(seq.slice(i + 1, i + 3), 16);

      if (b1 < 0x80) {
        result += cache[b1];
        continue;
      }

      if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
        // 110xxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);

        if ((b2 & 0xC0) === 0x80) {
          chr = b1 << 6 & 0x7C0 | b2 & 0x3F;

          if (chr < 0x80) {
            result += '\uFFFD\uFFFD';
          } else {
            result += String.fromCharCode(chr);
          }

          i += 3;
          continue;
        }
      }

      if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
        // 1110xxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);

        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
          chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;

          if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) {
            result += '\uFFFD\uFFFD\uFFFD';
          } else {
            result += String.fromCharCode(chr);
          }

          i += 6;
          continue;
        }
      }

      if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
        // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);
        b4 = parseInt(seq.slice(i + 10, i + 12), 16);

        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
          chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;

          if (chr < 0x10000 || chr > 0x10FFFF) {
            result += '\uFFFD\uFFFD\uFFFD\uFFFD';
          } else {
            chr -= 0x10000;
            result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
          }

          i += 9;
          continue;
        }
      }

      result += '\uFFFD';
    }

    return result;
  });
}

decode.defaultChars = ';/?:@&=+$,#';
decode.componentChars = '';

module.exports = decode;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = function format(url) {
  var result = '';

  result += url.protocol || '';
  result += url.slashes ? '//' : '';
  result += url.auth ? url.auth + '@' : '';

  if (url.hostname && url.hostname.indexOf(':') !== -1) {
    // ipv6 address
    result += '[' + url.hostname + ']';
  } else {
    result += url.hostname || '';
  }

  result += url.port ? ':' + url.port : '';
  result += url.pathname || '';
  result += url.search || '';
  result += url.hash || '';

  return result;
};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//


function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.pathname = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,


// Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,


// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],


// RFC 2396: characters not allowed for various reasons.
unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),


// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = ['\''].concat(unwise),

// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,

// protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */
// protocols that never have a hostname.
hostlessProtocol = {
  'javascript': true,
  'javascript:': true
},

// protocols that always contain a // bit.
slashedProtocol = {
  'http': true,
  'https': true,
  'ftp': true,
  'gopher': true,
  'file': true,
  'http:': true,
  'https:': true,
  'ftp:': true,
  'gopher:': true,
  'file:': true
};
/* eslint-enable no-script-url */

function urlParse(url, slashesDenoteHost) {
  if (url && url instanceof Url) {
    return url;
  }

  var u = new Url();
  u.parse(url, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, slashesDenoteHost) {
  var i,
      l,
      lowerProto,
      hec,
      slashes,
      rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    lowerProto = proto.toLowerCase();
    this.protocol = proto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (i = 0; i < hostEndingChars.length; i++) {
      hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = auth;
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (i = 0; i < nonHostChars.length; i++) {
      hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) {
      hostEnd = rest.length;
    }

    if (rest[hostEnd - 1] === ':') {
      hostEnd--;
    }
    var host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost(host);

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) {
          continue;
        }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    }

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    rest = rest.slice(0, qm);
  }
  if (rest) {
    this.pathname = rest;
  }
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '';
  }

  return this;
};

Url.prototype.parseHost = function (host) {
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) {
    this.hostname = host;
  }
};

module.exports = urlParse;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.Any = __webpack_require__(422);
exports.Cc = __webpack_require__(423);
exports.Cf = __webpack_require__(711);
exports.P = __webpack_require__(113);
exports.Z = __webpack_require__(424);

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Just a shortcut for bulk export


exports.parseLinkLabel = __webpack_require__(713);
exports.parseLinkDestination = __webpack_require__(714);
exports.parseLinkTitle = __webpack_require__(715);

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//


module.exports = function parseLinkLabel(state, start, disableNested) {
  var level,
      found,
      marker,
      prevPos,
      labelEnd = -1,
      max = state.posMax,
      oldPos = state.pos;

  state.pos = start + 1;
  level = 1;

  while (state.pos < max) {
    marker = state.src.charCodeAt(state.pos);
    if (marker === 0x5D /* ] */) {
        level--;
        if (level === 0) {
          found = true;
          break;
        }
      }

    prevPos = state.pos;
    state.md.inline.skipToken(state);
    if (marker === 0x5B /* [ */) {
        if (prevPos === state.pos - 1) {
          // increase level if we find text `[`, which is not a part of any token
          level++;
        } else if (disableNested) {
          state.pos = oldPos;
          return -1;
        }
      }
  }

  if (found) {
    labelEnd = state.pos;
  }

  // restore old state
  state.pos = oldPos;

  return labelEnd;
};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parse link destination
//


var isSpace = __webpack_require__(9).isSpace;
var unescapeAll = __webpack_require__(9).unescapeAll;

module.exports = function parseLinkDestination(str, pos, max) {
  var code,
      level,
      lines = 0,
      start = pos,
      result = {
    ok: false,
    pos: 0,
    lines: 0,
    str: ''
  };

  if (str.charCodeAt(pos) === 0x3C /* < */) {
      pos++;
      while (pos < max) {
        code = str.charCodeAt(pos);
        if (code === 0x0A /* \n */ || isSpace(code)) {
          return result;
        }
        if (code === 0x3E /* > */) {
            result.pos = pos + 1;
            result.str = unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
          }
        if (code === 0x5C /* \ */ && pos + 1 < max) {
          pos += 2;
          continue;
        }

        pos++;
      }

      // no closing '>'
      return result;
    }

  // this should be ... } else { ... branch

  level = 0;
  while (pos < max) {
    code = str.charCodeAt(pos);

    if (code === 0x20) {
      break;
    }

    // ascii control characters
    if (code < 0x20 || code === 0x7F) {
      break;
    }

    if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos += 2;
      continue;
    }

    if (code === 0x28 /* ( */) {
        level++;
      }

    if (code === 0x29 /* ) */) {
        if (level === 0) {
          break;
        }
        level--;
      }

    pos++;
  }

  if (start === pos) {
    return result;
  }
  if (level !== 0) {
    return result;
  }

  result.str = unescapeAll(str.slice(start, pos));
  result.lines = lines;
  result.pos = pos;
  result.ok = true;
  return result;
};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parse link title
//


var unescapeAll = __webpack_require__(9).unescapeAll;

module.exports = function parseLinkTitle(str, pos, max) {
  var code,
      marker,
      lines = 0,
      start = pos,
      result = {
    ok: false,
    pos: 0,
    lines: 0,
    str: ''
  };

  if (pos >= max) {
    return result;
  }

  marker = str.charCodeAt(pos);

  if (marker !== 0x22 /* " */ && marker !== 0x27 /* ' */ && marker !== 0x28 /* ( */) {
      return result;
    }

  pos++;

  // if opening marker is "(", switch it to closing marker ")"
  if (marker === 0x28) {
    marker = 0x29;
  }

  while (pos < max) {
    code = str.charCodeAt(pos);
    if (code === marker) {
      result.pos = pos + 1;
      result.lines = lines;
      result.str = unescapeAll(str.slice(start + 1, pos));
      result.ok = true;
      return result;
    } else if (code === 0x0A) {
      lines++;
    } else if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos++;
      if (str.charCodeAt(pos) === 0x0A) {
        lines++;
      }
    }

    pos++;
  }

  return result;
};

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/


var assign = __webpack_require__(9).assign;
var unescapeAll = __webpack_require__(9).unescapeAll;
var escapeHtml = __webpack_require__(9).escapeHtml;

////////////////////////////////////////////////////////////////////////////////

var default_rules = {};

default_rules.code_inline = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  return '<code' + slf.renderAttrs(token) + '>' + escapeHtml(tokens[idx].content) + '</code>';
};

default_rules.code_block = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  return '<pre' + slf.renderAttrs(token) + '><code>' + escapeHtml(tokens[idx].content) + '</code></pre>\n';
};

default_rules.fence = function (tokens, idx, options, env, slf) {
  var token = tokens[idx],
      info = token.info ? unescapeAll(token.info).trim() : '',
      langName = '',
      highlighted,
      i,
      tmpAttrs,
      tmpToken;

  if (info) {
    langName = info.split(/\s+/g)[0];
  }

  if (options.highlight) {
    highlighted = options.highlight(token.content, langName) || escapeHtml(token.content);
  } else {
    highlighted = escapeHtml(token.content);
  }

  if (highlighted.indexOf('<pre') === 0) {
    return highlighted + '\n';
  }

  // If language exists, inject class gently, without modifying original token.
  // May be, one day we will add .clone() for token and simplify this part, but
  // now we prefer to keep things local.
  if (info) {
    i = token.attrIndex('class');
    tmpAttrs = token.attrs ? token.attrs.slice() : [];

    if (i < 0) {
      tmpAttrs.push(['class', options.langPrefix + langName]);
    } else {
      tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
    }

    // Fake token just to render attributes
    tmpToken = {
      attrs: tmpAttrs
    };

    return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
  }

  return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};

default_rules.image = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  // "alt" attr MUST be set, even if empty. Because it's mandatory and
  // should be placed on proper position for tests.
  //
  // Replace content with actual value

  token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);

  return slf.renderToken(tokens, idx, options);
};

default_rules.hardbreak = function (tokens, idx, options /*, env */) {
  return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
default_rules.softbreak = function (tokens, idx, options /*, env */) {
  return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};

default_rules.text = function (tokens, idx /*, options, env */) {
  return escapeHtml(tokens[idx].content);
};

default_rules.html_block = function (tokens, idx /*, options, env */) {
  return tokens[idx].content;
};
default_rules.html_inline = function (tokens, idx /*, options, env */) {
  return tokens[idx].content;
};

/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/
function Renderer() {

  /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/
  this.rules = assign({}, default_rules);
}

/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/
Renderer.prototype.renderAttrs = function renderAttrs(token) {
  var i, l, result;

  if (!token.attrs) {
    return '';
  }

  result = '';

  for (i = 0, l = token.attrs.length; i < l; i++) {
    result += ' ' + escapeHtml(token.attrs[i][0]) + '="' + escapeHtml(token.attrs[i][1]) + '"';
  }

  return result;
};

/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/
Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
  var nextToken,
      result = '',
      needLf = false,
      token = tokens[idx];

  // Tight list paragraphs
  if (token.hidden) {
    return '';
  }

  // Insert a newline between hidden paragraph and subsequent opening
  // block-level tag.
  //
  // For example, here we should insert a newline before blockquote:
  //  - a
  //    >
  //
  if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) {
    result += '\n';
  }

  // Add token name, e.g. `<img`
  result += (token.nesting === -1 ? '</' : '<') + token.tag;

  // Encode attributes, e.g. `<img src="foo"`
  result += this.renderAttrs(token);

  // Add a slash for self-closing tags, e.g. `<img src="foo" /`
  if (token.nesting === 0 && options.xhtmlOut) {
    result += ' /';
  }

  // Check if we need to add a newline after this tag
  if (token.block) {
    needLf = true;

    if (token.nesting === 1) {
      if (idx + 1 < tokens.length) {
        nextToken = tokens[idx + 1];

        if (nextToken.type === 'inline' || nextToken.hidden) {
          // Block-level tag containing an inline tag.
          //
          needLf = false;
        } else if (nextToken.nesting === -1 && nextToken.tag === token.tag) {
          // Opening tag + closing tag of the same type. E.g. `<li></li>`.
          //
          needLf = false;
        }
      }
    }
  }

  result += needLf ? '>\n' : '>';

  return result;
};

/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to renter
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/
Renderer.prototype.renderInline = function (tokens, options, env) {
  var type,
      result = '',
      rules = this.rules;

  for (var i = 0, len = tokens.length; i < len; i++) {
    type = tokens[i].type;

    if (typeof rules[type] !== 'undefined') {
      result += rules[type](tokens, i, options, env, this);
    } else {
      result += this.renderToken(tokens, i, options);
    }
  }

  return result;
};

/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to renter
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/
Renderer.prototype.renderInlineAsText = function (tokens, options, env) {
  var result = '';

  for (var i = 0, len = tokens.length; i < len; i++) {
    if (tokens[i].type === 'text') {
      result += tokens[i].content;
    } else if (tokens[i].type === 'image') {
      result += this.renderInlineAsText(tokens[i].children, options, env);
    }
  }

  return result;
};

/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to renter
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/
Renderer.prototype.render = function (tokens, options, env) {
  var i,
      len,
      type,
      result = '',
      rules = this.rules;

  for (i = 0, len = tokens.length; i < len; i++) {
    type = tokens[i].type;

    if (type === 'inline') {
      result += this.renderInline(tokens[i].children, options, env);
    } else if (typeof rules[type] !== 'undefined') {
      result += rules[tokens[i].type](tokens, i, options, env, this);
    } else {
      result += this.renderToken(tokens, i, options, env);
    }
  }

  return result;
};

module.exports = Renderer;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/


var Ruler = __webpack_require__(114);

var _rules = [['normalize', __webpack_require__(718)], ['block', __webpack_require__(719)], ['inline', __webpack_require__(720)], ['linkify', __webpack_require__(721)], ['replacements', __webpack_require__(722)], ['smartquotes', __webpack_require__(723)]];

/**
 * new Core()
 **/
function Core() {
  /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/
  this.ruler = new Ruler();

  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }
}

/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/
Core.prototype.process = function (state) {
  var i, l, rules;

  rules = this.ruler.getRules('');

  for (i = 0, l = rules.length; i < l; i++) {
    rules[i](state);
  }
};

Core.prototype.State = __webpack_require__(724);

module.exports = Core;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Normalize input string



var NEWLINES_RE = /\r[\n\u0085]?|[\u2424\u2028\u0085]/g;
var NULL_RE = /\u0000/g;

module.exports = function inline(state) {
  var str;

  // Normalize newlines
  str = state.src.replace(NEWLINES_RE, '\n');

  // Replace NULL characters
  str = str.replace(NULL_RE, '\uFFFD');

  state.src = str;
};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function block(state) {
  var token;

  if (state.inlineMode) {
    token = new state.Token('inline', '', 0);
    token.content = state.src;
    token.map = [0, 1];
    token.children = [];
    state.tokens.push(token);
  } else {
    state.md.block.parse(state.src, state.md, state.env, state.tokens);
  }
};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function inline(state) {
  var tokens = state.tokens,
      tok,
      i,
      l;

  // Parse inlines
  for (i = 0, l = tokens.length; i < l; i++) {
    tok = tokens[i];
    if (tok.type === 'inline') {
      state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
  }
};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//


var arrayReplaceAt = __webpack_require__(9).arrayReplaceAt;

function isLinkOpen(str) {
  return (/^<a[>\s]/i.test(str)
  );
}
function isLinkClose(str) {
  return (/^<\/a\s*>/i.test(str)
  );
}

module.exports = function linkify(state) {
  var i,
      j,
      l,
      tokens,
      token,
      currentToken,
      nodes,
      ln,
      text,
      pos,
      lastPos,
      level,
      htmlLinkLevel,
      url,
      fullUrl,
      urlText,
      blockTokens = state.tokens,
      links;

  if (!state.md.options.linkify) {
    return;
  }

  for (j = 0, l = blockTokens.length; j < l; j++) {
    if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) {
      continue;
    }

    tokens = blockTokens[j].children;

    htmlLinkLevel = 0;

    // We scan from the end, to keep position when new tags added.
    // Use reversed logic in links start/end match
    for (i = tokens.length - 1; i >= 0; i--) {
      currentToken = tokens[i];

      // Skip content of markdown links
      if (currentToken.type === 'link_close') {
        i--;
        while (tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open') {
          i--;
        }
        continue;
      }

      // Skip content of html tag links
      if (currentToken.type === 'html_inline') {
        if (isLinkOpen(currentToken.content) && htmlLinkLevel > 0) {
          htmlLinkLevel--;
        }
        if (isLinkClose(currentToken.content)) {
          htmlLinkLevel++;
        }
      }
      if (htmlLinkLevel > 0) {
        continue;
      }

      if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {

        text = currentToken.content;
        links = state.md.linkify.match(text);

        // Now split string to nodes
        nodes = [];
        level = currentToken.level;
        lastPos = 0;

        for (ln = 0; ln < links.length; ln++) {

          url = links[ln].url;
          fullUrl = state.md.normalizeLink(url);
          if (!state.md.validateLink(fullUrl)) {
            continue;
          }

          urlText = links[ln].text;

          // Linkifier might send raw hostnames like "example.com", where url
          // starts with domain name. So we prepend http:// in those cases,
          // and remove it afterwards.
          //
          if (!links[ln].schema) {
            urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
          } else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) {
            urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
          } else {
            urlText = state.md.normalizeLinkText(urlText);
          }

          pos = links[ln].index;

          if (pos > lastPos) {
            token = new state.Token('text', '', 0);
            token.content = text.slice(lastPos, pos);
            token.level = level;
            nodes.push(token);
          }

          token = new state.Token('link_open', 'a', 1);
          token.attrs = [['href', fullUrl]];
          token.level = level++;
          token.markup = 'linkify';
          token.info = 'auto';
          nodes.push(token);

          token = new state.Token('text', '', 0);
          token.content = urlText;
          token.level = level;
          nodes.push(token);

          token = new state.Token('link_close', 'a', -1);
          token.level = --level;
          token.markup = 'linkify';
          token.info = 'auto';
          nodes.push(token);

          lastPos = links[ln].lastIndex;
        }
        if (lastPos < text.length) {
          token = new state.Token('text', '', 0);
          token.content = text.slice(lastPos);
          token.level = level;
          nodes.push(token);
        }

        // replace current node
        blockTokens[j].children = tokens = arrayReplaceAt(tokens, i, nodes);
      }
    }
  }
};

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Simple typographyc replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// (p) (P) -> §
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//


// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - miltiplication 2 x 4 -> 2 × 4

var RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;

// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var SCOPED_ABBR_TEST_RE = /\((c|tm|r|p)\)/i;

var SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
var SCOPED_ABBR = {
  c: '©',
  r: '®',
  p: '§',
  tm: '™'
};

function replaceFn(match, name) {
  return SCOPED_ABBR[name.toLowerCase()];
}

function replace_scoped(inlineTokens) {
  var i,
      token,
      inside_autolink = 0;

  for (i = inlineTokens.length - 1; i >= 0; i--) {
    token = inlineTokens[i];

    if (token.type === 'text' && !inside_autolink) {
      token.content = token.content.replace(SCOPED_ABBR_RE, replaceFn);
    }

    if (token.type === 'link_open' && token.info === 'auto') {
      inside_autolink--;
    }

    if (token.type === 'link_close' && token.info === 'auto') {
      inside_autolink++;
    }
  }
}

function replace_rare(inlineTokens) {
  var i,
      token,
      inside_autolink = 0;

  for (i = inlineTokens.length - 1; i >= 0; i--) {
    token = inlineTokens[i];

    if (token.type === 'text' && !inside_autolink) {
      if (RARE_RE.test(token.content)) {
        token.content = token.content.replace(/\+-/g, '±')
        // .., ..., ....... -> …
        // but ?..... & !..... -> ?.. & !..
        .replace(/\.{2,}/g, '…').replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')
        // em-dash
        .replace(/(^|[^-])---([^-]|$)/mg, '$1\u2014$2')
        // en-dash
        .replace(/(^|\s)--(\s|$)/mg, '$1\u2013$2').replace(/(^|[^-\s])--([^-\s]|$)/mg, '$1\u2013$2');
      }
    }

    if (token.type === 'link_open' && token.info === 'auto') {
      inside_autolink--;
    }

    if (token.type === 'link_close' && token.info === 'auto') {
      inside_autolink++;
    }
  }
}

module.exports = function replace(state) {
  var blkIdx;

  if (!state.md.options.typographer) {
    return;
  }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline') {
      continue;
    }

    if (SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) {
      replace_scoped(state.tokens[blkIdx].children);
    }

    if (RARE_RE.test(state.tokens[blkIdx].content)) {
      replace_rare(state.tokens[blkIdx].children);
    }
  }
};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Convert straight quotation marks to typographic ones
//


var isWhiteSpace = __webpack_require__(9).isWhiteSpace;
var isPunctChar = __webpack_require__(9).isPunctChar;
var isMdAsciiPunct = __webpack_require__(9).isMdAsciiPunct;

var QUOTE_TEST_RE = /['"]/;
var QUOTE_RE = /['"]/g;
var APOSTROPHE = '\u2019'; /* ’ */

function replaceAt(str, index, ch) {
  return str.substr(0, index) + ch + str.substr(index + 1);
}

function process_inlines(tokens, state) {
  var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;

  stack = [];

  for (i = 0; i < tokens.length; i++) {
    token = tokens[i];

    thisLevel = tokens[i].level;

    for (j = stack.length - 1; j >= 0; j--) {
      if (stack[j].level <= thisLevel) {
        break;
      }
    }
    stack.length = j + 1;

    if (token.type !== 'text') {
      continue;
    }

    text = token.content;
    pos = 0;
    max = text.length;

    /*eslint no-labels:0,block-scoped-var:0*/
    OUTER: while (pos < max) {
      QUOTE_RE.lastIndex = pos;
      t = QUOTE_RE.exec(text);
      if (!t) {
        break;
      }

      canOpen = canClose = true;
      pos = t.index + 1;
      isSingle = t[0] === "'";

      // Find previous character,
      // default to space if it's the beginning of the line
      //
      lastChar = 0x20;

      if (t.index - 1 >= 0) {
        lastChar = text.charCodeAt(t.index - 1);
      } else {
        for (j = i - 1; j >= 0; j--) {
          if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
          if (tokens[j].type !== 'text') continue;

          lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
          break;
        }
      }

      // Find next character,
      // default to space if it's the end of the line
      //
      nextChar = 0x20;

      if (pos < max) {
        nextChar = text.charCodeAt(pos);
      } else {
        for (j = i + 1; j < tokens.length; j++) {
          if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
          if (tokens[j].type !== 'text') continue;

          nextChar = tokens[j].content.charCodeAt(0);
          break;
        }
      }

      isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
      isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));

      isLastWhiteSpace = isWhiteSpace(lastChar);
      isNextWhiteSpace = isWhiteSpace(nextChar);

      if (isNextWhiteSpace) {
        canOpen = false;
      } else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) {
          canOpen = false;
        }
      }

      if (isLastWhiteSpace) {
        canClose = false;
      } else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) {
          canClose = false;
        }
      }

      if (nextChar === 0x22 /* " */ && t[0] === '"') {
        if (lastChar >= 0x30 /* 0 */ && lastChar <= 0x39 /* 9 */) {
            // special case: 1"" - count first quote as an inch
            canClose = canOpen = false;
          }
      }

      if (canOpen && canClose) {
        // treat this as the middle of the word
        canOpen = false;
        canClose = isNextPunctChar;
      }

      if (!canOpen && !canClose) {
        // middle of word
        if (isSingle) {
          token.content = replaceAt(token.content, t.index, APOSTROPHE);
        }
        continue;
      }

      if (canClose) {
        // this could be a closing quote, rewind the stack to get a match
        for (j = stack.length - 1; j >= 0; j--) {
          item = stack[j];
          if (stack[j].level < thisLevel) {
            break;
          }
          if (item.single === isSingle && stack[j].level === thisLevel) {
            item = stack[j];

            if (isSingle) {
              openQuote = state.md.options.quotes[2];
              closeQuote = state.md.options.quotes[3];
            } else {
              openQuote = state.md.options.quotes[0];
              closeQuote = state.md.options.quotes[1];
            }

            // replace token.content *before* tokens[item.token].content,
            // because, if they are pointing at the same token, replaceAt
            // could mess up indices when quote length != 1
            token.content = replaceAt(token.content, t.index, closeQuote);
            tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, openQuote);

            pos += closeQuote.length - 1;
            if (item.token === i) {
              pos += openQuote.length - 1;
            }

            text = token.content;
            max = text.length;

            stack.length = j;
            continue OUTER;
          }
        }
      }

      if (canOpen) {
        stack.push({
          token: i,
          pos: t.index,
          single: isSingle,
          level: thisLevel
        });
      } else if (canClose && isSingle) {
        token.content = replaceAt(token.content, t.index, APOSTROPHE);
      }
    }
  }
}

module.exports = function smartquotes(state) {
  /*eslint max-depth:0*/
  var blkIdx;

  if (!state.md.options.typographer) {
    return;
  }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline' || !QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) {
      continue;
    }

    process_inlines(state.tokens[blkIdx].children, state);
  }
};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Core state object
//


var Token = __webpack_require__(115);

function StateCore(src, md, env) {
  this.src = src;
  this.env = env;
  this.tokens = [];
  this.inlineMode = false;
  this.md = md; // link to parser instance
}

// re-export Token class to use in core rules
StateCore.prototype.Token = Token;

module.exports = StateCore;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/


var Ruler = __webpack_require__(114);

var _rules = [
// First 2 params - rule name & source. Secondary array - list of rules,
// which can be terminated by this one.
['table', __webpack_require__(726), ['paragraph', 'reference']], ['code', __webpack_require__(727)], ['fence', __webpack_require__(728), ['paragraph', 'reference', 'blockquote', 'list']], ['blockquote', __webpack_require__(729), ['paragraph', 'reference', 'blockquote', 'list']], ['hr', __webpack_require__(730), ['paragraph', 'reference', 'blockquote', 'list']], ['list', __webpack_require__(731), ['paragraph', 'reference', 'blockquote']], ['reference', __webpack_require__(732)], ['heading', __webpack_require__(733), ['paragraph', 'reference', 'blockquote']], ['lheading', __webpack_require__(734)], ['html_block', __webpack_require__(735), ['paragraph', 'reference', 'blockquote']], ['paragraph', __webpack_require__(737)]];

/**
 * new ParserBlock()
 **/
function ParserBlock() {
  /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/
  this.ruler = new Ruler();

  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1], { alt: (_rules[i][2] || []).slice() });
  }
}

// Generate tokens for input range
//
ParserBlock.prototype.tokenize = function (state, startLine, endLine) {
  var ok,
      i,
      rules = this.ruler.getRules(''),
      len = rules.length,
      line = startLine,
      hasEmptyLines = false,
      maxNesting = state.md.options.maxNesting;

  while (line < endLine) {
    state.line = line = state.skipEmptyLines(line);
    if (line >= endLine) {
      break;
    }

    // Termination condition for nested calls.
    // Nested calls currently used for blockquotes & lists
    if (state.sCount[line] < state.blkIndent) {
      break;
    }

    // If nesting level exceeded - skip tail to the end. That's not ordinary
    // situation and we should not care about content.
    if (state.level >= maxNesting) {
      state.line = endLine;
      break;
    }

    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.line`
    // - update `state.tokens`
    // - return true

    for (i = 0; i < len; i++) {
      ok = rules[i](state, line, endLine, false);
      if (ok) {
        break;
      }
    }

    // set state.tight if we had an empty line before current tag
    // i.e. latest empty line should not count
    state.tight = !hasEmptyLines;

    // paragraph might "eat" one newline after it in nested lists
    if (state.isEmpty(state.line - 1)) {
      hasEmptyLines = true;
    }

    line = state.line;

    if (line < endLine && state.isEmpty(line)) {
      hasEmptyLines = true;
      line++;
      state.line = line;
    }
  }
};

/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/
ParserBlock.prototype.parse = function (src, md, env, outTokens) {
  var state;

  if (!src) {
    return;
  }

  state = new this.State(src, md, env, outTokens);

  this.tokenize(state, state.line, state.lineMax);
};

ParserBlock.prototype.State = __webpack_require__(738);

module.exports = ParserBlock;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GFM table, non-standard



var isSpace = __webpack_require__(9).isSpace;

function getLine(state, line) {
  var pos = state.bMarks[line] + state.blkIndent,
      max = state.eMarks[line];

  return state.src.substr(pos, max - pos);
}

function escapedSplit(str) {
  var result = [],
      pos = 0,
      max = str.length,
      ch,
      escapes = 0,
      lastPos = 0,
      backTicked = false,
      lastBackTick = 0;

  ch = str.charCodeAt(pos);

  while (pos < max) {
    if (ch === 0x60 /* ` */) {
        if (backTicked) {
          // make \` close code sequence, but not open it;
          // the reason is: `\` is correct code block
          backTicked = false;
          lastBackTick = pos;
        } else if (escapes % 2 === 0) {
          backTicked = true;
          lastBackTick = pos;
        }
      } else if (ch === 0x7c /* | */ && escapes % 2 === 0 && !backTicked) {
      result.push(str.substring(lastPos, pos));
      lastPos = pos + 1;
    }

    if (ch === 0x5c /* \ */) {
        escapes++;
      } else {
      escapes = 0;
    }

    pos++;

    // If there was an un-closed backtick, go back to just after
    // the last backtick, but as if it was a normal character
    if (pos === max && backTicked) {
      backTicked = false;
      pos = lastBackTick + 1;
    }

    ch = str.charCodeAt(pos);
  }

  result.push(str.substring(lastPos));

  return result;
}

module.exports = function table(state, startLine, endLine, silent) {
  var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;

  // should have at least two lines
  if (startLine + 2 > endLine) {
    return false;
  }

  nextLine = startLine + 1;

  if (state.sCount[nextLine] < state.blkIndent) {
    return false;
  }

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[nextLine] - state.blkIndent >= 4) {
    return false;
  }

  // first character of the second line should be '|', '-', ':',
  // and no other characters are allowed but spaces;
  // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp

  pos = state.bMarks[nextLine] + state.tShift[nextLine];
  if (pos >= state.eMarks[nextLine]) {
    return false;
  }

  ch = state.src.charCodeAt(pos++);
  if (ch !== 0x7C /* | */ && ch !== 0x2D /* - */ && ch !== 0x3A /* : */) {
      return false;
    }

  while (pos < state.eMarks[nextLine]) {
    ch = state.src.charCodeAt(pos);

    if (ch !== 0x7C /* | */ && ch !== 0x2D /* - */ && ch !== 0x3A /* : */ && !isSpace(ch)) {
      return false;
    }

    pos++;
  }

  lineText = getLine(state, startLine + 1);

  columns = lineText.split('|');
  aligns = [];
  for (i = 0; i < columns.length; i++) {
    t = columns[i].trim();
    if (!t) {
      // allow empty columns before and after table, but not in between columns;
      // e.g. allow ` |---| `, disallow ` ---||--- `
      if (i === 0 || i === columns.length - 1) {
        continue;
      } else {
        return false;
      }
    }

    if (!/^:?-+:?$/.test(t)) {
      return false;
    }
    if (t.charCodeAt(t.length - 1) === 0x3A /* : */) {
        aligns.push(t.charCodeAt(0) === 0x3A /* : */ ? 'center' : 'right');
      } else if (t.charCodeAt(0) === 0x3A /* : */) {
        aligns.push('left');
      } else {
      aligns.push('');
    }
  }

  lineText = getLine(state, startLine).trim();
  if (lineText.indexOf('|') === -1) {
    return false;
  }
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }
  columns = escapedSplit(lineText.replace(/^\||\|$/g, ''));

  // header row will define an amount of columns in the entire table,
  // and align row shouldn't be smaller than that (the rest of the rows can)
  columnCount = columns.length;
  if (columnCount > aligns.length) {
    return false;
  }

  if (silent) {
    return true;
  }

  token = state.push('table_open', 'table', 1);
  token.map = tableLines = [startLine, 0];

  token = state.push('thead_open', 'thead', 1);
  token.map = [startLine, startLine + 1];

  token = state.push('tr_open', 'tr', 1);
  token.map = [startLine, startLine + 1];

  for (i = 0; i < columns.length; i++) {
    token = state.push('th_open', 'th', 1);
    token.map = [startLine, startLine + 1];
    if (aligns[i]) {
      token.attrs = [['style', 'text-align:' + aligns[i]]];
    }

    token = state.push('inline', '', 0);
    token.content = columns[i].trim();
    token.map = [startLine, startLine + 1];
    token.children = [];

    token = state.push('th_close', 'th', -1);
  }

  token = state.push('tr_close', 'tr', -1);
  token = state.push('thead_close', 'thead', -1);

  token = state.push('tbody_open', 'tbody', 1);
  token.map = tbodyLines = [startLine + 2, 0];

  for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
    if (state.sCount[nextLine] < state.blkIndent) {
      break;
    }

    lineText = getLine(state, nextLine).trim();
    if (lineText.indexOf('|') === -1) {
      break;
    }
    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      break;
    }
    columns = escapedSplit(lineText.replace(/^\||\|$/g, ''));

    token = state.push('tr_open', 'tr', 1);
    for (i = 0; i < columnCount; i++) {
      token = state.push('td_open', 'td', 1);
      if (aligns[i]) {
        token.attrs = [['style', 'text-align:' + aligns[i]]];
      }

      token = state.push('inline', '', 0);
      token.content = columns[i] ? columns[i].trim() : '';
      token.children = [];

      token = state.push('td_close', 'td', -1);
    }
    token = state.push('tr_close', 'tr', -1);
  }
  token = state.push('tbody_close', 'tbody', -1);
  token = state.push('table_close', 'table', -1);

  tableLines[1] = tbodyLines[1] = nextLine;
  state.line = nextLine;
  return true;
};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Code block (4 spaces padded)



module.exports = function code(state, startLine, endLine /*, silent*/) {
  var nextLine, last, token;

  if (state.sCount[startLine] - state.blkIndent < 4) {
    return false;
  }

  last = nextLine = startLine + 1;

  while (nextLine < endLine) {
    if (state.isEmpty(nextLine)) {
      nextLine++;
      continue;
    }

    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      nextLine++;
      last = nextLine;
      continue;
    }
    break;
  }

  state.line = last;

  token = state.push('code_block', 'code', 0);
  token.content = state.getLines(startLine, last, 4 + state.blkIndent, true);
  token.map = [startLine, state.line];

  return true;
};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// fences (``` lang, ~~~ lang)



module.exports = function fence(state, startLine, endLine, silent) {
  var marker,
      len,
      params,
      nextLine,
      mem,
      token,
      markup,
      haveEndMarker = false,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }

  if (pos + 3 > max) {
    return false;
  }

  marker = state.src.charCodeAt(pos);

  if (marker !== 0x7E /* ~ */ && marker !== 0x60 /* ` */) {
      return false;
    }

  // scan marker length
  mem = pos;
  pos = state.skipChars(pos, marker);

  len = pos - mem;

  if (len < 3) {
    return false;
  }

  markup = state.src.slice(mem, pos);
  params = state.src.slice(pos, max);

  if (params.indexOf(String.fromCharCode(marker)) >= 0) {
    return false;
  }

  // Since start is found, we can report success here in validation mode
  if (silent) {
    return true;
  }

  // search end of block
  nextLine = startLine;

  for (;;) {
    nextLine++;
    if (nextLine >= endLine) {
      // unclosed block should be autoclosed by end of document.
      // also block seems to be autoclosed by end of parent
      break;
    }

    pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos < max && state.sCount[nextLine] < state.blkIndent) {
      // non-empty line with negative indent should stop the list:
      // - ```
      //  test
      break;
    }

    if (state.src.charCodeAt(pos) !== marker) {
      continue;
    }

    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      // closing fence should be indented less than 4 spaces
      continue;
    }

    pos = state.skipChars(pos, marker);

    // closing code fence must be at least as long as the opening one
    if (pos - mem < len) {
      continue;
    }

    // make sure tail has spaces only
    pos = state.skipSpaces(pos);

    if (pos < max) {
      continue;
    }

    haveEndMarker = true;
    // found!
    break;
  }

  // If a fence has heading spaces, they should be removed from its inner block
  len = state.sCount[startLine];

  state.line = nextLine + (haveEndMarker ? 1 : 0);

  token = state.push('fence', 'code', 0);
  token.info = params;
  token.content = state.getLines(startLine + 1, nextLine, len, true);
  token.markup = markup;
  token.map = [startLine, state.line];

  return true;
};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Block quotes



var isSpace = __webpack_require__(9).isSpace;

module.exports = function blockquote(state, startLine, endLine, silent) {
  var adjustTab,
      ch,
      i,
      initial,
      l,
      lastLineEmpty,
      lines,
      nextLine,
      offset,
      oldBMarks,
      oldBSCount,
      oldIndent,
      oldParentType,
      oldSCount,
      oldTShift,
      spaceAfterMarker,
      terminate,
      terminatorRules,
      token,
      wasOutdented,
      oldLineMax = state.lineMax,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }

  // check the block quote marker
  if (state.src.charCodeAt(pos++) !== 0x3E /* > */) {
      return false;
    }

  // we know that it's going to be a valid blockquote,
  // so no point trying to find the end of it in silent mode
  if (silent) {
    return true;
  }

  // skip spaces after ">" and re-calculate offset
  initial = offset = state.sCount[startLine] + pos - (state.bMarks[startLine] + state.tShift[startLine]);

  // skip one optional space after '>'
  if (state.src.charCodeAt(pos) === 0x20 /* space */) {
      // ' >   test '
      //     ^ -- position start of line here:
      pos++;
      initial++;
      offset++;
      adjustTab = false;
      spaceAfterMarker = true;
    } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
      spaceAfterMarker = true;

      if ((state.bsCount[startLine] + offset) % 4 === 3) {
        // '  >\t  test '
        //       ^ -- position start of line here (tab has width===1)
        pos++;
        initial++;
        offset++;
        adjustTab = false;
      } else {
        // ' >\t  test '
        //    ^ -- position start of line here + shift bsCount slightly
        //         to make extra space appear
        adjustTab = true;
      }
    } else {
    spaceAfterMarker = false;
  }

  oldBMarks = [state.bMarks[startLine]];
  state.bMarks[startLine] = pos;

  while (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (isSpace(ch)) {
      if (ch === 0x09) {
        offset += 4 - (offset + state.bsCount[startLine] + (adjustTab ? 1 : 0)) % 4;
      } else {
        offset++;
      }
    } else {
      break;
    }

    pos++;
  }

  oldBSCount = [state.bsCount[startLine]];
  state.bsCount[startLine] = state.sCount[startLine] + 1 + (spaceAfterMarker ? 1 : 0);

  lastLineEmpty = pos >= max;

  oldSCount = [state.sCount[startLine]];
  state.sCount[startLine] = offset - initial;

  oldTShift = [state.tShift[startLine]];
  state.tShift[startLine] = pos - state.bMarks[startLine];

  terminatorRules = state.md.block.ruler.getRules('blockquote');

  oldParentType = state.parentType;
  state.parentType = 'blockquote';
  wasOutdented = false;

  // Search the end of the block
  //
  // Block ends with either:
  //  1. an empty line outside:
  //     ```
  //     > test
  //
  //     ```
  //  2. an empty line inside:
  //     ```
  //     >
  //     test
  //     ```
  //  3. another tag:
  //     ```
  //     > test
  //      - - -
  //     ```
  for (nextLine = startLine + 1; nextLine < endLine; nextLine++) {
    // check if it's outdented, i.e. it's inside list item and indented
    // less than said list item:
    //
    // ```
    // 1. anything
    //    > current blockquote
    // 2. checking this line
    // ```
    if (state.sCount[nextLine] < state.blkIndent) wasOutdented = true;

    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos >= max) {
      // Case 1: line is not inside the blockquote, and this line is empty.
      break;
    }

    if (state.src.charCodeAt(pos++) === 0x3E /* > */ && !wasOutdented) {
      // This line is inside the blockquote.

      // skip spaces after ">" and re-calculate offset
      initial = offset = state.sCount[nextLine] + pos - (state.bMarks[nextLine] + state.tShift[nextLine]);

      // skip one optional space after '>'
      if (state.src.charCodeAt(pos) === 0x20 /* space */) {
          // ' >   test '
          //     ^ -- position start of line here:
          pos++;
          initial++;
          offset++;
          adjustTab = false;
          spaceAfterMarker = true;
        } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
          spaceAfterMarker = true;

          if ((state.bsCount[nextLine] + offset) % 4 === 3) {
            // '  >\t  test '
            //       ^ -- position start of line here (tab has width===1)
            pos++;
            initial++;
            offset++;
            adjustTab = false;
          } else {
            // ' >\t  test '
            //    ^ -- position start of line here + shift bsCount slightly
            //         to make extra space appear
            adjustTab = true;
          }
        } else {
        spaceAfterMarker = false;
      }

      oldBMarks.push(state.bMarks[nextLine]);
      state.bMarks[nextLine] = pos;

      while (pos < max) {
        ch = state.src.charCodeAt(pos);

        if (isSpace(ch)) {
          if (ch === 0x09) {
            offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
          } else {
            offset++;
          }
        } else {
          break;
        }

        pos++;
      }

      lastLineEmpty = pos >= max;

      oldBSCount.push(state.bsCount[nextLine]);
      state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);

      oldSCount.push(state.sCount[nextLine]);
      state.sCount[nextLine] = offset - initial;

      oldTShift.push(state.tShift[nextLine]);
      state.tShift[nextLine] = pos - state.bMarks[nextLine];
      continue;
    }

    // Case 2: line is not inside the blockquote, and the last line was empty.
    if (lastLineEmpty) {
      break;
    }

    // Case 3: another tag found.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }

    if (terminate) {
      // Quirk to enforce "hard termination mode" for paragraphs;
      // normally if you call `tokenize(state, startLine, nextLine)`,
      // paragraphs will look below nextLine for paragraph continuation,
      // but if blockquote is terminated by another tag, they shouldn't
      state.lineMax = nextLine;

      if (state.blkIndent !== 0) {
        // state.blkIndent was non-zero, we now set it to zero,
        // so we need to re-calculate all offsets to appear as
        // if indent wasn't changed
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        state.sCount[nextLine] -= state.blkIndent;
      }

      break;
    }

    oldBMarks.push(state.bMarks[nextLine]);
    oldBSCount.push(state.bsCount[nextLine]);
    oldTShift.push(state.tShift[nextLine]);
    oldSCount.push(state.sCount[nextLine]);

    // A negative indentation means that this is a paragraph continuation
    //
    state.sCount[nextLine] = -1;
  }

  oldIndent = state.blkIndent;
  state.blkIndent = 0;

  token = state.push('blockquote_open', 'blockquote', 1);
  token.markup = '>';
  token.map = lines = [startLine, 0];

  state.md.block.tokenize(state, startLine, nextLine);

  token = state.push('blockquote_close', 'blockquote', -1);
  token.markup = '>';

  state.lineMax = oldLineMax;
  state.parentType = oldParentType;
  lines[1] = state.line;

  // Restore original tShift; this might not be necessary since the parser
  // has already been here, but just to make sure we can do that.
  for (i = 0; i < oldTShift.length; i++) {
    state.bMarks[i + startLine] = oldBMarks[i];
    state.tShift[i + startLine] = oldTShift[i];
    state.sCount[i + startLine] = oldSCount[i];
    state.bsCount[i + startLine] = oldBSCount[i];
  }
  state.blkIndent = oldIndent;

  return true;
};

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Horizontal rule



var isSpace = __webpack_require__(9).isSpace;

module.exports = function hr(state, startLine, endLine, silent) {
  var marker,
      cnt,
      ch,
      token,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }

  marker = state.src.charCodeAt(pos++);

  // Check hr marker
  if (marker !== 0x2A /* * */ && marker !== 0x2D /* - */ && marker !== 0x5F /* _ */) {
      return false;
    }

  // markers can be mixed with spaces, but there should be at least 3 of them

  cnt = 1;
  while (pos < max) {
    ch = state.src.charCodeAt(pos++);
    if (ch !== marker && !isSpace(ch)) {
      return false;
    }
    if (ch === marker) {
      cnt++;
    }
  }

  if (cnt < 3) {
    return false;
  }

  if (silent) {
    return true;
  }

  state.line = startLine + 1;

  token = state.push('hr', 'hr', 0);
  token.map = [startLine, state.line];
  token.markup = Array(cnt + 1).join(String.fromCharCode(marker));

  return true;
};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Lists



var isSpace = __webpack_require__(9).isSpace;

// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipBulletListMarker(state, startLine) {
  var marker, pos, max, ch;

  pos = state.bMarks[startLine] + state.tShift[startLine];
  max = state.eMarks[startLine];

  marker = state.src.charCodeAt(pos++);
  // Check bullet
  if (marker !== 0x2A /* * */ && marker !== 0x2D /* - */ && marker !== 0x2B /* + */) {
      return -1;
    }

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (!isSpace(ch)) {
      // " -test " - is not a list item
      return -1;
    }
  }

  return pos;
}

// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipOrderedListMarker(state, startLine) {
  var ch,
      start = state.bMarks[startLine] + state.tShift[startLine],
      pos = start,
      max = state.eMarks[startLine];

  // List marker should have at least 2 chars (digit + dot)
  if (pos + 1 >= max) {
    return -1;
  }

  ch = state.src.charCodeAt(pos++);

  if (ch < 0x30 /* 0 */ || ch > 0x39 /* 9 */) {
      return -1;
    }

  for (;;) {
    // EOL -> fail
    if (pos >= max) {
      return -1;
    }

    ch = state.src.charCodeAt(pos++);

    if (ch >= 0x30 /* 0 */ && ch <= 0x39 /* 9 */) {

        // List marker should have no more than 9 digits
        // (prevents integer overflow in browsers)
        if (pos - start >= 10) {
          return -1;
        }

        continue;
      }

    // found valid marker
    if (ch === 0x29 /* ) */ || ch === 0x2e /* . */) {
        break;
      }

    return -1;
  }

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (!isSpace(ch)) {
      // " 1.test " - is not a list item
      return -1;
    }
  }
  return pos;
}

function markTightParagraphs(state, idx) {
  var i,
      l,
      level = state.level + 2;

  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
      state.tokens[i + 2].hidden = true;
      state.tokens[i].hidden = true;
      i += 2;
    }
  }
}

module.exports = function list(state, startLine, endLine, silent) {
  var ch,
      contentStart,
      i,
      indent,
      indentAfterMarker,
      initial,
      isOrdered,
      itemLines,
      l,
      listLines,
      listTokIdx,
      markerCharCode,
      markerValue,
      max,
      nextLine,
      offset,
      oldIndent,
      oldLIndent,
      oldParentType,
      oldTShift,
      oldTight,
      pos,
      posAfterMarker,
      prevEmptyEnd,
      start,
      terminate,
      terminatorRules,
      token,
      isTerminatingParagraph = false,
      tight = true;

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }

  // limit conditions when list can interrupt
  // a paragraph (validation mode only)
  if (silent && state.parentType === 'paragraph') {
    // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    if (state.tShift[startLine] >= state.blkIndent) {
      isTerminatingParagraph = true;
    }
  }

  // Detect list type and position after marker
  if ((posAfterMarker = skipOrderedListMarker(state, startLine)) >= 0) {
    isOrdered = true;
    start = state.bMarks[startLine] + state.tShift[startLine];
    markerValue = Number(state.src.substr(start, posAfterMarker - start - 1));

    // If we're starting a new ordered list right after
    // a paragraph, it should start with 1.
    if (isTerminatingParagraph && markerValue !== 1) return false;
  } else if ((posAfterMarker = skipBulletListMarker(state, startLine)) >= 0) {
    isOrdered = false;
  } else {
    return false;
  }

  // If we're starting a new unordered list right after
  // a paragraph, first line should not be empty.
  if (isTerminatingParagraph) {
    if (state.skipSpaces(posAfterMarker) >= state.eMarks[startLine]) return false;
  }

  // We should terminate list on style change. Remember first one to compare.
  markerCharCode = state.src.charCodeAt(posAfterMarker - 1);

  // For validation mode we can terminate immediately
  if (silent) {
    return true;
  }

  // Start list
  listTokIdx = state.tokens.length;

  if (isOrdered) {
    token = state.push('ordered_list_open', 'ol', 1);
    if (markerValue !== 1) {
      token.attrs = [['start', markerValue]];
    }
  } else {
    token = state.push('bullet_list_open', 'ul', 1);
  }

  token.map = listLines = [startLine, 0];
  token.markup = String.fromCharCode(markerCharCode);

  //
  // Iterate list items
  //

  nextLine = startLine;
  prevEmptyEnd = false;
  terminatorRules = state.md.block.ruler.getRules('list');

  oldParentType = state.parentType;
  state.parentType = 'list';

  while (nextLine < endLine) {
    pos = posAfterMarker;
    max = state.eMarks[nextLine];

    initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[startLine] + state.tShift[startLine]);

    while (pos < max) {
      ch = state.src.charCodeAt(pos);

      if (ch === 0x09) {
        offset += 4 - (offset + state.bsCount[nextLine]) % 4;
      } else if (ch === 0x20) {
        offset++;
      } else {
        break;
      }

      pos++;
    }

    contentStart = pos;

    if (contentStart >= max) {
      // trimming space in "-    \n  3" case, indent is 1 here
      indentAfterMarker = 1;
    } else {
      indentAfterMarker = offset - initial;
    }

    // If we have more than 4 spaces, the indent is 1
    // (the rest is just indented code block)
    if (indentAfterMarker > 4) {
      indentAfterMarker = 1;
    }

    // "  -  test"
    //  ^^^^^ - calculating total length of this thing
    indent = initial + indentAfterMarker;

    // Run subparser & write tokens
    token = state.push('list_item_open', 'li', 1);
    token.markup = String.fromCharCode(markerCharCode);
    token.map = itemLines = [startLine, 0];

    oldIndent = state.blkIndent;
    oldTight = state.tight;
    oldTShift = state.tShift[startLine];
    oldLIndent = state.sCount[startLine];
    state.blkIndent = indent;
    state.tight = true;
    state.tShift[startLine] = contentStart - state.bMarks[startLine];
    state.sCount[startLine] = offset;

    if (contentStart >= max && state.isEmpty(startLine + 1)) {
      // workaround for this case
      // (list item is empty, list terminates before "foo"):
      // ~~~~~~~~
      //   -
      //
      //     foo
      // ~~~~~~~~
      state.line = Math.min(state.line + 2, endLine);
    } else {
      state.md.block.tokenize(state, startLine, endLine, true);
    }

    // If any of list item is tight, mark list as tight
    if (!state.tight || prevEmptyEnd) {
      tight = false;
    }
    // Item become loose if finish with empty line,
    // but we should filter last element, because it means list finish
    prevEmptyEnd = state.line - startLine > 1 && state.isEmpty(state.line - 1);

    state.blkIndent = oldIndent;
    state.tShift[startLine] = oldTShift;
    state.sCount[startLine] = oldLIndent;
    state.tight = oldTight;

    token = state.push('list_item_close', 'li', -1);
    token.markup = String.fromCharCode(markerCharCode);

    nextLine = startLine = state.line;
    itemLines[1] = nextLine;
    contentStart = state.bMarks[startLine];

    if (nextLine >= endLine) {
      break;
    }

    //
    // Try to check if list is terminated or continued.
    //
    if (state.sCount[nextLine] < state.blkIndent) {
      break;
    }

    // fail if terminating block found
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) {
      break;
    }

    // fail if list has another type
    if (isOrdered) {
      posAfterMarker = skipOrderedListMarker(state, nextLine);
      if (posAfterMarker < 0) {
        break;
      }
    } else {
      posAfterMarker = skipBulletListMarker(state, nextLine);
      if (posAfterMarker < 0) {
        break;
      }
    }

    if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) {
      break;
    }
  }

  // Finalize list
  if (isOrdered) {
    token = state.push('ordered_list_close', 'ol', -1);
  } else {
    token = state.push('bullet_list_close', 'ul', -1);
  }
  token.markup = String.fromCharCode(markerCharCode);

  listLines[1] = nextLine;
  state.line = nextLine;

  state.parentType = oldParentType;

  // mark paragraphs tight if needed
  if (tight) {
    markTightParagraphs(state, listTokIdx);
  }

  return true;
};

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var normalizeReference = __webpack_require__(9).normalizeReference;
var isSpace = __webpack_require__(9).isSpace;

module.exports = function reference(state, startLine, _endLine, silent) {
  var ch,
      destEndPos,
      destEndLineNo,
      endLine,
      href,
      i,
      l,
      label,
      labelEnd,
      oldParentType,
      res,
      start,
      str,
      terminate,
      terminatorRules,
      title,
      lines = 0,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine],
      nextLine = startLine + 1;

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }

  if (state.src.charCodeAt(pos) !== 0x5B /* [ */) {
      return false;
    }

  // Simple check to quickly interrupt scan on [link](url) at the start of line.
  // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
  while (++pos < max) {
    if (state.src.charCodeAt(pos) === 0x5D /* ] */ && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */) {
        if (pos + 1 === max) {
          return false;
        }
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */) {
            return false;
          }
        break;
      }
  }

  endLine = state.lineMax;

  // jump line-by-line until empty one or EOF
  terminatorRules = state.md.block.ruler.getRules('reference');

  oldParentType = state.parentType;
  state.parentType = 'reference';

  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) {
      continue;
    }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) {
      continue;
    }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) {
      break;
    }
  }

  str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
  max = str.length;

  for (pos = 1; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x5B /* [ */) {
        return false;
      } else if (ch === 0x5D /* ] */) {
        labelEnd = pos;
        break;
      } else if (ch === 0x0A /* \n */) {
        lines++;
      } else if (ch === 0x5C /* \ */) {
        pos++;
        if (pos < max && str.charCodeAt(pos) === 0x0A) {
          lines++;
        }
      }
  }

  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */) {
      return false;
    }

  // [label]:   destination   'title'
  //         ^^^ skip optional whitespace here
  for (pos = labelEnd + 2; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x0A) {
      lines++;
    } else if (isSpace(ch)) {
      /*eslint no-empty:0*/
    } else {
      break;
    }
  }

  // [label]:   destination   'title'
  //            ^^^^^^^^^^^ parse this
  res = state.md.helpers.parseLinkDestination(str, pos, max);
  if (!res.ok) {
    return false;
  }

  href = state.md.normalizeLink(res.str);
  if (!state.md.validateLink(href)) {
    return false;
  }

  pos = res.pos;
  lines += res.lines;

  // save cursor state, we could require to rollback later
  destEndPos = pos;
  destEndLineNo = lines;

  // [label]:   destination   'title'
  //                       ^^^ skipping those spaces
  start = pos;
  for (; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x0A) {
      lines++;
    } else if (isSpace(ch)) {
      /*eslint no-empty:0*/
    } else {
      break;
    }
  }

  // [label]:   destination   'title'
  //                          ^^^^^^^ parse this
  res = state.md.helpers.parseLinkTitle(str, pos, max);
  if (pos < max && start !== pos && res.ok) {
    title = res.str;
    pos = res.pos;
    lines += res.lines;
  } else {
    title = '';
    pos = destEndPos;
    lines = destEndLineNo;
  }

  // skip trailing spaces until the rest of the line
  while (pos < max) {
    ch = str.charCodeAt(pos);
    if (!isSpace(ch)) {
      break;
    }
    pos++;
  }

  if (pos < max && str.charCodeAt(pos) !== 0x0A) {
    if (title) {
      // garbage at the end of the line after title,
      // but it could still be a valid reference if we roll back
      title = '';
      pos = destEndPos;
      lines = destEndLineNo;
      while (pos < max) {
        ch = str.charCodeAt(pos);
        if (!isSpace(ch)) {
          break;
        }
        pos++;
      }
    }
  }

  if (pos < max && str.charCodeAt(pos) !== 0x0A) {
    // garbage at the end of the line
    return false;
  }

  label = normalizeReference(str.slice(1, labelEnd));
  if (!label) {
    // CommonMark 0.20 disallows empty labels
    return false;
  }

  // Reference can not terminate anything. This check is for safety only.
  /*istanbul ignore if*/
  if (silent) {
    return true;
  }

  if (typeof state.env.references === 'undefined') {
    state.env.references = {};
  }
  if (typeof state.env.references[label] === 'undefined') {
    state.env.references[label] = { title: title, href: href };
  }

  state.parentType = oldParentType;

  state.line = startLine + lines + 1;
  return true;
};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// heading (#, ##, ...)



var isSpace = __webpack_require__(9).isSpace;

module.exports = function heading(state, startLine, endLine, silent) {
  var ch,
      level,
      tmp,
      token,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }

  ch = state.src.charCodeAt(pos);

  if (ch !== 0x23 /* # */ || pos >= max) {
    return false;
  }

  // count heading level
  level = 1;
  ch = state.src.charCodeAt(++pos);
  while (ch === 0x23 /* # */ && pos < max && level <= 6) {
    level++;
    ch = state.src.charCodeAt(++pos);
  }

  if (level > 6 || pos < max && !isSpace(ch)) {
    return false;
  }

  if (silent) {
    return true;
  }

  // Let's cut tails like '    ###  ' from the end of string

  max = state.skipSpacesBack(max, pos);
  tmp = state.skipCharsBack(max, 0x23, pos); // #
  if (tmp > pos && isSpace(state.src.charCodeAt(tmp - 1))) {
    max = tmp;
  }

  state.line = startLine + 1;

  token = state.push('heading_open', 'h' + String(level), 1);
  token.markup = '########'.slice(0, level);
  token.map = [startLine, state.line];

  token = state.push('inline', '', 0);
  token.content = state.src.slice(pos, max).trim();
  token.map = [startLine, state.line];
  token.children = [];

  token = state.push('heading_close', 'h' + String(level), -1);
  token.markup = '########'.slice(0, level);

  return true;
};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// lheading (---, ===)



module.exports = function lheading(state, startLine, endLine /*, silent*/) {
  var content,
      terminate,
      i,
      l,
      token,
      pos,
      max,
      level,
      marker,
      nextLine = startLine + 1,
      oldParentType,
      terminatorRules = state.md.block.ruler.getRules('paragraph');

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }

  oldParentType = state.parentType;
  state.parentType = 'paragraph'; // use paragraph to match terminatorRules

  // jump line-by-line until empty one or EOF
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) {
      continue;
    }

    //
    // Check for underline in setext header
    //
    if (state.sCount[nextLine] >= state.blkIndent) {
      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];

      if (pos < max) {
        marker = state.src.charCodeAt(pos);

        if (marker === 0x2D /* - */ || marker === 0x3D /* = */) {
            pos = state.skipChars(pos, marker);
            pos = state.skipSpaces(pos);

            if (pos >= max) {
              level = marker === 0x3D /* = */ ? 1 : 2;
              break;
            }
          }
      }
    }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) {
      continue;
    }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) {
      break;
    }
  }

  if (!level) {
    // Didn't find valid underline
    return false;
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine + 1;

  token = state.push('heading_open', 'h' + String(level), 1);
  token.markup = String.fromCharCode(marker);
  token.map = [startLine, state.line];

  token = state.push('inline', '', 0);
  token.content = content;
  token.map = [startLine, state.line - 1];
  token.children = [];

  token = state.push('heading_close', 'h' + String(level), -1);
  token.markup = String.fromCharCode(marker);

  state.parentType = oldParentType;

  return true;
};

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// HTML block



var block_names = __webpack_require__(736);
var HTML_OPEN_CLOSE_TAG_RE = __webpack_require__(425).HTML_OPEN_CLOSE_TAG_RE;

// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var HTML_SEQUENCES = [[/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true], [/^<!--/, /-->/, true], [/^<\?/, /\?>/, true], [/^<![A-Z]/, />/, true], [/^<!\[CDATA\[/, /\]\]>/, true], [new RegExp('^</?(' + block_names.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true], [new RegExp(HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'), /^$/, false]];

module.exports = function html_block(state, startLine, endLine, silent) {
  var i,
      nextLine,
      token,
      lineText,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }

  if (!state.md.options.html) {
    return false;
  }

  if (state.src.charCodeAt(pos) !== 0x3C /* < */) {
      return false;
    }

  lineText = state.src.slice(pos, max);

  for (i = 0; i < HTML_SEQUENCES.length; i++) {
    if (HTML_SEQUENCES[i][0].test(lineText)) {
      break;
    }
  }

  if (i === HTML_SEQUENCES.length) {
    return false;
  }

  if (silent) {
    // true if this sequence can be a terminator, false otherwise
    return HTML_SEQUENCES[i][2];
  }

  nextLine = startLine + 1;

  // If we are here - we detected HTML block.
  // Let's roll down till block end.
  if (!HTML_SEQUENCES[i][1].test(lineText)) {
    for (; nextLine < endLine; nextLine++) {
      if (state.sCount[nextLine] < state.blkIndent) {
        break;
      }

      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];
      lineText = state.src.slice(pos, max);

      if (HTML_SEQUENCES[i][1].test(lineText)) {
        if (lineText.length !== 0) {
          nextLine++;
        }
        break;
      }
    }
  }

  state.line = nextLine;

  token = state.push('html_block', '', 0);
  token.map = [startLine, nextLine];
  token.content = state.getLines(startLine, nextLine, state.blkIndent, true);

  return true;
};

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks



module.exports = ['address', 'article', 'aside', 'base', 'basefont', 'blockquote', 'body', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dialog', 'dir', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hr', 'html', 'iframe', 'legend', 'li', 'link', 'main', 'menu', 'menuitem', 'meta', 'nav', 'noframes', 'ol', 'optgroup', 'option', 'p', 'param', 'section', 'source', 'summary', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul'];

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Paragraph



module.exports = function paragraph(state, startLine /*, endLine*/) {
  var content,
      terminate,
      i,
      l,
      token,
      oldParentType,
      nextLine = startLine + 1,
      terminatorRules = state.md.block.ruler.getRules('paragraph'),
      endLine = state.lineMax;

  oldParentType = state.parentType;
  state.parentType = 'paragraph';

  // jump line-by-line until empty one or EOF
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) {
      continue;
    }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) {
      continue;
    }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) {
      break;
    }
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine;

  token = state.push('paragraph_open', 'p', 1);
  token.map = [startLine, state.line];

  token = state.push('inline', '', 0);
  token.content = content;
  token.map = [startLine, state.line];
  token.children = [];

  token = state.push('paragraph_close', 'p', -1);

  state.parentType = oldParentType;

  return true;
};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parser state class



var Token = __webpack_require__(115);
var isSpace = __webpack_require__(9).isSpace;

function StateBlock(src, md, env, tokens) {
  var ch, s, start, pos, len, indent, offset, indent_found;

  this.src = src;

  // link to parser instance
  this.md = md;

  this.env = env;

  //
  // Internal state vartiables
  //

  this.tokens = tokens;

  this.bMarks = []; // line begin offsets for fast jumps
  this.eMarks = []; // line end offsets for fast jumps
  this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
  this.sCount = []; // indents for each line (tabs expanded)

  // An amount of virtual spaces (tabs expanded) between beginning
  // of each line (bMarks) and real beginning of that line.
  //
  // It exists only as a hack because blockquotes override bMarks
  // losing information in the process.
  //
  // It's used only when expanding tabs, you can think about it as
  // an initial tab length, e.g. bsCount=21 applied to string `\t123`
  // means first tab should be expanded to 4-21%4 === 3 spaces.
  //
  this.bsCount = [];

  // block parser variables
  this.blkIndent = 0; // required block content indent
  // (for example, if we are in list)
  this.line = 0; // line index in src
  this.lineMax = 0; // lines count
  this.tight = false; // loose/tight mode for lists
  this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)

  // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
  // used in lists to determine if they interrupt a paragraph
  this.parentType = 'root';

  this.level = 0;

  // renderer
  this.result = '';

  // Create caches
  // Generate markers.
  s = this.src;
  indent_found = false;

  for (start = pos = indent = offset = 0, len = s.length; pos < len; pos++) {
    ch = s.charCodeAt(pos);

    if (!indent_found) {
      if (isSpace(ch)) {
        indent++;

        if (ch === 0x09) {
          offset += 4 - offset % 4;
        } else {
          offset++;
        }
        continue;
      } else {
        indent_found = true;
      }
    }

    if (ch === 0x0A || pos === len - 1) {
      if (ch !== 0x0A) {
        pos++;
      }
      this.bMarks.push(start);
      this.eMarks.push(pos);
      this.tShift.push(indent);
      this.sCount.push(offset);
      this.bsCount.push(0);

      indent_found = false;
      indent = 0;
      offset = 0;
      start = pos + 1;
    }
  }

  // Push fake entry to simplify cache bounds checks
  this.bMarks.push(s.length);
  this.eMarks.push(s.length);
  this.tShift.push(0);
  this.sCount.push(0);
  this.bsCount.push(0);

  this.lineMax = this.bMarks.length - 1; // don't count last fake line
}

// Push new token to "stream".
//
StateBlock.prototype.push = function (type, tag, nesting) {
  var token = new Token(type, tag, nesting);
  token.block = true;

  if (nesting < 0) {
    this.level--;
  }
  token.level = this.level;
  if (nesting > 0) {
    this.level++;
  }

  this.tokens.push(token);
  return token;
};

StateBlock.prototype.isEmpty = function isEmpty(line) {
  return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};

StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
  for (var max = this.lineMax; from < max; from++) {
    if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) {
      break;
    }
  }
  return from;
};

// Skip spaces from given position.
StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
  var ch;

  for (var max = this.src.length; pos < max; pos++) {
    ch = this.src.charCodeAt(pos);
    if (!isSpace(ch)) {
      break;
    }
  }
  return pos;
};

// Skip spaces from given position in reverse.
StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
  if (pos <= min) {
    return pos;
  }

  while (pos > min) {
    if (!isSpace(this.src.charCodeAt(--pos))) {
      return pos + 1;
    }
  }
  return pos;
};

// Skip char codes from given position
StateBlock.prototype.skipChars = function skipChars(pos, code) {
  for (var max = this.src.length; pos < max; pos++) {
    if (this.src.charCodeAt(pos) !== code) {
      break;
    }
  }
  return pos;
};

// Skip char codes reverse from given position - 1
StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
  if (pos <= min) {
    return pos;
  }

  while (pos > min) {
    if (code !== this.src.charCodeAt(--pos)) {
      return pos + 1;
    }
  }
  return pos;
};

// cut lines range from source.
StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
  var i,
      lineIndent,
      ch,
      first,
      last,
      queue,
      lineStart,
      line = begin;

  if (begin >= end) {
    return '';
  }

  queue = new Array(end - begin);

  for (i = 0; line < end; line++, i++) {
    lineIndent = 0;
    lineStart = first = this.bMarks[line];

    if (line + 1 < end || keepLastLF) {
      // No need for bounds check because we have fake entry on tail.
      last = this.eMarks[line] + 1;
    } else {
      last = this.eMarks[line];
    }

    while (first < last && lineIndent < indent) {
      ch = this.src.charCodeAt(first);

      if (isSpace(ch)) {
        if (ch === 0x09) {
          lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
        } else {
          lineIndent++;
        }
      } else if (first - lineStart < this.tShift[line]) {
        // patched tShift masked characters to look like spaces (blockquotes, list markers)
        lineIndent++;
      } else {
        break;
      }

      first++;
    }

    if (lineIndent > indent) {
      // partially expanding tabs in code blocks, e.g '\t\tfoobar'
      // with indent=2 becomes '  \tfoobar'
      queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
    } else {
      queue[i] = this.src.slice(first, last);
    }
  }

  return queue.join('');
};

// re-export Token class to use in block rules
StateBlock.prototype.Token = Token;

module.exports = StateBlock;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/


var Ruler = __webpack_require__(114);

////////////////////////////////////////////////////////////////////////////////
// Parser rules

var _rules = [['text', __webpack_require__(740)], ['newline', __webpack_require__(741)], ['escape', __webpack_require__(742)], ['backticks', __webpack_require__(743)], ['strikethrough', __webpack_require__(426).tokenize], ['emphasis', __webpack_require__(427).tokenize], ['link', __webpack_require__(744)], ['image', __webpack_require__(745)], ['autolink', __webpack_require__(746)], ['html_inline', __webpack_require__(747)], ['entity', __webpack_require__(748)]];

var _rules2 = [['balance_pairs', __webpack_require__(749)], ['strikethrough', __webpack_require__(426).postProcess], ['emphasis', __webpack_require__(427).postProcess], ['text_collapse', __webpack_require__(750)]];

/**
 * new ParserInline()
 **/
function ParserInline() {
  var i;

  /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/
  this.ruler = new Ruler();

  for (i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }

  /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/
  this.ruler2 = new Ruler();

  for (i = 0; i < _rules2.length; i++) {
    this.ruler2.push(_rules2[i][0], _rules2[i][1]);
  }
}

// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
ParserInline.prototype.skipToken = function (state) {
  var ok,
      i,
      pos = state.pos,
      rules = this.ruler.getRules(''),
      len = rules.length,
      maxNesting = state.md.options.maxNesting,
      cache = state.cache;

  if (typeof cache[pos] !== 'undefined') {
    state.pos = cache[pos];
    return;
  }

  if (state.level < maxNesting) {
    for (i = 0; i < len; i++) {
      // Increment state.level and decrement it later to limit recursion.
      // It's harmless to do here, because no tokens are created. But ideally,
      // we'd need a separate private state variable for this purpose.
      //
      state.level++;
      ok = rules[i](state, true);
      state.level--;

      if (ok) {
        break;
      }
    }
  } else {
    // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
  }

  if (!ok) {
    state.pos++;
  }
  cache[pos] = state.pos;
};

// Generate tokens for input range
//
ParserInline.prototype.tokenize = function (state) {
  var ok,
      i,
      rules = this.ruler.getRules(''),
      len = rules.length,
      end = state.posMax,
      maxNesting = state.md.options.maxNesting;

  while (state.pos < end) {
    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.pos`
    // - update `state.tokens`
    // - return true

    if (state.level < maxNesting) {
      for (i = 0; i < len; i++) {
        ok = rules[i](state, false);
        if (ok) {
          break;
        }
      }
    }

    if (ok) {
      if (state.pos >= end) {
        break;
      }
      continue;
    }

    state.pending += state.src[state.pos++];
  }

  if (state.pending) {
    state.pushPending();
  }
};

/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/
ParserInline.prototype.parse = function (str, md, env, outTokens) {
  var i, rules, len;
  var state = new this.State(str, md, env, outTokens);

  this.tokenize(state);

  rules = this.ruler2.getRules('');
  len = rules.length;

  for (i = 0; i < len; i++) {
    rules[i](state);
  }
};

ParserInline.prototype.State = __webpack_require__(751);

module.exports = ParserInline;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Skip text characters for text token, place those to pending buffer
// and increment current pos



// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions

// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~

// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character

function isTerminatorChar(ch) {
  switch (ch) {
    case 0x0A /* \n */:
    case 0x21 /* ! */:
    case 0x23 /* # */:
    case 0x24 /* $ */:
    case 0x25 /* % */:
    case 0x26 /* & */:
    case 0x2A /* * */:
    case 0x2B /* + */:
    case 0x2D /* - */:
    case 0x3A /* : */:
    case 0x3C /* < */:
    case 0x3D /* = */:
    case 0x3E /* > */:
    case 0x40 /* @ */:
    case 0x5B /* [ */:
    case 0x5C /* \ */:
    case 0x5D /* ] */:
    case 0x5E /* ^ */:
    case 0x5F /* _ */:
    case 0x60 /* ` */:
    case 0x7B /* { */:
    case 0x7D /* } */:
    case 0x7E /* ~ */:
      return true;
    default:
      return false;
  }
}

module.exports = function text(state, silent) {
  var pos = state.pos;

  while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) {
    pos++;
  }

  if (pos === state.pos) {
    return false;
  }

  if (!silent) {
    state.pending += state.src.slice(state.pos, pos);
  }

  state.pos = pos;

  return true;
};

// Alternative implementation, for memory.
//
// It costs 10% of performance, but allows extend terminators list, if place it
// to `ParcerInline` property. Probably, will switch to it sometime, such
// flexibility required.

/*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Proceess '\n'



var isSpace = __webpack_require__(9).isSpace;

module.exports = function newline(state, silent) {
  var pmax,
      max,
      pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x0A /* \n */) {
      return false;
    }

  pmax = state.pending.length - 1;
  max = state.posMax;

  // '  \n' -> hardbreak
  // Lookup in pending chars is bad practice! Don't copy to other rules!
  // Pending string is stored in concat mode, indexed lookups will cause
  // convertion to flat mode.
  if (!silent) {
    if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
      if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
        state.pending = state.pending.replace(/ +$/, '');
        state.push('hardbreak', 'br', 0);
      } else {
        state.pending = state.pending.slice(0, -1);
        state.push('softbreak', 'br', 0);
      }
    } else {
      state.push('softbreak', 'br', 0);
    }
  }

  pos++;

  // skip heading spaces for next line
  while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    pos++;
  }

  state.pos = pos;
  return true;
};

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process escaped chars and hardbreaks



var isSpace = __webpack_require__(9).isSpace;

var ESCAPED = [];

for (var i = 0; i < 256; i++) {
  ESCAPED.push(0);
}

'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function (ch) {
  ESCAPED[ch.charCodeAt(0)] = 1;
});

module.exports = function escape(state, silent) {
  var ch,
      pos = state.pos,
      max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x5C /* \ */) {
      return false;
    }

  pos++;

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (ch < 256 && ESCAPED[ch] !== 0) {
      if (!silent) {
        state.pending += state.src[pos];
      }
      state.pos += 2;
      return true;
    }

    if (ch === 0x0A) {
      if (!silent) {
        state.push('hardbreak', 'br', 0);
      }

      pos++;
      // skip leading whitespaces from next line
      while (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!isSpace(ch)) {
          break;
        }
        pos++;
      }

      state.pos = pos;
      return true;
    }
  }

  if (!silent) {
    state.pending += '\\';
  }
  state.pos++;
  return true;
};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parse backticks



module.exports = function backtick(state, silent) {
  var start,
      max,
      marker,
      matchStart,
      matchEnd,
      token,
      pos = state.pos,
      ch = state.src.charCodeAt(pos);

  if (ch !== 0x60 /* ` */) {
      return false;
    }

  start = pos;
  pos++;
  max = state.posMax;

  while (pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */) {
    pos++;
  }

  marker = state.src.slice(start, pos);

  matchStart = matchEnd = pos;

  while ((matchStart = state.src.indexOf('`', matchEnd)) !== -1) {
    matchEnd = matchStart + 1;

    while (matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */) {
      matchEnd++;
    }

    if (matchEnd - matchStart === marker.length) {
      if (!silent) {
        token = state.push('code_inline', 'code', 0);
        token.markup = marker;
        token.content = state.src.slice(pos, matchStart).replace(/[ \n]+/g, ' ').trim();
      }
      state.pos = matchEnd;
      return true;
    }
  }

  if (!silent) {
    state.pending += marker;
  }
  state.pos += marker.length;
  return true;
};

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process [link](<to> "stuff")



var normalizeReference = __webpack_require__(9).normalizeReference;
var isSpace = __webpack_require__(9).isSpace;

module.exports = function link(state, silent) {
  var attrs,
      code,
      label,
      labelEnd,
      labelStart,
      pos,
      res,
      ref,
      title,
      token,
      href = '',
      oldPos = state.pos,
      max = state.posMax,
      start = state.pos,
      parseReference = true;

  if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */) {
      return false;
    }

  labelStart = state.pos + 1;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) {
    return false;
  }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */) {
      //
      // Inline link
      //

      // might have found a valid shortcut link, disable reference parsing
      parseReference = false;

      // [link](  <href>  "title"  )
      //        ^^ skipping these spaces
      pos++;
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) {
          break;
        }
      }
      if (pos >= max) {
        return false;
      }

      // [link](  <href>  "title"  )
      //          ^^^^^^ parsing link destination
      start = pos;
      res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
      if (res.ok) {
        href = state.md.normalizeLink(res.str);
        if (state.md.validateLink(href)) {
          pos = res.pos;
        } else {
          href = '';
        }
      }

      // [link](  <href>  "title"  )
      //                ^^ skipping these spaces
      start = pos;
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) {
          break;
        }
      }

      // [link](  <href>  "title"  )
      //                  ^^^^^^^ parsing link title
      res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
      if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;

        // [link](  <href>  "title"  )
        //                         ^^ skipping these spaces
        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);
          if (!isSpace(code) && code !== 0x0A) {
            break;
          }
        }
      } else {
        title = '';
      }

      if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */) {
          // parsing a valid shortcut link failed, fallback to reference
          parseReference = true;
        }
      pos++;
    }

  if (parseReference) {
    //
    // Link reference
    //
    if (typeof state.env.references === 'undefined') {
      return false;
    }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */) {
        start = pos + 1;
        pos = state.md.helpers.parseLinkLabel(state, pos);
        if (pos >= 0) {
          label = state.src.slice(start, pos++);
        } else {
          pos = labelEnd + 1;
        }
      } else {
      pos = labelEnd + 1;
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) {
      label = state.src.slice(labelStart, labelEnd);
    }

    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    state.pos = labelStart;
    state.posMax = labelEnd;

    token = state.push('link_open', 'a', 1);
    token.attrs = attrs = [['href', href]];
    if (title) {
      attrs.push(['title', title]);
    }

    state.md.inline.tokenize(state);

    token = state.push('link_close', 'a', -1);
  }

  state.pos = pos;
  state.posMax = max;
  return true;
};

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process ![image](<src> "title")



var normalizeReference = __webpack_require__(9).normalizeReference;
var isSpace = __webpack_require__(9).isSpace;

module.exports = function image(state, silent) {
  var attrs,
      code,
      content,
      label,
      labelEnd,
      labelStart,
      pos,
      ref,
      res,
      title,
      token,
      tokens,
      start,
      href = '',
      oldPos = state.pos,
      max = state.posMax;

  if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */) {
      return false;
    }
  if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */) {
      return false;
    }

  labelStart = state.pos + 2;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) {
    return false;
  }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */) {
      //
      // Inline link
      //

      // [link](  <href>  "title"  )
      //        ^^ skipping these spaces
      pos++;
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) {
          break;
        }
      }
      if (pos >= max) {
        return false;
      }

      // [link](  <href>  "title"  )
      //          ^^^^^^ parsing link destination
      start = pos;
      res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
      if (res.ok) {
        href = state.md.normalizeLink(res.str);
        if (state.md.validateLink(href)) {
          pos = res.pos;
        } else {
          href = '';
        }
      }

      // [link](  <href>  "title"  )
      //                ^^ skipping these spaces
      start = pos;
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) {
          break;
        }
      }

      // [link](  <href>  "title"  )
      //                  ^^^^^^^ parsing link title
      res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
      if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;

        // [link](  <href>  "title"  )
        //                         ^^ skipping these spaces
        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);
          if (!isSpace(code) && code !== 0x0A) {
            break;
          }
        }
      } else {
        title = '';
      }

      if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */) {
          state.pos = oldPos;
          return false;
        }
      pos++;
    } else {
    //
    // Link reference
    //
    if (typeof state.env.references === 'undefined') {
      return false;
    }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */) {
        start = pos + 1;
        pos = state.md.helpers.parseLinkLabel(state, pos);
        if (pos >= 0) {
          label = state.src.slice(start, pos++);
        } else {
          pos = labelEnd + 1;
        }
      } else {
      pos = labelEnd + 1;
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) {
      label = state.src.slice(labelStart, labelEnd);
    }

    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    content = state.src.slice(labelStart, labelEnd);

    state.md.inline.parse(content, state.md, state.env, tokens = []);

    token = state.push('image', 'img', 0);
    token.attrs = attrs = [['src', href], ['alt', '']];
    token.children = tokens;
    token.content = content;

    if (title) {
      attrs.push(['title', title]);
    }
  }

  state.pos = pos;
  state.posMax = max;
  return true;
};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process autolinks '<protocol:...>'



/*eslint max-len:0*/

var EMAIL_RE = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;
var AUTOLINK_RE = /^<([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)>/;

module.exports = function autolink(state, silent) {
  var tail,
      linkMatch,
      emailMatch,
      url,
      fullUrl,
      token,
      pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x3C /* < */) {
      return false;
    }

  tail = state.src.slice(pos);

  if (tail.indexOf('>') < 0) {
    return false;
  }

  if (AUTOLINK_RE.test(tail)) {
    linkMatch = tail.match(AUTOLINK_RE);

    url = linkMatch[0].slice(1, -1);
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) {
      return false;
    }

    if (!silent) {
      token = state.push('link_open', 'a', 1);
      token.attrs = [['href', fullUrl]];
      token.markup = 'autolink';
      token.info = 'auto';

      token = state.push('text', '', 0);
      token.content = state.md.normalizeLinkText(url);

      token = state.push('link_close', 'a', -1);
      token.markup = 'autolink';
      token.info = 'auto';
    }

    state.pos += linkMatch[0].length;
    return true;
  }

  if (EMAIL_RE.test(tail)) {
    emailMatch = tail.match(EMAIL_RE);

    url = emailMatch[0].slice(1, -1);
    fullUrl = state.md.normalizeLink('mailto:' + url);
    if (!state.md.validateLink(fullUrl)) {
      return false;
    }

    if (!silent) {
      token = state.push('link_open', 'a', 1);
      token.attrs = [['href', fullUrl]];
      token.markup = 'autolink';
      token.info = 'auto';

      token = state.push('text', '', 0);
      token.content = state.md.normalizeLinkText(url);

      token = state.push('link_close', 'a', -1);
      token.markup = 'autolink';
      token.info = 'auto';
    }

    state.pos += emailMatch[0].length;
    return true;
  }

  return false;
};

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process html tags



var HTML_TAG_RE = __webpack_require__(425).HTML_TAG_RE;

function isLetter(ch) {
  /*eslint no-bitwise:0*/
  var lc = ch | 0x20; // to lower case
  return lc >= 0x61 /* a */ && lc <= 0x7a /* z */;
}

module.exports = function html_inline(state, silent) {
  var ch,
      match,
      max,
      token,
      pos = state.pos;

  if (!state.md.options.html) {
    return false;
  }

  // Check start
  max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x3C /* < */ || pos + 2 >= max) {
    return false;
  }

  // Quick fail on second char
  ch = state.src.charCodeAt(pos + 1);
  if (ch !== 0x21 /* ! */ && ch !== 0x3F /* ? */ && ch !== 0x2F /* / */ && !isLetter(ch)) {
    return false;
  }

  match = state.src.slice(pos).match(HTML_TAG_RE);
  if (!match) {
    return false;
  }

  if (!silent) {
    token = state.push('html_inline', '', 0);
    token.content = state.src.slice(pos, pos + match[0].length);
  }
  state.pos += match[0].length;
  return true;
};

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process html entity - &#123;, &#xAF;, &quot;, ...



var entities = __webpack_require__(420);
var has = __webpack_require__(9).has;
var isValidEntityCode = __webpack_require__(9).isValidEntityCode;
var fromCodePoint = __webpack_require__(9).fromCodePoint;

var DIGITAL_RE = /^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i;
var NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;

module.exports = function entity(state, silent) {
  var ch,
      code,
      match,
      pos = state.pos,
      max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x26 /* & */) {
      return false;
    }

  if (pos + 1 < max) {
    ch = state.src.charCodeAt(pos + 1);

    if (ch === 0x23 /* # */) {
        match = state.src.slice(pos).match(DIGITAL_RE);
        if (match) {
          if (!silent) {
            code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
            state.pending += isValidEntityCode(code) ? fromCodePoint(code) : fromCodePoint(0xFFFD);
          }
          state.pos += match[0].length;
          return true;
        }
      } else {
      match = state.src.slice(pos).match(NAMED_RE);
      if (match) {
        if (has(entities, match[1])) {
          if (!silent) {
            state.pending += entities[match[1]];
          }
          state.pos += match[0].length;
          return true;
        }
      }
    }
  }

  if (!silent) {
    state.pending += '&';
  }
  state.pos++;
  return true;
};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// For each opening emphasis-like marker find a matching closing one
//


module.exports = function link_pairs(state) {
  var i,
      j,
      lastDelim,
      currDelim,
      delimiters = state.delimiters,
      max = state.delimiters.length;

  for (i = 0; i < max; i++) {
    lastDelim = delimiters[i];

    if (!lastDelim.close) {
      continue;
    }

    j = i - lastDelim.jump - 1;

    while (j >= 0) {
      currDelim = delimiters[j];

      if (currDelim.open && currDelim.marker === lastDelim.marker && currDelim.end < 0 && currDelim.level === lastDelim.level) {

        // typeofs are for backward compatibility with plugins
        var odd_match = (currDelim.close || lastDelim.open) && typeof currDelim.length !== 'undefined' && typeof lastDelim.length !== 'undefined' && (currDelim.length + lastDelim.length) % 3 === 0;

        if (!odd_match) {
          lastDelim.jump = i - j;
          lastDelim.open = false;
          currDelim.end = i;
          currDelim.jump = 0;
          break;
        }
      }

      j -= currDelim.jump + 1;
    }
  }
};

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Merge adjacent text nodes into one, and re-calculate all token levels
//


module.exports = function text_collapse(state) {
  var curr,
      last,
      level = 0,
      tokens = state.tokens,
      max = state.tokens.length;

  for (curr = last = 0; curr < max; curr++) {
    // re-calculate levels
    level += tokens[curr].nesting;
    tokens[curr].level = level;

    if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') {

      // collapse two adjacent text nodes
      tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
    } else {
      if (curr !== last) {
        tokens[last] = tokens[curr];
      }

      last++;
    }
  }

  if (curr !== last) {
    tokens.length = last;
  }
};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Inline parser state



var Token = __webpack_require__(115);
var isWhiteSpace = __webpack_require__(9).isWhiteSpace;
var isPunctChar = __webpack_require__(9).isPunctChar;
var isMdAsciiPunct = __webpack_require__(9).isMdAsciiPunct;

function StateInline(src, md, env, outTokens) {
  this.src = src;
  this.env = env;
  this.md = md;
  this.tokens = outTokens;

  this.pos = 0;
  this.posMax = this.src.length;
  this.level = 0;
  this.pending = '';
  this.pendingLevel = 0;

  this.cache = {}; // Stores { start: end } pairs. Useful for backtrack
  // optimization of pairs parse (emphasis, strikes).

  this.delimiters = []; // Emphasis-like delimiters
}

// Flush pending text
//
StateInline.prototype.pushPending = function () {
  var token = new Token('text', '', 0);
  token.content = this.pending;
  token.level = this.pendingLevel;
  this.tokens.push(token);
  this.pending = '';
  return token;
};

// Push new token to "stream".
// If pending text exists - flush it as text token
//
StateInline.prototype.push = function (type, tag, nesting) {
  if (this.pending) {
    this.pushPending();
  }

  var token = new Token(type, tag, nesting);

  if (nesting < 0) {
    this.level--;
  }
  token.level = this.level;
  if (nesting > 0) {
    this.level++;
  }

  this.pendingLevel = this.level;
  this.tokens.push(token);
  return token;
};

// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
StateInline.prototype.scanDelims = function (start, canSplitWord) {
  var pos = start,
      lastChar,
      nextChar,
      count,
      can_open,
      can_close,
      isLastWhiteSpace,
      isLastPunctChar,
      isNextWhiteSpace,
      isNextPunctChar,
      left_flanking = true,
      right_flanking = true,
      max = this.posMax,
      marker = this.src.charCodeAt(start);

  // treat beginning of the line as a whitespace
  lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;

  while (pos < max && this.src.charCodeAt(pos) === marker) {
    pos++;
  }

  count = pos - start;

  // treat end of the line as a whitespace
  nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;

  isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
  isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));

  isLastWhiteSpace = isWhiteSpace(lastChar);
  isNextWhiteSpace = isWhiteSpace(nextChar);

  if (isNextWhiteSpace) {
    left_flanking = false;
  } else if (isNextPunctChar) {
    if (!(isLastWhiteSpace || isLastPunctChar)) {
      left_flanking = false;
    }
  }

  if (isLastWhiteSpace) {
    right_flanking = false;
  } else if (isLastPunctChar) {
    if (!(isNextWhiteSpace || isNextPunctChar)) {
      right_flanking = false;
    }
  }

  if (!canSplitWord) {
    can_open = left_flanking && (!right_flanking || isLastPunctChar);
    can_close = right_flanking && (!left_flanking || isNextPunctChar);
  } else {
    can_open = left_flanking;
    can_close = right_flanking;
  }

  return {
    can_open: can_open,
    can_close: can_close,
    length: count
  };
};

// re-export Token class to use in block rules
StateInline.prototype.Token = Token;

module.exports = StateInline;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


////////////////////////////////////////////////////////////////////////////////
// Helpers

// Merge objects
//

function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) {
      return;
    }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

function _class(obj) {
  return Object.prototype.toString.call(obj);
}
function isString(obj) {
  return _class(obj) === '[object String]';
}
function isObject(obj) {
  return _class(obj) === '[object Object]';
}
function isRegExp(obj) {
  return _class(obj) === '[object RegExp]';
}
function isFunction(obj) {
  return _class(obj) === '[object Function]';
}

function escapeRE(str) {
  return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}

////////////////////////////////////////////////////////////////////////////////


var defaultOptions = {
  fuzzyLink: true,
  fuzzyEmail: true,
  fuzzyIP: false
};

function isOptionsObj(obj) {
  return Object.keys(obj || {}).reduce(function (acc, k) {
    return acc || defaultOptions.hasOwnProperty(k);
  }, false);
}

var defaultSchemas = {
  'http:': {
    validate: function validate(text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
      }
      if (self.re.http.test(tail)) {
        return tail.match(self.re.http)[0].length;
      }
      return 0;
    }
  },
  'https:': 'http:',
  'ftp:': 'http:',
  '//': {
    validate: function validate(text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.no_http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.no_http = new RegExp('^' + self.re.src_auth +
        // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
      }

      if (self.re.no_http.test(tail)) {
        // should not be `://` & `///`, that protects from errors in protocol name
        if (pos >= 3 && text[pos - 3] === ':') {
          return 0;
        }
        if (pos >= 3 && text[pos - 3] === '/') {
          return 0;
        }
        return tail.match(self.re.no_http)[0].length;
      }
      return 0;
    }
  },
  'mailto:': {
    validate: function validate(text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.mailto) {
        self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
      }
      if (self.re.mailto.test(tail)) {
        return tail.match(self.re.mailto)[0].length;
      }
      return 0;
    }
  }
};

/*eslint-disable max-len*/

// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';

// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');

/*eslint-enable max-len*/

////////////////////////////////////////////////////////////////////////////////

function resetScanCache(self) {
  self.__index__ = -1;
  self.__text_cache__ = '';
}

function createValidator(re) {
  return function (text, pos) {
    var tail = text.slice(pos);

    if (re.test(tail)) {
      return tail.match(re)[0].length;
    }
    return 0;
  };
}

function createNormalizer() {
  return function (match, self) {
    self.normalize(match);
  };
}

// Schemas compiler. Build regexps.
//
function compile(self) {

  // Load & clone RE patterns.
  var re = self.re = __webpack_require__(753)(self.__opts__);

  // Define dynamic patterns
  var tlds = self.__tlds__.slice();

  self.onCompile();

  if (!self.__tlds_replaced__) {
    tlds.push(tlds_2ch_src_re);
  }
  tlds.push(re.src_xn);

  re.src_tlds = tlds.join('|');

  function untpl(tpl) {
    return tpl.replace('%TLDS%', re.src_tlds);
  }

  re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
  re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
  re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');

  //
  // Compile each schema
  //

  var aliases = [];

  self.__compiled__ = {}; // Reset compiled data

  function schemaError(name, val) {
    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
  }

  Object.keys(self.__schemas__).forEach(function (name) {
    var val = self.__schemas__[name];

    // skip disabled methods
    if (val === null) {
      return;
    }

    var compiled = { validate: null, link: null };

    self.__compiled__[name] = compiled;

    if (isObject(val)) {
      if (isRegExp(val.validate)) {
        compiled.validate = createValidator(val.validate);
      } else if (isFunction(val.validate)) {
        compiled.validate = val.validate;
      } else {
        schemaError(name, val);
      }

      if (isFunction(val.normalize)) {
        compiled.normalize = val.normalize;
      } else if (!val.normalize) {
        compiled.normalize = createNormalizer();
      } else {
        schemaError(name, val);
      }

      return;
    }

    if (isString(val)) {
      aliases.push(name);
      return;
    }

    schemaError(name, val);
  });

  //
  // Compile postponed aliases
  //

  aliases.forEach(function (alias) {
    if (!self.__compiled__[self.__schemas__[alias]]) {
      // Silently fail on missed schemas to avoid errons on disable.
      // schemaError(alias, self.__schemas__[alias]);
      return;
    }

    self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
    self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
  });

  //
  // Fake record for guessed links
  //
  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };

  //
  // Build schema condition
  //
  var slist = Object.keys(self.__compiled__).filter(function (name) {
    // Filter disabled & fake schemas
    return name.length > 0 && self.__compiled__[name];
  }).map(escapeRE).join('|');
  // (?!_) cause 1.5x slowdown
  self.re.schema_test = RegExp('(^|(?!_)(?:[><\uFF5C]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
  self.re.schema_search = RegExp('(^|(?!_)(?:[><\uFF5C]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');

  self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');

  //
  // Cleanup
  //

  resetScanCache(self);
}

/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/
function Match(self, shift) {
  var start = self.__index__,
      end = self.__last_index__,
      text = self.__text_cache__.slice(start, end);

  /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/
  this.schema = self.__schema__.toLowerCase();
  /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/
  this.index = start + shift;
  /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/
  this.lastIndex = end + shift;
  /**
   * Match#raw -> String
   *
   * Matched string.
   **/
  this.raw = text;
  /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/
  this.text = text;
  /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/
  this.url = text;
}

function createMatch(self, shift) {
  var match = new Match(self, shift);

  self.__compiled__[match.schema].normalize(match, self);

  return match;
}

/**
 * class LinkifyIt
 **/

/**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/
function LinkifyIt(schemas, options) {
  if (!(this instanceof LinkifyIt)) {
    return new LinkifyIt(schemas, options);
  }

  if (!options) {
    if (isOptionsObj(schemas)) {
      options = schemas;
      schemas = {};
    }
  }

  this.__opts__ = assign({}, defaultOptions, options);

  // Cache last tested result. Used to skip repeating steps on next `match` call.
  this.__index__ = -1;
  this.__last_index__ = -1; // Next scan position
  this.__schema__ = '';
  this.__text_cache__ = '';

  this.__schemas__ = assign({}, defaultSchemas, schemas);
  this.__compiled__ = {};

  this.__tlds__ = tlds_default;
  this.__tlds_replaced__ = false;

  this.re = {};

  compile(this);
}

/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/
LinkifyIt.prototype.add = function add(schema, definition) {
  this.__schemas__[schema] = definition;
  compile(this);
  return this;
};

/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/
LinkifyIt.prototype.set = function set(options) {
  this.__opts__ = assign(this.__opts__, options);
  return this;
};

/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/
LinkifyIt.prototype.test = function test(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__ = -1;

  if (!text.length) {
    return false;
  }

  var m, ml, me, len, shift, next, re, tld_pos, at_pos;

  // try to scan for link with schema - that's the most simple rule
  if (this.re.schema_test.test(text)) {
    re = this.re.schema_search;
    re.lastIndex = 0;
    while ((m = re.exec(text)) !== null) {
      len = this.testSchemaAt(text, m[2], re.lastIndex);
      if (len) {
        this.__schema__ = m[2];
        this.__index__ = m.index + m[1].length;
        this.__last_index__ = m.index + m[0].length + len;
        break;
      }
    }
  }

  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
    // guess schemaless links
    tld_pos = text.search(this.re.host_fuzzy_test);
    if (tld_pos >= 0) {
      // if tld is located after found link - no need to check fuzzy pattern
      if (this.__index__ < 0 || tld_pos < this.__index__) {
        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {

          shift = ml.index + ml[1].length;

          if (this.__index__ < 0 || shift < this.__index__) {
            this.__schema__ = '';
            this.__index__ = shift;
            this.__last_index__ = ml.index + ml[0].length;
          }
        }
      }
    }
  }

  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
    // guess schemaless emails
    at_pos = text.indexOf('@');
    if (at_pos >= 0) {
      // We can't skip this check, because this cases are possible:
      // 192.168.1.1@gmail.com, my.in@example.com
      if ((me = text.match(this.re.email_fuzzy)) !== null) {

        shift = me.index + me[1].length;
        next = me.index + me[0].length;

        if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
          this.__schema__ = 'mailto:';
          this.__index__ = shift;
          this.__last_index__ = next;
        }
      }
    }
  }

  return this.__index__ >= 0;
};

/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/
LinkifyIt.prototype.pretest = function pretest(text) {
  return this.re.pretest.test(text);
};

/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/
LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
  // If not supported schema check requested - terminate
  if (!this.__compiled__[schema.toLowerCase()]) {
    return 0;
  }
  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};

/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/
LinkifyIt.prototype.match = function match(text) {
  var shift = 0,
      result = [];

  // Try to take previous element from cache, if .test() called before
  if (this.__index__ >= 0 && this.__text_cache__ === text) {
    result.push(createMatch(this, shift));
    shift = this.__last_index__;
  }

  // Cut head if cache was used
  var tail = shift ? text.slice(shift) : text;

  // Scan string until end reached
  while (this.test(tail)) {
    result.push(createMatch(this, shift));

    tail = tail.slice(this.__last_index__);
    shift += this.__last_index__;
  }

  if (result.length) {
    return result;
  }

  return null;
};

/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/
LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
  list = Array.isArray(list) ? list : [list];

  if (!keepOld) {
    this.__tlds__ = list.slice();
    this.__tlds_replaced__ = true;
    compile(this);
    return this;
  }

  this.__tlds__ = this.__tlds__.concat(list).sort().filter(function (el, idx, arr) {
    return el !== arr[idx - 1];
  }).reverse();

  compile(this);
  return this;
};

/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/
LinkifyIt.prototype.normalize = function normalize(match) {

  // Do minimal possible changes by default. Need to collect feedback prior
  // to move forward https://github.com/markdown-it/linkify-it/issues/1

  if (!match.schema) {
    match.url = 'http://' + match.url;
  }

  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
    match.url = 'mailto:' + match.url;
  }
};

/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/
LinkifyIt.prototype.onCompile = function onCompile() {};

module.exports = LinkifyIt;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (opts) {
  var re = {};

  // Use direct extract instead of `regenerate` to reduse browserified size
  re.src_Any = __webpack_require__(422).source;
  re.src_Cc = __webpack_require__(423).source;
  re.src_Z = __webpack_require__(424).source;
  re.src_P = __webpack_require__(113).source;

  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
  re.src_ZPCc = [re.src_Z, re.src_P, re.src_Cc].join('|');

  // \p{\Z\Cc} (white spaces + control)
  re.src_ZCc = [re.src_Z, re.src_Cc].join('|');

  // Experimental. List of chars, completely prohibited in links
  // because can separate it from other part of text
  var text_separators = '[><\uFF5C]';

  // All possible word characters (everything without punctuation, spaces & controls)
  // Defined via punctuation & spaces to save space
  // Should be something like \p{\L\N\S\M} (\w but without `_`)
  re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
  // The same as abothe but without [0-9]
  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';

  ////////////////////////////////////////////////////////////////////////////////

  re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

  // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
  re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';

  re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';

  re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';

  re.src_path = '(?:' + '[/?#]' + '(?:' + '(?!' + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
  '\\.{2,4}[a-zA-Z0-9%/]|' + // github has ... in commit range links,
  // google has .... in links (issue #66)
  // Restrict to
  // - english
  // - percent-encoded
  // - parts of file path
  // until more examples found.
  '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
  : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
  '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';

  // Allow anything in markdown spec, forbid quote (") at the first position
  // because emails enclosed in quotes are far more common
  re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';

  re.src_xn = 'xn--[a-z0-9\\-]{1,59}';

  // More to read about domain names
  // http://serverfault.com/questions/638260/

  re.src_domain_root =

  // Allow letters & digits (http://test1)
  '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';

  re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';

  re.src_host = '(?:' +
  // Don't need IP check, because digits are already allowed in normal domain names
  //   src_ip4 +
  // '|' +
  '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain /*_root*/ + ')' + ')';

  re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';

  re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';

  re.src_host_strict = re.src_host + re.src_host_terminator;

  re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;

  re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;

  re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;

  re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;

  ////////////////////////////////////////////////////////////////////////////////
  // Main rules

  // Rude test fuzzy links by host, for quick deny
  re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';

  re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';

  re.tpl_link_fuzzy =
  // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uFF5C])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';

  re.tpl_link_no_ip_fuzzy =
  // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uFF5C])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';

  return re;
};

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function (root) {

	/** Detect free variables */
	var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
	var freeModule = ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;
	var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
		root = freeGlobal;
	}

	/**
  * The `punycode` object.
  * @name punycode
  * @type Object
  */
	var punycode,


	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647,
	    // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	    tMin = 1,
	    tMax = 26,
	    skew = 38,
	    damp = 700,
	    initialBias = 72,
	    initialN = 128,
	    // 0x80
	delimiter = '-',
	    // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	    regexNonASCII = /[^\x20-\x7E]/,
	    // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
	    // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},


	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	    floor = Math.floor,
	    stringFromCharCode = String.fromCharCode,


	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
  * A generic error utility function.
  * @private
  * @param {String} type The error type.
  * @returns {Error} Throws a `RangeError` with the applicable error message.
  */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
  * A generic `Array#map` utility function.
  * @private
  * @param {Array} array The array to iterate over.
  * @param {Function} callback The function that gets called for every array
  * item.
  * @returns {Array} A new array of values returned by the callback function.
  */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
  * A simple `Array#map`-like wrapper to work with domain name strings or email
  * addresses.
  * @private
  * @param {String} domain The domain name or email address.
  * @param {Function} callback The function that gets called for every
  * character.
  * @returns {Array} A new string of characters returned by the callback
  * function.
  */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
  * Creates an array containing the numeric code points of each Unicode
  * character in the string. While JavaScript uses UCS-2 internally,
  * this function will convert a pair of surrogate halves (each of which
  * UCS-2 exposes as separate characters) into a single code point,
  * matching UTF-16.
  * @see `punycode.ucs2.encode`
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode.ucs2
  * @name decode
  * @param {String} string The Unicode input string (UCS-2).
  * @returns {Array} The new array of code points.
  */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) {
					// low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
  * Creates a string based on an array of numeric code points.
  * @see `punycode.ucs2.decode`
  * @memberOf punycode.ucs2
  * @name encode
  * @param {Array} codePoints The array of numeric code points.
  * @returns {String} The new Unicode string (UCS-2).
  */
	function ucs2encode(array) {
		return map(array, function (value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
  * Converts a basic code point into a digit/integer.
  * @see `digitToBasic()`
  * @private
  * @param {Number} codePoint The basic numeric code point value.
  * @returns {Number} The numeric value of a basic code point (for use in
  * representing integers) in the range `0` to `base - 1`, or `base` if
  * the code point does not represent a value.
  */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
  * Converts a digit/integer into a basic code point.
  * @see `basicToDigit()`
  * @private
  * @param {Number} digit The numeric value of a basic code point.
  * @returns {Number} The basic code point whose value (when used for
  * representing integers) is `digit`, which needs to be in the range
  * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
  * used; else, the lowercase form is used. The behavior is undefined
  * if `flag` is non-zero and `digit` has no uppercase form.
  */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
  * Bias adaptation function as per section 3.4 of RFC 3492.
  * https://tools.ietf.org/html/rfc3492#section-3.4
  * @private
  */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (; /* no initialization */delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
  * Converts a Punycode string of ASCII-only symbols to a string of Unicode
  * symbols.
  * @memberOf punycode
  * @param {String} input The Punycode string of ASCII-only symbols.
  * @returns {String} The resulting string of Unicode symbols.
  */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,

		/** Cached calculation results */
		baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength;) /* no final expression */{

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base;; /* no condition */k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;
			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);
		}

		return ucs2encode(output);
	}

	/**
  * Converts a string of Unicode symbols (e.g. a domain name label) to a
  * Punycode string of ASCII-only symbols.
  * @memberOf punycode
  * @param {String} input The string of Unicode symbols.
  * @returns {String} The resulting Punycode string of ASCII-only symbols.
  */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],

		/** `inputLength` will hold the number of code points in `input`. */
		inputLength,

		/** Cached calculation results */
		handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base;; /* no condition */k += base) {
						t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;
		}
		return output.join('');
	}

	/**
  * Converts a Punycode string representing a domain name or an email address
  * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
  * it doesn't matter if you call it on a string that has already been
  * converted to Unicode.
  * @memberOf punycode
  * @param {String} input The Punycoded domain name or email address to
  * convert to Unicode.
  * @returns {String} The Unicode representation of the given Punycode
  * string.
  */
	function toUnicode(input) {
		return mapDomain(input, function (string) {
			return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
		});
	}

	/**
  * Converts a Unicode string representing a domain name or an email address to
  * Punycode. Only the non-ASCII parts of the domain name will be converted,
  * i.e. it doesn't matter if you call it with a domain that's already in
  * ASCII.
  * @memberOf punycode
  * @param {String} input The domain name or email address to convert, as a
  * Unicode string.
  * @returns {String} The Punycode representation of the given domain name or
  * email address.
  */
	function toASCII(input) {
		return mapDomain(input, function (string) {
			return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
		'version': '1.4.1',
		/**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if ("function" == 'function' && _typeof(__webpack_require__(69)) == 'object' && __webpack_require__(69)) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}
})(undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)(module), __webpack_require__(42)))

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// markdown-it default options



module.exports = {
  options: {
    html: false, // Enable HTML tags in source
    xhtmlOut: false, // Use '/' to close single tags (<br />)
    breaks: false, // Convert '\n' in paragraphs into <br>
    langPrefix: 'language-', // CSS language prefix for fenced blocks
    linkify: false, // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer: false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201C\u201D\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting: 100 // Internal protection, recursion limit
  },

  components: {

    core: {},
    block: {},
    inline: {}
  }
};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.



module.exports = {
  options: {
    html: false, // Enable HTML tags in source
    xhtmlOut: false, // Use '/' to close single tags (<br />)
    breaks: false, // Convert '\n' in paragraphs into <br>
    langPrefix: 'language-', // CSS language prefix for fenced blocks
    linkify: false, // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer: false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201C\u201D\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting: 20 // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: ['normalize', 'block', 'inline']
    },

    block: {
      rules: ['paragraph']
    },

    inline: {
      rules: ['text'],
      rules2: ['balance_pairs', 'text_collapse']
    }
  }
};

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Commonmark default options



module.exports = {
  options: {
    html: true, // Enable HTML tags in source
    xhtmlOut: true, // Use '/' to close single tags (<br />)
    breaks: false, // Convert '\n' in paragraphs into <br>
    langPrefix: 'language-', // CSS language prefix for fenced blocks
    linkify: false, // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer: false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201C\u201D\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting: 20 // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: ['normalize', 'block', 'inline']
    },

    block: {
      rules: ['blockquote', 'code', 'fence', 'heading', 'hr', 'html_block', 'lheading', 'list', 'reference', 'paragraph']
    },

    inline: {
      rules: ['autolink', 'backticks', 'emphasis', 'entity', 'escape', 'html_inline', 'image', 'link', 'newline', 'text'],
      rules2: ['balance_pairs', 'emphasis', 'text_collapse']
    }
  }
};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var emojies_defs = __webpack_require__(759);
var emojies_shortcuts = __webpack_require__(760);
var emoji_html = __webpack_require__(761);
var emoji_replace = __webpack_require__(762);
var normalize_opts = __webpack_require__(763);

module.exports = function emoji_plugin(md, options) {
  var defaults = {
    defs: emojies_defs,
    shortcuts: emojies_shortcuts,
    enabled: []
  };

  var opts = normalize_opts(md.utils.assign({}, defaults, options || {}));

  md.renderer.rules.emoji = emoji_html;

  md.core.ruler.push('emoji', emoji_replace(md, opts.defs, opts.shortcuts, opts.scanRE, opts.replaceRE));
};

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Emoticons -> Emoji mapping.
//
// (!) Some patterns skipped, to avoid collisions
// without increase matcher complicity. Than can change in future.
//
// Places to look for more emoticons info:
//
// - http://en.wikipedia.org/wiki/List_of_emoticons#Western
// - https://github.com/wooorm/emoticon/blob/master/Support.md
// - http://factoryjoe.com/projects/emoticons/
//


module.exports = {
  angry: ['>:(', '>:-('],
  blush: [':")', ':-")'],
  broken_heart: ['</3', '<\\3'],
  // :\ and :-\ not used because of conflict with markdown escaping
  confused: [':/', ':-/'], // twemoji shows question
  cry: [":'(", ":'-(", ':,(', ':,-('],
  frowning: [':(', ':-('],
  heart: ['<3'],
  imp: [']:(', ']:-('],
  innocent: ['o:)', 'O:)', 'o:-)', 'O:-)', '0:)', '0:-)'],
  joy: [":')", ":'-)", ':,)', ':,-)', ":'D", ":'-D", ':,D', ':,-D'],
  kissing: [':*', ':-*'],
  laughing: ['x-)', 'X-)'],
  neutral_face: [':|', ':-|'],
  open_mouth: [':o', ':-o', ':O', ':-O'],
  rage: [':@', ':-@'],
  smile: [':D', ':-D'],
  smiley: [':)', ':-)'],
  smiling_imp: [']:)', ']:-)'],
  sob: [":,'(", ":,'-(", ';(', ';-('],
  stuck_out_tongue: [':P', ':-P'],
  sunglasses: ['8-)', 'B-)'],
  sweat: [',:(', ',:-('],
  sweat_smile: [',:)', ',:-)'],
  unamused: [':s', ':-S', ':z', ':-Z', ':$', ':-$'],
  wink: [';)', ';-)']
};

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function emoji_html(tokens, idx /*, options, env */) {
  return tokens[idx].content;
};

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Emojies & shortcuts replacement logic.
//
// Note: In theory, it could be faster to parse :smile: in inline chain and
// leave only shortcuts here. But, who care...
//



module.exports = function create_rule(md, emojies, shortcuts, scanRE, replaceRE) {
  var arrayReplaceAt = md.utils.arrayReplaceAt,
      ucm = md.utils.lib.ucmicro,
      ZPCc = new RegExp([ucm.Z.source, ucm.P.source, ucm.Cc.source].join('|'));

  function splitTextToken(text, level, Token) {
    var token,
        last_pos = 0,
        nodes = [];

    text.replace(replaceRE, function (match, offset, src) {
      var emoji_name;
      // Validate emoji name
      if (shortcuts.hasOwnProperty(match)) {
        // replace shortcut with full name
        emoji_name = shortcuts[match];

        // Don't allow letters before any shortcut (as in no ":/" in http://)
        if (offset > 0 && !ZPCc.test(src[offset - 1])) {
          return;
        }

        // Don't allow letters after any shortcut
        if (offset + match.length < src.length && !ZPCc.test(src[offset + match.length])) {
          return;
        }
      } else {
        emoji_name = match.slice(1, -1);
      }

      // Add new tokens to pending list
      if (offset > last_pos) {
        token = new Token('text', '', 0);
        token.content = text.slice(last_pos, offset);
        nodes.push(token);
      }

      token = new Token('emoji', '', 0);
      token.markup = emoji_name;
      token.content = emojies[emoji_name];
      nodes.push(token);

      last_pos = offset + match.length;
    });

    if (last_pos < text.length) {
      token = new Token('text', '', 0);
      token.content = text.slice(last_pos);
      nodes.push(token);
    }

    return nodes;
  }

  return function emoji_replace(state) {
    var i,
        j,
        l,
        tokens,
        token,
        blockTokens = state.tokens,
        autolinkLevel = 0;

    for (j = 0, l = blockTokens.length; j < l; j++) {
      if (blockTokens[j].type !== 'inline') {
        continue;
      }
      tokens = blockTokens[j].children;

      // We scan from the end, to keep position when new tags added.
      // Use reversed logic in links start/end match
      for (i = tokens.length - 1; i >= 0; i--) {
        token = tokens[i];

        if (token.type === 'link_open' || token.type === 'link_close') {
          if (token.info === 'auto') {
            autolinkLevel -= token.nesting;
          }
        }

        if (token.type === 'text' && autolinkLevel === 0 && scanRE.test(token.content)) {
          // replace current node
          blockTokens[j].children = tokens = arrayReplaceAt(tokens, i, splitTextToken(token.content, token.level, state.Token));
        }
      }
    }
  };
};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Convert input options to more useable format
// and compile search regexp



function quoteRE(str) {
  return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}

module.exports = function normalize_opts(options) {
  var emojies = options.defs,
      shortcuts;

  // Filter emojies by whitelist, if needed
  if (options.enabled.length) {
    emojies = Object.keys(emojies).reduce(function (acc, key) {
      if (options.enabled.indexOf(key) >= 0) {
        acc[key] = emojies[key];
      }
      return acc;
    }, {});
  }

  // Flatten shortcuts to simple object: { alias: emoji_name }
  shortcuts = Object.keys(options.shortcuts).reduce(function (acc, key) {
    // Skip aliases for filtered emojies, to reduce regexp
    if (!emojies[key]) {
      return acc;
    }

    if (Array.isArray(options.shortcuts[key])) {
      options.shortcuts[key].forEach(function (alias) {
        acc[alias] = key;
      });
      return acc;
    }

    acc[options.shortcuts[key]] = key;
    return acc;
  }, {});

  // Compile regexp
  var names = Object.keys(emojies).map(function (name) {
    return ':' + name + ':';
  }).concat(Object.keys(shortcuts)).sort().reverse().map(function (name) {
    return quoteRE(name);
  }).join('|');
  var scanRE = RegExp(names);
  var replaceRE = RegExp(names, 'g');

  return {
    defs: emojies,
    shortcuts: shortcuts,
    scanRE: scanRE,
    replaceRE: replaceRE
  };
};

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;
(function () {

    var root = this;
    var previous_emoji = root.EmojiConvertor;

    /**
     * @global
     * @namespace
     */

    var emoji = function emoji() {

        var self = this;

        /**
         * The set of images to use for graphical emoji.
         *
         * @memberof emoji
         * @type {string}
         */
        self.img_set = 'apple';

        /**
         * Configuration details for different image sets. This includes a path to a directory containing the
         * individual images (`path`) and a URL to sprite sheets (`sheet`). All of these images can be found
         * in the [emoji-data repository]{@link https://github.com/iamcal/emoji-data}. Using a CDN for these
         * is not a bad idea.
         *
         * @memberof emoji
         * @type {object}
         */
        self.img_sets = {
            'apple': { 'path': '/resources/emoji-data/img-apple-64/', 'sheet': '/resources/emoji-data/sheet_apple_64.png', 'mask': 1 },
            'google': { 'path': '/resources/emoji-data/img-google-64/', 'sheet': '/resources/emoji-data/sheet_google_64.png', 'mask': 2 },
            'twitter': { 'path': '/resources/emoji-data/img-twitter-64/', 'sheet': '/resources/emoji-data/sheet_twitter_64.png', 'mask': 4 },
            'emojione': { 'path': '/resources/emoji-data/img-emojione-64/', 'sheet': '/resources/emoji-data/sheet_emojione_64.png', 'mask': 8 },
            'facebook': { 'path': '/resources/emoji-data/img-facebook-64/', 'sheet': '/resources/emoji-data/sheet_facebook_64.png', 'mask': 16 },
            'messenger': { 'path': '/resources/emoji-data/img-messenger-64/', 'sheet': '/resources/emoji-data/sheet_messenger_64.png', 'mask': 32 }
        };

        /**
         * Use a CSS class instead of specifying a sprite or background image for
         * the span representing the emoticon. This requires a CSS sheet with
         * emoticon data-uris.
         *
         * @memberof emoji
         * @type bool
         * @todo document how to build the CSS stylesheet self requires.
         */
        self.use_css_imgs = false;

        /**
         * Instead of replacing emoticons with the appropriate representations,
         * replace them with their colon string representation.
         * @memberof emoji
         * @type bool
         */
        self.colons_mode = false;
        self.text_mode = false;

        /**
         * If true, sets the "title" property on the span or image that gets
         * inserted for the emoticon.
         * @memberof emoji
         * @type bool
         */
        self.include_title = false;

        /**
         * If true, sets the text of the span or image that gets inserted for the
         * emoticon.
         * @memberof emoji
         * @type bool
         */
        self.include_text = false;

        /**
         * If the platform supports native emoticons, use those instead
         * of the fallbacks.
         * @memberof emoji
         * @type bool
         */
        self.allow_native = true;

        /**
         * Set to true to use CSS sprites instead of individual images on 
         * platforms that support it.
         *
         * @memberof emoji
         * @type bool
         */
        self.use_sheet = false;

        /**
         *
         * Set to true to avoid black & white native Windows emoji being used.
         *
         * @memberof emoji
         * @type bool
         */
        self.avoid_ms_emoji = true;

        /**
         *
         * Set to true to allow :CAPITALIZATION:
         *
         * @memberof emoji
         * @type bool
         */
        self.allow_caps = false;

        /**
         *
         * Suffix to allow for individual image cache busting
         *
         * @memberof emoji
         * @type string
         */
        self.img_suffix = '';

        // Keeps track of what has been initialized.
        /** @private */
        self.inits = {};
        self.map = {};

        // discover the environment settings
        self.init_env();

        return self;
    };

    emoji.prototype.noConflict = function () {
        root.EmojiConvertor = previous_emoji;
        return emoji;
    };

    /**
     * @memberof emoji
     * @param {string} str A string potentially containing ascii emoticons
     * (ie. `:)`)
     *
     * @returns {string} A new string with all emoticons in `str`
     * replaced by a representatation that's supported by the current
     * environtment.
     */
    emoji.prototype.replace_emoticons = function (str) {
        var self = this;
        var colonized = self.replace_emoticons_with_colons(str);
        return self.replace_colons(colonized);
    };

    /**
     * @memberof emoji
     * @param {string} str A string potentially containing ascii emoticons
     * (ie. `:)`)
     *
     * @returns {string} A new string with all emoticons in `str`
     * replaced by their colon string representations (ie. `:smile:`)
     */
    emoji.prototype.replace_emoticons_with_colons = function (str) {
        var self = this;
        self.init_emoticons();
        var _prev_offset = 0;
        var emoticons_with_parens = [];
        var str_replaced = str.replace(self.rx_emoticons, function (m, $1, emoticon, offset) {
            var prev_offset = _prev_offset;
            _prev_offset = offset + m.length;

            var has_open_paren = emoticon.indexOf('(') !== -1;
            var has_close_paren = emoticon.indexOf(')') !== -1;

            /*
             * Track paren-having emoticons for fixing later
             */
            if ((has_open_paren || has_close_paren) && emoticons_with_parens.indexOf(emoticon) == -1) {
                emoticons_with_parens.push(emoticon);
            }

            /*
             * Look for preceding open paren for emoticons that contain a close paren
             * This prevents matching "8)" inside "(around 7 - 8)"
             */
            if (has_close_paren && !has_open_paren) {
                var piece = str.substring(prev_offset, offset);
                if (piece.indexOf('(') !== -1 && piece.indexOf(')') === -1) return m;
            }

            /*
             * See if we're in a numbered list
             * This prevents matching "8)" inside "7) foo\n8) bar"
             */
            if (m === '\n8)') {
                var before_match = str.substring(0, offset);
                if (/\n?(6\)|7\))/.test(before_match)) return m;
            }

            var val = self.data[self.map.emoticons[emoticon]][3][0];
            return val ? $1 + ':' + val + ':' : m;
        });

        /*
         * Come back and fix emoticons we ignored because they were inside parens.
         * It's useful to do self at the end so we don't get tripped up by other,
         * normal emoticons
         */
        if (emoticons_with_parens.length) {
            var escaped_emoticons = emoticons_with_parens.map(self.escape_rx);
            var parenthetical_rx = new RegExp('(\\(.+)(' + escaped_emoticons.join('|') + ')(.+\\))', 'g');

            str_replaced = str_replaced.replace(parenthetical_rx, function (m, $1, emoticon, $2) {
                var val = self.data[self.map.emoticons[emoticon]][3][0];
                return val ? $1 + ':' + val + ':' + $2 : m;
            });
        }

        return str_replaced;
    };

    /**
     * @memberof emoji
     * @param {string} str A string potentially containing colon string
     * representations of emoticons (ie. `:smile:`)
     *
     * @returns {string} A new string with all colon string emoticons replaced
     * with the appropriate representation.
     */
    emoji.prototype.replace_colons = function (str) {
        var self = this;
        self.init_colons();

        return str.replace(self.rx_colons, function (m) {
            var idx = m.substr(1, m.length - 2);
            if (self.allow_caps) idx = idx.toLowerCase();

            // special case - an emoji with a skintone modified
            if (idx.indexOf('::skin-tone-') > -1) {

                var skin_tone = idx.substr(-1, 1);
                var skin_idx = 'skin-tone-' + skin_tone;
                var skin_val = self.map.colons[skin_idx];

                idx = idx.substr(0, idx.length - 13);

                var val = self.map.colons[idx];
                if (val) {
                    return self.replacement(val, idx, ':', {
                        'idx': skin_val,
                        'actual': skin_idx,
                        'wrapper': ':'
                    });
                } else {
                    return ':' + idx + ':' + self.replacement(skin_val, skin_idx, ':');
                }
            } else {
                var val = self.map.colons[idx];
                return val ? self.replacement(val, idx, ':') : m;
            }
        });
    };

    /**
     * @memberof emoji
     * @param {string} str A string potentially containing unified unicode
     * emoticons. (ie. 😄)
     *
     * @returns {string} A new string with all unicode emoticons replaced with
     * the appropriate representation for the current environment.
     */
    emoji.prototype.replace_unified = function (str) {
        var self = this;
        self.init_unified();
        return str.replace(self.rx_unified, function (m, p1, p2) {

            var val = self.map.unified[p1];
            if (val) {
                var idx = null;
                if (p2 == '\uD83C\uDFFB') idx = '1f3fb';
                if (p2 == '\uD83C\uDFFC') idx = '1f3fc';
                if (p2 == '\uD83C\uDFFD') idx = '1f3fd';
                if (p2 == '\uD83C\uDFFE') idx = '1f3fe';
                if (p2 == '\uD83C\uDFFF') idx = '1f3ff';
                if (idx) {
                    return self.replacement(val, null, null, {
                        idx: idx,
                        actual: p2,
                        wrapper: ''
                    });
                }
                return self.replacement(val);
            }

            val = self.map.unified_vars[p1];
            if (val) {
                return self.replacement(val[0], null, null, {
                    'idx': val[1],
                    'actual': '',
                    'wrapper': ''
                });
            }

            return m;
        });
    };

    emoji.prototype.addAliases = function (map) {
        var self = this;

        self.init_colons();
        for (var i in map) {
            self.map.colons[i] = map[i];
        }
    };

    emoji.prototype.removeAliases = function (list) {
        var self = this;

        for (var i = 0; i < list.length; i++) {
            var alias = list[i];

            // first, delete the alias mapping
            delete self.map.colons[alias];

            // now reset it to the default, if one exists
            finder_block: {
                for (var j in self.data) {
                    for (var k = 0; k < self.data[j][3].length; k++) {
                        if (alias == self.data[j][3][k]) {
                            self.map.colons[alias] = j;
                            break finder_block;
                        }
                    }
                }
            }
        }
    };

    // Does the actual replacement of a character with the appropriate
    /** @private */
    emoji.prototype.replacement = function (idx, actual, wrapper, variation) {
        var self = this;

        var full_idx = idx;

        // for emoji with variation modifiers, set `extra` to the standalone output for the
        // modifier (used if we can't combine the glyph) and set variation_idx to key of the
        // variation modifier (used below)
        var extra = '';
        var var_idx = null;
        if ((typeof variation === 'undefined' ? 'undefined' : _typeof(variation)) === 'object') {
            extra = self.replacement(variation.idx, variation.actual, variation.wrapper);
            var_idx = variation.idx;
        }

        // deal with simple modes (colons and text) first
        wrapper = wrapper || '';
        if (self.colons_mode) return ':' + self.data[idx][3][0] + ':' + extra;
        var text_name = actual ? wrapper + actual + wrapper : self.data[idx][8] || wrapper + self.data[idx][3][0] + wrapper;
        if (self.text_mode) return text_name + extra;

        // native modes next.
        // for variations selectors, we just need to output them raw, which `extra` will contain.
        self.init_env();
        if (self.replace_mode == 'unified' && self.allow_native && self.data[idx][0][0]) return self.data[idx][0][0] + extra;
        if (self.replace_mode == 'softbank' && self.allow_native && self.data[idx][1]) return self.data[idx][1] + extra;
        if (self.replace_mode == 'google' && self.allow_native && self.data[idx][2]) return self.data[idx][2] + extra;

        // finally deal with image modes.
        // variation selectors are more complex here - if the image set and particular emoji supports variations, then
        // use the variation image. otherwise, return it as a separate image (already calculated in `extra`).
        // first we set up the params we'll use if we can't use a variation.
        var img = self.find_image(idx, var_idx);
        var title = self.include_title ? ' title="' + (actual || self.data[idx][3][0]) + '"' : '';
        var text = self.include_text ? wrapper + (actual || self.data[idx][3][0]) + wrapper : '';

        // custom image for this glyph?
        if (self.data[idx][7]) {
            img.path = self.data[idx][7];
            img.px = null;
            img.py = null;
            img.is_var = false;
        }

        // if we're displaying a variation, include it in the text and remove the extra
        if (img.is_var) {
            extra = '';
            // add variation text
            if (self.include_text && variation && variation.actual && variation.wrapper) {
                text += variation.wrapper + variation.actual + variation.wrapper;
            }
        }

        // output
        if (self.supports_css) {
            if (self.use_sheet && img.px != null && img.py != null) {
                var mul = 100 / (self.sheet_size - 1);
                var style = 'background: url(' + img.sheet + ');background-position:' + mul * img.px + '% ' + mul * img.py + '%;background-size:' + self.sheet_size + '00%';
                return '<span class="emoji-outer emoji-sizer"><span class="emoji-inner" style="' + style + '"' + title + ' data-codepoints="' + img.full_idx + '">' + text + '</span></span>' + extra;
            } else if (self.use_css_imgs) {
                return '<span class="emoji emoji-' + idx + '"' + title + ' data-codepoints="' + img.full_idx + '">' + text + '</span>' + extra;
            } else {
                return '<span class="emoji emoji-sizer" style="background-image:url(' + img.path + ')"' + title + ' data-codepoints="' + img.full_idx + '">' + text + '</span>' + extra;
            }
        }
        return '<img src="' + img.path + '" class="emoji" data-codepoints="' + img.full_idx + '" ' + title + '/>' + extra;
    };

    // Finds the best image to display, taking into account image set precedence and obsoletes
    /** @private */
    emoji.prototype.find_image = function (idx, var_idx) {
        var self = this;

        // set up some initial state
        var out = {
            'path': '',
            'sheet': '',
            'px': self.data[idx][4],
            'py': self.data[idx][5],
            'full_idx': idx,
            'is_var': false
        };
        var use_mask = self.data[idx][6];

        // can we use a variation?
        if (var_idx && self.variations_data[idx] && self.variations_data[idx][var_idx]) {
            var var_data = self.variations_data[idx][var_idx];

            out.px = var_data[1];
            out.py = var_data[2];
            out.full_idx = var_data[0];
            out.is_var = true;
            use_mask = var_data[3];
        }

        // this matches `build/build_image.php` `in emoji-data`, so that sheet and images modes always
        // agree about the image to use.
        var try_order = [self.img_set, 'apple', 'emojione', 'google', 'twitter', 'facebook', 'messenger'];

        // for each image set, see if we have the image we need. otherwise check for an obsolete in
        // that image set
        for (var j = 0; j < try_order.length; j++) {
            if (use_mask & self.img_sets[try_order[j]].mask) {
                out.path = self.img_sets[try_order[j]].path + out.full_idx + '.png' + self.img_suffix;
                // if we're not changing glyph, use our base set for sheets - it has every glyph
                out.sheet = self.img_sets[self.img_set].sheet;
                return out;
            }
            if (self.obsoletes_data[out.full_idx]) {
                var ob_data = self.obsoletes_data[out.full_idx];

                if (ob_data[3] & self.img_sets[try_order[j]].mask) {
                    out.path = self.img_sets[try_order[j]].path + ob_data[0] + '.png' + self.img_suffix;
                    out.sheet = self.img_sets[try_order[j]].sheet;
                    out.px = ob_data[1];
                    out.py = ob_data[2];
                    return out;
                }
            }
        }

        return out;
    };

    // Initializes the text emoticon data
    /** @private */
    emoji.prototype.init_emoticons = function () {
        var self = this;
        if (self.inits.emoticons) return;
        self.init_colons(); // we require this for the emoticons map
        self.inits.emoticons = 1;

        var a = [];
        self.map.emoticons = {};
        for (var i in self.emoticons_data) {
            // because we never see some characters in our text except as entities, we must do some replacing
            var emoticon = i.replace(/\&/g, '&amp;').replace(/\</g, '&lt;').replace(/\>/g, '&gt;');

            if (!self.map.colons[self.emoticons_data[i]]) continue;

            self.map.emoticons[emoticon] = self.map.colons[self.emoticons_data[i]];
            a.push(self.escape_rx(emoticon));
        }
        self.rx_emoticons = new RegExp('(^|\\s)(' + a.join('|') + ')(?=$|[\\s|\\?\\.,!])', 'g');
    };

    // Initializes the colon string data
    /** @private */
    emoji.prototype.init_colons = function () {
        var self = this;
        if (self.inits.colons) return;
        self.inits.colons = 1;
        self.rx_colons = new RegExp('\:[a-zA-Z0-9-_+]+\:(\:skin-tone-[2-6]\:)?', 'g');
        self.map.colons = {};
        for (var i in self.data) {
            for (var j = 0; j < self.data[i][3].length; j++) {
                self.map.colons[self.data[i][3][j]] = i;
            }
        }
    };

    // initializes the unified unicode emoticon data
    /** @private */
    emoji.prototype.init_unified = function () {
        var self = this;
        if (self.inits.unified) return;
        self.inits.unified = 1;

        var a = [];
        self.map.unified = {};
        self.map.unified_vars = {};

        for (var i in self.data) {
            for (var j = 0; j < self.data[i][0].length; j++) {
                a.push(self.data[i][0][j].replace('*', '\\*'));
                self.map.unified[self.data[i][0][j]] = i;
            }
        }
        for (var i in self.variations_data) {
            // skip simple append-style skin tones
            if (self.variations_data[i]['1f3fb'][0] == i + '-1f3fb') continue;

            for (var k in self.variations_data[i]) {
                for (var j = 0; j < self.variations_data[i][k][4].length; j++) {
                    a.push(self.variations_data[i][k][4][j].replace('*', '\\*'));
                    self.map.unified_vars[self.variations_data[i][k][4][j]] = [i, k];
                }
            }
        }

        a = a.sort(function (a, b) {
            return b.length - a.length;
        });

        self.rx_unified = new RegExp('(' + a.join('|') + ')(\uD83C[\uDFFB-\uDFFF])?', "g");
    };

    // initializes the environment, figuring out what representation
    // of emoticons is best.
    /** @private */
    emoji.prototype.init_env = function () {
        var self = this;
        if (self.inits.env) return;
        self.inits.env = 1;
        self.replace_mode = 'img';
        self.supports_css = false;

        // if (window.chrome && chrome.runtime && chrome.runtime.id) {
        //     self.supports_css = true;
        // }

        if (typeof navigator !== 'undefined') {
            var ua = navigator.userAgent;
            if (window.getComputedStyle) {
                try {
                    var st = window.getComputedStyle(document.body);
                    if (st['background-size'] || st['backgroundSize']) {
                        self.supports_css = true;
                    }
                } catch (e) {
                    // Swallow an exception caused by hidden iFrames on Firefox
                    // https://github.com/iamcal/js-emoji/issues/73
                    if (ua.match(/Firefox/i)) {
                        self.supports_css = true;
                    }
                }
            }
            if (ua.match(/(iPhone|iPod|iPad|iPhone\s+Simulator)/i)) {
                if (ua.match(/OS\s+[12345]/i)) {
                    self.replace_mode = 'softbank';
                    return;
                }
                if (ua.match(/OS\s+[6789]/i)) {
                    self.replace_mode = 'unified';
                    return;
                }
            }
            if (ua.match(/Mac OS X 10[._ ](?:[789]|1\d)/i)) {
                self.replace_mode = 'unified';
                return;
            }
            if (!self.avoid_ms_emoji) {
                if (ua.match(/Windows NT 6.[1-9]/i) || ua.match(/Windows NT 10.[0-9]/i)) {
                    if (!ua.match(/Chrome/i) && !ua.match(/MSIE 8/i)) {
                        self.replace_mode = 'unified';
                        return;
                    }
                }
            }
        }

        // Need a better way to detect android devices that actually
        // support emoji.
        if (false) {
            self.replace_mode = 'google';
            return;
        }
        if (self.supports_css) {
            self.replace_mode = 'css';
        }
        // nothing fancy detected - use images
    };
    /** @private */
    emoji.prototype.escape_rx = function (text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    };
    emoji.prototype.sheet_size = 49;
    /** @private */
    emoji.prototype.data = {
        // "00a9": [
        //     ["\u00A9\uFE0F", "\u00A9"], "\uE24E", "\uDBBA\uDF29", ["copyright"], 0, 0, 11, 0
        // ],
        // "00ae": [
        //     ["\u00AE\uFE0F", "\u00AE"], "\uE24F", "\uDBBA\uDF2D", ["registered"], 0, 1, 11, 0
        // ],
        "203c": [['\u203C\uFE0F', '\u203C'], "", '\uDBBA\uDF06', ["bangbang"], 0, 2, 63, 0],
        "2049": [['\u2049\uFE0F', '\u2049'], "", '\uDBBA\uDF05', ["interrobang"], 0, 3, 63, 0],
        // "2122": [
        //     ["\u2122\uFE0F", "\u2122"], "\uE537", "\uDBBA\uDF2A", ["tm"], 0, 4, 63, 0
        // ],
        "2139": [['\u2139\uFE0F', '\u2139'], "", '\uDBBA\uDF47', ["information_source"], 0, 5, 63, 0],
        "2194": [['\u2194\uFE0F', '\u2194'], "", '\uDBBA\uDEF6', ["left_right_arrow"], 0, 6, 63, 0],
        "2195": [['\u2195\uFE0F', '\u2195'], "", '\uDBBA\uDEF7', ["arrow_up_down"], 0, 7, 63, 0],
        "2196": [['\u2196\uFE0F', '\u2196'], '\uE237', '\uDBBA\uDEF2', ["arrow_upper_left"], 0, 8, 63, 0],
        "2197": [['\u2197\uFE0F', '\u2197'], '\uE236', '\uDBBA\uDEF0', ["arrow_upper_right"], 0, 9, 63, 0],
        "2198": [['\u2198\uFE0F', '\u2198'], '\uE238', '\uDBBA\uDEF1', ["arrow_lower_right"], 0, 10, 63, 0],
        "2199": [['\u2199\uFE0F', '\u2199'], '\uE239', '\uDBBA\uDEF3', ["arrow_lower_left"], 0, 11, 63, 0],
        "21a9": [['\u21A9\uFE0F', '\u21A9'], "", '\uDBBA\uDF83', ["leftwards_arrow_with_hook"], 0, 12, 63, 0],
        "21aa": [['\u21AA\uFE0F', '\u21AA'], "", '\uDBBA\uDF88', ["arrow_right_hook"], 0, 13, 63, 0],
        "231a": [['\u231A\uFE0F', '\u231A'], "", '\uDBB8\uDC1D', ["watch"], 0, 14, 63, 0],
        "231b": [['\u231B\uFE0F', '\u231B'], "", '\uDBB8\uDC1C', ["hourglass"], 0, 15, 63, 0],
        "2328": [['\u2328\uFE0F', '\u2328'], "", "", ["keyboard"], 0, 16, 31, 0],
        "23cf": [['\u23CF'], "", "", ["eject"], 0, 17, 30, 0],
        "23e9": [['\u23E9'], '\uE23C', '\uDBBA\uDEFE', ["fast_forward"], 0, 18, 63, 0],
        "23ea": [['\u23EA'], '\uE23D', '\uDBBA\uDEFF', ["rewind"], 0, 19, 63, 0],
        "23eb": [['\u23EB'], "", '\uDBBA\uDF03', ["arrow_double_up"], 0, 20, 63, 0],
        "23ec": [['\u23EC'], "", '\uDBBA\uDF02', ["arrow_double_down"], 0, 21, 63, 0],
        "23ed": [['\u23ED'], "", "", ["black_right_pointing_double_triangle_with_vertical_bar"], 0, 22, 31, 0],
        "23ee": [['\u23EE'], "", "", ["black_left_pointing_double_triangle_with_vertical_bar"], 0, 23, 31, 0],
        "23ef": [['\u23EF'], "", "", ["black_right_pointing_triangle_with_double_vertical_bar"], 0, 24, 31, 0],
        "23f0": [['\u23F0'], '\uE02D', '\uDBB8\uDC2A', ["alarm_clock"], 0, 25, 63, 0],
        "23f1": [['\u23F1'], "", "", ["stopwatch"], 0, 26, 31, 0],
        "23f2": [['\u23F2'], "", "", ["timer_clock"], 0, 27, 31, 0],
        "23f3": [['\u23F3'], "", '\uDBB8\uDC1B', ["hourglass_flowing_sand"], 0, 28, 63, 0],
        "23f8": [['\u23F8'], "", "", ["double_vertical_bar"], 0, 29, 31, 0],
        "23f9": [['\u23F9'], "", "", ["black_square_for_stop"], 0, 30, 31, 0],
        "23fa": [['\u23FA'], "", "", ["black_circle_for_record"], 0, 31, 31, 0],
        "24c2": [['\u24C2\uFE0F', '\u24C2'], '\uE434', '\uDBB9\uDFE1', ["m"], 0, 32, 63, 0],
        "25aa": [['\u25AA\uFE0F', '\u25AA'], '\uE21A', '\uDBBA\uDF6E', ["black_small_square"], 0, 33, 63, 0],
        "25ab": [['\u25AB\uFE0F', '\u25AB'], '\uE21B', '\uDBBA\uDF6D', ["white_small_square"], 0, 34, 63, 0],
        "25b6": [['\u25B6\uFE0F', '\u25B6'], '\uE23A', '\uDBBA\uDEFC', ["arrow_forward"], 0, 35, 63, 0],
        "25c0": [['\u25C0\uFE0F', '\u25C0'], '\uE23B', '\uDBBA\uDEFD', ["arrow_backward"], 0, 36, 63, 0],
        "25fb": [['\u25FB\uFE0F', '\u25FB'], '\uE21B', '\uDBBA\uDF71', ["white_medium_square"], 0, 37, 63, 0],
        "25fc": [['\u25FC\uFE0F', '\u25FC'], '\uE21A', '\uDBBA\uDF72', ["black_medium_square"], 0, 38, 63, 0],
        "25fd": [['\u25FD\uFE0F', '\u25FD'], '\uE21B', '\uDBBA\uDF6F', ["white_medium_small_square"], 0, 39, 63, 0],
        "25fe": [['\u25FE\uFE0F', '\u25FE'], '\uE21A', '\uDBBA\uDF70', ["black_medium_small_square"], 0, 40, 63, 0],
        "2600": [['\u2600\uFE0F', '\u2600'], '\uE04A', '\uDBB8\uDC00', ["sunny"], 0, 41, 63, 0],
        "2601": [['\u2601\uFE0F', '\u2601'], '\uE049', '\uDBB8\uDC01', ["cloud"], 0, 42, 63, 0],
        "2602": [['\u2602\uFE0F', '\u2602'], "", "", ["umbrella"], 0, 43, 31, 0],
        "2603": [['\u2603\uFE0F', '\u2603'], "", "", ["snowman"], 0, 44, 31, 0],
        "2604": [['\u2604\uFE0F', '\u2604'], "", "", ["comet"], 0, 45, 31, 0],
        "260e": [['\u260E\uFE0F', '\u260E'], '\uE009', '\uDBB9\uDD23', ["phone", "telephone"], 0, 46, 63, 0],
        "2611": [['\u2611\uFE0F', '\u2611'], "", '\uDBBA\uDF8B', ["ballot_box_with_check"], 0, 47, 63, 0],
        "2614": [['\u2614\uFE0F', '\u2614'], '\uE04B', '\uDBB8\uDC02', ["umbrella_with_rain_drops"], 0, 48, 63, 0],
        "2615": [['\u2615\uFE0F', '\u2615'], '\uE045', '\uDBBA\uDD81', ["coffee"], 1, 0, 63, 0],
        "2618": [['\u2618\uFE0F', '\u2618'], "", "", ["shamrock"], 1, 1, 31, 0],
        "261d": [['\u261D\uFE0F', '\u261D'], '\uE00F', '\uDBBA\uDF98', ["point_up"], 1, 2, 63, 0],
        "2620": [['\u2620\uFE0F', '\u2620'], "", "", ["skull_and_crossbones"], 1, 8, 31, 0],
        "2622": [['\u2622\uFE0F', '\u2622'], "", "", ["radioactive_sign"], 1, 9, 31, 0],
        "2623": [['\u2623\uFE0F', '\u2623'], "", "", ["biohazard_sign"], 1, 10, 31, 0],
        "2626": [['\u2626\uFE0F', '\u2626'], "", "", ["orthodox_cross"], 1, 11, 31, 0],
        "262a": [['\u262A\uFE0F', '\u262A'], "", "", ["star_and_crescent"], 1, 12, 31, 0],
        "262e": [['\u262E\uFE0F', '\u262E'], "", "", ["peace_symbol"], 1, 13, 31, 0],
        "262f": [['\u262F\uFE0F', '\u262F'], "", "", ["yin_yang"], 1, 14, 31, 0],
        "2638": [['\u2638\uFE0F', '\u2638'], "", "", ["wheel_of_dharma"], 1, 15, 31, 0],
        "2639": [['\u2639\uFE0F', '\u2639'], "", "", ["white_frowning_face"], 1, 16, 31, 0],
        "263a": [['\u263A\uFE0F', '\u263A'], '\uE414', '\uDBB8\uDF36', ["relaxed"], 1, 17, 63, 0],
        "2640": [['\u2640'], "", "", ["female_sign"], 1, 18, 22, 0],
        "2642": [['\u2642'], "", "", ["male_sign"], 1, 19, 22, 0],
        "2648": [['\u2648\uFE0F', '\u2648'], '\uE23F', '\uDBB8\uDC2B', ["aries"], 1, 20, 63, 0],
        "2649": [['\u2649\uFE0F', '\u2649'], '\uE240', '\uDBB8\uDC2C', ["taurus"], 1, 21, 63, 0],
        "264a": [['\u264A\uFE0F', '\u264A'], '\uE241', '\uDBB8\uDC2D', ["gemini"], 1, 22, 63, 0],
        "264b": [['\u264B\uFE0F', '\u264B'], '\uE242', '\uDBB8\uDC2E', ["cancer"], 1, 23, 63, 0],
        "264c": [['\u264C\uFE0F', '\u264C'], '\uE243', '\uDBB8\uDC2F', ["leo"], 1, 24, 63, 0],
        "264d": [['\u264D\uFE0F', '\u264D'], '\uE244', '\uDBB8\uDC30', ["virgo"], 1, 25, 63, 0],
        "264e": [['\u264E\uFE0F', '\u264E'], '\uE245', '\uDBB8\uDC31', ["libra"], 1, 26, 63, 0],
        "264f": [['\u264F\uFE0F', '\u264F'], '\uE246', '\uDBB8\uDC32', ["scorpius"], 1, 27, 63, 0],
        "2650": [['\u2650\uFE0F', '\u2650'], '\uE247', '\uDBB8\uDC33', ["sagittarius"], 1, 28, 63, 0],
        "2651": [['\u2651\uFE0F', '\u2651'], '\uE248', '\uDBB8\uDC34', ["capricorn"], 1, 29, 63, 0],
        "2652": [['\u2652\uFE0F', '\u2652'], '\uE249', '\uDBB8\uDC35', ["aquarius"], 1, 30, 63, 0],
        "2653": [['\u2653\uFE0F', '\u2653'], '\uE24A', '\uDBB8\uDC36', ["pisces"], 1, 31, 63, 0],
        "2660": [['\u2660\uFE0F', '\u2660'], '\uE20E', '\uDBBA\uDF1B', ["spades"], 1, 32, 63, 0],
        "2663": [['\u2663\uFE0F', '\u2663'], '\uE20F', '\uDBBA\uDF1D', ["clubs"], 1, 33, 63, 0],
        "2665": [['\u2665\uFE0F', '\u2665'], '\uE20C', '\uDBBA\uDF1A', ["hearts"], 1, 34, 63, 0],
        "2666": [['\u2666\uFE0F', '\u2666'], '\uE20D', '\uDBBA\uDF1C', ["diamonds"], 1, 35, 63, 0],
        "2668": [['\u2668\uFE0F', '\u2668'], '\uE123', '\uDBB9\uDFFA', ["hotsprings"], 1, 36, 63, 0],
        "267b": [['\u267B\uFE0F', '\u267B'], "", '\uDBBA\uDF2C', ["recycle"], 1, 37, 63, 0],
        "267f": [['\u267F\uFE0F', '\u267F'], '\uE20A', '\uDBBA\uDF20', ["wheelchair"], 1, 38, 63, 0],
        "2692": [['\u2692'], "", "", ["hammer_and_pick"], 1, 39, 31, 0],
        "2693": [['\u2693\uFE0F', '\u2693'], '\uE202', '\uDBB9\uDCC1', ["anchor"], 1, 40, 63, 0],
        "2694": [['\u2694\uFE0F', '\u2694'], "", "", ["crossed_swords"], 1, 41, 31, 0],
        "2695": [['\u2695'], "", "", ["staff_of_aesculapius"], 1, 42, 7, 0],
        "2696": [['\u2696\uFE0F', '\u2696'], "", "", ["scales"], 1, 43, 31, 0],
        "2697": [['\u2697\uFE0F', '\u2697'], "", "", ["alembic"], 1, 44, 31, 0],
        "2699": [['\u2699\uFE0F', '\u2699'], "", "", ["gear"], 1, 45, 31, 0],
        "269b": [['\u269B\uFE0F', '\u269B'], "", "", ["atom_symbol"], 1, 46, 31, 0],
        "269c": [['\u269C\uFE0F', '\u269C'], "", "", ["fleur_de_lis"], 1, 47, 31, 0],
        "26a0": [['\u26A0\uFE0F', '\u26A0'], '\uE252', '\uDBBA\uDF23', ["warning"], 1, 48, 63, 0],
        "26a1": [['\u26A1\uFE0F', '\u26A1'], '\uE13D', '\uDBB8\uDC04', ["zap"], 2, 0, 63, 0],
        "26aa": [['\u26AA\uFE0F', '\u26AA'], '\uE219', '\uDBBA\uDF65', ["white_circle"], 2, 1, 63, 0],
        "26ab": [['\u26AB\uFE0F', '\u26AB'], '\uE219', '\uDBBA\uDF66', ["black_circle"], 2, 2, 63, 0],
        "26b0": [['\u26B0\uFE0F', '\u26B0'], "", "", ["coffin"], 2, 3, 31, 0],
        "26b1": [['\u26B1\uFE0F', '\u26B1'], "", "", ["funeral_urn"], 2, 4, 31, 0],
        "26bd": [['\u26BD\uFE0F', '\u26BD'], '\uE018', '\uDBB9\uDFD4', ["soccer"], 2, 5, 63, 0],
        "26be": [['\u26BE\uFE0F', '\u26BE'], '\uE016', '\uDBB9\uDFD1', ["baseball"], 2, 6, 63, 0],
        "26c4": [['\u26C4\uFE0F', '\u26C4'], '\uE048', '\uDBB8\uDC03', ["snowman_without_snow"], 2, 7, 63, 0],
        "26c5": [['\u26C5\uFE0F', '\u26C5'], '\uE04A\uE049', '\uDBB8\uDC0F', ["partly_sunny"], 2, 8, 63, 0],
        "26c8": [['\u26C8'], "", "", ["thunder_cloud_and_rain"], 2, 9, 31, 0],
        "26ce": [['\u26CE'], '\uE24B', '\uDBB8\uDC37', ["ophiuchus"], 2, 10, 63, 0],
        "26cf": [['\u26CF'], "", "", ["pick"], 2, 11, 31, 0],
        "26d1": [['\u26D1'], "", "", ["helmet_with_white_cross"], 2, 12, 31, 0],
        "26d3": [['\u26D3'], "", "", ["chains"], 2, 13, 31, 0],
        "26d4": [['\u26D4\uFE0F', '\u26D4'], '\uE137', '\uDBBA\uDF26', ["no_entry"], 2, 14, 63, 0],
        "26e9": [['\u26E9'], "", "", ["shinto_shrine"], 2, 15, 31, 0],
        "26ea": [['\u26EA\uFE0F', '\u26EA'], '\uE037', '\uDBB9\uDCBB', ["church"], 2, 16, 63, 0],
        "26f0": [['\u26F0'], "", "", ["mountain"], 2, 17, 31, 0],
        "26f1": [['\u26F1'], "", "", ["umbrella_on_ground"], 2, 18, 31, 0],
        "26f2": [['\u26F2\uFE0F', '\u26F2'], '\uE121', '\uDBB9\uDCBC', ["fountain"], 2, 19, 63, 0],
        "26f3": [['\u26F3\uFE0F', '\u26F3'], '\uE014', '\uDBB9\uDFD2', ["golf"], 2, 20, 63, 0],
        "26f4": [['\u26F4'], "", "", ["ferry"], 2, 21, 31, 0],
        "26f5": [['\u26F5\uFE0F', '\u26F5'], '\uE01C', '\uDBB9\uDFEA', ["boat", "sailboat"], 2, 22, 63, 0],
        "26f7": [['\u26F7'], "", "", ["skier"], 2, 23, 31, 0],
        "26f8": [['\u26F8'], "", "", ["ice_skate"], 2, 24, 31, 0],
        "26fa": [['\u26FA\uFE0F', '\u26FA'], '\uE122', '\uDBB9\uDFFB', ["tent"], 2, 31, 63, 0],
        "26fd": [['\u26FD\uFE0F', '\u26FD'], '\uE03A', '\uDBB9\uDFF5', ["fuelpump"], 2, 32, 63, 0],
        "2702": [['\u2702\uFE0F', '\u2702'], '\uE313', '\uDBB9\uDD3E', ["scissors"], 2, 33, 63, 0],
        "2705": [['\u2705'], "", '\uDBBA\uDF4A', ["white_check_mark"], 2, 34, 63, 0],
        "2708": [['\u2708\uFE0F', '\u2708'], '\uE01D', '\uDBB9\uDFE9', ["airplane"], 2, 35, 63, 0],
        "2709": [['\u2709\uFE0F', '\u2709'], '\uE103', '\uDBB9\uDD29', ["email", "envelope"], 2, 36, 63, 0],
        "270a": [['\u270A'], '\uE010', '\uDBBA\uDF93', ["fist"], 2, 37, 63, 0],
        "270b": [['\u270B'], '\uE012', '\uDBBA\uDF95', ["hand", "raised_hand"], 2, 43, 63, 0],
        "270c": [['\u270C\uFE0F', '\u270C'], '\uE011', '\uDBBA\uDF94', ["v"], 3, 0, 63, 0],
        "270d": [['\u270D\uFE0F', '\u270D'], "", "", ["writing_hand"], 3, 6, 31, 0],
        "270f": [['\u270F\uFE0F', '\u270F'], '\uE301', '\uDBB9\uDD39', ["pencil2"], 3, 12, 63, 0],
        "2712": [['\u2712\uFE0F', '\u2712'], "", '\uDBB9\uDD36', ["black_nib"], 3, 13, 63, 0],
        "2714": [['\u2714\uFE0F', '\u2714'], "", '\uDBBA\uDF49', ["heavy_check_mark"], 3, 14, 63, 0],
        "2716": [['\u2716\uFE0F', '\u2716'], '\uE333', '\uDBBA\uDF53', ["heavy_multiplication_x"], 3, 15, 63, 0],
        "271d": [['\u271D\uFE0F', '\u271D'], "", "", ["latin_cross"], 3, 16, 31, 0],
        "2721": [['\u2721\uFE0F', '\u2721'], "", "", ["star_of_david"], 3, 17, 31, 0],
        "2728": [['\u2728'], '\uE32E', '\uDBBA\uDF60', ["sparkles"], 3, 18, 63, 0],
        "2733": [['\u2733\uFE0F', '\u2733'], '\uE206', '\uDBBA\uDF62', ["eight_spoked_asterisk"], 3, 19, 63, 0],
        "2734": [['\u2734\uFE0F', '\u2734'], '\uE205', '\uDBBA\uDF61', ["eight_pointed_black_star"], 3, 20, 63, 0],
        "2744": [['\u2744\uFE0F', '\u2744'], "", '\uDBB8\uDC0E', ["snowflake"], 3, 21, 63, 0],
        "2747": [['\u2747\uFE0F', '\u2747'], '\uE32E', '\uDBBA\uDF77', ["sparkle"], 3, 22, 63, 0],
        "274c": [['\u274C'], '\uE333', '\uDBBA\uDF45', ["x"], 3, 23, 63, 0],
        "274e": [['\u274E'], '\uE333', '\uDBBA\uDF46', ["negative_squared_cross_mark"], 3, 24, 63, 0],
        "2753": [['\u2753'], '\uE020', '\uDBBA\uDF09', ["question"], 3, 25, 63, 0],
        "2754": [['\u2754'], '\uE336', '\uDBBA\uDF0A', ["grey_question"], 3, 26, 63, 0],
        "2755": [['\u2755'], '\uE337', '\uDBBA\uDF0B', ["grey_exclamation"], 3, 27, 63, 0],
        "2757": [['\u2757\uFE0F', '\u2757'], '\uE021', '\uDBBA\uDF04', ["exclamation", "heavy_exclamation_mark"], 3, 28, 63, 0],
        "2763": [['\u2763\uFE0F', '\u2763'], "", "", ["heavy_heart_exclamation_mark_ornament"], 3, 29, 31, 0],
        "2764": [['\u2764\uFE0F', '\u2764'], '\uE022', '\uDBBA\uDF0C', ["heart"], 3, 30, 63, 0, "<3"],
        "2795": [['\u2795'], "", '\uDBBA\uDF51', ["heavy_plus_sign"], 3, 31, 63, 0],
        "2796": [['\u2796'], "", '\uDBBA\uDF52', ["heavy_minus_sign"], 3, 32, 63, 0],
        "2797": [['\u2797'], "", '\uDBBA\uDF54', ["heavy_division_sign"], 3, 33, 63, 0],
        "27a1": [['\u27A1\uFE0F', '\u27A1'], '\uE234', '\uDBBA\uDEFA', ["arrow_right"], 3, 34, 63, 0],
        "27b0": [['\u27B0'], "", '\uDBBA\uDF08', ["curly_loop"], 3, 35, 63, 0],
        "27bf": [['\u27BF'], '\uE211', '\uDBBA\uDC2B', ["loop"], 3, 36, 63, 0],
        "2934": [['\u2934\uFE0F', '\u2934'], '\uE236', '\uDBBA\uDEF4', ["arrow_heading_up"], 3, 37, 63, 0],
        "2935": [['\u2935\uFE0F', '\u2935'], '\uE238', '\uDBBA\uDEF5', ["arrow_heading_down"], 3, 38, 63, 0],
        "2b05": [['\u2B05\uFE0F', '\u2B05'], '\uE235', '\uDBBA\uDEFB', ["arrow_left"], 3, 39, 63, 0],
        "2b06": [['\u2B06\uFE0F', '\u2B06'], '\uE232', '\uDBBA\uDEF8', ["arrow_up"], 3, 40, 63, 0],
        "2b07": [['\u2B07\uFE0F', '\u2B07'], '\uE233', '\uDBBA\uDEF9', ["arrow_down"], 3, 41, 63, 0],
        "2b1b": [['\u2B1B\uFE0F', '\u2B1B'], '\uE21A', '\uDBBA\uDF6C', ["black_large_square"], 3, 42, 63, 0],
        "2b1c": [['\u2B1C\uFE0F', '\u2B1C'], '\uE21B', '\uDBBA\uDF6B', ["white_large_square"], 3, 43, 63, 0],
        "2b50": [['\u2B50\uFE0F', '\u2B50'], '\uE32F', '\uDBBA\uDF68', ["star"], 3, 44, 63, 0],
        "2b55": [['\u2B55\uFE0F', '\u2B55'], '\uE332', '\uDBBA\uDF44', ["o"], 3, 45, 63, 0],
        "3030": [['\u3030\uFE0F', '\u3030'], "", '\uDBBA\uDF07', ["wavy_dash"], 3, 46, 63, 0],
        "303d": [['\u303D\uFE0F', '\u303D'], '\uE12C', '\uDBBA\uDC1B', ["part_alternation_mark"], 3, 47, 63, 0],
        "3297": [['\u3297\uFE0F', '\u3297'], '\uE30D', '\uDBBA\uDF43', ["congratulations"], 3, 48, 63, 0],
        "3299": [['\u3299\uFE0F', '\u3299'], '\uE315', '\uDBBA\uDF2B', ["secret"], 4, 0, 63, 0],
        "1f004": [['\uD83C\uDC04\uFE0F', '\uD83C\uDC04'], '\uE12D', '\uDBBA\uDC0B', ["mahjong"], 4, 1, 63, 0],
        "1f0cf": [['\uD83C\uDCCF'], "", '\uDBBA\uDC12', ["black_joker"], 4, 2, 63, 0],
        "1f170": [['\uD83C\uDD70\uFE0F', '\uD83C\uDD70'], '\uE532', '\uDBB9\uDD0B', ["a"], 4, 3, 63, 0],
        "1f171": [['\uD83C\uDD71\uFE0F', '\uD83C\uDD71'], '\uE533', '\uDBB9\uDD0C', ["b"], 4, 4, 63, 0],
        "1f17e": [['\uD83C\uDD7E\uFE0F', '\uD83C\uDD7E'], '\uE535', '\uDBB9\uDD0E', ["o2"], 4, 5, 63, 0],
        "1f17f": [['\uD83C\uDD7F\uFE0F', '\uD83C\uDD7F'], '\uE14F', '\uDBB9\uDFF6', ["parking"], 4, 6, 63, 0],
        "1f18e": [['\uD83C\uDD8E'], '\uE534', '\uDBB9\uDD0D', ["ab"], 4, 7, 63, 0],
        "1f191": [['\uD83C\uDD91'], "", '\uDBBA\uDF84', ["cl"], 4, 8, 63, 0],
        "1f192": [['\uD83C\uDD92'], '\uE214', '\uDBBA\uDF38', ["cool"], 4, 9, 63, 0],
        "1f193": [['\uD83C\uDD93'], "", '\uDBBA\uDF21', ["free"], 4, 10, 63, 0],
        "1f194": [['\uD83C\uDD94'], '\uE229', '\uDBBA\uDF81', ["id"], 4, 11, 63, 0],
        "1f195": [['\uD83C\uDD95'], '\uE212', '\uDBBA\uDF36', ["new"], 4, 12, 63, 0],
        "1f196": [['\uD83C\uDD96'], "", '\uDBBA\uDF28', ["ng"], 4, 13, 63, 0],
        "1f197": [['\uD83C\uDD97'], '\uE24D', '\uDBBA\uDF27', ["ok"], 4, 14, 63, 0],
        "1f198": [['\uD83C\uDD98'], "", '\uDBBA\uDF4F', ["sos"], 4, 15, 63, 0],
        "1f199": [['\uD83C\uDD99'], '\uE213', '\uDBBA\uDF37', ["up"], 4, 16, 63, 0],
        "1f19a": [['\uD83C\uDD9A'], '\uE12E', '\uDBBA\uDF32', ["vs"], 4, 17, 63, 0],
        "1f201": [['\uD83C\uDE01'], '\uE203', '\uDBBA\uDF24', ["koko"], 4, 18, 63, 0],
        "1f202": [['\uD83C\uDE02\uFE0F', '\uD83C\uDE02'], '\uE228', '\uDBBA\uDF3F', ["sa"], 4, 19, 63, 0],
        "1f21a": [['\uD83C\uDE1A\uFE0F', '\uD83C\uDE1A'], '\uE216', '\uDBBA\uDF3A', ["u7121"], 4, 20, 63, 0],
        "1f22f": [['\uD83C\uDE2F\uFE0F', '\uD83C\uDE2F'], '\uE22C', '\uDBBA\uDF40', ["u6307"], 4, 21, 63, 0],
        "1f232": [['\uD83C\uDE32'], "", '\uDBBA\uDF2E', ["u7981"], 4, 22, 63, 0],
        "1f233": [['\uD83C\uDE33'], '\uE22B', '\uDBBA\uDF2F', ["u7a7a"], 4, 23, 63, 0],
        "1f234": [['\uD83C\uDE34'], "", '\uDBBA\uDF30', ["u5408"], 4, 24, 63, 0],
        "1f235": [['\uD83C\uDE35'], '\uE22A', '\uDBBA\uDF31', ["u6e80"], 4, 25, 63, 0],
        "1f236": [['\uD83C\uDE36'], '\uE215', '\uDBBA\uDF39', ["u6709"], 4, 26, 63, 0],
        "1f237": [['\uD83C\uDE37\uFE0F', '\uD83C\uDE37'], '\uE217', '\uDBBA\uDF3B', ["u6708"], 4, 27, 63, 0],
        "1f238": [['\uD83C\uDE38'], '\uE218', '\uDBBA\uDF3C', ["u7533"], 4, 28, 63, 0],
        "1f239": [['\uD83C\uDE39'], '\uE227', '\uDBBA\uDF3E', ["u5272"], 4, 29, 63, 0],
        "1f23a": [['\uD83C\uDE3A'], '\uE22D', '\uDBBA\uDF41', ["u55b6"], 4, 30, 63, 0],
        "1f250": [['\uD83C\uDE50'], '\uE226', '\uDBBA\uDF3D', ["ideograph_advantage"], 4, 31, 63, 0],
        "1f251": [['\uD83C\uDE51'], "", '\uDBBA\uDF50', ["accept"], 4, 32, 63, 0],
        "1f300": [['\uD83C\uDF00'], '\uE443', '\uDBB8\uDC05', ["cyclone"], 4, 33, 63, 0],
        "1f301": [['\uD83C\uDF01'], "", '\uDBB8\uDC06', ["foggy"], 4, 34, 63, 0],
        "1f302": [['\uD83C\uDF02'], '\uE43C', '\uDBB8\uDC07', ["closed_umbrella"], 4, 35, 63, 0],
        "1f303": [['\uD83C\uDF03'], '\uE44B', '\uDBB8\uDC08', ["night_with_stars"], 4, 36, 63, 0],
        "1f304": [['\uD83C\uDF04'], '\uE04D', '\uDBB8\uDC09', ["sunrise_over_mountains"], 4, 37, 63, 0],
        "1f305": [['\uD83C\uDF05'], '\uE449', '\uDBB8\uDC0A', ["sunrise"], 4, 38, 63, 0],
        "1f306": [['\uD83C\uDF06'], '\uE146', '\uDBB8\uDC0B', ["city_sunset"], 4, 39, 63, 0],
        "1f307": [['\uD83C\uDF07'], '\uE44A', '\uDBB8\uDC0C', ["city_sunrise"], 4, 40, 63, 0],
        "1f308": [['\uD83C\uDF08'], '\uE44C', '\uDBB8\uDC0D', ["rainbow"], 4, 41, 63, 0],
        "1f309": [['\uD83C\uDF09'], '\uE44B', '\uDBB8\uDC10', ["bridge_at_night"], 4, 42, 63, 0],
        "1f30a": [['\uD83C\uDF0A'], '\uE43E', '\uDBB8\uDC38', ["ocean"], 4, 43, 63, 0],
        "1f30b": [['\uD83C\uDF0B'], "", '\uDBB8\uDC3A', ["volcano"], 4, 44, 63, 0],
        "1f30c": [['\uD83C\uDF0C'], '\uE44B', '\uDBB8\uDC3B', ["milky_way"], 4, 45, 63, 0],
        "1f30d": [['\uD83C\uDF0D'], "", "", ["earth_africa"], 4, 46, 63, 0],
        "1f30e": [['\uD83C\uDF0E'], "", "", ["earth_americas"], 4, 47, 63, 0],
        "1f30f": [['\uD83C\uDF0F'], "", '\uDBB8\uDC39', ["earth_asia"], 4, 48, 63, 0],
        "1f310": [['\uD83C\uDF10'], "", "", ["globe_with_meridians"], 5, 0, 63, 0],
        "1f311": [['\uD83C\uDF11'], "", '\uDBB8\uDC11', ["new_moon"], 5, 1, 63, 0],
        "1f312": [['\uD83C\uDF12'], "", "", ["waxing_crescent_moon"], 5, 2, 63, 0],
        "1f313": [['\uD83C\uDF13'], '\uE04C', '\uDBB8\uDC13', ["first_quarter_moon"], 5, 3, 63, 0],
        "1f314": [['\uD83C\uDF14'], '\uE04C', '\uDBB8\uDC12', ["moon", "waxing_gibbous_moon"], 5, 4, 63, 0],
        "1f315": [['\uD83C\uDF15'], "", '\uDBB8\uDC15', ["full_moon"], 5, 5, 63, 0],
        "1f316": [['\uD83C\uDF16'], "", "", ["waning_gibbous_moon"], 5, 6, 63, 0],
        "1f317": [['\uD83C\uDF17'], "", "", ["last_quarter_moon"], 5, 7, 63, 0],
        "1f318": [['\uD83C\uDF18'], "", "", ["waning_crescent_moon"], 5, 8, 63, 0],
        "1f319": [['\uD83C\uDF19'], '\uE04C', '\uDBB8\uDC14', ["crescent_moon"], 5, 9, 63, 0],
        "1f31a": [['\uD83C\uDF1A'], "", "", ["new_moon_with_face"], 5, 10, 63, 0],
        "1f31b": [['\uD83C\uDF1B'], '\uE04C', '\uDBB8\uDC16', ["first_quarter_moon_with_face"], 5, 11, 63, 0],
        "1f31c": [['\uD83C\uDF1C'], "", "", ["last_quarter_moon_with_face"], 5, 12, 63, 0],
        "1f31d": [['\uD83C\uDF1D'], "", "", ["full_moon_with_face"], 5, 13, 63, 0],
        "1f31e": [['\uD83C\uDF1E'], "", "", ["sun_with_face"], 5, 14, 63, 0],
        "1f31f": [['\uD83C\uDF1F'], '\uE335', '\uDBBA\uDF69', ["star2"], 5, 15, 63, 0],
        "1f320": [['\uD83C\uDF20'], "", '\uDBBA\uDF6A', ["stars"], 5, 16, 63, 0],
        "1f321": [['\uD83C\uDF21'], "", "", ["thermometer"], 5, 17, 31, 0],
        "1f324": [['\uD83C\uDF24'], "", "", ["mostly_sunny", "sun_small_cloud"], 5, 18, 31, 0],
        "1f325": [['\uD83C\uDF25'], "", "", ["barely_sunny", "sun_behind_cloud"], 5, 19, 31, 0],
        "1f326": [['\uD83C\uDF26'], "", "", ["partly_sunny_rain", "sun_behind_rain_cloud"], 5, 20, 31, 0],
        "1f327": [['\uD83C\uDF27'], "", "", ["rain_cloud"], 5, 21, 31, 0],
        "1f328": [['\uD83C\uDF28'], "", "", ["snow_cloud"], 5, 22, 31, 0],
        "1f329": [['\uD83C\uDF29'], "", "", ["lightning", "lightning_cloud"], 5, 23, 31, 0],
        "1f32a": [['\uD83C\uDF2A'], "", "", ["tornado", "tornado_cloud"], 5, 24, 31, 0],
        "1f32b": [['\uD83C\uDF2B'], "", "", ["fog"], 5, 25, 31, 0],
        "1f32c": [['\uD83C\uDF2C'], "", "", ["wind_blowing_face"], 5, 26, 31, 0],
        "1f32d": [['\uD83C\uDF2D'], "", "", ["hotdog"], 5, 27, 31, 0],
        "1f32e": [['\uD83C\uDF2E'], "", "", ["taco"], 5, 28, 31, 0],
        "1f32f": [['\uD83C\uDF2F'], "", "", ["burrito"], 5, 29, 31, 0],
        "1f330": [['\uD83C\uDF30'], "", '\uDBB8\uDC4C', ["chestnut"], 5, 30, 63, 0],
        "1f331": [['\uD83C\uDF31'], '\uE110', '\uDBB8\uDC3E', ["seedling"], 5, 31, 63, 0],
        "1f332": [['\uD83C\uDF32'], "", "", ["evergreen_tree"], 5, 32, 63, 0],
        "1f333": [['\uD83C\uDF33'], "", "", ["deciduous_tree"], 5, 33, 63, 0],
        "1f334": [['\uD83C\uDF34'], '\uE307', '\uDBB8\uDC47', ["palm_tree"], 5, 34, 63, 0],
        "1f335": [['\uD83C\uDF35'], '\uE308', '\uDBB8\uDC48', ["cactus"], 5, 35, 63, 0],
        "1f336": [['\uD83C\uDF36'], "", "", ["hot_pepper"], 5, 36, 31, 0],
        "1f337": [['\uD83C\uDF37'], '\uE304', '\uDBB8\uDC3D', ["tulip"], 5, 37, 63, 0],
        "1f338": [['\uD83C\uDF38'], '\uE030', '\uDBB8\uDC40', ["cherry_blossom"], 5, 38, 63, 0],
        "1f339": [['\uD83C\uDF39'], '\uE032', '\uDBB8\uDC41', ["rose"], 5, 39, 63, 0],
        "1f33a": [['\uD83C\uDF3A'], '\uE303', '\uDBB8\uDC45', ["hibiscus"], 5, 40, 63, 0],
        "1f33b": [['\uD83C\uDF3B'], '\uE305', '\uDBB8\uDC46', ["sunflower"], 5, 41, 63, 0],
        "1f33c": [['\uD83C\uDF3C'], '\uE305', '\uDBB8\uDC4D', ["blossom"], 5, 42, 63, 0],
        "1f33d": [['\uD83C\uDF3D'], "", '\uDBB8\uDC4A', ["corn"], 5, 43, 63, 0],
        "1f33e": [['\uD83C\uDF3E'], '\uE444', '\uDBB8\uDC49', ["ear_of_rice"], 5, 44, 63, 0],
        "1f33f": [['\uD83C\uDF3F'], '\uE110', '\uDBB8\uDC4E', ["herb"], 5, 45, 63, 0],
        "1f340": [['\uD83C\uDF40'], '\uE110', '\uDBB8\uDC3C', ["four_leaf_clover"], 5, 46, 63, 0],
        "1f341": [['\uD83C\uDF41'], '\uE118', '\uDBB8\uDC3F', ["maple_leaf"], 5, 47, 63, 0],
        "1f342": [['\uD83C\uDF42'], '\uE119', '\uDBB8\uDC42', ["fallen_leaf"], 5, 48, 63, 0],
        "1f343": [['\uD83C\uDF43'], '\uE447', '\uDBB8\uDC43', ["leaves"], 6, 0, 63, 0],
        "1f344": [['\uD83C\uDF44'], "", '\uDBB8\uDC4B', ["mushroom"], 6, 1, 63, 0],
        "1f345": [['\uD83C\uDF45'], '\uE349', '\uDBB8\uDC55', ["tomato"], 6, 2, 63, 0],
        "1f346": [['\uD83C\uDF46'], '\uE34A', '\uDBB8\uDC56', ["eggplant"], 6, 3, 63, 0],
        "1f347": [['\uD83C\uDF47'], "", '\uDBB8\uDC59', ["grapes"], 6, 4, 63, 0],
        "1f348": [['\uD83C\uDF48'], "", '\uDBB8\uDC57', ["melon"], 6, 5, 63, 0],
        "1f349": [['\uD83C\uDF49'], '\uE348', '\uDBB8\uDC54', ["watermelon"], 6, 6, 63, 0],
        "1f34a": [['\uD83C\uDF4A'], '\uE346', '\uDBB8\uDC52', ["tangerine"], 6, 7, 63, 0],
        "1f34b": [['\uD83C\uDF4B'], "", "", ["lemon"], 6, 8, 63, 0],
        "1f34c": [['\uD83C\uDF4C'], "", '\uDBB8\uDC50', ["banana"], 6, 9, 63, 0],
        "1f34d": [['\uD83C\uDF4D'], "", '\uDBB8\uDC58', ["pineapple"], 6, 10, 63, 0],
        "1f34e": [['\uD83C\uDF4E'], '\uE345', '\uDBB8\uDC51', ["apple"], 6, 11, 63, 0],
        "1f34f": [['\uD83C\uDF4F'], '\uE345', '\uDBB8\uDC5B', ["green_apple"], 6, 12, 63, 0],
        "1f350": [['\uD83C\uDF50'], "", "", ["pear"], 6, 13, 63, 0],
        "1f351": [['\uD83C\uDF51'], "", '\uDBB8\uDC5A', ["peach"], 6, 14, 63, 0],
        "1f352": [['\uD83C\uDF52'], "", '\uDBB8\uDC4F', ["cherries"], 6, 15, 63, 0],
        "1f353": [['\uD83C\uDF53'], '\uE347', '\uDBB8\uDC53', ["strawberry"], 6, 16, 63, 0],
        "1f354": [['\uD83C\uDF54'], '\uE120', '\uDBBA\uDD60', ["hamburger"], 6, 17, 63, 0],
        "1f355": [['\uD83C\uDF55'], "", '\uDBBA\uDD75', ["pizza"], 6, 18, 63, 0],
        "1f356": [['\uD83C\uDF56'], "", '\uDBBA\uDD72', ["meat_on_bone"], 6, 19, 63, 0],
        "1f357": [['\uD83C\uDF57'], "", '\uDBBA\uDD76', ["poultry_leg"], 6, 20, 63, 0],
        "1f358": [['\uD83C\uDF58'], '\uE33D', '\uDBBA\uDD69', ["rice_cracker"], 6, 21, 63, 0],
        "1f359": [['\uD83C\uDF59'], '\uE342', '\uDBBA\uDD61', ["rice_ball"], 6, 22, 63, 0],
        "1f35a": [['\uD83C\uDF5A'], '\uE33E', '\uDBBA\uDD6A', ["rice"], 6, 23, 63, 0],
        "1f35b": [['\uD83C\uDF5B'], '\uE341', '\uDBBA\uDD6C', ["curry"], 6, 24, 63, 0],
        "1f35c": [['\uD83C\uDF5C'], '\uE340', '\uDBBA\uDD63', ["ramen"], 6, 25, 63, 0],
        "1f35d": [['\uD83C\uDF5D'], '\uE33F', '\uDBBA\uDD6B', ["spaghetti"], 6, 26, 63, 0],
        "1f35e": [['\uD83C\uDF5E'], '\uE339', '\uDBBA\uDD64', ["bread"], 6, 27, 63, 0],
        "1f35f": [['\uD83C\uDF5F'], '\uE33B', '\uDBBA\uDD67', ["fries"], 6, 28, 63, 0],
        "1f360": [['\uD83C\uDF60'], "", '\uDBBA\uDD74', ["sweet_potato"], 6, 29, 63, 0],
        "1f361": [['\uD83C\uDF61'], '\uE33C', '\uDBBA\uDD68', ["dango"], 6, 30, 63, 0],
        "1f362": [['\uD83C\uDF62'], '\uE343', '\uDBBA\uDD6D', ["oden"], 6, 31, 63, 0],
        "1f363": [['\uD83C\uDF63'], '\uE344', '\uDBBA\uDD6E', ["sushi"], 6, 32, 63, 0],
        "1f364": [['\uD83C\uDF64'], "", '\uDBBA\uDD7F', ["fried_shrimp"], 6, 33, 63, 0],
        "1f365": [['\uD83C\uDF65'], "", '\uDBBA\uDD73', ["fish_cake"], 6, 34, 63, 0],
        "1f366": [['\uD83C\uDF66'], '\uE33A', '\uDBBA\uDD66', ["icecream"], 6, 35, 63, 0],
        "1f367": [['\uD83C\uDF67'], '\uE43F', '\uDBBA\uDD71', ["shaved_ice"], 6, 36, 63, 0],
        "1f368": [['\uD83C\uDF68'], "", '\uDBBA\uDD77', ["ice_cream"], 6, 37, 63, 0],
        "1f369": [['\uD83C\uDF69'], "", '\uDBBA\uDD78', ["doughnut"], 6, 38, 63, 0],
        "1f36a": [['\uD83C\uDF6A'], "", '\uDBBA\uDD79', ["cookie"], 6, 39, 63, 0],
        "1f36b": [['\uD83C\uDF6B'], "", '\uDBBA\uDD7A', ["chocolate_bar"], 6, 40, 63, 0],
        "1f36c": [['\uD83C\uDF6C'], "", '\uDBBA\uDD7B', ["candy"], 6, 41, 63, 0],
        "1f36d": [['\uD83C\uDF6D'], "", '\uDBBA\uDD7C', ["lollipop"], 6, 42, 63, 0],
        "1f36e": [['\uD83C\uDF6E'], "", '\uDBBA\uDD7D', ["custard"], 6, 43, 63, 0],
        "1f36f": [['\uD83C\uDF6F'], "", '\uDBBA\uDD7E', ["honey_pot"], 6, 44, 63, 0],
        "1f370": [['\uD83C\uDF70'], '\uE046', '\uDBBA\uDD62', ["cake"], 6, 45, 63, 0],
        "1f371": [['\uD83C\uDF71'], '\uE34C', '\uDBBA\uDD6F', ["bento"], 6, 46, 63, 0],
        "1f372": [['\uD83C\uDF72'], '\uE34D', '\uDBBA\uDD70', ["stew"], 6, 47, 63, 0],
        "1f373": [['\uD83C\uDF73'], '\uE147', '\uDBBA\uDD65', ["fried_egg", "cooking"], 6, 48, 63, 0],
        "1f374": [['\uD83C\uDF74'], '\uE043', '\uDBBA\uDD80', ["fork_and_knife"], 7, 0, 63, 0],
        "1f375": [['\uD83C\uDF75'], '\uE338', '\uDBBA\uDD84', ["tea"], 7, 1, 63, 0],
        "1f376": [['\uD83C\uDF76'], '\uE30B', '\uDBBA\uDD85', ["sake"], 7, 2, 63, 0],
        "1f377": [['\uD83C\uDF77'], '\uE044', '\uDBBA\uDD86', ["wine_glass"], 7, 3, 63, 0],
        "1f378": [['\uD83C\uDF78'], '\uE044', '\uDBBA\uDD82', ["cocktail"], 7, 4, 63, 0],
        "1f379": [['\uD83C\uDF79'], '\uE044', '\uDBBA\uDD88', ["tropical_drink"], 7, 5, 63, 0],
        "1f37a": [['\uD83C\uDF7A'], '\uE047', '\uDBBA\uDD83', ["beer"], 7, 6, 63, 0],
        "1f37b": [['\uD83C\uDF7B'], '\uE30C', '\uDBBA\uDD87', ["beers"], 7, 7, 63, 0],
        "1f37c": [['\uD83C\uDF7C'], "", "", ["baby_bottle"], 7, 8, 63, 0],
        "1f37d": [['\uD83C\uDF7D'], "", "", ["knife_fork_plate"], 7, 9, 31, 0],
        "1f37e": [['\uD83C\uDF7E'], "", "", ["champagne"], 7, 10, 31, 0],
        "1f37f": [['\uD83C\uDF7F'], "", "", ["popcorn"], 7, 11, 31, 0],
        "1f380": [['\uD83C\uDF80'], '\uE314', '\uDBB9\uDD0F', ["ribbon"], 7, 12, 63, 0],
        "1f381": [['\uD83C\uDF81'], '\uE112', '\uDBB9\uDD10', ["gift"], 7, 13, 63, 0],
        "1f382": [['\uD83C\uDF82'], '\uE34B', '\uDBB9\uDD11', ["birthday"], 7, 14, 63, 0],
        "1f383": [['\uD83C\uDF83'], '\uE445', '\uDBB9\uDD1F', ["jack_o_lantern"], 7, 15, 63, 0],
        "1f384": [['\uD83C\uDF84'], '\uE033', '\uDBB9\uDD12', ["christmas_tree"], 7, 16, 63, 0],
        "1f385": [['\uD83C\uDF85'], '\uE448', '\uDBB9\uDD13', ["santa"], 7, 17, 63, 0],
        "1f386": [['\uD83C\uDF86'], '\uE117', '\uDBB9\uDD15', ["fireworks"], 7, 23, 63, 0],
        "1f387": [['\uD83C\uDF87'], '\uE440', '\uDBB9\uDD1D', ["sparkler"], 7, 24, 63, 0],
        "1f388": [['\uD83C\uDF88'], '\uE310', '\uDBB9\uDD16', ["balloon"], 7, 25, 63, 0],
        "1f389": [['\uD83C\uDF89'], '\uE312', '\uDBB9\uDD17', ["tada"], 7, 26, 63, 0],
        "1f38a": [['\uD83C\uDF8A'], "", '\uDBB9\uDD20', ["confetti_ball"], 7, 27, 63, 0],
        "1f38b": [['\uD83C\uDF8B'], "", '\uDBB9\uDD21', ["tanabata_tree"], 7, 28, 63, 0],
        "1f38c": [['\uD83C\uDF8C'], '\uE143', '\uDBB9\uDD14', ["crossed_flags"], 7, 29, 63, 0],
        "1f38d": [['\uD83C\uDF8D'], '\uE436', '\uDBB9\uDD18', ["bamboo"], 7, 30, 63, 0],
        "1f38e": [['\uD83C\uDF8E'], '\uE438', '\uDBB9\uDD19', ["dolls"], 7, 31, 63, 0],
        "1f38f": [['\uD83C\uDF8F'], '\uE43B', '\uDBB9\uDD1C', ["flags"], 7, 32, 63, 0],
        "1f390": [['\uD83C\uDF90'], '\uE442', '\uDBB9\uDD1E', ["wind_chime"], 7, 33, 63, 0],
        "1f391": [['\uD83C\uDF91'], '\uE446', '\uDBB8\uDC17', ["rice_scene"], 7, 34, 63, 0],
        "1f392": [['\uD83C\uDF92'], '\uE43A', '\uDBB9\uDD1B', ["school_satchel"], 7, 35, 63, 0],
        "1f393": [['\uD83C\uDF93'], '\uE439', '\uDBB9\uDD1A', ["mortar_board"], 7, 36, 63, 0],
        "1f396": [['\uD83C\uDF96'], "", "", ["medal"], 7, 37, 31, 0],
        "1f397": [['\uD83C\uDF97'], "", "", ["reminder_ribbon"], 7, 38, 31, 0],
        "1f399": [['\uD83C\uDF99'], "", "", ["studio_microphone"], 7, 39, 31, 0],
        "1f39a": [['\uD83C\uDF9A'], "", "", ["level_slider"], 7, 40, 31, 0],
        "1f39b": [['\uD83C\uDF9B'], "", "", ["control_knobs"], 7, 41, 31, 0],
        "1f39e": [['\uD83C\uDF9E'], "", "", ["film_frames"], 7, 42, 31, 0],
        "1f39f": [['\uD83C\uDF9F'], "", "", ["admission_tickets"], 7, 43, 31, 0],
        "1f3a0": [['\uD83C\uDFA0'], "", '\uDBB9\uDFFC', ["carousel_horse"], 7, 44, 63, 0],
        "1f3a1": [['\uD83C\uDFA1'], '\uE124', '\uDBB9\uDFFD', ["ferris_wheel"], 7, 45, 63, 0],
        "1f3a2": [['\uD83C\uDFA2'], '\uE433', '\uDBB9\uDFFE', ["roller_coaster"], 7, 46, 63, 0],
        "1f3a3": [['\uD83C\uDFA3'], '\uE019', '\uDBB9\uDFFF', ["fishing_pole_and_fish"], 7, 47, 63, 0],
        "1f3a4": [['\uD83C\uDFA4'], '\uE03C', '\uDBBA\uDC00', ["microphone"], 7, 48, 63, 0],
        "1f3a5": [['\uD83C\uDFA5'], '\uE03D', '\uDBBA\uDC01', ["movie_camera"], 8, 0, 63, 0],
        "1f3a6": [['\uD83C\uDFA6'], '\uE507', '\uDBBA\uDC02', ["cinema"], 8, 1, 63, 0],
        "1f3a7": [['\uD83C\uDFA7'], '\uE30A', '\uDBBA\uDC03', ["headphones"], 8, 2, 63, 0],
        "1f3a8": [['\uD83C\uDFA8'], '\uE502', '\uDBBA\uDC04', ["art"], 8, 3, 63, 0],
        "1f3a9": [['\uD83C\uDFA9'], '\uE503', '\uDBBA\uDC05', ["tophat"], 8, 4, 63, 0],
        "1f3aa": [['\uD83C\uDFAA'], "", '\uDBBA\uDC06', ["circus_tent"], 8, 5, 63, 0],
        "1f3ab": [['\uD83C\uDFAB'], '\uE125', '\uDBBA\uDC07', ["ticket"], 8, 6, 63, 0],
        "1f3ac": [['\uD83C\uDFAC'], '\uE324', '\uDBBA\uDC08', ["clapper"], 8, 7, 63, 0],
        "1f3ad": [['\uD83C\uDFAD'], '\uE503', '\uDBBA\uDC09', ["performing_arts"], 8, 8, 63, 0],
        "1f3ae": [['\uD83C\uDFAE'], "", '\uDBBA\uDC0A', ["video_game"], 8, 9, 63, 0],
        "1f3af": [['\uD83C\uDFAF'], '\uE130', '\uDBBA\uDC0C', ["dart"], 8, 10, 63, 0],
        "1f3b0": [['\uD83C\uDFB0'], '\uE133', '\uDBBA\uDC0D', ["slot_machine"], 8, 11, 63, 0],
        "1f3b1": [['\uD83C\uDFB1'], '\uE42C', '\uDBBA\uDC0E', ["8ball"], 8, 12, 63, 0],
        "1f3b2": [['\uD83C\uDFB2'], "", '\uDBBA\uDC0F', ["game_die"], 8, 13, 63, 0],
        "1f3b3": [['\uD83C\uDFB3'], "", '\uDBBA\uDC10', ["bowling"], 8, 14, 63, 0],
        "1f3b4": [['\uD83C\uDFB4'], "", '\uDBBA\uDC11', ["flower_playing_cards"], 8, 15, 63, 0],
        "1f3b5": [['\uD83C\uDFB5'], '\uE03E', '\uDBBA\uDC13', ["musical_note"], 8, 16, 63, 0],
        "1f3b6": [['\uD83C\uDFB6'], '\uE326', '\uDBBA\uDC14', ["notes"], 8, 17, 63, 0],
        "1f3b7": [['\uD83C\uDFB7'], '\uE040', '\uDBBA\uDC15', ["saxophone"], 8, 18, 63, 0],
        "1f3b8": [['\uD83C\uDFB8'], '\uE041', '\uDBBA\uDC16', ["guitar"], 8, 19, 63, 0],
        "1f3b9": [['\uD83C\uDFB9'], "", '\uDBBA\uDC17', ["musical_keyboard"], 8, 20, 63, 0],
        "1f3ba": [['\uD83C\uDFBA'], '\uE042', '\uDBBA\uDC18', ["trumpet"], 8, 21, 63, 0],
        "1f3bb": [['\uD83C\uDFBB'], "", '\uDBBA\uDC19', ["violin"], 8, 22, 63, 0],
        "1f3bc": [['\uD83C\uDFBC'], '\uE326', '\uDBBA\uDC1A', ["musical_score"], 8, 23, 63, 0],
        "1f3bd": [['\uD83C\uDFBD'], "", '\uDBB9\uDFD0', ["running_shirt_with_sash"], 8, 24, 63, 0],
        "1f3be": [['\uD83C\uDFBE'], '\uE015', '\uDBB9\uDFD3', ["tennis"], 8, 25, 63, 0],
        "1f3bf": [['\uD83C\uDFBF'], '\uE013', '\uDBB9\uDFD5', ["ski"], 8, 26, 63, 0],
        "1f3c0": [['\uD83C\uDFC0'], '\uE42A', '\uDBB9\uDFD6', ["basketball"], 8, 27, 63, 0],
        "1f3c1": [['\uD83C\uDFC1'], '\uE132', '\uDBB9\uDFD7', ["checkered_flag"], 8, 28, 63, 0],
        "1f3c2": [['\uD83C\uDFC2'], "", '\uDBB9\uDFD8', ["snowboarder"], 8, 29, 63, 0],
        "1f3c5": [['\uD83C\uDFC5'], "", "", ["sports_medal"], 8, 47, 31, 0],
        "1f3c6": [['\uD83C\uDFC6'], '\uE131', '\uDBB9\uDFDB', ["trophy"], 8, 48, 63, 0],
        "1f3c7": [['\uD83C\uDFC7'], "", "", ["horse_racing"], 9, 0, 63, 0],
        "1f3c8": [['\uD83C\uDFC8'], '\uE42B', '\uDBB9\uDFDD', ["football"], 9, 6, 63, 0],
        "1f3c9": [['\uD83C\uDFC9'], "", "", ["rugby_football"], 9, 7, 63, 0],
        "1f3cd": [['\uD83C\uDFCD'], "", "", ["racing_motorcycle"], 9, 26, 31, 0],
        "1f3ce": [['\uD83C\uDFCE'], "", "", ["racing_car"], 9, 27, 31, 0],
        "1f3cf": [['\uD83C\uDFCF'], "", "", ["cricket_bat_and_ball"], 9, 28, 31, 0],
        "1f3d0": [['\uD83C\uDFD0'], "", "", ["volleyball"], 9, 29, 31, 0],
        "1f3d1": [['\uD83C\uDFD1'], "", "", ["field_hockey_stick_and_ball"], 9, 30, 31, 0],
        "1f3d2": [['\uD83C\uDFD2'], "", "", ["ice_hockey_stick_and_puck"], 9, 31, 31, 0],
        "1f3d3": [['\uD83C\uDFD3'], "", "", ["table_tennis_paddle_and_ball"], 9, 32, 31, 0],
        "1f3d4": [['\uD83C\uDFD4'], "", "", ["snow_capped_mountain"], 9, 33, 31, 0],
        "1f3d5": [['\uD83C\uDFD5'], "", "", ["camping"], 9, 34, 31, 0],
        "1f3d6": [['\uD83C\uDFD6'], "", "", ["beach_with_umbrella"], 9, 35, 31, 0],
        "1f3d7": [['\uD83C\uDFD7'], "", "", ["building_construction"], 9, 36, 31, 0],
        "1f3d8": [['\uD83C\uDFD8'], "", "", ["house_buildings"], 9, 37, 31, 0],
        "1f3d9": [['\uD83C\uDFD9'], "", "", ["cityscape"], 9, 38, 31, 0],
        "1f3da": [['\uD83C\uDFDA'], "", "", ["derelict_house_building"], 9, 39, 31, 0],
        "1f3db": [['\uD83C\uDFDB'], "", "", ["classical_building"], 9, 40, 31, 0],
        "1f3dc": [['\uD83C\uDFDC'], "", "", ["desert"], 9, 41, 31, 0],
        "1f3dd": [['\uD83C\uDFDD'], "", "", ["desert_island"], 9, 42, 31, 0],
        "1f3de": [['\uD83C\uDFDE'], "", "", ["national_park"], 9, 43, 31, 0],
        "1f3df": [['\uD83C\uDFDF'], "", "", ["stadium"], 9, 44, 31, 0],
        "1f3e0": [['\uD83C\uDFE0'], '\uE036', '\uDBB9\uDCB0', ["house"], 9, 45, 63, 0],
        "1f3e1": [['\uD83C\uDFE1'], '\uE036', '\uDBB9\uDCB1', ["house_with_garden"], 9, 46, 63, 0],
        "1f3e2": [['\uD83C\uDFE2'], '\uE038', '\uDBB9\uDCB2', ["office"], 9, 47, 63, 0],
        "1f3e3": [['\uD83C\uDFE3'], '\uE153', '\uDBB9\uDCB3', ["post_office"], 9, 48, 63, 0],
        "1f3e4": [['\uD83C\uDFE4'], "", "", ["european_post_office"], 10, 0, 63, 0],
        "1f3e5": [['\uD83C\uDFE5'], '\uE155', '\uDBB9\uDCB4', ["hospital"], 10, 1, 63, 0],
        "1f3e6": [['\uD83C\uDFE6'], '\uE14D', '\uDBB9\uDCB5', ["bank"], 10, 2, 63, 0],
        "1f3e7": [['\uD83C\uDFE7'], '\uE154', '\uDBB9\uDCB6', ["atm"], 10, 3, 63, 0],
        "1f3e8": [['\uD83C\uDFE8'], '\uE158', '\uDBB9\uDCB7', ["hotel"], 10, 4, 63, 0],
        "1f3e9": [['\uD83C\uDFE9'], '\uE501', '\uDBB9\uDCB8', ["love_hotel"], 10, 5, 63, 0],
        "1f3ea": [['\uD83C\uDFEA'], '\uE156', '\uDBB9\uDCB9', ["convenience_store"], 10, 6, 63, 0],
        "1f3eb": [['\uD83C\uDFEB'], '\uE157', '\uDBB9\uDCBA', ["school"], 10, 7, 63, 0],
        "1f3ec": [['\uD83C\uDFEC'], '\uE504', '\uDBB9\uDCBD', ["department_store"], 10, 8, 63, 0],
        "1f3ed": [['\uD83C\uDFED'], '\uE508', '\uDBB9\uDCC0', ["factory"], 10, 9, 63, 0],
        "1f3ee": [['\uD83C\uDFEE'], '\uE30B', '\uDBB9\uDCC2', ["izakaya_lantern", "lantern"], 10, 10, 63, 0],
        "1f3ef": [['\uD83C\uDFEF'], '\uE505', '\uDBB9\uDCBE', ["japanese_castle"], 10, 11, 63, 0],
        "1f3f0": [['\uD83C\uDFF0'], '\uE506', '\uDBB9\uDCBF', ["european_castle"], 10, 12, 63, 0],
        "1f3f3": [['\uD83C\uDFF3\uFE0F', '\uD83C\uDFF3'], "", "", ["waving_white_flag"], 10, 13, 31, 0],
        "1f3f4": [['\uD83C\uDFF4'], "", "", ["waving_black_flag"], 10, 14, 31, 0],
        "1f3f5": [['\uD83C\uDFF5'], "", "", ["rosette"], 10, 15, 31, 0],
        "1f3f7": [['\uD83C\uDFF7'], "", "", ["label"], 10, 16, 31, 0],
        "1f3f8": [['\uD83C\uDFF8'], "", "", ["badminton_racquet_and_shuttlecock"], 10, 17, 31, 0],
        "1f3f9": [['\uD83C\uDFF9'], "", "", ["bow_and_arrow"], 10, 18, 31, 0],
        "1f3fa": [['\uD83C\uDFFA'], "", "", ["amphora"], 10, 19, 31, 0],
        "1f3fb": [['\uD83C\uDFFB'], "", "", ["skin-tone-2"], 10, 20, 31, 0],
        "1f3fc": [['\uD83C\uDFFC'], "", "", ["skin-tone-3"], 10, 21, 31, 0],
        "1f3fd": [['\uD83C\uDFFD'], "", "", ["skin-tone-4"], 10, 22, 31, 0],
        "1f3fe": [['\uD83C\uDFFE'], "", "", ["skin-tone-5"], 10, 23, 31, 0],
        "1f3ff": [['\uD83C\uDFFF'], "", "", ["skin-tone-6"], 10, 24, 31, 0],
        "1f400": [['\uD83D\uDC00'], "", "", ["rat"], 10, 25, 63, 0],
        "1f401": [['\uD83D\uDC01'], "", "", ["mouse2"], 10, 26, 63, 0],
        "1f402": [['\uD83D\uDC02'], "", "", ["ox"], 10, 27, 63, 0],
        "1f403": [['\uD83D\uDC03'], "", "", ["water_buffalo"], 10, 28, 63, 0],
        "1f404": [['\uD83D\uDC04'], "", "", ["cow2"], 10, 29, 63, 0],
        "1f405": [['\uD83D\uDC05'], "", "", ["tiger2"], 10, 30, 63, 0],
        "1f406": [['\uD83D\uDC06'], "", "", ["leopard"], 10, 31, 63, 0],
        "1f407": [['\uD83D\uDC07'], "", "", ["rabbit2"], 10, 32, 63, 0],
        "1f408": [['\uD83D\uDC08'], "", "", ["cat2"], 10, 33, 63, 0],
        "1f409": [['\uD83D\uDC09'], "", "", ["dragon"], 10, 34, 63, 0],
        "1f40a": [['\uD83D\uDC0A'], "", "", ["crocodile"], 10, 35, 63, 0],
        "1f40b": [['\uD83D\uDC0B'], "", "", ["whale2"], 10, 36, 63, 0],
        "1f40c": [['\uD83D\uDC0C'], "", '\uDBB8\uDDB9', ["snail"], 10, 37, 63, 0],
        "1f40d": [['\uD83D\uDC0D'], '\uE52D', '\uDBB8\uDDD3', ["snake"], 10, 38, 63, 0],
        "1f40e": [['\uD83D\uDC0E'], '\uE134', '\uDBB9\uDFDC', ["racehorse"], 10, 39, 63, 0],
        "1f40f": [['\uD83D\uDC0F'], "", "", ["ram"], 10, 40, 63, 0],
        "1f410": [['\uD83D\uDC10'], "", "", ["goat"], 10, 41, 63, 0],
        "1f411": [['\uD83D\uDC11'], '\uE529', '\uDBB8\uDDCF', ["sheep"], 10, 42, 63, 0],
        "1f412": [['\uD83D\uDC12'], '\uE528', '\uDBB8\uDDCE', ["monkey"], 10, 43, 63, 0],
        "1f413": [['\uD83D\uDC13'], "", "", ["rooster"], 10, 44, 63, 0],
        "1f414": [['\uD83D\uDC14'], '\uE52E', '\uDBB8\uDDD4', ["chicken"], 10, 45, 63, 0],
        "1f415": [['\uD83D\uDC15'], "", "", ["dog2"], 10, 46, 63, 0],
        "1f416": [['\uD83D\uDC16'], "", "", ["pig2"], 10, 47, 63, 0],
        "1f417": [['\uD83D\uDC17'], '\uE52F', '\uDBB8\uDDD5', ["boar"], 10, 48, 63, 0],
        "1f418": [['\uD83D\uDC18'], '\uE526', '\uDBB8\uDDCC', ["elephant"], 11, 0, 63, 0],
        "1f419": [['\uD83D\uDC19'], '\uE10A', '\uDBB8\uDDC5', ["octopus"], 11, 1, 63, 0],
        "1f41a": [['\uD83D\uDC1A'], '\uE441', '\uDBB8\uDDC6', ["shell"], 11, 2, 63, 0],
        "1f41b": [['\uD83D\uDC1B'], '\uE525', '\uDBB8\uDDCB', ["bug"], 11, 3, 63, 0],
        "1f41c": [['\uD83D\uDC1C'], "", '\uDBB8\uDDDA', ["ant"], 11, 4, 63, 0],
        "1f41d": [['\uD83D\uDC1D'], "", '\uDBB8\uDDE1', ["bee", "honeybee"], 11, 5, 63, 0],
        "1f41e": [['\uD83D\uDC1E'], "", '\uDBB8\uDDE2', ["beetle"], 11, 6, 63, 0],
        "1f41f": [['\uD83D\uDC1F'], '\uE019', '\uDBB8\uDDBD', ["fish"], 11, 7, 63, 0],
        "1f420": [['\uD83D\uDC20'], '\uE522', '\uDBB8\uDDC9', ["tropical_fish"], 11, 8, 63, 0],
        "1f421": [['\uD83D\uDC21'], '\uE019', '\uDBB8\uDDD9', ["blowfish"], 11, 9, 63, 0],
        "1f422": [['\uD83D\uDC22'], "", '\uDBB8\uDDDC', ["turtle"], 11, 10, 63, 0],
        "1f423": [['\uD83D\uDC23'], '\uE523', '\uDBB8\uDDDD', ["hatching_chick"], 11, 11, 63, 0],
        "1f424": [['\uD83D\uDC24'], '\uE523', '\uDBB8\uDDBA', ["baby_chick"], 11, 12, 63, 0],
        "1f425": [['\uD83D\uDC25'], '\uE523', '\uDBB8\uDDBB', ["hatched_chick"], 11, 13, 63, 0],
        "1f426": [['\uD83D\uDC26'], '\uE521', '\uDBB8\uDDC8', ["bird"], 11, 14, 63, 0],
        "1f427": [['\uD83D\uDC27'], '\uE055', '\uDBB8\uDDBC', ["penguin"], 11, 15, 63, 0],
        "1f428": [['\uD83D\uDC28'], '\uE527', '\uDBB8\uDDCD', ["koala"], 11, 16, 63, 0],
        "1f429": [['\uD83D\uDC29'], '\uE052', '\uDBB8\uDDD8', ["poodle"], 11, 17, 63, 0],
        "1f42a": [['\uD83D\uDC2A'], "", "", ["dromedary_camel"], 11, 18, 63, 0],
        "1f42b": [['\uD83D\uDC2B'], '\uE530', '\uDBB8\uDDD6', ["camel"], 11, 19, 63, 0],
        "1f42c": [['\uD83D\uDC2C'], '\uE520', '\uDBB8\uDDC7', ["dolphin", "flipper"], 11, 20, 63, 0],
        "1f42d": [['\uD83D\uDC2D'], '\uE053', '\uDBB8\uDDC2', ["mouse"], 11, 21, 63, 0],
        "1f42e": [['\uD83D\uDC2E'], '\uE52B', '\uDBB8\uDDD1', ["cow"], 11, 22, 63, 0],
        "1f42f": [['\uD83D\uDC2F'], '\uE050', '\uDBB8\uDDC0', ["tiger"], 11, 23, 63, 0],
        "1f430": [['\uD83D\uDC30'], '\uE52C', '\uDBB8\uDDD2', ["rabbit"], 11, 24, 63, 0],
        "1f431": [['\uD83D\uDC31'], '\uE04F', '\uDBB8\uDDB8', ["cat"], 11, 25, 63, 0],
        "1f432": [['\uD83D\uDC32'], "", '\uDBB8\uDDDE', ["dragon_face"], 11, 26, 63, 0],
        "1f433": [['\uD83D\uDC33'], '\uE054', '\uDBB8\uDDC3', ["whale"], 11, 27, 63, 0],
        "1f434": [['\uD83D\uDC34'], '\uE01A', '\uDBB8\uDDBE', ["horse"], 11, 28, 63, 0],
        "1f435": [['\uD83D\uDC35'], '\uE109', '\uDBB8\uDDC4', ["monkey_face"], 11, 29, 63, 0],
        "1f436": [['\uD83D\uDC36'], '\uE052', '\uDBB8\uDDB7', ["dog"], 11, 30, 63, 0],
        "1f437": [['\uD83D\uDC37'], '\uE10B', '\uDBB8\uDDBF', ["pig"], 11, 31, 63, 0],
        "1f438": [['\uD83D\uDC38'], '\uE531', '\uDBB8\uDDD7', ["frog"], 11, 32, 63, 0],
        "1f439": [['\uD83D\uDC39'], '\uE524', '\uDBB8\uDDCA', ["hamster"], 11, 33, 63, 0],
        "1f43a": [['\uD83D\uDC3A'], '\uE52A', '\uDBB8\uDDD0', ["wolf"], 11, 34, 63, 0],
        "1f43b": [['\uD83D\uDC3B'], '\uE051', '\uDBB8\uDDC1', ["bear"], 11, 35, 63, 0],
        "1f43c": [['\uD83D\uDC3C'], "", '\uDBB8\uDDDF', ["panda_face"], 11, 36, 63, 0],
        "1f43d": [['\uD83D\uDC3D'], '\uE10B', '\uDBB8\uDDE0', ["pig_nose"], 11, 37, 63, 0],
        "1f43e": [['\uD83D\uDC3E'], '\uE536', '\uDBB8\uDDDB', ["feet", "paw_prints"], 11, 38, 63, 0],
        "1f43f": [['\uD83D\uDC3F'], "", "", ["chipmunk"], 11, 39, 31, 0],
        "1f440": [['\uD83D\uDC40'], '\uE419', '\uDBB8\uDD90', ["eyes"], 11, 40, 63, 0],
        "1f441": [['\uD83D\uDC41'], "", "", ["eye"], 11, 41, 31, 0],
        "1f442": [['\uD83D\uDC42'], '\uE41B', '\uDBB8\uDD91', ["ear"], 11, 42, 63, 0],
        "1f443": [['\uD83D\uDC43'], '\uE41A', '\uDBB8\uDD92', ["nose"], 11, 48, 63, 0],
        "1f444": [['\uD83D\uDC44'], '\uE41C', '\uDBB8\uDD93', ["lips"], 12, 5, 63, 0],
        "1f445": [['\uD83D\uDC45'], '\uE409', '\uDBB8\uDD94', ["tongue"], 12, 6, 63, 0],
        "1f446": [['\uD83D\uDC46'], '\uE22E', '\uDBBA\uDF99', ["point_up_2"], 12, 7, 63, 0],
        "1f447": [['\uD83D\uDC47'], '\uE22F', '\uDBBA\uDF9A', ["point_down"], 12, 13, 63, 0],
        "1f448": [['\uD83D\uDC48'], '\uE230', '\uDBBA\uDF9B', ["point_left"], 12, 19, 63, 0],
        "1f449": [['\uD83D\uDC49'], '\uE231', '\uDBBA\uDF9C', ["point_right"], 12, 25, 63, 0],
        "1f44a": [['\uD83D\uDC4A'], '\uE00D', '\uDBBA\uDF96', ["facepunch", "punch"], 12, 31, 63, 0],
        "1f44b": [['\uD83D\uDC4B'], '\uE41E', '\uDBBA\uDF9D', ["wave"], 12, 37, 63, 0],
        "1f44c": [['\uD83D\uDC4C'], '\uE420', '\uDBBA\uDF9F', ["ok_hand"], 12, 43, 63, 0],
        "1f44d": [['\uD83D\uDC4D'], '\uE00E', '\uDBBA\uDF97', ["+1", "thumbsup"], 13, 0, 63, 0],
        "1f44e": [['\uD83D\uDC4E'], '\uE421', '\uDBBA\uDFA0', ["-1", "thumbsdown"], 13, 6, 63, 0],
        "1f44f": [['\uD83D\uDC4F'], '\uE41F', '\uDBBA\uDF9E', ["clap"], 13, 12, 63, 0],
        "1f450": [['\uD83D\uDC50'], '\uE422', '\uDBBA\uDFA1', ["open_hands"], 13, 18, 63, 0],
        "1f451": [['\uD83D\uDC51'], '\uE10E', '\uDBB9\uDCD1', ["crown"], 13, 24, 63, 0],
        "1f452": [['\uD83D\uDC52'], '\uE318', '\uDBB9\uDCD4', ["womans_hat"], 13, 25, 63, 0],
        "1f453": [['\uD83D\uDC53'], "", '\uDBB9\uDCCE', ["eyeglasses"], 13, 26, 63, 0],
        "1f454": [['\uD83D\uDC54'], '\uE302', '\uDBB9\uDCD3', ["necktie"], 13, 27, 63, 0],
        "1f455": [['\uD83D\uDC55'], '\uE006', '\uDBB9\uDCCF', ["shirt", "tshirt"], 13, 28, 63, 0],
        "1f456": [['\uD83D\uDC56'], "", '\uDBB9\uDCD0', ["jeans"], 13, 29, 63, 0],
        "1f457": [['\uD83D\uDC57'], '\uE319', '\uDBB9\uDCD5', ["dress"], 13, 30, 63, 0],
        "1f458": [['\uD83D\uDC58'], '\uE321', '\uDBB9\uDCD9', ["kimono"], 13, 31, 63, 0],
        "1f459": [['\uD83D\uDC59'], '\uE322', '\uDBB9\uDCDA', ["bikini"], 13, 32, 63, 0],
        "1f45a": [['\uD83D\uDC5A'], '\uE006', '\uDBB9\uDCDB', ["womans_clothes"], 13, 33, 63, 0],
        "1f45b": [['\uD83D\uDC5B'], "", '\uDBB9\uDCDC', ["purse"], 13, 34, 63, 0],
        "1f45c": [['\uD83D\uDC5C'], '\uE323', '\uDBB9\uDCF0', ["handbag"], 13, 35, 63, 0],
        "1f45d": [['\uD83D\uDC5D'], "", '\uDBB9\uDCF1', ["pouch"], 13, 36, 63, 0],
        "1f45e": [['\uD83D\uDC5E'], '\uE007', '\uDBB9\uDCCC', ["mans_shoe", "shoe"], 13, 37, 63, 0],
        "1f45f": [['\uD83D\uDC5F'], '\uE007', '\uDBB9\uDCCD', ["athletic_shoe"], 13, 38, 63, 0],
        "1f460": [['\uD83D\uDC60'], '\uE13E', '\uDBB9\uDCD6', ["high_heel"], 13, 39, 63, 0],
        "1f461": [['\uD83D\uDC61'], '\uE31A', '\uDBB9\uDCD7', ["sandal"], 13, 40, 63, 0],
        "1f462": [['\uD83D\uDC62'], '\uE31B', '\uDBB9\uDCD8', ["boot"], 13, 41, 63, 0],
        "1f463": [['\uD83D\uDC63'], '\uE536', '\uDBB9\uDD53', ["footprints"], 13, 42, 63, 0],
        "1f464": [['\uD83D\uDC64'], "", '\uDBB8\uDD9A', ["bust_in_silhouette"], 13, 43, 63, 0],
        "1f465": [['\uD83D\uDC65'], "", "", ["busts_in_silhouette"], 13, 44, 63, 0],
        "1f466": [['\uD83D\uDC66'], '\uE001', '\uDBB8\uDD9B', ["boy"], 13, 45, 63, 0],
        "1f467": [['\uD83D\uDC67'], '\uE002', '\uDBB8\uDD9C', ["girl"], 14, 2, 63, 0],
        "1f468": [['\uD83D\uDC68'], '\uE004', '\uDBB8\uDD9D', ["man"], 14, 8, 63, 0],
        "1f469": [['\uD83D\uDC69'], '\uE005', '\uDBB8\uDD9E', ["woman"], 14, 14, 63, 0],
        "1f46b": [['\uD83D\uDC6B'], '\uE428', '\uDBB8\uDDA0', ["couple", "man_and_woman_holding_hands"], 14, 21, 63, 0],
        "1f46c": [['\uD83D\uDC6C'], "", "", ["two_men_holding_hands"], 14, 22, 63, 0],
        "1f46d": [['\uD83D\uDC6D'], "", "", ["two_women_holding_hands"], 14, 23, 63, 0],
        "1f470": [['\uD83D\uDC70'], "", '\uDBB8\uDDA3', ["bride_with_veil"], 14, 31, 63, 0],
        "1f472": [['\uD83D\uDC72'], '\uE516', '\uDBB8\uDDA5', ["man_with_gua_pi_mao"], 14, 43, 63, 0],
        "1f474": [['\uD83D\uDC74'], '\uE518', '\uDBB8\uDDA7', ["older_man"], 15, 6, 63, 0],
        "1f475": [['\uD83D\uDC75'], '\uE519', '\uDBB8\uDDA8', ["older_woman"], 15, 12, 63, 0],
        "1f476": [['\uD83D\uDC76'], '\uE51A', '\uDBB8\uDDA9', ["baby"], 15, 18, 63, 0],
        "1f478": [['\uD83D\uDC78'], '\uE51C', '\uDBB8\uDDAB', ["princess"], 15, 30, 63, 0],
        "1f479": [['\uD83D\uDC79'], "", '\uDBB8\uDDAC', ["japanese_ogre"], 15, 36, 63, 0],
        "1f47a": [['\uD83D\uDC7A'], "", '\uDBB8\uDDAD', ["japanese_goblin"], 15, 37, 63, 0],
        "1f47b": [['\uD83D\uDC7B'], '\uE11B', '\uDBB8\uDDAE', ["ghost"], 15, 38, 63, 0],
        "1f47c": [['\uD83D\uDC7C'], '\uE04E', '\uDBB8\uDDAF', ["angel"], 15, 39, 63, 0],
        "1f47d": [['\uD83D\uDC7D'], '\uE10C', '\uDBB8\uDDB0', ["alien"], 15, 45, 63, 0],
        "1f47e": [['\uD83D\uDC7E'], '\uE12B', '\uDBB8\uDDB1', ["space_invader"], 15, 46, 63, 0],
        "1f47f": [['\uD83D\uDC7F'], '\uE11A', '\uDBB8\uDDB2', ["imp"], 15, 47, 63, 0],
        "1f480": [['\uD83D\uDC80'], '\uE11C', '\uDBB8\uDDB3', ["skull"], 15, 48, 63, 0],
        "1f483": [['\uD83D\uDC83'], '\uE51F', '\uDBB8\uDDB6', ["dancer"], 16, 12, 63, 0],
        "1f484": [['\uD83D\uDC84'], '\uE31C', '\uDBB8\uDD95', ["lipstick"], 16, 18, 63, 0],
        "1f485": [['\uD83D\uDC85'], '\uE31D', '\uDBB8\uDD96', ["nail_care"], 16, 19, 63, 0],
        "1f488": [['\uD83D\uDC88'], '\uE320', '\uDBB8\uDD99', ["barber"], 16, 37, 63, 0],
        "1f489": [['\uD83D\uDC89'], '\uE13B', '\uDBB9\uDD09', ["syringe"], 16, 38, 63, 0],
        "1f48a": [['\uD83D\uDC8A'], '\uE30F', '\uDBB9\uDD0A', ["pill"], 16, 39, 63, 0],
        "1f48b": [['\uD83D\uDC8B'], '\uE003', '\uDBBA\uDC23', ["kiss"], 16, 40, 63, 0],
        "1f48c": [['\uD83D\uDC8C'], '\uE103\uE328', '\uDBBA\uDC24', ["love_letter"], 16, 41, 63, 0],
        "1f48d": [['\uD83D\uDC8D'], '\uE034', '\uDBBA\uDC25', ["ring"], 16, 42, 63, 0],
        "1f48e": [['\uD83D\uDC8E'], '\uE035', '\uDBBA\uDC26', ["gem"], 16, 43, 63, 0],
        "1f490": [['\uD83D\uDC90'], '\uE306', '\uDBBA\uDC28', ["bouquet"], 16, 45, 63, 0],
        "1f492": [['\uD83D\uDC92'], '\uE43D', '\uDBBA\uDC2A', ["wedding"], 16, 47, 63, 0],
        "1f493": [['\uD83D\uDC93'], '\uE327', '\uDBBA\uDF0D', ["heartbeat"], 16, 48, 63, 0],
        "1f494": [['\uD83D\uDC94'], '\uE023', '\uDBBA\uDF0E', ["broken_heart"], 17, 0, 63, 0, "<\/3"],
        "1f495": [['\uD83D\uDC95'], '\uE327', '\uDBBA\uDF0F', ["two_hearts"], 17, 1, 63, 0],
        "1f496": [['\uD83D\uDC96'], '\uE327', '\uDBBA\uDF10', ["sparkling_heart"], 17, 2, 63, 0],
        "1f497": [['\uD83D\uDC97'], '\uE328', '\uDBBA\uDF11', ["heartpulse"], 17, 3, 63, 0],
        "1f498": [['\uD83D\uDC98'], '\uE329', '\uDBBA\uDF12', ["cupid"], 17, 4, 63, 0],
        "1f499": [['\uD83D\uDC99'], '\uE32A', '\uDBBA\uDF13', ["blue_heart"], 17, 5, 63, 0, "<3"],
        "1f49a": [['\uD83D\uDC9A'], '\uE32B', '\uDBBA\uDF14', ["green_heart"], 17, 6, 63, 0, "<3"],
        "1f49b": [['\uD83D\uDC9B'], '\uE32C', '\uDBBA\uDF15', ["yellow_heart"], 17, 7, 63, 0, "<3"],
        "1f49c": [['\uD83D\uDC9C'], '\uE32D', '\uDBBA\uDF16', ["purple_heart"], 17, 8, 63, 0, "<3"],
        "1f49d": [['\uD83D\uDC9D'], '\uE437', '\uDBBA\uDF17', ["gift_heart"], 17, 9, 63, 0],
        "1f49e": [['\uD83D\uDC9E'], '\uE327', '\uDBBA\uDF18', ["revolving_hearts"], 17, 10, 63, 0],
        "1f49f": [['\uD83D\uDC9F'], '\uE204', '\uDBBA\uDF19', ["heart_decoration"], 17, 11, 63, 0],
        "1f4a0": [['\uD83D\uDCA0'], "", '\uDBBA\uDF55', ["diamond_shape_with_a_dot_inside"], 17, 12, 63, 0],
        "1f4a1": [['\uD83D\uDCA1'], '\uE10F', '\uDBBA\uDF56', ["bulb"], 17, 13, 63, 0],
        "1f4a2": [['\uD83D\uDCA2'], '\uE334', '\uDBBA\uDF57', ["anger"], 17, 14, 63, 0],
        "1f4a3": [['\uD83D\uDCA3'], '\uE311', '\uDBBA\uDF58', ["bomb"], 17, 15, 63, 0],
        "1f4a4": [['\uD83D\uDCA4'], '\uE13C', '\uDBBA\uDF59', ["zzz"], 17, 16, 63, 0],
        "1f4a5": [['\uD83D\uDCA5'], "", '\uDBBA\uDF5A', ["boom", "collision"], 17, 17, 63, 0],
        "1f4a6": [['\uD83D\uDCA6'], '\uE331', '\uDBBA\uDF5B', ["sweat_drops"], 17, 18, 63, 0],
        "1f4a7": [['\uD83D\uDCA7'], '\uE331', '\uDBBA\uDF5C', ["droplet"], 17, 19, 63, 0],
        "1f4a8": [['\uD83D\uDCA8'], '\uE330', '\uDBBA\uDF5D', ["dash"], 17, 20, 63, 0],
        "1f4a9": [['\uD83D\uDCA9'], '\uE05A', '\uDBB9\uDCF4', ["hankey", "poop", "shit"], 17, 21, 63, 0],
        "1f4aa": [['\uD83D\uDCAA'], '\uE14C', '\uDBBA\uDF5E', ["muscle"], 17, 22, 63, 0],
        "1f4ab": [['\uD83D\uDCAB'], '\uE407', '\uDBBA\uDF5F', ["dizzy"], 17, 28, 63, 0],
        "1f4ac": [['\uD83D\uDCAC'], "", '\uDBB9\uDD32', ["speech_balloon"], 17, 29, 63, 0],
        "1f4ad": [['\uD83D\uDCAD'], "", "", ["thought_balloon"], 17, 30, 63, 0],
        "1f4ae": [['\uD83D\uDCAE'], "", '\uDBBA\uDF7A', ["white_flower"], 17, 31, 63, 0],
        "1f4af": [['\uD83D\uDCAF'], "", '\uDBBA\uDF7B', ["100"], 17, 32, 63, 0],
        "1f4b0": [['\uD83D\uDCB0'], '\uE12F', '\uDBB9\uDCDD', ["moneybag"], 17, 33, 63, 0],
        "1f4b1": [['\uD83D\uDCB1'], '\uE149', '\uDBB9\uDCDE', ["currency_exchange"], 17, 34, 63, 0],
        "1f4b2": [['\uD83D\uDCB2'], '\uE12F', '\uDBB9\uDCE0', ["heavy_dollar_sign"], 17, 35, 63, 0],
        "1f4b3": [['\uD83D\uDCB3'], "", '\uDBB9\uDCE1', ["credit_card"], 17, 36, 63, 0],
        "1f4b4": [['\uD83D\uDCB4'], "", '\uDBB9\uDCE2', ["yen"], 17, 37, 63, 0],
        "1f4b5": [['\uD83D\uDCB5'], '\uE12F', '\uDBB9\uDCE3', ["dollar"], 17, 38, 63, 0],
        "1f4b6": [['\uD83D\uDCB6'], "", "", ["euro"], 17, 39, 63, 0],
        "1f4b7": [['\uD83D\uDCB7'], "", "", ["pound"], 17, 40, 63, 0],
        "1f4b8": [['\uD83D\uDCB8'], "", '\uDBB9\uDCE4', ["money_with_wings"], 17, 41, 63, 0],
        "1f4b9": [['\uD83D\uDCB9'], '\uE14A', '\uDBB9\uDCDF', ["chart"], 17, 42, 63, 0],
        "1f4ba": [['\uD83D\uDCBA'], '\uE11F', '\uDBB9\uDD37', ["seat"], 17, 43, 63, 0],
        "1f4bb": [['\uD83D\uDCBB'], '\uE00C', '\uDBB9\uDD38', ["computer"], 17, 44, 63, 0],
        "1f4bc": [['\uD83D\uDCBC'], '\uE11E', '\uDBB9\uDD3B', ["briefcase"], 17, 45, 63, 0],
        "1f4bd": [['\uD83D\uDCBD'], '\uE316', '\uDBB9\uDD3C', ["minidisc"], 17, 46, 63, 0],
        "1f4be": [['\uD83D\uDCBE'], '\uE316', '\uDBB9\uDD3D', ["floppy_disk"], 17, 47, 63, 0],
        "1f4bf": [['\uD83D\uDCBF'], '\uE126', '\uDBBA\uDC1D', ["cd"], 17, 48, 63, 0],
        "1f4c0": [['\uD83D\uDCC0'], '\uE127', '\uDBBA\uDC1E', ["dvd"], 18, 0, 63, 0],
        "1f4c1": [['\uD83D\uDCC1'], "", '\uDBB9\uDD43', ["file_folder"], 18, 1, 63, 0],
        "1f4c2": [['\uD83D\uDCC2'], "", '\uDBB9\uDD44', ["open_file_folder"], 18, 2, 63, 0],
        "1f4c3": [['\uD83D\uDCC3'], '\uE301', '\uDBB9\uDD40', ["page_with_curl"], 18, 3, 63, 0],
        "1f4c4": [['\uD83D\uDCC4'], '\uE301', '\uDBB9\uDD41', ["page_facing_up"], 18, 4, 63, 0],
        "1f4c5": [['\uD83D\uDCC5'], "", '\uDBB9\uDD42', ["date"], 18, 5, 63, 0],
        "1f4c6": [['\uD83D\uDCC6'], "", '\uDBB9\uDD49', ["calendar"], 18, 6, 63, 0],
        "1f4c7": [['\uD83D\uDCC7'], '\uE148', '\uDBB9\uDD4D', ["card_index"], 18, 7, 63, 0],
        "1f4c8": [['\uD83D\uDCC8'], '\uE14A', '\uDBB9\uDD4B', ["chart_with_upwards_trend"], 18, 8, 63, 0],
        "1f4c9": [['\uD83D\uDCC9'], "", '\uDBB9\uDD4C', ["chart_with_downwards_trend"], 18, 9, 63, 0],
        "1f4ca": [['\uD83D\uDCCA'], '\uE14A', '\uDBB9\uDD4A', ["bar_chart"], 18, 10, 63, 0],
        "1f4cb": [['\uD83D\uDCCB'], '\uE301', '\uDBB9\uDD48', ["clipboard"], 18, 11, 63, 0],
        "1f4cc": [['\uD83D\uDCCC'], "", '\uDBB9\uDD4E', ["pushpin"], 18, 12, 63, 0],
        "1f4cd": [['\uD83D\uDCCD'], "", '\uDBB9\uDD3F', ["round_pushpin"], 18, 13, 63, 0],
        "1f4ce": [['\uD83D\uDCCE'], "", '\uDBB9\uDD3A', ["paperclip"], 18, 14, 63, 0],
        "1f4cf": [['\uD83D\uDCCF'], "", '\uDBB9\uDD50', ["straight_ruler"], 18, 15, 63, 0],
        "1f4d0": [['\uD83D\uDCD0'], "", '\uDBB9\uDD51', ["triangular_ruler"], 18, 16, 63, 0],
        "1f4d1": [['\uD83D\uDCD1'], '\uE301', '\uDBB9\uDD52', ["bookmark_tabs"], 18, 17, 63, 0],
        "1f4d2": [['\uD83D\uDCD2'], '\uE148', '\uDBB9\uDD4F', ["ledger"], 18, 18, 63, 0],
        "1f4d3": [['\uD83D\uDCD3'], '\uE148', '\uDBB9\uDD45', ["notebook"], 18, 19, 63, 0],
        "1f4d4": [['\uD83D\uDCD4'], '\uE148', '\uDBB9\uDD47', ["notebook_with_decorative_cover"], 18, 20, 63, 0],
        "1f4d5": [['\uD83D\uDCD5'], '\uE148', '\uDBB9\uDD02', ["closed_book"], 18, 21, 63, 0],
        "1f4d6": [['\uD83D\uDCD6'], '\uE148', '\uDBB9\uDD46', ["book", "open_book"], 18, 22, 63, 0],
        "1f4d7": [['\uD83D\uDCD7'], '\uE148', '\uDBB9\uDCFF', ["green_book"], 18, 23, 63, 0],
        "1f4d8": [['\uD83D\uDCD8'], '\uE148', '\uDBB9\uDD00', ["blue_book"], 18, 24, 63, 0],
        "1f4d9": [['\uD83D\uDCD9'], '\uE148', '\uDBB9\uDD01', ["orange_book"], 18, 25, 63, 0],
        "1f4da": [['\uD83D\uDCDA'], '\uE148', '\uDBB9\uDD03', ["books"], 18, 26, 63, 0],
        "1f4db": [['\uD83D\uDCDB'], "", '\uDBB9\uDD04', ["name_badge"], 18, 27, 63, 0],
        "1f4dc": [['\uD83D\uDCDC'], "", '\uDBB9\uDCFD', ["scroll"], 18, 28, 63, 0],
        "1f4dd": [['\uD83D\uDCDD'], '\uE301', '\uDBB9\uDD27', ["memo", "pencil"], 18, 29, 63, 0],
        "1f4de": [['\uD83D\uDCDE'], '\uE009', '\uDBB9\uDD24', ["telephone_receiver"], 18, 30, 63, 0],
        "1f4df": [['\uD83D\uDCDF'], "", '\uDBB9\uDD22', ["pager"], 18, 31, 63, 0],
        "1f4e0": [['\uD83D\uDCE0'], '\uE00B', '\uDBB9\uDD28', ["fax"], 18, 32, 63, 0],
        "1f4e1": [['\uD83D\uDCE1'], '\uE14B', '\uDBB9\uDD31', ["satellite_antenna"], 18, 33, 63, 0],
        "1f4e2": [['\uD83D\uDCE2'], '\uE142', '\uDBB9\uDD2F', ["loudspeaker"], 18, 34, 63, 0],
        "1f4e3": [['\uD83D\uDCE3'], '\uE317', '\uDBB9\uDD30', ["mega"], 18, 35, 63, 0],
        "1f4e4": [['\uD83D\uDCE4'], "", '\uDBB9\uDD33', ["outbox_tray"], 18, 36, 63, 0],
        "1f4e5": [['\uD83D\uDCE5'], "", '\uDBB9\uDD34', ["inbox_tray"], 18, 37, 63, 0],
        "1f4e6": [['\uD83D\uDCE6'], '\uE112', '\uDBB9\uDD35', ["package"], 18, 38, 63, 0],
        "1f4e7": [['\uD83D\uDCE7'], '\uE103', '\uDBBA\uDF92', ["e-mail"], 18, 39, 63, 0],
        "1f4e8": [['\uD83D\uDCE8'], '\uE103', '\uDBB9\uDD2A', ["incoming_envelope"], 18, 40, 63, 0],
        "1f4e9": [['\uD83D\uDCE9'], '\uE103', '\uDBB9\uDD2B', ["envelope_with_arrow"], 18, 41, 63, 0],
        "1f4ea": [['\uD83D\uDCEA'], '\uE101', '\uDBB9\uDD2C', ["mailbox_closed"], 18, 42, 63, 0],
        "1f4eb": [['\uD83D\uDCEB'], '\uE101', '\uDBB9\uDD2D', ["mailbox"], 18, 43, 63, 0],
        "1f4ec": [['\uD83D\uDCEC'], "", "", ["mailbox_with_mail"], 18, 44, 63, 0],
        "1f4ed": [['\uD83D\uDCED'], "", "", ["mailbox_with_no_mail"], 18, 45, 63, 0],
        "1f4ee": [['\uD83D\uDCEE'], '\uE102', '\uDBB9\uDD2E', ["postbox"], 18, 46, 63, 0],
        "1f4ef": [['\uD83D\uDCEF'], "", "", ["postal_horn"], 18, 47, 63, 0],
        "1f4f0": [['\uD83D\uDCF0'], "", '\uDBBA\uDC22', ["newspaper"], 18, 48, 63, 0],
        "1f4f1": [['\uD83D\uDCF1'], '\uE00A', '\uDBB9\uDD25', ["iphone"], 19, 0, 63, 0],
        "1f4f2": [['\uD83D\uDCF2'], '\uE104', '\uDBB9\uDD26', ["calling"], 19, 1, 63, 0],
        "1f4f3": [['\uD83D\uDCF3'], '\uE250', '\uDBBA\uDC39', ["vibration_mode"], 19, 2, 63, 0],
        "1f4f4": [['\uD83D\uDCF4'], '\uE251', '\uDBBA\uDC3A', ["mobile_phone_off"], 19, 3, 63, 0],
        "1f4f5": [['\uD83D\uDCF5'], "", "", ["no_mobile_phones"], 19, 4, 63, 0],
        "1f4f6": [['\uD83D\uDCF6'], '\uE20B', '\uDBBA\uDC38', ["signal_strength"], 19, 5, 63, 0],
        "1f4f7": [['\uD83D\uDCF7'], '\uE008', '\uDBB9\uDCEF', ["camera"], 19, 6, 63, 0],
        "1f4f8": [['\uD83D\uDCF8'], "", "", ["camera_with_flash"], 19, 7, 31, 0],
        "1f4f9": [['\uD83D\uDCF9'], '\uE03D', '\uDBB9\uDCF9', ["video_camera"], 19, 8, 63, 0],
        "1f4fa": [['\uD83D\uDCFA'], '\uE12A', '\uDBBA\uDC1C', ["tv"], 19, 9, 63, 0],
        "1f4fb": [['\uD83D\uDCFB'], '\uE128', '\uDBBA\uDC1F', ["radio"], 19, 10, 63, 0],
        "1f4fc": [['\uD83D\uDCFC'], '\uE129', '\uDBBA\uDC20', ["vhs"], 19, 11, 63, 0],
        "1f4fd": [['\uD83D\uDCFD'], "", "", ["film_projector"], 19, 12, 31, 0],
        "1f4ff": [['\uD83D\uDCFF'], "", "", ["prayer_beads"], 19, 13, 31, 0],
        "1f500": [['\uD83D\uDD00'], "", "", ["twisted_rightwards_arrows"], 19, 14, 63, 0],
        "1f501": [['\uD83D\uDD01'], "", "", ["repeat"], 19, 15, 63, 0],
        "1f502": [['\uD83D\uDD02'], "", "", ["repeat_one"], 19, 16, 63, 0],
        "1f503": [['\uD83D\uDD03'], "", '\uDBBA\uDF91', ["arrows_clockwise"], 19, 17, 63, 0],
        "1f504": [['\uD83D\uDD04'], "", "", ["arrows_counterclockwise"], 19, 18, 63, 0],
        "1f505": [['\uD83D\uDD05'], "", "", ["low_brightness"], 19, 19, 63, 0],
        "1f506": [['\uD83D\uDD06'], "", "", ["high_brightness"], 19, 20, 63, 0],
        "1f507": [['\uD83D\uDD07'], "", "", ["mute"], 19, 21, 63, 0],
        "1f508": [['\uD83D\uDD08'], "", "", ["speaker"], 19, 22, 63, 0],
        "1f509": [['\uD83D\uDD09'], "", "", ["sound"], 19, 23, 63, 0],
        "1f50a": [['\uD83D\uDD0A'], '\uE141', '\uDBBA\uDC21', ["loud_sound"], 19, 24, 63, 0],
        "1f50b": [['\uD83D\uDD0B'], "", '\uDBB9\uDCFC', ["battery"], 19, 25, 63, 0],
        "1f50c": [['\uD83D\uDD0C'], "", '\uDBB9\uDCFE', ["electric_plug"], 19, 26, 63, 0],
        "1f50d": [['\uD83D\uDD0D'], '\uE114', '\uDBBA\uDF85', ["mag"], 19, 27, 63, 0],
        "1f50e": [['\uD83D\uDD0E'], '\uE114', '\uDBBA\uDF8D', ["mag_right"], 19, 28, 63, 0],
        "1f50f": [['\uD83D\uDD0F'], '\uE144', '\uDBBA\uDF90', ["lock_with_ink_pen"], 19, 29, 63, 0],
        "1f510": [['\uD83D\uDD10'], '\uE144', '\uDBBA\uDF8A', ["closed_lock_with_key"], 19, 30, 63, 0],
        "1f511": [['\uD83D\uDD11'], '\uE03F', '\uDBBA\uDF82', ["key"], 19, 31, 63, 0],
        "1f512": [['\uD83D\uDD12'], '\uE144', '\uDBBA\uDF86', ["lock"], 19, 32, 63, 0],
        "1f513": [['\uD83D\uDD13'], '\uE145', '\uDBBA\uDF87', ["unlock"], 19, 33, 63, 0],
        "1f514": [['\uD83D\uDD14'], '\uE325', '\uDBB9\uDCF2', ["bell"], 19, 34, 63, 0],
        "1f515": [['\uD83D\uDD15'], "", "", ["no_bell"], 19, 35, 63, 0],
        "1f516": [['\uD83D\uDD16'], "", '\uDBBA\uDF8F', ["bookmark"], 19, 36, 63, 0],
        "1f517": [['\uD83D\uDD17'], "", '\uDBBA\uDF4B', ["link"], 19, 37, 63, 0],
        "1f518": [['\uD83D\uDD18'], "", '\uDBBA\uDF8C', ["radio_button"], 19, 38, 63, 0],
        "1f519": [['\uD83D\uDD19'], '\uE235', '\uDBBA\uDF8E', ["back"], 19, 39, 63, 0],
        "1f51a": [['\uD83D\uDD1A'], "", '\uDBB8\uDC1A', ["end"], 19, 40, 63, 0],
        "1f51b": [['\uD83D\uDD1B'], "", '\uDBB8\uDC19', ["on"], 19, 41, 63, 0],
        "1f51c": [['\uD83D\uDD1C'], "", '\uDBB8\uDC18', ["soon"], 19, 42, 63, 0],
        "1f51d": [['\uD83D\uDD1D'], '\uE24C', '\uDBBA\uDF42', ["top"], 19, 43, 63, 0],
        "1f51e": [['\uD83D\uDD1E'], '\uE207', '\uDBBA\uDF25', ["underage"], 19, 44, 63, 0],
        "1f51f": [['\uD83D\uDD1F'], "", '\uDBBA\uDC3B', ["keycap_ten"], 19, 45, 63, 0],
        "1f520": [['\uD83D\uDD20'], "", '\uDBBA\uDF7C', ["capital_abcd"], 19, 46, 63, 0],
        "1f521": [['\uD83D\uDD21'], "", '\uDBBA\uDF7D', ["abcd"], 19, 47, 63, 0],
        "1f522": [['\uD83D\uDD22'], "", '\uDBBA\uDF7E', ["1234"], 19, 48, 63, 0],
        "1f523": [['\uD83D\uDD23'], "", '\uDBBA\uDF7F', ["symbols"], 20, 0, 63, 0],
        "1f524": [['\uD83D\uDD24'], "", '\uDBBA\uDF80', ["abc"], 20, 1, 63, 0],
        "1f525": [['\uD83D\uDD25'], '\uE11D', '\uDBB9\uDCF6', ["fire"], 20, 2, 63, 0],
        "1f526": [['\uD83D\uDD26'], "", '\uDBB9\uDCFB', ["flashlight"], 20, 3, 63, 0],
        "1f527": [['\uD83D\uDD27'], "", '\uDBB9\uDCC9', ["wrench"], 20, 4, 63, 0],
        "1f528": [['\uD83D\uDD28'], '\uE116', '\uDBB9\uDCCA', ["hammer"], 20, 5, 63, 0],
        "1f529": [['\uD83D\uDD29'], "", '\uDBB9\uDCCB', ["nut_and_bolt"], 20, 6, 63, 0],
        "1f52a": [['\uD83D\uDD2A'], "", '\uDBB9\uDCFA', ["hocho", "knife"], 20, 7, 63, 0],
        "1f52b": [['\uD83D\uDD2B'], '\uE113', '\uDBB9\uDCF5', ["gun"], 20, 8, 63, 0],
        "1f52c": [['\uD83D\uDD2C'], "", "", ["microscope"], 20, 9, 63, 0],
        "1f52d": [['\uD83D\uDD2D'], "", "", ["telescope"], 20, 10, 63, 0],
        "1f52e": [['\uD83D\uDD2E'], '\uE23E', '\uDBB9\uDCF7', ["crystal_ball"], 20, 11, 63, 0],
        "1f52f": [['\uD83D\uDD2F'], '\uE23E', '\uDBB9\uDCF8', ["six_pointed_star"], 20, 12, 63, 0],
        "1f530": [['\uD83D\uDD30'], '\uE209', '\uDBB8\uDC44', ["beginner"], 20, 13, 63, 0],
        "1f531": [['\uD83D\uDD31'], '\uE031', '\uDBB9\uDCD2', ["trident"], 20, 14, 63, 0],
        "1f532": [['\uD83D\uDD32'], '\uE21A', '\uDBBA\uDF64', ["black_square_button"], 20, 15, 63, 0],
        "1f533": [['\uD83D\uDD33'], '\uE21B', '\uDBBA\uDF67', ["white_square_button"], 20, 16, 63, 0],
        "1f534": [['\uD83D\uDD34'], '\uE219', '\uDBBA\uDF63', ["red_circle"], 20, 17, 63, 0],
        "1f535": [['\uD83D\uDD35'], '\uE21A', '\uDBBA\uDF64', ["large_blue_circle"], 20, 18, 63, 0],
        "1f536": [['\uD83D\uDD36'], '\uE21B', '\uDBBA\uDF73', ["large_orange_diamond"], 20, 19, 63, 0],
        "1f537": [['\uD83D\uDD37'], '\uE21B', '\uDBBA\uDF74', ["large_blue_diamond"], 20, 20, 63, 0],
        "1f538": [['\uD83D\uDD38'], '\uE21B', '\uDBBA\uDF75', ["small_orange_diamond"], 20, 21, 63, 0],
        "1f539": [['\uD83D\uDD39'], '\uE21B', '\uDBBA\uDF76', ["small_blue_diamond"], 20, 22, 63, 0],
        "1f53a": [['\uD83D\uDD3A'], "", '\uDBBA\uDF78', ["small_red_triangle"], 20, 23, 63, 0],
        "1f53b": [['\uD83D\uDD3B'], "", '\uDBBA\uDF79', ["small_red_triangle_down"], 20, 24, 63, 0],
        "1f53c": [['\uD83D\uDD3C'], "", '\uDBBA\uDF01', ["arrow_up_small"], 20, 25, 63, 0],
        "1f53d": [['\uD83D\uDD3D'], "", '\uDBBA\uDF00', ["arrow_down_small"], 20, 26, 63, 0],
        "1f549": [['\uD83D\uDD49'], "", "", ["om_symbol"], 20, 27, 31, 0],
        "1f54a": [['\uD83D\uDD4A'], "", "", ["dove_of_peace"], 20, 28, 31, 0],
        "1f54b": [['\uD83D\uDD4B'], "", "", ["kaaba"], 20, 29, 31, 0],
        "1f54c": [['\uD83D\uDD4C'], "", "", ["mosque"], 20, 30, 31, 0],
        "1f54d": [['\uD83D\uDD4D'], "", "", ["synagogue"], 20, 31, 31, 0],
        "1f54e": [['\uD83D\uDD4E'], "", "", ["menorah_with_nine_branches"], 20, 32, 31, 0],
        "1f550": [['\uD83D\uDD50'], '\uE024', '\uDBB8\uDC1E', ["clock1"], 20, 33, 63, 0],
        "1f551": [['\uD83D\uDD51'], '\uE025', '\uDBB8\uDC1F', ["clock2"], 20, 34, 63, 0],
        "1f552": [['\uD83D\uDD52'], '\uE026', '\uDBB8\uDC20', ["clock3"], 20, 35, 63, 0],
        "1f553": [['\uD83D\uDD53'], '\uE027', '\uDBB8\uDC21', ["clock4"], 20, 36, 63, 0],
        "1f554": [['\uD83D\uDD54'], '\uE028', '\uDBB8\uDC22', ["clock5"], 20, 37, 63, 0],
        "1f555": [['\uD83D\uDD55'], '\uE029', '\uDBB8\uDC23', ["clock6"], 20, 38, 63, 0],
        "1f556": [['\uD83D\uDD56'], '\uE02A', '\uDBB8\uDC24', ["clock7"], 20, 39, 63, 0],
        "1f557": [['\uD83D\uDD57'], '\uE02B', '\uDBB8\uDC25', ["clock8"], 20, 40, 63, 0],
        "1f558": [['\uD83D\uDD58'], '\uE02C', '\uDBB8\uDC26', ["clock9"], 20, 41, 63, 0],
        "1f559": [['\uD83D\uDD59'], '\uE02D', '\uDBB8\uDC27', ["clock10"], 20, 42, 63, 0],
        "1f55a": [['\uD83D\uDD5A'], '\uE02E', '\uDBB8\uDC28', ["clock11"], 20, 43, 63, 0],
        "1f55b": [['\uD83D\uDD5B'], '\uE02F', '\uDBB8\uDC29', ["clock12"], 20, 44, 63, 0],
        "1f55c": [['\uD83D\uDD5C'], "", "", ["clock130"], 20, 45, 63, 0],
        "1f55d": [['\uD83D\uDD5D'], "", "", ["clock230"], 20, 46, 63, 0],
        "1f55e": [['\uD83D\uDD5E'], "", "", ["clock330"], 20, 47, 63, 0],
        "1f55f": [['\uD83D\uDD5F'], "", "", ["clock430"], 20, 48, 63, 0],
        "1f560": [['\uD83D\uDD60'], "", "", ["clock530"], 21, 0, 63, 0],
        "1f561": [['\uD83D\uDD61'], "", "", ["clock630"], 21, 1, 63, 0],
        "1f562": [['\uD83D\uDD62'], "", "", ["clock730"], 21, 2, 63, 0],
        "1f563": [['\uD83D\uDD63'], "", "", ["clock830"], 21, 3, 63, 0],
        "1f564": [['\uD83D\uDD64'], "", "", ["clock930"], 21, 4, 63, 0],
        "1f565": [['\uD83D\uDD65'], "", "", ["clock1030"], 21, 5, 63, 0],
        "1f566": [['\uD83D\uDD66'], "", "", ["clock1130"], 21, 6, 63, 0],
        "1f567": [['\uD83D\uDD67'], "", "", ["clock1230"], 21, 7, 63, 0],
        "1f56f": [['\uD83D\uDD6F'], "", "", ["candle"], 21, 8, 31, 0],
        "1f570": [['\uD83D\uDD70'], "", "", ["mantelpiece_clock"], 21, 9, 31, 0],
        "1f573": [['\uD83D\uDD73'], "", "", ["hole"], 21, 10, 31, 0],
        "1f574": [['\uD83D\uDD74'], "", "", ["man_in_business_suit_levitating"], 21, 11, 31, 0],
        "1f576": [['\uD83D\uDD76'], "", "", ["dark_sunglasses"], 21, 23, 31, 0],
        "1f577": [['\uD83D\uDD77'], "", "", ["spider"], 21, 24, 31, 0],
        "1f578": [['\uD83D\uDD78'], "", "", ["spider_web"], 21, 25, 31, 0],
        "1f579": [['\uD83D\uDD79'], "", "", ["joystick"], 21, 26, 31, 0],
        "1f57a": [['\uD83D\uDD7A'], "", "", ["man_dancing"], 21, 27, 31, 0],
        "1f587": [['\uD83D\uDD87'], "", "", ["linked_paperclips"], 21, 33, 31, 0],
        "1f58a": [['\uD83D\uDD8A'], "", "", ["lower_left_ballpoint_pen"], 21, 34, 31, 0],
        "1f58b": [['\uD83D\uDD8B'], "", "", ["lower_left_fountain_pen"], 21, 35, 31, 0],
        "1f58c": [['\uD83D\uDD8C'], "", "", ["lower_left_paintbrush"], 21, 36, 31, 0],
        "1f58d": [['\uD83D\uDD8D'], "", "", ["lower_left_crayon"], 21, 37, 31, 0],
        "1f590": [['\uD83D\uDD90'], "", "", ["raised_hand_with_fingers_splayed"], 21, 38, 31, 0],
        "1f595": [['\uD83D\uDD95'], "", "", ["middle_finger", "reversed_hand_with_middle_finger_extended"], 21, 44, 31, 0],
        "1f596": [['\uD83D\uDD96'], "", "", ["spock-hand"], 22, 1, 31, 0],
        "1f5a4": [['\uD83D\uDDA4'], "", "", ["black_heart"], 22, 7, 31, 0],
        "1f5a5": [['\uD83D\uDDA5'], "", "", ["desktop_computer"], 22, 8, 31, 0],
        "1f5a8": [['\uD83D\uDDA8'], "", "", ["printer"], 22, 9, 31, 0],
        "1f5b1": [['\uD83D\uDDB1'], "", "", ["three_button_mouse"], 22, 10, 31, 0],
        "1f5b2": [['\uD83D\uDDB2'], "", "", ["trackball"], 22, 11, 31, 0],
        "1f5bc": [['\uD83D\uDDBC'], "", "", ["frame_with_picture"], 22, 12, 31, 0],
        "1f5c2": [['\uD83D\uDDC2'], "", "", ["card_index_dividers"], 22, 13, 31, 0],
        "1f5c3": [['\uD83D\uDDC3'], "", "", ["card_file_box"], 22, 14, 31, 0],
        "1f5c4": [['\uD83D\uDDC4'], "", "", ["file_cabinet"], 22, 15, 31, 0],
        "1f5d1": [['\uD83D\uDDD1'], "", "", ["wastebasket"], 22, 16, 31, 0],
        "1f5d2": [['\uD83D\uDDD2'], "", "", ["spiral_note_pad"], 22, 17, 31, 0],
        "1f5d3": [['\uD83D\uDDD3'], "", "", ["spiral_calendar_pad"], 22, 18, 31, 0],
        "1f5dc": [['\uD83D\uDDDC'], "", "", ["compression"], 22, 19, 31, 0],
        "1f5dd": [['\uD83D\uDDDD'], "", "", ["old_key"], 22, 20, 31, 0],
        "1f5de": [['\uD83D\uDDDE'], "", "", ["rolled_up_newspaper"], 22, 21, 31, 0],
        "1f5e1": [['\uD83D\uDDE1'], "", "", ["dagger_knife"], 22, 22, 31, 0],
        "1f5e3": [['\uD83D\uDDE3'], "", "", ["speaking_head_in_silhouette"], 22, 23, 31, 0],
        "1f5e8": [['\uD83D\uDDE8'], "", "", ["left_speech_bubble"], 22, 24, 31, 0],
        "1f5ef": [['\uD83D\uDDEF'], "", "", ["right_anger_bubble"], 22, 25, 31, 0],
        "1f5f3": [['\uD83D\uDDF3'], "", "", ["ballot_box_with_ballot"], 22, 26, 31, 0],
        "1f5fa": [['\uD83D\uDDFA'], "", "", ["world_map"], 22, 27, 31, 0],
        "1f5fb": [['\uD83D\uDDFB'], '\uE03B', '\uDBB9\uDCC3', ["mount_fuji"], 22, 28, 63, 0],
        "1f5fc": [['\uD83D\uDDFC'], '\uE509', '\uDBB9\uDCC4', ["tokyo_tower"], 22, 29, 63, 0],
        "1f5fd": [['\uD83D\uDDFD'], '\uE51D', '\uDBB9\uDCC6', ["statue_of_liberty"], 22, 30, 63, 0],
        "1f5fe": [['\uD83D\uDDFE'], "", '\uDBB9\uDCC7', ["japan"], 22, 31, 63, 0],
        "1f5ff": [['\uD83D\uDDFF'], "", '\uDBB9\uDCC8', ["moyai"], 22, 32, 63, 0],
        "1f600": [['\uD83D\uDE00'], "", "", ["grinning"], 22, 33, 63, 0, ":D"],
        "1f601": [['\uD83D\uDE01'], '\uE404', '\uDBB8\uDF33', ["grin"], 22, 34, 63, 0],
        "1f602": [['\uD83D\uDE02'], '\uE412', '\uDBB8\uDF34', ["joy"], 22, 35, 63, 0],
        "1f603": [['\uD83D\uDE03'], '\uE057', '\uDBB8\uDF30', ["smiley"], 22, 36, 63, 0, ":)"],
        "1f604": [['\uD83D\uDE04'], '\uE415', '\uDBB8\uDF38', ["smile"], 22, 37, 63, 0, ":)"],
        "1f605": [['\uD83D\uDE05'], '\uE415\uE331', '\uDBB8\uDF31', ["sweat_smile"], 22, 38, 63, 0],
        "1f606": [['\uD83D\uDE06'], '\uE40A', '\uDBB8\uDF32', ["laughing", "satisfied"], 22, 39, 63, 0],
        "1f607": [['\uD83D\uDE07'], "", "", ["innocent"], 22, 40, 63, 0],
        "1f608": [['\uD83D\uDE08'], "", "", ["smiling_imp"], 22, 41, 63, 0],
        "1f609": [['\uD83D\uDE09'], '\uE405', '\uDBB8\uDF47', ["wink"], 22, 42, 63, 0, ";)"],
        "1f60a": [['\uD83D\uDE0A'], '\uE056', '\uDBB8\uDF35', ["blush"], 22, 43, 63, 0, ":)"],
        "1f60b": [['\uD83D\uDE0B'], '\uE056', '\uDBB8\uDF2B', ["yum"], 22, 44, 63, 0],
        "1f60c": [['\uD83D\uDE0C'], '\uE40A', '\uDBB8\uDF3E', ["relieved"], 22, 45, 63, 0],
        "1f60d": [['\uD83D\uDE0D'], '\uE106', '\uDBB8\uDF27', ["heart_eyes"], 22, 46, 63, 0],
        "1f60e": [['\uD83D\uDE0E'], "", "", ["sunglasses"], 22, 47, 63, 0],
        "1f60f": [['\uD83D\uDE0F'], '\uE402', '\uDBB8\uDF43', ["smirk"], 22, 48, 63, 0],
        "1f610": [['\uD83D\uDE10'], "", "", ["neutral_face"], 23, 0, 63, 0],
        "1f611": [['\uD83D\uDE11'], "", "", ["expressionless"], 23, 1, 63, 0],
        "1f612": [['\uD83D\uDE12'], '\uE40E', '\uDBB8\uDF26', ["unamused"], 23, 2, 63, 0, ":("],
        "1f613": [['\uD83D\uDE13'], '\uE108', '\uDBB8\uDF44', ["sweat"], 23, 3, 63, 0],
        "1f614": [['\uD83D\uDE14'], '\uE403', '\uDBB8\uDF40', ["pensive"], 23, 4, 63, 0],
        "1f615": [['\uD83D\uDE15'], "", "", ["confused"], 23, 5, 63, 0],
        "1f616": [['\uD83D\uDE16'], '\uE407', '\uDBB8\uDF3F', ["confounded"], 23, 6, 63, 0],
        "1f617": [['\uD83D\uDE17'], "", "", ["kissing"], 23, 7, 63, 0],
        "1f618": [['\uD83D\uDE18'], '\uE418', '\uDBB8\uDF2C', ["kissing_heart"], 23, 8, 63, 0],
        "1f619": [['\uD83D\uDE19'], "", "", ["kissing_smiling_eyes"], 23, 9, 63, 0],
        "1f61a": [['\uD83D\uDE1A'], '\uE417', '\uDBB8\uDF2D', ["kissing_closed_eyes"], 23, 10, 63, 0],
        "1f61b": [['\uD83D\uDE1B'], "", "", ["stuck_out_tongue"], 23, 11, 63, 0, ":p"],
        "1f61c": [['\uD83D\uDE1C'], '\uE105', '\uDBB8\uDF29', ["stuck_out_tongue_winking_eye"], 23, 12, 63, 0, ";p"],
        "1f61d": [['\uD83D\uDE1D'], '\uE409', '\uDBB8\uDF2A', ["stuck_out_tongue_closed_eyes"], 23, 13, 63, 0],
        "1f61e": [['\uD83D\uDE1E'], '\uE058', '\uDBB8\uDF23', ["disappointed"], 23, 14, 63, 0, ":("],
        "1f61f": [['\uD83D\uDE1F'], "", "", ["worried"], 23, 15, 63, 0],
        "1f620": [['\uD83D\uDE20'], '\uE059', '\uDBB8\uDF20', ["angry"], 23, 16, 63, 0],
        "1f621": [['\uD83D\uDE21'], '\uE416', '\uDBB8\uDF3D', ["rage"], 23, 17, 63, 0],
        "1f622": [['\uD83D\uDE22'], '\uE413', '\uDBB8\uDF39', ["cry"], 23, 18, 63, 0, ":'("],
        "1f623": [['\uD83D\uDE23'], '\uE406', '\uDBB8\uDF3C', ["persevere"], 23, 19, 63, 0],
        "1f624": [['\uD83D\uDE24'], '\uE404', '\uDBB8\uDF28', ["triumph"], 23, 20, 63, 0],
        "1f625": [['\uD83D\uDE25'], '\uE401', '\uDBB8\uDF45', ["disappointed_relieved"], 23, 21, 63, 0],
        "1f626": [['\uD83D\uDE26'], "", "", ["frowning"], 23, 22, 63, 0],
        "1f627": [['\uD83D\uDE27'], "", "", ["anguished"], 23, 23, 63, 0],
        "1f628": [['\uD83D\uDE28'], '\uE40B', '\uDBB8\uDF3B', ["fearful"], 23, 24, 63, 0],
        "1f629": [['\uD83D\uDE29'], '\uE403', '\uDBB8\uDF21', ["weary"], 23, 25, 63, 0],
        "1f62a": [['\uD83D\uDE2A'], '\uE408', '\uDBB8\uDF42', ["sleepy"], 23, 26, 63, 0],
        "1f62b": [['\uD83D\uDE2B'], '\uE406', '\uDBB8\uDF46', ["tired_face"], 23, 27, 63, 0],
        "1f62c": [['\uD83D\uDE2C'], "", "", ["grimacing"], 23, 28, 63, 0],
        "1f62d": [['\uD83D\uDE2D'], '\uE411', '\uDBB8\uDF3A', ["sob"], 23, 29, 63, 0, ":'("],
        "1f62e": [['\uD83D\uDE2E'], "", "", ["open_mouth"], 23, 30, 63, 0],
        "1f62f": [['\uD83D\uDE2F'], "", "", ["hushed"], 23, 31, 63, 0],
        "1f630": [['\uD83D\uDE30'], '\uE40F', '\uDBB8\uDF25', ["cold_sweat"], 23, 32, 63, 0],
        "1f631": [['\uD83D\uDE31'], '\uE107', '\uDBB8\uDF41', ["scream"], 23, 33, 63, 0],
        "1f632": [['\uD83D\uDE32'], '\uE410', '\uDBB8\uDF22', ["astonished"], 23, 34, 63, 0],
        "1f633": [['\uD83D\uDE33'], '\uE40D', '\uDBB8\uDF2F', ["flushed"], 23, 35, 63, 0],
        "1f634": [['\uD83D\uDE34'], "", "", ["sleeping"], 23, 36, 63, 0],
        "1f635": [['\uD83D\uDE35'], '\uE406', '\uDBB8\uDF24', ["dizzy_face"], 23, 37, 63, 0],
        "1f636": [['\uD83D\uDE36'], "", "", ["no_mouth"], 23, 38, 63, 0],
        "1f637": [['\uD83D\uDE37'], '\uE40C', '\uDBB8\uDF2E', ["mask"], 23, 39, 63, 0],
        "1f638": [['\uD83D\uDE38'], '\uE404', '\uDBB8\uDF49', ["smile_cat"], 23, 40, 63, 0],
        "1f639": [['\uD83D\uDE39'], '\uE412', '\uDBB8\uDF4A', ["joy_cat"], 23, 41, 63, 0],
        "1f63a": [['\uD83D\uDE3A'], '\uE057', '\uDBB8\uDF48', ["smiley_cat"], 23, 42, 63, 0],
        "1f63b": [['\uD83D\uDE3B'], '\uE106', '\uDBB8\uDF4C', ["heart_eyes_cat"], 23, 43, 63, 0],
        "1f63c": [['\uD83D\uDE3C'], '\uE404', '\uDBB8\uDF4F', ["smirk_cat"], 23, 44, 63, 0],
        "1f63d": [['\uD83D\uDE3D'], '\uE418', '\uDBB8\uDF4B', ["kissing_cat"], 23, 45, 63, 0],
        "1f63e": [['\uD83D\uDE3E'], '\uE416', '\uDBB8\uDF4E', ["pouting_cat"], 23, 46, 63, 0],
        "1f63f": [['\uD83D\uDE3F'], '\uE413', '\uDBB8\uDF4D', ["crying_cat_face"], 23, 47, 63, 0],
        "1f640": [['\uD83D\uDE40'], '\uE403', '\uDBB8\uDF50', ["scream_cat"], 23, 48, 63, 0],
        "1f641": [['\uD83D\uDE41'], "", "", ["slightly_frowning_face"], 24, 0, 31, 0],
        "1f642": [['\uD83D\uDE42'], "", "", ["slightly_smiling_face"], 24, 1, 63, 0],
        "1f643": [['\uD83D\uDE43'], "", "", ["upside_down_face"], 24, 2, 31, 0],
        "1f644": [['\uD83D\uDE44'], "", "", ["face_with_rolling_eyes"], 24, 3, 31, 0],
        "1f648": [['\uD83D\uDE48'], "", '\uDBB8\uDF54', ["see_no_evil"], 24, 22, 63, 0],
        "1f649": [['\uD83D\uDE49'], "", '\uDBB8\uDF56', ["hear_no_evil"], 24, 23, 63, 0],
        "1f64a": [['\uD83D\uDE4A'], "", '\uDBB8\uDF55', ["speak_no_evil"], 24, 24, 63, 0],
        "1f64c": [['\uD83D\uDE4C'], '\uE427', '\uDBB8\uDF58', ["raised_hands"], 24, 31, 63, 0],
        "1f64f": [['\uD83D\uDE4F'], '\uE41D', '\uDBB8\uDF5B', ["pray"], 25, 0, 63, 0],
        "1f680": [['\uD83D\uDE80'], '\uE10D', '\uDBB9\uDFED', ["rocket"], 25, 6, 63, 0],
        "1f681": [['\uD83D\uDE81'], "", "", ["helicopter"], 25, 7, 63, 0],
        "1f682": [['\uD83D\uDE82'], "", "", ["steam_locomotive"], 25, 8, 63, 0],
        "1f683": [['\uD83D\uDE83'], '\uE01E', '\uDBB9\uDFDF', ["railway_car"], 25, 9, 63, 0],
        "1f684": [['\uD83D\uDE84'], '\uE435', '\uDBB9\uDFE2', ["bullettrain_side"], 25, 10, 63, 0],
        "1f685": [['\uD83D\uDE85'], '\uE01F', '\uDBB9\uDFE3', ["bullettrain_front"], 25, 11, 63, 0],
        "1f686": [['\uD83D\uDE86'], "", "", ["train2"], 25, 12, 63, 0],
        "1f687": [['\uD83D\uDE87'], '\uE434', '\uDBB9\uDFE0', ["metro"], 25, 13, 63, 0],
        "1f688": [['\uD83D\uDE88'], "", "", ["light_rail"], 25, 14, 63, 0],
        "1f689": [['\uD83D\uDE89'], '\uE039', '\uDBB9\uDFEC', ["station"], 25, 15, 63, 0],
        "1f68a": [['\uD83D\uDE8A'], "", "", ["tram"], 25, 16, 63, 0],
        "1f68b": [['\uD83D\uDE8B'], "", "", ["train"], 25, 17, 63, 0],
        "1f68c": [['\uD83D\uDE8C'], '\uE159', '\uDBB9\uDFE6', ["bus"], 25, 18, 63, 0],
        "1f68d": [['\uD83D\uDE8D'], "", "", ["oncoming_bus"], 25, 19, 63, 0],
        "1f68e": [['\uD83D\uDE8E'], "", "", ["trolleybus"], 25, 20, 63, 0],
        "1f68f": [['\uD83D\uDE8F'], '\uE150', '\uDBB9\uDFE7', ["busstop"], 25, 21, 63, 0],
        "1f690": [['\uD83D\uDE90'], "", "", ["minibus"], 25, 22, 63, 0],
        "1f691": [['\uD83D\uDE91'], '\uE431', '\uDBB9\uDFF3', ["ambulance"], 25, 23, 63, 0],
        "1f692": [['\uD83D\uDE92'], '\uE430', '\uDBB9\uDFF2', ["fire_engine"], 25, 24, 63, 0],
        "1f693": [['\uD83D\uDE93'], '\uE432', '\uDBB9\uDFF4', ["police_car"], 25, 25, 63, 0],
        "1f694": [['\uD83D\uDE94'], "", "", ["oncoming_police_car"], 25, 26, 63, 0],
        "1f695": [['\uD83D\uDE95'], '\uE15A', '\uDBB9\uDFEF', ["taxi"], 25, 27, 63, 0],
        "1f696": [['\uD83D\uDE96'], "", "", ["oncoming_taxi"], 25, 28, 63, 0],
        "1f697": [['\uD83D\uDE97'], '\uE01B', '\uDBB9\uDFE4', ["car", "red_car"], 25, 29, 63, 0],
        "1f698": [['\uD83D\uDE98'], "", "", ["oncoming_automobile"], 25, 30, 63, 0],
        "1f699": [['\uD83D\uDE99'], '\uE42E', '\uDBB9\uDFE5', ["blue_car"], 25, 31, 63, 0],
        "1f69a": [['\uD83D\uDE9A'], '\uE42F', '\uDBB9\uDFF1', ["truck"], 25, 32, 63, 0],
        "1f69b": [['\uD83D\uDE9B'], "", "", ["articulated_lorry"], 25, 33, 63, 0],
        "1f69c": [['\uD83D\uDE9C'], "", "", ["tractor"], 25, 34, 63, 0],
        "1f69d": [['\uD83D\uDE9D'], "", "", ["monorail"], 25, 35, 63, 0],
        "1f69e": [['\uD83D\uDE9E'], "", "", ["mountain_railway"], 25, 36, 63, 0],
        "1f69f": [['\uD83D\uDE9F'], "", "", ["suspension_railway"], 25, 37, 63, 0],
        "1f6a0": [['\uD83D\uDEA0'], "", "", ["mountain_cableway"], 25, 38, 63, 0],
        "1f6a1": [['\uD83D\uDEA1'], "", "", ["aerial_tramway"], 25, 39, 63, 0],
        "1f6a2": [['\uD83D\uDEA2'], '\uE202', '\uDBB9\uDFE8', ["ship"], 25, 40, 63, 0],
        "1f6a4": [['\uD83D\uDEA4'], '\uE135', '\uDBB9\uDFEE', ["speedboat"], 25, 47, 63, 0],
        "1f6a5": [['\uD83D\uDEA5'], '\uE14E', '\uDBB9\uDFF7', ["traffic_light"], 25, 48, 63, 0],
        "1f6a6": [['\uD83D\uDEA6'], "", "", ["vertical_traffic_light"], 26, 0, 63, 0],
        "1f6a7": [['\uD83D\uDEA7'], '\uE137', '\uDBB9\uDFF8', ["construction"], 26, 1, 63, 0],
        "1f6a8": [['\uD83D\uDEA8'], '\uE432', '\uDBB9\uDFF9', ["rotating_light"], 26, 2, 63, 0],
        "1f6a9": [['\uD83D\uDEA9'], "", '\uDBBA\uDF22', ["triangular_flag_on_post"], 26, 3, 63, 0],
        "1f6aa": [['\uD83D\uDEAA'], "", '\uDBB9\uDCF3', ["door"], 26, 4, 63, 0],
        "1f6ab": [['\uD83D\uDEAB'], "", '\uDBBA\uDF48', ["no_entry_sign"], 26, 5, 63, 0],
        "1f6ac": [['\uD83D\uDEAC'], '\uE30E', '\uDBBA\uDF1E', ["smoking"], 26, 6, 63, 0],
        "1f6ad": [['\uD83D\uDEAD'], '\uE208', '\uDBBA\uDF1F', ["no_smoking"], 26, 7, 63, 0],
        "1f6ae": [['\uD83D\uDEAE'], "", "", ["put_litter_in_its_place"], 26, 8, 63, 0],
        "1f6af": [['\uD83D\uDEAF'], "", "", ["do_not_litter"], 26, 9, 63, 0],
        "1f6b0": [['\uD83D\uDEB0'], "", "", ["potable_water"], 26, 10, 63, 0],
        "1f6b1": [['\uD83D\uDEB1'], "", "", ["non-potable_water"], 26, 11, 63, 0],
        "1f6b2": [['\uD83D\uDEB2'], '\uE136', '\uDBB9\uDFEB', ["bike"], 26, 12, 63, 0],
        "1f6b3": [['\uD83D\uDEB3'], "", "", ["no_bicycles"], 26, 13, 63, 0],
        "1f6b7": [['\uD83D\uDEB7'], "", "", ["no_pedestrians"], 26, 32, 63, 0],
        "1f6b8": [['\uD83D\uDEB8'], "", "", ["children_crossing"], 26, 33, 63, 0],
        "1f6b9": [['\uD83D\uDEB9'], '\uE138', '\uDBBA\uDF33', ["mens"], 26, 34, 63, 0],
        "1f6ba": [['\uD83D\uDEBA'], '\uE139', '\uDBBA\uDF34', ["womens"], 26, 35, 63, 0],
        "1f6bb": [['\uD83D\uDEBB'], '\uE151', '\uDBB9\uDD06', ["restroom"], 26, 36, 63, 0],
        "1f6bc": [['\uD83D\uDEBC'], '\uE13A', '\uDBBA\uDF35', ["baby_symbol"], 26, 37, 63, 0],
        "1f6bd": [['\uD83D\uDEBD'], '\uE140', '\uDBB9\uDD07', ["toilet"], 26, 38, 63, 0],
        "1f6be": [['\uD83D\uDEBE'], '\uE309', '\uDBB9\uDD08', ["wc"], 26, 39, 63, 0],
        "1f6bf": [['\uD83D\uDEBF'], "", "", ["shower"], 26, 40, 63, 0],
        "1f6c0": [['\uD83D\uDEC0'], '\uE13F', '\uDBB9\uDD05', ["bath"], 26, 41, 63, 0],
        "1f6c1": [['\uD83D\uDEC1'], "", "", ["bathtub"], 26, 47, 63, 0],
        "1f6c2": [['\uD83D\uDEC2'], "", "", ["passport_control"], 26, 48, 63, 0],
        "1f6c3": [['\uD83D\uDEC3'], "", "", ["customs"], 27, 0, 63, 0],
        "1f6c4": [['\uD83D\uDEC4'], "", "", ["baggage_claim"], 27, 1, 63, 0],
        "1f6c5": [['\uD83D\uDEC5'], "", "", ["left_luggage"], 27, 2, 63, 0],
        "1f6cb": [['\uD83D\uDECB'], "", "", ["couch_and_lamp"], 27, 3, 31, 0],
        "1f6cc": [['\uD83D\uDECC'], "", "", ["sleeping_accommodation"], 27, 4, 31, 0],
        "1f6cd": [['\uD83D\uDECD'], "", "", ["shopping_bags"], 27, 10, 31, 0],
        "1f6ce": [['\uD83D\uDECE'], "", "", ["bellhop_bell"], 27, 11, 31, 0],
        "1f6cf": [['\uD83D\uDECF'], "", "", ["bed"], 27, 12, 31, 0],
        "1f6d0": [['\uD83D\uDED0'], "", "", ["place_of_worship"], 27, 13, 31, 0],
        "1f6d1": [['\uD83D\uDED1'], "", "", ["octagonal_sign"], 27, 14, 31, 0],
        "1f6d2": [['\uD83D\uDED2'], "", "", ["shopping_trolley"], 27, 15, 31, 0],
        "1f6e0": [['\uD83D\uDEE0'], "", "", ["hammer_and_wrench"], 27, 16, 31, 0],
        "1f6e1": [['\uD83D\uDEE1'], "", "", ["shield"], 27, 17, 31, 0],
        "1f6e2": [['\uD83D\uDEE2'], "", "", ["oil_drum"], 27, 18, 31, 0],
        "1f6e3": [['\uD83D\uDEE3'], "", "", ["motorway"], 27, 19, 31, 0],
        "1f6e4": [['\uD83D\uDEE4'], "", "", ["railway_track"], 27, 20, 31, 0],
        "1f6e5": [['\uD83D\uDEE5'], "", "", ["motor_boat"], 27, 21, 31, 0],
        "1f6e9": [['\uD83D\uDEE9'], "", "", ["small_airplane"], 27, 22, 31, 0],
        "1f6eb": [['\uD83D\uDEEB'], "", "", ["airplane_departure"], 27, 23, 31, 0],
        "1f6ec": [['\uD83D\uDEEC'], "", "", ["airplane_arriving"], 27, 24, 31, 0],
        "1f6f0": [['\uD83D\uDEF0'], "", "", ["satellite"], 27, 25, 31, 0],
        "1f6f3": [['\uD83D\uDEF3'], "", "", ["passenger_ship"], 27, 26, 31, 0],
        "1f6f4": [['\uD83D\uDEF4'], "", "", ["scooter"], 27, 27, 31, 0],
        "1f6f5": [['\uD83D\uDEF5'], "", "", ["motor_scooter"], 27, 28, 31, 0],
        "1f6f6": [['\uD83D\uDEF6'], "", "", ["canoe"], 27, 29, 31, 0],
        "1f910": [['\uD83E\uDD10'], "", "", ["zipper_mouth_face"], 27, 30, 31, 0],
        "1f911": [['\uD83E\uDD11'], "", "", ["money_mouth_face"], 27, 31, 31, 0],
        "1f912": [['\uD83E\uDD12'], "", "", ["face_with_thermometer"], 27, 32, 31, 0],
        "1f913": [['\uD83E\uDD13'], "", "", ["nerd_face"], 27, 33, 31, 0],
        "1f914": [['\uD83E\uDD14'], "", "", ["thinking_face"], 27, 34, 31, 0],
        "1f915": [['\uD83E\uDD15'], "", "", ["face_with_head_bandage"], 27, 35, 31, 0],
        "1f916": [['\uD83E\uDD16'], "", "", ["robot_face"], 27, 36, 31, 0],
        "1f917": [['\uD83E\uDD17'], "", "", ["hugging_face"], 27, 37, 31, 0],
        "1f918": [['\uD83E\uDD18'], "", "", ["the_horns", "sign_of_the_horns"], 27, 38, 31, 0],
        "1f919": [['\uD83E\uDD19'], "", "", ["call_me_hand"], 27, 44, 31, 0],
        "1f91a": [['\uD83E\uDD1A'], "", "", ["raised_back_of_hand"], 28, 1, 31, 0],
        "1f91b": [['\uD83E\uDD1B'], "", "", ["left-facing_fist"], 28, 7, 31, 0],
        "1f91c": [['\uD83E\uDD1C'], "", "", ["right-facing_fist"], 28, 13, 31, 0],
        "1f91d": [['\uD83E\uDD1D'], "", "", ["handshake"], 28, 19, 31, 0],
        "1f91e": [['\uD83E\uDD1E'], "", "", ["hand_with_index_and_middle_fingers_crossed"], 28, 20, 31, 0],
        "1f920": [['\uD83E\uDD20'], "", "", ["face_with_cowboy_hat"], 28, 26, 31, 0],
        "1f921": [['\uD83E\uDD21'], "", "", ["clown_face"], 28, 27, 31, 0],
        "1f922": [['\uD83E\uDD22'], "", "", ["nauseated_face"], 28, 28, 31, 0],
        "1f923": [['\uD83E\uDD23'], "", "", ["rolling_on_the_floor_laughing"], 28, 29, 31, 0],
        "1f924": [['\uD83E\uDD24'], "", "", ["drooling_face"], 28, 30, 31, 0],
        "1f925": [['\uD83E\uDD25'], "", "", ["lying_face"], 28, 31, 31, 0],
        "1f926": [['\uD83E\uDD26'], "", "", ["face_palm"], 28, 32, 31, 0],
        "1f927": [['\uD83E\uDD27'], "", "", ["sneezing_face"], 28, 38, 31, 0],
        "1f930": [['\uD83E\uDD30'], "", "", ["pregnant_woman"], 28, 39, 31, 0],
        "1f933": [['\uD83E\uDD33'], "", "", ["selfie"], 28, 45, 31, 0],
        "1f934": [['\uD83E\uDD34'], "", "", ["prince"], 29, 2, 31, 0],
        "1f935": [['\uD83E\uDD35'], "", "", ["man_in_tuxedo"], 29, 8, 31, 0],
        "1f936": [['\uD83E\uDD36'], "", "", ["mother_christmas"], 29, 14, 31, 0],
        "1f937": [['\uD83E\uDD37'], "", "", ["shrug"], 29, 20, 31, 0],
        "1f938": [['\uD83E\uDD38'], "", "", ["person_doing_cartwheel"], 29, 26, 31, 0],
        "1f939": [['\uD83E\uDD39'], "", "", ["juggling"], 29, 32, 31, 0],
        "1f93a": [['\uD83E\uDD3A'], "", "", ["fencer"], 29, 38, 31, 0],
        "1f93c": [['\uD83E\uDD3C'], "", "", ["wrestlers"], 29, 39, 31, 0],
        "1f93d": [['\uD83E\uDD3D'], "", "", ["water_polo"], 29, 40, 31, 0],
        "1f93e": [['\uD83E\uDD3E'], "", "", ["handball"], 29, 46, 31, 0],
        "1f940": [['\uD83E\uDD40'], "", "", ["wilted_flower"], 30, 3, 31, 0],
        "1f941": [['\uD83E\uDD41'], "", "", ["drum_with_drumsticks"], 30, 4, 31, 0],
        "1f942": [['\uD83E\uDD42'], "", "", ["clinking_glasses"], 30, 5, 31, 0],
        "1f943": [['\uD83E\uDD43'], "", "", ["tumbler_glass"], 30, 6, 31, 0],
        "1f944": [['\uD83E\uDD44'], "", "", ["spoon"], 30, 7, 31, 0],
        "1f945": [['\uD83E\uDD45'], "", "", ["goal_net"], 30, 8, 31, 0],
        "1f947": [['\uD83E\uDD47'], "", "", ["first_place_medal"], 30, 9, 31, 0],
        "1f948": [['\uD83E\uDD48'], "", "", ["second_place_medal"], 30, 10, 31, 0],
        "1f949": [['\uD83E\uDD49'], "", "", ["third_place_medal"], 30, 11, 31, 0],
        "1f94a": [['\uD83E\uDD4A'], "", "", ["boxing_glove"], 30, 12, 31, 0],
        "1f94b": [['\uD83E\uDD4B'], "", "", ["martial_arts_uniform"], 30, 13, 31, 0],
        "1f950": [['\uD83E\uDD50'], "", "", ["croissant"], 30, 14, 31, 0],
        "1f951": [['\uD83E\uDD51'], "", "", ["avocado"], 30, 15, 31, 0],
        "1f952": [['\uD83E\uDD52'], "", "", ["cucumber"], 30, 16, 31, 0],
        "1f953": [['\uD83E\uDD53'], "", "", ["bacon"], 30, 17, 31, 0],
        "1f954": [['\uD83E\uDD54'], "", "", ["potato"], 30, 18, 31, 0],
        "1f955": [['\uD83E\uDD55'], "", "", ["carrot"], 30, 19, 31, 0],
        "1f956": [['\uD83E\uDD56'], "", "", ["baguette_bread"], 30, 20, 31, 0],
        "1f957": [['\uD83E\uDD57'], "", "", ["green_salad"], 30, 21, 31, 0],
        "1f958": [['\uD83E\uDD58'], "", "", ["shallow_pan_of_food"], 30, 22, 31, 0],
        "1f959": [['\uD83E\uDD59'], "", "", ["stuffed_flatbread"], 30, 23, 31, 0],
        "1f95a": [['\uD83E\uDD5A'], "", "", ["egg"], 30, 24, 31, 0],
        "1f95b": [['\uD83E\uDD5B'], "", "", ["glass_of_milk"], 30, 25, 31, 0],
        "1f95c": [['\uD83E\uDD5C'], "", "", ["peanuts"], 30, 26, 31, 0],
        "1f95d": [['\uD83E\uDD5D'], "", "", ["kiwifruit"], 30, 27, 31, 0],
        "1f95e": [['\uD83E\uDD5E'], "", "", ["pancakes"], 30, 28, 31, 0],
        "1f980": [['\uD83E\uDD80'], "", "", ["crab"], 30, 29, 31, 0],
        "1f981": [['\uD83E\uDD81'], "", "", ["lion_face"], 30, 30, 31, 0],
        "1f982": [['\uD83E\uDD82'], "", "", ["scorpion"], 30, 31, 31, 0],
        "1f983": [['\uD83E\uDD83'], "", "", ["turkey"], 30, 32, 31, 0],
        "1f984": [['\uD83E\uDD84'], "", "", ["unicorn_face"], 30, 33, 31, 0],
        "1f985": [['\uD83E\uDD85'], "", "", ["eagle"], 30, 34, 31, 0],
        "1f986": [['\uD83E\uDD86'], "", "", ["duck"], 30, 35, 31, 0],
        "1f987": [['\uD83E\uDD87'], "", "", ["bat"], 30, 36, 31, 0],
        "1f988": [['\uD83E\uDD88'], "", "", ["shark"], 30, 37, 31, 0],
        "1f989": [['\uD83E\uDD89'], "", "", ["owl"], 30, 38, 31, 0],
        "1f98a": [['\uD83E\uDD8A'], "", "", ["fox_face"], 30, 39, 31, 0],
        "1f98b": [['\uD83E\uDD8B'], "", "", ["butterfly"], 30, 40, 31, 0],
        "1f98c": [['\uD83E\uDD8C'], "", "", ["deer"], 30, 41, 31, 0],
        "1f98d": [['\uD83E\uDD8D'], "", "", ["gorilla"], 30, 42, 31, 0],
        "1f98e": [['\uD83E\uDD8E'], "", "", ["lizard"], 30, 43, 31, 0],
        "1f98f": [['\uD83E\uDD8F'], "", "", ["rhinoceros"], 30, 44, 31, 0],
        "1f990": [['\uD83E\uDD90'], "", "", ["shrimp"], 30, 45, 31, 0],
        "1f991": [['\uD83E\uDD91'], "", "", ["squid"], 30, 46, 31, 0],
        "1f9c0": [['\uD83E\uDDC0'], "", "", ["cheese_wedge"], 30, 47, 31, 0],
        "0023-20e3": [['#\uFE0F\u20E3', '#\u20E3'], '\uE210', '\uDBBA\uDC2C', ["hash"], 30, 48, 15, 0],
        "002a-20e3": [['*\uFE0F\u20E3', '*\u20E3'], "", "", ["keycap_star"], 31, 0, 15, 0],
        "0030-20e3": [['0\uFE0F\u20E3', '0\u20E3'], '\uE225', '\uDBBA\uDC37', ["zero"], 31, 1, 15, 0],
        "0031-20e3": [['1\uFE0F\u20E3', '1\u20E3'], '\uE21C', '\uDBBA\uDC2E', ["one"], 31, 2, 15, 0],
        "0032-20e3": [['2\uFE0F\u20E3', '2\u20E3'], '\uE21D', '\uDBBA\uDC2F', ["two"], 31, 3, 15, 0],
        "0033-20e3": [['3\uFE0F\u20E3', '3\u20E3'], '\uE21E', '\uDBBA\uDC30', ["three"], 31, 4, 15, 0],
        "0034-20e3": [['4\uFE0F\u20E3', '4\u20E3'], '\uE21F', '\uDBBA\uDC31', ["four"], 31, 5, 15, 0],
        "0035-20e3": [['5\uFE0F\u20E3', '5\u20E3'], '\uE220', '\uDBBA\uDC32', ["five"], 31, 6, 15, 0],
        "0036-20e3": [['6\uFE0F\u20E3', '6\u20E3'], '\uE221', '\uDBBA\uDC33', ["six"], 31, 7, 15, 0],
        "0037-20e3": [['7\uFE0F\u20E3', '7\u20E3'], '\uE222', '\uDBBA\uDC34', ["seven"], 31, 8, 15, 0],
        "0038-20e3": [['8\uFE0F\u20E3', '8\u20E3'], '\uE223', '\uDBBA\uDC35', ["eight"], 31, 9, 15, 0],
        "0039-20e3": [['9\uFE0F\u20E3', '9\u20E3'], '\uE224', '\uDBBA\uDC36', ["nine"], 31, 10, 15, 0],
        "1f1e6-1f1e8": [['\uD83C\uDDE6\uD83C\uDDE8'], "", "", ["flag-ac"], 31, 11, 63, 0],
        "1f1e6-1f1e9": [['\uD83C\uDDE6\uD83C\uDDE9'], "", "", ["flag-ad"], 31, 12, 63, 0],
        "1f1e6-1f1ea": [['\uD83C\uDDE6\uD83C\uDDEA'], "", "", ["flag-ae"], 31, 13, 63, 0],
        "1f1e6-1f1eb": [['\uD83C\uDDE6\uD83C\uDDEB'], "", "", ["flag-af"], 31, 14, 63, 0],
        "1f1e6-1f1ec": [['\uD83C\uDDE6\uD83C\uDDEC'], "", "", ["flag-ag"], 31, 15, 63, 0],
        "1f1e6-1f1ee": [['\uD83C\uDDE6\uD83C\uDDEE'], "", "", ["flag-ai"], 31, 16, 63, 0],
        "1f1e6-1f1f1": [['\uD83C\uDDE6\uD83C\uDDF1'], "", "", ["flag-al"], 31, 17, 63, 0],
        "1f1e6-1f1f2": [['\uD83C\uDDE6\uD83C\uDDF2'], "", "", ["flag-am"], 31, 18, 63, 0],
        "1f1e6-1f1f4": [['\uD83C\uDDE6\uD83C\uDDF4'], "", "", ["flag-ao"], 31, 19, 63, 0],
        "1f1e6-1f1f6": [['\uD83C\uDDE6\uD83C\uDDF6'], "", "", ["flag-aq"], 31, 20, 63, 0],
        "1f1e6-1f1f7": [['\uD83C\uDDE6\uD83C\uDDF7'], "", "", ["flag-ar"], 31, 21, 63, 0],
        "1f1e6-1f1f8": [['\uD83C\uDDE6\uD83C\uDDF8'], "", "", ["flag-as"], 31, 22, 63, 0],
        "1f1e6-1f1f9": [['\uD83C\uDDE6\uD83C\uDDF9'], "", "", ["flag-at"], 31, 23, 63, 0],
        "1f1e6-1f1fa": [['\uD83C\uDDE6\uD83C\uDDFA'], "", "", ["flag-au"], 31, 24, 63, 0],
        "1f1e6-1f1fc": [['\uD83C\uDDE6\uD83C\uDDFC'], "", "", ["flag-aw"], 31, 25, 63, 0],
        "1f1e6-1f1fd": [['\uD83C\uDDE6\uD83C\uDDFD'], "", "", ["flag-ax"], 31, 26, 63, 0],
        "1f1e6-1f1ff": [['\uD83C\uDDE6\uD83C\uDDFF'], "", "", ["flag-az"], 31, 27, 63, 0],
        "1f1e7-1f1e6": [['\uD83C\uDDE7\uD83C\uDDE6'], "", "", ["flag-ba"], 31, 28, 31, 0],
        "1f1e7-1f1e7": [['\uD83C\uDDE7\uD83C\uDDE7'], "", "", ["flag-bb"], 31, 29, 63, 0],
        "1f1e7-1f1e9": [['\uD83C\uDDE7\uD83C\uDDE9'], "", "", ["flag-bd"], 31, 30, 63, 0],
        "1f1e7-1f1ea": [['\uD83C\uDDE7\uD83C\uDDEA'], "", "", ["flag-be"], 31, 31, 63, 0],
        "1f1e7-1f1eb": [['\uD83C\uDDE7\uD83C\uDDEB'], "", "", ["flag-bf"], 31, 32, 63, 0],
        "1f1e7-1f1ec": [['\uD83C\uDDE7\uD83C\uDDEC'], "", "", ["flag-bg"], 31, 33, 63, 0],
        "1f1e7-1f1ed": [['\uD83C\uDDE7\uD83C\uDDED'], "", "", ["flag-bh"], 31, 34, 63, 0],
        "1f1e7-1f1ee": [['\uD83C\uDDE7\uD83C\uDDEE'], "", "", ["flag-bi"], 31, 35, 63, 0],
        "1f1e7-1f1ef": [['\uD83C\uDDE7\uD83C\uDDEF'], "", "", ["flag-bj"], 31, 36, 63, 0],
        "1f1e7-1f1f1": [['\uD83C\uDDE7\uD83C\uDDF1'], "", "", ["flag-bl"], 31, 37, 61, 0],
        "1f1e7-1f1f2": [['\uD83C\uDDE7\uD83C\uDDF2'], "", "", ["flag-bm"], 31, 38, 63, 0],
        "1f1e7-1f1f3": [['\uD83C\uDDE7\uD83C\uDDF3'], "", "", ["flag-bn"], 31, 39, 31, 0],
        "1f1e7-1f1f4": [['\uD83C\uDDE7\uD83C\uDDF4'], "", "", ["flag-bo"], 31, 40, 63, 0],
        "1f1e7-1f1f6": [['\uD83C\uDDE7\uD83C\uDDF6'], "", "", ["flag-bq"], 31, 41, 61, 0],
        "1f1e7-1f1f7": [['\uD83C\uDDE7\uD83C\uDDF7'], "", "", ["flag-br"], 31, 42, 63, 0],
        "1f1e7-1f1f8": [['\uD83C\uDDE7\uD83C\uDDF8'], "", "", ["flag-bs"], 31, 43, 63, 0],
        "1f1e7-1f1f9": [['\uD83C\uDDE7\uD83C\uDDF9'], "", "", ["flag-bt"], 31, 44, 63, 0],
        "1f1e7-1f1fb": [['\uD83C\uDDE7\uD83C\uDDFB'], "", "", ["flag-bv"], 31, 45, 61, 0],
        "1f1e7-1f1fc": [['\uD83C\uDDE7\uD83C\uDDFC'], "", "", ["flag-bw"], 31, 46, 63, 0],
        "1f1e7-1f1fe": [['\uD83C\uDDE7\uD83C\uDDFE'], "", "", ["flag-by"], 31, 47, 63, 0],
        "1f1e7-1f1ff": [['\uD83C\uDDE7\uD83C\uDDFF'], "", "", ["flag-bz"], 31, 48, 63, 0],
        "1f1e8-1f1e6": [['\uD83C\uDDE8\uD83C\uDDE6'], "", "", ["flag-ca"], 32, 0, 63, 0],
        "1f1e8-1f1e8": [['\uD83C\uDDE8\uD83C\uDDE8'], "", "", ["flag-cc"], 32, 1, 63, 0],
        "1f1e8-1f1e9": [['\uD83C\uDDE8\uD83C\uDDE9'], "", "", ["flag-cd"], 32, 2, 63, 0],
        "1f1e8-1f1eb": [['\uD83C\uDDE8\uD83C\uDDEB'], "", "", ["flag-cf"], 32, 3, 63, 0],
        "1f1e8-1f1ec": [['\uD83C\uDDE8\uD83C\uDDEC'], "", "", ["flag-cg"], 32, 4, 63, 0],
        "1f1e8-1f1ed": [['\uD83C\uDDE8\uD83C\uDDED'], "", "", ["flag-ch"], 32, 5, 63, 0],
        "1f1e8-1f1ee": [['\uD83C\uDDE8\uD83C\uDDEE'], "", "", ["flag-ci"], 32, 6, 63, 0],
        "1f1e8-1f1f0": [['\uD83C\uDDE8\uD83C\uDDF0'], "", "", ["flag-ck"], 32, 7, 63, 0],
        "1f1e8-1f1f1": [['\uD83C\uDDE8\uD83C\uDDF1'], "", "", ["flag-cl"], 32, 8, 63, 0],
        "1f1e8-1f1f2": [['\uD83C\uDDE8\uD83C\uDDF2'], "", "", ["flag-cm"], 32, 9, 63, 0],
        "1f1e8-1f1f3": [['\uD83C\uDDE8\uD83C\uDDF3'], '\uE513', '\uDBB9\uDCED', ["flag-cn", "cn"], 32, 10, 63, 0],
        "1f1e8-1f1f4": [['\uD83C\uDDE8\uD83C\uDDF4'], "", "", ["flag-co"], 32, 11, 63, 0],
        "1f1e8-1f1f5": [['\uD83C\uDDE8\uD83C\uDDF5'], "", "", ["flag-cp"], 32, 12, 29, 0],
        "1f1e8-1f1f7": [['\uD83C\uDDE8\uD83C\uDDF7'], "", "", ["flag-cr"], 32, 13, 63, 0],
        "1f1e8-1f1fa": [['\uD83C\uDDE8\uD83C\uDDFA'], "", "", ["flag-cu"], 32, 14, 63, 0],
        "1f1e8-1f1fb": [['\uD83C\uDDE8\uD83C\uDDFB'], "", "", ["flag-cv"], 32, 15, 63, 0],
        "1f1e8-1f1fc": [['\uD83C\uDDE8\uD83C\uDDFC'], "", "", ["flag-cw"], 32, 16, 63, 0],
        "1f1e8-1f1fd": [['\uD83C\uDDE8\uD83C\uDDFD'], "", "", ["flag-cx"], 32, 17, 63, 0],
        "1f1e8-1f1fe": [['\uD83C\uDDE8\uD83C\uDDFE'], "", "", ["flag-cy"], 32, 18, 63, 0],
        "1f1e8-1f1ff": [['\uD83C\uDDE8\uD83C\uDDFF'], "", "", ["flag-cz"], 32, 19, 63, 0],
        "1f1e9-1f1ea": [['\uD83C\uDDE9\uD83C\uDDEA'], '\uE50E', '\uDBB9\uDCE8', ["flag-de", "de"], 32, 20, 63, 0],
        "1f1e9-1f1ec": [['\uD83C\uDDE9\uD83C\uDDEC'], "", "", ["flag-dg"], 32, 21, 61, 0],
        "1f1e9-1f1ef": [['\uD83C\uDDE9\uD83C\uDDEF'], "", "", ["flag-dj"], 32, 22, 63, 0],
        "1f1e9-1f1f0": [['\uD83C\uDDE9\uD83C\uDDF0'], "", "", ["flag-dk"], 32, 23, 63, 0],
        "1f1e9-1f1f2": [['\uD83C\uDDE9\uD83C\uDDF2'], "", "", ["flag-dm"], 32, 24, 63, 0],
        "1f1e9-1f1f4": [['\uD83C\uDDE9\uD83C\uDDF4'], "", "", ["flag-do"], 32, 25, 63, 0],
        "1f1e9-1f1ff": [['\uD83C\uDDE9\uD83C\uDDFF'], "", "", ["flag-dz"], 32, 26, 63, 0],
        "1f1ea-1f1e6": [['\uD83C\uDDEA\uD83C\uDDE6'], "", "", ["flag-ea"], 32, 27, 61, 0],
        "1f1ea-1f1e8": [['\uD83C\uDDEA\uD83C\uDDE8'], "", "", ["flag-ec"], 32, 28, 63, 0],
        "1f1ea-1f1ea": [['\uD83C\uDDEA\uD83C\uDDEA'], "", "", ["flag-ee"], 32, 29, 63, 0],
        "1f1ea-1f1ec": [['\uD83C\uDDEA\uD83C\uDDEC'], "", "", ["flag-eg"], 32, 30, 63, 0],
        "1f1ea-1f1ed": [['\uD83C\uDDEA\uD83C\uDDED'], "", "", ["flag-eh"], 32, 31, 61, 0],
        "1f1ea-1f1f7": [['\uD83C\uDDEA\uD83C\uDDF7'], "", "", ["flag-er"], 32, 32, 63, 0],
        "1f1ea-1f1f8": [['\uD83C\uDDEA\uD83C\uDDF8'], '\uE511', '\uDBB9\uDCEB', ["flag-es", "es"], 32, 33, 63, 0],
        "1f1ea-1f1f9": [['\uD83C\uDDEA\uD83C\uDDF9'], "", "", ["flag-et"], 32, 34, 63, 0],
        "1f1ea-1f1fa": [['\uD83C\uDDEA\uD83C\uDDFA'], "", "", ["flag-eu"], 32, 35, 63, 0],
        "1f1eb-1f1ee": [['\uD83C\uDDEB\uD83C\uDDEE'], "", "", ["flag-fi"], 32, 36, 63, 0],
        "1f1eb-1f1ef": [['\uD83C\uDDEB\uD83C\uDDEF'], "", "", ["flag-fj"], 32, 37, 63, 0],
        "1f1eb-1f1f0": [['\uD83C\uDDEB\uD83C\uDDF0'], "", "", ["flag-fk"], 32, 38, 61, 0],
        "1f1eb-1f1f2": [['\uD83C\uDDEB\uD83C\uDDF2'], "", "", ["flag-fm"], 32, 39, 63, 0],
        "1f1eb-1f1f4": [['\uD83C\uDDEB\uD83C\uDDF4'], "", "", ["flag-fo"], 32, 40, 63, 0],
        "1f1eb-1f1f7": [['\uD83C\uDDEB\uD83C\uDDF7'], '\uE50D', '\uDBB9\uDCE7', ["flag-fr", "fr"], 32, 41, 63, 0],
        "1f1ec-1f1e6": [['\uD83C\uDDEC\uD83C\uDDE6'], "", "", ["flag-ga"], 32, 42, 63, 0],
        "1f1ec-1f1e7": [['\uD83C\uDDEC\uD83C\uDDE7'], '\uE510', '\uDBB9\uDCEA', ["flag-gb", "gb", "uk"], 32, 43, 63, 0],
        "1f1ec-1f1e9": [['\uD83C\uDDEC\uD83C\uDDE9'], "", "", ["flag-gd"], 32, 44, 63, 0],
        "1f1ec-1f1ea": [['\uD83C\uDDEC\uD83C\uDDEA'], "", "", ["flag-ge"], 32, 45, 63, 0],
        "1f1ec-1f1eb": [['\uD83C\uDDEC\uD83C\uDDEB'], "", "", ["flag-gf"], 32, 46, 61, 0],
        "1f1ec-1f1ec": [['\uD83C\uDDEC\uD83C\uDDEC'], "", "", ["flag-gg"], 32, 47, 63, 0],
        "1f1ec-1f1ed": [['\uD83C\uDDEC\uD83C\uDDED'], "", "", ["flag-gh"], 32, 48, 63, 0],
        "1f1ec-1f1ee": [['\uD83C\uDDEC\uD83C\uDDEE'], "", "", ["flag-gi"], 33, 0, 63, 0],
        "1f1ec-1f1f1": [['\uD83C\uDDEC\uD83C\uDDF1'], "", "", ["flag-gl"], 33, 1, 63, 0],
        "1f1ec-1f1f2": [['\uD83C\uDDEC\uD83C\uDDF2'], "", "", ["flag-gm"], 33, 2, 63, 0],
        "1f1ec-1f1f3": [['\uD83C\uDDEC\uD83C\uDDF3'], "", "", ["flag-gn"], 33, 3, 63, 0],
        "1f1ec-1f1f5": [['\uD83C\uDDEC\uD83C\uDDF5'], "", "", ["flag-gp"], 33, 4, 61, 0],
        "1f1ec-1f1f6": [['\uD83C\uDDEC\uD83C\uDDF6'], "", "", ["flag-gq"], 33, 5, 63, 0],
        "1f1ec-1f1f7": [['\uD83C\uDDEC\uD83C\uDDF7'], "", "", ["flag-gr"], 33, 6, 63, 0],
        "1f1ec-1f1f8": [['\uD83C\uDDEC\uD83C\uDDF8'], "", "", ["flag-gs"], 33, 7, 61, 0],
        "1f1ec-1f1f9": [['\uD83C\uDDEC\uD83C\uDDF9'], "", "", ["flag-gt"], 33, 8, 63, 0],
        "1f1ec-1f1fa": [['\uD83C\uDDEC\uD83C\uDDFA'], "", "", ["flag-gu"], 33, 9, 63, 0],
        "1f1ec-1f1fc": [['\uD83C\uDDEC\uD83C\uDDFC'], "", "", ["flag-gw"], 33, 10, 63, 0],
        "1f1ec-1f1fe": [['\uD83C\uDDEC\uD83C\uDDFE'], "", "", ["flag-gy"], 33, 11, 63, 0],
        "1f1ed-1f1f0": [['\uD83C\uDDED\uD83C\uDDF0'], "", "", ["flag-hk"], 33, 12, 63, 0],
        "1f1ed-1f1f2": [['\uD83C\uDDED\uD83C\uDDF2'], "", "", ["flag-hm"], 33, 13, 61, 0],
        "1f1ed-1f1f3": [['\uD83C\uDDED\uD83C\uDDF3'], "", "", ["flag-hn"], 33, 14, 63, 0],
        "1f1ed-1f1f7": [['\uD83C\uDDED\uD83C\uDDF7'], "", "", ["flag-hr"], 33, 15, 63, 0],
        "1f1ed-1f1f9": [['\uD83C\uDDED\uD83C\uDDF9'], "", "", ["flag-ht"], 33, 16, 63, 0],
        "1f1ed-1f1fa": [['\uD83C\uDDED\uD83C\uDDFA'], "", "", ["flag-hu"], 33, 17, 63, 0],
        "1f1ee-1f1e8": [['\uD83C\uDDEE\uD83C\uDDE8'], "", "", ["flag-ic"], 33, 18, 63, 0],
        "1f1ee-1f1e9": [['\uD83C\uDDEE\uD83C\uDDE9'], "", "", ["flag-id"], 33, 19, 63, 0],
        "1f1ee-1f1ea": [['\uD83C\uDDEE\uD83C\uDDEA'], "", "", ["flag-ie"], 33, 20, 63, 0],
        "1f1ee-1f1f1": [['\uD83C\uDDEE\uD83C\uDDF1'], "", "", ["flag-il"], 33, 21, 63, 0],
        "1f1ee-1f1f2": [['\uD83C\uDDEE\uD83C\uDDF2'], "", "", ["flag-im"], 33, 22, 63, 0],
        "1f1ee-1f1f3": [['\uD83C\uDDEE\uD83C\uDDF3'], "", "", ["flag-in"], 33, 23, 63, 0],
        "1f1ee-1f1f4": [['\uD83C\uDDEE\uD83C\uDDF4'], "", "", ["flag-io"], 33, 24, 63, 0],
        "1f1ee-1f1f6": [['\uD83C\uDDEE\uD83C\uDDF6'], "", "", ["flag-iq"], 33, 25, 63, 0],
        "1f1ee-1f1f7": [['\uD83C\uDDEE\uD83C\uDDF7'], "", "", ["flag-ir"], 33, 26, 63, 0],
        "1f1ee-1f1f8": [['\uD83C\uDDEE\uD83C\uDDF8'], "", "", ["flag-is"], 33, 27, 63, 0],
        "1f1ee-1f1f9": [['\uD83C\uDDEE\uD83C\uDDF9'], '\uE50F', '\uDBB9\uDCE9', ["flag-it", "it"], 33, 28, 63, 0],
        "1f1ef-1f1ea": [['\uD83C\uDDEF\uD83C\uDDEA'], "", "", ["flag-je"], 33, 29, 63, 0],
        "1f1ef-1f1f2": [['\uD83C\uDDEF\uD83C\uDDF2'], "", "", ["flag-jm"], 33, 30, 63, 0],
        "1f1ef-1f1f4": [['\uD83C\uDDEF\uD83C\uDDF4'], "", "", ["flag-jo"], 33, 31, 63, 0],
        "1f1ef-1f1f5": [['\uD83C\uDDEF\uD83C\uDDF5'], '\uE50B', '\uDBB9\uDCE5', ["flag-jp", "jp"], 33, 32, 63, 0],
        "1f1f0-1f1ea": [['\uD83C\uDDF0\uD83C\uDDEA'], "", "", ["flag-ke"], 33, 33, 63, 0],
        "1f1f0-1f1ec": [['\uD83C\uDDF0\uD83C\uDDEC'], "", "", ["flag-kg"], 33, 34, 63, 0],
        "1f1f0-1f1ed": [['\uD83C\uDDF0\uD83C\uDDED'], "", "", ["flag-kh"], 33, 35, 63, 0],
        "1f1f0-1f1ee": [['\uD83C\uDDF0\uD83C\uDDEE'], "", "", ["flag-ki"], 33, 36, 63, 0],
        "1f1f0-1f1f2": [['\uD83C\uDDF0\uD83C\uDDF2'], "", "", ["flag-km"], 33, 37, 63, 0],
        "1f1f0-1f1f3": [['\uD83C\uDDF0\uD83C\uDDF3'], "", "", ["flag-kn"], 33, 38, 63, 0],
        "1f1f0-1f1f5": [['\uD83C\uDDF0\uD83C\uDDF5'], "", "", ["flag-kp"], 33, 39, 63, 0],
        "1f1f0-1f1f7": [['\uD83C\uDDF0\uD83C\uDDF7'], '\uE514', '\uDBB9\uDCEE', ["flag-kr", "kr"], 33, 40, 63, 0],
        "1f1f0-1f1fc": [['\uD83C\uDDF0\uD83C\uDDFC'], "", "", ["flag-kw"], 33, 41, 63, 0],
        "1f1f0-1f1fe": [['\uD83C\uDDF0\uD83C\uDDFE'], "", "", ["flag-ky"], 33, 42, 63, 0],
        "1f1f0-1f1ff": [['\uD83C\uDDF0\uD83C\uDDFF'], "", "", ["flag-kz"], 33, 43, 63, 0],
        "1f1f1-1f1e6": [['\uD83C\uDDF1\uD83C\uDDE6'], "", "", ["flag-la"], 33, 44, 63, 0],
        "1f1f1-1f1e7": [['\uD83C\uDDF1\uD83C\uDDE7'], "", "", ["flag-lb"], 33, 45, 63, 0],
        "1f1f1-1f1e8": [['\uD83C\uDDF1\uD83C\uDDE8'], "", "", ["flag-lc"], 33, 46, 63, 0],
        "1f1f1-1f1ee": [['\uD83C\uDDF1\uD83C\uDDEE'], "", "", ["flag-li"], 33, 47, 63, 0],
        "1f1f1-1f1f0": [['\uD83C\uDDF1\uD83C\uDDF0'], "", "", ["flag-lk"], 33, 48, 63, 0],
        "1f1f1-1f1f7": [['\uD83C\uDDF1\uD83C\uDDF7'], "", "", ["flag-lr"], 34, 0, 63, 0],
        "1f1f1-1f1f8": [['\uD83C\uDDF1\uD83C\uDDF8'], "", "", ["flag-ls"], 34, 1, 63, 0],
        "1f1f1-1f1f9": [['\uD83C\uDDF1\uD83C\uDDF9'], "", "", ["flag-lt"], 34, 2, 63, 0],
        "1f1f1-1f1fa": [['\uD83C\uDDF1\uD83C\uDDFA'], "", "", ["flag-lu"], 34, 3, 63, 0],
        "1f1f1-1f1fb": [['\uD83C\uDDF1\uD83C\uDDFB'], "", "", ["flag-lv"], 34, 4, 63, 0],
        "1f1f1-1f1fe": [['\uD83C\uDDF1\uD83C\uDDFE'], "", "", ["flag-ly"], 34, 5, 63, 0],
        "1f1f2-1f1e6": [['\uD83C\uDDF2\uD83C\uDDE6'], "", "", ["flag-ma"], 34, 6, 63, 0],
        "1f1f2-1f1e8": [['\uD83C\uDDF2\uD83C\uDDE8'], "", "", ["flag-mc"], 34, 7, 63, 0],
        "1f1f2-1f1e9": [['\uD83C\uDDF2\uD83C\uDDE9'], "", "", ["flag-md"], 34, 8, 63, 0],
        "1f1f2-1f1ea": [['\uD83C\uDDF2\uD83C\uDDEA'], "", "", ["flag-me"], 34, 9, 63, 0],
        "1f1f2-1f1eb": [['\uD83C\uDDF2\uD83C\uDDEB'], "", "", ["flag-mf"], 34, 10, 61, 0],
        "1f1f2-1f1ec": [['\uD83C\uDDF2\uD83C\uDDEC'], "", "", ["flag-mg"], 34, 11, 63, 0],
        "1f1f2-1f1ed": [['\uD83C\uDDF2\uD83C\uDDED'], "", "", ["flag-mh"], 34, 12, 63, 0],
        "1f1f2-1f1f0": [['\uD83C\uDDF2\uD83C\uDDF0'], "", "", ["flag-mk"], 34, 13, 63, 0],
        "1f1f2-1f1f1": [['\uD83C\uDDF2\uD83C\uDDF1'], "", "", ["flag-ml"], 34, 14, 63, 0],
        "1f1f2-1f1f2": [['\uD83C\uDDF2\uD83C\uDDF2'], "", "", ["flag-mm"], 34, 15, 63, 0],
        "1f1f2-1f1f3": [['\uD83C\uDDF2\uD83C\uDDF3'], "", "", ["flag-mn"], 34, 16, 63, 0],
        "1f1f2-1f1f4": [['\uD83C\uDDF2\uD83C\uDDF4'], "", "", ["flag-mo"], 34, 17, 63, 0],
        "1f1f2-1f1f5": [['\uD83C\uDDF2\uD83C\uDDF5'], "", "", ["flag-mp"], 34, 18, 63, 0],
        "1f1f2-1f1f6": [['\uD83C\uDDF2\uD83C\uDDF6'], "", "", ["flag-mq"], 34, 19, 61, 0],
        "1f1f2-1f1f7": [['\uD83C\uDDF2\uD83C\uDDF7'], "", "", ["flag-mr"], 34, 20, 63, 0],
        "1f1f2-1f1f8": [['\uD83C\uDDF2\uD83C\uDDF8'], "", "", ["flag-ms"], 34, 21, 63, 0],
        "1f1f2-1f1f9": [['\uD83C\uDDF2\uD83C\uDDF9'], "", "", ["flag-mt"], 34, 22, 63, 0],
        "1f1f2-1f1fa": [['\uD83C\uDDF2\uD83C\uDDFA'], "", "", ["flag-mu"], 34, 23, 63, 0],
        "1f1f2-1f1fb": [['\uD83C\uDDF2\uD83C\uDDFB'], "", "", ["flag-mv"], 34, 24, 63, 0],
        "1f1f2-1f1fc": [['\uD83C\uDDF2\uD83C\uDDFC'], "", "", ["flag-mw"], 34, 25, 63, 0],
        "1f1f2-1f1fd": [['\uD83C\uDDF2\uD83C\uDDFD'], "", "", ["flag-mx"], 34, 26, 63, 0],
        "1f1f2-1f1fe": [['\uD83C\uDDF2\uD83C\uDDFE'], "", "", ["flag-my"], 34, 27, 63, 0],
        "1f1f2-1f1ff": [['\uD83C\uDDF2\uD83C\uDDFF'], "", "", ["flag-mz"], 34, 28, 63, 0],
        "1f1f3-1f1e6": [['\uD83C\uDDF3\uD83C\uDDE6'], "", "", ["flag-na"], 34, 29, 63, 0],
        "1f1f3-1f1e8": [['\uD83C\uDDF3\uD83C\uDDE8'], "", "", ["flag-nc"], 34, 30, 61, 0],
        "1f1f3-1f1ea": [['\uD83C\uDDF3\uD83C\uDDEA'], "", "", ["flag-ne"], 34, 31, 63, 0],
        "1f1f3-1f1eb": [['\uD83C\uDDF3\uD83C\uDDEB'], "", "", ["flag-nf"], 34, 32, 63, 0],
        "1f1f3-1f1ec": [['\uD83C\uDDF3\uD83C\uDDEC'], "", "", ["flag-ng"], 34, 33, 63, 0],
        "1f1f3-1f1ee": [['\uD83C\uDDF3\uD83C\uDDEE'], "", "", ["flag-ni"], 34, 34, 63, 0],
        "1f1f3-1f1f1": [['\uD83C\uDDF3\uD83C\uDDF1'], "", "", ["flag-nl"], 34, 35, 63, 0],
        "1f1f3-1f1f4": [['\uD83C\uDDF3\uD83C\uDDF4'], "", "", ["flag-no"], 34, 36, 63, 0],
        "1f1f3-1f1f5": [['\uD83C\uDDF3\uD83C\uDDF5'], "", "", ["flag-np"], 34, 37, 63, 0],
        "1f1f3-1f1f7": [['\uD83C\uDDF3\uD83C\uDDF7'], "", "", ["flag-nr"], 34, 38, 63, 0],
        "1f1f3-1f1fa": [['\uD83C\uDDF3\uD83C\uDDFA'], "", "", ["flag-nu"], 34, 39, 63, 0],
        "1f1f3-1f1ff": [['\uD83C\uDDF3\uD83C\uDDFF'], "", "", ["flag-nz"], 34, 40, 63, 0],
        "1f1f4-1f1f2": [['\uD83C\uDDF4\uD83C\uDDF2'], "", "", ["flag-om"], 34, 41, 63, 0],
        "1f1f5-1f1e6": [['\uD83C\uDDF5\uD83C\uDDE6'], "", "", ["flag-pa"], 34, 42, 63, 0],
        "1f1f5-1f1ea": [['\uD83C\uDDF5\uD83C\uDDEA'], "", "", ["flag-pe"], 34, 43, 63, 0],
        "1f1f5-1f1eb": [['\uD83C\uDDF5\uD83C\uDDEB'], "", "", ["flag-pf"], 34, 44, 63, 0],
        "1f1f5-1f1ec": [['\uD83C\uDDF5\uD83C\uDDEC'], "", "", ["flag-pg"], 34, 45, 63, 0],
        "1f1f5-1f1ed": [['\uD83C\uDDF5\uD83C\uDDED'], "", "", ["flag-ph"], 34, 46, 63, 0],
        "1f1f5-1f1f0": [['\uD83C\uDDF5\uD83C\uDDF0'], "", "", ["flag-pk"], 34, 47, 63, 0],
        "1f1f5-1f1f1": [['\uD83C\uDDF5\uD83C\uDDF1'], "", "", ["flag-pl"], 34, 48, 63, 0],
        "1f1f5-1f1f2": [['\uD83C\uDDF5\uD83C\uDDF2'], "", "", ["flag-pm"], 35, 0, 61, 0],
        "1f1f5-1f1f3": [['\uD83C\uDDF5\uD83C\uDDF3'], "", "", ["flag-pn"], 35, 1, 63, 0],
        "1f1f5-1f1f7": [['\uD83C\uDDF5\uD83C\uDDF7'], "", "", ["flag-pr"], 35, 2, 63, 0],
        "1f1f5-1f1f8": [['\uD83C\uDDF5\uD83C\uDDF8'], "", "", ["flag-ps"], 35, 3, 63, 0],
        "1f1f5-1f1f9": [['\uD83C\uDDF5\uD83C\uDDF9'], "", "", ["flag-pt"], 35, 4, 63, 0],
        "1f1f5-1f1fc": [['\uD83C\uDDF5\uD83C\uDDFC'], "", "", ["flag-pw"], 35, 5, 63, 0],
        "1f1f5-1f1fe": [['\uD83C\uDDF5\uD83C\uDDFE'], "", "", ["flag-py"], 35, 6, 63, 0],
        "1f1f6-1f1e6": [['\uD83C\uDDF6\uD83C\uDDE6'], "", "", ["flag-qa"], 35, 7, 63, 0],
        "1f1f7-1f1ea": [['\uD83C\uDDF7\uD83C\uDDEA'], "", "", ["flag-re"], 35, 8, 61, 0],
        "1f1f7-1f1f4": [['\uD83C\uDDF7\uD83C\uDDF4'], "", "", ["flag-ro"], 35, 9, 63, 0],
        "1f1f7-1f1f8": [['\uD83C\uDDF7\uD83C\uDDF8'], "", "", ["flag-rs"], 35, 10, 63, 0],
        "1f1f7-1f1fa": [['\uD83C\uDDF7\uD83C\uDDFA'], '\uE512', '\uDBB9\uDCEC', ["flag-ru", "ru"], 35, 11, 63, 0],
        "1f1f7-1f1fc": [['\uD83C\uDDF7\uD83C\uDDFC'], "", "", ["flag-rw"], 35, 12, 63, 0],
        "1f1f8-1f1e6": [['\uD83C\uDDF8\uD83C\uDDE6'], "", "", ["flag-sa"], 35, 13, 63, 0],
        "1f1f8-1f1e7": [['\uD83C\uDDF8\uD83C\uDDE7'], "", "", ["flag-sb"], 35, 14, 63, 0],
        "1f1f8-1f1e8": [['\uD83C\uDDF8\uD83C\uDDE8'], "", "", ["flag-sc"], 35, 15, 63, 0],
        "1f1f8-1f1e9": [['\uD83C\uDDF8\uD83C\uDDE9'], "", "", ["flag-sd"], 35, 16, 63, 0],
        "1f1f8-1f1ea": [['\uD83C\uDDF8\uD83C\uDDEA'], "", "", ["flag-se"], 35, 17, 63, 0],
        "1f1f8-1f1ec": [['\uD83C\uDDF8\uD83C\uDDEC'], "", "", ["flag-sg"], 35, 18, 63, 0],
        "1f1f8-1f1ed": [['\uD83C\uDDF8\uD83C\uDDED'], "", "", ["flag-sh"], 35, 19, 63, 0],
        "1f1f8-1f1ee": [['\uD83C\uDDF8\uD83C\uDDEE'], "", "", ["flag-si"], 35, 20, 63, 0],
        "1f1f8-1f1ef": [['\uD83C\uDDF8\uD83C\uDDEF'], "", "", ["flag-sj"], 35, 21, 61, 0],
        "1f1f8-1f1f0": [['\uD83C\uDDF8\uD83C\uDDF0'], "", "", ["flag-sk"], 35, 22, 63, 0],
        "1f1f8-1f1f1": [['\uD83C\uDDF8\uD83C\uDDF1'], "", "", ["flag-sl"], 35, 23, 63, 0],
        "1f1f8-1f1f2": [['\uD83C\uDDF8\uD83C\uDDF2'], "", "", ["flag-sm"], 35, 24, 63, 0],
        "1f1f8-1f1f3": [['\uD83C\uDDF8\uD83C\uDDF3'], "", "", ["flag-sn"], 35, 25, 63, 0],
        "1f1f8-1f1f4": [['\uD83C\uDDF8\uD83C\uDDF4'], "", "", ["flag-so"], 35, 26, 63, 0],
        "1f1f8-1f1f7": [['\uD83C\uDDF8\uD83C\uDDF7'], "", "", ["flag-sr"], 35, 27, 63, 0],
        "1f1f8-1f1f8": [['\uD83C\uDDF8\uD83C\uDDF8'], "", "", ["flag-ss"], 35, 28, 63, 0],
        "1f1f8-1f1f9": [['\uD83C\uDDF8\uD83C\uDDF9'], "", "", ["flag-st"], 35, 29, 63, 0],
        "1f1f8-1f1fb": [['\uD83C\uDDF8\uD83C\uDDFB'], "", "", ["flag-sv"], 35, 30, 63, 0],
        "1f1f8-1f1fd": [['\uD83C\uDDF8\uD83C\uDDFD'], "", "", ["flag-sx"], 35, 31, 63, 0],
        "1f1f8-1f1fe": [['\uD83C\uDDF8\uD83C\uDDFE'], "", "", ["flag-sy"], 35, 32, 63, 0],
        "1f1f8-1f1ff": [['\uD83C\uDDF8\uD83C\uDDFF'], "", "", ["flag-sz"], 35, 33, 63, 0],
        "1f1f9-1f1e6": [['\uD83C\uDDF9\uD83C\uDDE6'], "", "", ["flag-ta"], 35, 34, 63, 0],
        "1f1f9-1f1e8": [['\uD83C\uDDF9\uD83C\uDDE8'], "", "", ["flag-tc"], 35, 35, 63, 0],
        "1f1f9-1f1e9": [['\uD83C\uDDF9\uD83C\uDDE9'], "", "", ["flag-td"], 35, 36, 63, 0],
        "1f1f9-1f1eb": [['\uD83C\uDDF9\uD83C\uDDEB'], "", "", ["flag-tf"], 35, 37, 61, 0],
        "1f1f9-1f1ec": [['\uD83C\uDDF9\uD83C\uDDEC'], "", "", ["flag-tg"], 35, 38, 63, 0],
        "1f1f9-1f1ed": [['\uD83C\uDDF9\uD83C\uDDED'], "", "", ["flag-th"], 35, 39, 63, 0],
        "1f1f9-1f1ef": [['\uD83C\uDDF9\uD83C\uDDEF'], "", "", ["flag-tj"], 35, 40, 63, 0],
        "1f1f9-1f1f0": [['\uD83C\uDDF9\uD83C\uDDF0'], "", "", ["flag-tk"], 35, 41, 63, 0],
        "1f1f9-1f1f1": [['\uD83C\uDDF9\uD83C\uDDF1'], "", "", ["flag-tl"], 35, 42, 63, 0],
        "1f1f9-1f1f2": [['\uD83C\uDDF9\uD83C\uDDF2'], "", "", ["flag-tm"], 35, 43, 63, 0],
        "1f1f9-1f1f3": [['\uD83C\uDDF9\uD83C\uDDF3'], "", "", ["flag-tn"], 35, 44, 63, 0],
        "1f1f9-1f1f4": [['\uD83C\uDDF9\uD83C\uDDF4'], "", "", ["flag-to"], 35, 45, 63, 0],
        "1f1f9-1f1f7": [['\uD83C\uDDF9\uD83C\uDDF7'], "", "", ["flag-tr"], 35, 46, 63, 0],
        "1f1f9-1f1f9": [['\uD83C\uDDF9\uD83C\uDDF9'], "", "", ["flag-tt"], 35, 47, 63, 0],
        "1f1f9-1f1fb": [['\uD83C\uDDF9\uD83C\uDDFB'], "", "", ["flag-tv"], 35, 48, 63, 0],
        "1f1f9-1f1fc": [['\uD83C\uDDF9\uD83C\uDDFC'], "", "", ["flag-tw"], 36, 0, 63, 0],
        "1f1f9-1f1ff": [['\uD83C\uDDF9\uD83C\uDDFF'], "", "", ["flag-tz"], 36, 1, 63, 0],
        "1f1fa-1f1e6": [['\uD83C\uDDFA\uD83C\uDDE6'], "", "", ["flag-ua"], 36, 2, 63, 0],
        "1f1fa-1f1ec": [['\uD83C\uDDFA\uD83C\uDDEC'], "", "", ["flag-ug"], 36, 3, 63, 0],
        "1f1fa-1f1f2": [['\uD83C\uDDFA\uD83C\uDDF2'], "", "", ["flag-um"], 36, 4, 61, 0],
        "1f1fa-1f1f3": [['\uD83C\uDDFA\uD83C\uDDF3'], "", "", ["flag-un"], 36, 5, 6, 0],
        "1f1fa-1f1f8": [['\uD83C\uDDFA\uD83C\uDDF8'], '\uE50C', '\uDBB9\uDCE6', ["flag-us", "us"], 36, 6, 63, 0],
        "1f1fa-1f1fe": [['\uD83C\uDDFA\uD83C\uDDFE'], "", "", ["flag-uy"], 36, 7, 63, 0],
        "1f1fa-1f1ff": [['\uD83C\uDDFA\uD83C\uDDFF'], "", "", ["flag-uz"], 36, 8, 63, 0],
        "1f1fb-1f1e6": [['\uD83C\uDDFB\uD83C\uDDE6'], "", "", ["flag-va"], 36, 9, 63, 0],
        "1f1fb-1f1e8": [['\uD83C\uDDFB\uD83C\uDDE8'], "", "", ["flag-vc"], 36, 10, 63, 0],
        "1f1fb-1f1ea": [['\uD83C\uDDFB\uD83C\uDDEA'], "", "", ["flag-ve"], 36, 11, 63, 0],
        "1f1fb-1f1ec": [['\uD83C\uDDFB\uD83C\uDDEC'], "", "", ["flag-vg"], 36, 12, 63, 0],
        "1f1fb-1f1ee": [['\uD83C\uDDFB\uD83C\uDDEE'], "", "", ["flag-vi"], 36, 13, 63, 0],
        "1f1fb-1f1f3": [['\uD83C\uDDFB\uD83C\uDDF3'], "", "", ["flag-vn"], 36, 14, 63, 0],
        "1f1fb-1f1fa": [['\uD83C\uDDFB\uD83C\uDDFA'], "", "", ["flag-vu"], 36, 15, 63, 0],
        "1f1fc-1f1eb": [['\uD83C\uDDFC\uD83C\uDDEB'], "", "", ["flag-wf"], 36, 16, 61, 0],
        "1f1fc-1f1f8": [['\uD83C\uDDFC\uD83C\uDDF8'], "", "", ["flag-ws"], 36, 17, 63, 0],
        "1f1fd-1f1f0": [['\uD83C\uDDFD\uD83C\uDDF0'], "", "", ["flag-xk"], 36, 18, 61, 0],
        "1f1fe-1f1ea": [['\uD83C\uDDFE\uD83C\uDDEA'], "", "", ["flag-ye"], 36, 19, 63, 0],
        "1f1fe-1f1f9": [['\uD83C\uDDFE\uD83C\uDDF9'], "", "", ["flag-yt"], 36, 20, 61, 0],
        "1f1ff-1f1e6": [['\uD83C\uDDFF\uD83C\uDDE6'], "", "", ["flag-za"], 36, 21, 63, 0],
        "1f1ff-1f1f2": [['\uD83C\uDDFF\uD83C\uDDF2'], "", "", ["flag-zm"], 36, 22, 63, 0],
        "1f1ff-1f1fc": [['\uD83C\uDDFF\uD83C\uDDFC'], "", "", ["flag-zw"], 36, 23, 63, 0],
        "1f468-200d-1f33e": [['\uD83D\uDC68\u200D\uD83C\uDF3E'], "", "", ["male-farmer"], 36, 24, 23, 0],
        "1f468-200d-1f373": [['\uD83D\uDC68\u200D\uD83C\uDF73'], "", "", ["male-cook"], 36, 30, 23, 0],
        "1f468-200d-1f393": [['\uD83D\uDC68\u200D\uD83C\uDF93'], "", "", ["male-student"], 36, 36, 23, 0],
        "1f468-200d-1f3a4": [['\uD83D\uDC68\u200D\uD83C\uDFA4'], "", "", ["male-singer"], 36, 42, 23, 0],
        "1f468-200d-1f3a8": [['\uD83D\uDC68\u200D\uD83C\uDFA8'], "", "", ["male-artist"], 36, 48, 23, 0],
        "1f468-200d-1f3eb": [['\uD83D\uDC68\u200D\uD83C\uDFEB'], "", "", ["male-teacher"], 37, 5, 23, 0],
        "1f468-200d-1f3ed": [['\uD83D\uDC68\u200D\uD83C\uDFED'], "", "", ["male-factory-worker"], 37, 11, 23, 0],
        "1f468-200d-1f466": [['\uD83D\uDC68\u200D\uD83D\uDC66'], "", "", ["man-boy"], 37, 17, 23, 0],
        "1f468-200d-1f467": [['\uD83D\uDC68\u200D\uD83D\uDC67'], "", "", ["man-girl"], 37, 18, 23, 0],
        "1f468-200d-1f4bb": [['\uD83D\uDC68\u200D\uD83D\uDCBB'], "", "", ["male-technologist"], 37, 19, 23, 0],
        "1f468-200d-1f4bc": [['\uD83D\uDC68\u200D\uD83D\uDCBC'], "", "", ["male-office-worker"], 37, 25, 23, 0],
        "1f468-200d-1f527": [['\uD83D\uDC68\u200D\uD83D\uDD27'], "", "", ["male-mechanic"], 37, 31, 23, 0],
        "1f468-200d-1f52c": [['\uD83D\uDC68\u200D\uD83D\uDD2C'], "", "", ["male-scientist"], 37, 37, 23, 0],
        "1f468-200d-1f680": [['\uD83D\uDC68\u200D\uD83D\uDE80'], "", "", ["male-astronaut"], 37, 43, 23, 0],
        "1f468-200d-1f692": [['\uD83D\uDC68\u200D\uD83D\uDE92'], "", "", ["male-firefighter"], 38, 0, 23, 0],
        "1f469-200d-1f33e": [['\uD83D\uDC69\u200D\uD83C\uDF3E'], "", "", ["female-farmer"], 38, 6, 23, 0],
        "1f469-200d-1f373": [['\uD83D\uDC69\u200D\uD83C\uDF73'], "", "", ["female-cook"], 38, 12, 23, 0],
        "1f469-200d-1f393": [['\uD83D\uDC69\u200D\uD83C\uDF93'], "", "", ["female-student"], 38, 18, 23, 0],
        "1f469-200d-1f3a4": [['\uD83D\uDC69\u200D\uD83C\uDFA4'], "", "", ["female-singer"], 38, 24, 23, 0],
        "1f469-200d-1f3a8": [['\uD83D\uDC69\u200D\uD83C\uDFA8'], "", "", ["female-artist"], 38, 30, 23, 0],
        "1f469-200d-1f3eb": [['\uD83D\uDC69\u200D\uD83C\uDFEB'], "", "", ["female-teacher"], 38, 36, 23, 0],
        "1f469-200d-1f3ed": [['\uD83D\uDC69\u200D\uD83C\uDFED'], "", "", ["female-factory-worker"], 38, 42, 23, 0],
        "1f469-200d-1f466": [['\uD83D\uDC69\u200D\uD83D\uDC66'], "", "", ["woman-boy"], 38, 48, 23, 0],
        "1f469-200d-1f467": [['\uD83D\uDC69\u200D\uD83D\uDC67'], "", "", ["woman-girl"], 39, 0, 23, 0],
        "1f469-200d-1f4bb": [['\uD83D\uDC69\u200D\uD83D\uDCBB'], "", "", ["female-technologist"], 39, 1, 23, 0],
        "1f469-200d-1f4bc": [['\uD83D\uDC69\u200D\uD83D\uDCBC'], "", "", ["female-office-worker"], 39, 7, 23, 0],
        "1f469-200d-1f527": [['\uD83D\uDC69\u200D\uD83D\uDD27'], "", "", ["female-mechanic"], 39, 13, 23, 0],
        "1f469-200d-1f52c": [['\uD83D\uDC69\u200D\uD83D\uDD2C'], "", "", ["female-scientist"], 39, 19, 23, 0],
        "1f469-200d-1f680": [['\uD83D\uDC69\u200D\uD83D\uDE80'], "", "", ["female-astronaut"], 39, 25, 23, 0],
        "1f469-200d-1f692": [['\uD83D\uDC69\u200D\uD83D\uDE92'], "", "", ["female-firefighter"], 39, 31, 23, 0],
        "1f3c3-200d-2640-fe0f": [['\uD83C\uDFC3\u200D\u2640\uFE0F'], "", "", ["woman-running"], 39, 37, 5, 0],
        "1f3c3-200d-2642-fe0f": [['\uD83C\uDFC3\u200D\u2642\uFE0F', '\uD83C\uDFC3'], "", "", ["man-running", "runner", "running"], 39, 43, 5, 0],
        "1f3c4-200d-2640-fe0f": [['\uD83C\uDFC4\u200D\u2640\uFE0F'], "", "", ["woman-surfing"], 40, 0, 5, 0],
        "1f3c4-200d-2642-fe0f": [['\uD83C\uDFC4\u200D\u2642\uFE0F', '\uD83C\uDFC4'], "", "", ["man-surfing", "surfer"], 40, 6, 5, 0],
        "1f3ca-200d-2640-fe0f": [['\uD83C\uDFCA\u200D\u2640\uFE0F'], "", "", ["woman-swimming"], 40, 12, 5, 0],
        "1f3ca-200d-2642-fe0f": [['\uD83C\uDFCA\u200D\u2642\uFE0F', '\uD83C\uDFCA'], "", "", ["man-swimming", "swimmer"], 40, 18, 5, 0],
        "1f3cb-fe0f-200d-2640-fe0f": [['\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F'], "", "", ["woman-lifting-weights"], 40, 24, 5, 0],
        "1f3cb-fe0f-200d-2642-fe0f": [['\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F', '\uD83C\uDFCB\uFE0F', '\uD83C\uDFCB'], "", "", ["man-lifting-weights", "weight_lifter"], 40, 30, 5, 0],
        "1f3cc-fe0f-200d-2640-fe0f": [['\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F'], "", "", ["woman-golfing"], 40, 36, 5, 0],
        "1f3cc-fe0f-200d-2642-fe0f": [['\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F', '\uD83C\uDFCC\uFE0F', '\uD83C\uDFCC'], "", "", ["man-golfing", "golfer"], 40, 42, 5, 0],
        "1f3f3-fe0f-200d-1f308": [['\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08'], "", "", ["rainbow-flag"], 40, 48, 53, 0],
        "1f441-fe0f-200d-1f5e8-fe0f": [['\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F'], "", "", ["eye-in-speech-bubble"], 41, 0, 1, 0],
        "1f468-200d-1f466-200d-1f466": [['\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66'], "", "", ["man-boy-boy"], 41, 1, 23, 0],
        "1f468-200d-1f467-200d-1f466": [['\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66'], "", "", ["man-girl-boy"], 41, 2, 23, 0],
        "1f468-200d-1f467-200d-1f467": [['\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67'], "", "", ["man-girl-girl"], 41, 3, 23, 0],
        "1f468-200d-1f468-200d-1f466": [['\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66'], "", "", ["man-man-boy"], 41, 4, 63, 0],
        "1f468-200d-1f468-200d-1f466-200d-1f466": [['\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66'], "", "", ["man-man-boy-boy"], 41, 5, 63, 0],
        "1f468-200d-1f468-200d-1f467": [['\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67'], "", "", ["man-man-girl"], 41, 6, 63, 0],
        "1f468-200d-1f468-200d-1f467-200d-1f466": [['\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66'], "", "", ["man-man-girl-boy"], 41, 7, 63, 0],
        "1f468-200d-1f468-200d-1f467-200d-1f467": [['\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67'], "", "", ["man-man-girl-girl"], 41, 8, 63, 0],
        "1f468-200d-1f469-200d-1f466": [['\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66', '\uD83D\uDC6A'], "", "", ["man-woman-boy", "family"], 41, 9, 55, 0],
        "1f468-200d-1f469-200d-1f466-200d-1f466": [['\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66'], "", "", ["man-woman-boy-boy"], 41, 10, 63, 0],
        "1f468-200d-1f469-200d-1f467": [['\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67'], "", "", ["man-woman-girl"], 41, 11, 63, 0],
        "1f468-200d-1f469-200d-1f467-200d-1f466": [['\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66'], "", "", ["man-woman-girl-boy"], 41, 12, 63, 0],
        "1f468-200d-1f469-200d-1f467-200d-1f467": [['\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67'], "", "", ["man-woman-girl-girl"], 41, 13, 63, 0],
        "1f468-200d-2695-fe0f": [['\uD83D\uDC68\u200D\u2695\uFE0F'], "", "", ["male-doctor"], 41, 14, 5, 0],
        "1f468-200d-2696-fe0f": [['\uD83D\uDC68\u200D\u2696\uFE0F'], "", "", ["male-judge"], 41, 20, 5, 0],
        "1f468-200d-2708-fe0f": [['\uD83D\uDC68\u200D\u2708\uFE0F'], "", "", ["male-pilot"], 41, 26, 5, 0],
        "1f468-200d-2764-fe0f-200d-1f468": [['\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68'], "", "", ["man-heart-man"], 41, 32, 53, 0],
        "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468": [['\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68'], "", "", ["man-kiss-man"], 41, 33, 53, 0],
        "1f469-200d-1f466-200d-1f466": [['\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66'], "", "", ["woman-boy-boy"], 41, 34, 23, 0],
        "1f469-200d-1f467-200d-1f466": [['\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66'], "", "", ["woman-girl-boy"], 41, 35, 23, 0],
        "1f469-200d-1f467-200d-1f467": [['\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67'], "", "", ["woman-girl-girl"], 41, 36, 23, 0],
        "1f469-200d-1f469-200d-1f466": [['\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66'], "", "", ["woman-woman-boy"], 41, 37, 63, 0],
        "1f469-200d-1f469-200d-1f466-200d-1f466": [['\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66'], "", "", ["woman-woman-boy-boy"], 41, 38, 63, 0],
        "1f469-200d-1f469-200d-1f467": [['\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67'], "", "", ["woman-woman-girl"], 41, 39, 63, 0],
        "1f469-200d-1f469-200d-1f467-200d-1f466": [['\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66'], "", "", ["woman-woman-girl-boy"], 41, 40, 63, 0],
        "1f469-200d-1f469-200d-1f467-200d-1f467": [['\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67'], "", "", ["woman-woman-girl-girl"], 41, 41, 63, 0],
        "1f469-200d-2695-fe0f": [['\uD83D\uDC69\u200D\u2695\uFE0F'], "", "", ["female-doctor"], 41, 42, 5, 0],
        "1f469-200d-2696-fe0f": [['\uD83D\uDC69\u200D\u2696\uFE0F'], "", "", ["female-judge"], 41, 48, 5, 0],
        "1f469-200d-2708-fe0f": [['\uD83D\uDC69\u200D\u2708\uFE0F'], "", "", ["female-pilot"], 42, 5, 5, 0],
        "1f469-200d-2764-fe0f-200d-1f468": [['\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68', '\uD83D\uDC91'], "", "", ["woman-heart-man", "couple_with_heart"], 42, 11, 21, 0],
        "1f469-200d-2764-fe0f-200d-1f469": [['\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69'], "", "", ["woman-heart-woman"], 42, 12, 53, 0],
        "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468": [['\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68', '\uD83D\uDC8F'], "", "", ["woman-kiss-man", "couplekiss"], 42, 13, 21, 0],
        "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469": [['\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69'], "", "", ["woman-kiss-woman"], 42, 14, 53, 0],
        "1f46e-200d-2640-fe0f": [['\uD83D\uDC6E\u200D\u2640\uFE0F'], "", "", ["female-police-officer"], 42, 15, 5, 0],
        "1f46e-200d-2642-fe0f": [['\uD83D\uDC6E\u200D\u2642\uFE0F', '\uD83D\uDC6E'], "", "", ["male-police-officer", "cop"], 42, 21, 5, 0],
        "1f46f-200d-2640-fe0f": [['\uD83D\uDC6F\u200D\u2640\uFE0F', '\uD83D\uDC6F'], "", "", ["woman-with-bunny-ears-partying", "dancers"], 42, 27, 5, 0],
        "1f46f-200d-2642-fe0f": [['\uD83D\uDC6F\u200D\u2642\uFE0F'], "", "", ["man-with-bunny-ears-partying"], 42, 28, 5, 0],
        "1f471-200d-2640-fe0f": [['\uD83D\uDC71\u200D\u2640\uFE0F'], "", "", ["blond-haired-woman"], 42, 29, 5, 0],
        "1f471-200d-2642-fe0f": [['\uD83D\uDC71\u200D\u2642\uFE0F', '\uD83D\uDC71'], "", "", ["blond-haired-man", "person_with_blond_hair"], 42, 35, 5, 0],
        "1f473-200d-2640-fe0f": [['\uD83D\uDC73\u200D\u2640\uFE0F'], "", "", ["woman-wearing-turban"], 42, 41, 5, 0],
        "1f473-200d-2642-fe0f": [['\uD83D\uDC73\u200D\u2642\uFE0F', '\uD83D\uDC73'], "", "", ["man-wearing-turban", "man_with_turban"], 42, 47, 5, 0],
        "1f477-200d-2640-fe0f": [['\uD83D\uDC77\u200D\u2640\uFE0F'], "", "", ["female-construction-worker"], 43, 4, 5, 0],
        "1f477-200d-2642-fe0f": [['\uD83D\uDC77\u200D\u2642\uFE0F', '\uD83D\uDC77'], "", "", ["male-construction-worker", "construction_worker"], 43, 10, 5, 0],
        "1f481-200d-2640-fe0f": [['\uD83D\uDC81\u200D\u2640\uFE0F', '\uD83D\uDC81'], "", "", ["woman-tipping-hand", "information_desk_person"], 43, 16, 5, 0],
        "1f481-200d-2642-fe0f": [['\uD83D\uDC81\u200D\u2642\uFE0F'], "", "", ["man-tipping-hand"], 43, 22, 5, 0],
        "1f482-200d-2640-fe0f": [['\uD83D\uDC82\u200D\u2640\uFE0F'], "", "", ["female-guard"], 43, 28, 5, 0],
        "1f482-200d-2642-fe0f": [['\uD83D\uDC82\u200D\u2642\uFE0F', '\uD83D\uDC82'], "", "", ["male-guard", "guardsman"], 43, 34, 5, 0],
        "1f486-200d-2640-fe0f": [['\uD83D\uDC86\u200D\u2640\uFE0F', '\uD83D\uDC86'], "", "", ["woman-getting-massage", "massage"], 43, 40, 5, 0],
        "1f486-200d-2642-fe0f": [['\uD83D\uDC86\u200D\u2642\uFE0F'], "", "", ["man-getting-massage"], 43, 46, 5, 0],
        "1f487-200d-2640-fe0f": [['\uD83D\uDC87\u200D\u2640\uFE0F', '\uD83D\uDC87'], "", "", ["woman-getting-haircut", "haircut"], 44, 3, 5, 0],
        "1f487-200d-2642-fe0f": [['\uD83D\uDC87\u200D\u2642\uFE0F'], "", "", ["man-getting-haircut"], 44, 9, 5, 0],
        "1f575-fe0f-200d-2640-fe0f": [['\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F'], "", "", ["female-detective"], 44, 15, 5, 0],
        "1f575-fe0f-200d-2642-fe0f": [['\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F', '\uD83D\uDD75\uFE0F', '\uD83D\uDD75'], "", "", ["male-detective", "sleuth_or_spy"], 44, 21, 5, 0],
        "1f645-200d-2640-fe0f": [['\uD83D\uDE45\u200D\u2640\uFE0F', '\uD83D\uDE45'], "", "", ["woman-gesturing-no", "no_good"], 44, 27, 5, 0],
        "1f645-200d-2642-fe0f": [['\uD83D\uDE45\u200D\u2642\uFE0F'], "", "", ["man-gesturing-no"], 44, 33, 5, 0],
        "1f646-200d-2640-fe0f": [['\uD83D\uDE46\u200D\u2640\uFE0F', '\uD83D\uDE46'], "", "", ["woman-gesturing-ok", "ok_woman"], 44, 39, 5, 0],
        "1f646-200d-2642-fe0f": [['\uD83D\uDE46\u200D\u2642\uFE0F'], "", "", ["man-gesturing-ok"], 44, 45, 5, 0],
        "1f647-200d-2640-fe0f": [['\uD83D\uDE47\u200D\u2640\uFE0F'], "", "", ["woman-bowing"], 45, 2, 5, 0],
        "1f647-200d-2642-fe0f": [['\uD83D\uDE47\u200D\u2642\uFE0F', '\uD83D\uDE47'], "", "", ["man-bowing", "bow"], 45, 8, 5, 0],
        "1f64b-200d-2640-fe0f": [['\uD83D\uDE4B\u200D\u2640\uFE0F', '\uD83D\uDE4B'], "", "", ["woman-raising-hand", "raising_hand"], 45, 14, 5, 0],
        "1f64b-200d-2642-fe0f": [['\uD83D\uDE4B\u200D\u2642\uFE0F'], "", "", ["man-raising-hand"], 45, 20, 5, 0],
        "1f64d-200d-2640-fe0f": [['\uD83D\uDE4D\u200D\u2640\uFE0F', '\uD83D\uDE4D'], "", "", ["woman-frowning", "person_frowning"], 45, 26, 5, 0],
        "1f64d-200d-2642-fe0f": [['\uD83D\uDE4D\u200D\u2642\uFE0F'], "", "", ["man-frowning"], 45, 32, 5, 0],
        "1f64e-200d-2640-fe0f": [['\uD83D\uDE4E\u200D\u2640\uFE0F', '\uD83D\uDE4E'], "", "", ["woman-pouting", "person_with_pouting_face"], 45, 38, 5, 0],
        "1f64e-200d-2642-fe0f": [['\uD83D\uDE4E\u200D\u2642\uFE0F'], "", "", ["man-pouting"], 45, 44, 5, 0],
        "1f6a3-200d-2640-fe0f": [['\uD83D\uDEA3\u200D\u2640\uFE0F'], "", "", ["woman-rowing-boat"], 46, 1, 5, 0],
        "1f6a3-200d-2642-fe0f": [['\uD83D\uDEA3\u200D\u2642\uFE0F', '\uD83D\uDEA3'], "", "", ["man-rowing-boat", "rowboat"], 46, 7, 5, 0],
        "1f6b4-200d-2640-fe0f": [['\uD83D\uDEB4\u200D\u2640\uFE0F'], "", "", ["woman-biking"], 46, 13, 5, 0],
        "1f6b4-200d-2642-fe0f": [['\uD83D\uDEB4\u200D\u2642\uFE0F', '\uD83D\uDEB4'], "", "", ["man-biking", "bicyclist"], 46, 19, 5, 0],
        "1f6b5-200d-2640-fe0f": [['\uD83D\uDEB5\u200D\u2640\uFE0F'], "", "", ["woman-mountain-biking"], 46, 25, 5, 0],
        "1f6b5-200d-2642-fe0f": [['\uD83D\uDEB5\u200D\u2642\uFE0F', '\uD83D\uDEB5'], "", "", ["man-mountain-biking", "mountain_bicyclist"], 46, 31, 5, 0],
        "1f6b6-200d-2640-fe0f": [['\uD83D\uDEB6\u200D\u2640\uFE0F'], "", "", ["woman-walking"], 46, 37, 5, 0],
        "1f6b6-200d-2642-fe0f": [['\uD83D\uDEB6\u200D\u2642\uFE0F', '\uD83D\uDEB6'], "", "", ["man-walking", "walking"], 46, 43, 5, 0],
        "1f926-200d-2640-fe0f": [['\uD83E\uDD26\u200D\u2640\uFE0F'], "", "", ["woman-facepalming"], 47, 0, 5, 0],
        "1f926-200d-2642-fe0f": [['\uD83E\uDD26\u200D\u2642\uFE0F'], "", "", ["man-facepalming"], 47, 6, 5, 0],
        "1f937-200d-2640-fe0f": [['\uD83E\uDD37\u200D\u2640\uFE0F'], "", "", ["woman-shrugging"], 47, 12, 5, 0],
        "1f937-200d-2642-fe0f": [['\uD83E\uDD37\u200D\u2642\uFE0F'], "", "", ["man-shrugging"], 47, 18, 5, 0],
        "1f938-200d-2640-fe0f": [['\uD83E\uDD38\u200D\u2640\uFE0F'], "", "", ["woman-cartwheeling"], 47, 24, 5, 0],
        "1f938-200d-2642-fe0f": [['\uD83E\uDD38\u200D\u2642\uFE0F'], "", "", ["man-cartwheeling"], 47, 30, 5, 0],
        "1f939-200d-2640-fe0f": [['\uD83E\uDD39\u200D\u2640\uFE0F'], "", "", ["woman-juggling"], 47, 36, 5, 0],
        "1f939-200d-2642-fe0f": [['\uD83E\uDD39\u200D\u2642\uFE0F'], "", "", ["man-juggling"], 47, 42, 5, 0],
        "1f93c-200d-2640-fe0f": [['\uD83E\uDD3C\u200D\u2640\uFE0F'], "", "", ["woman-wrestling"], 47, 48, 5, 0],
        "1f93c-200d-2642-fe0f": [['\uD83E\uDD3C\u200D\u2642\uFE0F'], "", "", ["man-wrestling"], 48, 0, 5, 0],
        "1f93d-200d-2640-fe0f": [['\uD83E\uDD3D\u200D\u2640\uFE0F'], "", "", ["woman-playing-water-polo"], 48, 1, 5, 0],
        "1f93d-200d-2642-fe0f": [['\uD83E\uDD3D\u200D\u2642\uFE0F'], "", "", ["man-playing-water-polo"], 48, 7, 5, 0],
        "1f93e-200d-2640-fe0f": [['\uD83E\uDD3E\u200D\u2640\uFE0F'], "", "", ["woman-playing-handball"], 48, 13, 5, 0],
        "1f93e-200d-2642-fe0f": [['\uD83E\uDD3E\u200D\u2642\uFE0F'], "", "", ["man-playing-handball"], 48, 19, 5, 0],
        "26f9-fe0f-200d-2640-fe0f": [['\u26F9\uFE0F\u200D\u2640\uFE0F'], "", "", ["woman-bouncing-ball"], 48, 25, 5, 0],
        "26f9-fe0f-200d-2642-fe0f": [['\u26F9\uFE0F\u200D\u2642\uFE0F', '\u26F9\uFE0F', '\u26F9'], "", "", ["man-bouncing-ball", "person_with_ball"], 48, 31, 5, 0]
    };
    /** @private */
    emoji.prototype.emoticons_data = {
        "<3": "heart",
        ":o)": "monkey_face",
        "<\/3": "broken_heart",
        "=)": "smiley",
        "=-)": "smiley",
        "C:": "smile",
        "c:": "smile",
        ":D": "smile",
        ":-D": "smile",
        ":>": "laughing",
        ":->": "laughing",
        ";)": "wink",
        ";-)": "wink",
        "8)": "sunglasses",
        ":|": "neutral_face",
        ":-|": "neutral_face",
        ":\\": "confused",
        ":-\\": "confused",
        ":\/": "confused",
        ":-\/": "confused",
        ":*": "kissing_heart",
        ":-*": "kissing_heart",
        ":p": "stuck_out_tongue",
        ":-p": "stuck_out_tongue",
        ":P": "stuck_out_tongue",
        ":-P": "stuck_out_tongue",
        ":b": "stuck_out_tongue",
        ":-b": "stuck_out_tongue",
        ";p": "stuck_out_tongue_winking_eye",
        ";-p": "stuck_out_tongue_winking_eye",
        ";b": "stuck_out_tongue_winking_eye",
        ";-b": "stuck_out_tongue_winking_eye",
        ";P": "stuck_out_tongue_winking_eye",
        ";-P": "stuck_out_tongue_winking_eye",
        "):": "disappointed",
        ":(": "disappointed",
        ":-(": "disappointed",
        ">:(": "angry",
        ">:-(": "angry",
        ":'(": "cry",
        "D:": "anguished",
        ":o": "open_mouth",
        ":-o": "open_mouth",
        ":O": "open_mouth",
        ":-O": "open_mouth",
        ":)": "slightly_smiling_face",
        "(:": "slightly_smiling_face",
        ":-)": "slightly_smiling_face"
    };
    /** @private */
    emoji.prototype.variations_data = {
        "261d": { "1f3fb": ["261d-1f3fb", 1, 3, 63, ['\u261D\uD83C\uDFFB']], "1f3fc": ["261d-1f3fc", 1, 4, 63, ['\u261D\uD83C\uDFFC']], "1f3fd": ["261d-1f3fd", 1, 5, 63, ['\u261D\uD83C\uDFFD']], "1f3fe": ["261d-1f3fe", 1, 6, 63, ['\u261D\uD83C\uDFFE']], "1f3ff": ["261d-1f3ff", 1, 7, 63, ['\u261D\uD83C\uDFFF']] },
        "270a": { "1f3fb": ["270a-1f3fb", 2, 38, 63, ['\u270A\uD83C\uDFFB']], "1f3fc": ["270a-1f3fc", 2, 39, 63, ['\u270A\uD83C\uDFFC']], "1f3fd": ["270a-1f3fd", 2, 40, 63, ['\u270A\uD83C\uDFFD']], "1f3fe": ["270a-1f3fe", 2, 41, 63, ['\u270A\uD83C\uDFFE']], "1f3ff": ["270a-1f3ff", 2, 42, 63, ['\u270A\uD83C\uDFFF']] },
        "270b": { "1f3fb": ["270b-1f3fb", 2, 44, 63, ['\u270B\uD83C\uDFFB']], "1f3fc": ["270b-1f3fc", 2, 45, 63, ['\u270B\uD83C\uDFFC']], "1f3fd": ["270b-1f3fd", 2, 46, 63, ['\u270B\uD83C\uDFFD']], "1f3fe": ["270b-1f3fe", 2, 47, 63, ['\u270B\uD83C\uDFFE']], "1f3ff": ["270b-1f3ff", 2, 48, 63, ['\u270B\uD83C\uDFFF']] },
        "270c": { "1f3fb": ["270c-1f3fb", 3, 1, 63, ['\u270C\uD83C\uDFFB']], "1f3fc": ["270c-1f3fc", 3, 2, 63, ['\u270C\uD83C\uDFFC']], "1f3fd": ["270c-1f3fd", 3, 3, 63, ['\u270C\uD83C\uDFFD']], "1f3fe": ["270c-1f3fe", 3, 4, 63, ['\u270C\uD83C\uDFFE']], "1f3ff": ["270c-1f3ff", 3, 5, 63, ['\u270C\uD83C\uDFFF']] },
        "270d": { "1f3fb": ["270d-1f3fb", 3, 7, 31, ['\u270D\uD83C\uDFFB']], "1f3fc": ["270d-1f3fc", 3, 8, 31, ['\u270D\uD83C\uDFFC']], "1f3fd": ["270d-1f3fd", 3, 9, 31, ['\u270D\uD83C\uDFFD']], "1f3fe": ["270d-1f3fe", 3, 10, 31, ['\u270D\uD83C\uDFFE']], "1f3ff": ["270d-1f3ff", 3, 11, 31, ['\u270D\uD83C\uDFFF']] },
        "1f385": { "1f3fb": ["1f385-1f3fb", 7, 18, 63, ['\uD83C\uDF85\uD83C\uDFFB']], "1f3fc": ["1f385-1f3fc", 7, 19, 63, ['\uD83C\uDF85\uD83C\uDFFC']], "1f3fd": ["1f385-1f3fd", 7, 20, 63, ['\uD83C\uDF85\uD83C\uDFFD']], "1f3fe": ["1f385-1f3fe", 7, 21, 63, ['\uD83C\uDF85\uD83C\uDFFE']], "1f3ff": ["1f385-1f3ff", 7, 22, 63, ['\uD83C\uDF85\uD83C\uDFFF']] },
        "1f3c2": { "1f3fb": ["1f3c2-1f3fb", 8, 30, 53, ['\uD83C\uDFC2\uD83C\uDFFB']], "1f3fc": ["1f3c2-1f3fc", 8, 31, 53, ['\uD83C\uDFC2\uD83C\uDFFC']], "1f3fd": ["1f3c2-1f3fd", 8, 32, 53, ['\uD83C\uDFC2\uD83C\uDFFD']], "1f3fe": ["1f3c2-1f3fe", 8, 33, 53, ['\uD83C\uDFC2\uD83C\uDFFE']], "1f3ff": ["1f3c2-1f3ff", 8, 34, 53, ['\uD83C\uDFC2\uD83C\uDFFF']] },
        "1f3c7": { "1f3fb": ["1f3c7-1f3fb", 9, 1, 61, ['\uD83C\uDFC7\uD83C\uDFFB']], "1f3fc": ["1f3c7-1f3fc", 9, 2, 61, ['\uD83C\uDFC7\uD83C\uDFFC']], "1f3fd": ["1f3c7-1f3fd", 9, 3, 61, ['\uD83C\uDFC7\uD83C\uDFFD']], "1f3fe": ["1f3c7-1f3fe", 9, 4, 61, ['\uD83C\uDFC7\uD83C\uDFFE']], "1f3ff": ["1f3c7-1f3ff", 9, 5, 61, ['\uD83C\uDFC7\uD83C\uDFFF']] },
        "1f442": { "1f3fb": ["1f442-1f3fb", 11, 43, 63, ['\uD83D\uDC42\uD83C\uDFFB']], "1f3fc": ["1f442-1f3fc", 11, 44, 63, ['\uD83D\uDC42\uD83C\uDFFC']], "1f3fd": ["1f442-1f3fd", 11, 45, 63, ['\uD83D\uDC42\uD83C\uDFFD']], "1f3fe": ["1f442-1f3fe", 11, 46, 63, ['\uD83D\uDC42\uD83C\uDFFE']], "1f3ff": ["1f442-1f3ff", 11, 47, 63, ['\uD83D\uDC42\uD83C\uDFFF']] },
        "1f443": { "1f3fb": ["1f443-1f3fb", 12, 0, 63, ['\uD83D\uDC43\uD83C\uDFFB']], "1f3fc": ["1f443-1f3fc", 12, 1, 63, ['\uD83D\uDC43\uD83C\uDFFC']], "1f3fd": ["1f443-1f3fd", 12, 2, 63, ['\uD83D\uDC43\uD83C\uDFFD']], "1f3fe": ["1f443-1f3fe", 12, 3, 63, ['\uD83D\uDC43\uD83C\uDFFE']], "1f3ff": ["1f443-1f3ff", 12, 4, 63, ['\uD83D\uDC43\uD83C\uDFFF']] },
        "1f446": { "1f3fb": ["1f446-1f3fb", 12, 8, 63, ['\uD83D\uDC46\uD83C\uDFFB']], "1f3fc": ["1f446-1f3fc", 12, 9, 63, ['\uD83D\uDC46\uD83C\uDFFC']], "1f3fd": ["1f446-1f3fd", 12, 10, 63, ['\uD83D\uDC46\uD83C\uDFFD']], "1f3fe": ["1f446-1f3fe", 12, 11, 63, ['\uD83D\uDC46\uD83C\uDFFE']], "1f3ff": ["1f446-1f3ff", 12, 12, 63, ['\uD83D\uDC46\uD83C\uDFFF']] },
        "1f447": { "1f3fb": ["1f447-1f3fb", 12, 14, 63, ['\uD83D\uDC47\uD83C\uDFFB']], "1f3fc": ["1f447-1f3fc", 12, 15, 63, ['\uD83D\uDC47\uD83C\uDFFC']], "1f3fd": ["1f447-1f3fd", 12, 16, 63, ['\uD83D\uDC47\uD83C\uDFFD']], "1f3fe": ["1f447-1f3fe", 12, 17, 63, ['\uD83D\uDC47\uD83C\uDFFE']], "1f3ff": ["1f447-1f3ff", 12, 18, 63, ['\uD83D\uDC47\uD83C\uDFFF']] },
        "1f448": { "1f3fb": ["1f448-1f3fb", 12, 20, 63, ['\uD83D\uDC48\uD83C\uDFFB']], "1f3fc": ["1f448-1f3fc", 12, 21, 63, ['\uD83D\uDC48\uD83C\uDFFC']], "1f3fd": ["1f448-1f3fd", 12, 22, 63, ['\uD83D\uDC48\uD83C\uDFFD']], "1f3fe": ["1f448-1f3fe", 12, 23, 63, ['\uD83D\uDC48\uD83C\uDFFE']], "1f3ff": ["1f448-1f3ff", 12, 24, 63, ['\uD83D\uDC48\uD83C\uDFFF']] },
        "1f449": { "1f3fb": ["1f449-1f3fb", 12, 26, 63, ['\uD83D\uDC49\uD83C\uDFFB']], "1f3fc": ["1f449-1f3fc", 12, 27, 63, ['\uD83D\uDC49\uD83C\uDFFC']], "1f3fd": ["1f449-1f3fd", 12, 28, 63, ['\uD83D\uDC49\uD83C\uDFFD']], "1f3fe": ["1f449-1f3fe", 12, 29, 63, ['\uD83D\uDC49\uD83C\uDFFE']], "1f3ff": ["1f449-1f3ff", 12, 30, 63, ['\uD83D\uDC49\uD83C\uDFFF']] },
        "1f44a": { "1f3fb": ["1f44a-1f3fb", 12, 32, 63, ['\uD83D\uDC4A\uD83C\uDFFB']], "1f3fc": ["1f44a-1f3fc", 12, 33, 63, ['\uD83D\uDC4A\uD83C\uDFFC']], "1f3fd": ["1f44a-1f3fd", 12, 34, 63, ['\uD83D\uDC4A\uD83C\uDFFD']], "1f3fe": ["1f44a-1f3fe", 12, 35, 63, ['\uD83D\uDC4A\uD83C\uDFFE']], "1f3ff": ["1f44a-1f3ff", 12, 36, 63, ['\uD83D\uDC4A\uD83C\uDFFF']] },
        "1f44b": { "1f3fb": ["1f44b-1f3fb", 12, 38, 63, ['\uD83D\uDC4B\uD83C\uDFFB']], "1f3fc": ["1f44b-1f3fc", 12, 39, 63, ['\uD83D\uDC4B\uD83C\uDFFC']], "1f3fd": ["1f44b-1f3fd", 12, 40, 63, ['\uD83D\uDC4B\uD83C\uDFFD']], "1f3fe": ["1f44b-1f3fe", 12, 41, 63, ['\uD83D\uDC4B\uD83C\uDFFE']], "1f3ff": ["1f44b-1f3ff", 12, 42, 63, ['\uD83D\uDC4B\uD83C\uDFFF']] },
        "1f44c": { "1f3fb": ["1f44c-1f3fb", 12, 44, 63, ['\uD83D\uDC4C\uD83C\uDFFB']], "1f3fc": ["1f44c-1f3fc", 12, 45, 63, ['\uD83D\uDC4C\uD83C\uDFFC']], "1f3fd": ["1f44c-1f3fd", 12, 46, 63, ['\uD83D\uDC4C\uD83C\uDFFD']], "1f3fe": ["1f44c-1f3fe", 12, 47, 63, ['\uD83D\uDC4C\uD83C\uDFFE']], "1f3ff": ["1f44c-1f3ff", 12, 48, 63, ['\uD83D\uDC4C\uD83C\uDFFF']] },
        "1f44d": { "1f3fb": ["1f44d-1f3fb", 13, 1, 63, ['\uD83D\uDC4D\uD83C\uDFFB']], "1f3fc": ["1f44d-1f3fc", 13, 2, 63, ['\uD83D\uDC4D\uD83C\uDFFC']], "1f3fd": ["1f44d-1f3fd", 13, 3, 63, ['\uD83D\uDC4D\uD83C\uDFFD']], "1f3fe": ["1f44d-1f3fe", 13, 4, 63, ['\uD83D\uDC4D\uD83C\uDFFE']], "1f3ff": ["1f44d-1f3ff", 13, 5, 63, ['\uD83D\uDC4D\uD83C\uDFFF']] },
        "1f44e": { "1f3fb": ["1f44e-1f3fb", 13, 7, 63, ['\uD83D\uDC4E\uD83C\uDFFB']], "1f3fc": ["1f44e-1f3fc", 13, 8, 63, ['\uD83D\uDC4E\uD83C\uDFFC']], "1f3fd": ["1f44e-1f3fd", 13, 9, 63, ['\uD83D\uDC4E\uD83C\uDFFD']], "1f3fe": ["1f44e-1f3fe", 13, 10, 63, ['\uD83D\uDC4E\uD83C\uDFFE']], "1f3ff": ["1f44e-1f3ff", 13, 11, 63, ['\uD83D\uDC4E\uD83C\uDFFF']] },
        "1f44f": { "1f3fb": ["1f44f-1f3fb", 13, 13, 63, ['\uD83D\uDC4F\uD83C\uDFFB']], "1f3fc": ["1f44f-1f3fc", 13, 14, 63, ['\uD83D\uDC4F\uD83C\uDFFC']], "1f3fd": ["1f44f-1f3fd", 13, 15, 63, ['\uD83D\uDC4F\uD83C\uDFFD']], "1f3fe": ["1f44f-1f3fe", 13, 16, 63, ['\uD83D\uDC4F\uD83C\uDFFE']], "1f3ff": ["1f44f-1f3ff", 13, 17, 63, ['\uD83D\uDC4F\uD83C\uDFFF']] },
        "1f450": { "1f3fb": ["1f450-1f3fb", 13, 19, 63, ['\uD83D\uDC50\uD83C\uDFFB']], "1f3fc": ["1f450-1f3fc", 13, 20, 63, ['\uD83D\uDC50\uD83C\uDFFC']], "1f3fd": ["1f450-1f3fd", 13, 21, 63, ['\uD83D\uDC50\uD83C\uDFFD']], "1f3fe": ["1f450-1f3fe", 13, 22, 63, ['\uD83D\uDC50\uD83C\uDFFE']], "1f3ff": ["1f450-1f3ff", 13, 23, 63, ['\uD83D\uDC50\uD83C\uDFFF']] },
        "1f466": { "1f3fb": ["1f466-1f3fb", 13, 46, 63, ['\uD83D\uDC66\uD83C\uDFFB']], "1f3fc": ["1f466-1f3fc", 13, 47, 63, ['\uD83D\uDC66\uD83C\uDFFC']], "1f3fd": ["1f466-1f3fd", 13, 48, 63, ['\uD83D\uDC66\uD83C\uDFFD']], "1f3fe": ["1f466-1f3fe", 14, 0, 63, ['\uD83D\uDC66\uD83C\uDFFE']], "1f3ff": ["1f466-1f3ff", 14, 1, 63, ['\uD83D\uDC66\uD83C\uDFFF']] },
        "1f467": { "1f3fb": ["1f467-1f3fb", 14, 3, 63, ['\uD83D\uDC67\uD83C\uDFFB']], "1f3fc": ["1f467-1f3fc", 14, 4, 63, ['\uD83D\uDC67\uD83C\uDFFC']], "1f3fd": ["1f467-1f3fd", 14, 5, 63, ['\uD83D\uDC67\uD83C\uDFFD']], "1f3fe": ["1f467-1f3fe", 14, 6, 63, ['\uD83D\uDC67\uD83C\uDFFE']], "1f3ff": ["1f467-1f3ff", 14, 7, 63, ['\uD83D\uDC67\uD83C\uDFFF']] },
        "1f468": { "1f3fb": ["1f468-1f3fb", 14, 9, 63, ['\uD83D\uDC68\uD83C\uDFFB']], "1f3fc": ["1f468-1f3fc", 14, 10, 63, ['\uD83D\uDC68\uD83C\uDFFC']], "1f3fd": ["1f468-1f3fd", 14, 11, 63, ['\uD83D\uDC68\uD83C\uDFFD']], "1f3fe": ["1f468-1f3fe", 14, 12, 63, ['\uD83D\uDC68\uD83C\uDFFE']], "1f3ff": ["1f468-1f3ff", 14, 13, 63, ['\uD83D\uDC68\uD83C\uDFFF']] },
        "1f469": { "1f3fb": ["1f469-1f3fb", 14, 15, 63, ['\uD83D\uDC69\uD83C\uDFFB']], "1f3fc": ["1f469-1f3fc", 14, 16, 63, ['\uD83D\uDC69\uD83C\uDFFC']], "1f3fd": ["1f469-1f3fd", 14, 17, 63, ['\uD83D\uDC69\uD83C\uDFFD']], "1f3fe": ["1f469-1f3fe", 14, 18, 63, ['\uD83D\uDC69\uD83C\uDFFE']], "1f3ff": ["1f469-1f3ff", 14, 19, 63, ['\uD83D\uDC69\uD83C\uDFFF']] },
        "1f470": { "1f3fb": ["1f470-1f3fb", 14, 32, 63, ['\uD83D\uDC70\uD83C\uDFFB']], "1f3fc": ["1f470-1f3fc", 14, 33, 63, ['\uD83D\uDC70\uD83C\uDFFC']], "1f3fd": ["1f470-1f3fd", 14, 34, 63, ['\uD83D\uDC70\uD83C\uDFFD']], "1f3fe": ["1f470-1f3fe", 14, 35, 63, ['\uD83D\uDC70\uD83C\uDFFE']], "1f3ff": ["1f470-1f3ff", 14, 36, 63, ['\uD83D\uDC70\uD83C\uDFFF']] },
        "1f472": { "1f3fb": ["1f472-1f3fb", 14, 44, 63, ['\uD83D\uDC72\uD83C\uDFFB']], "1f3fc": ["1f472-1f3fc", 14, 45, 63, ['\uD83D\uDC72\uD83C\uDFFC']], "1f3fd": ["1f472-1f3fd", 14, 46, 63, ['\uD83D\uDC72\uD83C\uDFFD']], "1f3fe": ["1f472-1f3fe", 14, 47, 63, ['\uD83D\uDC72\uD83C\uDFFE']], "1f3ff": ["1f472-1f3ff", 14, 48, 63, ['\uD83D\uDC72\uD83C\uDFFF']] },
        "1f474": { "1f3fb": ["1f474-1f3fb", 15, 7, 63, ['\uD83D\uDC74\uD83C\uDFFB']], "1f3fc": ["1f474-1f3fc", 15, 8, 63, ['\uD83D\uDC74\uD83C\uDFFC']], "1f3fd": ["1f474-1f3fd", 15, 9, 63, ['\uD83D\uDC74\uD83C\uDFFD']], "1f3fe": ["1f474-1f3fe", 15, 10, 63, ['\uD83D\uDC74\uD83C\uDFFE']], "1f3ff": ["1f474-1f3ff", 15, 11, 63, ['\uD83D\uDC74\uD83C\uDFFF']] },
        "1f475": { "1f3fb": ["1f475-1f3fb", 15, 13, 63, ['\uD83D\uDC75\uD83C\uDFFB']], "1f3fc": ["1f475-1f3fc", 15, 14, 63, ['\uD83D\uDC75\uD83C\uDFFC']], "1f3fd": ["1f475-1f3fd", 15, 15, 63, ['\uD83D\uDC75\uD83C\uDFFD']], "1f3fe": ["1f475-1f3fe", 15, 16, 63, ['\uD83D\uDC75\uD83C\uDFFE']], "1f3ff": ["1f475-1f3ff", 15, 17, 63, ['\uD83D\uDC75\uD83C\uDFFF']] },
        "1f476": { "1f3fb": ["1f476-1f3fb", 15, 19, 63, ['\uD83D\uDC76\uD83C\uDFFB']], "1f3fc": ["1f476-1f3fc", 15, 20, 63, ['\uD83D\uDC76\uD83C\uDFFC']], "1f3fd": ["1f476-1f3fd", 15, 21, 63, ['\uD83D\uDC76\uD83C\uDFFD']], "1f3fe": ["1f476-1f3fe", 15, 22, 63, ['\uD83D\uDC76\uD83C\uDFFE']], "1f3ff": ["1f476-1f3ff", 15, 23, 63, ['\uD83D\uDC76\uD83C\uDFFF']] },
        "1f478": { "1f3fb": ["1f478-1f3fb", 15, 31, 63, ['\uD83D\uDC78\uD83C\uDFFB']], "1f3fc": ["1f478-1f3fc", 15, 32, 63, ['\uD83D\uDC78\uD83C\uDFFC']], "1f3fd": ["1f478-1f3fd", 15, 33, 63, ['\uD83D\uDC78\uD83C\uDFFD']], "1f3fe": ["1f478-1f3fe", 15, 34, 63, ['\uD83D\uDC78\uD83C\uDFFE']], "1f3ff": ["1f478-1f3ff", 15, 35, 63, ['\uD83D\uDC78\uD83C\uDFFF']] },
        "1f47c": { "1f3fb": ["1f47c-1f3fb", 15, 40, 63, ['\uD83D\uDC7C\uD83C\uDFFB']], "1f3fc": ["1f47c-1f3fc", 15, 41, 63, ['\uD83D\uDC7C\uD83C\uDFFC']], "1f3fd": ["1f47c-1f3fd", 15, 42, 63, ['\uD83D\uDC7C\uD83C\uDFFD']], "1f3fe": ["1f47c-1f3fe", 15, 43, 63, ['\uD83D\uDC7C\uD83C\uDFFE']], "1f3ff": ["1f47c-1f3ff", 15, 44, 63, ['\uD83D\uDC7C\uD83C\uDFFF']] },
        "1f483": { "1f3fb": ["1f483-1f3fb", 16, 13, 63, ['\uD83D\uDC83\uD83C\uDFFB']], "1f3fc": ["1f483-1f3fc", 16, 14, 63, ['\uD83D\uDC83\uD83C\uDFFC']], "1f3fd": ["1f483-1f3fd", 16, 15, 63, ['\uD83D\uDC83\uD83C\uDFFD']], "1f3fe": ["1f483-1f3fe", 16, 16, 63, ['\uD83D\uDC83\uD83C\uDFFE']], "1f3ff": ["1f483-1f3ff", 16, 17, 63, ['\uD83D\uDC83\uD83C\uDFFF']] },
        "1f485": { "1f3fb": ["1f485-1f3fb", 16, 20, 63, ['\uD83D\uDC85\uD83C\uDFFB']], "1f3fc": ["1f485-1f3fc", 16, 21, 63, ['\uD83D\uDC85\uD83C\uDFFC']], "1f3fd": ["1f485-1f3fd", 16, 22, 63, ['\uD83D\uDC85\uD83C\uDFFD']], "1f3fe": ["1f485-1f3fe", 16, 23, 63, ['\uD83D\uDC85\uD83C\uDFFE']], "1f3ff": ["1f485-1f3ff", 16, 24, 63, ['\uD83D\uDC85\uD83C\uDFFF']] },
        "1f4aa": { "1f3fb": ["1f4aa-1f3fb", 17, 23, 63, ['\uD83D\uDCAA\uD83C\uDFFB']], "1f3fc": ["1f4aa-1f3fc", 17, 24, 63, ['\uD83D\uDCAA\uD83C\uDFFC']], "1f3fd": ["1f4aa-1f3fd", 17, 25, 63, ['\uD83D\uDCAA\uD83C\uDFFD']], "1f3fe": ["1f4aa-1f3fe", 17, 26, 63, ['\uD83D\uDCAA\uD83C\uDFFE']], "1f3ff": ["1f4aa-1f3ff", 17, 27, 63, ['\uD83D\uDCAA\uD83C\uDFFF']] },
        "1f574": { "1f3fb": ["1f574-1f3fb", 21, 12, 21, ['\uD83D\uDD74\uD83C\uDFFB']], "1f3fc": ["1f574-1f3fc", 21, 13, 21, ['\uD83D\uDD74\uD83C\uDFFC']], "1f3fd": ["1f574-1f3fd", 21, 14, 21, ['\uD83D\uDD74\uD83C\uDFFD']], "1f3fe": ["1f574-1f3fe", 21, 15, 21, ['\uD83D\uDD74\uD83C\uDFFE']], "1f3ff": ["1f574-1f3ff", 21, 16, 21, ['\uD83D\uDD74\uD83C\uDFFF']] },
        "1f57a": { "1f3fb": ["1f57a-1f3fb", 21, 28, 31, ['\uD83D\uDD7A\uD83C\uDFFB']], "1f3fc": ["1f57a-1f3fc", 21, 29, 31, ['\uD83D\uDD7A\uD83C\uDFFC']], "1f3fd": ["1f57a-1f3fd", 21, 30, 31, ['\uD83D\uDD7A\uD83C\uDFFD']], "1f3fe": ["1f57a-1f3fe", 21, 31, 31, ['\uD83D\uDD7A\uD83C\uDFFE']], "1f3ff": ["1f57a-1f3ff", 21, 32, 31, ['\uD83D\uDD7A\uD83C\uDFFF']] },
        "1f590": { "1f3fb": ["1f590-1f3fb", 21, 39, 31, ['\uD83D\uDD90\uD83C\uDFFB']], "1f3fc": ["1f590-1f3fc", 21, 40, 31, ['\uD83D\uDD90\uD83C\uDFFC']], "1f3fd": ["1f590-1f3fd", 21, 41, 31, ['\uD83D\uDD90\uD83C\uDFFD']], "1f3fe": ["1f590-1f3fe", 21, 42, 31, ['\uD83D\uDD90\uD83C\uDFFE']], "1f3ff": ["1f590-1f3ff", 21, 43, 31, ['\uD83D\uDD90\uD83C\uDFFF']] },
        "1f595": { "1f3fb": ["1f595-1f3fb", 21, 45, 31, ['\uD83D\uDD95\uD83C\uDFFB']], "1f3fc": ["1f595-1f3fc", 21, 46, 31, ['\uD83D\uDD95\uD83C\uDFFC']], "1f3fd": ["1f595-1f3fd", 21, 47, 31, ['\uD83D\uDD95\uD83C\uDFFD']], "1f3fe": ["1f595-1f3fe", 21, 48, 31, ['\uD83D\uDD95\uD83C\uDFFE']], "1f3ff": ["1f595-1f3ff", 22, 0, 31, ['\uD83D\uDD95\uD83C\uDFFF']] },
        "1f596": { "1f3fb": ["1f596-1f3fb", 22, 2, 31, ['\uD83D\uDD96\uD83C\uDFFB']], "1f3fc": ["1f596-1f3fc", 22, 3, 31, ['\uD83D\uDD96\uD83C\uDFFC']], "1f3fd": ["1f596-1f3fd", 22, 4, 31, ['\uD83D\uDD96\uD83C\uDFFD']], "1f3fe": ["1f596-1f3fe", 22, 5, 31, ['\uD83D\uDD96\uD83C\uDFFE']], "1f3ff": ["1f596-1f3ff", 22, 6, 31, ['\uD83D\uDD96\uD83C\uDFFF']] },
        "1f64c": { "1f3fb": ["1f64c-1f3fb", 24, 32, 63, ['\uD83D\uDE4C\uD83C\uDFFB']], "1f3fc": ["1f64c-1f3fc", 24, 33, 63, ['\uD83D\uDE4C\uD83C\uDFFC']], "1f3fd": ["1f64c-1f3fd", 24, 34, 63, ['\uD83D\uDE4C\uD83C\uDFFD']], "1f3fe": ["1f64c-1f3fe", 24, 35, 63, ['\uD83D\uDE4C\uD83C\uDFFE']], "1f3ff": ["1f64c-1f3ff", 24, 36, 63, ['\uD83D\uDE4C\uD83C\uDFFF']] },
        "1f64f": { "1f3fb": ["1f64f-1f3fb", 25, 1, 63, ['\uD83D\uDE4F\uD83C\uDFFB']], "1f3fc": ["1f64f-1f3fc", 25, 2, 63, ['\uD83D\uDE4F\uD83C\uDFFC']], "1f3fd": ["1f64f-1f3fd", 25, 3, 63, ['\uD83D\uDE4F\uD83C\uDFFD']], "1f3fe": ["1f64f-1f3fe", 25, 4, 63, ['\uD83D\uDE4F\uD83C\uDFFE']], "1f3ff": ["1f64f-1f3ff", 25, 5, 63, ['\uD83D\uDE4F\uD83C\uDFFF']] },
        "1f6c0": { "1f3fb": ["1f6c0-1f3fb", 26, 42, 63, ['\uD83D\uDEC0\uD83C\uDFFB']], "1f3fc": ["1f6c0-1f3fc", 26, 43, 63, ['\uD83D\uDEC0\uD83C\uDFFC']], "1f3fd": ["1f6c0-1f3fd", 26, 44, 63, ['\uD83D\uDEC0\uD83C\uDFFD']], "1f3fe": ["1f6c0-1f3fe", 26, 45, 63, ['\uD83D\uDEC0\uD83C\uDFFE']], "1f3ff": ["1f6c0-1f3ff", 26, 46, 63, ['\uD83D\uDEC0\uD83C\uDFFF']] },
        "1f6cc": { "1f3fb": ["1f6cc-1f3fb", 27, 5, 21, ['\uD83D\uDECC\uD83C\uDFFB']], "1f3fc": ["1f6cc-1f3fc", 27, 6, 21, ['\uD83D\uDECC\uD83C\uDFFC']], "1f3fd": ["1f6cc-1f3fd", 27, 7, 21, ['\uD83D\uDECC\uD83C\uDFFD']], "1f3fe": ["1f6cc-1f3fe", 27, 8, 21, ['\uD83D\uDECC\uD83C\uDFFE']], "1f3ff": ["1f6cc-1f3ff", 27, 9, 21, ['\uD83D\uDECC\uD83C\uDFFF']] },
        "1f918": { "1f3fb": ["1f918-1f3fb", 27, 39, 31, ['\uD83E\uDD18\uD83C\uDFFB']], "1f3fc": ["1f918-1f3fc", 27, 40, 31, ['\uD83E\uDD18\uD83C\uDFFC']], "1f3fd": ["1f918-1f3fd", 27, 41, 31, ['\uD83E\uDD18\uD83C\uDFFD']], "1f3fe": ["1f918-1f3fe", 27, 42, 31, ['\uD83E\uDD18\uD83C\uDFFE']], "1f3ff": ["1f918-1f3ff", 27, 43, 31, ['\uD83E\uDD18\uD83C\uDFFF']] },
        "1f919": { "1f3fb": ["1f919-1f3fb", 27, 45, 31, ['\uD83E\uDD19\uD83C\uDFFB']], "1f3fc": ["1f919-1f3fc", 27, 46, 31, ['\uD83E\uDD19\uD83C\uDFFC']], "1f3fd": ["1f919-1f3fd", 27, 47, 31, ['\uD83E\uDD19\uD83C\uDFFD']], "1f3fe": ["1f919-1f3fe", 27, 48, 31, ['\uD83E\uDD19\uD83C\uDFFE']], "1f3ff": ["1f919-1f3ff", 28, 0, 31, ['\uD83E\uDD19\uD83C\uDFFF']] },
        "1f91a": { "1f3fb": ["1f91a-1f3fb", 28, 2, 31, ['\uD83E\uDD1A\uD83C\uDFFB']], "1f3fc": ["1f91a-1f3fc", 28, 3, 31, ['\uD83E\uDD1A\uD83C\uDFFC']], "1f3fd": ["1f91a-1f3fd", 28, 4, 31, ['\uD83E\uDD1A\uD83C\uDFFD']], "1f3fe": ["1f91a-1f3fe", 28, 5, 31, ['\uD83E\uDD1A\uD83C\uDFFE']], "1f3ff": ["1f91a-1f3ff", 28, 6, 31, ['\uD83E\uDD1A\uD83C\uDFFF']] },
        "1f91b": { "1f3fb": ["1f91b-1f3fb", 28, 8, 31, ['\uD83E\uDD1B\uD83C\uDFFB']], "1f3fc": ["1f91b-1f3fc", 28, 9, 31, ['\uD83E\uDD1B\uD83C\uDFFC']], "1f3fd": ["1f91b-1f3fd", 28, 10, 31, ['\uD83E\uDD1B\uD83C\uDFFD']], "1f3fe": ["1f91b-1f3fe", 28, 11, 31, ['\uD83E\uDD1B\uD83C\uDFFE']], "1f3ff": ["1f91b-1f3ff", 28, 12, 31, ['\uD83E\uDD1B\uD83C\uDFFF']] },
        "1f91c": { "1f3fb": ["1f91c-1f3fb", 28, 14, 31, ['\uD83E\uDD1C\uD83C\uDFFB']], "1f3fc": ["1f91c-1f3fc", 28, 15, 31, ['\uD83E\uDD1C\uD83C\uDFFC']], "1f3fd": ["1f91c-1f3fd", 28, 16, 31, ['\uD83E\uDD1C\uD83C\uDFFD']], "1f3fe": ["1f91c-1f3fe", 28, 17, 31, ['\uD83E\uDD1C\uD83C\uDFFE']], "1f3ff": ["1f91c-1f3ff", 28, 18, 31, ['\uD83E\uDD1C\uD83C\uDFFF']] },
        "1f91e": { "1f3fb": ["1f91e-1f3fb", 28, 21, 31, ['\uD83E\uDD1E\uD83C\uDFFB']], "1f3fc": ["1f91e-1f3fc", 28, 22, 31, ['\uD83E\uDD1E\uD83C\uDFFC']], "1f3fd": ["1f91e-1f3fd", 28, 23, 31, ['\uD83E\uDD1E\uD83C\uDFFD']], "1f3fe": ["1f91e-1f3fe", 28, 24, 31, ['\uD83E\uDD1E\uD83C\uDFFE']], "1f3ff": ["1f91e-1f3ff", 28, 25, 31, ['\uD83E\uDD1E\uD83C\uDFFF']] },
        "1f926": { "1f3fb": ["1f926-1f3fb", 28, 33, 31, ['\uD83E\uDD26\uD83C\uDFFB']], "1f3fc": ["1f926-1f3fc", 28, 34, 31, ['\uD83E\uDD26\uD83C\uDFFC']], "1f3fd": ["1f926-1f3fd", 28, 35, 31, ['\uD83E\uDD26\uD83C\uDFFD']], "1f3fe": ["1f926-1f3fe", 28, 36, 31, ['\uD83E\uDD26\uD83C\uDFFE']], "1f3ff": ["1f926-1f3ff", 28, 37, 31, ['\uD83E\uDD26\uD83C\uDFFF']] },
        "1f930": { "1f3fb": ["1f930-1f3fb", 28, 40, 31, ['\uD83E\uDD30\uD83C\uDFFB']], "1f3fc": ["1f930-1f3fc", 28, 41, 31, ['\uD83E\uDD30\uD83C\uDFFC']], "1f3fd": ["1f930-1f3fd", 28, 42, 31, ['\uD83E\uDD30\uD83C\uDFFD']], "1f3fe": ["1f930-1f3fe", 28, 43, 31, ['\uD83E\uDD30\uD83C\uDFFE']], "1f3ff": ["1f930-1f3ff", 28, 44, 31, ['\uD83E\uDD30\uD83C\uDFFF']] },
        "1f933": { "1f3fb": ["1f933-1f3fb", 28, 46, 31, ['\uD83E\uDD33\uD83C\uDFFB']], "1f3fc": ["1f933-1f3fc", 28, 47, 31, ['\uD83E\uDD33\uD83C\uDFFC']], "1f3fd": ["1f933-1f3fd", 28, 48, 31, ['\uD83E\uDD33\uD83C\uDFFD']], "1f3fe": ["1f933-1f3fe", 29, 0, 31, ['\uD83E\uDD33\uD83C\uDFFE']], "1f3ff": ["1f933-1f3ff", 29, 1, 31, ['\uD83E\uDD33\uD83C\uDFFF']] },
        "1f934": { "1f3fb": ["1f934-1f3fb", 29, 3, 31, ['\uD83E\uDD34\uD83C\uDFFB']], "1f3fc": ["1f934-1f3fc", 29, 4, 31, ['\uD83E\uDD34\uD83C\uDFFC']], "1f3fd": ["1f934-1f3fd", 29, 5, 31, ['\uD83E\uDD34\uD83C\uDFFD']], "1f3fe": ["1f934-1f3fe", 29, 6, 31, ['\uD83E\uDD34\uD83C\uDFFE']], "1f3ff": ["1f934-1f3ff", 29, 7, 31, ['\uD83E\uDD34\uD83C\uDFFF']] },
        "1f935": { "1f3fb": ["1f935-1f3fb", 29, 9, 31, ['\uD83E\uDD35\uD83C\uDFFB']], "1f3fc": ["1f935-1f3fc", 29, 10, 31, ['\uD83E\uDD35\uD83C\uDFFC']], "1f3fd": ["1f935-1f3fd", 29, 11, 31, ['\uD83E\uDD35\uD83C\uDFFD']], "1f3fe": ["1f935-1f3fe", 29, 12, 31, ['\uD83E\uDD35\uD83C\uDFFE']], "1f3ff": ["1f935-1f3ff", 29, 13, 31, ['\uD83E\uDD35\uD83C\uDFFF']] },
        "1f936": { "1f3fb": ["1f936-1f3fb", 29, 15, 31, ['\uD83E\uDD36\uD83C\uDFFB']], "1f3fc": ["1f936-1f3fc", 29, 16, 31, ['\uD83E\uDD36\uD83C\uDFFC']], "1f3fd": ["1f936-1f3fd", 29, 17, 31, ['\uD83E\uDD36\uD83C\uDFFD']], "1f3fe": ["1f936-1f3fe", 29, 18, 31, ['\uD83E\uDD36\uD83C\uDFFE']], "1f3ff": ["1f936-1f3ff", 29, 19, 31, ['\uD83E\uDD36\uD83C\uDFFF']] },
        "1f937": { "1f3fb": ["1f937-1f3fb", 29, 21, 31, ['\uD83E\uDD37\uD83C\uDFFB']], "1f3fc": ["1f937-1f3fc", 29, 22, 31, ['\uD83E\uDD37\uD83C\uDFFC']], "1f3fd": ["1f937-1f3fd", 29, 23, 31, ['\uD83E\uDD37\uD83C\uDFFD']], "1f3fe": ["1f937-1f3fe", 29, 24, 31, ['\uD83E\uDD37\uD83C\uDFFE']], "1f3ff": ["1f937-1f3ff", 29, 25, 31, ['\uD83E\uDD37\uD83C\uDFFF']] },
        "1f938": { "1f3fb": ["1f938-1f3fb", 29, 27, 31, ['\uD83E\uDD38\uD83C\uDFFB']], "1f3fc": ["1f938-1f3fc", 29, 28, 31, ['\uD83E\uDD38\uD83C\uDFFC']], "1f3fd": ["1f938-1f3fd", 29, 29, 31, ['\uD83E\uDD38\uD83C\uDFFD']], "1f3fe": ["1f938-1f3fe", 29, 30, 31, ['\uD83E\uDD38\uD83C\uDFFE']], "1f3ff": ["1f938-1f3ff", 29, 31, 31, ['\uD83E\uDD38\uD83C\uDFFF']] },
        "1f939": { "1f3fb": ["1f939-1f3fb", 29, 33, 31, ['\uD83E\uDD39\uD83C\uDFFB']], "1f3fc": ["1f939-1f3fc", 29, 34, 31, ['\uD83E\uDD39\uD83C\uDFFC']], "1f3fd": ["1f939-1f3fd", 29, 35, 31, ['\uD83E\uDD39\uD83C\uDFFD']], "1f3fe": ["1f939-1f3fe", 29, 36, 31, ['\uD83E\uDD39\uD83C\uDFFE']], "1f3ff": ["1f939-1f3ff", 29, 37, 31, ['\uD83E\uDD39\uD83C\uDFFF']] },
        "1f93d": { "1f3fb": ["1f93d-1f3fb", 29, 41, 31, ['\uD83E\uDD3D\uD83C\uDFFB']], "1f3fc": ["1f93d-1f3fc", 29, 42, 31, ['\uD83E\uDD3D\uD83C\uDFFC']], "1f3fd": ["1f93d-1f3fd", 29, 43, 31, ['\uD83E\uDD3D\uD83C\uDFFD']], "1f3fe": ["1f93d-1f3fe", 29, 44, 31, ['\uD83E\uDD3D\uD83C\uDFFE']], "1f3ff": ["1f93d-1f3ff", 29, 45, 31, ['\uD83E\uDD3D\uD83C\uDFFF']] },
        "1f93e": { "1f3fb": ["1f93e-1f3fb", 29, 47, 31, ['\uD83E\uDD3E\uD83C\uDFFB']], "1f3fc": ["1f93e-1f3fc", 29, 48, 31, ['\uD83E\uDD3E\uD83C\uDFFC']], "1f3fd": ["1f93e-1f3fd", 30, 0, 31, ['\uD83E\uDD3E\uD83C\uDFFD']], "1f3fe": ["1f93e-1f3fe", 30, 1, 31, ['\uD83E\uDD3E\uD83C\uDFFE']], "1f3ff": ["1f93e-1f3ff", 30, 2, 31, ['\uD83E\uDD3E\uD83C\uDFFF']] },
        "1f468-200d-1f33e": { "1f3fb": ["1f468-1f3fb-200d-1f33e", 36, 25, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF3E']], "1f3fc": ["1f468-1f3fc-200d-1f33e", 36, 26, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF3E']], "1f3fd": ["1f468-1f3fd-200d-1f33e", 36, 27, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF3E']], "1f3fe": ["1f468-1f3fe-200d-1f33e", 36, 28, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF3E']], "1f3ff": ["1f468-1f3ff-200d-1f33e", 36, 29, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF3E']] },
        "1f468-200d-1f373": { "1f3fb": ["1f468-1f3fb-200d-1f373", 36, 31, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF73']], "1f3fc": ["1f468-1f3fc-200d-1f373", 36, 32, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF73']], "1f3fd": ["1f468-1f3fd-200d-1f373", 36, 33, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF73']], "1f3fe": ["1f468-1f3fe-200d-1f373", 36, 34, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF73']], "1f3ff": ["1f468-1f3ff-200d-1f373", 36, 35, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF73']] },
        "1f468-200d-1f393": { "1f3fb": ["1f468-1f3fb-200d-1f393", 36, 37, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF93']], "1f3fc": ["1f468-1f3fc-200d-1f393", 36, 38, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF93']], "1f3fd": ["1f468-1f3fd-200d-1f393", 36, 39, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF93']], "1f3fe": ["1f468-1f3fe-200d-1f393", 36, 40, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF93']], "1f3ff": ["1f468-1f3ff-200d-1f393", 36, 41, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF93']] },
        "1f468-200d-1f3a4": { "1f3fb": ["1f468-1f3fb-200d-1f3a4", 36, 43, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA4']], "1f3fc": ["1f468-1f3fc-200d-1f3a4", 36, 44, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA4']], "1f3fd": ["1f468-1f3fd-200d-1f3a4", 36, 45, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA4']], "1f3fe": ["1f468-1f3fe-200d-1f3a4", 36, 46, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA4']], "1f3ff": ["1f468-1f3ff-200d-1f3a4", 36, 47, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA4']] },
        "1f468-200d-1f3a8": { "1f3fb": ["1f468-1f3fb-200d-1f3a8", 37, 0, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA8']], "1f3fc": ["1f468-1f3fc-200d-1f3a8", 37, 1, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA8']], "1f3fd": ["1f468-1f3fd-200d-1f3a8", 37, 2, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA8']], "1f3fe": ["1f468-1f3fe-200d-1f3a8", 37, 3, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA8']], "1f3ff": ["1f468-1f3ff-200d-1f3a8", 37, 4, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA8']] },
        "1f468-200d-1f3eb": { "1f3fb": ["1f468-1f3fb-200d-1f3eb", 37, 6, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFEB']], "1f3fc": ["1f468-1f3fc-200d-1f3eb", 37, 7, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFEB']], "1f3fd": ["1f468-1f3fd-200d-1f3eb", 37, 8, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFEB']], "1f3fe": ["1f468-1f3fe-200d-1f3eb", 37, 9, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFEB']], "1f3ff": ["1f468-1f3ff-200d-1f3eb", 37, 10, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFEB']] },
        "1f468-200d-1f3ed": { "1f3fb": ["1f468-1f3fb-200d-1f3ed", 37, 12, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFED']], "1f3fc": ["1f468-1f3fc-200d-1f3ed", 37, 13, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFED']], "1f3fd": ["1f468-1f3fd-200d-1f3ed", 37, 14, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFED']], "1f3fe": ["1f468-1f3fe-200d-1f3ed", 37, 15, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFED']], "1f3ff": ["1f468-1f3ff-200d-1f3ed", 37, 16, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFED']] },
        "1f468-200d-1f4bb": { "1f3fb": ["1f468-1f3fb-200d-1f4bb", 37, 20, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBB']], "1f3fc": ["1f468-1f3fc-200d-1f4bb", 37, 21, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBB']], "1f3fd": ["1f468-1f3fd-200d-1f4bb", 37, 22, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBB']], "1f3fe": ["1f468-1f3fe-200d-1f4bb", 37, 23, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBB']], "1f3ff": ["1f468-1f3ff-200d-1f4bb", 37, 24, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBB']] },
        "1f468-200d-1f4bc": { "1f3fb": ["1f468-1f3fb-200d-1f4bc", 37, 26, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBC']], "1f3fc": ["1f468-1f3fc-200d-1f4bc", 37, 27, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBC']], "1f3fd": ["1f468-1f3fd-200d-1f4bc", 37, 28, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBC']], "1f3fe": ["1f468-1f3fe-200d-1f4bc", 37, 29, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBC']], "1f3ff": ["1f468-1f3ff-200d-1f4bc", 37, 30, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBC']] },
        "1f468-200d-1f527": { "1f3fb": ["1f468-1f3fb-200d-1f527", 37, 32, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD27']], "1f3fc": ["1f468-1f3fc-200d-1f527", 37, 33, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD27']], "1f3fd": ["1f468-1f3fd-200d-1f527", 37, 34, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD27']], "1f3fe": ["1f468-1f3fe-200d-1f527", 37, 35, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD27']], "1f3ff": ["1f468-1f3ff-200d-1f527", 37, 36, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD27']] },
        "1f468-200d-1f52c": { "1f3fb": ["1f468-1f3fb-200d-1f52c", 37, 38, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD2C']], "1f3fc": ["1f468-1f3fc-200d-1f52c", 37, 39, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD2C']], "1f3fd": ["1f468-1f3fd-200d-1f52c", 37, 40, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD2C']], "1f3fe": ["1f468-1f3fe-200d-1f52c", 37, 41, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD2C']], "1f3ff": ["1f468-1f3ff-200d-1f52c", 37, 42, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD2C']] },
        "1f468-200d-1f680": { "1f3fb": ["1f468-1f3fb-200d-1f680", 37, 44, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE80']], "1f3fc": ["1f468-1f3fc-200d-1f680", 37, 45, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE80']], "1f3fd": ["1f468-1f3fd-200d-1f680", 37, 46, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE80']], "1f3fe": ["1f468-1f3fe-200d-1f680", 37, 47, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE80']], "1f3ff": ["1f468-1f3ff-200d-1f680", 37, 48, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE80']] },
        "1f468-200d-1f692": { "1f3fb": ["1f468-1f3fb-200d-1f692", 38, 1, 23, ['\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE92']], "1f3fc": ["1f468-1f3fc-200d-1f692", 38, 2, 23, ['\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE92']], "1f3fd": ["1f468-1f3fd-200d-1f692", 38, 3, 23, ['\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE92']], "1f3fe": ["1f468-1f3fe-200d-1f692", 38, 4, 23, ['\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE92']], "1f3ff": ["1f468-1f3ff-200d-1f692", 38, 5, 23, ['\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE92']] },
        "1f469-200d-1f33e": { "1f3fb": ["1f469-1f3fb-200d-1f33e", 38, 7, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF3E']], "1f3fc": ["1f469-1f3fc-200d-1f33e", 38, 8, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF3E']], "1f3fd": ["1f469-1f3fd-200d-1f33e", 38, 9, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF3E']], "1f3fe": ["1f469-1f3fe-200d-1f33e", 38, 10, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF3E']], "1f3ff": ["1f469-1f3ff-200d-1f33e", 38, 11, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF3E']] },
        "1f469-200d-1f373": { "1f3fb": ["1f469-1f3fb-200d-1f373", 38, 13, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF73']], "1f3fc": ["1f469-1f3fc-200d-1f373", 38, 14, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF73']], "1f3fd": ["1f469-1f3fd-200d-1f373", 38, 15, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF73']], "1f3fe": ["1f469-1f3fe-200d-1f373", 38, 16, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF73']], "1f3ff": ["1f469-1f3ff-200d-1f373", 38, 17, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF73']] },
        "1f469-200d-1f393": { "1f3fb": ["1f469-1f3fb-200d-1f393", 38, 19, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF93']], "1f3fc": ["1f469-1f3fc-200d-1f393", 38, 20, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF93']], "1f3fd": ["1f469-1f3fd-200d-1f393", 38, 21, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF93']], "1f3fe": ["1f469-1f3fe-200d-1f393", 38, 22, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF93']], "1f3ff": ["1f469-1f3ff-200d-1f393", 38, 23, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF93']] },
        "1f469-200d-1f3a4": { "1f3fb": ["1f469-1f3fb-200d-1f3a4", 38, 25, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA4']], "1f3fc": ["1f469-1f3fc-200d-1f3a4", 38, 26, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA4']], "1f3fd": ["1f469-1f3fd-200d-1f3a4", 38, 27, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA4']], "1f3fe": ["1f469-1f3fe-200d-1f3a4", 38, 28, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA4']], "1f3ff": ["1f469-1f3ff-200d-1f3a4", 38, 29, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA4']] },
        "1f469-200d-1f3a8": { "1f3fb": ["1f469-1f3fb-200d-1f3a8", 38, 31, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA8']], "1f3fc": ["1f469-1f3fc-200d-1f3a8", 38, 32, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA8']], "1f3fd": ["1f469-1f3fd-200d-1f3a8", 38, 33, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA8']], "1f3fe": ["1f469-1f3fe-200d-1f3a8", 38, 34, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA8']], "1f3ff": ["1f469-1f3ff-200d-1f3a8", 38, 35, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA8']] },
        "1f469-200d-1f3eb": { "1f3fb": ["1f469-1f3fb-200d-1f3eb", 38, 37, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFEB']], "1f3fc": ["1f469-1f3fc-200d-1f3eb", 38, 38, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFEB']], "1f3fd": ["1f469-1f3fd-200d-1f3eb", 38, 39, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFEB']], "1f3fe": ["1f469-1f3fe-200d-1f3eb", 38, 40, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFEB']], "1f3ff": ["1f469-1f3ff-200d-1f3eb", 38, 41, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFEB']] },
        "1f469-200d-1f3ed": { "1f3fb": ["1f469-1f3fb-200d-1f3ed", 38, 43, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFED']], "1f3fc": ["1f469-1f3fc-200d-1f3ed", 38, 44, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFED']], "1f3fd": ["1f469-1f3fd-200d-1f3ed", 38, 45, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFED']], "1f3fe": ["1f469-1f3fe-200d-1f3ed", 38, 46, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFED']], "1f3ff": ["1f469-1f3ff-200d-1f3ed", 38, 47, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFED']] },
        "1f469-200d-1f4bb": { "1f3fb": ["1f469-1f3fb-200d-1f4bb", 39, 2, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBB']], "1f3fc": ["1f469-1f3fc-200d-1f4bb", 39, 3, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBB']], "1f3fd": ["1f469-1f3fd-200d-1f4bb", 39, 4, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBB']], "1f3fe": ["1f469-1f3fe-200d-1f4bb", 39, 5, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBB']], "1f3ff": ["1f469-1f3ff-200d-1f4bb", 39, 6, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBB']] },
        "1f469-200d-1f4bc": { "1f3fb": ["1f469-1f3fb-200d-1f4bc", 39, 8, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBC']], "1f3fc": ["1f469-1f3fc-200d-1f4bc", 39, 9, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBC']], "1f3fd": ["1f469-1f3fd-200d-1f4bc", 39, 10, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBC']], "1f3fe": ["1f469-1f3fe-200d-1f4bc", 39, 11, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBC']], "1f3ff": ["1f469-1f3ff-200d-1f4bc", 39, 12, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBC']] },
        "1f469-200d-1f527": { "1f3fb": ["1f469-1f3fb-200d-1f527", 39, 14, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD27']], "1f3fc": ["1f469-1f3fc-200d-1f527", 39, 15, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD27']], "1f3fd": ["1f469-1f3fd-200d-1f527", 39, 16, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD27']], "1f3fe": ["1f469-1f3fe-200d-1f527", 39, 17, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD27']], "1f3ff": ["1f469-1f3ff-200d-1f527", 39, 18, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD27']] },
        "1f469-200d-1f52c": { "1f3fb": ["1f469-1f3fb-200d-1f52c", 39, 20, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD2C']], "1f3fc": ["1f469-1f3fc-200d-1f52c", 39, 21, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD2C']], "1f3fd": ["1f469-1f3fd-200d-1f52c", 39, 22, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD2C']], "1f3fe": ["1f469-1f3fe-200d-1f52c", 39, 23, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD2C']], "1f3ff": ["1f469-1f3ff-200d-1f52c", 39, 24, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD2C']] },
        "1f469-200d-1f680": { "1f3fb": ["1f469-1f3fb-200d-1f680", 39, 26, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE80']], "1f3fc": ["1f469-1f3fc-200d-1f680", 39, 27, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE80']], "1f3fd": ["1f469-1f3fd-200d-1f680", 39, 28, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE80']], "1f3fe": ["1f469-1f3fe-200d-1f680", 39, 29, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE80']], "1f3ff": ["1f469-1f3ff-200d-1f680", 39, 30, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE80']] },
        "1f469-200d-1f692": { "1f3fb": ["1f469-1f3fb-200d-1f692", 39, 32, 23, ['\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE92']], "1f3fc": ["1f469-1f3fc-200d-1f692", 39, 33, 23, ['\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE92']], "1f3fd": ["1f469-1f3fd-200d-1f692", 39, 34, 23, ['\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE92']], "1f3fe": ["1f469-1f3fe-200d-1f692", 39, 35, 23, ['\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE92']], "1f3ff": ["1f469-1f3ff-200d-1f692", 39, 36, 23, ['\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE92']] },
        "1f3c3-200d-2640-fe0f": { "1f3fb": ["1f3c3-1f3fb-200d-2640-fe0f", 39, 38, 5, ['\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f3c3-1f3fc-200d-2640-fe0f", 39, 39, 5, ['\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f3c3-1f3fd-200d-2640-fe0f", 39, 40, 5, ['\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f3c3-1f3fe-200d-2640-fe0f", 39, 41, 5, ['\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f3c3-1f3ff-200d-2640-fe0f", 39, 42, 5, ['\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f3c3-200d-2642-fe0f": { "1f3fb": ["1f3c3-1f3fb-200d-2642-fe0f", 39, 44, 5, ['\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83C\uDFC3\uD83C\uDFFB']], "1f3fc": ["1f3c3-1f3fc-200d-2642-fe0f", 39, 45, 5, ['\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83C\uDFC3\uD83C\uDFFC']], "1f3fd": ["1f3c3-1f3fd-200d-2642-fe0f", 39, 46, 5, ['\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83C\uDFC3\uD83C\uDFFD']], "1f3fe": ["1f3c3-1f3fe-200d-2642-fe0f", 39, 47, 5, ['\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83C\uDFC3\uD83C\uDFFE']], "1f3ff": ["1f3c3-1f3ff-200d-2642-fe0f", 39, 48, 5, ['\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83C\uDFC3\uD83C\uDFFF']] },
        "1f3c4-200d-2640-fe0f": { "1f3fb": ["1f3c4-1f3fb-200d-2640-fe0f", 40, 1, 5, ['\uD83C\uDFC4\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f3c4-1f3fc-200d-2640-fe0f", 40, 2, 5, ['\uD83C\uDFC4\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f3c4-1f3fd-200d-2640-fe0f", 40, 3, 5, ['\uD83C\uDFC4\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f3c4-1f3fe-200d-2640-fe0f", 40, 4, 5, ['\uD83C\uDFC4\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f3c4-1f3ff-200d-2640-fe0f", 40, 5, 5, ['\uD83C\uDFC4\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f3c4-200d-2642-fe0f": { "1f3fb": ["1f3c4-1f3fb-200d-2642-fe0f", 40, 7, 5, ['\uD83C\uDFC4\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83C\uDFC4\uD83C\uDFFB']], "1f3fc": ["1f3c4-1f3fc-200d-2642-fe0f", 40, 8, 5, ['\uD83C\uDFC4\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83C\uDFC4\uD83C\uDFFC']], "1f3fd": ["1f3c4-1f3fd-200d-2642-fe0f", 40, 9, 5, ['\uD83C\uDFC4\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83C\uDFC4\uD83C\uDFFD']], "1f3fe": ["1f3c4-1f3fe-200d-2642-fe0f", 40, 10, 5, ['\uD83C\uDFC4\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83C\uDFC4\uD83C\uDFFE']], "1f3ff": ["1f3c4-1f3ff-200d-2642-fe0f", 40, 11, 5, ['\uD83C\uDFC4\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83C\uDFC4\uD83C\uDFFF']] },
        "1f3ca-200d-2640-fe0f": { "1f3fb": ["1f3ca-1f3fb-200d-2640-fe0f", 40, 13, 5, ['\uD83C\uDFCA\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f3ca-1f3fc-200d-2640-fe0f", 40, 14, 5, ['\uD83C\uDFCA\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f3ca-1f3fd-200d-2640-fe0f", 40, 15, 5, ['\uD83C\uDFCA\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f3ca-1f3fe-200d-2640-fe0f", 40, 16, 5, ['\uD83C\uDFCA\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f3ca-1f3ff-200d-2640-fe0f", 40, 17, 5, ['\uD83C\uDFCA\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f3ca-200d-2642-fe0f": { "1f3fb": ["1f3ca-1f3fb-200d-2642-fe0f", 40, 19, 5, ['\uD83C\uDFCA\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83C\uDFCA\uD83C\uDFFB']], "1f3fc": ["1f3ca-1f3fc-200d-2642-fe0f", 40, 20, 5, ['\uD83C\uDFCA\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83C\uDFCA\uD83C\uDFFC']], "1f3fd": ["1f3ca-1f3fd-200d-2642-fe0f", 40, 21, 5, ['\uD83C\uDFCA\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83C\uDFCA\uD83C\uDFFD']], "1f3fe": ["1f3ca-1f3fe-200d-2642-fe0f", 40, 22, 5, ['\uD83C\uDFCA\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83C\uDFCA\uD83C\uDFFE']], "1f3ff": ["1f3ca-1f3ff-200d-2642-fe0f", 40, 23, 5, ['\uD83C\uDFCA\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83C\uDFCA\uD83C\uDFFF']] },
        "1f3cb-fe0f-200d-2640-fe0f": { "1f3fb": ["1f3cb-1f3fb-200d-2640-fe0f", 40, 25, 5, ['\uD83C\uDFCB\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f3cb-1f3fc-200d-2640-fe0f", 40, 26, 5, ['\uD83C\uDFCB\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f3cb-1f3fd-200d-2640-fe0f", 40, 27, 5, ['\uD83C\uDFCB\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f3cb-1f3fe-200d-2640-fe0f", 40, 28, 5, ['\uD83C\uDFCB\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f3cb-1f3ff-200d-2640-fe0f", 40, 29, 5, ['\uD83C\uDFCB\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f3cb-fe0f-200d-2642-fe0f": { "1f3fb": ["1f3cb-1f3fb-200d-2642-fe0f", 40, 31, 5, ['\uD83C\uDFCB\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83C\uDFCB\uD83C\uDFFB']], "1f3fc": ["1f3cb-1f3fc-200d-2642-fe0f", 40, 32, 5, ['\uD83C\uDFCB\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83C\uDFCB\uD83C\uDFFC']], "1f3fd": ["1f3cb-1f3fd-200d-2642-fe0f", 40, 33, 5, ['\uD83C\uDFCB\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83C\uDFCB\uD83C\uDFFD']], "1f3fe": ["1f3cb-1f3fe-200d-2642-fe0f", 40, 34, 5, ['\uD83C\uDFCB\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83C\uDFCB\uD83C\uDFFE']], "1f3ff": ["1f3cb-1f3ff-200d-2642-fe0f", 40, 35, 5, ['\uD83C\uDFCB\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83C\uDFCB\uD83C\uDFFF']] },
        "1f3cc-fe0f-200d-2640-fe0f": { "1f3fb": ["1f3cc-1f3fb-200d-2640-fe0f", 40, 37, 5, ['\uD83C\uDFCC\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f3cc-1f3fc-200d-2640-fe0f", 40, 38, 5, ['\uD83C\uDFCC\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f3cc-1f3fd-200d-2640-fe0f", 40, 39, 5, ['\uD83C\uDFCC\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f3cc-1f3fe-200d-2640-fe0f", 40, 40, 5, ['\uD83C\uDFCC\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f3cc-1f3ff-200d-2640-fe0f", 40, 41, 5, ['\uD83C\uDFCC\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f3cc-fe0f-200d-2642-fe0f": { "1f3fb": ["1f3cc-1f3fb-200d-2642-fe0f", 40, 43, 5, ['\uD83C\uDFCC\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83C\uDFCC\uD83C\uDFFB']], "1f3fc": ["1f3cc-1f3fc-200d-2642-fe0f", 40, 44, 5, ['\uD83C\uDFCC\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83C\uDFCC\uD83C\uDFFC']], "1f3fd": ["1f3cc-1f3fd-200d-2642-fe0f", 40, 45, 5, ['\uD83C\uDFCC\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83C\uDFCC\uD83C\uDFFD']], "1f3fe": ["1f3cc-1f3fe-200d-2642-fe0f", 40, 46, 5, ['\uD83C\uDFCC\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83C\uDFCC\uD83C\uDFFE']], "1f3ff": ["1f3cc-1f3ff-200d-2642-fe0f", 40, 47, 5, ['\uD83C\uDFCC\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83C\uDFCC\uD83C\uDFFF']] },
        "1f468-200d-2695-fe0f": { "1f3fb": ["1f468-1f3fb-200d-2695-fe0f", 41, 15, 5, ['\uD83D\uDC68\uD83C\uDFFB\u200D\u2695\uFE0F']], "1f3fc": ["1f468-1f3fc-200d-2695-fe0f", 41, 16, 5, ['\uD83D\uDC68\uD83C\uDFFC\u200D\u2695\uFE0F']], "1f3fd": ["1f468-1f3fd-200d-2695-fe0f", 41, 17, 5, ['\uD83D\uDC68\uD83C\uDFFD\u200D\u2695\uFE0F']], "1f3fe": ["1f468-1f3fe-200d-2695-fe0f", 41, 18, 5, ['\uD83D\uDC68\uD83C\uDFFE\u200D\u2695\uFE0F']], "1f3ff": ["1f468-1f3ff-200d-2695-fe0f", 41, 19, 5, ['\uD83D\uDC68\uD83C\uDFFF\u200D\u2695\uFE0F']] },
        "1f468-200d-2696-fe0f": { "1f3fb": ["1f468-1f3fb-200d-2696-fe0f", 41, 21, 5, ['\uD83D\uDC68\uD83C\uDFFB\u200D\u2696\uFE0F']], "1f3fc": ["1f468-1f3fc-200d-2696-fe0f", 41, 22, 5, ['\uD83D\uDC68\uD83C\uDFFC\u200D\u2696\uFE0F']], "1f3fd": ["1f468-1f3fd-200d-2696-fe0f", 41, 23, 5, ['\uD83D\uDC68\uD83C\uDFFD\u200D\u2696\uFE0F']], "1f3fe": ["1f468-1f3fe-200d-2696-fe0f", 41, 24, 5, ['\uD83D\uDC68\uD83C\uDFFE\u200D\u2696\uFE0F']], "1f3ff": ["1f468-1f3ff-200d-2696-fe0f", 41, 25, 5, ['\uD83D\uDC68\uD83C\uDFFF\u200D\u2696\uFE0F']] },
        "1f468-200d-2708-fe0f": { "1f3fb": ["1f468-1f3fb-200d-2708-fe0f", 41, 27, 5, ['\uD83D\uDC68\uD83C\uDFFB\u200D\u2708\uFE0F']], "1f3fc": ["1f468-1f3fc-200d-2708-fe0f", 41, 28, 5, ['\uD83D\uDC68\uD83C\uDFFC\u200D\u2708\uFE0F']], "1f3fd": ["1f468-1f3fd-200d-2708-fe0f", 41, 29, 5, ['\uD83D\uDC68\uD83C\uDFFD\u200D\u2708\uFE0F']], "1f3fe": ["1f468-1f3fe-200d-2708-fe0f", 41, 30, 5, ['\uD83D\uDC68\uD83C\uDFFE\u200D\u2708\uFE0F']], "1f3ff": ["1f468-1f3ff-200d-2708-fe0f", 41, 31, 5, ['\uD83D\uDC68\uD83C\uDFFF\u200D\u2708\uFE0F']] },
        "1f469-200d-2695-fe0f": { "1f3fb": ["1f469-1f3fb-200d-2695-fe0f", 41, 43, 5, ['\uD83D\uDC69\uD83C\uDFFB\u200D\u2695\uFE0F']], "1f3fc": ["1f469-1f3fc-200d-2695-fe0f", 41, 44, 5, ['\uD83D\uDC69\uD83C\uDFFC\u200D\u2695\uFE0F']], "1f3fd": ["1f469-1f3fd-200d-2695-fe0f", 41, 45, 5, ['\uD83D\uDC69\uD83C\uDFFD\u200D\u2695\uFE0F']], "1f3fe": ["1f469-1f3fe-200d-2695-fe0f", 41, 46, 5, ['\uD83D\uDC69\uD83C\uDFFE\u200D\u2695\uFE0F']], "1f3ff": ["1f469-1f3ff-200d-2695-fe0f", 41, 47, 5, ['\uD83D\uDC69\uD83C\uDFFF\u200D\u2695\uFE0F']] },
        "1f469-200d-2696-fe0f": { "1f3fb": ["1f469-1f3fb-200d-2696-fe0f", 42, 0, 5, ['\uD83D\uDC69\uD83C\uDFFB\u200D\u2696\uFE0F']], "1f3fc": ["1f469-1f3fc-200d-2696-fe0f", 42, 1, 5, ['\uD83D\uDC69\uD83C\uDFFC\u200D\u2696\uFE0F']], "1f3fd": ["1f469-1f3fd-200d-2696-fe0f", 42, 2, 5, ['\uD83D\uDC69\uD83C\uDFFD\u200D\u2696\uFE0F']], "1f3fe": ["1f469-1f3fe-200d-2696-fe0f", 42, 3, 5, ['\uD83D\uDC69\uD83C\uDFFE\u200D\u2696\uFE0F']], "1f3ff": ["1f469-1f3ff-200d-2696-fe0f", 42, 4, 5, ['\uD83D\uDC69\uD83C\uDFFF\u200D\u2696\uFE0F']] },
        "1f469-200d-2708-fe0f": { "1f3fb": ["1f469-1f3fb-200d-2708-fe0f", 42, 6, 5, ['\uD83D\uDC69\uD83C\uDFFB\u200D\u2708\uFE0F']], "1f3fc": ["1f469-1f3fc-200d-2708-fe0f", 42, 7, 5, ['\uD83D\uDC69\uD83C\uDFFC\u200D\u2708\uFE0F']], "1f3fd": ["1f469-1f3fd-200d-2708-fe0f", 42, 8, 5, ['\uD83D\uDC69\uD83C\uDFFD\u200D\u2708\uFE0F']], "1f3fe": ["1f469-1f3fe-200d-2708-fe0f", 42, 9, 5, ['\uD83D\uDC69\uD83C\uDFFE\u200D\u2708\uFE0F']], "1f3ff": ["1f469-1f3ff-200d-2708-fe0f", 42, 10, 5, ['\uD83D\uDC69\uD83C\uDFFF\u200D\u2708\uFE0F']] },
        "1f46e-200d-2640-fe0f": { "1f3fb": ["1f46e-1f3fb-200d-2640-fe0f", 42, 16, 5, ['\uD83D\uDC6E\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f46e-1f3fc-200d-2640-fe0f", 42, 17, 5, ['\uD83D\uDC6E\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f46e-1f3fd-200d-2640-fe0f", 42, 18, 5, ['\uD83D\uDC6E\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f46e-1f3fe-200d-2640-fe0f", 42, 19, 5, ['\uD83D\uDC6E\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f46e-1f3ff-200d-2640-fe0f", 42, 20, 5, ['\uD83D\uDC6E\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f46e-200d-2642-fe0f": { "1f3fb": ["1f46e-1f3fb-200d-2642-fe0f", 42, 22, 5, ['\uD83D\uDC6E\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83D\uDC6E\uD83C\uDFFB']], "1f3fc": ["1f46e-1f3fc-200d-2642-fe0f", 42, 23, 5, ['\uD83D\uDC6E\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83D\uDC6E\uD83C\uDFFC']], "1f3fd": ["1f46e-1f3fd-200d-2642-fe0f", 42, 24, 5, ['\uD83D\uDC6E\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83D\uDC6E\uD83C\uDFFD']], "1f3fe": ["1f46e-1f3fe-200d-2642-fe0f", 42, 25, 5, ['\uD83D\uDC6E\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83D\uDC6E\uD83C\uDFFE']], "1f3ff": ["1f46e-1f3ff-200d-2642-fe0f", 42, 26, 5, ['\uD83D\uDC6E\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83D\uDC6E\uD83C\uDFFF']] },
        "1f471-200d-2640-fe0f": { "1f3fb": ["1f471-1f3fb-200d-2640-fe0f", 42, 30, 5, ['\uD83D\uDC71\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f471-1f3fc-200d-2640-fe0f", 42, 31, 5, ['\uD83D\uDC71\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f471-1f3fd-200d-2640-fe0f", 42, 32, 5, ['\uD83D\uDC71\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f471-1f3fe-200d-2640-fe0f", 42, 33, 5, ['\uD83D\uDC71\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f471-1f3ff-200d-2640-fe0f", 42, 34, 5, ['\uD83D\uDC71\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f471-200d-2642-fe0f": { "1f3fb": ["1f471-1f3fb-200d-2642-fe0f", 42, 36, 5, ['\uD83D\uDC71\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83D\uDC71\uD83C\uDFFB']], "1f3fc": ["1f471-1f3fc-200d-2642-fe0f", 42, 37, 5, ['\uD83D\uDC71\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83D\uDC71\uD83C\uDFFC']], "1f3fd": ["1f471-1f3fd-200d-2642-fe0f", 42, 38, 5, ['\uD83D\uDC71\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83D\uDC71\uD83C\uDFFD']], "1f3fe": ["1f471-1f3fe-200d-2642-fe0f", 42, 39, 5, ['\uD83D\uDC71\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83D\uDC71\uD83C\uDFFE']], "1f3ff": ["1f471-1f3ff-200d-2642-fe0f", 42, 40, 5, ['\uD83D\uDC71\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83D\uDC71\uD83C\uDFFF']] },
        "1f473-200d-2640-fe0f": { "1f3fb": ["1f473-1f3fb-200d-2640-fe0f", 42, 42, 5, ['\uD83D\uDC73\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f473-1f3fc-200d-2640-fe0f", 42, 43, 5, ['\uD83D\uDC73\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f473-1f3fd-200d-2640-fe0f", 42, 44, 5, ['\uD83D\uDC73\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f473-1f3fe-200d-2640-fe0f", 42, 45, 5, ['\uD83D\uDC73\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f473-1f3ff-200d-2640-fe0f", 42, 46, 5, ['\uD83D\uDC73\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f473-200d-2642-fe0f": { "1f3fb": ["1f473-1f3fb-200d-2642-fe0f", 42, 48, 5, ['\uD83D\uDC73\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83D\uDC73\uD83C\uDFFB']], "1f3fc": ["1f473-1f3fc-200d-2642-fe0f", 43, 0, 5, ['\uD83D\uDC73\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83D\uDC73\uD83C\uDFFC']], "1f3fd": ["1f473-1f3fd-200d-2642-fe0f", 43, 1, 5, ['\uD83D\uDC73\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83D\uDC73\uD83C\uDFFD']], "1f3fe": ["1f473-1f3fe-200d-2642-fe0f", 43, 2, 5, ['\uD83D\uDC73\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83D\uDC73\uD83C\uDFFE']], "1f3ff": ["1f473-1f3ff-200d-2642-fe0f", 43, 3, 5, ['\uD83D\uDC73\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83D\uDC73\uD83C\uDFFF']] },
        "1f477-200d-2640-fe0f": { "1f3fb": ["1f477-1f3fb-200d-2640-fe0f", 43, 5, 5, ['\uD83D\uDC77\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f477-1f3fc-200d-2640-fe0f", 43, 6, 5, ['\uD83D\uDC77\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f477-1f3fd-200d-2640-fe0f", 43, 7, 5, ['\uD83D\uDC77\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f477-1f3fe-200d-2640-fe0f", 43, 8, 5, ['\uD83D\uDC77\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f477-1f3ff-200d-2640-fe0f", 43, 9, 5, ['\uD83D\uDC77\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f477-200d-2642-fe0f": { "1f3fb": ["1f477-1f3fb-200d-2642-fe0f", 43, 11, 5, ['\uD83D\uDC77\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83D\uDC77\uD83C\uDFFB']], "1f3fc": ["1f477-1f3fc-200d-2642-fe0f", 43, 12, 5, ['\uD83D\uDC77\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83D\uDC77\uD83C\uDFFC']], "1f3fd": ["1f477-1f3fd-200d-2642-fe0f", 43, 13, 5, ['\uD83D\uDC77\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83D\uDC77\uD83C\uDFFD']], "1f3fe": ["1f477-1f3fe-200d-2642-fe0f", 43, 14, 5, ['\uD83D\uDC77\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83D\uDC77\uD83C\uDFFE']], "1f3ff": ["1f477-1f3ff-200d-2642-fe0f", 43, 15, 5, ['\uD83D\uDC77\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83D\uDC77\uD83C\uDFFF']] },
        "1f481-200d-2640-fe0f": { "1f3fb": ["1f481-1f3fb-200d-2640-fe0f", 43, 17, 5, ['\uD83D\uDC81\uD83C\uDFFB\u200D\u2640\uFE0F', '\uD83D\uDC81\uD83C\uDFFB']], "1f3fc": ["1f481-1f3fc-200d-2640-fe0f", 43, 18, 5, ['\uD83D\uDC81\uD83C\uDFFC\u200D\u2640\uFE0F', '\uD83D\uDC81\uD83C\uDFFC']], "1f3fd": ["1f481-1f3fd-200d-2640-fe0f", 43, 19, 5, ['\uD83D\uDC81\uD83C\uDFFD\u200D\u2640\uFE0F', '\uD83D\uDC81\uD83C\uDFFD']], "1f3fe": ["1f481-1f3fe-200d-2640-fe0f", 43, 20, 5, ['\uD83D\uDC81\uD83C\uDFFE\u200D\u2640\uFE0F', '\uD83D\uDC81\uD83C\uDFFE']], "1f3ff": ["1f481-1f3ff-200d-2640-fe0f", 43, 21, 5, ['\uD83D\uDC81\uD83C\uDFFF\u200D\u2640\uFE0F', '\uD83D\uDC81\uD83C\uDFFF']] },
        "1f481-200d-2642-fe0f": { "1f3fb": ["1f481-1f3fb-200d-2642-fe0f", 43, 23, 5, ['\uD83D\uDC81\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f481-1f3fc-200d-2642-fe0f", 43, 24, 5, ['\uD83D\uDC81\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f481-1f3fd-200d-2642-fe0f", 43, 25, 5, ['\uD83D\uDC81\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f481-1f3fe-200d-2642-fe0f", 43, 26, 5, ['\uD83D\uDC81\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f481-1f3ff-200d-2642-fe0f", 43, 27, 5, ['\uD83D\uDC81\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f482-200d-2640-fe0f": { "1f3fb": ["1f482-1f3fb-200d-2640-fe0f", 43, 29, 5, ['\uD83D\uDC82\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f482-1f3fc-200d-2640-fe0f", 43, 30, 5, ['\uD83D\uDC82\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f482-1f3fd-200d-2640-fe0f", 43, 31, 5, ['\uD83D\uDC82\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f482-1f3fe-200d-2640-fe0f", 43, 32, 5, ['\uD83D\uDC82\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f482-1f3ff-200d-2640-fe0f", 43, 33, 5, ['\uD83D\uDC82\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f482-200d-2642-fe0f": { "1f3fb": ["1f482-1f3fb-200d-2642-fe0f", 43, 35, 5, ['\uD83D\uDC82\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83D\uDC82\uD83C\uDFFB']], "1f3fc": ["1f482-1f3fc-200d-2642-fe0f", 43, 36, 5, ['\uD83D\uDC82\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83D\uDC82\uD83C\uDFFC']], "1f3fd": ["1f482-1f3fd-200d-2642-fe0f", 43, 37, 5, ['\uD83D\uDC82\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83D\uDC82\uD83C\uDFFD']], "1f3fe": ["1f482-1f3fe-200d-2642-fe0f", 43, 38, 5, ['\uD83D\uDC82\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83D\uDC82\uD83C\uDFFE']], "1f3ff": ["1f482-1f3ff-200d-2642-fe0f", 43, 39, 5, ['\uD83D\uDC82\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83D\uDC82\uD83C\uDFFF']] },
        "1f486-200d-2640-fe0f": { "1f3fb": ["1f486-1f3fb-200d-2640-fe0f", 43, 41, 5, ['\uD83D\uDC86\uD83C\uDFFB\u200D\u2640\uFE0F', '\uD83D\uDC86\uD83C\uDFFB']], "1f3fc": ["1f486-1f3fc-200d-2640-fe0f", 43, 42, 5, ['\uD83D\uDC86\uD83C\uDFFC\u200D\u2640\uFE0F', '\uD83D\uDC86\uD83C\uDFFC']], "1f3fd": ["1f486-1f3fd-200d-2640-fe0f", 43, 43, 5, ['\uD83D\uDC86\uD83C\uDFFD\u200D\u2640\uFE0F', '\uD83D\uDC86\uD83C\uDFFD']], "1f3fe": ["1f486-1f3fe-200d-2640-fe0f", 43, 44, 5, ['\uD83D\uDC86\uD83C\uDFFE\u200D\u2640\uFE0F', '\uD83D\uDC86\uD83C\uDFFE']], "1f3ff": ["1f486-1f3ff-200d-2640-fe0f", 43, 45, 5, ['\uD83D\uDC86\uD83C\uDFFF\u200D\u2640\uFE0F', '\uD83D\uDC86\uD83C\uDFFF']] },
        "1f486-200d-2642-fe0f": { "1f3fb": ["1f486-1f3fb-200d-2642-fe0f", 43, 47, 5, ['\uD83D\uDC86\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f486-1f3fc-200d-2642-fe0f", 43, 48, 5, ['\uD83D\uDC86\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f486-1f3fd-200d-2642-fe0f", 44, 0, 5, ['\uD83D\uDC86\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f486-1f3fe-200d-2642-fe0f", 44, 1, 5, ['\uD83D\uDC86\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f486-1f3ff-200d-2642-fe0f", 44, 2, 5, ['\uD83D\uDC86\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f487-200d-2640-fe0f": { "1f3fb": ["1f487-1f3fb-200d-2640-fe0f", 44, 4, 5, ['\uD83D\uDC87\uD83C\uDFFB\u200D\u2640\uFE0F', '\uD83D\uDC87\uD83C\uDFFB']], "1f3fc": ["1f487-1f3fc-200d-2640-fe0f", 44, 5, 5, ['\uD83D\uDC87\uD83C\uDFFC\u200D\u2640\uFE0F', '\uD83D\uDC87\uD83C\uDFFC']], "1f3fd": ["1f487-1f3fd-200d-2640-fe0f", 44, 6, 5, ['\uD83D\uDC87\uD83C\uDFFD\u200D\u2640\uFE0F', '\uD83D\uDC87\uD83C\uDFFD']], "1f3fe": ["1f487-1f3fe-200d-2640-fe0f", 44, 7, 5, ['\uD83D\uDC87\uD83C\uDFFE\u200D\u2640\uFE0F', '\uD83D\uDC87\uD83C\uDFFE']], "1f3ff": ["1f487-1f3ff-200d-2640-fe0f", 44, 8, 5, ['\uD83D\uDC87\uD83C\uDFFF\u200D\u2640\uFE0F', '\uD83D\uDC87\uD83C\uDFFF']] },
        "1f487-200d-2642-fe0f": { "1f3fb": ["1f487-1f3fb-200d-2642-fe0f", 44, 10, 5, ['\uD83D\uDC87\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f487-1f3fc-200d-2642-fe0f", 44, 11, 5, ['\uD83D\uDC87\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f487-1f3fd-200d-2642-fe0f", 44, 12, 5, ['\uD83D\uDC87\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f487-1f3fe-200d-2642-fe0f", 44, 13, 5, ['\uD83D\uDC87\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f487-1f3ff-200d-2642-fe0f", 44, 14, 5, ['\uD83D\uDC87\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f575-fe0f-200d-2640-fe0f": { "1f3fb": ["1f575-1f3fb-200d-2640-fe0f", 44, 16, 5, ['\uD83D\uDD75\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f575-1f3fc-200d-2640-fe0f", 44, 17, 5, ['\uD83D\uDD75\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f575-1f3fd-200d-2640-fe0f", 44, 18, 5, ['\uD83D\uDD75\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f575-1f3fe-200d-2640-fe0f", 44, 19, 5, ['\uD83D\uDD75\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f575-1f3ff-200d-2640-fe0f", 44, 20, 5, ['\uD83D\uDD75\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f575-fe0f-200d-2642-fe0f": { "1f3fb": ["1f575-1f3fb-200d-2642-fe0f", 44, 22, 5, ['\uD83D\uDD75\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83D\uDD75\uD83C\uDFFB']], "1f3fc": ["1f575-1f3fc-200d-2642-fe0f", 44, 23, 5, ['\uD83D\uDD75\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83D\uDD75\uD83C\uDFFC']], "1f3fd": ["1f575-1f3fd-200d-2642-fe0f", 44, 24, 5, ['\uD83D\uDD75\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83D\uDD75\uD83C\uDFFD']], "1f3fe": ["1f575-1f3fe-200d-2642-fe0f", 44, 25, 5, ['\uD83D\uDD75\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83D\uDD75\uD83C\uDFFE']], "1f3ff": ["1f575-1f3ff-200d-2642-fe0f", 44, 26, 5, ['\uD83D\uDD75\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83D\uDD75\uD83C\uDFFF']] },
        "1f645-200d-2640-fe0f": { "1f3fb": ["1f645-1f3fb-200d-2640-fe0f", 44, 28, 5, ['\uD83D\uDE45\uD83C\uDFFB\u200D\u2640\uFE0F', '\uD83D\uDE45\uD83C\uDFFB']], "1f3fc": ["1f645-1f3fc-200d-2640-fe0f", 44, 29, 5, ['\uD83D\uDE45\uD83C\uDFFC\u200D\u2640\uFE0F', '\uD83D\uDE45\uD83C\uDFFC']], "1f3fd": ["1f645-1f3fd-200d-2640-fe0f", 44, 30, 5, ['\uD83D\uDE45\uD83C\uDFFD\u200D\u2640\uFE0F', '\uD83D\uDE45\uD83C\uDFFD']], "1f3fe": ["1f645-1f3fe-200d-2640-fe0f", 44, 31, 5, ['\uD83D\uDE45\uD83C\uDFFE\u200D\u2640\uFE0F', '\uD83D\uDE45\uD83C\uDFFE']], "1f3ff": ["1f645-1f3ff-200d-2640-fe0f", 44, 32, 5, ['\uD83D\uDE45\uD83C\uDFFF\u200D\u2640\uFE0F', '\uD83D\uDE45\uD83C\uDFFF']] },
        "1f645-200d-2642-fe0f": { "1f3fb": ["1f645-1f3fb-200d-2642-fe0f", 44, 34, 5, ['\uD83D\uDE45\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f645-1f3fc-200d-2642-fe0f", 44, 35, 5, ['\uD83D\uDE45\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f645-1f3fd-200d-2642-fe0f", 44, 36, 5, ['\uD83D\uDE45\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f645-1f3fe-200d-2642-fe0f", 44, 37, 5, ['\uD83D\uDE45\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f645-1f3ff-200d-2642-fe0f", 44, 38, 5, ['\uD83D\uDE45\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f646-200d-2640-fe0f": { "1f3fb": ["1f646-1f3fb-200d-2640-fe0f", 44, 40, 5, ['\uD83D\uDE46\uD83C\uDFFB\u200D\u2640\uFE0F', '\uD83D\uDE46\uD83C\uDFFB']], "1f3fc": ["1f646-1f3fc-200d-2640-fe0f", 44, 41, 5, ['\uD83D\uDE46\uD83C\uDFFC\u200D\u2640\uFE0F', '\uD83D\uDE46\uD83C\uDFFC']], "1f3fd": ["1f646-1f3fd-200d-2640-fe0f", 44, 42, 5, ['\uD83D\uDE46\uD83C\uDFFD\u200D\u2640\uFE0F', '\uD83D\uDE46\uD83C\uDFFD']], "1f3fe": ["1f646-1f3fe-200d-2640-fe0f", 44, 43, 5, ['\uD83D\uDE46\uD83C\uDFFE\u200D\u2640\uFE0F', '\uD83D\uDE46\uD83C\uDFFE']], "1f3ff": ["1f646-1f3ff-200d-2640-fe0f", 44, 44, 5, ['\uD83D\uDE46\uD83C\uDFFF\u200D\u2640\uFE0F', '\uD83D\uDE46\uD83C\uDFFF']] },
        "1f646-200d-2642-fe0f": { "1f3fb": ["1f646-1f3fb-200d-2642-fe0f", 44, 46, 5, ['\uD83D\uDE46\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f646-1f3fc-200d-2642-fe0f", 44, 47, 5, ['\uD83D\uDE46\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f646-1f3fd-200d-2642-fe0f", 44, 48, 5, ['\uD83D\uDE46\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f646-1f3fe-200d-2642-fe0f", 45, 0, 5, ['\uD83D\uDE46\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f646-1f3ff-200d-2642-fe0f", 45, 1, 5, ['\uD83D\uDE46\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f647-200d-2640-fe0f": { "1f3fb": ["1f647-1f3fb-200d-2640-fe0f", 45, 3, 5, ['\uD83D\uDE47\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f647-1f3fc-200d-2640-fe0f", 45, 4, 5, ['\uD83D\uDE47\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f647-1f3fd-200d-2640-fe0f", 45, 5, 5, ['\uD83D\uDE47\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f647-1f3fe-200d-2640-fe0f", 45, 6, 5, ['\uD83D\uDE47\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f647-1f3ff-200d-2640-fe0f", 45, 7, 5, ['\uD83D\uDE47\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f647-200d-2642-fe0f": { "1f3fb": ["1f647-1f3fb-200d-2642-fe0f", 45, 9, 5, ['\uD83D\uDE47\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83D\uDE47\uD83C\uDFFB']], "1f3fc": ["1f647-1f3fc-200d-2642-fe0f", 45, 10, 5, ['\uD83D\uDE47\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83D\uDE47\uD83C\uDFFC']], "1f3fd": ["1f647-1f3fd-200d-2642-fe0f", 45, 11, 5, ['\uD83D\uDE47\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83D\uDE47\uD83C\uDFFD']], "1f3fe": ["1f647-1f3fe-200d-2642-fe0f", 45, 12, 5, ['\uD83D\uDE47\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83D\uDE47\uD83C\uDFFE']], "1f3ff": ["1f647-1f3ff-200d-2642-fe0f", 45, 13, 5, ['\uD83D\uDE47\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83D\uDE47\uD83C\uDFFF']] },
        "1f64b-200d-2640-fe0f": { "1f3fb": ["1f64b-1f3fb-200d-2640-fe0f", 45, 15, 5, ['\uD83D\uDE4B\uD83C\uDFFB\u200D\u2640\uFE0F', '\uD83D\uDE4B\uD83C\uDFFB']], "1f3fc": ["1f64b-1f3fc-200d-2640-fe0f", 45, 16, 5, ['\uD83D\uDE4B\uD83C\uDFFC\u200D\u2640\uFE0F', '\uD83D\uDE4B\uD83C\uDFFC']], "1f3fd": ["1f64b-1f3fd-200d-2640-fe0f", 45, 17, 5, ['\uD83D\uDE4B\uD83C\uDFFD\u200D\u2640\uFE0F', '\uD83D\uDE4B\uD83C\uDFFD']], "1f3fe": ["1f64b-1f3fe-200d-2640-fe0f", 45, 18, 5, ['\uD83D\uDE4B\uD83C\uDFFE\u200D\u2640\uFE0F', '\uD83D\uDE4B\uD83C\uDFFE']], "1f3ff": ["1f64b-1f3ff-200d-2640-fe0f", 45, 19, 5, ['\uD83D\uDE4B\uD83C\uDFFF\u200D\u2640\uFE0F', '\uD83D\uDE4B\uD83C\uDFFF']] },
        "1f64b-200d-2642-fe0f": { "1f3fb": ["1f64b-1f3fb-200d-2642-fe0f", 45, 21, 5, ['\uD83D\uDE4B\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f64b-1f3fc-200d-2642-fe0f", 45, 22, 5, ['\uD83D\uDE4B\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f64b-1f3fd-200d-2642-fe0f", 45, 23, 5, ['\uD83D\uDE4B\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f64b-1f3fe-200d-2642-fe0f", 45, 24, 5, ['\uD83D\uDE4B\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f64b-1f3ff-200d-2642-fe0f", 45, 25, 5, ['\uD83D\uDE4B\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f64d-200d-2640-fe0f": { "1f3fb": ["1f64d-1f3fb-200d-2640-fe0f", 45, 27, 5, ['\uD83D\uDE4D\uD83C\uDFFB\u200D\u2640\uFE0F', '\uD83D\uDE4D\uD83C\uDFFB']], "1f3fc": ["1f64d-1f3fc-200d-2640-fe0f", 45, 28, 5, ['\uD83D\uDE4D\uD83C\uDFFC\u200D\u2640\uFE0F', '\uD83D\uDE4D\uD83C\uDFFC']], "1f3fd": ["1f64d-1f3fd-200d-2640-fe0f", 45, 29, 5, ['\uD83D\uDE4D\uD83C\uDFFD\u200D\u2640\uFE0F', '\uD83D\uDE4D\uD83C\uDFFD']], "1f3fe": ["1f64d-1f3fe-200d-2640-fe0f", 45, 30, 5, ['\uD83D\uDE4D\uD83C\uDFFE\u200D\u2640\uFE0F', '\uD83D\uDE4D\uD83C\uDFFE']], "1f3ff": ["1f64d-1f3ff-200d-2640-fe0f", 45, 31, 5, ['\uD83D\uDE4D\uD83C\uDFFF\u200D\u2640\uFE0F', '\uD83D\uDE4D\uD83C\uDFFF']] },
        "1f64d-200d-2642-fe0f": { "1f3fb": ["1f64d-1f3fb-200d-2642-fe0f", 45, 33, 5, ['\uD83D\uDE4D\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f64d-1f3fc-200d-2642-fe0f", 45, 34, 5, ['\uD83D\uDE4D\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f64d-1f3fd-200d-2642-fe0f", 45, 35, 5, ['\uD83D\uDE4D\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f64d-1f3fe-200d-2642-fe0f", 45, 36, 5, ['\uD83D\uDE4D\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f64d-1f3ff-200d-2642-fe0f", 45, 37, 5, ['\uD83D\uDE4D\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f64e-200d-2640-fe0f": { "1f3fb": ["1f64e-1f3fb-200d-2640-fe0f", 45, 39, 5, ['\uD83D\uDE4E\uD83C\uDFFB\u200D\u2640\uFE0F', '\uD83D\uDE4E\uD83C\uDFFB']], "1f3fc": ["1f64e-1f3fc-200d-2640-fe0f", 45, 40, 5, ['\uD83D\uDE4E\uD83C\uDFFC\u200D\u2640\uFE0F', '\uD83D\uDE4E\uD83C\uDFFC']], "1f3fd": ["1f64e-1f3fd-200d-2640-fe0f", 45, 41, 5, ['\uD83D\uDE4E\uD83C\uDFFD\u200D\u2640\uFE0F', '\uD83D\uDE4E\uD83C\uDFFD']], "1f3fe": ["1f64e-1f3fe-200d-2640-fe0f", 45, 42, 5, ['\uD83D\uDE4E\uD83C\uDFFE\u200D\u2640\uFE0F', '\uD83D\uDE4E\uD83C\uDFFE']], "1f3ff": ["1f64e-1f3ff-200d-2640-fe0f", 45, 43, 5, ['\uD83D\uDE4E\uD83C\uDFFF\u200D\u2640\uFE0F', '\uD83D\uDE4E\uD83C\uDFFF']] },
        "1f64e-200d-2642-fe0f": { "1f3fb": ["1f64e-1f3fb-200d-2642-fe0f", 45, 45, 5, ['\uD83D\uDE4E\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f64e-1f3fc-200d-2642-fe0f", 45, 46, 5, ['\uD83D\uDE4E\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f64e-1f3fd-200d-2642-fe0f", 45, 47, 5, ['\uD83D\uDE4E\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f64e-1f3fe-200d-2642-fe0f", 45, 48, 5, ['\uD83D\uDE4E\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f64e-1f3ff-200d-2642-fe0f", 46, 0, 5, ['\uD83D\uDE4E\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f6a3-200d-2640-fe0f": { "1f3fb": ["1f6a3-1f3fb-200d-2640-fe0f", 46, 2, 5, ['\uD83D\uDEA3\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f6a3-1f3fc-200d-2640-fe0f", 46, 3, 5, ['\uD83D\uDEA3\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f6a3-1f3fd-200d-2640-fe0f", 46, 4, 5, ['\uD83D\uDEA3\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f6a3-1f3fe-200d-2640-fe0f", 46, 5, 5, ['\uD83D\uDEA3\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f6a3-1f3ff-200d-2640-fe0f", 46, 6, 5, ['\uD83D\uDEA3\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f6a3-200d-2642-fe0f": { "1f3fb": ["1f6a3-1f3fb-200d-2642-fe0f", 46, 8, 5, ['\uD83D\uDEA3\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83D\uDEA3\uD83C\uDFFB']], "1f3fc": ["1f6a3-1f3fc-200d-2642-fe0f", 46, 9, 5, ['\uD83D\uDEA3\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83D\uDEA3\uD83C\uDFFC']], "1f3fd": ["1f6a3-1f3fd-200d-2642-fe0f", 46, 10, 5, ['\uD83D\uDEA3\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83D\uDEA3\uD83C\uDFFD']], "1f3fe": ["1f6a3-1f3fe-200d-2642-fe0f", 46, 11, 5, ['\uD83D\uDEA3\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83D\uDEA3\uD83C\uDFFE']], "1f3ff": ["1f6a3-1f3ff-200d-2642-fe0f", 46, 12, 5, ['\uD83D\uDEA3\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83D\uDEA3\uD83C\uDFFF']] },
        "1f6b4-200d-2640-fe0f": { "1f3fb": ["1f6b4-1f3fb-200d-2640-fe0f", 46, 14, 5, ['\uD83D\uDEB4\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f6b4-1f3fc-200d-2640-fe0f", 46, 15, 5, ['\uD83D\uDEB4\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f6b4-1f3fd-200d-2640-fe0f", 46, 16, 5, ['\uD83D\uDEB4\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f6b4-1f3fe-200d-2640-fe0f", 46, 17, 5, ['\uD83D\uDEB4\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f6b4-1f3ff-200d-2640-fe0f", 46, 18, 5, ['\uD83D\uDEB4\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f6b4-200d-2642-fe0f": { "1f3fb": ["1f6b4-1f3fb-200d-2642-fe0f", 46, 20, 5, ['\uD83D\uDEB4\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83D\uDEB4\uD83C\uDFFB']], "1f3fc": ["1f6b4-1f3fc-200d-2642-fe0f", 46, 21, 5, ['\uD83D\uDEB4\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83D\uDEB4\uD83C\uDFFC']], "1f3fd": ["1f6b4-1f3fd-200d-2642-fe0f", 46, 22, 5, ['\uD83D\uDEB4\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83D\uDEB4\uD83C\uDFFD']], "1f3fe": ["1f6b4-1f3fe-200d-2642-fe0f", 46, 23, 5, ['\uD83D\uDEB4\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83D\uDEB4\uD83C\uDFFE']], "1f3ff": ["1f6b4-1f3ff-200d-2642-fe0f", 46, 24, 5, ['\uD83D\uDEB4\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83D\uDEB4\uD83C\uDFFF']] },
        "1f6b5-200d-2640-fe0f": { "1f3fb": ["1f6b5-1f3fb-200d-2640-fe0f", 46, 26, 5, ['\uD83D\uDEB5\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f6b5-1f3fc-200d-2640-fe0f", 46, 27, 5, ['\uD83D\uDEB5\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f6b5-1f3fd-200d-2640-fe0f", 46, 28, 5, ['\uD83D\uDEB5\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f6b5-1f3fe-200d-2640-fe0f", 46, 29, 5, ['\uD83D\uDEB5\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f6b5-1f3ff-200d-2640-fe0f", 46, 30, 5, ['\uD83D\uDEB5\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f6b5-200d-2642-fe0f": { "1f3fb": ["1f6b5-1f3fb-200d-2642-fe0f", 46, 32, 5, ['\uD83D\uDEB5\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83D\uDEB5\uD83C\uDFFB']], "1f3fc": ["1f6b5-1f3fc-200d-2642-fe0f", 46, 33, 5, ['\uD83D\uDEB5\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83D\uDEB5\uD83C\uDFFC']], "1f3fd": ["1f6b5-1f3fd-200d-2642-fe0f", 46, 34, 5, ['\uD83D\uDEB5\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83D\uDEB5\uD83C\uDFFD']], "1f3fe": ["1f6b5-1f3fe-200d-2642-fe0f", 46, 35, 5, ['\uD83D\uDEB5\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83D\uDEB5\uD83C\uDFFE']], "1f3ff": ["1f6b5-1f3ff-200d-2642-fe0f", 46, 36, 5, ['\uD83D\uDEB5\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83D\uDEB5\uD83C\uDFFF']] },
        "1f6b6-200d-2640-fe0f": { "1f3fb": ["1f6b6-1f3fb-200d-2640-fe0f", 46, 38, 5, ['\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f6b6-1f3fc-200d-2640-fe0f", 46, 39, 5, ['\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f6b6-1f3fd-200d-2640-fe0f", 46, 40, 5, ['\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f6b6-1f3fe-200d-2640-fe0f", 46, 41, 5, ['\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f6b6-1f3ff-200d-2640-fe0f", 46, 42, 5, ['\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f6b6-200d-2642-fe0f": { "1f3fb": ["1f6b6-1f3fb-200d-2642-fe0f", 46, 44, 5, ['\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\uFE0F', '\uD83D\uDEB6\uD83C\uDFFB']], "1f3fc": ["1f6b6-1f3fc-200d-2642-fe0f", 46, 45, 5, ['\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\uFE0F', '\uD83D\uDEB6\uD83C\uDFFC']], "1f3fd": ["1f6b6-1f3fd-200d-2642-fe0f", 46, 46, 5, ['\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\uFE0F', '\uD83D\uDEB6\uD83C\uDFFD']], "1f3fe": ["1f6b6-1f3fe-200d-2642-fe0f", 46, 47, 5, ['\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\uFE0F', '\uD83D\uDEB6\uD83C\uDFFE']], "1f3ff": ["1f6b6-1f3ff-200d-2642-fe0f", 46, 48, 5, ['\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\uFE0F', '\uD83D\uDEB6\uD83C\uDFFF']] },
        "1f926-200d-2640-fe0f": { "1f3fb": ["1f926-1f3fb-200d-2640-fe0f", 47, 1, 5, ['\uD83E\uDD26\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f926-1f3fc-200d-2640-fe0f", 47, 2, 5, ['\uD83E\uDD26\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f926-1f3fd-200d-2640-fe0f", 47, 3, 5, ['\uD83E\uDD26\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f926-1f3fe-200d-2640-fe0f", 47, 4, 5, ['\uD83E\uDD26\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f926-1f3ff-200d-2640-fe0f", 47, 5, 5, ['\uD83E\uDD26\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f926-200d-2642-fe0f": { "1f3fb": ["1f926-1f3fb-200d-2642-fe0f", 47, 7, 5, ['\uD83E\uDD26\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f926-1f3fc-200d-2642-fe0f", 47, 8, 5, ['\uD83E\uDD26\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f926-1f3fd-200d-2642-fe0f", 47, 9, 5, ['\uD83E\uDD26\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f926-1f3fe-200d-2642-fe0f", 47, 10, 5, ['\uD83E\uDD26\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f926-1f3ff-200d-2642-fe0f", 47, 11, 5, ['\uD83E\uDD26\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f937-200d-2640-fe0f": { "1f3fb": ["1f937-1f3fb-200d-2640-fe0f", 47, 13, 5, ['\uD83E\uDD37\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f937-1f3fc-200d-2640-fe0f", 47, 14, 5, ['\uD83E\uDD37\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f937-1f3fd-200d-2640-fe0f", 47, 15, 5, ['\uD83E\uDD37\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f937-1f3fe-200d-2640-fe0f", 47, 16, 5, ['\uD83E\uDD37\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f937-1f3ff-200d-2640-fe0f", 47, 17, 5, ['\uD83E\uDD37\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f937-200d-2642-fe0f": { "1f3fb": ["1f937-1f3fb-200d-2642-fe0f", 47, 19, 5, ['\uD83E\uDD37\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f937-1f3fc-200d-2642-fe0f", 47, 20, 5, ['\uD83E\uDD37\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f937-1f3fd-200d-2642-fe0f", 47, 21, 5, ['\uD83E\uDD37\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f937-1f3fe-200d-2642-fe0f", 47, 22, 5, ['\uD83E\uDD37\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f937-1f3ff-200d-2642-fe0f", 47, 23, 5, ['\uD83E\uDD37\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f938-200d-2640-fe0f": { "1f3fb": ["1f938-1f3fb-200d-2640-fe0f", 47, 25, 5, ['\uD83E\uDD38\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f938-1f3fc-200d-2640-fe0f", 47, 26, 5, ['\uD83E\uDD38\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f938-1f3fd-200d-2640-fe0f", 47, 27, 5, ['\uD83E\uDD38\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f938-1f3fe-200d-2640-fe0f", 47, 28, 5, ['\uD83E\uDD38\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f938-1f3ff-200d-2640-fe0f", 47, 29, 5, ['\uD83E\uDD38\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f938-200d-2642-fe0f": { "1f3fb": ["1f938-1f3fb-200d-2642-fe0f", 47, 31, 5, ['\uD83E\uDD38\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f938-1f3fc-200d-2642-fe0f", 47, 32, 5, ['\uD83E\uDD38\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f938-1f3fd-200d-2642-fe0f", 47, 33, 5, ['\uD83E\uDD38\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f938-1f3fe-200d-2642-fe0f", 47, 34, 5, ['\uD83E\uDD38\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f938-1f3ff-200d-2642-fe0f", 47, 35, 5, ['\uD83E\uDD38\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f939-200d-2640-fe0f": { "1f3fb": ["1f939-1f3fb-200d-2640-fe0f", 47, 37, 5, ['\uD83E\uDD39\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f939-1f3fc-200d-2640-fe0f", 47, 38, 5, ['\uD83E\uDD39\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f939-1f3fd-200d-2640-fe0f", 47, 39, 5, ['\uD83E\uDD39\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f939-1f3fe-200d-2640-fe0f", 47, 40, 5, ['\uD83E\uDD39\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f939-1f3ff-200d-2640-fe0f", 47, 41, 5, ['\uD83E\uDD39\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f939-200d-2642-fe0f": { "1f3fb": ["1f939-1f3fb-200d-2642-fe0f", 47, 43, 5, ['\uD83E\uDD39\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f939-1f3fc-200d-2642-fe0f", 47, 44, 5, ['\uD83E\uDD39\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f939-1f3fd-200d-2642-fe0f", 47, 45, 5, ['\uD83E\uDD39\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f939-1f3fe-200d-2642-fe0f", 47, 46, 5, ['\uD83E\uDD39\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f939-1f3ff-200d-2642-fe0f", 47, 47, 5, ['\uD83E\uDD39\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f93d-200d-2640-fe0f": { "1f3fb": ["1f93d-1f3fb-200d-2640-fe0f", 48, 2, 5, ['\uD83E\uDD3D\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f93d-1f3fc-200d-2640-fe0f", 48, 3, 5, ['\uD83E\uDD3D\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f93d-1f3fd-200d-2640-fe0f", 48, 4, 5, ['\uD83E\uDD3D\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f93d-1f3fe-200d-2640-fe0f", 48, 5, 5, ['\uD83E\uDD3D\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f93d-1f3ff-200d-2640-fe0f", 48, 6, 5, ['\uD83E\uDD3D\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f93d-200d-2642-fe0f": { "1f3fb": ["1f93d-1f3fb-200d-2642-fe0f", 48, 8, 5, ['\uD83E\uDD3D\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f93d-1f3fc-200d-2642-fe0f", 48, 9, 5, ['\uD83E\uDD3D\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f93d-1f3fd-200d-2642-fe0f", 48, 10, 5, ['\uD83E\uDD3D\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f93d-1f3fe-200d-2642-fe0f", 48, 11, 5, ['\uD83E\uDD3D\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f93d-1f3ff-200d-2642-fe0f", 48, 12, 5, ['\uD83E\uDD3D\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "1f93e-200d-2640-fe0f": { "1f3fb": ["1f93e-1f3fb-200d-2640-fe0f", 48, 14, 5, ['\uD83E\uDD3E\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["1f93e-1f3fc-200d-2640-fe0f", 48, 15, 5, ['\uD83E\uDD3E\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["1f93e-1f3fd-200d-2640-fe0f", 48, 16, 5, ['\uD83E\uDD3E\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["1f93e-1f3fe-200d-2640-fe0f", 48, 17, 5, ['\uD83E\uDD3E\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["1f93e-1f3ff-200d-2640-fe0f", 48, 18, 5, ['\uD83E\uDD3E\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "1f93e-200d-2642-fe0f": { "1f3fb": ["1f93e-1f3fb-200d-2642-fe0f", 48, 20, 5, ['\uD83E\uDD3E\uD83C\uDFFB\u200D\u2642\uFE0F']], "1f3fc": ["1f93e-1f3fc-200d-2642-fe0f", 48, 21, 5, ['\uD83E\uDD3E\uD83C\uDFFC\u200D\u2642\uFE0F']], "1f3fd": ["1f93e-1f3fd-200d-2642-fe0f", 48, 22, 5, ['\uD83E\uDD3E\uD83C\uDFFD\u200D\u2642\uFE0F']], "1f3fe": ["1f93e-1f3fe-200d-2642-fe0f", 48, 23, 5, ['\uD83E\uDD3E\uD83C\uDFFE\u200D\u2642\uFE0F']], "1f3ff": ["1f93e-1f3ff-200d-2642-fe0f", 48, 24, 5, ['\uD83E\uDD3E\uD83C\uDFFF\u200D\u2642\uFE0F']] },
        "26f9-fe0f-200d-2640-fe0f": { "1f3fb": ["26f9-1f3fb-200d-2640-fe0f", 48, 26, 5, ['\u26F9\uD83C\uDFFB\u200D\u2640\uFE0F']], "1f3fc": ["26f9-1f3fc-200d-2640-fe0f", 48, 27, 5, ['\u26F9\uD83C\uDFFC\u200D\u2640\uFE0F']], "1f3fd": ["26f9-1f3fd-200d-2640-fe0f", 48, 28, 5, ['\u26F9\uD83C\uDFFD\u200D\u2640\uFE0F']], "1f3fe": ["26f9-1f3fe-200d-2640-fe0f", 48, 29, 5, ['\u26F9\uD83C\uDFFE\u200D\u2640\uFE0F']], "1f3ff": ["26f9-1f3ff-200d-2640-fe0f", 48, 30, 5, ['\u26F9\uD83C\uDFFF\u200D\u2640\uFE0F']] },
        "26f9-fe0f-200d-2642-fe0f": { "1f3fb": ["26f9-1f3fb-200d-2642-fe0f", 48, 32, 5, ['\u26F9\uD83C\uDFFB\u200D\u2642\uFE0F', '\u26F9\uD83C\uDFFB']], "1f3fc": ["26f9-1f3fc-200d-2642-fe0f", 48, 33, 5, ['\u26F9\uD83C\uDFFC\u200D\u2642\uFE0F', '\u26F9\uD83C\uDFFC']], "1f3fd": ["26f9-1f3fd-200d-2642-fe0f", 48, 34, 5, ['\u26F9\uD83C\uDFFD\u200D\u2642\uFE0F', '\u26F9\uD83C\uDFFD']], "1f3fe": ["26f9-1f3fe-200d-2642-fe0f", 48, 35, 5, ['\u26F9\uD83C\uDFFE\u200D\u2642\uFE0F', '\u26F9\uD83C\uDFFE']], "1f3ff": ["26f9-1f3ff-200d-2642-fe0f", 48, 36, 5, ['\u26F9\uD83C\uDFFF\u200D\u2642\uFE0F', '\u26F9\uD83C\uDFFF']] }
    };
    /** @private */
    emoji.prototype.obsoletes_data = {
        "26f9-fe0f-200d-2642-fe0f": ["26f9", 2, 25, 31],
        "26f9-1f3fb-200d-2642-fe0f": ["26f9-1f3fb", 2, 26, 31],
        "26f9-1f3fc-200d-2642-fe0f": ["26f9-1f3fc", 2, 27, 31],
        "26f9-1f3fd-200d-2642-fe0f": ["26f9-1f3fd", 2, 28, 31],
        "26f9-1f3fe-200d-2642-fe0f": ["26f9-1f3fe", 2, 29, 31],
        "26f9-1f3ff-200d-2642-fe0f": ["26f9-1f3ff", 2, 30, 31],
        "1f3c3-200d-2642-fe0f": ["1f3c3", 8, 35, 63],
        "1f3c3-1f3fb-200d-2642-fe0f": ["1f3c3-1f3fb", 8, 36, 63],
        "1f3c3-1f3fc-200d-2642-fe0f": ["1f3c3-1f3fc", 8, 37, 63],
        "1f3c3-1f3fd-200d-2642-fe0f": ["1f3c3-1f3fd", 8, 38, 63],
        "1f3c3-1f3fe-200d-2642-fe0f": ["1f3c3-1f3fe", 8, 39, 63],
        "1f3c3-1f3ff-200d-2642-fe0f": ["1f3c3-1f3ff", 8, 40, 63],
        "1f3c4-200d-2642-fe0f": ["1f3c4", 8, 41, 63],
        "1f3c4-1f3fb-200d-2642-fe0f": ["1f3c4-1f3fb", 8, 42, 63],
        "1f3c4-1f3fc-200d-2642-fe0f": ["1f3c4-1f3fc", 8, 43, 63],
        "1f3c4-1f3fd-200d-2642-fe0f": ["1f3c4-1f3fd", 8, 44, 63],
        "1f3c4-1f3fe-200d-2642-fe0f": ["1f3c4-1f3fe", 8, 45, 63],
        "1f3c4-1f3ff-200d-2642-fe0f": ["1f3c4-1f3ff", 8, 46, 63],
        "1f3ca-200d-2642-fe0f": ["1f3ca", 9, 8, 63],
        "1f3ca-1f3fb-200d-2642-fe0f": ["1f3ca-1f3fb", 9, 9, 63],
        "1f3ca-1f3fc-200d-2642-fe0f": ["1f3ca-1f3fc", 9, 10, 63],
        "1f3ca-1f3fd-200d-2642-fe0f": ["1f3ca-1f3fd", 9, 11, 63],
        "1f3ca-1f3fe-200d-2642-fe0f": ["1f3ca-1f3fe", 9, 12, 63],
        "1f3ca-1f3ff-200d-2642-fe0f": ["1f3ca-1f3ff", 9, 13, 63],
        "1f3cb-fe0f-200d-2642-fe0f": ["1f3cb", 9, 14, 31],
        "1f3cb-1f3fb-200d-2642-fe0f": ["1f3cb-1f3fb", 9, 15, 31],
        "1f3cb-1f3fc-200d-2642-fe0f": ["1f3cb-1f3fc", 9, 16, 31],
        "1f3cb-1f3fd-200d-2642-fe0f": ["1f3cb-1f3fd", 9, 17, 31],
        "1f3cb-1f3fe-200d-2642-fe0f": ["1f3cb-1f3fe", 9, 18, 31],
        "1f3cb-1f3ff-200d-2642-fe0f": ["1f3cb-1f3ff", 9, 19, 31],
        "1f3cc-fe0f-200d-2642-fe0f": ["1f3cc", 9, 20, 31],
        "1f3cc-1f3fb-200d-2642-fe0f": ["1f3cc-1f3fb", 9, 21, 21],
        "1f3cc-1f3fc-200d-2642-fe0f": ["1f3cc-1f3fc", 9, 22, 21],
        "1f3cc-1f3fd-200d-2642-fe0f": ["1f3cc-1f3fd", 9, 23, 21],
        "1f3cc-1f3fe-200d-2642-fe0f": ["1f3cc-1f3fe", 9, 24, 21],
        "1f3cc-1f3ff-200d-2642-fe0f": ["1f3cc-1f3ff", 9, 25, 21],
        "1f468-200d-1f469-200d-1f466": ["1f46a", 14, 20, 63],
        "1f46e-200d-2642-fe0f": ["1f46e", 14, 24, 63],
        "1f46e-1f3fb-200d-2642-fe0f": ["1f46e-1f3fb", 14, 25, 63],
        "1f46e-1f3fc-200d-2642-fe0f": ["1f46e-1f3fc", 14, 26, 63],
        "1f46e-1f3fd-200d-2642-fe0f": ["1f46e-1f3fd", 14, 27, 63],
        "1f46e-1f3fe-200d-2642-fe0f": ["1f46e-1f3fe", 14, 28, 63],
        "1f46e-1f3ff-200d-2642-fe0f": ["1f46e-1f3ff", 14, 29, 63],
        "1f46f-200d-2640-fe0f": ["1f46f", 14, 30, 63],
        "1f471-200d-2642-fe0f": ["1f471", 14, 37, 63],
        "1f471-1f3fb-200d-2642-fe0f": ["1f471-1f3fb", 14, 38, 63],
        "1f471-1f3fc-200d-2642-fe0f": ["1f471-1f3fc", 14, 39, 63],
        "1f471-1f3fd-200d-2642-fe0f": ["1f471-1f3fd", 14, 40, 63],
        "1f471-1f3fe-200d-2642-fe0f": ["1f471-1f3fe", 14, 41, 63],
        "1f471-1f3ff-200d-2642-fe0f": ["1f471-1f3ff", 14, 42, 63],
        "1f473-200d-2642-fe0f": ["1f473", 15, 0, 63],
        "1f473-1f3fb-200d-2642-fe0f": ["1f473-1f3fb", 15, 1, 63],
        "1f473-1f3fc-200d-2642-fe0f": ["1f473-1f3fc", 15, 2, 63],
        "1f473-1f3fd-200d-2642-fe0f": ["1f473-1f3fd", 15, 3, 63],
        "1f473-1f3fe-200d-2642-fe0f": ["1f473-1f3fe", 15, 4, 63],
        "1f473-1f3ff-200d-2642-fe0f": ["1f473-1f3ff", 15, 5, 63],
        "1f477-200d-2642-fe0f": ["1f477", 15, 24, 63],
        "1f477-1f3fb-200d-2642-fe0f": ["1f477-1f3fb", 15, 25, 63],
        "1f477-1f3fc-200d-2642-fe0f": ["1f477-1f3fc", 15, 26, 63],
        "1f477-1f3fd-200d-2642-fe0f": ["1f477-1f3fd", 15, 27, 63],
        "1f477-1f3fe-200d-2642-fe0f": ["1f477-1f3fe", 15, 28, 63],
        "1f477-1f3ff-200d-2642-fe0f": ["1f477-1f3ff", 15, 29, 63],
        "1f481-200d-2640-fe0f": ["1f481", 16, 0, 63],
        "1f481-1f3fb-200d-2640-fe0f": ["1f481-1f3fb", 16, 1, 63],
        "1f481-1f3fc-200d-2640-fe0f": ["1f481-1f3fc", 16, 2, 63],
        "1f481-1f3fd-200d-2640-fe0f": ["1f481-1f3fd", 16, 3, 63],
        "1f481-1f3fe-200d-2640-fe0f": ["1f481-1f3fe", 16, 4, 63],
        "1f481-1f3ff-200d-2640-fe0f": ["1f481-1f3ff", 16, 5, 63],
        "1f482-200d-2642-fe0f": ["1f482", 16, 6, 63],
        "1f482-1f3fb-200d-2642-fe0f": ["1f482-1f3fb", 16, 7, 63],
        "1f482-1f3fc-200d-2642-fe0f": ["1f482-1f3fc", 16, 8, 63],
        "1f482-1f3fd-200d-2642-fe0f": ["1f482-1f3fd", 16, 9, 63],
        "1f482-1f3fe-200d-2642-fe0f": ["1f482-1f3fe", 16, 10, 63],
        "1f482-1f3ff-200d-2642-fe0f": ["1f482-1f3ff", 16, 11, 63],
        "1f486-200d-2640-fe0f": ["1f486", 16, 25, 63],
        "1f486-1f3fb-200d-2640-fe0f": ["1f486-1f3fb", 16, 26, 63],
        "1f486-1f3fc-200d-2640-fe0f": ["1f486-1f3fc", 16, 27, 63],
        "1f486-1f3fd-200d-2640-fe0f": ["1f486-1f3fd", 16, 28, 63],
        "1f486-1f3fe-200d-2640-fe0f": ["1f486-1f3fe", 16, 29, 63],
        "1f486-1f3ff-200d-2640-fe0f": ["1f486-1f3ff", 16, 30, 63],
        "1f487-200d-2640-fe0f": ["1f487", 16, 31, 63],
        "1f487-1f3fb-200d-2640-fe0f": ["1f487-1f3fb", 16, 32, 63],
        "1f487-1f3fc-200d-2640-fe0f": ["1f487-1f3fc", 16, 33, 63],
        "1f487-1f3fd-200d-2640-fe0f": ["1f487-1f3fd", 16, 34, 63],
        "1f487-1f3fe-200d-2640-fe0f": ["1f487-1f3fe", 16, 35, 63],
        "1f487-1f3ff-200d-2640-fe0f": ["1f487-1f3ff", 16, 36, 63],
        "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468": ["1f48f", 16, 44, 61],
        "1f469-200d-2764-fe0f-200d-1f468": ["1f491", 16, 46, 61],
        "1f575-fe0f-200d-2642-fe0f": ["1f575", 21, 17, 31],
        "1f575-1f3fb-200d-2642-fe0f": ["1f575-1f3fb", 21, 18, 31],
        "1f575-1f3fc-200d-2642-fe0f": ["1f575-1f3fc", 21, 19, 31],
        "1f575-1f3fd-200d-2642-fe0f": ["1f575-1f3fd", 21, 20, 31],
        "1f575-1f3fe-200d-2642-fe0f": ["1f575-1f3fe", 21, 21, 31],
        "1f575-1f3ff-200d-2642-fe0f": ["1f575-1f3ff", 21, 22, 31],
        "1f645-200d-2640-fe0f": ["1f645", 24, 4, 63],
        "1f645-1f3fb-200d-2640-fe0f": ["1f645-1f3fb", 24, 5, 63],
        "1f645-1f3fc-200d-2640-fe0f": ["1f645-1f3fc", 24, 6, 63],
        "1f645-1f3fd-200d-2640-fe0f": ["1f645-1f3fd", 24, 7, 63],
        "1f645-1f3fe-200d-2640-fe0f": ["1f645-1f3fe", 24, 8, 63],
        "1f645-1f3ff-200d-2640-fe0f": ["1f645-1f3ff", 24, 9, 63],
        "1f646-200d-2640-fe0f": ["1f646", 24, 10, 63],
        "1f646-1f3fb-200d-2640-fe0f": ["1f646-1f3fb", 24, 11, 63],
        "1f646-1f3fc-200d-2640-fe0f": ["1f646-1f3fc", 24, 12, 63],
        "1f646-1f3fd-200d-2640-fe0f": ["1f646-1f3fd", 24, 13, 63],
        "1f646-1f3fe-200d-2640-fe0f": ["1f646-1f3fe", 24, 14, 63],
        "1f646-1f3ff-200d-2640-fe0f": ["1f646-1f3ff", 24, 15, 63],
        "1f647-200d-2642-fe0f": ["1f647", 24, 16, 63],
        "1f647-1f3fb-200d-2642-fe0f": ["1f647-1f3fb", 24, 17, 63],
        "1f647-1f3fc-200d-2642-fe0f": ["1f647-1f3fc", 24, 18, 63],
        "1f647-1f3fd-200d-2642-fe0f": ["1f647-1f3fd", 24, 19, 63],
        "1f647-1f3fe-200d-2642-fe0f": ["1f647-1f3fe", 24, 20, 63],
        "1f647-1f3ff-200d-2642-fe0f": ["1f647-1f3ff", 24, 21, 63],
        "1f64b-200d-2640-fe0f": ["1f64b", 24, 25, 63],
        "1f64b-1f3fb-200d-2640-fe0f": ["1f64b-1f3fb", 24, 26, 63],
        "1f64b-1f3fc-200d-2640-fe0f": ["1f64b-1f3fc", 24, 27, 63],
        "1f64b-1f3fd-200d-2640-fe0f": ["1f64b-1f3fd", 24, 28, 63],
        "1f64b-1f3fe-200d-2640-fe0f": ["1f64b-1f3fe", 24, 29, 63],
        "1f64b-1f3ff-200d-2640-fe0f": ["1f64b-1f3ff", 24, 30, 63],
        "1f64d-200d-2640-fe0f": ["1f64d", 24, 37, 63],
        "1f64d-1f3fb-200d-2640-fe0f": ["1f64d-1f3fb", 24, 38, 63],
        "1f64d-1f3fc-200d-2640-fe0f": ["1f64d-1f3fc", 24, 39, 63],
        "1f64d-1f3fd-200d-2640-fe0f": ["1f64d-1f3fd", 24, 40, 63],
        "1f64d-1f3fe-200d-2640-fe0f": ["1f64d-1f3fe", 24, 41, 63],
        "1f64d-1f3ff-200d-2640-fe0f": ["1f64d-1f3ff", 24, 42, 63],
        "1f64e-200d-2640-fe0f": ["1f64e", 24, 43, 63],
        "1f64e-1f3fb-200d-2640-fe0f": ["1f64e-1f3fb", 24, 44, 63],
        "1f64e-1f3fc-200d-2640-fe0f": ["1f64e-1f3fc", 24, 45, 63],
        "1f64e-1f3fd-200d-2640-fe0f": ["1f64e-1f3fd", 24, 46, 63],
        "1f64e-1f3fe-200d-2640-fe0f": ["1f64e-1f3fe", 24, 47, 63],
        "1f64e-1f3ff-200d-2640-fe0f": ["1f64e-1f3ff", 24, 48, 63],
        "1f6a3-200d-2642-fe0f": ["1f6a3", 25, 41, 63],
        "1f6a3-1f3fb-200d-2642-fe0f": ["1f6a3-1f3fb", 25, 42, 31],
        "1f6a3-1f3fc-200d-2642-fe0f": ["1f6a3-1f3fc", 25, 43, 31],
        "1f6a3-1f3fd-200d-2642-fe0f": ["1f6a3-1f3fd", 25, 44, 31],
        "1f6a3-1f3fe-200d-2642-fe0f": ["1f6a3-1f3fe", 25, 45, 31],
        "1f6a3-1f3ff-200d-2642-fe0f": ["1f6a3-1f3ff", 25, 46, 31],
        "1f6b4-200d-2642-fe0f": ["1f6b4", 26, 14, 63],
        "1f6b4-1f3fb-200d-2642-fe0f": ["1f6b4-1f3fb", 26, 15, 63],
        "1f6b4-1f3fc-200d-2642-fe0f": ["1f6b4-1f3fc", 26, 16, 63],
        "1f6b4-1f3fd-200d-2642-fe0f": ["1f6b4-1f3fd", 26, 17, 63],
        "1f6b4-1f3fe-200d-2642-fe0f": ["1f6b4-1f3fe", 26, 18, 63],
        "1f6b4-1f3ff-200d-2642-fe0f": ["1f6b4-1f3ff", 26, 19, 63],
        "1f6b5-200d-2642-fe0f": ["1f6b5", 26, 20, 63],
        "1f6b5-1f3fb-200d-2642-fe0f": ["1f6b5-1f3fb", 26, 21, 63],
        "1f6b5-1f3fc-200d-2642-fe0f": ["1f6b5-1f3fc", 26, 22, 63],
        "1f6b5-1f3fd-200d-2642-fe0f": ["1f6b5-1f3fd", 26, 23, 63],
        "1f6b5-1f3fe-200d-2642-fe0f": ["1f6b5-1f3fe", 26, 24, 63],
        "1f6b5-1f3ff-200d-2642-fe0f": ["1f6b5-1f3ff", 26, 25, 63],
        "1f6b6-200d-2642-fe0f": ["1f6b6", 26, 26, 63],
        "1f6b6-1f3fb-200d-2642-fe0f": ["1f6b6-1f3fb", 26, 27, 63],
        "1f6b6-1f3fc-200d-2642-fe0f": ["1f6b6-1f3fc", 26, 28, 63],
        "1f6b6-1f3fd-200d-2642-fe0f": ["1f6b6-1f3fd", 26, 29, 63],
        "1f6b6-1f3fe-200d-2642-fe0f": ["1f6b6-1f3fe", 26, 30, 63],
        "1f6b6-1f3ff-200d-2642-fe0f": ["1f6b6-1f3ff", 26, 31, 63]
    };

    // export
    if (true) {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = emoji;
        }
        exports.EmojiConvertor = emoji;
    } else if (typeof define === 'function' && define.amd) {
        define(function () {
            return emoji;
        });
    } else {
        root.EmojiConvertor = emoji;
    }
}).call(function () {
    return this || (typeof window !== 'undefined' ? window : global);
}());
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright (c) Rotorz Limited. All rights reserved.
// Licensed under the MIT license. See LICENSE file in the project root.



var PluginEnvironment = __webpack_require__(766);
var tokenizer = __webpack_require__(767);

function setup(md, options) {
  var env = new PluginEnvironment(md, options);

  md.block.ruler.before("fence", "block-image", tokenizer.bind(env), {
    alt: ["paragraph", "reference", "blockquote", "list"]
  });
}

module.exports = setup;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright (c) Rotorz Limited. All rights reserved.
// Licensed under the MIT license. See LICENSE file in the project root.



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginEnvironment = function () {
  function PluginEnvironment(md, options) {
    _classCallCheck(this, PluginEnvironment);

    this.md = md;
    this.options = Object.assign(this.getDefaultOptions(), options);
  }

  _createClass(PluginEnvironment, [{
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return {
        outputContainer: false,
        containerClassName: "block-image"
      };
    }
  }]);

  return PluginEnvironment;
}();

module.exports = PluginEnvironment;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright (c) Rotorz Limited. All rights reserved.
// Licensed under the MIT license. See LICENSE file in the project root.



var SYNTAX_CHARS = "![]()".split("");
var SYNTAX_CODES = SYNTAX_CHARS.map(function (char) {
  return char.charCodeAt(0);
});

function advanceToSymbol(state, endLine, symbol, pointer) {
  var maxPos = null;
  var symbolLine = pointer.line;
  var symbolIndex = state.src.indexOf(symbol, pointer.pos);

  if (symbolIndex === -1) return false;

  maxPos = state.eMarks[pointer.line];
  while (symbolIndex >= maxPos) {
    ++symbolLine;
    maxPos = state.eMarks[symbolLine];

    if (symbolLine >= endLine) return false;
  }

  pointer.prevPos = pointer.pos;
  pointer.pos = symbolIndex;
  pointer.line = symbolLine;
  return true;
}

function tokenizer(state, startLine, endLine, silent) {
  var startPos = state.bMarks[startLine] + state.tShift[startLine];
  var maxPos = state.eMarks[startLine];

  var pointer = { line: startLine, pos: startPos };

  // Block image must be at start of input or the previous line must be blank.
  if (startLine !== 0) {
    var prevLineStartPos = state.bMarks[startLine - 1] + state.tShift[startLine - 1];
    var prevLineMaxPos = state.eMarks[startLine - 1];
    if (prevLineMaxPos > prevLineStartPos) return false;
  }

  // Identify as being a potential block image.
  if (maxPos - startPos < 2) return false;
  if (SYNTAX_CODES[0] !== state.src.charCodeAt(pointer.pos++)) return false;

  // Read alt text from within square brackets.
  if (SYNTAX_CODES[1] !== state.src.charCodeAt(pointer.pos++)) return false;
  if (!advanceToSymbol(state, endLine, "]", pointer)) return false;
  ++pointer.pos;

  // Read image url and title from within parenthesis.
  if (SYNTAX_CODES[3] !== state.src.charCodeAt(pointer.pos++)) return false;
  if (!advanceToSymbol(state, endLine, ")", pointer)) return false;

  ++pointer.pos;

  // Do not recognize as block element when there is trailing text.
  maxPos = state.eMarks[pointer.line];
  var trailingText = state.src.substr(pointer.pos, maxPos - pointer.pos).trim();
  if (trailingText !== "") return false;

  // Block image must be at end of input or the next line must be blank.
  if (endLine !== pointer.line + 1) {
    var nextLineStartPos = state.bMarks[pointer.line + 1] + state.tShift[pointer.line + 1];
    var nextLineMaxPos = state.eMarks[pointer.line + 1];
    if (nextLineMaxPos > nextLineStartPos) return false;
  }

  if (pointer.line >= endLine) return false;

  if (!silent) {
    var token = void 0;

    if (this.options.outputContainer) {
      token = state.push("block-image_open", this.options.outputContainer, 1);
      token.map = [pointer.line, pointer.line + 1];

      if (this.options.containerClassName) {
        token.attrSet("class", this.options.containerClassName);
      }
    }

    token = state.push("inline", "", 0);
    token.content = state.src.substr(startPos, pointer.pos - startPos);
    token.map = [startLine, pointer.line + 1];
    token.children = [];

    if (this.options.outputContainer) {
      state.push("block-image_close", this.options.outputContainer, -1);
    }

    state.line = pointer.line + 1;
  }

  return true;
}

module.exports = tokenizer;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.textOnHover = textOnHover;
textOnHover.$inject = ['$'];

function textOnHover($) {
    return {
        scope: {
            textOnHover: '@textOnHover'
        },
        link: function link($scope, element) {
            var backupText = '';
            $(element).on('mouseover', function () {
                backupText = $(element).text();
                $(element).text($scope.textOnHover);
            });

            $(element).on('mouseout', function () {
                $(element).text(backupText);
            });
        }
    };
}

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(7);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cartonomyLogo = __webpack_require__(417);

_module3.default.directive('cartonomyLogo', ['$', function ($) {
    return {
        restrict: 'E',
        link: function link($scope, element) {
            $(element).html(cartonomyLogo);
        }
    };
}]);

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _module2 = __webpack_require__(68);

var _module3 = _interopRequireDefault(_module2);

var _routeConfig = __webpack_require__(771);

var _routeConfig2 = _interopRequireDefault(_routeConfig);

var _CartController = __webpack_require__(777);

var _CartController2 = _interopRequireDefault(_CartController);

var _InvitedPeopleListController = __webpack_require__(778);

var _InvitedPeopleListController2 = _interopRequireDefault(_InvitedPeopleListController);

var _PopupBagDirective = __webpack_require__(779);

var _PopupBagDirective2 = _interopRequireDefault(_PopupBagDirective);

var _OrderDetailsDirective = __webpack_require__(780);

var _OrderDetailsDirective2 = _interopRequireDefault(_OrderDetailsDirective);

var _CartGroupsService = __webpack_require__(782);

var _CartGroupsService2 = _interopRequireDefault(_CartGroupsService);

var _CartDirective = __webpack_require__(783);

var _CartDirective2 = _interopRequireDefault(_CartDirective);

var _CartGroupsDirective = __webpack_require__(785);

var _CartGroupsDirective2 = _interopRequireDefault(_CartGroupsDirective);

var _StoreAdminCartController = __webpack_require__(428);

var _StoreAdminCartController2 = _interopRequireDefault(_StoreAdminCartController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.controller('Cartonomy.Cart.CartController', _CartController2.default);
_module3.default.controller('Cartonomy.Cart.InvitedPeopleListController', _InvitedPeopleListController2.default);
_module3.default.controller(_StoreAdminCartController2.default.$controllerName, _StoreAdminCartController2.default);

_module3.default.directive('popupBag', [function () {
    return {
        scope: {
            hasGroupOrder: '='
        },
        template: __webpack_require__(787),
        controller: _PopupBagDirective2.default
    };
}]);

_module3.default.config(['$stateProvider', function ($stateProvider) {
    _routeConfig2.default.forEach(function (route) {
        $stateProvider.state(route);
    });
}]);

exports.default = _module3.default.name;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _StoreAdminCartController = __webpack_require__(428);

var _StoreAdminCartController2 = _interopRequireDefault(_StoreAdminCartController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    name: _CommonConstants2.default.RoutingStates.CART,
    url: "/cart",
    windowTitle: 'client.cart.group',
    views: {
        contents: {
            template: __webpack_require__(772),
            controller: 'Cartonomy.Cart.CartController'
        }
    }
}, {
    name: _CommonConstants2.default.RoutingStates.START_CHECKOUT,
    url: "/start_checkout",
    windowTitle: 'client.cart.checkout_start',
    views: {
        contents: {
            template: __webpack_require__(773),
            controller: "Cartonomy.Cart.CartController"
        }
    }
}, {
    name: _CommonConstants2.default.RoutingStates.INVITED_PEOPLE,
    url: "/invitedPeople",
    windowTitle: 'client.members',
    views: {
        contents: {
            template: __webpack_require__(774),
            controller: 'Cartonomy.Cart.InvitedPeopleListController'
        }
    }
}, {
    name: _CommonConstants2.default.RoutingStates.STORE_ADMIN,
    url: "/storeAdmin",
    views: {
        contents: {
            template: __webpack_require__(775),
            controller: _StoreAdminCartController2.default.$controllerName
        }
    }
}, {
    name: _CommonConstants2.default.RoutingStates.OPEN_CARTS,
    url: "/opentCarts",
    windowTitle: 'client.cart.open_cart',
    views: {
        contents: {
            template: __webpack_require__(776),
            controller: _StoreAdminCartController2.default.$controllerName
        }
    }
}];

exports.default = routes;

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cart-page\" md-dynamic-height=\"md-dynamic-height\" md-border-bottom=\"md-border-bottom\"><cartonomy-cart ng-show=\"orderExists\" ng-class=\"{'is-mobile': isMobile() }\"></cartonomy-cart></div>"

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = "<div class=\"flex-column start-checkout\"><div class=\"text-info flex-column center-items\"><div class=\"icon\"><svg width=\"130\" height=\"130\" viewBox=\"0 0 130 130\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<circle cx=\"65\" cy=\"65\" r=\"65\" fill=\"#EFF4F7\"/>\n<path d=\"M71.0335 23H43.3669C39.553 23 36.4502 26.1028 36.4502 29.9167V79.7167C36.4502 83.5305 39.553 86.6334 43.3669 86.6334H68.2669V83.8667H43.3669C41.0789 83.8667 39.2169 82.0047 39.2169 79.7167V29.9167C39.2169 27.6287 41.0789 25.7667 43.3669 25.7667H71.0336C73.3216 25.7667 75.1836 27.6287 75.1836 29.9167V70.0334H77.9502V29.9167C77.9502 26.1028 74.8474 23 71.0335 23Z\" fill=\"#689DBC\"/>\n<path d=\"M91.2172 59.8465L77.6467 42.8868L75.4845 44.616L89.055 61.5742C90.816 63.7737 91.7843 66.5377 91.783 69.3555V103.233H71.5449C64.3986 103.233 58.5831 97.4191 58.5831 90.2715V85.25H55.8164V90.2715C55.8164 98.9435 62.8729 106 71.5449 106H93.1664C93.9314 106 94.5497 105.382 94.5497 104.617V69.357C94.5511 65.9152 93.3684 62.537 91.2172 59.8465Z\" fill=\"#689DBC\"/>\n<path d=\"M59.9614 55.6232C60.9324 55.6509 61.8359 56.0547 62.5012 56.7602L80.1436 75.5067C80.6673 76.0631 81.543 76.0897 82.0995 75.5661C82.6561 75.0423 82.6827 74.1665 82.1589 73.61L64.5139 54.8623C63.3394 53.6186 61.75 52.9063 60.0402 52.8578C58.3124 52.7997 56.7036 53.4291 55.4752 54.5898C55.4599 54.605 55.3492 54.71 55.3354 54.7253C52.9714 57.0963 52.8122 60.8175 54.9689 63.3878L64.5147 74.6591C66.0442 76.4651 66.8836 78.7551 66.8836 81.1218V81.7363C66.8823 88.917 71.124 95.4716 77.5723 98.4622C78.2653 98.7837 79.0654 98.4163 79.3335 97.7009C79.6017 96.9853 79.2352 96.1932 78.5463 95.8624C73.1721 93.2813 69.649 87.7681 69.6502 81.7363V76.95C69.6502 76.6235 69.534 76.3053 69.3224 76.055L57.0841 61.6033C55.8599 60.1452 55.9498 58.0273 57.3608 56.615C58.0662 55.9482 58.9874 55.6175 59.9614 55.6232Z\" fill=\"#689DBC\"/>\n<path d=\"M69.6495 25.7667H66.8828V60.35H69.6495V25.7667Z\" fill=\"#689DBC\"/>\n<path d=\"M62.7335 68.65H59.9668V85.25H62.7335V68.65Z\" fill=\"#689DBC\"/>\n<path d=\"M62.7335 24.3833H59.9668V54.8166H62.7335V24.3833Z\" fill=\"#689DBC\"/>\n<path d=\"M46.1339 46.5166V31.3001C46.1339 30.5361 45.5146 29.9167 44.7505 29.9167C43.9865 29.9167 43.3672 30.5361 43.3672 31.3001V46.5166C43.3672 47.2806 43.9865 47.9 44.7505 47.9C45.5146 47.9 46.1339 47.2806 46.1339 46.5166Z\" fill=\"#689DBC\"/>\n<path d=\"M53.0499 39.6001V31.3001C53.0499 30.5361 52.4306 29.9167 51.6666 29.9167C50.9026 29.9167 50.2832 30.5361 50.2832 31.3001V39.6001C50.2832 40.3641 50.9026 40.9834 51.6666 40.9834C52.4306 40.9834 53.0499 40.3641 53.0499 39.6001Z\" fill=\"#689DBC\"/>\n<path d=\"M53.0505 68.65H44.7505C43.9869 68.65 43.3672 69.2683 43.3672 70.0333V78.3333C43.3672 79.0983 43.9869 79.7165 44.7505 79.7165H53.0505C53.814 79.7165 54.4337 79.0983 54.4337 78.3333V70.0333C54.4337 69.2683 53.814 68.65 53.0505 68.65ZM51.6672 76.95H46.1339V71.4167H51.6672V76.95Z\" fill=\"#689DBC\"/>\n</svg>\n</div><div class=\"info-header\">{{'client.cart.checkout_process' | translate}}</div><div class=\"info-p\">{{'client.cart.checkout_share' | translate}}</div><div class=\"info-p\">{{'client.cart.checkout_pay_info' | translate}}</div></div><div class=\"extra-order-info flex-column\"><div class=\"flex-row center-items\"><div class=\"order-detail-container\"><order-details class=\"flex-row center-items\"></order-details></div><div class=\"order-total flex-column\"><div class=\"total-group flex-row\" ng-if=\"myTab.subtotal\"><span class=\"total-label\">{{'client.cart.total' | translate}}</span><span class=\"total-value\">{{formatAmount(myTab.subtotal)}}</span></div><div class=\"total-group flex-row\" ng-if=\"groupSpending &amp;&amp; !marketingMode\"><span class=\"total-label\">{{'client.cart.group_total' | translate}}</span><span class=\"total-value\">{{formatAmount(groupSpending)}}</span></div><div class=\"total-group flex-row\" ng-if=\"myTapDiscounted &amp;&amp; marketingMode\"><span class=\"total-label\">{{'client.cart.total_after' | translate}}</span><span class=\"total-value\">{{formatAmount(myTapDiscounted)}}</span></div></div></div><div class=\"order-actions flex-column\"><button class=\"btn-lg primary\" aria-label=\"Start Checkout\" ng-click=\"startCheckoutProcess()\">{{'client.cart.checkout_start' | translate}}</button><button class=\"btn-lg secondary\" aria-label=\"Back\" ng-click=\"backToCart()\">{{'client.back' | translate}}</button></div></div></div>"

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = "<div class=\"invited-people-list\"><div class=\"members flex-column\"><invite-link></invite-link><div class=\"contacts-list flex-column\"><div class=\"contact flex-row\" ng-repeat=\"contact in filterContacts()\"><div class=\"left-block\"><span class=\"avatar\" ng-if=\"!contact.avatarCropped\">{{ contact.firstLetter }}</span><img class=\"avatar\" ng-if=\"contact.avatarCropped\" ng-src=\"{{ contact.avatarCropped }}\"/><div class=\"flex-column name-info-block\"><div class=\"name\">{{ contact.name }}</div><div class=\"email\">{{ contact.email }}</div></div></div><div class=\"right-block\"><div class=\"flex-column\"><div class=\"status\">{{ contact.status }}</div><div class=\"flex-row\" ng-if=\"isOwner &amp;&amp; !isStealthUserMode\"><a class=\"icon-btn\" ng-if=\"!contact.invitationResending &amp;&amp; !contact.isOwner &amp;&amp; !isLocked()\" ng-click=\"resendInvitation(contact)\" title=\"Resend Invitation Email\"><i class=\"fa fa-envelope\"></i></a><a class=\"icon-btn\" ng-if=\"!contact.isOwner &amp;&amp; contact.status === 'Joined' &amp;&amp; !isLocked()\" ng-click=\"makeContactGroupOwner(contact)\" title=\"Make {{ contact.name }} the Group Owner\"><i class=\"fa fa-exchange\"></i></a><a class=\"icon-btn\" ng-if=\"canRemoveUser(contact)\" ng-click=\"removeFromCart(contact)\" title=\"Remove From This Order\"><i class=\"fa fa-times\"></i></a></div></div></div></div></div></div><!--.content.chat-contents(layout=\"column\")--><!--    div(ng-if=\"invitationType == 2\").invite-link-wrapper--><!--        div(layout=\"row\" layout-align=\"center center\").title Group Order Members--><!--        div(layout=\"row\" layout-align=\"center center\", ng-show=\"!isLocked()\").join-link-title Join order link:--><!--        div(layout=\"row\" layout-align=\"center center\", ng-show=\"!isLocked()\")--><!--            div.link--><!--                span.val {{invitationLink}}--><!--                span(class=\"fa fa-copy copy-clipboard\" ng-click=\"copyClipboard()\" title=\"copy the link\")--><!----><!--    div(layout=\"row\" ng-if=\"invitationType !== 2\")--><!--            div(flex=\"35\").title Group Order Members--><!--    div(layout=\"column\" layout-gt-sm=\"row\")--><!--        .actions(ng-if=\"isOwner && !isLocked() && !isStealthUserMode && invitationType !== 2\" layout=\"column\")--><!--            a.md-primary.invite-more-people(ng-click=\"inviteMorePeople()\" aria-label=\"Invite More People\") Invite More People--><!--    .contacts(layout=\"row\" layout-wrap)--><!--        .contact(ng-repeat=\"contact in filterContacts()\" flex=\"50\" flex-xs=\"50\")--><!--            div(layout=\"column\" layout-align=\"start center\")--><!--                .avatar(layout=\"row\" layout-align=\"center center\" ng-class=\"{'has-avatar': contact.avatarCropped}\")--><!--                    span(ng-if=\"!contact.avatarCropped\") {{ contact.firstLetter }}--><!--                    img.contact-avatar(ng-if=\"contact.avatarCropped\" ng-src=\"{{ contact.avatarCropped }}\")--><!----><!--                .details(layout=\"column\" layout-align=\"center center\")--><!--                    .name {{ contact.name }}--><!--                    .email {{ contact.email }}--><!--                    .status {{ contact.status }}--><!--                    .action(layout=\"row\" ng-if=\"!isLocked() && !isStealthUserMode\")--><!--                        a.md-primary.md-button.md-ink-ripple(--><!--                                    flex=\"30\"--><!--                                    ng-if=\"isOwner && !contact.invitationResending && !contact.isOwner\"--><!--                                    ng-click=\"resendInvitation(contact)\"--><!--                                    title=\"Resend Invitation Email\")--><!--                            i.fa.fa-envelope--><!----><!--                        a.md-primary.md-button.md-ink-ripple(--><!--                                    ng-if=\"isOwner && !contact.isOwner && contact.status === 'Joined'\"--><!--                                    ng-click=\"makeContactGroupOwner(contact)\"--><!--                                    title=\"Make {{ contact.name }} the Group Owner\")--><!--                            i.fa.fa-exchange--><!----><!--                        a.md-primary.md-button.md-ink-ripple(--><!--                                    flex=\"30\"--><!--                                    ng-if=\"isOwner && !contact.invitationResending && !contact.isOwner\"--><!--                                    ng-click=\"removeFromCart(contact)\"--><!--                                    title=\"Remove From This Order\")--><!--                            i.fa.fa-times--></div>"

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = "<div class=\"open-carts flex-column\"><span class=\"head\">{{'client.order.report' | translate}}</span><div class=\"cart-item flex-row\" ng-repeat=\"cart in model.carts\"><div class=\"left-block flex-column\"><span class=\"main-info\">{{ cart.cartName }}</span><div class=\"flex-row\"><span class=\"additional-info\">{{'client.owner' | translate}}:</span><a class=\"additional-info appended-link\">{{cart.ownerName}}</a></div></div><div class=\"right-block flex-column\"><div class=\"flex-row justify-content-sb\"><span class=\"main-info\">{{ formatAmount(cart.cartAmount) }}</span><a class=\"icon-btn circle-btn\" ng-click=\"overlayOpened = !overlayOpened\" ng-class=\"{'active': overlayOpened}\"><svg width=\"35\" height=\"35\" viewBox=\"0 0 35 35\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<circle class=\"main-circle\" cx=\"17.5\" cy=\"17.5\" r=\"17.5\" fill=\"#F9F9F9\"/>\n<circle class=\"dot-circle\" cx=\"8\" cy=\"18\" r=\"2\" fill=\"#54636C\"/>\n<circle class=\"dot-circle\" cx=\"17.6\" cy=\"18\" r=\"2\" fill=\"#54636C\"/>\n<circle class=\"dot-circle\" cx=\"26.4\" cy=\"18\" r=\"2\" fill=\"#54636C\"/>\n</svg>\n</a><div class=\"custom-popup flex-column\" ng-show=\"overlayOpened\"><div class=\"overlay\" ng-click=\"overlayOpened = false\"></div><a class=\"popup-btn\" ng-click=\"overlayOpened = false; goToCart(cart.id)\">{{'client.cart.go' | translate}}</a></div></div><a class=\"additional-info\" href=\"mailto:{{ cart.ownerEmail }}\">{{ cart.ownerEmail }}</a></div></div></div><!--.cart-page.store-admin(md-dynamic-height md-border-bottom)--><!--    div(layout=\"row\", layout-align=\"end center\")--><!--        div(flex=\"80\")--><!--            h3.title Group Orders Report--><!--            span.instruction (click on cart name to go to the cart)--><!--        div(flex=\"20\")--><!--            md-button.md-raised.md-hover.back-profile-button(ng-click=\"backToProfile()\" aria-label=\"back\")--><!--                md-icon arrow_back--><!--                span Back to profile--><!----><!--    table.table.table-responsive.table-bordered.table-custom(st-table=\"displayedCollection\", st-safe-src='model.carts')--><!--        thead--><!--            th(class=\"th-cart-name\") Cart Name1--><!--            th(class=\"th-owner-email\") Owner email--><!--            th(class=\"th-member\") Members--><!--            th(class=\"th-items\") Items--><!--            th(class=\"th-other-info\") Other info--><!--        tbody--><!--            tr(ng-if=\"!model.carts || model.carts.length === 0\")--><!--                td(colspan = 5) No Data--><!--            tr(ng-if=\"model.carts && model.carts.length > 0\", ng-repeat=\"cart in displayedCollection\")--><!--                td(class=\"td-cart-name\", ng-click=\"goToCart(cart.id)\" title=\"Go to this cart\")--><!--                    span.link {{ cart.cartName }}--><!--                td(class=\"td-owner-email\")--><!--                    a(href=\"mailto:{{ cart.ownerEmail }}\") {{ cart.ownerEmail }}--><!--                td(class=\"td-member\") {{ cart.participants }}--><!--                td(class=\"td-items\") {{ cart.items }}--><!--                td(class=\"td-other-info\")--><!--                    div - Start date: {{ cart.createdOn | amDateFormat:'MM/DD/YY hh:mm' }}--><!--                    div - Last updated: {{ cart.lastUpdated | amDateFormat:'MM/DD/YY hh:mm' }}--><!--                    div(ng-if=\"cart.cartAmount\") - Ammount: {{ cart.cartAmount | currency }}--><!--                    div(ng-if=\"cart.closeOn\") - Closed date:{{ cart.closeOn | amDateFormat:'MM/DD/YY hh:mm' }}--><!--                    div(ng-if=\"cart.orderLimit\") - Limit: {{ cart.orderLimit | currency }}--><!--                    div--><!--                        span.cart-status(ng-class=\"{ 'c-open': cart.cartStatus === 'OPEN' }\") {{ cart.cartStatus }}--><!--        tfoot(ng-if=\"model.carts.length > 50\")--><!--            tr--><!--                td.text-center(colspan=5)--><!--                    div(st-pagination='', st-items-by-page='50', st-displayed-pages='9')-->"

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = "<div class=\"open-carts flex-column\"><span class=\"head\">{{'client.cart.open_group_chart' | translate}}</span><div class=\"cart-item flex-row\" ng-repeat=\"cart in model.carts\"><div class=\"left-block flex-column\"><span class=\"main-info\">{{ cart.cartName }}</span><div class=\"flex-row\"><span class=\"additional-info\">{{'client.owner' | translate}}:</span><a class=\"additional-info appended-link\">{{cart.ownerName}}</a></div></div><div class=\"right-block flex-column\"><div class=\"flex-row justify-content-sb\"><span class=\"main-info\">{{formatAmount(cart.cartAmount)}}</span><a class=\"icon-btn circle-btn\" ng-click=\"overlayOpened = !overlayOpened\" ng-class=\"{'active': overlayOpened}\"><svg width=\"35\" height=\"35\" viewBox=\"0 0 35 35\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<circle class=\"main-circle\" cx=\"17.5\" cy=\"17.5\" r=\"17.5\" fill=\"#F9F9F9\"/>\n<circle class=\"dot-circle\" cx=\"8\" cy=\"18\" r=\"2\" fill=\"#54636C\"/>\n<circle class=\"dot-circle\" cx=\"17.6\" cy=\"18\" r=\"2\" fill=\"#54636C\"/>\n<circle class=\"dot-circle\" cx=\"26.4\" cy=\"18\" r=\"2\" fill=\"#54636C\"/>\n</svg>\n</a><div class=\"custom-popup flex-column\" ng-show=\"overlayOpened\"><div class=\"overlay\" ng-click=\"overlayOpened = false\"></div><a class=\"popup-btn\" ng-click=\"overlayOpened = false; joinToCart(cart.id, cart.cartToken)\">{{'client.cart.go' | translate}}</a></div></div><a class=\"additional-info\" href=\"mailto:{{ cart.ownerEmail }}\">{{ cart.ownerEmail }}</a></div></div></div><!--.cart-page.store-admin(md-dynamic-height md-border-bottom)--><!--    div(layout=\"row\", layout-align=\"end center\")--><!--        div(flex=\"80\")--><!--            h3.title Open Group Carts--><!--            span.instruction (click on cart name to go to the cart)--><!--        div(flex=\"20\")--><!--            md-button.md-raised.md-hover.back-profile-button(ng-click=\"backToProfile()\" aria-label=\"back\")--><!--                md-icon arrow_back--><!--                span Back to profile--><!----><!--    table.table.table-responsive.table-bordered.table-custom(st-table=\"displayedCollection\", st-safe-src='model.carts')--><!--        thead--><!--            th(class=\"th-cart-name\") Cart Name--><!--            th(class=\"th-owner-email\") Owner email--><!--            th(class=\"th-member\") Members--><!--            th(class=\"th-items\") Items--><!--            th(class=\"th-other-info\") Other info--><!--        tbody--><!--            tr(ng-if=\"!model.carts || model.carts.length === 0\")--><!--                td(colspan = 5) No Data--><!--            tr(ng-if=\"model.carts && model.carts.length > 0\", ng-repeat=\"cart in model.carts\")--><!--                td(class=\"td-cart-name\", ng-click=\"joinToCart(cart.id, cart.cartToken)\" title=\"Go to this cart\")--><!--                    span.link {{ cart.cartName }}--><!--                td(class=\"td-owner-email\")--><!--                    a(href=\"mailto:{{ cart.ownerEmail }}\") {{ cart.ownerEmail }}--><!--                td(class=\"td-member\") {{ cart.participants }}--><!--                td(class=\"td-items\") {{ cart.items }}--><!--                td(class=\"td-other-info\")--><!--                    div - Start date: {{ cart.createdOn | amDateFormat:'MM/DD/YY hh:mm' }}--><!--                    div - Last updated: {{ cart.lastUpdated | amDateFormat:'MM/DD/YY hh:mm' }}--><!--                    div(ng-if=\"cart.cartAmount\") - Ammount: {{ cart.cartAmount | currency }}--><!--                    div(ng-if=\"cart.closeOn\") - Closed date:{{ cart.closeOn | amDateFormat:'MM/DD/YY hh:mm' }}--><!--                    div(ng-if=\"cart.orderLimit\") - Limit: {{ cart.orderLimit | currency }}--><!--        tfoot(ng-if=\"model.carts.length > 50\")--><!--            tr--><!--                td.text-center(colspan='5')--><!--                    div(st-pagination='', st-items-by-page='50', st-displayed-pages='9')-->"

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _communicationService = __webpack_require__(28);

var _commandKeys = __webpack_require__(27);

var _utils = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartController = function () {
  function CartController(scope, stateService, cartService, session, authenticationService, messageService, rootScope, checkoutService, cartGroupsService, orderSetupService, configurationService, cartonomyConfig, timeout, localForageService, $translate) {
    var _this = this;

    _classCallCheck(this, CartController);

    scope.groupSpending = "";
    scope.numbers = _.range(1, 10);
    scope.deleteItem = function (item) {
      return _this._deleteItem(item);
    };
    scope.payMyTab = function () {
      return _this._payMyTab();
    };
    scope.leaveOrder = function () {
      return _this._leaveOrder();
    };
    scope.quantityKeyPressed = function ($event) {
      return _this._quantityKeyPressed($event);
    };

    scope.showPayButton = function () {
      return _this._shouldShowPayButton();
    };
    scope.shouldShowStartIndividualPaymentButton = function () {
      return _this._shouldShowStartIndividualPaymentButton();
    };

    scope.clearCart = function () {
      return _this._clearCart();
    };
    scope.cancelOrder = function () {
      return _this._cancelOrder();
    };
    scope.canCancelOrder = function () {
      return _this._canCancelOrder();
    };
    scope.separatePayments = function () {
      return _this._separatePayments();
    };
    scope.startCheckoutProcess = function (userId) {
      return _this._startCheckoutProcess(userId);
    };
    scope.toggleCollapse = function (group) {
      return _this._toggleCollapse(group);
    };
    scope.updateQuantity = function ($event, item, updateValue) {
      return _this._updateQuantity($event, item, updateValue);
    };
    scope.backToCart = function () {
      return _this._backToCart();
    };
    scope.confirmStartCheckout = function () {
      return _this._confirmStartCheckout();
    };
    scope.goToOrderSettings = function () {
      return _this._goToOrderSetting();
    };
    scope.startNewOrder = function () {
      return _this._startNewOrder();
    };

    window.messageService = messageService;

    this._cartService = cartService;
    this._scope = scope;
    this._state = stateService;
    this._session = session;
    this._messageService = messageService;
    this._authenticationService = authenticationService;
    this._checkoutService = checkoutService;
    this._cartGroupsService = cartGroupsService;
    this._scope.loading = false;
    this._cartonomyConfig = cartonomyConfig;
    this._rootScope = rootScope;
    this._orderSetupService = orderSetupService;
    this._timeout = timeout;
    this._configurationService = configurationService;
    this._localForageService = localForageService;
    this.$translate = $translate;

    this._cartChanging = false;
    this._retailer = null;
    this._scope.items = [];
    this._scope.checkOut = false;
    this._scope.groupsCollapses = {};
    this.quantityUpdating = false;
    this.quantityUpdateClicked = false;

    scope.updateSelectedTab = function (number) {
      scope.selectedTab = number;
    };

    scope.setQuantity = function (item) {
      return _this._setQuantity(item);
    };

    scope.startEditingItem = function (item) {
      item.isEditing = true;
    };

    scope.stopEditingItem = function (item) {
      setTimeout(function () {
        item.quantity = item.savedQuantity;
        item.isEditing = false;
        _scope2.default.apply(_this._scope);
      }, 200);
    };

    scope.isStealthUserMode = this._session.getStealthUserMode();
    scope.showClearButtonCart = function () {
      return _this._showClearButtonCart();
    };
    scope.isGeneralMillsPOC = false;
  }

  _createClass(CartController, [{
    key: '$onInit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this._rootScope.storeWindowTitle = 'client.header.group_cart';
                _context7.next = 3;
                return this._messageService.showLoadingWhiteBackground();

              case 3:
                this._scope.loading = _context7.sent;
                _context7.next = 6;
                return this._configurationService.getItem('retailer');

              case 6:
                this._retailer = _context7.sent;

                this._scope.isGeneralMillsPOC = this._retailer && _CommonConstants2.default.GENERAL_MILLS_POC.some(function (poc) {
                  return _this2._retailer.name.indexOf(poc) > -1;
                });

                if (!this._rootScope.safariWarningIsShowing) {
                  _context7.next = 11;
                  break;
                }

                _context7.next = 11;
                return this._rootScope.displaySafariWarning();

              case 11:
                if (!(_utils.utils.hash.indexOf('#/invite/') > -1)) {
                  _context7.next = 21;
                  break;
                }

                this._rootScope.$on(_CommonConstants2.default.Events.INVITATION_ACCEPTED, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _this2.resetCartToEmpty();
                          _scope2.default.apply(_this2._scope);
                          _context.next = 4;
                          return _this2._onCartChanged();

                        case 4:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                })));

                this._rootScope.$on(_CommonConstants2.default.Events.INVITATION_FAILED_DUE_TO_CART_CLOSED, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this2.$onInit();

                        case 2:
                          return _context2.abrupt('return', _context2.sent);

                        case 3:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

                _context7.next = 16;
                return this._session.loggedIn();

              case 16:
                if (!_context7.sent) {
                  _context7.next = 21;
                  break;
                }

                this.resetCartToEmpty();
                _scope2.default.apply(this._scope);
                _context7.next = 21;
                return this._onCartChanged();

              case 21:
                _context7.next = 23;
                return this._getAndSetupCart();

              case 23:

                if (this._scope.loading) {
                  this._scope.loading.close();
                  this._scope.loading = null;
                }
                _scope2.default.apply(this._scope);

                this._scope.$on(_CommonConstants2.default.RootEvents.CART_CHANGED, function () {
                  return _this2._onCartChanged();
                });

                this._scope.$on(_CommonConstants2.default.Events.WINDOW_STATE_CHANGED, _.debounce(function (scope, windowState) {
                  return _this2.onWindowStateChanged(windowState);
                }, 200));

                this._scope.$on(_CommonConstants2.default.Events.ORDER_CANCELLED, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this2.resetCartToEmpty();
                          _scope2.default.apply(_this2._scope);
                          _context3.next = 4;
                          return _this2._onCartChanged();

                        case 4:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this2);
                })));

                this._scope.$on(_CommonConstants2.default.Events.ORDER_CANCELLED_BY_OWNER, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _this2.resetCartToEmpty();
                          _scope2.default.apply(_this2._scope);

                        case 2:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _callee4, _this2);
                })));

                this._scope.$on(_CommonConstants2.default.Events.ORDER_CLEARED_BY_OWNER, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _this2.resetCartToEmpty();
                          _scope2.default.apply(_this2._scope);

                        case 2:
                        case 'end':
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this2);
                })));

                this._scope.$on(_CommonConstants2.default.Events.ORDER_CHECKED_OUT, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _this2.resetCartToEmpty();
                          _scope2.default.apply(_this2._scope);

                        case 2:
                        case 'end':
                          return _context6.stop();
                      }
                    }
                  }, _callee6, _this2);
                })));

              case 31:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function $onInit() {
        return _ref.apply(this, arguments);
      }

      return $onInit;
    }()
  }, {
    key: '_showClearButtonCart',
    value: function _showClearButtonCart() {
      return this._retailer && this._retailer.retailerType !== 'Shopify';
    }
  }, {
    key: '_shouldShowStartIndividualPaymentButton',
    value: function _shouldShowStartIndividualPaymentButton() {
      if (this._scope.cart) {
        if (this._rootScope.retailer.cartonomyMode === _CommonConstants2.default.CartonomyMode.marketing) {
          return this._scope.cart.cartStatus === 'OPEN' && (0, _moment2.default)().isAfter((0, _moment2.default)(this._scope.cart.closeOn));
        }
        if (this._scope.cart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.MIXED || this._scope.cart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.FULL_MIXED || this._scope.cart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.SELF) {
          return this._scope.cart.cartStatus === 'OPEN';
        }
      }

      return false;
    }
  }, {
    key: '_shouldShowPayButton',
    value: function _shouldShowPayButton() {
      if (this._scope.cart) {
        if (this._scope.cart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.MIXED || this._scope.cart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.FULL_MIXED || this._scope.cart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.SELF) {
          return this._scope.isOwner ? this._scope.cart.cartStatus === 'OWNER_CHECKING_OUT' : this._scope.cart.cartStatus === 'CHECKING_OUT';
        }
      }

      return (!this._scope.isGroupOrder || this._scope.payAllowed) && !this._scope.paymentAuthorized;
    }
  }, {
    key: '_clearCart',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var confirmed;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._messageService.showQuestionPopup(this.$translate.instant('client.order.remove_confirm'), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

              case 2:
                confirmed = _context8.sent;

                if (confirmed) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt('return', null);

              case 5:
                _context8.prev = 5;
                _context8.next = 8;
                return this._cartService.clearCart();

              case 8:
                this._scope.items = [];
                this.resetCartToEmpty();
                _context8.next = 15;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8['catch'](5);

                this._messageService.showErrorPopupForResponse(_context8.t0);

              case 15:

                _scope2.default.apply(this._scope);

              case 16:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[5, 12]]);
      }));

      function _clearCart() {
        return _ref8.apply(this, arguments);
      }

      return _clearCart;
    }()
  }, {
    key: '_cancelOrder',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var confirmed, stateToGo;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._messageService.showQuestionPopup(this.$translate.instant('client.order.group_cancel_confirm'), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

              case 2:
                confirmed = _context9.sent;

                if (confirmed) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt('return', null);

              case 5:
                if (!(this._scope.cart.cartStatus === "CHECKING_OUT" || this._participants.some(function (p) {
                  return p.paymentStatus === 1 && p.status !== 'OWNER' && p.items && p.items.length;
                }))) {
                  _context9.next = 9;
                  break;
                }

                _context9.next = 8;
                return this._messageService.showQuestionPopup(this.$translate.instant('client.order.payment_done_cancel_confirm'));

              case 8:
                confirmed = _context9.sent;

              case 9:
                if (confirmed) {
                  _context9.next = 11;
                  break;
                }

                return _context9.abrupt('return', null);

              case 11:
                _context9.prev = 11;
                _context9.next = 14;
                return this._cartService.deleteCart();

              case 14:
                _context9.next = 16;
                return this._cartService.resetCartInvitationType();

              case 16:
                this._rootScope.$broadcast(_CommonConstants2.default.Events.ORDER_CANCELLED);

                stateToGo = this._cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CART : _CommonConstants2.default.RoutingStates.CATALOG;

                this._state.go(stateToGo);
                _context9.next = 24;
                break;

              case 21:
                _context9.prev = 21;
                _context9.t0 = _context9['catch'](11);

                this._messageService.showErrorPopupForResponse(_context9.t0);

              case 24:

                _scope2.default.apply(this._scope);

              case 25:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[11, 21]]);
      }));

      function _cancelOrder() {
        return _ref9.apply(this, arguments);
      }

      return _cancelOrder;
    }()
  }, {
    key: 'onWindowStateChanged',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(windowState) {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(windowState === _CommonConstants2.default.WindowMode.maximized && this._scope.isCart())) {
                  _context10.next = 3;
                  break;
                }

                _context10.next = 3;
                return this._checkOrderAvailable();

              case 3:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function onWindowStateChanged(_x) {
        return _ref10.apply(this, arguments);
      }

      return onWindowStateChanged;
    }()
  }, {
    key: '_onCartChanged',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (this._cartChangeTimeout) {
                  clearTimeout(this._cartChangeTimeout);
                }

                this._cartChangeTimeout = setTimeout(function () {
                  clearTimeout(_this3._cartChangeTimeout);
                  _this3._getAndSetupCart().then(function () {
                    _this3.quantityUpdating = false;
                    _scope2.default.apply(_this3._scope);
                  });
                }, 500);

              case 2:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function _onCartChanged() {
        return _ref11.apply(this, arguments);
      }

      return _onCartChanged;
    }()
  }, {
    key: '_checkOrderAvailable',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var _this4 = this;

        var orderExists, isUserLoggedIn, cart, cartOwner;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                orderExists = false;

                if (!this._cartonomyConfig.externalStoreMode) {
                  _context12.next = 19;
                  break;
                }

                if (!this._orderSetupService.invitationPromise) {
                  _context12.next = 5;
                  break;
                }

                _context12.next = 5;
                return this._orderSetupService.invitationPromise;

              case 5:
                _context12.next = 7;
                return this._session.loggedIn();

              case 7:
                isUserLoggedIn = _context12.sent;

                if (!(!isUserLoggedIn && !(_utils.utils.hash.indexOf('#/invite/') > -1))) {
                  _context12.next = 11;
                  break;
                }

                _context12.next = 11;
                return this._authenticationService.showLoginDialog('', 'facade', true);

              case 11:
                _context12.next = 13;
                return this._cartService.isGroupOrder();

              case 13:
                orderExists = _context12.sent;

                if (orderExists) {
                  _context12.next = 19;
                  break;
                }

                _context12.next = 17;
                return this._orderSetupService.createOrder();

              case 17:
                if (_context12.sent) {
                  _context12.next = 19;
                  break;
                }

                return _context12.abrupt('return');

              case 19:
                _context12.next = 21;
                return this._cartService.getCart();

              case 21:
                cart = _context12.sent;
                _context12.next = 24;
                return this._cartService.isGroupOrder();

              case 24:
                orderExists = _context12.sent;

                if (!(cart && orderExists)) {
                  _context12.next = 31;
                  break;
                }

                cartOwner = _.find(cart.participants, function (participant) {
                  return participant.status === 'OWNER' || _this4._scope.isStealthUserMode && participant.status === 'REMOVED';
                });

                if (this._retailer.customCartNames === '1' && cart.cartName && cart.cartName !== this.$translate.instant(_CommonConstants2.default.CART_NAME_DEFAULT_VALUE)) this._scope.cartOwnerBtn = this.$translate.instant(_utils.utils.compileMyCartButtonText(cart.cartName), { user: cart.cartName });else this._scope.cartOwnerBtn = this.$translate.instant('client.add_to') + ' ' + this.toPossessiveString(cartOwner && cartOwner.name) + ' ' + this.$translate.instant('client.header.group_cart');

                this._scope.recentlyAddedProduct = this._rootScope.addingProduct && this._rootScope.addingProduct.variantId;
                _context12.next = 31;
                return this._setupCart(cart);

              case 31:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function _checkOrderAvailable() {
        return _ref12.apply(this, arguments);
      }

      return _checkOrderAvailable;
    }()
  }, {
    key: 'toPossessiveString',
    value: function toPossessiveString(name) {
      if (name[name.length - 1] == 's') {
        return name + '\'';
      }

      return name + '\'s';
    }
  }, {
    key: '_setQuantity',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(item, recursiveChangeValue) {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(item < 1)) {
                  _context13.next = 2;
                  break;
                }

                return _context13.abrupt('return');

              case 2:
                _context13.prev = 2;
                _context13.next = 5;
                return this._updateItem(item);

              case 5:
                _context13.next = 7;
                return this._updateGroups();

              case 7:
                _context13.next = 15;
                break;

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13['catch'](2);

                item.quantity -= recursiveChangeValue;
                _scope2.default.apply(this._scope);
                _context13.next = 15;
                return this.__setQuantityRecursively(item, recursiveChangeValue);

              case 15:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this, [[2, 9]]);
      }));

      function _setQuantity(_x2, _x3) {
        return _ref13.apply(this, arguments);
      }

      return _setQuantity;
    }()
  }, {
    key: '__setQuantityRecursively',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(item, recursiveChangeValue) {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!(item.savedQuantity === item.quantity || item.quantity < 1)) {
                  _context14.next = 3;
                  break;
                }

                this.quantityUpdating = false;
                return _context14.abrupt('return');

              case 3:
                _context14.prev = 3;
                _context14.next = 6;
                return this._updateItem(item);

              case 6:
                _context14.next = 14;
                break;

              case 8:
                _context14.prev = 8;
                _context14.t0 = _context14['catch'](3);

                item.quantity -= recursiveChangeValue;
                _scope2.default.apply(this._scope);
                _context14.next = 14;
                return this.__setQuantityRecursively(item, recursiveChangeValue);

              case 14:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this, [[3, 8]]);
      }));

      function __setQuantityRecursively(_x4, _x5) {
        return _ref14.apply(this, arguments);
      }

      return __setQuantityRecursively;
    }()
  }, {
    key: '_updateItem',
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(item) {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return this._cartService.updateItem(item);

              case 3:
                _context15.next = 9;
                break;

              case 5:
                _context15.prev = 5;
                _context15.t0 = _context15['catch'](0);

                this._messageService.showErrorPopupForResponse(_context15.t0);
                throw _context15.t0;

              case 9:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 5]]);
      }));

      function _updateItem(_x6) {
        return _ref15.apply(this, arguments);
      }

      return _updateItem;
    }()
  }, {
    key: '_quantityKeyPressed',
    value: function _quantityKeyPressed($event) {
      if ($event.which !== 13) {
        return;
      }

      $event.target.blur();
    }
  }, {
    key: '_deleteItem',
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(item) {
        var i;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return this._cartService.deleteItem(item.id);

              case 3:
                i = 0;

              case 4:
                if (!(i < this._scope.items.length)) {
                  _context16.next = 11;
                  break;
                }

                if (!(this._scope.items[i].id === item.id)) {
                  _context16.next = 8;
                  break;
                }

                this._scope.items.splice(i, 1);
                return _context16.abrupt('break', 11);

              case 8:
                i++;
                _context16.next = 4;
                break;

              case 11:
                _context16.next = 13;
                return this._updateGroups();

              case 13:
                _context16.next = 18;
                break;

              case 15:
                _context16.prev = 15;
                _context16.t0 = _context16['catch'](0);

                this._messageService.showErrorPopupForResponse(_context16.t0);

              case 18:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this, [[0, 15]]);
      }));

      function _deleteItem(_x7) {
        return _ref16.apply(this, arguments);
      }

      return _deleteItem;
    }()
  }, {
    key: '_updateGroups',
    value: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var recentUpdated;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this._scope.items.length) {
                  recentUpdated = _.maxBy(this._scope.items, function (item) {
                    return item.recordedOn;
                  });


                  if (recentUpdated) recentUpdated.recentlyUpdated = true;
                }

                _context17.next = 3;
                return this._cartGroupsService.groupItems(this._scope.items, this._participants);

              case 3:
                this._scope.groups = _context17.sent;

                this._scope.myTab = _.find(this._scope.groups, { myTab: true });
                this._scope.groupSpending = _.sumBy(this._scope.groups, function (group) {
                  return group.subtotal;
                });
                if (this._scope.myTab && this._scope.cart) {
                  this._scope.myTapDiscounted = this._scope.myTab.subtotal - this._scope.cart.cartDiscount;
                }

                _scope2.default.apply(this._scope);

              case 8:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function _updateGroups() {
        return _ref17.apply(this, arguments);
      }

      return _updateGroups;
    }()
  }, {
    key: '_getAndSetupCart',
    value: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this._checkOrderAvailable();

              case 2:
                _scope2.default.apply(this._scope);

              case 3:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function _getAndSetupCart() {
        return _ref18.apply(this, arguments);
      }

      return _getAndSetupCart;
    }()
  }, {
    key: 'resetCartToEmpty',
    value: function resetCartToEmpty() {
      this._scope.groups = null;
      this._scope.myTab = null;
      this._scope.groupSpending = null;
      this._scope.myTapDiscounted = null;
    }
  }, {
    key: '_setupCart',
    value: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(cart) {
        var _this5 = this;

        var currentUser, currentParticipant;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (cart) {
                  _context19.next = 3;
                  break;
                }

                this.resetCartToEmpty();
                return _context19.abrupt('return');

              case 3:

                this._scope.groupAllowance = cart.orderLimit;
                _context19.next = 6;
                return this._cartService.isGroupOrder(cart);

              case 6:
                this._scope.isGroupOrder = _context19.sent;

                this._scope.cart = cart;
                _context19.next = 10;
                return this._cartService.getCart();

              case 10:
                this._scope.cart = _context19.sent;
                _context19.next = 13;
                return this._cartService.isGroupOrder();

              case 13:
                this._scope.orderExists = _context19.sent;

                if (cart.closeOn) {
                  _context19.next = 18;
                  break;
                }

                this._scope.orderDeadline = this.$translate.instant('client.order.deadline') + ': ' + this.$translate.instant('client.none');
                _context19.next = 28;
                break;

              case 18:
                if (!_moment2.default.utc(cart.closeOn).isBefore((0, _moment2.default)())) {
                  _context19.next = 27;
                  break;
                }

                this._scope.orderDeadline = this.$translate.instant('client.order.deadline') + ': ' + this.$translate.instant('client.order.closed_br') + '<br />';
                _context19.next = 22;
                return this._session.getUserEmail();

              case 22:
                currentUser = _context19.sent;
                currentParticipant = _.find(cart.participants, function (participant) {
                  return participant.email == currentUser;
                });

                if (currentParticipant && currentParticipant.status === "OWNER") {
                  this._scope.orderDeadline += '' + this.$translate.instant('client.order.deadline_open');
                }
                _context19.next = 28;
                break;

              case 27:
                this._scope.orderDeadline = this.$translate.instant('client.order.deadline') + ': ' + (0, _moment2.default)().to(_moment2.default.utc(cart.closeOn));

              case 28:
                _context19.next = 30;
                return this._cartService.isOwner(cart);

              case 30:
                this._scope.isOwner = _context19.sent;

                this._scope.canDeleteItem = this._retailer.cartonomyMode !== _CommonConstants2.default.CartonomyMode.marketing;
                this._scope.marketingMode = this._retailer.cartonomyMode === _CommonConstants2.default.CartonomyMode.marketing;

                this._scope.items = _.cloneDeep(cart.items);
                this._scope._itemsCount = _.sumBy(this._scope.items, function (item) {
                  return item.quantity;
                });
                this._participants = cart.participants;
                _context19.next = 38;
                return this._checkoutService.paymentAuthorizedOrCaptured();

              case 38:
                this._scope.paymentAuthorized = _context19.sent;


                this._participants.forEach(function (participant) {
                  participant.items = _this5._scope.items.filter(function (item) {
                    return item.participantEmail === participant.email;
                  });
                });

                this._scope.awaitPayment = this._participants.filter(function (p) {
                  return p.paymentStatus === 0 && p.status !== 'OWNER' && p.items.length;
                }).length;

                if (cart.cartStatus === 'CHECKING_OUT') {
                  this._scope.paymentStatusMessage = this._scope.awaitPayment === 0 ? this.$translate.instant('client.order.checkout_complete') : this._scope.awaitPayment + ' ' + (this._scope.awaitPayment > 1 ? this.$translate.instant('client.order.people_need') : this.$translate.instant('client.order.people_needs')) + ' ' + this.$translate.instant('client.order.to_pay');
                }

                if (cart.cartStatus === 'OPEN') {
                  this._scope.isAllowChangeQuantity = true;
                }

                this._scope.groupPay = cart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.MULTIPLE;

                if (this._scope.groupPay) {
                  this._scope.payAllowed = true;
                } else if (!this._scope.isGroupOrder) {
                  this._scope.payAllowed = true;
                } else {
                  this._scope.payAllowed = this._scope.isOwner && !this._scope.paymentAuthorized;
                }

                _.each(this._scope.items, function (item) {
                  item.savedQuantity = item.quantity;
                  if (!item.catalogProductImage) {
                    item.catalogProductImage = _CommonConstants2.default.DEFAULT_PRODUCT_IMAGE;
                  }
                });

                _context19.next = 48;
                return this._updateGroups();

              case 48:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function _setupCart(_x8) {
        return _ref19.apply(this, arguments);
      }

      return _setupCart;
    }()
  }, {
    key: '_leaveOrder',
    value: function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var confirmed;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this._messageService.showQuestionPopup(this.$translate.instant('client.order.leave_order'), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

              case 2:
                confirmed = _context20.sent;

                if (confirmed) {
                  _context20.next = 5;
                  break;
                }

                return _context20.abrupt('return', null);

              case 5:
                _context20.prev = 5;
                _context20.next = 8;
                return this._cartService.leaveCart();

              case 8:
                this._scope.overlayOpened = false;

                if (!this._cartonomyConfig.externalStoreMode) {
                  _context20.next = 14;
                  break;
                }

                _context20.next = 12;
                return this._rootScope.$broadcast(_CommonConstants2.default.Events.LEFT_ORDER);

              case 12:
                _context20.next = 15;
                break;

              case 14:
                this._state.go(_CommonConstants2.default.RoutingStates.CATALOG);

              case 15:

                this._messageService.showErrorPopup(this.$translate.instant('client.order.left_order'));
                _context20.next = 23;
                break;

              case 18:
                _context20.prev = 18;
                _context20.t0 = _context20['catch'](5);

                this._scope.overlayOpened = false;
                _scope2.default.apply(this._scope);
                this._messageService.showErrorPopupForResponse(_context20.t0);

              case 23:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, this, [[5, 18]]);
      }));

      function _leaveOrder() {
        return _ref20.apply(this, arguments);
      }

      return _leaveOrder;
    }()
  }, {
    key: '_separatePayments',
    value: function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var confirmed;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this._messageService.showQuestionPopup(this.$translate.instant('client.cart.proceed_with_email'), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

              case 2:
                confirmed = _context21.sent;

                if (confirmed) {
                  _context21.next = 5;
                  break;
                }

                return _context21.abrupt('return', null);

              case 5:
                _context21.next = 7;
                return this._cartService.checkOutCart();

              case 7:
                this._rootScope.$broadcast(_CommonConstants2.default.RootEvents.CART_CHANGED);

              case 8:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function _separatePayments() {
        return _ref21.apply(this, arguments);
      }

      return _separatePayments;
    }()

    /**
     * Check out by owner only
     */

  }, {
    key: '_startCheckoutProcess',
    value: function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(userId) {
        var retailer;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (!(this._scope.cart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.FULL_MIXED && this._scope.isOwner && !userId)) {
                  _context22.next = 3;
                  break;
                }

                this._state.go(_CommonConstants2.default.RoutingStates.CHECKOUT_FULL_MIXED);
                return _context22.abrupt('return');

              case 3:
                if (this._cartonomyConfig.externalStoreMode) {
                  _context22.next = 7;
                  break;
                }

                this._state.go(_CommonConstants2.default.RoutingStates.CHECKOUT);
                _context22.next = 33;
                break;

              case 7:
                _context22.prev = 7;
                _context22.next = 10;
                return this._configurationService.getItem('retailer');

              case 10:
                retailer = _context22.sent;

                if (!(retailer.retailerType === 'Amazon')) {
                  _context22.next = 16;
                  break;
                }

                _context22.next = 14;
                return this._amazonCheckout();

              case 14:
                _context22.next = 28;
                break;

              case 16:
                if (!(retailer.retailerType === 'Walmart')) {
                  _context22.next = 21;
                  break;
                }

                _context22.next = 19;
                return this._walmartCheckout();

              case 19:
                _context22.next = 28;
                break;

              case 21:
                if (!(retailer.retailerType === 'Freshop')) {
                  _context22.next = 26;
                  break;
                }

                _context22.next = 24;
                return this._freshopCheckout();

              case 24:
                _context22.next = 28;
                break;

              case 26:
                _context22.next = 28;
                return this._shopifyCheckout(userId);

              case 28:
                _context22.next = 33;
                break;

              case 30:
                _context22.prev = 30;
                _context22.t0 = _context22['catch'](7);

                this._messageService.showErrorPopupForResponse(_context22.t0);

              case 33:
                this._rootScope.$broadcast(_CommonConstants2.default.RootEvents.CART_CHANGED);

              case 34:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, this, [[7, 30]]);
      }));

      function _startCheckoutProcess(_x9) {
        return _ref22.apply(this, arguments);
      }

      return _startCheckoutProcess;
    }()

    /**
     * Check out for mixed mode - pay personally
     */

  }, {
    key: '_payMyTab',
    value: function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var retailer;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (this._cartonomyConfig.externalStoreMode) {
                  _context23.next = 4;
                  break;
                }

                this._state.go(_CommonConstants2.default.RoutingStates.CHECKOUT);
                _context23.next = 30;
                break;

              case 4:
                _context23.prev = 4;
                _context23.next = 7;
                return this._configurationService.getItem('retailer');

              case 7:
                retailer = _context23.sent;

                if (!(retailer.retailerType === 'Amazon')) {
                  _context23.next = 13;
                  break;
                }

                _context23.next = 11;
                return this._amazonCheckout();

              case 11:
                _context23.next = 25;
                break;

              case 13:
                if (!(retailer.retailerType === 'Walmart')) {
                  _context23.next = 18;
                  break;
                }

                _context23.next = 16;
                return this._walmartCheckout();

              case 16:
                _context23.next = 25;
                break;

              case 18:
                if (!(retailer.retailerType === 'Freshop')) {
                  _context23.next = 23;
                  break;
                }

                _context23.next = 21;
                return this._freshopCheckout();

              case 21:
                _context23.next = 25;
                break;

              case 23:
                _context23.next = 25;
                return this._shopifyCheckout();

              case 25:
                _context23.next = 30;
                break;

              case 27:
                _context23.prev = 27;
                _context23.t0 = _context23['catch'](4);

                this._messageService.showErrorPopupForResponse(_context23.t0);

              case 30:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, this, [[4, 27]]);
      }));

      function _payMyTab() {
        return _ref23.apply(this, arguments);
      }

      return _payMyTab;
    }()
  }, {
    key: '_canCancelOrder',
    value: function _canCancelOrder() {
      return this._scope.cart && this._scope.isOwner;
    }
  }, {
    key: '_amazonCheckout',
    value: function () {
      var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var loadingDialog, amazonCheckoutInfo;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this._messageService.showLoading();

              case 2:
                loadingDialog = _context24.sent;
                _context24.next = 5;
                return this._checkoutService.getAmazonCheckoutInfo();

              case 5:
                amazonCheckoutInfo = _context24.sent;
                _context24.next = 8;
                return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.checkoutCart, {
                  cartInfo: amazonCheckoutInfo.cartInfo,
                  checkoutUrl: amazonCheckoutInfo.url
                });

              case 8:

                loadingDialog.close();

              case 9:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function _amazonCheckout() {
        return _ref24.apply(this, arguments);
      }

      return _amazonCheckout;
    }()
  }, {
    key: '_shopifyCheckout',
    value: function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(userId) {
        var loadingDialog, shopifyCheckoutInfo, myCartItems, continueCheckout, existingShopifyCartItems, hasMyCartItems, continueCheckoutWhenMatch, _continueCheckout, checkoutResult;

        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return this._messageService.showLoading();

              case 2:
                loadingDialog = _context25.sent;
                _context25.prev = 3;
                _context25.next = 6;
                return this._checkoutService.getShopifyCheckoutInfo(userId);

              case 6:
                shopifyCheckoutInfo = _context25.sent;
                myCartItems = shopifyCheckoutInfo.cartInfo.cartItems;

                if (!shopifyCheckoutInfo.warningInfo) {
                  _context25.next = 18;
                  break;
                }

                loadingDialog.close();
                _context25.next = 12;
                return this._messageService.showQuestionPopup(shopifyCheckoutInfo.warningInfo, '', this.$translate.instant('client.cart.continue_checkout'), this.$translate.instant('client.cart.checkout_review'));

              case 12:
                continueCheckout = _context25.sent;

                if (continueCheckout) {
                  _context25.next = 15;
                  break;
                }

                return _context25.abrupt('return');

              case 15:
                _context25.next = 17;
                return this._messageService.showLoading();

              case 17:
                loadingDialog = _context25.sent;

              case 18:
                _context25.next = 20;
                return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.checkCartItems, {});

              case 20:
                existingShopifyCartItems = _context25.sent;
                hasMyCartItems = existingShopifyCartItems.data.items.some(function (item) {
                  return myCartItems.some(function (myCart) {
                    return item.id === myCart.id;
                  });
                });

                if (!(existingShopifyCartItems.data.item_count > 0)) {
                  _context25.next = 44;
                  break;
                }

                if (!hasMyCartItems) {
                  _context25.next = 35;
                  break;
                }

                loadingDialog.close();
                _context25.next = 27;
                return this._cartService.confirmContinueCheckoutWhenMatchCartItems();

              case 27:
                continueCheckoutWhenMatch = _context25.sent;

                if (continueCheckoutWhenMatch) {
                  _context25.next = 30;
                  break;
                }

                return _context25.abrupt('return');

              case 30:
                _context25.next = 32;
                return this._messageService.showLoading();

              case 32:
                loadingDialog = _context25.sent;
                _context25.next = 44;
                break;

              case 35:
                loadingDialog.close();
                _context25.next = 38;
                return this._cartService.confirmContinueCheckout();

              case 38:
                _continueCheckout = _context25.sent;

                if (_continueCheckout) {
                  _context25.next = 41;
                  break;
                }

                return _context25.abrupt('return');

              case 41:
                _context25.next = 43;
                return this._messageService.showLoading();

              case 43:
                loadingDialog = _context25.sent;

              case 44:
                _context25.next = 46;
                return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.checkoutCart, {
                  cartInfo: shopifyCheckoutInfo.cartInfo
                });

              case 46:
                checkoutResult = _context25.sent;


                if (!checkoutResult.success) {
                  loadingDialog.close();
                  this._messageService.showErrorPopup(checkoutResult.errorMessage);
                } else {
                  loadingDialog.close();
                }
                _context25.next = 53;
                break;

              case 50:
                _context25.prev = 50;
                _context25.t0 = _context25['catch'](3);

                this._messageService.showErrorPopupForResponse(_context25.t0);

              case 53:
                _context25.prev = 53;

                loadingDialog.close();
                return _context25.finish(53);

              case 56:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, this, [[3, 50, 53, 56]]);
      }));

      function _shopifyCheckout(_x10) {
        return _ref25.apply(this, arguments);
      }

      return _shopifyCheckout;
    }()
  }, {
    key: '_walmartCheckout',
    value: function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var loadingDialog, walmartCheckoutInfo, myCartItems, checkoutResult;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this._messageService.showLoading();

              case 2:
                loadingDialog = _context26.sent;
                _context26.next = 5;
                return this._checkoutService.getWalmartCheckoutInfo();

              case 5:
                walmartCheckoutInfo = _context26.sent;
                myCartItems = walmartCheckoutInfo.cartInfo;
                _context26.next = 9;
                return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.checkoutCart, {
                  cartItems: myCartItems
                });

              case 9:
                checkoutResult = _context26.sent;

                if (checkoutResult.success) {
                  _context26.next = 16;
                  break;
                }

                loadingDialog.close();
                _context26.next = 14;
                return this._messageService.showErrorPopup(checkoutResult.errorMessage);

              case 14:
                _context26.next = 17;
                break;

              case 16:
                loadingDialog.close();

              case 17:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function _walmartCheckout() {
        return _ref26.apply(this, arguments);
      }

      return _walmartCheckout;
    }()
  }, {
    key: '_freshopCheckout',
    value: function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        var loadingDialog, freshopCheckoutInfo, myCartItems, isItemsResp, continueCheckout, checkoutResult;
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this._messageService.showLoading();

              case 2:
                loadingDialog = _context27.sent;
                _context27.next = 5;
                return this._checkoutService.getFreshopCheckoutInfo();

              case 5:
                freshopCheckoutInfo = _context27.sent;
                myCartItems = freshopCheckoutInfo.cartInfo;
                _context27.next = 9;
                return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.checkCartItems, {});

              case 9:
                isItemsResp = _context27.sent;

                if (isItemsResp.success) {
                  _context27.next = 16;
                  break;
                }

                _context27.next = 13;
                return this._cartService.confirmContinueCheckout('Freshop');

              case 13:
                continueCheckout = _context27.sent;

                if (continueCheckout) {
                  _context27.next = 16;
                  break;
                }

                return _context27.abrupt('return');

              case 16:
                _context27.next = 18;
                return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.checkoutCart, {
                  cartItems: myCartItems,
                  storeId: this._scope.cart.retailerStoreId
                });

              case 18:
                checkoutResult = _context27.sent;

                if (checkoutResult.success) {
                  _context27.next = 25;
                  break;
                }

                loadingDialog.close();
                _context27.next = 23;
                return this._messageService.showErrorPopup(checkoutResult.errorMessage);

              case 23:
                _context27.next = 26;
                break;

              case 25:
                loadingDialog.close();

              case 26:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function _freshopCheckout() {
        return _ref27.apply(this, arguments);
      }

      return _freshopCheckout;
    }()
  }, {
    key: '_toggleCollapse',
    value: function _toggleCollapse(group) {
      this._scope.groupsCollapses[group.participant.userId] = !this._scope.groupsCollapses[group.participant.userId];
    }
  }, {
    key: '_updateQuantity',
    value: function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29($event, item, updateValue) {
        var _this6 = this;

        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (this.qtyChangeTimeout) {
                  clearTimeout(this.qtyChangeTimeout);
                } else {
                  item.savedQuantity = item.quantity;
                }

                if (!this.quantityUpdating) {
                  _context29.next = 3;
                  break;
                }

                return _context29.abrupt('return');

              case 3:

                item.quantity += updateValue;

                this.qtyChangeTimeout = setTimeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
                  return regeneratorRuntime.wrap(function _callee28$(_context28) {
                    while (1) {
                      switch (_context28.prev = _context28.next) {
                        case 0:
                          _this6.quantityUpdating = true;
                          _context28.next = 3;
                          return _this6._setQuantity(item, updateValue);

                        case 3:
                        case 'end':
                          return _context28.stop();
                      }
                    }
                  }, _callee28, _this6);
                })), 1000);

              case 5:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function _updateQuantity(_x11, _x12, _x13) {
        return _ref28.apply(this, arguments);
      }

      return _updateQuantity;
    }()
  }, {
    key: '_backToCart',
    value: function _backToCart() {
      this._state.go(_CommonConstants2.default.RoutingStates.CART);
    }
  }, {
    key: '_confirmStartCheckout',
    value: function _confirmStartCheckout() {
      this._state.go(_CommonConstants2.default.RoutingStates.START_CHECKOUT);
    }
  }, {
    key: '_copyClipboard',
    value: function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                this._cartService.copyClipboard(this._scope.invitationLink);

              case 1:
              case 'end':
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function _copyClipboard() {
        return _ref30.apply(this, arguments);
      }

      return _copyClipboard;
    }()
  }, {
    key: '_goToOrderSetting',
    value: function () {
      var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.prev = 0;

                this._scope.overlayOpened = false;
                _scope2.default.apply(this._scope);
                _context31.next = 5;
                return this._orderSetupService.editOrder('preview');

              case 5:
                _context31.next = 7;
                return this._onCartChanged();

              case 7:
                _context31.next = 12;
                break;

              case 9:
                _context31.prev = 9;
                _context31.t0 = _context31['catch'](0);

                this._messageService.showErrorPopupForResponse(_context31.t0);

              case 12:
              case 'end':
                return _context31.stop();
            }
          }
        }, _callee31, this, [[0, 9]]);
      }));

      function _goToOrderSetting() {
        return _ref31.apply(this, arguments);
      }

      return _goToOrderSetting;
    }()
  }, {
    key: '_startNewOrder',
    value: function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
        return regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return this._orderSetupService.createOrder();

              case 2:
              case 'end':
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function _startNewOrder() {
        return _ref32.apply(this, arguments);
      }

      return _startNewOrder;
    }()
  }]);

  return CartController;
}();

CartController.$inject = ['$scope', '$state', 'CartService', 'Session', 'AuthenticationService', 'Message', '$rootScope', 'CheckoutService', 'CartGroupsService', 'OrderSetupService', 'ConfigurationService', 'cartonomyConfig', '$timeout', 'LocalForageService', '$translate'];
exports.default = CartController;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InvitedPeopleListController = function () {
  function InvitedPeopleListController(scope, cartService, dialogService, messageService, sessionService, rootScope, cartonomyConfig, stateService, HeapService, orderSetupService, configurationService, groupOrderService, $translate) {
    var _this = this;

    _classCallCheck(this, InvitedPeopleListController);

    this._scope = scope;
    this._dialogService = dialogService;
    this._cartService = cartService;
    this._messageService = messageService;
    this._rootScope = rootScope;
    this._sessionService = sessionService;
    this._cartonomyConfig = cartonomyConfig;
    this._stateService = stateService;
    this._heapService = HeapService;
    this._orderSetupService = orderSetupService;
    this._configurationService = configurationService;
    this._groupOrderService = groupOrderService;
    this.$translate = $translate;

    scope.searchString = '';
    scope.contacts = [];

    scope.clearSearch = function () {
      return _this._clearSearch();
    };
    scope.inviteMorePeople = function () {
      return _this._inviteMorePeople();
    };
    scope.filterContacts = function () {
      return _this._filterContacts();
    };
    scope.isCurrentUser = function (contact) {
      return _this._isCurrentUser(contact);
    };
    scope.resendInvitation = function (contact) {
      return _this._resendInvitation(contact);
    };
    scope.removeFromCart = function (contact) {
      return _this._removeFromCart(contact);
    };

    scope.makeContactGroupOwner = function (contact) {
      return _this._makeContactGroupOwner(contact);
    };
    scope.leaveOrder = function () {
      return _this._leaveOrder();
    };
    scope.cancelOrder = function () {
      return _this._cancelOrder();
    };
    scope.isLocked = function () {
      return _this.isLocked();
    };
    scope.canRemoveUser = function (contact) {
      return _this.canRemoveUser(contact);
    };
    scope.invitationLink = this._cartService.getInviteSingleLink();
    scope.invitationType = this._cartService.getInvitationType();
    scope.invitationCode = this._cartService.getInviteCode();
    scope.copyClipboard = function () {
      return _this._copyClipboard();
    };
    scope.isStealthUserMode = this._sessionService.getStealthUserMode();
    scope.marketingMode = this._rootScope.retailer.cartonomyMode === _CommonConstants2.default.CartonomyMode.marketing;
  }

  _createClass(InvitedPeopleListController, [{
    key: '$onInit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._initInvitationCode();

              case 2:
                _context.next = 4;
                return this._fetchParticipants();

              case 4:

                this._rootScope.storeWindowTitle = 'client.members';
                this._rootScope.$on(_CommonConstants2.default.RootEvents.CART_CHANGED, function () {
                  return _this2._fetchParticipants();
                });
                this._rootScope.$on(_CommonConstants2.default.RootEvents.DELETE_CONTACT_CONFIRM_FROM_ADDMORE_PEOPLE, function (scope, contact) {
                  return _this2._onDialogDeleteContact(scope, contact);
                });
                _scope2.default.apply(this._scope);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function $onInit() {
        return _ref.apply(this, arguments);
      }

      return $onInit;
    }()
  }, {
    key: '_fetchParticipants',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var participants;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._sessionService.loggedIn();

              case 2:
                if (_context2.sent) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                _context2.next = 6;
                return this._sessionService.getUserEmail();

              case 6:
                this.currentUserEmail = _context2.sent;

                if (!this._scope.isStealthUserMode) {
                  _context2.next = 11;
                  break;
                }

                this._cartService.getCart().then(function (cart) {
                  _this3.cart = cart;
                  _this3._cartService.isOwner(cart).then(function (isOwner) {
                    _this3._scope.isOwner = isOwner;
                  });
                  var participants = cart.participants;
                  _this3._onReceivedParticipants(participants);
                });
                _context2.next = 25;
                break;

              case 11:
                this._cartService.getCart().then(function (cart) {
                  _this3.cart = cart;
                  _this3._cartService.isOwner(cart).then(function (isOwner) {
                    _this3._scope.isOwner = isOwner;
                  });
                });

                _context2.prev = 12;
                _context2.next = 15;
                return this._cartService.getParticipants();

              case 15:
                participants = _context2.sent;

                this._onReceivedParticipants(participants);
                _context2.next = 22;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](12);

                this._messageService.showErrorPopupForResponse(_context2.t0);

              case 22:
                _context2.prev = 22;

                _scope2.default.apply(this._scope);
                return _context2.finish(22);

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[12, 19, 22, 25]]);
      }));

      function _fetchParticipants() {
        return _ref2.apply(this, arguments);
      }

      return _fetchParticipants;
    }()
  }, {
    key: 'isLocked',
    value: function isLocked() {
      var isLocked = this.cart && (this.cart.cartStatus === "CHECKING_OUT" || this.cart.cartStatus === "OWNER_CHECKING_OUT");

      return isLocked;
    }
  }, {
    key: 'canRemoveUser',
    value: function canRemoveUser(contact) {
      return !contact.invitationResending && !contact.isOwner && contact.paymentStatus === 0;
    }
  }, {
    key: '_isCurrentUser',
    value: function _isCurrentUser(contact) {
      return contact.email === this.currentUserEmail;
    }
  }, {
    key: '_removeFromCart',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(contact) {
        var confirmed, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!this._scope.isOwner || contact.isOwner)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                _context3.next = 4;
                return this._messageService.showQuestionPopup(this.$translate.instant('client.cart.remove_items', { contactName: contact.name }));

              case 4:
                confirmed = _context3.sent;

                if (confirmed) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt('return');

              case 7:
                _context3.prev = 7;
                _context3.next = 10;
                return this._cartService.removeParticipant(contact.email);

              case 10:
                response = _context3.sent;


                this._heapService.track('Remove-Participant', { email: contact.email });
                _context3.next = 17;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3['catch'](7);

                this._messageService.showErrorPopupForResponse(_context3.t0);

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 14]]);
      }));

      function _removeFromCart(_x) {
        return _ref3.apply(this, arguments);
      }

      return _removeFromCart;
    }()
  }, {
    key: '_resendInvitation',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(contact) {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!contact.isOwner) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                _context4.prev = 2;

                contact.invitationResending = true;
                _context4.next = 6;
                return this._cartService.sendInvites([contact.email]);

              case 6:
                response = _context4.sent;

                if (!response.data[0]) {
                  _context4.next = 16;
                  break;
                }

                if (!(response.data[0].status === "INVITESENT" || response.data[0].status === "INVITED")) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 11;
                return this._messageService.showMessagePopup(this.$translate.instant('client.user.email_sent', { contactEmail: contact.email }));

              case 11:
                _context4.next = 16;
                break;

              case 13:
                if (!(response.data[0].status === "JOINED")) {
                  _context4.next = 16;
                  break;
                }

                _context4.next = 16;
                return this._messageService.showMessagePopup(this.$translate.instant('client.user.email_resent', { contactEmail: contact.email }));

              case 16:
                _scope2.default.apply(this._scope, function () {
                  contact.invitationResending = false;
                });

                this._heapService.track('Invite-Resend', { email: contact.email });

                _context4.next = 23;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t0 = _context4['catch'](2);

                this._messageService.showErrorPopupForResponse(_context4.t0);

              case 23:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 20]]);
      }));

      function _resendInvitation(_x2) {
        return _ref4.apply(this, arguments);
      }

      return _resendInvitation;
    }()
  }, {
    key: '_participantToContact',
    value: function _participantToContact(participant) {

      // if (participant.status === Constants.CartDetails.Participant.Status.REMOVED) {
      //     return;
      // }

      var status = 'Undefined';

      if (participant.status === _CommonConstants2.default.CartDetails.Participant.Status.INVITE_SENT || participant.status === _CommonConstants2.default.CartDetails.Participant.Status.INVITED) {
        status = this.$translate.instant('client.invited');
      } else if (participant.status === _CommonConstants2.default.CartDetails.Participant.Status.JOINED) {
        status = this.$translate.instant('client.joined');
      } else if (participant.status === _CommonConstants2.default.CartDetails.Participant.Status.DECLINED) {
        status = this.$translate.instant('client.declined');
      } else if (participant.status === _CommonConstants2.default.CartDetails.Participant.Status.OWNER) {
        status = this.$translate.instant('client.owner');;
      } else if (participant.status === _CommonConstants2.default.CartDetails.Participant.Status.LEFT) {
        status = this.$translate.instant('client.order.left');;
      } else if (participant.status === _CommonConstants2.default.CartDetails.Participant.Status.REMOVED) {
        status = this.$translate.instant('client.remove');
      }

      var contact = {
        status: status,
        name: participant.name,
        email: participant.email,
        participantId: participant.participantId,
        userId: participant.userId,
        avatar: participant.avatar,
        avatarCropped: participant.avatarCropped,
        isOwner: status == 'Owner',
        paymentStatus: participant.paymentStatus
      };

      if (contact.name === contact.email) {
        contact.name = '';
      }

      contact.firstLetter = (contact.name || contact.email).substring(0, 1);

      return contact;
    }
  }, {
    key: '_onReceivedParticipants',
    value: function _onReceivedParticipants(participants) {
      var _this4 = this;

      this._scope.contacts = participants.map(function (participant) {
        return _this4._participantToContact(participant);
      }).filter(function (contact) {
        return contact;
      });
    }
  }, {
    key: '_clearSearch',
    value: function _clearSearch() {
      this._scope.searchString = '';
    }
  }, {
    key: '_filterContacts',
    value: function _filterContacts() {

      if (!this._scope.searchString) {
        return this._scope.contacts;
      }

      var filter = this._scope.searchString.toLowerCase();

      var contacts = this._scope.contacts.filter(function (contact) {
        return (contact.name && contact.name.toLowerCase().indexOf(filter)) >= 0 || contact.email && contact.email.toLowerCase().indexOf(filter) >= 0;
      });
      return contacts;
    }
  }, {
    key: '_makeContactGroupOwner',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(contact) {
        var confirmed;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._messageService.showQuestionPopup(this.$translate.instant('client.order.make_owner', { contactName: contact.name }), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

              case 2:
                confirmed = _context5.sent;

                if (confirmed) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt('return', null);

              case 5:
                _context5.prev = 5;
                _context5.next = 8;
                return this._cartService.transferOwner(contact.participantId);

              case 8:
                _context5.next = 10;
                return this._messageService.showMessagePopup(this.$translate.instant('client.cart.ownership_transfer', { contactName: contact.name }));

              case 10:
                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5['catch'](5);

                this._messageService.showErrorPopupForResponse(_context5.t0);

              case 15:

                _scope2.default.apply(this._scope);

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 12]]);
      }));

      function _makeContactGroupOwner(_x3) {
        return _ref5.apply(this, arguments);
      }

      return _makeContactGroupOwner;
    }()
  }, {
    key: '_initInvitationCode',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var cart, _retailer;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._cartService.getCart();

              case 2:
                cart = _context6.sent;

                if (!cart) {
                  _context6.next = 11;
                  break;
                }

                if (this._scope.invitationCode) {
                  _context6.next = 9;
                  break;
                }

                _context6.next = 7;
                return this._cartService.getShareTokenByCartId(cart.id);

              case 7:
                this._scope.invitationCode = _context6.sent;

                if (this._scope.invitationCode && this._scope.invitationCode > 0) {
                  this._cartService.setInviteCode(this._scope.invitationCode);
                  this._cartService.setInvitationType(_CommonConstants2.default.InvitationTypes.share);
                  this._scope.invitationType = _CommonConstants2.default.InvitationTypes.share;
                }

              case 9:

                if (!this._scope.invitationLink) {
                  //Retailer Link
                  _retailer = this._configurationService.getRetailer().retailer;

                  if (_retailer.retailerType === 'Shopify') {
                    this._scope.invitationLink = 'https://' + _retailer.website + _CommonConstants2.default.INVITE_LINK + this._scope.invitationCode;
                  } else {
                    this._scope.invitationLink = _retailer.website + _CommonConstants2.default.INVITE_LINK + this._scope.invitationCode;
                  }

                  this._cartService.setInviteSingleLink(this._scope.invitationLink);
                }

                _scope2.default.apply(this._scope);

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _initInvitationCode() {
        return _ref6.apply(this, arguments);
      }

      return _initInvitationCode;
    }()
  }, {
    key: '_inviteMorePeople',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var emails;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:

                this._cartService.setInviteMorePeopleMode(true);
                emails = this._scope.contacts.map(function (c) {
                  return c.email;
                });
                _context7.next = 4;
                return this._orderSetupService.showInviteMorePeople(emails);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _inviteMorePeople() {
        return _ref7.apply(this, arguments);
      }

      return _inviteMorePeople;
    }()
  }, {
    key: '_cancelOrder',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var confirmed, stateToGo;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._messageService.showQuestionPopup(this.$translate.instant('client.order.group_cancel_confirm'), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

              case 2:
                confirmed = _context8.sent;

                if (confirmed) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt('return', null);

              case 5:
                _context8.prev = 5;
                _context8.next = 8;
                return this._cartService.deleteCart();

              case 8:
                _context8.next = 10;
                return this._cartService.resetCartInvitationType();

              case 10:
                this._rootScope.$broadcast(_CommonConstants2.default.Events.ORDER_CANCELLED);

                _context8.t0 = this._heapService;
                _context8.next = 14;
                return this._sessionService.getAuthToken();

              case 14:
                _context8.t1 = _context8.sent;
                _context8.t2 = {
                  user: _context8.t1
                };

                _context8.t0.track.call(_context8.t0, 'Cart-Cancel', _context8.t2);

                stateToGo = this._cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CART : _CommonConstants2.default.RoutingStates.CATALOG;

                this._stateService.go(stateToGo);
                _context8.next = 24;
                break;

              case 21:
                _context8.prev = 21;
                _context8.t3 = _context8['catch'](5);

                this._messageService.showErrorPopupForResponse(_context8.t3);

              case 24:

                _scope2.default.apply(this._scope);

              case 25:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[5, 21]]);
      }));

      function _cancelOrder() {
        return _ref8.apply(this, arguments);
      }

      return _cancelOrder;
    }()
  }, {
    key: '_leaveOrder',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var confirmed;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._messageService.showQuestionPopup(this.$translate.instant('client.cart.group_leave'), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

              case 2:
                confirmed = _context9.sent;

                if (confirmed) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt('return', null);

              case 5:
                _context9.prev = 5;
                _context9.next = 8;
                return this._cartService.leaveCart();

              case 8:
                _context9.t0 = this._heapService;
                _context9.next = 11;
                return this._sessionService.getAuthToken();

              case 11:
                _context9.t1 = _context9.sent;
                _context9.t2 = {
                  user: _context9.t1
                };

                _context9.t0.track.call(_context9.t0, 'Cart-Leave', _context9.t2);

                if (this._cartonomyConfig.externalStoreMode) {
                  this._rootScope.$broadcast(_CommonConstants2.default.Events.LEFT_ORDER);
                } else {
                  this._stateService.go(_CommonConstants2.default.RoutingStates.CATALOG);
                }
                _context9.next = 20;
                break;

              case 17:
                _context9.prev = 17;
                _context9.t3 = _context9['catch'](5);

                this._messageService.showErrorPopupForResponse(_context9.t3);

              case 20:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[5, 17]]);
      }));

      function _leaveOrder() {
        return _ref9.apply(this, arguments);
      }

      return _leaveOrder;
    }()
  }, {
    key: '_copyClipboard',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this._cartService.copyClipboard(this._scope.invitationLink);

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function _copyClipboard() {
        return _ref10.apply(this, arguments);
      }

      return _copyClipboard;
    }()
  }, {
    key: '_onDialogDeleteContact',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(scope, contact) {
        var confirmed;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this._messageService.showQuestionPopup(this.$translate.instant('client.user.remove_contact'), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

              case 2:
                confirmed = _context11.sent;

                if (!(confirmed && contact)) {
                  _context11.next = 6;
                  break;
                }

                _context11.next = 6;
                return this._groupOrderService.deleteContact(contact.contactUserId);

              case 6:

                this._scope.inviteMorePeople();

              case 7:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function _onDialogDeleteContact(_x4, _x5) {
        return _ref11.apply(this, arguments);
      }

      return _onDialogDeleteContact;
    }()
  }]);

  return InvitedPeopleListController;
}();

InvitedPeopleListController.$inject = ['$scope', 'CartService', '$mdDialog', 'Message', 'Session', '$rootScope', 'cartonomyConfig', '$state', 'HeapService', 'OrderSetupService', 'ConfigurationService', 'GroupOrder', '$translate'];
exports.default = InvitedPeopleListController;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PopupBagDirectiveController = function () {
    function PopupBagDirectiveController(scope, timeoutService, cartService, sessionService, stateService, rootScope, checkoutService, cartonomyConfig) {
        var _this = this;

        _classCallCheck(this, PopupBagDirectiveController);

        this._scope = scope;
        this._sessionService = sessionService;
        this._timeoutService = timeoutService;
        this._stateService = stateService;
        this._cartService = cartService;
        this._checkoutService = checkoutService;
        this._rootScope = rootScope;
        this._cartonomyConfig = cartonomyConfig;

        scope.show = false;
        scope.count = 0;
        scope.countHot = false;
        scope.title = '';
        scope.subTotal = 0;
        scope.items = [];
        scope.exists = false;

        scope.close = function () {
            return _this._close();
        };
        scope.viewOrder = function () {
            return _this._viewOrder();
        };
        scope.payMyTab = function () {
            return _this._payMyTab();
        };

        rootScope.$on(_CommonConstants2.default.RootEvents.PAYMENT_STATUS_CHANGED, function () {
            _this._onPaymentStatusChanged();
        });

        scope.$on(_CommonConstants2.default.BroadcastMessages.POPUP_BAG_CHANGED, function () {
            _this._updateBagState(null, true);
        });

        scope.$on(_CommonConstants2.default.BroadcastMessages.DISPLAY_POPUP_BAG, function (event, itemId) {
            scope.show = true;
            _this._updateBagState(itemId, true);
        });

        scope.$on(_CommonConstants2.default.BroadcastMessages.TOGGLE_POPUP_BAG, function () {
            scope.countHot = false;
        });

        this._updateBagState(null, false);
        this._onPaymentStatusChanged();
    }

    _createClass(PopupBagDirectiveController, [{
        key: '_close',
        value: function _close() {
            this._scope.show = false;
            this._scope.countHot = false;
            this._rootScope.bagOpened = this._scope.show;
        }
    }, {
        key: 'isCart',
        value: function isCart() {
            return this._stateService.is(_CommonConstants2.default.RoutingStates.CART);
        }
    }, {
        key: '_viewOrder',
        value: function _viewOrder() {
            if (this.isCart()) {
                this._rootScope.$broadcast(_CommonConstants2.default.BroadcastMessages.CART_PAGE_REQUESTED);
            } else {
                this._stateService.go(_CommonConstants2.default.RoutingStates.CART);
            }
            this._scope.close();
        }
    }, {
        key: '_payMyTab',
        value: function _payMyTab() {
            this._stateService.go(_CommonConstants2.default.RoutingStates.CHECKOUT);
            this._scope.close();
        }
    }, {
        key: '_getOnlyMyItems',
        value: function _getOnlyMyItems(cart) {
            var _this2 = this;

            if (!cart || !cart.items || cart.items.length === 0) {
                return [];
            }

            return this._sessionService.loggedIn().then(function (loggedIn) {
                if (!loggedIn) {
                    return cart.items || [];
                } else {
                    return _this2._sessionService.getUserEmail().then(function (participantEmail) {
                        if (!participantEmail) {
                            return cart.items || [];
                        }

                        return cart.items.filter(function (item) {
                            return item.participantEmail == participantEmail;
                        });
                    });
                }
            });
        }
    }, {
        key: '_emptyScope',
        value: function _emptyScope(cart) {
            this._scope.count = 0;
            this._scope.title = cart ? cart.title : '';
            this._scope.subTotal = 0;
            this._scope.items = [];
            this._scope.exists = false;
        }
    }, {
        key: '_loadScope',
        value: function _loadScope(cart, updateHot, previousCount, itemId) {
            var _this3 = this;

            this._scope.title = cart.title;
            this._scope.exists = true;
            this._scope.groupPay = cart.fulfillment.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.MULTIPLE;

            var highlightItem = null;
            if (this._scope.items) {
                highlightItem = this._scope.items.find(function (item) {
                    return item.highlight;
                });
            }

            var itemsForCounting = this._cartonomyConfig.externalStoreMode ? cart.items : this._getOnlyMyItems(cart);

            this._scope.items = _.map(itemsForCounting, function (item) {
                return {
                    id: item.id,
                    name: item.itemName,
                    quantity: item.quantity,
                    price: item.price,
                    comment: item.comment,
                    catalogProductId: item.catalogProductId,
                    highlight: false
                };
            });

            if (highlightItem) {
                highlightItem = this._scope.items.find(function (item) {
                    return item.id === highlightItem.id;
                });
                if (highlightItem) {
                    highlightItem.highlight = true;
                }
            }

            this._scope.count = _.sumBy(this._scope.items, function (item) {
                return item.quantity;
            });
            this._scope.subTotal = _.sumBy(this._scope.items, function (item) {
                return item.quantity * item.price;
            });

            if (updateHot && !this.isCart()) {
                this._scope.countHot = previousCount !== this._scope.count;
            }

            if (itemId) {
                var item = _.find(this._scope.items, { id: itemId });
                if (item) {
                    item.highlight = true;
                    this._timeoutService(function () {
                        item = _.find(_this3._scope.items, { id: itemId });
                        if (item) {
                            item.highlight = false;
                        }
                    }, 3000);
                }
            }

            // forcing update because it mystically doesn't trigger often for this update
            _scope2.default.apply(this._scope);
        }
    }, {
        key: '_updateBagState',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(itemId, updateHot) {
                var previousCount, cart;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                previousCount = this._scope.count;
                                _context.next = 3;
                                return this._cartService.getCart();

                            case 3:
                                cart = _context.sent;


                                if (!cart.items || !cart.items.length) {
                                    this._emptyScope(cart);
                                } else {
                                    this._loadScope(cart, updateHot, previousCount, itemId);
                                }
                                _scope2.default.apply(this._scope);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _updateBagState(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return _updateBagState;
        }()
    }, {
        key: '_onPaymentStatusChanged',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this._checkoutService.paymentAuthorizedOrCaptured();

                            case 2:
                                this._scope.paymentProvided = _context2.sent;

                                _scope2.default.apply(this._scope);

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _onPaymentStatusChanged() {
                return _ref2.apply(this, arguments);
            }

            return _onPaymentStatusChanged;
        }()
    }]);

    return PopupBagDirectiveController;
}();

PopupBagDirectiveController.$inject = ['$scope', '$timeout', 'CartService', 'Session', '$state', '$rootScope', 'CheckoutService', 'cartonomyConfig'];
exports.default = PopupBagDirectiveController;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderDetailsDirective = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(68);

var _module3 = _interopRequireDefault(_module2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _communicationService = __webpack_require__(28);

var _commandKeys = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderDetailsDirective = exports.OrderDetailsDirective = function () {
    function OrderDetailsDirective(scope, cartService, stateService, orderSetupService, messageService, rootScope, configurationService, cartonomyConfig, $interval, $translate) {
        var _this = this;

        _classCallCheck(this, OrderDetailsDirective);

        this.intervals = {
            year: {
                singular: 'client.year',
                plural: 'client.years'
            },
            month: {
                singular: 'client.month',
                plural: 'client.months'
            },
            week: {
                singular: 'client.week',
                plural: 'client.weeks'
            },
            day: {
                singular: 'client.day',
                plural: 'client.days'
            },
            hour: {
                singular: 'client.hour',
                plural: 'client.hours'
            },
            minute: {
                singular: 'client.minute',
                plural: 'client.minutes'
            }
        };


        this._scope = scope;
        this._orderSetupService = orderSetupService;
        this._cartService = cartService;
        this._stateService = stateService;
        this._messageService = messageService;
        this._savedCart = {};
        this._scope.sections = [];
        this._rootScope = rootScope;
        this._configurationService = configurationService;
        this._scope.configuration = {
            readOnly: true,
            doNotAutoProcess: false,
            notificationsForParticipants: false,
            singlePay: false
        };
        this._cartonomyConfig = cartonomyConfig;
        this.$interval = $interval;
        this.$translate = $translate;

        this._scope.editSection = function (id) {
            return _this._editSection(id);
        };
        this._scope.updateCartName = function () {
            return _this._updateCartName();
        };
        this._scope.cancelCartNameChange = function () {
            return _this._cancelCartNameChange();
        };
        this._scope.saveCartName = function () {
            return _this._saveCartName();
        };
        this._scope.showUpdateCartName = false;
        this._scope.cartModel = {
            customCartNames: '0',
            cartNameValue: '',
            cartNameOldValue: ''
        };
        this._scope.$on(_CommonConstants2.default.RootEvents.INVITATION_ACCEPTED, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this._initialize();

                        case 2:
                            return _context.abrupt('return', _context.sent);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        })));
    }

    _createClass(OrderDetailsDirective, [{
        key: '$onInit',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this._initialize();

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function $onInit() {
                return _ref2.apply(this, arguments);
            }

            return $onInit;
        }()
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            if (angular.isDefined(this.deadlineInterval)) {
                this.$interval.cancel(this.deadlineInterval);
                stop = undefined;
            }
        }
    }, {
        key: '_initialize',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var _this2 = this;

                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this._reloadConfiguration();

                            case 2:
                                _context3.next = 4;
                                return this._loadCustomCartName();

                            case 4:

                                this._scope.$watch('configuration.doNotAutoProcess', function (newValue, oldValue) {
                                    if (newValue !== oldValue) {
                                        _this2._onDoNotAutoProcessChanged();
                                    }
                                });

                                this._scope.$watch('configuration.notificationsForParticipants', function (newValue, oldValue) {
                                    if (newValue != oldValue) {
                                        _this2._onNotificationsForParticipantsChanged();
                                    }
                                });

                                this._rootScope.$on(_CommonConstants2.default.RootEvents.CART_CHANGED, function () {
                                    _this2._scope.configuration.readOnly = true;
                                    _this2._reloadConfiguration();

                                    _scope2.default.apply(_this2._scope);
                                });

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function _initialize() {
                return _ref3.apply(this, arguments);
            }

            return _initialize;
        }()
    }, {
        key: '_setupTab',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(tabId) {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:

                                this._scope.configuration.readOnly = true;

                                _context4.prev = 1;
                                _context4.next = 4;
                                return this._orderSetupService.editOrder(tabId);

                            case 4:
                                _context4.next = 6;
                                return this._reloadConfiguration();

                            case 6:
                                this._scope.configuration.readOnly = false;
                                _context4.next = 13;
                                break;

                            case 9:
                                _context4.prev = 9;
                                _context4.t0 = _context4['catch'](1);

                                this._scope.configuration.readOnly = false;
                                this._messageService.showErrorPopupForResponse(_context4.t0);

                            case 13:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[1, 9]]);
            }));

            function _setupTab(_x) {
                return _ref4.apply(this, arguments);
            }

            return _setupTab;
        }()
    }, {
        key: '_editSection',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!this._scope.configuration.readOnly) {
                                    _context5.next = 2;
                                    break;
                                }

                                return _context5.abrupt('return', null);

                            case 2:
                                _context5.t0 = id;
                                _context5.next = _context5.t0 === 'payment-info' ? 5 : _context5.t0 === 'budget' ? 8 : _context5.t0 === 'delivery' ? 11 : _context5.t0 === 'deadline' ? 14 : 17;
                                break;

                            case 5:
                                _context5.next = 7;
                                return this._setupTab(_CommonConstants2.default.OrderSetupTabs.PAYMENT_DETAILS);

                            case 7:
                                return _context5.abrupt('break', 17);

                            case 8:
                                _context5.next = 10;
                                return this._setupTab(_CommonConstants2.default.OrderSetupTabs.BUDGET);

                            case 10:
                                return _context5.abrupt('break', 17);

                            case 11:
                                _context5.next = 13;
                                return this._setupTab(_CommonConstants2.default.OrderSetupTabs.DELIVERY_ADDRESS);

                            case 13:
                                return _context5.abrupt('break', 17);

                            case 14:
                                _context5.next = 16;
                                return this._setupTab(_CommonConstants2.default.OrderSetupTabs.DEADLINE);

                            case 16:
                                return _context5.abrupt('break', 17);

                            case 17:

                                _scope2.default.apply(this._scope);

                            case 18:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function _editSection(_x2) {
                return _ref5.apply(this, arguments);
            }

            return _editSection;
        }()
    }, {
        key: '_onDoNotAutoProcessChanged',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!this._scope.configuration.readOnly) {
                                    _context6.next = 3;
                                    break;
                                }

                                this._scope.configuration.doNotAutoProcess = this._savedCart.automaticProcess;
                                return _context6.abrupt('return');

                            case 3:

                                this._scope.configuration.readOnly = true;

                                this._savedCart.automaticProcess = !this._scope.configuration.doNotAutoProcess;

                                _context6.prev = 5;
                                _context6.next = 8;
                                return this._cartService.setCartConfiguration(this._savedCart);

                            case 8:
                                _context6.next = 13;
                                break;

                            case 10:
                                _context6.prev = 10;
                                _context6.t0 = _context6['catch'](5);

                                this._messageService.showErrorPopupForResponse(_context6.t0);

                            case 13:

                                this._scope.configuration.readOnly = false;

                            case 14:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this, [[5, 10]]);
            }));

            function _onDoNotAutoProcessChanged() {
                return _ref6.apply(this, arguments);
            }

            return _onDoNotAutoProcessChanged;
        }()
    }, {
        key: '_onNotificationsForParticipantsChanged',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (!this._scope.configuration.readOnly) {
                                    _context7.next = 3;
                                    break;
                                }

                                this._scope.configuration.notificationsForParticipants = this._savedCart.sendCloseNotification;
                                return _context7.abrupt('return');

                            case 3:

                                this._scope.configuration.readOnly = true;

                                this._savedCart.sendCloseNotification = this._scope.configuration.notificationsForParticipants;

                                _context7.prev = 5;
                                _context7.next = 8;
                                return this._cartService.setCartConfiguration(this._savedCart);

                            case 8:
                                _context7.next = 13;
                                break;

                            case 10:
                                _context7.prev = 10;
                                _context7.t0 = _context7['catch'](5);

                                this._messageService.showErrorPopupForResponse(_context7.t0);

                            case 13:

                                this._scope.configuration.readOnly = false;

                            case 14:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this, [[5, 10]]);
            }));

            function _onNotificationsForParticipantsChanged() {
                return _ref7.apply(this, arguments);
            }

            return _onNotificationsForParticipantsChanged;
        }()
    }, {
        key: '_getOrderDeadlineSection',
        value: function _getOrderDeadlineSection(cart) {
            var _this3 = this;

            this.retailer = this._configurationService.getRetailer().retailer;

            this.retailerTimezone = this.retailer.timeZoneSettingName;

            var dealine = {
                id: 'deadline',
                title: cart.closeOn ? '' : this.$translate.instant('client.deadline'),
                highlighted: cart.closeOn,
                lines: [this._getDeadlineString(cart)],
                line: cart.closeOn ? _moment2.default.tz(cart.closeOn, this.retailerTimezone).format('Do MMM') : this.$translate.instant('client.none'),
                editable: cart.cartStatus !== "OWNER_CHECKING_OUT" && cart.cartStatus !== "CHECKING_OUT"
            };

            this.deadlineInterval = this.$interval(function () {
                dealine.lines[0] = _this3._getDeadlineString(cart);
            }, 1000);

            return dealine;
        }
    }, {
        key: '_getDeadlineString',
        value: function _getDeadlineString(cart) {
            var _this4 = this;

            if (!cart.closeOn) {
                return this.$translate.instant('client.none');
            }

            var localTimeDeadline = _moment2.default.tz(cart.closeOn, this.retailerTimezone);
            if ((0, _moment2.default)(localTimeDeadline).isBefore((0, _moment2.default)())) {
                return this.$translate.instant('client.order.closed');
            }

            var result = null;
            Object.keys(this.intervals).forEach(function (key) {
                if (result) {
                    return;
                }
                var count = localTimeDeadline.diff((0, _moment2.default)(), key);
                if (count > 0) {
                    if (count === 1) {
                        var duration = _this4.$translate.instant(_this4.intervals[key].singular);
                        result = _this4.$translate.instant('client.order.end_in', { count: count, duration: duration });
                    } else {
                        var _duration = _this4.$translate.instant(_this4.intervals[key].plural);
                        result = _this4.$translate.instant('client.order.end_in', { count: count, duration: _duration });
                    }
                }
            });

            if (result) {
                return result;
            } else {
                return this.$translate.instant('client.order.time_end_min');
            }
        }
    }, {
        key: '_getDeliverySection',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(cartDetails) {
                var pickupAddress, ret, _ret;

                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.t0 = cartDetails.deliveryMethod;
                                _context8.next = _context8.t0 === _CommonConstants2.default.CartDetails.DeliveryMethods.PICKUP ? 3 : _context8.t0 === _CommonConstants2.default.CartDetails.DeliveryMethods.DELIVERY ? 11 : _context8.t0 === _CommonConstants2.default.CartDetails.DeliveryMethods.SHIPPING ? 17 : 18;
                                break;

                            case 3:
                                if (!(this._scope.retailer.retailerType === _CommonConstants2.default.SHOPIFY_RETAILER_TYPE || this._scope.retailer.retailerType === _CommonConstants2.default.AMAZON_RETAILER_TYPE || this._scope.retailer.retailerType.toLowerCase() === 'poc')) {
                                    _context8.next = 5;
                                    break;
                                }

                                return _context8.abrupt('return');

                            case 5:
                                _context8.next = 7;
                                return this._configurationService.getItem('pickupAddress');

                            case 7:
                                pickupAddress = _context8.sent;
                                ret = {
                                    id: 'delivery',
                                    title: this.$translate.instant('client.order.pick_up_info'),
                                    lines: [pickupAddress],
                                    editable: true
                                };

                                if (cartDetails.deliveryDate) {
                                    ret.lines.push(' on ' + _moment2.default.utc(cartDetails.deliveryDate).local().format('dddd[,] MMMM Do [at] LT'));
                                }
                                return _context8.abrupt('return', ret);

                            case 11:
                                if (!(this._scope.retailer.retailerType === _CommonConstants2.default.SHOPIFY_RETAILER_TYPE || this._scope.retailer.retailerType.toLowerCase() === 'poc')) {
                                    _context8.next = 13;
                                    break;
                                }

                                return _context8.abrupt('return');

                            case 13:
                                _ret = {
                                    id: 'delivery',
                                    title: this.$translate.instant('client.order.delivery_info'),
                                    lines: [cartDetails.deliveryAddress.street + ' ' + (', ' + cartDetails.deliveryAddress.aptSuite || ''), cartDetails.deliveryAddress.city + ', ' + cartDetails.deliveryAddress.state + ' ' + cartDetails.deliveryAddress.zip],
                                    editable: true
                                };


                                if (cartDetails.deliveryDate) {
                                    _ret.lines.push(' on ' + _moment2.default.utc(cartDetails.deliveryDate).local().format('dddd[,] MMMM Do [at] LT'));
                                }

                                if (cartDetails.deliveryPhone) {
                                    _ret.lines.push(this.$translate.instant('client.order.contact_phone') + ': (' + cartDetails.deliveryPhone.substring(0, 3) + ') ' + cartDetails.deliveryPhone.substring(3, 6) + '-' + cartDetails.deliveryPhone.substring(6, 10) + ' ' + cartDetails.deliveryPhone.substring(10, 20));
                                }

                                return _context8.abrupt('return', _ret);

                            case 17:
                                return _context8.abrupt('return', {});

                            case 18:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function _getDeliverySection(_x3) {
                return _ref8.apply(this, arguments);
            }

            return _getDeliverySection;
        }()
    }, {
        key: '_getBudgetSection',
        value: function _getBudgetSection(cart) {
            return {
                id: 'budget',
                title: this.$translate.instant('client.budget'),
                lines: [cart.orderLimit > 0 ? this._rootScope.formatAmount(cart.orderLimit) : this.$translate.instant('client.unlimited')],
                line: cart.orderLimit > 0 ? this._rootScope.formatAmount(cart.orderLimit) : this.$translate.instant('client.unlimited'),
                editable: cart.cartStatus !== "OWNER_CHECKING_OUT" && cart.cartStatus !== "CHECKING_OUT"
            };
        }
    }, {
        key: '_reloadConfiguration',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var _this5 = this;

                var cart, cartDetails, sections;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this._cartService.getCart();

                            case 2:
                                cart = _context9.sent;

                                this._savedCart = cart;
                                _context9.next = 6;
                                return this._cartService.getCartDetails();

                            case 6:
                                cartDetails = _context9.sent;


                                this._scope.configuration.singlePay = cartDetails.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.SINGLE;
                                this._scope.configuration.notificationsForParticipants = cart.sendCloseNotification;
                                this._scope.configuration.doNotAutoProcess = !cart.automaticProcess;

                                sections = [];


                                if (!this._cartonomyConfig.externalStoreMode) {
                                    sections.push(OrderDetailsDirective._getPaymentMethodSection(cartDetails));
                                }

                                sections.push(this._getOrderDeadlineSection(cart));

                                if (this._rootScope.retailer && !(_CommonConstants2.default.GENERAL_MILLS_POC.some(function (poc) {
                                    return _this5._rootScope.retailer.website.indexOf(poc) > -1;
                                }) || this._rootScope.retailer.noBudgetMode)) {
                                    sections.push(this._getBudgetSection(cart));
                                }

                                this._scope.sections = sections.filter(function (section) {
                                    return section && section && section.lines && section.lines.length;
                                });
                                this._scope.configuration.readOnly = false;

                                _scope2.default.apply(this._scope);

                            case 17:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function _reloadConfiguration() {
                return _ref9.apply(this, arguments);
            }

            return _reloadConfiguration;
        }()
    }, {
        key: '_loadCustomCartName',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                this._scope.cartModel.cartNameValue = this._savedCart.cartName;
                                this._scope.cartModel.cartNameOldValue = this._savedCart.cartName;
                                this._scope.cartModel.customCartNames = this._rootScope.retailer.customCartNames;

                            case 3:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function _loadCustomCartName() {
                return _ref10.apply(this, arguments);
            }

            return _loadCustomCartName;
        }()
    }, {
        key: '_updateCartName',
        value: function _updateCartName() {
            this._scope.showUpdateCartName = true;
        }
    }, {
        key: '_cancelCartNameChange',
        value: function _cancelCartNameChange() {
            this._scope.showUpdateCartName = false;
            this._scope.cartModel.cartNameValue = this._scope.cartModel.cartNameOldValue;
        }
    }, {
        key: '_saveCartName',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                if (!(this._scope.cartModel.cartNameValue && this._scope.cartModel.cartNameValue !== this._scope.cartModel.cartNameOldValue)) {
                                    _context11.next = 7;
                                    break;
                                }

                                _context11.next = 3;
                                return this._cartService.updateCartName(this._scope.cartModel.cartNameValue);

                            case 3:

                                // update realtime cart name for button
                                _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.updateMyCartButtonText, { cartNameValue: this._scope.cartModel.cartNameValue });
                                this._scope.cartModel.cartNameOldValue = this._scope.cartModel.cartNameValue;
                                _context11.next = 8;
                                break;

                            case 7:
                                this._scope.cartModel.cartNameValue = this._scope.cartModel.cartNameOldValue;

                            case 8:
                                this._scope.showUpdateCartName = false;

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function _saveCartName() {
                return _ref11.apply(this, arguments);
            }

            return _saveCartName;
        }()
    }], [{
        key: '_getPaymentMethodSection',
        value: function _getPaymentMethodSection(cartDetails) {
            return {
                id: 'payment-mode',
                title: 'Payment',
                lines: [cartDetails.paymentMethod === _CommonConstants2.default.CartDetails.PaymentMethods.SINGLE ? this.$translate.instant('client.order.single_payment') : this.$translate.instant('client.order.everyone_for')],
                editable: false
            };
        }
    }, {
        key: '_getPaymentInfoSection',
        value: function _getPaymentInfoSection() {
            return {
                id: 'payment-info',
                title: this.$translate.instant('client.order.payment_info'),
                lines: [],
                editable: false
            };
        }
    }]);

    return OrderDetailsDirective;
}();

OrderDetailsDirective.$inject = ['$scope', 'CartService', '$state', 'OrderSetupService', 'Message', '$rootScope', 'ConfigurationService', 'cartonomyConfig', '$interval', '$translate'];


_module3.default.controller('OrderDetailsDirectiveController', OrderDetailsDirective);

_module3.default.directive('orderDetails', [function () {
    return {
        template: __webpack_require__(781),
        controller: 'OrderDetailsDirectiveController',
        scope: true
    };
}]);

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports = "<div class=\"order-details flex-column\"><div class=\"section\" ng-repeat=\"section in sections\" ng-class=\"{'highlighted' : section.highlighted}\"><div class=\"section-line\" ng-repeat=\"line in section.lines\"><span class=\"editable\" ng-if=\"$index == 0 &amp;&amp; section.title\">{{ section.title }}: {{ line }}</span><span ng-if=\"$index != 0 || !section.title\">{{ line }}</span></div></div></div><!--div(layout=\"column\")--><!--    div.section(ng-repeat=\"section in sections\")--><!--        .div(ng-repeat=\"line in section.lines\")--><!--            span(ng-if=\"$index == 0\")--><!--                | {{ section.title }}: {{ line }}--><!--                md-button.md-icon-button.md-mini(ng-if=\"isOwner && section.editable && !isStealthUserMode\"--><!--                id=\"btnEdit_{{ section.id }}\"--><!--                ng-click=\"editSection(section.id)\"--><!--                aria-label=\"Edit\"--><!--                ng-disabled=\"configuration.readOnly\")--><!--                    md-icon edit--><!--            span(ng-if=\"$index != 0\") {{ line }}--><!----><!--        div(ng-if=\"section.id === 'payment-info'\" layout=\"column\")--><!--            div(layout=\"row\")--><!--                .details(flex=\"noshrink\") Auto Process Upon Deadline--><!--                md-button.md-primary.md-raised(ng-click=\"editSection(section.id)\"--><!--                ng-if=\"isOwner && !isStealthUserMode\"--><!--                ng-disabled=\"configuration.doNotAutoProcess || configuration.readOnly\"--><!--                aria-label=\"Enter Payment\")--><!--                    | Enter Payment--><!--            md-checkbox(ng-model=\"configuration.doNotAutoProcess\" ng-disabled=\"configuration.readOnly\") Do not auto process. I'll finalize and pay when I'm ready to order.--><!--    div.section.change-cartname(ng-if=\"isOwner && !isStealthUserMode\")--><!--        div(ng-if=\"cartModel.customCartNames === '1' && !showUpdateCartName\") Cart Name: {{cartModel.cartNameValue}}--><!--            md-button.md-icon-button.md-mini(aria-label=\"Edit\" ng-if=\"isOwner\" ng-click=\"updateCartName()\")--><!--                md-icon edit--><!--        .custom-cartname(ng-if=\"cartModel.customCartNames === '1' && showUpdateCartName\")--><!--            .title Name your cart:--><!--            .txt-value--><!--                input(ng-model=\"cartModel.cartNameValue\" type=\"text\" placeholder=\"Your name cart\" )--><!--            .lbl-error(ng-if=\"!cartModel.cartNameValue\") Please enter your name of cart--><!--            .buttons--><!--                md-button.md-primary.md-raised(ng-click=\"saveCartName()\") Save--><!--                md-button.md-primary.md-raised(ng-click=\"cancelCartNameChange()\") Cancel-->"

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CartGroupsService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(68);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartGroupsService = exports.CartGroupsService = function () {
    function CartGroupsService(sessionService, configurationService) {
        _classCallCheck(this, CartGroupsService);

        this._sessionService = sessionService;
        this._configurationService = configurationService;
    }

    _createClass(CartGroupsService, [{
        key: 'groupItems',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(items, participants) {
                var email, loggedIn, owner, isCartOwner, retailer;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._sessionService.getUserEmail();

                            case 2:
                                email = _context.sent;
                                _context.next = 5;
                                return this._sessionService.loggedIn();

                            case 5:
                                loggedIn = _context.sent;
                                owner = participants.find(function (p) {
                                    return p.status === 'OWNER';
                                });
                                isCartOwner = false;

                                if (owner) {
                                    isCartOwner = email === owner.email;
                                }

                                _context.next = 11;
                                return this._configurationService.getItem('retailer');

                            case 11:
                                retailer = _context.sent;
                                return _context.abrupt('return', _.chain(items).groupBy(function (item) {
                                    return item.participantEmail;
                                }).values().map(function (items) {
                                    var participantEmail = items[0].participant ? items[0].participant.participantEmail : items[0].participantEmail;
                                    var myTab = !loggedIn || items.length > 0 && participantEmail && participantEmail === email;
                                    var participant = !loggedIn || participants.find(function (p) {
                                        return p.email === participantEmail;
                                    });
                                    var participantName = participant ? loggedIn ? participant.name || participant.email || participant.participantEmail || "?" : 'Me' : participantEmail;
                                    return {
                                        participant: participant,
                                        iconLetter: participantName[0],
                                        participantName: participantName,
                                        items: items,
                                        subtotal: _.sumBy(items, function (item) {
                                            return item.price * item.quantity;
                                        }),
                                        paid: participant.paymentStatus !== 0,
                                        editable: myTab || isCartOwner && retailer.cartonomyMode !== _CommonConstants2.default.CartonomyMode.marketing,
                                        myTab: myTab,
                                        collapsed: true
                                    };
                                }).sortBy(function (g) {
                                    return (g.myTab ? 'a' : 'b') + ':' + g.participantName;
                                }).value());

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function groupItems(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return groupItems;
        }()
    }]);

    return CartGroupsService;
}();

CartGroupsService.$inject = ['Session', 'ConfigurationService'];


_module3.default.service('CartGroupsService', CartGroupsService);

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(68);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

_module3.default.directive('cartonomyCart', ['CartService', 'ConfigurationService', 'Session', '$translate', function (cartService, ConfigurationService, sessionService, $translate) {
    var _this = this;

    function toPossessiveString(name) {
        if (name[name.length - 1] == 's') {
            return name + '\'';
        }

        return name + '\'s';
    }

    return {
        template: __webpack_require__(784),
        link: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(scope, element, attributes) {
                var orderExists, cart, cartOwner;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                scope.isMobile = function () {
                                    return (/ios|iphone|android/gi.test(navigator.userAgent)
                                    );
                                };

                                _context.next = 3;
                                return cartService.isGroupOrder();

                            case 3:
                                orderExists = _context.sent;
                                _context.next = 6;
                                return cartService.getCart();

                            case 6:
                                cart = _context.sent;


                                if (orderExists) {
                                    cartOwner = _.find(cart.participants, function (participant) {
                                        return participant.status === 'OWNER' || sessionService.getStealthUserMode() && participant.status === 'REMOVED';
                                    });

                                    scope.groupCartButtonText = $translate.instant('client.add_to') + ' ' + toPossessiveString(cartOwner && cartOwner.name) + ' ' + $translate.instant('client.header.group_cart');
                                } else {
                                    scope.groupCartButtonText = $translate.instant('client.cart.group_add');
                                }

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function link(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            };
        }()
    };
}]);

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cart-content flex-column\"><invite-link></invite-link><!--div(layout=\"row\" layout-align=\"center center\" ng-show=\"_itemsCount\")--><!--    .your-tab(layout=\"column\" layout-gt-xs-margin text-center)--><!--        .pay(layout=\"row\" layout-align=\"center center\" ng-if=\"!isGeneralMillsPOC\")--><!--        .paid-content.m-t-10(ng-if=\"paymentAuthorized\") Thank you for paying your share of this order.--><!--        .total(ng-show=\"isOwner && !singlePayGroupOrder && isGroupOrder && !!paymentStatusMessage\")--><!--            span {{ paymentStatusMessage }}--><div class=\"order flex-column h-100 header-visible\" ng-show=\"!loading\"><div class=\"order-header flex-row\"><span class=\"cart-name\">{{cart.cartName || ( 'client.cart.group' | translate ) }}</span><a class=\"icon-btn circle-btn\" ng-click=\"overlayOpened = !overlayOpened\" ng-class=\"{'active': overlayOpened}\" ng-show=\"!isStealthUserMode\"><svg width=\"35\" height=\"35\" viewBox=\"0 0 35 35\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<circle class=\"main-circle\" cx=\"17.5\" cy=\"17.5\" r=\"17.5\" fill=\"#F9F9F9\"/>\n<circle class=\"dot-circle\" cx=\"8\" cy=\"18\" r=\"2\" fill=\"#54636C\"/>\n<circle class=\"dot-circle\" cx=\"17.6\" cy=\"18\" r=\"2\" fill=\"#54636C\"/>\n<circle class=\"dot-circle\" cx=\"26.4\" cy=\"18\" r=\"2\" fill=\"#54636C\"/>\n</svg>\n</a><div class=\"custom-popup\" ng-show=\"overlayOpened\"><div class=\"overlay\" ng-click=\"overlayOpened = false\"></div><a class=\"popup-btn\" ng-if=\"isOwner\" ng-click=\"goToOrderSettings()\">{{'client.cart.order_setting' | translate}}</a><a class=\"popup-btn\" ng-if=\"isOwner &amp;&amp; !isStealthUserMode &amp;&amp; items &amp;&amp; items.length &gt; 0 &amp;&amp; showClearButtonCart()\" ng-click=\"overlayOpened = false; clearCart()\" ng-disabled=\"configuration.readOnly\">{{'client.cart.clear' | translate}}</a><a class=\"popup-btn\" ng-if=\"isOwner &amp;&amp; canCancelOrder() &amp;&amp; !isStealthUserMode\" ng-click=\"overlayOpened = false; cancelOrder()\" ng-disabled=\"configuration.readOnly\">{{'client.cart.cancel' | translate}}</a><a class=\"popup-btn\" ng-if=\"!isOwner &amp;&amp; !paymentAuthorized &amp;&amp; !isStealthUserMode\" ng-click=\"overlayOpened = false;leaveOrder()\" aria-label=\"Leave this Order\">{{'client.cart.order_leave' | translate}}</a></div></div><div class=\"flex-row center-items h-100\" ng-if=\"!groups.length &amp;&amp; !myTab\"><div class=\"first-screen flex-column center-items\"><span class=\"cart-emty-title\">{{'client.cart.empty' | translate}}</span><div class=\"instruction\">{{'client.cart.empty_info' | translate}}</div><div class=\"instruction-button add-to-cart\">{{'client.cart.add' | translate}}</div><div class=\"instruction-button-container with-indicator\"><div class=\"instruction-button add-to-group-cart\"><span>{{ cartOwnerBtn }}</span></div></div></div></div><cartonomy-cart-groups></cartonomy-cart-groups></div><div class=\"extra-order-info flex-column\" ng-if=\"!loading &amp;&amp; isGroupOrder &amp;&amp; groups.length \"><div class=\"flex-row center-items\"><div class=\"order-detail-container\"><order-details class=\"flex-row center-items\"></order-details></div><div class=\"order-total flex-column\"><div class=\"total-group flex-row\" ng-if=\"myTab.subtotal\"><span class=\"total-label\">{{'client.cart.total' | translate}}</span><span class=\"total-value\">{{formatAmount(myTab.subtotal)}}</span></div><div class=\"total-group flex-row\" ng-if=\"groupSpending &amp;&amp; !marketingMode\"><span class=\"total-label\">{{'client.cart.group_total' | translate}}</span><span class=\"total-value\">{{formatAmount(groupSpending)}}</span></div><div class=\"total-group flex-row\" ng-if=\"myTapDiscounted &amp;&amp; marketingMode\"><span class=\"total-label\">{{'client.cart.total_after' | translate}}</span><span class=\"total-value\">{{formatAmount(myTapDiscounted)}}</span></div></div></div><div class=\"order-actions flex-column\"><button class=\"btn-lg primary\" ng-if=\"showPayButton() &amp;&amp; !paymentAuthorized\" ng-click=\"startCheckoutProcess()\" aria-label=\"Pay My Tab\">{{ !singlePayGroupOrder && !externalStoreMode ? ('client.cart.pay' | translate) : ('client.cart.checkout' | translate)}}</button><button class=\"btn-lg primary\" ng-if=\"shouldShowStartIndividualPaymentButton() &amp;&amp; isOwner &amp;&amp; !isStealthUserMode\" ng-click=\"confirmStartCheckout()\" aria-label=\"Separate Payment\" ng-disabled=\"configuration.readOnly\">{{'client.cart.checkout_start' | translate}}</button></div></div></div>"

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(68);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('cartonomyCartGroups', ['$rootScope', function ($rootScope) {
    return {
        template: __webpack_require__(786),
        link: function link(scope, element, attribute) {

            scope.overlayOpened = false;

            scope.openItem = function (item) {
                if (item.externalProductId) {
                    $rootScope.$broadcast(_CommonConstants2.default.Events.EXTERNAL_PRODUCT_DETAIL_REQUESTED, item.productUrl);
                }
            };

            scope.isParticipantOwner = function (participant) {
                return participant.status === _CommonConstants2.default.CartDetails.Participant.Status.OWNER;
            };

            scope.isGneralMillsPOC = function (item) {
                // Hide price, checkout button, budget for: Pillsbury, Bettycrocker, Tablespoon// retailerShop
                // CW-2661- hide :checkout, budget
                return _CommonConstants2.default.GENERAL_MILLS_POC.some(function (poc) {
                    return item.productUrl && item.productUrl.indexOf(poc) > -1;
                }) && item.price == 0;
            };

            scope.canPayForParticipant = function (group) {
                return scope.isOwner && scope.cart.cartStatus === 'CHECKING_OUT' && group.participant.paymentStatus === 0 && !group.myTab;
            };

            scope.getItemOptions = function (item) {
                if (!item.itemOption) return '';

                item.itemOption = item.itemOption.replace(/=/g, ': ');
                var options = item.itemOption.split('||').filter(function (_) {
                    return _[0] !== '_';
                });
                return options;
            };

            scope.canShowGroupOwner = function () {
                return scope.cart.cartStatus === 'CHECKING_OUT' || scope.cart.cartStatus === 'OWNER_CHECKING_OUT';
            };
            scope.canShowPaidStatus = function () {
                return scope.cart.cartStatus === 'CHECKING_OUT' || scope.cart.cartStatus === 'OWNER_CHECKING_OUT';
            };
        }
    };
}]);

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cart-group flex-column\" ng-repeat=\"group in groups\"><div class=\"cart-group-header flex-row center-items\" ng-class=\"{collapsed : !groupsCollapses[group.participant.userId]}\"><div class=\"left-block center-items\"><button class=\"icon-btn toggle-btn\" ng-click=\"toggleCollapse(group)\"><div ng-if=\"!groupsCollapses[group.participant.userId]\"><svg width=\"8\" height=\"4\" viewBox=\"0 0 8 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0L4 4L8 0L0 0Z\" fill=\"#54636C\"/>\n</svg>\n</div><div ng-if=\"groupsCollapses[group.participant.userId]\"><svg width=\"8\" height=\"4\" viewBox=\"0 0 8 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 4L4 -3.49691e-07L-9.53674e-07 4L8 4Z\" fill=\"#54636C\"/>\n</svg>\n</div></button><div class=\"icon participant-avatar\" ng-if=\"!group.participant.avatarCropped\">{{group.iconLetter}}</div><img class=\"participant-avatar\" ng-if=\"group.participant.avatarCropped\" ng-src=\"{{ group.participant.avatarCropped }}\"/><div class=\"name-div\">{{group.participant.name}}</div><button class=\"paid-tag paid pay-for-participant\" ng-if=\"canPayForParticipant(group)\" ng-click=\"startCheckoutProcess(group.participant.userId)\">{{'client.pay' | translate}}</button></div><div class=\"right-block center-items\"><div class=\"paid-tag owner\" ng-if=\"canShowGroupOwner() &amp;&amp; isParticipantOwner(group.participant)\">{{'client.cart.group_owner' | translate}}</div><div class=\"paid-tag paid\" ng-if=\"group.participant.paymentStatus == 1 &amp;&amp; !isParticipantOwner(group.participant) &amp;&amp; canShowPaidStatus()\">{{'client.paid' | translate}}</div><div class=\"paid-tag unpaid\" ng-if=\"group.participant.paymentStatus == 0 &amp;&amp; !isParticipantOwner(group.participant) &amp;&amp; canShowPaidStatus()\">{{'client.unpaid' | translate}}</div><span>{{formatAmount(group.subtotal)}}</span></div></div><div class=\"cart-items-container\" ng-hide=\"groupsCollapses[group.participant.userId]\"><div class=\"cart-item flex-row\" ng-repeat=\"item in group.items | orderBy: '-recordedOn'\" ng-class=\"{ editable: group.editable}\"><div class=\"left-block\"><button class=\"icon-btn delete-btn\" ng-click=\"deleteItem(item)\" ng-class=\"{ hidden: !group.editable || !canDeleteItem }\"><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.0012 4.23577L11.2953 3.52981L7.7655 7.05958L4.23573 3.52981L3.52977 4.23577L7.05954 7.76554L3.52971 11.2954L4.23567 12.0013L7.7655 8.4715L11.2953 12.0013L12.0013 11.2954L8.47146 7.76554L12.0012 4.23577Z\" fill=\"#54636C\"/>\n</svg>\n</button><div class=\"item-img-container\"><img class=\"item-img\" ng-src=\"{{item.catalogProductImage}}\"/></div><div class=\"flex-column\"><div class=\"product-title\" ng-click=\"openItem(item)\" role=\"button\">{{item.itemName}}</div><div class=\"item-options-container\"><div class=\"item-options\" ng-repeat=\"option in getItemOptions(item)\">{{ option | ellipsisText:28 }}</div></div></div></div><div class=\"right-block\"><div class=\"flex-column right-items-column\"><div class=\"product-price-container\" ng-if=\"!isGneralMillsPOC(item)\">{{formatAmount(item.total)}}</div><div class=\"quantity flex-row\"><a class=\"icon-btn quantity-btn\" ng-click=\"updateQuantity($event, item, -1)\" ng-show=\"group.editable\" ng-disabled=\"item.quantity &lt; 2 || !isAllowChangeQuantity\">—</a><input class=\"quantity-input\" type=\"number\" min=\"1\" ng-model=\"item.quantity\" aria-label=\"Amount To Order\" readonly=\"readonly\"/><a class=\"icon-btn quantity-btn\" ng-click=\"updateQuantity($event, item, +1)\" ng-show=\"group.editable\" ng-disabled=\"!isAllowChangeQuantity\">+</a></div></div></div></div></div></div><!--.cart-group(ng-repeat=\"group in groups\" layout=\"row\" ng-class=\"{ 'my-tab': group.myTab }\" flex)--><!--    div(title=\"{{group.participantName}}\" flex=\"10\" class=\"item-avatar\")--><!--        .icon(ng-if=\"!group.participant.avatarCropped\") {{group.iconLetter}}--><!--        img.participant-avatar(ng-if=\"group.participant.avatarCropped\" ng-src=\"{{ group.participant.avatarCropped }}\")--><!--    div(layout=\"column\" flex)--><!--        .name(layout=\"row\")--><!--            .name-div(flex=\"no-shrink\") {{group.myTab && !isStealthUserMode ? 'Me' : group.participant.name}}--><!--            .paid-tag-owner(ng-if=\"canShowGroupOwner() && isParticipantOwner(group.participant)\") GROUP OWNER--><!--            .paid-tag(ng-if=\"group.participant.paymentStatus == 1 && !isParticipantOwner(group.participant) && canShowPaidStatus()\") PAID--><!--            .paid-tag-unpaid(ng-if=\"group.participant.paymentStatus == 0 && !isParticipantOwner(group.participant) && canShowPaidStatus()\") UNPAID--><!----><!--        .cart-item(ng-repeat=\"item in group.items | orderBy: '-recordedOn'\", layout=\"row\" ng-class=\"{ editable: group.editable, 'recently-updated': item.recentlyUpdated }\")--><!--            .thumbnail(layout=\"column\")--><!--                div(ng-click=\"openItem(item)\" role=\"button\")--><!--                    span--><!--                        img(ng-src=\"{{item.catalogProductImage}}\")--><!--                    //(ng-style=\"{ 'background-image': 'url(\\\"' + item.catalogProductImage + '\\\")', 'background-size': 'cover'}\")--><!--            div(flex=\"2\")--><!--            .description.layout-align-space-around-end(layout=\"row\" flex)--><!--                div(layout=\"column\")--><!--                    .product-title(ng-click=\"openItem(item)\", role=\"button\") {{item.itemName}}--><!--                    .item-options(ng-repeat=\"option in getItemOptions(item)\", title=\"{{ option }}\") {{ option | ellipsisText:28 }}--><!--                div(flex layout-gt-xs-fill)--><!--                div(layout=\"row\")--><!--                    div(layout=\"row\" layout-align=\"end\" ng-if=\"!isStealthUserMode\")--><!--                        md-button.md-primary.button-text-only-highlight.customize-button.md-icon-button(ng-click=\"deleteItem(item)\" ng-show=\"group.editable\" aria-label=\"Remove\" title=\"Remove this item\")--><!--                            md-icon(md-svg-src=\"resources/icons/trashbin.svg\")--><!----><!--                    span(flex=\"2\")--><!--                    .quantity(layout=\"row\" layout-align=\"end\")--><!--                        div(layout=\"row\" layout-align=\"center center\")--><!--                            div.quantity-box(ng-show=\"!group.editable || isStealthUserMode\" ng-class=\"{ 'recently-updated': item.recentlyUpdated }\") {{item.quantity}}--><!--                            md-input-container.md-input-has-messages.item-count(ng-show=\"group.editable && !isStealthUserMode\" flex)--><!--                                select(ng-model=\"item.quantity\" ng-change=\"setQuantity(item)\" aria-label=\"Amount To Order\" ng-class=\"{ 'recently-updated': item.recentlyUpdated }\")--><!--                                    option(ng-value=\"$index+1\" ng-repeat=\"qty in maxItemQuantity track by $index\") {{ $index+1 }}--><!--                    span(flex=\"5\")--><!--                    .product-price-container(layout=\"row\" layout-align=\"end center\" ng-if=\"!isGneralMillsPOC(item)\") ${{::(item.total | number:2)}}--><!--        .allocated(ng-if=\"cart.fulfillment && cart.fulfillment.paymentMethod === 'fullmixed' && isOwner\") Allocated:  ${{::(group.participant.amountToPay | number:2)}}-->"

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = "<div layout=\"column\"><div class=\"counter-holder\"><div class=\"counter\" ng-class=\"{ 'hot': countHot }\">{{ count }}</div></div></div>"

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

var _InviteController = __webpack_require__(429);

var _OrderSetupDialogController = __webpack_require__(419);

var _OrderSetupDialogController2 = _interopRequireDefault(_OrderSetupDialogController);

var _OrderCheckoutController = __webpack_require__(791);

var _OrderCheckoutController2 = _interopRequireDefault(_OrderCheckoutController);

var _OrderCheckoutFullMixedController = __webpack_require__(792);

var _OrderCheckoutFullMixedController2 = _interopRequireDefault(_OrderCheckoutFullMixedController);

var _OrderConfirmationController = __webpack_require__(793);

var _OrderConfirmationController2 = _interopRequireDefault(_OrderConfirmationController);

var _OrderPayController = __webpack_require__(794);

var _OrderPayController2 = _interopRequireDefault(_OrderPayController);

var _OrderTabAddPeopleController = __webpack_require__(795);

var _OrderTabAddPeopleController2 = _interopRequireDefault(_OrderTabAddPeopleController);

var _OrderTabBudgetController = __webpack_require__(796);

var _OrderTabBudgetController2 = _interopRequireDefault(_OrderTabBudgetController);

var _OrderTabDeliveryAddressController = __webpack_require__(797);

var _OrderTabDeliveryAddressController2 = _interopRequireDefault(_OrderTabDeliveryAddressController);

var _OrderTabFinishController = __webpack_require__(798);

var _OrderTabFinishController2 = _interopRequireDefault(_OrderTabFinishController);

var _OrderTabPayModeController = __webpack_require__(799);

var _OrderTabPayModeController2 = _interopRequireDefault(_OrderTabPayModeController);

var _OrderTabPaymentDetailsController = __webpack_require__(800);

var _OrderTabPaymentDetailsController2 = _interopRequireDefault(_OrderTabPaymentDetailsController);

var _OrderTabPreviewController = __webpack_require__(801);

var _OrderTabPreviewController2 = _interopRequireDefault(_OrderTabPreviewController);

var _OrderTabDeliveryModeController = __webpack_require__(805);

var _OrderTabDeliveryModeController2 = _interopRequireDefault(_OrderTabDeliveryModeController);

var _OrderSummaryPageController = __webpack_require__(806);

var _OrderSummaryPageController2 = _interopRequireDefault(_OrderSummaryPageController);

var _OrderAddPeopleDirective = __webpack_require__(807);

var _OrderAddPeopleDirective2 = _interopRequireDefault(_OrderAddPeopleDirective);

var _OrderContactViewDirective = __webpack_require__(809);

var _OrderContactViewDirective2 = _interopRequireDefault(_OrderContactViewDirective);

var _orderDateService = __webpack_require__(810);

var _orderDateService2 = _interopRequireDefault(_orderDateService);

var _routeConfig = __webpack_require__(811);

var _routeConfig2 = _interopRequireDefault(_routeConfig);

var _OrderTabDeadlineController = __webpack_require__(813);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.factory('OrderDateService', ['ConfigurationService', function (configurationService) {
    return configurationService.getItem('storeHours').then(function (storeHours) {
        return configurationService.getItem('deliveryDaysRange').then(function (deliveryDaysRange) {
            return function (addMinutes, maximumDate) {
                return new _orderDateService2.default(storeHours, deliveryDaysRange, addMinutes, maximumDate);
            };
        });
    });
}]);

_module3.default.config(['$stateProvider', function ($stateProvider) {
    _routeConfig2.default.forEach(function (route) {
        $stateProvider.state(route);
    });
}]);

_module3.default.controller('OrderTabDeadline', _OrderTabDeadlineController.OrderTabDeadlineController);
_module3.default.controller('Cartonomy.Order.OrderSummaryPageController', _OrderSummaryPageController2.default);

exports.default = _module3.default.name;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (inviteDetails) {
    return ['$scope', '$mdDialog', '$state', 'Session', 'AuthenticationService', 'cartonomyConfig', function (scope, dialogService, stateService, sessionService, authenticationService, cartonomyConfig) {
        return new InviteDialogController(scope, dialogService, stateService, sessionService, authenticationService, cartonomyConfig, inviteDetails);
    }];
};

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InviteDialogController = function () {
    function InviteDialogController(scope, dialogService, stateService, sessionService, authenticationService, cartonomyConfig, inviteDetails) {
        var _this = this;

        _classCallCheck(this, InviteDialogController);

        this._stateService = stateService;
        this._dialogService = dialogService;
        this._scope = scope;
        this._authenticationService = authenticationService;
        this._inviteDetails = inviteDetails;
        this._cartonomyConfig = cartonomyConfig;

        sessionService.loggedIn().then(function (loggedIn) {
            scope.loggedIn = loggedIn;
        });

        if (scope.loggedIn) {
            // scope.username = await sessionService.getUserName();
            // scope.email = await sessionService.getUserEmail();
            sessionService.getUserName().then(function (username) {
                scope.username = username;
                return sessionService.getUserEmail();
            }).then(function (email) {
                scope.email = email;
            });
        } else {
            scope.username = inviteDetails.userName;
            scope.email = inviteDetails.userEmail;
        }
        scope.userFirstLetter = scope.username.substring(0, 1).toUpperCase();

        scope.continue = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', _this._continue());

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));
        scope.login = function () {
            return _this._login();
        };
        scope.signup = function () {
            return _this._signup();
        };
    }

    _createClass(InviteDialogController, [{
        key: '_goToCatalog',
        value: function _goToCatalog() {
            var stateToGo = this._cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CART : _CommonConstants2.default.RoutingStates.CATALOG;
            this._stateService.go(stateToGo);
        }
    }, {
        key: '_continue',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (this._scope.loggedIn) {
                                    _context2.next = 5;
                                    break;
                                }

                                _context2.next = 3;
                                return this._authenticationService.loginWithInviteToken(this._inviteDetails);

                            case 3:
                                _context2.next = 6;
                                break;

                            case 5:
                                this._authenticationService.onInviteAccepted();

                            case 6:

                                this._goToCatalog();
                                this._dialogService.hide();

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _continue() {
                return _ref2.apply(this, arguments);
            }

            return _continue;
        }()
    }, {
        key: '_login',
        value: function _login() {
            var _this2 = this;

            this._dialogService.hide();
            this._authenticationService.showLoginDialog(this._scope.email).then(function () {
                return _this2._goToCatalog();
            });
        }
    }, {
        key: '_signup',
        value: function _signup() {
            var _this3 = this;

            this._dialogService.hide();
            this._authenticationService.showSignupDialog(this._scope.email).then(function () {
                return _this3._goToCatalog();
            });
        }
    }]);

    return InviteDialogController;
}();

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports = "<md-dialog class=\"invite-failed\" aria-label=\"Accept Invite\" flex=\"80\" flex-sm=\"100\" flex-xs=\"100\"><md-dialog-content><md-content layout=\"column\" layout-padding=\"layout-padding\" style=\"text-align:center\"><h3>{{'client.order.already_paid' | translate}}<br/>{{'client.order.join_new_cart' | translate}}</h3><h3><span ng-bind-html-unsafe=\"('client.order.accept_current_invite' | translate)\"></span></h3><div class=\"buttons\" layout=\"row\" layout-align=\"center\"><div class=\"full-width\" layout=\"row\"><md-button class=\"md-primary md-raised\" ng-click=\"accept()\" aria-label=\"Accept\">{{'client.accept' | translate}}</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" aria-label=\"Cancel\">{{'client.accept' | translate}}</md-button></div></div></md-content></md-dialog-content></md-dialog>"

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function OrderCheckoutController($scope, cartService, session, $state, checkoutService, messageService) {
    var _this = this;

    this.$onInit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return $scope.init();

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    $scope.paymentSystemReady = false;
    $scope.config = {};
    $scope.paymentSystem = '';

    // $scope.$watch('paymentSystem', async paymentSystem => {
    $scope.paymentSystemChanged = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(paymentSystem) {
            var paymentConfiguration;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:

                            paymentSystem = paymentSystem || $scope.paymentSystem;

                            if (paymentSystem) {
                                _context2.next = 5;
                                break;
                            }

                            $scope.paymentSystemReady = false;
                            $scope.paymentError = '';
                            return _context2.abrupt('return');

                        case 5:

                            $scope.paymentSystemReady = false;
                            $scope.paymentError = '';
                            _scope2.default.apply($scope);

                            _context2.prev = 8;
                            _context2.next = 11;
                            return checkoutService.beginCheckout(paymentSystem);

                        case 11:
                            paymentConfiguration = _context2.sent;
                            _context2.t0 = paymentSystem;
                            _context2.next = _context2.t0 === 'PayPal' ? 15 : _context2.t0 === 'Square' ? 17 : 18;
                            break;

                        case 15:
                            $scope.clientToken = paymentConfiguration.clientToken;
                            return _context2.abrupt('break', 18);

                        case 17:
                            return _context2.abrupt('break', 18);

                        case 18:
                            $scope.paymentSystemReady = true;
                            _context2.next = 25;
                            break;

                        case 21:
                            _context2.prev = 21;
                            _context2.t1 = _context2['catch'](8);

                            $scope.paymentError = messageService.getMessageFromErrorResponse(_context2.t1);
                            $scope.paymentSystemReady = false;

                        case 25:
                            _context2.prev = 25;

                            _scope2.default.apply($scope);
                            return _context2.finish(25);

                        case 28:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this, [[8, 21, 25, 28]]);
        }));

        return function (_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    //); // end $scope.$watch

    $scope.pay = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var cardData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        if (!($scope.paymentSystem === 'PayPal')) {
                            _context3.next = 3;
                            break;
                        }

                        window.location.href = _CommonConstants2.default.PAYPAL_CHECKOUT_URL + $scope.clientToken;
                        return _context3.abrupt('return');

                    case 3:

                        $scope.paymentSystemReady = false;
                        $scope.paymentError = '';
                        _scope2.default.apply($scope);

                        _context3.prev = 6;
                        _context3.next = 9;
                        return $scope.config.getCardNonce();

                    case 9:
                        cardData = _context3.sent;

                        cardData.orderTotal = $scope.orderTotal;
                        cardData.isAuthorization = false;
                        _context3.next = 14;
                        return checkoutService.submitOrder($scope.paymentSystem, cardData);

                    case 14:
                        $state.go(_CommonConstants2.default.RoutingStates.CONFIRM_ORDER);
                        _context3.next = 22;
                        break;

                    case 17:
                        _context3.prev = 17;
                        _context3.t0 = _context3['catch'](6);

                        $scope.paymentError = "client.payment.credit_trans_not_approved";
                        $scope.paymentSystemReady = true;
                        _scope2.default.apply($scope);

                    case 22:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this, [[6, 17]]);
    }));

    $scope.init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var cart, userEmail;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return cartService.getCart();

                    case 2:
                        cart = _context4.sent;

                        if (!(cart.items.length === 0)) {
                            _context4.next = 6;
                            break;
                        }

                        $scope.showCatalog();
                        return _context4.abrupt('return');

                    case 6:

                        $scope.groupOrder = cartService.isGroupOrder(cart);

                        _context4.next = 9;
                        return session.getUserEmail();

                    case 9:
                        userEmail = _context4.sent;


                        $scope.orderTotal = 0;

                        if (cart.fulfillment.paymentMethod == "single") {
                            $scope.orderTotal = cart.cartTotal;
                        } else {
                            _.each(cart.items, function (item) {
                                if (!userEmail || item.participantEmail == userEmail) {
                                    $scope.orderTotal += item.price * item.quantity;
                                }
                            });
                        }

                    case 12:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this);
    }));
}

_module3.default.controller('Cartonomy.Order.CheckoutController', ['$scope', 'CartService', 'Session', '$state', 'CheckoutService', 'Message', OrderCheckoutController]);

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _communicationService = __webpack_require__(28);

var _commandKeys = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function OrderCheckoutFullMixedController($scope, rootScope, cartService, session, $state, checkoutService, messageService, $translate) {
    var _this = this;

    this.$onInit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return $scope.init();

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    $scope.participantAmounts = [];
    $scope.cartTotal = 0;
    $scope.totalAllocated = 0;
    $scope.totalRemaining = $scope.cartTotal - $scope.totalAllocated;
    this._rootScope = rootScope;

    $scope.init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var cart;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return cartService.getCart();

                    case 2:
                        cart = _context2.sent;

                        $scope.cartId = cart.id;
                        $scope.cartTotal = cart.cartTotal;
                        _context2.next = 7;
                        return cartService.getParticipantamounts(cart.id);

                    case 7:
                        $scope.participantAmounts = _context2.sent;

                        $scope.totalAllocated = $scope.participantAmounts.map(function (r) {
                            return r.amountToPay;
                        }).reduce(function (total, item) {
                            return total + item;
                        });
                        $scope.totalRemaining = $scope.cartTotal - $scope.totalAllocated;
                        _scope2.default.apply($scope);

                    case 11:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this);
    }));

    $scope.amountToPayChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        $scope.totalAllocated = $scope.participantAmounts.map(function (r) {
                            return r.amountToPay;
                        }).reduce(function (total, item) {
                            return total + item;
                        });
                        $scope.totalRemaining = $scope.cartTotal - $scope.totalAllocated;

                    case 2:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this);
    }));

    $scope.saveForLater = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        if (!($scope.totalAllocated > $scope.cartTotal)) {
                            _context4.next = 3;
                            break;
                        }

                        messageService.showErrorPopup($translate.instant('client.order.total_allocated'));
                        return _context4.abrupt('return');

                    case 3:
                        _context4.prev = 3;
                        _context4.next = 6;
                        return cartService.updateAmountTopay($scope.participantAmounts);

                    case 6:
                        _context4.next = 8;
                        return cartService.getCart($scope.cartId, false);

                    case 8:

                        $state.go(_CommonConstants2.default.RoutingStates.CART);
                        _context4.next = 14;
                        break;

                    case 11:
                        _context4.prev = 11;
                        _context4.t0 = _context4['catch'](3);

                        messageService.showErrorPopupForResponse(_context4.t0);

                    case 14:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this, [[3, 11]]);
    }));

    $scope.completeAndStartPaying = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var update;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        if (!($scope.totalAllocated > $scope.cartTotal)) {
                            _context5.next = 3;
                            break;
                        }

                        messageService.showErrorPopup($translate.instant('client.order.total_allocated'));
                        return _context5.abrupt('return');

                    case 3:
                        _context5.next = 5;
                        return cartService.updateAmountTopay($scope.participantAmounts);

                    case 5:
                        update = _context5.sent;

                        if (!update.data) {
                            _context5.next = 9;
                            break;
                        }

                        _context5.next = 9;
                        return $scope.shopifyCheckout();

                    case 9:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this);
    }));

    $scope.shopifyCheckout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var confirmed, loadingDialog, shopifyCheckoutInfo, myCartItems, continueCheckout, existingShopifyCartItems, hasMyCartItems, continueCheckoutWhenMatch, _continueCheckout, checkoutResult;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _context6.next = 2;
                        return cartService.startProcessCheckout();

                    case 2:
                        confirmed = _context6.sent;

                        if (confirmed) {
                            _context6.next = 5;
                            break;
                        }

                        return _context6.abrupt('return', null);

                    case 5:
                        _context6.next = 7;
                        return messageService.showLoading();

                    case 7:
                        loadingDialog = _context6.sent;
                        _context6.prev = 8;
                        _context6.next = 11;
                        return checkoutService.getShopifyCheckoutInfo();

                    case 11:
                        shopifyCheckoutInfo = _context6.sent;
                        myCartItems = shopifyCheckoutInfo.cartInfo.cartItems;

                        if (!shopifyCheckoutInfo.warningInfo) {
                            _context6.next = 23;
                            break;
                        }

                        loadingDialog.close();
                        _context6.next = 17;
                        return messageService.showQuestionPopup(shopifyCheckoutInfo.warningInfo, '', $translate.instant('client.cart.continue_checkout'), $translate.instant('client.cart.checkout_review'));

                    case 17:
                        continueCheckout = _context6.sent;

                        if (continueCheckout) {
                            _context6.next = 20;
                            break;
                        }

                        return _context6.abrupt('return');

                    case 20:
                        _context6.next = 22;
                        return messageService.showLoading();

                    case 22:
                        loadingDialog = _context6.sent;

                    case 23:
                        if (!shopifyCheckoutInfo.ownerPaid) {
                            _context6.next = 27;
                            break;
                        }

                        loadingDialog.close();
                        $state.go(_CommonConstants2.default.RoutingStates.CART);
                        return _context6.abrupt('return');

                    case 27:
                        _context6.next = 29;
                        return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.checkCartItems, {});

                    case 29:
                        existingShopifyCartItems = _context6.sent;
                        hasMyCartItems = existingShopifyCartItems.data.items.some(function (item) {
                            return myCartItems.some(function (myCart) {
                                return item.id === myCart.id;
                            });
                        });

                        if (!(existingShopifyCartItems.data.item_count > 0)) {
                            _context6.next = 53;
                            break;
                        }

                        if (!hasMyCartItems) {
                            _context6.next = 44;
                            break;
                        }

                        loadingDialog.close();
                        _context6.next = 36;
                        return cartService.confirmContinueCheckoutWhenMatchCartItems();

                    case 36:
                        continueCheckoutWhenMatch = _context6.sent;

                        if (continueCheckoutWhenMatch) {
                            _context6.next = 39;
                            break;
                        }

                        return _context6.abrupt('return');

                    case 39:
                        _context6.next = 41;
                        return messageService.showLoading();

                    case 41:
                        loadingDialog = _context6.sent;
                        _context6.next = 53;
                        break;

                    case 44:
                        loadingDialog.close();
                        _context6.next = 47;
                        return cartService.confirmContinueCheckout();

                    case 47:
                        _continueCheckout = _context6.sent;

                        if (_continueCheckout) {
                            _context6.next = 50;
                            break;
                        }

                        return _context6.abrupt('return');

                    case 50:
                        _context6.next = 52;
                        return messageService.showLoading();

                    case 52:
                        loadingDialog = _context6.sent;

                    case 53:
                        _context6.next = 55;
                        return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.checkoutCart, {
                            cartInfo: shopifyCheckoutInfo.cartInfo
                        });

                    case 55:
                        checkoutResult = _context6.sent;


                        if (!checkoutResult.success) {
                            messageService.showErrorPopup(checkoutResult.errorMessage);
                        }
                        _context6.next = 62;
                        break;

                    case 59:
                        _context6.prev = 59;
                        _context6.t0 = _context6['catch'](8);

                        messageService.showErrorPopupForResponse(_context6.t0);

                    case 62:
                        _context6.prev = 62;

                        loadingDialog.close();
                        return _context6.finish(62);

                    case 65:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, _this, [[8, 59, 62, 65]]);
    }));
}

_module3.default.controller('Cartonomy.Order.CheckoutFullMixedController', ['$scope', '$rootScope', 'CartService', 'Session', '$state', 'CheckoutService', 'Message', '$translate', OrderCheckoutFullMixedController]);

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OrderConfirmationController($scope, $state, cartService) {

    cartService.getCartDetails().then(function (cartDetails) {
        $scope.deliveryTime = (0, _moment2.default)(cartDetails.deliveryDate).format('LT [on] dddd[,] MMM DD');
    });

    $scope.go = function () {
        $state.go(_CommonConstants2.default.RoutingStates.CATALOG);
    };
}

_module3.default.controller('Cartonomy.Order.ConfirmationController', ['$scope', '$state', 'CartService', OrderConfirmationController]);

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OrderPayController($scope, $stateParams, groupOrder, $state) {

    $scope.paymentDetails = {
        cardNumber: '',
        cardName: '',
        expirationDate: '',
        securityCode: '',
        payTitle: 'client.pay_now',
        amountToPay: groupOrder.getAmountToPay()
    };

    /*jshint -W041 */
    if ($scope.paymentDetails.amountToPay == 0) {
        $state.go(_CommonConstants2.default.RoutingStates.CATALOG);
        return;
    }
    /*jshint +W041 */

    $scope.payNow = function (form) {

        if (!form.$valid) {
            form.highlightAllErrors();
            return;
        }

        groupOrder.payNow({
            cardNumber: $scope.paymentDetails.cardNumber,
            cardName: $scope.paymentDetails.cardName,
            expirationDate: $scope.paymentDetails.expirationDate,
            securityCode: $scope.paymentDetails.securityCode,
            id: $stateParams.id
        }).then(function () {
            $state.go(_CommonConstants2.default.RoutingStates.CONFIRM_ORDER);
        });
    };
}

_module3.default.controller('Cartonomy.Order.PayController', ['$scope', '$stateParams', 'GroupOrder', '$state', OrderPayController]);

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderTabAddPeopleController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderTabAddPeopleController = exports.OrderTabAddPeopleController = function () {
    function OrderTabAddPeopleController(scope, $rootScope, groupOrderService, messageService) {
        var _this = this;

        _classCallCheck(this, OrderTabAddPeopleController);

        this.scope = scope;

        scope.onContactListChanged = function (emails) {
            scope.configuration.contactDetails.selectedEmails = emails || scope.configuration.contactDetails.selectedEmails || [];
            scope.nextDisabled = scope.checkDisableGoingForward();
            _scope2.default.apply(scope);
        };

        scope.checkDisableGoingForward = function () {
            return _.isEmpty(scope.configuration.contactDetails.selectedEmails) && _.isEmpty(scope.configuration.contactDetails.selectedContacts);
        };

        scope.configuration = {
            contactDetails: groupOrderService.getContactDetails() || {
                selectedContacts: [],
                createdGroups: [],
                createdContacts: [],
                allContacts: [],
                allGroups: [],
                selectedEmails: []
            }
        };

        scope.$on('order:add:people.canAddPeople', function (s, value) {
            scope.canAddEmail = value;
            scope.nextDisabled = scope.checkDisableGoingForward();
            _scope2.default.apply(scope);
        });

        scope.sendInvitation = function (emails) {
            groupOrderService.setContactDetails(scope.configuration.contactDetails);

            var nextDisabled = scope.checkDisableGoingForward();

            if (!nextDisabled) {
                scope.next();
            }
        };

        scope.addPeopleToOrder = function () {
            scope.$broadcast(_CommonConstants2.default.Events.ADD_PEOPLE_ADVANCE_TO_NEXT_PAGE);
        };

        scope.goBack = function () {
            scope.back();
        };

        scope.onDeleteContact = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(contact) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                scope.onDialogDeleteContact(contact);

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();
    }

    _createClass(OrderTabAddPeopleController, [{
        key: '$onInit',
        value: function $onInit() {
            this.scope.onContactListChanged();
        }
    }]);

    return OrderTabAddPeopleController;
}();

OrderTabAddPeopleController.$inject = ['$scope', '$rootScope', 'GroupOrder', 'Message'];


_module3.default.controller('OrderTabAddPeople', OrderTabAddPeopleController);

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderTabBudgetController = function () {
    function OrderTabBudgetController($scope, cartonomyConfig, $filter, orderDateServicePromise, checkoutService, cartService, groupOrderService, $location, $window, messageService) {
        var _this = this;

        _classCallCheck(this, OrderTabBudgetController);

        this._scope = $scope;
        this._cartonomyConfig = cartonomyConfig;
        this._filterService = $filter;
        this._checkoutService = checkoutService;
        this._cartService = cartService;
        this._groupOrderService = groupOrderService;
        this._locationService = $location;
        this._windowService = $window;
        this._messageService = messageService;
        this._orderDateServicePromise = orderDateServicePromise;

        $scope.externalStoreMode = cartonomyConfig.externalStoreMode;
        $scope.maxAllowedBudget = 100000;

        this._joinDateTime = function () {
            return null;
        };

        $scope.parentBack = $scope.back;

        $scope.back = function (form) {
            return _this._back(form);
        };

        $scope.acceptSinglePayOrderNoBudget = function (form) {
            return _this._acceptSinglePayOrderNoBudget(form);
        };
        $scope.acceptSinglePayOrderNoPayment = function (form) {
            return _this._acceptSinglePayOrderNoPayment(form);
        };
        $scope.onBudgetChanged = function () {
            return _this._onBudgetChanged();
        };
        $scope.acceptSinglePayOrderBudget = function (form) {
            return _this._acceptSinglePayOrderBudget(form);
        };
        $scope.acceptPaymentInformation = function () {
            return _this._acceptPaymentInformation();
        };

        $scope.shouldDisablePaymentInformationNextButton = function () {
            return _this._shouldDisablePaymentInformationNextButton();
        };

        $scope.$watch('configuration.paymentSystem', function (paymentSystem) {
            return _this._onPaymentSystemChanged(paymentSystem);
        });
    }

    _createClass(OrderTabBudgetController, [{
        key: '$onInit',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._initialize();

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function $onInit() {
                return _ref.apply(this, arguments);
            }

            return $onInit;
        }()
    }, {
        key: '_initialize',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this._scope.configuration = {
                                    groupPay: this._groupOrderService.getGroupPay(),
                                    singlePayOrder: this._groupOrderService.getSinglePayOrder() || {
                                        paymentInformation: {}
                                    },
                                    paymentSystem: this._groupOrderService.getPaymentSystem(),
                                    vendorDetails: this._groupOrderService.getVendorDetails() || {},
                                    deliveryDetails: this._groupOrderService.getDeliveryDetails()
                                };

                                if (!this._scope._editMode) {
                                    _context2.next = 6;
                                    break;
                                }

                                _context2.next = 4;
                                return this._cartService.getCart();

                            case 4:
                                this.cart = _context2.sent;


                                if (!this._scope.configuration.singlePayOrder.budget) {
                                    this._scope.configuration.singlePayOrder.budget = this.cart.orderLimit;
                                }

                            case 6:

                                // stick a $ in front if not there
                                if (_.isString(this._scope.configuration.singlePayOrder.budget) && this._scope.configuration.singlePayOrder.budget.match(/^\d/) || this._scope.configuration.singlePayOrder.budget > 0) {
                                    this._scope.configuration.singlePayOrder.budget = parseFloat(this._scope.configuration.singlePayOrder.budget);
                                    this._scope.configuration.singlePayOrder.defineBudget = 'yes';
                                    this._scope.configuration.singlePayOrder.budgetEntered = true;
                                } else {
                                    this._scope.configuration.singlePayOrder.budget = "";
                                    this._scope.configuration.singlePayOrder.defineBudget = 'no';
                                }

                                if (this._scope.returnToPreview) {
                                    this._scope.configuration.singlePayOrder.defineBudget = 'yes';
                                }

                                _context2.next = 10;
                                return this._checkoutService.paymentAuthorizedOrCaptured();

                            case 10:
                                this._scope.configuration.paymentProvided = _context2.sent;


                                if (this._scope.externalStoreMode && !this._scope.configuration.singlePayOrder.enterPaymentInformation) {
                                    this._scope.configuration.singlePayOrder.enterPaymentInformation = 'no';
                                }

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _initialize() {
                return _ref2.apply(this, arguments);
            }

            return _initialize;
        }()
    }, {
        key: 'save',
        value: function save() {
            this._groupOrderService.setSinglePayOrder(this._scope.configuration.singlePayOrder);
            this._groupOrderService.setVendorDetails(this._scope.configuration.vendorDetails);
            this._groupOrderService.setPaymentSystem(this._scope.configuration.paymentSystem);
        }
    }, {
        key: 'saveAndGotoNext',
        value: function saveAndGotoNext() {
            this.save();
            this._scope.next();
        }
    }, {
        key: '_rejectSinglePayOrderPlace',
        value: function _rejectSinglePayOrderPlace() {
            if (!this._scope._editMode) {
                // this._scope.configuration.deliveryDetails.placeEntered = false;
            }
        }
    }, {
        key: '_back',
        value: function _back(form) {
            if (form && !form.$valid) {
                form.highlightAllErrors();
                return;
            }

            this._scope.parentBack();
        }
    }, {
        key: '_acceptSinglePayOrderNoBudget',
        value: function _acceptSinglePayOrderNoBudget(form) {
            if (form && !form.$valid) {
                form.highlightAllErrors();
                return;
            }

            this._scope.configuration.singlePayOrder.budget = 0;

            this.saveAndGotoNext();

            _scope2.default.apply(this._scope);
        }
    }, {
        key: '_acceptSinglePayOrderNoPayment',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(form) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(form && !form.$valid)) {
                                    _context3.next = 3;
                                    break;
                                }

                                form.highlightAllErrors();
                                return _context3.abrupt('return');

                            case 3:

                                this._scope.budgetExceeds = false;
                                this._scope.budgetMaximumReach = false;
                                _context3.next = 7;
                                return this._onBudgetChanged();

                            case 7:

                                if (!this._scope.budgetExceeds && !this._scope.budgetMaximumReach) {
                                    this.saveAndGotoNext();
                                }

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function _acceptSinglePayOrderNoPayment(_x) {
                return _ref3.apply(this, arguments);
            }

            return _acceptSinglePayOrderNoPayment;
        }()
    }, {
        key: '_onBudgetChanged',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var currentAmount;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (this._scope.configuration.singlePayOrder.budget && _.isString(this._scope.configuration.singlePayOrder.budget)) {
                                    this._scope.configuration.singlePayOrder.budget = this._scope.configuration.singlePayOrder.budget.replace(/[^0-9.]/g, "");
                                    this._scope.configuration.singlePayOrder.budgetEntered = true;
                                } else {
                                    this._scope.configuration.singlePayOrder.budgetEntered = false;
                                }

                                if (this._scope.externalStoreMode && !this._scope.configuration.singlePayOrder.enterPaymentInformation) {
                                    this._scope.configuration.singlePayOrder.enterPaymentInformation = 'no';
                                }

                                this._scope.budgetExceeds = false;
                                this._scope.budgetMaximumReach = false;

                                _context4.next = 6;
                                return this._cartService.getCartAmount();

                            case 6:
                                currentAmount = _context4.sent;

                                if (this._scope.configuration.singlePayOrder.budget < currentAmount) {
                                    this._scope.budgetExceeds = currentAmount;
                                }
                                if (this._scope.configuration.singlePayOrder.budget > this._scope.maxAllowedBudget) {
                                    this._scope.budgetMaximumReach = true;
                                }

                                _scope2.default.apply(this._scope);

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function _onBudgetChanged() {
                return _ref4.apply(this, arguments);
            }

            return _onBudgetChanged;
        }()
    }, {
        key: '_acceptSinglePayOrderBudget',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(form) {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (form.$valid) {
                                    _context5.next = 3;
                                    break;
                                }

                                form.highlightAllErrors();
                                return _context5.abrupt('return');

                            case 3:

                                // only digits and decimal point
                                if (_.isString(this._scope.configuration.singlePayOrder.budget)) {
                                    this._scope.configuration.singlePayOrder.budget = this._scope.configuration.singlePayOrder.budget.replace(/[^0-9.]/g, "");
                                    this._scope.configuration.singlePayOrder.budgetEntered = true;
                                } else {
                                    this.saveAndGotoNext();
                                }

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function _acceptSinglePayOrderBudget(_x2) {
                return _ref5.apply(this, arguments);
            }

            return _acceptSinglePayOrderBudget;
        }()
    }, {
        key: '_shouldDisablePaymentInformationNextButton',
        value: function _shouldDisablePaymentInformationNextButton() {
            if (!this._scope.configuration.paymentSystem) {
                return true;
            }

            if (this._scope.configuration.paymentSystem && this._scope.configuration.paymentSystem == 'PayPal' && !this._scope.configuration.vendorDetails.clientToken) {

                return true;
            }

            return this._scope.configuration.paymentSystem == '';
        }
    }, {
        key: '_onPaypalSelected',
        value: function _onPaypalSelected() {
            this._scope.processingPayment = true;
            this.save();
            this._groupOrderService.saveToSessionStorage();
            // this._windowService.onbeforeunload = null;
            window.location.href = _CommonConstants2.default.PAYPAL_CHECKOUT_URL + this._scope.configuration.vendorDetails.clientToken;
        }
    }, {
        key: '_onCreditCardSelected',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:

                                this._scope.processingPayment = true;
                                this._scope.paymentSystemError = '';
                                _scope2.default.apply(this._scope);

                                _context6.prev = 3;
                                _context6.next = 6;
                                return this._scope.configuration.getCardNonce();

                            case 6:
                                this._scope.configuration.vendorDetails = _context6.sent;

                                this._scope.configuration.vendorDetails.isAuthorization = true;
                                this._scope.configuration.vendorDetails.orderTotal = this._scope.configuration.singlePayOrder.budget;

                                _context6.next = 11;
                                return this._checkoutService.submitOrder(this._scope.configuration.paymentSystem, this._scope.configuration.vendorDetails);

                            case 11:
                                _context6.next = 19;
                                break;

                            case 13:
                                _context6.prev = 13;
                                _context6.t0 = _context6['catch'](3);

                                this._scope.paymentSystemError = "client.payment.credit_trans_not_approved";

                                this._scope.processingPayment = false;
                                _scope2.default.apply(this._scope);
                                return _context6.abrupt('return', null);

                            case 19:

                                this._scope.processingPayment = false;
                                _scope2.default.apply(this._scope);

                                this.saveAndGotoNext();

                            case 22:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this, [[3, 13]]);
            }));

            function _onCreditCardSelected() {
                return _ref6.apply(this, arguments);
            }

            return _onCreditCardSelected;
        }()
    }, {
        key: '_acceptPaymentInformation',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.t0 = this._scope.configuration.paymentSystem;
                                _context7.next = _context7.t0 === 'PayPal' ? 3 : _context7.t0 === 'Square' ? 4 : 7;
                                break;

                            case 3:
                                return _context7.abrupt('return', this._onPaypalSelected());

                            case 4:
                                _context7.next = 6;
                                return this._onCreditCardSelected();

                            case 6:
                                return _context7.abrupt('return', _context7.sent);

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function _acceptPaymentInformation() {
                return _ref7.apply(this, arguments);
            }

            return _acceptPaymentInformation;
        }()
    }, {
        key: '_onPaymentSystemChanged',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(paymentSystem) {
                var paymentConfiguration;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (paymentSystem) {
                                    _context8.next = 3;
                                    break;
                                }

                                this._scope.processingPayment = false;
                                return _context8.abrupt('return', null);

                            case 3:

                                this._scope.processingPayment = true;
                                this._scope.paymentSystemError = '';
                                _scope2.default.apply(this._scope);

                                _context8.prev = 6;
                                _context8.next = 9;
                                return this._groupOrderService.save();

                            case 9:
                                _context8.next = 11;
                                return this._checkoutService.beginCheckout(paymentSystem);

                            case 11:
                                paymentConfiguration = _context8.sent;

                                this._scope.configuration.vendorDetails.clientToken = paymentConfiguration.clientToken;
                                _context8.next = 18;
                                break;

                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8['catch'](6);

                                this._scope.paymentSystemError = this._messageService.getMessageFromErrorResponse(_context8.t0);

                            case 18:

                                this._scope.processingPayment = false;
                                _scope2.default.apply(this._scope);

                            case 20:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this, [[6, 15]]);
            }));

            function _onPaymentSystemChanged(_x3) {
                return _ref8.apply(this, arguments);
            }

            return _onPaymentSystemChanged;
        }()
    }]);

    return OrderTabBudgetController;
}();

OrderTabBudgetController.$inject = ['$scope', 'cartonomyConfig', '$filter', 'OrderDateService', 'CheckoutService', 'CartService', 'GroupOrder', '$location', '$window', 'Message'];


_module3.default.controller('OrderTabBudget', OrderTabBudgetController);

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// import module from '../module';
// import Constants from '../../../utils/CommonConstants';
// import states from '../../../resources/data/states.json';
// import moment from 'moment';
//
// function OrderTabDeliveryAddressController($scope, $window, configurationService, orderDateServicePromise, userProfileService, groupOrderService) {
//
//
//     let getTimeValues = function () {
//         return [];
//     };
//
//     let joinDateTime = function () {
//         return null;
//     };
//
//     $scope.pickupLocations = [];
//     $scope.timeValues = [];
//     $scope.minimumDate = new Date();
//     $scope.maximumDate = new Date();
//     $scope.acceptedDateFilter = function () {
//         return true;
//     };
//     $scope.states = states;
//
//     $scope.configuration = {
//         delivery: groupOrderService.getDeliveryMode(),
//         deliveryDetails: groupOrderService.getDeliveryDetails(),
//         deliveryAddress: groupOrderService.getDeliveryAddress(),
//         selectedDeliveryAddress: groupOrderService.getSelectedDeliveryAddress()
//     };
//
//     function saveAndGotoNext() {
//         groupOrderService.setDeliveryDetails($scope.configuration.deliveryDetails);
//         groupOrderService.setDeliveryAddress($scope.configuration.deliveryAddress);
//         groupOrderService.setSelectedDeliveryAddress($scope.configuration.selectedDeliveryAddress);
//         $scope.next();
//     }
//
//     $scope.$watch('configuration.deliveryDetails.date', function () {
//         $scope.timeValues = getTimeValues($scope.configuration.deliveryDetails.date);
//     });
//
//     $scope.$watch('configuration.deliveryDetails.accepted', function () {
//         if ($scope.configuration.deliveryDetails.accepted && $scope.selectDeliveryPhone) {
//             $scope.selectDeliveryPhone({selectAll: $scope.configuration.deliveryDetails.phone});
//         }
//     });
//
//     function resetDeliveryAddress() {
//         $scope.configuration.deliveryAddress = {
//             city: '',
//             state: '',
//             street: '',
//             zip: '',
//             aptSuite: '',
//             entered: false
//         };
//     }
//
//     function resetDeliveryDetails() {
//         $scope.configuration.deliveryDetails = {
//             date: $scope.minimumDate,
//             time: null,
//             deliveryTime: '',
//             deliveryTimeFormatted: '',
//             deadlineTime: '',
//             deadlineTimeFormatted: '',
//             phone: '',
//             entered: false,
//             accepted: false,
//             pickupLocation: ''
//         };
//     }
//
//     $scope.rejectDeliveryAddress = function () {
//         $scope.configuration.deliveryAddress.entered = false;
//     };
//
//     $scope.acceptDeliveryAddress = function (form) {
//         if (!form.$valid) {
//             form.highlightAllErrors();
//             return;
//         }
//
//         $scope.configuration.deliveryAddress.entered = true;
//     };
//
//     $scope.deliveryAddressSelected = function () {
//
//         if (!$scope.configuration.selectedDeliveryAddress) {
//             $scope.rejectDeliveryAddress();
//             return;
//         }
//
//         let selected = $scope.configuration.selectedDeliveryAddress;
//
//         if (selected.id === 0) {
//             resetDeliveryAddress();
//             return;
//         }
//
//         selected = selected.source;
//
//         let deliveryAddress = $scope.configuration.deliveryAddress;
//
//         deliveryAddress.entered = true;
//         deliveryAddress.city = selected.city;
//         deliveryAddress.state = selected.state;
//         deliveryAddress.zip = selected.zip;
//         deliveryAddress.street = selected.address;
//         deliveryAddress.aptSuite = selected.address2;
//     };
//
//     $scope.rejectPickupLocation = function () {
//         $scope.configuration.deliveryAddress.entered = false;
//     };
//
//     $scope.acceptPickupLocation = function (form) {
//         if (!form.$valid) {
//             form.pickupLocation.$setTouched();
//             return;
//         }
//
//         $scope.configuration.deliveryAddress.entered = true;
//     };
//
//     $scope.rejectDeliveryDetails = function () {
//         $scope.configuration.deliveryDetails.entered = false;
//         $scope.configuration.deliveryDetails.accepted = false;
//     };
//
//     $scope.checkDeliveryDetails = function (form) {
//
//         if (!form.$valid) {
//             form.highlightAllErrors();
//             return;
//         }
//
//         const deliveryDetails = $scope.configuration.deliveryDetails;
//
//         // deliveryDetails.deliveryTime = joinDateTime(deliveryDetails.date, deliveryDetails.time);
//         // deliveryDetails.deliveryTimeFormatted = moment(deliveryDetails.deliveryTime).format('LT');
//         //
//         // deliveryDetails.deadlineTime = moment(deliveryDetails.deliveryTime).subtract($scope.configuration.delivery ? 60 : 30, 'minutes').toDate();
//         // deliveryDetails.deadlineTimeFormatted = moment(deliveryDetails.deadlineTime).format('LT');
//         //
//         // $scope.configuration.deliveryDetails.placeDate = deliveryDetails.deadlineTime;
//         // $scope.configuration.deliveryDetails.placeTime = moment(deliveryDetails.deadlineTime).toISOString();
//
//         deliveryDetails.entered = true;
//     };
//
//     $scope.acceptDeliveryPhone = async function (form) {
//
//         if (!form.$valid) {
//             form.deliveryPhone.$setTouched();
//             return null;
//         }
//
//         $window.sessionStorage.setItem(Constants.SessionStorage.DELIVERY_PHONE, $scope.configuration.deliveryDetails.phone);
//
//         let address = $scope.configuration.selectedDeliveryAddress;
//
//         if (address && address.id !== 0) {
//             $window.sessionStorage.setItem(Constants.SessionStorage.DELIVERY_ADDRESS, address.id);
//             saveAndGotoNext();
//             return null;
//         }
//
//         address = $scope.configuration.deliveryAddress;
//
//         await userProfileService.createAddress({
//             address: address.street,
//             address2: address.aptSuite,
//             city: address.city,
//             state: address.state,
//             zip: address.zip
//         });
//
//         saveAndGotoNext();
//     };
//
//     this.$onInit = () => {
//         configurationService.getItem('pickupAddress').then((pickupAddress) => {
//             $scope.pickupLocations = [
//                 {address: pickupAddress}
//             ];
//         });
//
//         orderDateServicePromise.then(function (orderDateService) {
//             orderDateService = orderDateService($scope.configuration.delivery ? 75 : 45);
//             $scope.minimumDate = orderDateService.getMinimumDate();
//             $scope.maximumDate = orderDateService.getMaximumDate();
//             $scope.acceptedDateFilter = orderDateService.getDateInRangeFilter();
//             getTimeValues = orderDateService.getTimeValues;
//             $scope.timeValues = getTimeValues($scope.configuration.deliveryDetails.date);
//             joinDateTime = orderDateService.joinDateAndTime;
//         });
//
//         if (!$scope.configuration.deliveryDetails.time && $scope.configuration.deliveryDetails.deliveryTime) {
//             // const time = moment.utc($scope.configuration.deliveryDetails.deliveryTime);
//             $scope.configuration.deliveryDetails.date = time.toDate();
//             $scope.configuration.deliveryDetails.time = time.toISOString();
//         }
//
//
//         if (!$scope.configuration.deliveryDetails) {
//             resetDeliveryDetails();
//         }
//
//         const phone = $window.sessionStorage.getItem(Constants.SessionStorage.DELIVERY_PHONE);
//         if (phone) {
//             $scope.configuration.deliveryDetails.phone = phone;
//         }
//
//         if (!$scope.configuration.deliveryAddress) {
//             resetDeliveryAddress();
//         }
//
//         if ($scope.deliveryAddresses && $scope.deliveryAddresses.length > 1 && !$scope.configuration.selectedDeliveryAddress) {
//
//             const deliveryAddressId = $window.sessionStorage.getItem(Constants.SessionStorage.DELIVERY_ADDRESS);
//
//             if (deliveryAddressId) {
//                 const deliveryAddress = $scope.deliveryAddresses.find(a => a.id == deliveryAddressId);
//                 if (deliveryAddress) {
//                     $scope.configuration.selectedDeliveryAddress = deliveryAddress;
//                     $scope.deliveryAddressSelected();
//                 }
//             }
//         }
//     };
// }
//
// module.controller('OrderTabDeliveryAddress', ['$scope', '$window', 'ConfigurationService', 'OrderDateService', 'UserProfile', 'GroupOrder', OrderTabDeliveryAddressController]);


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OrderTabFinishController($scope, cartonomyConfig, userProfile, session, groupOrderService) {

    session.getUserName().then(function (ownerEmail) {
        $scope.orderOwnerEmail = ownerEmail;
    });
    $scope.orderOwnerName = $scope.orderOwnerEmail;
    $scope.externalStoreMode = cartonomyConfig.externalStoreMode;

    $scope.configuration = {
        groupPay: groupOrderService.getGroupPay(),
        singlePayOrder: groupOrderService.getSinglePayOrder(),
        deliveryDetails: groupOrderService.getDeliveryDetails()
    };

    $scope.deadlineTime = (0, _moment2.default)($scope.configuration.deliveryDetails.deadlineTime).format('LT [on] MMMM D, YYYY');

    if ((0, _moment2.default)($scope.configuration.deliveryDetails.deadlineTime).isValid()) {
        $scope.deadlineTimeText = (0, _moment2.default)($scope.configuration.deliveryDetails.deadlineTime).format('LT [on] MMMM D, YYYY');
    }

    userProfile.getUser().then(function (user) {
        $scope.orderOwnerName = _.trim(user.firstName + ' ' + user.lastName);
    });
}

_module3.default.controller('OrderTabFinish', ['$scope', 'cartonomyConfig', 'UserProfile', 'Session', 'GroupOrder', OrderTabFinishController]);

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OrderTabPayModeController($scope, groupOrderService) {

    $scope.configuration = {
        groupPay: groupOrderService.getGroupPay()
    };

    $scope.selectGroupPay = function (mode) {

        groupOrderService.setGroupPay(mode);
        groupOrderService.setSinglePayOrder(groupOrderService.getSinglePayOrder() || {});

        if (!mode) {
            $scope.cancelPreview();
        }

        $scope.next();
    };
}

_module3.default.controller('OrderTabPayMode', ['$scope', 'GroupOrder', OrderTabPayModeController]);

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OrderTabPaymentDetailsController($scope, groupOrderService) {

    $scope.configuration.singlePayOrder = groupOrderService.getSinglePayOrder() || {};

    $scope.acceptPaymentDetails = function (form) {

        if (!form.$valid) {
            form.highlightAllErrors();
            return;
        }

        $scope.next();
    };
}

_module3.default.controller('OrderTabPaymentDetails', ['$scope', 'GroupOrder', OrderTabPaymentDetailsController]);

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderTabPreviewController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _communicationService = __webpack_require__(28);

var _commandKeys = __webpack_require__(27);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(802);

var OrderTabPreviewController = exports.OrderTabPreviewController = function () {
  function OrderTabPreviewController(scope, cartonomyConfig, cartService, qService, messageService, configurationService, groupOrderService, checkoutService, rootScope, mdSelect, $translate) {
    var _this = this;

    _classCallCheck(this, OrderTabPreviewController);

    this._deadlineExpired = function () {
      if (!_this._scope.configuration.deliveryDetails.deadlineTime) {
        return false;
      }
      var deadlineTime = (0, _moment2.default)(_this._scope.configuration.deliveryDetails.deadlineTime).subtract(15, 'minutes').toDate();
      return (0, _moment2.default)().isAfter(deadlineTime);
    };

    this.__mdSelectBackdropCallback = function () {
      _this._mdSelect.hide();
    };

    this._scope = scope;

    this._cartService = cartService;
    this._cartonomyConfig = cartonomyConfig;
    this._qService = qService;
    this._messageService = messageService;
    this._groupOrderService = groupOrderService;
    this._configurationService = configurationService;
    this._checkoutService = checkoutService;
    this._rootScope = rootScope;
    this._mdSelect = mdSelect;
    this.$translate = $translate;

    scope.externalStoreMode = cartonomyConfig.externalStoreMode;
    scope.maxAllowedBudget = 100000;

    scope.readOnly = false;
    scope.errorMessage = '';

    scope.editDeliveryInfo = function () {
      return scope.previewTab('deliveryAddress');
    };
    scope.editOrderDeadline = function () {
      return scope.previewTab('deadline');
    };
    scope.editInvitees = function () {
      return scope.previewTab('addPeople');
    };
    scope.editBudget = function () {
      return scope.previewTab('budget');
    };
    scope.createOrderAndSendInvites = function () {
      return _this._createOrderAndSendInvites();
    };
    scope.acceptSinglePayOrderNoBudget = function (form) {
      return _this._acceptSinglePayOrderNoBudget(form);
    };
    scope.acceptSinglePayOrderNoPayment = function (form) {
      return _this._acceptSinglePayOrderNoPayment(form);
    };
    scope.onBudgetChanged = function () {
      return _this._onBudgetChanged();
    };
    scope.acceptSinglePayOrderBudget = function (form) {
      return _this._acceptSinglePayOrderBudget(form);
    };
    scope.acceptPaymentInformation = function () {
      return _this._acceptPaymentInformation();
    };
    scope.shouldDisablePaymentInformationNextButton = function () {
      return _this._shouldDisablePaymentInformationNextButton();
    };
    scope.saveAndGoNext = function () {
      return _this._saveAndGoNext();
    };
    scope.onDeadlineDateChanged = function () {
      return _this._onDeadlineDateChanged();
    };
    scope.onMdSelectOpen = function () {
      return _this._onMdSelectOpen();
    };
    scope.onMdSelectClose = function () {
      return _this._onMdSelectClose();
    };

    scope.cartNameChange = function () {
      return _this._cartNameChange();
    };
    scope.orderModel = {
      cartNameValue: $translate.instant(_CommonConstants2.default.CART_NAME_DEFAULT_VALUE),
      isValid: true,
      deadlineDate: null,
      deadlineTime: null,
      customCartName: '0'
    };

    scope.deliverTimeValues = [];

    scope.modelValidation = {
      budget: true,
      deadlineDate: true,
      deadlineTime: true,
      deliveryDate: true
    };

    scope.isGeneralMillsPOC = false;

    scope.currencySymbol = this._rootScope.moneyFormat.replace('{{amount}}', '');

    scope.$watch('configuration.paymentSystem', function (paymentSystem) {
      return _this._onPaymentSystemChanged(paymentSystem);
    });
  }

  _createClass(OrderTabPreviewController, [{
    key: '$onInit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._scope.orderModel.customCartName = this._rootScope.retailer.customCartNames;
                this._scope.configuration = {
                  delivery: this._groupOrderService.getDeliveryMode(),
                  groupPay: this._groupOrderService.getGroupPay(),
                  paymentMethod: _CommonConstants2.default.CartDetails.PaymentMethods.SINGLE,
                  singlePayOrder: this._groupOrderService.getSinglePayOrder(),
                  contactDetails: this._groupOrderService.getContactDetails(),
                  deliveryDetails: this._groupOrderService.getDeliveryDetails(),
                  deliveryAddress: this._groupOrderService.getDeliveryAddress()
                };

                this._scope.canChangeDeadline = this._rootScope.retailer.cartonomyMode !== _CommonConstants2.default.CartonomyMode.marketing;
                this._scope.hasDeliveryDate = this._rootScope.retailer.hasDeliveryDate;
                this._scope.createInstruction = this._rootScope.retailer.cartonomyMode === _CommonConstants2.default.CartonomyMode.marketing ? 'client.user.marketing' : 'client.user.marketing_link';
                this._scope.marketingMode = this._rootScope.retailer.cartonomyMode === _CommonConstants2.default.CartonomyMode.marketing;

                this._scope.invitedPeopleCount = this._scope.configuration.contactDetails != null ? this._scope.configuration.contactDetails.selectedEmails.length : 0;
                if (!this._scope.configuration.delivery) {
                  this._scope.pickup = {};
                  this._configurationService.getItem('pickupAddress').then(function (pickupAddress) {
                    _this2._scope.pickup.address = pickupAddress;
                    _scope2.default.apply(_this2._scope);
                  });
                }

                if (!this._scope._editMode) {
                  _context.next = 14;
                  break;
                }

                _context.next = 11;
                return this._cartService.getCart();

              case 11:
                this.cart = _context.sent;

                this._scope.orderModel.cartNameValue = this.cart.cartName || this.$translate.instant(_CommonConstants2.default.CART_NAME_DEFAULT_VALUE);

                if (!this._scope.configuration.singlePayOrder.budget) {
                  this._scope.configuration.singlePayOrder.budget = this.cart.orderLimit;
                }

              case 14:

                if (_.isString(this._scope.configuration.singlePayOrder.budget) && this._scope.configuration.singlePayOrder.budget.match(/^\d/) || this._scope.configuration.singlePayOrder.budget > 0) {
                  this._scope.configuration.singlePayOrder.budget = parseFloat(this._scope.configuration.singlePayOrder.budget);
                  this._scope.configuration.singlePayOrder.defineBudget = 'yes';
                  this._scope.configuration.singlePayOrder.budgetEntered = true;
                } else {
                  this._scope.configuration.singlePayOrder.budget = "";
                  this._scope.configuration.singlePayOrder.defineBudget = 'no';
                }

                _context.next = 17;
                return this._checkoutService.paymentAuthorizedOrCaptured();

              case 17:
                this._scope.configuration.paymentProvided = _context.sent;


                if (this._scope.externalStoreMode && !this._scope.configuration.singlePayOrder.enterPaymentInformation) {
                  this._scope.configuration.singlePayOrder.enterPaymentInformation = 'no';
                }

                //Retailer Link
                this.retailer = this._configurationService.getRetailer().retailer;
                this.retailerTimezone = this.retailer.timeZoneSettingName;
                _context.next = 23;
                return this._setupDeliveryTime();

              case 23:

                this._scope.isSelectPaymentType = this.retailer.paymentType === _CommonConstants2.default.CartDetails.PaymentMethods.USER_SELECT;
                this._scope.isSelectBudgetType = this.retailer.budgetType === _CommonConstants2.default.CartDetails.BudgetTypes.USER_SELECT;
                this._scope.isGeneralMillsPOC = this.retailer && _CommonConstants2.default.GENERAL_MILLS_POC.some(function (poc) {
                  return _this2.retailer.name.indexOf(poc) > -1;
                });

                this._scope.configuration.singlePayOrder.budgetType = this._scope.isSelectBudgetType ? _CommonConstants2.default.CartDetails.BudgetTypes.PER_CART : this.retailer.budgetType;

                _scope2.default.apply(this._scope);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function $onInit() {
        return _ref.apply(this, arguments);
      }

      return $onInit;
    }()
  }, {
    key: '_createOrderAndSendInvites',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this._scope.hasDeliveryDate && !this._scope.configuration.deliveryDetails.deliveryTime)) {
                  _context2.next = 3;
                  break;
                }

                this._scope.modelValidation.deliveryDate = false;
                return _context2.abrupt('return');

              case 3:
                _context2.next = 5;
                return _communicationService.communicationService.requestToParent(_commandKeys.commandKeys.createNewGroupOrder);

              case 5:
                response = _context2.sent;

                if (!(!response || !response.success)) {
                  _context2.next = 10;
                  break;
                }

                this._scope.errorMessage = response && response.errorMessage || this.$translate.instant('client.order.error_parent');
                this._scope.readOnly = true;
                return _context2.abrupt('return');

              case 10:
                if (!this._deadlineExpired()) {
                  _context2.next = 14;
                  break;
                }

                this._scope.errorMessage = this.$translate.instant('client.order.deadline_expired', { delivery: this._scope.configuration.delivery ? 'delivery' : 'pickup' });
                this._scope.readOnly = true;
                return _context2.abrupt('return');

              case 14:

                this._scope.readOnly = true;
                this._scope.errorMessage = '';

                _context2.prev = 16;
                _context2.next = 19;
                return this._cartService.setInvitationType(_CommonConstants2.default.InvitationTypes.share);

              case 19:
                _context2.next = 21;
                return this._submitOrder(response.data);

              case 21:
                _context2.prev = 21;

                this._scope.readOnly = false;
                return _context2.finish(21);

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[16,, 21, 24]]);
      }));

      function _createOrderAndSendInvites() {
        return _ref2.apply(this, arguments);
      }

      return _createOrderAndSendInvites;
    }()
  }, {
    key: '_submitOrder',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._scope.invitationCode = this._cartService.getInviteCode();

                if (this._scope.invitationCode) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 4;
                return this._cartService.getInvitationCode();

              case 4:
                this._scope.invitationCode = _context3.sent;

                this._cartService.setInviteCode(this._scope.invitationCode);
                this._cartService.setInvitationType(_CommonConstants2.default.InvitationTypes.share);

              case 7:
                _context3.next = 9;
                return this._saveOrderInfo();

              case 9:
                if (this._isModelValid()) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt('return');

              case 11:

                this._groupOrderService.setDeliveryDetails(this._scope.configuration.deliveryDetails);

                _context3.prev = 12;
                _context3.next = 15;
                return this._groupOrderService.save(data);

              case 15:
                _context3.next = 17;
                return this._groupOrderService.sendInvites();

              case 17:
                _context3.next = 19;
                return this._cartService.resetCart();

              case 19:
                this._scope.setCurrentTabById('finish');
                _scope2.default.apply(this._scope);
                _context3.next = 26;
                break;

              case 23:
                _context3.prev = 23;
                _context3.t0 = _context3['catch'](12);

                this._scope.errorMessage = this._messageService.getMessageFromErrorResponse(_context3.t0) || this.$translate.instant('client.order.cart_not_update');

              case 26:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[12, 23]]);
      }));

      function _submitOrder(_x) {
        return _ref3.apply(this, arguments);
      }

      return _submitOrder;
    }()
  }, {
    key: '_saveAndGoNext',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this._isModelValid()) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                _context4.next = 4;
                return this._saveOrderInfo();

              case 4:
                this._scope.next();

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _saveAndGoNext() {
        return _ref4.apply(this, arguments);
      }

      return _saveAndGoNext;
    }()
  }, {
    key: '_saveOrderInfo',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this._scope._editMode && this._scope.configuration.singlePayOrder.budget && this.cart.cartTotal < this._scope.configuration.singlePayOrder.budget) {
                  this._scope.configuration.singlePayOrder.budgetInvalid = true;
                }

                if (!this._scope.configuration.singlePayOrder.budget) {
                  _context5.next = 6;
                  break;
                }

                _context5.next = 4;
                return this._acceptSinglePayOrderBudget();

              case 4:
                _context5.next = 8;
                break;

              case 6:
                _context5.next = 8;
                return this._acceptSinglePayOrderNoBudget();

              case 8:
                _context5.next = 10;
                return this.saveDeadline();

              case 10:
                _context5.next = 12;
                return this.saveCartName();

              case 12:
                this._groupOrderService.setPaymentMethod(this._scope.configuration.paymentMethod);

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _saveOrderInfo() {
        return _ref5.apply(this, arguments);
      }

      return _saveOrderInfo;
    }()
  }, {
    key: '_setupDeliveryTime',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this3 = this;

        var placeDateAndTime, minimumTime, minimumDeliveryTime, minimumDate, maximumTime, maximumDate, getTimeValues, timeValues;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this._scope.configuration.deliveryDetails.placeDateAndTime = this._scope.configuration.deliveryDetails.placeDateAndTime || this._scope.configuration.deliveryDetails.deadlineTime;

                placeDateAndTime = this._scope.configuration.deliveryDetails.placeDateAndTime;

                this._scope.closeOn = placeDateAndTime ? _moment2.default.tz(placeDateAndTime, this.retailerTimezone).format('ddd[,] MMM Do[,] LT') + this.retailer.timeZoneDisplayName : '';

                minimumTime = (0, _moment2.default)().add(15, 'minutes');
                minimumDeliveryTime = (0, _moment2.default)().add(90, 'minutes');
                minimumDate = _moment2.default.tz(minimumTime, this.retailerTimezone).startOf('day');
                maximumTime = null;


                if (!this._scope._editMode || this._cartonomyConfig.externalStoreMode) {
                  maximumTime = (0, _moment2.default)().clone().add('3', 'years').endOf('day');
                } else if (this._scope.configuration.deliveryDetails.deadlineTime && !this._cartonomyConfig.externalStoreMode) {
                  maximumTime = (0, _moment2.default)(this._scope.configuration.deliveryDetails.deadlineTime);
                } else {
                  maximumTime = (0, _moment2.default)().clone().endOf('day');
                }

                maximumDate = maximumTime.clone().endOf('day');


                this._scope.minimumDate = minimumDate.toDate();
                this._scope.maximumDate = maximumDate.toDate();

                if (placeDateAndTime) {
                  this._scope.configuration.deliveryDetails.placeDate = (0, _moment2.default)(placeDateAndTime).toDate();
                }

                if (placeDateAndTime && (0, _moment2.default)(placeDateAndTime).isValid()) {
                  this._scope.configuration.deliveryDetails.placeTime = (0, _moment2.default)(placeDateAndTime).format();

                  this._scope.configuration.deliveryDetails.defineDeadline = true;
                } else {
                  this._scope.configuration.deliveryDetails.defineDeadline = false;
                }

                getTimeValues = function getTimeValues(date, minimumTime, maximumTime) {

                  var currentDate = (0, _moment2.default)(date).startOf('day');
                  var endDate = currentDate.clone().endOf('day');

                  var list = [];

                  for (; currentDate.isSameOrBefore(endDate); currentDate.add(30, 'minutes')) {
                    var _minimumTime = (0, _moment2.default)(minimumTime);
                    var _maximumTime = (0, _moment2.default)(maximumTime);
                    if (currentDate.isBetween(_minimumTime, _maximumTime, 'minutes', '[]')) {

                      var value = currentDate.format();
                      list.push({
                        text: currentDate.format('LT'),
                        value: value
                      });
                    }
                  }

                  return list;
                };

                this._scope.acceptedDateFilter = function (date) {
                  date = (0, _moment2.default)(date).format('YYYY-MM-DD');
                  date = _moment2.default.tz(date, _this3.retailerTimezone);
                  return date.isSameOrAfter(minimumDate);
                };

                // regular mode will have expire time assigned, shopify mode should not have
                if (!this._cartonomyConfig.externalStoreMode) {
                  timeValues = getTimeValues(maximumDate, minimumTime, maximumTime);


                  if (timeValues.length && !placeDateAndTime) {
                    this._scope.configuration.deliveryDetails.placeTime = timeValues[timeValues.length - 1].value;
                  }
                }

                if (this._scope.configuration.deliveryDetails.deliveryDate) {
                  this._scope.configuration.deliveryDetails._deliveryDate = _moment2.default.utc(this._scope.configuration.deliveryDetails.deliveryDate).local().toDate();
                  this._scope.configuration.deliveryDetails.deliveryTime = _moment2.default.utc(this._scope.configuration.deliveryDetails.deliveryTime).local().format();
                }

                this._scope.$watch('configuration.deliveryDetails._deliveryDate', function (newValue) {
                  if (!newValue) return;

                  _this3._scope.configuration.deliveryDetails.deliveryDate = _this3._scope.configuration.deliveryDetails._deliveryDate;
                  _this3._scope.deliverTimeValues = getTimeValues(newValue, minimumDeliveryTime, maximumDate);

                  if (_this3._scope.configuration.deliveryDetails.deliveryTime && _moment2.default.utc(_this3._scope.configuration.deliveryDetails.deliveryTime).local().isSame(_moment2.default.utc(_this3._scope.configuration.deliveryDetails._deliveryDate).local(), 'day')) {
                    _this3._scope.configuration.deliveryDetails.deliveryTime = _moment2.default.utc(_this3._scope.configuration.deliveryDetails.deliveryTime).local().format();
                  } else {
                    _this3._scope.configuration.deliveryDetails.deliveryTime = _this3._scope.deliverTimeValues[0].value;
                  }
                  _scope2.default.apply(_this3._scope);
                });

                this._scope.$watch('configuration.deliveryDetails.placeDate', function (newValue) {
                  if (!newValue) return;

                  var timeValues = getTimeValues(newValue, minimumTime, maximumTime);
                  _this3._scope.timeValues = timeValues;

                  if (!placeDateAndTime) {
                    _this3._scope.configuration.deliveryDetails.placeTime = timeValues[timeValues.length - 1].value;
                  }
                  _scope2.default.apply(_this3._scope);
                });

              case 19:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _setupDeliveryTime() {
        return _ref6.apply(this, arguments);
      }

      return _setupDeliveryTime;
    }()
  }, {
    key: '_acceptPaymentInformation',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.t0 = this._scope.configuration.paymentSystem;
                _context7.next = _context7.t0 === 'PayPal' ? 3 : _context7.t0 === 'Square' ? 4 : 7;
                break;

              case 3:
                return _context7.abrupt('return', this._onPaypalSelected());

              case 4:
                _context7.next = 6;
                return this._onCreditCardSelected();

              case 6:
                return _context7.abrupt('return', _context7.sent);

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _acceptPaymentInformation() {
        return _ref7.apply(this, arguments);
      }

      return _acceptPaymentInformation;
    }()
  }, {
    key: '_acceptSinglePayOrderNoPayment',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this._scope.budgetExceeds = false;
                this._scope.budgetMaximumReach = false;
                _context8.next = 4;
                return this._onBudgetChanged();

              case 4:

                if (!this._scope.budgetExceeds && !this._scope.budgetMaximumReach) {
                  this.saveBudget();
                }

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function _acceptSinglePayOrderNoPayment() {
        return _ref8.apply(this, arguments);
      }

      return _acceptSinglePayOrderNoPayment;
    }()
  }, {
    key: '_onBudgetChanged',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var currentAmount;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this._scope.configuration.singlePayOrder.budget && _.isString(this._scope.configuration.singlePayOrder.budget)) {
                  this._scope.configuration.singlePayOrder.budget = this._scope.configuration.singlePayOrder.budget.replace(/[^0-9.]/g, "");
                  this._scope.configuration.singlePayOrder.budgetEntered = true;
                } else {
                  this._scope.configuration.singlePayOrder.budgetEntered = false;
                }

                if (this._scope.externalStoreMode && !this._scope.configuration.singlePayOrder.enterPaymentInformation) {
                  this._scope.configuration.singlePayOrder.enterPaymentInformation = 'no';
                }

                this._scope.budgetExceeds = false;
                this._scope.budgetMaximumReach = false;

                _context9.next = 6;
                return this._cartService.getCartAmount();

              case 6:
                currentAmount = _context9.sent;

                if (this._scope.configuration.singlePayOrder.budget < currentAmount) {
                  this._scope.budgetExceeds = currentAmount;
                }
                if (this._scope.configuration.singlePayOrder.budget > this._scope.maxAllowedBudget) {
                  this._scope.budgetMaximumReach = true;
                }
                this._scope.modelValidation.budget = !(!!this._scope.configuration.singlePayOrder.budget && (this._scope.budgetExceeds || this._scope.budgetMaximumReach));
                _scope2.default.apply(this._scope);

              case 11:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function _onBudgetChanged() {
        return _ref9.apply(this, arguments);
      }

      return _onBudgetChanged;
    }()
  }, {
    key: '_acceptSinglePayOrderBudget',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!_.isString(this._scope.configuration.singlePayOrder.budget)) {
                  _context10.next = 5;
                  break;
                }

                this._scope.configuration.singlePayOrder.budget = this._scope.configuration.singlePayOrder.budget.replace(/[^0-9.]/g, "");
                this._scope.configuration.singlePayOrder.budgetEntered = true;
                _context10.next = 7;
                break;

              case 5:
                _context10.next = 7;
                return this.saveBudget();

              case 7:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function _acceptSinglePayOrderBudget() {
        return _ref10.apply(this, arguments);
      }

      return _acceptSinglePayOrderBudget;
    }()
  }, {
    key: '_acceptSinglePayOrderNoBudget',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this._scope.configuration.singlePayOrder.budget = 0;
                _context11.next = 3;
                return this.saveBudget();

              case 3:
                _scope2.default.apply(this._scope);

              case 4:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function _acceptSinglePayOrderNoBudget() {
        return _ref11.apply(this, arguments);
      }

      return _acceptSinglePayOrderNoBudget;
    }()
  }, {
    key: '_shouldDisablePaymentInformationNextButton',
    value: function _shouldDisablePaymentInformationNextButton() {
      if (!this._scope.configuration.paymentSystem) {
        return true;
      }

      if (this._scope.configuration.paymentSystem && this._scope.configuration.paymentSystem == 'PayPal' && !this._scope.configuration.vendorDetails.clientToken) {

        return true;
      }

      return this._scope.configuration.paymentSystem == '';
    }
  }, {
    key: '_onPaypalSelected',
    value: function _onPaypalSelected() {
      this._scope.processingPayment = true;
      this.saveBudget();
      this._groupOrderService.saveToSessionStorage();
      window.location.href = _CommonConstants2.default.PAYPAL_CHECKOUT_URL + this._scope.configuration.vendorDetails.clientToken;
    }
  }, {
    key: '_onCreditCardSelected',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:

                this._scope.processingPayment = true;
                this._scope.paymentSystemError = '';
                _scope2.default.apply(this._scope);

                _context12.prev = 3;
                _context12.next = 6;
                return this._scope.configuration.getCardNonce();

              case 6:
                this._scope.configuration.vendorDetails = _context12.sent;

                this._scope.configuration.vendorDetails.isAuthorization = true;
                this._scope.configuration.vendorDetails.orderTotal = this._scope.configuration.singlePayOrder.budget;

                _context12.next = 11;
                return this._checkoutService.submitOrder(this._scope.configuration.paymentSystem, this._scope.configuration.vendorDetails);

              case 11:
                _context12.next = 19;
                break;

              case 13:
                _context12.prev = 13;
                _context12.t0 = _context12['catch'](3);

                this._scope.paymentSystemError = "client.payment.credit_trans_not_approved";

                this._scope.processingPayment = false;
                _scope2.default.apply(this._scope);
                return _context12.abrupt('return', null);

              case 19:

                this._scope.processingPayment = false;
                _scope2.default.apply(this._scope);

                this.saveBudget();

              case 22:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this, [[3, 13]]);
      }));

      function _onCreditCardSelected() {
        return _ref12.apply(this, arguments);
      }

      return _onCreditCardSelected;
    }()
  }, {
    key: '_onPaymentSystemChanged',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(paymentSystem) {
        var paymentConfiguration;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (paymentSystem) {
                  _context13.next = 3;
                  break;
                }

                this._scope.processingPayment = false;
                return _context13.abrupt('return', null);

              case 3:

                this._scope.processingPayment = true;
                this._scope.paymentSystemError = '';
                _scope2.default.apply(this._scope);

                _context13.prev = 6;
                _context13.next = 9;
                return this._groupOrderService.save();

              case 9:
                _context13.next = 11;
                return this._checkoutService.beginCheckout(paymentSystem);

              case 11:
                paymentConfiguration = _context13.sent;

                this._scope.configuration.vendorDetails.clientToken = paymentConfiguration.clientToken;
                _context13.next = 18;
                break;

              case 15:
                _context13.prev = 15;
                _context13.t0 = _context13['catch'](6);

                this._scope.paymentSystemError = this._messageService.getMessageFromErrorResponse(_context13.t0);

              case 18:

                this._scope.processingPayment = false;
                _scope2.default.apply(this._scope);

              case 20:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this, [[6, 15]]);
      }));

      function _onPaymentSystemChanged(_x2) {
        return _ref13.apply(this, arguments);
      }

      return _onPaymentSystemChanged;
    }()
  }, {
    key: '_cartNameChange',
    value: function _cartNameChange() {
      if (!this._scope.orderModel.cartNameValue) {
        this._scope.orderModel.isValid = false;
      } else {
        this._scope.orderModel.isValid = true;
      }
    }
  }, {
    key: 'addEventListenerOnce',
    value: function addEventListenerOnce(target, type, listener, addOptions, removeOptions) {
      target.addEventListener(type, function fn(event) {
        target.removeEventListener(type, fn, removeOptions);
        listener.apply(this, arguments);
      }, addOptions);
    }
  }, {
    key: '_onMdSelectOpen',
    value: function _onMdSelectOpen() {
      var _this4 = this;

      setTimeout(function () {
        _this4.addEventListenerOnce(document, "click", _this4.__mdSelectBackdropCallback, true);
      }, 500);
    }
  }, {
    key: '_onMdSelectClose',
    value: function _onMdSelectClose() {
      document.removeEventListener("click", this.__mdSelectBackdropCallback, true);
    }
  }, {
    key: '_onDeadlineDateChanged',
    value: function _onDeadlineDateChanged() {
      this._scope.modelValidation.deadlineDate = !this._scope.configuration.deliveryDetails.placeTime && !this._scope.configuration.deliveryDetails.placeDate || !this._scope.configuration.deliveryDetails.placeTime || this._scope.configuration.deliveryDetails.placeDate;
      this._scope.modelValidation.deadlineTime = !this._scope.configuration.deliveryDetails.placeTime && !this._scope.configuration.deliveryDetails.placeDate || this._scope.configuration.deliveryDetails.placeTime || !this._scope.configuration.deliveryDetails.placeDate;
    }
  }, {
    key: 'saveBudget',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this._groupOrderService.setSinglePayOrder(this._scope.configuration.singlePayOrder);
                this._groupOrderService.setVendorDetails(this._scope.configuration.vendorDetails);
                this._groupOrderService.setPaymentSystem(this._scope.configuration.paymentSystem);

              case 3:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function saveBudget() {
        return _ref14.apply(this, arguments);
      }

      return saveBudget;
    }()
  }, {
    key: 'saveDeadline',
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var deadline, time;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (this._scope.configuration.deliveryDetails.placeDate) {
                  deadline = (0, _moment2.default)(this._scope.configuration.deliveryDetails.placeDate);

                  if (this._scope.configuration.deliveryDetails.placeTime) {
                    time = (0, _moment2.default)(this._scope.configuration.deliveryDetails.placeTime);

                    deadline.hour(time.hour());
                    deadline.minute(time.minute());
                  } else {
                    deadline.hour(0);
                    deadline.minute(0);
                  }
                  this._scope.configuration.deliveryDetails.deadlineTime = _moment2.default.tz(deadline, this.retailerTimezone).format();
                } else {
                  this._scope.configuration.deliveryDetails.deadlineTime = null;
                }
                this._groupOrderService.setDeliveryDetails(this._scope.configuration.deliveryDetails);

              case 2:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function saveDeadline() {
        return _ref15.apply(this, arguments);
      }

      return saveDeadline;
    }()
  }, {
    key: 'saveCartName',
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!(this._scope.orderModel.customCartName === '1' && !this._scope.orderModel.cartNameValue)) {
                  _context16.next = 3;
                  break;
                }

                this._scope.orderModel.isValid = false;
                return _context16.abrupt('return');

              case 3:
                this._groupOrderService.setCustomCartName(this._scope.orderModel.customCartName, this._scope.orderModel.cartNameValue);

              case 4:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function saveCartName() {
        return _ref16.apply(this, arguments);
      }

      return saveCartName;
    }()
  }, {
    key: '_isModelValid',
    value: function _isModelValid() {
      return this._scope.modelValidation.budget && this._scope.modelValidation.deadlineDate && this._scope.modelValidation.deadlineTime;
    }
  }]);

  return OrderTabPreviewController;
}();

OrderTabPreviewController.$inject = ['$scope', 'cartonomyConfig', 'CartService', '$q', 'Message', 'ConfigurationService', 'GroupOrder', 'CheckoutService', '$rootScope', '$mdSelect', '$translate'];


_module3.default.controller('OrderTabPreview', OrderTabPreviewController);

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = module.exports = __webpack_require__(803);
moment.tz.load(__webpack_require__(804));

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment-timezone.js
//! version : 0.5.31
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/

	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(1)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // AMD
	} else {
		factory(root.moment); // Browser
	}
})(undefined, function (moment) {
	"use strict";

	// Resolves es6 module loading issue

	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.31",
	    zones = {},
	    links = {},
	    _countries = {},
	    names = {},
	    guesses = {},
	    cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
	    major = +momentVersion[0],
	    minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || major === 2 && minor < 6) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
 	Unpacking
 ************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
		    parts = string.split('.'),
		    whole = parts[0],
		    fractional = parts[1] || '',
		    multiplier = 1,
		    num,
		    out = 0,
		    sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt(array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil(array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices(source, indices) {
		var out = [],
		    i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack(string) {
		var data = string.split('|'),
		    offsets = data[2].split(' '),
		    indices = data[3].split(''),
		    untils = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name: data[0],
			abbrs: mapIndices(data[1].split(' '), indices),
			offsets: mapIndices(offsets, indices),
			untils: untils,
			population: data[5] | 0
		};
	}

	/************************************
 	Zone object
 ************************************/

	function Zone(packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set: function _set(unpacked) {
			this.name = unpacked.name;
			this.abbrs = unpacked.abbrs;
			this.untils = unpacked.untils;
			this.offsets = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index: function _index(timestamp) {
			var target = +timestamp,
			    untils = this.untils,
			    i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries: function countries() {
			var zone_name = this.name;
			return Object.keys(_countries).filter(function (country_code) {
				return _countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse: function parse(timestamp) {
			var target = +timestamp,
			    offsets = this.offsets,
			    untils = this.untils,
			    max = untils.length - 1,
			    offset,
			    offsetNext,
			    offsetPrev,
			    i;

			for (i = 0; i < max; i++) {
				offset = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - offset * 60000) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr: function abbr(mom) {
			return this.abbrs[this._index(mom)];
		},

		offset: function offset(mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset: function utcOffset(mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
 	Country object
 ************************************/

	function Country(country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
 	Current Timezone
 ************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while (diff = ((high.at - low.at) / 12e4 | 0) * 6e4) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
		    last = new OffsetAt(new Date(startYear, 0, 1)),
		    offsets = [last],
		    change,
		    next,
		    i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores(a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses(name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets(offsets) {
		var offsetsLength = offsets.length,
		    filteredGuesses = {},
		    out = [],
		    i,
		    j,
		    guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess() {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
		    offsetsLength = offsets.length,
		    guesses = guessesForUserOffsets(offsets),
		    zoneScores = [],
		    zoneScore,
		    i,
		    j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess(ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
 	Global Methods
 ************************************/

	function normalizeName(name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone(packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone(name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames() {
		var i,
		    out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames() {
		return Object.keys(_countries);
	}

	function addLink(aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries(data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			_countries[country_code] = new Country(country_code, country_zones);
		}
	}

	function getCountry(name) {
		name = name.toUpperCase();
		return _countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData(data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists(name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
			logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset(m) {
		var isUnixTimestamp = m._f === 'X' || m._f === 'x';
		return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
	}

	function logError(message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
 	moment.tz namespace
 ************************************/

	function tz(input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
		    name = arguments[arguments.length - 1],
		    zone = getZone(name),
		    out = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version = VERSION;
	tz.dataVersion = '';
	tz._zones = zones;
	tz._links = links;
	tz._names = names;
	tz._countries = _countries;
	tz.add = addZone;
	tz.link = addLink;
	tz.load = loadData;
	tz.zone = getZone;
	tz.zoneExists = zoneExists; // deprecated in 0.1.0
	tz.guess = guess;
	tz.names = getNames;
	tz.Zone = Zone;
	tz.unpack = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset = needsOffset;
	tz.moveInvalidForward = true;
	tz.moveAmbiguousForward = false;
	tz.countries = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
 	Interface with Moment.js
 ************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
		    offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + (typeof name === 'undefined' ? 'undefined' : _typeof(name)) + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) {
			return this._z.name;
		}
	};

	function abbrWrap(old) {
		return function () {
			if (this._z) {
				return this._z.abbr(this);
			}
			return old.call(this);
		};
	}

	function resetZoneWrap(old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2(old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc = resetZoneWrap(fn.utc);
	fn.local = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function (name) {
		if (major < 2 || major === 2 && minor < 9) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)(module)))

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = {"version":"2020a","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function OrderTabDeliveryModeController($scope, groupOrderService) {
    var _this = this;

    $scope.selectDelivery = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(mode) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            groupOrderService.setDeliveryMode(mode);
                            $scope.cancelPreview();
                            $scope.next();

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
}

_module3.default.controller('OrderTabDeliveryMode', ['$scope', 'GroupOrder', OrderTabDeliveryModeController]);

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSummaryPageController = function () {
    function OrderSummaryPageController(scope, stateService, cartService, orderSetupService, configurationService, groupOrderService) {
        var _this = this;

        _classCallCheck(this, OrderSummaryPageController);

        this._scope = scope;
        this._stateService = stateService;
        this._cartService = cartService;
        this._orderSetupService = orderSetupService;
        this._configurationService = configurationService;
        this._groupOrderService = groupOrderService;

        scope.submitOrder = function () {
            return _this._submitOrder();
        };
        scope.invitationCode = this._cartService.getInviteCode();
        scope.invitationLink = '';
        this._initialize();
    }

    _createClass(OrderSummaryPageController, [{
        key: '_initialize',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _retailer;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _retailer = this._configurationService.getRetailer().retailer;

                                if (_retailer.retailerType === 'Shopify') {
                                    this._scope.invitationLink = 'https://' + _retailer.website + '#/invite/';
                                } else {
                                    this._scope.invitationLink = _retailer.website + '#/invite/';
                                }

                                if (this._scope.invitationCode) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 5;
                                return this._cartService.getInvitationCode();

                            case 5:
                                this._scope.invitationCode = _context.sent;

                                this._cartService.setInviteCode(this._scope.invitationCode);
                                this._cartService.setInvitationType(_CommonConstants2.default.InvitationTypes.share);

                                this._scope.submitOrder();

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _initialize() {
                return _ref.apply(this, arguments);
            }

            return _initialize;
        }()
    }, {
        key: '_submitOrder',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return this._groupOrderService.save();

                            case 3:
                                this._cartService.resetCart();
                                this._scope.setCurrentTabById('finish');
                                _scope2.default.apply(this._scope);
                                _context2.next = 10;
                                break;

                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2['catch'](0);

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 8]]);
            }));

            function _submitOrder() {
                return _ref2.apply(this, arguments);
            }

            return _submitOrder;
        }()
    }]);

    return OrderSummaryPageController;
}();

OrderSummaryPageController.$inject = ['$scope', '$state', 'CartService', 'OrderSetupService', 'ConfigurationService', 'GroupOrder'];
exports.default = OrderSummaryPageController;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderAddPeopleDirectiveController = function () {
    function OrderAddPeopleDirectiveController(scope, rootScope, contactsService, toastService, userProfileService, messageService, sessionService, $translate) {
        var _this = this;

        _classCallCheck(this, OrderAddPeopleDirectiveController);

        this._scope = scope;
        this._rootScope = rootScope;
        this._userEmails = {};
        this._excludedEmails = {};
        this._allContactsAndGroups = [];
        this._contactsService = contactsService;
        this._userProfileService = userProfileService;
        this._messageService = messageService;
        this._toastService = toastService;
        this._sessionService = sessionService;
        this.$translate = $translate;

        scope.foundContacts = [];
        scope.addAsGroup = false;
        scope.selectedEmails = scope.selectedEmails || [];
        scope.selectedContacts = scope.selectedContacts || [];
        scope.created = scope.created || [];
        scope.selectedTwoContacts = false;
        scope.groupNameToAdd = '';
        scope.nameToAdd = '';
        scope.context = scope.context || {};
        scope.context.contacts = scope.context.contacts || [];
        scope.recent = [];
        scope.allContactsMinusRecent = [];
        scope.showErrorMessage = false;
        scope.errorMessage = '';
        scope.addSelectedContactsToGroup = function () {
            return _this._addSelectedContactsToGroup();
        };
        scope.selectContact = function (contact) {
            return _this._selectContact(contact);
        };
        scope.unselectContact = function (contact) {
            return _this._unselectContact(contact);
        };
        scope.nameToAddChanged = function () {
            return _this._nameToAddChanged();
        };
        scope.closeFoundContactsForm = function () {
            return _this._closeFoundContactsForm();
        };
        scope.nameToAddKeyPressed = function (event) {
            return _this._nameToAddKeyPressed(event);
        };
        scope.groupToAddKeyPressed = function (event) {
            return _this._groupToAddKeyPressed(event);
        };
        scope.addEnteredEmails = function () {
            return _this._addEnteredEmails();
        };
        scope.updateSelectedContacts = function () {
            return _this._updateSelectedContacts();
        };

        scope.onNextBtnClicked = function () {
            return _this._onNextBtnClicked();
        };
        scope.onBackBtnClicked = function () {
            return _this._onBackBtnClicked();
        };
        scope.onDeleteContactClicked = function (contact) {
            return _this._onDeleteContactClicked(contact);
        };

        scope.$on(_CommonConstants2.default.Events.ADD_PEOPLE_ADVANCE_TO_NEXT_PAGE, function () {
            return _this._addEnteredEmails(true);
        });
    }

    _createClass(OrderAddPeopleDirectiveController, [{
        key: '$onInit',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var contactsLoaded;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                contactsLoaded = !!this._scope.context.contacts && this._scope.context.contacts.length;

                                if (!contactsLoaded) {
                                    _context.next = 5;
                                    break;
                                }

                                this._addContextContacts();
                                _context.next = 7;
                                break;

                            case 5:
                                _context.next = 7;
                                return this._getUserAndContacts();

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function $onInit() {
                return _ref.apply(this, arguments);
            }

            return $onInit;
        }()
    }, {
        key: '_fetchGroups',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this2 = this;

                var groups;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this._contactsService.getGroups();

                            case 2:
                                groups = _context2.sent;


                                this._scope.context.contacts = this._scope.context.contacts || [];
                                this._scope.context.groups = [];

                                if (!(!groups || !groups.length)) {
                                    _context2.next = 8;
                                    break;
                                }

                                _scope2.default.apply(this._scope);
                                return _context2.abrupt('return');

                            case 8:

                                _.each(groups, function (item) {
                                    return _this2._onGroupReceived(item);
                                });

                                this._updateRecentContacts();
                                this._sortContactsAndGroups();
                                this._updateSelectableGroups();

                                _scope2.default.apply(this._scope);

                            case 13:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _fetchGroups() {
                return _ref2.apply(this, arguments);
            }

            return _fetchGroups;
        }()
    }, {
        key: '_onGroupReceived',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(groupDefinition) {
                var _this3 = this;

                var group, forcedSelected;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                group = this._initializeGroup(groupDefinition.name);
                                forcedSelected = 0;


                                _.each(groupDefinition.groupMembers, function () {
                                    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(groupMember) {
                                        var contact;
                                        return regeneratorRuntime.wrap(function _callee3$(_context3) {
                                            while (1) {
                                                switch (_context3.prev = _context3.next) {
                                                    case 0:
                                                        contact = _.find(_this3._scope.context.contacts, { email: groupMember.memberEmail });

                                                        if (contact) {
                                                            _context3.next = 8;
                                                            break;
                                                        }

                                                        _context3.next = 4;
                                                        return _this3._initializeContact(groupMember.memberName, groupMember.memberEmail);

                                                    case 4:
                                                        contact = _context3.sent;

                                                        contact.forcedSelected = _this3._userEmails[contact.email] || _this3._excludedEmails[contact.email];
                                                        _this3._scope.context.contacts.push(contact);
                                                        _this3._allContactsAndGroups.push(contact);

                                                    case 8:

                                                        if (contact.forcedSelected) {
                                                            contact.selected = true;
                                                            forcedSelected++;
                                                        }

                                                        group.contacts.push(contact);

                                                    case 10:
                                                    case 'end':
                                                        return _context3.stop();
                                                }
                                            }
                                        }, _callee3, _this3);
                                    }));

                                    return function (_x2) {
                                        return _ref4.apply(this, arguments);
                                    };
                                }());

                                group.forcedSelected = group.contacts.length === forcedSelected;

                                if (group.forcedSelected) {
                                    group.selected = true;
                                }

                                this._scope.context.groups.push(group);
                                this._allContactsAndGroups.push(group);

                                _scope2.default.apply(this._scope);

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function _onGroupReceived(_x) {
                return _ref3.apply(this, arguments);
            }

            return _onGroupReceived;
        }()
    }, {
        key: '_fetchContacts',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var contacts, i, item, contact;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this._contactsService.getContacts();

                            case 2:
                                contacts = _context5.sent;


                                this._scope.context.contacts = this._scope.context.contacts || [];

                                if (!(!contacts || !contacts.length)) {
                                    _context5.next = 7;
                                    break;
                                }

                                _scope2.default.apply(this._scope);
                                return _context5.abrupt('return');

                            case 7:
                                _context5.t0 = regeneratorRuntime.keys(contacts);

                            case 8:
                                if ((_context5.t1 = _context5.t0()).done) {
                                    _context5.next = 21;
                                    break;
                                }

                                i = _context5.t1.value;
                                item = contacts[i];
                                contact = _.find(this._scope.context.contacts, { email: item.email });

                                if (contact) {
                                    _context5.next = 19;
                                    break;
                                }

                                _context5.next = 15;
                                return this._initializeContact(item.name, item.email, item.recent, item.avatar, item.userId, item.contactUserId);

                            case 15:
                                contact = _context5.sent;

                                contact.forcedSelected = this._userEmails[contact.email] || this._excludedEmails[contact.email];
                                this._scope.context.contacts.push(contact);
                                this._allContactsAndGroups.push(contact);

                            case 19:
                                _context5.next = 8;
                                break;

                            case 21:

                                this._updateRecentContacts();
                                this._sortContactsAndGroups();
                                _scope2.default.apply(this._scope);

                            case 24:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function _fetchContacts() {
                return _ref5.apply(this, arguments);
            }

            return _fetchContacts;
        }()
    }, {
        key: '_addContextContacts',
        value: function _addContextContacts() {
            var _this4 = this;

            // which means we have already read all data

            _.each(this._scope.context.groups, function (group) {
                _this4._allContactsAndGroups.push(group);
            });

            _.each(this._scope.context.contacts, function (contact) {
                _this4._allContactsAndGroups.push(contact);
            });

            this._updateRecentContacts();
        }
    }, {
        key: '_getUserAndContacts',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var _this5 = this;

                var user;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this._userProfileService.getUser();

                            case 2:
                                user = _context6.sent;


                                _.each(user.userEmails, function (item) {
                                    _this5._userEmails[item.email] = true;
                                });

                                if (this._scope.exclude) {
                                    this._scope.exclude.forEach(function (email) {
                                        _this5._excludedEmails[email] = true;
                                    });
                                }

                                _scope2.default.apply(this._scope, function () {
                                    _this5._scope.loading = true;
                                });
                                _context6.next = 8;
                                return this._fetchGroups();

                            case 8:
                                _context6.next = 10;
                                return this._fetchContacts();

                            case 10:
                                _scope2.default.apply(this._scope, function () {
                                    _this5._scope.loading = false;
                                });

                            case 11:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function _getUserAndContacts() {
                return _ref6.apply(this, arguments);
            }

            return _getUserAndContacts;
        }()
    }, {
        key: '_updateSelectableGroups',
        value: function _updateSelectableGroups() {
            this._scope.selectableGroups = _.filter(this._scope.context.groups, {
                forcedSelected: false
            });
        }
    }, {
        key: '_addSelectedContactsToExistingGroup',
        value: function _addSelectedContactsToExistingGroup(group) {
            var _this6 = this;

            var addedContacts = _.map(group.contacts, function (contact) {
                return contact.email;
            });
            var contactsAdded = false;

            _.each(this._scope.selectedContacts, function (contact) {

                if (contact.isGroup) {
                    return;
                }

                if (_.some(group.contacts, { email: contact.email })) {
                    return;
                }

                contactsAdded = true;
                group.contacts.push(contact);
                contact.selected = false;
                addedContacts.push(contact.email);
            });

            group.selected = true;

            if (contactsAdded) {
                group.forcedSelected = false;
                this._contactsService.updateGroup(group.name, addedContacts).catch(function (error) {
                    return _this6._messageService.showErrorPopupForResponse(error);
                });
            }

            this._scope.updateSelectedContacts();
            this._updateSelectableGroups();

            this._scope.addAsGroup = false;
            this._scope.groupNameToAdd = '';
        }
    }, {
        key: '_addSelectedContactsToGroup',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var _this7 = this;

                var groupName, group, addedContacts;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                groupName = _.trim(this._scope.groupNameToAdd);

                                if (!(groupName.length === 0)) {
                                    _context7.next = 3;
                                    break;
                                }

                                return _context7.abrupt('return');

                            case 3:
                                group = _.find(this._scope.context.groups, { name: groupName });
                                addedContacts = [];

                                if (!group) {
                                    _context7.next = 8;
                                    break;
                                }

                                this._addSelectedContactsToExistingGroup(group);
                                return _context7.abrupt('return');

                            case 8:

                                group = this._initializeGroup(groupName);

                                _.each(this._scope.selectedContacts, function (contact) {

                                    if (!contact.isGroup) {
                                        group.contacts.push(contact);
                                        contact.selected = false;
                                        addedContacts.push(contact.email);
                                    }
                                });

                                group.selected = true;

                                this._scope.context.groups.push(group);
                                this._allContactsAndGroups.push(group);

                                _context7.next = 15;
                                return this._contactsService.createGroup(groupName, addedContacts).catch(function (error) {
                                    return _this7._messageService.showErrorPopupForResponse(error);
                                });

                            case 15:

                                this._sortContactsAndGroups();

                                this._scope.groupNameToAdd = '';
                                this._scope.addAsGroup = false;

                                this._updateSelectedContacts();
                                this._updateSelectableGroups();

                            case 20:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function _addSelectedContactsToGroup() {
                return _ref7.apply(this, arguments);
            }

            return _addSelectedContactsToGroup;
        }()
    }, {
        key: '_selectContact',
        value: function _selectContact(contact) {
            console.log('_selectContact');
            if (contact.selected) {
                return;
            }

            contact.selected = true;

            this._updateSelectedContacts();
        }
    }, {
        key: '_unselectContact',
        value: function _unselectContact(contact) {
            console.log('_unselectContact');
            if (!contact.selected) {
                return;
            }

            contact.selected = false;

            this._updateSelectedContacts();
        }
    }, {
        key: '_updateRecentContacts',
        value: function _updateRecentContacts() {
            var _this8 = this;

            this._scope.recentContacts = _.chain(this._scope.context.contacts).filter(function (contact) {
                return contact && (contact.recent || false) && !contact.forcedSelected;
            }).sortBy(function (contact) {
                return _this8._getContactSortBy(contact);
            }).value();

            var alreadyInCartContacts = _.chain(this._scope.context.contacts).filter(function (contact) {
                return contact && !(contact.recent || false) && contact.forcedSelected;
            }).sortBy(function (contact) {
                return _this8._getContactSortBy(contact);
            }).value();

            this._scope.alreadyInCartContacts = alreadyInCartContacts.map(function (contact) {
                contact.selected = true;
                return contact;
            });

            this._scope.allContactsMinusRecent = _.chain(this._scope.context.contacts).filter(function (contact) {
                return contact && !(contact.recent || false) && !contact.forcedSelected && !contact.selected;
            }).sortBy(function (contact) {
                return _this8._getContactSortBy(contact);
            }).value();

            if (this._scope.selectedContacts.length) {
                this._scope.showErrorMessage = false;
            }

            _scope2.default.apply(this._scope);
        }
    }, {
        key: '_nameToAddChanged',
        value: function _nameToAddChanged() {
            var name = _.trim(this._scope.nameToAdd).toLowerCase();

            if (name.length === 0) {
                this._scope.foundContacts = [];
                return;
            }

            this._scope.foundContacts = _.chain(this._allContactsAndGroups).filter(function (contact) {
                return contact && (contact.name && contact.name.toLowerCase().includes(name) || contact.email.includes(name));
            }).sortBy(this._getContactSortBy).take(7).value();
        }
    }, {
        key: '_closeFoundContactsForm',
        value: function _closeFoundContactsForm() {
            this._scope.foundContacts = [];
            this._scope.nameToAdd = '';
        }
    }, {
        key: '_nameToAddKeyPressed',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(event) {
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (_CommonConstants2.default.EMAIL_REGEX.test(this._scope.nameToAdd)) {
                                    _context8.next = 3;
                                    break;
                                }

                                this._rootScope.$broadcast('order:add:people.canAddPeople', false);
                                return _context8.abrupt('return');

                            case 3:
                                this._rootScope.$broadcast('order:add:people.canAddPeople', true);

                                if (!(event.which !== 13)) {
                                    _context8.next = 6;
                                    break;
                                }

                                return _context8.abrupt('return');

                            case 6:
                                _context8.next = 8;
                                return this._addEnteredEmails();

                            case 8:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function _nameToAddKeyPressed(_x3) {
                return _ref8.apply(this, arguments);
            }

            return _nameToAddKeyPressed;
        }()
    }, {
        key: '_groupToAddKeyPressed',
        value: function _groupToAddKeyPressed(event) {

            if (event.which !== 13) {
                return;
            }

            this._addSelectedContactsToGroup();
        }
    }, {
        key: '_initializeContact',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(name, email, recent, avatar, userId, contactUserId) {
                var avatarModel;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!(!name && !avatar)) {
                                    _context9.next = 11;
                                    break;
                                }

                                _context9.prev = 1;
                                _context9.next = 4;
                                return this._userProfileService.getUserAvatar(email);

                            case 4:
                                avatarModel = _context9.sent;

                                if (avatarModel && avatarModel.data) avatar = avatarModel.data.avatar;
                                _context9.next = 11;
                                break;

                            case 8:
                                _context9.prev = 8;
                                _context9.t0 = _context9['catch'](1);

                                avatar = null;

                            case 11:
                                return _context9.abrupt('return', {
                                    email: _.trim(email).toLowerCase(),
                                    name: _.trim(name),
                                    isGroup: false,
                                    selected: false,
                                    recent: recent,
                                    avatar: avatar,
                                    userId: userId,
                                    contactUserId: contactUserId
                                });

                            case 12:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this, [[1, 8]]);
            }));

            function _initializeContact(_x4, _x5, _x6, _x7, _x8, _x9) {
                return _ref9.apply(this, arguments);
            }

            return _initializeContact;
        }()
    }, {
        key: '_initializeGroup',
        value: function _initializeGroup(name) {
            return {
                name: name.trim(),
                isGroup: true,
                contacts: [],
                selected: false,
                expanded: false
            };
        }
    }, {
        key: '_addEnteredEmail',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(email, state) {
                var existingContact, newContact;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:

                                email = _.trim(email);

                                if (!(email.length === 0)) {
                                    _context10.next = 3;
                                    break;
                                }

                                return _context10.abrupt('return');

                            case 3:
                                existingContact = this._scope.context.contacts.find(function (contact) {
                                    return contact.email === email;
                                });

                                if (!existingContact) {
                                    _context10.next = 15;
                                    break;
                                }

                                if (!this._excludedEmails[existingContact.email]) {
                                    _context10.next = 10;
                                    break;
                                }

                                if (state.updatedNameToAdd) {
                                    state.updatedNameToAdd += ', ';
                                }
                                state.updatedNameToAdd += email;
                                state.excludedEmails.push(email);
                                return _context10.abrupt('return');

                            case 10:

                                existingContact.selected = true;
                                existingContact.selectedOn = new Date();
                                // existingContact.recent = true;
                                state.addedEmails++;
                                _context10.next = 35;
                                break;

                            case 15:
                                if (_CommonConstants2.default.EMAIL_REGEX.test(email)) {
                                    _context10.next = 20;
                                    break;
                                }

                                if (state.updatedNameToAdd) {
                                    state.updatedNameToAdd += ', ';
                                }
                                state.updatedNameToAdd += email;
                                state.incorrectEmails++;
                                return _context10.abrupt('return');

                            case 20:
                                if (!this._excludedEmails[email]) {
                                    _context10.next = 25;
                                    break;
                                }

                                if (state.updatedNameToAdd) {
                                    state.updatedNameToAdd += ', ';
                                }
                                state.updatedNameToAdd += email;
                                state.excludedEmails++;
                                return _context10.abrupt('return');

                            case 25:
                                _context10.next = 27;
                                return this._initializeContact(null, email);

                            case 27:
                                newContact = _context10.sent;


                                newContact.selected = true;
                                newContact.recent = true;
                                this._scope.context.contacts.push(newContact);
                                this._allContactsAndGroups.push(newContact);
                                this._scope.created.push(newContact);
                                state.addedEmails++;
                                _scope2.default.apply(this._scope);

                            case 35:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function _addEnteredEmail(_x10, _x11) {
                return _ref10.apply(this, arguments);
            }

            return _addEnteredEmail;
        }()
    }, {
        key: '_addEnteredEmails',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(sendInvitation) {
                var emails, ownerEmail, hasOwnerEmail, state, i, email, message, toast;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                this._scope.errorMessage = '';
                                this._scope.showErrorMessage = false;

                                emails = this._scope.nameToAdd.split(/[,; ]/);

                                // [CW-735] - prevent owner to invite himself to his cart.

                                _context11.next = 5;
                                return this._sessionService.getUserEmail();

                            case 5:
                                ownerEmail = _context11.sent;
                                hasOwnerEmail = emails.some(function (email) {
                                    return ownerEmail === email;
                                });

                                if (!hasOwnerEmail) {
                                    _context11.next = 11;
                                    break;
                                }

                                this._scope.errorMessage = this.this.$translate.instant('client.cart.invite_restrict');
                                this._scope.showErrorMessage = true;
                                return _context11.abrupt('return');

                            case 11:
                                state = {
                                    addedEmails: 0,
                                    incorrectEmails: 0,
                                    excludedEmails: [],
                                    updatedNameToAdd: ''
                                };
                                _context11.t0 = regeneratorRuntime.keys(emails);

                            case 13:
                                if ((_context11.t1 = _context11.t0()).done) {
                                    _context11.next = 20;
                                    break;
                                }

                                i = _context11.t1.value;
                                email = emails[i];
                                _context11.next = 18;
                                return this._addEnteredEmail(email, state);

                            case 18:
                                _context11.next = 13;
                                break;

                            case 20:

                                this._sortContactsAndGroups();
                                this._updateSelectedContacts(sendInvitation);
                                this._closeFoundContactsForm();
                                this._updateRecentContacts();

                                this._scope.nameToAdd = state.updatedNameToAdd;

                                if (state.updatedNameToAdd) {
                                    message = '';

                                    if (state.excludedEmails.length) {
                                        message = this.$translate.instant('client.cart.exclude_emails', { excludedEmails: state.excludedEmails.join(', '), excludedEmailsLength: state.excludedEmails.length > 1 ? '' : 's' });
                                    }
                                    if (state.incorrectEmails) {
                                        if (message) {
                                            message += ', ';
                                        }
                                        message += this.$translate.instant('client.user.valid.email');
                                    }

                                    toast = this._toastService.simple().textContent(state.addedEmails ? this.$translate.instant('client.user.correct_email') : message).position('top');

                                    // this._toastService.show(toast);

                                    this._scope.errorMessage = message;
                                    this._scope.showErrorMessage = true;
                                } else {
                                    this._scope.errorMessage = '';
                                    this._scope.showErrorMessage = false;
                                }
                                _scope2.default.apply(this._scope);

                            case 27:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function _addEnteredEmails(_x12) {
                return _ref11.apply(this, arguments);
            }

            return _addEnteredEmails;
        }()
    }, {
        key: '_getContactSortBy',
        value: function _getContactSortBy(contact) {
            return (contact.name || contact.email).toLowerCase();
        }
    }, {
        key: '_sortContactsAndGroups',
        value: function _sortContactsAndGroups() {
            var _this9 = this;

            this._scope.context.contacts = _.chain(this._scope.context.contacts).filter(function (contact) {
                return !!contact;
            }).sortBy(function (contact) {
                return _this9._getContactSortBy(contact);
            }).value();

            this._scope.context.groups = _.chain(this._scope.context.groups).filter(function (contact) {
                return !!contact;
            }).sortBy(function (contact) {
                return _this9._getContactSortBy(contact);
            }).value();
        }
    }, {
        key: '_updateSelectedContacts',
        value: function _updateSelectedContacts(sendInvitation) {
            this._scope.selectedContacts = _.chain(this._allContactsAndGroups).filter(function (contact) {
                return contact && contact.selected && !contact.forcedSelected;
            }).sortBy(function (contact) {
                return -(contact.selectedOn || new Date()).getTime();
            }).value();

            this._scope.selectedTwoContacts = _.chain(this._scope.selectedContacts).filter(function (contact) {
                return !contact.isGroup;
            }).value().length > 1;

            var emailsSet = {};

            this._scope.selectedContacts.forEach(function (item) {
                if (item.isGroup) {
                    item.contacts.forEach(function (contact) {
                        emailsSet[contact.email] = true;
                    });
                } else {
                    emailsSet[item.email] = true;
                }
            });

            this._scope.selectedEmails = _.keys(emailsSet);

            if (this._scope.onChanged) {
                this._scope.onChanged(this._scope.selectedEmails);
            }

            if (sendInvitation && this._scope.sendInvitation) {
                this._scope.sendInvitation(this._scope.selectedEmails);
            }

            this._updateRecentContacts();

            this._rootScope.$broadcast('order:add:people.canAddPeople', this._scope.selectedEmails.length > 0);
        }
    }, {
        key: '_onNextBtnClicked',
        value: function _onNextBtnClicked() {
            if (!this._scope.selectedContacts.length && !this._scope.alreadyInCartContacts.length) {
                this._scope.showErrorMessage = true;
                _scope2.default.apply(this._scope);
                return;
            }

            this._scope.showErrorMessage = false;
            this._scope.goNext();
        }
    }, {
        key: '_onBackBtnClicked',
        value: function _onBackBtnClicked() {
            this._scope.goBack();
        }
    }, {
        key: '_onDeleteContactClicked',
        value: function _onDeleteContactClicked(conctact) {
            this._scope.deleteContact(conctact);
        }
    }]);

    return OrderAddPeopleDirectiveController;
}();

OrderAddPeopleDirectiveController.$inject = ['$scope', '$rootScope', 'ContactsService', '$mdToast', 'UserProfile', 'Message', 'Session', '$translate'];
exports.default = OrderAddPeopleDirectiveController;


_module3.default.directive('cartonomyOrderAddPeople', function () {
    return {
        scope: {
            selectedContacts: '=?selectedContacts',
            selectedEmails: '=?selectedEmails',
            onChanged: '=?onChanged',
            sendInvitation: '=?sendInvitation',
            created: '=?created',
            context: '=?context',
            exclude: '=?exclude',
            title: '@title',
            goNext: '=?goNext',
            goBack: '=?goBack',
            cancelAction: '=?cancelAction',
            showCancelButton: '=?showCancelButton',
            deleteContact: '=?deleteContact'
        },
        transclude: true,
        template: __webpack_require__(808),
        controller: OrderAddPeopleDirectiveController
    };
});

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "<div class=\"order-add-people\"><div class=\"header\" layout=\"column\" ng-form=\"addPeopleForm\"><ng-transclude layout=\"row\"></ng-transclude><div layout=\"row\"><md-button class=\"md-icon-button cancel-add-people-btn\" ng-if=\"showCancelButton\" ng-click=\"cancelAction()\" aria-label=\"Cancel\" flex=\"5\"><md-icon aria-label=\"Cancel\">clear</md-icon></md-button><md-button class=\"md-icon-button cancel-add-people-btn\" ng-if=\"!showCancelButton\" ng-click=\"onBackBtnClicked()\" title=\"Back\"><md-icon aria-label=\"Back\">arrow_back</md-icon></md-button><h2 ng-bind=\"title\" ng-if=\"title\" flex=\"no-shrink\"></h2><md-button class=\"md-raised md-hover invite-people-button\" ng-click=\"onNextBtnClicked()\" aria-label=\"Continue\" title=\"Continue\">{{showCancelButton ? \"Send Invites\" : \"Next\"}}&nbsp;&nbsp;<md-icon class=\"invite-people-icon\">send</md-icon></md-button></div><div class=\"input-form\" layout=\"row\"><md-input-container class=\"add-email-input\" flex=\"70\" flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" layout-wrap=\"layout-wrap\"><label hide-xs=\"hide-xs\" ng-if=\"!nameToAdd\">{{'client.user.email_address_label' | translate}}</label><label hide-lt-xs=\"hide-lt-xs\" show-xs=\"show-xs\" ng-if=\"!nameToAdd\">{{'client.user.email_address' | translate}}</label><input ng-model=\"nameToAdd\" type=\"text\" ng-keypress=\"nameToAddKeyPressed($event)\" ng-change=\"nameToAddChanged()\"/></md-input-container><div class=\"found-contacts-form\" ng-show=\"foundContacts.length &gt; 0\" layout=\"column\"><cartonomy-order-contact ng-repeat=\"contact in foundContacts\" contact=\"contact\" ng-click=\"selectContact(contact)\" contact-changed=\"updateSelectedContacts()\"></cartonomy-order-contact><div layout=\"row\"><div class=\"full-width\" flex=\"70\"><md-button class=\"md-primary md-raised\" ng-click=\"closeFoundContactsForm()\" aria-label=\"Close\">{{'client.close' | translate}}</md-button></div></div></div><md-button class=\"md-icon-button add-emails\" ng-click=\"addEnteredEmails()\" ng-disabled=\"nameToAdd.trim().length === 0\" aria-label=\"Add Entered Emails\"><md-icon>add_circle_outline</md-icon></md-button></div><div class=\"error\" layout=\"row\" ng-if=\"showErrorMessage\"><div>{{ errorMessage }}</div></div><!--.selected-contacts(layout=\"row\" layout-wrap)--><!--    .selected-contact(ng-repeat=\"contact in selectedContacts\" ng-class=\"{ 'is-group': contact.isGroup }\" layout-margin layout=\"row\")--><!--        .count(ng-if=\"contact.isGroup\")--><!--            div {{contact.contacts.length}}--><!--        div(layout=\"row\" layout-align=\"center center\" flex=\"noshrink\")--><!--            .name {{contact.name || contact.email}}--><!--            md-button.md-icon-button.remove-button(ng-click=\"unselectContact(contact)\" aria-label=\"Remove Contact\" ng-if=\"!contact.forcedSelected\")--><!--                md-icon clear--><!--.add-as-group(layout=\"row\" ng-show=\"selectedTwoContacts\")--><!--    md-checkbox(ng-model=\"addAsGroup\") {{ addAsGroup ? '' : 'Add these people to a group' }}--><!--    md-input-container(ng-show=\"addAsGroup\")--><!--        label Name Your Group--><!--        input(ng-model=\"groupNameToAdd\" ng-keypress=\"groupToAddKeyPressed($event)\" )--><!--    md-button.md-icon-button(ng-click=\"addSelectedContactsToGroup()\" ng-disabled=\"groupNameToAdd.trim().length === 0\" aria-label=\"Add New Group\" ng-show=\"addAsGroup\")--><!--        md-icon add--></div><div class=\"lists contacts-list-container\" layout=\"row\" layout-wrap=\"layout-wrap\" loading-indicator=\"loading\"><!--.groups(layout=\"column\" ng-if=\"selectableGroups.length > 0\")--><!--    h2 Groups--><!--    .group(ng-repeat=\"group in selectableGroups\" layout=\"column\")--><!--        cartonomy-order-contact(contact=\"group\" contact-changed=\"updateSelectedContacts()\")--><!--.all-contacts(layout=\"column\" flex=\"50\" ng-if=\"allContactsMinusRecent.length > 0\" flex-order-xs=\"1\")--><div class=\"all-contacts\" layout=\"column\" flex=\"50\" flex-order-xs=\"1\"><h2>{{'client.your_contacts' | translate}}</h2><div class=\"contacts-list\" layout=\"column\" layout-wrap=\"layout-wrap\"><div class=\"contact\" ng-repeat=\"contact in allContactsMinusRecent\"><cartonomy-order-contact contact=\"contact\" contact-delete=\"onDeleteContactClicked(contact)\" contact-changed=\"updateSelectedContacts()\" group-view=\"true\"></cartonomy-order-contact></div></div></div><!--.recent-contacts(layout=\"column\" flex-order-xs=\"1\" ng-if=\"recentContacts.length > 0\")--><!--    h2 Recent Contacts--><!--    .contacts-list(layout=\"row\" layout-wrap)--><!--        .contact(flex=\"50\" flex-xs=\"50\" ng-repeat=\"contact in recentContacts\")--><!--            cartonomy-order-contact(contact=\"contact\" contact-changed=\"updateSelectedContacts()\" group-view=\"true\")--><div class=\"recent-contacts\" layout=\"column\" flex=\"50\" flex-order-xs=\"2\"><h2>{{'client.order.in' | translate}}</h2><div class=\"contacts-list\" layout=\"column\" layout-wrap=\"layout-wrap\"><div class=\"error\" ng-if=\"showErrorMessage\">{{'client.user.add_min' | translate}}\n</div><div class=\"contact\" ng-repeat=\"contact in selectedContacts\"><cartonomy-order-contact contact=\"contact\" contact-changed=\"updateSelectedContacts()\" group-view=\"true\"></cartonomy-order-contact></div><div class=\"contact\" ng-repeat=\"contact in alreadyInCartContacts\"><cartonomy-order-contact contact=\"contact\" contact-changed=\"updateSelectedContacts()\" group-view=\"true\"></cartonomy-order-contact></div></div></div></div></div>"

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(18);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function OrderContactViewDirective($scope, messageService, groupOrderService) {
    var _this = this;

    function setFirstLetter(contact) {
        if (!contact.isGroup) {
            var name = contact.name || contact.email || "-";
            contact.firstLetter = name.substring(0, 1);
        }
    }

    $scope.toggleContact = function (contact) {
        if (contact.forcedSelected) {
            return;
        }
        contact.selected = !contact.selected;
        if (contact.selected) {
            contact.selectedOn = new Date();
        } else {
            contact.selectedOn = null;
        }
        $scope.onChanged();
    };

    $scope.expandCollapseGroup = function () {
        $scope.contact.expanded = !$scope.contact.expanded;
        $scope.onChanged();
    };

    this.$onInit = function () {
        setFirstLetter($scope.contact);

        if ($scope.contact.contacts) {
            $scope.contact.contacts.forEach(function (contact) {
                return setFirstLetter(contact);
            });
        }
    };

    $scope.deleteContact = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(email) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            $scope.onContactDelete();

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
}

OrderContactViewDirective.$inject = ['$scope', 'Message', 'GroupOrder'];

_module3.default.directive('cartonomyOrderContact', function () {
    return {
        scope: {
            contact: '=contact',
            onChanged: '&contactChanged',
            groupView: '=',
            onContactDelete: '&contactDelete'
        },
        templateUrl: 'modules/order/views/contactView.html',
        controller: OrderContactViewDirective
    };
});

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// import module from '../module';
// import moment from 'moment';
// import * as _ from 'lodash';
//
// export default function OrderDateService(storeHours, deliveryDaysRange, addMinutes, maximumDate) {
//
//     const minimumDate = moment();
//
//     minimumDate.add(addMinutes, 'minutes');
//
//     const weekHours = {};
//
//     _.each(storeHours, (storeHour) => {
//
//         if (!storeHour.open || !storeHour.close) {
//             return;
//         }
//
//         const openDate = moment(storeHour.open);
//         const closeDate = moment(storeHour.close);
//         const dayOfWeek = storeHour.dayOfWeek;
//
//         (weekHours[dayOfWeek] = weekHours[dayOfWeek] || []).push({
//             open: getTime(openDate),
//             close: getTime(closeDate),
//             inRange: function (date) {
//                 const time = getTime(date);
//                 return time >= this.open && time < this.close;
//             }
//         });
//     });
//
//     function getTime(date) {
//         if (!date.hour) {
//             return date; // suppose it is already a number
//         }
//         return date.hour() * 60 + date.minute();
//     }
//
//     function getWeekDay(date) {
//         const day = date.isoWeekday();
//         return day === 7 ? 0 : day;
//     }
//
//     let day;
//
//     for (day = 0; day < 20; day++) {
//
//         const dayOfWeek = getWeekDay(minimumDate);
//         const hours = weekHours[dayOfWeek];
//         if (hours) {
//             const start = getTime(minimumDate);
//             let i;
//             for (i = 0; i < hours.length; i++) {
//                 if (hours[i].close > start) {
//                     break;
//                 }
//             }
//             if (i < hours.length) {
//                 break;
//             }
//         }
//
//         minimumDate.add(1, 'days');
//         minimumDate.startOf('day');
//     }
//     /*
//      if (day >= 20) {
//      return {
//
//      };
//      } */
//
//     const minimumTime = minimumDate.clone();
//     minimumDate.startOf('day');
//
//     if (minimumTime.minutes() % 30 !== 0) {
//         minimumTime.add(30 - minimumTime.minutes() % 30, 'minutes');
//     }
//
//     let maximumTime = null;
//
//     if (maximumDate) {
//         maximumDate = moment(maximumDate);
//         maximumTime = maximumDate;
//     } else {
//         maximumDate = minimumDate.clone().add(1, 'day');
//
//         let weekDay = getWeekDay(minimumDate) + 1;
//
//         for (let days = 1; days < deliveryDaysRange; weekDay++) {
//             if (weekDay > 6) {
//                 weekDay = 0;
//             }
//             if (weekHours[weekDay]) {
//                 days++;
//             }
//             maximumDate.add(1, 'days');
//         }
//
//         maximumDate.endOf('day');
//     }
//
//     function isTimeInRange(date) {
//
//         if (!date.isoWeekday) {
//             date = moment(date);
//         }
//
//         const weekDay = getWeekDay(date);
//         let hours = weekHours[weekDay];
//
//         if (!hours) {
//             return false;
//         }
//
//         const time = getTime(date);
//
//         return _.some(hours, function (hour) {
//             return hour.inRange(time);
//         });
//     }
//
//     function dateHasWorkingHours(date) {
//         if (!date.isoWeekday) {
//             date = moment(date);
//         }
//
//         if (date.isBefore(minimumDate)) {
//             return false;
//         }
//
//         if (date.isAfter(maximumDate)) {
//             return false;
//         }
//
//         const weekDay = getWeekDay(date);
//
//         let workingHour = weekHours[weekDay];
//
//         return !!workingHour && workingHour.length;
//     }
//
//     function getTimeValues(newValue) {
//
//         let currentTime = moment(newValue);
//
//         const timeValues = [{
//             text: '',
//             value: null
//         }];
//
//         if (currentTime.isBefore(minimumTime)) {
//             if (currentTime.dayOfYear() != minimumTime.dayOfYear()) {
//                 return timeValues;
//             }
//
//             currentTime = minimumTime.clone();
//         } else if (currentTime.dayOfYear() != minimumDate.dayOfYear()) {
//             currentTime = currentTime.startOf('day');
//         }
//
//         let endOfDay = currentTime.clone().endOf('day');
//
//         if (maximumTime && endOfDay.isAfter(maximumTime)) {
//             endOfDay = maximumTime.clone().add(1, 'minutes');
//         }
//
//         for (; currentTime.isBefore(endOfDay); currentTime.add(30, 'minutes')) {
//             if (isTimeInRange(currentTime)) {
//                 timeValues.push({
//                     text: currentTime.format('LT'),
//                     value: currentTime.toISOString()
//                 });
//             }
//         }
//
//         return timeValues;
//     }
//
//     this.getMinimumDate = () => {
//         return minimumDate.toDate();
//     };
//
//     this.getMaximumDate = () => {
//         return maximumDate.toDate();
//     };
//
//     this.getTimeValues = (value) => getTimeValues(value);
//
//     this.getDateInRangeFilter = () => dateHasWorkingHours;
//
//     this.joinDateAndTime = (date, time) => {
//         time = moment(time);
//
//         let joined = moment({
//             year: date.getFullYear(),
//             month: date.getMonth(),
//             day: date.getDate(),
//             hours: time.hour(),
//             minutes: time.minute()
//         });
//
//         return joined.toDate();
//     };
// }


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _InviteController = __webpack_require__(429);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    name: _CommonConstants2.default.RoutingStates.INVITE,
    url: "/invite/{participantToken}",
    views: {
        contents: {
            controller: _InviteController.InviteController
        }
    }
}, {
    name: _CommonConstants2.default.RoutingStates.ORDER_SUMMARY_PAGE,
    url: "/orderSummaryPage",
    views: {
        contents: {
            template: __webpack_require__(812),
            controller: 'Cartonomy.Order.OrderSummaryPageController'
        }
    }
}];

exports.default = routes;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__(41);

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout-align=\"center center\" layout=\"row\" class=\"order-join-link\"><div layout=\"column\" flex=\"80\" layout-align=\"center center\" class=\"div\"><div class=\"title\">{{'client.join_link' | translate}}</div><div class=\"join-link\">{{invitationLink}}{{invitationCode}}</div></div></div>");;return buf.join("");
}

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// import module from '../module';
// import moment from 'moment';
//
// require('moment-timezone');
// import scopeUtils from '../../../utils/scope';
//
// export class OrderTabDeadlineController {
//     static $inject = [
//         '$scope', 'cartonomyConfig', '$filter', 'OrderDateService',
//         'CheckoutService', 'CartService', 'GroupOrder',
//         '$location', '$window', 'Message',
//         'ConfigurationService' ];
//
//     constructor($scope, cartonomyConfig, $filter, orderDateServicePromise,
//                 checkoutService, cartService, groupOrderService,
//                 $location, $window, messageService,
//                 ConfigurationService) {
//
//         this._scope = $scope;
//         this._cartonomyConfig = cartonomyConfig;
//         this._filterService = $filter;
//         this._checkoutService = checkoutService;
//         this._cartService = cartService;
//         this._groupOrderService = groupOrderService;
//         this._locationService = $location;
//         this._windowService = $window;
//         this._messageService = messageService;
//         this._orderDateServicePromise = orderDateServicePromise;
//         this._configurationService = ConfigurationService;
//
//         $scope.externalStoreMode = cartonomyConfig.externalStoreMode;
//         $scope.maxAllowedBudget = 100000;
//
//         this._joinDateTime = () => {
//             return null;
//         };
//
//         $scope.parentBack = $scope.back;
//
//         $scope.back = (form) => this._back(form);
//
//         $scope.onDeadlineDateChanged = () => this._onDeadlineDateChanged();
//
//         $scope.save = () => this.saveAndGotoNext();
//     }
//
//     async $onInit() {
//         await this._initialize();
//         await this._setupDeliveryTime(this._orderDateServicePromise);
//     }
//
//     async _initialize() {
//         this.retailer = this._configurationService.getRetailer().retailer;
//
//         this._scope.retailerTimezoneName = this.retailer.timeZoneDisplayName;
//         this.retailerTimezone = this.retailer.timeZoneSettingName;
//
//         this._scope.configuration = {
//             groupPay: this._groupOrderService.getGroupPay(),
//             singlePayOrder: this._groupOrderService.getSinglePayOrder() || {
//                 paymentInformation: {}
//             },
//             paymentSystem: this._groupOrderService.getPaymentSystem(),
//             vendorDetails: this._groupOrderService.getVendorDetails() || {},
//             deliveryDetails: this._groupOrderService.getDeliveryDetails(),
//         };
//     }
//
//     save() {
//         if (!this._scope.configuration.deliveryDetails.defineDeadline) {
//             this._scope.configuration.deliveryDetails.deadlineTime = null
//         } else {
//             this._scope.configuration.deliveryDetails.deadlineTime = moment.tz(this._scope.configuration.deliveryDetails.placeTime, this.retailerTimezone).format();
//         }
//
//         this._groupOrderService.setDeliveryDetails(this._scope.configuration.deliveryDetails);
//     }
//
//     saveAndGotoNext() {
//         this.save();
//         this._scope.next();
//     }
//
//     async _setupDeliveryTime(orderDateServicePromise) {
//         this._scope.configuration.deliveryDetails.placeDateAndTime =
//             this._scope.configuration.deliveryDetails.placeDateAndTime ||
//             this._scope.configuration.deliveryDetails.deadlineTime;
//
//         let placeDateAndTime = this._scope.configuration.deliveryDetails.placeDateAndTime;
//         this._scope.closeOn = placeDateAndTime ? moment.tz(placeDateAndTime, this.retailerTimezone).format('ddd[,] MMM Do[,] LT') + this.retailer.timeZoneDisplayName : '';
//
//         let minimumTime = moment().add(15, 'minutes');
//         let minimumDate = moment.tz(minimumTime,this.retailerTimezone).startOf('day');
//
//         let maximumTime = null;
//
//         if (!this._scope._editMode || this._cartonomyConfig.externalStoreMode) {
//             maximumTime = moment().clone().add('14', 'days').endOf('day');
//         } else if (this._scope.configuration.deliveryDetails.deadlineTime && !this._cartonomyConfig.externalStoreMode) {
//             maximumTime = moment(this._scope.configuration.deliveryDetails.deadlineTime);
//         } else {
//             maximumTime = moment().clone().endOf('day');
//         }
//
//         let maximumDate = maximumTime.clone().endOf('day');
//
//         this._scope.minimumDate = minimumDate.toDate();
//         this._scope.maximumDate = maximumDate.toDate();
//
//         this._scope.configuration.deliveryDetails.placeDate = moment.tz(placeDateAndTime, this.retailerTimezone).format();
//         if(moment.tz(placeDateAndTime, this.retailerTimezone) <  moment.tz(moment(), this.retailerTimezone)){
//             this._scope.configuration.deliveryDetails.placeDate = moment.tz(moment(), this.retailerTimezone).format();
//         }
//
//         if (placeDateAndTime && moment(placeDateAndTime).isValid()) {
//             this._scope.configuration.deliveryDetails.placeTime = moment.tz(placeDateAndTime, this.retailerTimezone).format();
//
//             this._scope.configuration.deliveryDetails.defineDeadline = true;
//         } else {
//             this._scope.configuration.deliveryDetails.defineDeadline = false;
//         }
//         this._scope.configuration.deliveryDetails.placeEntered = true;
//
//         if (this._scope.returnToPreview) {
//             this._scope.configuration.deliveryDetails.defineDeadline = true;
//         }
//
//         let getTimeValues = date => {
//             let dateInRetailerTimezone = date;// moment.tz(date, this.retailerTimezone).format();
//
//             let currentDate = moment.tz(moment(date),this.retailerTimezone).startOf('day');
//             let endDate = currentDate.clone().endOf('day');
//
//             let list = [];
//
//             for (; currentDate.isSameOrBefore(endDate); currentDate.add(30, 'minutes')) {
//                 var _minimumTime = moment.tz(minimumTime,this.retailerTimezone);
//                 var _maximumTime = moment.tz(maximumTime,this.retailerTimezone);
//                 if (currentDate.isBetween(_minimumTime, _maximumTime, 'minutes', '[]')) {
//
//                     let value = currentDate.format().substr(0, 19);
//                     list.push({
//                         text: currentDate.format('LT'),
//                         value: value
//                     });
//                 }
//             }
//
//             return list;
//         };
//
//         this._scope.acceptedDateFilter = date => {
//             date = moment(date).format('YYYY-MM-DD');
//             date = moment.tz(date,this.retailerTimezone);
//             return date.isSameOrAfter(minimumDate) && date.isSameOrBefore(maximumDate);
//         };
//
//         // regular mode will have expire time assigned, shopify mode should not have
//         if (!this._cartonomyConfig.externalStoreMode) {
//             let timeValues = getTimeValues(maximumDate);
//
//             if (timeValues.length && !placeDateAndTime) {
//                 this._scope.configuration.deliveryDetails.placeTime = timeValues[ timeValues.length - 1 ].value;
//             }
//         }
//
//         this._scope.$watch('configuration.deliveryDetails.placeDate', (newValue) => {
//             if (!newValue)
//                 return;
//
//             let timeValues = getTimeValues(newValue);
//             this._scope.timeValues = timeValues;
//
//             this._scope.configuration.deliveryDetails.placeTime = timeValues[ timeValues.length - 1 ].value;
//             scopeUtils.apply(this._scope);
//         });
//
//         this._scope.$watch('configuration.deliveryDetails.deadlineTime', async (newValue) => {
//             if (!newValue)
//                 return;
//
//             let orderDateServiceClass = await orderDateServicePromise;
//             let orderDateService = orderDateServiceClass(this._scope.configuration.delivery ? 75 : 45, newValue);
//             this._joinDateTime = orderDateService.joinDateAndTime;
//         });
//
//         if (this._scope.configuration.deliveryDetails.deadlineTime) {
//             let orderDateServiceClass = await orderDateServicePromise;
//             let orderDateService = orderDateServiceClass(this._scope.configuration.delivery ? 75 : 45, this._scope.configuration.deliveryDetails.deadlineTime);
//             this._joinDateTime = orderDateService.joinDateAndTime;
//         }
//     }
//
//     _onDeadlineDateChanged() {
//         this._rejectSinglePayOrderPlace();
//
//         if (!this._scope.configuration.deliveryDetails.placeTime) {
//
//         }
//     }
//
//
//     _onDeadlineTimeChanged() {
//         this._rejectSinglePayOrderPlace();
//     }
//
//     _rejectSinglePayOrderPlace() {
//         if (!this._scope._editMode) {
//             // this._scope.configuration.deliveryDetails.placeEntered = false;
//         }
//     }
//
//     _back(form) {
//         if (form && !form.$valid) {
//             form.highlightAllErrors();
//             return;
//         }
//
//         this._scope.parentBack();
//     }
// }
//
// module.controller('OrderTabDeadline', OrderTabDeadlineController);


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _module2 = __webpack_require__(58);

var _module3 = _interopRequireDefault(_module2);

var _ProfileController = __webpack_require__(815);

var _ProfileController2 = _interopRequireDefault(_ProfileController);

var _OrderHistoryService = __webpack_require__(816);

var _OrderHistoryService2 = _interopRequireDefault(_OrderHistoryService);

var _OrderHistoryDetailsDirective = __webpack_require__(817);

var _OrderHistoryDetailsDirective2 = _interopRequireDefault(_OrderHistoryDetailsDirective);

var _OrderHistoryDirective = __webpack_require__(818);

var _OrderHistoryDirective2 = _interopRequireDefault(_OrderHistoryDirective);

var _OrderHistoryHeaderDirective = __webpack_require__(819);

var _OrderHistoryHeaderDirective2 = _interopRequireDefault(_OrderHistoryHeaderDirective);

var _UserProfileDirective = __webpack_require__(820);

var _UserProfileDirective2 = _interopRequireDefault(_UserProfileDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _module3.default.name;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProfileController = undefined;

var _module2 = __webpack_require__(58);

var _module3 = _interopRequireDefault(_module2);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProfileController = exports.ProfileController = function ProfileController(scope, rootScope, authenticationService, messageService, userProfileService, sessionService) {
    _classCallCheck(this, ProfileController);

    this._scope = scope;
    this._messageService = messageService;
    this._userProfileService = userProfileService;
    this._sessionService = sessionService;
    this._rootScope = rootScope;
};

ProfileController.$inject = ['$scope', '$rootScope', 'AuthenticationService', 'Message', 'UserProfile', 'Session'];


_module3.default.controller('Cartonomy.Profile.ProfileController', ProfileController);

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(58);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderHistoryService = function () {
    function OrderHistoryService(httpService, cartonomyConfig) {
        _classCallCheck(this, OrderHistoryService);

        this._httpService = httpService;
        this._urlBase = cartonomyConfig.ApiV2 + 'order';
    }

    _createClass(OrderHistoryService, [{
        key: 'getDetails',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._httpService.get(this._urlBase + '/' + id);

                            case 2:
                                return _context.abrupt('return', _context.sent.data);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getDetails(_x) {
                return _ref.apply(this, arguments);
            }

            return getDetails;
        }()
    }, {
        key: 'getHistory',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this._httpService.get(this._urlBase);

                            case 2:
                                return _context2.abrupt('return', _context2.sent.data);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getHistory() {
                return _ref2.apply(this, arguments);
            }

            return getHistory;
        }()
    }]);

    return OrderHistoryService;
}();

OrderHistoryService.$inject = ['$http', 'cartonomyConfig'];


_module3.default.factory('OrderHistoryService', OrderHistoryService);

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(58);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderHistoryDetailsDirectiveController = function () {
    function OrderHistoryDetailsDirectiveController(scope, orderHistoryService, cartGroupsService) {
        var _this = this;

        _classCallCheck(this, OrderHistoryDetailsDirectiveController);

        this._scope = scope;
        this._orderHistoryService = orderHistoryService;
        this._cartGroupsService = cartGroupsService;
        scope.printDetails = function () {
            return _this._printDetails();
        };
        scope.groups = [];
        this._getItems();
    }

    _createClass(OrderHistoryDetailsDirectiveController, [{
        key: '_getItems',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var details;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._orderHistoryService.getDetails(this._scope.orderDetails.orderId);

                            case 2:
                                details = _context.sent;
                                _context.next = 5;
                                return this._cartGroupsService.groupItems(details.items, details.participants);

                            case 5:
                                this._scope.groups = _context.sent;

                                _.each(this._scope.groups, function (group) {
                                    group.history = true;
                                    group.editable = false;
                                });

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _getItems() {
                return _ref.apply(this, arguments);
            }

            return _getItems;
        }()
    }, {
        key: '_printDetails',
        value: function _printDetails() {
            window.print();
        }
    }]);

    return OrderHistoryDetailsDirectiveController;
}();

OrderHistoryDetailsDirectiveController.$inject = ['$scope', 'OrderHistoryService', 'CartGroupsService'];


_module3.default.directive('orderHistoryDetails', function () {
    return {
        templateUrl: 'modules/profile/views/orderHistoryDetails.html',
        controller: OrderHistoryDetailsDirectiveController
    };
});

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(58);

var _module3 = _interopRequireDefault(_module2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderHistoryDirectiveController = function () {
    function OrderHistoryDirectiveController(scope, orderHistoryService) {
        var _this = this;

        _classCallCheck(this, OrderHistoryDirectiveController);

        this._scope = scope;
        this._orderHistoryService = orderHistoryService;
        this._scope.viewDetails = function (id) {
            return _this._viewDetails(id);
        };
        this._scope.closeDetails = function () {
            return _this._scope.orderDetails = null;
        };
        this._scope.orderDetails = null;
        this._scope.history = [];
        this._initialize();
    }

    _createClass(OrderHistoryDirectiveController, [{
        key: '_initialize',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var history;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._orderHistoryService.getHistory();

                            case 2:
                                history = _context.sent;

                                this._scope.history = history;

                                _.each(history, function (item) {
                                    item.orderedFormatted = (0, _moment2.default)(item.orderedOn).format('H:mm A dddd, MMMM DD, YYYY');
                                    item.expectedFormatted = (0, _moment2.default)(item.expectedOn).format('MMMM DD, YYYY');
                                    item.address = item.shippingAddress + (item.shippingAddress2 ? ' ' + item.shippingAddress2 : '') + ', ' + item.shippingCity + ', ' + item.shippingState + ' ' + item.shippingZip;
                                });

                                _scope2.default.apply(this._scope);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _initialize() {
                return _ref.apply(this, arguments);
            }

            return _initialize;
        }()
    }, {
        key: '_viewDetails',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this._scope.orderDetails = _.find(this._scope.history, function (item) {
                                    return item.orderId === id;
                                });
                                _scope2.default.apply(this._scope);

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _viewDetails(_x) {
                return _ref2.apply(this, arguments);
            }

            return _viewDetails;
        }()
    }]);

    return OrderHistoryDirectiveController;
}();

OrderHistoryDirectiveController.$inject = ['$scope', 'OrderHistoryService'];


_module3.default.directive('orderHistory', function () {
    return {
        scope: true,
        templateUrl: 'modules/profile/views/orderHistory.html',
        controller: OrderHistoryDirectiveController
    };
});

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module2 = __webpack_require__(58);

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('orderHistoryHeader', function () {
    return {
        transclude: true,
        templateUrl: 'modules/profile/views/orderHistoryHeader.html',
        scope: {
            record: '=orderHistoryHeader'
        }
    };
});

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(58);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _EditAddressController = __webpack_require__(821);

var _EditAddressController2 = _interopRequireDefault(_EditAddressController);

var _utils = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProfileDirectiveController = function () {
    function UserProfileDirectiveController(scope, authenticationService, stateService, userProfileService, dialogService, messageService, rootScope, cartonomyConfig, SessionStorage, sessionService, cartService, localForageService, $translate) {
        var _this = this;

        _classCallCheck(this, UserProfileDirectiveController);

        this._scope = scope;
        this._stateService = stateService;
        this._userProfileService = userProfileService;
        this._dialogService = dialogService;
        this._messageService = messageService;
        this._authenticationService = authenticationService;
        this._cartonomyConfig = cartonomyConfig;
        this._rootScope = rootScope;
        //this._sessionStorageService = SessionStorage;
        this._localForageService = localForageService;
        this._sessionService = sessionService;
        this._cartService = cartService;
        this._translateService = $translate;

        scope.emailEditMode = false;
        scope.addressEditMode = false;

        scope.data = {
            addresses: [],
            emails: []
        };

        scope.openIdProviders = authenticationService.getOpenIdProviders();

        scope.toggleEmailEditMode = function () {
            return scope.emailEditMode = !scope.emailEditMode;
        };
        scope.toggleAddressEditMode = function () {
            return scope.addressEditMode = !scope.addressEditMode;
        };
        scope.toggleNameEditMode = function () {
            return scope.nameEditMode = !scope.nameEditMode;
        };

        scope.changePassword = function () {
            return authenticationService.showChangePasswordDialog();
        };
        scope.canChangePassword = function () {
            return _this._canChangePassword();
        };
        scope.login = function () {
            return authenticationService.showLoginDialog();
        };
        scope.logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', _this.logout());

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        scope.canLoadAvatarFrom = function (openIdProvider) {
            return _this._canLoadAvatarFrom(openIdProvider);
        };
        scope.updateAvatarFromProvider = function (provider) {
            return _this._updateAvatarFromProvider(provider);
        };

        scope.canLinkAccount = function (openIdProvider) {
            return _this._canLinkAccount(openIdProvider);
        };
        scope.linkToProvider = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(openIdProvider) {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                return _context2.abrupt('return', _this._linkAccountToProvider(openIdProvider));

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }));

            return function (_x) {
                return _ref2.apply(this, arguments);
            };
        }();

        this.onOAuthResponseCallback = function (event) {
            return _this.onOAuthResponse(event);
        };
        window.addEventListener('message', this.onOAuthResponseCallback);

        scope.isStoreAdmin = function () {
            return _this._rootScope.isStoreAdmin;
        };
        scope.changeAvatar = function () {
            return _this._changeAvatar(event);
        };

        scope.goToGroupOrderReport = function () {
            _this._stateService.go(_CommonConstants2.default.RoutingStates.STORE_ADMIN);
        };

        scope.goToOpenCarts = function () {
            _this._stateService.go(_CommonConstants2.default.RoutingStates.OPEN_CARTS);
        };
        scope.createNewGroupOrder = function () {
            // 1. Clear Stealth mod if needed
            if (_this._sessionService.getStealthUserMode()) {
                _this._sessionService.setStealthUserMode(null);
                _this._cartService.resetCart();
                _this._rootScope.$broadcast(_CommonConstants2.default.Events.ORDER_CANCELLED);
            }

            // 2. go to
            _this._rootScope.$broadcast(_CommonConstants2.default.Events.OPEN_SPLASH_SCREEN);
            _this._stateService.go(_CommonConstants2.default.RoutingStates.CART);
        };

        scope.addEmailInput = function () {
            return _this._addEmailInput();
        };
        scope.saveProfile = function () {
            return _this._save();
        };
    }

    _createClass(UserProfileDirectiveController, [{
        key: '$onInit',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function $onInit() {
                return _ref3.apply(this, arguments);
            }

            return $onInit;
        }()
    }, {
        key: '_save',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var _this2 = this;

                var isError, user;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                isError = false;

                                this._scope.profile.emails.forEach(function (item) {
                                    if (!isError && !_CommonConstants2.default.EMAIL_REGEX.test(item.email)) {
                                        _this2._messageService.showErrorPopup("Incorrect email address");
                                        isError = true;
                                    }
                                });

                                if (!isError) {
                                    _context4.next = 4;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 4:
                                _context4.prev = 4;
                                _context4.next = 7;
                                return this._userProfileService.saveProfile({
                                    firstName: this._scope.profile.firstName,
                                    lastName: this._scope.profile.lastName,
                                    emails: this._scope.profile.emails
                                });

                            case 7:
                                user = _context4.sent;

                                this._messageService.showMessagePopup(this._translateService.instant('client.profile.success'));
                                _context4.t0 = this._sessionService;
                                _context4.t1 = user.email;
                                _context4.t2 = user.fullName;
                                _context4.t3 = user.firstName;
                                _context4.t4 = user.lastName;
                                _context4.next = 16;
                                return this._sessionService.getAuthToken();

                            case 16:
                                _context4.t5 = _context4.sent;
                                _context4.next = 19;
                                return this._sessionService.isInvite();

                            case 19:
                                _context4.t6 = _context4.sent;
                                _context4.t7 = {
                                    userEmail: _context4.t1,
                                    userName: _context4.t2,
                                    firstName: _context4.t3,
                                    lastName: _context4.t4,
                                    authToken: _context4.t5,
                                    isInvite: _context4.t6
                                };

                                _context4.t0.setSessionDetails.call(_context4.t0, _context4.t7);

                                _context4.next = 27;
                                break;

                            case 24:
                                _context4.prev = 24;
                                _context4.t8 = _context4['catch'](4);

                                this._messageService.showErrorPopupForResponse(_context4.t8);

                            case 27:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[4, 24]]);
            }));

            function _save() {
                return _ref4.apply(this, arguments);
            }

            return _save;
        }()
    }, {
        key: 'logout',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var stateToGo;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this._authenticationService.logout();

                            case 2:
                                this._rootScope.$broadcast(_CommonConstants2.default.Events.USER_LOGGED_OUT);

                                stateToGo = this._cartonomyConfig.externalStoreMode ? _CommonConstants2.default.RoutingStates.CART : _CommonConstants2.default.RoutingStates.CATALOG;

                                this._authenticationService.showLoginDialog('', 'login');

                            case 5:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function logout() {
                return _ref5.apply(this, arguments);
            }

            return logout;
        }()
    }, {
        key: '_changeAvatar',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6($event) {
                var file, upload;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!($event && $event.target.files && $event.target.files.length > 0)) {
                                    _context6.next = 6;
                                    break;
                                }

                                file = $event.target.files[0];
                                _context6.next = 4;
                                return this._userProfileService.uploadAvatar(file);

                            case 4:
                                upload = _context6.sent;

                                if (upload.status === 200) {
                                    this._scope.profile.avatar = upload.data.data.avatar;
                                    this._scope.profile.avatarCropped = upload.data.data.avatar;
                                    this._rootScope.$broadcast(_CommonConstants2.default.RootEvents.USER_PROFILE_UPDATED);
                                    _scope2.default.apply(this._scope);
                                }

                            case 6:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function _changeAvatar(_x2) {
                return _ref6.apply(this, arguments);
            }

            return _changeAvatar;
        }()
    }, {
        key: '_canChangePassword',
        value: function _canChangePassword() {
            return !this._scope.isGuest && this._scope.profile && !this._scope.profile.linkOAuthOnly;
        }
    }, {
        key: '_canLoadAvatarFrom',
        value: function _canLoadAvatarFrom(openIdProvider) {
            return this._scope.profile && this._scope.profile.linkedOAuth && _.some(this._scope.profile.linkedOAuth, function (p) {
                return p == openIdProvider;
            });
        }
    }, {
        key: '_canLinkAccount',
        value: function _canLinkAccount(openIdProvider) {
            return this._scope.profile && this._scope.profile.linkedOAuth && !_.some(this._scope.profile.linkedOAuth, function (p) {
                return p == openIdProvider;
            });
        }
    }, {
        key: '_linkAccountToProvider',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(openIdProvider) {
                var externalLogin;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this._localForageService.store(_CommonConstants2.default.SessionStorage.LINKING_SOCIAL_ACCOUNT, true);

                            case 2:
                                _context7.next = 4;
                                return this._authenticationService.checkLoginToken();

                            case 4:
                                externalLogin = this._authenticationService.externalLogin(openIdProvider);

                                window.open('' + externalLogin, 'social_login_facebook');

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function _linkAccountToProvider(_x3) {
                return _ref7.apply(this, arguments);
            }

            return _linkAccountToProvider;
        }()
    }, {
        key: '_updateAvatarFromProvider',
        value: function _updateAvatarFromProvider(provider) {
            var _this3 = this;

            this._userProfileService.updateOpenIdAvatar(provider).then(function () {
                _this3._rootScope.$broadcast(_CommonConstants2.default.RootEvents.USER_PROFILE_UPDATED);
            }, function (error) {
                var message = _this3._messageService.getMessageFromErrorResponse(error) || 'Cannot update avatar';
                _this3._messageService.showErrorPopup(message);
            });
        }
    }, {
        key: 'onOAuthResponse',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(response) {
                var responseData, authToken, user, awaitingInvitation, linkingSocialAccount;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (!(response.data.eventType !== 'OAuthResult')) {
                                    _context8.next = 2;
                                    break;
                                }

                                return _context8.abrupt('return');

                            case 2:
                                _context8.next = 4;
                                return this._sessionService.loggedIn();

                            case 4:
                                if (_context8.sent) {
                                    _context8.next = 6;
                                    break;
                                }

                                return _context8.abrupt('return');

                            case 6:
                                responseData = response.data;
                                authToken = responseData.token;

                                if (!(!authToken && responseData.errorMessage)) {
                                    _context8.next = 12;
                                    break;
                                }

                                _context8.next = 11;
                                return this._messageService.showErrorPopup(responseData.errorMessage);

                            case 11:
                                return _context8.abrupt('return');

                            case 12:

                                window.removeEventListener('message', this.onOAuthResponseCallback);
                                _context8.prev = 13;
                                _context8.next = 16;
                                return this._authenticationService.externalLoginFinalize(authToken);

                            case 16:
                                _context8.next = 23;
                                break;

                            case 18:
                                _context8.prev = 18;
                                _context8.t0 = _context8['catch'](13);
                                _context8.next = 22;
                                return this._messageService.showErrorPopupForResponse(_context8.t0);

                            case 22:
                                return _context8.abrupt('return');

                            case 23:
                                _context8.next = 25;
                                return this._sessionService.clearSessionDetails();

                            case 25:
                                _context8.t1 = this._sessionService;
                                _context8.t2 = authToken;
                                _context8.next = 29;
                                return this._sessionService.getUserEmail();

                            case 29:
                                _context8.t3 = _context8.sent;
                                _context8.next = 32;
                                return this._sessionService.getUserName();

                            case 32:
                                _context8.t4 = _context8.sent;
                                _context8.t5 = {
                                    authToken: _context8.t2,
                                    userEmail: _context8.t3,
                                    userName: _context8.t4
                                };
                                _context8.next = 36;
                                return _context8.t1.setSessionDetails.call(_context8.t1, _context8.t5);

                            case 36:
                                this._userProfileService.resetUser();
                                _context8.next = 39;
                                return this._userProfileService.getUser();

                            case 39:
                                user = _context8.sent;
                                _context8.next = 42;
                                return this._sessionService.setSessionDetails({
                                    authToken: authToken,
                                    userEmail: user.email,
                                    userName: user.fullName,
                                    firstName: user.firstName,
                                    lastName: user.lastName
                                });

                            case 42:
                                awaitingInvitation = null;

                                if (_utils.utils.hash.indexOf('#/invite/') > -1) {
                                    awaitingInvitation = JSON.stringify({ participantToken: _utils.utils.hash.replace('#/invite/', '') });
                                }

                                if (!awaitingInvitation) {
                                    _context8.next = 47;
                                    break;
                                }

                                this._stateService.go(_CommonConstants2.default.RoutingStates.INVITE, JSON.parse(awaitingInvitation));
                                return _context8.abrupt('return');

                            case 47:
                                _context8.next = 49;
                                return this._localForageService.retrieve(_CommonConstants2.default.SessionStorage.LINKING_SOCIAL_ACCOUNT);

                            case 49:
                                linkingSocialAccount = _context8.sent;

                                if (!linkingSocialAccount) {
                                    _context8.next = 55;
                                    break;
                                }

                                _context8.next = 53;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.LINKING_SOCIAL_ACCOUNT);

                            case 53:
                                this._stateService.go(_CommonConstants2.default.RoutingStates.USER_PROFILE);
                                return _context8.abrupt('return');

                            case 55:

                                this._sessionService.setCartReference(null);

                            case 56:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this, [[13, 18]]);
            }));

            function onOAuthResponse(_x4) {
                return _ref8.apply(this, arguments);
            }

            return onOAuthResponse;
        }()
    }]);

    return UserProfileDirectiveController;
}();

UserProfileDirectiveController.$inject = ['$scope', 'AuthenticationService', '$state', 'UserProfile', '$mdDialog', 'Message', '$rootScope', 'cartonomyConfig', 'SessionStorage', 'Session', 'CartService', 'LocalForageService', '$translate'];


_module3.default.directive('userProfile', function () {
    return {
        scope: true,
        template: __webpack_require__(823),
        controller: UserProfileDirectiveController
    };
});

_module3.default.directive('fileOnChange', function () {
    return {
        scope: true,
        restrict: 'A',
        link: function link(scope, element, attrs) {
            element.bind('change', scope.changeAvatar);
        },
        controller: UserProfileDirectiveController
    };
});

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _states = __webpack_require__(822);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditAddressController = function () {
    function EditAddressController(scope, dialogService, address) {
        var _this = this;

        _classCallCheck(this, EditAddressController);

        this._dialogService = dialogService;
        this._scope = scope;
        scope.states = _states2.default;

        scope.address = address;
        scope.save = function (form) {
            return _this.save(form);
        };
        scope.cancel = function () {
            return _this.cancel();
        };
    }

    _createClass(EditAddressController, [{
        key: 'save',
        value: function save(form) {
            if (!form.$valid) {
                form.highlightAllErrors();
                return;
            }

            this._dialogService.hide(this._scope.address);
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this._dialogService.cancel();
        }
    }]);

    return EditAddressController;
}();

exports.default = ['$scope', '$mdDialog', 'address', function (scope, dialogService, address) {
    return new EditAddressController(scope, dialogService, address);
}];

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = ["AL","AK","AZ","AR","CA","CO","CT","DE","DC","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"]

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = "<div class=\"profile\"><div class=\"main-info\"><div class=\"top-row\"><div class=\"avatar\"><img ng-src=\"{{ profile.avatar }}\"/><label class=\"change-avatar-label\" for=\"Avatar\" title=\"Change avatar\"><svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"#F9F9F9\"/>\n<path d=\"M10 17.917V20H12.083L18.2266 13.8564L16.1436 11.7734L10 17.917ZM19.8375 12.2455C20.0542 12.0289 20.0542 11.6789 19.8375 11.4623L18.5377 10.1625C18.3211 9.94584 17.9711 9.94584 17.7545 10.1625L16.738 11.179L18.821 13.262L19.8375 12.2455Z\" fill=\"#54636C\"/>\n</svg>\n<input type=\"file\" file-on-change=\"changeAvatar($event)\" name=\"Avatar\" id=\"Avatar\" accept=\"image/x-png,image/jpeg\"/></label></div><div class=\"right-inputs\"><div class=\"input-group\"><label for=\"firstName\">{{'client.auth.firstname' | translate}}</label><input id=\"firstName\" ng-model=\"profile.firstName\" type=\"text\"/></div><div class=\"input-group\"><label for=\"lastName\">{{'client.auth.lastname' | translate}}</label><input id=\"lastName\" ng-model=\"profile.lastName\" type=\"text\"/></div></div></div><div class=\"email-inputs\"><div class=\"input-group\"><label for=\"email\">{{'client.email' | translate}}</label><input id=\"email\" ng-repeat=\"item in profile.emails\" ng-disabled=\"profile.linkedOAuth.length &gt; 0\" ng-model=\"item.email\" type=\"email\"/></div></div><div class=\"buttons-container m-0\"><button class=\"btn-lg primary\" ng-click=\"saveProfile()\">{{'client.save' | translate}}</button><button class=\"btn-lg primary\" ng-click=\"changePassword()\" ng-if=\"canChangePassword()\">{{'client.user.change_password' | translate}}</button></div></div><div class=\"buttons-container\"><button class=\"provider-btn facebook btn-lg\" ng-click=\"linkToProvider('Facebook')\" ng-if=\"canLinkAccount('Facebook')\">{{'client.auth.facebook_link' | translate}}<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z\" fill=\"white\"/>\n<path d=\"M12.5139 10.3915H10.7295V16.9286H8.02602V10.3915H6.74023V8.09404H8.02602V6.60736C8.02602 5.54422 8.53103 3.87946 10.7536 3.87946L12.7561 3.88783V6.11786H11.3031C11.0648 6.11786 10.7297 6.23694 10.7297 6.74409V8.09618H12.7501L12.5139 10.3915Z\" fill=\"#4E69A2\"/>\n</svg>\n</button><button class=\"provider-btn facebook btn-lg\" ng-click=\"updateAvatarFromProvider('Facebook')\" ng-if=\"canLoadAvatarFrom('Facebook')\">{{'client.auth.facebook_avatar' | translate}}<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z\" fill=\"white\"/>\n<path d=\"M12.5139 10.3915H10.7295V16.9286H8.02602V10.3915H6.74023V8.09404H8.02602V6.60736C8.02602 5.54422 8.53103 3.87946 10.7536 3.87946L12.7561 3.88783V6.11786H11.3031C11.0648 6.11786 10.7297 6.23694 10.7297 6.74409V8.09618H12.7501L12.5139 10.3915Z\" fill=\"#4E69A2\"/>\n</svg>\n</button><button class=\"provider-btn google btn-lg\" ng-click=\"linkToProvider('Google')\" ng-if=\"canLinkAccount('Google')\">{{'client.auth.google_link' | translate}}<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z\" fill=\"white\"/>\n<path d=\"M10 8.8V11.2H13.3948C12.8992 12.5968 11.5648 13.6 10 13.6C8.0152 13.6 6.4 11.9848 6.4 10C6.4 8.0152 8.0152 6.4 10 6.4C10.8604 6.4 11.6884 6.7084 12.3316 7.2688L13.9084 5.4592C12.8284 4.5184 11.4412 4 10 4C6.6916 4 4 6.6916 4 10C4 13.3084 6.6916 16 10 16C13.3084 16 16 13.3084 16 10V8.8H10Z\" fill=\"#4285F6\"/>\n</svg>\n</button><button class=\"provider-btn google btn-lg\" ng-click=\"updateAvatarFromProvider('Google')\" ng-if=\"canLoadAvatarFrom('Google')\">{{'client.auth.google_avatar' | translate}}<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z\" fill=\"white\"/>\n<path d=\"M10 8.8V11.2H13.3948C12.8992 12.5968 11.5648 13.6 10 13.6C8.0152 13.6 6.4 11.9848 6.4 10C6.4 8.0152 8.0152 6.4 10 6.4C10.8604 6.4 11.6884 6.7084 12.3316 7.2688L13.9084 5.4592C12.8284 4.5184 11.4412 4 10 4C6.6916 4 4 6.6916 4 10C4 13.3084 6.6916 16 10 16C13.3084 16 16 13.3084 16 10V8.8H10Z\" fill=\"#4285F6\"/>\n</svg>\n</button></div><div class=\"buttons-container\"><div class=\"side-by-side-buttons-block\" ng-if=\"isStoreAdmin()\"><button class=\"btn-lg primary btn-left\" ng-click=\"goToOpenCarts()\">{{'client.cart.open' | translate}}</button><button class=\"btn-lg primary btn-right\" ng-click=\"goToGroupOrderReport()\">{{'client.cart.order_report' | translate}}</button></div><button class=\"btn-lg primary\" ng-if=\"!isStoreAdmin()\" ng-click=\"goToOpenCarts()\">{{'client.cart.open_view' | translate}}</button><button class=\"btn-lg primary\" ng-click=\"logout()\">{{'client.auth.logout' | translate}}</button></div></div>"

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _module2 = __webpack_require__(116);

var _module3 = _interopRequireDefault(_module2);

var _ChatViewController = __webpack_require__(825);

var _ChatViewController2 = _interopRequireDefault(_ChatViewController);

var _CategoryController = __webpack_require__(826);

var _CategoryController2 = _interopRequireDefault(_CategoryController);

var _ProductDetailController = __webpack_require__(430);

var _ProductDetailController2 = _interopRequireDefault(_ProductDetailController);

var _ProductListDirective = __webpack_require__(827);

var _ProductListDirective2 = _interopRequireDefault(_ProductListDirective);

var _ChatDirective = __webpack_require__(828);

var _ChatDirective2 = _interopRequireDefault(_ChatDirective);

var _ChatCounterDirective = __webpack_require__(832);

var _ChatCounterDirective2 = _interopRequireDefault(_ChatCounterDirective);

var _CatalogService = __webpack_require__(833);

var _CatalogService2 = _interopRequireDefault(_CatalogService);

var _ChatService = __webpack_require__(834);

var _ChatService2 = _interopRequireDefault(_ChatService);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.controller('Cartonomy.Catalog.ChatViewController', _ChatViewController2.default);

_module3.default.controller('Cartonomy.Catalog.CategoryController', ['$scope', '$rootScope', '$state', 'Message', '$stateParams', 'OrderSetupService', 'GroupOrder', 'CheckoutService', 'CartService', _CategoryController2.default]);

_module3.default.directive('cartonomyCatalogProductList', function () {
    return {
        scope: {
            categoryId: '=',
            searchString: '='
        },
        templateUrl: 'modules/catalog/views/productList.html',
        controller: _ProductListDirective2.default
    };
});

_module3.default.directive('cartonomyCatalogChat', function () {
    return {
        scope: true,
        template: __webpack_require__(835),
        controller: _ChatDirective2.default
    };
});

_module3.default.service('CatalogService', _CatalogService2.default);

_module3.default.service('CatalogChatService', _ChatService2.default);

_module3.default.directive('chatCounter', [function () {
    return {
        templateUrl: '/modules/catalog/views/chatCounterDirective.html',
        controller: _ChatCounterDirective2.default
    };
}]);

_module3.default.directive('chatListener', ['CatalogChatService', function (chatService) {
    return {
        link: function link(scope, element, attr) {

            var count = chatService.getUnreadMessages();
            if (count && count > 0) {
                element.addClass(attr.chatListener);
            }

            scope.$on(_CommonConstants2.default.Events.CHAT_MESSAGE_RECEIVED, function (scope, unreadMessages) {
                if (unreadMessages) {
                    element.addClass(attr.chatListener);
                } else {
                    element.removeClass(attr.chatListener);
                }
                _scope2.default.apply(scope);
            });
        }
    };
}]);

exports.default = _module3.default.name;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChatViewController = function () {
    function ChatViewController(scope) {
        var _this = this;

        _classCallCheck(this, ChatViewController);

        this._scope = scope;
        this._scope.CHATVIEW = 0;
        this._scope.INVITEDPEOPLE = 1;

        this._scope.switchTab = function (tab) {
            return _this._switchTab(tab);
        };
        this._scope.switchToChatTab = function () {
            return _this._switchToChatTab();
        };
        this._scope.switchToInvitedPeopleTab = function () {
            return _this._switchToInvitedPeopleTab();
        };
    }

    _createClass(ChatViewController, [{
        key: '_switchTab',
        value: function _switchTab(tab) {
            this._scope.selectedTab = tab;
        }
    }, {
        key: '_switchToChatTab',
        value: function _switchToChatTab() {
            this._switchTab(this._scope.CHATVIEW);
        }
    }, {
        key: '_switchToInvitedPeopleTab',
        value: function _switchToInvitedPeopleTab() {
            this._switchTab(this._scope.INVITEDPEOPLE);
        }
    }]);

    return ChatViewController;
}();

ChatViewController.$inject = ['$scope'];
exports.default = ChatViewController;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _module2 = __webpack_require__(116);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function CategoryController(scope, rootScope, state, messageService, stateParams, orderSetupService, groupOrder, checkoutService, cartService) {

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var externalPayerId, cart, isGroupOrder, hasSavedSession;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        scope.page = 1;

                        scope.underConstruction = function () {
                            messageService.showErrorPopup('Under Construction');
                        };

                        if (!stateParams.externalPayerId) {
                            _context.next = 6;
                            break;
                        }

                        rootScope.externalPayerId = stateParams.externalPayerId;
                        state.go(_CommonConstants2.default.RoutingStates.CATALOG);
                        return _context.abrupt('return');

                    case 6:
                        if (!rootScope.externalPayerId) {
                            _context.next = 17;
                            break;
                        }

                        externalPayerId = rootScope.externalPayerId;

                        rootScope.externalPayerId = undefined;

                        _context.next = 11;
                        return cartService.getCart();

                    case 11:
                        cart = _context.sent;
                        isGroupOrder = cartService.isGroupOrder(cart);
                        hasSavedSession = groupOrder.hasSavedSession();
                        _context.next = 16;
                        return checkoutService.submitOrder('PayPal', scope.total, {
                            externalPayerId: externalPayerId,
                            isAuthorization: hasSavedSession
                        });

                    case 16:

                        if (hasSavedSession) {
                            orderSetupService.continueOrder({
                                externalPayerId: externalPayerId
                            });
                        } else {
                            state.go(_CommonConstants2.default.RoutingStates.CONFIRM_ORDER);
                        }

                    case 17:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }))();
}

exports.default = CategoryController;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = __webpack_require__(116);

var _module3 = _interopRequireDefault(_module2);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _ProductDetailController = __webpack_require__(430);

var _ProductDetailController2 = _interopRequireDefault(_ProductDetailController);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductListDirectiveController = function () {
    function ProductListDirectiveController(scope, mdDialog, catalogService, cartService, timeoutService, messageService, locationService) {
        var _this = this;

        _classCallCheck(this, ProductListDirectiveController);

        this._scope = scope;
        this._catalogService = catalogService;
        this._cartService = cartService;
        this._messageService = messageService;
        this._timeoutService = timeoutService;
        this._dialogService = mdDialog;
        this._locationService = locationService;

        scope.products = [];
        scope.pageNum = 0;
        scope.hasMore = true;

        scope.loadMore = function () {
            return _this._loadMore();
        };
        scope.customizeProduct = function (product) {
            return _this._customizeProduct(product);
        };
        scope.endCustomizeProduct = function (product) {
            return _this._endCustomizeProduct(product);
        };
        scope.customizeKeyPressed = function ($event, product) {
            return _this._customizeKeyPressed($event, product);
        };

        scope.$watch('categoryId', function (newValue, oldValue) {
            return _this._onCategoryIdChanged(newValue, oldValue);
        });

        scope.$watch('searchString', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                _this.refreshList();
            }
        });

        scope.showProductDetail = function (product) {
            return _this._showProductDetail(product);
        };
        scope.addToCart = function (product) {
            return _this._addToCart(product);
        };
    }

    _createClass(ProductListDirectiveController, [{
        key: '$onInit',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.refreshList();

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function $onInit() {
                return _ref.apply(this, arguments);
            }

            return $onInit;
        }()
    }, {
        key: '_loadMore',
        value: function _loadMore() {
            this._scope.pageNum++;
            this.refreshList();
        }
    }, {
        key: '_customizeProduct',
        value: function _customizeProduct(product) {
            product.showComment = true;
            product.setFocus();
        }
    }, {
        key: '_endCustomizeProduct',
        value: function _endCustomizeProduct(product) {
            if (!product.comment.length) {
                product.showComment = false;
            }
            this._addToCart(product);
        }
    }, {
        key: '_customizeKeyPressed',
        value: function _customizeKeyPressed($event, product) {
            if ($event.which === 13) {
                this.endCustomizeProduct(product);
            }
        }
    }, {
        key: '_onCategoryIdChanged',
        value: function _onCategoryIdChanged(newValue, oldValue) {

            if (newValue === oldValue) {
                return;
            }

            this.catDefaults();
            this.refreshList();
        }
    }, {
        key: 'catDefaults',
        value: function catDefaults() {
            this._scope.pageNum = 0;
            this._scope.hasMore = true;
            this._scope.products = [];
        }
    }, {
        key: 'prepareProducts',
        value: function prepareProducts() {
            var _this2 = this;

            _.each(this._scope.products, function (product) {
                if (!product.image) {
                    product.image = _CommonConstants2.default.DEFAULT_PRODUCT_IMAGE;
                } else {
                    product.image = product.image.replace(/^(\w)+\:/, function () {
                        return _this2._locationService.protocol() + ':';
                    });
                }
                product.quantity = 1;
                product.comment = "";
                product.showComment = false;
                product.addedState = false;
                product.setFocus = function () {};
            });
        }
    }, {
        key: 'refreshList',
        value: function refreshList() {
            var _this3 = this;

            if (!this._scope.searchString && !this._scope.categoryId) {
                this._scope.products = [];
                return;
            }

            if (_.isEmpty(this._scope.searchString)) {
                var limit = _CommonConstants2.default.Pagination.PAGE_LIMIT;
                var offset = this._scope.pageNum * limit;
                this._catalogService.getProductsBySuperCategory(this._scope.categoryId, offset, limit).then(function (data) {
                    var _products = data || [];
                    if (_.isEmpty(_products)) {
                        _this3._scope.hasMore = false;
                    }

                    _this3._scope.products = _this3._scope.products.concat(_products);
                    _this3.prepareProducts();
                });
            } else {
                this._catalogService.searchProducts(this._scope.searchString, 0).then(function (data) {
                    _this3._scope.products = data.productList.result || {};
                    _this3.prepareProducts();
                });
            }
        }
    }, {
        key: '_showProductDetail',
        value: function _showProductDetail(product) {
            var _this4 = this;

            this._catalogService.getProduct(product.id).then(function (product) {
                _this4._dialogService.show({
                    controller: _ProductDetailController2.default,
                    templateUrl: '/modules/catalog/views/productDetails.html',
                    clickOutsideToClose: true,
                    locals: {
                        product: product
                    }
                });
            });
        }
    }, {
        key: '_addToCart',
        value: function _addToCart(product) {
            var _this5 = this;

            this._cartService.addProduct({
                id: product.id,
                image: product.image,
                quantity: product.quantity || 1,
                comment: product.comment,
                name: product.name,
                price: product.price
            }).then(function () {
                product.quantity = 1;
                product.comment = "";
                product.showComment = false;
                product.addedState = true;
                _this5._timeoutService(function () {
                    product.addedState = false;
                }, 3000);
            }, function (error) {
                return _this5._messageService.showErrorPopupForResponse(error);
            });
        }
    }]);

    return ProductListDirectiveController;
}();

ProductListDirectiveController.$inject = ['$scope', '$mdDialog', 'CatalogService', 'CartService', '$timeout', 'Message', '$location'];
exports.default = ProductListDirectiveController;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

var _emojiPicker = __webpack_require__(829);

var _emojiPicker2 = _interopRequireDefault(_emojiPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var logoPath = 'resources/images/cartonomy-icon.svg';

var ChatDirectiveController = function () {
    function ChatDirectiveController(scope, catalogChatService, stateService, messageService, timeoutService, Session, localForageService, $, configurationService, cartService, rootScope, orderSetupService) {
        var _this = this;

        _classCallCheck(this, ChatDirectiveController);

        this._onChatUpdated = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var newMessages;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setTimeout(function () {
                                if (document.querySelector('.msg_container_base') && document.querySelector('.msg_container_base')) {
                                    document.querySelector('.msg_container_base').scrollTop = document.querySelector('.msg_container_base').scrollHeight;
                                }
                            }, 100);
                            _this._scope.refreshing = true;
                            _context.next = 4;
                            return _this._catalogChatService.getMessages();

                        case 4:
                            newMessages = _context.sent;

                            if (_this._scope.messages.length <= newMessages.length) {
                                _this._scope.messages = newMessages;
                            }
                            _this._scope.hasMore = false;

                            if (_this._scope.compactMode && _this._scope.messages.length > _CommonConstants2.default.CHAT_MESSAGES_LIMIT) {
                                _this._scope.messages = _.slice(_this._scope.messages, _this._scope.messages.length - _CommonConstants2.default.CHAT_MESSAGES_LIMIT);
                                _this._scope.hasMore = true;
                            }

                            if (_this._scope.messages.length) {
                                _context.next = 12;
                                break;
                            }

                            _this._scope.participants = [];
                            // this._scope.refreshing = false;
                            _scope2.default.apply(_this._scope);
                            return _context.abrupt('return');

                        case 12:

                            _.each(_this._scope.messages, function (message) {
                                message.name = message.Name || message.name || message.Email || message.email;
                                message.email = message.Email || message.email;
                                message.message = _this._formatMessage(message.Message) || _this._formatMessage(message.message);
                                message.isMy = message.email === _this._scope.currentLoggedInUserEmail;

                                // message.message = message.message.replace('target="_parent"', 'target="_blank"');

                                message.iconLetter = message.name[0];
                                message.avatarCropped = message.avatarCropped || message.AvatarCropped;
                                message.avatar = message.avatar || message.Avatar;
                            });

                            _this._scope.participants = _.chain(_this._scope.messages).map(function (m) {
                                return _.pick(m, ['email', 'name']);
                            }).uniqWith(_.isEqual).sortBy('name').value();
                            _this._scope.selectedParticipants = _this._scope.participants.map(function (r) {
                                return r.email;
                            });

                            _this._scope.refreshing = false;
                            _scope2.default.apply(_this._scope);

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));


        this._catalogChatService = catalogChatService;
        this._scope = scope;
        this._stateService = stateService;
        this._cartService = cartService;
        this._messageService = messageService;
        this._sessionService = Session;
        this._configurationService = configurationService;
        //this._sessionStorageService = SessionStorage;
        this._localForageService = localForageService;
        this.currentClientTime = new Date();
        this.currentClientTimeCount = new Date().getTime();
        this._rootScope = rootScope;
        this._orderSetupService = orderSetupService;
        scope.copyClipboard = function () {
            return _this._copyClipboard();
        };

        scope.participants = [];
        scope.messages = [];
        scope.newMessage = '';
        scope.compactMode = stateService.is(_CommonConstants2.default.RoutingStates.CATALOG);
        scope.maxTextLength = _CommonConstants2.default.MAXIMUM_CHAT_TEXT_LENGTH;
        scope.refreshing = false;
        scope.selectedParticipants = [];
        this._sessionService.getUserEmail().then(function (result) {
            return scope.currentLoggedInUserEmail = result;
        });
        this.jQuery = $;

        scope.getTimeForMessage = function (messageUTCTime) {
            var currentTime = new Date().getTime();
            return new Date(messageUTCTime).getTime() > currentTime ? currentTime : messageUTCTime;
        };

        scope.participantsFilter = function () {
            return _this._participantsFilter();
        };
        scope.selectAllParticipants = function () {
            return _this._selectAllParticipants();
        };
        scope.checkedAllParticipants = function () {
            return _this._checkedAllParticipants();
        };

        scope.isSvg = function (path) {
            return !!path && path.indexOf(logoPath) > -1;
        };
        scope.$on('$destroy', _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this._catalogChatService.startWatchingOnUnreadMessage();

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        })));

        scope.$on(_CommonConstants2.default.Events.WINDOW_STATE_CHANGED, function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(scope, state) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(state === _CommonConstants2.default.WindowMode.maximized)) {
                                    _context3.next = 3;
                                    break;
                                }

                                _context3.next = 3;
                                return _this._catalogChatService.stopWatchingForUnreadMessage();

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this);
            }));

            return function (_x, _x2) {
                return _ref3.apply(this, arguments);
            };
        }());

        scope.$on(_CommonConstants2.default.Events.REALTIME_CHAT_RECEIVED, function (scope) {
            timeoutService(function () {
                return _this._onChatUpdated();
            }, 1);
        });

        scope.postMessage = function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(event) {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                return _context4.abrupt('return', _this._postMessage(event));

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this);
            }));

            return function (_x3) {
                return _ref4.apply(this, arguments);
            };
        }();

        scope.onMessageTextAreaKeyPress = function (event) {
            if (event.which === 13) {
                return _this._postMessage(event).then(function () {
                    return;
                });
            }
        };

        scope.showMore = function () {
            return _this._showMore();
        };

        this._refreshTimes = 0;
        this._lastRefreshTime = null;
        this.emojiEditor = null;
        this.emojiArea = null;
        scope.isStealthUserMode = this._sessionService.getStealthUserMode();
    }

    _createClass(ChatDirectiveController, [{
        key: '$onInit',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var _this2 = this;

                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                this._rootScope.storeWindowTitle = 'Group Chat';
                                new _emojiPicker2.default({
                                    emojiable_selector: '[data-emojiable=true]',
                                    assetsPath: '/resources/emoji-data/emoji-picker/img',
                                    popupButtonClasses: 'fa fa-smile-o',
                                    onLoaded: function onLoaded(emojiEditor, emojiArea) {

                                        if (_this2._scope.isStealthUserMode && emojiEditor) {
                                            emojiEditor[0].setAttribute("placeholder", 'You are viewing this cart and cannot send messages');
                                            emojiEditor[0].setAttribute("disabled", 'disabled');
                                        }

                                        _this2.emojiEditor = emojiEditor;
                                        _this2.emojiArea = emojiArea;
                                    },
                                    onKeyUp: function () {
                                        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(event, emojiEditor) {
                                            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                                                while (1) {
                                                    switch (_context5.prev = _context5.next) {
                                                        case 0:
                                                            _scope2.default.apply(_this2._scope, function () {
                                                                _this2._scope.newMessage = emojiEditor.html();
                                                            });

                                                            if (!(event.which === 13)) {
                                                                _context5.next = 5;
                                                                break;
                                                            }

                                                            _this2._scope.newMessage = emojiEditor.html();
                                                            _context5.next = 5;
                                                            return _this2._postMessage(event);

                                                        case 5:
                                                        case 'end':
                                                            return _context5.stop();
                                                    }
                                                }
                                            }, _callee5, _this2);
                                        }));

                                        return function onKeyUp(_x4, _x5) {
                                            return _ref6.apply(this, arguments);
                                        };
                                    }()
                                }).discover();

                                _context8.next = 4;
                                return this._refreshData();

                            case 4:

                                this._refreshTimes = 0;
                                this._lastRefreshTime = null;
                                this._scope.$on(_CommonConstants2.default.Events.SIGNALR_CONNECTED, function () {
                                    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(scope) {
                                        return regeneratorRuntime.wrap(function _callee6$(_context6) {
                                            while (1) {
                                                switch (_context6.prev = _context6.next) {
                                                    case 0:
                                                        if (!(_this2._lastRefreshTime && (0, _moment2.default)(_this2._lastRefreshTime).diff((0, _moment2.default)(), 'seconds', true) <= 20 && _this2._refreshTimes >= 3)) {
                                                            _context6.next = 3;
                                                            break;
                                                        }

                                                        window.location.reload(true);
                                                        return _context6.abrupt('return');

                                                    case 3:
                                                        _this2._refreshTimes++;
                                                        _this2._lastRefreshTime = new Date();

                                                        if (_this2._signalrConnectedTimeOut) {
                                                            clearTimeout(_this2._signalrConnectedTimeOut);
                                                        }

                                                        _this2._signalrConnectedTimeOut = setTimeout(function () {
                                                            return _this2._refreshData();
                                                        }, 500);

                                                    case 7:
                                                    case 'end':
                                                        return _context6.stop();
                                                }
                                            }
                                        }, _callee6, _this2);
                                    }));

                                    return function (_x6) {
                                        return _ref7.apply(this, arguments);
                                    };
                                }());

                                this._scope.$on(_CommonConstants2.default.Events.USER_JOINED_OTHER_CART, function () {
                                    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(scope) {
                                        return regeneratorRuntime.wrap(function _callee7$(_context7) {
                                            while (1) {
                                                switch (_context7.prev = _context7.next) {
                                                    case 0:
                                                        _context7.next = 2;
                                                        return _this2._refreshData();

                                                    case 2:
                                                    case 'end':
                                                        return _context7.stop();
                                                }
                                            }
                                        }, _callee7, _this2);
                                    }));

                                    return function (_x7) {
                                        return _ref8.apply(this, arguments);
                                    };
                                }());

                            case 8:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function $onInit() {
                return _ref5.apply(this, arguments);
            }

            return $onInit;
        }()
    }, {
        key: '_refreshData',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var cart;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!this._orderSetupService.invitationPromise) {
                                    _context9.next = 3;
                                    break;
                                }

                                _context9.next = 3;
                                return this._orderSetupService.invitationPromise;

                            case 3:
                                this._scope.refreshing = true;
                                _context9.next = 6;
                                return this._sessionService.getCartReference();

                            case 6:
                                cart = _context9.sent;

                                if (!(cart && cart.id != 0)) {
                                    _context9.next = 12;
                                    break;
                                }

                                _context9.next = 10;
                                return this._catalogChatService.updateByCartId(cart.id);

                            case 10:
                                _context9.next = 14;
                                break;

                            case 12:
                                _context9.next = 14;
                                return this._catalogChatService.update();

                            case 14:
                                _context9.next = 16;
                                return this._catalogChatService.stopWatchingForUnreadMessage();

                            case 16:
                                _context9.next = 18;
                                return this._onChatUpdated();

                            case 18:
                                setTimeout(function () {
                                    if (document.querySelector('.msg_container_base')) document.querySelector('.msg_container_base').scrollTop = document.querySelector('.msg_container_base').scrollHeight;
                                }, 100);

                            case 19:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function _refreshData() {
                return _ref9.apply(this, arguments);
            }

            return _refreshData;
        }()
    }, {
        key: '_showMore',
        value: function _showMore() {
            this._stateService.go(_CommonConstants2.default.RoutingStates.CHAT);
        }
    }, {
        key: '_copyClipboard',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                this._cartService.copyClipboard(this._scope.invitationLink);

                            case 1:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function _copyClipboard() {
                return _ref10.apply(this, arguments);
            }

            return _copyClipboard;
        }()
    }, {
        key: '_postMessage',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(event) {
                var _this3 = this;

                var newMessage, userData, user, newMessageObj, res;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:

                                if (event) {
                                    event.preventDefault();
                                }

                                // hide emoji before posting messages
                                if (this.emojiArea && this.emojiArea.emojiMenu) {
                                    this.emojiArea.emojiMenu.hide();
                                }

                                //CW-2552 & CW-2553: issues relates to microsoft edge . added .replace('<br>','')
                                if (this._scope.newMessage === '<br>') this._scope.newMessage = this._scope.newMessage.replace('<br>', '');

                                newMessage = _.trim(this._scope.newMessage);

                                if (!newMessage.length) {
                                    _context11.next = 25;
                                    break;
                                }

                                _context11.prev = 5;
                                _context11.next = 8;
                                return this._localForageService.retrieve(_CommonConstants2.default.SessionStorage.USER_DATA);

                            case 8:
                                userData = _context11.sent;
                                user = JSON.parse(userData);
                                newMessageObj = {
                                    message: newMessage,
                                    name: user.fullName,
                                    isSending: true,
                                    avatarCropped: user.avatarCropped,
                                    avatar: user.avatarSrc,
                                    createdOn: new Date()
                                };


                                this._scope.messages.splice(0, 0, newMessageObj);

                                _scope2.default.apply(this._scope, function () {
                                    _this3._scope.newMessage = '';

                                    _this3.emojiEditor && _this3.emojiEditor.empty && _this3.emojiEditor.empty();
                                });
                                _context11.next = 15;
                                return this._catalogChatService.postMessage(newMessage);

                            case 15:
                                res = _context11.sent;


                                if (res && res.data && res.data.id) {
                                    newMessageObj.isSending = false;
                                }
                                _context11.next = 21;
                                break;

                            case 19:
                                _context11.prev = 19;
                                _context11.t0 = _context11['catch'](5);

                            case 21:
                                _context11.prev = 21;

                                _scope2.default.apply(this._scope, function () {});
                                setTimeout(function () {
                                    document.querySelector('.msg_container_base').scrollTop = document.querySelector('.msg_container_base').scrollHeight;
                                }, 100);
                                return _context11.finish(21);

                            case 25:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this, [[5, 19, 21, 25]]);
            }));

            function _postMessage(_x8) {
                return _ref11.apply(this, arguments);
            }

            return _postMessage;
        }()
    }, {
        key: '_participantsFilter',
        value: function _participantsFilter() {
            var _this4 = this;

            if (this._scope.selectedParticipants.length > 0) {
                var results = this._scope.messages.filter(function (r) {
                    return _this4._scope.selectedParticipants.indexOf(r.email) > -1 || r.email === _this4._scope.currentLoggedInUserEmail;
                });
                return results;
            } else {
                return [];
            }
        }
    }, {
        key: '_selectAllParticipants',
        value: function _selectAllParticipants() {
            if (this._scope.checkedAllParticipants()) {
                this._scope.selectedParticipants = [];
            } else {
                this._scope.selectedParticipants = this._scope.participants.map(function (r) {
                    return r.email;
                });
            }
        }
    }, {
        key: '_checkedAllParticipants',
        value: function _checkedAllParticipants() {
            return this._scope.participants.length === this._scope.selectedParticipants.length;
        }
    }, {
        key: '_formatMessage',
        value: function _formatMessage(message) {
            if (!message) {
                return message;
            }

            var utcLabelIndex = message.indexOf(_CommonConstants2.default.CHAT_TIME_LABEL);
            if (utcLabelIndex !== -1) {
                var timeString = message.substr(message.indexOf('(', utcLabelIndex) + 1, message.indexOf(')', utcLabelIndex) - message.indexOf('(', utcLabelIndex) - 1);
                var timeStringFormated = (0, _moment2.default)(timeString).format('dddd, MMM Do, YYYY [at] hh:mm A');
                return message.replace(_CommonConstants2.default.CHAT_TIME_LABEL + '(' + timeString + ')', timeStringFormated);
            }

            return message;
        }
    }]);

    return ChatDirectiveController;
}();

ChatDirectiveController.$inject = ['$scope', 'CatalogChatService', '$state', 'Message', '$timeout', 'Session', 'LocalForageService', '$', 'ConfigurationService', 'CartService', '$rootScope', 'OrderSetupService'];
exports.default = ChatDirectiveController;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(84);

var _jquery2 = _interopRequireDefault(_jquery);

var _config = __webpack_require__(431);

var _config2 = _interopRequireDefault(_config);

var _jquery3 = __webpack_require__(830);

var _jquery4 = _interopRequireDefault(_jquery3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.jQuery = window.jQuery || _jquery2.default;
var $ = window.jQuery;

(0, _jquery4.default)($, window, document);

function EmojiPicker(options) {
    var ref, ref1;
    if (options == null) {
        options = {};
    }
    $.emojiarea.iconSize = (ref = options.iconSize) != null ? ref : 25;
    $.emojiarea.assetsPath = (ref1 = options.assetsPath) != null ? ref1 : '';
    this.generateEmojiIconSets(options);
    if (!options.emojiable_selector) {
        options.emojiable_selector = '[data-emojiable=true]';
    }
    this.options = options;
}

EmojiPicker.prototype.discover = function () {
    var isiOS;
    isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isiOS) {
        return;
    }
    return $(this.options.emojiable_selector).emojiarea($.extend({
        emojiPopup: this,
        norealTime: true
    }, this.options));
};

EmojiPicker.prototype.generateEmojiIconSets = function (options) {
    var column, dataItem, hex, i, icons, j, name, reverseIcons, row, totalColumns;
    icons = {};
    reverseIcons = {};
    i = void 0;
    j = void 0;
    hex = void 0;
    name = void 0;
    dataItem = void 0;
    row = void 0;
    column = void 0;
    totalColumns = void 0;
    j = 0;
    while (j < _config2.default.EmojiCategories.length) {
        totalColumns = _config2.default.EmojiCategorySpritesheetDimens[j][1];
        i = 0;
        while (i < _config2.default.EmojiCategories[j].length) {
            dataItem = _config2.default.Emoji[_config2.default.EmojiCategories[j][i]];
            name = dataItem[1][0];
            row = Math.floor(i / totalColumns);
            column = i % totalColumns;
            icons[':' + name + ':'] = [j, row, column, ':' + name + ':'];
            reverseIcons[name] = dataItem[0];
            i++;
        }
        j++;
    }
    $.emojiarea.icons = icons;
    return $.emojiarea.reverseIcons = reverseIcons;
};

EmojiPicker.prototype.colonToUnicode = function (input) {
    if (!input) {
        return '';
    }
    if (!_config2.default.rx_colons) {
        _config2.default.init_unified();
    }
    return input.replace(_config2.default.rx_colons, function (m) {
        var val;
        val = _config2.default.mapcolon[m];
        if (val) {
            return val;
        } else {
            return '';
        }
    });
};

EmojiPicker.prototype.appendUnicodeAsImageToElement = function (element, input) {
    var k, len, split_on_unicode, text, val;
    if (!input) {
        return '';
    }
    if (!_config2.default.rx_codes) {
        _config2.default.init_unified();
    }
    split_on_unicode = input.split(_config2.default.rx_codes);
    for (k = 0, len = split_on_unicode.length; k < len; k++) {
        text = split_on_unicode[k];
        val = '';
        if (_config2.default.rx_codes.test(text)) {
            val = _config2.default.reversemap[text];
            if (val) {
                val = ':' + val + ':';
                val = $.emojiarea.createIcon($.emojiarea.icons[val]);
            }
        } else {
            val = document.createTextNode(text);
        }
        element.append(val);
    }
    return input.replace(_config2.default.rx_codes, function (m) {
        var $img;
        val = _config2.default.reversemap[m];
        if (val) {
            val = ':' + val + ':';
            $img = $.emojiarea.createIcon($.emojiarea.icons[val]);
            return $img;
        } else {
            return '';
        }
    });
};

EmojiPicker.prototype.colonToImage = function (input) {
    if (!input) {
        return '';
    }
    if (!_config2.default.rx_colons) {
        _config2.default.init_unified();
    }
    return input.replace(_config2.default.rx_colons, function (m) {
        var $img;
        if (m) {
            $img = $.emojiarea.createIcon($.emojiarea.icons[m]);
            return $img;
        } else {
            return '';
        }
    });
};

exports.default = EmojiPicker;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = initialEmojiArea;

var _config = __webpack_require__(431);

var _config2 = _interopRequireDefault(_config);

var _util = __webpack_require__(831);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This file also contains some modifications by Igor Zhukov in order to add
 * custom scrollbars to EmojiMenu See keyword `MODIFICATION` in source code.
 */
function initialEmojiArea($, window, document) {
    function getGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }

    var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var TAGS_BLOCK = ['p', 'div', 'pre', 'form'];
    var KEY_ESC = 27;
    var KEY_TAB = 9;
    /* Keys that are not intercepted and canceled when the textbox has reached its max length:
     Backspace, Tab, Ctrl, Alt, Left Arrow, Up Arrow, Right Arrow, Down Arrow, Cmd Key, Delete
     */
    var MAX_LENGTH_ALLOWED_KEYS = [8, 9, 17, 18, 37, 38, 39, 40, 91, 46];

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    /*
     * ! MODIFICATION START Options 'spritesheetPath', 'spritesheetDimens',
     * 'iconSize' added by Andre Staltz.
     */
    $.emojiarea = {
        assetsPath: '',
        spriteSheetPath: '',
        blankGifPath: '',
        iconSize: 25,
        icons: {}
    };
    var defaultRecentEmojis = ':joy:,:kissing_heart:,:heart:,:heart_eyes:,:blush:,:grin:,:+1:,:relaxed:,:pensive:,:smile:,:sob:,:kiss:,:unamused:,:flushed:,:stuck_out_tongue_winking_eye:,:see_no_evil:,:wink:,:smiley:,:cry:,:stuck_out_tongue_closed_eyes:,:scream:,:rage:,:smirk:,:disappointed:,:sweat_smile:,:kissing_closed_eyes:,:speak_no_evil:,:relieved:,:grinning:,:yum:,:laughing:,:ok_hand:,:neutral_face:,:confused:'.split(',');
    /* ! MODIFICATION END */

    $.fn.emojiarea = function (options) {
        options = $.extend({}, options);
        return this.each(function () {
            var originalInput = $(this);
            var id = getGuid();
            if ('contentEditable' in document.body && options.wysiwyg !== false) {
                new EmojiArea_WYSIWYG(originalInput, id, $.extend({}, options));
            } else {
                new EmojiArea_Plain(originalInput, id, options);
            }
            originalInput.attr({
                'data-emojiable': 'converted',
                'data-id': id,
                'data-type': 'original-input'
            });
        });
    };

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    var util = {};

    util.restoreSelection = function () {
        if (window.getSelection) {
            return function (savedSelection) {
                var sel = window.getSelection();
                sel.removeAllRanges();
                for (var i = 0, len = savedSelection.length; i < len; ++i) {
                    sel.addRange(savedSelection[i]);
                }
            };
        } else if (document.selection && document.selection.createRange) {
            return function (savedSelection) {
                if (savedSelection) {
                    savedSelection.select();
                }
            };
        }
    }();

    util.saveSelection = function () {
        if (window.getSelection) {
            return function () {
                var sel = window.getSelection(),
                    ranges = [];
                if (sel.rangeCount) {
                    for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                        ranges.push(sel.getRangeAt(i));
                    }
                }
                return ranges;
            };
        } else if (document.selection && document.selection.createRange) {
            return function () {
                var sel = document.selection;
                return sel.type.toLowerCase() !== 'none' ? sel.createRange() : null;
            };
        }
    }();

    util.replaceSelection = function () {
        if (window.getSelection) {
            return function (content) {
                var range = void 0,
                    sel = window.getSelection();
                var node = typeof content === 'string' ? document.createTextNode(content) : content;
                if (sel.getRangeAt && sel.rangeCount) {
                    range = sel.getRangeAt(0);
                    range.deleteContents();
                    //range.insertNode(document.createTextNode(''));
                    range.insertNode(node);
                    range.setStart(node, 0);

                    window.setTimeout(function () {
                        range = document.createRange();
                        range.setStartAfter(node);
                        range.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }, 0);
                }
            };
        } else if (document.selection && document.selection.createRange) {
            return function (content) {
                var range = document.selection.createRange();
                if (typeof content === 'string') {
                    range.text = content;
                } else {
                    range.pasteHTML(content.outerHTML);
                }
            };
        }
    }();

    util.insertAtCursor = function (text, el) {
        text = ' ' + text;
        var val = el.value,
            endIndex = void 0,
            startIndex = void 0,
            range = void 0;
        if (typeof el.selectionStart != 'undefined' && typeof el.selectionEnd != 'undefined') {
            startIndex = el.selectionStart;
            endIndex = el.selectionEnd;
            el.value = val.substring(0, startIndex) + text + val.substring(el.selectionEnd);
            el.selectionStart = el.selectionEnd = startIndex + text.length;
        } else if (typeof document.selection != 'undefined' && typeof document.selection.createRange != 'undefined') {
            el.focus();
            range = document.selection.createRange();
            range.text = text;
            range.select();
        }
    };

    util.extend = function (a, b) {
        if (typeof a === 'undefined' || !a) {
            a = {};
        }
        if ((typeof b === 'undefined' ? 'undefined' : _typeof(b)) === 'object') {
            for (var key in b) {
                if (b.hasOwnProperty(key)) {
                    a[key] = b[key];
                }
            }
        }
        return a;
    };

    util.escapeRegex = function (str) {
        return (str + '').replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    };

    util.htmlEntities = function (str) {
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    };

    /*
     * ! MODIFICATION START This function was added by Igor Zhukov to save
     * recent used emojis.
     */
    util.emojiInserted = function (emojiKey, menu) {
        _util.ConfigStorage.get('emojis_recent', function (curEmojis) {
            curEmojis = curEmojis || defaultRecentEmojis || [];

            var pos = curEmojis.indexOf(emojiKey);
            if (!pos) {
                return false;
            }
            if (pos != -1) {
                curEmojis.splice(pos, 1);
            }
            curEmojis.unshift(emojiKey);
            if (curEmojis.length > 42) {
                curEmojis = curEmojis.slice(42);
            }

            _util.ConfigStorage.set({
                emojis_recent: curEmojis
            });
        });
    };
    /* ! MODIFICATION END */

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    var EmojiArea = function EmojiArea() {};

    EmojiArea.prototype.setup = function () {
        var self = this;

        this.$editor.on('focus', function () {
            self.hasFocus = true;
        });
        this.$editor.on('blur', function () {
            self.hasFocus = false;
        });

        // Assign a unique instance of an emojiMenu to
        self.emojiMenu = new EmojiMenu(self);

        this.setupButton();
    };

    EmojiArea.prototype.setupButton = function () {
        var self = this;
        var $button = $('[data-id=' + this.id + '][data-type=picker]');

        $button.on('click', function (e) {
            self.emojiMenu.show(self);
        });

        this.$button = $button;
        this.$dontHideOnClick = 'emoji-picker';
    };

    /*
     * ! MODIFICATION START This function was modified by Andre Staltz so that
     * the icon is created from a spritesheet.
     */
    EmojiArea.createIcon = function (emoji, menu) {
        var category = emoji[0];
        var row = emoji[1];
        var column = emoji[2];
        var name = emoji[3];
        var filename = $.emojiarea.spriteSheetPath ? $.emojiarea.spriteSheetPath : $.emojiarea.assetsPath + '/emoji_spritesheet_!.png';
        var blankGifPath = $.emojiarea.blankGifPath ? $.emojiarea.blankGifPath : $.emojiarea.assetsPath + '/blank.gif';
        var iconSize = menu && _config2.default.Mobile ? 26 : $.emojiarea.iconSize;
        var xoffset = -(iconSize * column);
        var yoffset = -(iconSize * row);
        var scaledWidth = _config2.default.EmojiCategorySpritesheetDimens[category][1] * iconSize;
        var scaledHeight = _config2.default.EmojiCategorySpritesheetDimens[category][0] * iconSize;

        var style = 'display:inline-block;';
        style += 'width:' + iconSize + 'px;';
        style += 'height:' + iconSize + 'px;';
        style += 'background:url(\'' + filename.replace('!', category) + '\') ' + xoffset + 'px ' + yoffset + 'px no-repeat;';
        style += 'background-size:' + scaledWidth + 'px ' + scaledHeight + 'px;';
        return '<img src="' + blankGifPath + '" class="img" style="' + style + '" alt="' + util.htmlEntities(name) + '">';
    };

    $.emojiarea.createIcon = EmojiArea.createIcon;
    /* ! MODIFICATION END */

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    /**
     * Editor (plain-text)
     *
     * @constructor
     * @param {object}
     *            $textarea
     * @param {object}
     *            options
     */

    var EmojiArea_Plain = function EmojiArea_Plain($textarea, id, options) {
        this.options = options;
        this.$textarea = $textarea;
        this.$editor = $textarea;
        this.id = id;
        this.setup();
    };

    EmojiArea_Plain.prototype.insert = function (emoji) {
        if (!$.emojiarea.icons.hasOwnProperty(emoji)) return;
        util.insertAtCursor(emoji, this.$textarea[0]);
        /*
         * MODIFICATION: Following line was added by Igor Zhukov, in order to
         * save recent emojis
         */
        util.emojiInserted(emoji, this.menu);
        this.$textarea.trigger('change');
    };

    EmojiArea_Plain.prototype.val = function () {
        if (this.$textarea == '\n') return '';
        return this.$textarea.val();
    };

    util.extend(EmojiArea_Plain.prototype, EmojiArea.prototype);

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    /**
     * Editor (rich)
     *
     * @constructor
     * @param {object}
     *            $textarea
     * @param {object}
     *            options
     */

    var EmojiArea_WYSIWYG = function EmojiArea_WYSIWYG($textarea, id, options) {
        var self = this;

        this.options = options || {};
        if ($($textarea).attr('data-emoji-input') === 'unicode') this.options.inputMethod = 'unicode';else this.options.inputMethod = this.options.inputMethod || 'image';
        this.id = id;
        this.$textarea = $textarea;
        this.emojiPopup = options.emojiPopup;
        this.$editor = $('<div>').addClass('emoji-wysiwyg-editor').addClass($($textarea)[0].className);
        this.$editor.data('self', this);

        if ($textarea.attr('maxlength')) {
            this.$editor.attr('maxlength', $textarea.attr('maxlength'));
        }
        this.$editor.height($textarea.outerHeight()); //auto adjust height
        this.emojiPopup.appendUnicodeAsImageToElement(this.$editor, $textarea.val());

        this.$editor.attr({
            'data-id': id,
            'data-type': 'input',
            'placeholder': $textarea.attr('placeholder'),
            'contenteditable': 'true'
        });

        /*
         * ! MODIFICATION START Following code was modified by Igor Zhukov, in
         * order to improve rich text paste
         */
        var changeEvents = 'blur change';
        if (!this.options.norealTime) {
            changeEvents += ' keyup';
        }
        this.$editor.on(changeEvents, function (e) {
            return self.onChange.apply(self, [e]);
        });
        /* ! MODIFICATION END */

        this.$editor.on('mousedown focus', function () {
            document.execCommand('enableObjectResizing', false, false);
        });
        this.$editor.on('blur', function () {
            document.execCommand('enableObjectResizing', true, true);
        });

        var editorDiv = this.$editor;
        this.$editor.on("change keydown keyup resize scroll", function (e) {
            if (MAX_LENGTH_ALLOWED_KEYS.indexOf(e.which) == -1 && !((e.ctrlKey || e.metaKey) && e.which == 65) && // Ctrl + A
            !((e.ctrlKey || e.metaKey) && e.which == 67) && // Ctrl + C
            editorDiv.text().length + editorDiv.find('img').length >= editorDiv.attr('maxlength')) {
                e.preventDefault();
            }
            self.updateBodyPadding(editorDiv);

            if (options.onKeyUp) {
                options.onKeyUp(e, editorDiv, self.emojiMenu);
            }
        });

        this.$editor.on("paste", function (e) {
            e.preventDefault();
            var content = void 0;
            var charsRemaining = editorDiv.attr('maxlength') - (editorDiv.text().length + editorDiv.find('img').length);
            if ((e.originalEvent || e).clipboardData) {
                content = (e.originalEvent || e).clipboardData.getData('text/plain');
                if (self.options.onPaste) {
                    content = self.options.onPaste(content);
                }
                if (charsRemaining < content.length) {
                    content = content.substring(0, charsRemaining);
                }
                document.execCommand('insertText', false, content);
            } else if (window.clipboardData) {
                content = window.clipboardData.getData('Text');
                if (self.options.onPaste) {
                    content = self.options.onPaste(content);
                }
                if (charsRemaining < content.length) {
                    content = content.substring(0, charsRemaining);
                }
                document.selection.createRange().pasteHTML(content);
            }
            editorDiv.scrollTop(editorDiv[0].scrollHeight);
        });

        $textarea.after("<i class='emoji-picker-icon emoji-picker " + this.options.popupButtonClasses + "' data-id='" + id + "' data-type='picker'></i>");

        $textarea.hide().after(this.$editor);
        this.setup();
        if (options.onLoaded) {
            options.onLoaded(editorDiv, self);
        }

        /*
         * MODIFICATION: Following line was modified by Igor Zhukov, in order to
         * improve emoji insert behaviour
         */
        $(document.body).on('mousedown', function () {
            if (self.hasFocus) {
                self.selection = util.saveSelection();
            }
        });
    };

    EmojiArea_WYSIWYG.prototype.updateBodyPadding = function (target) {
        var emojiPicker = $('[data-id=' + this.id + '][data-type=picker]');
        if ($(target).hasScrollbar()) {
            if (!emojiPicker.hasClass('parent-has-scroll')) emojiPicker.addClass('parent-has-scroll');
            if (!$(target).hasClass('parent-has-scroll')) $(target).addClass('parent-has-scroll');
        } else {
            if (emojiPicker.hasClass('parent-has-scroll')) emojiPicker.removeClass('parent-has-scroll');
            if ($(target).hasClass('parent-has-scroll')) $(target).removeClass('parent-has-scroll');
        }
    };

    EmojiArea_WYSIWYG.prototype.onChange = function (e) {
        var event = new CustomEvent('input', { bubbles: true });
        this.$textarea.val(this.val())[0].dispatchEvent(event);
    };

    EmojiArea_WYSIWYG.prototype.insert = function (emoji) {
        var content = void 0;
        /*
         * MODIFICATION: Following line was modified by Andre Staltz, to use new
         * implementation of createIcon function.
         */
        var insertionContent = '';
        if (this.options.inputMethod == 'unicode') {
            insertionContent = this.emojiPopup.colonToUnicode(emoji);
        } else {
            var $img = $(EmojiArea.createIcon($.emojiarea.icons[emoji]));
            if ($img[0].attachEvent) {
                $img[0].attachEvent('onresizestart', function (e) {
                    e.returnValue = false;
                }, false);
            }
            insertionContent = $img[0];
        }

        this.$editor.trigger('focus');
        if (this.selection) {
            util.restoreSelection(this.selection);
        }
        try {
            util.replaceSelection(insertionContent);
        } catch (e) {}

        /*
         * MODIFICATION: Following line was added by Igor Zhukov, in order to
         * save recent emojis
         */
        util.emojiInserted(emoji, this.menu);

        this.onChange();
    };

    EmojiArea_WYSIWYG.prototype.val = function () {
        var lines = [];
        var line = [];
        var emojiPopup = this.emojiPopup;

        var flush = function flush() {
            lines.push(line.join(''));
            line = [];
        };

        var sanitizeNode = function sanitizeNode(node) {
            if (node.nodeType === TEXT_NODE) {
                line.push(node.nodeValue);
            } else if (node.nodeType === ELEMENT_NODE) {
                var tagName = node.tagName.toLowerCase();
                var isBlock = TAGS_BLOCK.indexOf(tagName) !== -1;

                if (isBlock && line.length) flush();

                if (tagName === 'img') {
                    var alt = node.getAttribute('alt') || '';
                    if (alt) {
                        line.push(alt);
                    }
                    return;
                } else if (tagName === 'br') {
                    flush();
                }

                var _children = node.childNodes;
                for (var i = 0; i < _children.length; i++) {
                    sanitizeNode(_children[i]);
                }

                if (isBlock && line.length) flush();
            }
        };

        var children = this.$editor[0].childNodes;
        for (var i = 0; i < children.length; i++) {
            sanitizeNode(children[i]);
        }

        if (line.length) flush();

        var returnValue = lines.join('\n');
        return emojiPopup.colonToUnicode(returnValue);
    };

    util.extend(EmojiArea_WYSIWYG.prototype, EmojiArea.prototype);

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    jQuery.fn.hasScrollbar = function () {
        var scrollHeight = this.get(0).scrollHeight;

        //safari's scrollHeight includes padding
        //if ($.browser.safari)
        //      scrollHeight -= parseInt(this.css('padding-top')) + parseInt(this.css('padding-bottom'));
        if (this.outerHeight() < scrollHeight) return true;else return false;
    };

    /**
     * Emoji Dropdown Menu
     *
     * @constructor
     * @param {object}
     *            emojiarea
     */
    var EmojiMenu = function EmojiMenu(emojiarea) {
        var self = this;
        self.id = emojiarea.id;
        var $body = $(document.body);
        var $window = $(window);

        this.visible = false;
        this.emojiarea = emojiarea;
        EmojiMenu.menuZIndex = 5000;
        this.$menu = $('<div>');
        this.$menu.addClass('emoji-menu');
        this.$menu.attr('data-id', self.id);
        this.$menu.attr('data-type', 'menu');
        this.$menu.hide();

        this.$itemsTailWrap = $('<div class="emoji-items-wrap1"></div>').appendTo(this.$menu);
        this.$categoryTabs = $('<table class="emoji-menu-tabs"><tr>' + '<td><a class="emoji-menu-tab icon-recent" ></a></td>' + '<td><a class="emoji-menu-tab icon-smile" ></a></td>' + '<td><a class="emoji-menu-tab icon-flower"></a></td>' + '<td><a class="emoji-menu-tab icon-bell"></a></td>' + '<td><a class="emoji-menu-tab icon-car"></a></td>' + '<td><a class="emoji-menu-tab icon-grid"></a></td>' + '</tr></table>').appendTo(this.$itemsTailWrap);
        this.$itemsWrap = $('<div class="emoji-items-wrap mobile_scrollable_wrap"></div>').appendTo(this.$itemsTailWrap);
        this.$items = $('<div class="emoji-items">').appendTo(this.$itemsWrap);

        this.emojiarea.$editor.after(this.$menu);

        $body.on('keydown', function (e) {
            if (e.keyCode === KEY_ESC || e.keyCode === KEY_TAB) {
                self.hide();
            }
        });

        /*
         * ! MODIFICATION: Following 3 lines were added by Igor Zhukov, in order
         * to hide menu on message submit with keyboard
         */
        $body.on('message_send', function (e) {
            self.hide();
        });

        $body.on('mouseup', function (e) {
            e = e.originalEvent || e;
            var target = e.target || window;

            if ($(target).hasClass(self.emojiarea.$dontHideOnClick)) {
                return;
            }

            while (target && target != window) {
                target = target.parentNode;
                if (target == self.$menu[0] || self.emojiarea && target == self.emojiarea.$button[0]) {
                    return;
                }
            }
            self.hide();
        });

        this.$menu.on('mouseup', 'a', function (e) {
            e.stopPropagation();
            return false;
        });

        this.$menu.on('click', 'a', function (e) {

            self.emojiarea.updateBodyPadding(self.emojiarea.$editor);
            if ($(this).hasClass('emoji-menu-tab')) {
                if (self.getTabIndex(this) !== self.currentCategory) {
                    self.selectCategory(self.getTabIndex(this));
                }
                return false;
            }

            var emoji = $('.label', $(this)).text();
            window.setTimeout(function () {
                self.onItemSelected(emoji);
                if (e.ctrlKey || e.metaKey) {
                    self.hide();
                }
            }, 0);
            e.stopPropagation();
            return false;
        });

        this.selectCategory(0);
    };

    /*
     * ! MODIFICATION START Following code was added by Andre Staltz, to
     * implement category selection.
     */
    EmojiMenu.prototype.getTabIndex = function (tab) {
        return this.$categoryTabs.find('.emoji-menu-tab').index(tab);
    };

    EmojiMenu.prototype.selectCategory = function (category) {
        var self = this;
        this.$categoryTabs.find('.emoji-menu-tab').each(function (index) {
            if (index === category) {
                this.className += '-selected';
            } else {
                this.className = this.className.replace('-selected', '');
            }
        });
        this.currentCategory = category;
        this.load(category);
    };
    /* ! MODIFICATION END */

    EmojiMenu.prototype.onItemSelected = function (emoji) {
        if (this.emojiarea.$editor.text().length + this.emojiarea.$editor.find('img').length >= this.emojiarea.$editor.attr('maxlength')) {
            return;
        }
        this.emojiarea.insert(emoji);
    };

    /*
     * MODIFICATION: The following function argument was modified by Andre
     * Staltz, in order to load only icons from a category. Also function was
     * modified by Igor Zhukov in order to display recent emojis from
     * localStorage
     */
    EmojiMenu.prototype.load = function (category) {
        var html = [];
        var options = $.emojiarea.icons;
        var path = $.emojiarea.assetsPath;
        var self = this;
        if (path.length && path.charAt(path.length - 1) !== '/') {
            path += '/';
        }

        /*
         * ! MODIFICATION: Following function was added by Igor Zhukov, in order
         * to add scrollbars to EmojiMenu
         */
        var updateItems = function updateItems() {
            self.$items.html(html.join(''));
        };

        if (category > 0) {
            for (var key in options) {
                /*
                 * MODIFICATION: The following 2 lines were modified by Andre
                 * Staltz, in order to load only icons from the specified
                 * category.
                 */
                if (options.hasOwnProperty(key) && options[key][0] === category - 1) {
                    html.push('<a href="javascript:void(0)" title="' + util.htmlEntities(key) + '">' + EmojiArea.createIcon(options[key], true) + '<span class="label">' + util.htmlEntities(key) + '</span></a>');
                }
            }
            updateItems();
        } else {
            _util.ConfigStorage.get('emojis_recent', function (curEmojis) {
                curEmojis = curEmojis || defaultRecentEmojis || [];
                var key = void 0,
                    i = void 0;
                for (i = 0; i < curEmojis.length; i++) {
                    key = curEmojis[i];
                    if (options[key]) {
                        html.push('<a href="javascript:void(0)" title="' + util.htmlEntities(key) + '">' + EmojiArea.createIcon(options[key], true) + '<span class="label">' + util.htmlEntities(key) + '</span></a>');
                    }
                }
                updateItems();
            });
        }
    };

    EmojiMenu.prototype.hide = function (callback) {
        this.visible = false;
        this.$menu.hide("fast");
    };

    EmojiMenu.prototype.show = function (emojiarea) {
        /*
         * MODIFICATION: Following line was modified by Igor Zhukov, in order to
         * improve EmojiMenu behaviour
         */
        if (this.visible) return this.hide();
        $(this.$menu).css('z-index', ++EmojiMenu.menuZIndex);
        this.$menu.show("fast");
        /*
         * MODIFICATION: Following 3 lines were added by Igor Zhukov, in order
         * to update EmojiMenu contents
         */
        if (!this.currentCategory) {
            this.load(0);
        }
        this.visible = true;
    };
};

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var keyPrefix = '';
var noPrefix = false;
var cache = {};
var useCs = !!(window.chrome && chrome.storage && chrome.storage.local);
var useLs = !useCs && !!window.localStorage;

function storageSetPrefix(newPrefix) {
    keyPrefix = newPrefix;
}

function storageSetNoPrefix() {
    noPrefix = true;
}

function storageGetPrefix() {
    if (noPrefix) {
        noPrefix = false;
        return '';
    }
    return keyPrefix;
}

function storageGetValue() {
    var keys = Array.prototype.slice.call(arguments),
        callback = keys.pop(),
        result = [],
        single = keys.length === 1,
        value = void 0,
        allFound = true,
        prefix = storageGetPrefix(),
        i = void 0,
        key = void 0;

    for (i = 0; i < keys.length; i++) {
        key = keys[i] = prefix + keys[i];
        if (key.substr(0, 3) !== 'xt_' && cache[key] !== undefined) {
            result.push(cache[key]);
        } else if (useLs) {
            try {
                value = localStorage.getItem(key);
            } catch (e) {
                useLs = false;
            }
            try {
                value = value === undefined || value === null ? false : JSON.parse(value);
            } catch (e) {
                value = false;
            }
            result.push(cache[key] = value);
        } else if (!useCs) {
            result.push(cache[key] = false);
        } else {
            allFound = false;
        }
    }

    if (allFound) {
        return callback(single ? result[0] : result);
    }

    chrome.storage.local.get(keys, function (resultObj) {
        var value = void 0;
        result = [];
        for (i = 0; i < keys.length; i++) {
            key = keys[i];
            value = resultObj[key];
            value = value === undefined || value === null ? false : JSON.parse(value);
            result.push(cache[key] = value);
        }

        callback(single ? result[0] : result);
    });
};

function storageSetValue(obj, callback) {
    var keyValues = {},
        prefix = storageGetPrefix(),
        key = void 0,
        value = void 0;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            value = obj[key];
            key = prefix + key;
            cache[key] = value;
            value = JSON.stringify(value);
            if (useLs) {
                try {
                    localStorage.setItem(key, value);
                } catch (e) {
                    useLs = false;
                }
            } else {
                keyValues[key] = value;
            }
        }
    }

    if (useLs || !useCs) {
        if (callback) {
            callback();
        }
        return;
    }

    chrome.storage.local.set(keyValues, callback);
};

function storageRemoveValue() {
    var keys = Array.prototype.slice.call(arguments),
        prefix = storageGetPrefix(),
        i = void 0,
        key = void 0,
        callback = void 0;

    if (typeof keys[keys.length - 1] === 'function') {
        callback = keys.pop();
    }

    for (i = 0; i < keys.length; i++) {
        key = keys[i] = prefix + keys[i];
        delete cache[key];
        if (useLs) {
            try {
                localStorage.removeItem(key);
            } catch (e) {
                useLs = false;
            }
        }
    }
    if (useCs) {
        chrome.storage.local.remove(keys, callback);
    } else if (callback) {
        callback();
    }
};

var ConfigStorage = exports.ConfigStorage = {
    prefix: storageSetPrefix,
    noPrefix: storageSetNoPrefix,
    get: storageGetValue,
    set: storageSetValue,
    remove: storageRemoveValue
};

// // Pollyfill for IE 9 support of CustomEvent
// (function () {
//
//     if (typeof window.CustomEvent === "function") return false;
//
//     function CustomEvent(event, params) {
//         params = params || {bubbles: false, cancelable: false, detail: undefined};
//         let evt = document.createEvent('CustomEvent');
//         evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
//         return evt;
//     }
//
//     CustomEvent.prototype = window.Event.prototype;
//
//     window.CustomEvent = CustomEvent;
// })();

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _scope = __webpack_require__(11);

var _scope2 = _interopRequireDefault(_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChatCounterDirectiveController = function ChatCounterDirectiveController(scope, ChatService) {
    var _this = this;

    _classCallCheck(this, ChatCounterDirectiveController);

    this._scope = scope;
    this._chatService = ChatService;

    this._chatService.getUnreadMessages().then(function (resp) {
        return scope.count = resp;
    });

    this._scope.$on(_CommonConstants2.default.Events.CHAT_MESSAGE_RECEIVED, function (scope, unreadMessages) {
        _this._scope.count = unreadMessages;
        _scope2.default.apply(_this._scope);
    });
};

ChatCounterDirectiveController.$inject = ['$scope', 'CatalogChatService'];
exports.default = ChatCounterDirectiveController;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CatalogService = function () {
    function CatalogService(httpService, configurationService, cartonomyConfig) {
        _classCallCheck(this, CatalogService);

        this._httpService = httpService;
        this._configurationService = configurationService;
        this._urlBase = cartonomyConfig.ApiV2 + 'catalog/';
        this._cachedSuperCategoryProducts = {};
    }

    _createClass(CatalogService, [{
        key: 'getAllCategories',
        value: function getAllCategories() {

            if (this._allCategories) {
                return this._allCategories;
            }

            this._allCategories = this._httpService.get(this._urlBase + 'categories').then(function (res) {
                return res.data;
            });

            return this._allCategories;
        }
    }, {
        key: 'getCategory',
        value: function getCategory(categoryId) {
            return this._httpService.get(this._urlBase + 'categories/' + categoryId).then(function (res) {
                return res.data;
            });
        }
    }, {
        key: 'getDefaultCategory',
        value: function getDefaultCategory() {
            return this._configurationService.getItem('defaultCategory');
        }
    }, {
        key: 'getProductsInCategory',
        value: function getProductsInCategory(categoryId) {
            return this._httpService.get(this._urlBase + 'categories/' + categoryId + '/products').then(function (res) {
                return res.data;
            });
        }
    }, {
        key: 'getProductsBySuperCategory',
        value: function getProductsBySuperCategory(categoryId, offset, limit) {
            var _this = this;

            limit = typeof limit === "undefined" ? _CommonConstants2.default.Pagination.PAGE_LIMIT : limit;
            offset = typeof offset === "undefined" ? 0 : offset;

            var key = categoryId + ":" + offset + ":" + limit;

            if (this._cachedSuperCategoryProducts[key]) {
                return new Promise(function (resolve) {
                    resolve(_this._cachedSuperCategoryProducts[key]);
                });
            }

            return this._httpService.get(this._urlBase + 'supercategory/' + categoryId + '/products/' + offset + '/' + limit).then(function (res) {
                _this._cachedSuperCategoryProducts[key] = res.data;
                return res.data;
            });
        }
    }, {
        key: 'getProduct',
        value: function getProduct(productId) {
            return this._httpService.get(this._urlBase + 'product/' + productId).then(function (res) {
                return res.data;
            });
        }
    }, {
        key: 'searchProducts',
        value: function searchProducts(searchString, page) {

            var catalogSearchParams = {
                SearchString: searchString,
                MaxProductsPerPage: _CommonConstants2.default.Pagination.PAGE_LIMIT,
                CurrentPage: page
            };

            return this._httpService.post(this._urlBase + 'search', catalogSearchParams).then(function (res) {
                return res.data;
            });
        }
    }]);

    return CatalogService;
}();

CatalogService.$inject = ['$http', 'ConfigurationService', 'cartonomyConfig'];
exports.default = CatalogService;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CatalogChatService = function () {
    function CatalogChatService(httpService, cartonomyConfig, messageService, sessionService, localForageService, rootScope, RealTimeUpdateService) {
        var _this2 = this;

        _classCallCheck(this, CatalogChatService);

        this._httpService = httpService;
        this._sessionService = sessionService;
        //this._sessionStorageService = sessionStorageService;
        this._localForageService = localForageService;
        this._urlBase = cartonomyConfig.ApiV2 + 'cartpost';
        this._postList = [];
        this._rootScope = rootScope;
        this._messageService = messageService;
        this._cartonomyConfig = cartonomyConfig;
        this._chatFailRetries = 0;

        this._refreshing = false;

        this.chatActive = false;

        this.realtimeUpdateService = RealTimeUpdateService;

        this.refreshing = function () {
            return _this2._refreshing;
        };

        this._unreadMessages = this.getUnreadMessages();

        rootScope.$on(_CommonConstants2.default.Events.WINDOW_STATE_CHANGED, function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(scope, state) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(state === _CommonConstants2.default.WindowMode.minimized)) {
                                    _context.next = 3;
                                    break;
                                }

                                _context.next = 3;
                                return _this2.startWatchingOnUnreadMessage();

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }());

        rootScope.$on(_CommonConstants2.default.Events.REALTIME_CHAT_RECEIVED, function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(scope, messageObj) {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                return _context2.abrupt('return', _this2._onChatMessageReceived(messageObj));

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }));

            return function (_x3, _x4) {
                return _ref2.apply(this, arguments);
            };
        }());
    }

    _createClass(CatalogChatService, [{
        key: 'postMessage',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(message) {
                var cart, cartId, res;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context3.sent) {
                                    _context3.next = 4;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 4:
                                if (this.realtimeUpdateService.instance) {
                                    _context3.next = 7;
                                    break;
                                }

                                _context3.next = 7;
                                return this.realtimeUpdateService.ensureConnected();

                            case 7:
                                _context3.prev = 7;
                                _context3.next = 10;
                                return this._sessionService.getCartReference();

                            case 10:
                                cart = _context3.sent;
                                cartId = void 0;

                                if (cart) {
                                    cartId = cart.id;
                                }
                                _context3.next = 15;
                                return this._httpService.post(this._urlBase, { message: message, cartId: cartId });

                            case 15:
                                res = _context3.sent;

                                this._chatFailRetries = 0;
                                return _context3.abrupt('return', res);

                            case 20:
                                _context3.prev = 20;
                                _context3.t0 = _context3['catch'](7);

                                this._chatFailRetries++;

                                if (!(this._chatFailRetries === 5)) {
                                    _context3.next = 27;
                                    break;
                                }

                                //await this._messageService.showErrorPopup('Oops!  Your chat session is having trouble communicating
                                // with the server. Please press OK so that the application can re-load.');
                                this._chatFailRetries = 0;
                                location.reload(true);
                                return _context3.abrupt('return');

                            case 27:
                                this.realtimeUpdateService.resetConnection();
                                _context3.next = 30;
                                return this.postMessage(message);

                            case 30:
                                return _context3.abrupt('return', _context3.sent);

                            case 31:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[7, 20]]);
            }));

            function postMessage(_x5) {
                return _ref3.apply(this, arguments);
            }

            return postMessage;
        }()
    }, {
        key: 'reset',
        value: function reset() {
            this._postList = [];
        }
    }, {
        key: 'stopWatchingForUnreadMessage',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.UnreadChatMessages);

                            case 2:
                                this._unreadMessages = undefined;
                                this.chatActive = true;

                                _context4.next = 6;
                                return this._localForageService.remove(_CommonConstants2.default.SessionStorage.UnreadChatMessages);

                            case 6:
                                this._rootScope.$broadcast(_CommonConstants2.default.Events.CHAT_MESSAGE_RECEIVED, this._unreadMessages);

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function stopWatchingForUnreadMessage() {
                return _ref4.apply(this, arguments);
            }

            return stopWatchingForUnreadMessage;
        }()
    }, {
        key: 'startWatchingOnUnreadMessage',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this._localForageService.retrieve(_CommonConstants2.default.SessionStorage.UnreadChatMessages);

                            case 2:
                                _context5.t0 = _context5.sent;

                                if (_context5.t0) {
                                    _context5.next = 5;
                                    break;
                                }

                                _context5.t0 = 0;

                            case 5:
                                this._unreadMessages = _context5.t0;

                                this.chatActive = false;

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function startWatchingOnUnreadMessage() {
                return _ref5.apply(this, arguments);
            }

            return startWatchingOnUnreadMessage;
        }()
    }, {
        key: 'update',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context6.sent) {
                                    _context6.next = 5;
                                    break;
                                }

                                this.reset();
                                return _context6.abrupt('return');

                            case 5:
                                _context6.next = 7;
                                return this._httpService.get(this._urlBase);

                            case 7:
                                response = _context6.sent;


                                this.reset();
                                this._onResponseReceived(response.data);
                                return _context6.abrupt('return', this._postList);

                            case 11:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function update() {
                return _ref6.apply(this, arguments);
            }

            return update;
        }()
    }, {
        key: 'updateByCartId',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(cartId) {
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this._sessionService.loggedIn();

                            case 2:
                                if (_context7.sent) {
                                    _context7.next = 5;
                                    break;
                                }

                                this.reset();
                                return _context7.abrupt('return');

                            case 5:
                                _context7.next = 7;
                                return this._httpService.get(this._urlBase + '/' + cartId);

                            case 7:
                                response = _context7.sent;


                                this.reset();
                                this._onResponseReceived(response.data);
                                return _context7.abrupt('return', this._postList);

                            case 11:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function updateByCartId(_x6) {
                return _ref7.apply(this, arguments);
            }

            return updateByCartId;
        }()
    }, {
        key: '_handleCartPostDetails',
        value: function _handleCartPostDetails(post) {
            post.id = post.id || post.Id;
            post.createdOn = _moment2.default.utc(post.createdOn).toDate();
            this._postList.push(post);
        }
    }, {
        key: '_onResponseReceived',
        value: function _onResponseReceived(data) {
            var _this3 = this;

            if (!data || !data.length) {
                return;
            }

            _.each(data, function (post) {
                return _this3._handleCartPostDetails(post);
            });
        }
    }, {
        key: 'getMessages',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var _this4 = this;

                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                return _context8.abrupt('return', new Promise(function (resolve, reject) {
                                    var _this = _this4;
                                    function checkAndReturnMessageList() {
                                        if (_this.lockMsgList) {
                                            setTimeout(function () {
                                                return checkAndReturnMessageList();
                                            }, 1);
                                            return;
                                        }
                                        resolve(_this._postList);
                                    }

                                    checkAndReturnMessageList();
                                }));

                            case 1:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function getMessages() {
                return _ref8.apply(this, arguments);
            }

            return getMessages;
        }()
    }, {
        key: 'notifyUnreadMessageIfNeeded',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var playSound = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (this.chatActive) {
                                    _context9.next = 7;
                                    break;
                                }

                                if (playSound) {
                                    new Audio(_CommonConstants2.default.Notifications.chatNotification).play();
                                }
                                if (this._unreadMessages === undefined) this._unreadMessages = 0;

                                this._unreadMessages++;
                                _context9.next = 6;
                                return this._localForageService.store(_CommonConstants2.default.SessionStorage.UnreadChatMessages, this._unreadMessages);

                            case 6:
                                this._rootScope.$broadcast(_CommonConstants2.default.Events.CHAT_MESSAGE_RECEIVED, this._unreadMessages);

                            case 7:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function notifyUnreadMessageIfNeeded() {
                return _ref9.apply(this, arguments);
            }

            return notifyUnreadMessageIfNeeded;
        }()
    }, {
        key: 'getUnreadMessages',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this._localForageService.retrieve(_CommonConstants2.default.SessionStorage.UnreadChatMessages);

                            case 2:
                                _context10.t0 = _context10.sent;

                                if (_context10.t0) {
                                    _context10.next = 5;
                                    break;
                                }

                                _context10.t0 = undefined;

                            case 5:
                                return _context10.abrupt('return', _context10.t0);

                            case 6:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function getUnreadMessages() {
                return _ref10.apply(this, arguments);
            }

            return getUnreadMessages;
        }()
    }, {
        key: '_onChatMessageReceived',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(messageObj) {
                var cart, existingChatMsg, currentLoggedInUser, playSound, _currentLoggedInUser, _playSound;

                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                this.lockMsgList = true;
                                _context11.next = 3;
                                return this._sessionService.getCartReference();

                            case 3:
                                cart = _context11.sent;

                                if (!cart && this._postList.length > 0) cart = { id: this._postList[0].cartId };

                                if (!(cart && cart.id === messageObj.cartId)) {
                                    _context11.next = 15;
                                    break;
                                }

                                existingChatMsg = _.find(this._postList, function (post) {
                                    return post.id === messageObj.id || post.id === messageObj.Id;
                                });

                                if (existingChatMsg) {
                                    this._postList = _.without(this._postList, existingChatMsg);
                                }

                                currentLoggedInUser = this._sessionService.getUserEmail();

                                this._handleCartPostDetails(messageObj);

                                playSound = false;

                                if (messageObj.Email !== currentLoggedInUser && !messageObj.IsOwner) {
                                    playSound = true;
                                }
                                this.notifyUnreadMessageIfNeeded(playSound);
                                _context11.next = 22;
                                break;

                            case 15:
                                _context11.next = 17;
                                return this._sessionService.getUserEmail();

                            case 17:
                                _currentLoggedInUser = _context11.sent;
                                _playSound = false;

                                if (messageObj.Email !== _currentLoggedInUser && !messageObj.IsOwner) {
                                    _playSound = true;
                                }
                                _context11.next = 22;
                                return this.notifyUnreadMessageIfNeeded(_playSound);

                            case 22:
                                this.lockMsgList = false;

                            case 23:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function _onChatMessageReceived(_x8) {
                return _ref11.apply(this, arguments);
            }

            return _onChatMessageReceived;
        }()
    }]);

    return CatalogChatService;
}();

CatalogChatService.$inject = ['$http', 'cartonomyConfig', 'Message', 'Session', 'LocalForageService', '$rootScope', 'RealTimeUpdateService'];
exports.default = CatalogChatService;

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "<div class=\"chat-contents\"><invite-link></invite-link><div class=\"chat-area\"><div class=\"messages-container msg_container_base\"><div class=\"message-container\" ng-repeat=\"message in participantsFilter() | orderBy: 'createdOn'\" ng-class=\"{'message-right': message.isMy, 'message-left': !message.isMy}\"><div class=\"avatar\"><img class=\"participant-avatar\" ng-if=\"message.avatarCropped &amp;&amp; !isSvg(message.avatarCropped)\" ng-src=\"{{ message.avatarCropped }}\"/><div class=\"icon participant-avatar\" ng-if=\"!message.avatarCropped\">{{message.iconLetter}}</div><div ng-if=\"isSvg(message.avatarCropped)\"><svg width=\"46\" height=\"40\" xmlns=\"http://www.w3.org/2000/svg\">\n\n <g>\n  <title>background</title>\n  <rect fill=\"none\" id=\"canvas_background\" height=\"402\" width=\"582\" y=\"-1\" x=\"-1\"/>\n </g>\n <g>\n  <title>Layer 1</title>\n  <path class=\"fill-path\" id=\"svg_1\" fill=\"#ADC0CB\" d=\"m22.7476,0c11.0353,0 20,8.96471 20,20c0,11.0353 -8.9647,20 -20,20c-11.0353,0 -20.00004,-8.9647 -20.00004,-20c0,-11.03529 8.96474,-20 20.00004,-20z\"/>\n  <path class=\"stroke-path\" id=\"svg_2\" stroke-width=\"0.5\" stroke=\"#ADC0CB\" fill=\"white\" d=\"m39.1214,35.8072c-0.0329,0.3599 -0.1418,0.7272 -0.3097,1.0459c-0.4814,-0.493 -1.0736,-0.693 -1.6854,-0.8122c-0.2452,-0.0477 -0.5033,-0.0841 -0.7592,-0.1202c-0.1104,-0.0155 -0.2203,-0.031 -0.3287,-0.0473c-0.3665,-0.0553 -0.7303,-0.1219 -1.0887,-0.2351c-0.7077,-0.2235 -1.4067,-0.6324 -2.031,-1.5208c-0.5858,-0.8335 -1.1128,-2.0993 -1.5055,-4.0517c0.1628,0.0731 0.3304,0.1518 0.5036,0.2332c1.5507,0.7283 3.5614,1.6728 6.7176,0.7398l0.2062,-0.0609l-0.0294,-0.213c-0.4056,-2.936 -2.21,-4.6264 -3.4293,-5.6173c0.5519,0.0523 1.106,0.032 1.6463,-0.0078c0.2439,-0.0179 0.4834,-0.0396 0.719,-0.0609c0.6201,-0.0561 1.2134,-0.1097 1.7886,-0.0869c0.7811,0.0309 1.4892,0.2036 2.1106,0.6927c0.5777,0.4549 1.1052,1.2028 1.5348,2.4291c-0.0477,0.0018 -0.0958,0.0034 -0.1448,0.005c-0.1029,0.0034 -0.2095,0.0069 -0.3238,0.0131c-0.2752,0.015 -0.5681,0.0455 -0.8547,0.1363c-0.4125,0.1222 -0.7554,0.4163 -1.0273,0.6496c-0.0309,0.0265 -0.0609,0.0522 -0.09,0.0768l0.2221,0.4334c0.4549,-0.1137 0.9827,-0.0596 1.4884,0.1164c0.5048,0.1755 0.9669,0.4654 1.2876,0.7966c0.2254,0.2359 0.5487,0.7741 0.7544,1.3517c0.1019,0.286 0.17,0.5685 0.1859,0.8161c0.0052,0.0813 0.0047,0.1559 -0.0012,0.2238c-0.2975,-0.2307 -0.6917,-0.3764 -1.0692,-0.4666c-0.5523,-0.1319 -1.1467,-0.1632 -1.5598,-0.1257l-0.4085,0.0372l0.2202,0.346c0.4186,0.6578 0.9907,1.3823 1.684,1.9479c0.4882,0.3983 1.0446,0.7242 1.6557,0.8865c-1.1002,0.4467 -2.3296,0.3638 -3.3963,0.1007c-0.6396,-0.1578 -1.2092,-0.3777 -1.6384,-0.5752c-0.2145,-0.0987 -0.3925,-0.1912 -0.5255,-0.2665c-0.1387,-0.0787 -0.2146,-0.131 -0.2356,-0.149l-0.0114,-0.0098l-0.0126,-0.0084c-0.0091,-0.0061 -0.0219,-0.017 -0.0472,-0.0449c-0.005,-0.0055 -0.0114,-0.0127 -0.0188,-0.021c-0.0219,-0.0248 -0.0528,-0.0598 -0.083,-0.0899l-0.3752,0.3289c0.2179,0.2841 0.3085,0.7105 0.2652,1.1844z\"/>\n  <path id=\"svg_3\" fill=\"black\" d=\"m32.6702,20.9537l1.6136,1.0289l-5.7997,8.3955l-1.6136,-1.0289l1.1927,-1.754l-1.2863,-0.8185l-0.9588,1.3798c-0.2105,0.304 -0.6548,0.3742 -0.9588,0.1637l-2.2684,-1.4499l-1.9177,1.7773c0.1637,0.4677 0.2339,1.0056 0.2105,1.5902c-0.0701,1.4032 -0.6782,3.3676 -2.2918,4.7473l-3.1805,-1.1225l-0.1169,1.2628c0.5379,0.2573 0.8887,0.8185 0.8419,1.45c-0.0702,0.8185 -0.8185,1.4265 -1.6604,1.3563c-0.8419,-0.0701 -1.4733,-0.7717 -1.4031,-1.5902c0.0467,-0.6314 0.4911,-1.1225 1.0991,-1.2862l0.1403,-1.5669l-10.10265,-3.6248l-0.25724,1.3564c0.51449,0.3274 0.8185,0.9121 0.67819,1.5201c-0.1637,0.7951 -0.95882,1.333 -1.80071,1.1693c-0.84188,-0.1403 -1.37976,-0.9121 -1.21606,-1.7306c0.11693,-0.608 0.60803,-1.0523 1.21606,-1.1693l0.30402,-1.5434l-2.05795,-0.7484c-0.53787,-0.2104 -0.79512,-0.7717 -0.60803,-1.3096c0.21047,-0.5145 0.79512,-0.7717 1.37976,-0.5846l16.11281,5.7763c0.8887,-1.333 0.9354,-2.8999 0.7016,-3.3676l-16.67409,-9.3309c-0.44433,-0.2572 -0.65481,-0.7717 -0.44433,-1.2394l6.4077,-15.83222c0.11693,-0.28063 0.37417,-0.51449 0.67819,-0.60803c0.30401,-0.09354 0.6548,-0.04677 0.91204,0.11693l21.44479,13.86772l4.2796,-3.9755c0.912,-0.8653 2.1281,-1.333 3.4143,-1.333c1.2862,0 2.5257,0.4911 3.4377,1.3563c1.8943,1.8241 1.8943,4.7707 0,6.5715c-0.4209,0.3741 -1.0524,0.3975 -1.4733,0.0233c-0.4209,-0.3975 -0.4209,-1.0523 -0.0234,-1.4499c1.0524,-1.029 1.0524,-2.6893 0,-3.6949c-0.5145,-0.4911 -1.1927,-0.7718 -1.941,-0.7718c-0.725,0 -1.4265,0.2807 -1.941,0.7484l-4.6304,4.3264c-0.0468,0.0935 -0.1169,0.187 -0.2105,0.2572l-1.3564,1.2628l0.3041,0.1871c0.304,0.2339 0.3975,0.6782 0.187,0.9822l-0.8185,1.1693l1.2863,0.8185l1.1693,-1.7305zm-28.78795,-2.5023l15.22415,8.6527l10.3131,-9.3543l-19.90127,-12.86217l-5.63598,13.56377z\"/>\n  <path class=\"stroke-path\" id=\"svg_4\" stroke-width=\"0.5\" stroke=\"#ADC0CB\" fill=\"white\" d=\"m31.4271,22.5546l-0.2004,-0.1269l-0.7015,-0.4443l-0.2216,-0.1404l0.1508,-0.2146l0.6062,-0.8627c0.0003,-0.0004 0.0006,-0.0008 0.0008,-0.0011c0.2281,-0.3347 0.1596,-0.8217 -0.165,-1.0922l-0.2179,-0.1816l0.2076,-0.1933l1.0257,-0.9558c0.0996,-0.0997 0.1514,-0.1569 0.1754,-0.217l0.0207,-0.0518l0.0408,-0.0381l4.5836,-4.2796l0.0034,-0.0031l0,0c0.5136,-0.4622 1.1812,-0.719 1.8744,-0.719c0.6921,0 1.3648,0.2563 1.8594,0.7503c1.0094,0.9847 1.0134,2.5723 -0.001,3.5373c-0.458,0.4603 -0.4396,1.1628 0.0217,1.605c0.4334,0.4143 1.1473,0.4068 1.6207,-0.0255c1.9303,-1.8434 1.9515,-4.8577 -0.0017,-6.7223c-0.9345,-0.89 -2.1818,-1.3809 -3.4991,-1.3809c-1.3165,0 -2.542,0.4905 -3.4781,1.3597l-4.0689,3.7883l-0.1426,0.1328l-0.1635,-0.1059l-21.21095,-13.72746l-0.00285,-0.00184l0.00001,-0.00002c-0.2823,-0.1882 -0.64856,-0.23038 -0.98346,-0.13187l-0.00362,0.00106l-0.00001,-0.00003c-0.34441,0.09567 -0.6074,0.34229 -0.71982,0.66083l-0.00388,0.01098l-0.00025,-0.0001l-6.43109,15.83215l-0.0001,0.0003c-0.20907,0.5131 -0.00048,1.1025 0.49504,1.3693l0.00363,0.002l-0.00002,0l16.58047,9.2841l0.0811,0.0454l0.0318,0.0873c0.1178,0.324 0.1001,0.8131 -0.0017,1.3134c-0.1043,0.5122 -0.3063,1.0822 -0.6022,1.5877l-0.1048,0.1791l-0.1953,-0.07l-15.85246,-5.6817c-0.00052,-0.0002 -0.00103,-0.0003 -0.00154,-0.0005c-0.62938,-0.2155 -1.28113,0.082 -1.50917,0.6521c-0.22384,0.5596 0.06829,1.1914 0.65152,1.4272l1.77249,0.6297l0.20479,0.0727l-0.04355,0.213l-0.21047,1.0289l-0.02893,0.1415l-0.13694,0.0456c-0.55216,0.1841 -0.97592,0.631 -1.09708,1.2166l-0.00012,0.0006c-0.1792,0.8562 0.41688,1.6872 1.31466,1.83l0.00545,0.0009l-0.00001,0c0.90174,0.164 1.74802,-0.411 1.90796,-1.2507l0.00107,-0.0056l0.00006,0c0.11938,-0.5571 -0.09846,-1.14 -0.56442,-1.5047l-0.12043,-0.0942l0.02906,-0.1502l0.14031,-0.7249l0.05541,-0.2863l0.27445,0.0985l9.51799,3.4143l0.1814,0.065l-0.0167,0.192l-0.0936,1.0757l-0.013,0.1499l-0.1386,0.0587c-0.526,0.2225 -0.9072,0.7278 -0.9472,1.307l-0.0004,0.006l0,0c-0.0795,0.8546 0.5988,1.6319 1.5015,1.7154c0.9093,0.0605 1.706,-0.5798 1.7653,-1.4286c0.0404,-0.5871 -0.2433,-1.132 -0.7057,-1.4336l-0.1245,-0.0812l0.0118,-0.1481l0.0468,-0.5847l0.0261,-0.3257l0.3076,0.1104l2.7361,0.9822l0.0033,0.0012l0.0488,0.0183l0.0513,-0.044l12.7877,-12.5683zm0,0l0.1373,-0.1934l1.029,-1.4499l0,0l0.0041,-0.006l0.0484,-0.0727m-1.2188,1.722l1.2188,-1.722m0,0l0.0726,0.0484l0,0.0001l0.0043,0.0027l1.6136,1.029l0,0l0.0034,0.0021l0.0793,0.0488l-0.0603,0.0871l-0.0001,0.0002l-5.7997,8.3955l0,0l-0.0023,0.0034l-0.0484,0.0726l-0.0727,-0.0484l0.0001,0l-0.0043,-0.0027l-1.6136,-1.029l0,0l-0.0034,-0.0021l-0.0793,-0.0488l0.0601,-0.087l0.0002,-0.0001l1.0054,-1.4498l0.1486,-0.2142l-0.2202,-0.1395l-0.7016,-0.4443l-0.2034,-0.1288l-0.1364,0.1984l-0.7705,1.1208c-0.0002,0.0003 -0.0004,0.0005 -0.0006,0.0008c-0.2488,0.3544 -0.7473,0.4427 -1.1012,0.195l0.0002,-0.0002l-0.0093,-0.0059l-2.058,-1.3096l-0.1638,-0.1043l-0.1415,0.133l-1.5435,1.4499l-0.1127,0.1059l0.0444,0.1481c0.1303,0.4343 0.1758,0.9192 0.1534,1.4362c-0.0904,1.7375 -0.9045,3.5887 -2.3451,4.8268l14.0063,-14.2901zm-28.55022,-2.6175l-0.08478,0.204l0.19201,0.1093l14.75639,8.3955l0.1577,0.0896l0.1341,-0.122l9.7753,-8.8866l0.2404,-0.2185l-0.2729,-0.1764l-19.17631,-12.39446l-0.25159,-0.16261l-0.11497,0.27663l-5.35535,12.88554z\"/>\n  <path class=\"fill-path\" id=\"svg_5\" d=\"m4.03033,18.537508c0,0 5.57575,-13.402197 5.57575,-13.402197c0,0 19.39391,12.690577 19.36357,12.638659c0.03034,0.051918 -9.66662,9.065794 -9.69695,9.013866c0.03033,0.051928 -15.24237,-8.250328 -15.24237,-8.250328z\" stroke-width=\"0.5\" fill=\"#adc0cb\"/>\n </g>\n</svg></div></div><div class=\"message\"><div class=\"message-header\"><div class=\"time\" ng-if=\"!message.isSending\" am-time-ago=\"getTimeForMessage(message.createdOn)\"></div><div class=\"name\">{{ message.name }}</div></div><div class=\"message-body\" ng-if=\"message.message\" markdown-transpile=\"message.message\"></div><div class=\"message-body\" ng-if=\"!message.message &amp;&amp; message.Message\" markdown-transpile=\"message.Message\"></div></div></div></div></div><div class=\"send-message-area\"><div class=\"emoji-picker-container emoji-text-area\"><textarea ng-model=\"newMessage\" aria-label=\"New Message\" placeholder=\"Type your message here\" ng-disabled=\"postingMessage || isStealthUserMode\" data-emoji-input=\"unicode\" data-emojiable=\"true\" ng-keypress=\"onMessageTextAreaKeyPress($event)\"></textarea></div><div class=\"send-message-btn\" ng-click=\"postMessage($event)\" aria-label=\"Post\" type=\"submit\"><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M0 20L20 10L0 0V7.77778L14.2857 10L0 12.2222V20Z\" fill=\"#668698\"/>\n</svg>\n</div></div></div><!--.chat-contents(layout=\"column\")--><!--    .header(layout=\"row\" layout-align=\"start center\")--><!--        .title(flex=50) Chat with All Group Members--><!----><!--        .check-all(flex=20 hidden)--><!--            md-checkbox(ng-click=\"selectAllParticipants()\" ng-checked=\"checkedAllParticipants()\") Select All--><!--        .filter-message(flex=30 hidden)--><!--            md-input-container--><!--                label.lbl-placeholder Filter Participants--><!--                md-select.filter-select-menu(ng-model='selectedParticipants', md-on-close='clearSearchTerm()', multiple='')--><!--                    md-optgroup(label='Participants')--><!--                        md-option.option-filter(ng-value='participant.email', ng-repeat='participant in participants') {{participant.name}}--><!----><!--    .post( layout=\"row\" ng-form=\"postMessageForm\")--><!--        md-input-container.md-input-has-messages.emoji-text-area(flex=\"noshrink\" ng-class=\"{'msg-disabled' : isStealthUserMode}\")--><!--            textarea(ng-model=\"newMessage\" aria-label=\"New Message\" placeholder=\"Type your message here\" rows=\"1\"--><!--                        ng-disabled=\"postingMessage\"--><!--                        ng-keypress=\"onMessageTextAreaKeyPress($event)\" md-maxlength=\"maxTextLength\"--><!--                        data-emoji-input=\"unicode\"--><!--                        data-emojiable=\"true\")--><!--        md-button.md-icon-button(ng-class=\"{'active': newMessage.length}\" ng-disabled=\"postingMessage || !newMessage.length || isStealthUserMode\" ng-click=\"postMessage($event)\" aria-label=\"Post\")--><!--            md-icon send--><!----><!--    .messages(layout=\"column\" ng-show=\"refreshing\")--><!--        .label.label-info Loading messages...--><!----><!--    .messages(layout=\"column\" ng-show=\"!refreshing && (!messages || !messages.length)\")--><!--        .label.label-warning No messages available--><!----><!--    .messages(layout=\"column\" ng-show=\"!refreshing && messages && messages.length\")--><!--        div.messages-container--><!--            .message(ng-repeat=\"message in participantsFilter() | orderBy: '-createdOn'\" layout=\"row\")--><!--                .avatar--><!--                    span(ng-if=\"!message.avatarCropped\") {{message.iconLetter}}--><!--                    img.participant-avatar(ng-if=\"message.avatarCropped && !isSvg(message.avatarCropped)\" ng-src=\"{{ message.avatarCropped }}\")--><!--                    cartonomy-logo(ng-if=\"isSvg(message.avatarCropped)\")--><!----><!--                div(layout=\"column\" flex)--><!--                    div(layout=\"row\")--><!--                        .name(flex) {{ message.name }}--><!--                        .time.message.loading.loading-spinner(ng-if=\"message.isSending\").--><!--                            Sending...--><!--                            #[.spinner]--><!----><!--                        .time(ng-if=\"!message.isSending\" am-time-ago=\"getTimeForMessage(message.createdOn)\")--><!--                    .body(layout-fill ng-if=\"message.message\" flex markdown-transpile=\"message.message\")--><!--                    .body(layout-fill ng-if=\"!message.message && message.Message\" flex markdown-transpile=\"message.Message\")--><!----><!--    .messages(layout=\"column\")--><!--        md-button(ng-show=\"hasMore\" ng-click=\"showMore()\") Display Older Messages-->"

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(837);
module.exports = 'ngSanitize';

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @license AngularJS v1.6.4
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function (window, angular) {
  'use strict';

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   *     Any commits to this file should be reviewed with security in mind.  *
   *   Changes to this file can potentially create security vulnerabilities. *
   *          An approval from 2 Core members with history of modifying      *
   *                         this file is required.                          *
   *                                                                         *
   *  Does the change somehow allow for arbitrary javascript to be executed? *
   *    Or allows for someone to change the prototype of built-in objects?   *
   *     Or gives undesired access to variables likes document or window?    *
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  var $sanitizeMinErr = angular.$$minErr('$sanitize');
  var bind;
  var extend;
  var forEach;
  var isDefined;
  var lowercase;
  var noop;
  var nodeContains;
  var htmlParser;
  var htmlSanitizeWriter;

  /**
   * @ngdoc module
   * @name ngSanitize
   * @description
   *
   * # ngSanitize
   *
   * The `ngSanitize` module provides functionality to sanitize HTML.
   *
   *
   * <div doc-module-components="ngSanitize"></div>
   *
   * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
   */

  /**
   * @ngdoc service
   * @name $sanitize
   * @kind function
   *
   * @description
   *   Sanitizes an html string by stripping all potentially dangerous tokens.
   *
   *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
   *   then serialized back to properly escaped html string. This means that no unsafe input can make
   *   it into the returned string.
   *
   *   The whitelist for URL sanitization of attribute values is configured using the functions
   *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
   *   `$compileProvider`}.
   *
   *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
   *
   * @param {string} html HTML input.
   * @returns {string} Sanitized HTML.
   *
   * @example
     <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
     <file name="index.html">
       <script>
           angular.module('sanitizeExample', ['ngSanitize'])
             .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
               $scope.snippet =
                 '<p style="color:blue">an html\n' +
                 '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
                 'snippet</p>';
               $scope.deliberatelyTrustDangerousSnippet = function() {
                 return $sce.trustAsHtml($scope.snippet);
               };
             }]);
       </script>
       <div ng-controller="ExampleController">
          Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
         <table>
           <tr>
             <td>Directive</td>
             <td>How</td>
             <td>Source</td>
             <td>Rendered</td>
           </tr>
           <tr id="bind-html-with-sanitize">
             <td>ng-bind-html</td>
             <td>Automatically uses $sanitize</td>
             <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
             <td><div ng-bind-html="snippet"></div></td>
           </tr>
           <tr id="bind-html-with-trust">
             <td>ng-bind-html</td>
             <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
             <td>
             <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
  &lt;/div&gt;</pre>
             </td>
             <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
           </tr>
           <tr id="bind-default">
             <td>ng-bind</td>
             <td>Automatically escapes</td>
             <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
             <td><div ng-bind="snippet"></div></td>
           </tr>
         </table>
         </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should sanitize the html snippet by default', function() {
         expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
           toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
       });
  
       it('should inline raw snippet if bound to a trusted value', function() {
         expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
           toBe("<p style=\"color:blue\">an html\n" +
                "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
                "snippet</p>");
       });
  
       it('should escape snippet without any filter', function() {
         expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
           toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
                "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
                "snippet&lt;/p&gt;");
       });
  
       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
         expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
           toBe('new <b>text</b>');
         expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
           'new <b onclick="alert(1)">text</b>');
         expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
           "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
       });
     </file>
     </example>
   */

  /**
   * @ngdoc provider
   * @name $sanitizeProvider
   * @this
   *
   * @description
   * Creates and configures {@link $sanitize} instance.
   */
  function $SanitizeProvider() {
    var svgEnabled = false;

    this.$get = ['$$sanitizeUri', function ($$sanitizeUri) {
      if (svgEnabled) {
        extend(validElements, svgElements);
      }
      return function (html) {
        var buf = [];
        htmlParser(html, htmlSanitizeWriter(buf, function (uri, isImage) {
          return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
        }));
        return buf.join('');
      };
    }];

    /**
     * @ngdoc method
     * @name $sanitizeProvider#enableSvg
     * @kind function
     *
     * @description
     * Enables a subset of svg to be supported by the sanitizer.
     *
     * <div class="alert alert-warning">
     *   <p>By enabling this setting without taking other precautions, you might expose your
     *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
     *   outside of the containing element and be rendered over other elements on the page (e.g. a login
     *   link). Such behavior can then result in phishing incidents.</p>
     *
     *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
     *   tags within the sanitized content:</p>
     *
     *   <br>
     *
     *   <pre><code>
     *   .rootOfTheIncludedContent svg {
     *     overflow: hidden !important;
     *   }
     *   </code></pre>
     * </div>
     *
     * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
     * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
     *    without an argument or self for chaining otherwise.
     */
    this.enableSvg = function (enableSvg) {
      if (isDefined(enableSvg)) {
        svgEnabled = enableSvg;
        return this;
      } else {
        return svgEnabled;
      }
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Private stuff
    //////////////////////////////////////////////////////////////////////////////////////////////////

    bind = angular.bind;
    extend = angular.extend;
    forEach = angular.forEach;
    isDefined = angular.isDefined;
    lowercase = angular.lowercase;
    noop = angular.noop;

    htmlParser = htmlParserImpl;
    htmlSanitizeWriter = htmlSanitizeWriterImpl;

    nodeContains = window.Node.prototype.contains || /** @this */function (arg) {
      // eslint-disable-next-line no-bitwise
      return !!(this.compareDocumentPosition(arg) & 16);
    };

    // Regular Expressions for parsing tags and attributes
    var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,

    // Match everything outside of normal chars and " (quote character)
    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;

    // Good source of info about elements and attributes
    // http://dev.w3.org/html5/spec/Overview.html#semantics
    // http://simon.html5.org/html-elements

    // Safe Void Elements - HTML5
    // http://dev.w3.org/html5/spec/Overview.html#void-elements
    var voidElements = toMap('area,br,col,hr,img,wbr');

    // Elements that you can, intentionally, leave open (and which close themselves)
    // http://dev.w3.org/html5/spec/Overview.html#optional-tags
    var optionalEndTagBlockElements = toMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
        optionalEndTagInlineElements = toMap('rp,rt'),
        optionalEndTagElements = extend({}, optionalEndTagInlineElements, optionalEndTagBlockElements);

    // Safe Block Elements - HTML5
    var blockElements = extend({}, optionalEndTagBlockElements, toMap('address,article,' + 'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' + 'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));

    // Inline Elements - HTML5
    var inlineElements = extend({}, optionalEndTagInlineElements, toMap('a,abbr,acronym,b,' + 'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' + 'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));

    // SVG Elements
    // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
    // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
    // They can potentially allow for arbitrary javascript to be executed. See #11290
    var svgElements = toMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' + 'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' + 'radialGradient,rect,stop,svg,switch,text,title,tspan');

    // Blocked Elements (will be stripped)
    var blockedElements = toMap('script,style');

    var validElements = extend({}, voidElements, blockElements, inlineElements, optionalEndTagElements);

    //Attributes that have href and hence need to be sanitized
    var uriAttrs = toMap('background,cite,href,longdesc,src,xlink:href');

    var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' + 'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' + 'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' + 'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' + 'valign,value,vspace,width');

    // SVG attributes (without "id" and "name" attributes)
    // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
    var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' + 'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' + 'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' + 'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' + 'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' + 'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' + 'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' + 'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' + 'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' + 'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' + 'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' + 'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' + 'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' + 'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' + 'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

    var validAttrs = extend({}, uriAttrs, svgAttrs, htmlAttrs);

    function toMap(str, lowercaseKeys) {
      var obj = {},
          items = str.split(','),
          i;
      for (i = 0; i < items.length; i++) {
        obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
      }
      return obj;
    }

    var inertBodyElement;
    (function (window) {
      var doc;
      if (window.document && window.document.implementation) {
        doc = window.document.implementation.createHTMLDocument('inert');
      } else {
        throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
      }
      var docElement = doc.documentElement || doc.getDocumentElement();
      var bodyElements = docElement.getElementsByTagName('body');

      // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
      if (bodyElements.length === 1) {
        inertBodyElement = bodyElements[0];
      } else {
        var html = doc.createElement('html');
        inertBodyElement = doc.createElement('body');
        html.appendChild(inertBodyElement);
        doc.appendChild(html);
      }
    })(window);

    /**
     * @example
     * htmlParser(htmlString, {
     *     start: function(tag, attrs) {},
     *     end: function(tag) {},
     *     chars: function(text) {},
     *     comment: function(text) {}
     * });
     *
     * @param {string} html string
     * @param {object} handler
     */
    function htmlParserImpl(html, handler) {
      if (html === null || html === undefined) {
        html = '';
      } else if (typeof html !== 'string') {
        html = '' + html;
      }
      inertBodyElement.innerHTML = html;

      //mXSS protection
      var mXSSAttempts = 5;
      do {
        if (mXSSAttempts === 0) {
          throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
        }
        mXSSAttempts--;

        // strip custom-namespaced attributes on IE<=11
        if (window.document.documentMode) {
          stripCustomNsAttrs(inertBodyElement);
        }
        html = inertBodyElement.innerHTML; //trigger mXSS
        inertBodyElement.innerHTML = html;
      } while (html !== inertBodyElement.innerHTML);

      var node = inertBodyElement.firstChild;
      while (node) {
        switch (node.nodeType) {
          case 1:
            // ELEMENT_NODE
            handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
            break;
          case 3:
            // TEXT NODE
            handler.chars(node.textContent);
            break;
        }

        var nextNode;
        if (!(nextNode = node.firstChild)) {
          if (node.nodeType === 1) {
            handler.end(node.nodeName.toLowerCase());
          }
          nextNode = getNonDescendant('nextSibling', node);
          if (!nextNode) {
            while (nextNode == null) {
              node = getNonDescendant('parentNode', node);
              if (node === inertBodyElement) break;
              nextNode = getNonDescendant('nextSibling', node);
              if (node.nodeType === 1) {
                handler.end(node.nodeName.toLowerCase());
              }
            }
          }
        }
        node = nextNode;
      }

      while (node = inertBodyElement.firstChild) {
        inertBodyElement.removeChild(node);
      }
    }

    function attrToMap(attrs) {
      var map = {};
      for (var i = 0, ii = attrs.length; i < ii; i++) {
        var attr = attrs[i];
        map[attr.name] = attr.value;
      }
      return map;
    }

    /**
     * Escapes all potentially dangerous characters, so that the
     * resulting string can be safely inserted into attribute or
     * element text.
     * @param value
     * @returns {string} escaped text
     */
    function encodeEntities(value) {
      return value.replace(/&/g, '&amp;').replace(SURROGATE_PAIR_REGEXP, function (value) {
        var hi = value.charCodeAt(0);
        var low = value.charCodeAt(1);
        return '&#' + ((hi - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000) + ';';
      }).replace(NON_ALPHANUMERIC_REGEXP, function (value) {
        return '&#' + value.charCodeAt(0) + ';';
      }).replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    /**
     * create an HTML/XML writer which writes to buffer
     * @param {Array} buf use buf.join('') to get out sanitized html string
     * @returns {object} in the form of {
     *     start: function(tag, attrs) {},
     *     end: function(tag) {},
     *     chars: function(text) {},
     *     comment: function(text) {}
     * }
     */
    function htmlSanitizeWriterImpl(buf, uriValidator) {
      var ignoreCurrentElement = false;
      var out = bind(buf, buf.push);
      return {
        start: function start(tag, attrs) {
          tag = lowercase(tag);
          if (!ignoreCurrentElement && blockedElements[tag]) {
            ignoreCurrentElement = tag;
          }
          if (!ignoreCurrentElement && validElements[tag] === true) {
            out('<');
            out(tag);
            forEach(attrs, function (value, key) {
              var lkey = lowercase(key);
              var isImage = tag === 'img' && lkey === 'src' || lkey === 'background';
              if (validAttrs[lkey] === true && (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
                out(' ');
                out(key);
                out('="');
                out(encodeEntities(value));
                out('"');
              }
            });
            out('>');
          }
        },
        end: function end(tag) {
          tag = lowercase(tag);
          if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
            out('</');
            out(tag);
            out('>');
          }
          // eslint-disable-next-line eqeqeq
          if (tag == ignoreCurrentElement) {
            ignoreCurrentElement = false;
          }
        },
        chars: function chars(_chars) {
          if (!ignoreCurrentElement) {
            out(encodeEntities(_chars));
          }
        }
      };
    }

    /**
     * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
     * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
     * to allow any of these custom attributes. This method strips them all.
     *
     * @param node Root element to process
     */
    function stripCustomNsAttrs(node) {
      while (node) {
        if (node.nodeType === window.Node.ELEMENT_NODE) {
          var attrs = node.attributes;
          for (var i = 0, l = attrs.length; i < l; i++) {
            var attrNode = attrs[i];
            var attrName = attrNode.name.toLowerCase();
            if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
              node.removeAttributeNode(attrNode);
              i--;
              l--;
            }
          }
        }

        var nextNode = node.firstChild;
        if (nextNode) {
          stripCustomNsAttrs(nextNode);
        }

        node = getNonDescendant('nextSibling', node);
      }
    }

    function getNonDescendant(propName, node) {
      // An element is clobbered if its `propName` property points to one of its descendants
      var nextNode = node[propName];
      if (nextNode && nodeContains.call(node, nextNode)) {
        throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
      }
      return nextNode;
    }
  }

  function sanitizeText(chars) {
    var buf = [];
    var writer = htmlSanitizeWriter(buf, noop);
    writer.chars(chars);
    return buf.join('');
  }

  // define ngSanitize module and register $sanitize service
  angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider).info({ angularVersion: '1.6.4' });

  /**
   * @ngdoc filter
   * @name linky
   * @kind function
   *
   * @description
   * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
   * plain email address links.
   *
   * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
   *
   * @param {string} text Input text.
   * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
   * @param {object|function(url)} [attributes] Add custom attributes to the link element.
   *
   *    Can be one of:
   *
   *    - `object`: A map of attributes
   *    - `function`: Takes the url as a parameter and returns a map of attributes
   *
   *    If the map of attributes contains a value for `target`, it overrides the value of
   *    the target parameter.
   *
   *
   * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
   *
   * @usage
     <span ng-bind-html="linky_expression | linky"></span>
   *
   * @example
     <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
       <file name="index.html">
         <div ng-controller="ExampleController">
         Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
         <table>
           <tr>
             <th>Filter</th>
             <th>Source</th>
             <th>Rendered</th>
           </tr>
           <tr id="linky-filter">
             <td>linky filter</td>
             <td>
               <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
             </td>
             <td>
               <div ng-bind-html="snippet | linky"></div>
             </td>
           </tr>
           <tr id="linky-target">
            <td>linky target</td>
            <td>
              <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
            </td>
            <td>
              <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
            </td>
           </tr>
           <tr id="linky-custom-attributes">
            <td>linky custom attributes</td>
            <td>
              <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
            </td>
            <td>
              <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
            </td>
           </tr>
           <tr id="escaped-html">
             <td>no filter</td>
             <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
             <td><div ng-bind="snippet"></div></td>
           </tr>
         </table>
       </file>
       <file name="script.js">
         angular.module('linkyExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.snippet =
               'Pretty text with some links:\n' +
               'http://angularjs.org/,\n' +
               'mailto:us@somewhere.org,\n' +
               'another@somewhere.org,\n' +
               'and one more: ftp://127.0.0.1/.';
             $scope.snippetWithSingleURL = 'http://angularjs.org/';
           }]);
       </file>
       <file name="protractor.js" type="protractor">
         it('should linkify the snippet with urls', function() {
           expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
               toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                    'another@somewhere.org, and one more: ftp://127.0.0.1/.');
           expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
         });
  
         it('should not linkify snippet without the linky filter', function() {
           expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
               toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                    'another@somewhere.org, and one more: ftp://127.0.0.1/.');
           expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
         });
  
         it('should update', function() {
           element(by.model('snippet')).clear();
           element(by.model('snippet')).sendKeys('new http://link.');
           expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
               toBe('new http://link.');
           expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
           expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
               .toBe('new http://link.');
         });
  
         it('should work with the target property', function() {
          expect(element(by.id('linky-target')).
              element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
              toBe('http://angularjs.org/');
          expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
         });
  
         it('should optionally add custom attributes', function() {
          expect(element(by.id('linky-custom-attributes')).
              element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
              toBe('http://angularjs.org/');
          expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
         });
       </file>
     </example>
   */
  angular.module('ngSanitize').filter('linky', ['$sanitize', function ($sanitize) {
    var LINKY_URL_REGEXP = /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
        MAILTO_REGEXP = /^mailto:/i;

    var linkyMinErr = angular.$$minErr('linky');
    var isDefined = angular.isDefined;
    var isFunction = angular.isFunction;
    var isObject = angular.isObject;
    var isString = angular.isString;

    return function (text, target, attributes) {
      if (text == null || text === '') return text;
      if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);

      var attributesFn = isFunction(attributes) ? attributes : isObject(attributes) ? function getAttributesObject() {
        return attributes;
      } : function getEmptyAttributesObject() {
        return {};
      };

      var match;
      var raw = text;
      var html = [];
      var url;
      var i;
      while (match = raw.match(LINKY_URL_REGEXP)) {
        // We can not end in these as they are sometimes found at the end of the sentence
        url = match[0];
        // if we did not match ftp/http/www/mailto then assume mailto
        if (!match[2] && !match[4]) {
          url = (match[3] ? 'http://' : 'mailto:') + url;
        }
        i = match.index;
        addText(raw.substr(0, i));
        addLink(url, match[0].replace(MAILTO_REGEXP, ''));
        raw = raw.substring(i + match[0].length);
      }
      addText(raw);
      return $sanitize(html.join(''));

      function addText(text) {
        if (!text) {
          return;
        }
        html.push(sanitizeText(text));
      }

      function addLink(url, text) {
        var key,
            linkAttributes = attributesFn(url);
        html.push('<a ');

        for (key in linkAttributes) {
          html.push(key + '="' + linkAttributes[key] + '" ');
        }

        if (isDefined(target) && !('target' in linkAttributes)) {
          html.push('target="', target, '" ');
        }
        html.push('href="', url.replace(/"/g, '&quot;'), '">');
        addText(text);
        html.push('</a>');
      }
    };
  }]);
})(window, window.angular);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * angular-marked
 * (c) 2014 - 2016 J. Harshbarger
 * Licensed MIT
 */

/* global angular, marked */



var unindent = __webpack_require__(839);

/**
 * @ngdoc overview
 * @name index
 *
 * @description
 * AngularJS Markdown using [marked](https://github.com/chjj/marked).
 *
 * ## Why?
 *
 * I wanted to use [marked](https://github.com/chjj/marked) instead of [showdown](https://github.com/coreyti/showdown) as used in [angular-markdown-directive](https://github.com/btford/angular-markdown-directive) as well as expose the option to globally set defaults.
 *
 * ## How?
 *
 * - {@link hc.marked.directive:marked As a directive}
 * - {@link hc.marked.service:marked As a service}
 * - {@link hc.marked.service:markedProvider Set default options}
 *
 * @example
     Convert markdown to html at run time.  For example:
     <example module="app">
      <file name="example.html">
        <form ng-controller="MainController">
          Markdown:<br />
          <textarea ng-model="my_markdown" cols="60" rows="5" class="span8"></textarea><br />
          Output:<br />
          <div marked="my_markdown" />
        </form>
      </file>
      <file  name="example.js">
        function MainController($scope) {
          $scope.my_markdown = "*This* **is** [markdown](https://daringfireball.net/projects/markdown/)";
        }
        angular.module('app', ['hc.marked']).controller('MainController', MainController);
      </file>
    </example>
   *
  */

/**
 * @ngdoc overview
 * @name hc.marked
 * @description # angular-marked (core module)
   # Installation
  First include angular-marked.js in your HTML:
   ```js
    <script src="angular-marked.js">
  ```
   Then load the module in your application by adding it as a dependency:
   ```js
  angular.module('yourApp', ['hc.marked']);
  ```
   With that you're ready to get started!
 */

/**
* @ngdoc service
* @name hc.marked.service:marked
* @requires $window
* @description
* A reference to the [marked](https://github.com/chjj/marked) parser.
*
* @example
<example module="app">
  <file name="example.html">
    <div ng-controller="MainController">
      html: {{html}}
    </div>
  </file>
  <file  name="example.js">
    function MainController($scope, marked) {
      $scope.html = marked('#TEST');
    }
    angular.module('app', ['hc.marked']).controller('MainController', MainController);
  </file>
</example>
**/

/**
* @ngdoc service
* @name hc.marked.service:markedProvider
* @description
* Use `markedProvider` to change the default behavior of the {@link hc.marked.service:marked marked} service.
*
* @example
  ## Example using [google-code-prettify syntax highlighter](https://code.google.com/p/google-code-prettify/) (must include google-code-prettify.js script).  Also works with [highlight.js Javascript syntax highlighter](http://highlightjs.org/).
  <example module="myAppA">
   <file name="exampleA.js">
   angular.module('myAppA', ['hc.marked'])
     .config(['markedProvider', function(markedProvider) {
       markedProvider.setOptions({
         gfm: true,
         tables: true,
         highlight: function (code) {
           return prettyPrintOne(code);
         }
       });
     }]);
   </file>
   <file name="exampleA.html">
     <marked>
     ```js
     angular.module('myAppA', ['hc.marked'])
       .config(['markedProvider', function(markedProvider) {
         markedProvider.setOptions({
           gfm: true,
           tables: true,
           highlight: function (code) {
             return prettyPrintOne(code);
           }
         });
       }]);
     ```
     </marked>
   </file>
 </example>
  ## Example overriding the way custom markdown links are displayed
  <example module="myAppB">
   <file name="exampleB.js">
   angular.module('myAppB', ['hc.marked'])
     .config(['markedProvider', function(markedProvider) {
       markedProvider.setRenderer({
         link: function(href, title, text) {
           return "<a href='" + href + "'" + (title ? " title='" + title + "'" : '') + " target='_blank'>" + text + "</a>";
         }
       });
     }]);
   </file>
   <file name="exampleB.html">
     <marked>
       This is [an example](http://example.com/ "Title") inline link.
       [This link](http://example.net/) has no title attribute.
     </marked>
   </file>
 </example>
**/

function markedProvider() {
  var self = this;

  /**
   * @ngdoc method
   * @name markedProvider#setRenderer
   * @methodOf hc.marked.service:markedProvider
   *
   * @param {object} opts Default renderer options for [marked](https://github.com/chjj/marked#overriding-renderer-methods).
   */

  self.setRenderer = function (opts) {
    this.renderer = opts;
  };

  /**
   * @ngdoc method
   * @name markedProvider#setOptions
   * @methodOf hc.marked.service:markedProvider
   *
   * @param {object} opts Default options for [marked](https://github.com/chjj/marked#options-1).
   */

  self.setOptions = function (opts) {
    // Store options for later
    this.defaults = opts;
  };

  self.$get = ['$log', '$window', function ($log, $window) {
    var m;

    try {
      m = __webpack_require__(840);
    } catch (err) {
      m = $window.marked || marked;
    }

    if (angular.isUndefined(m)) {
      $log.error('angular-marked Error: marked not loaded.  See installation instructions.');
      return;
    }

    var r = new m.Renderer();

    // override rendered markdown html
    // with custom definitions if defined
    if (self.renderer) {
      var o = Object.keys(self.renderer);
      var l = o.length;

      while (l--) {
        r[o[l]] = self.renderer[o[l]];
      }
    }

    // Customize code and codespan rendering to wrap default or overriden output in a ng-non-bindable span
    function wrapNonBindable(string) {
      return '<span ng-non-bindable>' + string + '</span>';
    }

    var renderCode = r.code.bind(r);
    r.code = function (code, lang, escaped) {
      return wrapNonBindable(renderCode(code, lang, escaped));
    };
    var renderCodespan = r.codespan.bind(r);
    r.codespan = function (code) {
      return wrapNonBindable(renderCodespan(code));
    };

    // add the new renderer to the options if need be
    self.defaults = self.defaults || {};
    self.defaults.renderer = r;

    m.setOptions(self.defaults);

    return m;
  }];
}

// xTODO: filter and tests */
// app.filter('marked', ['marked', function(marked) {
//   return marked;
// }]);

/**
 * @ngdoc directive
 * @name hc.marked.directive:marked
 * @restrict AE
 * @element any
 *
 * @description
 * Compiles source test into HTML.
 *
 * @param {expression=} marked The source text to be compiled.  If blank uses content as the source.
 * @param {expression=} opts Hash of options that override defaults.
 * @param {boolean=} compile Set to true to to support AngularJS directives inside markdown.
 * @param {string=} src Expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 *
 * @example
    ## A simple block of text
     <example module="hc.marked">
      <file name="exampleA.html">
       * <marked>
       *   ### Markdown directive
       *
       *   *It works!*
       *
       *   *This* **is** [markdown](https://daringfireball.net/projects/markdown/) in the view.
       * </marked>
      </file>
    </example>
    ## Bind to a scope variable
     <example module="app">
      <file name="exampleB.html">
        <form ng-controller="MainController">
          Markdown:<br />
          <textarea ng-model="my_markdown" class="span8" cols="60" rows="5"></textarea><br />
          Output:<br />
          <blockquote marked="my_markdown"></blockquote>
        </form>
      </file>
      <file  name="exampleB.js">
        * function MainController($scope) {
        *     $scope.my_markdown = '*This* **is** [markdown](https://daringfireball.net/projects/markdown/)';
        *     $scope.my_markdown += ' in a scope variable';
        * }
        * angular.module('app', ['hc.marked']).controller('MainController', MainController);
      </file>
    </example>
     ## Include a markdown file:
      <example module="hc.marked">
       <file name="exampleC.html">
         <div marked src="'include.html'" />
       </file>
       * <file name="include.html">
       * *This* **is** [markdown](https://daringfireball.net/projects/markdown/) in a include file.
       * </file>
     </example>
 */
markedDirective.$inject = ['marked', '$templateRequest', '$compile'];
function markedDirective(marked, $templateRequest, $compile) {
  return {
    restrict: 'AE',
    replace: true,
    scope: {
      opts: '=',
      marked: '=',
      compile: '@',
      src: '='
    },
    link: function link(scope, element, attrs) {
      if (attrs.marked) {
        set(scope.marked);
        scope.$watch('marked', set);
      } else if (attrs.src) {
        scope.$watch('src', function (src) {
          $templateRequest(src, true).then(function (response) {
            set(response);
          }, function () {
            set('');
            scope.$emit('$markedIncludeError', attrs.src);
          });
        });
      } else {
        set(element.text());
      }

      function set(text) {
        text = unindent(String(text || ''));
        element.html(marked(text, scope.opts || null));
        if (scope.$eval(attrs.compile)) {
          $compile(element.contents())(scope.$parent);
        }
      }
    }
  };
}

module.exports = angular.module('hc.marked', []).directive('marked', markedDirective).provider('marked', markedProvider).name;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function unindent(text) {
  if (!text) {
    return text;
  }

  var lines = text.replace(/\t/g, '  ').split(/\r?\n/);

  var min = null;
  var len = lines.length;
  var i;

  for (i = 0; i < len; i++) {
    var line = lines[i];
    var l = line.match(/^(\s*)/)[0].length;
    if (l === line.length) {
      continue;
    }
    min = l < min || min === null ? l : min;
  }

  if (min !== null && min > 0) {
    for (i = 0; i < len; i++) {
      lines[i] = lines[i].substr(min);
    }
  }
  return lines.join('\n');
};

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * marked - a markdown parser
 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

;(function (root) {
  'use strict';

  /**
   * Block-Level Grammar
   */

  var block = {
    newline: /^\n+/,
    code: /^( {4}[^\n]+\n*)+/,
    fences: noop,
    hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
    heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
    nptable: noop,
    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
    list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
    html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
    def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
    table: noop,
    lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
    paragraph: /^([^\n]+(?:\n?(?!hr|heading|lheading| {0,3}>|tag)[^\n]+)+)/,
    text: /^[^\n]+/
  };

  block._label = /(?:\\[\[\]]|[^\[\]])+/;
  block._title = /(?:"(?:\\"|[^"]|"[^"\n]*")*"|'\n?(?:[^'\n]+\n?)*'|\([^()]*\))/;
  block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();

  block.bullet = /(?:[*+-]|\d+\.)/;
  block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
  block.item = edit(block.item, 'gm').replace(/bull/g, block.bullet).getRegex();

  block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();

  block._tag = '(?!(?:' + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code' + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo' + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b';

  block.html = edit(block.html).replace('comment', /<!--[\s\S]*?-->/).replace('closed', /<(tag)[\s\S]+?<\/\1>/).replace('closing', /<tag(?:"[^"]*"|'[^']*'|\s[^'"\/>\s]*)*?\/?>/).replace(/tag/g, block._tag).getRegex();

  block.paragraph = edit(block.paragraph).replace('hr', block.hr).replace('heading', block.heading).replace('lheading', block.lheading).replace('tag', '<' + block._tag).getRegex();

  block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();

  /**
   * Normal Block Grammar
   */

  block.normal = merge({}, block);

  /**
   * GFM Block Grammar
   */

  block.gfm = merge({}, block.normal, {
    fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\n? *\1 *(?:\n+|$)/,
    paragraph: /^/,
    heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
  });

  block.gfm.paragraph = edit(block.paragraph).replace('(?!', '(?!' + block.gfm.fences.source.replace('\\1', '\\2') + '|' + block.list.source.replace('\\1', '\\3') + '|').getRegex();

  /**
   * GFM + Tables Block Grammar
   */

  block.tables = merge({}, block.gfm, {
    nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
    table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
  });

  /**
   * Block Lexer
   */

  function Lexer(options) {
    this.tokens = [];
    this.tokens.links = {};
    this.options = options || marked.defaults;
    this.rules = block.normal;

    if (this.options.gfm) {
      if (this.options.tables) {
        this.rules = block.tables;
      } else {
        this.rules = block.gfm;
      }
    }
  }

  /**
   * Expose Block Rules
   */

  Lexer.rules = block;

  /**
   * Static Lex Method
   */

  Lexer.lex = function (src, options) {
    var lexer = new Lexer(options);
    return lexer.lex(src);
  };

  /**
   * Preprocessing
   */

  Lexer.prototype.lex = function (src) {
    src = src.replace(/\r\n|\r/g, '\n').replace(/\t/g, '    ').replace(/\u00a0/g, ' ').replace(/\u2424/g, '\n');

    return this.token(src, true);
  };

  /**
   * Lexing
   */

  Lexer.prototype.token = function (src, top) {
    src = src.replace(/^ +$/gm, '');
    var next, loose, cap, bull, b, item, space, i, tag, l, isordered;

    while (src) {
      // newline
      if (cap = this.rules.newline.exec(src)) {
        src = src.substring(cap[0].length);
        if (cap[0].length > 1) {
          this.tokens.push({
            type: 'space'
          });
        }
      }

      // code
      if (cap = this.rules.code.exec(src)) {
        src = src.substring(cap[0].length);
        cap = cap[0].replace(/^ {4}/gm, '');
        this.tokens.push({
          type: 'code',
          text: !this.options.pedantic ? cap.replace(/\n+$/, '') : cap
        });
        continue;
      }

      // fences (gfm)
      if (cap = this.rules.fences.exec(src)) {
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: 'code',
          lang: cap[2],
          text: cap[3] || ''
        });
        continue;
      }

      // heading
      if (cap = this.rules.heading.exec(src)) {
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: 'heading',
          depth: cap[1].length,
          text: cap[2]
        });
        continue;
      }

      // table no leading pipe (gfm)
      if (top && (cap = this.rules.nptable.exec(src))) {
        src = src.substring(cap[0].length);

        item = {
          type: 'table',
          header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
          cells: cap[3].replace(/\n$/, '').split('\n')
        };

        for (i = 0; i < item.align.length; i++) {
          if (/^ *-+: *$/.test(item.align[i])) {
            item.align[i] = 'right';
          } else if (/^ *:-+: *$/.test(item.align[i])) {
            item.align[i] = 'center';
          } else if (/^ *:-+ *$/.test(item.align[i])) {
            item.align[i] = 'left';
          } else {
            item.align[i] = null;
          }
        }

        for (i = 0; i < item.cells.length; i++) {
          item.cells[i] = item.cells[i].split(/ *\| */);
        }

        this.tokens.push(item);

        continue;
      }

      // hr
      if (cap = this.rules.hr.exec(src)) {
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: 'hr'
        });
        continue;
      }

      // blockquote
      if (cap = this.rules.blockquote.exec(src)) {
        src = src.substring(cap[0].length);

        this.tokens.push({
          type: 'blockquote_start'
        });

        cap = cap[0].replace(/^ *> ?/gm, '');

        // Pass `top` to keep the current
        // "toplevel" state. This is exactly
        // how markdown.pl works.
        this.token(cap, top);

        this.tokens.push({
          type: 'blockquote_end'
        });

        continue;
      }

      // list
      if (cap = this.rules.list.exec(src)) {
        src = src.substring(cap[0].length);
        bull = cap[2];
        isordered = bull.length > 1;

        this.tokens.push({
          type: 'list_start',
          ordered: isordered,
          start: isordered ? +bull : ''
        });

        // Get each top-level item.
        cap = cap[0].match(this.rules.item);

        next = false;
        l = cap.length;
        i = 0;

        for (; i < l; i++) {
          item = cap[i];

          // Remove the list item's bullet
          // so it is seen as the next token.
          space = item.length;
          item = item.replace(/^ *([*+-]|\d+\.) +/, '');

          // Outdent whatever the
          // list item contains. Hacky.
          if (~item.indexOf('\n ')) {
            space -= item.length;
            item = !this.options.pedantic ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '') : item.replace(/^ {1,4}/gm, '');
          }

          // Determine whether the next list item belongs here.
          // Backpedal if it does not belong in this list.
          if (this.options.smartLists && i !== l - 1) {
            b = block.bullet.exec(cap[i + 1])[0];
            if (bull !== b && !(bull.length > 1 && b.length > 1)) {
              src = cap.slice(i + 1).join('\n') + src;
              i = l - 1;
            }
          }

          // Determine whether item is loose or not.
          // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
          // for discount behavior.
          loose = next || /\n\n(?!\s*$)/.test(item);
          if (i !== l - 1) {
            next = item.charAt(item.length - 1) === '\n';
            if (!loose) loose = next;
          }

          this.tokens.push({
            type: loose ? 'loose_item_start' : 'list_item_start'
          });

          // Recurse.
          this.token(item, false);

          this.tokens.push({
            type: 'list_item_end'
          });
        }

        this.tokens.push({
          type: 'list_end'
        });

        continue;
      }

      // html
      if (cap = this.rules.html.exec(src)) {
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: this.options.sanitize ? 'paragraph' : 'html',
          pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
          text: cap[0]
        });
        continue;
      }

      // def
      if (top && (cap = this.rules.def.exec(src))) {
        src = src.substring(cap[0].length);
        if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
        tag = cap[1].toLowerCase();
        if (!this.tokens.links[tag]) {
          this.tokens.links[tag] = {
            href: cap[2],
            title: cap[3]
          };
        }
        continue;
      }

      // table (gfm)
      if (top && (cap = this.rules.table.exec(src))) {
        src = src.substring(cap[0].length);

        item = {
          type: 'table',
          header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
          cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
        };

        for (i = 0; i < item.align.length; i++) {
          if (/^ *-+: *$/.test(item.align[i])) {
            item.align[i] = 'right';
          } else if (/^ *:-+: *$/.test(item.align[i])) {
            item.align[i] = 'center';
          } else if (/^ *:-+ *$/.test(item.align[i])) {
            item.align[i] = 'left';
          } else {
            item.align[i] = null;
          }
        }

        for (i = 0; i < item.cells.length; i++) {
          item.cells[i] = item.cells[i].replace(/^ *\| *| *\| *$/g, '').split(/ *\| */);
        }

        this.tokens.push(item);

        continue;
      }

      // lheading
      if (cap = this.rules.lheading.exec(src)) {
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: 'heading',
          depth: cap[2] === '=' ? 1 : 2,
          text: cap[1]
        });
        continue;
      }

      // top-level paragraph
      if (top && (cap = this.rules.paragraph.exec(src))) {
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: 'paragraph',
          text: cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1]
        });
        continue;
      }

      // text
      if (cap = this.rules.text.exec(src)) {
        // Top-level should never reach here.
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: 'text',
          text: cap[0]
        });
        continue;
      }

      if (src) {
        throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
      }
    }

    return this.tokens;
  };

  /**
   * Inline-Level Grammar
   */

  var inline = {
    escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
    url: noop,
    tag: /^<!--[\s\S]*?-->|^<\/?[a-zA-Z0-9\-]+(?:"[^"]*"|'[^']*'|\s[^<'">\/\s]*)*?\/?>/,
    link: /^!?\[(inside)\]\(href\)/,
    reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
    nolink: /^!?\[((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\]/,
    strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
    em: /^_([^\s_](?:[^_]|__)+?[^\s_])_\b|^\*((?:\*\*|[^*])+?)\*(?!\*)/,
    code: /^(`+)\s*([\s\S]*?[^`]?)\s*\1(?!`)/,
    br: /^ {2,}\n(?!\s*$)/,
    del: noop,
    text: /^[\s\S]+?(?=[\\<!\[`*]|\b_| {2,}\n|$)/
  };

  inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
  inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;

  inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();

  inline._inside = /(?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]]|\](?=[^\[]*\]))*/;
  inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;

  inline.link = edit(inline.link).replace('inside', inline._inside).replace('href', inline._href).getRegex();

  inline.reflink = edit(inline.reflink).replace('inside', inline._inside).getRegex();

  /**
   * Normal Inline Grammar
   */

  inline.normal = merge({}, inline);

  /**
   * Pedantic Inline Grammar
   */

  inline.pedantic = merge({}, inline.normal, {
    strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
  });

  /**
   * GFM Inline Grammar
   */

  inline.gfm = merge({}, inline.normal, {
    escape: edit(inline.escape).replace('])', '~|])').getRegex(),
    url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace('email', inline._email).getRegex(),
    _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
    del: /^~~(?=\S)([\s\S]*?\S)~~/,
    text: edit(inline.text).replace(']|', '~]|').replace('|', '|https?://|ftp://|www\\.|[a-zA-Z0-9.!#$%&\'*+/=?^_`{\\|}~-]+@|').getRegex()
  });

  /**
   * GFM + Line Breaks Inline Grammar
   */

  inline.breaks = merge({}, inline.gfm, {
    br: edit(inline.br).replace('{2,}', '*').getRegex(),
    text: edit(inline.gfm.text).replace('{2,}', '*').getRegex()
  });

  /**
   * Inline Lexer & Compiler
   */

  function InlineLexer(links, options) {
    this.options = options || marked.defaults;
    this.links = links;
    this.rules = inline.normal;
    this.renderer = this.options.renderer || new Renderer();
    this.renderer.options = this.options;

    if (!this.links) {
      throw new Error('Tokens array requires a `links` property.');
    }

    if (this.options.gfm) {
      if (this.options.breaks) {
        this.rules = inline.breaks;
      } else {
        this.rules = inline.gfm;
      }
    } else if (this.options.pedantic) {
      this.rules = inline.pedantic;
    }
  }

  /**
   * Expose Inline Rules
   */

  InlineLexer.rules = inline;

  /**
   * Static Lexing/Compiling Method
   */

  InlineLexer.output = function (src, links, options) {
    var inline = new InlineLexer(links, options);
    return inline.output(src);
  };

  /**
   * Lexing/Compiling
   */

  InlineLexer.prototype.output = function (src) {
    var out = '',
        link,
        text,
        href,
        cap;

    while (src) {
      // escape
      if (cap = this.rules.escape.exec(src)) {
        src = src.substring(cap[0].length);
        out += cap[1];
        continue;
      }

      // autolink
      if (cap = this.rules.autolink.exec(src)) {
        src = src.substring(cap[0].length);
        if (cap[2] === '@') {
          text = escape(this.mangle(cap[1]));
          href = 'mailto:' + text;
        } else {
          text = escape(cap[1]);
          href = text;
        }
        out += this.renderer.link(href, null, text);
        continue;
      }

      // url (gfm)
      if (!this.inLink && (cap = this.rules.url.exec(src))) {
        cap[0] = this.rules._backpedal.exec(cap[0])[0];
        src = src.substring(cap[0].length);
        if (cap[2] === '@') {
          text = escape(cap[0]);
          href = 'mailto:' + text;
        } else {
          text = escape(cap[0]);
          if (cap[1] === 'www.') {
            href = 'http://' + text;
          } else {
            href = text;
          }
        }
        out += this.renderer.link(href, null, text);
        continue;
      }

      // tag
      if (cap = this.rules.tag.exec(src)) {
        if (!this.inLink && /^<a /i.test(cap[0])) {
          this.inLink = true;
        } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
          this.inLink = false;
        }
        src = src.substring(cap[0].length);
        out += this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
        continue;
      }

      // link
      if (cap = this.rules.link.exec(src)) {
        src = src.substring(cap[0].length);
        this.inLink = true;
        out += this.outputLink(cap, {
          href: cap[2],
          title: cap[3]
        });
        this.inLink = false;
        continue;
      }

      // reflink, nolink
      if ((cap = this.rules.reflink.exec(src)) || (cap = this.rules.nolink.exec(src))) {
        src = src.substring(cap[0].length);
        link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
        link = this.links[link.toLowerCase()];
        if (!link || !link.href) {
          out += cap[0].charAt(0);
          src = cap[0].substring(1) + src;
          continue;
        }
        this.inLink = true;
        out += this.outputLink(cap, link);
        this.inLink = false;
        continue;
      }

      // strong
      if (cap = this.rules.strong.exec(src)) {
        src = src.substring(cap[0].length);
        out += this.renderer.strong(this.output(cap[2] || cap[1]));
        continue;
      }

      // em
      if (cap = this.rules.em.exec(src)) {
        src = src.substring(cap[0].length);
        out += this.renderer.em(this.output(cap[2] || cap[1]));
        continue;
      }

      // code
      if (cap = this.rules.code.exec(src)) {
        src = src.substring(cap[0].length);
        out += this.renderer.codespan(escape(cap[2].trim(), true));
        continue;
      }

      // br
      if (cap = this.rules.br.exec(src)) {
        src = src.substring(cap[0].length);
        out += this.renderer.br();
        continue;
      }

      // del (gfm)
      if (cap = this.rules.del.exec(src)) {
        src = src.substring(cap[0].length);
        out += this.renderer.del(this.output(cap[1]));
        continue;
      }

      // text
      if (cap = this.rules.text.exec(src)) {
        src = src.substring(cap[0].length);
        out += this.renderer.text(escape(this.smartypants(cap[0])));
        continue;
      }

      if (src) {
        throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
      }
    }

    return out;
  };

  /**
   * Compile Link
   */

  InlineLexer.prototype.outputLink = function (cap, link) {
    var href = escape(link.href),
        title = link.title ? escape(link.title) : null;

    return cap[0].charAt(0) !== '!' ? this.renderer.link(href, title, this.output(cap[1])) : this.renderer.image(href, title, escape(cap[1]));
  };

  /**
   * Smartypants Transformations
   */

  InlineLexer.prototype.smartypants = function (text) {
    if (!this.options.smartypants) return text;
    return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201C')
    // closing doubles
    .replace(/"/g, '\u201D')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
  };

  /**
   * Mangle Links
   */

  InlineLexer.prototype.mangle = function (text) {
    if (!this.options.mangle) return text;
    var out = '',
        l = text.length,
        i = 0,
        ch;

    for (; i < l; i++) {
      ch = text.charCodeAt(i);
      if (Math.random() > 0.5) {
        ch = 'x' + ch.toString(16);
      }
      out += '&#' + ch + ';';
    }

    return out;
  };

  /**
   * Renderer
   */

  function Renderer(options) {
    this.options = options || {};
  }

  Renderer.prototype.code = function (code, lang, escaped) {
    if (this.options.highlight) {
      var out = this.options.highlight(code, lang);
      if (out != null && out !== code) {
        escaped = true;
        code = out;
      }
    }

    if (!lang) {
      return '<pre><code>' + (escaped ? code : escape(code, true)) + '\n</code></pre>';
    }

    return '<pre><code class="' + this.options.langPrefix + escape(lang, true) + '">' + (escaped ? code : escape(code, true)) + '\n</code></pre>\n';
  };

  Renderer.prototype.blockquote = function (quote) {
    return '<blockquote>\n' + quote + '</blockquote>\n';
  };

  Renderer.prototype.html = function (html) {
    return html;
  };

  Renderer.prototype.heading = function (text, level, raw) {
    return '<h' + level + ' id="' + this.options.headerPrefix + raw.toLowerCase().replace(/[^\w]+/g, '-') + '">' + text + '</h' + level + '>\n';
  };

  Renderer.prototype.hr = function () {
    return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
  };

  Renderer.prototype.list = function (body, ordered, start) {
    var type = ordered ? 'ol' : 'ul',
        startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
    return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
  };

  Renderer.prototype.listitem = function (text) {
    return '<li>' + text + '</li>\n';
  };

  Renderer.prototype.paragraph = function (text) {
    return '<p>' + text + '</p>\n';
  };

  Renderer.prototype.table = function (header, body) {
    return '<table>\n' + '<thead>\n' + header + '</thead>\n' + '<tbody>\n' + body + '</tbody>\n' + '</table>\n';
  };

  Renderer.prototype.tablerow = function (content) {
    return '<tr>\n' + content + '</tr>\n';
  };

  Renderer.prototype.tablecell = function (content, flags) {
    var type = flags.header ? 'th' : 'td';
    var tag = flags.align ? '<' + type + ' style="text-align:' + flags.align + '">' : '<' + type + '>';
    return tag + content + '</' + type + '>\n';
  };

  // span level renderer
  Renderer.prototype.strong = function (text) {
    return '<strong>' + text + '</strong>';
  };

  Renderer.prototype.em = function (text) {
    return '<em>' + text + '</em>';
  };

  Renderer.prototype.codespan = function (text) {
    return '<code>' + text + '</code>';
  };

  Renderer.prototype.br = function () {
    return this.options.xhtml ? '<br/>' : '<br>';
  };

  Renderer.prototype.del = function (text) {
    return '<del>' + text + '</del>';
  };

  Renderer.prototype.link = function (href, title, text) {
    if (this.options.sanitize) {
      try {
        var prot = decodeURIComponent(unescape(href)).replace(/[^\w:]/g, '').toLowerCase();
      } catch (e) {
        return text;
      }
      if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
        return text;
      }
    }
    if (this.options.baseUrl && !originIndependentUrl.test(href)) {
      href = resolveUrl(this.options.baseUrl, href);
    }
    var out = '<a href="' + href + '"';
    if (title) {
      out += ' title="' + title + '"';
    }
    out += '>' + text + '</a>';
    return out;
  };

  Renderer.prototype.image = function (href, title, text) {
    if (this.options.baseUrl && !originIndependentUrl.test(href)) {
      href = resolveUrl(this.options.baseUrl, href);
    }
    var out = '<img src="' + href + '" alt="' + text + '"';
    if (title) {
      out += ' title="' + title + '"';
    }
    out += this.options.xhtml ? '/>' : '>';
    return out;
  };

  Renderer.prototype.text = function (text) {
    return text;
  };

  /**
   * TextRenderer
   * returns only the textual part of the token
   */

  function TextRenderer() {}

  // no need for block level renderers

  TextRenderer.prototype.strong = TextRenderer.prototype.em = TextRenderer.prototype.codespan = TextRenderer.prototype.del = TextRenderer.prototype.text = function (text) {
    return text;
  };

  TextRenderer.prototype.link = TextRenderer.prototype.image = function (href, title, text) {
    return '' + text;
  };

  TextRenderer.prototype.br = function () {
    return '';
  };

  /**
   * Parsing & Compiling
   */

  function Parser(options) {
    this.tokens = [];
    this.token = null;
    this.options = options || marked.defaults;
    this.options.renderer = this.options.renderer || new Renderer();
    this.renderer = this.options.renderer;
    this.renderer.options = this.options;
  }

  /**
   * Static Parse Method
   */

  Parser.parse = function (src, options) {
    var parser = new Parser(options);
    return parser.parse(src);
  };

  /**
   * Parse Loop
   */

  Parser.prototype.parse = function (src) {
    this.inline = new InlineLexer(src.links, this.options);
    // use an InlineLexer with a TextRenderer to extract pure text
    this.inlineText = new InlineLexer(src.links, merge({}, this.options, { renderer: new TextRenderer() }));
    this.tokens = src.reverse();

    var out = '';
    while (this.next()) {
      out += this.tok();
    }

    return out;
  };

  /**
   * Next Token
   */

  Parser.prototype.next = function () {
    return this.token = this.tokens.pop();
  };

  /**
   * Preview Next Token
   */

  Parser.prototype.peek = function () {
    return this.tokens[this.tokens.length - 1] || 0;
  };

  /**
   * Parse Text Tokens
   */

  Parser.prototype.parseText = function () {
    var body = this.token.text;

    while (this.peek().type === 'text') {
      body += '\n' + this.next().text;
    }

    return this.inline.output(body);
  };

  /**
   * Parse Current Token
   */

  Parser.prototype.tok = function () {
    switch (this.token.type) {
      case 'space':
        {
          return '';
        }
      case 'hr':
        {
          return this.renderer.hr();
        }
      case 'heading':
        {
          return this.renderer.heading(this.inline.output(this.token.text), this.token.depth, unescape(this.inlineText.output(this.token.text)));
        }
      case 'code':
        {
          return this.renderer.code(this.token.text, this.token.lang, this.token.escaped);
        }
      case 'table':
        {
          var header = '',
              body = '',
              i,
              row,
              cell,
              j;

          // header
          cell = '';
          for (i = 0; i < this.token.header.length; i++) {
            cell += this.renderer.tablecell(this.inline.output(this.token.header[i]), { header: true, align: this.token.align[i] });
          }
          header += this.renderer.tablerow(cell);

          for (i = 0; i < this.token.cells.length; i++) {
            row = this.token.cells[i];

            cell = '';
            for (j = 0; j < row.length; j++) {
              cell += this.renderer.tablecell(this.inline.output(row[j]), { header: false, align: this.token.align[j] });
            }

            body += this.renderer.tablerow(cell);
          }
          return this.renderer.table(header, body);
        }
      case 'blockquote_start':
        {
          body = '';

          while (this.next().type !== 'blockquote_end') {
            body += this.tok();
          }

          return this.renderer.blockquote(body);
        }
      case 'list_start':
        {
          body = '';
          var ordered = this.token.ordered,
              start = this.token.start;

          while (this.next().type !== 'list_end') {
            body += this.tok();
          }

          return this.renderer.list(body, ordered, start);
        }
      case 'list_item_start':
        {
          body = '';

          while (this.next().type !== 'list_item_end') {
            body += this.token.type === 'text' ? this.parseText() : this.tok();
          }

          return this.renderer.listitem(body);
        }
      case 'loose_item_start':
        {
          body = '';

          while (this.next().type !== 'list_item_end') {
            body += this.tok();
          }

          return this.renderer.listitem(body);
        }
      case 'html':
        {
          var html = !this.token.pre && !this.options.pedantic ? this.inline.output(this.token.text) : this.token.text;
          return this.renderer.html(html);
        }
      case 'paragraph':
        {
          return this.renderer.paragraph(this.inline.output(this.token.text));
        }
      case 'text':
        {
          return this.renderer.paragraph(this.parseText());
        }
    }
  };

  /**
   * Helpers
   */

  function escape(html, encode) {
    return html.replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function unescape(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function (_, n) {
      n = n.toLowerCase();
      if (n === 'colon') return ':';
      if (n.charAt(0) === '#') {
        return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
      }
      return '';
    });
  }

  function edit(regex, opt) {
    regex = regex.source;
    opt = opt || '';
    return {
      replace: function replace(name, val) {
        val = val.source || val;
        val = val.replace(/(^|[^\[])\^/g, '$1');
        regex = regex.replace(name, val);
        return this;
      },
      getRegex: function getRegex() {
        return new RegExp(regex, opt);
      }
    };
  }

  function resolveUrl(base, href) {
    if (!baseUrls[' ' + base]) {
      // we can ignore everything in base after the last slash of its path component,
      // but we might need to add _that_
      // https://tools.ietf.org/html/rfc3986#section-3
      if (/^[^:]+:\/*[^/]*$/.test(base)) {
        baseUrls[' ' + base] = base + '/';
      } else {
        baseUrls[' ' + base] = base.replace(/[^/]*$/, '');
      }
    }
    base = baseUrls[' ' + base];

    if (href.slice(0, 2) === '//') {
      return base.replace(/:[\s\S]*/, ':') + href;
    } else if (href.charAt(0) === '/') {
      return base.replace(/(:\/*[^/]*)[\s\S]*/, '$1') + href;
    } else {
      return base + href;
    }
  }
  var baseUrls = {};
  var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

  function noop() {}
  noop.exec = noop;

  function merge(obj) {
    var i = 1,
        target,
        key;

    for (; i < arguments.length; i++) {
      target = arguments[i];
      for (key in target) {
        if (Object.prototype.hasOwnProperty.call(target, key)) {
          obj[key] = target[key];
        }
      }
    }

    return obj;
  }

  /**
   * Marked
   */

  function marked(src, opt, callback) {
    // throw error in case of non string input
    if (typeof src === 'undefined' || src === null) {
      throw new Error('marked(): input parameter is undefined or null');
    }
    if (typeof src !== 'string') {
      throw new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected');
    }

    if (callback || typeof opt === 'function') {
      if (!callback) {
        callback = opt;
        opt = null;
      }

      opt = merge({}, marked.defaults, opt || {});

      var highlight = opt.highlight,
          tokens,
          pending,
          i = 0;

      try {
        tokens = Lexer.lex(src, opt);
      } catch (e) {
        return callback(e);
      }

      pending = tokens.length;

      var done = function done(err) {
        if (err) {
          opt.highlight = highlight;
          return callback(err);
        }

        var out;

        try {
          out = Parser.parse(tokens, opt);
        } catch (e) {
          err = e;
        }

        opt.highlight = highlight;

        return err ? callback(err) : callback(null, out);
      };

      if (!highlight || highlight.length < 3) {
        return done();
      }

      delete opt.highlight;

      if (!pending) return done();

      for (; i < tokens.length; i++) {
        (function (token) {
          if (token.type !== 'code') {
            return --pending || done();
          }
          return highlight(token.text, token.lang, function (err, code) {
            if (err) return done(err);
            if (code == null || code === token.text) {
              return --pending || done();
            }
            token.text = code;
            token.escaped = true;
            --pending || done();
          });
        })(tokens[i]);
      }

      return;
    }
    try {
      if (opt) opt = merge({}, marked.defaults, opt);
      return Parser.parse(Lexer.lex(src, opt), opt);
    } catch (e) {
      e.message += '\nPlease report this to https://github.com/markedjs/marked.';
      if ((opt || marked.defaults).silent) {
        return '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
      }
      throw e;
    }
  }

  /**
   * Options
   */

  marked.options = marked.setOptions = function (opt) {
    merge(marked.defaults, opt);
    return marked;
  };

  marked.defaults = {
    gfm: true,
    tables: true,
    breaks: false,
    pedantic: false,
    sanitize: false,
    sanitizer: null,
    mangle: true,
    smartLists: false,
    silent: false,
    highlight: null,
    langPrefix: 'lang-',
    smartypants: false,
    headerPrefix: '',
    renderer: new Renderer(),
    xhtml: false,
    baseUrl: null
  };

  /**
   * Expose
   */

  marked.Parser = Parser;
  marked.parser = Parser.parse;

  marked.Renderer = Renderer;
  marked.TextRenderer = TextRenderer;

  marked.Lexer = Lexer;
  marked.lexer = Lexer.lex;

  marked.InlineLexer = InlineLexer;
  marked.inlineLexer = InlineLexer.output;

  marked.parse = marked;

  if (typeof module !== 'undefined' && ( false ? 'undefined' : _typeof(exports)) === 'object') {
    module.exports = marked;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return marked;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    root.marked = marked;
  }
})(undefined || (typeof window !== 'undefined' ? window : global));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(842);
module.exports = 'smart-table';

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** 
* @version 2.1.10
* @license MIT
*/
(function (ng, undefined) {
  'use strict';

  ng.module('smart-table', []).run(['$templateCache', function ($templateCache) {
    $templateCache.put('template/smart-table/pagination.html', '<nav ng-if="numPages && pages.length >= 2"><ul class="pagination">' + '<li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="#" ng-click="selectPage(page); $event.preventDefault(); $event.stopPropagation();">{{page}}</a></li>' + '</ul></nav>');
  }]);

  ng.module('smart-table').constant('stConfig', {
    pagination: {
      template: 'template/smart-table/pagination.html',
      itemsByPage: 10,
      displayedPages: 5
    },
    search: {
      delay: 400, // ms
      inputEvent: 'input',
      trimSearch: false
    },
    select: {
      mode: 'single',
      selectedClass: 'st-selected'
    },
    sort: {
      ascentClass: 'st-sort-ascent',
      descentClass: 'st-sort-descent',
      descendingFirst: false,
      skipNatural: false,
      delay: 300
    },
    pipe: {
      delay: 100 //ms
    }
  });
  ng.module('smart-table').controller('stTableController', ['$scope', '$parse', '$filter', '$attrs', function StTableController($scope, $parse, $filter, $attrs) {
    var propertyName = $attrs.stTable;
    var displayGetter = $parse(propertyName);
    var displaySetter = displayGetter.assign;
    var safeGetter;
    var orderBy = $filter('orderBy');
    var filter = $filter('filter');
    var safeCopy = copyRefs(displayGetter($scope));
    var tableState = {
      sort: {},
      search: {},
      pagination: { start: 0, totalItemCount: 0 }
    };
    var filtered;
    var pipeAfterSafeCopy = true;
    var ctrl = this;
    var lastSelected;

    function copyRefs(src) {
      return src ? [].concat(src) : [];
    }

    function updateSafeCopy() {
      safeCopy = copyRefs(safeGetter($scope));
      if (pipeAfterSafeCopy === true) {
        ctrl.pipe();
      }
    }

    function deepDelete(object, path) {
      if (path.indexOf('.') != -1) {
        var partials = path.split('.');
        var key = partials.pop();
        var parentPath = partials.join('.');
        var parentObject = $parse(parentPath)(object);
        delete parentObject[key];
        if (Object.keys(parentObject).length == 0) {
          deepDelete(object, parentPath);
        }
      } else {
        delete object[path];
      }
    }

    if ($attrs.stSafeSrc) {
      safeGetter = $parse($attrs.stSafeSrc);
      $scope.$watch(function () {
        var safeSrc = safeGetter($scope);
        return safeSrc && safeSrc.length ? safeSrc[0] : undefined;
      }, function (newValue, oldValue) {
        if (newValue !== oldValue) {
          updateSafeCopy();
        }
      });
      $scope.$watch(function () {
        var safeSrc = safeGetter($scope);
        return safeSrc ? safeSrc.length : 0;
      }, function (newValue, oldValue) {
        if (newValue !== safeCopy.length) {
          updateSafeCopy();
        }
      });
      $scope.$watch(function () {
        return safeGetter($scope);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue) {
          tableState.pagination.start = 0;
          updateSafeCopy();
        }
      });
    }

    /**
     * sort the rows
     * @param {Function | String} predicate - function or string which will be used as predicate for the sorting
     * @param [reverse] - if you want to reverse the order
     */
    this.sortBy = function sortBy(predicate, reverse) {
      tableState.sort.predicate = predicate;
      tableState.sort.reverse = reverse === true;

      if (ng.isFunction(predicate)) {
        tableState.sort.functionName = predicate.name;
      } else {
        delete tableState.sort.functionName;
      }

      tableState.pagination.start = 0;
      return this.pipe();
    };

    /**
     * search matching rows
     * @param {String} input - the input string
     * @param {String} [predicate] - the property name against you want to check the match, otherwise it will search on all properties
     * @param {String | Function } [comparator] - a comparator to pass to the filter for the (pass true for stric mode)
     */
    this.search = function search(input, predicate, comparator) {
      var predicateObject = tableState.search.predicateObject || {};
      var prop = predicate ? predicate : '$';

      $parse(prop).assign(predicateObject, input);
      // to avoid to filter out null value
      if (!input) {
        deepDelete(predicateObject, prop);
      }
      tableState.search.predicateObject = predicateObject;
      tableState.pagination.start = 0;
      return this.pipe();
    };

    /**
     * this will chain the operations of sorting and filtering based on the current table state (sort options, filtering, ect)
     */
    this.pipe = function pipe() {
      var pagination = tableState.pagination;
      var output;
      filtered = tableState.search.predicateObject ? filter(safeCopy, tableState.search.predicateObject) : safeCopy;
      if (tableState.sort.predicate) {
        filtered = orderBy(filtered, tableState.sort.predicate, tableState.sort.reverse);
      }
      pagination.totalItemCount = filtered.length;
      if (pagination.number !== undefined) {
        pagination.numberOfPages = filtered.length > 0 ? Math.ceil(filtered.length / pagination.number) : 1;
        pagination.start = pagination.start >= filtered.length ? (pagination.numberOfPages - 1) * pagination.number : pagination.start;
        output = filtered.slice(pagination.start, pagination.start + parseInt(pagination.number));
      }
      displaySetter($scope, output || filtered);
    };

    /**
     * select a dataRow (it will add the attribute isSelected to the row object)
     * @param {Object} row - the row to select
     * @param {String} [mode] - "single" or "multiple" (multiple by default)
     */
    this.select = function select(row, mode) {
      var rows = copyRefs(displayGetter($scope));
      var index = rows.indexOf(row);
      if (index !== -1) {
        if (mode === 'single') {
          row.isSelected = row.isSelected !== true;
          if (lastSelected) {
            lastSelected.isSelected = false;
          }
          lastSelected = row.isSelected === true ? row : undefined;
        } else {
          rows[index].isSelected = !rows[index].isSelected;
        }
      }
    };

    /**
     * take a slice of the current sorted/filtered collection (pagination)
     *
     * @param {Number} start - start index of the slice
     * @param {Number} number - the number of item in the slice
     */
    this.slice = function splice(start, number) {
      tableState.pagination.start = start;
      tableState.pagination.number = number;
      return this.pipe();
    };

    /**
     * return the current state of the table
     * @returns {{sort: {}, search: {}, pagination: {start: number}}}
     */
    this.tableState = function getTableState() {
      return tableState;
    };

    this.getFilteredCollection = function getFilteredCollection() {
      return filtered || safeCopy;
    };

    /**
     * Use a different filter function than the angular FilterFilter
     * @param filterName the name under which the custom filter is registered
     */
    this.setFilterFunction = function setFilterFunction(filterName) {
      filter = $filter(filterName);
    };

    /**
     * Use a different function than the angular orderBy
     * @param sortFunctionName the name under which the custom order function is registered
     */
    this.setSortFunction = function setSortFunction(sortFunctionName) {
      orderBy = $filter(sortFunctionName);
    };

    /**
     * Usually when the safe copy is updated the pipe function is called.
     * Calling this method will prevent it, which is something required when using a custom pipe function
     */
    this.preventPipeOnWatch = function preventPipe() {
      pipeAfterSafeCopy = false;
    };
  }]).directive('stTable', function () {
    return {
      restrict: 'A',
      controller: 'stTableController',
      link: function link(scope, element, attr, ctrl) {
        if (attr.stSetFilter) {
          ctrl.setFilterFunction(attr.stSetFilter);
        }

        if (attr.stSetSort) {
          ctrl.setSortFunction(attr.stSetSort);
        }
      }
    };
  });

  ng.module('smart-table').directive('stSearch', ['stConfig', '$timeout', '$parse', function (stConfig, $timeout, $parse) {
    return {
      require: '^stTable',
      link: function link(scope, element, attr, ctrl) {
        var tableCtrl = ctrl;
        var promise = null;
        var throttle = attr.stDelay || stConfig.search.delay;
        var event = attr.stInputEvent || stConfig.search.inputEvent;
        var trimSearch = attr.trimSearch || stConfig.search.trimSearch;

        attr.$observe('stSearch', function (newValue, oldValue) {
          var input = element[0].value;
          if (newValue !== oldValue && input) {
            ctrl.tableState().search = {};
            input = ng.isString(input) && trimSearch ? input.trim() : input;
            tableCtrl.search(input, newValue);
          }
        });

        //table state -> view
        scope.$watch(function () {
          return ctrl.tableState().search;
        }, function (newValue, oldValue) {
          var predicateExpression = attr.stSearch || '$';
          if (newValue.predicateObject && $parse(predicateExpression)(newValue.predicateObject) !== element[0].value) {
            element[0].value = $parse(predicateExpression)(newValue.predicateObject) || '';
          }
        }, true);

        // view -> table state
        element.bind(event, function (evt) {
          evt = evt.originalEvent || evt;
          if (promise !== null) {
            $timeout.cancel(promise);
          }

          promise = $timeout(function () {
            var input = evt.target.value;
            input = ng.isString(input) && trimSearch ? input.trim() : input;
            tableCtrl.search(input, attr.stSearch || '');
            promise = null;
          }, throttle);
        });
      }
    };
  }]);

  ng.module('smart-table').directive('stSelectRow', ['stConfig', function (stConfig) {
    return {
      restrict: 'A',
      require: '^stTable',
      scope: {
        row: '=stSelectRow'
      },
      link: function link(scope, element, attr, ctrl) {
        var mode = attr.stSelectMode || stConfig.select.mode;
        element.bind('click', function () {
          scope.$apply(function () {
            ctrl.select(scope.row, mode);
          });
        });

        scope.$watch('row.isSelected', function (newValue) {
          if (newValue === true) {
            element.addClass(stConfig.select.selectedClass);
          } else {
            element.removeClass(stConfig.select.selectedClass);
          }
        });
      }
    };
  }]);

  ng.module('smart-table').directive('stSort', ['stConfig', '$parse', '$timeout', function (stConfig, $parse, $timeout) {
    return {
      restrict: 'A',
      require: '^stTable',
      link: function link(scope, element, attr, ctrl) {

        var predicate = attr.stSort;
        var getter = $parse(predicate);
        var index = 0;
        var classAscent = attr.stClassAscent || stConfig.sort.ascentClass;
        var classDescent = attr.stClassDescent || stConfig.sort.descentClass;
        var stateClasses = [classAscent, classDescent];
        var sortDefault;
        var skipNatural = attr.stSkipNatural !== undefined ? attr.stSkipNatural : stConfig.sort.skipNatural;
        var descendingFirst = attr.stDescendingFirst !== undefined ? attr.stDescendingFirst : stConfig.sort.descendingFirst;
        var promise = null;
        var throttle = attr.stDelay || stConfig.sort.delay;

        // set aria attributes
        var ariaSort = 'aria-sort';
        var ariaSortNone = 'none';
        var ariaSortAscending = 'ascending';
        var ariaSortDescending = 'descending';
        element.attr('role', 'columnheader').attr(ariaSort, ariaSortNone);

        if (attr.stSortDefault) {
          sortDefault = scope.$eval(attr.stSortDefault) !== undefined ? scope.$eval(attr.stSortDefault) : attr.stSortDefault;
        }

        //view --> table state
        function sort() {
          if (descendingFirst) {
            index = index === 0 ? 2 : index - 1;
          } else {
            index++;
          }

          var func;
          predicate = ng.isFunction(getter(scope)) || ng.isArray(getter(scope)) ? getter(scope) : attr.stSort;
          if (index % 3 === 0 && !!skipNatural !== true) {
            //manual reset
            index = 0;
            ctrl.tableState().sort = {};
            ctrl.tableState().pagination.start = 0;
            func = ctrl.pipe.bind(ctrl);
          } else {
            func = ctrl.sortBy.bind(ctrl, predicate, index % 2 === 0);
          }
          if (promise !== null) {
            $timeout.cancel(promise);
          }
          if (throttle < 0) {
            func();
          } else {
            promise = $timeout(function () {
              func();
            }, throttle);
          }
        }

        element.bind('click', function sortClick() {
          if (predicate) {
            scope.$apply(sort);
          }
        });

        if (sortDefault) {
          index = sortDefault === 'reverse' ? 1 : 0;
          sort();
        }

        //table state --> view
        scope.$watch(function () {
          return ctrl.tableState().sort;
        }, function (newValue) {
          if (newValue.predicate !== predicate) {
            index = 0;
            element.removeClass(classAscent).removeClass(classDescent).attr(ariaSort, ariaSortNone);
          } else {
            index = newValue.reverse === true ? 2 : 1;
            element.removeClass(stateClasses[index % 2]).addClass(stateClasses[index - 1]).attr(ariaSort, newValue.reverse ? ariaSortAscending : ariaSortDescending);
          }
        }, true);
      }
    };
  }]);

  ng.module('smart-table').directive('stPagination', ['stConfig', function (stConfig) {
    return {
      restrict: 'EA',
      require: '^stTable',
      scope: {
        stItemsByPage: '=?',
        stDisplayedPages: '=?',
        stPageChange: '&'
      },
      templateUrl: function templateUrl(element, attrs) {
        if (attrs.stTemplate) {
          return attrs.stTemplate;
        }
        return stConfig.pagination.template;
      },
      link: function link(scope, element, attrs, ctrl) {

        scope.stItemsByPage = scope.stItemsByPage ? +scope.stItemsByPage : stConfig.pagination.itemsByPage;
        scope.stDisplayedPages = scope.stDisplayedPages ? +scope.stDisplayedPages : stConfig.pagination.displayedPages;

        scope.currentPage = 1;
        scope.pages = [];

        function redraw() {
          var paginationState = ctrl.tableState().pagination;
          var start = 1;
          var end;
          var i;
          var prevPage = scope.currentPage;
          scope.totalItemCount = paginationState.totalItemCount;
          scope.currentPage = Math.floor(paginationState.start / paginationState.number) + 1;

          start = Math.max(start, scope.currentPage - Math.abs(Math.floor(scope.stDisplayedPages / 2)));
          end = start + scope.stDisplayedPages;

          if (end > paginationState.numberOfPages) {
            end = paginationState.numberOfPages + 1;
            start = Math.max(1, end - scope.stDisplayedPages);
          }

          scope.pages = [];
          scope.numPages = paginationState.numberOfPages;

          for (i = start; i < end; i++) {
            scope.pages.push(i);
          }

          if (prevPage !== scope.currentPage) {
            scope.stPageChange({ newPage: scope.currentPage });
          }
        }

        //table state --> view
        scope.$watch(function () {
          return ctrl.tableState().pagination;
        }, redraw, true);

        //scope --> table state  (--> view)
        scope.$watch('stItemsByPage', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.selectPage(1);
          }
        });

        scope.$watch('stDisplayedPages', redraw);

        //view -> table state
        scope.selectPage = function (page) {
          if (page > 0 && page <= scope.numPages) {
            ctrl.slice((page - 1) * scope.stItemsByPage, scope.stItemsByPage);
          }
        };

        if (!ctrl.tableState().pagination.number) {
          ctrl.slice(0, scope.stItemsByPage);
        }
      }
    };
  }]);

  ng.module('smart-table').directive('stPipe', ['stConfig', '$timeout', function (config, $timeout) {
    return {
      require: 'stTable',
      scope: {
        stPipe: '='
      },
      link: {

        pre: function pre(scope, element, attrs, ctrl) {

          var pipePromise = null;

          if (ng.isFunction(scope.stPipe)) {
            ctrl.preventPipeOnWatch();
            ctrl.pipe = function () {

              if (pipePromise !== null) {
                $timeout.cancel(pipePromise);
              }

              pipePromise = $timeout(function () {
                scope.stPipe(ctrl.tableState(), ctrl);
              }, config.pipe.delay);

              return pipePromise;
            };
          }
        },

        post: function post(scope, element, attrs, ctrl) {
          ctrl.pipe();
        }
      }
    };
  }]);
})(angular);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * angular-translate - v2.18.4 - 2021-01-14
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return factory();
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
})(undefined, function () {

  /**
   * @ngdoc overview
   * @name pascalprecht.translate
   *
   * @description
   * The main module which holds everything together.
   */
  runTranslate.$inject = ['$translate'];
  $translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
  $translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
  translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
  translateAttrDirective.$inject = ['$translate', '$rootScope'];
  translateCloakDirective.$inject = ['$translate', '$rootScope'];
  translateFilterFactory.$inject = ['$parse', '$translate'];
  $translationCache.$inject = ['$cacheFactory'];
  angular.module('pascalprecht.translate', ['ng']).run(runTranslate);

  function runTranslate($translate) {

    'use strict';

    var key = $translate.storageKey(),
        storage = $translate.storage();

    var fallbackFromIncorrectStorageValue = function fallbackFromIncorrectStorageValue() {
      var preferred = $translate.preferredLanguage();
      if (angular.isString(preferred)) {
        $translate.use(preferred);
        // $translate.use() will also remember the language.
        // So, we don't need to call storage.put() here.
      } else {
        storage.put(key, $translate.use());
      }
    };

    fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';

    if (storage) {
      if (!storage.get(key)) {
        fallbackFromIncorrectStorageValue();
      } else {
        $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
      }
    } else if (angular.isString($translate.preferredLanguage())) {
      $translate.use($translate.preferredLanguage());
    }
  }

  runTranslate.displayName = 'runTranslate';

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   *
   * Configurations for $translateSanitization
   */
  angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);

  function $translateSanitizationProvider() {

    'use strict';

    var $sanitize,
        $sce,
        currentStrategy = null,
        // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
    hasConfiguredStrategy = false,
        hasShownNoStrategyConfiguredWarning = false,
        strategies;

    /**
     * Definition of a sanitization strategy function
     * @callback StrategyFunction
     * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
     * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
     * @return {string|object}
     */

    /**
     * @ngdoc property
     * @name strategies
     * @propertyOf pascalprecht.translate.$translateSanitizationProvider
     *
     * @description
     * Following strategies are built-in:
     * <dl>
     *   <dt>sanitize</dt>
     *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
     *   <dt>escape</dt>
     *   <dd>Escapes HTML in the translation</dd>
     *   <dt>sanitizeParameters</dt>
     *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
     *   <dt>escapeParameters</dt>
     *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
     *   <dt>escaped</dt>
     *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
     * </dl>
     *
     */

    strategies = {
      sanitize: function sanitize(value, mode /*, context*/) {
        if (mode === 'text') {
          value = htmlSanitizeValue(value);
        }
        return value;
      },
      escape: function escape(value, mode /*, context*/) {
        if (mode === 'text') {
          value = htmlEscapeValue(value);
        }
        return value;
      },
      sanitizeParameters: function sanitizeParameters(value, mode /*, context*/) {
        if (mode === 'params') {
          value = mapInterpolationParameters(value, htmlSanitizeValue);
        }
        return value;
      },
      escapeParameters: function escapeParameters(value, mode /*, context*/) {
        if (mode === 'params') {
          value = mapInterpolationParameters(value, htmlEscapeValue);
        }
        return value;
      },
      sce: function sce(value, mode, context) {
        if (mode === 'text') {
          value = htmlTrustValue(value);
        } else if (mode === 'params') {
          if (context !== 'filter') {
            // do html escape in filter context #1101
            value = mapInterpolationParameters(value, htmlEscapeValue);
          }
        }
        return value;
      },
      sceParameters: function sceParameters(value, mode /*, context*/) {
        if (mode === 'params') {
          value = mapInterpolationParameters(value, htmlTrustValue);
        }
        return value;
      }
    };
    // Support legacy strategy name 'escaped' for backwards compatibility.
    // TODO should be removed in 3.0
    strategies.escaped = strategies.escapeParameters;

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
     * @methodOf pascalprecht.translate.$translateSanitizationProvider
     *
     * @description
     * Adds a sanitization strategy to the list of known strategies.
     *
     * @param {string} strategyName - unique key for a strategy
     * @param {StrategyFunction} strategyFunction - strategy function
     * @returns {object} this
     */
    this.addStrategy = function (strategyName, strategyFunction) {
      strategies[strategyName] = strategyFunction;
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
     * @methodOf pascalprecht.translate.$translateSanitizationProvider
     *
     * @description
     * Removes a sanitization strategy from the list of known strategies.
     *
     * @param {string} strategyName - unique key for a strategy
     * @returns {object} this
     */
    this.removeStrategy = function (strategyName) {
      delete strategies[strategyName];
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
     * @methodOf pascalprecht.translate.$translateSanitizationProvider
     *
     * @description
     * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
     *
     * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
     * @returns {object} this
     */
    this.useStrategy = function (strategy) {
      hasConfiguredStrategy = true;
      currentStrategy = strategy;
      return this;
    };

    /**
     * @ngdoc object
     * @name pascalprecht.translate.$translateSanitization
     * @requires $injector
     * @requires $log
     *
     * @description
     * Sanitizes interpolation parameters and translated texts.
     *
     */
    this.$get = ['$injector', '$log', function ($injector, $log) {

      var cachedStrategyMap = {};

      var applyStrategies = function applyStrategies(value, mode, context, selectedStrategies) {
        angular.forEach(selectedStrategies, function (selectedStrategy) {
          if (angular.isFunction(selectedStrategy)) {
            value = selectedStrategy(value, mode, context);
          } else if (angular.isFunction(strategies[selectedStrategy])) {
            value = strategies[selectedStrategy](value, mode, context);
          } else if (angular.isString(strategies[selectedStrategy])) {
            if (!cachedStrategyMap[strategies[selectedStrategy]]) {
              try {
                cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
              } catch (e) {
                cachedStrategyMap[strategies[selectedStrategy]] = function () {};
                throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
              }
            }
            value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
          } else {
            throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
          }
        });
        return value;
      };

      // TODO: should be removed in 3.0
      var showNoStrategyConfiguredWarning = function showNoStrategyConfiguredWarning() {
        if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
          $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
          hasShownNoStrategyConfiguredWarning = true;
        }
      };

      if ($injector.has('$sanitize')) {
        $sanitize = $injector.get('$sanitize');
      }
      if ($injector.has('$sce')) {
        $sce = $injector.get('$sce');
      }

      return {
        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateSanitization#useStrategy
         * @methodOf pascalprecht.translate.$translateSanitization
         *
         * @description
         * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
         *
         * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
         */
        useStrategy: function (self) {
          return function (strategy) {
            self.useStrategy(strategy);
          };
        }(this),

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateSanitization#sanitize
         * @methodOf pascalprecht.translate.$translateSanitization
         *
         * @description
         * Sanitizes a value.
         *
         * @param {string|object} value The value which should be sanitized.
         * @param {string} mode The current sanitization mode, either 'params' or 'text'.
         * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
         * @param {string} [context] The context of this call: filter, service. Default is service
         * @returns {string|object} sanitized value
         */
        sanitize: function sanitize(value, mode, strategy, context) {
          if (!currentStrategy) {
            showNoStrategyConfiguredWarning();
          }

          if (!strategy && strategy !== null) {
            strategy = currentStrategy;
          }

          if (!strategy) {
            return value;
          }

          if (!context) {
            context = 'service';
          }

          var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
          return applyStrategies(value, mode, context, selectedStrategies);
        }
      };
    }];

    var htmlEscapeValue = function htmlEscapeValue(value) {
      var element = angular.element('<div></div>');
      element.text(value); // not chainable, see #1044
      return element.html();
    };

    var htmlSanitizeValue = function htmlSanitizeValue(value) {
      if (!$sanitize) {
        throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
      }
      return $sanitize(value);
    };

    var htmlTrustValue = function htmlTrustValue(value) {
      if (!$sce) {
        throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
      }
      return $sce.trustAsHtml(value);
    };

    var mapInterpolationParameters = function mapInterpolationParameters(value, iteratee, stack) {
      if (angular.isDate(value)) {
        return value;
      } else if (angular.isObject(value)) {
        var result = angular.isArray(value) ? [] : {};

        if (!stack) {
          stack = [];
        } else {
          if (stack.indexOf(value) > -1) {
            throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
          }
        }

        stack.push(value);
        angular.forEach(value, function (propertyValue, propertyKey) {

          /* Skipping function properties. */
          if (angular.isFunction(propertyValue)) {
            return;
          }

          result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
        });
        stack.splice(-1, 1); // remove last

        return result;
      } else if (angular.isNumber(value)) {
        return value;
      } else if (value === true || value === false) {
        return value;
      } else if (!angular.isUndefined(value) && value !== null) {
        return iteratee(value);
      } else {
        return value;
      }
    };
  }

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateProvider
   * @description
   *
   * $translateProvider allows developers to register translation-tables, asynchronous loaders
   * and similar to configure translation behavior directly inside of a module.
   *
   */
  angular.module('pascalprecht.translate').constant('pascalprechtTranslateOverrider', {}).provider('$translate', $translate);

  function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {

    'use strict';

    var $translationTable = {},
        $preferredLanguage,
        $availableLanguageKeys = [],
        $languageKeyAliases,
        $fallbackLanguage,
        $fallbackWasString,
        $uses,
        $nextLang,
        $storageFactory,
        $storageKey = $STORAGE_KEY,
        $storagePrefix,
        $missingTranslationHandlerFactory,
        $interpolationFactory,
        $interpolatorFactories = [],
        $loaderFactory,
        $cloakClassName = 'translate-cloak',
        $loaderOptions,
        $notFoundIndicatorLeft,
        $notFoundIndicatorRight,
        $postCompilingEnabled = false,
        $forceAsyncReloadEnabled = false,
        $nestedObjectDelimeter = '.',
        $isReady = false,
        $keepContent = false,
        loaderCache,
        directivePriority = 0,
        statefulFilter = true,
        postProcessFn,
        uniformLanguageTagResolver = 'default',
        languageTagResolver = {
      'default': function _default(tag) {
        return (tag || '').split('-').join('_');
      },
      java: function java(tag) {
        var temp = (tag || '').split('-').join('_');
        var parts = temp.split('_');
        return parts.length > 1 ? parts[0].toLowerCase() + '_' + parts[1].toUpperCase() : temp;
      },
      bcp47: function bcp47(tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');

        switch (parts.length) {
          case 1:
            // language only
            parts[0] = parts[0].toLowerCase();
            break;
          case 2:
            // language-script or language-region
            parts[0] = parts[0].toLowerCase();
            if (parts[1].length === 4) {
              // parts[1] is script
              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            } else {
              // parts[1] is region
              parts[1] = parts[1].toUpperCase();
            }
            break;
          case 3:
            // language-script-region
            parts[0] = parts[0].toLowerCase();
            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            parts[2] = parts[2].toUpperCase();
            break;
          default:
            return temp;
        }

        return parts.join('-');
      },
      'iso639-1': function iso6391(tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');
        return parts[0].toLowerCase();
      }
    };

    var version = '2.18.4';

    // tries to determine the browsers language
    var getFirstBrowserLanguage = function getFirstBrowserLanguage() {

      // internal purpose only
      if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
        return pascalprechtTranslateOverrider.getLocale();
      }

      var nav = $windowProvider.$get().navigator,
          browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
          i,
          language;

      // support for HTML 5.1 "navigator.languages"
      if (angular.isArray(nav.languages)) {
        for (i = 0; i < nav.languages.length; i++) {
          language = nav.languages[i];
          if (language && language.length) {
            return language;
          }
        }
      }

      // support for other well known properties in browsers
      for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
        language = nav[browserLanguagePropertyKeys[i]];
        if (language && language.length) {
          return language;
        }
      }

      return null;
    };
    getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';

    // tries to determine the browsers locale
    var getLocale = function getLocale() {
      var locale = getFirstBrowserLanguage() || '';
      if (languageTagResolver[uniformLanguageTagResolver]) {
        locale = languageTagResolver[uniformLanguageTagResolver](locale);
      }
      return locale;
    };
    getLocale.displayName = 'angular-translate/service: getLocale';

    /**
     * @name indexOf
     * @private
     *
     * @description
     * indexOf polyfill. Kinda sorta.
     *
     * @param {array} array Array to search in.
     * @param {string} searchElement Element to search for.
     *
     * @returns {int} Index of search element.
     */
    var indexOf = function indexOf(array, searchElement) {
      for (var i = 0, len = array.length; i < len; i++) {
        if (array[i] === searchElement) {
          return i;
        }
      }
      return -1;
    };

    /**
     * @name trim
     * @private
     *
     * @description
     * trim polyfill
     *
     * @returns {string} The string stripped of whitespace from both ends
     */
    var trim = function trim() {
      return this.toString().replace(/^\s+|\s+$/g, '');
    };

    /**
     * @name lowercase
     * @private
     *
     * @description
     * Return the lowercase string only if the type is string
     *
     * @returns {string} The string all in lowercase
     */
    var lowercase = function lowercase(string) {
      return angular.isString(string) ? string.toLowerCase() : string;
    };

    var negotiateLocale = function negotiateLocale(preferred) {
      if (!preferred) {
        return;
      }

      var avail = [],
          locale = lowercase(preferred),
          i = 0,
          n = $availableLanguageKeys.length;

      for (; i < n; i++) {
        avail.push(lowercase($availableLanguageKeys[i]));
      }

      // Check for an exact match in our list of available keys
      i = indexOf(avail, locale);
      if (i > -1) {
        return $availableLanguageKeys[i];
      }

      if ($languageKeyAliases) {
        var alias;
        for (var langKeyAlias in $languageKeyAliases) {
          if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
            var hasWildcardKey = false;
            var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) && lowercase(langKeyAlias) === lowercase(preferred);

            if (langKeyAlias.slice(-1) === '*') {
              hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
            }
            if (hasExactKey || hasWildcardKey) {
              alias = $languageKeyAliases[langKeyAlias];
              if (indexOf(avail, lowercase(alias)) > -1) {
                return alias;
              }
            }
          }
        }
      }

      // Check for a language code without region
      var parts = preferred.split('_');

      if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
        return parts[0];
      }

      // If everything fails, return undefined.
      return;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#translations
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Registers a new translation table for specific language key.
     *
     * To register a translation table for specific language, pass a defined language
     * key as first parameter.
     *
     * <pre>
     *  // register translation table for language: 'de_DE'
     *  $translateProvider.translations('de_DE', {
     *    'GREETING': 'Hallo Welt!'
     *  });
     *
     *  // register another one
     *  $translateProvider.translations('en_US', {
     *    'GREETING': 'Hello world!'
     *  });
     * </pre>
     *
     * When registering multiple translation tables for for the same language key,
     * the actual translation table gets extended. This allows you to define module
     * specific translation which only get added, once a specific module is loaded in
     * your app.
     *
     * Invoking this method with no arguments returns the translation table which was
     * registered with no language key. Invoking it with a language key returns the
     * related translation table.
     *
     * @param {string} langKey A language key.
     * @param {object} translationTable A plain old JavaScript object that represents a translation table.
     *
     */
    var translations = function translations(langKey, translationTable) {

      if (!langKey && !translationTable) {
        return $translationTable;
      }

      if (langKey && !translationTable) {
        if (angular.isString(langKey)) {
          return $translationTable[langKey];
        }
      } else {
        if (!angular.isObject($translationTable[langKey])) {
          $translationTable[langKey] = {};
        }
        angular.extend($translationTable[langKey], flatObject(translationTable));
      }
      return this;
    };

    this.translations = translations;

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#cloakClassName
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     *
     * Let's you change the class name for `translate-cloak` directive.
     * Default class name is `translate-cloak`.
     *
     * @param {string} name translate-cloak class name
     */
    this.cloakClassName = function (name) {
      if (!name) {
        return $cloakClassName;
      }
      $cloakClassName = name;
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     *
     * Let's you change the delimiter for namespaced translations.
     * Default delimiter is `.`.
     *
     * @param {string} delimiter namespace separator
     */
    this.nestedObjectDelimeter = function (delimiter) {
      if (!delimiter) {
        return $nestedObjectDelimeter;
      }
      $nestedObjectDelimeter = delimiter;
      return this;
    };

    /**
     * @name flatObject
     * @private
     *
     * @description
     * Flats an object. This function is used to flatten given translation data with
     * namespaces, so they are later accessible via dot notation.
     */
    var flatObject = function flatObject(data, path, result, prevKey) {
      var key, keyWithPath, keyWithShortPath, val;

      if (!path) {
        path = [];
      }
      if (!result) {
        result = {};
      }
      for (key in data) {
        if (!Object.prototype.hasOwnProperty.call(data, key)) {
          continue;
        }
        val = data[key];
        if (angular.isObject(val)) {
          flatObject(val, path.concat(key), result, key);
        } else {
          keyWithPath = path.length ? '' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key : key;
          if (path.length && key === prevKey) {
            // Create shortcut path (foo.bar == foo.bar.bar)
            keyWithShortPath = '' + path.join($nestedObjectDelimeter);
            // Link it to original path
            result[keyWithShortPath] = '@:' + keyWithPath;
          }
          result[keyWithPath] = val;
        }
      }
      return result;
    };
    flatObject.displayName = 'flatObject';

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#addInterpolation
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Adds interpolation services to angular-translate, so it can manage them.
     *
     * @param {object} factory Interpolation service factory
     */
    this.addInterpolation = function (factory) {
      $interpolatorFactories.push(factory);
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells angular-translate to use interpolation functionality of messageformat.js.
     * This is useful when having high level pluralization and gender selection.
     */
    this.useMessageFormatInterpolation = function () {
      return this.useInterpolation('$translateMessageFormatInterpolation');
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#useInterpolation
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells angular-translate which interpolation style to use as default, application-wide.
     * Simply pass a factory/service name. The interpolation service has to implement
     * the correct interface.
     *
     * @param {string} factory Interpolation service name.
     */
    this.useInterpolation = function (factory) {
      $interpolationFactory = factory;
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Simply sets a sanitation strategy type.
     *
     * @param {string} value Strategy type.
     */
    this.useSanitizeValueStrategy = function (value) {
      $translateSanitizationProvider.useStrategy(value);
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#preferredLanguage
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells the module which of the registered translation tables to use for translation
     * at initial startup by passing a language key. Similar to `$translateProvider#use`
     * only that it says which language to **prefer**.
     * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
     *
     * @param {string} langKey A language key.
     */
    this.preferredLanguage = function (langKey) {
      if (langKey) {
        setupPreferredLanguage(langKey);
        return this;
      }
      return $preferredLanguage;
    };
    var setupPreferredLanguage = function setupPreferredLanguage(langKey) {
      if (langKey) {
        $preferredLanguage = langKey;
      }
      return $preferredLanguage;
    };
    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Sets an indicator which is used when a translation isn't found. E.g. when
     * setting the indicator as 'X' and one tries to translate a translation id
     * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
     *
     * Internally this methods sets a left indicator and a right indicator using
     * `$translateProvider.translationNotFoundIndicatorLeft()` and
     * `$translateProvider.translationNotFoundIndicatorRight()`.
     *
     * **Note**: These methods automatically add a whitespace between the indicators
     * and the translation id.
     *
     * @param {string} indicator An indicator, could be any string.
     */
    this.translationNotFoundIndicator = function (indicator) {
      this.translationNotFoundIndicatorLeft(indicator);
      this.translationNotFoundIndicatorRight(indicator);
      return this;
    };

    /**
     * ngdoc function
     * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Sets an indicator which is used when a translation isn't found left to the
     * translation id.
     *
     * @param {string} indicator An indicator.
     */
    this.translationNotFoundIndicatorLeft = function (indicator) {
      if (!indicator) {
        return $notFoundIndicatorLeft;
      }
      $notFoundIndicatorLeft = indicator;
      return this;
    };

    /**
     * ngdoc function
     * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Sets an indicator which is used when a translation isn't found right to the
     * translation id.
     *
     * @param {string} indicator An indicator.
     */
    this.translationNotFoundIndicatorRight = function (indicator) {
      if (!indicator) {
        return $notFoundIndicatorRight;
      }
      $notFoundIndicatorRight = indicator;
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#fallbackLanguage
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells the module which of the registered translation tables to use when missing translations
     * at initial startup by passing a language key. Similar to `$translateProvider#use`
     * only that it says which language to **fallback**.
     *
     * @param {string||array} langKey A language key.
     *
     */
    this.fallbackLanguage = function (langKey) {
      fallbackStack(langKey);
      return this;
    };

    var fallbackStack = function fallbackStack(langKey) {
      if (langKey) {
        if (angular.isString(langKey)) {
          $fallbackWasString = true;
          $fallbackLanguage = [langKey];
        } else if (angular.isArray(langKey)) {
          $fallbackWasString = false;
          $fallbackLanguage = langKey;
        }
        if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
          $fallbackLanguage.push($preferredLanguage);
        }

        return this;
      } else {
        if ($fallbackWasString) {
          return $fallbackLanguage[0];
        } else {
          return $fallbackLanguage;
        }
      }
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#use
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Set which translation table to use for translation by given language key. When
     * trying to 'use' a language which isn't provided, it'll throw an error.
     *
     * You actually don't have to use this method since `$translateProvider#preferredLanguage`
     * does the job too.
     *
     * @param {string} langKey A language key.
     */
    this.use = function (langKey) {
      if (langKey) {
        if (!$translationTable[langKey] && !$loaderFactory) {
          // only throw an error, when not loading translation data asynchronously
          throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
        }
        $uses = langKey;
        return this;
      }
      return $uses;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#resolveClientLocale
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
     *
     * @returns {string} the current client/browser language key
     */
    this.resolveClientLocale = function () {
      return getLocale();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#storageKey
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells the module which key must represent the choosed language by a user in the storage.
     *
     * @param {string} key A key for the storage.
     */
    var storageKey = function storageKey(key) {
      if (!key) {
        if ($storagePrefix) {
          return $storagePrefix + $storageKey;
        }
        return $storageKey;
      }
      $storageKey = key;
      return this;
    };

    this.storageKey = storageKey;

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#useUrlLoader
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
     *
     * @param {string} url Url
     * @param {Object=} options Optional configuration object
     */
    this.useUrlLoader = function (url, options) {
      return this.useLoader('$translateUrlLoader', angular.extend({ url: url }, options));
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
     *
     * @param {Object=} options Optional configuration object
     */
    this.useStaticFilesLoader = function (options) {
      return this.useLoader('$translateStaticFilesLoader', options);
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#useLoader
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells angular-translate to use any other service as loader.
     *
     * @param {string} loaderFactory Factory name to use
     * @param {Object=} options Optional configuration object
     */
    this.useLoader = function (loaderFactory, options) {
      $loaderFactory = loaderFactory;
      $loaderOptions = options || {};
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#useLocalStorage
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
     *
     */
    this.useLocalStorage = function () {
      return this.useStorage('$translateLocalStorage');
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#useCookieStorage
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
     */
    this.useCookieStorage = function () {
      return this.useStorage('$translateCookieStorage');
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#useStorage
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells angular-translate to use custom service as storage layer.
     */
    this.useStorage = function (storageFactory) {
      $storageFactory = storageFactory;
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#storagePrefix
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Sets prefix for storage key.
     *
     * @param {string} prefix Storage key prefix
     */
    this.storagePrefix = function (prefix) {
      if (!prefix) {
        return prefix;
      }
      $storagePrefix = prefix;
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells angular-translate to use built-in log handler when trying to translate
     * a translation Id which doesn't exist.
     *
     * This is actually a shortcut method for `useMissingTranslationHandler()`.
     *
     */
    this.useMissingTranslationHandlerLog = function () {
      return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Expects a factory name which later gets instantiated with `$injector`.
     * This method can be used to tell angular-translate to use a custom
     * missingTranslationHandler. Just build a factory which returns a function
     * and expects a translation id as argument.
     *
     * Example:
     * <pre>
     *  app.config(function ($translateProvider) {
     *    $translateProvider.useMissingTranslationHandler('customHandler');
     *  });
     *
     *  app.factory('customHandler', function (dep1, dep2) {
     *    return function (translationId) {
     *      // something with translationId and dep1 and dep2
     *    };
     *  });
     * </pre>
     *
     * @param {string} factory Factory name
     */
    this.useMissingTranslationHandler = function (factory) {
      $missingTranslationHandlerFactory = factory;
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#usePostCompiling
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * If post compiling is enabled, all translated values will be processed
     * again with AngularJS' $compile.
     *
     * Example:
     * <pre>
     *  app.config(function ($translateProvider) {
     *    $translateProvider.usePostCompiling(true);
     *  });
     * </pre>
     *
     * @param {string} factory Factory name
     */
    this.usePostCompiling = function (value) {
      $postCompilingEnabled = !!value;
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#forceAsyncReload
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * If force async reload is enabled, async loader will always be called
     * even if $translationTable already contains the language key, adding
     * possible new entries to the $translationTable.
     *
     * Example:
     * <pre>
     *  app.config(function ($translateProvider) {
     *    $translateProvider.forceAsyncReload(true);
     *  });
     * </pre>
     *
     * @param {boolean} value - valid values are true or false
     */
    this.forceAsyncReload = function (value) {
      $forceAsyncReloadEnabled = !!value;
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells angular-translate which language tag should be used as a result when determining
     * the current browser language.
     *
     * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
     *
     * <pre>
     * $translateProvider
     *   .uniformLanguageTag('bcp47')
     *   .determinePreferredLanguage()
     * </pre>
     *
     * The resolver currently supports:
     * * default
     *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
     *     en-US => en_US
     *     en_US => en_US
     *     en-us => en_us
     * * java
     *     like default, but the second part will be always in uppercase
     *     en-US => en_US
     *     en_US => en_US
     *     en-us => en_US
     * * BCP 47 (RFC 4646 & 4647)
     *     EN => en
     *     en-US => en-US
     *     en_US => en-US
     *     en-us => en-US
     *     sr-latn => sr-Latn
     *     sr-latn-rs => sr-Latn-RS
     *
     * See also:
     * * http://en.wikipedia.org/wiki/IETF_language_tag
     * * http://www.w3.org/International/core/langtags/
     * * http://tools.ietf.org/html/bcp47
     *
     * @param {string|object} options - options (or standard)
     * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
     */
    this.uniformLanguageTag = function (options) {

      if (!options) {
        options = {};
      } else if (angular.isString(options)) {
        options = {
          standard: options
        };
      }

      uniformLanguageTagResolver = options.standard;

      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Tells angular-translate to try to determine on its own which language key
     * to set as preferred language. When `fn` is given, angular-translate uses it
     * to determine a language key, otherwise it uses the built-in `getLocale()`
     * method.
     *
     * The `getLocale()` returns a language key in the format `[lang]_[country]` or
     * `[lang]` depending on what the browser provides.
     *
     * Use this method at your own risk, since not all browsers return a valid
     * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
     *
     * @param {Function=} fn Function to determine a browser's locale
     */
    this.determinePreferredLanguage = function (fn) {

      var locale = fn && angular.isFunction(fn) ? fn() : getLocale();

      if (!$availableLanguageKeys.length) {
        $preferredLanguage = locale;
      } else {
        $preferredLanguage = negotiateLocale(locale) || locale;
      }

      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Registers a set of language keys the app will work with. Use this method in
     * combination with
     * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
     * When available languages keys are registered, angular-translate
     * tries to find the best fitting language key depending on the browsers locale,
     * considering your language key convention.
     *
     * @param {object} languageKeys Array of language keys the your app will use
     * @param {object=} aliases Alias map.
     */
    this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
      if (languageKeys) {
        $availableLanguageKeys = languageKeys;
        if (aliases) {
          $languageKeyAliases = aliases;
        }
        return this;
      }
      return $availableLanguageKeys;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#useLoaderCache
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Registers a cache for internal $http based loaders.
     * {@link pascalprecht.translate.$translationCache $translationCache}.
     * When false the cache will be disabled (default). When true or undefined
     * the cache will be a default (see $cacheFactory). When an object it will
     * be treat as a cache object itself: the usage is $http({cache: cache})
     *
     * @param {object} cache boolean, string or cache-object
     */
    this.useLoaderCache = function (cache) {
      if (cache === false) {
        // disable cache
        loaderCache = undefined;
      } else if (cache === true) {
        // enable cache using AJS defaults
        loaderCache = true;
      } else if (typeof cache === 'undefined') {
        // enable cache using default
        loaderCache = '$translationCache';
      } else if (cache) {
        // enable cache using given one (see $cacheFactory)
        loaderCache = cache;
      }
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#directivePriority
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Sets the default priority of the translate directive. The standard value is `0`.
     * Calling this function without an argument will return the current value.
     *
     * @param {number} priority for the translate-directive
     */
    this.directivePriority = function (priority) {
      if (priority === undefined) {
        // getter
        return directivePriority;
      } else {
        // setter with chaining
        directivePriority = priority;
        return this;
      }
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#statefulFilter
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
     * have to explicit define this behavior.
     * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
     * meaning being stateful.
     * Calling this function without an argument will return the current value.
     *
     * @param {boolean} state - defines the state of the filter
     */
    this.statefulFilter = function (state) {
      if (state === undefined) {
        // getter
        return statefulFilter;
      } else {
        // setter with chaining
        statefulFilter = state;
        return this;
      }
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#postProcess
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * The post processor will be intercept right after the translation result. It can modify the result.
     *
     * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
     */
    this.postProcess = function (fn) {
      if (fn) {
        postProcessFn = fn;
      } else {
        postProcessFn = undefined;
      }
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateProvider#keepContent
     * @methodOf pascalprecht.translate.$translateProvider
     *
     * @description
     * If keepContent is set to true than translate directive will always use innerHTML
     * as a default translation
     *
     * Example:
     * <pre>
     *  app.config(function ($translateProvider) {
     *    $translateProvider.keepContent(true);
     *  });
     * </pre>
     *
     * @param {boolean} value - valid values are true or false
     */
    this.keepContent = function (value) {
      $keepContent = !!value;
      return this;
    };

    /**
     * @ngdoc object
     * @name pascalprecht.translate.$translate
     * @requires $interpolate
     * @requires $log
     * @requires $rootScope
     * @requires $q
     *
     * @description
     * The `$translate` service is the actual core of angular-translate. It expects a translation id
     * and optional interpolate parameters to translate contents.
     *
     * <pre>
     *  $translate('HEADLINE_TEXT').then(function (translation) {
     *    $scope.translatedText = translation;
     *  });
     * </pre>
     *
     * @param {string|array} translationId A token which represents a translation id
     *                                     This can be optionally an array of translation ids which
     *                                     results that the function returns an object where each key
     *                                     is the translation id and the value the translation.
     * @param {object=} [interpolateParams={}] An object hash for dynamic values
     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
     * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
     *                                        as default text in case it is not found in any configured language
     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
     * @returns {object} promise
     */
    this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {

      var Storage,
          defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
          pendingLoader = false,
          interpolatorHashMap = {},
          langPromises = {},
          fallbackIndex,
          startFallbackIteration;

      var $translate = function $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
        if (!$uses && $preferredLanguage) {
          $uses = $preferredLanguage;
        }
        var uses = forceLanguage && forceLanguage !== $uses ? // we don't want to re-negotiate $uses
        negotiateLocale(forceLanguage) || forceLanguage : $uses;

        // Check forceLanguage is present
        if (forceLanguage) {
          loadTranslationsIfMissing(forceLanguage);
        }

        // Duck detection: If the first argument is an array, a bunch of translations was requested.
        // The result is an object.
        if (angular.isArray(translationId)) {
          // Inspired by Q.allSettled by Kris Kowal
          // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
          // This transforms all promises regardless resolved or rejected
          var translateAll = function translateAll(translationIds) {
            var results = {}; // storing the actual results
            var promises = []; // promises to wait for
            // Wraps the promise a) being always resolved and b) storing the link id->value
            var translate = function translate(translationId) {
              var deferred = $q.defer();
              var regardless = function regardless(value) {
                results[translationId] = value;
                deferred.resolve([translationId, value]);
              };
              // we don't care whether the promise was resolved or rejected; just store the values
              $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
              return deferred.promise;
            };
            for (var i = 0, c = translationIds.length; i < c; i++) {
              promises.push(translate(translationIds[i]));
            }
            // wait for all (including storing to results)
            return $q.all(promises).then(function () {
              // return the results
              return results;
            });
          };
          return translateAll(translationId);
        }

        var deferred = $q.defer();

        // trim off any whitespace
        if (translationId) {
          translationId = trim.apply(translationId);
        } else {
          throw new TypeError('translationId must be a not empty string');
        }

        var promiseToWaitFor = function () {
          var promise = langPromises[uses] || langPromises[$preferredLanguage];

          fallbackIndex = 0;

          if ($storageFactory && !promise) {
            // looks like there's no pending promise for $preferredLanguage or
            // $uses. Maybe there's one pending for a language that comes from
            // storage.
            var langKey = Storage.get($storageKey);
            promise = langPromises[langKey];

            if ($fallbackLanguage && $fallbackLanguage.length) {
              var index = indexOf($fallbackLanguage, langKey);
              // maybe the language from storage is also defined as fallback language
              // we increase the fallback language index to not search in that language
              // as fallback, since it's probably the first used language
              // in that case the index starts after the first element
              fallbackIndex = index === 0 ? 1 : 0;

              // but we can make sure to ALWAYS fallback to preferred language at least
              if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
                $fallbackLanguage.push($preferredLanguage);
              }
            }
          }
          return promise;
        }();

        if (!promiseToWaitFor) {
          // no promise to wait for? okay. Then there's no loader registered
          // nor is a one pending for language that comes from storage.
          // We can just translate.
          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
        } else {
          var promiseResolved = function promiseResolved() {
            // $uses may have changed while waiting
            if (!forceLanguage) {
              uses = $uses;
            }
            determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
          };
          promiseResolved.displayName = 'promiseResolved';

          promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
        }
        return deferred.promise;
      };

      /**
       * @name applyNotFoundIndicators
       * @private
       *
       * @description
       * Applies not fount indicators to given translation id, if needed.
       * This function gets only executed, if a translation id doesn't exist,
       * which is why a translation id is expected as argument.
       *
       * @param {string} translationId Translation id.
       * @returns {string} Same as given translation id but applied with not found
       * indicators.
       */
      var applyNotFoundIndicators = function applyNotFoundIndicators(translationId) {
        // applying notFoundIndicators
        if ($notFoundIndicatorLeft) {
          translationId = [$notFoundIndicatorLeft, translationId].join(' ');
        }
        if ($notFoundIndicatorRight) {
          translationId = [translationId, $notFoundIndicatorRight].join(' ');
        }
        return translationId;
      };

      /**
       * @name useLanguage
       * @private
       *
       * @description
       * Makes actual use of a language by setting a given language key as used
       * language and informs registered interpolators to also use the given
       * key as locale.
       *
       * @param {string} key Locale key.
       */
      var useLanguage = function useLanguage(key) {
        $uses = key;

        // make sure to store new language key before triggering success event
        if ($storageFactory) {
          Storage.put($translate.storageKey(), $uses);
        }

        $rootScope.$emit('$translateChangeSuccess', { language: key });

        // inform default interpolator
        defaultInterpolator.setLocale($uses);

        var eachInterpolator = function eachInterpolator(interpolator, id) {
          interpolatorHashMap[id].setLocale($uses);
        };
        eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';

        // inform all others too!
        angular.forEach(interpolatorHashMap, eachInterpolator);
        $rootScope.$emit('$translateChangeEnd', { language: key });
      };

      /**
       * @name loadAsync
       * @private
       *
       * @description
       * Kicks off registered async loader using `$injector` and applies existing
       * loader options. When resolved, it updates translation tables accordingly
       * or rejects with given language key.
       *
       * @param {string} key Language key.
       * @return {Promise} A promise.
       */
      var loadAsync = function loadAsync(key) {
        if (!key) {
          throw 'No language key specified for loading.';
        }

        var deferred = $q.defer();

        $rootScope.$emit('$translateLoadingStart', { language: key });
        pendingLoader = true;

        var cache = loaderCache;
        if (typeof cache === 'string') {
          // getting on-demand instance of loader
          cache = $injector.get(cache);
        }

        var loaderOptions = angular.extend({}, $loaderOptions, {
          key: key,
          $http: angular.extend({}, {
            cache: cache
          }, $loaderOptions.$http)
        });

        var onLoaderSuccess = function onLoaderSuccess(data) {
          var translationTable = {};
          $rootScope.$emit('$translateLoadingSuccess', { language: key });

          if (angular.isArray(data)) {
            angular.forEach(data, function (table) {
              angular.extend(translationTable, flatObject(table));
            });
          } else {
            angular.extend(translationTable, flatObject(data));
          }
          pendingLoader = false;
          deferred.resolve({
            key: key,
            table: translationTable
          });
          $rootScope.$emit('$translateLoadingEnd', { language: key });
        };
        onLoaderSuccess.displayName = 'onLoaderSuccess';

        var onLoaderError = function onLoaderError(key) {
          $rootScope.$emit('$translateLoadingError', { language: key });
          deferred.reject(key);
          $rootScope.$emit('$translateLoadingEnd', { language: key });
        };
        onLoaderError.displayName = 'onLoaderError';

        $injector.get($loaderFactory)(loaderOptions).then(onLoaderSuccess, onLoaderError);

        return deferred.promise;
      };

      if ($storageFactory) {
        Storage = $injector.get($storageFactory);

        if (!Storage.get || !Storage.put) {
          throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
        }
      }

      // if we have additional interpolations that were added via
      // $translateProvider.addInterpolation(), we have to map'em
      if ($interpolatorFactories.length) {
        var eachInterpolationFactory = function eachInterpolationFactory(interpolatorFactory) {
          var interpolator = $injector.get(interpolatorFactory);
          // setting initial locale for each interpolation service
          interpolator.setLocale($preferredLanguage || $uses);
          // make'em recognizable through id
          interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
        };
        eachInterpolationFactory.displayName = 'interpolationFactoryAdder';

        angular.forEach($interpolatorFactories, eachInterpolationFactory);
      }

      /**
       * @name getTranslationTable
       * @private
       *
       * @description
       * Returns a promise that resolves to the translation table
       * or is rejected if an error occurred.
       *
       * @param langKey
       * @returns {Q.promise}
       */
      var getTranslationTable = function getTranslationTable(langKey) {
        var deferred = $q.defer();
        if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
          deferred.resolve($translationTable[langKey]);
        } else if (langPromises[langKey]) {
          var onResolve = function onResolve(data) {
            translations(data.key, data.table);
            deferred.resolve(data.table);
          };
          onResolve.displayName = 'translationTableResolver';
          langPromises[langKey].then(onResolve, deferred.reject);
        } else {
          deferred.reject();
        }
        return deferred.promise;
      };

      /**
       * @name getFallbackTranslation
       * @private
       *
       * @description
       * Returns a promise that will resolve to the translation
       * or be rejected if no translation was found for the language.
       * This function is currently only used for fallback language translation.
       *
       * @param langKey The language to translate to.
       * @param translationId
       * @param interpolateParams
       * @param Interpolator
       * @param sanitizeStrategy
       * @returns {Q.promise}
       */
      var getFallbackTranslation = function getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
        var deferred = $q.defer();

        var onResolve = function onResolve(translationTable) {
          if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
            Interpolator.setLocale(langKey);
            var translation = translationTable[translationId];
            if (translation.substr(0, 2) === '@:') {
              getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy).then(deferred.resolve, deferred.reject);
            } else {
              var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
              interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);

              deferred.resolve(interpolatedValue);
            }
            Interpolator.setLocale($uses);
          } else {
            deferred.reject();
          }
        };
        onResolve.displayName = 'fallbackTranslationResolver';

        getTranslationTable(langKey).then(onResolve, deferred.reject);

        return deferred.promise;
      };

      /**
       * @name getFallbackTranslationInstant
       * @private
       *
       * @description
       * Returns a translation
       * This function is currently only used for fallback language translation.
       *
       * @param langKey The language to translate to.
       * @param translationId
       * @param interpolateParams
       * @param Interpolator
       * @param sanitizeStrategy sanitize strategy override
       *
       * @returns {string} translation
       */
      var getFallbackTranslationInstant = function getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
        var result,
            translationTable = $translationTable[langKey];

        if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
          Interpolator.setLocale(langKey);
          result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
          result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
          // workaround for TrustedValueHolderType
          if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
            var result2 = result.$$unwrapTrustedValue();
            if (result2.substr(0, 2) === '@:') {
              return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
            }
          } else if (result.substr(0, 2) === '@:') {
            return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
          }
          Interpolator.setLocale($uses);
        }

        return result;
      };

      /**
       * @name translateByHandler
       * @private
       *
       * Translate by missing translation handler.
       *
       * @param translationId
       * @param interpolateParams
       * @param defaultTranslationText
       * @param sanitizeStrategy sanitize strategy override
       *
       * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
       * absent
       */
      var translateByHandler = function translateByHandler(translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
        // If we have a handler factory - we might also call it here to determine if it provides
        // a default text for a translationid that can't be found anywhere in our tables
        if ($missingTranslationHandlerFactory) {
          return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
        } else {
          return translationId;
        }
      };

      /**
       * @name resolveForFallbackLanguage
       * @private
       *
       * Recursive helper function for fallbackTranslation that will sequentially look
       * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
       *
       * @param fallbackLanguageIndex
       * @param translationId
       * @param interpolateParams
       * @param Interpolator
       * @param defaultTranslationText
       * @param sanitizeStrategy
       * @returns {Q.promise} Promise that will resolve to the translation.
       */
      var resolveForFallbackLanguage = function resolveForFallbackLanguage(fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
        var deferred = $q.defer();

        if (fallbackLanguageIndex < $fallbackLanguage.length) {
          var langKey = $fallbackLanguage[fallbackLanguageIndex];
          getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(function (data) {
            deferred.resolve(data);
          }, function () {
            // Look in the next fallback language for a translation.
            // It delays the resolving by passing another promise to resolve.
            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
          });
        } else {
          // No translation found in any fallback language
          // if a default translation text is set in the directive, then return this as a result
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);

            // if no default translation is set and an error handler is defined, send it to the handler
            // and then return the result if it isn't undefined
            if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
              deferred.resolve(missingTranslationHandlerTranslation);
            } else {
              deferred.reject(applyNotFoundIndicators(translationId));
            }
          }
        }
        return deferred.promise;
      };

      /**
       * @name resolveForFallbackLanguageInstant
       * @private
       *
       * Recursive helper function for fallbackTranslation that will sequentially look
       * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
       *
       * @param fallbackLanguageIndex
       * @param translationId
       * @param interpolateParams
       * @param Interpolator
       * @param sanitizeStrategy
       * @returns {string} translation
       */
      var resolveForFallbackLanguageInstant = function resolveForFallbackLanguageInstant(fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
        var result;

        if (fallbackLanguageIndex < $fallbackLanguage.length) {
          var langKey = $fallbackLanguage[fallbackLanguageIndex];
          result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
          if (!result && result !== '') {
            result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
          }
        }
        return result;
      };

      /**
       * Translates with the usage of the fallback languages.
       *
       * @param translationId
       * @param interpolateParams
       * @param Interpolator
       * @param defaultTranslationText
       * @param sanitizeStrategy
       * @returns {Q.promise} Promise, that resolves to the translation.
       */
      var fallbackTranslation = function fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
        // Start with the fallbackLanguage with index 0
        return resolveForFallbackLanguage(startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
      };

      /**
       * Translates with the usage of the fallback languages.
       *
       * @param translationId
       * @param interpolateParams
       * @param Interpolator
       * @param sanitizeStrategy
       * @returns {String} translation
       */
      var fallbackTranslationInstant = function fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy) {
        // Start with the fallbackLanguage with index 0
        return resolveForFallbackLanguageInstant(startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy);
      };

      var determineTranslation = function determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {

        var deferred = $q.defer();

        var table = uses ? $translationTable[uses] : $translationTable,
            Interpolator = interpolationId ? interpolatorHashMap[interpolationId] : defaultInterpolator;

        // if the translation id exists, we can just interpolate it
        if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
          var translation = table[translationId];

          // If using link, rerun $translate with linked translationId and return it
          if (translation.substr(0, 2) === '@:') {

            $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
          } else {
            //
            var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
            resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
            deferred.resolve(resolvedTranslation);
          }
        } else {
          var missingTranslationHandlerTranslation;
          // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
          if ($missingTranslationHandlerFactory && !pendingLoader) {
            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
          }

          // since we couldn't translate the inital requested translation id,
          // we try it now with one or more fallback languages, if fallback language(s) is
          // configured.
          if (uses && $fallbackLanguage && $fallbackLanguage.length) {
            fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(function (translation) {
              deferred.resolve(translation);
            }, function (_translationId) {
              deferred.reject(applyNotFoundIndicators(_translationId));
            });
          } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
            // looks like the requested translation id doesn't exists.
            // Now, if there is a registered handler for missing translations and no
            // asyncLoader is pending, we execute the handler
            if (defaultTranslationText) {
              deferred.resolve(defaultTranslationText);
            } else {
              deferred.resolve(missingTranslationHandlerTranslation);
            }
          } else {
            if (defaultTranslationText) {
              deferred.resolve(defaultTranslationText);
            } else {
              deferred.reject(applyNotFoundIndicators(translationId));
            }
          }
        }
        return deferred.promise;
      };

      var determineTranslationInstant = function determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {

        var result,
            table = uses ? $translationTable[uses] : $translationTable,
            Interpolator = defaultInterpolator;

        // if the interpolation id exists use custom interpolator
        if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
          Interpolator = interpolatorHashMap[interpolationId];
        }

        // if the translation id exists, we can just interpolate it
        if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
          var translation = table[translationId];

          // If using link, rerun $translate with linked translationId and return it
          if (translation.substr(0, 2) === '@:') {
            result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
          } else {
            result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
            result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
          }
        } else {
          var missingTranslationHandlerTranslation;
          // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
          if ($missingTranslationHandlerFactory && !pendingLoader) {
            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
          }

          // since we couldn't translate the inital requested translation id,
          // we try it now with one or more fallback languages, if fallback language(s) is
          // configured.
          if (uses && $fallbackLanguage && $fallbackLanguage.length) {
            fallbackIndex = 0;
            result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
          } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
            // looks like the requested translation id doesn't exists.
            // Now, if there is a registered handler for missing translations and no
            // asyncLoader is pending, we execute the handler
            result = missingTranslationHandlerTranslation;
          } else {
            result = applyNotFoundIndicators(translationId);
          }
        }

        return result;
      };

      var clearNextLangAndPromise = function clearNextLangAndPromise(key) {
        if ($nextLang === key) {
          $nextLang = undefined;
        }
        langPromises[key] = undefined;
      };

      var applyPostProcessing = function applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
        var fn = postProcessFn;

        if (fn) {

          if (typeof fn === 'string') {
            // getting on-demand instance
            fn = $injector.get(fn);
          }
          if (fn) {
            return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
          }
        }

        return resolvedTranslation;
      };

      var loadTranslationsIfMissing = function loadTranslationsIfMissing(key) {
        if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
          langPromises[key] = loadAsync(key).then(function (translation) {
            translations(translation.key, translation.table);
            return translation;
          });
        }
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#preferredLanguage
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the language key for the preferred language.
       *
       * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
       *
       * @return {string} preferred language key
       */
      $translate.preferredLanguage = function (langKey) {
        if (langKey) {
          setupPreferredLanguage(langKey);
        }
        return $preferredLanguage;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#cloakClassName
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the configured class name for `translate-cloak` directive.
       *
       * @return {string} cloakClassName
       */
      $translate.cloakClassName = function () {
        return $cloakClassName;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#nestedObjectDelimeter
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the configured delimiter for nested namespaces.
       *
       * @return {string} nestedObjectDelimeter
       */
      $translate.nestedObjectDelimeter = function () {
        return $nestedObjectDelimeter;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#fallbackLanguage
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the language key for the fallback languages or sets a new fallback stack.
       * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
       *
       * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
       *
       * @return {string||array} fallback language key
       */
      $translate.fallbackLanguage = function (langKey) {
        if (langKey !== undefined && langKey !== null) {
          fallbackStack(langKey);

          // as we might have an async loader initiated and a new translation language might have been defined
          // we need to add the promise to the stack also. So - iterate.
          if ($loaderFactory) {
            if ($fallbackLanguage && $fallbackLanguage.length) {
              for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
                if (!langPromises[$fallbackLanguage[i]]) {
                  langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
                }
              }
            }
          }
          $translate.use($translate.use());
        }
        if ($fallbackWasString) {
          return $fallbackLanguage[0];
        } else {
          return $fallbackLanguage;
        }
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#useFallbackLanguage
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Sets the first key of the fallback language stack to be used for translation.
       * Therefore all languages in the fallback array BEFORE this key will be skipped!
       *
       * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
       * get back to the whole stack
       */
      $translate.useFallbackLanguage = function (langKey) {
        if (langKey !== undefined && langKey !== null) {
          if (!langKey) {
            startFallbackIteration = 0;
          } else {
            var langKeyPosition = indexOf($fallbackLanguage, langKey);
            if (langKeyPosition > -1) {
              startFallbackIteration = langKeyPosition;
            }
          }
        }
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#proposedLanguage
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the language key of language that is currently loaded asynchronously.
       *
       * @return {string} language key
       */
      $translate.proposedLanguage = function () {
        return $nextLang;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#storage
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns registered storage.
       *
       * @return {object} Storage
       */
      $translate.storage = function () {
        return Storage;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#negotiateLocale
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns a language key based on available languages and language aliases. If a
       * language key cannot be resolved, returns undefined.
       *
       * If no or a falsy key is given, returns undefined.
       *
       * @param {string} [key] Language key
       * @return {string|undefined} Language key or undefined if no language key is found.
       */
      $translate.negotiateLocale = negotiateLocale;

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#use
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Tells angular-translate which language to use by given language key. This method is
       * used to change language at runtime. It also takes care of storing the language
       * key in a configured store to let your app remember the choosed language.
       *
       * When trying to 'use' a language which isn't available it tries to load it
       * asynchronously with registered loaders.
       *
       * Returns promise object with loaded language file data or string of the currently used language.
       *
       * If no or a falsy key is given it returns the currently used language key.
       * The returned string will be ```undefined``` if setting up $translate hasn't finished.
       * @example
       * $translate.use("en_US").then(function(data){
         *   $scope.text = $translate("HELLO");
         * });
       *
       * @param {string=} key Language key
       * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
       */
      $translate.use = function (key) {
        if (!key) {
          return $uses;
        }

        var deferred = $q.defer();
        deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"

        $rootScope.$emit('$translateChangeStart', { language: key });

        // Try to get the aliased language key
        var aliasedKey = negotiateLocale(key);
        // Ensure only registered language keys will be loaded
        if ($availableLanguageKeys.length > 0 && !aliasedKey) {
          return $q.reject(key);
        }

        if (aliasedKey) {
          key = aliasedKey;
        }

        // if there isn't a translation table for the language we've requested,
        // we load it asynchronously
        $nextLang = key;
        if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
          langPromises[key] = loadAsync(key).then(function (translation) {
            translations(translation.key, translation.table);
            deferred.resolve(translation.key);
            if ($nextLang === key) {
              useLanguage(translation.key);
            }
            return translation;
          }, function (key) {
            $rootScope.$emit('$translateChangeError', { language: key });
            deferred.reject(key);
            $rootScope.$emit('$translateChangeEnd', { language: key });
            return $q.reject(key);
          });
          langPromises[key]['finally'](function () {
            clearNextLangAndPromise(key);
          })['catch'](angular.noop); // we don't care about errors (clearing)
        } else if (langPromises[key]) {
          // we are already loading this asynchronously
          // resolve our new deferred when the old langPromise is resolved
          langPromises[key].then(function (translation) {
            if ($nextLang === translation.key) {
              useLanguage(translation.key);
            }
            deferred.resolve(translation.key);
            return translation;
          }, function (key) {
            // find first available fallback language if that request has failed
            if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
              return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
            } else {
              return deferred.reject(key);
            }
          });
        } else {
          deferred.resolve(key);
          useLanguage(key);
        }

        return deferred.promise;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#resolveClientLocale
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
       *
       * @returns {string} the current client/browser language key
       */
      $translate.resolveClientLocale = function () {
        return getLocale();
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#storageKey
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the key for the storage.
       *
       * @return {string} storage key
       */
      $translate.storageKey = function () {
        return storageKey();
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#isPostCompilingEnabled
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns whether post compiling is enabled or not
       *
       * @return {bool} storage key
       */
      $translate.isPostCompilingEnabled = function () {
        return $postCompilingEnabled;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns whether force async reload is enabled or not
       *
       * @return {boolean} forceAsyncReload value
       */
      $translate.isForceAsyncReloadEnabled = function () {
        return $forceAsyncReloadEnabled;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#isKeepContent
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns whether keepContent or not
       *
       * @return {boolean} keepContent value
       */
      $translate.isKeepContent = function () {
        return $keepContent;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#refresh
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
       * the module will drop all existent translation tables and load new version of those which
       * are currently in use.
       *
       * Refresh means that the module will drop target translation table and try to load it again.
       *
       * In case there are no loaders registered the refresh() method will throw an Error.
       *
       * If the module is able to refresh translation tables refresh() method will broadcast
       * $translateRefreshStart and $translateRefreshEnd events.
       *
       * @example
       * // this will drop all currently existent translation tables and reload those which are
       * // currently in use
       * $translate.refresh();
       * // this will refresh a translation table for the en_US language
       * $translate.refresh('en_US');
       *
       * @param {string} langKey A language key of the table, which has to be refreshed
       *
       * @return {promise} Promise, which will be resolved in case a translation tables refreshing
       * process is finished successfully, and reject if not.
       */
      $translate.refresh = function (langKey) {
        if (!$loaderFactory) {
          throw new Error('Couldn\'t refresh translation table, no loader registered!');
        }

        $rootScope.$emit('$translateRefreshStart', { language: langKey });

        var deferred = $q.defer(),
            updatedLanguages = {};

        //private helper
        function loadNewData(languageKey) {
          var promise = loadAsync(languageKey);
          //update the load promise cache for this language
          langPromises[languageKey] = promise;
          //register a data handler for the promise
          promise.then(function (data) {
            //clear the cache for this language
            $translationTable[languageKey] = {};
            //add the new data for this language
            translations(languageKey, data.table);
            //track that we updated this language
            updatedLanguages[languageKey] = true;
          },
          //handle rejection to appease the $q validation
          angular.noop);
          return promise;
        }

        //set up post-processing
        deferred.promise.then(function () {
          for (var key in $translationTable) {
            if ($translationTable.hasOwnProperty(key)) {
              //delete cache entries that were not updated
              if (!(key in updatedLanguages)) {
                delete $translationTable[key];
              }
            }
          }
          if ($uses) {
            useLanguage($uses);
          }
        },
        //handle rejection to appease the $q validation
        angular.noop)['finally'](function () {
          $rootScope.$emit('$translateRefreshEnd', { language: langKey });
        });

        if (!langKey) {
          // if there's no language key specified we refresh ALL THE THINGS!
          var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
          if ($uses && languagesToReload.indexOf($uses) === -1) {
            languagesToReload.push($uses);
          }
          $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);
        } else if ($translationTable[langKey]) {
          //just refresh the specified language cache
          loadNewData(langKey).then(deferred.resolve, deferred.reject);
        } else {
          deferred.reject();
        }

        return deferred.promise;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#instant
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns a translation instantly from the internal state of loaded translation. All rules
       * regarding the current language, the preferred language of even fallback languages will be
       * used except any promise handling. If a language was not found, an asynchronous loading
       * will be invoked in the background.
       *
       * @param {string|array} translationId A token which represents a translation id
       *                                     This can be optionally an array of translation ids which
       *                                     results that the function's promise returns an object where
       *                                     each key is the translation id and the value the translation.
       * @param {object=} [interpolateParams={}] Params
       * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
       * @param {string=} [forceLanguage=false] A language to be used instead of the current language
       * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
       *
       * @return {string|object} translation
       */
      $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {

        // we don't want to re-negotiate $uses
        var uses = forceLanguage && forceLanguage !== $uses ? // we don't want to re-negotiate $uses
        negotiateLocale(forceLanguage) || forceLanguage : $uses;

        // Detect undefined and null values to shorten the execution and prevent exceptions
        if (translationId === null || angular.isUndefined(translationId)) {
          return translationId;
        }

        // Check forceLanguage is present
        if (forceLanguage) {
          loadTranslationsIfMissing(forceLanguage);
        }

        // Duck detection: If the first argument is an array, a bunch of translations was requested.
        // The result is an object.
        if (angular.isArray(translationId)) {
          var results = {};
          for (var i = 0, c = translationId.length; i < c; i++) {
            results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
          }
          return results;
        }

        // We discarded unacceptable values. So we just need to verify if translationId is empty String
        if (angular.isString(translationId) && translationId.length < 1) {
          return translationId;
        }

        // trim off any whitespace
        if (translationId) {
          translationId = trim.apply(translationId);
        }

        var result,
            possibleLangKeys = [];
        if ($preferredLanguage) {
          possibleLangKeys.push($preferredLanguage);
        }
        if (uses) {
          possibleLangKeys.push(uses);
        }
        if ($fallbackLanguage && $fallbackLanguage.length) {
          possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
        }
        for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
          var possibleLangKey = possibleLangKeys[j];
          if ($translationTable[possibleLangKey]) {
            if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
              result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
            }
          }
          if (typeof result !== 'undefined') {
            break;
          }
        }

        if (!result && result !== '') {
          if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
            result = applyNotFoundIndicators(translationId);
          } else {
            // Return translation of default interpolator if not found anything.
            result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);

            // looks like the requested translation id doesn't exists.
            // Now, if there is a registered handler for missing translations and no
            // asyncLoader is pending, we execute the handler
            var missingTranslationHandlerTranslation;
            if ($missingTranslationHandlerFactory && !pendingLoader) {
              missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
            }

            if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
              result = missingTranslationHandlerTranslation;
            }
          }
        }

        return result;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#versionInfo
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the current version information for the angular-translate library
       *
       * @return {string} angular-translate version
       */
      $translate.versionInfo = function () {
        return version;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#loaderCache
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the defined loaderCache.
       *
       * @return {boolean|string|object} current value of loaderCache
       */
      $translate.loaderCache = function () {
        return loaderCache;
      };

      // internal purpose only
      $translate.directivePriority = function () {
        return directivePriority;
      };

      // internal purpose only
      $translate.statefulFilter = function () {
        return statefulFilter;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#isReady
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns whether the service is "ready" to translate (i.e. loading 1st language).
       *
       * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
       *
       * @return {boolean} current value of ready
       */
      $translate.isReady = function () {
        return $isReady;
      };

      var $onReadyDeferred = $q.defer();
      $onReadyDeferred.promise.then(function () {
        $isReady = true;
      });

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#onReady
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
       *
       * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
       *
       * @param {Function=} fn Function to invoke when service is ready
       * @return {object} Promise resolved when service is ready
       */
      $translate.onReady = function (fn) {
        var deferred = $q.defer();
        if (angular.isFunction(fn)) {
          deferred.promise.then(fn);
        }
        if ($isReady) {
          deferred.resolve();
        } else {
          $onReadyDeferred.promise.then(deferred.resolve);
        }
        return deferred.promise;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * This function simply returns the registered language keys being defined before in the config phase
       * With this, an application can use the array to provide a language selection dropdown or similar
       * without any additional effort
       *
       * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
       */
      $translate.getAvailableLanguageKeys = function () {
        if ($availableLanguageKeys.length > 0) {
          return $availableLanguageKeys;
        }
        return null;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#getTranslationTable
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns translation table by the given language key.
       *
       * Unless a language is provided it returns a translation table of the current one.
       * Note: If translation dictionary is currently downloading or in progress
       * it will return null.
       *
       * @param {string} langKey A token which represents a translation id
       *
       * @return {object} a copy of angular-translate $translationTable
       */
      $translate.getTranslationTable = function (langKey) {
        langKey = langKey || $translate.use();
        if (langKey && $translationTable[langKey]) {
          return angular.copy($translationTable[langKey]);
        }
        return null;
      };

      // Whenever $translateReady is being fired, this will ensure the state of $isReady
      var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
        $onReadyDeferred.resolve();
        globalOnReadyListener(); // one time only
        globalOnReadyListener = null;
      });
      var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
        $onReadyDeferred.resolve();
        globalOnChangeListener(); // one time only
        globalOnChangeListener = null;
      });

      if ($loaderFactory) {

        // If at least one async loader is defined and there are no
        // (default) translations available we should try to load them.
        if (angular.equals($translationTable, {})) {
          if ($translate.use()) {
            $translate.use($translate.use());
          }
        }

        // Also, if there are any fallback language registered, we start
        // loading them asynchronously as soon as we can.
        if ($fallbackLanguage && $fallbackLanguage.length) {
          var processAsyncResult = function processAsyncResult(translation) {
            translations(translation.key, translation.table);
            $rootScope.$emit('$translateChangeEnd', { language: translation.key });
            return translation;
          };
          for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
            var fallbackLanguageId = $fallbackLanguage[i];
            if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
              langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
            }
          }
        }
      } else {
        $rootScope.$emit('$translateReady', { language: $translate.use() });
      }

      return $translate;
    }];
  }

  $translate.displayName = 'displayName';

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateDefaultInterpolation
   * @requires $interpolate
   *
   * @description
   * Uses angular's `$interpolate` services to interpolate strings against some values.
   *
   * Be aware to configure a proper sanitization strategy.
   *
   * See also:
   * * {@link pascalprecht.translate.$translateSanitization}
   *
   * @return {object} $translateDefaultInterpolation Interpolator service
   */
  angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);

  function $translateDefaultInterpolation($interpolate, $translateSanitization) {

    'use strict';

    var $translateInterpolator = {},
        $locale,
        $identifier = 'default';

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
     * @methodOf pascalprecht.translate.$translateDefaultInterpolation
     *
     * @description
     * Sets current locale (this is currently not use in this interpolation).
     *
     * @param {string} locale Language key or locale.
     */
    $translateInterpolator.setLocale = function (locale) {
      $locale = locale;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
     * @methodOf pascalprecht.translate.$translateDefaultInterpolation
     *
     * @description
     * Returns an identifier for this interpolation service.
     *
     * @returns {string} $identifier
     */
    $translateInterpolator.getInterpolationIdentifier = function () {
      return $identifier;
    };

    /**
     * @deprecated will be removed in 3.0
     * @see {@link pascalprecht.translate.$translateSanitization}
     */
    $translateInterpolator.useSanitizeValueStrategy = function (value) {
      $translateSanitization.useStrategy(value);
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
     * @methodOf pascalprecht.translate.$translateDefaultInterpolation
     *
     * @description
     * Interpolates given value agains given interpolate params using angulars
     * `$interpolate` service.
     *
     * Since AngularJS 1.5, `value` must not be a string but can be anything input.
     *
     * @param {string} value translation
     * @param {object} [interpolationParams={}] interpolation params
     * @param {string} [context=undefined] current context (filter, directive, service)
     * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
     * @param {string} translationId current translationId
     *
     * @returns {string} interpolated string
     */
    $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) {
      // jshint ignore:line
      interpolationParams = interpolationParams || {};
      interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);

      var interpolatedText;
      if (angular.isNumber(value)) {
        // numbers are safe
        interpolatedText = '' + value;
      } else if (angular.isString(value)) {
        // strings must be interpolated (that's the job here)
        interpolatedText = $interpolate(value)(interpolationParams);
        interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
      } else {
        // neither a number or a string, cant interpolate => empty string
        interpolatedText = '';
      }

      return interpolatedText;
    };

    return $translateInterpolator;
  }

  $translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';

  angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');

  angular.module('pascalprecht.translate')
  /**
   * @ngdoc directive
   * @name pascalprecht.translate.directive:translate
   * @requires $interpolate,
   * @requires $compile,
   * @requires $parse,
   * @requires $rootScope
   * @restrict AE
   *
   * @description
   * Translates given translation id either through attribute or DOM content.
   * Internally it uses $translate service to translate the translation id. It possible to
   * pass an optional `translate-values` object literal as string into translation id.
   *
   * @param {string=} translate Translation id which could be either string or interpolated string.
   * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
   * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
   * @param {string=} translate-default will be used unless translation was successful
   * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
   * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
   * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
   *
   * @example
     <example module="ngView">
      <file name="index.html">
        <div ng-controller="TranslateCtrl">
  
          <pre translate="TRANSLATION_ID"></pre>
          <pre translate>TRANSLATION_ID</pre>
          <pre translate translate-attr-title="TRANSLATION_ID"></pre>
          <pre translate="{{translationId}}"></pre>
          <pre translate>{{translationId}}</pre>
          <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
          <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
          <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
          <pre translate translate-values="{{values}}">WITH_VALUES</pre>
          <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
          <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>
  
        </div>
      </file>
      <file name="script.js">
        angular.module('ngView', ['pascalprecht.translate'])
  
        .config(function ($translateProvider) {
  
          $translateProvider.translations('en',{
            'TRANSLATION_ID': 'Hello there!',
            'WITH_VALUES': 'The following value is dynamic: {{value}}',
            'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
          }).preferredLanguage('en');
  
        });
  
        angular.module('ngView').controller('TranslateCtrl', function ($scope) {
          $scope.translationId = 'TRANSLATION_ID';
  
          $scope.values = {
            value: 78
          };
        });
      </file>
      <file name="scenario.js">
        it('should translate', function () {
          inject(function ($rootScope, $compile) {
            $rootScope.translationId = 'TRANSLATION_ID';
  
            element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
            $rootScope.$digest();
            expect(element.text()).toBe('Hello there!');
  
            element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
            $rootScope.$digest();
            expect(element.text()).toBe('Hello there!');
  
            element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
            $rootScope.$digest();
            expect(element.text()).toBe('Hello there!');
  
            element = $compile('<p translate>{{translationId}}</p>')($rootScope);
            $rootScope.$digest();
            expect(element.text()).toBe('Hello there!');
  
            element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
            $rootScope.$digest();
            expect(element.attr('title')).toBe('Hello there!');
  
            element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
            $rootScope.$digest();
            expect(element.text()).toBe('The interpolation key is camel cased: Hello');
          });
        });
      </file>
     </example>
   */
  .directive('translate', translateDirective);
  function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {

    'use strict';

    /**
     * @name trim
     * @private
     *
     * @description
     * trim polyfill
     *
     * @returns {string} The string stripped of whitespace from both ends
     */

    var trim = function trim() {
      return this.toString().replace(/^\s+|\s+$/g, '');
    };

    /**
     * @name lowercase
     * @private
     *
     * @description
     * Return the lowercase string only if the type is string
     *
     * @returns {string} The string all in lowercase
     */
    var lowercase = function lowercase(string) {
      return angular.isString(string) ? string.toLowerCase() : string;
    };

    return {
      restrict: 'AE',
      scope: true,
      priority: $translate.directivePriority(),
      compile: function compile(tElement, tAttr) {

        var translateValuesExist = tAttr.translateValues ? tAttr.translateValues : undefined;

        var translateInterpolation = tAttr.translateInterpolation ? tAttr.translateInterpolation : undefined;

        var translateSanitizeStrategyExist = tAttr.translateSanitizeStrategy ? tAttr.translateSanitizeStrategy : undefined;

        var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);

        var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
            watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';

        return function linkFn(scope, iElement, iAttr) {

          scope.interpolateParams = {};
          scope.preText = '';
          scope.postText = '';
          scope.translateNamespace = getTranslateNamespace(scope);
          var translationIds = {};

          var initInterpolationParams = function initInterpolationParams(interpolateParams, iAttr, tAttr) {
            // initial setup
            if (iAttr.translateValues) {
              angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
            }
            // initially fetch all attributes if existing and fill the params
            if (translateValueExist) {
              for (var attr in tAttr) {
                if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                  var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
                  interpolateParams[attributeName] = tAttr[attr];
                }
              }
            }
          };

          // Ensures any change of the attribute "translate" containing the id will
          // be re-stored to the scope's "translationId".
          // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
          var observeElementTranslation = function observeElementTranslation(translationId) {

            // Remove any old watcher
            if (angular.isFunction(observeElementTranslation._unwatchOld)) {
              observeElementTranslation._unwatchOld();
              observeElementTranslation._unwatchOld = undefined;
            }

            if (angular.equals(translationId, '') || !angular.isDefined(translationId)) {
              var iElementText = trim.apply(iElement.text()).replace(/\n/g, ' ');

              // Resolve translation id by inner html if required
              var interpolateMatches = iElementText.match(interpolateRegExp);
              // Interpolate translation id if required
              if (angular.isArray(interpolateMatches)) {
                scope.preText = interpolateMatches[1];
                scope.postText = interpolateMatches[3];
                translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
                var watcherMatches = iElementText.match(watcherRegExp);
                if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
                  observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
                    translationIds.translate = newValue;
                    updateTranslations();
                  });
                }
              } else {
                // do not assigne the translation id if it is empty.
                translationIds.translate = !iElementText ? undefined : iElementText;
              }
            } else {
              translationIds.translate = translationId;
            }
            updateTranslations();
          };

          var observeAttributeTranslation = function observeAttributeTranslation(translateAttr) {
            iAttr.$observe(translateAttr, function (translationId) {
              translationIds[translateAttr] = translationId;
              updateTranslations();
            });
          };

          // initial setup with values
          initInterpolationParams(scope.interpolateParams, iAttr, tAttr);

          var firstAttributeChangedEvent = true;
          iAttr.$observe('translate', function (translationId) {
            if (typeof translationId === 'undefined') {
              // case of element "<translate>xyz</translate>"
              observeElementTranslation('');
            } else {
              // case of regular attribute
              if (translationId !== '' || !firstAttributeChangedEvent) {
                translationIds.translate = translationId;
                updateTranslations();
              }
            }
            firstAttributeChangedEvent = false;
          });

          for (var translateAttr in iAttr) {
            if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
              observeAttributeTranslation(translateAttr);
            }
          }

          iAttr.$observe('translateDefault', function (value) {
            scope.defaultText = value;
            updateTranslations();
          });

          if (translateSanitizeStrategyExist) {
            iAttr.$observe('translateSanitizeStrategy', function (value) {
              scope.sanitizeStrategy = $parse(value)(scope.$parent);
              updateTranslations();
            });
          }

          if (translateValuesExist) {
            iAttr.$observe('translateValues', function (interpolateParams) {
              if (interpolateParams) {
                scope.$parent.$watch(function () {
                  angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
                });
              }
            });
          }

          if (translateValueExist) {
            var observeValueAttribute = function observeValueAttribute(attrName) {
              iAttr.$observe(attrName, function (value) {
                var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
                scope.interpolateParams[attributeName] = value;
              });
            };
            for (var attr in iAttr) {
              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                observeValueAttribute(attr);
              }
            }
          }

          // Master update function
          var updateTranslations = function updateTranslations() {
            for (var key in translationIds) {
              if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
                updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
              }
            }
          };

          // Put translation processing function outside loop
          var updateTranslation = function updateTranslation(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
            if (translationId) {
              // if translation id starts with '.' and translateNamespace given, prepend namespace
              if (translateNamespace && translationId.charAt(0) === '.') {
                translationId = translateNamespace + translationId;
              }

              $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy).then(function (translation) {
                applyTranslation(translation, scope, true, translateAttr);
              }, function (translationId) {
                applyTranslation(translationId, scope, false, translateAttr);
              });
            } else {
              // as an empty string cannot be translated, we can solve this using successful=false
              applyTranslation(translationId, scope, false, translateAttr);
            }
          };

          var applyTranslation = function applyTranslation(value, scope, successful, translateAttr) {
            if (!successful) {
              if (typeof scope.defaultText !== 'undefined') {
                value = scope.defaultText;
              }
            }
            if (translateAttr === 'translate') {
              // default translate into innerHTML
              if (successful || !successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined') {
                iElement.empty().append(scope.preText + value + scope.postText);
              }
              var globallyEnabled = $translate.isPostCompilingEnabled();
              var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
              var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
              if (globallyEnabled && !locallyDefined || locallyEnabled) {
                $compile(iElement.contents())(scope);
              }
            } else {
              // translate attribute
              var attributeName = iAttr.$attr[translateAttr];
              if (attributeName.substr(0, 5) === 'data-') {
                // ensure html5 data prefix is stripped
                attributeName = attributeName.substr(5);
              }
              attributeName = attributeName.substr(15);
              iElement.attr(attributeName, value);
            }
          };

          if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
            scope.$watch('interpolateParams', updateTranslations, true);
          }

          // Replaced watcher on translateLanguage with event listener
          scope.$on('translateLanguageChanged', updateTranslations);

          // Ensures the text will be refreshed after the current language was changed
          // w/ $translate.use(...)
          var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

          // ensure translation will be looked up at least one
          if (iElement.text().length) {
            if (iAttr.translate) {
              observeElementTranslation(iAttr.translate);
            } else {
              observeElementTranslation('');
            }
          } else if (iAttr.translate) {
            // ensure attribute will be not skipped
            observeElementTranslation(iAttr.translate);
          }
          updateTranslations();
          scope.$on('$destroy', unbind);
        };
      }
    };
  }

  /**
   * Returns the scope's namespace.
   * @private
   * @param scope
   * @returns {string}
   */
  function getTranslateNamespace(scope) {
    'use strict';

    if (scope.translateNamespace) {
      return scope.translateNamespace;
    }
    if (scope.$parent) {
      return getTranslateNamespace(scope.$parent);
    }
  }

  translateDirective.displayName = 'translateDirective';

  angular.module('pascalprecht.translate')
  /**
   * @ngdoc directive
   * @name pascalprecht.translate.directive:translate-attr
   * @restrict A
   *
   * @description
   * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
   * Internally it uses `translate` service to translate translation id. It possible to
   * pass an optional `translate-values` object literal as string into translation id.
   *
   * @param {string=} translate-attr Object literal mapping attributes to translation ids.
   * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
   * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
   *
   * @example
     <example module="ngView">
      <file name="index.html">
        <div ng-controller="TranslateCtrl">
  
          <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />
  
        </div>
      </file>
      <file name="script.js">
        angular.module('ngView', ['pascalprecht.translate'])
  
        .config(function ($translateProvider) {
  
          $translateProvider.translations('en',{
            'TRANSLATION_ID': 'Hello there!',
            'WITH_VALUES': 'The following value is dynamic: {{value}}',
          }).preferredLanguage('en');
  
        });
  
        angular.module('ngView').controller('TranslateCtrl', function ($scope) {
          $scope.translationId = 'TRANSLATION_ID';
  
          $scope.values = {
            value: 78
          };
        });
      </file>
      <file name="scenario.js">
        it('should translate', function () {
          inject(function ($rootScope, $compile) {
            $rootScope.translationId = 'TRANSLATION_ID';
  
            element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
            $rootScope.$digest();
            expect(element.attr('placeholder)).toBe('Hello there!');
            expect(element.attr('title)).toBe('The following value is dynamic: 5');
          });
        });
      </file>
     </example>
   */
  .directive('translateAttr', translateAttrDirective);
  function translateAttrDirective($translate, $rootScope) {

    'use strict';

    return {
      restrict: 'A',
      priority: $translate.directivePriority(),
      link: function linkFn(scope, element, attr) {

        var translateAttr,
            translateValues,
            translateSanitizeStrategy,
            previousAttributes = {};

        // Main update translations function
        var updateTranslations = function updateTranslations() {
          angular.forEach(translateAttr, function (translationId, attributeName) {
            if (!translationId) {
              return;
            }
            previousAttributes[attributeName] = true;

            // if translation id starts with '.' and translateNamespace given, prepend namespace
            if (scope.translateNamespace && translationId.charAt(0) === '.') {
              translationId = scope.translateNamespace + translationId;
            }
            $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy).then(function (translation) {
              element.attr(attributeName, translation);
            }, function (translationId) {
              element.attr(attributeName, translationId);
            });
          });

          // Removing unused attributes that were previously used
          angular.forEach(previousAttributes, function (flag, attributeName) {
            if (!translateAttr[attributeName]) {
              element.removeAttr(attributeName);
              delete previousAttributes[attributeName];
            }
          });
        };

        // Watch for attribute changes
        watchAttribute(scope, attr.translateAttr, function (newValue) {
          translateAttr = newValue;
        }, updateTranslations);
        // Watch for value changes
        watchAttribute(scope, attr.translateValues, function (newValue) {
          translateValues = newValue;
        }, updateTranslations);
        // Watch for sanitize strategy changes
        watchAttribute(scope, attr.translateSanitizeStrategy, function (newValue) {
          translateSanitizeStrategy = newValue;
        }, updateTranslations);

        if (attr.translateValues) {
          scope.$watch(attr.translateValues, updateTranslations, true);
        }

        // Replaced watcher on translateLanguage with event listener
        scope.$on('translateLanguageChanged', updateTranslations);

        // Ensures the text will be refreshed after the current language was changed
        // w/ $translate.use(...)
        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

        updateTranslations();
        scope.$on('$destroy', unbind);
      }
    };
  }

  function watchAttribute(scope, attribute, valueCallback, changeCallback) {
    'use strict';

    if (!attribute) {
      return;
    }
    if (attribute.substr(0, 2) === '::') {
      attribute = attribute.substr(2);
    } else {
      scope.$watch(attribute, function (newValue) {
        valueCallback(newValue);
        changeCallback();
      }, true);
    }
    valueCallback(scope.$eval(attribute));
  }

  translateAttrDirective.displayName = 'translateAttrDirective';

  angular.module('pascalprecht.translate')
  /**
   * @ngdoc directive
   * @name pascalprecht.translate.directive:translateCloak
   * @requires $translate
   * @restrict A
   *
   * $description
   * Adds a `translate-cloak` class name to the given element where this directive
   * is applied initially and removes it, once a loader has finished loading.
   *
   * This directive can be used to prevent initial flickering when loading translation
   * data asynchronously.
   *
   * The class name is defined in
   * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
   *
   * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
   *                                  or hiding the cloak. Basically it relies on the translation
   *                                  resolve.
   */
  .directive('translateCloak', translateCloakDirective);

  function translateCloakDirective($translate, $rootScope) {

    'use strict';

    return {
      compile: function compile(tElement) {
        var applyCloak = function applyCloak(element) {
          element.addClass($translate.cloakClassName());
        },
            removeCloak = function removeCloak(element) {
          element.removeClass($translate.cloakClassName());
        };
        applyCloak(tElement);

        return function linkFn(scope, iElement, iAttr) {
          //Create bound functions that incorporate the active DOM element.
          var iRemoveCloak = removeCloak.bind(this, iElement),
              iApplyCloak = applyCloak.bind(this, iElement);
          if (iAttr.translateCloak && iAttr.translateCloak.length) {
            // Register a watcher for the defined translation allowing a fine tuned cloak
            iAttr.$observe('translateCloak', function (translationId) {
              $translate(translationId).then(iRemoveCloak, iApplyCloak);
            });
            $rootScope.$on('$translateChangeSuccess', function () {
              $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
            });
          } else {
            $translate.onReady(iRemoveCloak);
          }
        };
      }
    };
  }

  translateCloakDirective.displayName = 'translateCloakDirective';

  angular.module('pascalprecht.translate')
  /**
   * @ngdoc directive
   * @name pascalprecht.translate.directive:translateNamespace
   * @restrict A
   *
   * @description
   * Translates given translation id either through attribute or DOM content.
   * Internally it uses `translate` filter to translate translation id. It is possible to
   * pass an optional `translate-values` object literal as string into translation id.
   *
   * @param {string=} translate namespace name which could be either string or interpolated string.
   *
   * @example
     <example module="ngView">
      <file name="index.html">
        <div translate-namespace="CONTENT">
  
          <div>
              <h1 translate>.HEADERS.TITLE</h1>
              <h1 translate>.HEADERS.WELCOME</h1>
          </div>
  
          <div translate-namespace=".HEADERS">
              <h1 translate>.TITLE</h1>
              <h1 translate>.WELCOME</h1>
          </div>
  
        </div>
      </file>
      <file name="script.js">
        angular.module('ngView', ['pascalprecht.translate'])
  
        .config(function ($translateProvider) {
  
          $translateProvider.translations('en',{
            'TRANSLATION_ID': 'Hello there!',
            'CONTENT': {
              'HEADERS': {
                  TITLE: 'Title'
              }
            },
            'CONTENT.HEADERS.WELCOME': 'Welcome'
          }).preferredLanguage('en');
  
        });
  
      </file>
     </example>
   */
  .directive('translateNamespace', translateNamespaceDirective);

  function translateNamespaceDirective() {

    'use strict';

    return {
      restrict: 'A',
      scope: true,
      compile: function compile() {
        return {
          pre: function pre(scope, iElement, iAttrs) {
            scope.translateNamespace = _getTranslateNamespace(scope);

            if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
              scope.translateNamespace += iAttrs.translateNamespace;
            } else {
              scope.translateNamespace = iAttrs.translateNamespace;
            }
          }
        };
      }
    };
  }

  /**
   * Returns the scope's namespace.
   * @private
   * @param scope
   * @returns {string}
   */
  function _getTranslateNamespace(scope) {
    'use strict';

    if (scope.translateNamespace) {
      return scope.translateNamespace;
    }
    if (scope.$parent) {
      return _getTranslateNamespace(scope.$parent);
    }
  }

  translateNamespaceDirective.displayName = 'translateNamespaceDirective';

  angular.module('pascalprecht.translate')
  /**
   * @ngdoc directive
   * @name pascalprecht.translate.directive:translateLanguage
   * @restrict A
   *
   * @description
   * Forces the language to the directives in the underlying scope.
   *
   * @param {string=} translate language that will be negotiated.
   *
   * @example
     <example module="ngView">
      <file name="index.html">
        <div>
  
          <div>
              <h1 translate>HELLO</h1>
          </div>
  
          <div translate-language="de">
              <h1 translate>HELLO</h1>
          </div>
  
        </div>
      </file>
      <file name="script.js">
        angular.module('ngView', ['pascalprecht.translate'])
  
        .config(function ($translateProvider) {
  
          $translateProvider
            .translations('en',{
              'HELLO': 'Hello world!'
            })
            .translations('de',{
              'HELLO': 'Hallo Welt!'
            })
            .preferredLanguage('en');
  
        });
  
      </file>
     </example>
   */
  .directive('translateLanguage', translateLanguageDirective);

  function translateLanguageDirective() {

    'use strict';

    return {
      restrict: 'A',
      scope: true,
      compile: function compile() {
        return function linkFn(scope, iElement, iAttrs) {

          iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
            scope.translateLanguage = newTranslateLanguage;
          });

          scope.$watch('translateLanguage', function () {
            scope.$broadcast('translateLanguageChanged');
          });
        };
      }
    };
  }

  translateLanguageDirective.displayName = 'translateLanguageDirective';

  angular.module('pascalprecht.translate')
  /**
   * @ngdoc filter
   * @name pascalprecht.translate.filter:translate
   * @requires $parse
   * @requires pascalprecht.translate.$translate
   * @function
   *
   * @description
   * Uses `$translate` service to translate contents. Accepts interpolate parameters
   * to pass dynamized values though translation.
   *
   * @param {string} translationId A translation id to be translated.
   * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
   *
   * @returns {string} Translated text.
   *
   * @example
     <example module="ngView">
      <file name="index.html">
        <div ng-controller="TranslateCtrl">
  
          <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
          <pre>{{ translationId | translate }}</pre>
          <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
          <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
  
        </div>
      </file>
      <file name="script.js">
        angular.module('ngView', ['pascalprecht.translate'])
  
        .config(function ($translateProvider) {
  
          $translateProvider.translations('en', {
            'TRANSLATION_ID': 'Hello there!',
            'WITH_VALUES': 'The following value is dynamic: {{value}}'
          });
          $translateProvider.preferredLanguage('en');
  
        });
  
        angular.module('ngView').controller('TranslateCtrl', function ($scope) {
          $scope.translationId = 'TRANSLATION_ID';
  
          $scope.values = {
            value: 78
          };
        });
      </file>
     </example>
   */
  .filter('translate', translateFilterFactory);

  function translateFilterFactory($parse, $translate) {

    'use strict';

    var translateFilter = function translateFilter(translationId, interpolateParams, interpolation, forceLanguage) {
      if (!angular.isObject(interpolateParams)) {
        var ctx = this || {
          '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
        };
        interpolateParams = $parse(interpolateParams)(ctx);
      }

      return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
    };

    if ($translate.statefulFilter()) {
      translateFilter.$stateful = true;
    }

    return translateFilter;
  }

  translateFilterFactory.displayName = 'translateFilterFactory';

  angular.module('pascalprecht.translate')

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translationCache
   * @requires $cacheFactory
   *
   * @description
   * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
   * can load translation tables directly into the cache by consuming the
   * `$translationCache` service directly.
   *
   * @return {object} $cacheFactory object.
   */
  .factory('$translationCache', $translationCache);

  function $translationCache($cacheFactory) {

    'use strict';

    return $cacheFactory('translations');
  }

  $translationCache.displayName = '$translationCache';
  return 'pascalprecht.translate';
});

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * angular-translate - v2.18.4 - 2021-01-14
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return factory();
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
})(undefined, function () {

  $translateUrlLoader.$inject = ['$q', '$http'];
  angular.module('pascalprecht.translate')
  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateUrlLoader
   * @requires $q
   * @requires $http
   *
   * @description
   * Creates a loading function for a typical dynamic url pattern:
   * "locale.php?lang=en_US", "locale.php?lang=de_DE", "locale.php?language=nl_NL" etc.
   * Prefixing the specified url, the current requested, language id will be applied
   * with "?{queryParameter}={key}".
   * Using this service, the response of these urls must be an object of
   * key-value pairs.
   *
   * @param {object} options Options object, which gets the url, key and
   * optional queryParameter ('lang' is used by default).
   */
  .factory('$translateUrlLoader', $translateUrlLoader);

  function $translateUrlLoader($q, $http) {

    'use strict';

    return function (options) {

      if (!options || !options.url) {
        throw new Error('Couldn\'t use urlLoader since no url is given!');
      }

      var requestParams = {};

      requestParams[options.queryParameter || 'lang'] = options.key;

      return $http(angular.extend({
        url: options.url,
        params: requestParams,
        method: 'GET'
      }, options.$http)).then(function (result) {
        return result.data;
      }, function () {
        return $q.reject(options.key);
      });
    };
  }

  $translateUrlLoader.displayName = '$translateUrlLoader';
  return 'pascalprecht.translate';
});

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignalRHub = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(22);

var _angular2 = _interopRequireDefault(_angular);

var _lodash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lodash);

var _jquery = __webpack_require__(846);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function initNewConnection(options) {
    var connection = null;
    if (options && options.rootPath) {
        connection = (0, _jquery.hubConnection)(options.rootPath, { useDefaultPath: false });
    } else {
        connection = (0, _jquery.hubConnection)();
    }

    connection.logging = !!(options && options.logging);
    return connection;
}

function getConnection(options) {
    return initNewConnection(options);
}

function makeArray(array) {
    var ret = [];

    if (array !== null) {
        var i = array.length;
        // The window, strings (and functions) also have 'length'
        if (i === null || typeof array === "string" || _.isFunction(array) || array.setInterval) ret[0] = array;else while (i) {
            ret[--i] = array[i];
        }
    }

    return ret;
}

var SignalRHub = exports.SignalRHub = function () {
    function SignalRHub(hubName, options) {
        var _this = this,
            _arguments = arguments;

        _classCallCheck(this, SignalRHub);

        this.options = options;
        this.connection = getConnection(options);
        this.proxy = this.connection.createHubProxy(hubName);

        if (options && options.listeners) {
            Object.getOwnPropertyNames(options.listeners).filter(function (propName) {
                return typeof options.listeners[propName] === 'function';
            }).forEach(function (propName) {
                _this.on(propName, options.listeners[propName]);
            });
        }

        if (options && options.methods) {
            _.each(options.methods, function (method) {
                _this[method] = function () {
                    var args = makeArray(_arguments);
                    args.unshift(method);
                    return _this.invoke.apply(_this, args);
                };
            });
        }
        if (options && options.queryParams) {
            this.connection.qs = options.queryParams;
        }
        if (options && options.errorHandler) {
            this.connection.error(options.errorHandler);
        }
        if (options && options.stateChanged) {
            this.connection.stateChanged(options.stateChanged);
        }

        //Adding additional property of promise allows to access it in rest of the application.
        if (options.autoConnect === undefined || options.autoConnect) {
            this.promise = this.connect();
        }
    }

    _createClass(SignalRHub, [{
        key: 'on',
        value: function on(event, fn) {
            this.proxy.on(event, fn);
        }
    }, {
        key: 'invoke',
        value: function invoke(method, args) {
            return this.proxy.invoke.apply(Hub.proxy, arguments);
        }
    }, {
        key: 'disconnect',
        value: function disconnect() {
            this.connection.stop();
        }
    }, {
        key: 'connect',
        value: function connect(queryParams) {
            var startOptions = {};
            if (this.options.transport) startOptions.transport = this.options.transport;
            if (this.options.jsonp) startOptions.jsonp = this.options.jsonp;
            if (!_.isUndefined(this.options.withCredentials)) startOptions.withCredentials = this.options.withCredentials;
            if (queryParams) this.connection.qs = queryParams;
            return this.connection.start(startOptions);
        }
    }]);

    return SignalRHub;
}();

exports.default = _angular2.default.module('SignalR', []).constant('$', window.jQuery).factory('Hub', [function () {
    //This will allow same connection to be used for all Hubs
    //It also keeps connection as singleton.
    var globalConnections = [];

    return SignalRHub;
}]);

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _jquery = __webpack_require__(84);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* jquery.signalR.core.js */
/*global window:false */
/*!
 * ASP.NET SignalR JavaScript Library v2.2.1
 * http://signalr.net/
 *
 * Copyright (c) .NET Foundation. All rights reserved.
 * Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *
 */
window.jQuery = window.jQuery || _jquery2.default;
/// <reference path="Scripts/jquery-1.6.4.js" />
/// <reference path="jquery.signalR.version.js" />
(function ($, window, undefined) {

    var resources = {
        nojQuery: "jQuery was not found. Please ensure jQuery is referenced before the SignalR client JavaScript file.",
        noTransportOnInit: "No transport could be initialized successfully. Try specifying a different transport or none at all for auto initialization.",
        errorOnNegotiate: "Error during negotiation request.",
        stoppedWhileLoading: "The connection was stopped during page load.",
        stoppedWhileNegotiating: "The connection was stopped during the negotiate request.",
        errorParsingNegotiateResponse: "Error parsing negotiate response.",
        errorDuringStartRequest: "Error during start request. Stopping the connection.",
        stoppedDuringStartRequest: "The connection was stopped during the start request.",
        errorParsingStartResponse: "Error parsing start response: '{0}'. Stopping the connection.",
        invalidStartResponse: "Invalid start response: '{0}'. Stopping the connection.",
        protocolIncompatible: "You are using a version of the client that isn't compatible with the server. Client version {0}, server version {1}.",
        sendFailed: "Send failed.",
        parseFailed: "Failed at parsing response: {0}",
        longPollFailed: "Long polling request failed.",
        eventSourceFailedToConnect: "EventSource failed to connect.",
        eventSourceError: "Error raised by EventSource",
        webSocketClosed: "WebSocket closed.",
        pingServerFailedInvalidResponse: "Invalid ping response when pinging server: '{0}'.",
        pingServerFailed: "Failed to ping server.",
        pingServerFailedStatusCode: "Failed to ping server.  Server responded with status code {0}, stopping the connection.",
        pingServerFailedParse: "Failed to parse ping server response, stopping the connection.",
        noConnectionTransport: "Connection is in an invalid state, there is no transport active.",
        webSocketsInvalidState: "The Web Socket transport is in an invalid state, transitioning into reconnecting.",
        reconnectTimeout: "Couldn't reconnect within the configured timeout of {0} ms, disconnecting.",
        reconnectWindowTimeout: "The client has been inactive since {0} and it has exceeded the inactivity timeout of {1} ms. Stopping the connection."
    };

    if (typeof $ !== "function") {
        // no jQuery!
        throw new Error(resources.nojQuery);
    }

    var _signalR,
        _connection,
        _pageLoaded = window.document.readyState === "complete",
        _pageWindow = $(window),
        _negotiateAbortText = "__Negotiate Aborted__",
        events = {
        onStart: "onStart",
        onStarting: "onStarting",
        onReceived: "onReceived",
        onError: "onError",
        onConnectionSlow: "onConnectionSlow",
        onReconnecting: "onReconnecting",
        onReconnect: "onReconnect",
        onStateChanged: "onStateChanged",
        onDisconnect: "onDisconnect"
    },
        ajaxDefaults = {
        processData: true,
        timeout: null,
        async: true,
        global: false,
        cache: false
    },
        _log = function _log(msg, logging) {
        if (logging === false) {
            return;
        }
        var m;
        if (typeof window.console === "undefined") {
            return;
        }
        m = "[" + new Date().toTimeString() + "] SignalR: " + msg;
        if (window.console.debug) {
            window.console.debug(m);
        } else if (window.console.log) {
            window.console.log(m);
        }
    },
        changeState = function changeState(connection, expectedState, newState) {
        if (expectedState === connection.state) {
            connection.state = newState;

            $(connection).triggerHandler(events.onStateChanged, [{ oldState: expectedState, newState: newState }]);
            return true;
        }

        return false;
    },
        isDisconnecting = function isDisconnecting(connection) {
        return connection.state === _signalR.connectionState.disconnected;
    },
        supportsKeepAlive = function supportsKeepAlive(connection) {
        return connection._.keepAliveData.activated && connection.transport.supportsKeepAlive(connection);
    },
        configureStopReconnectingTimeout = function configureStopReconnectingTimeout(connection) {
        var stopReconnectingTimeout, onReconnectTimeout;

        // Check if this connection has already been configured to stop reconnecting after a specified timeout.
        // Without this check if a connection is stopped then started events will be bound multiple times.
        if (!connection._.configuredStopReconnectingTimeout) {
            onReconnectTimeout = function onReconnectTimeout(connection) {
                var message = _signalR._.format(_signalR.resources.reconnectTimeout, connection.disconnectTimeout);
                connection.log(message);
                $(connection).triggerHandler(events.onError, [_signalR._.error(message, /* source */"TimeoutException")]);
                connection.stop( /* async */false, /* notifyServer */false);
            };

            connection.reconnecting(function () {
                var connection = this;

                // Guard against state changing in a previous user defined even handler
                if (connection.state === _signalR.connectionState.reconnecting) {
                    stopReconnectingTimeout = window.setTimeout(function () {
                        onReconnectTimeout(connection);
                    }, connection.disconnectTimeout);
                }
            });

            connection.stateChanged(function (data) {
                if (data.oldState === _signalR.connectionState.reconnecting) {
                    // Clear the pending reconnect timeout check
                    window.clearTimeout(stopReconnectingTimeout);
                }
            });

            connection._.configuredStopReconnectingTimeout = true;
        }
    };

    _signalR = function signalR(url, qs, logging) {
        /// <summary>Creates a new SignalR connection for the given url</summary>
        /// <param name="url" type="String">The URL of the long polling endpoint</param>
        /// <param name="qs" type="Object">
        ///     [Optional] Custom querystring parameters to add to the connection URL.
        ///     If an object, every non-function member will be added to the querystring.
        ///     If a string, it's added to the QS as specified.
        /// </param>
        /// <param name="logging" type="Boolean">
        ///     [Optional] A flag indicating whether connection logging is enabled to the browser
        ///     console/log. Defaults to false.
        /// </param>

        return new _signalR.fn.init(url, qs, logging);
    };

    _signalR._ = {
        defaultContentType: "application/x-www-form-urlencoded; charset=UTF-8",

        ieVersion: function () {
            var version, matches;

            if (window.navigator.appName === 'Microsoft Internet Explorer') {
                // Check if the user agent has the pattern "MSIE (one or more numbers).(one or more numbers)";
                matches = /MSIE ([0-9]+\.[0-9]+)/.exec(window.navigator.userAgent);

                if (matches) {
                    version = window.parseFloat(matches[1]);
                }
            }

            // undefined value means not IE
            return version;
        }(),

        error: function error(message, source, context) {
            var e = new Error(message);
            e.source = source;

            if (typeof context !== "undefined") {
                e.context = context;
            }

            return e;
        },

        transportError: function transportError(message, transport, source, context) {
            var e = this.error(message, source, context);
            e.transport = transport ? transport.name : undefined;
            return e;
        },

        format: function format() {
            /// <summary>Usage: format("Hi {0}, you are {1}!", "Foo", 100) </summary>
            var s = arguments[0];
            for (var i = 0; i < arguments.length - 1; i++) {
                s = s.replace("{" + i + "}", arguments[i + 1]);
            }
            return s;
        },

        firefoxMajorVersion: function firefoxMajorVersion(userAgent) {
            // Firefox user agents: http://useragentstring.com/pages/Firefox/
            var matches = userAgent.match(/Firefox\/(\d+)/);
            if (!matches || !matches.length || matches.length < 2) {
                return 0;
            }
            return parseInt(matches[1], 10 /* radix */);
        },

        configurePingInterval: function configurePingInterval(connection) {
            var config = connection._.config,
                onFail = function onFail(error) {
                $(connection).triggerHandler(events.onError, [error]);
            };

            if (config && !connection._.pingIntervalId && config.pingInterval) {
                connection._.pingIntervalId = window.setInterval(function () {
                    _signalR.transports._logic.pingServer(connection).fail(onFail);
                }, config.pingInterval);
            }
        }
    };

    _signalR.events = events;

    _signalR.resources = resources;

    _signalR.ajaxDefaults = ajaxDefaults;

    _signalR.changeState = changeState;

    _signalR.isDisconnecting = isDisconnecting;

    _signalR.connectionState = {
        connecting: 0,
        connected: 1,
        reconnecting: 2,
        disconnected: 4
    };

    _signalR.hub = {
        start: function start() {
            // This will get replaced with the real hub connection start method when hubs is referenced correctly
            throw new Error("SignalR: Error loading hubs. Ensure your hubs reference is correct, e.g. <script src='/signalr/js'></script>.");
        }
    };

    // .on() was added in version 1.7.0, .load() was removed in version 3.0.0 so we fallback to .load() if .on() does
    // not exist to not break existing applications
    if (typeof _pageWindow.on == "function") {
        _pageWindow.on("load", function () {
            _pageLoaded = true;
        });
    } else {
        _pageWindow.load(function () {
            _pageLoaded = true;
        });
    }

    function validateTransport(requestedTransport, connection) {
        /// <summary>Validates the requested transport by cross checking it with the pre-defined signalR.transports</summary>
        /// <param name="requestedTransport" type="Object">The designated transports that the user has specified.</param>
        /// <param name="connection" type="signalR">The connection that will be using the requested transports.  Used for logging purposes.</param>
        /// <returns type="Object" />

        if ($.isArray(requestedTransport)) {
            // Go through transport array and remove an "invalid" tranports
            for (var i = requestedTransport.length - 1; i >= 0; i--) {
                var transport = requestedTransport[i];
                if ($.type(transport) !== "string" || !_signalR.transports[transport]) {
                    connection.log("Invalid transport: " + transport + ", removing it from the transports list.");
                    requestedTransport.splice(i, 1);
                }
            }

            // Verify we still have transports left, if we dont then we have invalid transports
            if (requestedTransport.length === 0) {
                connection.log("No transports remain within the specified transport array.");
                requestedTransport = null;
            }
        } else if (!_signalR.transports[requestedTransport] && requestedTransport !== "auto") {
            connection.log("Invalid transport: " + requestedTransport.toString() + ".");
            requestedTransport = null;
        } else if (requestedTransport === "auto" && _signalR._.ieVersion <= 8) {
            // If we're doing an auto transport and we're IE8 then force longPolling, #1764
            return ["longPolling"];
        }

        return requestedTransport;
    }

    function getDefaultPort(protocol) {
        if (protocol === "http:") {
            return 80;
        } else if (protocol === "https:") {
            return 443;
        }
    }

    function addDefaultPort(protocol, url) {
        // Remove ports  from url.  We have to check if there's a / or end of line
        // following the port in order to avoid removing ports such as 8080.
        if (url.match(/:\d+$/)) {
            return url;
        } else {
            return url + ":" + getDefaultPort(protocol);
        }
    }

    function ConnectingMessageBuffer(connection, drainCallback) {
        var that = this,
            buffer = [];

        that.tryBuffer = function (message) {
            if (connection.state === $.signalR.connectionState.connecting) {
                buffer.push(message);

                return true;
            }

            return false;
        };

        that.drain = function () {
            // Ensure that the connection is connected when we drain (do not want to drain while a connection is not active)
            if (connection.state === $.signalR.connectionState.connected) {
                while (buffer.length > 0) {
                    drainCallback(buffer.shift());
                }
            }
        };

        that.clear = function () {
            buffer = [];
        };
    }

    _signalR.fn = _signalR.prototype = {
        init: function init(url, qs, logging) {
            var $connection = $(this);

            this.url = url;
            this.qs = qs;
            this.lastError = null;
            this._ = {
                keepAliveData: {},
                connectingMessageBuffer: new ConnectingMessageBuffer(this, function (message) {
                    $connection.triggerHandler(events.onReceived, [message]);
                }),
                lastMessageAt: new Date().getTime(),
                lastActiveAt: new Date().getTime(),
                beatInterval: 5000, // Default value, will only be overridden if keep alive is enabled,
                beatHandle: null,
                totalTransportConnectTimeout: 0 // This will be the sum of the TransportConnectTimeout sent in response to negotiate and connection.transportConnectTimeout
            };
            if (typeof logging === "boolean") {
                this.logging = logging;
            }
        },

        _parseResponse: function _parseResponse(response) {
            var that = this;

            if (!response) {
                return response;
            } else if (typeof response === "string") {
                return that.json.parse(response);
            } else {
                return response;
            }
        },

        _originalJson: window.JSON,

        json: window.JSON,

        isCrossDomain: function isCrossDomain(url, against) {
            /// <summary>Checks if url is cross domain</summary>
            /// <param name="url" type="String">The base URL</param>
            /// <param name="against" type="Object">
            ///     An optional argument to compare the URL against, if not specified it will be set to window.location.
            ///     If specified it must contain a protocol and a host property.
            /// </param>
            var link;

            url = $.trim(url);

            against = against || window.location;

            if (url.indexOf("http") !== 0) {
                return false;
            }

            // Create an anchor tag.
            link = window.document.createElement("a");
            link.href = url;

            // When checking for cross domain we have to special case port 80 because the window.location will remove the
            return link.protocol + addDefaultPort(link.protocol, link.host) !== against.protocol + addDefaultPort(against.protocol, against.host);
        },

        ajaxDataType: "text",

        contentType: "application/json; charset=UTF-8",

        logging: false,

        state: _signalR.connectionState.disconnected,

        clientProtocol: "1.5",

        reconnectDelay: 2000,

        transportConnectTimeout: 0,

        disconnectTimeout: 30000, // This should be set by the server in response to the negotiate request (30s default)

        reconnectWindow: 30000, // This should be set by the server in response to the negotiate request

        keepAliveWarnAt: 2 / 3, // Warn user of slow connection if we breach the X% mark of the keep alive timeout

        start: function start(options, callback) {
            /// <summary>Starts the connection</summary>
            /// <param name="options" type="Object">Options map</param>
            /// <param name="callback" type="Function">A callback function to execute when the connection has started</param>
            var connection = this,
                config = {
                pingInterval: 300000,
                waitForPageLoad: true,
                transport: "auto",
                jsonp: false
            },
                _initialize,
                deferred = connection._deferral || $.Deferred(),
                // Check to see if there is a pre-existing deferral that's being built on, if so we want to keep using it
            parser = window.document.createElement("a");

            connection.lastError = null;

            // Persist the deferral so that if start is called multiple times the same deferral is used.
            connection._deferral = deferred;

            if (!connection.json) {
                // no JSON!
                throw new Error("SignalR: No JSON parser found. Please ensure json2.js is referenced before the SignalR.js file if you need to support clients without native JSON parsing support, e.g. IE<8.");
            }

            if ($.type(options) === "function") {
                // Support calling with single callback parameter
                callback = options;
            } else if ($.type(options) === "object") {
                $.extend(config, options);
                if ($.type(config.callback) === "function") {
                    callback = config.callback;
                }
            }

            config.transport = validateTransport(config.transport, connection);

            // If the transport is invalid throw an error and abort start
            if (!config.transport) {
                throw new Error("SignalR: Invalid transport(s) specified, aborting start.");
            }

            connection._.config = config;

            // Check to see if start is being called prior to page load
            // If waitForPageLoad is true we then want to re-direct function call to the window load event
            if (!_pageLoaded && config.waitForPageLoad === true) {
                connection._.deferredStartHandler = function () {
                    connection.start(options, callback);
                };
                _pageWindow.bind("load", connection._.deferredStartHandler);

                return deferred.promise();
            }

            // If we're already connecting just return the same deferral as the original connection start
            if (connection.state === _signalR.connectionState.connecting) {
                return deferred.promise();
            } else if (changeState(connection, _signalR.connectionState.disconnected, _signalR.connectionState.connecting) === false) {
                // We're not connecting so try and transition into connecting.
                // If we fail to transition then we're either in connected or reconnecting.

                deferred.resolve(connection);
                return deferred.promise();
            }

            configureStopReconnectingTimeout(connection);

            // Resolve the full url
            parser.href = connection.url;
            if (!parser.protocol || parser.protocol === ":") {
                connection.protocol = window.document.location.protocol;
                connection.host = parser.host || window.document.location.host;
            } else {
                connection.protocol = parser.protocol;
                connection.host = parser.host;
            }

            connection.baseUrl = connection.protocol + "//" + connection.host;

            // Set the websocket protocol
            connection.wsProtocol = connection.protocol === "https:" ? "wss://" : "ws://";

            // If jsonp with no/auto transport is specified, then set the transport to long polling
            // since that is the only transport for which jsonp really makes sense.
            // Some developers might actually choose to specify jsonp for same origin requests
            // as demonstrated by Issue #623.
            if (config.transport === "auto" && config.jsonp === true) {
                config.transport = "longPolling";
            }

            // If the url is protocol relative, prepend the current windows protocol to the url.
            if (connection.url.indexOf("//") === 0) {
                connection.url = window.location.protocol + connection.url;
                connection.log("Protocol relative URL detected, normalizing it to '" + connection.url + "'.");
            }

            if (this.isCrossDomain(connection.url)) {
                connection.log("Auto detected cross domain url.");

                if (config.transport === "auto") {
                    // TODO: Support XDM with foreverFrame
                    config.transport = ["webSockets", "serverSentEvents", "longPolling"];
                }

                if (typeof config.withCredentials === "undefined") {
                    config.withCredentials = true;
                }

                // Determine if jsonp is the only choice for negotiation, ajaxSend and ajaxAbort.
                // i.e. if the browser doesn't supports CORS
                // If it is, ignore any preference to the contrary, and switch to jsonp.
                if (!config.jsonp) {
                    config.jsonp = !$.support.cors;

                    if (config.jsonp) {
                        connection.log("Using jsonp because this browser doesn't support CORS.");
                    }
                }

                connection.contentType = _signalR._.defaultContentType;
            }

            connection.withCredentials = config.withCredentials;

            connection.ajaxDataType = config.jsonp ? "jsonp" : "text";

            $(connection).bind(events.onStart, function (e, data) {
                if ($.type(callback) === "function") {
                    callback.call(connection);
                }
                deferred.resolve(connection);
            });

            connection._.initHandler = _signalR.transports._logic.initHandler(connection);

            _initialize = function initialize(transports, index) {
                var noTransportError = _signalR._.error(resources.noTransportOnInit);

                index = index || 0;
                if (index >= transports.length) {
                    if (index === 0) {
                        connection.log("No transports supported by the server were selected.");
                    } else if (index === 1) {
                        connection.log("No fallback transports were selected.");
                    } else {
                        connection.log("Fallback transports exhausted.");
                    }

                    // No transport initialized successfully
                    $(connection).triggerHandler(events.onError, [noTransportError]);
                    deferred.reject(noTransportError);
                    // Stop the connection if it has connected and move it into the disconnected state
                    connection.stop();
                    return;
                }

                // The connection was aborted
                if (connection.state === _signalR.connectionState.disconnected) {
                    return;
                }

                var transportName = transports[index],
                    transport = _signalR.transports[transportName],
                    onFallback = function onFallback() {
                    _initialize(transports, index + 1);
                };

                connection.transport = transport;

                try {
                    connection._.initHandler.start(transport, function () {
                        // success
                        // Firefox 11+ doesn't allow sync XHR withCredentials: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#withCredentials
                        var isFirefox11OrGreater = _signalR._.firefoxMajorVersion(window.navigator.userAgent) >= 11,
                            asyncAbort = !!connection.withCredentials && isFirefox11OrGreater;

                        connection.log("The start request succeeded. Transitioning to the connected state.");

                        if (supportsKeepAlive(connection)) {
                            _signalR.transports._logic.monitorKeepAlive(connection);
                        }

                        _signalR.transports._logic.startHeartbeat(connection);

                        // Used to ensure low activity clients maintain their authentication.
                        // Must be configured once a transport has been decided to perform valid ping requests.
                        _signalR._.configurePingInterval(connection);

                        if (!changeState(connection, _signalR.connectionState.connecting, _signalR.connectionState.connected)) {
                            connection.log("WARNING! The connection was not in the connecting state.");
                        }

                        // Drain any incoming buffered messages (messages that came in prior to connect)
                        connection._.connectingMessageBuffer.drain();

                        $(connection).triggerHandler(events.onStart);

                        // wire the stop handler for when the user leaves the page
                        _pageWindow.bind("unload", function () {
                            connection.log("Window unloading, stopping the connection.");

                            connection.stop(asyncAbort);
                        });

                        if (isFirefox11OrGreater) {
                            // Firefox does not fire cross-domain XHRs in the normal unload handler on tab close.
                            // #2400
                            _pageWindow.bind("beforeunload", function () {
                                // If connection.stop() runs runs in beforeunload and fails, it will also fail
                                // in unload unless connection.stop() runs after a timeout.
                                window.setTimeout(function () {
                                    connection.stop(asyncAbort);
                                }, 0);
                            });
                        }
                    }, onFallback);
                } catch (error) {
                    connection.log(transport.name + " transport threw '" + error.message + "' when attempting to start.");
                    onFallback();
                }
            };

            var url = connection.url + "/negotiate",
                onFailed = function onFailed(error, connection) {
                var err = _signalR._.error(resources.errorOnNegotiate, error, connection._.negotiateRequest);

                $(connection).triggerHandler(events.onError, err);
                deferred.reject(err);
                // Stop the connection if negotiate failed
                connection.stop();
            };

            $(connection).triggerHandler(events.onStarting);

            url = _signalR.transports._logic.prepareQueryString(connection, url);

            connection.log("Negotiating with '" + url + "'.");

            // Save the ajax negotiate request object so we can abort it if stop is called while the request is in flight.
            connection._.negotiateRequest = _signalR.transports._logic.ajax(connection, {
                url: url,
                error: function error(_error, statusText) {
                    // We don't want to cause any errors if we're aborting our own negotiate request.
                    if (statusText !== _negotiateAbortText) {
                        onFailed(_error, connection);
                    } else {
                        // This rejection will noop if the deferred has already been resolved or rejected.
                        deferred.reject(_signalR._.error(resources.stoppedWhileNegotiating, null /* error */, connection._.negotiateRequest));
                    }
                },
                success: function success(result) {
                    var res,
                        keepAliveData,
                        protocolError,
                        transports = [],
                        supportedTransports = [];

                    try {
                        res = connection._parseResponse(result);
                    } catch (error) {
                        onFailed(_signalR._.error(resources.errorParsingNegotiateResponse, error), connection);
                        return;
                    }

                    keepAliveData = connection._.keepAliveData;
                    connection.appRelativeUrl = res.Url;
                    connection.id = res.ConnectionId;
                    connection.token = res.ConnectionToken;
                    connection.webSocketServerUrl = res.WebSocketServerUrl;

                    // The long poll timeout is the ConnectionTimeout plus 10 seconds
                    connection._.pollTimeout = res.ConnectionTimeout * 1000 + 10000; // in ms

                    // Once the server has labeled the PersistentConnection as Disconnected, we should stop attempting to reconnect
                    // after res.DisconnectTimeout seconds.
                    connection.disconnectTimeout = res.DisconnectTimeout * 1000; // in ms

                    // Add the TransportConnectTimeout from the response to the transportConnectTimeout from the client to calculate the total timeout
                    connection._.totalTransportConnectTimeout = connection.transportConnectTimeout + res.TransportConnectTimeout * 1000;

                    // If we have a keep alive
                    if (res.KeepAliveTimeout) {
                        // Register the keep alive data as activated
                        keepAliveData.activated = true;

                        // Timeout to designate when to force the connection into reconnecting converted to milliseconds
                        keepAliveData.timeout = res.KeepAliveTimeout * 1000;

                        // Timeout to designate when to warn the developer that the connection may be dead or is not responding.
                        keepAliveData.timeoutWarning = keepAliveData.timeout * connection.keepAliveWarnAt;

                        // Instantiate the frequency in which we check the keep alive.  It must be short in order to not miss/pick up any changes
                        connection._.beatInterval = (keepAliveData.timeout - keepAliveData.timeoutWarning) / 3;
                    } else {
                        keepAliveData.activated = false;
                    }

                    connection.reconnectWindow = connection.disconnectTimeout + (keepAliveData.timeout || 0);

                    if (!res.ProtocolVersion || res.ProtocolVersion !== connection.clientProtocol) {
                        protocolError = _signalR._.error(_signalR._.format(resources.protocolIncompatible, connection.clientProtocol, res.ProtocolVersion));
                        $(connection).triggerHandler(events.onError, [protocolError]);
                        deferred.reject(protocolError);

                        return;
                    }

                    $.each(_signalR.transports, function (key) {
                        if (key.indexOf("_") === 0 || key === "webSockets" && !res.TryWebSockets) {
                            return true;
                        }
                        supportedTransports.push(key);
                    });

                    if ($.isArray(config.transport)) {
                        $.each(config.transport, function (_, transport) {
                            if ($.inArray(transport, supportedTransports) >= 0) {
                                transports.push(transport);
                            }
                        });
                    } else if (config.transport === "auto") {
                        transports = supportedTransports;
                    } else if ($.inArray(config.transport, supportedTransports) >= 0) {
                        transports.push(config.transport);
                    }

                    _initialize(transports);
                }
            });

            return deferred.promise();
        },

        starting: function starting(callback) {
            /// <summary>Adds a callback that will be invoked before anything is sent over the connection</summary>
            /// <param name="callback" type="Function">A callback function to execute before the connection is fully instantiated.</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).bind(events.onStarting, function (e, data) {
                callback.call(connection);
            });
            return connection;
        },

        send: function send(data) {
            /// <summary>Sends data over the connection</summary>
            /// <param name="data" type="String">The data to send over the connection</param>
            /// <returns type="signalR" />
            var connection = this;

            if (connection.state === _signalR.connectionState.disconnected) {
                // Connection hasn't been started yet
                throw new Error("SignalR: Connection must be started before data can be sent. Call .start() before .send()");
            }

            if (connection.state === _signalR.connectionState.connecting) {
                // Connection hasn't been started yet
                throw new Error("SignalR: Connection has not been fully initialized. Use .start().done() or .start().fail() to run logic after the connection has started.");
            }

            connection.transport.send(connection, data);
            // REVIEW: Should we return deferred here?
            return connection;
        },

        received: function received(callback) {
            /// <summary>Adds a callback that will be invoked after anything is received over the connection</summary>
            /// <param name="callback" type="Function">A callback function to execute when any data is received on the connection</param>
            /// <returns type="signalR" />
            var connection = this;

            $(connection).bind(events.onReceived, function (e, data) {
                callback.call(connection, data);
            });
            return connection;
        },

        stateChanged: function stateChanged(callback) {
            /// <summary>Adds a callback that will be invoked when the connection state changes</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection state changes</param>
            /// <returns type="signalR" />
            var connection = this;

            $(connection).bind(events.onStateChanged, function (e, data) {
                callback.call(connection, data);
            });
            return connection;
        },

        error: function error(callback) {
            /// <summary>Adds a callback that will be invoked after an error occurs with the connection</summary>
            /// <param name="callback" type="Function">A callback function to execute when an error occurs on the connection</param>
            /// <returns type="signalR" />
            var connection = this;

            $(connection).bind(events.onError, function (e, errorData, sendData) {
                connection.lastError = errorData;
                // In practice 'errorData' is the SignalR built error object.
                // In practice 'sendData' is undefined for all error events except those triggered by
                // 'ajaxSend' and 'webSockets.send'.'sendData' is the original send payload.
                callback.call(connection, errorData, sendData);
            });
            return connection;
        },

        disconnected: function disconnected(callback) {
            /// <summary>Adds a callback that will be invoked when the client disconnects</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection is broken</param>
            /// <returns type="signalR" />
            var connection = this;

            $(connection).bind(events.onDisconnect, function (e, data) {
                callback.call(connection);
            });
            return connection;
        },

        connectionSlow: function connectionSlow(callback) {
            /// <summary>Adds a callback that will be invoked when the client detects a slow connection</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection is slow</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).bind(events.onConnectionSlow, function (e, data) {
                callback.call(connection);
            });

            return connection;
        },

        reconnecting: function reconnecting(callback) {
            /// <summary>Adds a callback that will be invoked when the underlying transport begins reconnecting</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection enters a reconnecting state</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).bind(events.onReconnecting, function (e, data) {
                callback.call(connection);
            });
            return connection;
        },

        reconnected: function reconnected(callback) {
            /// <summary>Adds a callback that will be invoked when the underlying transport reconnects</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection is restored</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).bind(events.onReconnect, function (e, data) {
                callback.call(connection);
            });
            return connection;
        },

        stop: function stop(async, notifyServer) {
            /// <summary>Stops listening</summary>
            /// <param name="async" type="Boolean">Whether or not to asynchronously abort the connection</param>
            /// <param name="notifyServer" type="Boolean">Whether we want to notify the server that we are aborting the connection</param>
            /// <returns type="signalR" />
            var connection = this,

            // Save deferral because this is always cleaned up
            deferral = connection._deferral;

            // Verify that we've bound a load event.
            if (connection._.deferredStartHandler) {
                // Unbind the event.
                _pageWindow.unbind("load", connection._.deferredStartHandler);
            }

            // Always clean up private non-timeout based state.
            delete connection._.config;
            delete connection._.deferredStartHandler;

            // This needs to be checked despite the connection state because a connection start can be deferred until page load.
            // If we've deferred the start due to a page load we need to unbind the "onLoad" -> start event.
            if (!_pageLoaded && (!connection._.config || connection._.config.waitForPageLoad === true)) {
                connection.log("Stopping connection prior to negotiate.");

                // If we have a deferral we should reject it
                if (deferral) {
                    deferral.reject(_signalR._.error(resources.stoppedWhileLoading));
                }

                // Short-circuit because the start has not been fully started.
                return;
            }

            if (connection.state === _signalR.connectionState.disconnected) {
                return;
            }

            connection.log("Stopping connection.");

            // Clear this no matter what
            window.clearTimeout(connection._.beatHandle);
            window.clearInterval(connection._.pingIntervalId);

            if (connection.transport) {
                connection.transport.stop(connection);

                if (notifyServer !== false) {
                    connection.transport.abort(connection, async);
                }

                if (supportsKeepAlive(connection)) {
                    _signalR.transports._logic.stopMonitoringKeepAlive(connection);
                }

                connection.transport = null;
            }

            if (connection._.negotiateRequest) {
                // If the negotiation request has already completed this will noop.
                connection._.negotiateRequest.abort(_negotiateAbortText);
                delete connection._.negotiateRequest;
            }

            // Ensure that initHandler.stop() is called before connection._deferral is deleted
            if (connection._.initHandler) {
                connection._.initHandler.stop();
            }

            delete connection._deferral;
            delete connection.messageId;
            delete connection.groupsToken;
            delete connection.id;
            delete connection._.pingIntervalId;
            delete connection._.lastMessageAt;
            delete connection._.lastActiveAt;

            // Clear out our message buffer
            connection._.connectingMessageBuffer.clear();

            // Trigger the disconnect event
            changeState(connection, connection.state, _signalR.connectionState.disconnected);
            $(connection).triggerHandler(events.onDisconnect);

            return connection;
        },

        log: function log(msg) {
            _log(msg, this.logging);
        }
    };

    _signalR.fn.init.prototype = _signalR.fn;

    _signalR.noConflict = function () {
        /// <summary>Reinstates the original value of $.connection and returns the signalR object for manual assignment</summary>
        /// <returns type="signalR" />
        if ($.connection === _signalR) {
            $.connection = _connection;
        }
        return _signalR;
    };

    if ($.connection) {
        _connection = $.connection;
    }

    $.connection = $.signalR = _signalR;
})(window.jQuery, window);
/* jquery.signalR.transports.common.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.

/*global window:false */
/// <reference path="jquery.signalR.core.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        startAbortText = "__Start Aborted__",
        transportLogic;

    signalR.transports = {};

    function beat(connection) {
        if (connection._.keepAliveData.monitoring) {
            checkIfAlive(connection);
        }

        // Ensure that we successfully marked active before continuing the heartbeat.
        if (transportLogic.markActive(connection)) {
            connection._.beatHandle = window.setTimeout(function () {
                beat(connection);
            }, connection._.beatInterval);
        }
    }

    function checkIfAlive(connection) {
        var keepAliveData = connection._.keepAliveData,
            timeElapsed;

        // Only check if we're connected
        if (connection.state === signalR.connectionState.connected) {
            timeElapsed = new Date().getTime() - connection._.lastMessageAt;

            // Check if the keep alive has completely timed out
            if (timeElapsed >= keepAliveData.timeout) {
                connection.log("Keep alive timed out.  Notifying transport that connection has been lost.");

                // Notify transport that the connection has been lost
                connection.transport.lostConnection(connection);
            } else if (timeElapsed >= keepAliveData.timeoutWarning) {
                // This is to assure that the user only gets a single warning
                if (!keepAliveData.userNotified) {
                    connection.log("Keep alive has been missed, connection may be dead/slow.");
                    $(connection).triggerHandler(events.onConnectionSlow);
                    keepAliveData.userNotified = true;
                }
            } else {
                keepAliveData.userNotified = false;
            }
        }
    }

    function getAjaxUrl(connection, path) {
        var url = connection.url + path;

        if (connection.transport) {
            url += "?transport=" + connection.transport.name;
        }

        return transportLogic.prepareQueryString(connection, url);
    }

    function InitHandler(connection) {
        this.connection = connection;

        this.startRequested = false;
        this.startCompleted = false;
        this.connectionStopped = false;
    }

    InitHandler.prototype = {
        start: function start(transport, onSuccess, onFallback) {
            var that = this,
                connection = that.connection,
                failCalled = false;

            if (that.startRequested || that.connectionStopped) {
                connection.log("WARNING! " + transport.name + " transport cannot be started. Initialization ongoing or completed.");
                return;
            }

            connection.log(transport.name + " transport starting.");

            transport.start(connection, function () {
                if (!failCalled) {
                    that.initReceived(transport, onSuccess);
                }
            }, function (error) {
                // Don't allow the same transport to cause onFallback to be called twice
                if (!failCalled) {
                    failCalled = true;
                    that.transportFailed(transport, error, onFallback);
                }

                // Returns true if the transport should stop;
                // false if it should attempt to reconnect
                return !that.startCompleted || that.connectionStopped;
            });

            that.transportTimeoutHandle = window.setTimeout(function () {
                if (!failCalled) {
                    failCalled = true;
                    connection.log(transport.name + " transport timed out when trying to connect.");
                    that.transportFailed(transport, undefined, onFallback);
                }
            }, connection._.totalTransportConnectTimeout);
        },

        stop: function stop() {
            this.connectionStopped = true;
            window.clearTimeout(this.transportTimeoutHandle);
            signalR.transports._logic.tryAbortStartRequest(this.connection);
        },

        initReceived: function initReceived(transport, onSuccess) {
            var that = this,
                connection = that.connection;

            if (that.startRequested) {
                connection.log("WARNING! The client received multiple init messages.");
                return;
            }

            if (that.connectionStopped) {
                return;
            }

            that.startRequested = true;
            window.clearTimeout(that.transportTimeoutHandle);

            connection.log(transport.name + " transport connected. Initiating start request.");
            signalR.transports._logic.ajaxStart(connection, function () {
                that.startCompleted = true;
                onSuccess();
            });
        },

        transportFailed: function transportFailed(transport, error, onFallback) {
            var connection = this.connection,
                deferred = connection._deferral,
                wrappedError;

            if (this.connectionStopped) {
                return;
            }

            window.clearTimeout(this.transportTimeoutHandle);

            if (!this.startRequested) {
                transport.stop(connection);

                connection.log(transport.name + " transport failed to connect. Attempting to fall back.");
                onFallback();
            } else if (!this.startCompleted) {
                // Do not attempt to fall back if a start request is ongoing during a transport failure.
                // Instead, trigger an error and stop the connection.
                wrappedError = signalR._.error(signalR.resources.errorDuringStartRequest, error);

                connection.log(transport.name + " transport failed during the start request. Stopping the connection.");
                $(connection).triggerHandler(events.onError, [wrappedError]);
                if (deferred) {
                    deferred.reject(wrappedError);
                }

                connection.stop();
            } else {
                // The start request has completed, but the connection has not stopped.
                // No need to do anything here. The transport should attempt its normal reconnect logic.
            }
        }
    };

    transportLogic = signalR.transports._logic = {
        ajax: function ajax(connection, options) {
            return $.ajax($.extend( /*deep copy*/true, {}, $.signalR.ajaxDefaults, {
                type: "GET",
                data: {},
                xhrFields: { withCredentials: connection.withCredentials },
                contentType: connection.contentType,
                dataType: connection.ajaxDataType
            }, options));
        },

        pingServer: function pingServer(connection) {
            /// <summary>Pings the server</summary>
            /// <param name="connection" type="signalr">Connection associated with the server ping</param>
            /// <returns type="signalR" />
            var url,
                xhr,
                deferral = $.Deferred();

            if (connection.transport) {
                url = connection.url + "/ping";

                url = transportLogic.addQs(url, connection.qs);

                xhr = transportLogic.ajax(connection, {
                    url: url,
                    success: function success(result) {
                        var data;

                        try {
                            data = connection._parseResponse(result);
                        } catch (error) {
                            deferral.reject(signalR._.transportError(signalR.resources.pingServerFailedParse, connection.transport, error, xhr));
                            connection.stop();
                            return;
                        }

                        if (data.Response === "pong") {
                            deferral.resolve();
                        } else {
                            deferral.reject(signalR._.transportError(signalR._.format(signalR.resources.pingServerFailedInvalidResponse, result), connection.transport, null /* error */
                            , xhr));
                        }
                    },
                    error: function error(_error2) {
                        if (_error2.status === 401 || _error2.status === 403) {
                            deferral.reject(signalR._.transportError(signalR._.format(signalR.resources.pingServerFailedStatusCode, _error2.status), connection.transport, _error2, xhr));
                            connection.stop();
                        } else {
                            deferral.reject(signalR._.transportError(signalR.resources.pingServerFailed, connection.transport, _error2, xhr));
                        }
                    }
                });
            } else {
                deferral.reject(signalR._.transportError(signalR.resources.noConnectionTransport, connection.transport));
            }

            return deferral.promise();
        },

        prepareQueryString: function prepareQueryString(connection, url) {
            var preparedUrl;

            // Use addQs to start since it handles the ?/& prefix for us
            preparedUrl = transportLogic.addQs(url, "clientProtocol=" + connection.clientProtocol);

            // Add the user-specified query string params if any
            preparedUrl = transportLogic.addQs(preparedUrl, connection.qs);

            if (connection.token) {
                preparedUrl += "&connectionToken=" + window.encodeURIComponent(connection.token);
            }

            if (connection.data) {
                preparedUrl += "&connectionData=" + window.encodeURIComponent(connection.data);
            }

            return preparedUrl;
        },

        addQs: function addQs(url, qs) {
            var appender = url.indexOf("?") !== -1 ? "&" : "?",
                firstChar;

            if (!qs) {
                return url;
            }

            if ((typeof qs === "undefined" ? "undefined" : _typeof(qs)) === "object") {
                return url + appender + $.param(qs);
            }

            if (typeof qs === "string") {
                firstChar = qs.charAt(0);

                if (firstChar === "?" || firstChar === "&") {
                    appender = "";
                }

                return url + appender + qs;
            }

            throw new Error("Query string property must be either a string or object.");
        },

        // BUG #2953: The url needs to be same otherwise it will cause a memory leak
        getUrl: function getUrl(connection, transport, reconnecting, poll, ajaxPost) {
            /// <summary>Gets the url for making a GET based connect request</summary>
            var baseUrl = transport === "webSockets" ? "" : connection.baseUrl,
                url = baseUrl + connection.appRelativeUrl,
                qs = "transport=" + transport;

            if (!ajaxPost && connection.groupsToken) {
                qs += "&groupsToken=" + window.encodeURIComponent(connection.groupsToken);
            }

            if (!reconnecting) {
                url += "/connect";
            } else {
                if (poll) {
                    // longPolling transport specific
                    url += "/poll";
                } else {
                    url += "/reconnect";
                }

                if (!ajaxPost && connection.messageId) {
                    qs += "&messageId=" + window.encodeURIComponent(connection.messageId);
                }
            }
            url += "?" + qs;
            url = transportLogic.prepareQueryString(connection, url);

            if (!ajaxPost) {
                url += "&tid=" + Math.floor(Math.random() * 11);
            }

            return url;
        },

        maximizePersistentResponse: function maximizePersistentResponse(minPersistentResponse) {
            return {
                MessageId: minPersistentResponse.C,
                Messages: minPersistentResponse.M,
                Initialized: typeof minPersistentResponse.S !== "undefined" ? true : false,
                ShouldReconnect: typeof minPersistentResponse.T !== "undefined" ? true : false,
                LongPollDelay: minPersistentResponse.L,
                GroupsToken: minPersistentResponse.G
            };
        },

        updateGroups: function updateGroups(connection, groupsToken) {
            if (groupsToken) {
                connection.groupsToken = groupsToken;
            }
        },

        stringifySend: function stringifySend(connection, message) {
            if (typeof message === "string" || typeof message === "undefined" || message === null) {
                return message;
            }
            return connection.json.stringify(message);
        },

        ajaxSend: function ajaxSend(connection, data) {
            var payload = transportLogic.stringifySend(connection, data),
                url = getAjaxUrl(connection, "/send"),
                xhr,
                onFail = function onFail(error, connection) {
                $(connection).triggerHandler(events.onError, [signalR._.transportError(signalR.resources.sendFailed, connection.transport, error, xhr), data]);
            };

            xhr = transportLogic.ajax(connection, {
                url: url,
                type: connection.ajaxDataType === "jsonp" ? "GET" : "POST",
                contentType: signalR._.defaultContentType,
                data: {
                    data: payload
                },
                success: function success(result) {
                    var res;

                    if (result) {
                        try {
                            res = connection._parseResponse(result);
                        } catch (error) {
                            onFail(error, connection);
                            connection.stop();
                            return;
                        }

                        transportLogic.triggerReceived(connection, res);
                    }
                },
                error: function error(_error3, textStatus) {
                    if (textStatus === "abort" || textStatus === "parsererror") {
                        // The parsererror happens for sends that don't return any data, and hence
                        // don't write the jsonp callback to the response. This is harder to fix on the server
                        // so just hack around it on the client for now.
                        return;
                    }

                    onFail(_error3, connection);
                }
            });

            return xhr;
        },

        ajaxAbort: function ajaxAbort(connection, async) {
            if (typeof connection.transport === "undefined") {
                return;
            }

            // Async by default unless explicitly overidden
            async = typeof async === "undefined" ? true : async;

            var url = getAjaxUrl(connection, "/abort");

            transportLogic.ajax(connection, {
                url: url,
                async: true,
                timeout: 1000,
                type: "POST"
            });

            connection.log("Fired ajax abort async = " + async + ".");
        },

        ajaxStart: function ajaxStart(connection, onSuccess) {
            var rejectDeferred = function rejectDeferred(error) {
                var deferred = connection._deferral;
                if (deferred) {
                    deferred.reject(error);
                }
            },
                triggerStartError = function triggerStartError(error) {
                connection.log("The start request failed. Stopping the connection.");
                $(connection).triggerHandler(events.onError, [error]);
                rejectDeferred(error);
                connection.stop();
            };

            connection._.startRequest = transportLogic.ajax(connection, {
                url: getAjaxUrl(connection, "/start"),
                success: function success(result, statusText, xhr) {
                    var data;

                    try {
                        data = connection._parseResponse(result);
                    } catch (error) {
                        triggerStartError(signalR._.error(signalR._.format(signalR.resources.errorParsingStartResponse, result), error, xhr));
                        return;
                    }

                    if (data.Response === "started") {
                        onSuccess();
                    } else {
                        triggerStartError(signalR._.error(signalR._.format(signalR.resources.invalidStartResponse, result), null /* error */, xhr));
                    }
                },
                error: function error(xhr, statusText, _error4) {
                    if (statusText !== startAbortText) {
                        triggerStartError(signalR._.error(signalR.resources.errorDuringStartRequest, _error4, xhr));
                    } else {
                        // Stop has been called, no need to trigger the error handler
                        // or stop the connection again with onStartError
                        connection.log("The start request aborted because connection.stop() was called.");
                        rejectDeferred(signalR._.error(signalR.resources.stoppedDuringStartRequest, null /* error */, xhr));
                    }
                }
            });
        },

        tryAbortStartRequest: function tryAbortStartRequest(connection) {
            if (connection._.startRequest) {
                // If the start request has already completed this will noop.
                connection._.startRequest.abort(startAbortText);
                delete connection._.startRequest;
            }
        },

        tryInitialize: function tryInitialize(connection, persistentResponse, onInitialized) {
            if (persistentResponse.Initialized && onInitialized) {
                onInitialized();
            } else if (persistentResponse.Initialized) {
                connection.log("WARNING! The client received an init message after reconnecting.");
            }
        },

        triggerReceived: function triggerReceived(connection, data) {
            if (!connection._.connectingMessageBuffer.tryBuffer(data)) {
                $(connection).triggerHandler(events.onReceived, [data]);
            }
        },

        processMessages: function processMessages(connection, minData, onInitialized) {
            var data;

            // Update the last message time stamp
            transportLogic.markLastMessage(connection);

            if (minData) {
                data = transportLogic.maximizePersistentResponse(minData);

                transportLogic.updateGroups(connection, data.GroupsToken);

                if (data.MessageId) {
                    connection.messageId = data.MessageId;
                }

                if (data.Messages) {
                    $.each(data.Messages, function (index, message) {
                        transportLogic.triggerReceived(connection, message);
                    });

                    transportLogic.tryInitialize(connection, data, onInitialized);
                }
            }
        },

        monitorKeepAlive: function monitorKeepAlive(connection) {
            var keepAliveData = connection._.keepAliveData;

            // If we haven't initiated the keep alive timeouts then we need to
            if (!keepAliveData.monitoring) {
                keepAliveData.monitoring = true;

                transportLogic.markLastMessage(connection);

                // Save the function so we can unbind it on stop
                connection._.keepAliveData.reconnectKeepAliveUpdate = function () {
                    // Mark a new message so that keep alive doesn't time out connections
                    transportLogic.markLastMessage(connection);
                };

                // Update Keep alive on reconnect
                $(connection).bind(events.onReconnect, connection._.keepAliveData.reconnectKeepAliveUpdate);

                connection.log("Now monitoring keep alive with a warning timeout of " + keepAliveData.timeoutWarning + ", keep alive timeout of " + keepAliveData.timeout + " and disconnecting timeout of " + connection.disconnectTimeout);
            } else {
                connection.log("Tried to monitor keep alive but it's already being monitored.");
            }
        },

        stopMonitoringKeepAlive: function stopMonitoringKeepAlive(connection) {
            var keepAliveData = connection._.keepAliveData;

            // Only attempt to stop the keep alive monitoring if its being monitored
            if (keepAliveData.monitoring) {
                // Stop monitoring
                keepAliveData.monitoring = false;

                // Remove the updateKeepAlive function from the reconnect event
                $(connection).unbind(events.onReconnect, connection._.keepAliveData.reconnectKeepAliveUpdate);

                // Clear all the keep alive data
                connection._.keepAliveData = {};
                connection.log("Stopping the monitoring of the keep alive.");
            }
        },

        startHeartbeat: function startHeartbeat(connection) {
            connection._.lastActiveAt = new Date().getTime();
            beat(connection);
        },

        markLastMessage: function markLastMessage(connection) {
            connection._.lastMessageAt = new Date().getTime();
        },

        markActive: function markActive(connection) {
            if (transportLogic.verifyLastActive(connection)) {
                connection._.lastActiveAt = new Date().getTime();
                return true;
            }

            return false;
        },

        isConnectedOrReconnecting: function isConnectedOrReconnecting(connection) {
            return connection.state === signalR.connectionState.connected || connection.state === signalR.connectionState.reconnecting;
        },

        ensureReconnectingState: function ensureReconnectingState(connection) {
            if (changeState(connection, signalR.connectionState.connected, signalR.connectionState.reconnecting) === true) {
                $(connection).triggerHandler(events.onReconnecting);
            }
            return connection.state === signalR.connectionState.reconnecting;
        },

        clearReconnectTimeout: function clearReconnectTimeout(connection) {
            if (connection && connection._.reconnectTimeout) {
                window.clearTimeout(connection._.reconnectTimeout);
                delete connection._.reconnectTimeout;
            }
        },

        verifyLastActive: function verifyLastActive(connection) {
            if (new Date().getTime() - connection._.lastActiveAt >= connection.reconnectWindow) {
                var message = signalR._.format(signalR.resources.reconnectWindowTimeout, new Date(connection._.lastActiveAt), connection.reconnectWindow);
                connection.log(message);
                $(connection).triggerHandler(events.onError, [signalR._.error(message, /* source */"TimeoutException")]);
                connection.stop( /* async */false, /* notifyServer */false);
                return false;
            }

            return true;
        },

        reconnect: function reconnect(connection, transportName) {
            var transport = signalR.transports[transportName];

            // We should only set a reconnectTimeout if we are currently connected
            // and a reconnectTimeout isn't already set.
            if (transportLogic.isConnectedOrReconnecting(connection) && !connection._.reconnectTimeout) {
                // Need to verify before the setTimeout occurs because an application sleep could occur during the setTimeout duration.
                if (!transportLogic.verifyLastActive(connection)) {
                    return;
                }

                connection._.reconnectTimeout = window.setTimeout(function () {
                    if (!transportLogic.verifyLastActive(connection)) {
                        return;
                    }

                    transport.stop(connection);

                    if (transportLogic.ensureReconnectingState(connection)) {
                        connection.log(transportName + " reconnecting.");
                        transport.start(connection);
                    }
                }, connection.reconnectDelay);
            }
        },

        handleParseFailure: function handleParseFailure(connection, result, error, onFailed, context) {
            var wrappedError = signalR._.transportError(signalR._.format(signalR.resources.parseFailed, result), connection.transport, error, context);

            // If we're in the initialization phase trigger onFailed, otherwise stop the connection.
            if (onFailed && onFailed(wrappedError)) {
                connection.log("Failed to parse server response while attempting to connect.");
            } else {
                $(connection).triggerHandler(events.onError, [wrappedError]);
                connection.stop();
            }
        },

        initHandler: function initHandler(connection) {
            return new InitHandler(connection);
        },

        foreverFrame: {
            count: 0,
            connections: {}
        }
    };
})(window.jQuery, window);
/* jquery.signalR.transports.webSockets.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.transports.common.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        transportLogic = signalR.transports._logic;

    signalR.transports.webSockets = {
        name: "webSockets",

        supportsKeepAlive: function supportsKeepAlive() {
            return true;
        },

        send: function send(connection, data) {
            var payload = transportLogic.stringifySend(connection, data);

            try {
                connection.socket.send(payload);
            } catch (ex) {
                $(connection).triggerHandler(events.onError, [signalR._.transportError(signalR.resources.webSocketsInvalidState, connection.transport, ex, connection.socket), data]);
            }
        },

        start: function start(connection, onSuccess, onFailed) {
            var url,
                opened = false,
                that = this,
                reconnecting = !onSuccess,
                $connection = $(connection);

            if (!window.WebSocket) {
                onFailed();
                return;
            }

            if (!connection.socket) {
                if (connection.webSocketServerUrl) {
                    url = connection.webSocketServerUrl;
                } else {
                    url = connection.wsProtocol + connection.host;
                }

                url += transportLogic.getUrl(connection, this.name, reconnecting);

                connection.log("Connecting to websocket endpoint '" + url + "'.");
                connection.socket = new window.WebSocket(url);

                connection.socket.onopen = function () {
                    opened = true;
                    connection.log("Websocket opened.");

                    transportLogic.clearReconnectTimeout(connection);

                    if (changeState(connection, signalR.connectionState.reconnecting, signalR.connectionState.connected) === true) {
                        $connection.triggerHandler(events.onReconnect);
                    }
                };

                connection.socket.onclose = function (event) {
                    var error;

                    // Only handle a socket close if the close is from the current socket.
                    // Sometimes on disconnect the server will push down an onclose event
                    // to an expired socket.

                    if (this === connection.socket) {
                        if (opened && typeof event.wasClean !== "undefined" && event.wasClean === false) {
                            // Ideally this would use the websocket.onerror handler (rather than checking wasClean in onclose) but
                            // I found in some circumstances Chrome won't call onerror. This implementation seems to work on all browsers.
                            error = signalR._.transportError(signalR.resources.webSocketClosed, connection.transport, event);

                            connection.log("Unclean disconnect from websocket: " + (event.reason || "[no reason given]."));
                        } else {
                            connection.log("Websocket closed.");
                        }

                        if (!onFailed || !onFailed(error)) {
                            if (error) {
                                $(connection).triggerHandler(events.onError, [error]);
                            }

                            that.reconnect(connection);
                        }
                    }
                };

                connection.socket.onmessage = function (event) {
                    var data;

                    try {
                        data = connection._parseResponse(event.data);
                    } catch (error) {
                        transportLogic.handleParseFailure(connection, event.data, error, onFailed, event);
                        return;
                    }

                    if (data) {
                        // data.M is PersistentResponse.Messages
                        if ($.isEmptyObject(data) || data.M) {
                            transportLogic.processMessages(connection, data, onSuccess);
                        } else {
                            // For websockets we need to trigger onReceived
                            // for callbacks to outgoing hub calls.
                            transportLogic.triggerReceived(connection, data);
                        }
                    }
                };
            }
        },

        reconnect: function reconnect(connection) {
            transportLogic.reconnect(connection, this.name);
        },

        lostConnection: function lostConnection(connection) {
            this.reconnect(connection);
        },

        stop: function stop(connection) {
            // Don't trigger a reconnect after stopping
            transportLogic.clearReconnectTimeout(connection);

            if (connection.socket) {
                connection.log("Closing the Websocket.");
                connection.socket.close();
                connection.socket = null;
            }
        },

        abort: function abort(connection, async) {
            transportLogic.ajaxAbort(connection, async);
        }
    };
})(window.jQuery, window);
/* jquery.signalR.transports.serverSentEvents.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.transports.common.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        transportLogic = signalR.transports._logic,
        clearReconnectAttemptTimeout = function clearReconnectAttemptTimeout(connection) {
        window.clearTimeout(connection._.reconnectAttemptTimeoutHandle);
        delete connection._.reconnectAttemptTimeoutHandle;
    };

    signalR.transports.serverSentEvents = {
        name: "serverSentEvents",

        supportsKeepAlive: function supportsKeepAlive() {
            return true;
        },

        timeOut: 3000,

        start: function start(connection, onSuccess, onFailed) {
            var that = this,
                opened = false,
                $connection = $(connection),
                reconnecting = !onSuccess,
                url;

            if (connection.eventSource) {
                connection.log("The connection already has an event source. Stopping it.");
                connection.stop();
            }

            if (!window.EventSource) {
                if (onFailed) {
                    connection.log("This browser doesn't support SSE.");
                    onFailed();
                }
                return;
            }

            url = transportLogic.getUrl(connection, this.name, reconnecting);

            try {
                connection.log("Attempting to connect to SSE endpoint '" + url + "'.");
                connection.eventSource = new window.EventSource(url, { withCredentials: connection.withCredentials });
            } catch (e) {
                connection.log("EventSource failed trying to connect with error " + e.Message + ".");
                if (onFailed) {
                    // The connection failed, call the failed callback
                    onFailed();
                } else {
                    $connection.triggerHandler(events.onError, [signalR._.transportError(signalR.resources.eventSourceFailedToConnect, connection.transport, e)]);
                    if (reconnecting) {
                        // If we were reconnecting, rather than doing initial connect, then try reconnect again
                        that.reconnect(connection);
                    }
                }
                return;
            }

            if (reconnecting) {
                connection._.reconnectAttemptTimeoutHandle = window.setTimeout(function () {
                    if (opened === false) {
                        // If we're reconnecting and the event source is attempting to connect,
                        // don't keep retrying. This causes duplicate connections to spawn.
                        if (connection.eventSource.readyState !== window.EventSource.OPEN) {
                            // If we were reconnecting, rather than doing initial connect, then try reconnect again
                            that.reconnect(connection);
                        }
                    }
                }, that.timeOut);
            }

            connection.eventSource.addEventListener("open", function (e) {
                connection.log("EventSource connected.");

                clearReconnectAttemptTimeout(connection);
                transportLogic.clearReconnectTimeout(connection);

                if (opened === false) {
                    opened = true;

                    if (changeState(connection, signalR.connectionState.reconnecting, signalR.connectionState.connected) === true) {
                        $connection.triggerHandler(events.onReconnect);
                    }
                }
            }, false);

            connection.eventSource.addEventListener("message", function (e) {
                var res;

                // process messages
                if (e.data === "initialized") {
                    return;
                }

                try {
                    res = connection._parseResponse(e.data);
                } catch (error) {
                    transportLogic.handleParseFailure(connection, e.data, error, onFailed, e);
                    return;
                }

                transportLogic.processMessages(connection, res, onSuccess);
            }, false);

            connection.eventSource.addEventListener("error", function (e) {
                var error = signalR._.transportError(signalR.resources.eventSourceError, connection.transport, e);

                // Only handle an error if the error is from the current Event Source.
                // Sometimes on disconnect the server will push down an error event
                // to an expired Event Source.
                if (this !== connection.eventSource) {
                    return;
                }

                if (onFailed && onFailed(error)) {
                    return;
                }

                connection.log("EventSource readyState: " + connection.eventSource.readyState + ".");

                if (e.eventPhase === window.EventSource.CLOSED) {
                    // We don't use the EventSource's native reconnect function as it
                    // doesn't allow us to change the URL when reconnecting. We need
                    // to change the URL to not include the /connect suffix, and pass
                    // the last message id we received.
                    connection.log("EventSource reconnecting due to the server connection ending.");
                    that.reconnect(connection);
                } else {
                    // connection error
                    connection.log("EventSource error.");
                    $connection.triggerHandler(events.onError, [error]);
                }
            }, false);
        },

        reconnect: function reconnect(connection) {
            transportLogic.reconnect(connection, this.name);
        },

        lostConnection: function lostConnection(connection) {
            this.reconnect(connection);
        },

        send: function send(connection, data) {
            transportLogic.ajaxSend(connection, data);
        },

        stop: function stop(connection) {
            // Don't trigger a reconnect after stopping
            clearReconnectAttemptTimeout(connection);
            transportLogic.clearReconnectTimeout(connection);

            if (connection && connection.eventSource) {
                connection.log("EventSource calling close().");
                connection.eventSource.close();
                connection.eventSource = null;
                delete connection.eventSource;
            }
        },

        abort: function abort(connection, async) {
            transportLogic.ajaxAbort(connection, async);
        }
    };
})(window.jQuery, window);
/* jquery.signalR.transports.foreverFrame.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.transports.common.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        transportLogic = signalR.transports._logic,
        createFrame = function createFrame() {
        var frame = window.document.createElement("iframe");
        frame.setAttribute("style", "position:absolute;top:0;left:0;width:0;height:0;visibility:hidden;");
        return frame;
    },

    // Used to prevent infinite loading icon spins in older versions of ie
    // We build this object inside a closure so we don't pollute the rest of
    // the foreverFrame transport with unnecessary functions/utilities.
    loadPreventer = function () {
        var loadingFixIntervalId = null,
            loadingFixInterval = 1000,
            attachedTo = 0;

        return {
            prevent: function prevent() {
                // Prevent additional iframe removal procedures from newer browsers
                if (signalR._.ieVersion <= 8) {
                    // We only ever want to set the interval one time, so on the first attachedTo
                    if (attachedTo === 0) {
                        // Create and destroy iframe every 3 seconds to prevent loading icon, super hacky
                        loadingFixIntervalId = window.setInterval(function () {
                            var tempFrame = createFrame();

                            window.document.body.appendChild(tempFrame);
                            window.document.body.removeChild(tempFrame);

                            tempFrame = null;
                        }, loadingFixInterval);
                    }

                    attachedTo++;
                }
            },
            cancel: function cancel() {
                // Only clear the interval if there's only one more object that the loadPreventer is attachedTo
                if (attachedTo === 1) {
                    window.clearInterval(loadingFixIntervalId);
                }

                if (attachedTo > 0) {
                    attachedTo--;
                }
            }
        };
    }();

    signalR.transports.foreverFrame = {
        name: "foreverFrame",

        supportsKeepAlive: function supportsKeepAlive() {
            return true;
        },

        // Added as a value here so we can create tests to verify functionality
        iframeClearThreshold: 50,

        start: function start(connection, onSuccess, onFailed) {
            var that = this,
                frameId = transportLogic.foreverFrame.count += 1,
                url,
                frame = createFrame(),
                frameLoadHandler = function frameLoadHandler() {
                connection.log("Forever frame iframe finished loading and is no longer receiving messages.");
                if (!onFailed || !onFailed()) {
                    that.reconnect(connection);
                }
            };

            if (window.EventSource) {
                // If the browser supports SSE, don't use Forever Frame
                if (onFailed) {
                    connection.log("Forever Frame is not supported by SignalR on browsers with SSE support.");
                    onFailed();
                }
                return;
            }

            frame.setAttribute("data-signalr-connection-id", connection.id);

            // Start preventing loading icon
            // This will only perform work if the loadPreventer is not attached to another connection.
            loadPreventer.prevent();

            // Build the url
            url = transportLogic.getUrl(connection, this.name);
            url += "&frameId=" + frameId;

            // add frame to the document prior to setting URL to avoid caching issues.
            window.document.documentElement.appendChild(frame);

            connection.log("Binding to iframe's load event.");

            if (frame.addEventListener) {
                frame.addEventListener("load", frameLoadHandler, false);
            } else if (frame.attachEvent) {
                frame.attachEvent("onload", frameLoadHandler);
            }

            frame.src = url;
            transportLogic.foreverFrame.connections[frameId] = connection;

            connection.frame = frame;
            connection.frameId = frameId;

            if (onSuccess) {
                connection.onSuccess = function () {
                    connection.log("Iframe transport started.");
                    onSuccess();
                };
            }
        },

        reconnect: function reconnect(connection) {
            var that = this;

            // Need to verify connection state and verify before the setTimeout occurs because an application sleep could occur during the setTimeout duration.
            if (transportLogic.isConnectedOrReconnecting(connection) && transportLogic.verifyLastActive(connection)) {
                window.setTimeout(function () {
                    // Verify that we're ok to reconnect.
                    if (!transportLogic.verifyLastActive(connection)) {
                        return;
                    }

                    if (connection.frame && transportLogic.ensureReconnectingState(connection)) {
                        var frame = connection.frame,
                            src = transportLogic.getUrl(connection, that.name, true) + "&frameId=" + connection.frameId;
                        connection.log("Updating iframe src to '" + src + "'.");
                        frame.src = src;
                    }
                }, connection.reconnectDelay);
            }
        },

        lostConnection: function lostConnection(connection) {
            this.reconnect(connection);
        },

        send: function send(connection, data) {
            transportLogic.ajaxSend(connection, data);
        },

        receive: function receive(connection, data) {
            var cw, body, response;

            if (connection.json !== connection._originalJson) {
                // If there's a custom JSON parser configured then serialize the object
                // using the original (browser) JSON parser and then deserialize it using
                // the custom parser (connection._parseResponse does that). This is so we
                // can easily send the response from the server as "raw" JSON but still
                // support custom JSON deserialization in the browser.
                data = connection._originalJson.stringify(data);
            }

            response = connection._parseResponse(data);

            transportLogic.processMessages(connection, response, connection.onSuccess);

            // Protect against connection stopping from a callback trigger within the processMessages above.
            if (connection.state === $.signalR.connectionState.connected) {
                // Delete the script & div elements
                connection.frameMessageCount = (connection.frameMessageCount || 0) + 1;
                if (connection.frameMessageCount > signalR.transports.foreverFrame.iframeClearThreshold) {
                    connection.frameMessageCount = 0;
                    cw = connection.frame.contentWindow || connection.frame.contentDocument;
                    if (cw && cw.document && cw.document.body) {
                        body = cw.document.body;

                        // Remove all the child elements from the iframe's body to conserver memory
                        while (body.firstChild) {
                            body.removeChild(body.firstChild);
                        }
                    }
                }
            }
        },

        stop: function stop(connection) {
            var cw = null;

            // Stop attempting to prevent loading icon
            loadPreventer.cancel();

            if (connection.frame) {
                if (connection.frame.stop) {
                    connection.frame.stop();
                } else {
                    try {
                        cw = connection.frame.contentWindow || connection.frame.contentDocument;
                        if (cw.document && cw.document.execCommand) {
                            cw.document.execCommand("Stop");
                        }
                    } catch (e) {
                        connection.log("Error occurred when stopping foreverFrame transport. Message = " + e.message + ".");
                    }
                }

                // Ensure the iframe is where we left it
                if (connection.frame.parentNode === window.document.body) {
                    window.document.body.removeChild(connection.frame);
                }

                delete transportLogic.foreverFrame.connections[connection.frameId];
                connection.frame = null;
                connection.frameId = null;
                delete connection.frame;
                delete connection.frameId;
                delete connection.onSuccess;
                delete connection.frameMessageCount;
                connection.log("Stopping forever frame.");
            }
        },

        abort: function abort(connection, async) {
            transportLogic.ajaxAbort(connection, async);
        },

        getConnection: function getConnection(id) {
            return transportLogic.foreverFrame.connections[id];
        },

        started: function started(connection) {
            if (changeState(connection, signalR.connectionState.reconnecting, signalR.connectionState.connected) === true) {

                $(connection).triggerHandler(events.onReconnect);
            }
        }
    };
})(window.jQuery, window);
/* jquery.signalR.transports.longPolling.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.transports.common.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        isDisconnecting = $.signalR.isDisconnecting,
        transportLogic = signalR.transports._logic;

    signalR.transports.longPolling = {
        name: "longPolling",

        supportsKeepAlive: function supportsKeepAlive() {
            return false;
        },

        reconnectDelay: 3000,

        start: function start(connection, onSuccess, onFailed) {
            /// <summary>Starts the long polling connection</summary>
            /// <param name="connection" type="signalR">The SignalR connection to start</param>
            var that = this,
                _fireConnect = function fireConnect() {
                _fireConnect = $.noop;

                connection.log("LongPolling connected.");

                if (onSuccess) {
                    onSuccess();
                } else {
                    connection.log("WARNING! The client received an init message after reconnecting.");
                }
            },
                tryFailConnect = function tryFailConnect(error) {
                if (onFailed(error)) {
                    connection.log("LongPolling failed to connect.");
                    return true;
                }

                return false;
            },
                privateData = connection._,
                reconnectErrors = 0,
                fireReconnected = function fireReconnected(instance) {
                window.clearTimeout(privateData.reconnectTimeoutId);
                privateData.reconnectTimeoutId = null;

                if (changeState(instance, signalR.connectionState.reconnecting, signalR.connectionState.connected) === true) {
                    // Successfully reconnected!
                    instance.log("Raising the reconnect event");
                    $(instance).triggerHandler(events.onReconnect);
                }
            },

            // 1 hour
            maxFireReconnectedTimeout = 3600000;

            if (connection.pollXhr) {
                connection.log("Polling xhr requests already exists, aborting.");
                connection.stop();
            }

            connection.messageId = null;

            privateData.reconnectTimeoutId = null;

            privateData.pollTimeoutId = window.setTimeout(function () {
                (function poll(instance, raiseReconnect) {
                    var messageId = instance.messageId,
                        connect = messageId === null,
                        reconnecting = !connect,
                        polling = !raiseReconnect,
                        url = transportLogic.getUrl(instance, that.name, reconnecting, polling, true /* use Post for longPolling */),
                        postData = {};

                    if (instance.messageId) {
                        postData.messageId = instance.messageId;
                    }

                    if (instance.groupsToken) {
                        postData.groupsToken = instance.groupsToken;
                    }

                    // If we've disconnected during the time we've tried to re-instantiate the poll then stop.
                    if (isDisconnecting(instance) === true) {
                        return;
                    }

                    connection.log("Opening long polling request to '" + url + "'.");
                    instance.pollXhr = transportLogic.ajax(connection, {
                        xhrFields: {
                            onprogress: function onprogress() {
                                transportLogic.markLastMessage(connection);
                            }
                        },
                        url: url,
                        type: "POST",
                        contentType: signalR._.defaultContentType,
                        data: postData,
                        timeout: connection._.pollTimeout,
                        success: function success(result) {
                            var minData,
                                delay = 0,
                                data,
                                shouldReconnect;

                            connection.log("Long poll complete.");

                            // Reset our reconnect errors so if we transition into a reconnecting state again we trigger
                            // reconnected quickly
                            reconnectErrors = 0;

                            try {
                                // Remove any keep-alives from the beginning of the result
                                minData = connection._parseResponse(result);
                            } catch (error) {
                                transportLogic.handleParseFailure(instance, result, error, tryFailConnect, instance.pollXhr);
                                return;
                            }

                            // If there's currently a timeout to trigger reconnect, fire it now before processing messages
                            if (privateData.reconnectTimeoutId !== null) {
                                fireReconnected(instance);
                            }

                            if (minData) {
                                data = transportLogic.maximizePersistentResponse(minData);
                            }

                            transportLogic.processMessages(instance, minData, _fireConnect);

                            if (data && $.type(data.LongPollDelay) === "number") {
                                delay = data.LongPollDelay;
                            }

                            if (isDisconnecting(instance) === true) {
                                return;
                            }

                            shouldReconnect = data && data.ShouldReconnect;
                            if (shouldReconnect) {
                                // Transition into the reconnecting state
                                // If this fails then that means that the user transitioned the connection into a invalid state in processMessages.
                                if (!transportLogic.ensureReconnectingState(instance)) {
                                    return;
                                }
                            }

                            // We never want to pass a raiseReconnect flag after a successful poll.  This is handled via the error function
                            if (delay > 0) {
                                privateData.pollTimeoutId = window.setTimeout(function () {
                                    poll(instance, shouldReconnect);
                                }, delay);
                            } else {
                                poll(instance, shouldReconnect);
                            }
                        },

                        error: function error(data, textStatus) {
                            var error = signalR._.transportError(signalR.resources.longPollFailed, connection.transport, data, instance.pollXhr);

                            // Stop trying to trigger reconnect, connection is in an error state
                            // If we're not in the reconnect state this will noop
                            window.clearTimeout(privateData.reconnectTimeoutId);
                            privateData.reconnectTimeoutId = null;

                            if (textStatus === "abort") {
                                connection.log("Aborted xhr request.");
                                return;
                            }

                            if (!tryFailConnect(error)) {

                                // Increment our reconnect errors, we assume all errors to be reconnect errors
                                // In the case that it's our first error this will cause Reconnect to be fired
                                // after 1 second due to reconnectErrors being = 1.
                                reconnectErrors++;

                                if (connection.state !== signalR.connectionState.reconnecting) {
                                    connection.log("An error occurred using longPolling. Status = " + textStatus + ".  Response = " + data.responseText + ".");
                                    $(instance).triggerHandler(events.onError, [error]);
                                }

                                // We check the state here to verify that we're not in an invalid state prior to verifying Reconnect.
                                // If we're not in connected or reconnecting then the next ensureReconnectingState check will fail and will return.
                                // Therefore we don't want to change that failure code path.
                                if ((connection.state === signalR.connectionState.connected || connection.state === signalR.connectionState.reconnecting) && !transportLogic.verifyLastActive(connection)) {
                                    return;
                                }

                                // Transition into the reconnecting state
                                // If this fails then that means that the user transitioned the connection into the disconnected or connecting state within the above error handler trigger.
                                if (!transportLogic.ensureReconnectingState(instance)) {
                                    return;
                                }

                                // Call poll with the raiseReconnect flag as true after the reconnect delay
                                privateData.pollTimeoutId = window.setTimeout(function () {
                                    poll(instance, true);
                                }, that.reconnectDelay);
                            }
                        }
                    });

                    // This will only ever pass after an error has occurred via the poll ajax procedure.
                    if (reconnecting && raiseReconnect === true) {
                        // We wait to reconnect depending on how many times we've failed to reconnect.
                        // This is essentially a heuristic that will exponentially increase in wait time before
                        // triggering reconnected.  This depends on the "error" handler of Poll to cancel this
                        // timeout if it triggers before the Reconnected event fires.
                        // The Math.min at the end is to ensure that the reconnect timeout does not overflow.
                        privateData.reconnectTimeoutId = window.setTimeout(function () {
                            fireReconnected(instance);
                        }, Math.min(1000 * (Math.pow(2, reconnectErrors) - 1), maxFireReconnectedTimeout));
                    }
                })(connection);
            }, 250); // Have to delay initial poll so Chrome doesn't show loader spinner in tab
        },

        lostConnection: function lostConnection(connection) {
            if (connection.pollXhr) {
                connection.pollXhr.abort("lostConnection");
            }
        },

        send: function send(connection, data) {
            transportLogic.ajaxSend(connection, data);
        },

        stop: function stop(connection) {
            /// <summary>Stops the long polling connection</summary>
            /// <param name="connection" type="signalR">The SignalR connection to stop</param>

            window.clearTimeout(connection._.pollTimeoutId);
            window.clearTimeout(connection._.reconnectTimeoutId);

            delete connection._.pollTimeoutId;
            delete connection._.reconnectTimeoutId;

            if (connection.pollXhr) {
                connection.pollXhr.abort();
                connection.pollXhr = null;
                delete connection.pollXhr;
            }
        },

        abort: function abort(connection, async) {
            transportLogic.ajaxAbort(connection, async);
        }
    };
})(window.jQuery, window);
/* jquery.signalR.hubs.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.

/*global window:false */
/// <reference path="jquery.signalR.core.js" />

(function ($, window, undefined) {

    var eventNamespace = ".hubProxy",
        signalR = $.signalR;

    function makeEventName(event) {
        return event + eventNamespace;
    }

    // Equivalent to Array.prototype.map
    function map(arr, fun, thisp) {
        var i,
            length = arr.length,
            result = [];
        for (i = 0; i < length; i += 1) {
            if (arr.hasOwnProperty(i)) {
                result[i] = fun.call(thisp, arr[i], i, arr);
            }
        }
        return result;
    }

    function getArgValue(a) {
        return $.isFunction(a) ? null : $.type(a) === "undefined" ? null : a;
    }

    function hasMembers(obj) {
        for (var key in obj) {
            // If we have any properties in our callback map then we have callbacks and can exit the loop via return
            if (obj.hasOwnProperty(key)) {
                return true;
            }
        }

        return false;
    }

    function clearInvocationCallbacks(connection, error) {
        /// <param name="connection" type="hubConnection" />
        var callbacks = connection._.invocationCallbacks,
            callback;

        if (hasMembers(callbacks)) {
            connection.log("Clearing hub invocation callbacks with error: " + error + ".");
        }

        // Reset the callback cache now as we have a local var referencing it
        connection._.invocationCallbackId = 0;
        delete connection._.invocationCallbacks;
        connection._.invocationCallbacks = {};

        // Loop over the callbacks and invoke them.
        // We do this using a local var reference and *after* we've cleared the cache
        // so that if a fail callback itself tries to invoke another method we don't
        // end up with its callback in the list we're looping over.
        for (var callbackId in callbacks) {
            callback = callbacks[callbackId];
            callback.method.call(callback.scope, { E: error });
        }
    }

    // hubProxy
    function hubProxy(hubConnection, hubName) {
        /// <summary>
        ///     Creates a new proxy object for the given hub connection that can be used to invoke
        ///     methods on server hubs and handle client method invocation requests from the server.
        /// </summary>
        return new hubProxy.fn.init(hubConnection, hubName);
    }

    hubProxy.fn = hubProxy.prototype = {
        init: function init(connection, hubName) {
            this.state = {};
            this.connection = connection;
            this.hubName = hubName;
            this._ = {
                callbackMap: {}
            };
        },

        constructor: hubProxy,

        hasSubscriptions: function hasSubscriptions() {
            return hasMembers(this._.callbackMap);
        },

        on: function on(eventName, callback) {
            /// <summary>Wires up a callback to be invoked when a invocation request is received from the server hub.</summary>
            /// <param name="eventName" type="String">The name of the hub event to register the callback for.</param>
            /// <param name="callback" type="Function">The callback to be invoked.</param>
            var that = this,
                callbackMap = that._.callbackMap;

            // Normalize the event name to lowercase
            eventName = eventName.toLowerCase();

            // If there is not an event registered for this callback yet we want to create its event space in the callback map.
            if (!callbackMap[eventName]) {
                callbackMap[eventName] = {};
            }

            // Map the callback to our encompassed function
            callbackMap[eventName][callback] = function (e, data) {
                callback.apply(that, data);
            };

            $(that).bind(makeEventName(eventName), callbackMap[eventName][callback]);

            return that;
        },

        off: function off(eventName, callback) {
            /// <summary>Removes the callback invocation request from the server hub for the given event name.</summary>
            /// <param name="eventName" type="String">The name of the hub event to unregister the callback for.</param>
            /// <param name="callback" type="Function">The callback to be invoked.</param>
            var that = this,
                callbackMap = that._.callbackMap,
                callbackSpace;

            // Normalize the event name to lowercase
            eventName = eventName.toLowerCase();

            callbackSpace = callbackMap[eventName];

            // Verify that there is an event space to unbind
            if (callbackSpace) {
                // Only unbind if there's an event bound with eventName and a callback with the specified callback
                if (callbackSpace[callback]) {
                    $(that).unbind(makeEventName(eventName), callbackSpace[callback]);

                    // Remove the callback from the callback map
                    delete callbackSpace[callback];

                    // Check if there are any members left on the event, if not we need to destroy it.
                    if (!hasMembers(callbackSpace)) {
                        delete callbackMap[eventName];
                    }
                } else if (!callback) {
                    // Check if we're removing the whole event and we didn't error because of an invalid callback
                    $(that).unbind(makeEventName(eventName));

                    delete callbackMap[eventName];
                }
            }

            return that;
        },

        invoke: function invoke(methodName) {
            /// <summary>Invokes a server hub method with the given arguments.</summary>
            /// <param name="methodName" type="String">The name of the server hub method.</param>

            var that = this,
                connection = that.connection,
                args = $.makeArray(arguments).slice(1),
                argValues = map(args, getArgValue),
                data = { H: that.hubName, M: methodName, A: argValues, I: connection._.invocationCallbackId },
                d = $.Deferred(),
                callback = function callback(minResult) {
                var result = that._maximizeHubResponse(minResult),
                    source,
                    error;

                // Update the hub state
                $.extend(that.state, result.State);

                if (result.Progress) {
                    if (d.notifyWith) {
                        // Progress is only supported in jQuery 1.7+
                        d.notifyWith(that, [result.Progress.Data]);
                    } else if (!connection._.progressjQueryVersionLogged) {
                        connection.log("A hub method invocation progress update was received but the version of jQuery in use (" + $.prototype.jquery + ") does not support progress updates. Upgrade to jQuery 1.7+ to receive progress notifications.");
                        connection._.progressjQueryVersionLogged = true;
                    }
                } else if (result.Error) {
                    // Server hub method threw an exception, log it & reject the deferred
                    if (result.StackTrace) {
                        connection.log(result.Error + "\n" + result.StackTrace + ".");
                    }

                    // result.ErrorData is only set if a HubException was thrown
                    source = result.IsHubException ? "HubException" : "Exception";
                    error = signalR._.error(result.Error, source);
                    error.data = result.ErrorData;

                    connection.log(that.hubName + "." + methodName + " failed to execute. Error: " + error.message);
                    d.rejectWith(that, [error]);
                } else {
                    // Server invocation succeeded, resolve the deferred
                    connection.log("Invoked " + that.hubName + "." + methodName);
                    d.resolveWith(that, [result.Result]);
                }
            };

            connection._.invocationCallbacks[connection._.invocationCallbackId.toString()] = {
                scope: that,
                method: callback
            };
            connection._.invocationCallbackId += 1;

            if (!$.isEmptyObject(that.state)) {
                data.S = that.state;
            }

            connection.log("Invoking " + that.hubName + "." + methodName);
            connection.send(data);

            return d.promise();
        },

        _maximizeHubResponse: function _maximizeHubResponse(minHubResponse) {
            return {
                State: minHubResponse.S,
                Result: minHubResponse.R,
                Progress: minHubResponse.P ? {
                    Id: minHubResponse.P.I,
                    Data: minHubResponse.P.D
                } : null,
                Id: minHubResponse.I,
                IsHubException: minHubResponse.H,
                Error: minHubResponse.E,
                StackTrace: minHubResponse.T,
                ErrorData: minHubResponse.D
            };
        }
    };

    hubProxy.fn.init.prototype = hubProxy.fn;

    // hubConnection
    function hubConnection(url, options) {
        /// <summary>Creates a new hub connection.</summary>
        /// <param name="url" type="String">[Optional] The hub route url, defaults to "/signalr".</param>
        /// <param name="options" type="Object">[Optional] Settings to use when creating the hubConnection.</param>
        var settings = {
            qs: null,
            logging: false,
            useDefaultPath: true
        };

        $.extend(settings, options);

        if (!url || settings.useDefaultPath) {
            url = (url || "") + "/signalr";
        }
        return new hubConnection.fn.init(url, settings);
    }

    hubConnection.fn = hubConnection.prototype = $.connection();

    hubConnection.fn.init = function (url, options) {
        var settings = {
            qs: null,
            logging: false,
            useDefaultPath: true
        },
            connection = this;

        $.extend(settings, options);

        // Call the base constructor
        $.signalR.fn.init.call(connection, url, settings.qs, settings.logging);

        // Object to store hub proxies for this connection
        connection.proxies = {};

        connection._.invocationCallbackId = 0;
        connection._.invocationCallbacks = {};

        // Wire up the received handler
        connection.received(function (minData) {
            var data, proxy, dataCallbackId, callback, hubName, eventName;
            if (!minData) {
                return;
            }

            // We have to handle progress updates first in order to ensure old clients that receive
            // progress updates enter the return value branch and then no-op when they can't find
            // the callback in the map (because the minData.I value will not be a valid callback ID)
            if (typeof minData.P !== "undefined") {
                // Process progress notification
                dataCallbackId = minData.P.I.toString();
                callback = connection._.invocationCallbacks[dataCallbackId];
                if (callback) {
                    callback.method.call(callback.scope, minData);
                }
            } else if (typeof minData.I !== "undefined") {
                // We received the return value from a server method invocation, look up callback by id and call it
                dataCallbackId = minData.I.toString();
                callback = connection._.invocationCallbacks[dataCallbackId];
                if (callback) {
                    // Delete the callback from the proxy
                    connection._.invocationCallbacks[dataCallbackId] = null;
                    delete connection._.invocationCallbacks[dataCallbackId];

                    // Invoke the callback
                    callback.method.call(callback.scope, minData);
                }
            } else {
                data = this._maximizeClientHubInvocation(minData);

                // We received a client invocation request, i.e. broadcast from server hub
                connection.log("Triggering client hub event '" + data.Method + "' on hub '" + data.Hub + "'.");

                // Normalize the names to lowercase
                hubName = data.Hub.toLowerCase();
                eventName = data.Method.toLowerCase();

                // Trigger the local invocation event
                proxy = this.proxies[hubName];

                // Update the hub state
                $.extend(proxy.state, data.State);
                $(proxy).triggerHandler(makeEventName(eventName), [data.Args]);
            }
        });

        connection.error(function (errData, origData) {
            var callbackId, callback;

            if (!origData) {
                // No original data passed so this is not a send error
                return;
            }

            callbackId = origData.I;
            callback = connection._.invocationCallbacks[callbackId];

            // Verify that there is a callback bound (could have been cleared)
            if (callback) {
                // Delete the callback
                connection._.invocationCallbacks[callbackId] = null;
                delete connection._.invocationCallbacks[callbackId];

                // Invoke the callback with an error to reject the promise
                callback.method.call(callback.scope, { E: errData });
            }
        });

        connection.reconnecting(function () {
            if (connection.transport && connection.transport.name === "webSockets") {
                clearInvocationCallbacks(connection, "Connection started reconnecting before invocation result was received.");
            }
        });

        connection.disconnected(function () {
            clearInvocationCallbacks(connection, "Connection was disconnected before invocation result was received.");
        });
    };

    hubConnection.fn._maximizeClientHubInvocation = function (minClientHubInvocation) {
        return {
            Hub: minClientHubInvocation.H,
            Method: minClientHubInvocation.M,
            Args: minClientHubInvocation.A,
            State: minClientHubInvocation.S
        };
    };

    hubConnection.fn._registerSubscribedHubs = function () {
        /// <summary>
        ///     Sets the starting event to loop through the known hubs and register any new hubs
        ///     that have been added to the proxy.
        /// </summary>
        var connection = this;

        if (!connection._subscribedToHubs) {
            connection._subscribedToHubs = true;
            connection.starting(function () {
                // Set the connection's data object with all the hub proxies with active subscriptions.
                // These proxies will receive notifications from the server.
                var subscribedHubs = [];

                $.each(connection.proxies, function (key) {
                    if (this.hasSubscriptions()) {
                        subscribedHubs.push({ name: key });
                        connection.log("Client subscribed to hub '" + key + "'.");
                    }
                });

                if (subscribedHubs.length === 0) {
                    connection.log("No hubs have been subscribed to.  The client will not receive data from hubs.  To fix, declare at least one client side function prior to connection start for each hub you wish to subscribe to.");
                }

                connection.data = connection.json.stringify(subscribedHubs);
            });
        }
    };

    hubConnection.fn.createHubProxy = function (hubName) {
        /// <summary>
        ///     Creates a new proxy object for the given hub connection that can be used to invoke
        ///     methods on server hubs and handle client method invocation requests from the server.
        /// </summary>
        /// <param name="hubName" type="String">
        ///     The name of the hub on the server to create the proxy for.
        /// </param>

        // Normalize the name to lowercase
        hubName = hubName.toLowerCase();

        var proxy = this.proxies[hubName];
        if (!proxy) {
            proxy = hubProxy(this, hubName);
            this.proxies[hubName] = proxy;
        }

        this._registerSubscribedHubs();

        return proxy;
    };

    hubConnection.fn.init.prototype = hubConnection.fn;

    $.hubConnection = hubConnection;
})(window.jQuery, window);
/* jquery.signalR.version.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.core.js" />
(function ($, undefined) {
    $.signalR.version = "2.2.1";
})(window.jQuery);

exports.hubConnection = window.jQuery.hubConnection;
exports.signalR = window.jQuery.signalR;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(848);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPolyfill(self) {
    'use strict';

    if (self.fetch) {
        return;
    }

    if (!self.Promise) {
        (0, _promise2.default)(self);
    }

    var support = {
        searchParams: 'URLSearchParams' in self,
        iterable: 'Symbol' in self && 'iterator' in Symbol,
        blob: 'FileReader' in self && 'Blob' in self && function () {
            try {
                new Blob();
                return true;
            } catch (e) {
                return false;
            }
        }(),
        formData: 'FormData' in self,
        arrayBuffer: 'ArrayBuffer' in self
    };

    if (support.arrayBuffer) {
        var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

        var isDataView = function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        };

        var isArrayBufferView = ArrayBuffer.isView || function (obj) {
            return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
        };
    }

    function normalizeName(name) {
        if (typeof name !== 'string') {
            name = String(name);
        }
        if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
            throw new TypeError('Invalid character in header field name');
        }
        return name.toLowerCase();
    }

    function normalizeValue(value) {
        if (typeof value !== 'string') {
            value = String(value);
        }
        return value;
    }

    // Build a destructive iterator for the value list
    function iteratorFor(items) {
        var iterator = {
            next: function next() {
                var value = items.shift();
                return { done: value === undefined, value: value };
            }
        };

        if (support.iterable) {
            iterator[Symbol.iterator] = function () {
                return iterator;
            };
        }

        return iterator;
    }

    function Headers(headers) {
        this.map = {};

        if (headers instanceof Headers) {
            headers.forEach(function (value, name) {
                this.append(name, value);
            }, this);
        } else if (Array.isArray(headers)) {
            headers.forEach(function (header) {
                this.append(header[0], header[1]);
            }, this);
        } else if (headers) {
            Object.getOwnPropertyNames(headers).forEach(function (name) {
                this.append(name, headers[name]);
            }, this);
        }
    }

    Headers.prototype.append = function (name, value) {
        name = normalizeName(name);
        value = normalizeValue(value);
        var oldValue = this.map[name];
        this.map[name] = oldValue ? oldValue + ',' + value : value;
    };

    Headers.prototype['delete'] = function (name) {
        delete this.map[normalizeName(name)];
    };

    Headers.prototype.get = function (name) {
        name = normalizeName(name);
        return this.has(name) ? this.map[name] : null;
    };

    Headers.prototype.has = function (name) {
        return this.map.hasOwnProperty(normalizeName(name));
    };

    Headers.prototype.set = function (name, value) {
        this.map[normalizeName(name)] = normalizeValue(value);
    };

    Headers.prototype.forEach = function (callback, thisArg) {
        for (var name in this.map) {
            if (this.map.hasOwnProperty(name)) {
                callback.call(thisArg, this.map[name], name, this);
            }
        }
    };

    Headers.prototype.keys = function () {
        var items = [];
        this.forEach(function (value, name) {
            items.push(name);
        });
        return iteratorFor(items);
    };

    Headers.prototype.values = function () {
        var items = [];
        this.forEach(function (value) {
            items.push(value);
        });
        return iteratorFor(items);
    };

    Headers.prototype.entries = function () {
        var items = [];
        this.forEach(function (value, name) {
            items.push([name, value]);
        });
        return iteratorFor(items);
    };

    if (support.iterable) {
        Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
    }

    function consumed(body) {
        if (body.bodyUsed) {
            return Promise.reject(new TypeError('Already read'));
        }
        body.bodyUsed = true;
    }

    function fileReaderReady(reader) {
        return new Promise(function (resolve, reject) {
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function () {
                reject(reader.error);
            };
        });
    }

    function readBlobAsArrayBuffer(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsArrayBuffer(blob);
        return promise;
    }

    function readBlobAsText(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsText(blob);
        return promise;
    }

    function readArrayBufferAsText(buf) {
        var view = new Uint8Array(buf);
        var chars = new Array(view.length);

        for (var i = 0; i < view.length; i++) {
            chars[i] = String.fromCharCode(view[i]);
        }
        return chars.join('');
    }

    function bufferClone(buf) {
        if (buf.slice) {
            return buf.slice(0);
        } else {
            var view = new Uint8Array(buf.byteLength);
            view.set(new Uint8Array(buf));
            return view.buffer;
        }
    }

    function Body() {
        this.bodyUsed = false;

        this._initBody = function (body) {
            this._bodyInit = body;
            if (!body) {
                this._bodyText = '';
            } else if (typeof body === 'string') {
                this._bodyText = body;
            } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
                this._bodyBlob = body;
            } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
                this._bodyFormData = body;
            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                this._bodyText = body.toString();
            } else if (support.arrayBuffer && support.blob && isDataView(body)) {
                this._bodyArrayBuffer = bufferClone(body.buffer);
                // IE 10-11 can't handle a DataView body.
                this._bodyInit = new Blob([this._bodyArrayBuffer]);
            } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
                this._bodyArrayBuffer = bufferClone(body);
            } else {
                throw new Error('unsupported BodyInit type');
            }

            if (!this.headers.get('content-type')) {
                if (typeof body === 'string') {
                    this.headers.set('content-type', 'text/plain;charset=UTF-8');
                } else if (this._bodyBlob && this._bodyBlob.type) {
                    this.headers.set('content-type', this._bodyBlob.type);
                } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                    this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            }
        };

        if (support.blob) {
            this.blob = function () {
                var rejected = consumed(this);
                if (rejected) {
                    return rejected;
                }

                if (this._bodyBlob) {
                    return Promise.resolve(this._bodyBlob);
                } else if (this._bodyArrayBuffer) {
                    return Promise.resolve(new Blob([this._bodyArrayBuffer]));
                } else if (this._bodyFormData) {
                    throw new Error('could not read FormData body as blob');
                } else {
                    return Promise.resolve(new Blob([this._bodyText]));
                }
            };

            this.arrayBuffer = function () {
                if (this._bodyArrayBuffer) {
                    return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                } else {
                    return this.blob().then(readBlobAsArrayBuffer);
                }
            };
        }

        this.text = function () {
            var rejected = consumed(this);
            if (rejected) {
                return rejected;
            }

            if (this._bodyBlob) {
                return readBlobAsText(this._bodyBlob);
            } else if (this._bodyArrayBuffer) {
                return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
            } else if (this._bodyFormData) {
                throw new Error('could not read FormData body as text');
            } else {
                return Promise.resolve(this._bodyText);
            }
        };

        if (support.formData) {
            this.formData = function () {
                return this.text().then(decode);
            };
        }

        this.json = function () {
            return this.text().then(JSON.parse);
        };

        return this;
    }

    // HTTP methods whose capitalization should be normalized
    var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

    function normalizeMethod(method) {
        var upcased = method.toUpperCase();
        return methods.indexOf(upcased) > -1 ? upcased : method;
    }

    function Request(input, options) {
        options = options || {};
        var body = options.body;

        if (input instanceof Request) {
            if (input.bodyUsed) {
                throw new TypeError('Already read');
            }
            this.url = input.url;
            this.credentials = input.credentials;
            if (!options.headers) {
                this.headers = new Headers(input.headers);
            }
            this.method = input.method;
            this.mode = input.mode;
            if (!body && input._bodyInit != null) {
                body = input._bodyInit;
                input.bodyUsed = true;
            }
        } else {
            this.url = String(input);
        }

        this.credentials = options.credentials || this.credentials || 'omit';
        if (options.headers || !this.headers) {
            this.headers = new Headers(options.headers);
        }
        this.method = normalizeMethod(options.method || this.method || 'GET');
        this.mode = options.mode || this.mode || null;
        this.referrer = null;

        if ((this.method === 'GET' || this.method === 'HEAD') && body) {
            throw new TypeError('Body not allowed for GET or HEAD requests');
        }
        this._initBody(body);
    }

    Request.prototype.clone = function () {
        return new Request(this, { body: this._bodyInit });
    };

    function decode(body) {
        var form = new FormData();
        body.trim().split('&').forEach(function (bytes) {
            if (bytes) {
                var split = bytes.split('=');
                var name = split.shift().replace(/\+/g, ' ');
                var value = split.join('=').replace(/\+/g, ' ');
                form.append(decodeURIComponent(name), decodeURIComponent(value));
            }
        });
        return form;
    }

    function parseHeaders(rawHeaders) {
        var headers = new Headers();
        // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
        // https://tools.ietf.org/html/rfc7230#section-3.2
        var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
        preProcessedHeaders.split(/\r?\n/).forEach(function (line) {
            var parts = line.split(':');
            var key = parts.shift().trim();
            if (key) {
                var value = parts.join(':').trim();
                headers.append(key, value);
            }
        });
        return headers;
    }

    Body.call(Request.prototype);

    function Response(bodyInit, options) {
        if (!options) {
            options = {};
        }

        this.type = 'default';
        this.status = 'status' in options ? options.status : 200;
        this.ok = this.status >= 200 && this.status < 300;
        this.statusText = 'statusText' in options ? options.statusText : 'OK';
        this.headers = new Headers(options.headers);
        this.url = options.url || '';
        this._initBody(bodyInit);
    }

    Body.call(Response.prototype);

    Response.prototype.clone = function () {
        return new Response(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers(this.headers),
            url: this.url
        });
    };

    Response.error = function () {
        var response = new Response(null, { status: 0, statusText: '' });
        response.type = 'error';
        return response;
    };

    var redirectStatuses = [301, 302, 303, 307, 308];

    Response.redirect = function (url, status) {
        if (redirectStatuses.indexOf(status) === -1) {
            throw new RangeError('Invalid status code');
        }

        return new Response(null, { status: status, headers: { location: url } });
    };

    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;

    self.fetch = function (input, init) {
        return new Promise(function (resolve, reject) {
            var request = new Request(input, init);
            var xhr = new XMLHttpRequest();

            xhr.onload = function () {
                var options = {
                    status: xhr.status,
                    statusText: xhr.statusText,
                    headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                };
                options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                var body = 'response' in xhr ? xhr.response : xhr.responseText;
                resolve(new Response(body, options));
            };

            xhr.onerror = function () {
                reject(new TypeError('Network request failed'));
            };

            xhr.ontimeout = function () {
                reject(new TypeError('Network request failed'));
            };

            xhr.open(request.method, request.url, true);

            if (request.credentials === 'include') {
                xhr.withCredentials = true;
            } else if (request.credentials === 'omit') {
                xhr.withCredentials = false;
            }

            if ('responseType' in xhr && support.blob) {
                xhr.responseType = 'blob';
            }

            request.headers.forEach(function (value, name) {
                xhr.setRequestHeader(name, value);
            });

            xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
        });
    };
    self.fetch.polyfill = true;
}

exports.default = fetchPolyfill;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function promisePolyfill(root) {

    // Store setTimeout reference so promise-polyfill will be unaffected by
    // other code modifying setTimeout (like sinon.useFakeTimers())
    var setTimeoutFunc = setTimeout;

    function noop() {}

    // Polyfill for Function.prototype.bind
    function bind(fn, thisArg) {
        return function () {
            fn.apply(thisArg, arguments);
        };
    }

    function Promise(fn) {
        if (_typeof(this) !== 'object') throw new TypeError('Promises must be constructed via new');
        if (typeof fn !== 'function') throw new TypeError('not a function');
        this._state = 0;
        this._handled = false;
        this._value = undefined;
        this._deferreds = [];

        doResolve(fn, this);
    }

    function handle(self, deferred) {
        while (self._state === 3) {
            self = self._value;
        }
        if (self._state === 0) {
            self._deferreds.push(deferred);
            return;
        }
        self._handled = true;
        Promise._immediateFn(function () {
            var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
            if (cb === null) {
                (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
                return;
            }
            var ret;
            try {
                ret = cb(self._value);
            } catch (e) {
                reject(deferred.promise, e);
                return;
            }
            resolve(deferred.promise, ret);
        });
    }

    function resolve(self, newValue) {
        try {
            // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
            if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
            if (newValue && ((typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) === 'object' || typeof newValue === 'function')) {
                var then = newValue.then;
                if (newValue instanceof Promise) {
                    self._state = 3;
                    self._value = newValue;
                    finale(self);
                    return;
                } else if (typeof then === 'function') {
                    doResolve(bind(then, newValue), self);
                    return;
                }
            }
            self._state = 1;
            self._value = newValue;
            finale(self);
        } catch (e) {
            reject(self, e);
        }
    }

    function reject(self, newValue) {
        self._state = 2;
        self._value = newValue;
        finale(self);
    }

    function finale(self) {
        if (self._state === 2 && self._deferreds.length === 0) {
            Promise._immediateFn(function () {
                if (!self._handled) {
                    Promise._unhandledRejectionFn(self._value);
                }
            });
        }

        for (var i = 0, len = self._deferreds.length; i < len; i++) {
            handle(self, self._deferreds[i]);
        }
        self._deferreds = null;
    }

    function Handler(onFulfilled, onRejected, promise) {
        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
        this.onRejected = typeof onRejected === 'function' ? onRejected : null;
        this.promise = promise;
    }

    /**
     * Take a potentially misbehaving resolver function and make sure
     * onFulfilled and onRejected are only called once.
     *
     * Makes no guarantees about asynchrony.
     */
    function doResolve(fn, self) {
        var done = false;
        try {
            fn(function (value) {
                if (done) return;
                done = true;
                resolve(self, value);
            }, function (reason) {
                if (done) return;
                done = true;
                reject(self, reason);
            });
        } catch (ex) {
            if (done) return;
            done = true;
            reject(self, ex);
        }
    }

    Promise.prototype['catch'] = function (onRejected) {
        return this.then(null, onRejected);
    };

    Promise.prototype.then = function (onFulfilled, onRejected) {
        var prom = new this.constructor(noop);

        handle(this, new Handler(onFulfilled, onRejected, prom));
        return prom;
    };

    Promise.all = function (arr) {
        var args = Array.prototype.slice.call(arr);

        return new Promise(function (resolve, reject) {
            if (args.length === 0) return resolve([]);
            var remaining = args.length;

            function res(i, val) {
                try {
                    if (val && ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' || typeof val === 'function')) {
                        var then = val.then;
                        if (typeof then === 'function') {
                            then.call(val, function (val) {
                                res(i, val);
                            }, reject);
                            return;
                        }
                    }
                    args[i] = val;
                    if (--remaining === 0) {
                        resolve(args);
                    }
                } catch (ex) {
                    reject(ex);
                }
            }

            for (var i = 0; i < args.length; i++) {
                res(i, args[i]);
            }
        });
    };

    Promise.resolve = function (value) {
        if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.constructor === Promise) {
            return value;
        }

        return new Promise(function (resolve) {
            resolve(value);
        });
    };

    Promise.reject = function (value) {
        return new Promise(function (resolve, reject) {
            reject(value);
        });
    };

    Promise.race = function (values) {
        return new Promise(function (resolve, reject) {
            for (var i = 0, len = values.length; i < len; i++) {
                values[i].then(resolve, reject);
            }
        });
    };

    // Use polyfill for setImmediate for performance gains
    Promise._immediateFn = typeof setImmediate === 'function' && function (fn) {
        setImmediate(fn);
    } || function (fn) {
        setTimeoutFunc(fn, 0);
    };

    Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
        if (typeof console !== 'undefined' && console) {
            console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
        }
    };

    /**
     * Set the immediate function to execute callbacks
     * @param fn {function} Function to execute
     * @deprecated
     */
    Promise._setImmediateFn = function _setImmediateFn(fn) {
        Promise._immediateFn = fn;
    };

    /**
     * Change the function to execute on unhandled rejection
     * @param {function} fn Function to execute on unhandled rejection
     * @deprecated
     */
    Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
        Promise._unhandledRejectionFn = fn;
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = Promise;
    } else if (!root.Promise) {
        root.Promise = Promise;
    }
}

exports.default = promisePolyfill;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(849).setImmediate))

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(850);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || undefined && undefined.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || undefined && undefined.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42), __webpack_require__(851)))

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(412);

var _app2 = _interopRequireDefault(_app);

var _CommonConstants = __webpack_require__(3);

var _CommonConstants2 = _interopRequireDefault(_CommonConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var routes = {};

_app2.default.config(['$stateProvider', '$urlRouterProvider', '$locationProvider', 'cartonomyConfig', function ($stateProvider, $urlRouterProvider, $locationProvider, cartonomyConfig) {
    $locationProvider.hashPrefix('');

    $urlRouterProvider.otherwise(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee($injector, $location) {
            var url, match, sessionService, authenticationService;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            url = $location.absUrl();
                            match = url.match(/(.*)\?externalLogin=([a-z]+)&code=(.*)/);

                            if (!match) {
                                _context.next = 5;
                                break;
                            }

                            location.href = match[1] + '#/externalLogin/' + match[2] + '/' + match[3];
                            return _context.abrupt('return');

                        case 5:

                            match = url.match(/(.*)\?success=true&token=([^&]+)&PayerID=(.+)/);

                            if (!match) {
                                _context.next = 9;
                                break;
                            }

                            location.href = match[1] + '#/paypal/' + match[2] + '/' + match[3];
                            return _context.abrupt('return');

                        case 9:

                            match = url.match(/(.*)\?cancel=true&token=(.*)/);

                            if (!match) {
                                _context.next = 13;
                                break;
                            }

                            location.href = match[1]; // currently we don't show any message for cancelled PayPal transaction
                            return _context.abrupt('return');

                        case 13:
                            sessionService = $injector.get('Session');
                            authenticationService = $injector.get('AuthenticationService');

                            if (cartonomyConfig.externalStoreMode) {
                                _context.next = 19;
                                break;
                            }

                            $location.url('/catalog');
                            _context.next = 23;
                            break;

                        case 19:
                            _context.next = 21;
                            return sessionService.loggedIn();

                        case 21:
                            if (!_context.sent) {
                                _context.next = 23;
                                break;
                            }

                            $location.url('/profile');

                        case 23:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }());

    // only register catalog page if not in shopify integration
    if (!cartonomyConfig.externalStoreMode) {
        $stateProvider.state({
            name: _CommonConstants2.default.RoutingStates.CATALOG,
            url: "/catalog",
            views: {
                contents: {
                    template: __webpack_require__(853),
                    controller: 'Cartonomy.Catalog.CategoryController'
                }
            }
        });
    }

    $stateProvider.state({
        name: _CommonConstants2.default.RoutingStates.USER_PROFILE,
        url: "/profile",
        windowTitle: 'client.profile',
        views: {
            contents: {
                template: __webpack_require__(854),
                controller: 'Cartonomy.Profile.ProfileController'
            }
        }
    }).state({
        name: _CommonConstants2.default.RoutingStates.CHAT,
        url: "/chat",
        windowTitle: 'client.group.chat',
        views: {
            contents: {
                templateUrl: "modules/catalog/views/chatView.html",
                controller: "Cartonomy.Catalog.ChatViewController"
            }
        }
    }).state({
        name: _CommonConstants2.default.RoutingStates.CONFIRM_TICKET,
        url: "/resetpassword/{ticket}",
        views: {
            contents: {
                templateUrl: "modules/shared/views/confirmTicket.html",
                controller: "Cartonomy.Shared.ConfirmTicketController"
            }
        }
    }).state({
        name: _CommonConstants2.default.RoutingStates.CHECKOUT,
        url: "/checkout",
        views: {
            contents: {
                templateUrl: "modules/order/views/orderCheckout.html",
                controller: "Cartonomy.Order.CheckoutController"
            }
        }
    }).state({
        name: _CommonConstants2.default.RoutingStates.CHECKOUT_FULL_MIXED,
        url: "/checkout_fullmixed",
        views: {
            contents: {
                templateUrl: "modules/order/views/orderCheckoutFullMixed.html",
                controller: "Cartonomy.Order.CheckoutFullMixedController"
            }
        }
    }).state({
        name: _CommonConstants2.default.RoutingStates.PAY,
        url: "/pay/{id}",
        views: {
            contents: {
                templateUrl: "modules/order/views/orderPay.html",
                controller: "Cartonomy.Order.PayController"
            }
        }
    }).state({
        name: _CommonConstants2.default.RoutingStates.LOGIN_TICKET,
        url: "/auth_token={authToken}?errorMessage",
        views: {
            contents: {
                controller: "Cartonomy.Shared.LoginTicketController"
            }
        }
    }).state({
        name: _CommonConstants2.default.RoutingStates.PAYPAL_REDIRECT,
        url: "/paypal/{token}/{externalPayerId}",
        views: {
            contents: {
                templateUrl: 'modules/catalog/views/categoryView.html',
                controller: 'Cartonomy.Catalog.CategoryController'
            }
        }
    }).state({
        name: _CommonConstants2.default.RoutingStates.CONFIRM_ORDER,
        url: "/confirm_order",
        views: {
            contents: {
                templateUrl: "modules/order/views/orderConfirmation.html",
                controller: "Cartonomy.Order.ConfirmationController"
            }
        }
    });
}]);

exports.default = routes;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__(41);

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout-align=\"center center\" layout=\"row\"><div layout=\"row\" class=\"content\"><cartonomy-catalog-product-list flex category-id=\"categoryId\" search-string=\"searchString\" layout-wrap></cartonomy-catalog-product-list><cartonomy-catalog-chat flex=\"33\" ng-if=\"groupOrderCreated &amp;&amp; !sizeXsSm\" class=\"embedded\"></cartonomy-catalog-chat></div></div>");;return buf.join("");
}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__(41);

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div md-dynamic-height md-border-bottom class=\"toolbar-tabs\"><user-profile></user-profile></div>");;return buf.join("");
}

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initializeEventHandlerService = initializeEventHandlerService;

var _commandHandlerService = __webpack_require__(416);

function initializeEventHandlerService() {
    window.addEventListener('message', function (event) {
        if (_commandHandlerService.commandHandlerService.hasHandler(event.data.action)) {
            _commandHandlerService.commandHandlerService.handleCommand(event.data.action, event.data, event, function (callbackData) {
                if (!callbackData) {
                    callbackData = {};
                }

                if (event.data.responseCommand) {
                    callbackData.action = event.data.responseCommand;
                }
                if (event.source) {
                    event.source.postMessage(callbackData, event.origin);
                }
            });
        }
    }, false);
}

/***/ })
],[645]);


// WEBPACK FOOTER //
// scripts/app.77861da34a6cc3389414.js